'use client';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React$1 from 'react';
import React__default$1, { useRef, useState, useMemo, useEffect, createElement, useCallback, Fragment as Fragment$1, createContext, useContext, useReducer, Children, isValidElement, cloneElement, forwardRef, useImperativeHandle, useLayoutEffect, memo as memo$1 } from 'react';
import { debounce as debounce$1, useTheme as useTheme$2, useMediaQuery, Snackbar, ThemeProvider, Button, Grid as Grid$3, Typography as Typography$1, Tooltip, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions as DialogActions$1, createFilterOptions, Box as Box$1, IconButton, styled as styled$4, Link, InputLabel as InputLabel$1, Backdrop, CircularProgress as CircularProgress$1, Stack, RadioGroup, FormControlLabel, Radio, TextField as TextField$1, Slider, OutlinedInput, InputAdornment, Skeleton as Skeleton$d, ToggleButton, darken, ToggleButtonGroup, alpha as alpha$1, hexToRgb, FormHelperText, Checkbox as Checkbox$1, FormGroup, SvgIcon as SvgIcon$1, Card, CardContent, TableRow, TableContainer, Table, TableBody, TableCell, Divider as Divider$1, Collapse as Collapse$1, Dialog as Dialog$1, Avatar, FormLabel, LinearProgress, Alert as Alert$1, Slide, useAutocomplete, Container as Container$1, Menu, ListItemText as ListItemText$1, MenuList as MenuList$1, MenuItem as MenuItem$1, Paper as Paper$1, Switch as Switch$1, Tab as Tab$2, Tabs as Tabs$1, List as List$1, ListItem as ListItem$2, ListItemButton, ListItemIcon as ListItemIcon$1 } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete/Autocomplete';
import TextField from '@mui/material/TextField/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { useQuery as useQuery$1, useQueries, useQueryClient, useMutation as useMutation$1, QueryClientProvider as QueryClientProvider$1, IsRestoringProvider, QueryClient, defaultShouldDehydrateQuery as defaultShouldDehydrateQuery$1 } from '@tanstack/react-query';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ExpandMore, WindowOutlined, Delete, Close, ExpandLess, Search as Search$1, Circle, Add, CheckBoxOutlineBlank, CheckBox, FlightOutlined, DirectionsBoatOutlined, StarBorderOutlined, Star, WarningAmber, DownloadSharp, CheckCircle, Check, Place, Person, MailOutline, Cancel, NotificationsNone, Share, Navigation, AddCircleOutline, DeleteForever, Edit, DeleteOutline, Warning, FilterListOutlined, SortOutlined, SearchSharp, ArrowBackIosNew, KeyboardArrowRightSharp, Settings, OpenInFullRounded, AttachFile, SaveAlt, TextSnippet, Remove, HelpOutline, FileDownload, InfoOutlined, HelpOutlineOutlined, MyLocationOutlined, LocationOnOutlined, InsertDriveFile, FiberManualRecord, ArrowForward, VerticalShadesClosed, Notifications, IosShare, ChevronRight, ChevronLeft } from '@mui/icons-material';
import Button$1 from '@mui/material/Button';
import { useForm as useForm$1, FormProvider, useFormContext, Controller, useFieldArray, useWatch } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAuth } from '@sal/authentication.react';
import { createRoot } from 'react-dom/client';
import MuiDialog from '@mui/material/Dialog/Dialog';
import DialogActions from '@mui/material/DialogActions/DialogActions';
import DialogContent from '@mui/material/DialogContent/DialogContent';
import DialogContentText from '@mui/material/DialogContentText/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle/DialogTitle';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
import DialogContent$2 from '@mui/material/DialogContent';
import DialogContentText$1 from '@mui/material/DialogContentText';
import DialogTitle$2 from '@mui/material/DialogTitle';
import DialogActions$2 from '@mui/material/DialogActions';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import { useThemeProps, styled as styled$3, useTheme as useTheme$3, alpha, lighten, darken as darken$1 } from '@mui/material/styles';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import useMediaQuery$1 from '@mui/material/useMediaQuery';
import IconButton$1 from '@mui/material/IconButton';
import { createSvgIcon, unstable_useId, capitalize as capitalize$1, isMuiElement } from '@mui/material/utils';
import Fade from '@mui/material/Fade';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import BaseFocusTrap from '@mui/material/Unstable_TrapFocus';
import List from '@mui/material/List';
import ListItem$1 from '@mui/material/ListItem';
import Chip from '@mui/material/Chip';
import ButtonBase from '@mui/material/ButtonBase';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';
import MuiInputAdornment from '@mui/material/InputAdornment';
import MuiTextField from '@mui/material/TextField';
import Tooltip$1, { tooltipClasses } from '@mui/material/Tooltip';
import { Link as Link$1, useParams, useLocation, Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import Switch, { switchClasses } from '@mui/material/Switch';
import Tabs from '@mui/material/Tabs';
import Tab$1 from '@mui/material/Tab';
import { useGridApiRef, GridActionsCellItem as GridActionsCellItem$1, useGridApiContext as useGridApiContext$1, DataGridPro, getGridSingleSelectOperators as getGridSingleSelectOperators$1, getGridNumericOperators as getGridNumericOperators$1, GridRowModes as GridRowModes$1 } from '@mui/x-data-grid-pro';
import Checkbox from '@mui/material/Checkbox/Checkbox';
import Grid$4 from '@mui/material/Grid';
import SvgIcon from '@mui/material/SvgIcon';
import TableBody$1 from '@mui/material/TableBody';
import Alert from '@mui/material/Alert';
import generateUtilityClass$1 from '@mui/material/generateUtilityClass';
import generateUtilityClasses$1 from '@mui/material/generateUtilityClasses';
import Divider from '@mui/material/Divider';
import v from '@mui/material/FormHelperText';
import m from '@mui/material/FormControl';
import p from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputBase from '@mui/material/InputBase';
import MenuList from '@mui/material/MenuList';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ListItemIcon from '@mui/material/ListItemIcon';
import Skeleton$e from '@mui/material/Skeleton';
import Badge from '@mui/material/Badge';
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel$1 from '@mui/material/FormControlLabel';
import Autocomplete$1, { createFilterOptions as createFilterOptions$1 } from '@mui/material/Autocomplete';
import TablePagination, { tablePaginationClasses } from '@mui/material/TablePagination';
import MUICheckbox from '@mui/material/Checkbox';
import MUIInputLabel from '@mui/material/InputLabel';
import Stack$1 from '@mui/material/Stack';
import useTheme$4 from '@mui/material/styles/useTheme';
import Drawer from '@mui/material/Drawer';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$2(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual$1 = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
let Loader$1 = class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual$1(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */
    createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy,
        };
        // keep the URL minimal:
        Object.keys(params).forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key) => !params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) {
            // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
            // which also sets the base url, the id, and the nonce
            /* eslint-disable */
            ((g) => {
                // @ts-ignore
                let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                // @ts-ignore
                b = b[c] || (b[c] = {});
                // @ts-ignore
                const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => 
                // @ts-ignore
                h || (h = new Promise((f, n) => __awaiter$2(this, void 0, void 0, function* () {
                    var _a;
                    yield (a = m.createElement("script"));
                    a.id = this.id;
                    e.set("libraries", [...r] + "");
                    // @ts-ignore
                    for (k in g)
                        e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
                    e.set("callback", c + ".maps." + q);
                    a.src = this.url + `?` + e;
                    d[q] = f;
                    a.onerror = () => (h = n(Error(p + " could not load.")));
                    // @ts-ignore
                    a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                    m.head.append(a);
                })));
                // @ts-ignore
                d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
            })(params);
            /* eslint-enable */
        }
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library) => this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) {
            libraryPromises.push(this.importLibrary("core"));
        }
        Promise.all(libraryPromises).then(() => this.callback(), (error) => {
            const event = new ErrorEvent("error", { error }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
};

var __defProp$1M = Object.defineProperty;
var __defProps$1q = Object.defineProperties;
var __getOwnPropDescs$1q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1M = Object.getOwnPropertySymbols;
var __hasOwnProp$1M = Object.prototype.hasOwnProperty;
var __propIsEnum$1M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1M = (obj, key, value) => key in obj ? __defProp$1M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1M.call(b, prop))
      __defNormalProp$1M(a, prop, b[prop]);
  if (__getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(b)) {
      if (__propIsEnum$1M.call(b, prop))
        __defNormalProp$1M(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1q = (a, b) => __defProps$1q(a, __getOwnPropDescs$1q(b));
var __objRest$Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getLabel = (labelKey) => (value) => {
  return typeof value === "string" ? value : value[labelKey];
};
function AutocompleteDropdown(_a) {
  var _b = _a, {
    labelKey = "name",
    autoComplete = true,
    autoHighlight = true,
    disablePortal = true,
    openOnFocus = true,
    getOptionLabel = getLabel(labelKey),
    placeholder,
    loading,
    error,
    sx,
    InputProps,
    errorMessage
  } = _b, rest = __objRest$Y(_b, [
    "labelKey",
    "autoComplete",
    "autoHighlight",
    "disablePortal",
    "openOnFocus",
    "getOptionLabel",
    "placeholder",
    "loading",
    "error",
    "sx",
    "InputProps",
    "errorMessage"
  ]);
  return /* @__PURE__ */ jsx(
    Autocomplete,
    __spreadProps$1q(__spreadValues$1L({}, rest), {
      autoComplete,
      autoHighlight,
      disablePortal,
      openOnFocus,
      getOptionLabel,
      loading,
      renderInput: (params) => /* @__PURE__ */ jsx(
        TextField,
        __spreadProps$1q(__spreadValues$1L({}, params), {
          error,
          placeholder,
          InputProps: __spreadProps$1q(__spreadValues$1L(__spreadValues$1L({}, params.InputProps), InputProps), {
            endAdornment: /* @__PURE__ */ jsxs(Fragment, { children: [
              loading && /* @__PURE__ */ jsx(CircularProgress, { color: "inherit", size: "1rem" }),
              params.InputProps.endAdornment
            ] })
          }),
          helperText: error ? errorMessage : void 0,
          FormHelperTextProps: {
            sx: {
              marginX: 0
            }
          }
        })
      ),
      sx: __spreadValues$1L({
        ".MuiAutocomplete-input": {
          padding: "0.5rem 0.75rem !important"
        }
      }, sx)
    })
  );
}

var toString = Object.prototype.toString;

function isFunc(obj) {
  return toString.call(obj) === "[object Function]";
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function icPart(str) {
  return str.split("").map(function (c) {
    return "(?:" + c.toUpperCase() + "|" + c.toLowerCase() + ")";
  }).join("");
}

function remove(arr, elem) {
  for (var i = arr.length - 1; i >= 0; i--) {
    if (arr[i] === elem) {
      Array.prototype.splice.call(arr, i, 1);
    }
  }
}

function hasProp(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

var instances = {};

var Inflector = function () {
  createClass(Inflector, null, [{
    key: "getInstance",
    value: function getInstance(locale) {
      instances[locale] = instances[locale] || new Inflector();
      return instances[locale];
    }
  }]);

  function Inflector() {
    classCallCheck(this, Inflector);

    this.plurals = [];
    this.singulars = [];
    this.uncountables = [];
    this.humans = [];
    this.acronyms = {};
    this.acronymRegex = /(?=a)b/;
  }

  createClass(Inflector, [{
    key: "acronym",
    value: function acronym(word) {
      this.acronyms[word.toLowerCase()] = word;

      var values = [];

      for (var key in this.acronyms) {
        if (hasProp(this.acronyms, key)) {
          values.push(this.acronyms[key]);
        }
      }

      this.acronymRegex = new RegExp(values.join("|"));
    }
  }, {
    key: "plural",
    value: function plural(rule, replacement) {
      if (typeof rule === "string") {
        remove(this.uncountables, rule);
      }

      remove(this.uncountables, replacement);
      this.plurals.unshift([rule, replacement]);
    }
  }, {
    key: "singular",
    value: function singular(rule, replacement) {
      if (typeof rule === "string") {
        remove(this.uncountables, rule);
      }

      remove(this.uncountables, replacement);
      this.singulars.unshift([rule, replacement]);
    }
  }, {
    key: "irregular",
    value: function irregular(singular, plural) {
      remove(this.uncountables, singular);
      remove(this.uncountables, plural);

      var s0 = singular[0];
      var sRest = singular.substr(1);

      var p0 = plural[0];
      var pRest = plural.substr(1);

      if (s0.toUpperCase() === p0.toUpperCase()) {
        this.plural(new RegExp("(" + s0 + ")" + sRest + "$", "i"), "$1" + pRest);
        this.plural(new RegExp("(" + p0 + ")" + pRest + "$", "i"), "$1" + pRest);

        this.singular(new RegExp("(" + s0 + ")" + sRest + "$", "i"), "$1" + sRest);
        this.singular(new RegExp("(" + p0 + ")" + pRest + "$", "i"), "$1" + sRest);
      } else {
        var sRestIC = icPart(sRest);
        var pRestIC = icPart(pRest);

        this.plural(new RegExp(s0.toUpperCase() + sRestIC + "$"), p0.toUpperCase() + pRest);
        this.plural(new RegExp(s0.toLowerCase() + sRestIC + "$"), p0.toLowerCase() + pRest);
        this.plural(new RegExp(p0.toUpperCase() + pRestIC + "$"), p0.toUpperCase() + pRest);
        this.plural(new RegExp(p0.toLowerCase() + pRestIC + "$"), p0.toLowerCase() + pRest);

        this.singular(new RegExp(s0.toUpperCase() + sRestIC + "$"), s0.toUpperCase() + sRest);
        this.singular(new RegExp(s0.toLowerCase() + sRestIC + "$"), s0.toLowerCase() + sRest);
        this.singular(new RegExp(p0.toUpperCase() + pRestIC + "$"), s0.toUpperCase() + sRest);
        this.singular(new RegExp(p0.toLowerCase() + pRestIC + "$"), s0.toLowerCase() + sRest);
      }
    }
  }, {
    key: "uncountable",
    value: function uncountable() {
      for (var _len = arguments.length, words = Array(_len), _key = 0; _key < _len; _key++) {
        words[_key] = arguments[_key];
      }

      this.uncountables = this.uncountables.concat(words);
    }
  }, {
    key: "human",
    value: function human(rule, replacement) {
      this.humans.unshift([rule, replacement]);
    }
  }, {
    key: "clear",
    value: function clear() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";

      if (scope === "all") {
        this.plurals = [];
        this.singulars = [];
        this.uncountables = [];
        this.humans = [];
      } else {
        this[scope] = [];
      }
    }
  }]);
  return Inflector;
}();

function en(inflector) {
  inflector.plural(/$/, "s");
  inflector.plural(/s$/i, "s");
  inflector.plural(/^(ax|test)is$/i, "$1es");
  inflector.plural(/(octop|vir)us$/i, "$1i");
  inflector.plural(/(octop|vir)i$/i, "$1i");
  inflector.plural(/(alias|status)$/i, "$1es");
  inflector.plural(/(bu)s$/i, "$1ses");
  inflector.plural(/(buffal|tomat)o$/i, "$1oes");
  inflector.plural(/([ti])um$/i, "$1a");
  inflector.plural(/([ti])a$/i, "$1a");
  inflector.plural(/sis$/i, "ses");
  inflector.plural(/(?:([^f])fe|([lr])f)$/i, "$1$2ves");
  inflector.plural(/(hive)$/i, "$1s");
  inflector.plural(/([^aeiouy]|qu)y$/i, "$1ies");
  inflector.plural(/(x|ch|ss|sh)$/i, "$1es");
  inflector.plural(/(matr|vert|ind)(?:ix|ex)$/i, "$1ices");
  inflector.plural(/^(m|l)ouse$/i, "$1ice");
  inflector.plural(/^(m|l)ice$/i, "$1ice");
  inflector.plural(/^(ox)$/i, "$1en");
  inflector.plural(/^(oxen)$/i, "$1");
  inflector.plural(/(quiz)$/i, "$1zes");

  inflector.singular(/s$/i, "");
  inflector.singular(/(ss)$/i, "$1");
  inflector.singular(/(n)ews$/i, "$1ews");
  inflector.singular(/([ti])a$/i, "$1um");
  inflector.singular(/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(sis|ses)$/i, "$1sis");
  inflector.singular(/(^analy)(sis|ses)$/i, "$1sis");
  inflector.singular(/([^f])ves$/i, "$1fe");
  inflector.singular(/(hive)s$/i, "$1");
  inflector.singular(/(tive)s$/i, "$1");
  inflector.singular(/([lr])ves$/i, "$1f");
  inflector.singular(/([^aeiouy]|qu)ies$/i, "$1y");
  inflector.singular(/(s)eries$/i, "$1eries");
  inflector.singular(/(m)ovies$/i, "$1ovie");
  inflector.singular(/(x|ch|ss|sh)es$/i, "$1");
  inflector.singular(/^(m|l)ice$/i, "$1ouse");
  inflector.singular(/(bus)(es)?$/i, "$1");
  inflector.singular(/(o)es$/i, "$1");
  inflector.singular(/(shoe)s$/i, "$1");
  inflector.singular(/(cris|test)(is|es)$/i, "$1is");
  inflector.singular(/^(a)x[ie]s$/i, "$1xis");
  inflector.singular(/(octop|vir)(us|i)$/i, "$1us");
  inflector.singular(/(alias|status)(es)?$/i, "$1");
  inflector.singular(/^(ox)en/i, "$1");
  inflector.singular(/(vert|ind)ices$/i, "$1ex");
  inflector.singular(/(matr)ices$/i, "$1ix");
  inflector.singular(/(quiz)zes$/i, "$1");
  inflector.singular(/(database)s$/i, "$1");

  inflector.irregular("person", "people");
  inflector.irregular("man", "men");
  inflector.irregular("child", "children");
  inflector.irregular("sex", "sexes");
  inflector.irregular("move", "moves");
  inflector.irregular("zombie", "zombies");

  inflector.uncountable("equipment", "information", "rice", "money", "species", "series", "fish", "sheep", "jeans", "police");
}

var defaults$1 = {
  en: en
};

function inflections(locale, fn) {
  if (isFunc(locale)) {
    fn = locale;
    locale = null;
  }

  locale = locale || "en";

  if (fn) {
    fn(Inflector.getInstance(locale));
  } else {
    return Inflector.getInstance(locale);
  }
}

for (var locale$3 in defaults$1) {
  inflections(locale$3, defaults$1[locale$3]);
}

function applyInflections(word, rules) {
  var result = "" + word,
      rule,
      regex,
      replacement;

  if (result.length === 0) {
    return result;
  } else {
    var match = result.toLowerCase().match(/\b\w+$/);

    if (match && inflections().uncountables.indexOf(match[0]) > -1) {
      return result;
    } else {
      for (var i = 0, ii = rules.length; i < ii; i++) {
        rule = rules[i];

        regex = rule[0];
        replacement = rule[1];

        if (result.match(regex)) {
          result = result.replace(regex, replacement);
          break;
        }
      }

      return result;
    }
  }
}

function pluralize(word) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

  return applyInflections(word, inflections(locale).plurals);
}

function singularize(word) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

  return applyInflections(word, inflections(locale).singulars);
}

// prettier-ignore
var DEFAULT_APPROXIMATIONS = {
  'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
  'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
  'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
  'Õ': 'O', 'Ö': 'O', '×': 'x', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U',
  'Ü': 'U', 'Ý': 'Y', 'Þ': 'Th', 'ß': 'ss', 'à': 'a', 'á': 'a', 'â': 'a',
  'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e', 'é': 'e',
  'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i', 'ð': 'd',
  'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ø': 'o',
  'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ý': 'y', 'þ': 'th', 'ÿ': 'y',
  'Ā': 'A', 'ā': 'a', 'Ă': 'A', 'ă': 'a', 'Ą': 'A', 'ą': 'a', 'Ć': 'C',
  'ć': 'c', 'Ĉ': 'C', 'ĉ': 'c', 'Ċ': 'C', 'ċ': 'c', 'Č': 'C', 'č': 'c',
  'Ď': 'D', 'ď': 'd', 'Đ': 'D', 'đ': 'd', 'Ē': 'E', 'ē': 'e', 'Ĕ': 'E',
  'ĕ': 'e', 'Ė': 'E', 'ė': 'e', 'Ę': 'E', 'ę': 'e', 'Ě': 'E', 'ě': 'e',
  'Ĝ': 'G', 'ĝ': 'g', 'Ğ': 'G', 'ğ': 'g', 'Ġ': 'G', 'ġ': 'g', 'Ģ': 'G',
  'ģ': 'g', 'Ĥ': 'H', 'ĥ': 'h', 'Ħ': 'H', 'ħ': 'h', 'Ĩ': 'I', 'ĩ': 'i',
  'Ī': 'I', 'ī': 'i', 'Ĭ': 'I', 'ĭ': 'i', 'Į': 'I', 'į': 'i', 'İ': 'I',
  'ı': 'i', 'Ĳ': 'IJ', 'ĳ': 'ij', 'Ĵ': 'J', 'ĵ': 'j', 'Ķ': 'K', 'ķ': 'k',
  'ĸ': 'k', 'Ĺ': 'L', 'ĺ': 'l', 'Ļ': 'L', 'ļ': 'l', 'Ľ': 'L', 'ľ': 'l',
  'Ŀ': 'L', 'ŀ': 'l', 'Ł': 'L', 'ł': 'l', 'Ń': 'N', 'ń': 'n', 'Ņ': 'N',
  'ņ': 'n', 'Ň': 'N', 'ň': 'n', 'ŉ': '\'n', 'Ŋ': 'NG', 'ŋ': 'ng',
  'Ō': 'O', 'ō': 'o', 'Ŏ': 'O', 'ŏ': 'o', 'Ő': 'O', 'ő': 'o', 'Œ': 'OE',
  'œ': 'oe', 'Ŕ': 'R', 'ŕ': 'r', 'Ŗ': 'R', 'ŗ': 'r', 'Ř': 'R', 'ř': 'r',
  'Ś': 'S', 'ś': 's', 'Ŝ': 'S', 'ŝ': 's', 'Ş': 'S', 'ş': 's', 'Š': 'S',
  'š': 's', 'Ţ': 'T', 'ţ': 't', 'Ť': 'T', 'ť': 't', 'Ŧ': 'T', 'ŧ': 't',
  'Ũ': 'U', 'ũ': 'u', 'Ū': 'U', 'ū': 'u', 'Ŭ': 'U', 'ŭ': 'u', 'Ů': 'U',
  'ů': 'u', 'Ű': 'U', 'ű': 'u', 'Ų': 'U', 'ų': 'u', 'Ŵ': 'W', 'ŵ': 'w',
  'Ŷ': 'Y', 'ŷ': 'y', 'Ÿ': 'Y', 'Ź': 'Z', 'ź': 'z', 'Ż': 'Z', 'ż': 'z',
  'Ž': 'Z', 'ž': 'z',
  'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'E',
  'Ж': 'ZH', 'З': 'Z', 'И': 'I', 'Й': 'J', 'К': 'K', 'Л': 'L', 'М': 'M',
  'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
  'Ф': 'F', 'Х': 'KH', 'Ц': 'C', 'Ч': 'CH', 'Ш': 'SH', 'Щ': 'SHCH',
  'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'YU', 'Я': 'YA',
  'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'e',
  'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm',
  'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
  'ф': 'f', 'х': 'kh', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
  'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya'
};

var DEFAULT_REPLACEMENT_CHAR = "?";

var instances$1 = {};

(function () {
  createClass(Transliterator, null, [{
    key: 'getInstance',
    value: function getInstance(locale) {
      instances$1[locale] = instances$1[locale] || new Transliterator();
      return instances$1[locale];
    }
  }]);

  function Transliterator() {
    classCallCheck(this, Transliterator);

    this.approximations = {};

    for (var char in DEFAULT_APPROXIMATIONS) {
      this.approximate(char, DEFAULT_APPROXIMATIONS[char]);
    }
  }

  createClass(Transliterator, [{
    key: 'approximate',
    value: function approximate(char, replacement) {
      this.approximations[char] = replacement;
    }
  }, {
    key: 'transliterate',
    value: function transliterate(string, replacement) {
      var _this = this;

      return string.replace(/[^\u0000-\u007f]/g, function (c) {
        return _this.approximations[c] || replacement || DEFAULT_REPLACEMENT_CHAR;
      });
    }
  }]);
  return Transliterator;
})();

inflections("en", function(inflect2) {
  inflect2.irregular("percent", "percent");
  inflect2.irregular("%", "%");
  inflect2.irregular("celcius", "celcius");
  inflect2.irregular("fahrenheit", "fahrenheit");
  inflect2.irregular("has", "have");
  inflect2.irregular("kn", "kn");
  inflect2.irregular("km/h", "km/h");
  inflect2.irregular("\xB0", "\xB0");
  inflect2.irregular("\xB0E", "\xB0E");
  inflect2.irregular("\xB0S", "\xB0S");
  inflect2.irregular("\xB0N", "\xB0N");
  inflect2.irregular("\xB0W", "\xB0W");
});
const EMPTY_STRING$g = "";
const noop$6 = () => void 0;
const defaultValue = (value, fallback) => value != null ? value : fallback;
const uc_first = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
const inflect = (term, count) => {
  if (count === void 0 || isNaN(count)) {
    return term;
  }
  return count === 1 ? singularize(term) : pluralize(term);
};
const getQueryStringFromObject = (queryObject) => {
  if (Object.keys(queryObject).length !== 0) {
    const urlQuery = new URLSearchParams(queryObject);
    return `?${urlQuery.toString()}`;
  }
  return "";
};
const convertDataToBoolean = (data) => {
  if (data === "true") {
    return true;
  }
  if (data === "false") {
    return false;
  }
  if (typeof data === "boolean") {
    return data;
  }
  if (data === void 0 || data === null || data === "") {
    return false;
  }
  return true;
};
const createURLParams = (queryParameters) => {
  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(queryParameters)) {
    if (value !== null && value !== void 0) {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(key, String(v)));
      } else {
        queryParams.append(key, String(value));
      }
    }
  }
  return queryParams;
};
const aggregateQueries = (queries) => {
  var _a;
  const error = (_a = queries.find((q) => q.error)) == null ? void 0 : _a.error;
  const isError = !!error;
  const isFetching = queries.some((q) => q.isFetching);
  const data = !isError && !isFetching && queries.map((q) => q.data);
  return { data, error, isError, isFetching };
};
const priceFormatter = (price) => {
  return new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
};
function isEmpty$2(value) {
  return value === void 0 || value === null || value === "";
}
function isPropertyEmpty(obj, prop) {
  if (obj && obj.hasOwnProperty(prop)) {
    const value = obj[prop];
    return value === void 0 || value === null || value === "";
  }
  return true;
}

var __defProp$1L = Object.defineProperty;
var __defProps$1p = Object.defineProperties;
var __getOwnPropDescs$1p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1L = Object.getOwnPropertySymbols;
var __hasOwnProp$1L = Object.prototype.hasOwnProperty;
var __propIsEnum$1L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1L = (obj, key, value) => key in obj ? __defProp$1L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1L.call(b, prop))
      __defNormalProp$1L(a, prop, b[prop]);
  if (__getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(b)) {
      if (__propIsEnum$1L.call(b, prop))
        __defNormalProp$1L(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1p = (a, b) => __defProps$1p(a, __getOwnPropDescs$1p(b));
var __objRest$X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const optionRender$1 = (id, label) => (props, option) => {
  return /* @__PURE__ */ createElement("li", __spreadProps$1p(__spreadValues$1K({}, props), { key: option[id] }), /* @__PURE__ */ jsx(Fragment, { children: option[label] }));
};
const optionEqualToValue$1 = (id, label) => (option, value) => option[id] === value[id] && option[label] === value[label];
function AddressFinder(_a) {
  var _b = _a, {
    placesAPIKey,
    value,
    useSearchTerm,
    open: lookupOpen = false,
    prefetch = false,
    disableClearOnSelect = false,
    blurOnSelect = true,
    onOpen,
    onClose,
    onDataLoad,
    onSetSearchTerm = (term) => term,
    renderOption = optionRender$1("id", "name"),
    isOptionEqualToValue = optionEqualToValue$1("id", "name"),
    applyOptions = (options) => options,
    libraries = ["core", "geometry", "maps", "marker"],
    autocompleteRequestOptions,
    placeDetailsRequestOptions
  } = _b, rest = __objRest$X(_b, [
    "placesAPIKey",
    "value",
    "useSearchTerm",
    "open",
    "prefetch",
    "disableClearOnSelect",
    "blurOnSelect",
    "onOpen",
    "onClose",
    "onDataLoad",
    "onSetSearchTerm",
    "renderOption",
    "isOptionEqualToValue",
    "applyOptions",
    "libraries",
    "autocompleteRequestOptions",
    "placeDetailsRequestOptions"
  ]);
  const ref = useRef(null);
  const [open, setOpen] = useState(lookupOpen);
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);
  const [inputValue, setInputValue] = useState(EMPTY_STRING$g);
  const [searchTerm, setSearchTerm] = useState(void 0);
  const applySearchTerm = useMemo(() => debounce$1((value2) => setSearchTerm(value2), 300), []);
  const loader = new Loader$1({
    apiKey: placesAPIKey,
    libraries: [...libraries, "places"]
  });
  const instantiateServices = () => {
    var _a2, _b2, _c, _d, _e, _f;
    if (((_c = (_b2 = (_a2 = window.google) == null ? void 0 : _a2.maps) == null ? void 0 : _b2.places) == null ? void 0 : _c.AutocompleteService) && !autocompleteService) {
      setAutocompleteService(new window.google.maps.places.AutocompleteService());
    }
    if (((_f = (_e = (_d = window.google) == null ? void 0 : _d.maps) == null ? void 0 : _e.places) == null ? void 0 : _f.PlacesService) && !placesService) {
      const map = new window.google.maps.Map(document.createElement("div"));
      setPlacesService(new window.google.maps.places.PlacesService(map));
    }
  };
  useEffect(() => {
    loader.importLibrary("places").then(instantiateServices).catch((e) => console.error(e));
  }, [loader]);
  const queryOptions = useMemo(
    () => ({
      enabled: !!autocompleteService && !!searchTerm || open || prefetch,
      keepPreviousData: useSearchTerm && open,
      debounce: 300
    }),
    [open, prefetch, searchTerm, useSearchTerm]
  );
  const { data: predictions = [], isFetching: isFetchingPredictions } = useQuery$1(
    ["google/maps/AutocompleteService", searchTerm],
    () => {
      return new Promise((resolve, reject) => {
        if (!autocompleteService) {
          reject("AutocompleteService not instantiated");
        }
        if (!searchTerm) {
          resolve([]);
        }
        autocompleteService == null ? void 0 : autocompleteService.getPlacePredictions(
          autocompleteRequestOptions ? __spreadProps$1p(__spreadValues$1K({}, autocompleteRequestOptions), {
            input: searchTerm
          }) : {
            input: searchTerm
          },
          (results, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && results) {
              resolve(results);
            } else {
              reject(status);
            }
          }
        );
      });
    },
    queryOptions
  );
  const { data: placesDetails, isFetching: isFetchingDetails } = useQuery$1(
    ["google/maps/PlacesService", predictions],
    () => {
      if (!placesService || !predictions.length)
        return Promise.resolve([]);
      return Promise.all(
        predictions.map((prediction) => {
          return new Promise((resolve, reject) => {
            placesService.getDetails(
              placeDetailsRequestOptions ? __spreadProps$1p(__spreadValues$1K({}, placeDetailsRequestOptions), {
                placeId: prediction.place_id
              }) : {
                placeId: prediction.place_id
              },
              (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                  resolve(__spreadProps$1p(__spreadValues$1K({}, place), { originalID: prediction.place_id }));
                } else {
                  reject(status);
                }
              }
            );
          });
        })
      );
    },
    {
      enabled: !!placesService && predictions.length > 0 || open || prefetch,
      keepPreviousData: useSearchTerm && open
    }
  );
  const addressOption = useMemo(() => {
    const options = applyOptions(
      (placesDetails || []).map((detail, ind) => {
        var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
        const subpremise = (_b2 = (_a2 = detail == null ? void 0 : detail.address_components) == null ? void 0 : _a2.find((x) => x.types.includes("subpremise"))) == null ? void 0 : _b2.long_name;
        const streetNumber = (_d = (_c = detail == null ? void 0 : detail.address_components) == null ? void 0 : _c.find((x) => x.types.includes("street_number"))) == null ? void 0 : _d.long_name;
        const route = (_f = (_e = detail == null ? void 0 : detail.address_components) == null ? void 0 : _e.find((x) => x.types.includes("route"))) == null ? void 0 : _f.long_name;
        const locality = (_h = (_g = detail == null ? void 0 : detail.address_components) == null ? void 0 : _g.find((x) => x.types.includes("locality"))) == null ? void 0 : _h.long_name;
        const sublocality = (_j = (_i = detail == null ? void 0 : detail.address_components) == null ? void 0 : _i.find((x) => x.types.includes("sublocality"))) == null ? void 0 : _j.long_name;
        const administrativeAreaLevel1 = (_l = (_k = detail == null ? void 0 : detail.address_components) == null ? void 0 : _k.find(
          (x) => x.types.includes("administrative_area_level_1")
        )) == null ? void 0 : _l.long_name;
        const address1 = subpremise ? `${subpremise}/${streetNumber} ${route}` : `${streetNumber} ${route}`;
        const optionName = ((_m = predictions == null ? void 0 : predictions.find((x) => x.place_id === detail.originalID)) == null ? void 0 : _m.structured_formatting.main_text) + " - " + ((_n = predictions == null ? void 0 : predictions.find((x) => x.place_id === detail.originalID)) == null ? void 0 : _n.structured_formatting.secondary_text);
        return {
          name: optionName,
          id: ind.toString(),
          additionalData: {
            formattedAddress: detail.formatted_address,
            combinedCode: detail.place_id,
            address1,
            address2: sublocality,
            suburb: locality,
            state: administrativeAreaLevel1,
            placeId: detail.place_id,
            latitude: ((_o = detail.geometry) == null ? void 0 : _o.location) ? detail.geometry.location.lat() : void 0,
            longitude: ((_p = detail.geometry) == null ? void 0 : _p.location) ? detail.geometry.location.lng() : void 0,
            displayName: detail.name,
            originalID: detail.originalID,
            locationName: detail.name
          }
        };
      })
    );
    if (inputValue && inputValue !== EMPTY_STRING$g && inputValue !== void 0 && !isFetchingPredictions) {
      if (!options.find((x) => x.name === inputValue)) {
        options.push({
          name: inputValue,
          id: "-1000"
        });
      }
    }
    return options;
  }, [placesDetails, predictions, applyOptions]);
  return /* @__PURE__ */ jsx(
    AutocompleteDropdown,
    __spreadValues$1K({
      value,
      options: addressOption || [],
      loading: isFetchingPredictions || isFetchingDetails,
      getOptionLabel: (option) => option.name,
      filterOptions: (options) => {
        return options;
      },
      open,
      onOpen: () => setOpen(true),
      onClose: () => setOpen(false),
      blurOnSelect,
      isOptionEqualToValue,
      renderOption,
      inputValue,
      onInputChange: (_, inputValue2, reason) => {
        if (disableClearOnSelect && open && reason === "reset")
          return;
        const value2 = inputValue2.trim();
        const term = reason === "clear" || value2 === EMPTY_STRING$g ? void 0 : value2;
        setInputValue(inputValue2);
        if (useSearchTerm) {
          applySearchTerm(onSetSearchTerm(term));
        }
      },
      InputProps: {
        inputRef: ref,
        onClick: (event) => event.stopPropagation()
      }
    }, rest)
  );
}

var __defProp$1K = Object.defineProperty;
var __defProps$1o = Object.defineProperties;
var __getOwnPropDescs$1o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1K = Object.getOwnPropertySymbols;
var __hasOwnProp$1K = Object.prototype.hasOwnProperty;
var __propIsEnum$1K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1K = (obj, key, value) => key in obj ? __defProp$1K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1K.call(b, prop))
      __defNormalProp$1K(a, prop, b[prop]);
  if (__getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(b)) {
      if (__propIsEnum$1K.call(b, prop))
        __defNormalProp$1K(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1o = (a, b) => __defProps$1o(a, __getOwnPropDescs$1o(b));
var __objRest$W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Collapse = (_a) => {
  var _b = _a, { title, children } = _b, rest = __objRest$W(_b, ["title", "children"]);
  return /* @__PURE__ */ jsx(Box, { mb: 5, children: /* @__PURE__ */ jsxs(Accordion, __spreadProps$1o(__spreadValues$1J({}, rest), { children: [
    /* @__PURE__ */ jsx(AccordionSummary, { id: title, expandIcon: /* @__PURE__ */ jsx(ExpandMore, {}), children: /* @__PURE__ */ jsx(Typography, { variant: "h5", children: title }) }),
    /* @__PURE__ */ jsx(AccordionDetails, { children })
  ] })) });
};

/* eslint-disable  @typescript-eslint/no-explicit-any */
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var headers = {
    "Content-Type": "application/json"
};
function get(url, data, throwError, opts) {
    if (data === void 0) { data = null; }
    if (throwError === void 0) { throwError = false; }
    if (opts === void 0) { opts = {}; }
    return __awaiter$1(this, void 0, void 0, function () {
        var responseData;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign(__assign({}, opts), {
                        method: "GET",
                        headers: __assign(__assign({}, headers), ((opts === null || opts === void 0 ? void 0 : opts.headers) || {}))
                    });
                    if (data) {
                        url += getQueryString(data);
                    }
                    return [4 /*yield*/, fetch(url, opts)];
                case 1:
                    responseData = _a.sent();
                    if (!responseData.ok) {
                        if (throwError) {
                            throw new Error(responseData.statusText);
                        }
                        if (responseData.status !== 400) {
                            return [2 /*return*/, {
                                    errors: [{ message: "Unexpected error. Please refresh page and try again." }]
                                }];
                        }
                    }
                    return [2 /*return*/, responseData.json()];
            }
        });
    });
}
function post(url, data, throwError, opts) {
    if (data === void 0) { data = null; }
    if (throwError === void 0) { throwError = false; }
    if (opts === void 0) { opts = {}; }
    return __awaiter$1(this, void 0, void 0, function () {
        var responseData;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign(__assign({}, opts), {
                        method: "POST",
                        headers: __assign(__assign({}, headers), ((opts === null || opts === void 0 ? void 0 : opts.headers) || {})),
                        body: JSON.stringify(data, replacer)
                    });
                    return [4 /*yield*/, fetch(url, opts)];
                case 1:
                    responseData = _a.sent();
                    if (!responseData.ok) {
                        if (throwError) {
                            throw new Error(responseData.statusText);
                        }
                        if (responseData.status !== 400) {
                            return [2 /*return*/, {
                                    errors: [{ message: "Unexpected error. Please refresh page and try again." }]
                                }];
                        }
                    }
                    if (responseData.status === 204) { // HTTP NO CONTENT
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, responseData.json()];
            }
        });
    });
}
function put(url, data, throwError, opts) {
    if (data === void 0) { data = null; }
    if (throwError === void 0) { throwError = false; }
    if (opts === void 0) { opts = {}; }
    return __awaiter$1(this, void 0, void 0, function () {
        var responseData;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign(__assign({}, opts), {
                        method: "PUT",
                        headers: __assign(__assign({}, headers), ((opts === null || opts === void 0 ? void 0 : opts.headers) || {})),
                        body: JSON.stringify(data, replacer)
                    });
                    return [4 /*yield*/, fetch(url, opts)];
                case 1:
                    responseData = _a.sent();
                    if (!responseData.ok) {
                        if (throwError) {
                            throw new Error(responseData.statusText);
                        }
                        if (responseData.status !== 400) {
                            return [2 /*return*/, {
                                    errors: [{ message: "Unexpected error. Please refresh page and try again." }]
                                }];
                        }
                    }
                    if (responseData.status === 204) { // HTTP NO CONTENT
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, responseData.json()];
            }
        });
    });
}
function del(url, data, throwError, opts) {
    if (data === void 0) { data = null; }
    if (throwError === void 0) { throwError = false; }
    if (opts === void 0) { opts = {}; }
    return __awaiter$1(this, void 0, void 0, function () {
        var responseData;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign(__assign({}, opts), {
                        method: "DELETE",
                        headers: __assign(__assign({}, headers), ((opts === null || opts === void 0 ? void 0 : opts.headers) || {}))
                    });
                    if (data) {
                        url += getQueryString(data);
                    }
                    return [4 /*yield*/, fetch(url, opts)];
                case 1:
                    responseData = _a.sent();
                    if (!responseData.ok) {
                        if (throwError) {
                            throw new Error(responseData.statusText);
                        }
                        if (responseData.status !== 400) {
                            return [2 /*return*/, {
                                    errors: [{ message: "Unexpected error. Please refresh page and try again." }]
                                }];
                        }
                    }
                    if (responseData.status === 204) { // HTTP NO CONTENT
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, responseData.json()];
            }
        });
    });
}
function patch(url, data, throwError, opts) {
    if (data === void 0) { data = null; }
    if (throwError === void 0) { throwError = false; }
    if (opts === void 0) { opts = {}; }
    return __awaiter$1(this, void 0, void 0, function () {
        var responseData;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opts = __assign(__assign({}, opts), {
                        method: "PATCH",
                        headers: __assign(__assign({}, headers), ((opts === null || opts === void 0 ? void 0 : opts.headers) || {})),
                        body: JSON.stringify(data)
                    });
                    return [4 /*yield*/, fetch(url, opts)];
                case 1:
                    responseData = _a.sent();
                    if (!responseData.ok) {
                        if (throwError) {
                            throw new Error(responseData.statusText);
                        }
                        if (responseData.status !== 400) {
                            return [2 /*return*/, {
                                    errors: [{ message: "Unexpected error. Please refresh page and try again." }]
                                }];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var replacer = function (key, value) {
    // THIS SORTS OUT THE ISSUE WHERE THE DATE IS PASSED TO C# AS UTC WHEN WE CALL JSON.Stringify
    if (this[key] instanceof Date) {
        //return this[key].toISOString();// Default is .toUTCString(); but we don't want that...
        // FROM: https://stackoverflow.com/a/28149561/182888
        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        var localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);
        return localISOTime;
    }
    return value;
};
var getQueryString = function (data) {
    var query = Object.keys(data)
        .map(function (k) {
        if (data[k] === null) {
            return;
        }
        return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
    });
    var nonEmptyQuery = query.filter(function (item) {
        return item != null;
    });
    var queryString = nonEmptyQuery.join("&");
    return "?" + queryString;
};
/* eslint-enable @typescript-eslint/no-explicit-any */

const portalFrameworkApiPath = "/PortalFramework";

var __defProp$1J = Object.defineProperty;
var __defNormalProp$1J = (obj, key, value) => key in obj ? __defProp$1J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1J(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async$A = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class HttpService {
  constructor(baseUrl) {
    __publicField$1(this, "baseUrl");
    this.baseUrl = baseUrl;
  }
  get(path, query, signal) {
    return get(`${this.baseUrl}/${path}`, query, true, { signal });
  }
  post(path, body, signal) {
    return post(`${this.baseUrl}/${path}`, body, true, { signal });
  }
  put(path, body, signal) {
    return put(`${this.baseUrl}/${path}`, body, true, { signal });
  }
  patch(path, body, signal) {
    return patch(`${this.baseUrl}/${path}`, body, true, { signal });
  }
  delete(path, query, signal) {
    return del(`${this.baseUrl}/${path}`, query, true, { signal });
  }
  download(path, method, body, signal) {
    return __async$A(this, null, function* () {
      const response = yield fetch(`${this.baseUrl}/${path}`, {
        method: method != null ? method : "GET",
        headers: {
          "Content-Type": "application/json"
        },
        body: body ? JSON.stringify(body) : void 0,
        signal
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return yield response.blob();
    });
  }
  downloadReport(path, method, body, signal) {
    return __async$A(this, null, function* () {
      const response = yield fetch(`${onEventCoreAPI.baseUrl}/${path}`, {
        method: method != null ? method : "GET",
        headers: {
          "Content-Type": "application/json"
        },
        body: body ? JSON.stringify(body) : void 0,
        signal
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return yield response.blob();
    });
  }
}
const onEventAPI = new HttpService(process.env.ONEVENT_API_PATHNAME);
const onEventCoreAPI = new HttpService(process.env.ONEVENT_CORE_API_PATHNAME);
const portalFrameworkService = new HttpService(portalFrameworkApiPath);
const httpService$1 = onEventAPI;

var __defProp$1I = Object.defineProperty;
var __defProps$1n = Object.defineProperties;
var __getOwnPropDescs$1n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1J = Object.getOwnPropertySymbols;
var __hasOwnProp$1J = Object.prototype.hasOwnProperty;
var __propIsEnum$1J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1I = (obj, key, value) => key in obj ? __defProp$1I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1J.call(b, prop))
      __defNormalProp$1I(a, prop, b[prop]);
  if (__getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(b)) {
      if (__propIsEnum$1J.call(b, prop))
        __defNormalProp$1I(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1n = (a, b) => __defProps$1n(a, __getOwnPropDescs$1n(b));
function useAttachmentDownload(objectAttachmentId, options) {
  const queryOptions = useMemo(() => __spreadProps$1n(__spreadValues$1I({}, options), {
    staleTime: Number.POSITIVE_INFINITY
  }), [options]);
  const url = `Attachment/Download/${objectAttachmentId}`;
  const queryKey = [url];
  const query = useQuery$1(
    queryKey,
    ({ signal }) => httpService$1.download(url, "GET", void 0, signal),
    queryOptions
  );
  return [query, queryKey];
}

var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid$1 = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid$1(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid$1(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid$1(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid$1(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid$1,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

var __defProp$1H = Object.defineProperty;
var __defProps$1m = Object.defineProperties;
var __getOwnPropDescs$1m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1I = Object.getOwnPropertySymbols;
var __hasOwnProp$1I = Object.prototype.hasOwnProperty;
var __propIsEnum$1I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1H = (obj, key, value) => key in obj ? __defProp$1H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1I.call(b, prop))
      __defNormalProp$1H(a, prop, b[prop]);
  if (__getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(b)) {
      if (__propIsEnum$1I.call(b, prop))
        __defNormalProp$1H(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1m = (a, b) => __defProps$1m(a, __getOwnPropDescs$1m(b));
var __objRest$V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function isFormRenderProp(fn) {
  return typeof fn === "function";
}
function useForm(_a) {
  var _b = _a, {
    validationSchema = z$1.any(),
    onSubmit = noop$6,
    onError = noop$6
  } = _b, props = __objRest$V(_b, [
    "validationSchema",
    "onSubmit",
    "onError"
  ]);
  const _a2 = Object.assign(
    {
      resolver: zodResolver
    },
    props
  ), { resolver } = _a2, config = __objRest$V(_a2, ["resolver"]);
  const context = useForm$1(__spreadProps$1m(__spreadValues$1H({}, config), {
    resolver: resolver(validationSchema)
  }));
  const { handleSubmit, reset } = context;
  const component = useMemo(
    () => (_a3) => {
      var _b2 = _a3, { children } = _b2, props2 = __objRest$V(_b2, ["children"]);
      return /* @__PURE__ */ jsx(FormProvider, __spreadProps$1m(__spreadValues$1H({}, context), { children: /* @__PURE__ */ jsx("form", __spreadProps$1m(__spreadValues$1H({ noValidate: true }, props2), { onSubmit: handleSubmit(onSubmit, onError), onReset: () => reset(), children: isFormRenderProp(children) ? children(context) : children })) }));
    },
    [onSubmit, onError]
  );
  return useMemo(() => [context, component], [component]);
}

const boolOptional = z$1.boolean().nullable().optional();
const stringOptional = z$1.string().nullable().optional();
const optional = z$1.any().nullable().optional();
const inputRequired = z$1.string().min(1, { message: "Is required" });
const email = z$1.string({
  required_error: "Email is required",
  invalid_type_error: "Email is required"
}).email({ message: "Invalid email" });
const empty = z$1.string().max(0).optional().nullable();
const phoneRegex = new RegExp(
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
);
const phone = z$1.string({
  required_error: "Phone is required",
  invalid_type_error: "Phone is required"
}).regex(phoneRegex, "Invalid phone number");
const passwordMinLength = 8;
const password = z$1.string().min(passwordMinLength, { message: `Password must at least ${passwordMinLength} characters long` });
const zodValidator = {
  inputRequired,
  email,
  phone,
  empty,
  optional,
  boolOptional,
  stringOptional,
  password
};

function useFormConfigure({ config = {}, otherSettings = [] }) {
  const getConfig = useCallback((configKey) => {
    if (config) {
      return config[configKey];
    }
  }, [config]);
  const getHidedValue = useCallback((configKey) => {
    var _a;
    return ((_a = getConfig(configKey)) == null ? void 0 : _a.hided) || false;
  }, [getConfig]);
  const getRequiredValue = useCallback((configKey) => {
    var _a;
    return ((_a = getConfig(configKey)) == null ? void 0 : _a.required) || false;
  }, [getConfig]);
  const validationSchema = useMemo(() => {
    const generalValidateSchema = z$1.object(
      Object.fromEntries(
        [
          ...Object.keys(config).filter(
            (key) => !getHidedValue(key)
          ).map((key) => {
            let validation;
            if (getRequiredValue(key)) {
              validation = zodValidator.inputRequired;
            } else {
              validation = zodValidator.optional;
            }
            return [key, validation];
          }),
          ...otherSettings.map((setting) => {
            return [setting.name, zodValidator.optional];
          })
        ]
      )
    );
    return generalValidateSchema;
  }, [config, otherSettings]);
  return {
    getHidedValue,
    getRequiredValue,
    validationSchema
  };
}

var __defProp$1G = Object.defineProperty;
var __getOwnPropSymbols$1H = Object.getOwnPropertySymbols;
var __hasOwnProp$1H = Object.prototype.hasOwnProperty;
var __propIsEnum$1H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1G = (obj, key, value) => key in obj ? __defProp$1G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1H.call(b, prop))
      __defNormalProp$1G(a, prop, b[prop]);
  if (__getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(b)) {
      if (__propIsEnum$1H.call(b, prop))
        __defNormalProp$1G(a, prop, b[prop]);
    }
  return a;
};
function useGridQuery(params, options) {
  const selectParams = useMemo(() => {
    const select = __spreadValues$1G({}, params);
    if (typeof select.parameters === "object") {
      select.parameters = JSON.stringify(select.parameters);
    }
    return select;
  }, [params]);
  const queryOptions = useMemo(() => options, [options]);
  const queryKey = ["grid", selectParams];
  const query = useQuery$1(
    queryKey,
    ({ signal }) => httpService$1.post("Grid/Select", params, signal),
    queryOptions
  );
  return [query, queryKey];
}

function useIsMounted() {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
    return function cleanup() {
      isMounted.current = false;
    };
  }, []);
  return useCallback(() => isMounted.current, []);
}

function useLoginRedirectPath({ routePermissionMapping, notMatchPath = "/NotFound" }) {
  const auth = useAuth();
  const [redirectPath, setRedirectPath] = useState(null);
  const redirectToPageFromPermission = useCallback(() => {
    const isMatching = Object.keys(routePermissionMapping).some((keyName) => {
      const pagePermission = routePermissionMapping[keyName];
      if (pagePermission.securityContext && pagePermission.securityContextPermission) {
        if (auth.userHasPermission(pagePermission.securityContext, pagePermission.securityContextPermission)) {
          setRedirectPath(pagePermission.path);
          return true;
        }
        return false;
      }
      if (pagePermission.permissions) {
        const hasPermission = pagePermission.permissions.every(
          ([securityContext, securityContextPermission]) => {
            return auth.userHasPermission(securityContext, securityContextPermission);
          }
        );
        if (hasPermission) {
          setRedirectPath(pagePermission.path);
          return true;
        }
        return false;
      }
      return false;
    });
    if (!isMatching) {
      setRedirectPath(notMatchPath);
    }
  }, [auth, notMatchPath, routePermissionMapping]);
  useEffect(() => {
    redirectToPageFromPermission();
  }, [redirectToPageFromPermission]);
  return { redirectPath };
}

var __defProp$1F = Object.defineProperty;
var __getOwnPropSymbols$1G = Object.getOwnPropertySymbols;
var __hasOwnProp$1G = Object.prototype.hasOwnProperty;
var __propIsEnum$1G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1F = (obj, key, value) => key in obj ? __defProp$1F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1G.call(b, prop))
      __defNormalProp$1F(a, prop, b[prop]);
  if (__getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(b)) {
      if (__propIsEnum$1G.call(b, prop))
        __defNormalProp$1F(a, prop, b[prop]);
    }
  return a;
};
function useLookupQuery(params, options, uniqKey) {
  const searchOptions = useMemo(() => {
    const search = __spreadValues$1F({}, params);
    if (typeof search.additionalFilter === "object") {
      search.additionalFilter = JSON.stringify(search.additionalFilter);
    }
    return search;
  }, [params]);
  const queryOptions = useMemo(() => options, [options]);
  const queryKey = ["lookup", searchOptions, uniqKey || ""];
  const query = useQuery$1(
    queryKey,
    ({ signal }) => httpService$1.post("Lookup/Search", searchOptions, signal),
    queryOptions
  );
  return [query, queryKey];
}

function useMobileBreakpoint() {
  const theme = useTheme$2();
  return useMediaQuery(theme.breakpoints.down("sm"));
}

function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$c.apply(null, arguments);
}

let warnedOnce$1 = false;

/**
 * @ignore - do not document.
 */
var MuiAlert = /*#__PURE__*/React$1.forwardRef(function DeprecatedAlert(props, ref) {
  if (!warnedOnce$1) {
    console.warn(['MUI: The Alert component was moved from the lab to the core.', '', "You should use `import { Alert } from '@mui/material'`", "or `import Alert from '@mui/material/Alert'`"].join('\n'));
    warnedOnce$1 = true;
  }
  return /*#__PURE__*/jsx(Alert, _extends$c({
    ref: ref
  }, props));
});

function PopupAlert({ message, severity, duration, placement, handleClose }) {
  return /* @__PURE__ */ jsx(Snackbar, { open: true, anchorOrigin: placement, autoHideDuration: duration, onClose: handleClose, children: /* @__PURE__ */ jsx(MuiAlert, { elevation: 6, variant: "filled", severity, children: /* @__PURE__ */ jsx(Fragment, { children: Array.isArray(message) ? message.map((x) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    x,
    /* @__PURE__ */ jsx("br", {})
  ] }, x)) : message }) }) });
}
function usePopupAlert() {
  const popup = useCallback(
    ({
      message,
      severity = "info",
      duration = 6e3,
      placement = { vertical: "bottom", horizontal: "center" }
    }) => {
      return new Promise((resolve) => {
        const container = document.createElement("div");
        const root = createRoot(container);
        document.body.appendChild(container);
        const handleClose = () => {
          root.unmount();
          document.body.removeChild(container);
          resolve();
        };
        root.render(
          /* @__PURE__ */ jsx(
            PopupAlert,
            {
              message,
              severity,
              duration,
              placement,
              handleClose
            }
          )
        );
      });
    },
    []
  );
  return popup;
}

function useSortedTransportLegs(transportLegs) {
  const filter = (x) => !!x.transport.portID && x.transport.portID !== 0;
  const comparer = (a, b) => {
    if (!!a.transport.etd && !a.transport.eta && !!b.transport.etd && !!b.transport.eta) {
      return -1;
    }
    if (!!a.transport.etd && !!b.transport.etd) {
      return new Date(a.transport.etd).getTime() - new Date(b.transport.etd).getTime();
    }
    if (!!a.transport.etd && !a.transport.eta) {
      return -1;
    }
    if (!!a.transport.eta && !a.transport.etd) {
      return 1;
    }
    return 0;
  };
  const filtered = transportLegs.filter(filter);
  return filtered.sort(comparer);
}

function useSupplyChainEventList(objectID, objectType, options) {
  const url = "SupplyChainEvent/List";
  const objectTypeKey = objectType != null ? objectType : "Job";
  const queryKey = [url, objectTypeKey, objectID];
  const queryOptions = useMemo(() => options, [options]);
  const query = useQuery$1(
    queryKey,
    ({ signal }) => httpService$1.get(url, {
      objectID,
      objectType: objectTypeKey
    }, signal),
    queryOptions
  );
  return [query, queryKey];
}

function useSupplyChainMemberList(supplyChainID, options) {
  const url = "SupplyChainMember/List";
  const queryKey = [url, supplyChainID];
  const queryOptions = useMemo(() => options, [options]);
  const query = useQuery$1(
    queryKey,
    ({ signal }) => httpService$1.get(url, {
      supplyChainID
    }, signal),
    queryOptions
  );
  return [query, queryKey];
}

function useTabletBreakpoint() {
  const theme = useTheme$2();
  return useMediaQuery(theme.breakpoints.down("md"));
}

function useToggle(defaultValue) {
  const [isOpen, setIsOpen] = useState(defaultValue || false);
  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  return [isOpen, handleOpen, handleClose];
}

class AccountService {
  changePassword(data, signal) {
    return httpService$1.post(`Account/ChangePassword`, data, signal);
  }
  createPin(data, signal) {
    return httpService$1.post("Account/CreatePIN", data, signal);
  }
  resetPassword(data, signal) {
    return httpService$1.post("Account/ResetPassword", data, signal);
  }
}
class PortalFrameAccountService {
  changePassword(data, signal) {
    return portalFrameworkService.post(`Account/ChangePassword`, data, signal);
  }
  forgotPassword(data, signal) {
    return portalFrameworkService.post("Account/ForgotPassword", data, signal);
  }
}

class UserService {
  getUser(id, signal) {
    return httpService$1.get(`User/${id}`, void 0, signal);
  }
  createUser(userData, signal) {
    return httpService$1.post(`User`, userData, signal);
  }
  updateUser(userId, userData, signal) {
    return httpService$1.put(`User/${userId}`, userData, signal);
  }
}

class UserSettingService {
  getSetting(queryOption, signal) {
    const query = getQueryStringFromObject(queryOption);
    return httpService$1.get(`UserSetting${query}`, void 0, signal);
  }
  saveSetting(setting, signal) {
    return httpService$1.post(`UserSetting`, setting, signal);
  }
  getListSetting(queryOption, signal) {
    const query = getQueryStringFromObject(queryOption);
    return httpService$1.get(`UserSetting/List${query}`, void 0, signal);
  }
  getListSettingOfOther(queryOption, signal) {
    const query = getQueryStringFromObject(queryOption);
    return httpService$1.get(`UserSetting/ListOther${query}`, void 0, signal);
  }
  updateListSetting(settingList, signal) {
    return httpService$1.put(`UserSetting/Update`, settingList, signal);
  }
  updateListSettingOfOther(settingList, userID, signal) {
    const queryObj = {
      userID
    };
    const query = getQueryStringFromObject(queryObj);
    return httpService$1.put(`UserSetting/UpdateOther${query}`, settingList, signal);
  }
}

class ContactService {
  updateContact(contactId, contactData, signal) {
    return httpService$1.put(`Contact/${contactId}`, contactData, signal);
  }
}

class UserGroupService {
  getUserGroup(userId, signal) {
    const query = getQueryStringFromObject({ userID: userId });
    return httpService$1.get(`UserGroup/List${query}`, void 0, signal);
  }
  updateUserGroup(userId, userGroups, signal) {
    const query = getQueryStringFromObject({ userID: userId });
    return httpService$1.put(`UserGroup/Update${query}`, userGroups, signal);
  }
}

class MyAccountService {
  getMe(signal) {
    return httpService$1.get("MyAccount/Me", void 0, signal);
  }
  updateMe(userData, signal) {
    return httpService$1.put("MyAccount/Me", userData, signal);
  }
}

class ShareService {
  createMagicLink(data, signal) {
    const { intent, returnUrl, objectId } = data;
    switch (intent) {
      case "Shipment":
        return this.createShipmentMagicLink(objectId, returnUrl, signal);
      case "Order":
        return this.createOrderMagicLink(objectId, returnUrl, signal);
      case "Container":
        return this.createContainerMagicLink(objectId, returnUrl, signal);
    }
  }
  createShipmentMagicLink(shipmentId, returnUrl, signal) {
    const query = getQueryStringFromObject({ returnUrl });
    return httpService$1.post(`Share/Shipment/${shipmentId}${query}`, void 0, signal);
  }
  createOrderMagicLink(orderId, returnUrl, signal) {
    const query = getQueryStringFromObject({ returnUrl });
    return httpService$1.post(`Share/Order/${orderId}${query}`, void 0, signal);
  }
  createContainerMagicLink(containerId, returnUrl, signal) {
    const query = getQueryStringFromObject({ returnUrl });
    return httpService$1.post(`Share/Container/${containerId}${query}`, void 0, signal);
  }
}

class ScheduleJobService {
  getScheduleJobSearch(queryObject, signal) {
    const query = getQueryStringFromObject(queryObject);
    return httpService$1.get(`ScheduleJob/Search${query}`, void 0, signal);
  }
  getScheduleJobByID(scheduleJobId, signal) {
    return httpService$1.get(`ScheduleJob/${scheduleJobId}`, void 0, signal);
  }
  createScheduleJob(data, signal) {
    return httpService$1.post(`ScheduleJob`, data, signal);
  }
  updateScheduleJob(id, data, signal) {
    return httpService$1.put(`ScheduleJob/${id}`, data, signal);
  }
}

class NotificationConfigurationService {
  getNotificationConfiguration(notificationId, signal) {
    return httpService$1.get(`NotificationConfiguration/${notificationId}`, void 0, signal);
  }
  postNotificationConfiguration(body, signal) {
    return httpService$1.post(`NotificationConfiguration`, body, signal);
  }
  getNotificationConfigurationList(path, signal) {
    const { objectId, objectType, contactId } = path;
    return httpService$1.get(`NotificationConfiguration/${objectId}/${objectType}/${contactId}`, void 0, signal);
  }
  postNotificationConfigurationList(body, signal) {
    return httpService$1.post("NotificationConfiguration/SaveList", body, signal);
  }
}

var __async$z = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function useUserGroupHelper({ adminGroupName = "Administrators" }) {
  const myAccountService = new MyAccountService();
  const userGroupService = new UserGroupService();
  const [myUserGroups, setMyUserGroups] = useState([]);
  const mapLookupToUserGroupData = useCallback((lookupData) => {
    if (Array.isArray(lookupData)) {
      return lookupData.map((item) => {
        var _a;
        return {
          id: item.id,
          name: item.name,
          categoryName: (_a = item.additionalData) == null ? void 0 : _a.categoryName
        };
      });
    }
    return [];
  }, []);
  const [adminGroupQuery] = useLookupQuery({
    searchTerm: adminGroupName,
    systemName: "UserGroup",
    additionalFilter: { activeStatus: true }
  });
  const getAdminGroup = useCallback(() => {
    var _a, _b;
    const result = (_b = (_a = adminGroupQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results;
    if (Array.isArray(result)) {
      const matchUserGroup = mapLookupToUserGroupData(result.filter((item) => item.name === adminGroupName));
      return matchUserGroup[0];
    }
    return void 0;
  }, [mapLookupToUserGroupData, adminGroupName, adminGroupQuery]);
  const getMyUserGroups = useCallback(() => __async$z(this, null, function* () {
    var _a;
    try {
      const myAccountResponse = yield myAccountService.getMe();
      const myUserId = (_a = myAccountResponse.data) == null ? void 0 : _a.id;
      const myUserGroupResponse = yield userGroupService.getUserGroup(myUserId);
      const myGroup = myUserGroupResponse.data;
      setMyUserGroups(myGroup);
    } catch (e) {
    }
  }), []);
  useEffect(() => {
    getMyUserGroups();
  }, [getMyUserGroups]);
  const hasAdminGroup = useMemo(() => {
    if (Array.isArray(myUserGroups)) {
      return myUserGroups.findIndex((userGroup) => {
        return userGroup.name === adminGroupName;
      }) !== -1;
    }
    return false;
  }, [myUserGroups, adminGroupName]);
  return { mapLookupToUserGroupData, getAdminGroup, hasAdminGroup };
}

function useUserParentHelper(options) {
  const { userID, userContactType, parentContacts, childContactTypeName, parentContactTypeName } = options;
  const [childContactTypeQuery] = useLookupQuery({
    searchTerm: childContactTypeName,
    systemName: "ContactType"
  });
  const [parentContactTypeQuery] = useLookupQuery({
    searchTerm: parentContactTypeName,
    systemName: "ContactType"
  });
  const [userContactQuery] = useLookupQuery({
    systemName: "CoreContact",
    additionalFilter: {
      contactType: userContactType,
      contactID: userID
    }
  });
  const getContactContactTypeIdFromQuery = useCallback((query) => {
    var _a, _b, _c;
    const result = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results[0];
    return ((_c = result == null ? void 0 : result.additionalData) == null ? void 0 : _c.contactContactTypeID) || null;
  }, []);
  const getContactTypeIdFromQuery = useCallback((query) => {
    var _a, _b;
    const result = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results[0];
    return (result == null ? void 0 : result.id) || null;
  }, []);
  const childContactContactTypeID = useMemo(() => {
    if (userID && userContactType) {
      const id = getContactContactTypeIdFromQuery(userContactQuery);
      return id;
    }
    return null;
  }, [userContactQuery]);
  const childContactTypeID = useMemo(() => {
    if (childContactTypeName) {
      return getContactTypeIdFromQuery(childContactTypeQuery);
    }
    return null;
  }, [childContactTypeQuery]);
  const parentContactTypeID = useMemo(() => {
    if (parentContactTypeName) {
      return getContactTypeIdFromQuery(parentContactTypeQuery);
    }
    return null;
  }, [parentContactTypeQuery]);
  const parentContactsFilterByContactType = useMemo(() => {
    if (Array.isArray(parentContacts)) {
      return parentContacts.filter((contact) => {
        var _a, _b;
        let childContactTypeMatch = true;
        let parentContactTypeMatch = true;
        if (childContactTypeID) {
          childContactTypeMatch = ((_a = contact.childContactTypeID) == null ? void 0 : _a.toString()) === childContactTypeID;
        }
        if (parentContactTypeID) {
          parentContactTypeMatch = ((_b = contact.parentContactTypeID) == null ? void 0 : _b.toString()) === parentContactTypeID;
        }
        return childContactTypeMatch && parentContactTypeMatch;
      });
    }
    return [];
  }, [parentContacts, childContactTypeID, parentContactTypeID]);
  const mapFromContactContactToOrganisation = (contactContact) => {
    return {
      organisationID: contactContact.parentContactID,
      organisationName: contactContact.parentContactName || "",
      organisationContactContactTypeID: contactContact.parentContactContactTypeID
    };
  };
  const mapFromOrganisationToContactContact = useCallback((organisation) => {
    if (userID && childContactContactTypeID) {
      return {
        childContactID: userID,
        childContactContactTypeID,
        parentContactID: organisation.organisationID,
        parentContactContactTypeID: organisation.organisationContactContactTypeID,
        delete: organisation.delete
      };
    }
    return null;
  }, [userID, childContactContactTypeID]);
  const mapAllFromOrganisationToContactContact = useCallback((organisations) => {
    if (Array.isArray(organisations)) {
      let notEmpty = function(value) {
        return value !== null && value !== void 0;
      };
      return organisations.map(
        (org) => mapFromOrganisationToContactContact(org)
      ).filter(notEmpty);
    }
    return [];
  }, [mapFromOrganisationToContactContact]);
  const userOrganisations = useMemo(() => {
    return parentContactsFilterByContactType.map((contact) => {
      return mapFromContactContactToOrganisation(contact);
    });
  }, [parentContactsFilterByContactType]);
  return {
    parentContactsFilterByContactType,
    userOrganisations,
    userContactContactTypeID: childContactContactTypeID,
    mapFromContactContactToOrganisation,
    mapAllFromOrganisationToContactContact
  };
}

function useUserPreferenceHelper({ userPreferences, settingTypeSystemName }) {
  const userPreferenceData = useMemo(() => {
    let preferenceData = {};
    if (Array.isArray(userPreferences)) {
      userPreferences.forEach((preference) => {
        preferenceData[preference.systemName] = preference.setting;
      });
    }
    return preferenceData;
  }, [userPreferences]);
  const mapPreferenceFormToAPIdata = useCallback((preferenceFormData) => {
    return Object.keys(preferenceFormData).map((preferenceKey) => {
      return {
        systemName: preferenceKey,
        settingTypeSystemName,
        setting: preferenceFormData[preferenceKey]
      };
    });
  }, [settingTypeSystemName]);
  return { userPreferenceData, mapPreferenceFormToAPIdata };
}

function useVesselMovementCoordinates(data) {
  const lineCoordsQueries = useQueries({
    queries: data.map((vm) => ({
      queryKey: ["/GeoCoordinate/List", vm.transportID, "VesselMovement"],
      queryFn: () => httpService$1.get(`GeoCoordinate/List?objectID=${vm.transportID}&objectType=VesselMovement`)
    }))
  });
  return aggregateQueries(lineCoordsQueries);
}

function useVesselMovementLocations(data) {
  const portCoordsQueries = useQueries({
    queries: [...new Set(data.map((vm) => vm.transport.portID))].map((portID) => ({
      queryKey: ["/Location/Get", portID],
      queryFn: () => httpService$1.get(`Location/Get?objectID=${portID}`)
    }))
  });
  return aggregateQueries(portCoordsQueries);
}

const EventCode = {
  Air: {
    Approved: "Approved",
    BookingConfirmed: "BookingConfirmed",
    BookingRequested: "BookingRequested",
    ConfirmedOnFlight: "ConfirmedOnFlight",
    Created: "Created",
    Delivered: "Delivered"
  },
  FCL: {
    Approved: "Approved",
    BookingConfirmed: "BookingConfirmed",
    BookingRequested: "BookingRequested",
    ContainersOnboard: "ContainersOnboard",
    Created: "Created",
    Delivered: "Delivered"
  },
  LCL: {
    Approved: "Approved",
    BookingConfirmed: "BookingConfirmed",
    BookingRequested: "BookingRequested",
    ContainersOnboard: "ContainersOnboard",
    Created: "Created",
    Delivered: "Delivered"
  },
  Order: {
    ActualCargoReady: "ActualCargoReady"
  },
  Container: {
    Delivered: "Delivered"
  }
};

const SecurityContext = {
  Consignment: "portal_Consignment",
  DistributionOrder: "portal_DistributionOrder",
  Menu: "portal_Menu",
  Host: "web_Host"
};

const Symbol$1 = {
  "Degrees": "\xB0",
  "DegreesEast": "\xB0E",
  "DegreesSouth": "\xB0S",
  "DegreesNorth": "\xB0N",
  "DegreesWest": "\xB0W",
  "KilometersPerHour": "km/h",
  "KilometresPerHour": "km/h",
  "Knots": "kn"
};

const SystemName = {
  CodeQualifier: {
    ShipmentMode: "ShipmentMode",
    ShipmentType: "ShipmentType"
  },
  ContactType: {
    Consignee: "Consignee",
    Consignor: "Consignor"
  },
  ContainerTransportType: {
    Standard: "Standard",
    Side: "Side"
  },
  GeoCoordinateInformationType: {
    GeneralEvent: "GeneralEvent",
    SignificantEvent: "SignificantEvent"
  },
  GoodsLoad: {
    Full: "Full",
    Empty: "Empty"
  },
  JobType: {
    EmptyContainerDelivery: "EmptyContainerDelivery",
    EmpyContainerPickup: "EmpyContainerPickup",
    FullContainerDelivery: "FullContainerDelivery",
    LCLAirDelivery: "LCLAirDelivery",
    LCLAirPickup: "LCLAirPickup",
    PackedContainerPickup: "PackedContainerPickup",
    PortalOrder: "PortalOrder",
    PortalShipment: "PortalShipment",
    FreightConsignment: "FreightConsignment",
    ContainerConsignment: "ContainerConsignment"
  },
  LocationType: {
    Country: "Country",
    Port: "Port",
    Address: "Address",
    Terminal: "Terminal",
    Area: "Area",
    Park: "Park",
    Client: "Client"
  },
  MeasureUnitType: {
    "Degrees": "Degrees",
    "DegreesEast": "DegreesEast",
    "DegreesSouth": "DegreesSouth",
    "DegreesNorth": "DegreesNorth",
    "DegreesWest": "DegreesWest"
  },
  MovementType: {
    Import: "Import",
    Export: "Export",
    Move: "Move"
  },
  NotificationTransportType: {
    Messaging: "Messaging",
    Email: "Email"
  },
  NotificationType: {
    Report: "Report"
  },
  ScheduleJobType: {
    ReportNotification: "ReportNotification"
  },
  ServiceType: {
    Direct: "Direct",
    Transhipment: "Transhipment"
  },
  ShipmentMode: {
    Air: "Air",
    Sea: "Sea"
  },
  ShipmentType: {
    FCL: "FCL",
    LCL: "LCL",
    FCLOrLCL: "FCLOrLCL"
  },
  Status: {
    BookingConfirmed: "BookingConfirmed",
    BookingInProgress: "BookingInProgress",
    BookingRequested: "BookingRequested",
    EmptyContainerDehired: "EmptyContainerDehired",
    GoodsArrivedAtDestination: "GoodsArrivedAtDestination",
    GoodsArrivedAtTranshipmentPort: "GoodsArrivedAtTranshipmentPort",
    GoodsBookedForDelivery: "GoodsBookedForDelivery",
    GoodsCustomsClearedAtDestination: "GoodsCustomsClearedAtDestination",
    GoodsCustomsClearedAndArrivedAtDestination: "GoodsCustomsClearedAndArrivedAtDestination",
    GoodsDelivered: "GoodsDelivered",
    GoodsDispatchedAtSupplier: "GoodsDispatchedAtSupplier",
    GoodsInInternationalTransit: "GoodsInInternationalTransit",
    GoodsInInternationalTransitToDestination: "GoodsInInternationalTransitToDestination",
    GoodsReadyAtSupplier: "GoodsReadyAtSupplier",
    InTransit: "InTransit",
    ShipmentBookedWithCarrier: "ShipmentBookedWithCarrier",
    Draft: "Draft",
    Quote: "Quote",
    Submitted: "Submitted"
  }
};

const SystemCookies = {
  Organisations: "organisations"
};

var __defProp$1E = Object.defineProperty;
var __defProps$1l = Object.defineProperties;
var __getOwnPropDescs$1l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1F = Object.getOwnPropertySymbols;
var __hasOwnProp$1F = Object.prototype.hasOwnProperty;
var __propIsEnum$1F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1E = (obj, key, value) => key in obj ? __defProp$1E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1F.call(b, prop))
      __defNormalProp$1E(a, prop, b[prop]);
  if (__getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(b)) {
      if (__propIsEnum$1F.call(b, prop))
        __defNormalProp$1E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1l = (a, b) => __defProps$1l(a, __getOwnPropDescs$1l(b));
var __async$y = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function useFavouriteReportSchedulingData({
  favouriteId,
  reportNotificationTypeId,
  contactId,
  emailTransportTypeId,
  timeZoneId
}) {
  const favouriteObjectType = "ReportUserFavourite";
  const notificationConfigService = new NotificationConfigurationService();
  const scheduleJobService = new ScheduleJobService();
  const queryClient = useQueryClient();
  const {
    isFetching: loadingNotificationConfigurationList,
    isError: loadingNotificationConfigurationListError,
    refetch: refetchNotificationConfiguration,
    data: notificationConfigurationData
  } = useQuery$1({
    queryKey: ["notificationConfiguration", favouriteId],
    queryFn: () => notificationConfigService.getNotificationConfigurationList({
      contactId: contactId || "",
      objectId: favouriteId || "",
      objectType: favouriteObjectType
    }),
    enabled: !!contactId && !!favouriteId
  });
  useEffect(() => {
    if (favouriteId) {
      refetchNotificationConfiguration();
    }
  }, [favouriteId, refetchNotificationConfiguration]);
  const reportNotificationConfiguration = useMemo(() => {
    if (Array.isArray(notificationConfigurationData == null ? void 0 : notificationConfigurationData.data)) {
      return notificationConfigurationData == null ? void 0 : notificationConfigurationData.data.find((nc) => {
        return nc.notificationTypeID.toString() === reportNotificationTypeId;
      });
    }
    return void 0;
  }, [notificationConfigurationData, reportNotificationTypeId]);
  const reportNotificationConfigurationId = useMemo(() => {
    return reportNotificationConfiguration == null ? void 0 : reportNotificationConfiguration.id;
  }, [reportNotificationConfiguration]);
  const {
    isFetching: loadingScheduleJob,
    isError: loadingScheduleJobError,
    refetch: refetchScheduleJob,
    data: scheduleJobData
  } = useQuery$1({
    queryKey: ["scheduleJob", favouriteId],
    queryFn: () => {
      const searchObject = {
        objectID: reportNotificationConfigurationId || "",
        objectType: "NotificationConfiguration",
        contactID: contactId,
        scheduleJobTypeSystemName: SystemName.ScheduleJobType.ReportNotification
      };
      return scheduleJobService.getScheduleJobSearch(searchObject);
    },
    enabled: !!reportNotificationConfigurationId
  });
  const reportScheduleJob = useMemo(() => {
    if (Array.isArray(scheduleJobData == null ? void 0 : scheduleJobData.data)) {
      return scheduleJobData == null ? void 0 : scheduleJobData.data[0];
    }
    return void 0;
  }, [scheduleJobData]);
  const notificationConfigurationMutation = useMutation$1({
    mutationKey: ["notificationConfigurationMutation", reportNotificationConfigurationId],
    mutationFn: (state2) => {
      return notificationConfigService.postNotificationConfiguration(state2);
    }
  });
  const scheduleJobCreate = useMutation$1({
    mutationKey: ["scheduleJobCreate"],
    mutationFn: (state2) => {
      const body = __spreadProps$1l(__spreadValues$1E({}, state2), {
        timeZoneID: timeZoneId
      });
      return scheduleJobService.createScheduleJob(body);
    }
  });
  const scheduleJobUpdate = useMutation$1({
    mutationKey: ["scheduleJobUpdate"],
    mutationFn: (state2) => {
      const id = state2.id || "";
      const body = __spreadProps$1l(__spreadValues$1E({}, state2), {
        timeZoneID: timeZoneId
      });
      return scheduleJobService.updateScheduleJob(id, body);
    }
  });
  const handlePostNotificationConfiguration = useCallback((data) => __async$y(this, null, function* () {
    try {
      const result = yield notificationConfigurationMutation.mutateAsync(data);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e);
    }
  }), [notificationConfigurationMutation]);
  const handleCreateScheduleJob = useCallback((data) => __async$y(this, null, function* () {
    try {
      const result = yield scheduleJobCreate.mutateAsync(data);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e);
    }
  }), [scheduleJobCreate]);
  const handleUpdateScheduleJob = useCallback((data) => __async$y(this, null, function* () {
    try {
      const result = yield scheduleJobUpdate.mutateAsync(data);
      return Promise.resolve(result);
    } catch (e) {
      return Promise.reject(e);
    }
  }), [scheduleJobUpdate]);
  const handleRemoveFavouriteScheduleReport = useCallback(() => __async$y(this, null, function* () {
    try {
      if (reportScheduleJob) {
        yield scheduleJobUpdate.mutateAsync(__spreadProps$1l(__spreadValues$1E({}, reportScheduleJob), {
          active: false
        }));
      }
      if (reportNotificationConfiguration) {
        yield notificationConfigurationMutation.mutateAsync(__spreadProps$1l(__spreadValues$1E({}, reportNotificationConfiguration), {
          active: false
        }));
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }), [reportScheduleJob, reportNotificationConfiguration]);
  const handleInvalidateQuery = useCallback(() => {
    queryClient.invalidateQueries(["notificationConfiguration", favouriteId]);
    queryClient.invalidateQueries(["scheduleJob", favouriteId]);
  }, [queryClient]);
  const handleSubmit = useCallback(
    (formData) => __async$y(this, null, function* () {
      try {
        if (reportScheduleJob && reportNotificationConfiguration) {
          yield handleUpdateScheduleJob(__spreadProps$1l(__spreadValues$1E({}, reportScheduleJob), {
            cronExpression: formData.scheduleCron,
            active: true
          }));
          yield handlePostNotificationConfiguration(__spreadProps$1l(__spreadValues$1E({}, reportNotificationConfiguration), {
            email: formData.notifyEmail,
            active: true
          }));
        } else {
          if (reportNotificationConfiguration) {
            yield handlePostNotificationConfiguration(__spreadProps$1l(__spreadValues$1E({}, reportNotificationConfiguration), {
              email: formData.notifyEmail,
              active: true
            }));
            const newScheduleJob = {
              contactID: contactId,
              objectID: reportNotificationConfiguration.id,
              objectType: "NotificationConfiguration",
              scheduleJobTypeSystemName: SystemName.ScheduleJobType.ReportNotification,
              cronExpression: formData.scheduleCron,
              active: true
            };
            yield handleCreateScheduleJob(newScheduleJob);
          } else {
            if (contactId && reportNotificationTypeId && emailTransportTypeId && favouriteId) {
              const newConfiguration = {
                contactID: contactId,
                objectID: favouriteId,
                objectType: favouriteObjectType,
                notificationTypeID: reportNotificationTypeId,
                notificationTransportTypeID: emailTransportTypeId,
                active: true,
                email: formData.notifyEmail
              };
              const result = yield handlePostNotificationConfiguration(newConfiguration);
              const newConfigurationId = result == null ? void 0 : result.data;
              const newScheduleJob = {
                contactID: contactId,
                objectID: newConfigurationId,
                objectType: "NotificationConfiguration",
                scheduleJobTypeSystemName: SystemName.ScheduleJobType.ReportNotification,
                cronExpression: formData.scheduleCron,
                active: true
              };
              yield handleCreateScheduleJob(newScheduleJob);
            }
          }
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }),
    [
      handleCreateScheduleJob,
      handleUpdateScheduleJob,
      handlePostNotificationConfiguration,
      handleInvalidateQuery,
      reportScheduleJob,
      reportNotificationConfiguration,
      favouriteId,
      contactId,
      emailTransportTypeId,
      reportNotificationTypeId
    ]
  );
  const state = useMemo(() => {
    const isLoading = loadingNotificationConfigurationList || loadingScheduleJob;
    const isError = loadingNotificationConfigurationListError || loadingScheduleJobError;
    return {
      isLoading,
      isError
    };
  }, [loadingNotificationConfigurationList, loadingScheduleJob]);
  return {
    state,
    reportNotificationConfiguration,
    reportNotificationConfigurationId,
    reportScheduleJob,
    handleSubmit,
    handlePostNotificationConfiguration,
    handleCreateScheduleJob,
    handleUpdateScheduleJob,
    handleRemoveFavouriteScheduleReport,
    handleInvalidateQuery
  };
}

function useShipmentOptionLookup() {
  const prefetch = true;
  const fetchOption = useMemo(
    () => ({
      enabled: prefetch,
      keepPreviousData: true
    }),
    [prefetch]
  );
  const params = {
    systemName: "Code",
    additionalFilter: {
      codeQualifier: "ShipmentType"
    }
  };
  const [shipmentTypeLookup] = useLookupQuery(params, fetchOption);
  return { shipmentTypeLookup };
}

function useMyTimeZone() {
  const [timeZoneQuery] = useLookupQuery({
    systemName: "TimeZone",
    searchTerm: "New Zealand"
  });
  const findTimeZone = useMemo(() => {
    var _a, _b;
    const result = (_b = (_a = timeZoneQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results[0];
    return result;
  }, [timeZoneQuery]);
  return {
    timeZoneId: findTimeZone == null ? void 0 : findTimeZone.id
  };
}

function useMyAccount() {
  const myAccountService = new MyAccountService();
  const {
    data: userData
  } = useQuery$1(["myDetail"], () => myAccountService.getMe());
  const userDetail = useMemo(() => {
    return userData == null ? void 0 : userData.data;
  }, [userData]);
  return {
    userDetail
  };
}

var __defProp$1D = Object.defineProperty;
var __defProps$1k = Object.defineProperties;
var __getOwnPropDescs$1k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1E = Object.getOwnPropertySymbols;
var __hasOwnProp$1E = Object.prototype.hasOwnProperty;
var __propIsEnum$1E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1D = (obj, key, value) => key in obj ? __defProp$1D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1E.call(b, prop))
      __defNormalProp$1D(a, prop, b[prop]);
  if (__getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(b)) {
      if (__propIsEnum$1E.call(b, prop))
        __defNormalProp$1D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1k = (a, b) => __defProps$1k(a, __getOwnPropDescs$1k(b));
const loadPreferences = ({ preferences, type }) => __spreadProps$1k(__spreadValues$1D({}, preferences), {
  type
});
const insertView = (state, { name, value }) => __spreadProps$1k(__spreadValues$1D({}, state), {
  type: "savePreferences",
  activeViewName: name,
  preferences: [
    ...state.preferences,
    {
      name,
      config: value
    }
  ]
});
const updateView = (state, { index, value }) => __spreadProps$1k(__spreadValues$1D({}, state), {
  type: "savePreferences",
  preferences: state.preferences.map((preference, i) => {
    if (i !== index) {
      return preference;
    }
    return __spreadProps$1k(__spreadValues$1D({}, preference), {
      config: value
    });
  })
});
const deleteView = (state, { name }) => {
  const preferences = state.preferences.filter((preference) => preference.name !== name);
  return __spreadProps$1k(__spreadValues$1D({}, state), {
    type: "savePreferences",
    preferences,
    activeViewName: "Default"
  });
};
const setActiveView = (state, { name }) => __spreadProps$1k(__spreadValues$1D({}, state), {
  type: "savePreferences",
  activeViewName: name
});
const toolbarReducer = (state, action) => {
  switch (action.type) {
    case "loadPreferences":
      return loadPreferences(action);
    case "insertView":
      return insertView(state, action);
    case "updateView":
      return updateView(state, action);
    case "deleteView":
      return deleteView(state, action);
    case "setActiveView":
      return setActiveView(state, action);
    default:
      return state;
  }
};

// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}
function dehydrate(client, options = {}) {
  const mutations = [];
  const queries = [];

  if (options.dehydrateMutations !== false) {
    const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(mutation => {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (options.dehydrateQueries !== false) {
    const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(query => {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations,
    queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  const mutationCache = client.getMutationCache();
  const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const queries = dehydratedState.queries || [];
  mutations.forEach(dehydratedMutation => {
    var _options$defaultOptio;

    mutationCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations),
      mutationKey: dehydratedMutation.mutationKey
    }, dehydratedMutation.state);
  });
  queries.forEach(({
    queryKey,
    state,
    queryHash
  }) => {
    var _options$defaultOptio2;

    const query = queryCache.get(queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
        // omit fetchStatus from dehydrated state
        // so that query stays in its current fetchStatus
        const {
          fetchStatus: _ignored,
          ...dehydratedQueryState
        } = state;
        query.setState(dehydratedQueryState);
      }

      return;
    } // Restore query


    queryCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries),
      queryKey,
      queryHash
    }, // Reset fetch status to idle to avoid
    // query being stuck in fetching state upon hydration
    { ...state,
      fetchStatus: 'idle'
    });
  });
}

/**
 * Checks if emitted event is about cache change and not about observers.
 * Useful for persist, where we only want to trigger save when cache is changed.
 */
const cacheableEventTypes = ['added', 'removed', 'updated'];

function isCacheableEventType(eventType) {
  return cacheableEventTypes.includes(eventType);
}
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */


async function persistQueryClientRestore({
  queryClient,
  persister,
  maxAge = 1000 * 60 * 60 * 24,
  buster = '',
  hydrateOptions
}) {
  try {
    const persistedClient = await persister.restoreClient();

    if (persistedClient) {
      if (persistedClient.timestamp) {
        const expired = Date.now() - persistedClient.timestamp > maxAge;
        const busted = persistedClient.buster !== buster;

        if (expired || busted) {
          persister.removeClient();
        } else {
          hydrate(queryClient, persistedClient.clientState, hydrateOptions);
        }
      } else {
        persister.removeClient();
      }
    }
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      queryClient.getLogger().error(err);
      queryClient.getLogger().warn('Encountered an error attempting to restore client cache from persisted location. As a precaution, the persisted cache will be discarded.');
    }

    persister.removeClient();
  }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */

async function persistQueryClientSave({
  queryClient,
  persister,
  buster = '',
  dehydrateOptions
}) {
  const persistClient = {
    buster,
    timestamp: Date.now(),
    clientState: dehydrate(queryClient, dehydrateOptions)
  };
  await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */

function persistQueryClientSubscribe(props) {
  const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe(event => {
    if (isCacheableEventType(event.type)) {
      persistQueryClientSave(props);
    }
  });
  const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe(event => {
    if (isCacheableEventType(event.type)) {
      persistQueryClientSave(props);
    }
  });
  return () => {
    unsubscribeQueryCache();
    unusbscribeMutationCache();
  };
}

function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$b.apply(this, arguments);
}

const PersistQueryClientProvider = ({
  client,
  children,
  persistOptions,
  onSuccess,
  ...props
}) => {
  const [isRestoring, setIsRestoring] = React$1.useState(true);
  const refs = React$1.useRef({
    persistOptions,
    onSuccess
  });
  const didRestore = React$1.useRef(false);
  React$1.useEffect(() => {
    refs.current = {
      persistOptions,
      onSuccess
    };
  });
  React$1.useEffect(() => {
    const options = { ...refs.current.persistOptions,
      queryClient: client
    };

    if (!didRestore.current) {
      didRestore.current = true;
      setIsRestoring(true);
      persistQueryClientRestore(options).then(async () => {
        try {
          await (refs.current.onSuccess == null ? void 0 : refs.current.onSuccess());
        } finally {
          setIsRestoring(false);
        }
      });
    }

    return isRestoring ? undefined : persistQueryClientSubscribe(options);
  }, [client, isRestoring]);
  return /*#__PURE__*/React$1.createElement(QueryClientProvider$1, _extends$b({
    client: client
  }, props), /*#__PURE__*/React$1.createElement(IsRestoringProvider, {
    value: isRestoring
  }, children));
};

function createSyncStoragePersister({
  storage,
  key = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime = 1000,
  serialize = JSON.stringify,
  deserialize = JSON.parse,
  retry
}) {
  if (storage) {
    const trySave = persistedClient => {
      try {
        storage.setItem(key, serialize(persistedClient));
        return;
      } catch (error) {
        return error;
      }
    };

    return {
      persistClient: throttle(persistedClient => {
        let client = persistedClient;
        let error = trySave(client);
        let errorCount = 0;

        while (error && client) {
          errorCount++;
          client = retry == null ? void 0 : retry({
            persistedClient: client,
            error,
            errorCount
          });

          if (client) {
            error = trySave(client);
          }
        }
      }, throttleTime),
      restoreClient: () => {
        const cacheString = storage.getItem(key);

        if (!cacheString) {
          return;
        }

        return deserialize(cacheString);
      },
      removeClient: () => {
        storage.removeItem(key);
      }
    };
  }

  return {
    persistClient: noop$5,
    restoreClient: () => undefined,
    removeClient: noop$5
  };
}

function throttle(func, wait = 100) {
  let timer = null;
  let params;
  return function (...args) {
    params = args;

    if (timer === null) {
      timer = setTimeout(() => {
        func(...params);
        timer = null;
      }, wait);
    }
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function


function noop$5() {}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 1e3 * 60 * 60 * 24
      // 24 hours
    },
    mutations: {
      retry: false
    }
  }
});
const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "APP_CACHE"
});
const persistOptions = {
  persister,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      var _a;
      return ((_a = query.meta) == null ? void 0 : _a.persist) === true && defaultShouldDehydrateQuery$1(query);
    }
  }
};
const QueryClientProvider = PersistQueryClientProvider;
const useQuery = useQuery$1;
const useMutation = useMutation$1;

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign$1 (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign$1({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign$1({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign$1({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign$1({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

const DEFAULT_COOKIE_OPTIONS = {
  expires: 30,
  secure: !!(process.env.NODE_ENV === "production"),
  sameSite: "strict"
};
const Context$f = createContext({});
function PortalApplicationContext({ children }) {
  const [selectedOrganisations, setSelectedOrganisations] = useState(() => {
    const cookieValue = api.get(SystemCookies.Organisations);
    return cookieValue && cookieValue !== null ? JSON.parse(cookieValue) : [];
  });
  const getOrganisations = useCallback(() => {
    return selectedOrganisations;
  }, [selectedOrganisations]);
  const setOrganisations = useCallback((organisations) => {
    api.set(SystemCookies.Organisations, JSON.stringify(organisations), DEFAULT_COOKIE_OPTIONS);
    setSelectedOrganisations(organisations);
  }, []);
  const clearOrganisations = useCallback(() => {
    api.remove(SystemCookies.Organisations, DEFAULT_COOKIE_OPTIONS);
    setSelectedOrganisations([]);
  }, []);
  return /* @__PURE__ */ jsx(
    Context$f.Provider,
    {
      value: {
        organisations: {
          getOrganisations,
          setOrganisations,
          clearOrganisations
        }
      },
      children
    }
  );
}
function usePortalApplicationContext() {
  return useContext(Context$f);
}

var __defProp$1C = Object.defineProperty;
var __defProps$1j = Object.defineProperties;
var __getOwnPropDescs$1j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1D = Object.getOwnPropertySymbols;
var __hasOwnProp$1D = Object.prototype.hasOwnProperty;
var __propIsEnum$1D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1C = (obj, key, value) => key in obj ? __defProp$1C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1D.call(b, prop))
      __defNormalProp$1C(a, prop, b[prop]);
  if (__getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(b)) {
      if (__propIsEnum$1D.call(b, prop))
        __defNormalProp$1C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1j = (a, b) => __defProps$1j(a, __getOwnPropDescs$1j(b));
var __objRest$U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DEFAULT_MODAL_OPTIONS = {
  dismissible: true,
  fullWidth: true,
  transitionDuration: 300
};
function Modal$1(_a) {
  var _b = _a, {
    content,
    close: closeFn,
    dismissible,
    transitionDuration
  } = _b, rest = __objRest$U(_b, [
    "content",
    "close",
    "dismissible",
    "transitionDuration"
  ]);
  var _a2;
  const duration = typeof transitionDuration === "number" ? transitionDuration : (_a2 = transitionDuration == null ? void 0 : transitionDuration.exit) != null ? _a2 : 0;
  const [open, setOpen] = useState(true);
  const close = useCallback((x) => {
    setOpen(false);
    setTimeout(() => closeFn(x), duration);
  }, []);
  return /* @__PURE__ */ jsx(
    MuiDialog,
    __spreadProps$1j(__spreadValues$1C({}, rest), {
      open,
      onClose: () => {
        if (dismissible) {
          close();
        }
      },
      transitionDuration,
      children: /* @__PURE__ */ jsx(Fragment, { children: content({ isOpen: open, close }) })
    })
  );
}
function useModal() {
  const theme = useTheme$2();
  return function modal(content, options) {
    const modalOptions = Object.assign(__spreadValues$1C({}, DEFAULT_MODAL_OPTIONS), options);
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);
      const root = createRoot(container);
      const close = (x) => {
        root.unmount();
        document.body.removeChild(container);
        return resolve(x);
      };
      root.render(
        /* @__PURE__ */ jsx(PortalApplicationContext, { children: /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(
          QueryClientProvider,
          {
            client: queryClient,
            persistOptions,
            children: /* @__PURE__ */ jsx(
              Modal$1,
              __spreadProps$1j(__spreadValues$1C({}, modalOptions), {
                content,
                close
              })
            )
          }
        ) }) })
      );
    });
  };
}

var __defProp$1B = Object.defineProperty;
var __defProps$1i = Object.defineProperties;
var __getOwnPropDescs$1i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1C = Object.getOwnPropertySymbols;
var __hasOwnProp$1C = Object.prototype.hasOwnProperty;
var __propIsEnum$1C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1B = (obj, key, value) => key in obj ? __defProp$1B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1C.call(b, prop))
      __defNormalProp$1B(a, prop, b[prop]);
  if (__getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(b)) {
      if (__propIsEnum$1C.call(b, prop))
        __defNormalProp$1B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1i = (a, b) => __defProps$1i(a, __getOwnPropDescs$1i(b));
function ConfirmationDialog({ title, text, close, okButtonText }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: title }),
    /* @__PURE__ */ jsx(DialogContent, { children: typeof text === "string" ? /* @__PURE__ */ jsx(DialogContentText, { children: text }) : /* @__PURE__ */ jsx(Fragment, { children: text }) }),
    /* @__PURE__ */ jsxs(DialogActions, { sx: { padding: "1.25rem" }, children: [
      /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => close(false), children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: () => close(true), children: okButtonText != null ? okButtonText : "OK" })
    ] })
  ] });
}
function useConfirmationDialog() {
  const modal = useModal();
  return function confirmationDialog(title, text, options, okButtonText) {
    return modal(
      (props) => /* @__PURE__ */ jsx(ConfirmationDialog, __spreadProps$1i(__spreadValues$1B({}, props), { title, text, okButtonText })),
      options
    );
  };
}

var __defProp$1A = Object.defineProperty;
var __defProps$1h = Object.defineProperties;
var __getOwnPropDescs$1h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1B = Object.getOwnPropertySymbols;
var __hasOwnProp$1B = Object.prototype.hasOwnProperty;
var __propIsEnum$1B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1A = (obj, key, value) => key in obj ? __defProp$1A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1B.call(b, prop))
      __defNormalProp$1A(a, prop, b[prop]);
  if (__getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(b)) {
      if (__propIsEnum$1B.call(b, prop))
        __defNormalProp$1A(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1h = (a, b) => __defProps$1h(a, __getOwnPropDescs$1h(b));
var __objRest$T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$x = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function useDataGridPreferences(arg1, arg2, _arg3, arg4) {
  if (typeof arg1 === "string") {
    return usePreferences({
      gridSystemName: arg1,
      initialData: arg2,
      apiRef: arg4
    }, []);
  }
  return usePreferences(arg1, arg2);
}
function usePreferences({ gridSystemName, initialData, apiRef = useGridApiRef() }, dependencies = []) {
  const popup = usePopupAlert();
  const defaultPreference = useMemo(() => {
    var _a, _b, _c;
    return {
      name: "Default",
      config: __spreadProps$1h(__spreadValues$1A({}, initialData), {
        columns: __spreadProps$1h(__spreadValues$1A({}, initialData == null ? void 0 : initialData.columns), {
          columnVisibilityModel: __spreadValues$1A({}, (_a = initialData == null ? void 0 : initialData.columns) == null ? void 0 : _a.columnVisibilityModel)
        }),
        sorting: __spreadProps$1h(__spreadValues$1A({}, initialData == null ? void 0 : initialData.sorting), {
          sortModel: (_c = (_b = initialData == null ? void 0 : initialData.sorting) == null ? void 0 : _b.sortModel) != null ? _c : []
        }),
        filter: {
          filterModel: {
            items: []
          }
        },
        pinnedColumns: {
          left: [],
          right: []
        },
        rowGrouping: {
          model: []
        }
      })
    };
  }, [initialData]);
  const [state, dispatch] = useReducer(
    toolbarReducer,
    {
      preferences: [defaultPreference],
      type: null,
      activeViewName: "Default"
    }
  );
  const { preferences, activeViewName } = state;
  useEffect(() => {
    var _a, _b, _c, _d;
    const defaultStatePreferenceIndex = preferences.findIndex((preference) => preference.name === "Default");
    if (((_b = (_a = defaultPreference.config.sorting) == null ? void 0 : _a.sortModel) == null ? void 0 : _b.length) !== ((_d = (_c = preferences[defaultStatePreferenceIndex].config.sorting) == null ? void 0 : _c.sortModel) == null ? void 0 : _d.length)) {
      dispatch({ type: "updateView", value: defaultPreference.config, index: defaultStatePreferenceIndex });
    }
  }, [defaultPreference]);
  const getUserSettingData = useCallback(() => {
    const _a = state, data = __objRest$T(_a, ["type"]);
    return {
      systemName: `Grid_${gridSystemName}`,
      settingTypeSystemName: "json",
      setting: JSON.stringify(data)
    };
  }, [state]);
  const getLookupQuery = `UserSetting?systemName=Grid_${gridSystemName}&settingTypeSystemName=json`;
  const preferenceQuery = useQuery$1(
    [getLookupQuery],
    () => httpService$1.get(getLookupQuery)
  );
  useEffect(() => {
    var _a, _b, _c;
    if (!preferenceQuery.isLoading && ((_b = (_a = preferenceQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.setting)) {
      const settings = JSON.parse(preferenceQuery.data.data.setting);
      if (settings && ((_c = settings.preferences) == null ? void 0 : _c.length) > 0) {
        dispatch({ type: "loadPreferences", preferences: settings });
      }
    }
  }, [preferenceQuery.isLoading]);
  const lookupOptions = useMemo(
    () => preferences.map((p, i) => ({
      id: i.toString(),
      name: p.name,
      additionalData: p.config
    })),
    [preferences, defaultPreference]
  );
  const currentLookup = useMemo(() => {
    const defaultSettingIndex = preferences.findIndex((setting) => setting.name === activeViewName);
    return lookupOptions[defaultSettingIndex];
  }, [state, lookupOptions]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      var _a;
      (_a = apiRef.current.restoreState) == null ? void 0 : _a.call(apiRef.current, currentLookup.additionalData);
    }, 100);
    return () => clearTimeout(timeout);
  }, [...dependencies]);
  const GridStateToolbar = ({ children }) => {
    const dialog = useModal();
    const confirm = useConfirmationDialog();
    useEffect(() => {
      if (state.type === "savePreferences") {
        httpService$1.post("UserSetting", getUserSettingData());
      }
    }, [state]);
    const savePreferences = (name, create = true) => __async$x(this, null, function* () {
      const newPreferenceConfig = apiRef.current.exportState();
      if (create) {
        dispatch({ type: "insertView", value: newPreferenceConfig, name });
        return;
      }
      let index = preferences.findIndex((preference) => preference.name.toLowerCase() === name.toLowerCase());
      if (index === -1) {
        index = currentLookup.id ? Number(currentLookup.id) - 1 : 0;
      }
      dispatch({ type: "updateView", value: newPreferenceConfig, index });
    });
    const renderOptions = (props, option) => {
      const typedOption = option;
      return /* @__PURE__ */ createElement(
        "li",
        __spreadProps$1h(__spreadValues$1A({}, props), {
          key: typedOption.id,
          className: `${props.className} flex`,
          style: { justifyContent: "space-between", alignItems: "center" }
        }),
        typedOption.name,
        typedOption.id !== "0" && /* @__PURE__ */ jsx(Tooltip, { title: "Delete", children: /* @__PURE__ */ jsx(
          GridActionsCellItem$1,
          {
            label: "Delete",
            icon: /* @__PURE__ */ jsx(Delete, {}),
            onClick: (e) => {
              e.stopPropagation();
              onDeleteHandler(typedOption);
            }
          }
        ) })
      );
    };
    const getNameDialog = () => __async$x(this, null, function* () {
      return yield dialog(({ close }) => {
        const [name, setName] = useState((currentLookup == null ? void 0 : currentLookup.name) || "");
        const handleUpdate = () => __async$x(this, null, function* () {
          const confirmUpdate = yield confirm("Confirm", "Are you sure you want to update this view?");
          if (confirmUpdate) {
            close([name.trim(), false]);
          }
        });
        const isValidForNew = useMemo(
          () => lookupOptions.every((preference) => preference.name.toLowerCase() !== name.toLowerCase().trim()),
          [name]
        );
        const isValidForUpdate = useMemo(
          () => name !== "Default" && (currentLookup.id !== "0" || lookupOptions.some((preference) => preference.name.toLowerCase() === name.toLowerCase().trim())),
          [name]
        );
        return /* @__PURE__ */ jsxs("form", { onSubmit: (e) => {
          e.preventDefault();
          close([name.trim(), true]);
        }, children: [
          /* @__PURE__ */ jsx(DialogTitle$1, { children: "Save View" }),
          /* @__PURE__ */ jsxs(DialogContent$1, { children: [
            /* @__PURE__ */ jsx(InputLabel, { name: "name", label: "Name" }),
            /* @__PURE__ */ jsx(
              Input$2,
              {
                autoFocus: true,
                focused: true,
                name: "name",
                value: name,
                onChange: setName
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(
            DialogActions$1,
            {
              sx: {
                padding: "1.25rem",
                flexDirection: "row-reverse",
                gap: "10px",
                justifyContent: "flex-start"
              },
              children: [
                /* @__PURE__ */ jsx(Button, { variant: "contained", type: "submit", disabled: !isValidForNew, children: "Create" }),
                /* @__PURE__ */ jsx(Button, { variant: "outlined", disabled: !isValidForUpdate, onClick: handleUpdate, children: "Update" }),
                /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => close(), children: "Cancel" })
              ]
            }
          )
        ] });
      });
    });
    const onDeleteHandler = (item) => __async$x(this, null, function* () {
      const deleteConfig = yield confirm(
        "Are you sure you want to delete this layout?",
        `Name: ${item.name}`
      );
      if (!deleteConfig) {
        return;
      }
      dispatch({ type: "deleteView", name: item.name });
      if (item.name === activeViewName) {
        apiRef.current.restoreState(defaultPreference.config);
      }
      popup({ message: "Grid state deleted successfully", severity: "success" });
    });
    const saveStateHandler = () => __async$x(this, null, function* () {
      const result = yield getNameDialog();
      if (!result) {
        return;
      }
      const [name, create] = result;
      yield savePreferences(name, create);
      popup({ message: "View saved successfully", severity: "success" });
    });
    const onChangeHandler = (_e, value) => __async$x(this, null, function* () {
      if (value) {
        apiRef.current.restoreState(value.additionalData);
        dispatch({ type: "setActiveView", name: value.name });
      }
    });
    return /* @__PURE__ */ jsxs(Grid$3, { item: true, container: true, spacing: 2, justifyContent: "flex-end", padding: 2, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, container: true, xs: 12, md: 3, alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: "0.85rem"
            },
            children: "Layout"
          }
        ) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: true, children: /* @__PURE__ */ jsx(
          AutocompleteDropdown,
          {
            options: lookupOptions,
            onChange: onChangeHandler,
            value: currentLookup,
            renderOption: renderOptions,
            disableClearable: true
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: saveStateHandler, startIcon: /* @__PURE__ */ jsx(WindowOutlined, {}), children: "Save View" }) }),
      children
    ] });
  };
  return {
    GridStateToolbar,
    apiRef,
    state: currentLookup == null ? void 0 : currentLookup.additionalData
  };
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

var __defProp$1z = Object.defineProperty;
var __defProps$1g = Object.defineProperties;
var __getOwnPropDescs$1g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1A = Object.getOwnPropertySymbols;
var __hasOwnProp$1A = Object.prototype.hasOwnProperty;
var __propIsEnum$1A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1z = (obj, key, value) => key in obj ? __defProp$1z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1A.call(b, prop))
      __defNormalProp$1z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(b)) {
      if (__propIsEnum$1A.call(b, prop))
        __defNormalProp$1z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1g = (a, b) => __defProps$1g(a, __getOwnPropDescs$1g(b));
function useOrganisationLookupHelper() {
  const auth = useAuth();
  const unrestrictedUser = auth.userHasPermission("restrictByAssociation", "False");
  const filterOptions = createFilterOptions({
    stringify: (option) => {
      var _a;
      return unrestrictedUser ? `${option.name} ${((_a = option.additionalData) == null ? void 0 : _a.ediCode) || ""}` : option.name;
    }
  });
  const organisationLookupParams = {
    systemName: "PortalContact",
    maxResults: "150",
    additionalFilter: {
      contactType: "Organisation",
      searchEDI: unrestrictedUser,
      excludeChildContact: true
    }
  };
  const renderOption = (props, option, { selected }) => {
    var _a, _b;
    return /* @__PURE__ */ createElement("li", __spreadProps$1g(__spreadValues$1z({}, props), { key: v4() }), /* @__PURE__ */ jsxs(Box$1, { children: [
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "1rem", children: `${option.name} ${((_a = option.additionalData) == null ? void 0 : _a.parentLocationName) && ((_b = option.additionalData) == null ? void 0 : _b.parentLocationName) !== null ? ` - ${option.additionalData.parentLocationName}` : ""} 
				` }),
      unrestrictedUser ? /* @__PURE__ */ jsx(Typography$1, { fontSize: "1rem", children: `Code: ${option.additionalData.ediCode || "Not available"}` }) : null
    ] }));
  };
  return { filterOptions, renderOption, organisationLookupParams };
}

var __async$w = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function useUserSetting({ settingSystemName, settingTypeSystemName }) {
  const userSettingService = new UserSettingService();
  const queryClient = useQueryClient();
  const {
    isLoading,
    data: userSettingQueryData,
    isError
    //refetch: refetchUserSetting
  } = useQuery$1([`/UserSetting/${settingTypeSystemName}/${settingSystemName}`], () => {
    const queryObj = {
      settingTypeSystemName,
      systemName: settingSystemName
    };
    return userSettingService.getSetting(queryObj);
  });
  const userSettingMutation = useMutation$1({
    mutationKey: ["/UserSettingMutation", settingSystemName],
    mutationFn: (state) => {
      return userSettingService.saveSetting(state);
    },
    onSuccess: () => {
      return queryClient.invalidateQueries([`/UserSetting/${settingTypeSystemName}/${settingSystemName}`]);
    }
  });
  const settingValue = useMemo(() => {
    var _a;
    return (_a = userSettingQueryData == null ? void 0 : userSettingQueryData.data) == null ? void 0 : _a.setting;
  }, [userSettingQueryData]);
  const handleUpdate = useCallback((newSetting) => __async$w(this, null, function* () {
    const body = {
      setting: newSetting,
      settingTypeSystemName,
      systemName: settingSystemName
    };
    try {
      const result = yield userSettingMutation.mutateAsync(body);
    } catch (e) {
      console.log("Failed to save setting for ", settingSystemName);
    }
  }), [settingSystemName, settingSystemName, userSettingMutation]);
  return [settingValue, handleUpdate, { isLoading, isError }];
}

var RPC = 'rpc';
var UPLOAD = 'upload';
var DOWNLOAD = 'download';
var APP_AUTH = 'app';
var USER_AUTH = 'user';
var TEAM_AUTH = 'team';
var NO_AUTH = 'noauth';
var COOKIE = 'cookie';
var DEFAULT_API_DOMAIN = 'dropboxapi.com';
var DEFAULT_DOMAIN = 'dropbox.com';
var TEST_DOMAIN_MAPPINGS = {
  api: 'api',
  notify: 'bolt',
  content: 'api-content'
};

// Auto-generated by Stone, do not modify.
var routes = {};
/**
 * Sets a user's profile photo.
 * Route attributes:
 *   scope: account_info.write
 * @function Dropbox#accountSetProfilePhoto
 * @arg {AccountSetProfilePhotoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AccountSetProfilePhotoResult>, DropboxResponseError.<AccountSetProfilePhotoError>>}
 */

routes.accountSetProfilePhoto = function (arg) {
  return this.request('account/set_profile_photo', arg, 'user', 'api', 'rpc', 'account_info.write');
};
/**
 * Creates an OAuth 2.0 access token from the supplied OAuth 1.0 access token.
 * @function Dropbox#authTokenFromOauth1
 * @arg {AuthTokenFromOAuth1Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AuthTokenFromOAuth1Result>, DropboxResponseError.<AuthTokenFromOAuth1Error>>}
 */


routes.authTokenFromOauth1 = function (arg) {
  return this.request('auth/token/from_oauth1', arg, 'app', 'api', 'rpc', null);
};
/**
 * Disables the access token used to authenticate the call. If there is a
 * corresponding refresh token for the access token, this disables that refresh
 * token, as well as any other access tokens for that refresh token.
 * @function Dropbox#authTokenRevoke
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<void>>}
 */


routes.authTokenRevoke = function () {
  return this.request('auth/token/revoke', null, 'user', 'api', 'rpc', null);
};
/**
 * This endpoint performs App Authentication, validating the supplied app key
 * and secret, and returns the supplied string, to allow you to test your code
 * and connection to the Dropbox API. It has no other effect. If you receive an
 * HTTP 200 response with the supplied query, it indicates at least part of the
 * Dropbox API infrastructure is working and that the app key and secret valid.
 * @function Dropbox#checkApp
 * @arg {CheckEchoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<CheckEchoResult>, DropboxResponseError.<void>>}
 */


routes.checkApp = function (arg) {
  return this.request('check/app', arg, 'app', 'api', 'rpc', null);
};
/**
 * This endpoint performs User Authentication, validating the supplied access
 * token, and returns the supplied string, to allow you to test your code and
 * connection to the Dropbox API. It has no other effect. If you receive an HTTP
 * 200 response with the supplied query, it indicates at least part of the
 * Dropbox API infrastructure is working and that the access token is valid.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#checkUser
 * @arg {CheckEchoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<CheckEchoResult>, DropboxResponseError.<void>>}
 */


routes.checkUser = function (arg) {
  return this.request('check/user', arg, 'user', 'api', 'rpc', 'account_info.read');
};
/**
 * Removes all manually added contacts. You'll still keep contacts who are on
 * your team or who you imported. New contacts will be added when you share.
 * Route attributes:
 *   scope: contacts.write
 * @function Dropbox#contactsDeleteManualContacts
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<void>>}
 */


routes.contactsDeleteManualContacts = function () {
  return this.request('contacts/delete_manual_contacts', null, 'user', 'api', 'rpc', 'contacts.write');
};
/**
 * Removes manually added contacts from the given list.
 * Route attributes:
 *   scope: contacts.write
 * @function Dropbox#contactsDeleteManualContactsBatch
 * @arg {ContactsDeleteManualContactsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<ContactsDeleteManualContactsError>>}
 */


routes.contactsDeleteManualContactsBatch = function (arg) {
  return this.request('contacts/delete_manual_contacts_batch', arg, 'user', 'api', 'rpc', 'contacts.write');
};
/**
 * Add property groups to a Dropbox file. See templates/add_for_user or
 * templates/add_for_team to create new templates.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesAdd
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesAddPropertiesError>>}
 */


routes.filePropertiesPropertiesAdd = function (arg) {
  return this.request('file_properties/properties/add', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Overwrite property groups associated with a file. This endpoint should be
 * used instead of properties/update when property groups are being updated via
 * a "snapshot" instead of via a "delta". In other words, this endpoint will
 * delete all omitted fields from a property group, whereas properties/update
 * will only delete fields that are explicitly marked for deletion.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesOverwrite
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesInvalidPropertyGroupError>>}
 */


routes.filePropertiesPropertiesOverwrite = function (arg) {
  return this.request('file_properties/properties/overwrite', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Permanently removes the specified property group from the file. To remove
 * specific property field key value pairs, see properties/update. To update a
 * template, see templates/update_for_user or templates/update_for_team. To
 * remove a template, see templates/remove_for_user or
 * templates/remove_for_team.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesRemove
 * @arg {FilePropertiesRemovePropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesRemovePropertiesError>>}
 */


routes.filePropertiesPropertiesRemove = function (arg) {
  return this.request('file_properties/properties/remove', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Search across property templates for particular property field values.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesPropertiesSearch
 * @arg {FilePropertiesPropertiesSearchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesPropertiesSearchResult>, DropboxResponseError.<FilePropertiesPropertiesSearchError>>}
 */


routes.filePropertiesPropertiesSearch = function (arg) {
  return this.request('file_properties/properties/search', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Once a cursor has been retrieved from properties/search, use this to paginate
 * through all search results.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesPropertiesSearchContinue
 * @arg {FilePropertiesPropertiesSearchContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesPropertiesSearchResult>, DropboxResponseError.<FilePropertiesPropertiesSearchContinueError>>}
 */


routes.filePropertiesPropertiesSearchContinue = function (arg) {
  return this.request('file_properties/properties/search/continue', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Add, update or remove properties associated with the supplied file and
 * templates. This endpoint should be used instead of properties/overwrite when
 * property groups are being updated via a "delta" instead of via a "snapshot" .
 * In other words, this endpoint will not delete any omitted fields from a
 * property group, whereas properties/overwrite will delete any fields that are
 * omitted from a property group.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesPropertiesUpdate
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesUpdatePropertiesError>>}
 */


routes.filePropertiesPropertiesUpdate = function (arg) {
  return this.request('file_properties/properties/update', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Add a template associated with a team. See properties/add to add properties
 * to a file or folder. Note: this endpoint will create team-owned templates.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesAddForTeam
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesAddForTeam = function (arg) {
  return this.request('file_properties/templates/add_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Add a template associated with a user. See properties/add to add properties
 * to a file. This endpoint can't be called on a team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesAddForUser
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesAddForUser = function (arg) {
  return this.request('file_properties/templates/add_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Get the schema for a specified template.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesGetForTeam
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesGetForTeam = function (arg) {
  return this.request('file_properties/templates/get_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Get the schema for a specified template. This endpoint can't be called on a
 * team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesTemplatesGetForUser
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesGetForUser = function (arg) {
  return this.request('file_properties/templates/get_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_team.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesListForTeam
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesListForTeam = function () {
  return this.request('file_properties/templates/list_for_team', null, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Get the template identifiers for a team. To get the schema of each template
 * use templates/get_for_user. This endpoint can't be called on a team member or
 * admin's behalf.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filePropertiesTemplatesListForUser
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesListForUser = function () {
  return this.request('file_properties/templates/list_for_user', null, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesRemoveForTeam
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesRemoveForTeam = function (arg) {
  return this.request('file_properties/templates/remove_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Permanently removes the specified template created from
 * templates/add_for_user. All properties associated with the template will also
 * be removed. This action cannot be undone.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesRemoveForUser
 * @arg {FilePropertiesRemoveTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filePropertiesTemplatesRemoveForUser = function (arg) {
  return this.request('file_properties/templates/remove_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Update a template associated with a team. This route can update the template
 * name, the template description and add optional properties to templates.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#filePropertiesTemplatesUpdateForTeam
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesUpdateTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesUpdateForTeam = function (arg) {
  return this.request('file_properties/templates/update_for_team', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Update a template associated with a user. This route can update the template
 * name, the template description and add optional properties to templates. This
 * endpoint can't be called on a team member or admin's behalf.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filePropertiesTemplatesUpdateForUser
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesUpdateTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.filePropertiesTemplatesUpdateForUser = function (arg) {
  return this.request('file_properties/templates/update_for_user', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Returns the total number of file requests owned by this user. Includes both
 * open and closed file requests.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsCount
 * @returns {Promise.<DropboxResponse<FileRequestsCountFileRequestsResult>, DropboxResponseError.<FileRequestsCountFileRequestsError>>}
 */


routes.fileRequestsCount = function () {
  return this.request('file_requests/count', null, 'user', 'api', 'rpc', 'file_requests.read');
};
/**
 * Creates a file request for this user.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsCreate
 * @arg {FileRequestsCreateFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsCreateFileRequestError>>}
 */


routes.fileRequestsCreate = function (arg) {
  return this.request('file_requests/create', arg, 'user', 'api', 'rpc', 'file_requests.write');
};
/**
 * Delete a batch of closed file requests.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsDelete
 * @arg {FileRequestsDeleteFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsDeleteFileRequestsResult>, DropboxResponseError.<FileRequestsDeleteFileRequestError>>}
 */


routes.fileRequestsDelete = function (arg) {
  return this.request('file_requests/delete', arg, 'user', 'api', 'rpc', 'file_requests.write');
};
/**
 * Delete all closed file requests owned by this user.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsDeleteAllClosed
 * @returns {Promise.<DropboxResponse<FileRequestsDeleteAllClosedFileRequestsResult>, DropboxResponseError.<FileRequestsDeleteAllClosedFileRequestsError>>}
 */


routes.fileRequestsDeleteAllClosed = function () {
  return this.request('file_requests/delete_all_closed', null, 'user', 'api', 'rpc', 'file_requests.write');
};
/**
 * Returns the specified file request.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsGet
 * @arg {FileRequestsGetFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsGetFileRequestError>>}
 */


routes.fileRequestsGet = function (arg) {
  return this.request('file_requests/get', arg, 'user', 'api', 'rpc', 'file_requests.read');
};
/**
 * Returns a list of file requests owned by this user. For apps with the app
 * folder permission, this will only return file requests with destinations in
 * the app folder.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsListV2
 * @arg {FileRequestsListFileRequestsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsV2Result>, DropboxResponseError.<FileRequestsListFileRequestsError>>}
 */


routes.fileRequestsListV2 = function (arg) {
  return this.request('file_requests/list_v2', arg, 'user', 'api', 'rpc', 'file_requests.read');
};
/**
 * Returns a list of file requests owned by this user. For apps with the app
 * folder permission, this will only return file requests with destinations in
 * the app folder.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsList
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsResult>, DropboxResponseError.<FileRequestsListFileRequestsError>>}
 */


routes.fileRequestsList = function () {
  return this.request('file_requests/list', null, 'user', 'api', 'rpc', 'file_requests.read');
};
/**
 * Once a cursor has been retrieved from list_v2, use this to paginate through
 * all file requests. The cursor must come from a previous call to list_v2 or
 * list/continue.
 * Route attributes:
 *   scope: file_requests.read
 * @function Dropbox#fileRequestsListContinue
 * @arg {FileRequestsListFileRequestsContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsListFileRequestsV2Result>, DropboxResponseError.<FileRequestsListFileRequestsContinueError>>}
 */


routes.fileRequestsListContinue = function (arg) {
  return this.request('file_requests/list/continue', arg, 'user', 'api', 'rpc', 'file_requests.read');
};
/**
 * Update a file request.
 * Route attributes:
 *   scope: file_requests.write
 * @function Dropbox#fileRequestsUpdate
 * @arg {FileRequestsUpdateFileRequestArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FileRequestsFileRequest>, DropboxResponseError.<FileRequestsUpdateFileRequestError>>}
 */


routes.fileRequestsUpdate = function (arg) {
  return this.request('file_requests/update', arg, 'user', 'api', 'rpc', 'file_requests.write');
};
/**
 * Returns the metadata for a file or folder. This is an alpha endpoint
 * compatible with the properties API. Note: Metadata for the root folder is
 * unsupported.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesAlphaGetMetadata
 * @deprecated
 * @arg {FilesAlphaGetMetadataArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesAlphaGetMetadataError>>}
 */


routes.filesAlphaGetMetadata = function (arg) {
  return this.request('files/alpha/get_metadata', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Create a new file with the contents provided in the request. Note that the
 * behavior of this alpha endpoint is unstable and subject to change. Do not use
 * this to upload a file larger than 150 MB. Instead, create an upload session
 * with upload_session/start.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesAlphaUpload
 * @deprecated
 * @arg {FilesUploadArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadError>>}
 */


routes.filesAlphaUpload = function (arg) {
  return this.request('files/alpha/upload', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationResult>, DropboxResponseError.<FilesRelocationError>>}
 */


routes.filesCopyV2 = function (arg) {
  return this.request('files/copy_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Copy a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be copied.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopy
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesRelocationError>>}
 */


routes.filesCopy = function (arg) {
  return this.request('files/copy', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Copy multiple files or folders to different locations at once in the user's
 * Dropbox. This route will replace copy_batch. The main difference is this
 * route will return status for each entry, while copy_batch raises failure if
 * any entry fails. This route will either finish synchronously, or return a job
 * ID and do the async copy job in background. Please use copy_batch/check_v2 to
 * check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchV2
 * @arg {Object} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2Launch>, DropboxResponseError.<void>>}
 */


routes.filesCopyBatchV2 = function (arg) {
  return this.request('files/copy_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Copy multiple files or folders to different locations at once in the user's
 * Dropbox. This route will return job ID immediately and do the async copy job
 * in background. Please use copy_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatch
 * @deprecated
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchLaunch>, DropboxResponseError.<void>>}
 */


routes.filesCopyBatch = function (arg) {
  return this.request('files/copy_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for copy_batch_v2. It returns list
 * of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchCheckV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2JobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesCopyBatchCheckV2 = function (arg) {
  return this.request('files/copy_batch/check_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for copy_batch. If success, it
 * returns list of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyBatchCheck
 * @deprecated
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesCopyBatchCheck = function (arg) {
  return this.request('files/copy_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Get a copy reference to a file or folder. This reference string can be used
 * to save that file or folder to another user's Dropbox by passing it to
 * copy_reference/save.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyReferenceGet
 * @arg {FilesGetCopyReferenceArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesGetCopyReferenceResult>, DropboxResponseError.<FilesGetCopyReferenceError>>}
 */


routes.filesCopyReferenceGet = function (arg) {
  return this.request('files/copy_reference/get', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Save a copy reference returned by copy_reference/get to the user's Dropbox.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCopyReferenceSave
 * @arg {FilesSaveCopyReferenceArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSaveCopyReferenceResult>, DropboxResponseError.<FilesSaveCopyReferenceError>>}
 */


routes.filesCopyReferenceSave = function (arg) {
  return this.request('files/copy_reference/save', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Create a folder at a given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderV2
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderResult>, DropboxResponseError.<FilesCreateFolderError>>}
 */


routes.filesCreateFolderV2 = function (arg) {
  return this.request('files/create_folder_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Create a folder at a given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolder
 * @deprecated
 * @arg {FilesCreateFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFolderMetadata>, DropboxResponseError.<FilesCreateFolderError>>}
 */


routes.filesCreateFolder = function (arg) {
  return this.request('files/create_folder', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Create multiple folders at once. This route is asynchronous for large
 * batches, which returns a job ID immediately and runs the create folder batch
 * asynchronously. Otherwise, creates the folders and returns the result
 * synchronously for smaller inputs. You can force asynchronous behaviour by
 * using the CreateFolderBatchArg.force_async flag.  Use
 * create_folder_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderBatch
 * @arg {FilesCreateFolderBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderBatchLaunch>, DropboxResponseError.<void>>}
 */


routes.filesCreateFolderBatch = function (arg) {
  return this.request('files/create_folder_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for create_folder_batch. If
 * success, it returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesCreateFolderBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesCreateFolderBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesCreateFolderBatchCheck = function (arg) {
  return this.request('files/create_folder_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteV2
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesDeleteResult>, DropboxResponseError.<FilesDeleteError>>}
 */


routes.filesDeleteV2 = function (arg) {
  return this.request('files/delete_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Delete the file or folder at a given path. If the path is a folder, all its
 * contents will be deleted too. A successful response indicates that the file
 * or folder was deleted. The returned metadata will be the corresponding
 * FileMetadata or FolderMetadata for the item at time of deletion, and not a
 * DeletedMetadata object.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDelete
 * @deprecated
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesDeleteError>>}
 */


routes.filesDelete = function (arg) {
  return this.request('files/delete', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Delete multiple files/folders at once. This route is asynchronous, which
 * returns a job ID immediately and runs the delete batch asynchronously. Use
 * delete_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteBatch
 * @arg {FilesDeleteBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesDeleteBatchLaunch>, DropboxResponseError.<void>>}
 */


routes.filesDeleteBatch = function (arg) {
  return this.request('files/delete_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for delete_batch. If success, it
 * returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesDeleteBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesDeleteBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesDeleteBatchCheck = function (arg) {
  return this.request('files/delete_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Download a file from a user's Dropbox.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesDownload
 * @arg {FilesDownloadArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesDownloadError>>}
 */


routes.filesDownload = function (arg) {
  return this.request('files/download', arg, 'user', 'content', 'download', 'files.content.read');
};
/**
 * Download a folder from the user's Dropbox, as a zip file. The folder must be
 * less than 20 GB in size and any single file within must be less than 4 GB in
 * size. The resulting zip must have fewer than 10,000 total file and folder
 * entries, including the top level folder. The input cannot be a single file.
 * Note: this endpoint does not support HTTP range requests.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesDownloadZip
 * @arg {FilesDownloadZipArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesDownloadZipResult>, DropboxResponseError.<FilesDownloadZipError>>}
 */


routes.filesDownloadZip = function (arg) {
  return this.request('files/download_zip', arg, 'user', 'content', 'download', 'files.content.read');
};
/**
 * Export a file from a user's Dropbox. This route only supports exporting files
 * that cannot be downloaded directly  and whose ExportResult.file_metadata has
 * ExportInfo.export_as populated.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesExport
 * @arg {FilesExportArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesExportResult>, DropboxResponseError.<FilesExportError>>}
 */


routes.filesExport = function (arg) {
  return this.request('files/export', arg, 'user', 'content', 'download', 'files.content.read');
};
/**
 * Return the lock metadata for the given list of paths.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetFileLockBatch
 * @arg {FilesLockFileBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */


routes.filesGetFileLockBatch = function (arg) {
  return this.request('files/get_file_lock_batch', arg, 'user', 'api', 'rpc', 'files.content.read');
};
/**
 * Returns the metadata for a file or folder. Note: Metadata for the root folder
 * is unsupported.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesGetMetadata
 * @arg {FilesGetMetadataArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesGetMetadataError>>}
 */


routes.filesGetMetadata = function (arg) {
  return this.request('files/get_metadata', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Get a preview for a file. Currently, PDF previews are generated for files
 * with the following extensions: .ai, .doc, .docm, .docx, .eps, .gdoc,
 * .gslides, .odp, .odt, .pps, .ppsm, .ppsx, .ppt, .pptm, .pptx, .rtf. HTML
 * previews are generated for files with the following extensions: .csv, .ods,
 * .xls, .xlsm, .gsheet, .xlsx. Other formats will return an unsupported
 * extension error.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetPreview
 * @arg {FilesPreviewArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesPreviewError>>}
 */


routes.filesGetPreview = function (arg) {
  return this.request('files/get_preview', arg, 'user', 'content', 'download', 'files.content.read');
};
/**
 * Get a temporary link to stream content of a file. This link will expire in
 * four hours and afterwards you will get 410 Gone. This URL should not be used
 * to display content directly in the browser. The Content-Type of the link is
 * determined automatically by the file's mime type.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetTemporaryLink
 * @arg {FilesGetTemporaryLinkArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesGetTemporaryLinkResult>, DropboxResponseError.<FilesGetTemporaryLinkError>>}
 */


routes.filesGetTemporaryLink = function (arg) {
  return this.request('files/get_temporary_link', arg, 'user', 'api', 'rpc', 'files.content.read');
};
/**
 * Get a one-time use temporary upload link to upload a file to a Dropbox
 * location.  This endpoint acts as a delayed upload. The returned temporary
 * upload link may be used to make a POST request with the data to be uploaded.
 * The upload will then be perfomed with the CommitInfo previously provided to
 * get_temporary_upload_link but evaluated only upon consumption. Hence, errors
 * stemming from invalid CommitInfo with respect to the state of the user's
 * Dropbox will only be communicated at consumption time. Additionally, these
 * errors are surfaced as generic HTTP 409 Conflict responses, potentially
 * hiding issue details. The maximum temporary upload link duration is 4 hours.
 * Upon consumption or expiration, a new link will have to be generated.
 * Multiple links may exist for a specific upload path at any given time.  The
 * POST request on the temporary upload link must have its Content-Type set to
 * "application/octet-stream".  Example temporary upload link consumption
 * request:  curl -X POST
 * https://content.dropboxapi.com/apitul/1/bNi2uIYF51cVBND --header
 * "Content-Type: application/octet-stream" --data-binary @local_file.txt  A
 * successful temporary upload link consumption request returns the content hash
 * of the uploaded data in JSON format.  Example successful temporary upload
 * link consumption response: {"content-hash":
 * "599d71033d700ac892a0e48fa61b125d2f5994"}  An unsuccessful temporary upload
 * link consumption request returns any of the following status codes:  HTTP 400
 * Bad Request: Content-Type is not one of application/octet-stream and
 * text/plain or request is invalid. HTTP 409 Conflict: The temporary upload
 * link does not exist or is currently unavailable, the upload failed, or
 * another error happened. HTTP 410 Gone: The temporary upload link is expired
 * or consumed.  Example unsuccessful temporary upload link consumption
 * response: Temporary upload link has been recently consumed.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesGetTemporaryUploadLink
 * @arg {FilesGetTemporaryUploadLinkArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesGetTemporaryUploadLinkResult>, DropboxResponseError.<void>>}
 */


routes.filesGetTemporaryUploadLink = function (arg) {
  return this.request('files/get_temporary_upload_link', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Get a thumbnail for an image. This method currently supports files with the
 * following file extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp.
 * Photos that are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnail
 * @arg {FilesThumbnailArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesThumbnailError>>}
 */


routes.filesGetThumbnail = function (arg) {
  return this.request('files/get_thumbnail', arg, 'user', 'content', 'download', 'files.content.read');
};
/**
 * Get a thumbnail for an image. This method currently supports files with the
 * following file extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp.
 * Photos that are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnailV2
 * @arg {FilesThumbnailV2Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesPreviewResult>, DropboxResponseError.<FilesThumbnailV2Error>>}
 */


routes.filesGetThumbnailV2 = function (arg) {
  return this.request('files/get_thumbnail_v2', arg, 'app, user', 'content', 'download', 'files.content.read');
};
/**
 * Get thumbnails for a list of images. We allow up to 25 thumbnails in a single
 * batch. This method currently supports files with the following file
 * extensions: jpg, jpeg, png, tiff, tif, gif, webp, ppm and bmp. Photos that
 * are larger than 20MB in size won't be converted to a thumbnail.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#filesGetThumbnailBatch
 * @arg {FilesGetThumbnailBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesGetThumbnailBatchResult>, DropboxResponseError.<FilesGetThumbnailBatchError>>}
 */


routes.filesGetThumbnailBatch = function (arg) {
  return this.request('files/get_thumbnail_batch', arg, 'user', 'content', 'rpc', 'files.content.read');
};
/**
 * Starts returning the contents of a folder. If the result's
 * ListFolderResult.has_more field is true, call list_folder/continue with the
 * returned ListFolderResult.cursor to retrieve more entries. If you're using
 * ListFolderArg.recursive set to true to keep a local cache of the contents of
 * a Dropbox account, iterate through each entry in order and process them as
 * follows to keep your local state in sync: For each FileMetadata, store the
 * new entry at the given path in your local state. If the required parent
 * folders don't exist yet, create them. If there's already something else at
 * the given path, replace it and remove all its children. For each
 * FolderMetadata, store the new entry at the given path in your local state. If
 * the required parent folders don't exist yet, create them. If there's already
 * something else at the given path, replace it but leave the children as they
 * are. Check the new entry's FolderSharingInfo.read_only and set all its
 * children's read-only statuses to match. For each DeletedMetadata, if your
 * local state has something at the given path, remove it and all its children.
 * If there's nothing at the given path, ignore this entry. Note:
 * auth.RateLimitError may be returned if multiple list_folder or
 * list_folder/continue calls with same parameters are made simultaneously by
 * same API app for same user. If your app implements retry logic, please hold
 * off the retry until the previous request finishes.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolder
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesListFolderResult>, DropboxResponseError.<FilesListFolderError>>}
 */


routes.filesListFolder = function (arg) {
  return this.request('files/list_folder', arg, 'app, user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Once a cursor has been retrieved from list_folder, use this to paginate
 * through all files and retrieve updates to the folder, following the same
 * rules as documented for list_folder.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderContinue
 * @arg {FilesListFolderContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesListFolderResult>, DropboxResponseError.<FilesListFolderContinueError>>}
 */


routes.filesListFolderContinue = function (arg) {
  return this.request('files/list_folder/continue', arg, 'app, user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * A way to quickly get a cursor for the folder's state. Unlike list_folder,
 * list_folder/get_latest_cursor doesn't return any entries. This endpoint is
 * for app which only needs to know about new files and modifications and
 * doesn't need to know about files that already exist in Dropbox.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderGetLatestCursor
 * @arg {FilesListFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesListFolderGetLatestCursorResult>, DropboxResponseError.<FilesListFolderError>>}
 */


routes.filesListFolderGetLatestCursor = function (arg) {
  return this.request('files/list_folder/get_latest_cursor', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * A longpoll endpoint to wait for changes on an account. In conjunction with
 * list_folder/continue, this call gives you a low-latency way to monitor an
 * account for file changes. The connection will block until there are changes
 * available or a timeout occurs. This endpoint is useful mostly for client-side
 * apps. If you're looking for server-side notifications, check out our webhooks
 * documentation https://www.dropbox.com/developers/reference/webhooks.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListFolderLongpoll
 * @arg {FilesListFolderLongpollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesListFolderLongpollResult>, DropboxResponseError.<FilesListFolderLongpollError>>}
 */


routes.filesListFolderLongpoll = function (arg) {
  return this.request('files/list_folder/longpoll', arg, 'noauth', 'notify', 'rpc', 'files.metadata.read');
};
/**
 * Returns revisions for files based on a file path or a file id. The file path
 * or file id is identified from the latest file entry at the given file path or
 * id. This end point allows your app to query either by file path or file id by
 * setting the mode parameter appropriately. In the ListRevisionsMode.path
 * (default) mode, all revisions at the same file path as the latest file entry
 * are returned. If revisions with the same file id are desired, then mode must
 * be set to ListRevisionsMode.id. The ListRevisionsMode.id mode is useful to
 * retrieve revisions for a given file across moves or renames.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesListRevisions
 * @arg {FilesListRevisionsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesListRevisionsResult>, DropboxResponseError.<FilesListRevisionsError>>}
 */


routes.filesListRevisions = function (arg) {
  return this.request('files/list_revisions', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Lock the files at the given paths. A locked file will be writable only by the
 * lock holder. A successful response indicates that the file has been locked.
 * Returns a list of the locked file paths and their metadata after this
 * operation.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesLockFileBatch
 * @arg {FilesLockFileBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */


routes.filesLockFileBatch = function (arg) {
  return this.request('files/lock_file_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved. Note that we do not
 * currently support case-only renaming.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveV2
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationResult>, DropboxResponseError.<FilesRelocationError>>}
 */


routes.filesMoveV2 = function (arg) {
  return this.request('files/move_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Move a file or folder to a different location in the user's Dropbox. If the
 * source path is a folder all its contents will be moved.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMove
 * @deprecated
 * @arg {FilesRelocationArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(FilesFileMetadata|FilesFolderMetadata|FilesDeletedMetadata)>, DropboxResponseError.<FilesRelocationError>>}
 */


routes.filesMove = function (arg) {
  return this.request('files/move', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Move multiple files or folders to different locations at once in the user's
 * Dropbox. Note that we do not currently support case-only renaming. This route
 * will replace move_batch. The main difference is this route will return status
 * for each entry, while move_batch raises failure if any entry fails. This
 * route will either finish synchronously, or return a job ID and do the async
 * move job in background. Please use move_batch/check_v2 to check the job
 * status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchV2
 * @arg {FilesMoveBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2Launch>, DropboxResponseError.<void>>}
 */


routes.filesMoveBatchV2 = function (arg) {
  return this.request('files/move_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Move multiple files or folders to different locations at once in the user's
 * Dropbox. This route will return job ID immediately and do the async moving
 * job in background. Please use move_batch/check to check the job status.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatch
 * @deprecated
 * @arg {FilesRelocationBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchLaunch>, DropboxResponseError.<void>>}
 */


routes.filesMoveBatch = function (arg) {
  return this.request('files/move_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for move_batch_v2. It returns list
 * of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchCheckV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchV2JobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesMoveBatchCheckV2 = function (arg) {
  return this.request('files/move_batch/check_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for move_batch. If success, it
 * returns list of results for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesMoveBatchCheck
 * @deprecated
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesRelocationBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesMoveBatchCheck = function (arg) {
  return this.request('files/move_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Creates a new Paper doc with the provided content.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesPaperCreate
 * @arg {FilesPaperCreateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesPaperCreateResult>, DropboxResponseError.<FilesPaperCreateError>>}
 */


routes.filesPaperCreate = function (arg) {
  return this.request('files/paper/create', arg, 'user', 'api', 'upload', 'files.content.write');
};
/**
 * Updates an existing Paper doc with the provided content.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesPaperUpdate
 * @arg {FilesPaperUpdateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesPaperUpdateResult>, DropboxResponseError.<FilesPaperUpdateError>>}
 */


routes.filesPaperUpdate = function (arg) {
  return this.request('files/paper/update', arg, 'user', 'api', 'upload', 'files.content.write');
};
/**
 * Permanently delete the file or folder at a given path (see
 * https://www.dropbox.com/en/help/40). If the given file or folder is not yet
 * deleted, this route will first delete it. It is possible for this route to
 * successfully delete, then fail to permanently delete. Note: This endpoint is
 * only available for Dropbox Business apps.
 * Route attributes:
 *   scope: files.permanent_delete
 * @function Dropbox#filesPermanentlyDelete
 * @arg {FilesDeleteArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesDeleteError>>}
 */


routes.filesPermanentlyDelete = function (arg) {
  return this.request('files/permanently_delete', arg, 'user', 'api', 'rpc', 'files.permanent_delete');
};
/**
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesAdd
 * @deprecated
 * @arg {FilePropertiesAddPropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesAddPropertiesError>>}
 */


routes.filesPropertiesAdd = function (arg) {
  return this.request('files/properties/add', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesOverwrite
 * @deprecated
 * @arg {FilePropertiesOverwritePropertyGroupArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesInvalidPropertyGroupError>>}
 */


routes.filesPropertiesOverwrite = function (arg) {
  return this.request('files/properties/overwrite', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesRemove
 * @deprecated
 * @arg {FilePropertiesRemovePropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesRemovePropertiesError>>}
 */


routes.filesPropertiesRemove = function (arg) {
  return this.request('files/properties/remove', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesPropertiesTemplateGet
 * @deprecated
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filesPropertiesTemplateGet = function (arg) {
  return this.request('files/properties/template/get', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesPropertiesTemplateList
 * @deprecated
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.filesPropertiesTemplateList = function () {
  return this.request('files/properties/template/list', null, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesPropertiesUpdate
 * @deprecated
 * @arg {FilePropertiesUpdatePropertiesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilePropertiesUpdatePropertiesError>>}
 */


routes.filesPropertiesUpdate = function (arg) {
  return this.request('files/properties/update', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Restore a specific revision of a file to the given path.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesRestore
 * @arg {FilesRestoreArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesRestoreError>>}
 */


routes.filesRestore = function (arg) {
  return this.request('files/restore', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Save the data from a specified URL into a file in user's Dropbox. Note that
 * the transfer from the URL must complete within 5 minutes, or the operation
 * will time out and the job will fail. If the given path already exists, the
 * file will be renamed to avoid the conflict (e.g. myfile (1).txt).
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesSaveUrl
 * @arg {FilesSaveUrlArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSaveUrlResult>, DropboxResponseError.<FilesSaveUrlError>>}
 */


routes.filesSaveUrl = function (arg) {
  return this.request('files/save_url', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Check the status of a save_url job.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesSaveUrlCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSaveUrlJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesSaveUrlCheckJobStatus = function (arg) {
  return this.request('files/save_url/check_job_status', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Searches for files and folders. Note: Recent changes will be reflected in
 * search results within a few seconds and older revisions of existing files may
 * still match your query for up to a few days.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearch
 * @deprecated
 * @arg {FilesSearchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSearchResult>, DropboxResponseError.<FilesSearchError>>}
 */


routes.filesSearch = function (arg) {
  return this.request('files/search', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Searches for files and folders. Note: search_v2 along with search/continue_v2
 * can only be used to retrieve a maximum of 10,000 matches. Recent changes may
 * not immediately be reflected in search results due to a short delay in
 * indexing. Duplicate results may be returned across pages. Some results may
 * not be returned.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearchV2
 * @arg {FilesSearchV2Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSearchV2Result>, DropboxResponseError.<FilesSearchError>>}
 */


routes.filesSearchV2 = function (arg) {
  return this.request('files/search_v2', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Fetches the next page of search results returned from search_v2. Note:
 * search_v2 along with search/continue_v2 can only be used to retrieve a
 * maximum of 10,000 matches. Recent changes may not immediately be reflected in
 * search results due to a short delay in indexing. Duplicate results may be
 * returned across pages. Some results may not be returned.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesSearchContinueV2
 * @arg {FilesSearchV2ContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesSearchV2Result>, DropboxResponseError.<FilesSearchError>>}
 */


routes.filesSearchContinueV2 = function (arg) {
  return this.request('files/search/continue_v2', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Add a tag to an item. A tag is a string. The strings are automatically
 * converted to lowercase letters. No more than 20 tags can be added to a given
 * item.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesTagsAdd
 * @arg {FilesAddTagArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesAddTagError>>}
 */


routes.filesTagsAdd = function (arg) {
  return this.request('files/tags/add', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Get list of tags assigned to items.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#filesTagsGet
 * @arg {FilesGetTagsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesGetTagsResult>, DropboxResponseError.<FilesBaseTagError>>}
 */


routes.filesTagsGet = function (arg) {
  return this.request('files/tags/get', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Remove a tag from an item.
 * Route attributes:
 *   scope: files.metadata.write
 * @function Dropbox#filesTagsRemove
 * @arg {FilesRemoveTagArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesRemoveTagError>>}
 */


routes.filesTagsRemove = function (arg) {
  return this.request('files/tags/remove', arg, 'user', 'api', 'rpc', 'files.metadata.write');
};
/**
 * Unlock the files at the given paths. A locked file can only be unlocked by
 * the lock holder or, if a business account, a team admin. A successful
 * response indicates that the file has been unlocked. Returns a list of the
 * unlocked file paths and their metadata after this operation.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUnlockFileBatch
 * @arg {FilesUnlockFileBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesLockFileBatchResult>, DropboxResponseError.<FilesLockFileError>>}
 */


routes.filesUnlockFileBatch = function (arg) {
  return this.request('files/unlock_file_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Create a new file with the contents provided in the request. Do not use this
 * to upload a file larger than 150 MB. Instead, create an upload session with
 * upload_session/start. Calls to this endpoint will count as data transport
 * calls for any Dropbox Business teams with a limit on the number of data
 * transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUpload
 * @arg {FilesUploadArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadError>>}
 */


routes.filesUpload = function (arg) {
  return this.request('files/upload', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * Append more data to an upload session. When the parameter close is set, this
 * call will close the session. A single request should not upload more than 150
 * MB. The maximum size of a file one can upload to an upload session is 350 GB.
 * Calls to this endpoint will count as data transport calls for any Dropbox
 * Business teams with a limit on the number of data transport calls allowed per
 * month. For more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionAppendV2
 * @arg {FilesUploadSessionAppendArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesUploadSessionAppendError>>}
 */


routes.filesUploadSessionAppendV2 = function (arg) {
  return this.request('files/upload_session/append_v2', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * Append more data to an upload session. A single request should not upload
 * more than 150 MB. The maximum size of a file one can upload to an upload
 * session is 350 GB. Calls to this endpoint will count as data transport calls
 * for any Dropbox Business teams with a limit on the number of data transport
 * calls allowed per month. For more information, see the Data transport limit
 * page https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionAppend
 * @deprecated
 * @arg {FilesUploadSessionCursor} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<FilesUploadSessionAppendError>>}
 */


routes.filesUploadSessionAppend = function (arg) {
  return this.request('files/upload_session/append', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * Finish an upload session and save the uploaded data to the given file path. A
 * single request should not upload more than 150 MB. The maximum size of a file
 * one can upload to an upload session is 350 GB. Calls to this endpoint will
 * count as data transport calls for any Dropbox Business teams with a limit on
 * the number of data transport calls allowed per month. For more information,
 * see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinish
 * @arg {FilesUploadSessionFinishArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesFileMetadata>, DropboxResponseError.<FilesUploadSessionFinishError>>}
 */


routes.filesUploadSessionFinish = function (arg) {
  return this.request('files/upload_session/finish', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * This route helps you commit many files at once into a user's Dropbox. Use
 * upload_session/start and upload_session/append_v2 to upload file contents. We
 * recommend uploading many files in parallel to increase throughput. Once the
 * file contents have been uploaded, rather than calling upload_session/finish,
 * use this route to finish all your upload sessions in a single request.
 * UploadSessionStartArg.close or UploadSessionAppendArg.close needs to be true
 * for the last upload_session/start or upload_session/append_v2 call. The
 * maximum size of a file one can upload to an upload session is 350 GB. This
 * route will return a job_id immediately and do the async commit job in
 * background. Use upload_session/finish_batch/check to check the job status.
 * For the same account, this route should be executed serially. That means you
 * should not start the next job before current job finishes. We allow up to
 * 1000 entries in a single request. Calls to this endpoint will count as data
 * transport calls for any Dropbox Business teams with a limit on the number of
 * data transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatch
 * @deprecated
 * @arg {FilesUploadSessionFinishBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchLaunch>, DropboxResponseError.<void>>}
 */


routes.filesUploadSessionFinishBatch = function (arg) {
  return this.request('files/upload_session/finish_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * This route helps you commit many files at once into a user's Dropbox. Use
 * upload_session/start and upload_session/append_v2 to upload file contents. We
 * recommend uploading many files in parallel to increase throughput. Once the
 * file contents have been uploaded, rather than calling upload_session/finish,
 * use this route to finish all your upload sessions in a single request.
 * UploadSessionStartArg.close or UploadSessionAppendArg.close needs to be true
 * for the last upload_session/start or upload_session/append_v2 call of each
 * upload session. The maximum size of a file one can upload to an upload
 * session is 350 GB. We allow up to 1000 entries in a single request. Calls to
 * this endpoint will count as data transport calls for any Dropbox Business
 * teams with a limit on the number of data transport calls allowed per month.
 * For more information, see the Data transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatchV2
 * @arg {FilesUploadSessionFinishBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchResult>, DropboxResponseError.<void>>}
 */


routes.filesUploadSessionFinishBatchV2 = function (arg) {
  return this.request('files/upload_session/finish_batch_v2', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Returns the status of an asynchronous job for upload_session/finish_batch. If
 * success, it returns list of result for each entry.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionFinishBatchCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionFinishBatchJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.filesUploadSessionFinishBatchCheck = function (arg) {
  return this.request('files/upload_session/finish_batch/check', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Upload sessions allow you to upload a single file in one or more requests,
 * for example where the size of the file is greater than 150 MB.  This call
 * starts a new upload session with the given data. You can then use
 * upload_session/append_v2 to add more data and upload_session/finish to save
 * all the data to a file in Dropbox. A single request should not upload more
 * than 150 MB. The maximum size of a file one can upload to an upload session
 * is 350 GB. An upload session can be used for a maximum of 7 days. Attempting
 * to use an UploadSessionStartResult.session_id with upload_session/append_v2
 * or upload_session/finish more than 7 days after its creation will return a
 * UploadSessionLookupError.not_found. Calls to this endpoint will count as data
 * transport calls for any Dropbox Business teams with a limit on the number of
 * data transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit. By
 * default, upload sessions require you to send content of the file in
 * sequential order via consecutive upload_session/start,
 * upload_session/append_v2, upload_session/finish calls. For better
 * performance, you can instead optionally use a UploadSessionType.concurrent
 * upload session. To start a new concurrent session, set
 * UploadSessionStartArg.session_type to UploadSessionType.concurrent. After
 * that, you can send file data in concurrent upload_session/append_v2 requests.
 * Finally finish the session with upload_session/finish. There are couple of
 * constraints with concurrent sessions to make them work. You can not send data
 * with upload_session/start or upload_session/finish call, only with
 * upload_session/append_v2 call. Also data uploaded in upload_session/append_v2
 * call must be multiple of 4194304 bytes (except for last
 * upload_session/append_v2 with UploadSessionStartArg.close to true, that may
 * contain any remaining data).
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionStart
 * @arg {FilesUploadSessionStartArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionStartResult>, DropboxResponseError.<FilesUploadSessionStartError>>}
 */


routes.filesUploadSessionStart = function (arg) {
  return this.request('files/upload_session/start', arg, 'user', 'content', 'upload', 'files.content.write');
};
/**
 * This route starts batch of upload_sessions. Please refer to
 * `upload_session/start` usage. Calls to this endpoint will count as data
 * transport calls for any Dropbox Business teams with a limit on the number of
 * data transport calls allowed per month. For more information, see the Data
 * transport limit page
 * https://www.dropbox.com/developers/reference/data-transport-limit.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#filesUploadSessionStartBatch
 * @arg {FilesUploadSessionStartBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilesUploadSessionStartBatchResult>, DropboxResponseError.<void>>}
 */


routes.filesUploadSessionStartBatch = function (arg) {
  return this.request('files/upload_session/start_batch', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * This route is used for refreshing the info that is found in the id_token
 * during the OIDC flow. This route doesn't require any arguments and will use
 * the scopes approved for the given access token.
 * Route attributes:
 *   scope: openid
 * @function Dropbox#openidUserinfo
 * @arg {OpenidUserInfoArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<OpenidUserInfoResult>, DropboxResponseError.<OpenidUserInfoError>>}
 */


routes.openidUserinfo = function (arg) {
  return this.request('openid/userinfo', arg, 'user', 'api', 'rpc', 'openid');
};
/**
 * Marks the given Paper doc as archived. This action can be performed or undone
 * by anyone with edit permissions to the doc. Note that this endpoint will
 * continue to work for content created by users on the older version of Paper.
 * To check which version of Paper a user is on, use /users/features/get_values.
 * If the paper_as_files feature is enabled, then the user is running the new
 * version of Paper. This endpoint will be retired in September 2020. Refer to
 * the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsArchive
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsArchive = function (arg) {
  return this.request('paper/docs/archive', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Creates a new Paper doc with the provided content. Note that this endpoint
 * will continue to work for content created by users on the older version of
 * Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. This endpoint will be retired
 * in September 2020. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsCreate
 * @deprecated
 * @arg {PaperPaperDocCreateArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperPaperDocCreateUpdateResult>, DropboxResponseError.<PaperPaperDocCreateError>>}
 */


routes.paperDocsCreate = function (arg) {
  return this.request('paper/docs/create', arg, 'user', 'api', 'upload', 'files.content.write');
};
/**
 * Exports and downloads Paper doc either as HTML or markdown. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.content.read
 * @function Dropbox#paperDocsDownload
 * @deprecated
 * @arg {PaperPaperDocExport} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperPaperDocExportResult>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsDownload = function (arg) {
  return this.request('paper/docs/download', arg, 'user', 'api', 'download', 'files.content.read');
};
/**
 * Lists the users who are explicitly invited to the Paper folder in which the
 * Paper doc is contained. For private folders all users (including owner)
 * shared on the folder are listed and for team folders all non-team users
 * shared on the folder are returned. Note that this endpoint will continue to
 * work for content created by users on the older version of Paper. To check
 * which version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsFolderUsersList
 * @deprecated
 * @arg {PaperListUsersOnFolderArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnFolderResponse>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsFolderUsersList = function (arg) {
  return this.request('paper/docs/folder_users/list', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from docs/folder_users/list, use this to
 * paginate through all users on the Paper folder. Note that this endpoint will
 * continue to work for content created by users on the older version of Paper.
 * To check which version of Paper a user is on, use /users/features/get_values.
 * If the paper_as_files feature is enabled, then the user is running the new
 * version of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsFolderUsersListContinue
 * @deprecated
 * @arg {PaperListUsersOnFolderContinueArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnFolderResponse>, DropboxResponseError.<PaperListUsersCursorError>>}
 */


routes.paperDocsFolderUsersListContinue = function (arg) {
  return this.request('paper/docs/folder_users/list/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Retrieves folder information for the given Paper doc. This includes:   -
 * folder sharing policy; permissions for subfolders are set by the top-level
 * folder.   - full 'filepath', i.e. the list of folders (both folderId and
 * folderName) from     the root folder to the folder directly containing the
 * Paper doc.  If the Paper doc is not in any folder (aka unfiled) the response
 * will be empty. Note that this endpoint will continue to work for content
 * created by users on the older version of Paper. To check which version of
 * Paper a user is on, use /users/features/get_values. If the paper_as_files
 * feature is enabled, then the user is running the new version of Paper. Refer
 * to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsGetFolderInfo
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperFoldersContainingPaperDoc>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsGetFolderInfo = function (arg) {
  return this.request('paper/docs/get_folder_info', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Return the list of all Paper docs according to the argument specifications.
 * To iterate over through the full pagination, pass the cursor to
 * docs/list/continue. Note that this endpoint will continue to work for content
 * created by users on the older version of Paper. To check which version of
 * Paper a user is on, use /users/features/get_values. If the paper_as_files
 * feature is enabled, then the user is running the new version of Paper. Refer
 * to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#paperDocsList
 * @deprecated
 * @arg {PaperListPaperDocsArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListPaperDocsResponse>, DropboxResponseError.<void>>}
 */


routes.paperDocsList = function (arg) {
  return this.request('paper/docs/list', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Once a cursor has been retrieved from docs/list, use this to paginate through
 * all Paper doc. Note that this endpoint will continue to work for content
 * created by users on the older version of Paper. To check which version of
 * Paper a user is on, use /users/features/get_values. If the paper_as_files
 * feature is enabled, then the user is running the new version of Paper. Refer
 * to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: files.metadata.read
 * @function Dropbox#paperDocsListContinue
 * @deprecated
 * @arg {PaperListPaperDocsContinueArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListPaperDocsResponse>, DropboxResponseError.<PaperListDocsCursorError>>}
 */


routes.paperDocsListContinue = function (arg) {
  return this.request('paper/docs/list/continue', arg, 'user', 'api', 'rpc', 'files.metadata.read');
};
/**
 * Permanently deletes the given Paper doc. This operation is final as the doc
 * cannot be recovered. This action can be performed only by the doc owner. Note
 * that this endpoint will continue to work for content created by users on the
 * older version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.permanent_delete
 * @function Dropbox#paperDocsPermanentlyDelete
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsPermanentlyDelete = function (arg) {
  return this.request('paper/docs/permanently_delete', arg, 'user', 'api', 'rpc', 'files.permanent_delete');
};
/**
 * Gets the default sharing policy for the given Paper doc. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsSharingPolicyGet
 * @deprecated
 * @arg {PaperRefPaperDoc} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperSharingPolicy>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsSharingPolicyGet = function (arg) {
  return this.request('paper/docs/sharing_policy/get', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Sets the default sharing policy for the given Paper doc. The default
 * 'team_sharing_policy' can be changed only by teams, omit this field for
 * personal accounts. The 'public_sharing_policy' policy can't be set to the
 * value 'disabled' because this setting can be changed only via the team admin
 * console. Note that this endpoint will continue to work for content created by
 * users on the older version of Paper. To check which version of Paper a user
 * is on, use /users/features/get_values. If the paper_as_files feature is
 * enabled, then the user is running the new version of Paper. Refer to the
 * Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsSharingPolicySet
 * @deprecated
 * @arg {PaperPaperDocSharingPolicy} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsSharingPolicySet = function (arg) {
  return this.request('paper/docs/sharing_policy/set', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Updates an existing Paper doc with the provided content. Note that this
 * endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. This endpoint will be retired
 * in September 2020. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * more information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperDocsUpdate
 * @deprecated
 * @arg {PaperPaperDocUpdateArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperPaperDocCreateUpdateResult>, DropboxResponseError.<PaperPaperDocUpdateError>>}
 */


routes.paperDocsUpdate = function (arg) {
  return this.request('paper/docs/update', arg, 'user', 'api', 'upload', 'files.content.write');
};
/**
 * Allows an owner or editor to add users to a Paper doc or change their
 * permissions using their email address or Dropbox account ID. The doc owner's
 * permissions cannot be changed. Note that this endpoint will continue to work
 * for content created by users on the older version of Paper. To check which
 * version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsUsersAdd
 * @deprecated
 * @arg {PaperAddPaperDocUser} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<PaperAddPaperDocUserMemberResult>>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsUsersAdd = function (arg) {
  return this.request('paper/docs/users/add', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Lists all users who visited the Paper doc or users with explicit access. This
 * call excludes users who have been removed. The list is sorted by the date of
 * the visit or the share date. The list will include both users, the explicitly
 * shared ones as well as those who came in using the Paper url link. Note that
 * this endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsUsersList
 * @deprecated
 * @arg {PaperListUsersOnPaperDocArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnPaperDocResponse>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsUsersList = function (arg) {
  return this.request('paper/docs/users/list', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from docs/users/list, use this to paginate
 * through all users on the Paper doc. Note that this endpoint will continue to
 * work for content created by users on the older version of Paper. To check
 * which version of Paper a user is on, use /users/features/get_values. If the
 * paper_as_files feature is enabled, then the user is running the new version
 * of Paper. Refer to the Paper Migration Guide
 * https://www.dropbox.com/lp/developers/reference/paper-migration-guide for
 * migration information.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#paperDocsUsersListContinue
 * @deprecated
 * @arg {PaperListUsersOnPaperDocContinueArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperListUsersOnPaperDocResponse>, DropboxResponseError.<PaperListUsersCursorError>>}
 */


routes.paperDocsUsersListContinue = function (arg) {
  return this.request('paper/docs/users/list/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Allows an owner or editor to remove users from a Paper doc using their email
 * address or Dropbox account ID. The doc owner cannot be removed. Note that
 * this endpoint will continue to work for content created by users on the older
 * version of Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#paperDocsUsersRemove
 * @deprecated
 * @arg {PaperRemovePaperDocUser} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<PaperDocLookupError>>}
 */


routes.paperDocsUsersRemove = function (arg) {
  return this.request('paper/docs/users/remove', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Create a new Paper folder with the provided info. Note that this endpoint
 * will continue to work for content created by users on the older version of
 * Paper. To check which version of Paper a user is on, use
 * /users/features/get_values. If the paper_as_files feature is enabled, then
 * the user is running the new version of Paper. Refer to the Paper Migration
 * Guide https://www.dropbox.com/lp/developers/reference/paper-migration-guide
 * for migration information.
 * Route attributes:
 *   scope: files.content.write
 * @function Dropbox#paperFoldersCreate
 * @deprecated
 * @arg {PaperPaperFolderCreateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<PaperPaperFolderCreateResult>, DropboxResponseError.<PaperPaperFolderCreateError>>}
 */


routes.paperFoldersCreate = function (arg) {
  return this.request('paper/folders/create', arg, 'user', 'api', 'rpc', 'files.content.write');
};
/**
 * Adds specified members to a file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingAddFileMember
 * @arg {SharingAddFileMemberArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<SharingFileMemberActionResult>>, DropboxResponseError.<SharingAddFileMemberError>>}
 */


routes.sharingAddFileMember = function (arg) {
  return this.request('sharing/add_file_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to add another member. For the new member to get access to all the
 * functionality for this folder, you will need to call mount_folder on their
 * behalf.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingAddFolderMember
 * @arg {SharingAddFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingAddFolderMemberError>>}
 */


routes.sharingAddFolderMember = function (arg) {
  return this.request('sharing/add_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Returns the status of an asynchronous job.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.sharingCheckJobStatus = function (arg) {
  return this.request('sharing/check_job_status', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Returns the status of an asynchronous job for sharing a folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckRemoveMemberJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingRemoveMemberJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.sharingCheckRemoveMemberJobStatus = function (arg) {
  return this.request('sharing/check_remove_member_job_status', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Returns the status of an asynchronous job for sharing a folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCheckShareJobStatus
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingShareFolderJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.sharingCheckShareJobStatus = function (arg) {
  return this.request('sharing/check_share_job_status', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Create a shared link. If a shared link already exists for the given path,
 * that link is returned. Previously, it was technically possible to break a
 * shared link by moving or renaming the corresponding file or folder. In the
 * future, this will no longer be the case, so your app shouldn't rely on this
 * behavior. Instead, if your app needs to revoke a shared link, use
 * revoke_shared_link.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCreateSharedLink
 * @deprecated
 * @arg {SharingCreateSharedLinkArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingPathLinkMetadata>, DropboxResponseError.<SharingCreateSharedLinkError>>}
 */


routes.sharingCreateSharedLink = function (arg) {
  return this.request('sharing/create_shared_link', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Create a shared link with custom settings. If no settings are given then the
 * default visibility is RequestedVisibility.public (The resolved visibility,
 * though, may depend on other aspects such as team and shared folder settings).
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingCreateSharedLinkWithSettings
 * @arg {SharingCreateSharedLinkWithSettingsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingCreateSharedLinkWithSettingsError>>}
 */


routes.sharingCreateSharedLinkWithSettings = function (arg) {
  return this.request('sharing/create_shared_link_with_settings', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Returns shared file metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFileMetadata
 * @arg {SharingGetFileMetadataArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMetadata>, DropboxResponseError.<SharingGetFileMetadataError>>}
 */


routes.sharingGetFileMetadata = function (arg) {
  return this.request('sharing/get_file_metadata', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Returns shared file metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFileMetadataBatch
 * @arg {SharingGetFileMetadataBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<SharingGetFileMetadataBatchResult>>, DropboxResponseError.<SharingSharingUserError>>}
 */


routes.sharingGetFileMetadataBatch = function (arg) {
  return this.request('sharing/get_file_metadata/batch', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Returns shared folder metadata by its folder ID.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetFolderMetadata
 * @arg {SharingGetMetadataArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingSharedFolderAccessError>>}
 */


routes.sharingGetFolderMetadata = function (arg) {
  return this.request('sharing/get_folder_metadata', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Download the shared link's file from a user's Dropbox.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinkFile
 * @arg {Object} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingGetSharedLinkFileError>>}
 */


routes.sharingGetSharedLinkFile = function (arg) {
  return this.request('sharing/get_shared_link_file', arg, 'user', 'content', 'download', 'sharing.read');
};
/**
 * Get the shared link's metadata.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinkMetadata
 * @arg {SharingGetSharedLinkMetadataArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingSharedLinkError>>}
 */


routes.sharingGetSharedLinkMetadata = function (arg) {
  return this.request('sharing/get_shared_link_metadata', arg, 'app, user', 'api', 'rpc', 'sharing.read');
};
/**
 * Returns a list of LinkMetadata objects for this user, including collection
 * links. If no path is given, returns a list of all shared links for the
 * current user, including collection links, up to a maximum of 1000 links. If a
 * non-empty path is given, returns a list of all shared links that allow access
 * to the given path.  Collection links are never returned in this case.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingGetSharedLinks
 * @deprecated
 * @arg {SharingGetSharedLinksArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingGetSharedLinksResult>, DropboxResponseError.<SharingGetSharedLinksError>>}
 */


routes.sharingGetSharedLinks = function (arg) {
  return this.request('sharing/get_shared_links', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Use to obtain the members who have been invited to a file, both inherited and
 * uninherited members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembers
 * @arg {SharingListFileMembersArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMembers>, DropboxResponseError.<SharingListFileMembersError>>}
 */


routes.sharingListFileMembers = function (arg) {
  return this.request('sharing/list_file_members', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Get members of multiple files at once. The arguments to this route are more
 * limited, and the limit on query result size per file is more strict. To
 * customize the results more, use the individual file endpoint. Inherited users
 * and groups are not included in the result, and permissions are not returned
 * for this endpoint.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembersBatch
 * @arg {SharingListFileMembersBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<SharingListFileMembersBatchResult>>, DropboxResponseError.<SharingSharingUserError>>}
 */


routes.sharingListFileMembersBatch = function (arg) {
  return this.request('sharing/list_file_members/batch', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from list_file_members or
 * list_file_members/batch, use this to paginate through all shared file
 * members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFileMembersContinue
 * @arg {SharingListFileMembersContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFileMembers>, DropboxResponseError.<SharingListFileMembersContinueError>>}
 */


routes.sharingListFileMembersContinue = function (arg) {
  return this.request('sharing/list_file_members/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Returns shared folder membership by its folder ID.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolderMembers
 * @arg {SharingListFolderMembersArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMembers>, DropboxResponseError.<SharingSharedFolderAccessError>>}
 */


routes.sharingListFolderMembers = function (arg) {
  return this.request('sharing/list_folder_members', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from list_folder_members, use this to
 * paginate through all shared folder members.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolderMembersContinue
 * @arg {SharingListFolderMembersContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMembers>, DropboxResponseError.<SharingListFolderMembersContinueError>>}
 */


routes.sharingListFolderMembersContinue = function (arg) {
  return this.request('sharing/list_folder_members/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Return the list of all shared folders the current user has access to.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<void>>}
 */


routes.sharingListFolders = function (arg) {
  return this.request('sharing/list_folders', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from list_folders, use this to paginate
 * through all shared folders. The cursor must come from a previous call to
 * list_folders or list_folders/continue.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<SharingListFoldersContinueError>>}
 */


routes.sharingListFoldersContinue = function (arg) {
  return this.request('sharing/list_folders/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Return the list of all shared folders the current user can mount or unmount.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListMountableFolders
 * @arg {SharingListFoldersArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<void>>}
 */


routes.sharingListMountableFolders = function (arg) {
  return this.request('sharing/list_mountable_folders', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Once a cursor has been retrieved from list_mountable_folders, use this to
 * paginate through all mountable shared folders. The cursor must come from a
 * previous call to list_mountable_folders or list_mountable_folders/continue.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListMountableFoldersContinue
 * @arg {SharingListFoldersContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFoldersResult>, DropboxResponseError.<SharingListFoldersContinueError>>}
 */


routes.sharingListMountableFoldersContinue = function (arg) {
  return this.request('sharing/list_mountable_folders/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Returns a list of all files shared with current user.  Does not include files
 * the user has received via shared folders, and does  not include unclaimed
 * invitations.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListReceivedFiles
 * @arg {SharingListFilesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFilesResult>, DropboxResponseError.<SharingSharingUserError>>}
 */


routes.sharingListReceivedFiles = function (arg) {
  return this.request('sharing/list_received_files', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Get more results with a cursor from list_received_files.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListReceivedFilesContinue
 * @arg {SharingListFilesContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListFilesResult>, DropboxResponseError.<SharingListFilesContinueError>>}
 */


routes.sharingListReceivedFilesContinue = function (arg) {
  return this.request('sharing/list_received_files/continue', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * List shared links of this user. If no path is given, returns a list of all
 * shared links for the current user. For members of business teams using team
 * space and member folders, returns all shared links in the team member's home
 * folder unless the team space ID is specified in the request header. For more
 * information, refer to the Namespace Guide
 * https://www.dropbox.com/developers/reference/namespace-guide. If a non-empty
 * path is given, returns a list of all shared links that allow access to the
 * given path - direct links to the given path and links to parent folders of
 * the given path. Links to parent folders can be suppressed by setting
 * direct_only to true.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#sharingListSharedLinks
 * @arg {SharingListSharedLinksArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingListSharedLinksResult>, DropboxResponseError.<SharingListSharedLinksError>>}
 */


routes.sharingListSharedLinks = function (arg) {
  return this.request('sharing/list_shared_links', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Modify the shared link's settings. If the requested visibility conflict with
 * the shared links policy of the team or the shared folder (in case the linked
 * file is part of a shared folder) then the LinkPermissions.resolved_visibility
 * of the returned SharedLinkMetadata will reflect the actual visibility of the
 * shared link and the LinkPermissions.requested_visibility will reflect the
 * requested visibility.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingModifySharedLinkSettings
 * @arg {SharingModifySharedLinkSettingsArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<(SharingFileLinkMetadata|SharingFolderLinkMetadata|SharingSharedLinkMetadata)>, DropboxResponseError.<SharingModifySharedLinkSettingsError>>}
 */


routes.sharingModifySharedLinkSettings = function (arg) {
  return this.request('sharing/modify_shared_link_settings', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * The current user mounts the designated folder. Mount a shared folder for a
 * user after they have been added as a member. Once mounted, the shared folder
 * will appear in their Dropbox.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingMountFolder
 * @arg {SharingMountFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingMountFolderError>>}
 */


routes.sharingMountFolder = function (arg) {
  return this.request('sharing/mount_folder', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * The current user relinquishes their membership in the designated file. Note
 * that the current user may still have inherited access to this file through
 * the parent folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRelinquishFileMembership
 * @arg {SharingRelinquishFileMembershipArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingRelinquishFileMembershipError>>}
 */


routes.sharingRelinquishFileMembership = function (arg) {
  return this.request('sharing/relinquish_file_membership', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * The current user relinquishes their membership in the designated shared
 * folder and will no longer have access to the folder.  A folder owner cannot
 * relinquish membership in their own folder. This will run synchronously if
 * leave_a_copy is false, and asynchronously if leave_a_copy is true.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRelinquishFolderMembership
 * @arg {SharingRelinquishFolderMembershipArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<SharingRelinquishFolderMembershipError>>}
 */


routes.sharingRelinquishFolderMembership = function (arg) {
  return this.request('sharing/relinquish_folder_membership', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Identical to remove_file_member_2 but with less information returned.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFileMember
 * @deprecated
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingFileMemberActionIndividualResult>, DropboxResponseError.<SharingRemoveFileMemberError>>}
 */


routes.sharingRemoveFileMember = function (arg) {
  return this.request('sharing/remove_file_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Removes a specified member from the file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFileMember2
 * @arg {SharingRemoveFileMemberArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingFileMemberRemoveActionResult>, DropboxResponseError.<SharingRemoveFileMemberError>>}
 */


routes.sharingRemoveFileMember2 = function (arg) {
  return this.request('sharing/remove_file_member_2', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Allows an owner or editor (if the ACL update policy allows) of a shared
 * folder to remove another member.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRemoveFolderMember
 * @arg {SharingRemoveFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchResultBase>, DropboxResponseError.<SharingRemoveFolderMemberError>>}
 */


routes.sharingRemoveFolderMember = function (arg) {
  return this.request('sharing/remove_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Revoke a shared link. Note that even after revoking a shared link to a file,
 * the file may be accessible if there are shared links leading to any of the
 * file parent folders. To list all shared links that enable access to a
 * specific file, you can use the list_shared_links with the file as the
 * ListSharedLinksArg.path argument.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingRevokeSharedLink
 * @arg {SharingRevokeSharedLinkArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingRevokeSharedLinkError>>}
 */


routes.sharingRevokeSharedLink = function (arg) {
  return this.request('sharing/revoke_shared_link', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Change the inheritance policy of an existing Shared Folder. Only permitted
 * for shared folders in a shared team root. If a ShareFolderLaunch.async_job_id
 * is returned, you'll need to call check_share_job_status until the action
 * completes to get the metadata for the folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingSetAccessInheritance
 * @arg {SharingSetAccessInheritanceArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingShareFolderLaunch>, DropboxResponseError.<SharingSetAccessInheritanceError>>}
 */


routes.sharingSetAccessInheritance = function (arg) {
  return this.request('sharing/set_access_inheritance', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Share a folder with collaborators. Most sharing will be completed
 * synchronously. Large folders will be completed asynchronously. To make
 * testing the async case repeatable, set `ShareFolderArg.force_async`. If a
 * ShareFolderLaunch.async_job_id is returned, you'll need to call
 * check_share_job_status until the action completes to get the metadata for the
 * folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingShareFolder
 * @arg {SharingShareFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingShareFolderLaunch>, DropboxResponseError.<SharingShareFolderError>>}
 */


routes.sharingShareFolder = function (arg) {
  return this.request('sharing/share_folder', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Transfer ownership of a shared folder to a member of the shared folder. User
 * must have AccessLevel.owner access to the shared folder to perform a
 * transfer.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingTransferFolder
 * @arg {SharingTransferFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingTransferFolderError>>}
 */


routes.sharingTransferFolder = function (arg) {
  return this.request('sharing/transfer_folder', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * The current user unmounts the designated folder. They can re-mount the folder
 * at a later time using mount_folder.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnmountFolder
 * @arg {SharingUnmountFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingUnmountFolderError>>}
 */


routes.sharingUnmountFolder = function (arg) {
  return this.request('sharing/unmount_folder', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Remove all members from this file. Does not remove inherited members.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnshareFile
 * @arg {SharingUnshareFileArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<SharingUnshareFileError>>}
 */


routes.sharingUnshareFile = function (arg) {
  return this.request('sharing/unshare_file', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Allows a shared folder owner to unshare the folder. You'll need to call
 * check_job_status to determine if the action has completed successfully.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUnshareFolder
 * @arg {SharingUnshareFolderArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<SharingUnshareFolderError>>}
 */


routes.sharingUnshareFolder = function (arg) {
  return this.request('sharing/unshare_folder', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Changes a member's access on a shared file.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFileMember
 * @arg {SharingUpdateFileMemberArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingMemberAccessLevelResult>, DropboxResponseError.<SharingFileMemberActionError>>}
 */


routes.sharingUpdateFileMember = function (arg) {
  return this.request('sharing/update_file_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Allows an owner or editor of a shared folder to update another member's
 * permissions.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFolderMember
 * @arg {SharingUpdateFolderMemberArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingMemberAccessLevelResult>, DropboxResponseError.<SharingUpdateFolderMemberError>>}
 */


routes.sharingUpdateFolderMember = function (arg) {
  return this.request('sharing/update_folder_member', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * Update the sharing policies for a shared folder. User must have
 * AccessLevel.owner access to the shared folder to update its policies.
 * Route attributes:
 *   scope: sharing.write
 * @function Dropbox#sharingUpdateFolderPolicy
 * @arg {SharingUpdateFolderPolicyArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<SharingSharedFolderMetadata>, DropboxResponseError.<SharingUpdateFolderPolicyError>>}
 */


routes.sharingUpdateFolderPolicy = function (arg) {
  return this.request('sharing/update_folder_policy', arg, 'user', 'api', 'rpc', 'sharing.write');
};
/**
 * List all device sessions of a team's member.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListMemberDevices
 * @arg {TeamListMemberDevicesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListMemberDevicesResult>, DropboxResponseError.<TeamListMemberDevicesError>>}
 */


routes.teamDevicesListMemberDevices = function (arg) {
  return this.request('team/devices/list_member_devices', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * List all device sessions of a team. Permission : Team member file access.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListMembersDevices
 * @arg {TeamListMembersDevicesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListMembersDevicesResult>, DropboxResponseError.<TeamListMembersDevicesError>>}
 */


routes.teamDevicesListMembersDevices = function (arg) {
  return this.request('team/devices/list_members_devices', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * List all device sessions of a team. Permission : Team member file access.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamDevicesListTeamDevices
 * @deprecated
 * @arg {TeamListTeamDevicesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListTeamDevicesResult>, DropboxResponseError.<TeamListTeamDevicesError>>}
 */


routes.teamDevicesListTeamDevices = function (arg) {
  return this.request('team/devices/list_team_devices', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * Revoke a device session of a team's member.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamDevicesRevokeDeviceSession
 * @arg {TeamRevokeDeviceSessionArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamRevokeDeviceSessionError>>}
 */


routes.teamDevicesRevokeDeviceSession = function (arg) {
  return this.request('team/devices/revoke_device_session', arg, 'team', 'api', 'rpc', 'sessions.modify');
};
/**
 * Revoke a list of device sessions of team members.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamDevicesRevokeDeviceSessionBatch
 * @arg {TeamRevokeDeviceSessionBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamRevokeDeviceSessionBatchResult>, DropboxResponseError.<TeamRevokeDeviceSessionBatchError>>}
 */


routes.teamDevicesRevokeDeviceSessionBatch = function (arg) {
  return this.request('team/devices/revoke_device_session_batch', arg, 'team', 'api', 'rpc', 'sessions.modify');
};
/**
 * Get the values for one or more featues. This route allows you to check your
 * account's capability for what feature you can access or what value you have
 * for certain features. Permission : Team information.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamFeaturesGetValues
 * @arg {TeamFeaturesGetValuesBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamFeaturesGetValuesBatchResult>, DropboxResponseError.<TeamFeaturesGetValuesBatchError>>}
 */


routes.teamFeaturesGetValues = function (arg) {
  return this.request('team/features/get_values', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Retrieves information about a team.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamGetInfo
 * @returns {Promise.<DropboxResponse<TeamTeamGetInfoResult>, DropboxResponseError.<void>>}
 */


routes.teamGetInfo = function () {
  return this.request('team/get_info', null, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Creates a new, empty group, with a requested name. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsCreate
 * @arg {TeamGroupCreateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupFullInfo>, DropboxResponseError.<TeamGroupCreateError>>}
 */


routes.teamGroupsCreate = function (arg) {
  return this.request('team/groups/create', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Deletes a group. The group is deleted immediately. However the revoking of
 * group-owned resources may take additional time. Use the groups/job_status/get
 * to determine whether this process has completed. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsDelete
 * @arg {TeamGroupSelector} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamGroupDeleteError>>}
 */


routes.teamGroupsDelete = function (arg) {
  return this.request('team/groups/delete', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Retrieves information about one or more groups. Note that the optional field
 * GroupFullInfo.members is not returned for system-managed groups. Permission :
 * Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsGetInfo
 * @arg {TeamGroupsSelector} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamGroupsGetInfoError>>}
 */


routes.teamGroupsGetInfo = function (arg) {
  return this.request('team/groups/get_info', arg, 'team', 'api', 'rpc', 'groups.read');
};
/**
 * Once an async_job_id is returned from groups/delete, groups/members/add , or
 * groups/members/remove use this method to poll the status of granting/revoking
 * group members' access to group-owned resources. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<TeamGroupsPollError>>}
 */


routes.teamGroupsJobStatusGet = function (arg) {
  return this.request('team/groups/job_status/get', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Lists groups on a team. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsList
 * @arg {TeamGroupsListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupsListResult>, DropboxResponseError.<void>>}
 */


routes.teamGroupsList = function (arg) {
  return this.request('team/groups/list', arg, 'team', 'api', 'rpc', 'groups.read');
};
/**
 * Once a cursor has been retrieved from groups/list, use this to paginate
 * through all groups. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsListContinue
 * @arg {TeamGroupsListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupsListResult>, DropboxResponseError.<TeamGroupsListContinueError>>}
 */


routes.teamGroupsListContinue = function (arg) {
  return this.request('team/groups/list/continue', arg, 'team', 'api', 'rpc', 'groups.read');
};
/**
 * Adds members to a group. The members are added immediately. However the
 * granting of group-owned resources may take additional time. Use the
 * groups/job_status/get to determine whether this process has completed.
 * Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersAdd
 * @arg {TeamGroupMembersAddArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupMembersChangeResult>, DropboxResponseError.<TeamGroupMembersAddError>>}
 */


routes.teamGroupsMembersAdd = function (arg) {
  return this.request('team/groups/members/add', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Lists members of a group. Permission : Team Information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsMembersList
 * @arg {TeamGroupsMembersListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupsMembersListResult>, DropboxResponseError.<TeamGroupSelectorError>>}
 */


routes.teamGroupsMembersList = function (arg) {
  return this.request('team/groups/members/list', arg, 'team', 'api', 'rpc', 'groups.read');
};
/**
 * Once a cursor has been retrieved from groups/members/list, use this to
 * paginate through all members of the group. Permission : Team information.
 * Route attributes:
 *   scope: groups.read
 * @function Dropbox#teamGroupsMembersListContinue
 * @arg {TeamGroupsMembersListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupsMembersListResult>, DropboxResponseError.<TeamGroupsMembersListContinueError>>}
 */


routes.teamGroupsMembersListContinue = function (arg) {
  return this.request('team/groups/members/list/continue', arg, 'team', 'api', 'rpc', 'groups.read');
};
/**
 * Removes members from a group. The members are removed immediately. However
 * the revoking of group-owned resources may take additional time. Use the
 * groups/job_status/get to determine whether this process has completed. This
 * method permits removing the only owner of a group, even in cases where this
 * is not possible via the web client. Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersRemove
 * @arg {TeamGroupMembersRemoveArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupMembersChangeResult>, DropboxResponseError.<TeamGroupMembersRemoveError>>}
 */


routes.teamGroupsMembersRemove = function (arg) {
  return this.request('team/groups/members/remove', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Sets a member's access type in a group. Permission : Team member management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsMembersSetAccessType
 * @arg {TeamGroupMembersSetAccessTypeArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamGroupMemberSetAccessTypeError>>}
 */


routes.teamGroupsMembersSetAccessType = function (arg) {
  return this.request('team/groups/members/set_access_type', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Updates a group's name and/or external ID. Permission : Team member
 * management.
 * Route attributes:
 *   scope: groups.write
 * @function Dropbox#teamGroupsUpdate
 * @arg {TeamGroupUpdateArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGroupFullInfo>, DropboxResponseError.<TeamGroupUpdateError>>}
 */


routes.teamGroupsUpdate = function (arg) {
  return this.request('team/groups/update', arg, 'team', 'api', 'rpc', 'groups.write');
};
/**
 * Creates new legal hold policy. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsCreatePolicy
 * @arg {TeamLegalHoldsPolicyCreateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsPolicyCreateError>>}
 */


routes.teamLegalHoldsCreatePolicy = function (arg) {
  return this.request('team/legal_holds/create_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * Gets a legal hold by Id. Note: Legal Holds is a paid add-on. Not all teams
 * have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsGetPolicy
 * @arg {TeamLegalHoldsGetPolicyArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsGetPolicyError>>}
 */


routes.teamLegalHoldsGetPolicy = function (arg) {
  return this.request('team/legal_holds/get_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * List the file metadata that's under the hold. Note: Legal Holds is a paid
 * add-on. Not all teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListHeldRevisions
 * @arg {TeamLegalHoldsListHeldRevisionsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListHeldRevisionResult>, DropboxResponseError.<TeamLegalHoldsListHeldRevisionsError>>}
 */


routes.teamLegalHoldsListHeldRevisions = function (arg) {
  return this.request('team/legal_holds/list_held_revisions', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * Continue listing the file metadata that's under the hold. Note: Legal Holds
 * is a paid add-on. Not all teams have the feature. Permission : Team member
 * file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListHeldRevisionsContinue
 * @arg {TeamLegalHoldsListHeldRevisionsContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListHeldRevisionResult>, DropboxResponseError.<TeamLegalHoldsListHeldRevisionsError>>}
 */


routes.teamLegalHoldsListHeldRevisionsContinue = function (arg) {
  return this.request('team/legal_holds/list_held_revisions_continue', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * Lists legal holds on a team. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsListPolicies
 * @arg {TeamLegalHoldsListPoliciesArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamLegalHoldsListPoliciesResult>, DropboxResponseError.<TeamLegalHoldsListPoliciesError>>}
 */


routes.teamLegalHoldsListPolicies = function (arg) {
  return this.request('team/legal_holds/list_policies', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * Releases a legal hold by Id. Note: Legal Holds is a paid add-on. Not all
 * teams have the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsReleasePolicy
 * @arg {TeamLegalHoldsPolicyReleaseArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamLegalHoldsPolicyReleaseError>>}
 */


routes.teamLegalHoldsReleasePolicy = function (arg) {
  return this.request('team/legal_holds/release_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * Updates a legal hold. Note: Legal Holds is a paid add-on. Not all teams have
 * the feature. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.governance.write
 * @function Dropbox#teamLegalHoldsUpdatePolicy
 * @arg {TeamLegalHoldsPolicyUpdateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamLegalHoldsPolicyUpdateError>>}
 */


routes.teamLegalHoldsUpdatePolicy = function (arg) {
  return this.request('team/legal_holds/update_policy', arg, 'team', 'api', 'rpc', 'team_data.governance.write');
};
/**
 * List all linked applications of the team member. Note, this endpoint does not
 * list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListMemberLinkedApps
 * @arg {TeamListMemberAppsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListMemberAppsResult>, DropboxResponseError.<TeamListMemberAppsError>>}
 */


routes.teamLinkedAppsListMemberLinkedApps = function (arg) {
  return this.request('team/linked_apps/list_member_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * List all applications linked to the team members' accounts. Note, this
 * endpoint does not list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListMembersLinkedApps
 * @arg {TeamListMembersAppsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListMembersAppsResult>, DropboxResponseError.<TeamListMembersAppsError>>}
 */


routes.teamLinkedAppsListMembersLinkedApps = function (arg) {
  return this.request('team/linked_apps/list_members_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * List all applications linked to the team members' accounts. Note, this
 * endpoint doesn't list any team-linked applications.
 * Route attributes:
 *   scope: sessions.list
 * @function Dropbox#teamLinkedAppsListTeamLinkedApps
 * @deprecated
 * @arg {TeamListTeamAppsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamListTeamAppsResult>, DropboxResponseError.<TeamListTeamAppsError>>}
 */


routes.teamLinkedAppsListTeamLinkedApps = function (arg) {
  return this.request('team/linked_apps/list_team_linked_apps', arg, 'team', 'api', 'rpc', 'sessions.list');
};
/**
 * Revoke a linked application of the team member.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamLinkedAppsRevokeLinkedApp
 * @arg {TeamRevokeLinkedApiAppArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamRevokeLinkedAppError>>}
 */


routes.teamLinkedAppsRevokeLinkedApp = function (arg) {
  return this.request('team/linked_apps/revoke_linked_app', arg, 'team', 'api', 'rpc', 'sessions.modify');
};
/**
 * Revoke a list of linked applications of the team members.
 * Route attributes:
 *   scope: sessions.modify
 * @function Dropbox#teamLinkedAppsRevokeLinkedAppBatch
 * @arg {TeamRevokeLinkedApiAppBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamRevokeLinkedAppBatchResult>, DropboxResponseError.<TeamRevokeLinkedAppBatchError>>}
 */


routes.teamLinkedAppsRevokeLinkedAppBatch = function (arg) {
  return this.request('team/linked_apps/revoke_linked_app_batch', arg, 'team', 'api', 'rpc', 'sessions.modify');
};
/**
 * Add users to member space limits excluded users list.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersAdd
 * @arg {TeamExcludedUsersUpdateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersUpdateResult>, DropboxResponseError.<TeamExcludedUsersUpdateError>>}
 */


routes.teamMemberSpaceLimitsExcludedUsersAdd = function (arg) {
  return this.request('team/member_space_limits/excluded_users/add', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * List member space limits excluded users.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersList
 * @arg {TeamExcludedUsersListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersListResult>, DropboxResponseError.<TeamExcludedUsersListError>>}
 */


routes.teamMemberSpaceLimitsExcludedUsersList = function (arg) {
  return this.request('team/member_space_limits/excluded_users/list', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Continue listing member space limits excluded users.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersListContinue
 * @arg {TeamExcludedUsersListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersListResult>, DropboxResponseError.<TeamExcludedUsersListContinueError>>}
 */


routes.teamMemberSpaceLimitsExcludedUsersListContinue = function (arg) {
  return this.request('team/member_space_limits/excluded_users/list/continue', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Remove users from member space limits excluded users list.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsExcludedUsersRemove
 * @arg {TeamExcludedUsersUpdateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamExcludedUsersUpdateResult>, DropboxResponseError.<TeamExcludedUsersUpdateError>>}
 */


routes.teamMemberSpaceLimitsExcludedUsersRemove = function (arg) {
  return this.request('team/member_space_limits/excluded_users/remove', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Get users custom quota. Returns none as the custom quota if none was set. A
 * maximum of 1000 members can be specified in a single call.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsGetCustomQuota
 * @arg {TeamCustomQuotaUsersArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<TeamCustomQuotaResult>>, DropboxResponseError.<TeamCustomQuotaError>>}
 */


routes.teamMemberSpaceLimitsGetCustomQuota = function (arg) {
  return this.request('team/member_space_limits/get_custom_quota', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Remove users custom quota. A maximum of 1000 members can be specified in a
 * single call.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMemberSpaceLimitsRemoveCustomQuota
 * @arg {TeamCustomQuotaUsersArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<TeamRemoveCustomQuotaResult>>, DropboxResponseError.<TeamCustomQuotaError>>}
 */


routes.teamMemberSpaceLimitsRemoveCustomQuota = function (arg) {
  return this.request('team/member_space_limits/remove_custom_quota', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Set users custom quota. Custom quota has to be at least 15GB. A maximum of
 * 1000 members can be specified in a single call.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMemberSpaceLimitsSetCustomQuota
 * @arg {TeamSetCustomQuotaArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<TeamCustomQuotaResult>>, DropboxResponseError.<TeamSetCustomQuotaError>>}
 */


routes.teamMemberSpaceLimitsSetCustomQuota = function (arg) {
  return this.request('team/member_space_limits/set_custom_quota', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Adds members to a team. Permission : Team member management A maximum of 20
 * members can be specified in a single call. If no Dropbox account exists with
 * the email address specified, a new Dropbox account will be created with the
 * given email address, and that account will be invited to the team. If a
 * personal Dropbox account exists with the email address specified in the call,
 * this call will create a placeholder Dropbox account for the user on the team
 * and send an email inviting the user to migrate their existing personal
 * account onto the team. Team member management apps are required to set an
 * initial given_name and surname for a user to use in the team invitation and
 * for 'Perform as team member' actions taken on the user before they become
 * 'active'.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddV2
 * @arg {TeamMembersAddV2Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersAddLaunchV2Result>, DropboxResponseError.<void>>}
 */


routes.teamMembersAddV2 = function (arg) {
  return this.request('team/members/add_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Adds members to a team. Permission : Team member management A maximum of 20
 * members can be specified in a single call. If no Dropbox account exists with
 * the email address specified, a new Dropbox account will be created with the
 * given email address, and that account will be invited to the team. If a
 * personal Dropbox account exists with the email address specified in the call,
 * this call will create a placeholder Dropbox account for the user on the team
 * and send an email inviting the user to migrate their existing personal
 * account onto the team. Team member management apps are required to set an
 * initial given_name and surname for a user to use in the team invitation and
 * for 'Perform as team member' actions taken on the user before they become
 * 'active'.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAdd
 * @arg {TeamMembersAddArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersAddLaunch>, DropboxResponseError.<void>>}
 */


routes.teamMembersAdd = function (arg) {
  return this.request('team/members/add', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Once an async_job_id is returned from members/add_v2 , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddJobStatusGetV2
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersAddJobStatusV2Result>, DropboxResponseError.<AsyncPollError>>}
 */


routes.teamMembersAddJobStatusGetV2 = function (arg) {
  return this.request('team/members/add/job_status/get_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Once an async_job_id is returned from members/add , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersAddJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersAddJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.teamMembersAddJobStatusGet = function (arg) {
  return this.request('team/members/add/job_status/get', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Deletes a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersDeleteProfilePhotoV2
 * @arg {TeamMembersDeleteProfilePhotoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersDeleteProfilePhotoError>>}
 */


routes.teamMembersDeleteProfilePhotoV2 = function (arg) {
  return this.request('team/members/delete_profile_photo_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Deletes a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersDeleteProfilePhoto
 * @arg {TeamMembersDeleteProfilePhotoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersDeleteProfilePhotoError>>}
 */


routes.teamMembersDeleteProfilePhoto = function (arg) {
  return this.request('team/members/delete_profile_photo', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Get available TeamMemberRoles for the connected team. To be used with
 * members/set_admin_permissions_v2. Permission : Team member management.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetAvailableTeamMemberRoles
 * @returns {Promise.<DropboxResponse<TeamMembersGetAvailableTeamMemberRolesResult>, DropboxResponseError.<void>>}
 */


routes.teamMembersGetAvailableTeamMemberRoles = function () {
  return this.request('team/members/get_available_team_member_roles', null, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Returns information about multiple team members. Permission : Team
 * information This endpoint will return MembersGetInfoItem.id_not_found, for
 * IDs (or emails) that cannot be matched to a valid team member.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetInfoV2
 * @arg {TeamMembersGetInfoV2Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersGetInfoV2Result>, DropboxResponseError.<TeamMembersGetInfoError>>}
 */


routes.teamMembersGetInfoV2 = function (arg) {
  return this.request('team/members/get_info_v2', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Returns information about multiple team members. Permission : Team
 * information This endpoint will return MembersGetInfoItem.id_not_found, for
 * IDs (or emails) that cannot be matched to a valid team member.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersGetInfo
 * @arg {TeamMembersGetInfoArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<TeamMembersGetInfoError>>}
 */


routes.teamMembersGetInfo = function (arg) {
  return this.request('team/members/get_info', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Lists members of a team. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListV2
 * @arg {TeamMembersListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersListV2Result>, DropboxResponseError.<TeamMembersListError>>}
 */


routes.teamMembersListV2 = function (arg) {
  return this.request('team/members/list_v2', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Lists members of a team. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersList
 * @arg {TeamMembersListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersListResult>, DropboxResponseError.<TeamMembersListError>>}
 */


routes.teamMembersList = function (arg) {
  return this.request('team/members/list', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Once a cursor has been retrieved from members/list_v2, use this to paginate
 * through all team members. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListContinueV2
 * @arg {TeamMembersListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersListV2Result>, DropboxResponseError.<TeamMembersListContinueError>>}
 */


routes.teamMembersListContinueV2 = function (arg) {
  return this.request('team/members/list/continue_v2', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Once a cursor has been retrieved from members/list, use this to paginate
 * through all team members. Permission : Team information.
 * Route attributes:
 *   scope: members.read
 * @function Dropbox#teamMembersListContinue
 * @arg {TeamMembersListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersListResult>, DropboxResponseError.<TeamMembersListContinueError>>}
 */


routes.teamMembersListContinue = function (arg) {
  return this.request('team/members/list/continue', arg, 'team', 'api', 'rpc', 'members.read');
};
/**
 * Moves removed member's files to a different member. This endpoint initiates
 * an asynchronous job. To obtain the final result of the job, the client should
 * periodically poll members/move_former_member_files/job_status/check.
 * Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersMoveFormerMemberFiles
 * @arg {TeamMembersDataTransferArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamMembersTransferFormerMembersFilesError>>}
 */


routes.teamMembersMoveFormerMemberFiles = function (arg) {
  return this.request('team/members/move_former_member_files', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Once an async_job_id is returned from members/move_former_member_files , use
 * this to poll the status of the asynchronous request. Permission : Team member
 * management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersMoveFormerMemberFilesJobStatusCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<AsyncPollError>>}
 */


routes.teamMembersMoveFormerMemberFilesJobStatusCheck = function (arg) {
  return this.request('team/members/move_former_member_files/job_status/check', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Recover a deleted member. Permission : Team member management Exactly one of
 * team_member_id, email, or external_id must be provided to identify the user
 * account.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRecover
 * @arg {TeamMembersRecoverArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersRecoverError>>}
 */


routes.teamMembersRecover = function (arg) {
  return this.request('team/members/recover', arg, 'team', 'api', 'rpc', 'members.delete');
};
/**
 * Removes a member from a team. Permission : Team member management Exactly one
 * of team_member_id, email, or external_id must be provided to identify the
 * user account. Accounts can be recovered via members/recover for a 7 day
 * period or until the account has been permanently deleted or transferred to
 * another account (whichever comes first). Calling members/add while a user is
 * still recoverable on your team will return with
 * MemberAddResult.user_already_on_team. Accounts can have their files
 * transferred via the admin console for a limited time, based on the version
 * history length associated with the team (180 days for most teams). This
 * endpoint may initiate an asynchronous job. To obtain the final result of the
 * job, the client should periodically poll members/remove/job_status/get.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRemove
 * @arg {TeamMembersRemoveArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncLaunchEmptyResult>, DropboxResponseError.<TeamMembersRemoveError>>}
 */


routes.teamMembersRemove = function (arg) {
  return this.request('team/members/remove', arg, 'team', 'api', 'rpc', 'members.delete');
};
/**
 * Once an async_job_id is returned from members/remove , use this to poll the
 * status of the asynchronous request. Permission : Team member management.
 * Route attributes:
 *   scope: members.delete
 * @function Dropbox#teamMembersRemoveJobStatusGet
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<AsyncPollEmptyResult>, DropboxResponseError.<AsyncPollError>>}
 */


routes.teamMembersRemoveJobStatusGet = function (arg) {
  return this.request('team/members/remove/job_status/get', arg, 'team', 'api', 'rpc', 'members.delete');
};
/**
 * Add secondary emails to users. Permission : Team member management. Emails
 * that are on verified domains will be verified automatically. For each email
 * address not on a verified domain a verification email will be sent.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsAdd
 * @arg {TeamAddSecondaryEmailsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamAddSecondaryEmailsResult>, DropboxResponseError.<TeamAddSecondaryEmailsError>>}
 */


routes.teamMembersSecondaryEmailsAdd = function (arg) {
  return this.request('team/members/secondary_emails/add', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Delete secondary emails from users Permission : Team member management. Users
 * will be notified of deletions of verified secondary emails at both the
 * secondary email and their primary email.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsDelete
 * @arg {TeamDeleteSecondaryEmailsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamDeleteSecondaryEmailsResult>, DropboxResponseError.<void>>}
 */


routes.teamMembersSecondaryEmailsDelete = function (arg) {
  return this.request('team/members/secondary_emails/delete', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Resend secondary email verification emails. Permission : Team member
 * management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSecondaryEmailsResendVerificationEmails
 * @arg {TeamResendVerificationEmailArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamResendVerificationEmailResult>, DropboxResponseError.<void>>}
 */


routes.teamMembersSecondaryEmailsResendVerificationEmails = function (arg) {
  return this.request('team/members/secondary_emails/resend_verification_emails', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Sends welcome email to pending team member. Permission : Team member
 * management Exactly one of team_member_id, email, or external_id must be
 * provided to identify the user account. No-op if team member is not pending.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSendWelcomeEmail
 * @arg {TeamUserSelectorArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersSendWelcomeError>>}
 */


routes.teamMembersSendWelcomeEmail = function (arg) {
  return this.request('team/members/send_welcome_email', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's permissions. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetAdminPermissionsV2
 * @arg {TeamMembersSetPermissions2Arg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersSetPermissions2Result>, DropboxResponseError.<TeamMembersSetPermissions2Error>>}
 */


routes.teamMembersSetAdminPermissionsV2 = function (arg) {
  return this.request('team/members/set_admin_permissions_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's permissions. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetAdminPermissions
 * @arg {TeamMembersSetPermissionsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamMembersSetPermissionsResult>, DropboxResponseError.<TeamMembersSetPermissionsError>>}
 */


routes.teamMembersSetAdminPermissions = function (arg) {
  return this.request('team/members/set_admin_permissions', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's profile. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfileV2
 * @arg {TeamMembersSetProfileArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersSetProfileError>>}
 */


routes.teamMembersSetProfileV2 = function (arg) {
  return this.request('team/members/set_profile_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's profile. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfile
 * @arg {TeamMembersSetProfileArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersSetProfileError>>}
 */


routes.teamMembersSetProfile = function (arg) {
  return this.request('team/members/set_profile', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfilePhotoV2
 * @arg {TeamMembersSetProfilePhotoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfoV2Result>, DropboxResponseError.<TeamMembersSetProfilePhotoError>>}
 */


routes.teamMembersSetProfilePhotoV2 = function (arg) {
  return this.request('team/members/set_profile_photo_v2', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Updates a team member's profile photo. Permission : Team member management.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSetProfilePhoto
 * @arg {TeamMembersSetProfilePhotoArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamMemberInfo>, DropboxResponseError.<TeamMembersSetProfilePhotoError>>}
 */


routes.teamMembersSetProfilePhoto = function (arg) {
  return this.request('team/members/set_profile_photo', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Suspend a member from a team. Permission : Team member management Exactly one
 * of team_member_id, email, or external_id must be provided to identify the
 * user account.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersSuspend
 * @arg {TeamMembersDeactivateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersSuspendError>>}
 */


routes.teamMembersSuspend = function (arg) {
  return this.request('team/members/suspend', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Unsuspend a member from a team. Permission : Team member management Exactly
 * one of team_member_id, email, or external_id must be provided to identify the
 * user account.
 * Route attributes:
 *   scope: members.write
 * @function Dropbox#teamMembersUnsuspend
 * @arg {TeamMembersUnsuspendArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamMembersUnsuspendError>>}
 */


routes.teamMembersUnsuspend = function (arg) {
  return this.request('team/members/unsuspend', arg, 'team', 'api', 'rpc', 'members.write');
};
/**
 * Returns a list of all team-accessible namespaces. This list includes team
 * folders, shared folders containing team members, team members' home
 * namespaces, and team members' app folders. Home namespaces and app folders
 * are always owned by this team or members of the team, but shared folders may
 * be owned by other users or other teams. Duplicates may occur in the list.
 * Route attributes:
 *   scope: team_data.member
 * @function Dropbox#teamNamespacesList
 * @arg {TeamTeamNamespacesListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamNamespacesListResult>, DropboxResponseError.<TeamTeamNamespacesListError>>}
 */


routes.teamNamespacesList = function (arg) {
  return this.request('team/namespaces/list', arg, 'team', 'api', 'rpc', 'team_data.member');
};
/**
 * Once a cursor has been retrieved from namespaces/list, use this to paginate
 * through all team-accessible namespaces. Duplicates may occur in the list.
 * Route attributes:
 *   scope: team_data.member
 * @function Dropbox#teamNamespacesListContinue
 * @arg {TeamTeamNamespacesListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamNamespacesListResult>, DropboxResponseError.<TeamTeamNamespacesListContinueError>>}
 */


routes.teamNamespacesListContinue = function (arg) {
  return this.request('team/namespaces/list/continue', arg, 'team', 'api', 'rpc', 'team_data.member');
};
/**
 * Permission : Team member file access.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateAdd
 * @deprecated
 * @arg {FilePropertiesAddTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesAddTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.teamPropertiesTemplateAdd = function (arg) {
  return this.request('team/properties/template/add', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Permission : Team member file access. The scope for the route is
 * files.team_metadata.write.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateGet
 * @deprecated
 * @arg {FilePropertiesGetTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesGetTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.teamPropertiesTemplateGet = function (arg) {
  return this.request('team/properties/template/get', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Permission : Team member file access. The scope for the route is
 * files.team_metadata.write.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateList
 * @deprecated
 * @returns {Promise.<DropboxResponse<FilePropertiesListTemplateResult>, DropboxResponseError.<FilePropertiesTemplateError>>}
 */


routes.teamPropertiesTemplateList = function () {
  return this.request('team/properties/template/list', null, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Permission : Team member file access.
 * Route attributes:
 *   scope: files.team_metadata.write
 * @function Dropbox#teamPropertiesTemplateUpdate
 * @deprecated
 * @arg {FilePropertiesUpdateTemplateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<FilePropertiesUpdateTemplateResult>, DropboxResponseError.<FilePropertiesModifyTemplateError>>}
 */


routes.teamPropertiesTemplateUpdate = function (arg) {
  return this.request('team/properties/template/update', arg, 'team', 'api', 'rpc', 'files.team_metadata.write');
};
/**
 * Retrieves reporting data about a team's user activity. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetActivity
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGetActivityReport>, DropboxResponseError.<TeamDateRangeError>>}
 */


routes.teamReportsGetActivity = function (arg) {
  return this.request('team/reports/get_activity', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Retrieves reporting data about a team's linked devices. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetDevices
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGetDevicesReport>, DropboxResponseError.<TeamDateRangeError>>}
 */


routes.teamReportsGetDevices = function (arg) {
  return this.request('team/reports/get_devices', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Retrieves reporting data about a team's membership. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetMembership
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGetMembershipReport>, DropboxResponseError.<TeamDateRangeError>>}
 */


routes.teamReportsGetMembership = function (arg) {
  return this.request('team/reports/get_membership', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Retrieves reporting data about a team's storage usage. Deprecated: Will be
 * removed on July 1st 2021.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamReportsGetStorage
 * @deprecated
 * @arg {TeamDateRange} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamGetStorageReport>, DropboxResponseError.<TeamDateRangeError>>}
 */


routes.teamReportsGetStorage = function (arg) {
  return this.request('team/reports/get_storage', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Endpoint adds Approve List entries. Changes are effective immediately.
 * Changes are committed in transaction. In case of single validation error -
 * all entries are rejected. Valid domains (RFC-1034/5) and emails
 * (RFC-5322/822) are accepted. Added entries cannot overflow limit of 10000
 * entries per team. Maximum 100 entries per call is allowed.
 * Route attributes:
 *   scope: team_info.write
 * @function Dropbox#teamSharingAllowlistAdd
 * @arg {TeamSharingAllowlistAddArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistAddResponse>, DropboxResponseError.<TeamSharingAllowlistAddError>>}
 */


routes.teamSharingAllowlistAdd = function (arg) {
  return this.request('team/sharing_allowlist/add', arg, 'team', 'api', 'rpc', 'team_info.write');
};
/**
 * Lists Approve List entries for given team, from newest to oldest, returning
 * up to `limit` entries at a time. If there are more than `limit` entries
 * associated with the current team, more can be fetched by passing the returned
 * `cursor` to sharing_allowlist/list/continue.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamSharingAllowlistList
 * @arg {TeamSharingAllowlistListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistListResponse>, DropboxResponseError.<TeamSharingAllowlistListError>>}
 */


routes.teamSharingAllowlistList = function (arg) {
  return this.request('team/sharing_allowlist/list', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Lists entries associated with given team, starting from a the cursor. See
 * sharing_allowlist/list.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamSharingAllowlistListContinue
 * @arg {TeamSharingAllowlistListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistListResponse>, DropboxResponseError.<TeamSharingAllowlistListContinueError>>}
 */


routes.teamSharingAllowlistListContinue = function (arg) {
  return this.request('team/sharing_allowlist/list/continue', arg, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Endpoint removes Approve List entries. Changes are effective immediately.
 * Changes are committed in transaction. In case of single validation error -
 * all entries are rejected. Valid domains (RFC-1034/5) and emails
 * (RFC-5322/822) are accepted. Entries being removed have to be present on the
 * list. Maximum 1000 entries per call is allowed.
 * Route attributes:
 *   scope: team_info.write
 * @function Dropbox#teamSharingAllowlistRemove
 * @arg {TeamSharingAllowlistRemoveArgs} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamSharingAllowlistRemoveResponse>, DropboxResponseError.<TeamSharingAllowlistRemoveError>>}
 */


routes.teamSharingAllowlistRemove = function (arg) {
  return this.request('team/sharing_allowlist/remove', arg, 'team', 'api', 'rpc', 'team_info.write');
};
/**
 * Sets an archived team folder's status to active. Permission : Team member
 * file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderActivate
 * @arg {TeamTeamFolderIdArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderActivateError>>}
 */


routes.teamTeamFolderActivate = function (arg) {
  return this.request('team/team_folder/activate', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Sets an active team folder's status to archived and removes all folder and
 * file members. This endpoint cannot be used for teams that have a shared team
 * space. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderArchive
 * @arg {TeamTeamFolderArchiveArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderArchiveLaunch>, DropboxResponseError.<TeamTeamFolderArchiveError>>}
 */


routes.teamTeamFolderArchive = function (arg) {
  return this.request('team/team_folder/archive', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Returns the status of an asynchronous job for archiving a team folder.
 * Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderArchiveCheck
 * @arg {AsyncPollArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderArchiveJobStatus>, DropboxResponseError.<AsyncPollError>>}
 */


routes.teamTeamFolderArchiveCheck = function (arg) {
  return this.request('team/team_folder/archive/check', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Creates a new, active, team folder with no members. This endpoint can only be
 * used for teams that do not already have a shared team space. Permission :
 * Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderCreate
 * @arg {TeamTeamFolderCreateArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderCreateError>>}
 */


routes.teamTeamFolderCreate = function (arg) {
  return this.request('team/team_folder/create', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Retrieves metadata for team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderGetInfo
 * @arg {TeamTeamFolderIdListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Array.<TeamTeamFolderGetInfoItem>>, DropboxResponseError.<void>>}
 */


routes.teamTeamFolderGetInfo = function (arg) {
  return this.request('team/team_folder/get_info', arg, 'team', 'api', 'rpc', 'team_data.content.read');
};
/**
 * Lists all team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderList
 * @arg {TeamTeamFolderListArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderListResult>, DropboxResponseError.<TeamTeamFolderListError>>}
 */


routes.teamTeamFolderList = function (arg) {
  return this.request('team/team_folder/list', arg, 'team', 'api', 'rpc', 'team_data.content.read');
};
/**
 * Once a cursor has been retrieved from team_folder/list, use this to paginate
 * through all team folders. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.read
 * @function Dropbox#teamTeamFolderListContinue
 * @arg {TeamTeamFolderListContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderListResult>, DropboxResponseError.<TeamTeamFolderListContinueError>>}
 */


routes.teamTeamFolderListContinue = function (arg) {
  return this.request('team/team_folder/list/continue', arg, 'team', 'api', 'rpc', 'team_data.content.read');
};
/**
 * Permanently deletes an archived team folder. This endpoint cannot be used for
 * teams that have a shared team space. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderPermanentlyDelete
 * @arg {TeamTeamFolderIdArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<void>, DropboxResponseError.<TeamTeamFolderPermanentlyDeleteError>>}
 */


routes.teamTeamFolderPermanentlyDelete = function (arg) {
  return this.request('team/team_folder/permanently_delete', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Changes an active team folder's name. Permission : Team member file access.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderRename
 * @arg {TeamTeamFolderRenameArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderRenameError>>}
 */


routes.teamTeamFolderRename = function (arg) {
  return this.request('team/team_folder/rename', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Updates the sync settings on a team folder or its contents.  Use of this
 * endpoint requires that the team has team selective sync enabled.
 * Route attributes:
 *   scope: team_data.content.write
 * @function Dropbox#teamTeamFolderUpdateSyncSettings
 * @arg {TeamTeamFolderUpdateSyncSettingsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamTeamFolderMetadata>, DropboxResponseError.<TeamTeamFolderUpdateSyncSettingsError>>}
 */


routes.teamTeamFolderUpdateSyncSettings = function (arg) {
  return this.request('team/team_folder/update_sync_settings', arg, 'team', 'api', 'rpc', 'team_data.content.write');
};
/**
 * Returns the member profile of the admin who generated the team access token
 * used to make the call.
 * Route attributes:
 *   scope: team_info.read
 * @function Dropbox#teamTokenGetAuthenticatedAdmin
 * @returns {Promise.<DropboxResponse<TeamTokenGetAuthenticatedAdminResult>, DropboxResponseError.<TeamTokenGetAuthenticatedAdminError>>}
 */


routes.teamTokenGetAuthenticatedAdmin = function () {
  return this.request('team/token/get_authenticated_admin', null, 'team', 'api', 'rpc', 'team_info.read');
};
/**
 * Retrieves team events. If the result's GetTeamEventsResult.has_more field is
 * true, call get_events/continue with the returned cursor to retrieve more
 * entries. If end_time is not specified in your request, you may use the
 * returned cursor to poll get_events/continue for new events. Many attributes
 * note 'may be missing due to historical data gap'. Note that the
 * file_operations category and & analogous paper events are not available on
 * all Dropbox Business plans /business/plans-comparison. Use
 * features/get_values
 * /developers/documentation/http/teams#team-features-get_values to check for
 * this feature. Permission : Team Auditing.
 * Route attributes:
 *   scope: events.read
 * @function Dropbox#teamLogGetEvents
 * @arg {TeamLogGetTeamEventsArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamLogGetTeamEventsResult>, DropboxResponseError.<TeamLogGetTeamEventsError>>}
 */


routes.teamLogGetEvents = function (arg) {
  return this.request('team_log/get_events', arg, 'team', 'api', 'rpc', 'events.read');
};
/**
 * Once a cursor has been retrieved from get_events, use this to paginate
 * through all events. Permission : Team Auditing.
 * Route attributes:
 *   scope: events.read
 * @function Dropbox#teamLogGetEventsContinue
 * @arg {TeamLogGetTeamEventsContinueArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<TeamLogGetTeamEventsResult>, DropboxResponseError.<TeamLogGetTeamEventsContinueError>>}
 */


routes.teamLogGetEventsContinue = function (arg) {
  return this.request('team_log/get_events/continue', arg, 'team', 'api', 'rpc', 'events.read');
};
/**
 * Get a list of feature values that may be configured for the current account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersFeaturesGetValues
 * @arg {UsersUserFeaturesGetValuesBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<UsersUserFeaturesGetValuesBatchResult>, DropboxResponseError.<UsersUserFeaturesGetValuesBatchError>>}
 */


routes.usersFeaturesGetValues = function (arg) {
  return this.request('users/features/get_values', arg, 'user', 'api', 'rpc', 'account_info.read');
};
/**
 * Get information about a user's account.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#usersGetAccount
 * @arg {UsersGetAccountArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<UsersBasicAccount>, DropboxResponseError.<UsersGetAccountError>>}
 */


routes.usersGetAccount = function (arg) {
  return this.request('users/get_account', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Get information about multiple user accounts.  At most 300 accounts may be
 * queried per request.
 * Route attributes:
 *   scope: sharing.read
 * @function Dropbox#usersGetAccountBatch
 * @arg {UsersGetAccountBatchArg} arg - The request parameters.
 * @returns {Promise.<DropboxResponse<Object>, DropboxResponseError.<UsersGetAccountBatchError>>}
 */


routes.usersGetAccountBatch = function (arg) {
  return this.request('users/get_account_batch', arg, 'user', 'api', 'rpc', 'sharing.read');
};
/**
 * Get information about the current user's account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersGetCurrentAccount
 * @returns {Promise.<DropboxResponse<UsersFullAccount>, DropboxResponseError.<void>>}
 */


routes.usersGetCurrentAccount = function () {
  return this.request('users/get_current_account', null, 'user', 'api', 'rpc', 'account_info.read');
};
/**
 * Get the space usage information for the current user's account.
 * Route attributes:
 *   scope: account_info.read
 * @function Dropbox#usersGetSpaceUsage
 * @returns {Promise.<DropboxResponse<UsersSpaceUsage>, DropboxResponseError.<void>>}
 */


routes.usersGetSpaceUsage = function () {
  return this.request('users/get_space_usage', null, 'user', 'api', 'rpc', 'account_info.read');
};

function getSafeUnicode(c) {
  var unicode = "000".concat(c.charCodeAt(0).toString(16)).slice(-4);
  return "\\u".concat(unicode);
}

var baseApiUrl = function baseApiUrl(subdomain) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_API_DOMAIN;
  var domainDelimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';

  if (!domainDelimiter) {
    return "https://".concat(domain, "/2/");
  }

  if (domain !== DEFAULT_API_DOMAIN && TEST_DOMAIN_MAPPINGS[subdomain] !== undefined) {
    subdomain = TEST_DOMAIN_MAPPINGS[subdomain];
    domainDelimiter = '-';
  }

  return "https://".concat(subdomain).concat(domainDelimiter).concat(domain, "/2/");
};
var OAuth2AuthorizationUrl = function OAuth2AuthorizationUrl() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DOMAIN;

  if (domain !== DEFAULT_DOMAIN) {
    domain = "meta-".concat(domain);
  }

  return "https://".concat(domain, "/oauth2/authorize");
};
var OAuth2TokenUrl = function OAuth2TokenUrl() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_API_DOMAIN;
  var domainDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';
  var subdomain = 'api';

  if (domain !== DEFAULT_API_DOMAIN) {
    subdomain = TEST_DOMAIN_MAPPINGS[subdomain];
    domainDelimiter = '-';
  }

  return "https://".concat(subdomain).concat(domainDelimiter).concat(domain, "/oauth2/token");
}; // source https://www.dropboxforum.com/t5/API-support/HTTP-header-quot-Dropbox-API-Arg-quot-could-not-decode-input-as/m-p/173823/highlight/true#M6786

function httpHeaderSafeJson(args) {
  return JSON.stringify(args).replace(/[\u007f-\uffff]/g, getSafeUnicode);
}
function getTokenExpiresAtDate(expiresIn) {
  return new Date(Date.now() + expiresIn * 1000);
}
/* global WorkerGlobalScope */

function isWindowOrWorker() {
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope // eslint-disable-line no-restricted-globals
  || typeof module === 'undefined' || typeof window !== 'undefined';
}
function isBrowserEnv() {
  return typeof window !== 'undefined';
}
function isWorkerEnv() {
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope; // eslint-disable-line no-restricted-globals
}
function createBrowserSafeString(toBeConverted) {
  var convertedString = toBeConverted.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  return convertedString;
}

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper$1(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper$1 = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction$1(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct$1(Class, arguments, _getPrototypeOf$2(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf$3(Wrapper, Class); }; return _wrapNativeSuper$1(Class); }

function _construct$1(Parent, args, Class) { if (_isNativeReflectConstruct$2()) { _construct$1 = Reflect.construct; } else { _construct$1 = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf$3(instance, Class.prototype); return instance; }; } return _construct$1.apply(null, arguments); }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction$1(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

/**
 * The response class of HTTP errors from API calls using the Dropbox SDK.
 * @class DropboxResponseError
 * @classdesc The response class of HTTP errors from API calls using the Dropbox SDK.
 * @arg {number} status - HTTP Status code of the call
 * @arg {Object} headers - Headers returned from the call
 * @arg {Object} error - Serialized Error of the call
 */
var DropboxResponseError = /*#__PURE__*/function (_Error) {
  _inherits$2(DropboxResponseError, _Error);

  var _super = _createSuper$2(DropboxResponseError);

  function DropboxResponseError(status, headers, error) {
    var _this;

    _classCallCheck$d(this, DropboxResponseError);

    _this = _super.call(this, "Response failed with a ".concat(status, " code"));
    _this.name = 'DropboxResponseError';
    _this.status = status;
    _this.headers = headers;
    _this.error = error;
    return _this;
  }

  return DropboxResponseError;
}( /*#__PURE__*/_wrapNativeSuper$1(Error));

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var DropboxResponse = function DropboxResponse(status, headers, result) {
  _classCallCheck$c(this, DropboxResponse);

  this.status = status;
  this.headers = headers;
  this.result = result;
};

function throwAsError(res) {
  return res.text().then(function (data) {
    var errorObject;

    try {
      errorObject = JSON.parse(data);
    } catch (error) {
      errorObject = data;
    }

    throw new DropboxResponseError(res.status, res.headers, errorObject);
  });
}

function parseResponse(res) {
  if (!res.ok) {
    return throwAsError(res);
  }

  return res.text().then(function (data) {
    var responseObject;

    try {
      responseObject = JSON.parse(data);
    } catch (error) {
      responseObject = data;
    }

    return new DropboxResponse(res.status, res.headers, responseObject);
  });
}
function parseDownloadResponse(res) {
  if (!res.ok) {
    return throwAsError(res);
  }

  return new Promise(function (resolve) {
    if (isWindowOrWorker()) {
      res.blob().then(function (data) {
        return resolve(data);
      });
    } else {
      res.buffer().then(function (data) {
        return resolve(data);
      });
    }
  }).then(function (data) {
    var result = JSON.parse(res.headers.get('dropbox-api-result'));

    if (isWindowOrWorker()) {
      result.fileBlob = data;
    } else {
      result.fileBinary = data;
    }

    return new DropboxResponse(res.status, res.headers, result);
  });
}

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }
var fetch$1;
var crypto$1;
var Encoder; // Expiration is 300 seconds but needs to be in milliseconds for Date object

var TokenExpirationBuffer = 300 * 1000;
var PKCELength = 128;
var TokenAccessTypes = ['legacy', 'offline', 'online'];
var GrantTypes = ['code', 'token'];
var IncludeGrantedScopes = ['none', 'user', 'team'];
/**
 * @class DropboxAuth
 * @classdesc The DropboxAuth class that provides methods to manage, acquire, and refresh tokens.
 * @arg {Object} options
 * @arg {Function} [options.fetch] - fetch library for making requests.
 * @arg {String} [options.accessToken] - An access token for making authenticated
 * requests.
 * @arg {Date} [options.AccessTokenExpiresAt] - Date of the current access token's
 * expiration (if available)
 * @arg {String} [options.refreshToken] - A refresh token for retrieving access tokens
 * @arg {String} [options.clientId] - The client id for your app. Used to create
 * authentication URL.
 * @arg {String} [options.clientSecret] - The client secret for your app. Used to create
 * authentication URL and refresh access tokens.
 * @arg {String} [options.domain] - A custom domain to use when making api requests. This
 * should only be used for testing as scaffolding to avoid making network requests.
 * @arg {String} [options.domainDelimiter] - A custom delimiter to use when separating domain from
 * subdomain. This should only be used for testing as scaffolding.
 * @arg {Object} [options.customHeaders] - An object (in the form of header: value) designed to set
 * custom headers to use during a request.
 * @arg {Boolean} [options.dataOnBody] - Whether request data is sent on body or as URL params.
  * Defaults to false.
*/

var DropboxAuth = /*#__PURE__*/function () {
  function DropboxAuth(options) {
    _classCallCheck$b(this, DropboxAuth);

    options = options || {};

    if (isBrowserEnv()) {
      fetch$1 = window.fetch.bind(window);
      crypto$1 = window.crypto || window.msCrypto; // for IE11
    } else if (isWorkerEnv()) {
      /* eslint-disable no-restricted-globals */
      fetch$1 = self.fetch.bind(self);
      crypto$1 = self.crypto;
      /* eslint-enable no-restricted-globals */
    } else {
      fetch$1 = require('node-fetch'); // eslint-disable-line global-require

      crypto$1 = require('crypto'); // eslint-disable-line global-require
    }

    if (typeof TextEncoder === 'undefined') {
      Encoder = require('util').TextEncoder; // eslint-disable-line global-require
    } else {
      Encoder = TextEncoder;
    }

    this.fetch = options.fetch || fetch$1;
    this.accessToken = options.accessToken;
    this.accessTokenExpiresAt = options.accessTokenExpiresAt;
    this.refreshToken = options.refreshToken;
    this.clientId = options.clientId;
    this.clientSecret = options.clientSecret;
    this.domain = options.domain;
    this.domainDelimiter = options.domainDelimiter;
    this.customHeaders = options.customHeaders;
    this.dataOnBody = options.dataOnBody;
  }
  /**
     * Set the access token used to authenticate requests to the API.
     * @arg {String} accessToken - An access token
     * @returns {undefined}
     */


  _createClass$b(DropboxAuth, [{
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      this.accessToken = accessToken;
    }
    /**
       * Get the access token
       * @returns {String} Access token
       */

  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.accessToken;
    }
    /**
       * Set the client id, which is used to help gain an access token.
       * @arg {String} clientId - Your apps client id
       * @returns {undefined}
       */

  }, {
    key: "setClientId",
    value: function setClientId(clientId) {
      this.clientId = clientId;
    }
    /**
       * Get the client id
       * @returns {String} Client id
       */

  }, {
    key: "getClientId",
    value: function getClientId() {
      return this.clientId;
    }
    /**
       * Set the client secret
       * @arg {String} clientSecret - Your app's client secret
       * @returns {undefined}
       */

  }, {
    key: "setClientSecret",
    value: function setClientSecret(clientSecret) {
      this.clientSecret = clientSecret;
    }
    /**
       * Get the client secret
       * @returns {String} Client secret
       */

  }, {
    key: "getClientSecret",
    value: function getClientSecret() {
      return this.clientSecret;
    }
    /**
       * Gets the refresh token
       * @returns {String} Refresh token
       */

  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return this.refreshToken;
    }
    /**
       * Sets the refresh token
       * @param refreshToken - A refresh token
       */

  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(refreshToken) {
      this.refreshToken = refreshToken;
    }
    /**
       * Gets the access token's expiration date
       * @returns {Date} date of token expiration
       */

  }, {
    key: "getAccessTokenExpiresAt",
    value: function getAccessTokenExpiresAt() {
      return this.accessTokenExpiresAt;
    }
    /**
       * Sets the access token's expiration date
       * @param accessTokenExpiresAt - new expiration date
       */

  }, {
    key: "setAccessTokenExpiresAt",
    value: function setAccessTokenExpiresAt(accessTokenExpiresAt) {
      this.accessTokenExpiresAt = accessTokenExpiresAt;
    }
    /**
       * Sets the code verifier for PKCE flow
       * @param {String} codeVerifier - new code verifier
       */

  }, {
    key: "setCodeVerifier",
    value: function setCodeVerifier(codeVerifier) {
      this.codeVerifier = codeVerifier;
    }
    /**
       * Gets the code verifier for PKCE flow
       * @returns {String} - code verifier for PKCE
       */

  }, {
    key: "getCodeVerifier",
    value: function getCodeVerifier() {
      return this.codeVerifier;
    }
  }, {
    key: "generateCodeChallenge",
    value: function generateCodeChallenge() {
      var _this = this;

      var encoder = new Encoder();
      var codeData = encoder.encode(this.codeVerifier);
      var codeChallenge;

      if (isBrowserEnv() || isWorkerEnv()) {
        return crypto$1.subtle.digest('SHA-256', codeData).then(function (digestedHash) {
          var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(digestedHash)));
          codeChallenge = createBrowserSafeString(base64String).substr(0, 128);
          _this.codeChallenge = codeChallenge;
        });
      }

      var digestedHash = crypto$1.createHash('sha256').update(codeData).digest();
      codeChallenge = createBrowserSafeString(digestedHash);
      this.codeChallenge = codeChallenge;
      return Promise.resolve();
    }
  }, {
    key: "generatePKCECodes",
    value: function generatePKCECodes() {
      var codeVerifier;

      if (isBrowserEnv() || isWorkerEnv()) {
        var array = new Uint8Array(PKCELength);
        var randomValueArray = crypto$1.getRandomValues(array);
        var base64String = btoa(randomValueArray);
        codeVerifier = createBrowserSafeString(base64String).substr(0, 128);
      } else {
        var randomBytes = crypto$1.randomBytes(PKCELength);
        codeVerifier = createBrowserSafeString(randomBytes).substr(0, 128);
      }

      this.codeVerifier = codeVerifier;
      return this.generateCodeChallenge();
    }
    /**
       * Get a URL that can be used to authenticate users for the Dropbox API.
       * @arg {String} redirectUri - A URL to redirect the user to after
       * authenticating. This must be added to your app through the admin interface.
       * @arg {String} [state] - State that will be returned in the redirect URL to help
       * prevent cross site scripting attacks.
       * @arg {String} [authType] - auth type, defaults to 'token', other option is 'code'
       * @arg {String} [tokenAccessType] - type of token to request.  From the following:
       * null - creates a token with the app default (either legacy or online)
       * legacy - creates one long-lived token with no expiration
       * online - create one short-lived token with an expiration
       * offline - create one short-lived token with an expiration with a refresh token
       * @arg {Array<String>} [scope] - scopes to request for the grant
       * @arg {String} [includeGrantedScopes] - whether or not to include previously granted scopes.
       * From the following:
       * user - include user scopes in the grant
       * team - include team scopes in the grant
       * Note: if this user has never linked the app, include_granted_scopes must be None
       * @arg {boolean} [usePKCE] - Whether or not to use Sha256 based PKCE. PKCE should be only use
       * on client apps which doesn't call your server. It is less secure than non-PKCE flow but
       * can be used if you are unable to safely retrieve your app secret
       * @returns {Promise<String>} - Url to send user to for Dropbox API authentication
       * returned in a promise
       */

  }, {
    key: "getAuthenticationUrl",
    value: function getAuthenticationUrl(redirectUri, state) {
      var _this2 = this;

      var authType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'token';
      var tokenAccessType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var scope = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var includeGrantedScopes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'none';
      var usePKCE = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var clientId = this.getClientId();
      var baseUrl = OAuth2AuthorizationUrl(this.domain);

      if (!clientId) {
        throw new Error('A client id is required. You can set the client id using .setClientId().');
      }

      if (authType !== 'code' && !redirectUri) {
        throw new Error('A redirect uri is required.');
      }

      if (!GrantTypes.includes(authType)) {
        throw new Error('Authorization type must be code or token');
      }

      if (tokenAccessType && !TokenAccessTypes.includes(tokenAccessType)) {
        throw new Error('Token Access Type must be legacy, offline, or online');
      }

      if (scope && !(scope instanceof Array)) {
        throw new Error('Scope must be an array of strings');
      }

      if (!IncludeGrantedScopes.includes(includeGrantedScopes)) {
        throw new Error('includeGrantedScopes must be none, user, or team');
      }

      var authUrl;

      if (authType === 'code') {
        authUrl = "".concat(baseUrl, "?response_type=code&client_id=").concat(clientId);
      } else {
        authUrl = "".concat(baseUrl, "?response_type=token&client_id=").concat(clientId);
      }

      if (redirectUri) {
        authUrl += "&redirect_uri=".concat(redirectUri);
      }

      if (state) {
        authUrl += "&state=".concat(state);
      }

      if (tokenAccessType) {
        authUrl += "&token_access_type=".concat(tokenAccessType);
      }

      if (scope) {
        authUrl += "&scope=".concat(scope.join(' '));
      }

      if (includeGrantedScopes !== 'none') {
        authUrl += "&include_granted_scopes=".concat(includeGrantedScopes);
      }

      if (usePKCE) {
        return this.generatePKCECodes().then(function () {
          authUrl += '&code_challenge_method=S256';
          authUrl += "&code_challenge=".concat(_this2.codeChallenge);
          return authUrl;
        });
      }

      return Promise.resolve(authUrl);
    }
    /**
       * Get an OAuth2 access token from an OAuth2 Code.
       * @arg {String} redirectUri - A URL to redirect the user to after
       * authenticating. This must be added to your app through the admin interface.
       * @arg {String} code - An OAuth2 code.
       * @returns {Object} An object containing the token and related info (if applicable)
       */

  }, {
    key: "getAccessTokenFromCode",
    value: function getAccessTokenFromCode(redirectUri, code) {
      var clientId = this.getClientId();
      var clientSecret = this.getClientSecret();

      if (!clientId) {
        throw new Error('A client id is required. You can set the client id using .setClientId().');
      }

      var path = OAuth2TokenUrl(this.domain, this.domainDelimiter);
      path += '?grant_type=authorization_code';
      path += "&code=".concat(code);
      path += "&client_id=".concat(clientId);

      if (clientSecret) {
        path += "&client_secret=".concat(clientSecret);
      } else {
        if (!this.codeVerifier) {
          throw new Error('You must use PKCE when generating the authorization URL to not include a client secret');
        }

        path += "&code_verifier=".concat(this.codeVerifier);
      }

      if (redirectUri) {
        path += "&redirect_uri=".concat(redirectUri);
      }

      var fetchOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      return this.fetch(path, fetchOptions).then(function (res) {
        return parseResponse(res);
      });
    }
    /**
       * Checks if a token is needed, can be refreshed and if the token is expired.
       * If so, attempts to refresh access token
       * @returns {Promise<*>}
       */

  }, {
    key: "checkAndRefreshAccessToken",
    value: function checkAndRefreshAccessToken() {
      var canRefresh = this.getRefreshToken() && this.getClientId();
      var needsRefresh = !this.getAccessTokenExpiresAt() || new Date(Date.now() + TokenExpirationBuffer) >= this.getAccessTokenExpiresAt();
      var needsToken = !this.getAccessToken();

      if ((needsRefresh || needsToken) && canRefresh) {
        return this.refreshAccessToken();
      }

      return Promise.resolve();
    }
    /**
       * Refreshes the access token using the refresh token, if available
       * @arg {Array<String>} scope - a subset of scopes from the original
       * refresh to acquire with an access token
       * @returns {Promise<*>}
       */

  }, {
    key: "refreshAccessToken",
    value: function refreshAccessToken() {
      var _this3 = this;

      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var clientId = this.getClientId();
      var clientSecret = this.getClientSecret();

      if (!clientId) {
        throw new Error('A client id is required. You can set the client id using .setClientId().');
      }

      if (scope && !(scope instanceof Array)) {
        throw new Error('Scope must be an array of strings');
      }

      var refreshUrl = OAuth2TokenUrl(this.domain, this.domainDelimiter);
      var fetchOptions = {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      };

      if (this.dataOnBody) {
        var body = {
          grant_type: 'refresh_token',
          client_id: clientId,
          refresh_token: this.getRefreshToken()
        };

        if (clientSecret) {
          body.client_secret = clientSecret;
        }

        if (scope) {
          body.scope = scope.join(' ');
        }

        fetchOptions.body = body;
      } else {
        refreshUrl += "?grant_type=refresh_token&refresh_token=".concat(this.getRefreshToken());
        refreshUrl += "&client_id=".concat(clientId);

        if (clientSecret) {
          refreshUrl += "&client_secret=".concat(clientSecret);
        }

        if (scope) {
          refreshUrl += "&scope=".concat(scope.join(' '));
        }
      }

      return this.fetch(refreshUrl, fetchOptions).then(function (res) {
        return parseResponse(res);
      }).then(function (res) {
        _this3.setAccessToken(res.result.access_token);

        _this3.setAccessTokenExpiresAt(getTokenExpiresAtDate(res.result.expires_in));
      });
    }
  }]);

  return DropboxAuth;
}();

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }
var b64 = typeof btoa === 'undefined' ? function (str) {
  return Buffer.from(str).toString('base64');
} : btoa;
/**
 * @class Dropbox
 * @classdesc The Dropbox SDK class that provides methods to read, write and
 * create files or folders in a user or team's Dropbox.
 * @arg {Object} options
 * @arg {Function} [options.fetch] - fetch library for making requests.
 * @arg {String} [options.selectUser] - Select user is only used for team functionality.
 * It specifies which user the team access token should be acting as.
 * @arg {String} [options.pathRoot] - root path to access other namespaces
 * Use to access team folders for example
 * @arg {String} [options.selectAdmin] - Select admin is only used by team functionality.
 * It specifies which team admin the team access token should be acting as.
 * @arg {DropboxAuth} [options.auth] - The DropboxAuth object used to authenticate requests.
 * If this is set, the remaining parameters will be ignored.
 * @arg {String} [options.accessToken] - An access token for making authenticated
 * requests.
 * @arg {Date} [options.accessTokenExpiresAt] - Date of the current access token's
 * expiration (if available)
 * @arg {String} [options.refreshToken] - A refresh token for retrieving access tokens
 * @arg {String} [options.clientId] - The client id for your app. Used to create
 * authentication URL.
 * @arg {String} [options.clientSecret] - The client secret for your app. Used to create
 * authentication URL and refresh access tokens.
 * @arg {String} [options.domain] - A custom domain to use when making api requests. This
 * should only be used for testing as scaffolding to avoid making network requests.
 * @arg {String} [options.domainDelimiter] - A custom delimiter to use when separating domain from
 * subdomain. This should only be used for testing as scaffolding.
 * @arg {Object} [options.customHeaders] - An object (in the form of header: value) designed to set
 * custom headers to use during a request.
 */

var Dropbox = /*#__PURE__*/function () {
  function Dropbox(options) {
    _classCallCheck$a(this, Dropbox);

    options = options || {};

    if (options.auth) {
      this.auth = options.auth;
    } else {
      this.auth = new DropboxAuth(options);
    }

    this.fetch = options.fetch || this.auth.fetch;
    this.selectUser = options.selectUser;
    this.selectAdmin = options.selectAdmin;
    this.pathRoot = options.pathRoot;
    this.domain = options.domain || this.auth.domain;
    this.domainDelimiter = options.domainDelimiter || this.auth.domainDelimiter;
    this.customHeaders = options.customHeaders || this.auth.customHeaders;
    Object.assign(this, routes);
  }

  _createClass$a(Dropbox, [{
    key: "request",
    value: function request(path, args, auth, host, style) {
      // scope is provided after "style", but unused in requests, so it's not in parameters
      switch (style) {
        case RPC:
          return this.rpcRequest(path, args, auth, host);

        case DOWNLOAD:
          return this.downloadRequest(path, args, auth, host);

        case UPLOAD:
          return this.uploadRequest(path, args, auth, host);

        default:
          throw new Error("Invalid request style: ".concat(style));
      }
    }
  }, {
    key: "rpcRequest",
    value: function rpcRequest(path, body, auth, host) {
      var _this = this;

      return this.auth.checkAndRefreshAccessToken().then(function () {
        var fetchOptions = {
          method: 'POST',
          body: body ? JSON.stringify(body) : null,
          headers: {}
        };

        if (body) {
          fetchOptions.headers['Content-Type'] = 'application/json';
        }

        _this.setAuthHeaders(auth, fetchOptions);

        _this.setCommonHeaders(fetchOptions);

        return fetchOptions;
      }).then(function (fetchOptions) {
        return _this.fetch(baseApiUrl(host, _this.domain, _this.domainDelimiter) + path, fetchOptions);
      }).then(function (res) {
        return parseResponse(res);
      });
    }
  }, {
    key: "downloadRequest",
    value: function downloadRequest(path, args, auth, host) {
      var _this2 = this;

      return this.auth.checkAndRefreshAccessToken().then(function () {
        var fetchOptions = {
          method: 'POST',
          headers: {
            'Dropbox-API-Arg': httpHeaderSafeJson(args)
          }
        };

        _this2.setAuthHeaders(auth, fetchOptions);

        _this2.setCommonHeaders(fetchOptions);

        return fetchOptions;
      }).then(function (fetchOptions) {
        return _this2.fetch(baseApiUrl(host, _this2.domain, _this2.domainDelimiter) + path, fetchOptions);
      }).then(function (res) {
        return parseDownloadResponse(res);
      });
    }
  }, {
    key: "uploadRequest",
    value: function uploadRequest(path, args, auth, host) {
      var _this3 = this;

      return this.auth.checkAndRefreshAccessToken().then(function () {
        var contents = args.contents;
        delete args.contents;
        var fetchOptions = {
          body: contents,
          method: 'POST',
          headers: {
            'Content-Type': 'application/octet-stream',
            'Dropbox-API-Arg': httpHeaderSafeJson(args)
          }
        };

        _this3.setAuthHeaders(auth, fetchOptions);

        _this3.setCommonHeaders(fetchOptions);

        return fetchOptions;
      }).then(function (fetchOptions) {
        return _this3.fetch(baseApiUrl(host, _this3.domain, _this3.domainDelimiter) + path, fetchOptions);
      }).then(function (res) {
        return parseResponse(res);
      });
    }
  }, {
    key: "setAuthHeaders",
    value: function setAuthHeaders(auth, fetchOptions) {
      // checks for multiauth and assigns auth based on priority to create header in switch case
      if (auth.split(',').length > 1) {
        var authTypes = auth.replace(' ', '').split(',');

        if (authTypes.includes(USER_AUTH) && this.auth.getAccessToken()) {
          auth = USER_AUTH;
        } else if (authTypes.includes(TEAM_AUTH) && this.auth.getAccessToken()) {
          auth = TEAM_AUTH;
        } else if (authTypes.includes(APP_AUTH)) {
          auth = APP_AUTH;
        }
      }

      switch (auth) {
        case APP_AUTH:
          if (this.auth.clientId && this.auth.clientSecret) {
            var authHeader = b64("".concat(this.auth.clientId, ":").concat(this.auth.clientSecret));
            fetchOptions.headers.Authorization = "Basic ".concat(authHeader);
          }

          break;

        case TEAM_AUTH:
        case USER_AUTH:
          if (this.auth.getAccessToken()) {
            fetchOptions.headers.Authorization = "Bearer ".concat(this.auth.getAccessToken());
          }

          break;

        case NO_AUTH:
        case COOKIE:
          break;

        default:
          throw new Error("Unhandled auth type: ".concat(auth));
      }
    }
  }, {
    key: "setCommonHeaders",
    value: function setCommonHeaders(options) {
      var _this4 = this;

      if (this.selectUser) {
        options.headers['Dropbox-API-Select-User'] = this.selectUser;
      }

      if (this.selectAdmin) {
        options.headers['Dropbox-API-Select-Admin'] = this.selectAdmin;
      }

      if (this.pathRoot) {
        options.headers['Dropbox-API-Path-Root'] = this.pathRoot;
      }

      if (this.customHeaders) {
        var headerKeys = Object.keys(this.customHeaders);
        headerKeys.forEach(function (header) {
          options.headers[header] = _this4.customHeaders[header];
        });
      }
    }
  }]);

  return Dropbox;
}();

const dropboxAccessTokenName = "dropboxAccessToken";
const getDropboxAccessToken = () => {
  return localStorage.getItem(dropboxAccessTokenName);
};
const setDropboxAccessToken = (token) => {
  localStorage.setItem(dropboxAccessTokenName, token);
};

var __async$v = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const checkIfErrorIsAuthenticationError = (error) => {
  if (error instanceof Error && "status" in error && error.status === 401) {
    return true;
  }
  return false;
};
function useDropbox() {
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();
  const accessToken = getDropboxAccessToken();
  const dropbox = new Dropbox({ accessToken: accessToken != null ? accessToken : void 0 });
  const fetchDropboxAccessToken = useMutation$1({
    mutationFn: () => __async$v(this, null, function* () {
      try {
        const response = yield httpService$1.get("Dropbox/GetAccessToken");
        setDropboxAccessToken(response.access_Token);
        return response.access_Token;
      } catch (error2) {
        setError("Error fetching Dropbox access token");
        throw error2;
      }
    }),
    onSuccess: (newToken) => {
      queryClient.invalidateQueries(["dropboxTokenValidity"]);
      console.log("New access token fetched:", newToken);
    },
    onError: (error2) => {
      console.error("Error fetching Dropbox access token:", error2);
    }
  });
  useEffect(() => {
    if (isEmpty$2(accessToken)) {
      fetchDropboxAccessToken.mutateAsync();
    }
  }, []);
  const listFolderContentsQuery = (folderPath, enabled = true) => useQuery$1({
    queryKey: ["folderContents", folderPath],
    queryFn: () => __async$v(this, null, function* () {
      try {
        const response = yield dropbox.filesListFolder({ path: folderPath });
        return response.result.entries.filter((entry) => entry[".tag"] === "file");
      } catch (err) {
        if (checkIfErrorIsAuthenticationError(err)) {
          yield fetchDropboxAccessToken.mutateAsync();
          setError("AuthenticationError");
        } else {
          setError("Error retrieving folder contents");
        }
        console.error("Error retrieving folder contents:", err);
      }
    }),
    enabled: !!folderPath && !!accessToken && enabled,
    // Only run if folderPath is provided and there's an access token and enabled is true
    onError: (err) => {
      console.error("Error listing folder contents:", err);
    }
  });
  const createFolder = useMutation$1({
    mutationFn: (folderPath) => __async$v(this, null, function* () {
      try {
        const response = yield dropbox.filesCreateFolderV2({ path: folderPath });
        return response.result.metadata;
      } catch (error2) {
        setError("Error creating folder");
        throw error2;
      }
    }),
    onSuccess: (data) => {
      console.log("Folder created:", data);
    },
    onError: (error2) => {
      console.error("Error creating folder:", error2);
    }
  });
  const uploadFile = useMutation$1({
    mutationFn: (_0) => __async$v(this, [_0], function* ({ file, folderPath, fileName }) {
      const path = fileName ? `${folderPath}/${fileName}` : `${folderPath}/${file.name}`;
      try {
        const response = yield dropbox.filesUpload({
          path,
          contents: file
        });
        return response.result;
      } catch (error2) {
        setError("Error uploading file");
        throw error2;
      }
    }),
    onSuccess: (data) => {
      console.log("File uploaded successfully:", data);
    },
    onError: (error2) => {
      console.error("Error uploading file:", error2);
    }
  });
  const checkFolderExists = (folderPath) => __async$v(this, null, function* () {
    try {
      const folderMetadata = yield dropbox.filesGetMetadata({ path: folderPath });
      return folderMetadata;
    } catch (error2) {
      if (error2 instanceof Error && "status" in error2 && error2.status === 409) {
        return false;
      } else {
        setError("Error checking folder existence");
        console.error("Error checking folder existence:", error2);
      }
    }
  });
  const downloadFile = useMutation$1({
    mutationFn: (_0) => __async$v(this, [_0], function* ({ path, fileName }) {
      const fullFilePath = path + "/" + fileName;
      try {
        const response = yield dropbox.filesDownload({ path: fullFilePath });
        const fileBlob = response.result.fileBlob;
        const url = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error2) {
        setError("Error downloading file");
        throw error2;
      }
    }),
    onError: (error2) => {
      console.error("Error downloading file:", error2);
    }
  });
  const getTemporaryLink = useMutation$1({
    mutationFn: (fileId) => __async$v(this, null, function* () {
      try {
        const response = yield dropbox.filesGetTemporaryLink({ path: fileId });
        return response.result.link;
      } catch (error2) {
        if (checkIfErrorIsAuthenticationError(error2)) {
          yield fetchDropboxAccessToken.mutateAsync();
        }
        setError("Error fetching Dropbox temporary link");
        throw error2;
      }
    }),
    onError: (error2) => {
      console.error("Error fetching Dropbox link:", error2);
    }
  });
  return {
    fetchDropboxAccessToken,
    createFolder,
    uploadFile,
    listFolderContentsQuery,
    checkFolderExists,
    downloadFile,
    getTemporaryLink,
    error
    // Return error so that the component can use it
  };
}

var __defProp$1y = Object.defineProperty;
var __defProps$1f = Object.defineProperties;
var __getOwnPropDescs$1f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1z = Object.getOwnPropertySymbols;
var __hasOwnProp$1z = Object.prototype.hasOwnProperty;
var __propIsEnum$1z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1y = (obj, key, value) => key in obj ? __defProp$1y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1z.call(b, prop))
      __defNormalProp$1y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(b)) {
      if (__propIsEnum$1z.call(b, prop))
        __defNormalProp$1y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1f = (a, b) => __defProps$1f(a, __getOwnPropDescs$1f(b));
var __objRest$S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function DialogWrap(_a) {
  var _b = _a, { title, content, onCloseBtnClick, children } = _b, rest = __objRest$S(_b, ["title", "content", "onCloseBtnClick", "children"]);
  const theme = useTheme$2();
  const handleCloseBtnClick = (e) => {
    typeof onCloseBtnClick === "function" && onCloseBtnClick(e);
  };
  return /* @__PURE__ */ jsxs(Dialog, __spreadProps$1f(__spreadValues$1y({}, rest), { children: [
    /* @__PURE__ */ jsxs(
      DialogTitle$2,
      {
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: theme.palette.common.black
        },
        children: [
          /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: title }),
          onCloseBtnClick && /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: handleCloseBtnClick,
              sx: {
                padding: 0
              },
              edge: "end",
              color: "inherit",
              "aria-label": "close",
              children: /* @__PURE__ */ jsx(Close, { sx: { flexGrow: 1 } })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs(DialogContent$2, { children: [
      content && /* @__PURE__ */ jsx(DialogContentText$1, { children: content }),
      children
    ] })
  ] }));
}

var __defProp$1x = Object.defineProperty;
var __defProps$1e = Object.defineProperties;
var __getOwnPropDescs$1e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1y = Object.getOwnPropertySymbols;
var __hasOwnProp$1y = Object.prototype.hasOwnProperty;
var __propIsEnum$1y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1x = (obj, key, value) => key in obj ? __defProp$1x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1y.call(b, prop))
      __defNormalProp$1x(a, prop, b[prop]);
  if (__getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(b)) {
      if (__propIsEnum$1y.call(b, prop))
        __defNormalProp$1x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1e = (a, b) => __defProps$1e(a, __getOwnPropDescs$1e(b));
var __objRest$R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$u = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function ConfirmActionButton(_a) {
  var _b = _a, {
    modalTitle,
    modalContent,
    confirmBtnText = "Confirm",
    onConfirm = noop$6,
    onClick,
    children
  } = _b, rest = __objRest$R(_b, [
    "modalTitle",
    "modalContent",
    "confirmBtnText",
    "onConfirm",
    "onClick",
    "children"
  ]);
  const [isConfirmOpen, openConfirm, closeConfirm] = useToggle(false);
  const handleOnClick = () => __async$u(this, null, function* () {
    if (typeof onClick === "function") {
      const result = yield onClick();
      if (result === true) {
        openConfirm();
      }
    } else {
      openConfirm();
    }
  });
  const handleConfirmClick = () => {
    onConfirm();
    closeConfirm();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button$1, __spreadProps$1e(__spreadValues$1x({ onClick: handleOnClick }, rest), { children })),
    /* @__PURE__ */ jsx(DialogWrap, { open: isConfirmOpen, onClose: closeConfirm, title: modalTitle, content: modalContent, children: /* @__PURE__ */ jsxs(DialogActions$2, { children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: closeConfirm, autoFocus: true, children: "Cancel" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleConfirmClick, autoFocus: true, children: confirmBtnText })
    ] }) })
  ] });
}

function _objectWithoutPropertiesLoose$b(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$2.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$2.exports = requireReactIs_production_min$1();
	} else {
	  reactIs$2.exports = requireReactIs_development$1();
	}
	return reactIs$2.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

const _excluded$1C = ["localeText"];
const MuiPickersAdapterContext = /*#__PURE__*/React$1.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
}
const LocalizationProvider = function LocalizationProvider(inProps) {
  var _React$useContext;
  const {
      localeText: inLocaleText
    } = inProps,
    otherInProps = _objectWithoutPropertiesLoose$b(inProps, _excluded$1C);
  const {
    utils: parentUtils,
    localeText: parentLocaleText
  } = (_React$useContext = React$1.useContext(MuiPickersAdapterContext)) != null ? _React$useContext : {
    utils: undefined,
    localeText: undefined
  };
  const props = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: otherInProps,
    name: 'MuiLocalizationProvider'
  });
  const {
    children,
    dateAdapter: DateAdapter,
    dateFormats,
    dateLibInstance,
    adapterLocale,
    localeText: themeLocaleText
  } = props;
  const localeText = React$1.useMemo(() => _extends$c({}, themeLocaleText, parentLocaleText, inLocaleText), [themeLocaleText, parentLocaleText, inLocaleText]);
  const utils = React$1.useMemo(() => {
    if (!DateAdapter) {
      if (parentUtils) {
        return parentUtils;
      }
      return null;
    }
    const adapter = new DateAdapter({
      locale: adapterLocale,
      formats: dateFormats,
      instance: dateLibInstance
    });
    if (!adapter.isMUIAdapter) {
      throw new Error(['MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`', "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", 'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'].join(`\n`));
    }
    return adapter;
  }, [DateAdapter, adapterLocale, dateFormats, dateLibInstance, parentUtils]);
  const defaultDates = React$1.useMemo(() => {
    if (!utils) {
      return null;
    }
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = React$1.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/jsx(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
};
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: PropTypes.any,
  children: PropTypes.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: PropTypes.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    fullDate: PropTypes.string,
    fullDateTime: PropTypes.string,
    fullDateTime12h: PropTypes.string,
    fullDateTime24h: PropTypes.string,
    fullDateWithWeekday: PropTypes.string,
    fullTime: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    meridiem: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthAndDate: PropTypes.string,
    monthAndYear: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,
  /**
   * Locale for components texts
   */
  localeText: PropTypes.object
} : void 0;

const buildWarning$1 = (message, gravity = 'warning') => {
  let alreadyWarned = false;
  const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
  return () => {
    if (!alreadyWarned) {
      alreadyWarned = true;
      if (gravity === 'error') {
        console.error(cleanMessage);
      } else {
        console.warn(cleanMessage);
      }
    }
  };
};

dayjs.extend(customParseFormatPlugin);
dayjs.extend(localizedFormatPlugin);
dayjs.extend(isBetweenPlugin);
const localeNotFoundWarning = buildWarning$1(['Your locale has not been found.', 'Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale', "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", 'fallback on English locale']);
const formatTokenMap = {
  // Year
  YY: 'year',
  YYYY: {
    sectionType: 'year',
    contentType: 'digit',
    maxLength: 4
  },
  // Month
  M: {
    sectionType: 'month',
    contentType: 'digit',
    maxLength: 2
  },
  MM: 'month',
  MMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  MMMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  // Day of the month
  D: {
    sectionType: 'day',
    contentType: 'digit',
    maxLength: 2
  },
  DD: 'day',
  Do: {
    sectionType: 'day',
    contentType: 'digit-with-letter'
  },
  // Day of the week
  d: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 2
  },
  dd: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  ddd: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  dddd: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  // Meridiem
  A: 'meridiem',
  a: 'meridiem',
  // Hours
  H: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  HH: 'hours',
  h: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  hh: 'hours',
  // Minutes
  m: {
    sectionType: 'minutes',
    contentType: 'digit',
    maxLength: 2
  },
  mm: 'minutes',
  // Seconds
  s: {
    sectionType: 'seconds',
    contentType: 'digit',
    maxLength: 2
  },
  ss: 'seconds'
};
const defaultFormats = {
  year: 'YYYY',
  month: 'MMMM',
  monthShort: 'MMM',
  dayOfMonth: 'D',
  weekday: 'dddd',
  weekdayShort: 'ddd',
  hours24h: 'HH',
  hours12h: 'hh',
  meridiem: 'A',
  minutes: 'mm',
  seconds: 'ss',
  fullDate: 'll',
  fullDateWithWeekday: 'dddd, LL',
  keyboardDate: 'L',
  shortDate: 'MMM D',
  normalDate: 'D MMMM',
  normalDateWithWeekday: 'ddd, MMM D',
  monthAndYear: 'MMMM YYYY',
  monthAndDate: 'MMMM D',
  fullTime: 'LT',
  fullTime12h: 'hh:mm A',
  fullTime24h: 'HH:mm',
  fullDateTime: 'lll',
  fullDateTime12h: 'll hh:mm A',
  fullDateTime24h: 'll HH:mm',
  keyboardDateTime: 'L LT',
  keyboardDateTime12h: 'L hh:mm A',
  keyboardDateTime24h: 'L HH:mm'
};
const MISSING_UTC_PLUGIN = ['Missing UTC plugin', 'To be able to use UTC or timezones, you have to enable the `utc` plugin', 'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'].join('\n');
const MISSING_TIMEZONE_PLUGIN = ['Missing timezone plugin', 'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin', 'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'].join('\n');
const withLocale = (dayjs, locale) => !locale ? dayjs : (...args) => dayjs(...args).locale(locale);

/**
 * Based on `@date-io/dayjs`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
class AdapterDayjs {
  constructor({
    locale: _locale,
    formats,
    instance
  } = {}) {
    var _this$rawDayJsInstanc;
    this.isMUIAdapter = true;
    this.isTimezoneCompatible = true;
    this.lib = 'dayjs';
    this.rawDayJsInstance = void 0;
    this.dayjs = void 0;
    this.locale = void 0;
    this.formats = void 0;
    this.escapedCharacters = {
      start: '[',
      end: ']'
    };
    this.formatTokenMap = formatTokenMap;
    this.setLocaleToValue = value => {
      const expectedLocale = this.getCurrentLocaleCode();
      if (expectedLocale === value.locale()) {
        return value;
      }
      return value.locale(expectedLocale);
    };
    this.hasUTCPlugin = () => typeof dayjs.utc !== 'undefined';
    this.hasTimezonePlugin = () => typeof dayjs.tz !== 'undefined';
    this.isSame = (value, comparing, comparisonTemplate) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
    };
    /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */
    this.cleanTimezone = timezone => {
      switch (timezone) {
        case 'default':
          {
            return undefined;
          }
        case 'system':
          {
            return dayjs.tz.guess();
          }
        default:
          {
            return timezone;
          }
      }
    };
    this.createSystemDate = value => {
      // TODO v7: Stop using `this.rawDayJsInstance` (drop the `instance` param on the adapters)
      /* istanbul ignore next */
      if (this.rawDayJsInstance) {
        return this.rawDayJsInstance(value);
      }
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const timezone = dayjs.tz.guess();

        // We can't change the system timezone in the tests
        /* istanbul ignore next */
        if (timezone !== 'UTC') {
          return dayjs.tz(value, timezone);
        }
        return dayjs(value);
      }
      return dayjs(value);
    };
    this.createUTCDate = value => {
      /* istanbul ignore next */
      if (!this.hasUTCPlugin()) {
        throw new Error(MISSING_UTC_PLUGIN);
      }
      return dayjs.utc(value);
    };
    this.createTZDate = (value, timezone) => {
      /* istanbul ignore next */
      if (!this.hasUTCPlugin()) {
        throw new Error(MISSING_UTC_PLUGIN);
      }

      /* istanbul ignore next */
      if (!this.hasTimezonePlugin()) {
        throw new Error(MISSING_TIMEZONE_PLUGIN);
      }
      const keepLocalTime = value !== undefined && !value.endsWith('Z');
      return dayjs(value).tz(this.cleanTimezone(timezone), keepLocalTime);
    };
    this.getLocaleFormats = () => {
      const locales = dayjs.Ls;
      const locale = this.locale || 'en';
      let localeObject = locales[locale];
      if (localeObject === undefined) {
        localeNotFoundWarning();
        localeObject = locales.en;
      }
      return localeObject.formats;
    };
    /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */
    this.adjustOffset = value => {
      if (!this.hasTimezonePlugin()) {
        return value;
      }
      const timezone = this.getTimezone(value);
      if (timezone !== 'UTC') {
        var _fixedValue$$offset, _value$$offset;
        const fixedValue = value.tz(this.cleanTimezone(timezone), true);
        // @ts-ignore
        if (((_fixedValue$$offset = fixedValue.$offset) != null ? _fixedValue$$offset : 0) === ((_value$$offset = value.$offset) != null ? _value$$offset : 0)) {
          return value;
        }
        return fixedValue;
      }
      return value;
    };
    this.date = value => {
      if (value === null) {
        return null;
      }
      return this.dayjs(value);
    };
    this.dateWithTimezone = (value, timezone) => {
      if (value === null) {
        return null;
      }
      let parsedValue;
      if (timezone === 'UTC') {
        parsedValue = this.createUTCDate(value);
      } else if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) {
        parsedValue = this.createSystemDate(value);
      } else {
        parsedValue = this.createTZDate(value, timezone);
      }
      if (this.locale === undefined) {
        return parsedValue;
      }
      return parsedValue.locale(this.locale);
    };
    this.getTimezone = value => {
      if (this.hasUTCPlugin() && value.isUTC()) {
        return 'UTC';
      }
      if (this.hasTimezonePlugin()) {
        var _value$$x;
        // @ts-ignore
        const zone = (_value$$x = value.$x) == null ? void 0 : _value$$x.$timezone;
        return zone != null ? zone : 'system';
      }
      return 'system';
    };
    this.setTimezone = (value, timezone) => {
      if (this.getTimezone(value) === timezone) {
        return value;
      }
      if (timezone === 'UTC') {
        /* istanbul ignore next */
        if (!this.hasUTCPlugin()) {
          throw new Error(MISSING_UTC_PLUGIN);
        }
        return value.utc();
      }

      // We know that we have the UTC plugin.
      // Otherwise, the value timezone would always equal "system".
      // And it would be caught by the first "if" of this method.
      if (timezone === 'system') {
        return value.local();
      }
      if (!this.hasTimezonePlugin()) {
        if (timezone === 'default') {
          return value;
        }

        /* istanbul ignore next */
        throw new Error(MISSING_TIMEZONE_PLUGIN);
      }
      return dayjs.tz(value, this.cleanTimezone(timezone));
    };
    this.toJsDate = value => {
      return value.toDate();
    };
    this.parseISO = isoString => {
      return this.dayjs(isoString);
    };
    this.toISO = value => {
      return value.toISOString();
    };
    this.parse = (value, format) => {
      if (value === '') {
        return null;
      }
      return this.dayjs(value, format, this.locale, true);
    };
    this.getCurrentLocaleCode = () => {
      return this.locale || 'en';
    };
    this.is12HourCycleInCurrentLocale = () => {
      /* istanbul ignore next */
      return /A|a/.test(this.getLocaleFormats().LT || '');
    };
    this.expandFormat = format => {
      const localeFormats = this.getLocaleFormats();

      // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
      const t = formatBis => formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b) => a || b.slice(1));
      return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b) => {
        const B = b && b.toUpperCase();
        return a || localeFormats[b] || t(localeFormats[B]);
      });
    };
    this.getFormatHelperText = format => {
      return this.expandFormat(format).replace(/a/gi, '(a|p)m').toLocaleLowerCase();
    };
    this.isNull = value => {
      return value === null;
    };
    this.isValid = value => {
      return this.dayjs(value).isValid();
    };
    this.format = (value, formatKey) => {
      return this.formatByString(value, this.formats[formatKey]);
    };
    this.formatByString = (value, formatString) => {
      return this.dayjs(value).format(formatString);
    };
    this.formatNumber = numberToFormat => {
      return numberToFormat;
    };
    this.getDiff = (value, comparing, unit) => {
      return value.diff(comparing, unit);
    };
    this.isEqual = (value, comparing) => {
      if (value === null && comparing === null) {
        return true;
      }
      return this.dayjs(value).toDate().getTime() === this.dayjs(comparing).toDate().getTime();
    };
    this.isSameYear = (value, comparing) => {
      return this.isSame(value, comparing, 'YYYY');
    };
    this.isSameMonth = (value, comparing) => {
      return this.isSame(value, comparing, 'YYYY-MM');
    };
    this.isSameDay = (value, comparing) => {
      return this.isSame(value, comparing, 'YYYY-MM-DD');
    };
    this.isSameHour = (value, comparing) => {
      return value.isSame(comparing, 'hour');
    };
    this.isAfter = (value, comparing) => {
      return value > comparing;
    };
    this.isAfterYear = (value, comparing) => {
      if (!this.hasUTCPlugin()) {
        return value.isAfter(comparing, 'year');
      }
      return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
    };
    this.isAfterDay = (value, comparing) => {
      if (!this.hasUTCPlugin()) {
        return value.isAfter(comparing, 'day');
      }
      return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
    };
    this.isBefore = (value, comparing) => {
      return value < comparing;
    };
    this.isBeforeYear = (value, comparing) => {
      if (!this.hasUTCPlugin()) {
        return value.isBefore(comparing, 'year');
      }
      return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
    };
    this.isBeforeDay = (value, comparing) => {
      if (!this.hasUTCPlugin()) {
        return value.isBefore(comparing, 'day');
      }
      return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
    };
    this.isWithinRange = (value, [start, end]) => {
      return value >= start && value <= end;
    };
    this.startOfYear = value => {
      return this.adjustOffset(value.startOf('year'));
    };
    this.startOfMonth = value => {
      return this.adjustOffset(value.startOf('month'));
    };
    this.startOfWeek = value => {
      return this.adjustOffset(value.startOf('week'));
    };
    this.startOfDay = value => {
      return this.adjustOffset(value.startOf('day'));
    };
    this.endOfYear = value => {
      return this.adjustOffset(value.endOf('year'));
    };
    this.endOfMonth = value => {
      return this.adjustOffset(value.endOf('month'));
    };
    this.endOfWeek = value => {
      return this.adjustOffset(value.endOf('week'));
    };
    this.endOfDay = value => {
      return this.adjustOffset(value.endOf('day'));
    };
    this.addYears = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'year') : value.add(amount, 'year'));
    };
    this.addMonths = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'month') : value.add(amount, 'month'));
    };
    this.addWeeks = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'week') : value.add(amount, 'week'));
    };
    this.addDays = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'day') : value.add(amount, 'day'));
    };
    this.addHours = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'hour') : value.add(amount, 'hour'));
    };
    this.addMinutes = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'minute') : value.add(amount, 'minute'));
    };
    this.addSeconds = (value, amount) => {
      return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'second') : value.add(amount, 'second'));
    };
    this.getYear = value => {
      return value.year();
    };
    this.getMonth = value => {
      return value.month();
    };
    this.getDate = value => {
      return value.date();
    };
    this.getHours = value => {
      return value.hour();
    };
    this.getMinutes = value => {
      return value.minute();
    };
    this.getSeconds = value => {
      return value.second();
    };
    this.getMilliseconds = value => {
      return value.millisecond();
    };
    this.setYear = (value, year) => {
      return this.adjustOffset(value.set('year', year));
    };
    this.setMonth = (value, month) => {
      return this.adjustOffset(value.set('month', month));
    };
    this.setDate = (value, date) => {
      return this.adjustOffset(value.set('date', date));
    };
    this.setHours = (value, hours) => {
      return this.adjustOffset(value.set('hour', hours));
    };
    this.setMinutes = (value, minutes) => {
      return this.adjustOffset(value.set('minute', minutes));
    };
    this.setSeconds = (value, seconds) => {
      return this.adjustOffset(value.set('second', seconds));
    };
    this.setMilliseconds = (value, milliseconds) => {
      return this.adjustOffset(value.set('millisecond', milliseconds));
    };
    this.getDaysInMonth = value => {
      return value.daysInMonth();
    };
    this.getNextMonth = value => {
      return this.addMonths(value, 1);
    };
    this.getPreviousMonth = value => {
      return this.addMonths(value, -1);
    };
    this.getMonthArray = value => {
      const firstMonth = value.startOf('year');
      const monthArray = [firstMonth];
      while (monthArray.length < 12) {
        const prevMonth = monthArray[monthArray.length - 1];
        monthArray.push(this.addMonths(prevMonth, 1));
      }
      return monthArray;
    };
    this.mergeDateAndTime = (dateParam, timeParam) => {
      return dateParam.hour(timeParam.hour()).minute(timeParam.minute()).second(timeParam.second());
    };
    this.getWeekdays = () => {
      const start = this.dayjs().startOf('week');
      return [0, 1, 2, 3, 4, 5, 6].map(diff => this.formatByString(this.addDays(start, diff), 'dd'));
    };
    this.getWeekArray = value => {
      const cleanValue = this.setLocaleToValue(value);
      const start = cleanValue.startOf('month').startOf('week');
      const end = cleanValue.endOf('month').endOf('week');
      let count = 0;
      let current = start;
      const nestedWeeks = [];
      while (current < end) {
        const weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        nestedWeeks[weekNumber].push(current);
        current = this.addDays(current, 1);
        count += 1;
      }
      return nestedWeeks;
    };
    this.getWeekNumber = value => {
      return value.week();
    };
    this.getYearRange = (start, end) => {
      const startDate = start.startOf('year');
      const endDate = end.endOf('year');
      const years = [];
      let current = startDate;
      while (current < endDate) {
        years.push(current);
        current = this.addYears(current, 1);
      }
      return years;
    };
    this.getMeridiemText = ampm => {
      return ampm === 'am' ? 'AM' : 'PM';
    };
    this.rawDayJsInstance = instance;
    this.dayjs = withLocale((_this$rawDayJsInstanc = this.rawDayJsInstance) != null ? _this$rawDayJsInstanc : dayjs, _locale);
    this.locale = _locale;
    this.formats = _extends$c({}, defaultFormats, formats);
    dayjs.extend(weekOfYear);
  }
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}

function isPlainObject(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepClone$1(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone$1(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$c({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone$1(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}

var reactIsExports = reactIs$1.exports;

// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */
function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
  }
  return null;
}

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? React$1.useLayoutEffect : React$1.useEffect;

let globalId$1 = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React$1.useState(idOverride);
  const id = idOverride || defaultId;
  React$1.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId$1 += 1;
      setDefaultId(`mui-${globalId$1}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = React$1['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React$1.useRef(controlled !== undefined);
  const [valueState, setValue] = React$1.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React$1.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React$1.useRef(defaultProp);
    React$1.useEffect(() => {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React$1.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = React$1.useRef(fn);
  useEnhancedEffect(() => {
    ref.current = fn;
  });
  return React$1.useCallback((...args) =>
  // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}

function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React$1.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        setRef(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;

// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
const globalStateClassesMapping = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends$c({}, pickersTranslations)
        }
      }
    }
  };
};

// This object is not Partial<PickersLocaleText> because it is the default values

const enUSPickers = {
  // Calendar navigation
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  // View navigation
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: view => view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
  // DateRange placeholders
  start: 'Start',
  end: 'End',
  // Action bar
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  // Toolbar titles
  datePickerToolbarTitle: 'Select date',
  dateTimePickerToolbarTitle: 'Select date & time',
  timePickerToolbarTitle: 'Select time',
  dateRangePickerToolbarTitle: 'Select date range',
  // Clock labels
  clockLabelText: (view, time, adapter) => `Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
  hoursClockNumberText: hours => `${hours} hours`,
  minutesClockNumberText: minutes => `${minutes} minutes`,
  secondsClockNumberText: seconds => `${seconds} seconds`,
  // Digital clock labels
  selectViewText: view => `Select ${view}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: 'Week number',
  calendarWeekNumberHeaderText: '#',
  calendarWeekNumberAriaLabelText: weekNumber => `Week ${weekNumber}`,
  calendarWeekNumberText: weekNumber => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
  openTimePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
  // Table labels
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date',
  // Field section placeholders
  fieldYearPlaceholder: params => 'Y'.repeat(params.digitAmount),
  fieldMonthPlaceholder: params => params.contentType === 'letter' ? 'MMMM' : 'MM',
  fieldDayPlaceholder: () => 'DD',
  fieldWeekDayPlaceholder: params => params.contentType === 'letter' ? 'EEEE' : 'EE',
  fieldHoursPlaceholder: () => 'hh',
  fieldMinutesPlaceholder: () => 'mm',
  fieldSecondsPlaceholder: () => 'ss',
  fieldMeridiemPlaceholder: () => 'aa'
};
const DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);

const useLocalizationContext = () => {
  const localization = React$1.useContext(MuiPickersAdapterContext);
  if (localization === null) {
    throw new Error(['MUI: Can not find the date and time pickers localization context.', 'It looks like you forgot to wrap your component in LocalizationProvider.', 'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'].join('\n'));
  }
  if (localization.utils === null) {
    throw new Error(['MUI: Can not find the date and time pickers adapter from its localization context.', 'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'].join('\n'));
  }
  const localeText = React$1.useMemo(() => _extends$c({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return React$1.useMemo(() => _extends$c({}, localization, {
    localeText
  }), [localization, localeText]);
};
const useUtils = () => useLocalizationContext().utils;
const useDefaultDates = () => useLocalizationContext().defaultDates;
const useLocaleText = () => useLocalizationContext().localeText;
const useNow = timezone => {
  const utils = useUtils();
  const now = React$1.useRef();
  if (now.current === undefined) {
    now.current = utils.dateWithTimezone(undefined, timezone);
  }
  return now.current;
};

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$c({}, otherProps, {
    ownerState: _extends$c({}, otherProps.ownerState, ownerState)
  });
}

/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}

/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = clsx(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
    const mergedStyle = _extends$c({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = _extends$c({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }
    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }
    return {
      props,
      internalRef: undefined
    };
  }

  // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.

  const eventHandlers = extractEventHandlers(_extends$c({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);

  // The order of classes is important here.
  // Emotion (that we use in libraries consuming Base UI) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
  const joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends$c({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends$c({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}

const _excluded$1B = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
      elementType,
      externalSlotProps,
      ownerState,
      skipResolvingSlotProps = false
    } = parameters,
    rest = _objectWithoutPropertiesLoose$b(parameters, _excluded$1B);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends$c({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, _extends$c({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}

const ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

/**
 * @ignore - internal component.
 */
const ArrowLeftIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');

/**
 * @ignore - internal component.
 */
const ArrowRightIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');

/**
 * @ignore - internal component.
 */
const CalendarIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');

/**
 * @ignore - internal component.
 */
createSvgIcon( /*#__PURE__*/jsxs(React$1.Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');

/**
 * @ignore - internal component.
 */
createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');

/**
 * @ignore - internal component.
 */
createSvgIcon( /*#__PURE__*/jsxs(React$1.Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

function getPickersArrowSwitcherUtilityClass(slot) {
  return generateUtilityClass('MuiPickersArrowSwitcher', slot);
}
generateUtilityClasses('MuiPickersArrowSwitcher', ['root', 'spacer', 'button']);

const _excluded$1A = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"],
  _excluded2$g = ["ownerState"],
  _excluded3$7 = ["ownerState"];
const PickersArrowSwitcherRoot = styled$3('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex'
});
const PickersArrowSwitcherSpacer = styled$3('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Spacer',
  overridesResolver: (props, styles) => styles.spacer
})(({
  theme
}) => ({
  width: theme.spacing(3)
}));
const PickersArrowSwitcherButton = styled$3(IconButton$1, {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Button',
  overridesResolver: (props, styles) => styles.button
})(({
  ownerState
}) => _extends$c({}, ownerState.hidden && {
  visibility: 'hidden'
}));
const useUtilityClasses$Y = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    spacer: ['spacer'],
    button: ['button']
  };
  return composeClasses(slots, getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher = /*#__PURE__*/React$1.forwardRef(function PickersArrowSwitcher(inProps, ref) {
  var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
  const theme = useTheme$3();
  const isRTL = theme.direction === 'rtl';
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersArrowSwitcher'
  });
  const {
      children,
      className,
      slots,
      slotProps,
      isNextDisabled,
      isNextHidden,
      onGoToNext,
      nextLabel,
      isPreviousDisabled,
      isPreviousHidden,
      onGoToPrevious,
      previousLabel
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1A);
  const ownerState = props;
  const classes = useUtilityClasses$Y(ownerState);
  const nextProps = {
    isDisabled: isNextDisabled,
    isHidden: isNextHidden,
    goTo: onGoToNext,
    label: nextLabel
  };
  const previousProps = {
    isDisabled: isPreviousDisabled,
    isHidden: isPreviousHidden,
    goTo: onGoToPrevious,
    label: previousLabel
  };
  const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : PickersArrowSwitcherButton;
  const previousIconButtonProps = useSlotProps({
    elementType: PreviousIconButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
    additionalProps: {
      size: 'medium',
      title: previousProps.label,
      'aria-label': previousProps.label,
      disabled: previousProps.isDisabled,
      edge: 'end',
      onClick: previousProps.goTo
    },
    ownerState: _extends$c({}, ownerState, {
      hidden: previousProps.isHidden
    }),
    className: classes.button
  });
  const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : PickersArrowSwitcherButton;
  const nextIconButtonProps = useSlotProps({
    elementType: NextIconButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
    additionalProps: {
      size: 'medium',
      title: nextProps.label,
      'aria-label': nextProps.label,
      disabled: nextProps.isDisabled,
      edge: 'start',
      onClick: nextProps.goTo
    },
    ownerState: _extends$c({}, ownerState, {
      hidden: nextProps.isHidden
    }),
    className: classes.button
  });
  const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : ArrowLeftIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = useSlotProps({
      elementType: LeftArrowIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState: undefined
    }),
    leftArrowIconProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$g);
  const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : ArrowRightIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps2 = useSlotProps({
      elementType: RightArrowIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState: undefined
    }),
    rightArrowIconProps = _objectWithoutPropertiesLoose$b(_useSlotProps2, _excluded3$7);
  return /*#__PURE__*/jsxs(PickersArrowSwitcherRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(PreviousIconButton, _extends$c({}, previousIconButtonProps, {
      children: isRTL ? /*#__PURE__*/jsx(RightArrowIcon, _extends$c({}, rightArrowIconProps)) : /*#__PURE__*/jsx(LeftArrowIcon, _extends$c({}, leftArrowIconProps))
    })), children ? /*#__PURE__*/jsx(Typography, {
      variant: "subtitle1",
      component: "span",
      children: children
    }) : /*#__PURE__*/jsx(PickersArrowSwitcherSpacer, {
      className: classes.spacer,
      ownerState: ownerState
    }), /*#__PURE__*/jsx(NextIconButton, _extends$c({}, nextIconButtonProps, {
      children: isRTL ? /*#__PURE__*/jsx(LeftArrowIcon, _extends$c({}, leftArrowIconProps)) : /*#__PURE__*/jsx(RightArrowIcon, _extends$c({}, rightArrowIconProps))
    }))]
  }));
});

const areViewsEqual = (views, expectedViews) => {
  if (views.length !== expectedViews.length) {
    return false;
  }
  return expectedViews.every(expectedView => views.includes(expectedView));
};
const applyDefaultViewProps = ({
  openTo,
  defaultOpenTo,
  views,
  defaultViews
}) => {
  const viewsWithDefault = views != null ? views : defaultViews;
  let openToWithDefault;
  if (openTo != null) {
    openToWithDefault = openTo;
  } else if (viewsWithDefault.includes(defaultOpenTo)) {
    openToWithDefault = defaultOpenTo;
  } else if (viewsWithDefault.length > 0) {
    openToWithDefault = viewsWithDefault[0];
  } else {
    throw new Error('MUI: The `views` prop must contain at least one view');
  }
  return {
    views: viewsWithDefault,
    openTo: openToWithDefault
  };
};

const timeViews = ['hours', 'minutes', 'seconds'];
const isTimeView = view => timeViews.includes(view);
const getSecondsInDay = (date, utils) => {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return utils.isAfter(dateLeft, dateRight);
  }
  return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
};

let warnedOnceNotValidView = false;
function useViews({
  onChange,
  onViewChange,
  openTo,
  view: inView,
  views,
  autoFocus,
  focusedView: inFocusedView,
  onFocusedViewChange
}) {
  var _views, _views2;
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnceNotValidView) {
      if (inView != null && !views.includes(inView)) {
        console.warn(`MUI: \`view="${inView}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
      if (inView == null && openTo != null && !views.includes(openTo)) {
        console.warn(`MUI: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
    }
  }
  const previousOpenTo = React$1.useRef(openTo);
  const previousViews = React$1.useRef(views);
  const defaultView = React$1.useRef(views.includes(openTo) ? openTo : views[0]);
  const [view, setView] = useControlled({
    name: 'useViews',
    state: 'view',
    controlled: inView,
    default: defaultView.current
  });
  const defaultFocusedView = React$1.useRef(autoFocus ? view : null);
  const [focusedView, setFocusedView] = useControlled({
    name: 'useViews',
    state: 'focusedView',
    controlled: inFocusedView,
    default: defaultFocusedView.current
  });
  React$1.useEffect(() => {
    // Update the current view when `openTo` or `views` props change
    if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some(previousView => !views.includes(previousView))) {
      setView(views.includes(openTo) ? openTo : views[0]);
      previousViews.current = views;
      previousOpenTo.current = openTo;
    }
  }, [openTo, setView, view, views]);
  const viewIndex = views.indexOf(view);
  const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
  const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
  const handleFocusedViewChange = useEventCallback((viewToFocus, hasFocus) => {
    if (hasFocus) {
      // Focus event
      setFocusedView(viewToFocus);
    } else {
      // Blur event
      setFocusedView(prevFocusedView => viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
      );
    }

    onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
  });
  const handleChangeView = useEventCallback(newView => {
    if (newView === view) {
      return;
    }
    setView(newView);
    handleFocusedViewChange(newView, true);
    if (onViewChange) {
      onViewChange(newView);
    }
  });
  const goToNextView = useEventCallback(() => {
    if (nextView) {
      handleChangeView(nextView);
    }
    handleFocusedViewChange(nextView, true);
  });
  const setValueAndGoToNextView = useEventCallback((value, currentViewSelectionState, selectedView) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
    const hasMoreViews = selectedView ?
    // handles case like `DateTimePicker`, where a view might return a `finish` selection state
    // but we it's not the final view given all `views` -> overall selection state should be `partial`.
    views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
    const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
    onChange(value, globalSelectionState);
    if (isSelectionFinishedOnCurrentView) {
      goToNextView();
    }
  });
  const setValueAndGoToView = useEventCallback((value, newView, selectedView) => {
    onChange(value, newView ? 'partial' : 'finish', selectedView);
    if (newView) {
      handleChangeView(newView);
      handleFocusedViewChange(newView, true);
    }
  });
  return {
    view,
    setView: handleChangeView,
    focusedView,
    setFocusedView: handleFocusedViewChange,
    nextView,
    previousView,
    defaultView: defaultView.current,
    goToNextView,
    setValueAndGoToNextView,
    setValueAndGoToView
  };
}

function useNextMonthDisabled(month, {
  disableFuture,
  maxDate,
  timezone
}) {
  const utils = useUtils();
  return React$1.useMemo(() => {
    const now = utils.dateWithTimezone(undefined, timezone);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils, timezone]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate,
  timezone
}) {
  const utils = useUtils();
  return React$1.useMemo(() => {
    const now = utils.dateWithTimezone(undefined, timezone);
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils, timezone]);
}

const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const VIEW_HEIGHT = 358;

const PickerViewRoot = styled$3('div')({
  overflow: 'hidden',
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto'
});

const findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  isDateDisabled,
  utils,
  timezone
}) => {
  const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }
  let forward = date;
  let backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
const replaceInvalidDateByNull = (utils, value) => value == null || !utils.isValid(value) ? null : value;
const applyDefaultDate = (utils, value, defaultValue) => {
  if (value == null || !utils.isValid(value)) {
    return defaultValue;
  }
  return value;
};
const areDatesEqual = (utils, a, b) => {
  if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) {
    return true;
  }
  return utils.isEqual(a, b);
};
const getMonthsInYear = (utils, year) => {
  const firstMonth = utils.startOfYear(year);
  const months = [firstMonth];
  while (months.length < 12) {
    const prevMonth = months[months.length - 1];
    months.push(utils.addMonths(prevMonth, 1));
  }
  return months;
};
const mergeDateAndTime = (utils, dateParam, timeParam) => {
  let mergedDate = dateParam;
  mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
  mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
  mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
  return mergedDate;
};
const getTodayDate = (utils, timezone, valueType) => valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const dateViews = ['year', 'month', 'day'];
const isDatePickerView = view => dateViews.includes(view);
const resolveDateFormat = (utils, {
  format,
  views
}, isInToolbar) => {
  if (format != null) {
    return format;
  }
  const formats = utils.formats;
  if (areViewsEqual(views, ['year'])) {
    return formats.year;
  }
  if (areViewsEqual(views, ['month'])) {
    return formats.month;
  }
  if (areViewsEqual(views, ['day'])) {
    return formats.dayOfMonth;
  }
  if (areViewsEqual(views, ['month', 'year'])) {
    return `${formats.month} ${formats.year}`;
  }
  if (areViewsEqual(views, ['day', 'month'])) {
    return `${formats.month} ${formats.dayOfMonth}`;
  }
  if (isInToolbar) {
    // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
  }
  return formats.keyboardDate;
};

/**
 * Hooks making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */
const useValueWithTimezone = ({
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange,
  valueManager
}) => {
  var _ref, _ref2;
  const utils = useUtils();
  const firstDefaultValue = React$1.useRef(defaultValue);
  const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
  const inputTimezone = React$1.useMemo(() => valueManager.getTimezone(utils, inputValue), [utils, valueManager, inputValue]);
  const setInputTimezone = useEventCallback(newValue => {
    if (inputTimezone == null) {
      return newValue;
    }
    return valueManager.setTimezone(utils, inputTimezone, newValue);
  });
  const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
  const valueWithTimezoneToRender = React$1.useMemo(() => valueManager.setTimezone(utils, timezoneToRender, inputValue), [valueManager, utils, timezoneToRender, inputValue]);
  const handleValueChange = useEventCallback((newValue, ...otherParams) => {
    const newValueWithInputTimezone = setInputTimezone(newValue);
    onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
  });
  return {
    value: valueWithTimezoneToRender,
    handleValueChange,
    timezone: timezoneToRender
  };
};

/**
 * Wrapper around `useControlled` and `useValueWithTimezone`
 */
const useControlledValueWithTimezone = ({
  name,
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange: onChangeProp,
  valueManager
}) => {
  const [valueWithInputTimezone, setValue] = useControlled({
    name,
    state: 'value',
    controlled: valueProp,
    default: defaultValue != null ? defaultValue : valueManager.emptyValue
  });
  const onChange = useEventCallback((newValue, ...otherParams) => {
    setValue(newValue);
    onChangeProp == null || onChangeProp(newValue, ...otherParams);
  });
  return useValueWithTimezone({
    timezone: timezoneProp,
    value: valueWithInputTimezone,
    defaultValue: undefined,
    onChange,
    valueManager
  });
};

const SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
};
const getSectionTypeGranularity = sections => Math.max(...sections.map(section => {
  var _SECTION_TYPE_GRANULA;
  return (_SECTION_TYPE_GRANULA = SECTION_TYPE_GRANULARITY[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
}));
const roundDate = (utils, granularity, date) => {
  if (granularity === SECTION_TYPE_GRANULARITY.year) {
    return utils.startOfYear(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.month) {
    return utils.startOfMonth(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.day) {
    return utils.startOfDay(date);
  }

  // We don't have startOfHour / startOfMinute / startOfSecond
  let roundedDate = date;
  if (granularity < SECTION_TYPE_GRANULARITY.minutes) {
    roundedDate = utils.setMinutes(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.seconds) {
    roundedDate = utils.setSeconds(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) {
    roundedDate = utils.setMilliseconds(roundedDate, 0);
  }
  return roundedDate;
};
const getDefaultReferenceDate = ({
  props,
  utils,
  granularity,
  timezone,
  getTodayDate: inGetTodayDate
}) => {
  var _props$disableIgnorin;
  let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, getTodayDate(utils, timezone));
  if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.minDate);
  }
  if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.maxDate);
  }
  const isAfter = createIsAfterIgnoreDatePart((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
  if (props.minTime != null && isAfter(props.minTime, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : mergeDateAndTime(utils, referenceDate, props.minTime));
  }
  if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : mergeDateAndTime(utils, referenceDate, props.maxTime));
  }
  return referenceDate;
};

const getDateSectionConfigFromFormatToken = (utils, formatToken) => {
  const config = utils.formatTokenMap[formatToken];
  if (config == null) {
    throw new Error([`MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`, 'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'].join('\n'));
  }
  if (typeof config === 'string') {
    return {
      type: config,
      contentType: config === 'meridiem' ? 'letter' : 'digit',
      maxLength: undefined
    };
  }
  return {
    type: config.sectionType,
    contentType: config.contentType,
    maxLength: config.maxLength
  };
};
const getDeltaFromKeyCode = keyCode => {
  switch (keyCode) {
    case 'ArrowUp':
      return 1;
    case 'ArrowDown':
      return -1;
    case 'PageUp':
      return 5;
    case 'PageDown':
      return -5;
    default:
      return 0;
  }
};
const getDaysInWeekStr = (utils, timezone, format) => {
  const elements = [];
  const now = utils.dateWithTimezone(undefined, timezone);
  const startDate = utils.startOfWeek(now);
  const endDate = utils.endOfWeek(now);
  let current = startDate;
  while (utils.isBefore(current, endDate)) {
    elements.push(current);
    current = utils.addDays(current, 1);
  }
  return elements.map(weekDay => utils.formatByString(weekDay, format));
};
const getLetterEditingOptions = (utils, timezone, sectionType, format) => {
  switch (sectionType) {
    case 'month':
      {
        return getMonthsInYear(utils, utils.dateWithTimezone(undefined, timezone)).map(month => utils.formatByString(month, format));
      }
    case 'weekDay':
      {
        return getDaysInWeekStr(utils, timezone, format);
      }
    case 'meridiem':
      {
        const now = utils.dateWithTimezone(undefined, timezone);
        return [utils.startOfDay(now), utils.endOfDay(now)].map(date => utils.formatByString(date, format));
      }
    default:
      {
        return [];
      }
  }
};
const cleanLeadingZeros = (utils, valueStr, size) => {
  let cleanValueStr = valueStr;

  // Remove the leading zeros
  cleanValueStr = Number(cleanValueStr).toString();

  // Add enough leading zeros to fill the section
  while (cleanValueStr.length < size) {
    cleanValueStr = `0${cleanValueStr}`;
  }
  return cleanValueStr;
};
const cleanDigitSectionValue = (utils, timezone, value, sectionBoundaries, section) => {
  if (process.env.NODE_ENV !== 'production') {
    if (section.type !== 'day' && section.contentType === 'digit-with-letter') {
      throw new Error([`MUI: The token "${section.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join('\n'));
    }
  }
  if (section.type === 'day' && section.contentType === 'digit-with-letter') {
    const date = utils.setDate(sectionBoundaries.longestMonth, value);
    return utils.formatByString(date, section.format);
  }

  // queryValue without leading `0` (`01` => `1`)
  const valueStr = value.toString();
  if (section.hasLeadingZerosInInput) {
    return cleanLeadingZeros(utils, valueStr, section.maxLength);
  }
  return valueStr;
};
const adjustSectionValue = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes) => {
  const delta = getDeltaFromKeyCode(keyCode);
  const isStart = keyCode === 'Home';
  const isEnd = keyCode === 'End';
  const shouldSetAbsolute = section.value === '' || isStart || isEnd;
  const adjustDigitSection = () => {
    const sectionBoundaries = sectionsValueBoundaries[section.type]({
      currentDate: activeDate,
      format: section.format,
      contentType: section.contentType
    });
    const getCleanValue = value => cleanDigitSectionValue(utils, timezone, value, sectionBoundaries, section);
    const step = section.type === 'minutes' && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
    const currentSectionValue = parseInt(section.value, 10);
    let newSectionValueNumber = currentSectionValue + delta * step;
    if (shouldSetAbsolute) {
      if (section.type === 'year' && !isEnd && !isStart) {
        return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
      }
      if (delta > 0 || isStart) {
        newSectionValueNumber = sectionBoundaries.minimum;
      } else {
        newSectionValueNumber = sectionBoundaries.maximum;
      }
    }
    if (newSectionValueNumber % step !== 0) {
      if (delta < 0 || isStart) {
        newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
      }

      if (delta > 0 || isEnd) {
        newSectionValueNumber -= newSectionValueNumber % step;
      }
    }
    if (newSectionValueNumber > sectionBoundaries.maximum) {
      return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    if (newSectionValueNumber < sectionBoundaries.minimum) {
      return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    return getCleanValue(newSectionValueNumber);
  };
  const adjustLetterSection = () => {
    const options = getLetterEditingOptions(utils, timezone, section.type, section.format);
    if (options.length === 0) {
      return section.value;
    }
    if (shouldSetAbsolute) {
      if (delta > 0 || isStart) {
        return options[0];
      }
      return options[options.length - 1];
    }
    const currentOptionIndex = options.indexOf(section.value);
    const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
    return options[newOptionIndex];
  };
  if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') {
    return adjustDigitSection();
  }
  return adjustLetterSection();
};
const getSectionVisibleValue = (section, target) => {
  let value = section.value || section.placeholder;
  const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
  if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) {
    value = Number(value).toString();
  }

  // In the input, we add an empty character at the end of each section without leading zeros.
  // This makes sure that `onChange` will always be fired.
  // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
  // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
  // So the browser will not fire the input `onChange`.
  const shouldAddInvisibleSpace = ['input-rtl', 'input-ltr'].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
  if (shouldAddInvisibleSpace) {
    value = `${value}\u200e`;
  }
  if (target === 'input-rtl') {
    value = `\u2068${value}\u2069`;
  }
  return value;
};
const cleanString = dirtyString => dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const addPositionPropertiesToSections = (sections, isRTL) => {
  let position = 0;
  let positionInInput = isRTL ? 1 : 0;
  const newSections = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const renderedValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr');
    const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
    const sectionLength = cleanString(sectionStr).length;
    const sectionLengthInInput = sectionStr.length;

    // The ...InInput values consider the unicode characters but do include them in their indexes
    const cleanedValue = cleanString(renderedValue);
    const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
    const endInInput = startInInput + cleanedValue.length;
    newSections.push(_extends$c({}, section, {
      start: position,
      end: position + sectionLength,
      startInInput,
      endInInput
    }));
    position += sectionLength;
    // Move position to the end of string associated to the current section
    positionInInput += sectionLengthInInput;
  }
  return newSections;
};
const getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, currentTokenValue) => {
  switch (sectionConfig.type) {
    case 'year':
      {
        return localeText.fieldYearPlaceholder({
          digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), currentTokenValue).length
        });
      }
    case 'month':
      {
        return localeText.fieldMonthPlaceholder({
          contentType: sectionConfig.contentType
        });
      }
    case 'day':
      {
        return localeText.fieldDayPlaceholder();
      }
    case 'weekDay':
      {
        return localeText.fieldWeekDayPlaceholder({
          contentType: sectionConfig.contentType
        });
      }
    case 'hours':
      {
        return localeText.fieldHoursPlaceholder();
      }
    case 'minutes':
      {
        return localeText.fieldMinutesPlaceholder();
      }
    case 'seconds':
      {
        return localeText.fieldSecondsPlaceholder();
      }
    case 'meridiem':
      {
        return localeText.fieldMeridiemPlaceholder();
      }
    default:
      {
        return currentTokenValue;
      }
  }
};
const changeSectionValueFormat = (utils, valueStr, currentFormat, newFormat) => {
  if (process.env.NODE_ENV !== 'production') {
    if (getDateSectionConfigFromFormatToken(utils, currentFormat).type === 'weekDay') {
      throw new Error("changeSectionValueFormat doesn't support week day formats");
    }
  }
  return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const isFourDigitYearFormat = (utils, timezone, format) => utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const doesSectionFormatHaveLeadingZeros = (utils, timezone, contentType, sectionType, format) => {
  if (contentType !== 'digit') {
    return false;
  }
  const now = utils.dateWithTimezone(undefined, timezone);
  switch (sectionType) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case 'year':
      {
        if (isFourDigitYearFormat(utils, timezone, format)) {
          const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
          return formatted0001 === '0001';
        }
        const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
        return formatted2001 === '01';
      }
    case 'month':
      {
        return utils.formatByString(utils.startOfYear(now), format).length > 1;
      }
    case 'day':
      {
        return utils.formatByString(utils.startOfMonth(now), format).length > 1;
      }
    case 'weekDay':
      {
        return utils.formatByString(utils.startOfWeek(now), format).length > 1;
      }
    case 'hours':
      {
        return utils.formatByString(utils.setHours(now, 1), format).length > 1;
      }
    case 'minutes':
      {
        return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
      }
    case 'seconds':
      {
        return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
      }
    default:
      {
        throw new Error('Invalid section type');
      }
  }
};
const getEscapedPartsFromFormat = (utils, format) => {
  const escapedParts = [];
  const {
    start: startChar,
    end: endChar
  } = utils.escapedCharacters;
  const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
  let match = null;
  // eslint-disable-next-line no-cond-assign
  while (match = regExp.exec(format)) {
    escapedParts.push({
      start: match.index,
      end: regExp.lastIndex - 1
    });
  }
  return escapedParts;
};
const splitFormatIntoSections = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL) => {
  let startSeparator = '';
  const sections = [];
  const now = utils.date();
  const commitToken = token => {
    if (token === '') {
      return null;
    }
    const sectionConfig = getDateSectionConfigFromFormatToken(utils, token);
    const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
      if (hasLeadingZerosInFormat) {
        maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
      } else {
        if (sectionConfig.maxLength == null) {
          throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
        }
        maxLength = sectionConfig.maxLength;
        if (isValidDate) {
          sectionValue = cleanLeadingZeros(utils, sectionValue, maxLength);
        }
      }
    }
    sections.push(_extends$c({}, sectionConfig, {
      format: token,
      maxLength,
      value: sectionValue,
      placeholder: getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
      hasLeadingZeros: hasLeadingZerosInFormat,
      hasLeadingZerosInFormat,
      hasLeadingZerosInInput,
      startSeparator: sections.length === 0 ? startSeparator : '',
      endSeparator: '',
      modified: false
    }));
    return null;
  };

  // Expand the provided format
  let formatExpansionOverflow = 10;
  let prevFormat = format;
  let nextFormat = utils.expandFormat(format);
  while (nextFormat !== prevFormat) {
    prevFormat = nextFormat;
    nextFormat = utils.expandFormat(prevFormat);
    formatExpansionOverflow -= 1;
    if (formatExpansionOverflow < 0) {
      throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
  }
  const expandedFormat = nextFormat;

  // Get start/end indexes of escaped sections
  const escapedParts = getEscapedPartsFromFormat(utils, expandedFormat);

  // This RegExp test if the beginning of a string correspond to a supported token
  const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).sort((a, b) => b.length - a.length) // Sort to put longest word first
  .join('|')})`, 'g') // used to get access to lastIndex state
  ;

  let currentTokenValue = '';
  for (let i = 0; i < expandedFormat.length; i += 1) {
    const escapedPartOfCurrentChar = escapedParts.find(escapeIndex => escapeIndex.start <= i && escapeIndex.end >= i);
    const char = expandedFormat[i];
    const isEscapedChar = escapedPartOfCurrentChar != null;
    const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
    const regExpMatch = isTokenStartRegExp.test(potentialToken);
    if (!isEscapedChar && char.match(/([A-Za-z]+)/) && regExpMatch) {
      currentTokenValue = potentialToken.slice(0, isTokenStartRegExp.lastIndex);
      i += isTokenStartRegExp.lastIndex - 1;
    } else {
      // If we are on the opening or closing character of an escaped part of the format,
      // Then we ignore this character.
      const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
      if (!isEscapeBoundary) {
        commitToken(currentTokenValue);
        currentTokenValue = '';
        if (sections.length === 0) {
          startSeparator += char;
        } else {
          sections[sections.length - 1].endSeparator += char;
        }
      }
    }
  }
  commitToken(currentTokenValue);
  return sections.map(section => {
    const cleanSeparator = separator => {
      let cleanedSeparator = separator;
      if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) {
        cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
      }
      if (formatDensity === 'spacious' && ['/', '.', '-'].includes(cleanedSeparator)) {
        cleanedSeparator = ` ${cleanedSeparator} `;
      }
      return cleanedSeparator;
    };
    section.startSeparator = cleanSeparator(section.startSeparator);
    section.endSeparator = cleanSeparator(section.endSeparator);
    return section;
  });
};

/**
 * Some date libraries like `dayjs` don't support parsing from date with escaped characters.
 * To make sure that the parsing works, we are building a format and a date without any separator.
 */
const getDateFromDateSections = (utils, sections) => {
  // If we have both a day and a weekDay section,
  // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
  // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
  const shouldSkipWeekDays = sections.some(section => section.type === 'day');
  const sectionFormats = [];
  const sectionValues = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
    if (!shouldSkip) {
      sectionFormats.push(section.format);
      sectionValues.push(getSectionVisibleValue(section, 'non-input'));
    }
  }
  const formatWithoutSeparator = sectionFormats.join(' ');
  const dateWithoutSeparatorStr = sectionValues.join(' ');
  return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const createDateStrForInputFromSections = (sections, isRTL) => {
  const formattedSections = sections.map(section => {
    const dateValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr');
    return `${section.startSeparator}${dateValue}${section.endSeparator}`;
  });
  const dateStr = formattedSections.join('');
  if (!isRTL) {
    return dateStr;
  }

  // \u2066: start left-to-right isolation
  // \u2067: start right-to-left isolation
  // \u2068: start first strong character isolation
  // \u2069: pop isolation
  // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
  return `\u2066${dateStr}\u2069`;
};
const getSectionsBoundaries = (utils, timezone) => {
  const today = utils.dateWithTimezone(undefined, timezone);
  const endOfYear = utils.endOfYear(today);
  const endOfDay = utils.endOfDay(today);
  const {
    maxDaysInMonth,
    longestMonth
  } = getMonthsInYear(utils, today).reduce((acc, month) => {
    const daysInMonth = utils.getDaysInMonth(month);
    if (daysInMonth > acc.maxDaysInMonth) {
      return {
        maxDaysInMonth: daysInMonth,
        longestMonth: month
      };
    }
    return acc;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: utils.getMonth(endOfYear) + 1
    }),
    day: ({
      currentDate
    }) => ({
      minimum: 1,
      maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
      longestMonth: longestMonth
    }),
    weekDay: ({
      format,
      contentType
    }) => {
      if (contentType === 'digit') {
        const daysInWeek = getDaysInWeekStr(utils, timezone, format).map(Number);
        return {
          minimum: Math.min(...daysInWeek),
          maximum: Math.max(...daysInWeek)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format
    }) => {
      const lastHourInDay = utils.getHours(endOfDay);
      const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
      if (hasMeridiem) {
        return {
          minimum: 1,
          maximum: Number(utils.formatByString(utils.startOfDay(today), format))
        };
      }
      return {
        minimum: 0,
        maximum: lastHourInDay
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: utils.getMinutes(endOfDay)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: utils.getSeconds(endOfDay)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType) => {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnceInvalidSection) {
      const supportedSections = [];
      if (['date', 'date-time'].includes(valueType)) {
        supportedSections.push('weekDay', 'day', 'month', 'year');
      }
      if (['time', 'date-time'].includes(valueType)) {
        supportedSections.push('hours', 'minutes', 'seconds', 'meridiem');
      }
      const invalidSection = sections.find(section => !supportedSections.includes(section.type));
      if (invalidSection) {
        console.warn(`MUI: The field component you are using is not compatible with the "${invalidSection.type} date section.`, `The supported date sections are ["${supportedSections.join('", "')}"]\`.`);
        warnedOnceInvalidSection = true;
      }
    }
  }
};
const transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo) => {
  switch (section.type) {
    case 'year':
      {
        return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
      }
    case 'month':
      {
        return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
      }
    case 'weekDay':
      {
        const formattedDaysInWeek = getDaysInWeekStr(utils, timezone, section.format);
        const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
        const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
        const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
        const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
        return utils.addDays(dateToTransferFrom, diff);
      }
    case 'day':
      {
        return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
      }
    case 'meridiem':
      {
        const isAM = utils.getHours(dateToTransferFrom) < 12;
        const mergedDateHours = utils.getHours(dateToTransferTo);
        if (isAM && mergedDateHours >= 12) {
          return utils.addHours(dateToTransferTo, -12);
        }
        if (!isAM && mergedDateHours < 12) {
          return utils.addHours(dateToTransferTo, 12);
        }
        return dateToTransferTo;
      }
    case 'hours':
      {
        return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
      }
    case 'minutes':
      {
        return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
      }
    case 'seconds':
      {
        return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
      }
    default:
      {
        return dateToTransferTo;
      }
  }
};
const reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
};
const mergeDateIntoReferenceDate = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections) =>
// cloning sections before sort to avoid mutating it
[...sections].sort((a, b) => reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section) => {
  if (!shouldLimitToEditedSections || section.modified) {
    return transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
  }
  return mergedDate;
}, referenceDate);
const isAndroid$1 = () => navigator.userAgent.toLowerCase().indexOf('android') > -1;
const getSectionOrder = (sections, isRTL) => {
  const neighbors = {};
  if (!isRTL) {
    sections.forEach((_, index) => {
      const leftIndex = index === 0 ? null : index - 1;
      const rightIndex = index === sections.length - 1 ? null : index + 1;
      neighbors[index] = {
        leftIndex,
        rightIndex
      };
    });
    return {
      neighbors,
      startIndex: 0,
      endIndex: sections.length - 1
    };
  }
  const rtl2ltr = {};
  const ltr2rtl = {};
  let groupedSectionsStart = 0;
  let groupedSectionsEnd = 0;
  let RTLIndex = sections.length - 1;
  while (RTLIndex >= 0) {
    groupedSectionsEnd = sections.findIndex(
    // eslint-disable-next-line @typescript-eslint/no-loop-func
    (section, index) => {
      var _section$endSeparator;
      return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) &&
      // Special case where the spaces were not there in the initial input
      section.endSeparator !== ' / ';
    });
    if (groupedSectionsEnd === -1) {
      groupedSectionsEnd = sections.length - 1;
    }
    for (let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1) {
      ltr2rtl[i] = RTLIndex;
      rtl2ltr[RTLIndex] = i;
      RTLIndex -= 1;
    }
    groupedSectionsStart = groupedSectionsEnd + 1;
  }
  sections.forEach((_, index) => {
    const rtlIndex = ltr2rtl[index];
    const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
    const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
    neighbors[index] = {
      leftIndex,
      rightIndex
    };
  });
  return {
    neighbors,
    startIndex: rtl2ltr[0],
    endIndex: rtl2ltr[sections.length - 1]
  };
};

const _excluded$1z = ["value", "referenceDate"];
const singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: _ref => {
    let {
        value,
        referenceDate
      } = _ref,
      params = _objectWithoutPropertiesLoose$b(_ref, _excluded$1z);
    if (value != null && params.utils.isValid(value)) {
      return value;
    }
    if (referenceDate != null) {
      return referenceDate;
    }
    return getDefaultReferenceDate(params);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (a, b) => a === b,
  hasError: error => error != null,
  defaultErrorState: null,
  getTimezone: (utils, value) => value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
  setTimezone: (utils, timezone, value) => value == null ? null : utils.setTimezone(value, timezone)
};
const singleItemFieldValueManager = {
  updateReferenceValue: (utils, value, prevReferenceValue) => value == null || !utils.isValid(value) ? prevReferenceValue : value,
  getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate) => {
    const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
    if (shouldReUsePrevDateSections) {
      return prevSections;
    }
    return addPositionPropertiesToSections(getSectionsFromDate(date), isRTL);
  },
  getValueStrFromSections: createDateStrForInputFromSections,
  getActiveDateManager: (utils, state) => ({
    date: state.value,
    referenceDate: state.referenceValue,
    getSections: sections => sections,
    getNewValuesFromNewActiveDate: newActiveDate => ({
      value: newActiveDate,
      referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
    })
  }),
  parseValueStr: (valueStr, referenceValue, parseDate) => parseDate(valueStr.trim(), referenceValue)
};

// TODO v7: This file exist only to simplify typing between
// components/componentsProps and slots/slotProps
// Should be deleted when components/componentsProps are removed

const uncapitalizeObjectKeys$1 = capitalizedObject => {
  if (capitalizedObject === undefined) {
    return undefined;
  }
  return Object.keys(capitalizedObject).reduce((acc, key) => _extends$c({}, acc, {
    [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
  }), {});
};

function getPickersDayUtilityClass(slot) {
  return generateUtilityClass('MuiPickersDay', slot);
}
const pickersDayClasses = generateUtilityClasses('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

const _excluded$1y = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"];
const useUtilityClasses$X = ownerState => {
  const {
    selected,
    disableMargin,
    disableHighlightToday,
    today,
    disabled,
    outsideCurrentMonth,
    showDaysOutsideCurrentMonth,
    classes
  } = ownerState;
  const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
  const slots = {
    root: ['root', selected && !isHiddenDaySpacingFiller && 'selected', disabled && 'disabled', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth', isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return composeClasses(slots, getPickersDayUtilityClass, classes);
};
const styleArg = ({
  theme,
  ownerState
}) => _extends$c({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: '50%',
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: 'transparent',
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.short
  }),
  color: (theme.vars || theme).palette.text.primary,
  '@media (pointer: fine)': {
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    }
  },
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  }
}, !ownerState.disableMargin && {
  margin: `0 ${DAY_MARGIN}px`
}, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableHighlightToday && ownerState.today && {
  [`&:not(.${pickersDayClasses.selected})`]: {
    border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
  }
});
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
const PickersDayRoot = styled$3(ButtonBase, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(styleArg);
const PickersDayFiller = styled$3('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => _extends$c({}, styleArg({
  theme,
  ownerState
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: 'none'
}));
const noop$4 = () => {};
const PickersDayRaw = /*#__PURE__*/React$1.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersDay'
  });
  const {
      autoFocus = false,
      className,
      day,
      disabled = false,
      disableHighlightToday = false,
      disableMargin = false,
      isAnimating,
      onClick,
      onDaySelect,
      onFocus = noop$4,
      onBlur = noop$4,
      onKeyDown = noop$4,
      onMouseDown = noop$4,
      onMouseEnter = noop$4,
      outsideCurrentMonth,
      selected = false,
      showDaysOutsideCurrentMonth = false,
      children,
      today: isToday = false
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1y);
  const ownerState = _extends$c({}, props, {
    autoFocus,
    disabled,
    disableHighlightToday,
    disableMargin,
    selected,
    showDaysOutsideCurrentMonth,
    today: isToday
  });
  const classes = useUtilityClasses$X(ownerState);
  const utils = useUtils();
  const ref = React$1.useRef(null);
  const handleRef = useForkRef(ref, forwardedRef);

  // Since this is rendered when a Popper is opened we can't use passive effects.
  // Focusing in passive effects in Popper causes scroll jump.
  useEnhancedEffect(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      // ref.current being null would be a bug in MUI
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);

  // For day outside of current month, move focus from mouseDown to mouseUp
  // Goal: have the onClick ends before sliding to the new month
  const handleMouseDown = event => {
    onMouseDown(event);
    if (outsideCurrentMonth) {
      event.preventDefault();
    }
  };
  const handleClick = event => {
    if (!disabled) {
      onDaySelect(day);
    }
    if (outsideCurrentMonth) {
      event.currentTarget.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/jsx(PickersDayFiller, {
      className: clsx(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState,
      role: other.role
    });
  }
  return /*#__PURE__*/jsx(PickersDayRoot, _extends$c({
    className: clsx(classes.root, className),
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    tabIndex: selected ? 0 : -1,
    onKeyDown: event => onKeyDown(event, day),
    onFocus: event => onFocus(event, day),
    onBlur: event => onBlur(event, day),
    onMouseEnter: event => onMouseEnter(event, day),
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, other, {
    ownerState: ownerState,
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * The date to show.
   */
  day: PropTypes.any.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  isAnimating: PropTypes.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: PropTypes.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })])
} : void 0;

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */
const PickersDay = /*#__PURE__*/React$1.memo(PickersDayRaw);

function useValidation(props, validate, isSameError, defaultErrorState) {
  const {
    value,
    onError
  } = props;
  const adapter = useLocalizationContext();
  const previousValidationErrorRef = React$1.useRef(defaultErrorState);
  const validationError = validate({
    adapter,
    value,
    props
  });
  React$1.useEffect(() => {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }
    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

const useFieldState = params => {
  const utils = useUtils();
  const localeText = useLocaleText();
  const adapter = useLocalizationContext();
  const theme = useTheme$3();
  const isRTL = theme.direction === 'rtl';
  const {
    valueManager,
    fieldValueManager,
    valueType,
    validator,
    internalProps,
    internalProps: {
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      onChange,
      format,
      formatDensity = 'dense',
      selectedSections: selectedSectionsProp,
      onSelectedSectionsChange,
      shouldRespectLeadingZeros = false,
      timezone: timezoneProp
    }
  } = params;
  const {
    timezone,
    value: valueFromTheOutside,
    handleValueChange
  } = useValueWithTimezone({
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager
  });
  const sectionsValueBoundaries = React$1.useMemo(() => getSectionsBoundaries(utils, timezone), [utils, timezone]);
  const getSectionsFromValue = React$1.useCallback((value, fallbackSections = null) => fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, date => splitFormatIntoSections(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [fieldValueManager, format, localeText, isRTL, shouldRespectLeadingZeros, utils, formatDensity, timezone]);
  const placeholder = React$1.useMemo(() => fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [fieldValueManager, getSectionsFromValue, valueManager.emptyValue, isRTL]);
  const [state, setState] = React$1.useState(() => {
    const sections = getSectionsFromValue(valueFromTheOutside);
    validateSections(sections, valueType);
    const stateWithoutReferenceDate = {
      sections,
      value: valueFromTheOutside,
      referenceValue: valueManager.emptyValue,
      tempValueStrAndroid: null
    };
    const granularity = getSectionTypeGranularity(sections);
    const referenceValue = valueManager.getInitialReferenceValue({
      referenceDate: referenceDateProp,
      value: valueFromTheOutside,
      utils,
      props: internalProps,
      granularity,
      timezone
    });
    return _extends$c({}, stateWithoutReferenceDate, {
      referenceValue
    });
  });
  const [selectedSections, innerSetSelectedSections] = useControlled({
    controlled: selectedSectionsProp,
    default: null,
    name: 'useField',
    state: 'selectedSectionIndexes'
  });
  const setSelectedSections = newSelectedSections => {
    innerSetSelectedSections(newSelectedSections);
    onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    setState(prevState => _extends$c({}, prevState, {
      selectedSectionQuery: null
    }));
  };
  const selectedSectionIndexes = React$1.useMemo(() => {
    if (selectedSections == null) {
      return null;
    }
    if (selectedSections === 'all') {
      return {
        startIndex: 0,
        endIndex: state.sections.length - 1,
        shouldSelectBoundarySelectors: true
      };
    }
    if (typeof selectedSections === 'number') {
      return {
        startIndex: selectedSections,
        endIndex: selectedSections
      };
    }
    if (typeof selectedSections === 'string') {
      const selectedSectionIndex = state.sections.findIndex(section => section.type === selectedSections);
      return {
        startIndex: selectedSectionIndex,
        endIndex: selectedSectionIndex
      };
    }
    return selectedSections;
  }, [selectedSections, state.sections]);
  const publishValue = ({
    value,
    referenceValue,
    sections
  }) => {
    setState(prevState => _extends$c({}, prevState, {
      sections,
      value,
      referenceValue,
      tempValueStrAndroid: null
    }));
    const context = {
      validationError: validator({
        adapter,
        value,
        props: _extends$c({}, internalProps, {
          value,
          timezone
        })
      })
    };
    handleValueChange(value, context);
  };
  const setSectionValue = (sectionIndex, newSectionValue) => {
    const newSections = [...state.sections];
    newSections[sectionIndex] = _extends$c({}, newSections[sectionIndex], {
      value: newSectionValue,
      modified: true
    });
    return addPositionPropertiesToSections(newSections, isRTL);
  };
  const clearValue = () => {
    if (valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue)) {
      return;
    }
    publishValue({
      value: valueManager.emptyValue,
      referenceValue: state.referenceValue,
      sections: getSectionsFromValue(valueManager.emptyValue)
    });
  };
  const clearActiveSection = () => {
    if (selectedSectionIndexes == null) {
      return;
    }
    const activeSection = state.sections[selectedSectionIndexes.startIndex];
    if (activeSection.value === '') {
      return;
    }
    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter(section => section.value !== '').length;
    const isTheOnlyNonEmptySection = nonEmptySectionCountBefore === 1;
    const newSections = setSectionValue(selectedSectionIndexes.startIndex, '');
    const newActiveDate = isTheOnlyNonEmptySection ? null : utils.date(new Date(''));
    const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
    if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) {
      publishValue(_extends$c({}, newValues, {
        sections: newSections
      }));
    } else {
      setState(prevState => _extends$c({}, prevState, newValues, {
        sections: newSections,
        tempValueStrAndroid: null
      }));
    }
  };
  const updateValueFromValueStr = valueStr => {
    const parseDateStr = (dateStr, referenceDate) => {
      const date = utils.parse(dateStr, format);
      if (date == null || !utils.isValid(date)) {
        return null;
      }
      const sections = splitFormatIntoSections(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
      return mergeDateIntoReferenceDate(utils, timezone, date, sections, referenceDate, false);
    };
    const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
    const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
    publishValue({
      value: newValue,
      referenceValue: newReferenceValue,
      sections: getSectionsFromValue(newValue, state.sections)
    });
  };
  const updateSectionValue = ({
    activeSection,
    newSectionValue,
    shouldGoToNextSection
  }) => {
    /**
     * 1. Decide which section should be focused
     */
    if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) {
      setSelectedSections(selectedSectionIndexes.startIndex + 1);
    } else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) {
      setSelectedSections(selectedSectionIndexes.startIndex);
    }

    /**
     * 2. Try to build a valid date from the new section value
     */
    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
    const newActiveDateSections = activeDateManager.getSections(newSections);
    const newActiveDate = getDateFromDateSections(utils, newActiveDateSections);
    let values;
    let shouldPublish;

    /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */
    if (newActiveDate != null && utils.isValid(newActiveDate)) {
      const mergedDate = mergeDateIntoReferenceDate(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
      values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
      shouldPublish = true;
    } else {
      values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
      shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
    }

    /**
     * Publish or update the internal state with the new value and sections.
     */
    if (shouldPublish) {
      return publishValue(_extends$c({}, values, {
        sections: newSections
      }));
    }
    return setState(prevState => _extends$c({}, prevState, values, {
      sections: newSections,
      tempValueStrAndroid: null
    }));
  };
  const setTempAndroidValueStr = tempValueStrAndroid => setState(prev => _extends$c({}, prev, {
    tempValueStrAndroid
  }));
  React$1.useEffect(() => {
    const sections = getSectionsFromValue(state.value);
    validateSections(sections, valueType);
    setState(prevState => _extends$c({}, prevState, {
      sections
    }));
  }, [format, utils.locale]); // eslint-disable-line react-hooks/exhaustive-deps

  React$1.useEffect(() => {
    let shouldUpdate = false;
    if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) {
      shouldUpdate = true;
    } else {
      shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
    }
    if (shouldUpdate) {
      setState(prevState => _extends$c({}, prevState, {
        value: valueFromTheOutside,
        referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
        sections: getSectionsFromValue(valueFromTheOutside)
      }));
    }
  }, [valueFromTheOutside]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    state,
    selectedSectionIndexes,
    setSelectedSections,
    clearValue,
    clearActiveSection,
    updateSectionValue,
    updateValueFromValueStr,
    setTempAndroidValueStr,
    sectionsValueBoundaries,
    placeholder,
    timezone
  };
};

/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */

/**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */

const QUERY_LIFE_DURATION_MS = 5000;
const isQueryResponseWithoutValue = response => response.saveQuery != null;

/**
 * Update the active section value when the user pressed a key that is not a navigation key (arrow key for example).
 * This hook has two main editing behaviors
 *
 * 1. The numeric editing when the user presses a digit
 * 2. The letter editing when the user presses another key
 */
const useFieldCharacterEditing = ({
  sections,
  updateSectionValue,
  sectionsValueBoundaries,
  setTempAndroidValueStr,
  timezone
}) => {
  const utils = useUtils();
  const [query, setQuery] = React$1.useState(null);
  const resetQuery = useEventCallback(() => setQuery(null));
  React$1.useEffect(() => {
    var _sections$query$secti;
    if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) {
      resetQuery();
    }
  }, [sections, query, resetQuery]);
  React$1.useEffect(() => {
    if (query != null) {
      const timeout = setTimeout(() => resetQuery(), QUERY_LIFE_DURATION_MS);
      return () => {
        window.clearTimeout(timeout);
      };
    }
    return () => {};
  }, [query, resetQuery]);
  const applyQuery = ({
    keyPressed,
    sectionIndex
  }, getFirstSectionValueMatchingWithQuery, isValidQueryValue) => {
    const cleanKeyPressed = keyPressed.toLowerCase();
    const activeSection = sections[sectionIndex];

    // The current query targets the section being editing
    // We can try to concatenated value
    if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
      const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
      const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
      if (!isQueryResponseWithoutValue(queryResponse)) {
        setQuery({
          sectionIndex,
          value: concatenatedQueryValue,
          sectionType: activeSection.type
        });
        return queryResponse;
      }
    }
    const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
    if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
      resetQuery();
      return null;
    }
    setQuery({
      sectionIndex,
      value: cleanKeyPressed,
      sectionType: activeSection.type
    });
    if (isQueryResponseWithoutValue(queryResponse)) {
      return null;
    }
    return queryResponse;
  };
  const applyLetterEditing = params => {
    const findMatchingOptions = (format, options, queryValue) => {
      const matchingValues = options.filter(option => option.toLowerCase().startsWith(queryValue));
      if (matchingValues.length === 0) {
        return {
          saveQuery: false
        };
      }
      return {
        sectionValue: matchingValues[0],
        shouldGoToNextSection: matchingValues.length === 1
      };
    };
    const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue) => {
      const getOptions = format => getLetterEditingOptions(utils, timezone, activeSection.type, format);
      if (activeSection.contentType === 'letter') {
        return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
      }

      // When editing a digit-format month / weekDay and the user presses a letter,
      // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
      // We just have to make sure that the default month / weekDay format is a letter format,
      if (fallbackFormat && formatFallbackValue != null && getDateSectionConfigFromFormatToken(utils, fallbackFormat).contentType === 'letter') {
        const fallbackOptions = getOptions(fallbackFormat);
        const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
        if (isQueryResponseWithoutValue(response)) {
          return {
            saveQuery: false
          };
        }
        return _extends$c({}, response, {
          sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
        });
      }
      return {
        saveQuery: false
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      switch (activeSection.type) {
        case 'month':
          {
            const formatFallbackValue = fallbackValue => changeSectionValueFormat(utils, fallbackValue, utils.formats.month, activeSection.format);
            return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
          }
        case 'weekDay':
          {
            const formatFallbackValue = (fallbackValue, fallbackOptions) => fallbackOptions.indexOf(fallbackValue).toString();
            return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
          }
        case 'meridiem':
          {
            return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
          }
        default:
          {
            return {
              saveQuery: false
            };
          }
      }
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery);
  };
  const applyNumericEditing = params => {
    const getNewSectionValue = (queryValue, section) => {
      const queryValueNumber = Number(`${queryValue}`);
      const sectionBoundaries = sectionsValueBoundaries[section.type]({
        currentDate: null,
        format: section.format,
        contentType: section.contentType
      });
      if (queryValueNumber > sectionBoundaries.maximum) {
        return {
          saveQuery: false
        };
      }

      // If the user types `0` on a month section,
      // It is below the minimum, but we want to store the `0` in the query,
      // So that when he pressed `1`, it will store `01` and move to the next section.
      if (queryValueNumber < sectionBoundaries.minimum) {
        return {
          saveQuery: true
        };
      }
      const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
      const newSectionValue = cleanDigitSectionValue(utils, timezone, queryValueNumber, sectionBoundaries, section);
      return {
        sectionValue: newSectionValue,
        shouldGoToNextSection
      };
    };
    const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection) => {
      if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') {
        return getNewSectionValue(queryValue, activeSection);
      }

      // When editing a letter-format month and the user presses a digit,
      // We can support the numeric editing by using the digit-format month and re-formatting the result.
      if (activeSection.type === 'month') {
        const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, 'digit', 'month', 'MM');
        const response = getNewSectionValue(queryValue, {
          type: activeSection.type,
          format: 'MM',
          hasLeadingZerosInFormat,
          hasLeadingZerosInInput: true,
          contentType: 'digit',
          maxLength: 2
        });
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = changeSectionValueFormat(utils, response.sectionValue, 'MM', activeSection.format);
        return _extends$c({}, response, {
          sectionValue: formattedValue
        });
      }

      // When editing a letter-format weekDay and the user presses a digit,
      // We can support the numeric editing by returning the nth day in the week day array.
      if (activeSection.type === 'weekDay') {
        const response = getNewSectionValue(queryValue, activeSection);
        if (isQueryResponseWithoutValue(response)) {
          return response;
        }
        const formattedValue = getDaysInWeekStr(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
        return _extends$c({}, response, {
          sectionValue: formattedValue
        });
      }
      return {
        saveQuery: false
      };
    };
    return applyQuery(params, getFirstSectionValueMatchingWithQuery, queryValue => !Number.isNaN(Number(queryValue)));
  };
  const applyCharacterEditing = useEventCallback(params => {
    const activeSection = sections[params.sectionIndex];
    const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
    const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
    if (response == null) {
      setTempAndroidValueStr(null);
    } else {
      updateSectionValue({
        activeSection,
        newSectionValue: response.sectionValue,
        shouldGoToNextSection: response.shouldGoToNextSection
      });
    }
  });
  return {
    applyCharacterEditing,
    resetCharacterQuery: resetQuery
  };
};

/* Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(item => array.indexOf(item) !== -1);
  }
  return array.indexOf(itemOrItems) !== -1;
}
const onSpaceOrEnter = (innerFn, externalEvent) => event => {
  if (event.key === 'Enter' || event.key === ' ') {
    innerFn(event);

    // prevent any side effects
    event.preventDefault();
    event.stopPropagation();
  }
  if (externalEvent) {
    externalEvent(event);
  }
};

// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const getActiveElement = (root = document) => {
  const activeEl = root.activeElement;
  if (!activeEl) {
    return null;
  }
  if (activeEl.shadowRoot) {
    return getActiveElement(activeEl.shadowRoot);
  }
  return activeEl;
};
const DEFAULT_DESKTOP_MODE_MEDIA_QUERY = '@media (pointer: fine)';

const _excluded$1x = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error"];
const useField = params => {
  const utils = useUtils();
  const {
    state,
    selectedSectionIndexes,
    setSelectedSections,
    clearValue,
    clearActiveSection,
    updateSectionValue,
    updateValueFromValueStr,
    setTempAndroidValueStr,
    sectionsValueBoundaries,
    placeholder,
    timezone
  } = useFieldState(params);
  const {
      inputRef: inputRefProp,
      internalProps,
      internalProps: {
        readOnly = false,
        unstableFieldRef,
        minutesStep
      },
      forwardedProps: {
        onClick,
        onKeyDown,
        onFocus,
        onBlur,
        onMouseUp,
        onPaste,
        error
      },
      fieldValueManager,
      valueManager,
      validator
    } = params,
    otherForwardedProps = _objectWithoutPropertiesLoose$b(params.forwardedProps, _excluded$1x);
  const {
    applyCharacterEditing,
    resetCharacterQuery
  } = useFieldCharacterEditing({
    sections: state.sections,
    updateSectionValue,
    sectionsValueBoundaries,
    setTempAndroidValueStr,
    timezone
  });
  const inputRef = React$1.useRef(null);
  const handleRef = useForkRef(inputRefProp, inputRef);
  const focusTimeoutRef = React$1.useRef(undefined);
  const theme = useTheme$3();
  const isRTL = theme.direction === 'rtl';
  const sectionOrder = React$1.useMemo(() => getSectionOrder(state.sections, isRTL), [state.sections, isRTL]);
  const syncSelectionFromDOM = () => {
    var _selectionStart;
    if (readOnly) {
      setSelectedSections(null);
      return;
    }
    const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
    let nextSectionIndex;
    if (browserStartIndex <= state.sections[0].startInInput) {
      // Special case if browser index is in invisible characters at the beginning
      nextSectionIndex = 1;
    } else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) {
      // If the click is after the last character of the input, then we want to select the 1st section.
      nextSectionIndex = 1;
    } else {
      nextSectionIndex = state.sections.findIndex(section => section.startInInput - section.startSeparator.length > browserStartIndex);
    }
    const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
    setSelectedSections(sectionIndex);
  };
  const handleInputClick = useEventCallback((...args) => {
    onClick == null || onClick(...args);
    syncSelectionFromDOM();
  });
  const handleInputMouseUp = useEventCallback(event => {
    onMouseUp == null || onMouseUp(event);

    // Without this, the browser will remove the selected when clicking inside an already-selected section.
    event.preventDefault();
  });
  const handleInputFocus = useEventCallback((...args) => {
    onFocus == null || onFocus(...args);
    // The ref is guaranteed to be resolved at this point.
    const input = inputRef.current;
    window.clearTimeout(focusTimeoutRef.current);
    focusTimeoutRef.current = setTimeout(() => {
      // The ref changed, the component got remounted, the focus event is no longer relevant.
      if (!input || input !== inputRef.current) {
        return;
      }
      if (selectedSectionIndexes != null || readOnly) {
        return;
      }
      if (
      // avoid selecting all sections when focusing empty field without value
      input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) {
        setSelectedSections('all');
      } else {
        syncSelectionFromDOM();
      }
    });
  });
  const handleInputBlur = useEventCallback((...args) => {
    onBlur == null || onBlur(...args);
    setSelectedSections(null);
  });
  const handleInputPaste = useEventCallback(event => {
    onPaste == null || onPaste(event);
    if (readOnly) {
      event.preventDefault();
      return;
    }
    const pastedValue = event.clipboardData.getData('text');
    if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
      const activeSection = state.sections[selectedSectionIndexes.startIndex];
      const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
      const digitsOnly = /^[0-9]+$/.test(pastedValue);
      const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
      const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
      if (isValidPastedValue) {
        // Early return to let the paste update section, value
        return;
      }
      if (lettersOnly || digitsOnly) {
        // The pasted value correspond to a single section but not the expected type
        // skip the modification
        event.preventDefault();
        return;
      }
    }
    event.preventDefault();
    resetCharacterQuery();
    updateValueFromValueStr(pastedValue);
  });
  const handleInputChange = useEventCallback(event => {
    if (readOnly) {
      return;
    }
    const targetValue = event.target.value;
    const eventData = event.nativeEvent.data;
    // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
    // usual changes have only the currently typed character in the `event.nativeEvent.data`
    const shouldUseEventData = eventData && eventData.length > 1;
    const valueStr = shouldUseEventData ? eventData : targetValue;
    const cleanValueStr = cleanString(valueStr);

    // If no section is selected or eventData should be used, we just try to parse the new value
    // This line is mostly triggered by imperative code / application tests.
    if (selectedSectionIndexes == null || shouldUseEventData) {
      updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
      return;
    }
    let keyPressed;
    if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) {
      keyPressed = cleanValueStr;
    } else {
      const prevValueStr = cleanString(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
      let startOfDiffIndex = -1;
      let endOfDiffIndex = -1;
      for (let i = 0; i < prevValueStr.length; i += 1) {
        if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) {
          startOfDiffIndex = i;
        }
        if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) {
          endOfDiffIndex = i;
        }
      }
      const activeSection = state.sections[selectedSectionIndexes.startIndex];
      const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
      if (hasDiffOutsideOfActiveSection) {
        // TODO: Support if the new date is valid
        return;
      }

      // The active section being selected, the browser has replaced its value with the key pressed by the user.
      const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || '').length;
      keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
    }
    if (isAndroid$1() && keyPressed.length === 0) {
      setTempAndroidValueStr(valueStr);
      return;
    }
    applyCharacterEditing({
      keyPressed,
      sectionIndex: selectedSectionIndexes.startIndex
    });
  });
  const handleInputKeyDown = useEventCallback(event => {
    onKeyDown == null || onKeyDown(event);

    // eslint-disable-next-line default-case
    switch (true) {
      // Select all
      case event.key === 'a' && (event.ctrlKey || event.metaKey):
        {
          // prevent default to make sure that the next line "select all" while updating
          // the internal state at the same time.
          event.preventDefault();
          setSelectedSections('all');
          break;
        }

      // Move selection to next section
      case event.key === 'ArrowRight':
        {
          event.preventDefault();
          if (selectedSectionIndexes == null) {
            setSelectedSections(sectionOrder.startIndex);
          } else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) {
            setSelectedSections(selectedSectionIndexes.endIndex);
          } else {
            const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
            if (nextSectionIndex !== null) {
              setSelectedSections(nextSectionIndex);
            }
          }
          break;
        }

      // Move selection to previous section
      case event.key === 'ArrowLeft':
        {
          event.preventDefault();
          if (selectedSectionIndexes == null) {
            setSelectedSections(sectionOrder.endIndex);
          } else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) {
            setSelectedSections(selectedSectionIndexes.startIndex);
          } else {
            const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
            if (nextSectionIndex !== null) {
              setSelectedSections(nextSectionIndex);
            }
          }
          break;
        }

      // Reset the value of the selected section
      case ['Backspace', 'Delete'].includes(event.key):
        {
          event.preventDefault();
          if (readOnly) {
            break;
          }
          if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) {
            clearValue();
          } else {
            clearActiveSection();
          }
          resetCharacterQuery();
          break;
        }

      // Increment / decrement the selected section value
      case ['ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key):
        {
          event.preventDefault();
          if (readOnly || selectedSectionIndexes == null) {
            break;
          }
          const activeSection = state.sections[selectedSectionIndexes.startIndex];
          const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
          const newSectionValue = adjustSectionValue(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
            minutesStep
          });
          updateSectionValue({
            activeSection,
            newSectionValue,
            shouldGoToNextSection: false
          });
          break;
        }
    }
  });
  useEnhancedEffect(() => {
    if (!inputRef.current) {
      return;
    }
    if (selectedSectionIndexes == null) {
      if (inputRef.current.scrollLeft) {
        // Ensure that input content is not marked as selected.
        // setting selection range to 0 causes issues in Safari.
        // https://bugs.webkit.org/show_bug.cgi?id=224425
        inputRef.current.scrollLeft = 0;
      }
      return;
    }
    const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
    const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
    let selectionStart = firstSelectedSection.startInInput;
    let selectionEnd = lastSelectedSection.endInInput;
    if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
      selectionStart -= firstSelectedSection.startSeparator.length;
      selectionEnd += lastSelectedSection.endSeparator.length;
    }
    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
      // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
      const currentScrollTop = inputRef.current.scrollTop;
      // On multi input range pickers we want to update selection range only for the active input
      // This helps avoiding the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
      // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
      if (inputRef.current === getActiveElement(document)) {
        inputRef.current.setSelectionRange(selectionStart, selectionEnd);
      }
      // Even reading this variable seems to do the trick, but also setting it just to make use of it
      inputRef.current.scrollTop = currentScrollTop;
    }
  });
  const validationError = useValidation(_extends$c({}, internalProps, {
    value: state.value,
    timezone
  }), validator, valueManager.isSameError, valueManager.defaultErrorState);
  const inputError = React$1.useMemo(() => {
    // only override when `error` is undefined.
    // in case of multi input fields, the `error` value is provided externally and will always be defined.
    if (error !== undefined) {
      return error;
    }
    return valueManager.hasError(validationError);
  }, [valueManager, validationError, error]);
  React$1.useEffect(() => {
    if (!inputError && !selectedSectionIndexes) {
      resetCharacterQuery();
    }
  }, [state.referenceValue, selectedSectionIndexes, inputError]); // eslint-disable-line react-hooks/exhaustive-deps

  React$1.useEffect(() => {
    // Select the right section when focused on mount (`autoFocus = true` on the input)
    if (inputRef.current && inputRef.current === document.activeElement) {
      setSelectedSections('all');
    }
    return () => window.clearTimeout(focusTimeoutRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
  // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
  // This causes a small flickering on Android,
  // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
  React$1.useEffect(() => {
    if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
      resetCharacterQuery();
      clearActiveSection();
    }
  }, [state.tempValueStrAndroid]); // eslint-disable-line react-hooks/exhaustive-deps

  const valueStr = React$1.useMemo(() => {
    var _state$tempValueStrAn;
    return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
  }, [state.sections, fieldValueManager, state.tempValueStrAndroid, isRTL]);
  const inputMode = React$1.useMemo(() => {
    if (selectedSectionIndexes == null) {
      return 'text';
    }
    if (state.sections[selectedSectionIndexes.startIndex].contentType === 'letter') {
      return 'text';
    }
    return 'numeric';
  }, [selectedSectionIndexes, state.sections]);
  const inputHasFocus = inputRef.current && inputRef.current === getActiveElement(document);
  const shouldShowPlaceholder = !inputHasFocus && valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
  React$1.useImperativeHandle(unstableFieldRef, () => ({
    getSections: () => state.sections,
    getActiveSectionIndex: () => {
      var _selectionStart2, _selectionEnd;
      const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
      const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
      if (browserStartIndex === 0 && browserEndIndex === 0) {
        return null;
      }
      const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
      : state.sections.findIndex(section => section.startInInput - section.startSeparator.length > browserStartIndex);
      return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
    },
    setSelectedSections: activeSectionIndex => setSelectedSections(activeSectionIndex)
  }));
  return _extends$c({
    placeholder,
    autoComplete: 'off'
  }, otherForwardedProps, {
    value: shouldShowPlaceholder ? '' : valueStr,
    inputMode,
    readOnly,
    onClick: handleInputClick,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onPaste: handleInputPaste,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    onMouseUp: handleInputMouseUp,
    error: inputError,
    ref: handleRef
  });
};

const validateDate = ({
  props,
  value,
  adapter
}) => {
  if (value === null) {
    return null;
  }
  const {
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    disablePast,
    disableFuture,
    timezone
  } = props;
  const now = adapter.utils.dateWithTimezone(undefined, timezone);
  const minDate = applyDefaultDate(adapter.utils, props.minDate, adapter.defaultDates.minDate);
  const maxDate = applyDefaultDate(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(shouldDisableDate && shouldDisableDate(value)):
      return 'shouldDisableDate';
    case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
      return 'shouldDisableMonth';
    case Boolean(shouldDisableYear && shouldDisableYear(value)):
      return 'shouldDisableYear';
    case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
      return 'disablePast';
    case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
      return 'minDate';
    case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
      return 'maxDate';
    default:
      return null;
  }
};

const DATE_VALIDATION_PROP_NAMES = ['disablePast', 'disableFuture', 'minDate', 'maxDate', 'shouldDisableDate', 'shouldDisableMonth', 'shouldDisableYear'];
const TIME_VALIDATION_PROP_NAMES = ['disablePast', 'disableFuture', 'minTime', 'maxTime', 'shouldDisableClock', 'shouldDisableTime', 'minutesStep', 'ampm', 'disableIgnoringDatePartForTimeValidation'];
const DATE_TIME_VALIDATION_PROP_NAMES = ['minDateTime', 'maxDateTime'];
const VALIDATION_PROP_NAMES = [...DATE_VALIDATION_PROP_NAMES, ...TIME_VALIDATION_PROP_NAMES, ...DATE_TIME_VALIDATION_PROP_NAMES];
/**
 * Extract the validation props for the props received by a component.
 * Limit the risk of forgetting some of them and reduce the bundle size.
 */
const extractValidationProps = props => VALIDATION_PROP_NAMES.reduce((extractedProps, propName) => {
  if (props.hasOwnProperty(propName)) {
    extractedProps[propName] = props[propName];
  }
  return extractedProps;
}, {});

const SHARED_FIELD_INTERNAL_PROP_NAMES = ['value', 'defaultValue', 'referenceDate', 'format', 'formatDensity', 'onChange', 'timezone', 'readOnly', 'onError', 'shouldRespectLeadingZeros', 'selectedSections', 'onSelectedSectionsChange', 'unstableFieldRef'];
const splitFieldInternalAndForwardedProps = (props, valueType) => {
  const forwardedProps = _extends$c({}, props);
  const internalProps = {};
  const extractProp = propName => {
    if (forwardedProps.hasOwnProperty(propName)) {
      // @ts-ignore
      internalProps[propName] = forwardedProps[propName];
      delete forwardedProps[propName];
    }
  };
  SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
  if (valueType === 'date') {
    DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
  } else if (valueType === 'time') {
    TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
  } else if (valueType === 'date-time') {
    DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
    TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
    DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
  }
  return {
    forwardedProps,
    internalProps
  };
};

const useDefaultizedDateField = props => {
  var _props$disablePast, _props$disableFuture, _props$format;
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  return _extends$c({}, props, {
    disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
    disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
    format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
    minDate: applyDefaultDate(utils, props.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, props.maxDate, defaultDates.maxDate)
  });
};
const useDateField = ({
  props: inProps,
  inputRef
}) => {
  const props = useDefaultizedDateField(inProps);
  const {
    forwardedProps,
    internalProps
  } = splitFieldInternalAndForwardedProps(props, 'date');
  return useField({
    inputRef,
    forwardedProps,
    internalProps,
    valueManager: singleItemValueManager,
    fieldValueManager: singleItemFieldValueManager,
    validator: validateDate,
    valueType: 'date'
  });
};

const _excluded$1w = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"],
  _excluded2$f = ["inputRef"],
  _excluded3$6 = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly"];
const DateField = /*#__PURE__*/React$1.forwardRef(function DateField(inProps, ref) {
  var _ref, _slots$textField, _slotProps$textField;
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiDateField'
  });
  const {
      components,
      componentsProps,
      slots,
      slotProps,
      InputProps,
      inputProps
    } = themeProps,
    other = _objectWithoutPropertiesLoose$b(themeProps, _excluded$1w);
  const ownerState = themeProps;
  const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : MuiTextField;
  const _useSlotProps = useSlotProps({
      elementType: TextField,
      externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
      externalForwardedProps: other,
      ownerState
    }),
    {
      inputRef: externalInputRef
    } = _useSlotProps,
    textFieldProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$f);

  // TODO: Remove when mui/material-ui#35088 will be merged
  textFieldProps.inputProps = _extends$c({}, inputProps, textFieldProps.inputProps);
  textFieldProps.InputProps = _extends$c({}, InputProps, textFieldProps.InputProps);
  const _useDateField = useDateField({
      props: textFieldProps,
      inputRef: externalInputRef
    }),
    {
      ref: inputRef,
      onPaste,
      onKeyDown,
      inputMode,
      readOnly
    } = _useDateField,
    fieldProps = _objectWithoutPropertiesLoose$b(_useDateField, _excluded3$6);
  return /*#__PURE__*/jsx(TextField, _extends$c({
    ref: ref
  }, fieldProps, {
    InputProps: _extends$c({}, fieldProps.InputProps, {
      readOnly
    }),
    inputProps: _extends$c({}, fieldProps.inputProps, {
      inputMode,
      onPaste,
      onKeyDown,
      ref: inputRef
    })
  }));
});
process.env.NODE_ENV !== "production" ? DateField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']),
  component: PropTypes.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(['dense', 'spacious']),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(['all', 'day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'weekDay', 'year']), PropTypes.number, PropTypes.shape({
    endIndex: PropTypes.number.isRequired,
    startIndex: PropTypes.number.isRequired
  })]),
  /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOf(['medium', 'small']),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;

const validateTime = ({
  adapter,
  value,
  props
}) => {
  if (value === null) {
    return null;
  }
  const {
    minTime,
    maxTime,
    minutesStep,
    shouldDisableClock,
    shouldDisableTime,
    disableIgnoringDatePartForTimeValidation = false,
    disablePast,
    disableFuture,
    timezone
  } = props;
  const now = adapter.utils.dateWithTimezone(undefined, timezone);
  const isAfter = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, adapter.utils);
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(minTime && isAfter(minTime, value)):
      return 'minTime';
    case Boolean(maxTime && isAfter(value, maxTime)):
      return 'maxTime';
    case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBefore(value, now)):
      return 'disablePast';
    case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
      return 'shouldDisableTime-hours';
    case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
      return 'shouldDisableTime-minutes';
    case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
      return 'shouldDisableTime-seconds';
    case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getHours(value), 'hours')):
      return 'shouldDisableClock-hours';
    case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getMinutes(value), 'minutes')):
      return 'shouldDisableClock-minutes';
    case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getSeconds(value), 'seconds')):
      return 'shouldDisableClock-seconds';
    case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
      return 'minutesStep';
    default:
      return null;
  }
};

const useDefaultizedTimeField = props => {
  var _props$ampm, _props$disablePast, _props$disableFuture, _props$format;
  const utils = useUtils();
  const ampm = (_props$ampm = props.ampm) != null ? _props$ampm : utils.is12HourCycleInCurrentLocale();
  const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
  return _extends$c({}, props, {
    disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
    disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
    format: (_props$format = props.format) != null ? _props$format : defaultFormat
  });
};
const useTimeField = ({
  props: inProps,
  inputRef
}) => {
  const props = useDefaultizedTimeField(inProps);
  const {
    forwardedProps,
    internalProps
  } = splitFieldInternalAndForwardedProps(props, 'time');
  return useField({
    inputRef,
    forwardedProps,
    internalProps,
    valueManager: singleItemValueManager,
    fieldValueManager: singleItemFieldValueManager,
    validator: validateTime,
    valueType: 'time'
  });
};

const _excluded$1v = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"],
  _excluded2$e = ["inputRef"],
  _excluded3$5 = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly"];
const TimeField = /*#__PURE__*/React$1.forwardRef(function TimeField(inProps, ref) {
  var _ref, _slots$textField, _slotProps$textField;
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiTimeField'
  });
  const {
      slots,
      slotProps,
      components,
      componentsProps,
      InputProps,
      inputProps
    } = themeProps,
    other = _objectWithoutPropertiesLoose$b(themeProps, _excluded$1v);
  const ownerState = themeProps;
  const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : MuiTextField;
  const _useSlotProps = useSlotProps({
      elementType: TextField,
      externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
      externalForwardedProps: other,
      ownerState
    }),
    {
      inputRef: externalInputRef
    } = _useSlotProps,
    textFieldProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$e);

  // TODO: Remove when mui/material-ui#35088 will be merged
  textFieldProps.inputProps = _extends$c({}, inputProps, textFieldProps.inputProps);
  textFieldProps.InputProps = _extends$c({}, InputProps, textFieldProps.InputProps);
  const _useTimeField = useTimeField({
      props: textFieldProps,
      inputRef: externalInputRef
    }),
    {
      ref: inputRef,
      onPaste,
      onKeyDown,
      inputMode,
      readOnly
    } = _useTimeField,
    fieldProps = _objectWithoutPropertiesLoose$b(_useTimeField, _excluded3$5);
  return /*#__PURE__*/jsx(TextField, _extends$c({
    ref: ref
  }, fieldProps, {
    InputProps: _extends$c({}, fieldProps.InputProps, {
      readOnly
    }),
    inputProps: _extends$c({}, fieldProps.inputProps, {
      inputMode,
      onPaste,
      onKeyDown,
      ref: inputRef
    })
  }));
});
process.env.NODE_ENV !== "production" ? TimeField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: PropTypes.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']),
  component: PropTypes.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(['dense', 'spacious']),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(['all', 'day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'weekDay', 'year']), PropTypes.number, PropTypes.shape({
    endIndex: PropTypes.number.isRequired,
    startIndex: PropTypes.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: PropTypes.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOf(['medium', 'small']),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;

const useIsDateDisabled = ({
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  timezone
}) => {
  const adapter = useLocalizationContext();
  return React$1.useCallback(day => validateDate({
    adapter,
    value: day,
    props: {
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      minDate,
      maxDate,
      disableFuture,
      disablePast,
      timezone
    }
  }) !== null, [adapter, shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone]);
};

const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils) => (state, action) => {
  switch (action.type) {
    case 'changeMonth':
      return _extends$c({}, state, {
        slideDirection: action.direction,
        currentMonth: action.newMonth,
        isMonthSwitchingAnimating: !reduceAnimations
      });
    case 'finishMonthSwitchingAnimation':
      return _extends$c({}, state, {
        isMonthSwitchingAnimating: false
      });
    case 'changeFocusedDay':
      {
        if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
          return state;
        }
        const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
        return _extends$c({}, state, {
          focusedDay: action.focusedDay,
          isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
          currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
          slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
        });
      }
    default:
      throw new Error('missing support');
  }
};
const useCalendarState = params => {
  const {
    value,
    referenceDate: referenceDateProp,
    defaultCalendarMonth,
    disableFuture,
    disablePast,
    disableSwitchToMonthOnDayFocus = false,
    maxDate,
    minDate,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    timezone
  } = params;
  const now = useNow(timezone);
  const utils = useUtils();
  const reducerFn = React$1.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  const referenceDate = React$1.useMemo(() => {
    let externalReferenceDate = null;
    if (referenceDateProp) {
      externalReferenceDate = referenceDateProp;
    } else if (defaultCalendarMonth) {
      // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
      externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
    }
    return singleItemValueManager.getInitialReferenceValue({
      value,
      utils,
      timezone,
      props: params,
      referenceDate: externalReferenceDate,
      granularity: SECTION_TYPE_GRANULARITY.day
    });
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const [calendarState, dispatch] = React$1.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: value || now,
    currentMonth: utils.startOfMonth(referenceDate),
    slideDirection: 'left'
  });
  const handleChangeMonth = React$1.useCallback(payload => {
    dispatch(_extends$c({
      type: 'changeMonth'
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  const changeMonth = React$1.useCallback(newDate => {
    const newDateRequested = newDate;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, utils]);
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    minDate,
    maxDate,
    disableFuture,
    disablePast,
    timezone
  });
  const onMonthSwitchingAnimationEnd = React$1.useCallback(() => {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  const changeFocusedDay = useEventCallback((newFocusedDate, withoutMonthSwitchingAnimation) => {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate,
        withoutMonthSwitchingAnimation
      });
    }
  });
  return {
    referenceDate,
    calendarState,
    changeMonth,
    changeFocusedDay,
    isDateDisabled,
    onMonthSwitchingAnimationEnd,
    handleChangeMonth
  };
};

function _setPrototypeOf$2(t, e) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$2(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf$2(t, o);
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default$1.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$b(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default$1.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default$1.cloneElement(React__default$1.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default$1.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$3() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$3,
  onEntering: noop$3,
  onEntered: noop$3,
  onExit: noop$3,
  onExiting: noop$3,
  onExited: noop$3
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose$b(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default$1.createElement(Transition, _extends$c({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default$1.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$c({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized$2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values$1 = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$2 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$2(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$c({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$b(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values$1(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default$1.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default$1.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default$1.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default$1.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$2;
var TransitionGroup$1 = TransitionGroup;

const getPickersFadeTransitionGroupUtilityClass = slot => generateUtilityClass('MuiPickersFadeTransitionGroup', slot);
generateUtilityClasses('MuiPickersFadeTransitionGroup', ['root']);

const useUtilityClasses$W = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const animationDuration = 500;
const PickersFadeTransitionGroupRoot = styled$3(TransitionGroup$1, {
  name: 'MuiPickersFadeTransitionGroup',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'block',
  position: 'relative'
});

/**
 * @ignore - do not document.
 */
function PickersFadeTransitionGroup(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersFadeTransitionGroup'
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
  } = props;
  const classes = useUtilityClasses$W(props);
  if (reduceAnimations) {
    return children;
  }
  return /*#__PURE__*/jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(classes.root, className),
    children: /*#__PURE__*/jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: animationDuration,
        enter: animationDuration / 2,
        exit: 0
      },
      children: children
    }, transKey)
  });
}

const getPickersSlideTransitionUtilityClass = slot => generateUtilityClass('MuiPickersSlideTransition', slot);
const pickersSlideTransitionClasses = generateUtilityClasses('MuiPickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);

const _excluded$1u = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"];
const useUtilityClasses$V = ownerState => {
  const {
    classes,
    slideDirection
  } = ownerState;
  const slots = {
    root: ['root'],
    exit: ['slideExit'],
    enterActive: ['slideEnterActive'],
    enter: [`slideEnter-${slideDirection}`],
    exitActive: [`slideExitActiveLeft-${slideDirection}`]
  };
  return composeClasses(slots, getPickersSlideTransitionUtilityClass, classes);
};
const slideAnimationDuration = 350;
const PickersSlideTransitionRoot = styled$3(TransitionGroup$1, {
  name: 'MuiPickersSlideTransition',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root, {
    [`.${pickersSlideTransitionClasses['slideEnter-left']}`]: styles['slideEnter-left']
  }, {
    [`.${pickersSlideTransitionClasses['slideEnter-right']}`]: styles['slideEnter-right']
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
  }, {
    [`.${pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
  }, {
    [`.${pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
  }]
})(({
  theme
}) => {
  const slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses['slideEnter-left']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses['slideEnter-right']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: 'translate(0%)'
    },
    [`& .${pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }
  };
});

/**
 * @ignore - do not document.
 */
function PickersSlideTransition(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersSlideTransition'
  });
  const {
      children,
      className,
      reduceAnimations,
      transKey
      // extracting `classes` from `other`
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1u);
  const classes = useUtilityClasses$V(props);
  if (reduceAnimations) {
    return /*#__PURE__*/jsx("div", {
      className: clsx(classes.root, className),
      children: children
    });
  }
  const transitionClasses = {
    exit: classes.exit,
    enterActive: classes.enterActive,
    enter: classes.enter,
    exitActive: classes.exitActive
  };
  return /*#__PURE__*/jsx(PickersSlideTransitionRoot, {
    className: clsx(classes.root, className),
    childFactory: element => /*#__PURE__*/React$1.cloneElement(element, {
      classNames: transitionClasses
    }),
    role: "presentation",
    children: /*#__PURE__*/jsx(CSSTransition$1, _extends$c({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: slideAnimationDuration,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
}

const getDayCalendarUtilityClass = slot => generateUtilityClass('MuiDayCalendar', slot);
generateUtilityClasses('MuiDayCalendar', ['header', 'weekDayLabel', 'loadingContainer', 'slideTransition', 'monthContainer', 'weekContainer', 'weekNumberLabel', 'weekNumber']);

const _excluded$1t = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"],
  _excluded2$d = ["ownerState"];
const useUtilityClasses$U = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    header: ['header'],
    weekDayLabel: ['weekDayLabel'],
    loadingContainer: ['loadingContainer'],
    slideTransition: ['slideTransition'],
    monthContainer: ['monthContainer'],
    weekContainer: ['weekContainer'],
    weekNumberLabel: ['weekNumberLabel'],
    weekNumber: ['weekNumber']
  };
  return composeClasses(slots, getDayCalendarUtilityClass, classes);
};
const defaultDayOfWeekFormatter = day => day.charAt(0).toUpperCase();
const weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6;
const PickersCalendarDayHeader = styled$3('div', {
  name: 'MuiDayCalendar',
  slot: 'Header',
  overridesResolver: (_, styles) => styles.header
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const PickersCalendarWeekDayLabel = styled$3(Typography, {
  name: 'MuiDayCalendar',
  slot: 'WeekDayLabel',
  overridesResolver: (_, styles) => styles.weekDayLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: (theme.vars || theme).palette.text.secondary
}));
const PickersCalendarWeekNumberLabel = styled$3(Typography, {
  name: 'MuiDayPicker',
  slot: 'WeekNumberLabel',
  overridesResolver: (_, styles) => styles.weekNumberLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.disabled
}));
const PickersCalendarWeekNumber = styled$3(Typography, {
  name: 'MuiDayPicker',
  slot: 'WeekNumber',
  overridesResolver: (_, styles) => styles.weekNumber
})(({
  theme
}) => _extends$c({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: theme.palette.text.disabled,
  fontSize: '0.75rem',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'inline-flex'
}));
const PickersCalendarLoadingContainer = styled$3('div', {
  name: 'MuiDayCalendar',
  slot: 'LoadingContainer',
  overridesResolver: (_, styles) => styles.loadingContainer
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = styled$3(PickersSlideTransition, {
  name: 'MuiDayCalendar',
  slot: 'SlideTransition',
  overridesResolver: (_, styles) => styles.slideTransition
})({
  minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = styled$3('div', {
  name: 'MuiDayCalendar',
  slot: 'MonthContainer',
  overridesResolver: (_, styles) => styles.monthContainer
})({
  overflow: 'hidden'
});
const PickersCalendarWeek = styled$3('div', {
  name: 'MuiDayCalendar',
  slot: 'WeekContainer',
  overridesResolver: (_, styles) => styles.weekContainer
})({
  margin: `${DAY_MARGIN}px 0`,
  display: 'flex',
  justifyContent: 'center'
});
function WrappedDay(_ref) {
  var _ref2, _slots$day, _slotProps$day;
  let {
      parentProps,
      day,
      focusableDay,
      selectedDays,
      isDateDisabled,
      currentMonthNumber,
      isViewFocused
    } = _ref,
    other = _objectWithoutPropertiesLoose$b(_ref, _excluded$1t);
  const {
    disabled,
    disableHighlightToday,
    isMonthSwitchingAnimating,
    showDaysOutsideCurrentMonth,
    components,
    componentsProps,
    slots,
    slotProps,
    timezone
  } = parentProps;
  const utils = useUtils();
  const now = useNow(timezone);
  const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
  const isSelected = selectedDays.some(selectedDay => utils.isSameDay(selectedDay, day));
  const isToday = utils.isSameDay(day, now);
  const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : PickersDay;
  // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
  const _useSlotProps = useSlotProps({
      elementType: Day,
      externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
      additionalProps: _extends$c({
        disableHighlightToday,
        showDaysOutsideCurrentMonth,
        role: 'gridcell',
        isAnimating: isMonthSwitchingAnimating,
        // it is used in date range dragging logic by accessing `dataset.timestamp`
        'data-timestamp': utils.toJsDate(day).valueOf()
      }, other),
      ownerState: _extends$c({}, parentProps, {
        day,
        selected: isSelected
      })
    }),
    dayProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$d);
  const isDisabled = React$1.useMemo(() => disabled || isDateDisabled(day), [disabled, isDateDisabled, day]);
  const outsideCurrentMonth = React$1.useMemo(() => utils.getMonth(day) !== currentMonthNumber, [utils, day, currentMonthNumber]);
  const isFirstVisibleCell = React$1.useMemo(() => {
    const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, startOfMonth);
    }
    return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  const isLastVisibleCell = React$1.useMemo(() => {
    const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, endOfMonth);
    }
    return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  return /*#__PURE__*/jsx(Day, _extends$c({}, dayProps, {
    day: day,
    disabled: isDisabled,
    autoFocus: isViewFocused && isFocusableDay,
    today: isToday,
    outsideCurrentMonth: outsideCurrentMonth,
    isFirstVisibleCell: isFirstVisibleCell,
    isLastVisibleCell: isLastVisibleCell,
    selected: isSelected,
    tabIndex: isFocusableDay ? 0 : -1,
    "aria-selected": isSelected,
    "aria-current": isToday ? 'date' : undefined
  }));
}

/**
 * @ignore - do not document.
 */
function DayCalendar(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDayCalendar'
  });
  const {
    onFocusedDayChange,
    className,
    currentMonth,
    selectedDays,
    focusedDay,
    loading,
    onSelectedDaysChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderLoading = () => /*#__PURE__*/jsx("span", {
      children: "..."
    }),
    slideDirection,
    TransitionProps,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    dayOfWeekFormatter = defaultDayOfWeekFormatter,
    hasFocus,
    onFocusedViewChange,
    gridLabelId,
    displayWeekNumber,
    fixedWeekNumber,
    autoFocus,
    timezone
  } = props;
  const now = useNow(timezone);
  const utils = useUtils();
  const classes = useUtilityClasses$U(props);
  const theme = useTheme$3();
  const isRTL = theme.direction === 'rtl';
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    timezone
  });
  const localeText = useLocaleText();
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'DayCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const [internalFocusedDay, setInternalFocusedDay] = React$1.useState(() => focusedDay || now);
  const handleDaySelect = useEventCallback(day => {
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day);
  });
  const focusDay = day => {
    if (!isDateDisabled(day)) {
      onFocusedDayChange(day);
      setInternalFocusedDay(day);
      onFocusedViewChange == null || onFocusedViewChange(true);
      setInternalHasFocus(true);
    }
  };
  const handleKeyDown = useEventCallback((event, day) => {
    switch (event.key) {
      case 'ArrowUp':
        focusDay(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusDay(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case 'ArrowLeft':
        {
          const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
          const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
          const closestDayToFocus = findClosestEnabledDate({
            utils,
            date: newFocusedDayDefault,
            minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
            maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'ArrowRight':
        {
          const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
          const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
          const closestDayToFocus = findClosestEnabledDate({
            utils,
            date: newFocusedDayDefault,
            minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'Home':
        focusDay(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case 'End':
        focusDay(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case 'PageUp':
        focusDay(utils.addMonths(day, 1));
        event.preventDefault();
        break;
      case 'PageDown':
        focusDay(utils.addMonths(day, -1));
        event.preventDefault();
        break;
    }
  });
  const handleFocus = useEventCallback((event, day) => focusDay(day));
  const handleBlur = useEventCallback((event, day) => {
    if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) {
      onFocusedViewChange == null || onFocusedViewChange(false);
    }
  });
  const currentMonthNumber = utils.getMonth(currentMonth);
  const validSelectedDays = React$1.useMemo(() => selectedDays.filter(day => !!day).map(day => utils.startOfDay(day)), [utils, selectedDays]);

  // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
  const transitionKey = currentMonthNumber;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const slideNodeRef = React$1.useMemo(() => /*#__PURE__*/React$1.createRef(), [transitionKey]);
  const startOfCurrentWeek = utils.startOfWeek(now);
  const focusableDay = React$1.useMemo(() => {
    const startOfMonth = utils.startOfMonth(currentMonth);
    const endOfMonth = utils.endOfMonth(currentMonth);
    if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) {
      return findClosestEnabledDate({
        utils,
        date: internalFocusedDay,
        minDate: startOfMonth,
        maxDate: endOfMonth,
        disablePast,
        disableFuture,
        isDateDisabled,
        timezone
      });
    }
    return internalFocusedDay;
  }, [currentMonth, disableFuture, disablePast, internalFocusedDay, isDateDisabled, utils, timezone]);
  const weeksToDisplay = React$1.useMemo(() => {
    const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
    const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
    let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
    while (fixedWeekNumber && toDisplay.length < fixedWeekNumber) {
      const additionalWeeks = utils.getWeekArray(nextMonth);
      const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
      additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach(week => {
        if (toDisplay.length < fixedWeekNumber) {
          toDisplay.push(week);
        }
      });
      nextMonth = utils.addMonths(nextMonth, 1);
    }
    return toDisplay;
  }, [currentMonth, fixedWeekNumber, utils, timezone]);
  return /*#__PURE__*/jsxs("div", {
    role: "grid",
    "aria-labelledby": gridLabelId,
    children: [/*#__PURE__*/jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: classes.header,
      children: [displayWeekNumber && /*#__PURE__*/jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": localeText.calendarWeekNumberHeaderLabel,
        className: classes.weekNumberLabel,
        children: localeText.calendarWeekNumberHeaderText
      }), utils.getWeekdays().map((day, i) => {
        var _dayOfWeekFormatter;
        return /*#__PURE__*/jsx(PickersCalendarWeekDayLabel, {
          variant: "caption",
          role: "columnheader",
          "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
          className: classes.weekDayLabel,
          children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
        }, day + i.toString());
      })]
    }), loading ? /*#__PURE__*/jsx(PickersCalendarLoadingContainer, {
      className: classes.loadingContainer,
      children: renderLoading()
    }) : /*#__PURE__*/jsx(PickersCalendarSlideTransition, _extends$c({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: clsx(className, classes.slideTransition)
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/jsx(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "rowgroup",
        className: classes.monthContainer,
        children: weeksToDisplay.map((week, index) => /*#__PURE__*/jsxs(PickersCalendarWeek, {
          role: "row",
          className: classes.weekContainer
          // fix issue of announcing row 1 as row 2
          // caused by week day labels row
          ,
          "aria-rowindex": index + 1,
          children: [displayWeekNumber && /*#__PURE__*/jsx(PickersCalendarWeekNumber, {
            className: classes.weekNumber,
            role: "rowheader",
            "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
            children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
          }), week.map((day, dayIndex) => /*#__PURE__*/jsx(WrappedDay, {
            parentProps: props,
            day: day,
            selectedDays: validSelectedDays,
            focusableDay: focusableDay,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onDaySelect: handleDaySelect,
            isDateDisabled: isDateDisabled,
            currentMonthNumber: currentMonthNumber,
            isViewFocused: internalHasFocus
            // fix issue of announcing column 1 as column 2 when `displayWeekNumber` is enabled
            ,
            "aria-colindex": dayIndex + 1
          }, day.toString()))]
        }, `week-${week[0]}`))
      })
    }))]
  });
}

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$1 (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$2('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$2 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$2(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse$2(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$2(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$4 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs = requireReactIs();
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React$1['useInsertion' + 'Effect'] ? React$1['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */React$1.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React$1.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */React$1.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React$1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React$1.useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React$1.createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser = typeof document !== 'undefined';

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React$1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var createStyled$1 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = React$1.useContext(ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React$1.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$c({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$1.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

if (typeof document === 'object') {
  createCache({
    key: 'css',
    prepend: true
  });
}
process.env.NODE_ENV !== "production" ? {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
} : void 0;

process.env.NODE_ENV !== "production" ? {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;

/**
 * @mui/styled-engine v5.14.13
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function styled$2(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

const _excluded$1s = ["values", "unit", "step"];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$c({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },

      unit = 'px',
      step = 5
    } = breakpoints,
    other = _objectWithoutPropertiesLoose$b(breakpoints, _excluded$1s);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return _extends$c({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};

const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (typeof value === 'object') {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`MUI: The value found in theme for prop: "${propValueFinal}" is an [Object] instead of string or number. Check if you forgot to add the correct dotted notation, eg, "background.paper" instead of "background".`);
    }
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};

// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
/* tslint:disable:unified-signatures */
/* tslint:enable:unified-signatures */

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
const border = style$1({
  prop: 'border',
  themeKey: 'borders',
  transform: borderTransform
});
const borderTop = style$1({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: borderTransform
});
const borderRight = style$1({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: borderTransform
});
const borderBottom = style$1({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: borderTransform
});
const borderLeft = style$1({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: borderTransform
});
const borderColor = style$1({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = style$1({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = style$1({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = style$1({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = style$1({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ['borderRadius'];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);

// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$1({
  prop: 'gridColumn'
});
const gridRow = style$1({
  prop: 'gridRow'
});
const gridAutoFlow = style$1({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$1({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$1({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$1({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$1({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$1({
  prop: 'gridTemplateAreas'
});
const gridArea = style$1({
  prop: 'gridArea'
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = style$1({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$1({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$1({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = style$1({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = style$1({
  prop: 'minHeight',
  transform: sizingTransform
});
style$1({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style$1({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: 'boxSizing'
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }

    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];

const _excluded$1r = ["breakpoints", "palette", "spacing", "shape"];
function createTheme(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = _objectWithoutPropertiesLoose$b(options, _excluded$1r);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$c({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$c({}, shape, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$c({}, defaultSxConfig, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$1(defaultTheme = null) {
  const contextTheme = React$1.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme();
function useTheme(defaultTheme = systemDefaultTheme$1) {
  return useTheme$1(defaultTheme);
}

const _excluded$1q = ["variant"];
function isEmpty$1(string) {
  return string.length === 0;
}

/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */
function propsToClassKey(props) {
  const {
      variant
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1q);
  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty$1(classKey) ? props[key] : capitalize(props[key]);
    } else {
      classKey += `${isEmpty$1(classKey) ? key : capitalize(key)}${capitalize(props[key].toString())}`;
    }
  });
  return classKey;
}

const _excluded$1p = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }
  return null;
};
const transformVariants = variants => {
  const variantsStyles = {};
  if (variants) {
    variants.forEach(definition => {
      const key = propsToClassKey(definition.props);
      variantsStyles[key] = definition.style;
    });
  }
  return variantsStyles;
};
const getVariantStyles = (name, theme) => {
  let variants = [];
  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }
  return transformVariants(variants);
};
const variantsResolver = (props, styles, variants) => {
  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  if (variants) {
    variants.forEach(variant => {
      let isMatch = true;
      Object.keys(variant.props).forEach(key => {
        if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) {
          isMatch = false;
        }
      });
      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(variant.props)]);
      }
    });
  }
  return variantsStyles;
};
const themeVariantsResolver = (props, styles, theme, name) => {
  var _theme$components;
  const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
  return variantsResolver(props, styles, themeVariants);
};

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createTheme();
const lowercaseFirstLetter = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
const muiStyledFunctionResolver = ({
  styledArg,
  props,
  defaultTheme,
  themeId
}) => {
  const resolvedStyles = styledArg(_extends$c({}, props, {
    theme: resolveTheme(_extends$c({}, props, {
      defaultTheme,
      themeId
    }))
  }));
  let optionalVariants;
  if (resolvedStyles && resolvedStyles.variants) {
    optionalVariants = resolvedStyles.variants;
    delete resolvedStyles.variants;
  }
  if (optionalVariants) {
    const variantsStyles = variantsResolver(props, transformVariants(optionalVariants), optionalVariants);
    return [resolvedStyles, ...variantsStyles];
  }
  return resolvedStyles;
};
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return styleFunctionSx(_extends$c({}, props, {
      theme: resolveTheme(_extends$c({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    internal_processStyles(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions,
      options = _objectWithoutPropertiesLoose$b(inputOptions, _excluded$1p);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = styled$2(tag, _extends$c({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg) {
          return props => muiStyledFunctionResolver({
            styledArg: stylesArg,
            props,
            defaultTheme,
            themeId
          });
        }
        if (isPlainObject(stylesArg)) {
          let transformedStylesArg = stylesArg;
          let styledArgVariants;
          if (stylesArg && stylesArg.variants) {
            styledArgVariants = stylesArg.variants;
            delete transformedStylesArg.variants;
            transformedStylesArg = props => {
              let result = stylesArg;
              const variantStyles = variantsResolver(props, transformVariants(styledArgVariants), styledArgVariants);
              variantStyles.forEach(variantStyle => {
                result = deepmerge(result, variantStyle);
              });
              return result;
            };
          }
          return transformedStylesArg;
        }
        return stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;
      if (isPlainObject(styleArg)) {
        let styledArgVariants;
        if (styleArg && styleArg.variants) {
          styledArgVariants = styleArg.variants;
          delete transformedStyleArg.variants;
          transformedStyleArg = props => {
            let result = styleArg;
            const variantStyles = variantsResolver(props, transformVariants(styledArgVariants), styledArgVariants);
            variantStyles.forEach(variantStyle => {
              result = deepmerge(result, variantStyle);
            });
            return result;
          };
        }
      } else if (typeof styleArg === 'function' &&
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = props => muiStyledFunctionResolver({
          styledArg: styleArg,
          props,
          defaultTheme,
          themeId
        });
      }
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme(_extends$c({}, props, {
            defaultTheme,
            themeId
          }));
          const styleOverrides = getStyleOverrides(componentName, theme);
          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle(_extends$c({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }
          return null;
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme(_extends$c({}, props, {
            defaultTheme,
            themeId
          }));
          return themeVariantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== 'production') {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${capitalize(componentSlot || '')}`;
        }
        if (displayName === undefined) {
          displayName = `Styled(${getDisplayName(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

const styled = createStyled();
var styled$1 = styled;

function getPickersMonthUtilityClass(slot) {
  return generateUtilityClass('MuiPickersMonth', slot);
}
const pickersMonthClasses = generateUtilityClasses('MuiPickersMonth', ['root', 'monthButton', 'disabled', 'selected']);

const _excluded$1o = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow"];
const useUtilityClasses$T = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    monthButton: ['monthButton', disabled && 'disabled', selected && 'selected']
  };
  return composeClasses(slots, getPickersMonthUtilityClass, classes);
};
const PickersMonthRoot = styled$3('div', {
  name: 'MuiPickersMonth',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})(({
  ownerState
}) => ({
  flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
const PickersMonthButton = styled$3('button', {
  name: 'MuiPickersMonth',
  slot: 'MonthButton',
  overridesResolver: (_, styles) => [styles.monthButton, {
    [`&.${pickersMonthClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersMonthClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends$c({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersMonthClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersMonthClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - do not document.
 */
const PickersMonth = /*#__PURE__*/React$1.memo(function PickersMonth(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersMonth'
  });
  const {
      autoFocus,
      children,
      disabled,
      selected,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent,
      'aria-label': ariaLabel
      // We don't want to forward this prop to the root element
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1o);
  const ref = React$1.useRef(null);
  const classes = useUtilityClasses$T(props);
  useEnhancedEffect(() => {
    if (autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) == null || _ref$current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/jsx(PickersMonthRoot, _extends$c({
    className: classes.root,
    ownerState: props
  }, other, {
    children: /*#__PURE__*/jsx(PickersMonthButton, {
      ref: ref,
      disabled: disabled,
      type: "button",
      role: "radio",
      tabIndex: disabled ? -1 : tabIndex,
      "aria-current": ariaCurrent,
      "aria-checked": selected,
      "aria-label": ariaLabel,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value),
      className: classes.monthButton,
      ownerState: props,
      children: children
    })
  }));
});

function getMonthCalendarUtilityClass(slot) {
  return generateUtilityClass('MuiMonthCalendar', slot);
}
generateUtilityClasses('MuiMonthCalendar', ['root']);

const _excluded$1n = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId"];
const useUtilityClasses$S = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends$c({
    disableFuture: false,
    disablePast: false
  }, themeProps, {
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const MonthCalendarRoot = styled$3('div', {
  name: 'MuiMonthCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'stretch',
  padding: '0 4px',
  width: 320
});
const MonthCalendar = /*#__PURE__*/React$1.forwardRef(function MonthCalendar(inProps, ref) {
  const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
  const {
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      shouldDisableMonth,
      readOnly,
      disableHighlightToday,
      autoFocus = false,
      onMonthFocus,
      hasFocus,
      onFocusedViewChange,
      monthsPerRow = 3,
      timezone: timezoneProp,
      gridLabelId
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1n);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'MonthCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange: onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const theme = useTheme();
  const utils = useUtils();
  const referenceDate = React$1.useMemo(() => singleItemValueManager.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: SECTION_TYPE_GRANULARITY.month
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const ownerState = props;
  const classes = useUtilityClasses$S(ownerState);
  const todayMonth = React$1.useMemo(() => utils.getMonth(now), [utils, now]);
  const selectedMonth = React$1.useMemo(() => {
    if (value != null) {
      return utils.getMonth(value);
    }
    if (disableHighlightToday) {
      return null;
    }
    return utils.getMonth(referenceDate);
  }, [value, utils, disableHighlightToday, referenceDate]);
  const [focusedMonth, setFocusedMonth] = React$1.useState(() => selectedMonth || todayMonth);
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'MonthCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const changeHasFocus = useEventCallback(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isMonthDisabled = React$1.useCallback(dateToValidate => {
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    const monthToValidate = utils.startOfMonth(dateToValidate);
    if (utils.isBefore(monthToValidate, firstEnabledMonth)) {
      return true;
    }
    if (utils.isAfter(monthToValidate, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(monthToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableMonth, utils]);
  const handleMonthSelection = useEventCallback((event, month) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setMonth(value != null ? value : referenceDate, month);
    handleValueChange(newDate);
  });
  const focusMonth = useEventCallback(month => {
    if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
      setFocusedMonth(month);
      changeHasFocus(true);
      if (onMonthFocus) {
        onMonthFocus(month);
      }
    }
  });
  React$1.useEffect(() => {
    setFocusedMonth(prevFocusedMonth => selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
  }, [selectedMonth]);
  const handleKeyDown = useEventCallback((event, month) => {
    const monthsInYear = 12;
    const monthsInRow = 3;
    switch (event.key) {
      case 'ArrowUp':
        focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
        event.preventDefault();
        break;
    }
  });
  const handleMonthFocus = useEventCallback((event, month) => {
    focusMonth(month);
  });
  const handleMonthBlur = useEventCallback((event, month) => {
    if (focusedMonth === month) {
      changeHasFocus(false);
    }
  });
  return /*#__PURE__*/jsx(MonthCalendarRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: getMonthsInYear(utils, value != null ? value : referenceDate).map(month => {
      const monthNumber = utils.getMonth(month);
      const monthText = utils.format(month, 'monthShort');
      const monthLabel = utils.format(month, 'month');
      const isSelected = monthNumber === selectedMonth;
      const isDisabled = disabled || isMonthDisabled(month);
      return /*#__PURE__*/jsx(PickersMonth, {
        selected: isSelected,
        value: monthNumber,
        onClick: handleMonthSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && monthNumber === focusedMonth,
        disabled: isDisabled,
        tabIndex: monthNumber === focusedMonth ? 0 : -1,
        onFocus: handleMonthFocus,
        onBlur: handleMonthBlur,
        "aria-current": todayMonth === monthNumber ? 'date' : undefined,
        "aria-label": monthLabel,
        monthsPerRow: monthsPerRow,
        children: monthText
      }, monthText);
    })
  }));
});
process.env.NODE_ENV !== "production" ? MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onMonthFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: PropTypes.any,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any
} : void 0;

function getPickersYearUtilityClass(slot) {
  return generateUtilityClass('MuiPickersYear', slot);
}
const pickersYearClasses = generateUtilityClasses('MuiPickersYear', ['root', 'yearButton', 'selected', 'disabled']);

const _excluded$1m = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"];
const useUtilityClasses$R = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
  };
  return composeClasses(slots, getPickersYearUtilityClass, classes);
};
const PickersYearRoot = styled$3('div', {
  name: 'MuiPickersYear',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})(({
  ownerState
}) => ({
  flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
const PickersYearButton = styled$3('button', {
  name: 'MuiPickersYear',
  slot: 'YearButton',
  overridesResolver: (_, styles) => [styles.yearButton, {
    [`&.${pickersYearClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersYearClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends$c({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha(theme.palette.action.active, theme.palette.action.focusOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - internal component.
 */
const PickersYear = /*#__PURE__*/React$1.memo(function PickersYear(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersYear'
  });
  const {
      autoFocus,
      className,
      children,
      disabled,
      selected,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent
      // We don't want to forward this prop to the root element
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1m);
  const ref = React$1.useRef(null);
  const classes = useUtilityClasses$R(props);

  // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
  React$1.useEffect(() => {
    if (autoFocus) {
      // `ref.current` being `null` would be a bug in MUI.
      ref.current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/jsx(PickersYearRoot, _extends$c({
    className: clsx(classes.root, className),
    ownerState: props
  }, other, {
    children: /*#__PURE__*/jsx(PickersYearButton, {
      ref: ref,
      disabled: disabled,
      type: "button",
      role: "radio",
      tabIndex: disabled ? -1 : tabIndex,
      "aria-current": ariaCurrent,
      "aria-checked": selected,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value),
      className: classes.yearButton,
      ownerState: props,
      children: children
    })
  }));
});

function getYearCalendarUtilityClass(slot) {
  return generateUtilityClass('MuiYearCalendar', slot);
}
generateUtilityClasses('MuiYearCalendar', ['root']);

const _excluded$1l = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"];
const useUtilityClasses$Q = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends$c({
    disablePast: false,
    disableFuture: false
  }, themeProps, {
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const YearCalendarRoot = styled$3('div', {
  name: 'MuiYearCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  height: '100%',
  padding: '0 4px',
  width: 320,
  maxHeight: 304,
  // avoid padding increasing width over defined
  boxSizing: 'border-box',
  position: 'relative'
});
const YearCalendar = /*#__PURE__*/React$1.forwardRef(function YearCalendar(inProps, ref) {
  const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
  const {
      autoFocus,
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      readOnly,
      shouldDisableYear,
      disableHighlightToday,
      onYearFocus,
      hasFocus,
      onFocusedViewChange,
      yearsPerRow = 3,
      timezone: timezoneProp,
      gridLabelId
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1l);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'YearCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange: onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const theme = useTheme();
  const utils = useUtils();
  const referenceDate = React$1.useMemo(() => singleItemValueManager.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: SECTION_TYPE_GRANULARITY.year
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const ownerState = props;
  const classes = useUtilityClasses$Q(ownerState);
  const todayYear = React$1.useMemo(() => utils.getYear(now), [utils, now]);
  const selectedYear = React$1.useMemo(() => {
    if (value != null) {
      return utils.getYear(value);
    }
    if (disableHighlightToday) {
      return null;
    }
    return utils.getYear(referenceDate);
  }, [value, utils, disableHighlightToday, referenceDate]);
  const [focusedYear, setFocusedYear] = React$1.useState(() => selectedYear || todayYear);
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'YearCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const changeHasFocus = useEventCallback(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isYearDisabled = React$1.useCallback(dateToValidate => {
    if (disablePast && utils.isBeforeYear(dateToValidate, now)) {
      return true;
    }
    if (disableFuture && utils.isAfterYear(dateToValidate, now)) {
      return true;
    }
    if (minDate && utils.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (!shouldDisableYear) {
      return false;
    }
    const yearToValidate = utils.startOfYear(dateToValidate);
    return shouldDisableYear(yearToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableYear, utils]);
  const handleYearSelection = useEventCallback((event, year) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setYear(value != null ? value : referenceDate, year);
    handleValueChange(newDate);
  });
  const focusYear = useEventCallback(year => {
    if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
      setFocusedYear(year);
      changeHasFocus(true);
      onYearFocus == null || onYearFocus(year);
    }
  });
  React$1.useEffect(() => {
    setFocusedYear(prevFocusedYear => selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
  }, [selectedYear]);
  const handleKeyDown = useEventCallback((event, year) => {
    switch (event.key) {
      case 'ArrowUp':
        focusYear(year - yearsPerRow);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusYear(year + yearsPerRow);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
    }
  });
  const handleYearFocus = useEventCallback((event, year) => {
    focusYear(year);
  });
  const handleYearBlur = useEventCallback((event, year) => {
    if (focusedYear === year) {
      changeHasFocus(false);
    }
  });
  const scrollerRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, scrollerRef);
  React$1.useEffect(() => {
    if (autoFocus || scrollerRef.current === null) {
      return;
    }
    const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
    if (!tabbableButton) {
      return;
    }

    // Taken from useScroll in x-data-grid, but vertically centered
    const offsetHeight = tabbableButton.offsetHeight;
    const offsetTop = tabbableButton.offsetTop;
    const clientHeight = scrollerRef.current.clientHeight;
    const scrollTop = scrollerRef.current.scrollTop;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight || offsetTop < scrollTop) {
      // Button already visible
      return;
    }
    scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
  }, [autoFocus]);
  return /*#__PURE__*/jsx(YearCalendarRoot, _extends$c({
    ref: handleRef,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: utils.getYearRange(minDate, maxDate).map(year => {
      const yearNumber = utils.getYear(year);
      const isSelected = yearNumber === selectedYear;
      const isDisabled = disabled || isYearDisabled(year);
      return /*#__PURE__*/jsx(PickersYear, {
        selected: isSelected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && yearNumber === focusedYear,
        disabled: isDisabled,
        tabIndex: yearNumber === focusedYear ? 0 : -1,
        onFocus: handleYearFocus,
        onBlur: handleYearBlur,
        "aria-current": todayYear === yearNumber ? 'date' : undefined,
        yearsPerRow: yearsPerRow,
        children: utils.format(year, 'year')
      }, utils.format(year, 'year'));
    })
  }));
});
process.env.NODE_ENV !== "production" ? YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onYearFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: PropTypes.any,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;

const getPickersCalendarHeaderUtilityClass = slot => generateUtilityClass('MuiPickersCalendarHeader', slot);
const pickersCalendarHeaderClasses = generateUtilityClasses('MuiPickersCalendarHeader', ['root', 'labelContainer', 'label', 'switchViewButton', 'switchViewIcon']);

const _excluded$1k = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone"],
  _excluded2$c = ["ownerState"];
const useUtilityClasses$P = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    labelContainer: ['labelContainer'],
    label: ['label'],
    switchViewButton: ['switchViewButton'],
    switchViewIcon: ['switchViewIcon']
  };
  return composeClasses(slots, getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = styled$3('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'flex',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
});
const PickersCalendarHeaderLabelContainer = styled$3('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'LabelContainer',
  overridesResolver: (_, styles) => styles.labelContainer
})(({
  theme
}) => _extends$c({
  display: 'flex',
  overflow: 'hidden',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 'auto'
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
const PickersCalendarHeaderLabel = styled$3('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Label',
  overridesResolver: (_, styles) => styles.label
})({
  marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = styled$3(IconButton$1, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewButton',
  overridesResolver: (_, styles) => styles.switchViewButton
})(({
  ownerState
}) => _extends$c({
  marginRight: 'auto'
}, ownerState.view === 'year' && {
  [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
    transform: 'rotate(180deg)'
  }
}));
const PickersCalendarHeaderSwitchViewIcon = styled$3(ArrowDropDownIcon, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewIcon',
  overridesResolver: (_, styles) => styles.switchViewIcon
})(({
  theme
}) => ({
  willChange: 'transform',
  transition: theme.transitions.create('transform'),
  transform: 'rotate(0deg)'
}));
const PickersCalendarHeader = /*#__PURE__*/React$1.forwardRef(function PickersCalendarHeader(inProps, ref) {
  var _slots$switchViewButt, _slots$switchViewIcon;
  const localeText = useLocaleText();
  const utils = useUtils();
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersCalendarHeader'
  });
  const {
      slots,
      slotProps,
      currentMonth: month,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onMonthChange,
      onViewChange,
      view,
      reduceAnimations,
      views,
      labelId,
      className,
      timezone
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1k);
  const ownerState = props;
  const classes = useUtilityClasses$P(props);
  const SwitchViewButton = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : PickersCalendarHeaderSwitchViewButton;
  const switchViewButtonProps = useSlotProps({
    elementType: SwitchViewButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
    additionalProps: {
      size: 'small',
      'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
    },
    ownerState,
    className: classes.switchViewButton
  });
  const SwitchViewIcon = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : PickersCalendarHeaderSwitchViewIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = useSlotProps({
      elementType: SwitchViewIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
      ownerState: undefined,
      className: classes.switchViewIcon
    }),
    switchViewIconProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$c);
  const selectNextMonth = () => onMonthChange(utils.addMonths(month, 1), 'left');
  const selectPreviousMonth = () => onMonthChange(utils.addMonths(month, -1), 'right');
  const isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture,
    maxDate,
    timezone
  });
  const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast,
    minDate,
    timezone
  });
  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find(el => el !== view) || views[0]);
    } else {
      // switching only between first 2
      const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };

  // No need to display more information
  if (views.length === 1 && views[0] === 'year') {
    return null;
  }
  return /*#__PURE__*/jsxs(PickersCalendarHeaderRoot, _extends$c({}, other, {
    ownerState: ownerState,
    className: clsx(className, classes.root),
    ref: ref,
    children: [/*#__PURE__*/jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState
      // putting this on the label item element below breaks when using transition
      ,
      "aria-live": "polite",
      className: classes.labelContainer,
      children: [/*#__PURE__*/jsx(PickersFadeTransitionGroup, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'monthAndYear'),
        children: /*#__PURE__*/jsx(PickersCalendarHeaderLabel, {
          id: labelId,
          ownerState: ownerState,
          className: classes.label,
          children: utils.format(month, 'monthAndYear')
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/jsx(SwitchViewButton, _extends$c({}, switchViewButtonProps, {
        children: /*#__PURE__*/jsx(SwitchViewIcon, _extends$c({}, switchViewIconProps))
      }))]
    }), /*#__PURE__*/jsx(Fade, {
      in: view === 'day',
      children: /*#__PURE__*/jsx(PickersArrowSwitcher, {
        slots: slots,
        slotProps: slotProps,
        onGoToPrevious: selectPreviousMonth,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: localeText.previousMonth,
        onGoToNext: selectNextMonth,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: localeText.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  currentMonth: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  labelId: PropTypes.string,
  maxDate: PropTypes.any.isRequired,
  minDate: PropTypes.any.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onViewChange: PropTypes.func,
  reduceAnimations: PropTypes.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timezone: PropTypes.string.isRequired,
  view: PropTypes.oneOf(['day', 'month', 'year']).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired).isRequired
} : void 0;

const PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';

// detect if user agent has Android version < 10 or iOS version < 13
const mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
const useDefaultReduceAnimations = () => {
  const prefersReduced = useMediaQuery$1(PREFERS_REDUCED_MOTION, {
    defaultMatches: false
  });
  return prefersReduced || slowAnimationDevices;
};

const getDateCalendarUtilityClass = slot => generateUtilityClass('MuiDateCalendar', slot);
generateUtilityClasses('MuiDateCalendar', ['root', 'viewTransitionContainer']);

const _excluded$1j = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "components", "componentsProps", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"];
const useUtilityClasses$O = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    viewTransitionContainer: ['viewTransitionContainer']
  };
  return composeClasses(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
  var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const defaultReduceAnimations = useDefaultReduceAnimations();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends$c({}, themeProps, {
    loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
    disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
    disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
    openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : 'day',
    views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : ['year', 'day'],
    reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
    renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : () => /*#__PURE__*/jsx("span", {
      children: "..."
    }),
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const DateCalendarRoot = styled$3(PickerViewRoot, {
  name: 'MuiDateCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column'
});
const DateCalendarViewTransitionContainer = styled$3(PickersFadeTransitionGroup, {
  name: 'MuiDateCalendar',
  slot: 'ViewTransitionContainer',
  overridesResolver: (props, styles) => styles.viewTransitionContainer
})({});
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */
const DateCalendar = /*#__PURE__*/React$1.forwardRef(function DateCalendar(inProps, ref) {
  var _ref, _slots$calendarHeader, _slotProps$calendarHe;
  const utils = useUtils();
  const id = useId();
  const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
  const {
      autoFocus,
      onViewChange,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disableFuture,
      disablePast,
      defaultCalendarMonth,
      onChange,
      onYearChange,
      onMonthChange,
      reduceAnimations,
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      view: inView,
      views,
      openTo,
      className,
      disabled,
      readOnly,
      minDate,
      maxDate,
      disableHighlightToday,
      focusedView: inFocusedView,
      onFocusedViewChange,
      showDaysOutsideCurrentMonth,
      fixedWeekNumber,
      dayOfWeekFormatter,
      components,
      componentsProps,
      slots,
      slotProps,
      loading,
      renderLoading,
      displayWeekNumber,
      yearsPerRow,
      monthsPerRow,
      timezone: timezoneProp
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1j);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'DateCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager: singleItemValueManager
  });
  const {
    view,
    setView,
    focusedView,
    setFocusedView,
    goToNextView,
    setValueAndGoToNextView
  } = useViews({
    view: inView,
    views,
    openTo,
    onChange: handleValueChange,
    onViewChange,
    autoFocus,
    focusedView: inFocusedView,
    onFocusedViewChange
  });
  const {
    referenceDate,
    calendarState,
    changeFocusedDay,
    changeMonth,
    handleChangeMonth,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  } = useCalendarState({
    value,
    defaultCalendarMonth,
    referenceDate: referenceDateProp,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture,
    timezone
  });

  // When disabled, limit the view to the selected date
  const minDateWithDisabled = disabled && value || minDate;
  const maxDateWithDisabled = disabled && value || maxDate;
  const gridLabelId = `${id}-grid-label`;
  const hasFocus = focusedView !== null;
  const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : PickersCalendarHeader;
  const calendarHeaderProps = useSlotProps({
    elementType: CalendarHeader,
    externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
    additionalProps: {
      views,
      view,
      currentMonth: calendarState.currentMonth,
      onViewChange: setView,
      onMonthChange: (newMonth, direction) => handleChangeMonth({
        newMonth,
        direction
      }),
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled,
      disablePast,
      disableFuture,
      reduceAnimations,
      timezone,
      labelId: gridLabelId,
      slots,
      slotProps
    },
    ownerState: props
  });
  const handleDateMonthChange = useEventCallback(newDate => {
    const startOfMonth = utils.startOfMonth(newDate);
    const endOfMonth = utils.endOfMonth(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
      maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onMonthChange == null || onMonthChange(startOfMonth);
    } else {
      goToNextView();
      changeMonth(startOfMonth);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleDateYearChange = useEventCallback(newDate => {
    const startOfYear = utils.startOfYear(newDate);
    const endOfYear = utils.endOfYear(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
      maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onYearChange == null || onYearChange(closestEnabledDate);
    } else {
      goToNextView();
      changeMonth(startOfYear);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleSelectedDayChange = useEventCallback(day => {
    if (day) {
      // If there is a date already selected, then we want to keep its time
      return handleValueChange(mergeDateAndTime(utils, day, value != null ? value : referenceDate), 'finish');
    }
    return handleValueChange(day, 'finish');
  });
  React$1.useEffect(() => {
    if (value != null && utils.isValid(value)) {
      changeMonth(value);
    }
  }, [value]); // eslint-disable-line

  const ownerState = props;
  const classes = useUtilityClasses$O(ownerState);
  const baseDateValidationProps = {
    disablePast,
    disableFuture,
    maxDate,
    minDate
  };
  const commonViewProps = {
    disableHighlightToday,
    readOnly,
    disabled,
    timezone,
    gridLabelId
  };
  const prevOpenViewRef = React$1.useRef(view);
  React$1.useEffect(() => {
    // If the view change and the focus was on the previous view
    // Then we update the focus.
    if (prevOpenViewRef.current === view) {
      return;
    }
    if (focusedView === prevOpenViewRef.current) {
      setFocusedView(view, true);
    }
    prevOpenViewRef.current = view;
  }, [focusedView, setFocusedView, view]);
  const selectedDays = React$1.useMemo(() => [value], [value]);
  return /*#__PURE__*/jsxs(DateCalendarRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(CalendarHeader, _extends$c({}, calendarHeaderProps)), /*#__PURE__*/jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations: reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: view,
      ownerState: ownerState,
      children: /*#__PURE__*/jsxs("div", {
        children: [view === 'year' && /*#__PURE__*/jsx(YearCalendar, _extends$c({}, baseDateValidationProps, commonViewProps, {
          value: value,
          onChange: handleDateYearChange,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('year', isViewFocused),
          yearsPerRow: yearsPerRow,
          referenceDate: referenceDate
        })), view === 'month' && /*#__PURE__*/jsx(MonthCalendar, _extends$c({}, baseDateValidationProps, commonViewProps, {
          hasFocus: hasFocus,
          className: className,
          value: value,
          onChange: handleDateMonthChange,
          shouldDisableMonth: shouldDisableMonth,
          onFocusedViewChange: isViewFocused => setFocusedView('month', isViewFocused),
          monthsPerRow: monthsPerRow,
          referenceDate: referenceDate
        })), view === 'day' && /*#__PURE__*/jsx(DayCalendar, _extends$c({}, calendarState, baseDateValidationProps, commonViewProps, {
          onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations: reduceAnimations,
          selectedDays: selectedDays,
          onSelectedDaysChange: handleSelectedDayChange,
          shouldDisableDate: shouldDisableDate,
          shouldDisableMonth: shouldDisableMonth,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('day', isViewFocused),
          showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
          fixedWeekNumber: fixedWeekNumber,
          dayOfWeekFormatter: dayOfWeekFormatter,
          displayWeekNumber: displayWeekNumber,
          components: components,
          componentsProps: componentsProps,
          slots: slots,
          slotProps: slotProps,
          loading: loading,
          renderLoading: renderLoading
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */
  defaultCalendarMonth: PropTypes.any,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate | null} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: PropTypes.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;

function getPickersToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiPickersToolbar', slot);
}
generateUtilityClasses('MuiPickersToolbar', ['root', 'content']);

const useUtilityClasses$N = ownerState => {
  const {
    classes,
    isLandscape
  } = ownerState;
  const slots = {
    root: ['root'],
    content: ['content'],
    penIconButton: ['penIconButton', isLandscape && 'penIconButtonLandscape']
  };
  return composeClasses(slots, getPickersToolbarUtilityClass, classes);
};
const PickersToolbarRoot = styled$3('div', {
  name: 'MuiPickersToolbar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => _extends$c({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3)
}, ownerState.isLandscape && {
  height: 'auto',
  maxWidth: 160,
  padding: 16,
  justifyContent: 'flex-start',
  flexWrap: 'wrap'
}));
const PickersToolbarContent = styled$3('div', {
  name: 'MuiPickersToolbar',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})(({
  ownerState
}) => {
  var _ownerState$landscape;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: ownerState.isLandscape ? 'flex-start' : 'space-between',
    flexDirection: ownerState.isLandscape ? (_ownerState$landscape = ownerState.landscapeDirection) != null ? _ownerState$landscape : 'column' : 'row',
    flex: 1,
    alignItems: ownerState.isLandscape ? 'flex-start' : 'center'
  };
});
const PickersToolbar = /*#__PURE__*/React$1.forwardRef(function PickersToolbar(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersToolbar'
  });
  const {
    children,
    className,
    toolbarTitle,
    hidden,
    titleId
  } = props;
  const ownerState = props;
  const classes = useUtilityClasses$N(ownerState);
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/jsxs(PickersToolbarRoot, {
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx(Typography, {
      color: "text.secondary",
      variant: "overline",
      id: titleId,
      children: toolbarTitle
    }), /*#__PURE__*/jsx(PickersToolbarContent, {
      className: classes.content,
      ownerState: ownerState,
      children: children
    })]
  });
});

function getDatePickerToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiDatePickerToolbar', slot);
}
generateUtilityClasses('MuiDatePickerToolbar', ['root', 'title']);

const _excluded$1i = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views"];
const useUtilityClasses$M = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    title: ['title']
  };
  return composeClasses(slots, getDatePickerToolbarUtilityClass, classes);
};
const DatePickerToolbarRoot = styled$3(PickersToolbar, {
  name: 'MuiDatePickerToolbar',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({});

/**
 * @ignore - do not document.
 */
const DatePickerToolbarTitle = styled$3(Typography, {
  name: 'MuiDatePickerToolbar',
  slot: 'Title',
  overridesResolver: (_, styles) => styles.title
})(({
  ownerState
}) => _extends$c({}, ownerState.isLandscape && {
  margin: 'auto 16px auto auto'
}));
const DatePickerToolbar = /*#__PURE__*/React$1.forwardRef(function DatePickerToolbar(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDatePickerToolbar'
  });
  const {
      value,
      isLandscape,
      toolbarFormat,
      toolbarPlaceholder = '––',
      views
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1i);
  const utils = useUtils();
  const localeText = useLocaleText();
  const classes = useUtilityClasses$M(props);
  const dateText = React$1.useMemo(() => {
    if (!value) {
      return toolbarPlaceholder;
    }
    const formatFromViews = resolveDateFormat(utils, {
      format: toolbarFormat,
      views
    }, true);
    return utils.formatByString(value, formatFromViews);
  }, [value, toolbarFormat, toolbarPlaceholder, utils, views]);
  const ownerState = props;
  return /*#__PURE__*/jsx(DatePickerToolbarRoot, _extends$c({
    ref: ref,
    toolbarTitle: localeText.datePickerToolbarTitle,
    isLandscape: isLandscape,
    className: classes.root
  }, other, {
    children: /*#__PURE__*/jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: isLandscape ? 'left' : 'center',
      ownerState: ownerState,
      className: classes.title,
      children: dateText
    })
  }));
});
process.env.NODE_ENV !== "production" ? DatePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  /**
   * className applied to the root component.
   */
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleId: PropTypes.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: PropTypes.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: PropTypes.node,
  value: PropTypes.any,
  /**
   * Currently visible picker view.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired).isRequired
} : void 0;

function useDatePickerDefaultizedProps(props, name) {
  var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  const localeText = React$1.useMemo(() => {
    var _themeProps$localeTex;
    if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) {
      return themeProps.localeText;
    }
    return _extends$c({}, themeProps.localeText, {
      datePickerToolbarTitle: themeProps.localeText.toolbarTitle
    });
  }, [themeProps.localeText]);
  const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : uncapitalizeObjectKeys$1(themeProps.components);
  return _extends$c({}, themeProps, {
    localeText
  }, applyDefaultViewProps({
    views: themeProps.views,
    openTo: themeProps.openTo,
    defaultViews: ['year', 'day'],
    defaultOpenTo: 'day'
  }), {
    disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
    disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate),
    slots: _extends$c({
      toolbar: DatePickerToolbar
    }, slots),
    slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
  });
}

const PickersModalDialogRoot = styled$3(Dialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
const PickersModalDialogContent = styled$3(DialogContent$2)({
  '&:first-of-type': {
    padding: 0
  }
});
function PickersModalDialog(props) {
  var _slots$dialog, _slots$mobileTransiti;
  const {
    children,
    onDismiss,
    open,
    slots,
    slotProps
  } = props;
  const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : PickersModalDialogRoot;
  const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : Fade;
  return /*#__PURE__*/jsx(Dialog, _extends$c({
    open: open,
    onClose: onDismiss
  }, slotProps == null ? void 0 : slotProps.dialog, {
    TransitionComponent: Transition,
    TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
    PaperComponent: slots == null ? void 0 : slots.mobilePaper,
    PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
    children: /*#__PURE__*/jsx(PickersModalDialogContent, {
      children: children
    })
  }));
}

function getPickersPopperUtilityClass(slot) {
  return generateUtilityClass('MuiPickersPopper', slot);
}
generateUtilityClasses('MuiPickersPopper', ['root', 'paper']);

const _excluded$1h = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"];
const useUtilityClasses$L = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return composeClasses(slots, getPickersPopperUtilityClass, classes);
};
const PickersPopperRoot = styled$3(Popper, {
  name: 'MuiPickersPopper',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})(({
  theme
}) => ({
  zIndex: theme.zIndex.modal
}));
const PickersPopperPaper = styled$3(Paper, {
  name: 'MuiPickersPopper',
  slot: 'Paper',
  overridesResolver: (_, styles) => styles.paper
})(({
  ownerState
}) => _extends$c({
  outline: 0,
  transformOrigin: 'top center'
}, ownerState.placement.includes('top') && {
  transformOrigin: 'bottom center'
}));
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */
function useClickAwayListener(active, onClickAway) {
  const movedRef = React$1.useRef(false);
  const syntheticEventRef = React$1.useRef(false);
  const nodeRef = React$1.useRef(null);
  const activatedRef = React$1.useRef(false);
  React$1.useEffect(() => {
    if (!active) {
      return undefined;
    }

    // Ensure that this hook is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    function armClickAwayListener() {
      activatedRef.current = true;
    }
    document.addEventListener('mousedown', armClickAwayListener, true);
    document.addEventListener('touchstart', armClickAwayListener, true);
    return () => {
      document.removeEventListener('mousedown', armClickAwayListener, true);
      document.removeEventListener('touchstart', armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]);

  // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.
  const handleClickAway = useEventCallback(event => {
    if (!activatedRef.current) {
      return;
    }

    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current);

    // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.
    if (!nodeRef.current ||
    // is a TouchEvent?
    'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    }

    // Do not act if user performed touchmove
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;

    // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }
    if (!insideDOM && !insideReactTree) {
      onClickAway(event);
    }
  });

  // Keep track of mouse/touch events that bubbled up through the portal.
  const handleSynthetic = () => {
    syntheticEventRef.current = true;
  };
  React$1.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener('touchstart', handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener('touchstart', handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  React$1.useEffect(() => {
    // TODO This behavior is not tested automatically
    // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
    // Or if this is a timing related issues due to different Transition components
    // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener('click', handleClickAway);
      return () => {
        doc.removeEventListener('click', handleClickAway);
        // cleanup `handleClickAway`
        syntheticEventRef.current = false;
      };
    }
    return undefined;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}
const PickersPopperPaperWrapper = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  const {
      PaperComponent,
      popperPlacement,
      ownerState: inOwnerState,
      children,
      paperSlotProps,
      paperClasses,
      onPaperClick,
      onPaperTouchStart
      // picks up the style props provided by `Transition`
      // https://mui.com/material-ui/transitions/#child-requirement
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1h);
  const ownerState = _extends$c({}, inOwnerState, {
    placement: popperPlacement
  });
  const paperProps = useSlotProps({
    elementType: PaperComponent,
    externalSlotProps: paperSlotProps,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref
    },
    className: paperClasses,
    ownerState
  });
  return /*#__PURE__*/jsx(PaperComponent, _extends$c({}, other, paperProps, {
    onClick: event => {
      var _paperProps$onClick;
      onPaperClick(event);
      (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
    },
    onTouchStart: event => {
      var _paperProps$onTouchSt;
      onPaperTouchStart(event);
      (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
    },
    ownerState: ownerState,
    children: children
  }));
});
function PickersPopper(inProps) {
  var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersPopper'
  });
  const {
    anchorEl,
    children,
    containerRef = null,
    shouldRestoreFocus,
    onBlur,
    onDismiss,
    open,
    role,
    placement,
    slots,
    slotProps,
    reduceAnimations: inReduceAnimations
  } = props;
  React$1.useEffect(() => {
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Blink?) use 'Esc'
      if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) {
        onDismiss();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onDismiss, open]);
  const lastFocusedElementRef = React$1.useRef(null);
  React$1.useEffect(() => {
    if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) {
      return;
    }
    if (open) {
      lastFocusedElementRef.current = getActiveElement(document);
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      // make sure the button is flushed with updated label, before returning focus to it
      // avoids issue, where screen reader could fail to announce selected date after selection
      setTimeout(() => {
        if (lastFocusedElementRef.current instanceof HTMLElement) {
          lastFocusedElementRef.current.focus();
        }
      });
    }
  }, [open, role, shouldRestoreFocus]);
  const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
  const paperRef = React$1.useRef(null);
  const handleRef = useForkRef(paperRef, containerRef);
  const handlePaperRef = useForkRef(handleRef, clickAwayRef);
  const ownerState = props;
  const classes = useUtilityClasses$L(ownerState);
  const defaultReduceAnimations = useDefaultReduceAnimations();
  const reduceAnimations = inReduceAnimations != null ? inReduceAnimations : defaultReduceAnimations;
  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      // stop the propagation to avoid closing parent modal
      event.stopPropagation();
      onDismiss();
    }
  };
  const Transition = ((_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : reduceAnimations) ? Fade : Grow;
  const FocusTrap = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : BaseFocusTrap;
  const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : PickersPopperPaper;
  const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : PickersPopperRoot;
  const popperProps = useSlotProps({
    elementType: Popper,
    externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
    additionalProps: {
      transition: true,
      role,
      open,
      anchorEl,
      placement,
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState: props
  });
  return /*#__PURE__*/jsx(Popper, _extends$c({}, popperProps, {
    children: ({
      TransitionProps,
      placement: popperPlacement
    }) => /*#__PURE__*/jsx(FocusTrap, _extends$c({
      open: open,
      disableAutoFocus: true
      // pickers are managing focus position manually
      // without this prop the focus is returned to the button before `aria-label` is updated
      // which would force screen readers to read too old label
      ,
      disableRestoreFocus: true,
      disableEnforceFocus: role === 'tooltip',
      isEnabled: () => true
    }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
      children: /*#__PURE__*/jsx(Transition, _extends$c({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
        children: /*#__PURE__*/jsx(PickersPopperPaperWrapper, {
          PaperComponent: Paper,
          ownerState: ownerState,
          popperPlacement: popperPlacement,
          ref: handlePaperRef,
          onPaperClick: onPaperClick,
          onPaperTouchStart: onPaperTouchStart,
          paperClasses: classes.paper,
          paperSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
          children: children
        })
      }))
    }))
  }));
}

generateUtilityClasses('MuiPickersToolbarButton', ['root']);

const pickersToolbarTextClasses = generateUtilityClasses('MuiPickersToolbarText', ['root', 'selected']);

styled$3(Typography, {
  name: 'MuiPickersToolbarText',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root, {
    [`&.${pickersToolbarTextClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => ({
  transition: theme.transitions.create('color'),
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${pickersToolbarTextClasses.selected}`]: {
    color: (theme.vars || theme).palette.text.primary
  }
}));

styled$3(Button$1, {
  name: 'MuiPickersToolbarButton',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: 'none'
});

const useOpenState = ({
  open,
  onOpen,
  onClose
}) => {
  const isControllingOpenProp = React$1.useRef(typeof open === 'boolean').current;
  const [openState, setIsOpenState] = React$1.useState(false);

  // It is required to update inner state in useEffect in order to avoid situation when
  // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
  React$1.useEffect(() => {
    if (isControllingOpenProp) {
      if (typeof open !== 'boolean') {
        throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
      }
      setIsOpenState(open);
    }
  }, [isControllingOpenProp, open]);
  const setIsOpen = React$1.useCallback(newIsOpen => {
    if (!isControllingOpenProp) {
      setIsOpenState(newIsOpen);
    }
    if (newIsOpen && onOpen) {
      onOpen();
    }
    if (!newIsOpen && onClose) {
      onClose();
    }
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: openState,
    setIsOpen
  };
};

/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */
const shouldPublishValue = params => {
  const {
    action,
    hasChanged,
    dateState,
    isControlled
  } = params;
  const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;

  // The field is responsible for only calling `onChange` when needed.
  if (action.name === 'setValueFromField') {
    return true;
  }
  if (action.name === 'setValueFromAction') {
    // If the component is not controlled, and the value has not been modified since the mount,
    // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
    if (isCurrentValueTheDefaultValue && ['accept', 'today', 'clear'].includes(action.pickerAction)) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
    // On the first view,
    // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  if (action.name === 'setValueFromShortcut') {
    // On the first view,
    // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastPublishedValue);
  }
  return false;
};

/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */
const shouldCommitValue = params => {
  const {
    action,
    hasChanged,
    dateState,
    isControlled,
    closeOnSelect
  } = params;
  const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
  if (action.name === 'setValueFromAction') {
    // If the component is not controlled, and the value has not been modified since the mount,
    // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
    if (isCurrentValueTheDefaultValue && ['accept', 'today', 'clear'].includes(action.pickerAction)) {
      return true;
    }
    return hasChanged(dateState.lastCommittedValue);
  }
  if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
    // On picker where the 1st view is also the last view,
    // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
    if (isCurrentValueTheDefaultValue) {
      return true;
    }
    return hasChanged(dateState.lastCommittedValue);
  }
  if (action.name === 'setValueFromShortcut') {
    return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
  }
  return false;
};

/**
 * Decide if the picker should be closed after the value is updated.
 */
const shouldClosePicker = params => {
  const {
    action,
    closeOnSelect
  } = params;
  if (action.name === 'setValueFromAction') {
    return true;
  }
  if (action.name === 'setValueFromView') {
    return action.selectionState === 'finish' && closeOnSelect;
  }
  if (action.name === 'setValueFromShortcut') {
    return action.changeImportance === 'accept';
  }
  return false;
};

/**
 * Manage the value lifecycle of all the pickers.
 */
const usePickerValue = ({
  props,
  valueManager,
  valueType,
  wrapperVariant,
  validator
}) => {
  const {
    onAccept,
    onChange,
    value: inValue,
    defaultValue: inDefaultValue,
    closeOnSelect = wrapperVariant === 'desktop',
    selectedSections: selectedSectionsProp,
    onSelectedSectionsChange,
    timezone: timezoneProp
  } = props;
  const {
    current: defaultValue
  } = React$1.useRef(inDefaultValue);
  const {
    current: isControlled
  } = React$1.useRef(inValue !== undefined);

  /* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
  if (process.env.NODE_ENV !== 'production') {
    React$1.useEffect(() => {
      if (isControlled !== (inValue !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled value of a picker to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled value` + 'for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [inValue]);
    React$1.useEffect(() => {
      if (!isControlled && defaultValue !== inDefaultValue) {
        console.error([`MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. ` + `To suppress this warning opt to use a controlled value.`].join('\n'));
      }
    }, [JSON.stringify(defaultValue)]);
  }
  /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

  const utils = useUtils();
  const adapter = useLocalizationContext();
  const [selectedSections, setSelectedSections] = useControlled({
    controlled: selectedSectionsProp,
    default: null,
    name: 'usePickerValue',
    state: 'selectedSections'
  });
  const {
    isOpen,
    setIsOpen
  } = useOpenState(props);
  const [dateState, setDateState] = React$1.useState(() => {
    let initialValue;
    if (inValue !== undefined) {
      initialValue = inValue;
    } else if (defaultValue !== undefined) {
      initialValue = defaultValue;
    } else {
      initialValue = valueManager.emptyValue;
    }
    return {
      draft: initialValue,
      lastPublishedValue: initialValue,
      lastCommittedValue: initialValue,
      lastControlledValue: inValue,
      hasBeenModifiedSinceMount: false
    };
  });
  const {
    timezone,
    handleValueChange
  } = useValueWithTimezone({
    timezone: timezoneProp,
    value: inValue,
    defaultValue,
    onChange,
    valueManager
  });
  useValidation(_extends$c({}, props, {
    value: dateState.draft,
    timezone
  }), validator, valueManager.isSameError, valueManager.defaultErrorState);
  const updateDate = useEventCallback(action => {
    const updaterParams = {
      action,
      dateState,
      hasChanged: comparison => !valueManager.areValuesEqual(utils, action.value, comparison),
      isControlled,
      closeOnSelect
    };
    const shouldPublish = shouldPublishValue(updaterParams);
    const shouldCommit = shouldCommitValue(updaterParams);
    const shouldClose = shouldClosePicker(updaterParams);
    setDateState(prev => _extends$c({}, prev, {
      draft: action.value,
      lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
      lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
      hasBeenModifiedSinceMount: true
    }));
    if (shouldPublish) {
      const validationError = action.name === 'setValueFromField' ? action.context.validationError : validator({
        adapter,
        value: action.value,
        props: _extends$c({}, props, {
          value: action.value,
          timezone
        })
      });
      const context = {
        validationError
      };

      // TODO v7: Remove 2nd condition
      if (action.name === 'setValueFromShortcut' && action.shortcut != null) {
        context.shortcut = action.shortcut;
      }
      handleValueChange(action.value, context);
    }
    if (shouldCommit && onAccept) {
      onAccept(action.value);
    }
    if (shouldClose) {
      setIsOpen(false);
    }
  });
  if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
    const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
    setDateState(prev => _extends$c({}, prev, {
      lastControlledValue: inValue
    }, isUpdateComingFromPicker ? {} : {
      lastCommittedValue: inValue,
      lastPublishedValue: inValue,
      draft: inValue,
      hasBeenModifiedSinceMount: true
    }));
  }
  const handleClear = useEventCallback(() => {
    updateDate({
      value: valueManager.emptyValue,
      name: 'setValueFromAction',
      pickerAction: 'clear'
    });
  });
  const handleAccept = useEventCallback(() => {
    updateDate({
      value: dateState.lastPublishedValue,
      name: 'setValueFromAction',
      pickerAction: 'accept'
    });
  });
  const handleDismiss = useEventCallback(() => {
    updateDate({
      value: dateState.lastPublishedValue,
      name: 'setValueFromAction',
      pickerAction: 'dismiss'
    });
  });
  const handleCancel = useEventCallback(() => {
    updateDate({
      value: dateState.lastCommittedValue,
      name: 'setValueFromAction',
      pickerAction: 'cancel'
    });
  });
  const handleSetToday = useEventCallback(() => {
    updateDate({
      value: valueManager.getTodayValue(utils, timezone, valueType),
      name: 'setValueFromAction',
      pickerAction: 'today'
    });
  });
  const handleOpen = useEventCallback(() => setIsOpen(true));
  const handleClose = useEventCallback(() => setIsOpen(false));
  const handleChange = useEventCallback((newValue, selectionState = 'partial') => updateDate({
    name: 'setValueFromView',
    value: newValue,
    selectionState
  }));

  // TODO v7: Make changeImportance and label mandatory.
  const handleSelectShortcut = useEventCallback((newValue, changeImportance, shortcut) => updateDate({
    name: 'setValueFromShortcut',
    value: newValue,
    changeImportance: changeImportance != null ? changeImportance : 'accept',
    shortcut
  }));
  const handleChangeFromField = useEventCallback((newValue, context) => updateDate({
    name: 'setValueFromField',
    value: newValue,
    context
  }));
  const handleFieldSelectedSectionsChange = useEventCallback(newSelectedSections => {
    setSelectedSections(newSelectedSections);
    onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
  });
  const actions = {
    onClear: handleClear,
    onAccept: handleAccept,
    onDismiss: handleDismiss,
    onCancel: handleCancel,
    onSetToday: handleSetToday,
    onOpen: handleOpen,
    onClose: handleClose
  };
  const fieldResponse = {
    value: dateState.draft,
    onChange: handleChangeFromField,
    selectedSections,
    onSelectedSectionsChange: handleFieldSelectedSectionsChange
  };
  const viewValue = React$1.useMemo(() => valueManager.cleanValue(utils, dateState.draft), [utils, valueManager, dateState.draft]);
  const viewResponse = {
    value: viewValue,
    onChange: handleChange,
    onClose: handleClose,
    open: isOpen,
    onSelectedSectionsChange: handleFieldSelectedSectionsChange
  };
  const isValid = testedValue => {
    const error = validator({
      adapter,
      value: testedValue,
      props: _extends$c({}, props, {
        value: testedValue,
        timezone
      })
    });
    return !valueManager.hasError(error);
  };
  const layoutResponse = _extends$c({}, actions, {
    value: viewValue,
    onChange: handleChange,
    onSelectShortcut: handleSelectShortcut,
    isValid
  });
  return {
    open: isOpen,
    fieldProps: fieldResponse,
    viewProps: viewResponse,
    layoutProps: layoutResponse,
    actions
  };
};

const _excluded$1g = ["className", "sx"];

/**
 * Props used to handle the views that are common to all pickers.
 */

/**
 * Props used to handle the views of the pickers.
 */

/**
 * Props used to handle the value of the pickers.
 */

/**
 * Manage the views of all the pickers:
 * - Handles the view switch
 * - Handles the switch between UI views and field views
 * - Handles the focus management when switching views
 */
const usePickerViews = ({
  props,
  propsFromPickerValue,
  additionalViewProps,
  inputRef,
  autoFocusView
}) => {
  const {
    onChange,
    open,
    onSelectedSectionsChange,
    onClose
  } = propsFromPickerValue;
  const {
    views,
    openTo,
    onViewChange,
    disableOpenPicker,
    viewRenderers,
    timezone
  } = props;
  const propsToForwardToView = _objectWithoutPropertiesLoose$b(props, _excluded$1g);
  const {
    view,
    setView,
    defaultView,
    focusedView,
    setFocusedView,
    setValueAndGoToNextView
  } = useViews({
    view: undefined,
    views,
    openTo,
    onChange,
    onViewChange,
    autoFocus: autoFocusView
  });
  const {
    hasUIView,
    viewModeLookup
  } = React$1.useMemo(() => views.reduce((acc, viewForReduce) => {
    let viewMode;
    if (disableOpenPicker) {
      viewMode = 'field';
    } else if (viewRenderers[viewForReduce] != null) {
      viewMode = 'UI';
    } else {
      viewMode = 'field';
    }
    acc.viewModeLookup[viewForReduce] = viewMode;
    if (viewMode === 'UI') {
      acc.hasUIView = true;
    }
    return acc;
  }, {
    hasUIView: false,
    viewModeLookup: {}
  }), [disableOpenPicker, viewRenderers, views]);
  const timeViewsCount = React$1.useMemo(() => views.reduce((acc, viewForReduce) => {
    if (viewRenderers[viewForReduce] != null && isTimeView(viewForReduce)) {
      return acc + 1;
    }
    return acc;
  }, 0), [viewRenderers, views]);
  const currentViewMode = viewModeLookup[view];
  const shouldRestoreFocus = useEventCallback(() => currentViewMode === 'UI');
  const [popperView, setPopperView] = React$1.useState(currentViewMode === 'UI' ? view : null);
  if (popperView !== view && viewModeLookup[view] === 'UI') {
    setPopperView(view);
  }
  useEnhancedEffect(() => {
    // Handle case of `DateTimePicker` without time renderers
    if (currentViewMode === 'field' && open) {
      onClose();
      setTimeout(() => {
        // focusing the input before the range selection is done
        // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
        inputRef == null || inputRef.current.focus();
        onSelectedSectionsChange(view);
      });
    }
  }, [view]); // eslint-disable-line react-hooks/exhaustive-deps

  useEnhancedEffect(() => {
    if (!open) {
      return;
    }
    let newView = view;

    // If the current view is a field view, go to the last popper view
    if (currentViewMode === 'field' && popperView != null) {
      newView = popperView;
    }

    // If the current view is not the default view and both are UI views
    if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') {
      newView = defaultView;
    }
    if (newView !== view) {
      setView(newView);
    }
    setFocusedView(newView, true);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const layoutProps = {
    views,
    view: popperView,
    onViewChange: setView
  };
  return {
    hasUIView,
    shouldRestoreFocus,
    layoutProps,
    renderCurrentView: () => {
      if (popperView == null) {
        return null;
      }
      const renderer = viewRenderers[popperView];
      if (renderer == null) {
        return null;
      }
      return renderer(_extends$c({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
        views,
        timezone,
        onChange: setValueAndGoToNextView,
        view: popperView,
        onViewChange: setView,
        focusedView,
        onFocusedViewChange: setFocusedView,
        showViewSwitcher: timeViewsCount > 1,
        timeViewsCount
      }));
    }
  };
};

function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }
  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  }

  // Support IOS safari
  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }
  return 'portrait';
}
const useIsLandscape = (views, customOrientation) => {
  const [orientation, setOrientation] = React$1.useState(getOrientation);
  useEnhancedEffect(() => {
    const eventHandler = () => {
      setOrientation(getOrientation());
    };
    window.addEventListener('orientationchange', eventHandler);
    return () => {
      window.removeEventListener('orientationchange', eventHandler);
    };
  }, []);
  if (arrayIncludes(views, ['hours', 'minutes', 'seconds'])) {
    // could not display 13:34:44 in landscape mode
    return false;
  }
  const orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
};

/**
 * Props used to create the layout of the views.
 * Those props are exposed on all the pickers.
 */

/**
 * Prepare the props for the view layout (managed by `PickersLayout`)
 */
const usePickerLayoutProps = ({
  props,
  propsFromPickerValue,
  propsFromPickerViews,
  wrapperVariant
}) => {
  const {
    orientation
  } = props;
  const isLandscape = useIsLandscape(propsFromPickerViews.views, orientation);
  const layoutProps = _extends$c({}, propsFromPickerViews, propsFromPickerValue, {
    isLandscape,
    wrapperVariant,
    disabled: props.disabled,
    readOnly: props.readOnly
  });
  return {
    layoutProps
  };
};

const warnRenderInputIsDefined = buildWarning$1(['The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.', 'You can replace it with the `textField` component slot in most cases.', 'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).']);
const usePicker = ({
  props,
  valueManager,
  valueType,
  wrapperVariant,
  inputRef,
  additionalViewProps,
  validator,
  autoFocusView
}) => {
  if (process.env.NODE_ENV !== 'production') {
    if (props.renderInput != null) {
      warnRenderInputIsDefined();
    }
  }
  const pickerValueResponse = usePickerValue({
    props,
    valueManager,
    valueType,
    wrapperVariant,
    validator
  });
  const pickerViewsResponse = usePickerViews({
    props,
    inputRef,
    additionalViewProps,
    autoFocusView,
    propsFromPickerValue: pickerValueResponse.viewProps
  });
  const pickerLayoutResponse = usePickerLayoutProps({
    props,
    wrapperVariant,
    propsFromPickerValue: pickerValueResponse.layoutProps,
    propsFromPickerViews: pickerViewsResponse.layoutProps
  });
  return {
    // Picker value
    open: pickerValueResponse.open,
    actions: pickerValueResponse.actions,
    fieldProps: pickerValueResponse.fieldProps,
    // Picker views
    renderCurrentView: pickerViewsResponse.renderCurrentView,
    hasUIView: pickerViewsResponse.hasUIView,
    shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
    // Picker layout
    layoutProps: pickerLayoutResponse.layoutProps
  };
};

function getPickersLayoutUtilityClass(slot) {
  return generateUtilityClass('MuiPickersLayout', slot);
}
const pickersLayoutClasses = generateUtilityClasses('MuiPickersLayout', ['root', 'landscape', 'contentWrapper', 'toolbar', 'actionBar', 'shortcuts']);

const _excluded$1f = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function PickersActionBar(props) {
  const {
      onAccept,
      onClear,
      onCancel,
      onSetToday,
      actions
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1f);
  const localeText = useLocaleText();
  if (actions == null || actions.length === 0) {
    return null;
  }
  const buttons = actions == null ? void 0 : actions.map(actionType => {
    switch (actionType) {
      case 'clear':
        return /*#__PURE__*/jsx(Button$1, {
          onClick: onClear,
          children: localeText.clearButtonLabel
        }, actionType);
      case 'cancel':
        return /*#__PURE__*/jsx(Button$1, {
          onClick: onCancel,
          children: localeText.cancelButtonLabel
        }, actionType);
      case 'accept':
        return /*#__PURE__*/jsx(Button$1, {
          onClick: onAccept,
          children: localeText.okButtonLabel
        }, actionType);
      case 'today':
        return /*#__PURE__*/jsx(Button$1, {
          onClick: onSetToday,
          children: localeText.todayButtonLabel
        }, actionType);
      default:
        return null;
    }
  });
  return /*#__PURE__*/jsx(DialogActions$2, _extends$c({}, other, {
    children: buttons
  }));
}
process.env.NODE_ENV !== "production" ? PickersActionBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: PropTypes.arrayOf(PropTypes.oneOf(['accept', 'cancel', 'clear', 'today']).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSetToday: PropTypes.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$1e = ["items", "changeImportance", "isLandscape", "onChange", "isValid"],
  _excluded2$b = ["getValue"];
function PickersShortcuts(props) {
  const {
      items,
      changeImportance,
      onChange,
      isValid
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1e);
  if (items == null || items.length === 0) {
    return null;
  }
  const resolvedItems = items.map(_ref => {
    let {
        getValue
      } = _ref,
      item = _objectWithoutPropertiesLoose$b(_ref, _excluded2$b);
    const newValue = getValue({
      isValid
    });
    return {
      label: item.label,
      onClick: () => {
        onChange(newValue, changeImportance, item);
      },
      disabled: !isValid(newValue)
    };
  });
  return /*#__PURE__*/jsx(List, _extends$c({
    dense: true,
    sx: [{
      maxHeight: VIEW_HEIGHT,
      maxWidth: 200,
      overflow: 'auto'
    }, ...(Array.isArray(other.sx) ? other.sx : [other.sx])]
  }, other, {
    children: resolvedItems.map(item => {
      return /*#__PURE__*/jsx(ListItem$1, {
        children: /*#__PURE__*/jsx(Chip, _extends$c({}, item))
      }, item.label);
    })
  }));
}
process.env.NODE_ENV !== "production" ? PickersShortcuts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: PropTypes.oneOf(['accept', 'set']),
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default `[]`
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    getValue: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

function toolbarHasView(toolbarProps) {
  return toolbarProps.view !== null;
}
const useUtilityClasses$K = ownerState => {
  const {
    classes,
    isLandscape
  } = ownerState;
  const slots = {
    root: ['root', isLandscape && 'landscape'],
    contentWrapper: ['contentWrapper'],
    toolbar: ['toolbar'],
    actionBar: ['actionBar'],
    tabs: ['tabs'],
    landscape: ['landscape'],
    shortcuts: ['shortcuts']
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const usePickerLayout = props => {
  var _slots$actionBar, _slots$shortcuts;
  const {
    wrapperVariant,
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    view,
    views,
    onViewChange,
    value,
    onChange,
    onSelectShortcut,
    isValid,
    isLandscape,
    disabled,
    readOnly,
    children,
    components,
    componentsProps,
    slots: innerSlots,
    slotProps: innerSlotProps
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = props;
  const slots = innerSlots != null ? innerSlots : uncapitalizeObjectKeys$1(components);
  const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
  const classes = useUtilityClasses$K(props);

  // Action bar

  const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : PickersActionBar;
  const actionBarProps = useSlotProps({
    elementType: ActionBar,
    externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
    additionalProps: {
      onAccept,
      onClear,
      onCancel,
      onSetToday,
      actions: wrapperVariant === 'desktop' ? [] : ['cancel', 'accept'],
      className: classes.actionBar
    },
    ownerState: _extends$c({}, props, {
      wrapperVariant
    })
  });
  const actionBar = /*#__PURE__*/jsx(ActionBar, _extends$c({}, actionBarProps));

  // Toolbar

  const Toolbar = slots == null ? void 0 : slots.toolbar;
  const toolbarProps = useSlotProps({
    elementType: Toolbar,
    externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
    additionalProps: {
      isLandscape,
      onChange,
      value,
      view,
      onViewChange,
      views,
      disabled,
      readOnly,
      className: classes.toolbar
    },
    ownerState: _extends$c({}, props, {
      wrapperVariant
    })
  });
  const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/jsx(Toolbar, _extends$c({}, toolbarProps)) : null;

  // Content

  const content = children;

  // Tabs

  const Tabs = slots == null ? void 0 : slots.tabs;
  const tabs = view && Tabs ? /*#__PURE__*/jsx(Tabs, _extends$c({
    view: view,
    onViewChange: onViewChange
  }, slotProps == null ? void 0 : slotProps.tabs)) : null;

  // Shortcuts

  const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : PickersShortcuts;
  const shortcutsProps = useSlotProps({
    elementType: Shortcuts,
    externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
    additionalProps: {
      isValid,
      isLandscape,
      onChange: onSelectShortcut,
      className: classes.shortcuts
    },
    ownerState: {
      isValid,
      isLandscape,
      onChange: onSelectShortcut,
      className: classes.shortcuts,
      wrapperVariant
    }
  });
  const shortcuts = view && !!Shortcuts ? /*#__PURE__*/jsx(Shortcuts, _extends$c({}, shortcutsProps)) : null;
  return {
    toolbar,
    content,
    tabs,
    actionBar,
    shortcuts
  };
};

const useUtilityClasses$J = ownerState => {
  const {
    isLandscape,
    classes
  } = ownerState;
  const slots = {
    root: ['root', isLandscape && 'landscape'],
    contentWrapper: ['contentWrapper']
  };
  return composeClasses(slots, getPickersLayoutUtilityClass, classes);
};
const PickersLayoutRoot = styled$3('div', {
  name: 'MuiPickersLayout',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridAutoColumns: 'max-content auto max-content',
  gridAutoRows: 'max-content auto max-content',
  [`& .${pickersLayoutClasses.toolbar}`]: ownerState.isLandscape ? {
    gridColumn: theme.direction === 'rtl' ? 3 : 1,
    gridRow: '2 / 3'
  } : {
    gridColumn: '2 / 4',
    gridRow: 1
  },
  [`.${pickersLayoutClasses.shortcuts}`]: ownerState.isLandscape ? {
    gridColumn: '2 / 4',
    gridRow: 1
  } : {
    gridColumn: theme.direction === 'rtl' ? 3 : 1,
    gridRow: '2 / 3'
  },
  [`& .${pickersLayoutClasses.actionBar}`]: {
    gridColumn: '1 / 4',
    gridRow: 3
  }
}));
PickersLayoutRoot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: PropTypes.elementType,
  ownerState: PropTypes.shape({
    isLandscape: PropTypes.bool.isRequired
  }).isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
};
const PickersLayoutContentWrapper = styled$3('div', {
  name: 'MuiPickersLayout',
  slot: 'ContentWrapper',
  overridesResolver: (props, styles) => styles.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: 'flex',
  flexDirection: 'column'
});
const PickersLayout = function PickersLayout(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersLayout'
  });
  const {
    toolbar,
    content,
    tabs,
    actionBar,
    shortcuts
  } = usePickerLayout(props);
  const {
    sx,
    className,
    isLandscape,
    ref,
    wrapperVariant
  } = props;
  const ownerState = props;
  const classes = useUtilityClasses$J(ownerState);
  return /*#__PURE__*/jsxs(PickersLayoutRoot, {
    ref: ref,
    sx: sx,
    className: clsx(className, classes.root),
    ownerState: ownerState,
    children: [isLandscape ? shortcuts : toolbar, isLandscape ? toolbar : shortcuts, /*#__PURE__*/jsx(PickersLayoutContentWrapper, {
      className: classes.contentWrapper,
      children: wrapperVariant === 'desktop' ? /*#__PURE__*/jsxs(React$1.Fragment, {
        children: [content, tabs]
      }) : /*#__PURE__*/jsxs(React$1.Fragment, {
        children: [tabs, content]
      })
    }), actionBar]
  });
};
process.env.NODE_ENV !== "production" ? PickersLayout.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  disabled: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onSelectShortcut: PropTypes.func.isRequired,
  onSetToday: PropTypes.func.isRequired,
  onViewChange: PropTypes.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(['landscape', 'portrait']),
  readOnly: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.any,
  view: PropTypes.oneOf(['day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'year']),
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'year']).isRequired).isRequired,
  wrapperVariant: PropTypes.oneOf(['desktop', 'mobile'])
} : void 0;

styled$3(PickersLayout)(({
  theme
}) => ({
  overflow: 'hidden',
  minWidth: DIALOG_WIDTH,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));

const _excluded$1d = ["props", "getOpenDialogAriaText"],
  _excluded2$a = ["ownerState"],
  _excluded3$4 = ["ownerState"];
/**
 * Hook managing all the single-date desktop pickers:
 * - DesktopDatePicker
 * - DesktopDateTimePicker
 * - DesktopTimePicker
 */
const useDesktopPicker = _ref => {
  var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
  let {
      props,
      getOpenDialogAriaText
    } = _ref,
    pickerParams = _objectWithoutPropertiesLoose$b(_ref, _excluded$1d);
  const {
    slots,
    slotProps: innerSlotProps,
    className,
    sx,
    format,
    formatDensity,
    timezone,
    label,
    inputRef,
    readOnly,
    disabled,
    autoFocus,
    localeText,
    reduceAnimations
  } = props;
  const utils = useUtils();
  const internalInputRef = React$1.useRef(null);
  const containerRef = React$1.useRef(null);
  const labelId = useId();
  const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
  const {
    open,
    actions,
    hasUIView,
    layoutProps,
    renderCurrentView,
    shouldRestoreFocus,
    fieldProps: pickerFieldProps
  } = usePicker(_extends$c({}, pickerParams, {
    props,
    inputRef: internalInputRef,
    autoFocusView: true,
    additionalViewProps: {},
    wrapperVariant: 'desktop'
  }));
  const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : MuiInputAdornment;
  const _useSlotProps = useSlotProps({
      elementType: InputAdornment,
      externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
      additionalProps: {
        position: 'end'
      },
      ownerState: props
    }),
    inputAdornmentProps = _objectWithoutPropertiesLoose$b(_useSlotProps, _excluded2$a);
  const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : IconButton$1;
  const _useSlotProps2 = useSlotProps({
      elementType: OpenPickerButton,
      externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
      additionalProps: {
        disabled: disabled || readOnly,
        onClick: open ? actions.onClose : actions.onOpen,
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils),
        edge: inputAdornmentProps.position
      },
      ownerState: props
    }),
    openPickerButtonProps = _objectWithoutPropertiesLoose$b(_useSlotProps2, _excluded3$4);
  const OpenPickerIcon = slots.openPickerIcon;
  const Field = slots.field;
  const fieldProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
    additionalProps: _extends$c({}, pickerFieldProps, isToolbarHidden && {
      id: labelId
    }, {
      readOnly,
      disabled,
      className,
      sx,
      format,
      formatDensity,
      timezone,
      label,
      autoFocus: autoFocus && !props.open,
      focused: open ? true : undefined
    }),
    ownerState: props
  });

  // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
  if (hasUIView) {
    fieldProps.InputProps = _extends$c({}, fieldProps.InputProps, {
      ref: containerRef,
      [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/jsx(InputAdornment, _extends$c({}, inputAdornmentProps, {
        children: /*#__PURE__*/jsx(OpenPickerButton, _extends$c({}, openPickerButtonProps, {
          children: /*#__PURE__*/jsx(OpenPickerIcon, _extends$c({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
        }))
      }))
    });
  }
  const slotsForField = _extends$c({
    textField: slots.textField
  }, fieldProps.slots);
  const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : PickersLayout;
  const handleInputRef = useForkRef(internalInputRef, fieldProps.inputRef, inputRef);
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = undefined;
    }
  }
  const slotProps = _extends$c({}, innerSlotProps, {
    toolbar: _extends$c({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
      titleId: labelId
    }),
    popper: _extends$c({
      'aria-labelledby': labelledById
    }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
  });
  const renderPicker = () => /*#__PURE__*/jsxs(LocalizationProvider, {
    localeText: localeText,
    children: [/*#__PURE__*/jsx(Field, _extends$c({}, fieldProps, {
      slots: slotsForField,
      slotProps: slotProps,
      inputRef: handleInputRef
    })), /*#__PURE__*/jsx(PickersPopper, _extends$c({
      role: "dialog",
      placement: "bottom-start",
      anchorEl: containerRef.current
    }, actions, {
      open: open,
      slots: slots,
      slotProps: slotProps,
      shouldRestoreFocus: shouldRestoreFocus,
      reduceAnimations: reduceAnimations,
      children: /*#__PURE__*/jsx(Layout, _extends$c({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
        slots: slots,
        slotProps: slotProps,
        children: renderCurrentView()
      }))
    }))]
  });
  return {
    renderPicker
  };
};

const renderDateViewCalendar = ({
  view,
  onViewChange,
  views,
  focusedView,
  onFocusedViewChange,
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  reduceAnimations,
  onMonthChange,
  monthsPerRow,
  onYearChange,
  yearsPerRow,
  defaultCalendarMonth,
  components,
  componentsProps,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  sx,
  autoFocus,
  fixedWeekNumber,
  displayWeekNumber,
  timezone
}) => /*#__PURE__*/jsx(DateCalendar, {
  view: view,
  onViewChange: onViewChange,
  views: views.filter(isDatePickerView),
  focusedView: focusedView && isDatePickerView(focusedView) ? focusedView : null,
  onFocusedViewChange: onFocusedViewChange,
  value: value,
  defaultValue: defaultValue,
  referenceDate: referenceDate,
  onChange: onChange,
  className: className,
  classes: classes,
  disableFuture: disableFuture,
  disablePast: disablePast,
  minDate: minDate,
  maxDate: maxDate,
  shouldDisableDate: shouldDisableDate,
  shouldDisableMonth: shouldDisableMonth,
  shouldDisableYear: shouldDisableYear,
  reduceAnimations: reduceAnimations,
  onMonthChange: onMonthChange,
  monthsPerRow: monthsPerRow,
  onYearChange: onYearChange,
  yearsPerRow: yearsPerRow,
  defaultCalendarMonth: defaultCalendarMonth,
  components: components,
  componentsProps: componentsProps,
  slots: slots,
  slotProps: slotProps,
  loading: loading,
  renderLoading: renderLoading,
  disableHighlightToday: disableHighlightToday,
  readOnly: readOnly,
  disabled: disabled,
  showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
  dayOfWeekFormatter: dayOfWeekFormatter,
  sx: sx,
  autoFocus: autoFocus,
  fixedWeekNumber: fixedWeekNumber,
  displayWeekNumber: displayWeekNumber,
  timezone: timezone
});

const DesktopDatePicker = /*#__PURE__*/React$1.forwardRef(function DesktopDatePicker(inProps, ref) {
  var _defaultizedProps$yea, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
  const localeText = useLocaleText();
  const utils = useUtils();

  // Props with the default values common to all date pickers
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, 'MuiDesktopDatePicker');
  const viewRenderers = _extends$c({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);

  // Props with the default values specific to the desktop variant
  const props = _extends$c({}, defaultizedProps, {
    viewRenderers,
    format: resolveDateFormat(utils, defaultizedProps, false),
    yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
    slots: _extends$c({
      openPickerIcon: CalendarIcon,
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends$c({}, defaultizedProps.slotProps, {
      field: ownerState => {
        var _defaultizedProps$slo;
        return _extends$c({}, resolveComponentProps((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), extractValidationProps(defaultizedProps), {
          ref
        });
      },
      toolbar: _extends$c({
        hidden: true
      }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
    })
  });
  const {
    renderPicker
  } = useDesktopPicker({
    props,
    valueManager: singleItemValueManager,
    valueType: 'date',
    getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
    validator: validateDate
  });
  return renderPicker();
});
DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */
  defaultCalendarMonth: PropTypes.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(['dense', 'spacious']),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(['landscape', 'portrait']),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(['all', 'day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'weekDay', 'year']), PropTypes.number, PropTypes.shape({
    endIndex: PropTypes.number.isRequired,
    startIndex: PropTypes.number.isRequired
  })]),
  /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};

const _excluded$1c = ["props", "getOpenDialogAriaText"];
/**
 * Hook managing all the single-date mobile pickers:
 * - MobileDatePicker
 * - MobileDateTimePicker
 * - MobileTimePicker
 */
const useMobilePicker = _ref => {
  var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
  let {
      props,
      getOpenDialogAriaText
    } = _ref,
    pickerParams = _objectWithoutPropertiesLoose$b(_ref, _excluded$1c);
  const {
    slots,
    slotProps: innerSlotProps,
    className,
    sx,
    format,
    formatDensity,
    timezone,
    label,
    inputRef,
    readOnly,
    disabled,
    localeText
  } = props;
  const utils = useUtils();
  const internalInputRef = React$1.useRef(null);
  const labelId = useId();
  const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
  const {
    open,
    actions,
    layoutProps,
    renderCurrentView,
    fieldProps: pickerFieldProps
  } = usePicker(_extends$c({}, pickerParams, {
    props,
    inputRef: internalInputRef,
    autoFocusView: true,
    additionalViewProps: {},
    wrapperVariant: 'mobile'
  }));
  const Field = slots.field;
  const fieldProps = useSlotProps({
    elementType: Field,
    externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
    additionalProps: _extends$c({}, pickerFieldProps, isToolbarHidden && {
      id: labelId
    }, !(disabled || readOnly) && {
      onClick: actions.onOpen,
      onKeyDown: onSpaceOrEnter(actions.onOpen)
    }, {
      readOnly: readOnly != null ? readOnly : true,
      disabled,
      className,
      sx,
      format,
      formatDensity,
      timezone,
      label
    }),
    ownerState: props
  });

  // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
  fieldProps.inputProps = _extends$c({}, fieldProps.inputProps, {
    'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
  });
  const slotsForField = _extends$c({
    textField: slots.textField
  }, fieldProps.slots);
  const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : PickersLayout;
  const handleInputRef = useForkRef(internalInputRef, fieldProps.inputRef, inputRef);
  let labelledById = labelId;
  if (isToolbarHidden) {
    if (label) {
      labelledById = `${labelId}-label`;
    } else {
      labelledById = undefined;
    }
  }
  const slotProps = _extends$c({}, innerSlotProps, {
    toolbar: _extends$c({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
      titleId: labelId
    }),
    mobilePaper: _extends$c({
      'aria-labelledby': labelledById
    }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
  });
  const renderPicker = () => /*#__PURE__*/jsxs(LocalizationProvider, {
    localeText: localeText,
    children: [/*#__PURE__*/jsx(Field, _extends$c({}, fieldProps, {
      slots: slotsForField,
      slotProps: slotProps,
      inputRef: handleInputRef
    })), /*#__PURE__*/jsx(PickersModalDialog, _extends$c({}, actions, {
      open: open,
      slots: slots,
      slotProps: slotProps,
      children: /*#__PURE__*/jsx(Layout, _extends$c({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
        slots: slots,
        slotProps: slotProps,
        children: renderCurrentView()
      }))
    }))]
  });
  return {
    renderPicker
  };
};

const MobileDatePicker = /*#__PURE__*/React$1.forwardRef(function MobileDatePicker(inProps, ref) {
  var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
  const localeText = useLocaleText();
  const utils = useUtils();

  // Props with the default values common to all date pickers
  const defaultizedProps = useDatePickerDefaultizedProps(inProps, 'MuiMobileDatePicker');
  const viewRenderers = _extends$c({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, defaultizedProps.viewRenderers);

  // Props with the default values specific to the mobile variant
  const props = _extends$c({}, defaultizedProps, {
    viewRenderers,
    format: resolveDateFormat(utils, defaultizedProps, false),
    slots: _extends$c({
      field: DateField
    }, defaultizedProps.slots),
    slotProps: _extends$c({}, defaultizedProps.slotProps, {
      field: ownerState => {
        var _defaultizedProps$slo;
        return _extends$c({}, resolveComponentProps((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), extractValidationProps(defaultizedProps), {
          ref
        });
      },
      toolbar: _extends$c({
        hidden: false
      }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
    })
  });
  const {
    renderPicker
  } = useMobilePicker({
    props,
    valueManager: singleItemValueManager,
    valueType: 'date',
    getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
    validator: validateDate
  });
  return renderPicker();
});
MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */
  defaultCalendarMonth: PropTypes.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(['dense', 'spacious']),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(['landscape', 'portrait']),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(['all', 'day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'weekDay', 'year']), PropTypes.number, PropTypes.shape({
    endIndex: PropTypes.number.isRequired,
    startIndex: PropTypes.number.isRequired
  })]),
  /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};

const _excluded$1b = ["desktopModeMediaQuery"];
const DatePicker = /*#__PURE__*/React$1.forwardRef(function DatePicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDatePicker'
  });
  const {
      desktopModeMediaQuery = DEFAULT_DESKTOP_MODE_MEDIA_QUERY
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1b);

  // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
  const isDesktop = useMediaQuery$1(desktopModeMediaQuery, {
    defaultMatches: true
  });
  if (isDesktop) {
    return /*#__PURE__*/jsx(DesktopDatePicker, _extends$c({
      ref: ref
    }, other));
  }
  return /*#__PURE__*/jsx(MobileDatePicker, _extends$c({
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: PropTypes.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: PropTypes.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */
  defaultCalendarMonth: PropTypes.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: PropTypes.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(['dense', 'spacious']),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.any,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(['landscape', 'portrait']),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(['all', 'day', 'hours', 'meridiem', 'minutes', 'month', 'seconds', 'weekDay', 'year']), PropTypes.number, PropTypes.shape({
    endIndex: PropTypes.number.isRequired,
    startIndex: PropTypes.number.isRequired
  })]),
  /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormatPlugin);
const locale$2 = navigator.language;
const localeMap = {
  "en-US": "en",
  "en-CA": "en-ca",
  "en-NZ": "en-nz",
  "en-AU": "en-au",
  "en-GB": "en-gb",
  "fr-CA": "fr-ca",
  "de-DE": "de"
};
const getDayjsLocale = (locale2) => defaultValue(localeMap[locale2], "en-nz");
import(`dayjs/locale/${getDayjsLocale(locale$2)}.js`).then(() => dayjs.locale(getDayjsLocale(locale$2)));

var __async$t = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const httpService = new HttpService(process.env.ONEVENT_CORE_API_PATHNAME);
function useLocalisationSettings(options) {
  return useQuery$1(
    ["/System/Settings", "ONEVENT.Localisation"],
    (_0) => __async$t(this, [_0], function* ({ signal }) {
      var _a;
      const data = yield httpService.get("System/Settings?keyPrefix=ONEVENT.Localisation", void 0, signal);
      if (data) {
        return typeof data[0].value === "string" ? (_a = JSON.parse(data[0].value)) != null ? _a : {} : data[0].value;
      } else {
        throw new Error("No localisation data found");
      }
    }),
    Object.assign({ staleTime: Number.POSITIVE_INFINITY }, options)
  );
}

const isNothing = (value) => value === void 0 || value === null;
const isObjectCode = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("codeID") && value.hasOwnProperty("name");
const isLookupItem = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("id") && value.hasOwnProperty("name");
const isObjectLocation = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("locationID") && value.hasOwnProperty("locationName");
const isObjectParty = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("contactID") && value.hasOwnProperty("fileAs");
const isObjectReference = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("reference");
const isObjectDate = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("dateAndTime");
const isObjectMeasure = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("measure");
const isObjectNote = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("note");
const isObjectMark = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("value");
const isToggleItem = (value) => value !== null && value !== void 0 && typeof value === "object" && value.hasOwnProperty("value") && value.hasOwnProperty("label");

var __defProp$1w = Object.defineProperty;
var __getOwnPropSymbols$1x = Object.getOwnPropertySymbols;
var __hasOwnProp$1x = Object.prototype.hasOwnProperty;
var __propIsEnum$1x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1w = (obj, key, value) => key in obj ? __defProp$1w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1x.call(b, prop))
      __defNormalProp$1w(a, prop, b[prop]);
  if (__getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(b)) {
      if (__propIsEnum$1x.call(b, prop))
        __defNormalProp$1w(a, prop, b[prop]);
    }
  return a;
};
dayjs.extend(utc);
const locale$1 = navigator.language;
const inputStyles = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    "& .MuiInputBase-input": {
      padding: "0.5rem 0.75rem !important"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: (theme) => theme.palette.grey[400]
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: (theme) => theme.palette.grey[400]
    }
  }
};
function DateTimePicker({
  value,
  timePicker = false,
  disablePast = false,
  disableFuture = false,
  minDate,
  maxDate,
  disabled = false,
  readOnly = false,
  slotProps,
  onChange,
  dateTimeFormat = {
    dateFormat: void 0,
    timeFormat: void 0,
    pattern: void 0
  },
  error,
  errorMessage,
  dateTimePickerStyle
}) {
  var _a, _b, _c, _d, _e;
  const theme = useTheme$2();
  const onDatePickerChange = (newValue) => {
    handleChange(newValue);
  };
  const onTimePickerChange = (newValue) => {
    var _a2, _b2;
    if (newValue == null ? void 0 : newValue.isValid()) {
      handleChange(newValue);
      return;
    }
    const dateWithNoTime = (_b2 = (_a2 = getPickerValue(value)) == null ? void 0 : _a2.startOf("day")) != null ? _b2 : null;
    handleChange(dateWithNoTime);
  };
  const handleChange = (newValue) => {
    let value2;
    if (isNothing(newValue)) {
      value2 = null;
    } else if (!newValue.isValid()) {
      value2 = newValue.format();
    } else {
      value2 = omitTimezoneOffset ? newValue.format() : newValue.toISOString();
    }
    onChange(value2);
  };
  const getPickerValue = (value2) => {
    if (!value2) {
      return null;
    }
    return omitTimezoneOffset ? dayjs.utc(value2) : dayjs(value2);
  };
  const { data: localisationSettings } = useLocalisationSettings();
  const dateTimeFormats = (_a = localisationSettings == null ? void 0 : localisationSettings.dateTimeFormats) == null ? void 0 : _a.dayjs;
  const omitTimezoneOffset = !((_c = (_b = localisationSettings == null ? void 0 : localisationSettings.dateTimeFormatting) == null ? void 0 : _b.enableBackwardCompatibility) != null ? _c : false);
  const pickersTimezone = omitTimezoneOffset ? void 0 : "system";
  dateTimeFormat.dateFormat = (_d = dateTimeFormat == null ? void 0 : dateTimeFormat.dateFormat) != null ? _d : dateTimeFormats == null ? void 0 : dateTimeFormats.shortDate;
  dateTimeFormat.timeFormat = (_e = dateTimeFormat == null ? void 0 : dateTimeFormat.timeFormat) != null ? _e : dateTimeFormats == null ? void 0 : dateTimeFormats.shortTime;
  return /* @__PURE__ */ jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: getDayjsLocale(locale$1), children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", columnGap: theme.spacing(4) }, children: [
    /* @__PURE__ */ jsx(
      DatePicker,
      {
        value: getPickerValue(value),
        onChange: onDatePickerChange,
        sx: __spreadValues$1w(__spreadValues$1w({}, inputStyles), dateTimePickerStyle),
        disableFuture,
        disablePast,
        minDate: minDate ? dayjs.utc(minDate) : void 0,
        maxDate: maxDate ? dayjs.utc(maxDate) : void 0,
        disabled,
        readOnly,
        format: dateTimeFormat.dateFormat,
        timezone: pickersTimezone,
        slotProps: __spreadValues$1w({
          openPickerButton: {
            color: "primary",
            sx: { padding: 0, "& .MuiSvgIcon-root": { fontSize: "inherit" } }
          },
          textField: {
            error,
            helperText: errorMessage ? errorMessage : void 0,
            FormHelperTextProps: {
              sx: {
                marginX: 0
              }
            }
          }
        }, slotProps)
      }
    ),
    timePicker && /* @__PURE__ */ jsx(
      TimeField,
      {
        value: getPickerValue(value),
        onChange: onTimePickerChange,
        sx: inputStyles,
        disableFuture,
        disablePast,
        disabled,
        readOnly,
        format: dateTimeFormat.timeFormat,
        timezone: pickersTimezone
      }
    )
  ] }) });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject$2(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject$2(value);
}
function isChangeEvt(value) {
    return isObject$2(value) && isObject$2(value.target);
}
function isObject$2(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default$1 = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$h(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$h(arr); }

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$h(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }

function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default$1(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$4(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$4(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$4(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$4(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$8(_objectSpread$8({}, agg), {}, _defineProperty$8({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$4(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded$1a = ["children"],
    _excluded2$9 = ["open"],
    _excluded3$3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4$1 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$g(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$g(arr); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$g(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }

function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$9(_ref, _excluded$1a);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$9(_useDropzone, _excluded2$9);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default$1.createElement(Fragment$1, null, children(_objectSpread$7(_objectSpread$7({}, props), {}, {
    open: open
  })));
});
Dropzone$1.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps$1 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone$1.defaultProps = defaultProps$1;
Dropzone$1.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread$7(_objectSpread$7({}, defaultProps$1), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$2;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$2;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$3(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray$3(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray$3(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties$9(_ref2, _excluded3$3);

      return _objectSpread$7(_objectSpread$7(_defineProperty$7({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties$9(_ref3, _excluded4$1);

      var inputProps = _defineProperty$7({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$7(_objectSpread$7({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread$7(_objectSpread$7({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread$7(_objectSpread$7({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread$7(_objectSpread$7({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread$7(_objectSpread$7({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread$7(_objectSpread$7({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread$7(_objectSpread$7({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread$7(_objectSpread$7({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread$7({}, initialState);

    default:
      return state;
  }
}

function noop$2() {}

var __defProp$1v = Object.defineProperty;
var __defProps$1d = Object.defineProperties;
var __getOwnPropDescs$1d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1w = Object.getOwnPropertySymbols;
var __hasOwnProp$1w = Object.prototype.hasOwnProperty;
var __propIsEnum$1w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1v = (obj, key, value) => key in obj ? __defProp$1v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1w.call(b, prop))
      __defNormalProp$1v(a, prop, b[prop]);
  if (__getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(b)) {
      if (__propIsEnum$1w.call(b, prop))
        __defNormalProp$1v(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1d = (a, b) => __defProps$1d(a, __getOwnPropDescs$1d(b));
var MimeTypes = /* @__PURE__ */ ((MimeTypes2) => {
  MimeTypes2["pdf"] = "application/pdf";
  MimeTypes2["doc"] = "application/msword";
  MimeTypes2["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  MimeTypes2["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  MimeTypes2["xls"] = "application/vnd.ms-excel";
  MimeTypes2["jpg"] = "image/jpeg";
  MimeTypes2["jpeg"] = "image/jpeg";
  MimeTypes2["png"] = "image/png";
  MimeTypes2["tif"] = "image/tiff";
  MimeTypes2["tiff"] = "image/tiff";
  MimeTypes2["webp"] = "image/webp";
  MimeTypes2["csv"] = "text/csv";
  MimeTypes2["msg"] = "application/vnd.ms-outlook";
  MimeTypes2["allImageTypes"] = "image/*";
  MimeTypes2["allTypes"] = "*/*";
  return MimeTypes2;
})(MimeTypes || {});
const baseStyle = {
  flex: "1",
  display: "flex",
  alignItems: "center",
  borderWidth: "2px",
  borderRadius: "2px",
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  height: "100%",
  justifyContent: "center",
  cursor: "pointer"
};
const focusedStyle = {
  borderColor: "#2196f3"
};
const acceptStyle = {
  borderColor: "#00e676"
};
const rejectStyle = {
  borderColor: "#ff1744"
};
function Dropzone({
  accept = ["*/*" /* allTypes */],
  onDrop,
  multiple,
  maxFiles,
  maxSize,
  label = "Drag 'n' drop some files here, or click to select files",
  icon,
  disabled
}) {
  var _a;
  const acceptedFileTypes = {};
  if (accept.some((type) => type === "*/*" /* allTypes */)) {
    acceptedFileTypes["*/*"] = [];
    accept = [];
  }
  if (accept.some((type) => type === "image/*" /* allImageTypes */)) {
    acceptedFileTypes["image/*"] = [".jpg", ".jpeg", ".png", ".tif", ".tiff", ".webp"];
    accept = accept.filter((type) => !acceptedFileTypes["image/*"].includes(`.${type}`));
  }
  for (const mimeType of accept) {
    const enumKey = (_a = Object.entries(MimeTypes).find(([, type]) => type === mimeType)) == null ? void 0 : _a[0];
    if (!enumKey)
      continue;
    if (!acceptedFileTypes[mimeType]) {
      acceptedFileTypes[mimeType] = [];
    }
    acceptedFileTypes[mimeType].push("." + enumKey);
  }
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject, open } = useDropzone({
    accept: acceptedFileTypes,
    onDrop,
    multiple,
    maxFiles,
    maxSize
  });
  const style = useMemo(
    () => __spreadValues$1v(__spreadValues$1v(__spreadValues$1v(__spreadValues$1v({}, baseStyle), isFocused ? focusedStyle : {}), isDragAccept ? acceptStyle : {}), isDragReject ? rejectStyle : {}),
    [isFocused, isDragAccept, isDragReject]
  );
  return /* @__PURE__ */ jsxs("div", __spreadProps$1d(__spreadValues$1v({ style }, getRootProps({ className: "dropzone" })), { children: [
    /* @__PURE__ */ jsx("input", __spreadProps$1d(__spreadValues$1v({}, getInputProps()), { disabled })),
    icon ? icon : label
  ] }));
}

function ExpandableSection({ title, expanded = true, children }) {
  const [_expanded, setExpanded] = useState(expanded);
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
          cursor: "pointer"
        },
        onClick: () => setExpanded((x) => !x),
        children: [
          /* @__PURE__ */ jsx(Typography, { color: "primary", fontSize: "0.85rem", fontWeight: "bold", children: title }),
          _expanded ? /* @__PURE__ */ jsx(ExpandLess, { color: "primary", fontSize: "medium" }) : /* @__PURE__ */ jsx(ExpandMore, { color: "primary", fontSize: "medium" })
        ]
      }
    ),
    _expanded && /* @__PURE__ */ jsx(Fragment, { children })
  ] });
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var equal = /*@__PURE__*/getDefaultExportFromCjs(fastDeepEqual);

const ARRAY_TYPES = [
    Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array,
    Int32Array, Uint32Array, Float32Array, Float64Array
];

/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */

const VERSION = 1; // serialized format version
const HEADER_SIZE = 8;

class KDBush {

    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */
    static from(data) {
        if (!(data instanceof ArrayBuffer)) {
            throw new Error('Data must be an instance of ArrayBuffer.');
        }
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) {
            throw new Error('Data does not appear to be in a KDBush format.');
        }
        const version = versionAndType >> 4;
        if (version !== VERSION) {
            throw new Error(`Got v${version} data when expected v${VERSION}.`);
        }
        const ArrayType = ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) {
            throw new Error('Unrecognized array type.');
        }
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);

        return new KDBush(numItems, nodeSize, ArrayType, data);
    }

    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */
    constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data) {
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);

        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;

        const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;

        if (arrayTypeIndex < 0) {
            throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        }

        if (data && (data instanceof ArrayBuffer)) { // reconstruct an index from a buffer
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else { // initialize a new index
            this.data = new ArrayBuffer(HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;

            // set header
            new Uint8Array(this.data, 0, 2).set([0xdb, (VERSION << 4) + arrayTypeIndex]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }

    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */
    add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }

    /**
     * Perform indexing of the added points.
     */
    finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) {
            throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        }
        // kd-sort both arrays for efficient search
        sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);

        this._finished = true;
        return this;
    }

    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */
    range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');

        const {ids, coords, nodeSize} = this;
        const stack = [0, ids.length - 1, 0];
        const result = [];

        // recursively search for items in range in the kd-sorted arrays
        while (stack.length) {
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;

            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for (let i = left; i <= right; i++) {
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }

            // otherwise find the middle index
            const m = (left + right) >> 1;

            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);

            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }

        return result;
    }

    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */
    within(qx, qy, r) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');

        const {ids, coords, nodeSize} = this;
        const stack = [0, ids.length - 1, 0];
        const result = [];
        const r2 = r * r;

        // recursively search for items within radius in the kd-sorted arrays
        while (stack.length) {
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;

            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for (let i = left; i <= right; i++) {
                    if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                }
                continue;
            }

            // otherwise find the middle index
            const m = (left + right) >> 1;

            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);

            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }

        return result;
    }
}

/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */
function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;

    const m = (left + right) >> 1; // middle index

    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    select(ids, coords, m, left, right, axis);

    // recursively kd-sort first half and second half on the opposite axis
    sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}

/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */
function select(ids, coords, k, left, right, axis) {

    while (right > left) {
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, axis);
        }

        const t = coords[2 * k + axis];
        let i = left;
        let j = right;

        swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) swapItem(ids, coords, left, right);

        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + axis] < t) i++;
            while (coords[2 * j + axis] > t) j--;
        }

        if (coords[2 * left + axis] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */
function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}

/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */
function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

const defaultOptions$1 = {
    minZoom: 0,   // min zoom to generate clusters on
    maxZoom: 16,  // max zoom level to cluster the points on
    minPoints: 2, // minimum points to form a cluster
    radius: 40,   // cluster radius in pixels
    extent: 512,  // tile extent (radius is calculated relative to it)
    nodeSize: 64, // size of the KD-tree leaf node, affects performance
    log: false,   // whether to log timing info

    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,

    // a reduce function for calculating custom cluster properties
    reduce: null, // (accumulated, props) => { accumulated.sum += props.sum; }

    // properties to use for individual points when running the reducer
    map: props => props // props => ({sum: props.my_value})
};

const fround = Math.fround || (tmp => ((x) => { tmp[0] = +x; return tmp[0]; }))(new Float32Array(1));

const OFFSET_ZOOM = 2;
const OFFSET_ID = 3;
const OFFSET_PARENT = 4;
const OFFSET_NUM = 5;
const OFFSET_PROP = 6;

class Supercluster {
    constructor(options) {
        this.options = Object.assign(Object.create(defaultOptions$1), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }

    load(points) {
        const {log, minZoom, maxZoom} = this.options;

        if (log) console.time('total time');

        const timerId = `prepare ${  points.length  } points`;
        if (log) console.time(timerId);

        this.points = points;

        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];

        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            if (!p.geometry) continue;

            const [lng, lat] = p.geometry.coordinates;
            const x = fround(lngX(lng));
            const y = fround(latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(
                x, y, // projected point coordinates
                Infinity, // the last zoom the point was processed at
                i, // index of the source feature in the original input array
                -1, // parent cluster id
                1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);

        if (log) console.timeEnd(timerId);

        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for (let z = maxZoom; z >= minZoom; z--) {
            const now = +Date.now();

            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));

            if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
        }

        if (log) console.timeEnd('total time');

        return this;
    }

    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));

        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
            const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
            return easternHem.concat(westernHem);
        }

        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids) {
            const k = this.stride * id;
            clusters.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
        return clusters;
    }

    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';

        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);

        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);

        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids) {
            const k = id * this.stride;
            if (data[k + OFFSET_PARENT] === clusterId) {
                children.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
            }
        }

        if (children.length === 0) throw new Error(errorMsg);

        return children;
    }

    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;

        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);

        return leaves;
    }

    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const {extent, radius} = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;

        const tile = {
            features: []
        };

        this._addTileFeatures(
            tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
            tree.data, x, y, z2, tile);

        if (x === 0) {
            this._addTileFeatures(
                tree.range(1 - p / z2, top, 1, bottom),
                tree.data, z2, y, z2, tile);
        }
        if (x === z2 - 1) {
            this._addTileFeatures(
                tree.range(0, top, p / z2, bottom),
                tree.data, -1, y, z2, tile);
        }

        return tile.features.length ? tile : null;
    }

    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while (expansionZoom <= this.options.maxZoom) {
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }

    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);

        for (const child of children) {
            const props = child.properties;

            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) {
                    // skip the whole cluster
                    skipped += props.point_count;
                } else {
                    // enter the cluster
                    skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
                    // exit the cluster
                }
            } else if (skipped < offset) {
                // skip a single point
                skipped++;
            } else {
                // add a single point
                result.push(child);
            }
            if (result.length === limit) break;
        }

        return skipped;
    }

    _createTree(data) {
        const tree = new KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for (let i = 0; i < data.length; i += this.stride) tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }

    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids) {
            const k = i * this.stride;
            const isCluster = data[k + OFFSET_NUM] > 1;

            let tags, px, py;
            if (isCluster) {
                tags = getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = lngX(lng);
                py = latY(lat);
            }

            const f = {
                type: 1,
                geometry: [[
                    Math.round(this.options.extent * (px * z2 - x)),
                    Math.round(this.options.extent * (py * z2 - y))
                ]],
                tags
            };

            // assign id
            let id;
            if (isCluster || this.options.generateId) {
                // optionally generate id for points
                id = data[k + OFFSET_ID];
            } else {
                // keep id if already assigned
                id = this.points[data[k + OFFSET_ID]].id;
            }

            if (id !== undefined) f.id = id;

            tile.features.push(f);
        }
    }

    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }

    _cluster(tree, zoom) {
        const {radius, extent, reduce, minPoints} = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;

        // loop through each point
        for (let i = 0; i < data.length; i += stride) {
            // if we've already visited the point at this zoom level, skip it
            if (data[i + OFFSET_ZOOM] <= zoom) continue;
            data[i + OFFSET_ZOOM] = zoom;

            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);

            const numPointsOrigin = data[i + OFFSET_NUM];
            let numPoints = numPointsOrigin;

            // count the number of points in a potential cluster
            for (const neighborId of neighborIds) {
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + OFFSET_ZOOM] > zoom) numPoints += data[k + OFFSET_NUM];
            }

            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;

                let clusterProperties;
                let clusterPropIndex = -1;

                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;

                for (const neighborId of neighborIds) {
                    const k = neighborId * stride;

                    if (data[k + OFFSET_ZOOM] <= zoom) continue;
                    data[k + OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)

                    const numPoints2 = data[k + OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;

                    data[k + OFFSET_PARENT] = id;

                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }

                data[i + OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);

            } else { // left points as unclustered
                for (let j = 0; j < stride; j++) nextData.push(data[i + j]);

                if (numPoints > 1) {
                    for (const neighborId of neighborIds) {
                        const k = neighborId * stride;
                        if (data[k + OFFSET_ZOOM] <= zoom) continue;
                        data[k + OFFSET_ZOOM] = zoom;
                        for (let j = 0; j < stride; j++) nextData.push(data[k + j]);
                    }
                }
            }
        }

        return nextData;
    }

    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return (clusterId - this.points.length) >> 5;
    }

    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }

    _map(data, i, clone) {
        if (data[i + OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}

function getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + OFFSET_ID],
        properties: getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [xLng(data[i]), yLat(data[i + 1])]
        }
    };
}

function getClusterProperties(data, i, clusterProps) {
    const count = data[i + OFFSET_NUM];
    const abbrev =
        count >= 10000 ? `${Math.round(count / 1000)  }k` :
        count >= 1000 ? `${Math.round(count / 100) / 10  }k` : count;
    const propIndex = data[i + OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
    return y < 0 ? 0 : y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */
class MarkerUtils {
    static isAdvancedMarkerAvailable(map) {
        return (google.maps.marker &&
            map.getMapCapabilities().isAdvancedMarkersAvailable === true);
    }
    static isAdvancedMarker(marker) {
        return (google.maps.marker &&
            marker instanceof google.maps.marker.AdvancedMarkerElement);
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) {
            marker.map = map;
        }
        else {
            marker.setMap(map);
        }
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) {
                    return marker.position;
                }
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) {
                    return new google.maps.LatLng(marker.position.lat, marker.position.lng);
                }
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) {
            /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */
            return true;
        }
        return marker.getVisible();
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Cluster {
    constructor({ markers, position }) {
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) {
                this._position = position;
            }
            else {
                this._position = new google.maps.LatLng(position);
            }
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) {
            return;
        }
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers) {
            bounds.extend(MarkerUtils.getPosition(marker));
        }
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */
    get count() {
        return this.markers.filter((m) => MarkerUtils.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */
    push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */
    delete() {
        if (this.marker) {
            MarkerUtils.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @hidden
 */
class AbstractAlgorithm {
    constructor({ maxZoom = 16 }) {
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */
    noop({ markers, }) {
        return noop$1(markers);
    }
}
/**
 * @hidden
 */
const noop$1 = (markers) => {
    const clusters = markers.map((marker) => new Cluster({
        position: MarkerUtils.getPosition(marker),
        markers: [marker],
    }));
    return clusters;
};

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */
class SuperClusterAlgorithm extends AbstractAlgorithm {
    constructor(_a) {
        var { maxZoom, radius = 60 } = _a, options = __rest(_a, ["maxZoom", "radius"]);
        super({ maxZoom });
        this.state = { zoom: -1 };
        this.superCluster = new Supercluster(Object.assign({ maxZoom: this.maxZoom, radius }, options));
    }
    calculate(input) {
        let changed = false;
        const state = { zoom: input.map.getZoom() };
        if (!equal(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [...input.markers];
            const points = this.markers.map((marker) => {
                const position = MarkerUtils.getPosition(marker);
                const coordinates = [position.lng(), position.lat()];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates,
                    },
                    properties: { marker },
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) {
                changed = !equal(this.state, state);
            }
        }
        this.state = state;
        if (changed) {
            this.clusters = this.cluster(input);
        }
        return { clusters: this.clusters, changed };
    }
    cluster({ map }) {
        return this.superCluster
            .getClusters([-180, -90, 180, 90], Math.round(map.getZoom()))
            .map((feature) => this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat], }, properties, }) {
        if (properties.cluster) {
            return new Cluster({
                markers: this.superCluster
                    .getLeaves(properties.cluster_id, Infinity)
                    .map((leaf) => leaf.properties.marker),
                position: { lat, lng },
            });
        }
        const marker = properties.marker;
        return new Cluster({
            markers: [marker],
            position: MarkerUtils.getPosition(marker),
        });
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */
class ClusterStats {
    constructor(markers, clusters) {
        this.markers = { sum: markers.length };
        const clusterMarkerCounts = clusters.map((a) => a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b) => a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts),
            },
        };
    }
}
class DefaultRenderer {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    render({ count, position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, 
        // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map,
                position,
                zIndex,
                title,
                content: svgEl,
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position,
            zIndex,
            title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25),
            },
        };
        return new google.maps.Marker(clusterOptions);
    }
}

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extend(type1, type2) {
    /* istanbul ignore next */
    // eslint-disable-next-line prefer-const
    for (let property in type2.prototype) {
        type1.prototype[property] = type2.prototype[property];
    }
}
/**
 * @ignore
 */
class OverlayViewSafe {
    constructor() {
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        extend(OverlayViewSafe, google.maps.OverlayView);
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MarkerClustererEvents;
(function (MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
const defaultOnClusterClickHandler = (_, cluster, map) => {
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */
class MarkerClusterer extends OverlayViewSafe {
    constructor({ map, markers = [], algorithmOptions = {}, algorithm = new SuperClusterAlgorithm(algorithmOptions), renderer = new DefaultRenderer(), onClusterClick = defaultOnClusterClickHandler, }) {
        super();
        this.markers = [...markers];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) {
            this.setMap(map);
        }
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) {
            return;
        }
        this.markers.push(marker);
        if (!noDraw) {
            this.render();
        }
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker) => {
            this.addMarker(marker, true);
        });
        if (!noDraw) {
            this.render();
        }
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) {
            // Marker is not in our list of markers, so do nothing:
            return false;
        }
        MarkerUtils.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) {
            this.render();
        }
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker) => {
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) {
            this.render();
        }
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) {
            this.render();
        }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */
    render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
            const { clusters, changed } = this.algorithm.calculate({
                markers: this.markers,
                map,
                mapCanvasProjection: this.getProjection(),
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters) {
                    if (cluster.markers.length == 1) {
                        singleMarker.add(cluster.markers[0]);
                    }
                }
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters) {
                    if (cluster.marker == null) {
                        continue;
                    }
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) {
                            // The marker:
                            // - was previously rendered because it is from a cluster with 1 marker,
                            // - should no more be rendered as it is not in singleMarker.
                            MarkerUtils.setMap(cluster.marker, null);
                        }
                    }
                    else {
                        // Delay the removal of old group markers to avoid flickering.
                        groupMarkers.push(cluster.marker);
                    }
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(() => groupMarkers.forEach((marker) => MarkerUtils.setMap(marker, null)));
            }
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
        this.clusters.forEach((cluster) => cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new ClusterStats(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster) => {
            if (cluster.markers.length === 1) {
                cluster.marker = cluster.markers[0];
            }
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
                if (this.onClusterClick) {
                    cluster.marker.addListener("click", 
                    /* istanbul ignore next */
                    (event) => {
                        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                        this.onClusterClick(event, cluster, map);
                    });
                }
            }
            MarkerUtils.setMap(cluster.marker, map);
        });
    }
}

var __defProp$1u = Object.defineProperty;
var __defProps$1c = Object.defineProperties;
var __getOwnPropDescs$1c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1v = Object.getOwnPropertySymbols;
var __hasOwnProp$1v = Object.prototype.hasOwnProperty;
var __propIsEnum$1v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1u = (obj, key, value) => key in obj ? __defProp$1u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1v.call(b, prop))
      __defNormalProp$1u(a, prop, b[prop]);
  if (__getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(b)) {
      if (__propIsEnum$1v.call(b, prop))
        __defNormalProp$1u(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1c = (a, b) => __defProps$1c(a, __getOwnPropDescs$1c(b));
var __objRest$Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp$1u(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async$s = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const DEFAULT_OPTIONS$1 = {
  center: { lat: -36.85665, lng: 174.746974 },
  zoom: 8,
  maxZoom: 15,
  disableDefaultUI: true,
  zoomControl: true
};
const Context$e = createContext({});
const AdvancedMarkerContext = createContext({});
const MarkerClustererContext = createContext({});
function _GoogleMap({
  apiKey,
  libraries = ["core", "geometry", "maps", "marker"],
  options = DEFAULT_OPTIONS$1,
  children
}) {
  const ref = useRef(null);
  const loader = new Loader$1({
    apiKey,
    libraries
  });
  const [mapInstance, setMapInstance] = useState();
  const [mapBounds, setMapBounds] = useState();
  const instantiateMap = () => {
    var _a, _b, _c, _d;
    if (((_b = (_a = window.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.LatLngBounds) && !mapBounds) {
      const bounds = new window.google.maps.LatLngBounds();
      setMapBounds(bounds);
    }
    if (ref.current && ((_d = (_c = window.google) == null ? void 0 : _c.maps) == null ? void 0 : _d.Map) && !mapInstance) {
      const map = new window.google.maps.Map(ref.current, Object.assign(DEFAULT_OPTIONS$1, options));
      setMapInstance(map);
    }
  };
  useEffect(() => {
    const libs = libraries.reduce((accum, lib) => {
      return [...accum, loader.importLibrary(lib)];
    }, []);
    (() => __async$s(this, null, function* () {
      yield Promise.allSettled(libs).then(instantiateMap);
    }))();
  }, [loader]);
  const instancesLoaded = mapInstance && mapBounds;
  return /* @__PURE__ */ jsx("div", { ref, style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsx(
    Context$e.Provider,
    {
      value: {
        apiLoader: loader,
        map: mapInstance,
        bounds: mapBounds
      },
      children: instancesLoaded && /* @__PURE__ */ jsx(Fragment, { children })
    }
  ) });
}
function GoogleMapAdvancedMarker({
  position,
  onClick = noop$6,
  children
}) {
  const { map, bounds } = useContext(Context$e);
  const { markerClusterer } = useContext(MarkerClustererContext);
  const [markerInstance, setMarkerInstance] = useState();
  const [marker, setMarker] = useState();
  useEffect(() => {
    return () => {
      if (markerInstance) {
        window.queueMicrotask(() => {
          google.maps.event.clearInstanceListeners(markerInstance);
          markerInstance.map = null;
        });
      }
    };
  }, []);
  if (window.google.maps.marker.AdvancedMarkerElement && !markerInstance) {
    const container = document.createElement("div");
    const marker2 = new window.google.maps.marker.AdvancedMarkerElement({
      map,
      position,
      content: container
    });
    marker2.addListener("click", (event) => onClick(event, marker2));
    bounds.extend(position);
    map.fitBounds(bounds);
    map.setCenter(bounds.getCenter());
    if (markerClusterer) {
      markerClusterer.addMarker(marker2, true);
    }
    setMarkerInstance(marker2);
    setMarker(createPortal(children, container));
  }
  const renderCond = map && markerInstance && marker;
  return /* @__PURE__ */ jsx(AdvancedMarkerContext.Provider, { value: { marker: markerInstance }, children: /* @__PURE__ */ jsx(Fragment, { children: renderCond && marker }) });
}
function GoogleMapMarkerClusterer(_a) {
  var _b = _a, { children } = _b, props = __objRest$Q(_b, ["children"]);
  const { map } = useContext(Context$e);
  const [markerClustererInstance, setMarkerClustererInstance] = useState();
  useEffect(() => {
    return () => {
      if (markerClustererInstance) {
        window.queueMicrotask(() => markerClustererInstance.clearMarkers(false));
      }
    };
  }, []);
  if (map && !markerClustererInstance) {
    const markerClusterer = new MarkerClusterer(__spreadProps$1c(__spreadValues$1u({}, props), { map }));
    setMarkerClustererInstance(markerClusterer);
  }
  return /* @__PURE__ */ jsx(MarkerClustererContext.Provider, { value: { markerClusterer: markerClustererInstance }, children: /* @__PURE__ */ jsx(Fragment, { children: markerClustererInstance && children }) });
}
function GoogleMapPolyline(props) {
  const { map } = useContext(Context$e);
  if (map) {
    const polyline = new google.maps.Polyline(props);
    polyline.setMap(map);
  }
  return /* @__PURE__ */ jsx(Fragment, {});
}
function GoogleMapOverlayView({
  position,
  pane,
  offset = { x: 0, y: 0 },
  children
}) {
  const { map } = useContext(Context$e);
  const container = document.createElement("div");
  container.style.position = "absolute";
  class Overlay extends google.maps.OverlayView {
    constructor(container2, position2, pane2, offset2) {
      super();
      __publicField(this, "container");
      __publicField(this, "position");
      __publicField(this, "pane");
      __publicField(this, "offset");
      this.container = container2;
      this.position = position2;
      this.pane = pane2;
      this.offset = offset2;
    }
    onAdd() {
      var _a, _b;
      (_b = (_a = this.getPanes()) == null ? void 0 : _a[this.pane]) == null ? void 0 : _b.appendChild(this.container);
    }
    onRemove() {
      if (this.container.parentElement) {
        this.container.parentElement.removeChild(this.container);
      }
    }
    draw() {
      var _a, _b;
      const position2 = this.getProjection().fromLatLngToDivPixel(this.position);
      this.container.style.left = `${position2.x + defaultValue((_a = this.offset) == null ? void 0 : _a.x, 0)}px`;
      this.container.style.top = `${position2.y + defaultValue((_b = this.offset) == null ? void 0 : _b.y, 0)}px`;
    }
  }
  if (map) {
    const overlay = new Overlay(container, position, pane, offset);
    overlay.setMap(map);
  }
  return createPortal(children, container);
}
const GoogleMap = Object.assign(_GoogleMap, {
  AdvancedMarker: React__default$1.memo(GoogleMapAdvancedMarker),
  MarkerClusterer: React__default$1.memo(GoogleMapMarkerClusterer),
  OverlayView: React__default$1.memo(GoogleMapOverlayView),
  Polyline: React__default$1.memo(GoogleMapPolyline)
});
const useGoogleMapContext = () => {
  return useContext(Context$e);
};
const useGoogleMapAdvancedMarkerContext = () => {
  return useContext(AdvancedMarkerContext);
};
const useGoogleMapMarkerClustererContext = () => {
  return useContext(MarkerClustererContext);
};

var __defProp$1t = Object.defineProperty;
var __defProps$1b = Object.defineProperties;
var __getOwnPropDescs$1b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1u = Object.getOwnPropertySymbols;
var __hasOwnProp$1u = Object.prototype.hasOwnProperty;
var __propIsEnum$1u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1t = (obj, key, value) => key in obj ? __defProp$1t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1u.call(b, prop))
      __defNormalProp$1t(a, prop, b[prop]);
  if (__getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(b)) {
      if (__propIsEnum$1u.call(b, prop))
        __defNormalProp$1t(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1b = (a, b) => __defProps$1b(a, __getOwnPropDescs$1b(b));
var __objRest$P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTooltip = styled$4((_a) => {
  var _b = _a, { className } = _b, props = __objRest$P(_b, ["className"]);
  return /* @__PURE__ */ jsx(Tooltip$1, __spreadProps$1b(__spreadValues$1t({}, props), { classes: { popper: className } }));
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "400px",
    minWidth: "300px",
    minHeight: "300px",
    padding: 0,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: "2px"
  }
}));
function InformationWindow({
  region,
  geoCoordinateInformation,
  severityIconMap,
  getRegionSeverity
}) {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: 2,
      bgcolor: theme.palette.background.paper,
      color: theme.palette.grey[800],
      children: [
        /* @__PURE__ */ jsxs(Typography, { fontWeight: 600, sx: { textDecoration: "underline" }, children: [
          region.name,
          ":"
        ] }),
        /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", gap: 4, children: /* @__PURE__ */ jsx(Fragment, { children: geoCoordinateInformation.map((info) => {
          const severity = getRegionSeverity([info]);
          const icon = severity ? severityIconMap[severity] : null;
          return /* @__PURE__ */ jsxs(
            Box,
            {
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: 2,
              children: [
                /* @__PURE__ */ jsx(Box, { fontSize: "1.5rem", color: theme.palette.primary.main, children: icon }),
                /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [
                  /* @__PURE__ */ jsx(Typography, { fontWeight: 600, children: info.informationTitle }),
                  /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", children: info.informationDescription })
                ] })
              ]
            },
            info.id
          );
        }) }) })
      ]
    }
  );
}
function GeoInformationRegionMapLayer({
  regions,
  geoCoordinateInformation,
  regionStyles,
  severityIconMap,
  getRegionSeverity
}) {
  const theme = useTheme$2();
  const { map } = useGoogleMapContext();
  const featureLayer = map.getFeatureLayer(google.maps.FeatureType.ADMINISTRATIVE_AREA_LEVEL_1);
  const defaultStyles = {
    strokeColor: theme.palette.grey[500],
    strokeOpacity: 0.5,
    strokeWeight: 1
  };
  const regionPlaceIds = regions.map((region) => region.placeId);
  const regionInformationMap = regions.reduce((accum, curr) => {
    accum[`${curr.placeId}`] = geoCoordinateInformation.filter((x) => +x.locationID === +curr.id);
    return accum;
  }, {});
  featureLayer.style = (options) => {
    const feature = options.feature;
    if (regionPlaceIds.includes(feature.placeId)) {
      const severity = getRegionSeverity(regionInformationMap[feature.placeId]);
      return severity ? regionStyles[severity] : defaultStyles;
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: regions.map((region) => {
    const severity = getRegionSeverity(regionInformationMap[region.placeId]);
    const icon = severity ? severityIconMap[severity] : null;
    return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(
      GoogleMap.OverlayView,
      {
        position: { lat: region.latitude, lng: region.longitude },
        pane: "overlayMouseTarget",
        offset: { x: -16, y: -16 },
        children: /* @__PURE__ */ jsx(
          StyledTooltip,
          {
            disableFocusListener: true,
            placement: "right-start",
            slotProps: {
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -12]
                    }
                  }
                ]
              }
            },
            title: /* @__PURE__ */ jsx(
              InformationWindow,
              {
                region,
                geoCoordinateInformation: regionInformationMap[region.placeId],
                severityIconMap,
                getRegionSeverity
              }
            ),
            children: /* @__PURE__ */ jsx(Box, { fontSize: "2rem", color: theme.palette.primary.main, sx: { cursor: "pointer" }, children: icon })
          }
        )
      }
    ) }, region.placeId);
  }) });
}

var __defProp$1s = Object.defineProperty;
var __defProps$1a = Object.defineProperties;
var __getOwnPropDescs$1a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1t = Object.getOwnPropertySymbols;
var __hasOwnProp$1t = Object.prototype.hasOwnProperty;
var __propIsEnum$1t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1s = (obj, key, value) => key in obj ? __defProp$1s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1t.call(b, prop))
      __defNormalProp$1s(a, prop, b[prop]);
  if (__getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(b)) {
      if (__propIsEnum$1t.call(b, prop))
        __defNormalProp$1s(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1a = (a, b) => __defProps$1a(a, __getOwnPropDescs$1a(b));
function Hyperlink({
  to,
  fontSize = "0.85rem",
  children,
  sx,
  target,
  onClick
}) {
  return /* @__PURE__ */ jsx(
    Link,
    __spreadProps$1a(__spreadValues$1s({
      component: Link$1,
      to,
      fontWeight: "600",
      fontSize,
      lineHeight: 1,
      sx: __spreadValues$1s({}, sx),
      onClick
    }, target ? { target: "_blank", rel: "noopener noreferrer" } : {}), {
      children
    })
  );
}

const useRifm = props => {
  const [, refresh] = useReducer(c => c + 1, 0);
  const valueRef = useRef(null);
  const {
    replace,
    append
  } = props;
  const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support

  const isDeleleteButtonDownRef = useRef(false);

  const onChange = evt => {
    if (process.env.NODE_ENV !== 'production') {
      if (evt.target.type === 'number') {
        console.error('Rifm does not support input type=number, use type=tel instead.');
        return;
      }

      if (evt.target.type === 'date') {
        console.error('Rifm does not support input type=date.');
        return;
      }
    }

    const eventValue = evt.target.value;
    valueRef.current = [eventValue, // eventValue
    evt.target, // input
    eventValue.length > userValue.length, // isSizeIncreaseOperation
    isDeleleteButtonDownRef.current, // isDeleleteButtonDown
    userValue === props.format(eventValue) // isNoOperation
    ];

    if (process.env.NODE_ENV !== 'production') {
      const formattedEventValue = props.format(eventValue);

      if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
        console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
      }
    } // The main trick is to update underlying input with non formatted value (= eventValue)
    // that allows us to calculate right cursor position after formatting (see getCursorPosition)
    // then we format new value and call props.onChange with masked/formatted value
    // and finally we are able to set cursor position into right place


    refresh();
  }; // React prints warn on server in non production mode about useLayoutEffect usage
  // in both cases it's noop


  if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
    useLayoutEffect(() => {
      if (valueRef.current == null) return;
      let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      isNoOperation] = valueRef.current;
      valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
      // in case of isDeleleteButtonDown cursor should move differently vs backspace

      const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
      const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
      const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
      const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols

      const clean = str => (str.match(props.accept || /\d/g) || []).join('');

      const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
      // This works because we assume that format doesn't change the order of accepted symbols.
      // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
      // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
      // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
      // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
      // so for formatting just this function to determine cursor position after formatting is enough
      // with masking we need to do some additional checks see `mask` below

      const getCursorPosition = val => {
        let start = 0;
        let cleanPos = 0;

        for (let i = 0; i !== valueBeforeSelectionStart.length; ++i) {
          let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
          let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
          // For example fixes edge case with fixed point numbers:
          // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
          // that order of accepted symbols is not changed after format,
          // so here we don't update start position if other accepted symbols was inbetween current and new position

          if (newCleanPos - cleanPos > 1) {
            newPos = start;
            newCleanPos = cleanPos;
          }

          cleanPos = Math.max(newCleanPos, cleanPos);
          start = Math.max(start, newPos);
        }

        return start;
      }; // Masking part, for masks if size of mask is above some value
      // we need to replace symbols instead of do nothing as like in format


      if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
        let start = getCursorPosition(eventValue);
        const c = clean(eventValue.substr(start))[0];
        start = eventValue.indexOf(c, start);
        eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
      }

      let formattedValue = props.format(eventValue);

      if (append != null && // cursor at the end
      input.selectionStart === eventValue.length && !isNoOperation) {
        if (isSizeIncreaseOperation) {
          formattedValue = append(formattedValue);
        } else {
          // If after delete last char is special character and we use append
          // delete it too
          // was: "12-3|" backspace pressed, then should be "12|"
          if (clean(formattedValue.slice(-1)) === '') {
            formattedValue = formattedValue.slice(0, -1);
          }
        }
      }

      const replacedValue = replace ? replace(formattedValue) : formattedValue;

      if (userValue === replacedValue) {
        // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
      } else {
        props.onChange(replacedValue);
      }

      return () => {
        let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
        // like cursor jumping over refused symbols
        // as an example date mask: was "5|1-24-3" then user pressed "6"
        // it becomes "56-|12-43" with this code, and "56|-12-43" without

        if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
          while (formattedValue[start] && clean(formattedValue[start]) === '') {
            start += 1;
          }
        }

        input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
      };
    });
  }

  useEffect(() => {
    // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
    // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
    // there is no way I found to distinguish in onChange
    // backspace or delete was called in some situations
    // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
    const handleKeyDown = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = true;
      }
    };

    const handleKeyUp = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = false;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return {
    value: valueRef.current != null ? valueRef.current[0] : userValue,
    onChange
  };
};
const Rifm = props => {
  const renderProps = useRifm(props);
  return props.children(renderProps);
};

var __defProp$1r = Object.defineProperty;
var __defProps$19 = Object.defineProperties;
var __getOwnPropDescs$19 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1s = Object.getOwnPropertySymbols;
var __hasOwnProp$1s = Object.prototype.hasOwnProperty;
var __propIsEnum$1s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1r = (obj, key, value) => key in obj ? __defProp$1r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1s.call(b, prop))
      __defNormalProp$1r(a, prop, b[prop]);
  if (__getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(b)) {
      if (__propIsEnum$1s.call(b, prop))
        __defNormalProp$1r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$19 = (a, b) => __defProps$19(a, __getOwnPropDescs$19(b));
var __objRest$O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$f = "";
const StyledTextField$2 = styled$4(MuiTextField, {
  shouldForwardProp: () => true
})(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    "& .MuiInputBase-input": {
      padding: 0,
      cursor: "inherit"
    }
  }
}));
function Input$2(_a) {
  var _b = _a, {
    type = "text",
    name,
    id = name,
    value = EMPTY_STRING$f,
    readOnly = false,
    disabled = false,
    fullWidth = true,
    InputProps,
    mask = false,
    accept = /./g,
    format = (input) => input,
    replace,
    append,
    onChange = noop$6
  } = _b, rest = __objRest$O(_b, [
    "type",
    "name",
    "id",
    "value",
    "readOnly",
    "disabled",
    "fullWidth",
    "InputProps",
    "mask",
    "accept",
    "format",
    "replace",
    "append",
    "onChange"
  ]);
  return /* @__PURE__ */ jsx(
    Rifm,
    {
      value,
      mask,
      accept,
      format,
      replace,
      append,
      onChange,
      children: ({ value: rifmValue, onChange: rifmOnChange }) => /* @__PURE__ */ jsx(
        StyledTextField$2,
        __spreadProps$19(__spreadValues$1r({}, rest), {
          id,
          name,
          type,
          value: rifmValue,
          disabled,
          fullWidth,
          onChange: rifmOnChange,
          InputProps: __spreadProps$19(__spreadValues$1r({}, InputProps), {
            readOnly
          })
        })
      )
    }
  );
}

var __defProp$1q = Object.defineProperty;
var __getOwnPropSymbols$1r = Object.getOwnPropertySymbols;
var __hasOwnProp$1r = Object.prototype.hasOwnProperty;
var __propIsEnum$1r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1q = (obj, key, value) => key in obj ? __defProp$1q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1r.call(b, prop))
      __defNormalProp$1q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(b)) {
      if (__propIsEnum$1r.call(b, prop))
        __defNormalProp$1q(a, prop, b[prop]);
    }
  return a;
};
function Label({ name, label, style, required, htmlFor }) {
  return /* @__PURE__ */ jsxs(InputLabel$1, { sx: __spreadValues$1q({}, style), id: name, htmlFor, children: [
    label,
    required && /* @__PURE__ */ jsx("span", { style: { color: "#d32f2f" }, children: "\xA0*" })
  ] });
}

function InputLabel({ name, label, required = false, htmlFor }) {
  return /* @__PURE__ */ jsx(
    Label,
    {
      name,
      label,
      required,
      style: {
        fontSize: "0.85rem",
        fontWeight: 600,
        color: (theme) => theme.palette.common.black,
        marginBottom: "0.5rem"
      },
      htmlFor
    }
  );
}

var __defProp$1p = Object.defineProperty;
var __defProps$18 = Object.defineProperties;
var __getOwnPropDescs$18 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1q = Object.getOwnPropertySymbols;
var __hasOwnProp$1q = Object.prototype.hasOwnProperty;
var __propIsEnum$1q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1p = (obj, key, value) => key in obj ? __defProp$1p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1q.call(b, prop))
      __defNormalProp$1p(a, prop, b[prop]);
  if (__getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(b)) {
      if (__propIsEnum$1q.call(b, prop))
        __defNormalProp$1p(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$18 = (a, b) => __defProps$18(a, __getOwnPropDescs$18(b));
var __objRest$N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Loader(_a) {
  var _b = _a, { sx } = _b, rest = __objRest$N(_b, ["sx"]);
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(Backdrop, __spreadProps$18(__spreadValues$1p({}, rest), { invisible: true, open: true, sx: __spreadValues$1p({ zIndex: theme.zIndex.modal }, sx), children: /* @__PURE__ */ jsx(CircularProgress$1, {}) }));
}

function LoadingWrap({
  isLoading,
  isError,
  errorMessage,
  children,
  retryBtnText,
  onRetry
}) {
  const renderError = useMemo(() => {
    const errorMsg = errorMessage || "Loading failed!";
    if (typeof onRetry === "function") {
      return /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [
        /* @__PURE__ */ jsx(Typography$1, { children: errorMsg }),
        /* @__PURE__ */ jsx(Button, { onClick: onRetry, children: retryBtnText || "RETRY" })
      ] });
    }
    return /* @__PURE__ */ jsx(Typography$1, { children: errorMsg });
  }, [errorMessage, retryBtnText, onRetry]);
  const renderContent = useMemo(() => {
    return isError ? renderError : children;
  }, [isError, renderError, children]);
  return /* @__PURE__ */ jsx(Fragment, { children: isLoading ? /* @__PURE__ */ jsx(Box$1, { display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ jsx(CircularProgress$1, {}) }) : renderContent });
}

var __defProp$1o = Object.defineProperty;
var __defProps$17 = Object.defineProperties;
var __getOwnPropDescs$17 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1p = Object.getOwnPropertySymbols;
var __hasOwnProp$1p = Object.prototype.hasOwnProperty;
var __propIsEnum$1p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1o = (obj, key, value) => key in obj ? __defProp$1o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1p.call(b, prop))
      __defNormalProp$1o(a, prop, b[prop]);
  if (__getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(b)) {
      if (__propIsEnum$1p.call(b, prop))
        __defNormalProp$1o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$17 = (a, b) => __defProps$17(a, __getOwnPropDescs$17(b));
var __objRest$M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$e = "";
const optionRender = (id, label) => (props, option) => {
  return /* @__PURE__ */ createElement("li", __spreadProps$17(__spreadValues$1o({}, props), { key: option[id] }), /* @__PURE__ */ jsx(Fragment, { children: option[label] }));
};
const optionEqualToValue = (id, label) => (option, value) => option[id] === value[id] && option[label] === value[label];
function Lookup(_a) {
  var _b = _a, {
    params,
    prefetch = false,
    useSearchTerm = false,
    disableClearOnSelect = false,
    value,
    blurOnSelect = true,
    open: lookupOpen = false,
    onOpen,
    onClose,
    onDataLoad,
    onSetSearchTerm = (term) => term,
    renderOption = optionRender("id", "name"),
    isOptionEqualToValue = optionEqualToValue("id", "name"),
    sortOptions,
    applyOptions = (options) => options
  } = _b, rest = __objRest$M(_b, [
    "params",
    "prefetch",
    "useSearchTerm",
    "disableClearOnSelect",
    "value",
    "blurOnSelect",
    "open",
    "onOpen",
    "onClose",
    "onDataLoad",
    "onSetSearchTerm",
    "renderOption",
    "isOptionEqualToValue",
    "sortOptions",
    "applyOptions"
  ]);
  var _a2;
  const ref = useRef(null);
  const [open, setOpen] = useState(lookupOpen);
  const queryOptions = useMemo(
    () => ({
      enabled: open || prefetch,
      keepPreviousData: useSearchTerm && open
    }),
    [open, prefetch]
  );
  const onSuccess = useCallback(
    (data2) => {
      if (onDataLoad) {
        onDataLoad(data2, ref);
      }
    },
    [onDataLoad, ref]
  );
  const [inputValue, setInputValue] = useState(EMPTY_STRING$e);
  const [searchTerm, setSearchTerm] = useState(void 0);
  const [{ data, isFetching, refetch }] = useLookupQuery(
    Object.assign({ searchTerm }, params),
    queryOptions,
    rest.name
  );
  const applySearchTerm = useMemo(() => debounce$1((value2) => setSearchTerm(value2), 300), []);
  useEffect(() => {
    if ((data == null ? void 0 : data.data) && !isFetching) {
      onSuccess(data.data.results);
    }
  }, [data == null ? void 0 : data.data, isFetching]);
  const options = applyOptions((_a2 = data == null ? void 0 : data.data.results) != null ? _a2 : []).sort(sortOptions);
  return /* @__PURE__ */ jsx(
    AutocompleteDropdown,
    __spreadValues$1o({
      options,
      value,
      open,
      onOpen: (event) => {
        setOpen(true);
        onOpen && onOpen(event);
      },
      onClose: (event, reason) => {
        setOpen(false);
        onClose && onClose(event, reason);
      },
      onFocus: () => prefetch && refetch(),
      loading: isFetching,
      blurOnSelect,
      isOptionEqualToValue,
      renderOption,
      inputValue,
      onInputChange: (_, inputValue2, reason) => {
        if (disableClearOnSelect && open && reason === "reset")
          return;
        const value2 = inputValue2.trim();
        const term = reason === "clear" || value2 === EMPTY_STRING$e ? void 0 : value2;
        setInputValue(inputValue2);
        if (useSearchTerm) {
          applySearchTerm(onSetSearchTerm(term));
        }
      },
      InputProps: {
        inputRef: ref,
        onClick: (event) => event.stopPropagation()
      }
    }, rest)
  );
}

var __defProp$1n = Object.defineProperty;
var __getOwnPropSymbols$1o = Object.getOwnPropertySymbols;
var __hasOwnProp$1o = Object.prototype.hasOwnProperty;
var __propIsEnum$1o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1n = (obj, key, value) => key in obj ? __defProp$1n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1o.call(b, prop))
      __defNormalProp$1n(a, prop, b[prop]);
  if (__getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(b)) {
      if (__propIsEnum$1o.call(b, prop))
        __defNormalProp$1n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$d = "";
const parseInteger = (value, pattern) => (value.match(pattern) || []).join(EMPTY_STRING$d);
function NumberInput(_a) {
  var _b = _a, {
    accept = /\d+/g,
    format = (input) => {
      const parsed = parseInteger(input, accept);
      const number = parseInt(parsed, 10);
      return Number.isNaN(number) ? EMPTY_STRING$d : number.toLocaleString(window.navigator.language);
    }
  } = _b, props = __objRest$L(_b, [
    "accept",
    "format"
  ]);
  return /* @__PURE__ */ jsx(Input$2, __spreadValues$1n({ type: "tel", accept, format }, props));
}

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata$1 = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:22|44|7[27]|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-689]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:5056(?:[0-35-9]\\d|4[468])|7302[0-3]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[237-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:20|33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
  switch (operation) {
    case 'Backspace':
      // If there exists the previous character,
      // then erase it and reposition the caret.
      if (caret > 0) {
        // Remove the previous character
        value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

        caret--;
      }

      break;

    case 'Delete':
      // Remove current digit (if any)
      value = value.slice(0, caret) + value.slice(caret + 1);
      break;
  }

  return {
    value: value,
    caret: caret
  };
}

// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value, context)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// `context` argument is just a utility empty object that is shared within the bounds
// of parsing a single input string. The `_parse()` function could use that object
// to store any kind of "flags" in it in order to alter its behavior based when
// parsing next characters within the same string. Or it could completely ignore it.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function parse$1(text, caret_position, parse_character) {
  var context = {};
  var value = '';
  var focused_input_character_index = 0;
  var index = 0;

  while (index < text.length) {
    var character = parse_character(text[index], value, context);

    if (character !== undefined) {
      value += character;

      if (caret_position !== undefined) {
        if (caret_position === index) {
          focused_input_character_index = value.length - 1;
        } else if (caret_position > index) {
          focused_input_character_index = value.length;
        }
      }
    }

    index++;
  } // If caret position wasn't specified


  if (caret_position === undefined) {
    // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
  }

  var result = {
    value: value,
    caret: focused_input_character_index
  };
  return result;
}

function _createForOfIteratorHelperLoose$c(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$f(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }

function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
  var count = 0; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes)
  // but template placeholder characters don't fall into that range
  // so skipping such miscellaneous "exotic" characters
  // won't matter here for just counting placeholder character occurrences.

  for (var _iterator = _createForOfIteratorHelperLoose$c(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;

    if (character === symbol) {
      count++;
    }
  }

  return count;
}

function closeBraces(retained_template, template) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var cut_before = retained_template.length;
  var opening_braces = count_occurences('(', retained_template);
  var closing_braces = count_occurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    retained_template += template[cut_before].replace(placeholder, empty_placeholder);

    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return retained_template;
}

function _createForOfIteratorHelperLoose$b(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$e(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }

function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `should_close_braces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//

function template_formatter (template) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;

  if (!template) {
    return function (value) {
      return {
        text: value
      };
    };
  }

  var characters_in_template = count_occurences(placeholder, template);
  return function (value) {
    if (!value) {
      return {
        text: '',
        template: template
      };
    }

    var value_character_index = 0;
    var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // and appending UTF-8 characters to a string in parts still works.

    for (var _iterator = _createForOfIteratorHelperLoose$b(template.split('')), _step; !(_step = _iterator()).done;) {
      var character = _step.value;

      if (character !== placeholder) {
        filled_in_template += character;
        continue;
      }

      filled_in_template += value[value_character_index];
      value_character_index++; // If the last available value character has been filled in,
      // then return the filled in template
      // (either trim the right part or retain it,
      //  if no more character placeholders in there)

      if (value_character_index === value.length) {
        // If there are more character placeholders
        // in the right part of the template
        // then simply trim it.
        if (value.length < characters_in_template) {
          break;
        }
      }
    }

    if (should_close_braces) {
      filled_in_template = closeBraces(filled_in_template, template);
    }

    return {
      text: filled_in_template,
      template: template
    };
  };
}

//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//

function format$3(value, caret, formatter) {
  if (typeof formatter === 'string') {
    formatter = template_formatter(formatter);
  }

  var _ref = formatter(value) || {},
      text = _ref.text,
      template = _ref.template;

  if (text === undefined) {
    text = value;
  }

  if (template) {
    if (caret === undefined) {
      caret = text.length;
    } else {
      var index = 0;
      var found = false;
      var possibly_last_input_character_index = -1;

      while (index < text.length && index < template.length) {
        // Character placeholder found
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = true;
            caret = index;
            break;
          }

          possibly_last_input_character_index = index;
          caret--;
        }

        index++;
      } // If the caret was positioned after last input character,
      // then the text caret index is just after the last input character.


      if (!found) {
        caret = possibly_last_input_character_index + 1;
      }
    }
  }

  return {
    text: text,
    caret: caret
  };
}

function isReadOnly(element) {
  return element.hasAttribute('readonly');
} // Gets <input/> selection bounds

function getSelection(element) {
  // If no selection, return nothing
  if (element.selectionStart === element.selectionEnd) {
    return;
  }

  return {
    start: element.selectionStart,
    end: element.selectionEnd
  };
} // Key codes

var Keys = {
  Backspace: 8,
  Delete: 46
}; // Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.

function getOperation(event) {
  switch (event.keyCode) {
    case Keys.Backspace:
      return 'Backspace';

    case Keys.Delete:
      return 'Delete';
  }
} // Gets <input/> caret position

function getCaretPosition(element) {
  return element.selectionStart;
} // Sets <input/> caret position

function setCaretPosition(element, caret_position) {
  // Sanity check
  if (caret_position === undefined) {
    return;
  } // Set caret position.
  // There has been an issue with caret positioning on Android devices.
  // https://github.com/catamphetamine/input-format/issues/2
  // I was revisiting this issue and looked for similar issues in other libraries.
  // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
  // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
  // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
  // https://github.com/text-mask/text-mask/issues/300
  // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
  // https://github.com/text-mask/text-mask/pull/400/files
  // I've implemented the same workaround here.


  if (isAndroid()) {
    setTimeout(function () {
      return element.setSelectionRange(caret_position, caret_position);
    }, 0);
  } else {
    element.setSelectionRange(caret_position, caret_position);
  }
}

function isAndroid() {
  // `navigator` is not defined when running mocha tests.
  if (typeof navigator !== 'undefined') {
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
  }
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;

function onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
// in a way that they're not handled by the regular `onChange()` handler
// and instead are intercepted and re-applied manually.
// The reason is that normally hitting "Backspace" or "Delete"
// results in erasing a character, but that character might be any character,
// while it would be a better "user experience" if it erased not just any character
// but the closest "meaningful" character.
// For example, if a template is `(xxx) xxx-xxxx`,
// and the `<input/>` value is `(111) 222-3333`,
// then, if a user begins erasing the `3333` part via "Backspace"
// and reaches the "-" character, then it would just erase the "-" character.
// Nothing wrong with that, but it would be a better "user experience"
// if hitting "Backspace" at that position would erase the closest "meaningful"
// character, which would be the rightmost `2`.
// So, what this `onKeyDown()` handler does is it intercepts
// "Backspace" and "Delete" keys and re-applies those operations manually
// following the logic described above.

function onKeyDown(event, input, _parse, _format, on_change) {
  if (isReadOnly(input)) {
    return;
  }

  var operation = getOperation(event);

  switch (operation) {
    case 'Delete':
    case 'Backspace':
      // Intercept this operation and perform it manually.
      event.preventDefault();
      var selection = getSelection(input); // If a selection is made, just erase the selected text.

      if (selection) {
        eraseSelection(input, selection);
        return formatInputText(input, _parse, _format, undefined, on_change);
      } // Else, perform the (character erasing) operation manually.


      return formatInputText(input, _parse, _format, operation, on_change);

  }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */

function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end);
  input.value = text;
  setCaretPosition(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */


function formatInputText(input, _parse, _format, operation, on_change) {
  // Parse `<input/>` textual value.
  // Get the `value` and `caret` position.
  var _parse2 = parse$1(input.value, getCaretPosition(input), _parse),
      value = _parse2.value,
      caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
  // then apply that operation and get the new `value` and `caret` position.


  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value;
    caret = newValueAndCaret.caret;
  } // Format the `value`.
  // (and reposition the caret accordingly)


  var formatted = format$3(value, caret, _format);
  var text = formatted.text;
  caret = formatted.caret; // Set `<input/>` textual value manually
  // to prevent React from resetting the caret position
  // later inside a subsequent `render()`.
  // Doesn't work for custom `inputComponent`s for some reason.

  input.value = text; // Position the caret properly.

  setCaretPosition(input, caret); // If the `<input/>` textual value did change,
  // then the parsed `value` may have changed too.

  on_change(value);
}

var _excluded$19 = ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"];

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

function Input(_ref, ref) {
  var value = _ref.value,
      parse = _ref.parse,
      format = _ref.format,
      InputComponent = _ref.inputComponent,
      onChange$1 = _ref.onChange,
      onKeyDown$1 = _ref.onKeyDown,
      rest = _objectWithoutProperties$8(_ref, _excluded$19);

  var internalRef = useRef();
  var setRef = useCallback(function (instance) {
    internalRef.current = instance;

    if (ref) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, [ref]);

  var _onChange = useCallback(function (event) {
    return onChange(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1]);

  var _onKeyDown = useCallback(function (event) {
    if (onKeyDown$1) {
      onKeyDown$1(event);
    }

    return onKeyDown(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1, onKeyDown$1]);

  return /*#__PURE__*/React__default$1.createElement(InputComponent, _extends$a({}, rest, {
    ref: setRef,
    value: format(isEmptyValue(value) ? '' : value).text,
    onKeyDown: _onKeyDown,
    onChange: _onChange
  }));
}

Input = /*#__PURE__*/React__default$1.forwardRef(Input);
Input.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: PropTypes.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: PropTypes.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: PropTypes.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: PropTypes.string.isRequired,
  // Is parsed from <input/> text.
  value: PropTypes.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: PropTypes.func.isRequired,
  // Passthrough
  onKeyDown: PropTypes.func,
  onCut: PropTypes.func,
  onPaste: PropTypes.func
};
Input.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: 'input',
  // `<input/>` `type` attribute.
  type: 'text'
};
var Input$1 = Input;

function isEmptyValue(value) {
  return value === undefined || value === null;
}

function _typeof$3(obj) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$3(obj); }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf$1(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf$1(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct$1()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf$1(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits$1(ParseError, _Error);

  var _super = _createSuper$1(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck$9(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized$1(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass$9(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

var objectConstructor = {}.constructor;
function isObject$1(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck$8(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$8(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$8(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$8(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck$8(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$8(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck$8(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$8(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!isObject$1(metadata) || !isObject$1(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$1(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return _typeof$2(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

function _createForOfIteratorHelperLoose$a(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$d(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }

function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$a(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

function _createForOfIteratorHelperLoose$9(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }

function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$9(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `emitEvent` argument.
      //
      // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof emitEvent === 'function') {
        emitEvent('end');
      }

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

function _createForOfIteratorHelperLoose$8(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }

function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = _createForOfIteratorHelperLoose$8(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

function _createForOfIteratorHelperLoose$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }

function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = _createForOfIteratorHelperLoose$7(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
      _ref.carrierCode;
      _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

function _createForOfIteratorHelperLoose$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }

function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber$1(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread$6(_objectSpread$6({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber$1(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber$1(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$6(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$7(this, PhoneNumber);

    if (!countryOrCountryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  _createClass$7(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber$1(this, _format, options ? _objectSpread$5(_objectSpread$5({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }

function _createForOfIteratorHelperLoose$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);
  var matchingCountries = [];

  for (var _iterator = _createForOfIteratorHelperLoose$5(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If the `defaultCountry` is among the `matchingCountries` then return it.
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }

        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  } // Return the first ("main") one of the `matchingCountries`.


  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}

function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}

// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.
var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread$4(_objectSpread$4({}, options), {}, {
    v2: true
  }), metadata);
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$2(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$3({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject$1(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber$2(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$2(_objectSpread$2({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function parsePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumber$2(text, options, metadata);
}

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$6(this, AsYouTypeState);

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$6(AsYouTypeState, [{
    key: "reset",
    value: function reset(_ref2) {
      var country = _ref2.country,
          callingCode = _ref2.callingCode;
      this.international = false;
      this.missingPlus = false;
      this.IDDPrefix = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = _createForOfIteratorHelperLoose$4(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  state.nationalSignificantNumber;
      state.international;
      state.nationalPrefix;
      state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    _classCallCheck$5(this, PatternParser);
  }

  _createClass$5(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);

      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }

      var _this$context$ = this.context[0],
          branches = _this$context$.branches,
          instructions = _this$context$.instructions;

      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }
      /* istanbul ignore if */


      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }

      if (instructions.length === 1) {
        return instructions[0];
      }

      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }

      var match = pattern.match(OPERATOR);

      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }

        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }

      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);

      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;

        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }

          if (before) {
            this.parsePattern(before);
          }

          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }

          var _this$getContext = this.getContext(),
              branches = _this$getContext.branches;

          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;

        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }

          if (before) {
            this.parsePattern(before);
          } // The top-level is an implicit "or" group, if required.


          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.

            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }

          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;

        case '[':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            oneOfSet: true
          });
          break;

        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }

          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */

        default:
          throw new Error("Unknown operator: ".concat(operator));
      }

      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);

  return PatternParser;
}();

function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;

  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }

      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;

      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }

    i++;
  }

  return values;
}

var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp( // any of:
'(' + // or operator
'\\|' + // or
'|' + // or group start
'\\(\\?\\:' + // or
'|' + // or group end
'\\)' + // or
'|' + // one-of set start
'\\[' + // or
'|' + // one-of set end
'\\]' + ')');

function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }

  return array;
}

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    _classCallCheck$4(this, PatternMatcher);

    this.matchTree = new PatternParser().parse(pattern);
  }

  _createClass$4(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          allowOverflow = _ref.allowOverflow;

      if (!string) {
        throw new Error('String is required');
      }

      var result = _match(string.split(''), this.matchTree, true);

      if (result && result.match) {
        delete result.matchedChars;
      }

      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }

      return result;
    }
  }]);

  return PatternMatcher;
}();

function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');

    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      } // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore next */


      return {
        partialMatch: true // matchedChars: characters

      };
    }

    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.

        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }

      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }

    return;
  }

  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;

    while (i < tree.length) {
      var subtree = tree[i];

      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);

        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true // matchedChars: characters

            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true // matchedChars: characters

          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }

      i++;
    } // If `last` then overflow has already been checked
    // by the last element of the `tree` array.

    /* istanbul ignore if */


    if (last) {
      return {
        overflow: true
      };
    }

    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }

  switch (tree.op) {
    case '|':
      var partialMatch;

      for (var _iterator = _createForOfIteratorHelperLoose$3(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;

        var _result = _match(characters, branch, last);

        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }

      if (partialMatch) {
        return {
          partialMatch: true // matchedChars: ...

        };
      } // Not even a partial match.


      return;

    case '[]':
      for (var _iterator2 = _createForOfIteratorHelperLoose$3(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;

        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }

          if (last) {
            return {
              overflow: true
            };
          }

          return {
            match: true,
            matchedChars: [_char]
          };
        }
      } // No character matches.


      return;

    /* istanbul ignore next */

    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    _ref.state;
        var metadata = _ref.metadata;

    _classCallCheck$3(this, AsYouTypeFormatter);

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$3(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */

  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = _createForOfIteratorHelperLoose$2(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var format = _step.value;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;

      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
          nationalPrefix = _ref2.nationalPrefix,
          international = _ref2.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)
      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //

      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error)
        /* istanbul ignore next */
        {
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //


      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;

      var _loop = function _loop() {
        var format = _step2.value;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this3.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this3.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this3.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //

      /* istanbul ignore next */
      for (var _iterator2 = _createForOfIteratorHelperLoose$2(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
        if (_ret === "continue") continue;
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
          missingPlus = _ref3.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          international = _ref4.international,
          nationalPrefix = _ref4.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
          nationalPrefix = _ref5.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$2(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$2(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$1(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits;
          state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode;
            _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
          callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$1(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AsYouType = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$1(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
    // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
    // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.


    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass$1(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (isObject$1(optionsOrDefaultCountry)) {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      });
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

      if (digits) {
        return this._getCountry();
      }
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;

      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
          nationalSignificantNumber = _this$state.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */

  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
          digits = _this$state2.digits,
          callingCode = _this$state2.callingCode,
          country = _this$state2.country,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

      if (!digits) {
        return;
      }

      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode,
          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it return `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

      var country = this._getCountry();

      if (!nationalSignificantNumber) {
        return;
      } // `state.country` and `state.callingCode` aren't required to be in sync.
      // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
      // So `country` and `callingCode` are totally independent.


      if (!country && !callingCode) {
        return;
      } // By default, if `defaultCountry` parameter was passed when
      // creating `AsYouType` instance, `state.country` is gonna be
      // that `defaultCountry`, which doesn't entirely conform with
      // `parsePhoneNumber()`'s behavior where it attempts to determine
      // the country more precisely in cases when multiple countries
      // could correspond to the same `countryCallingCode`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
      //
      // Because `AsYouType.getNumber()` method is supposed to be a 1:1
      // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
      // then it should also behave accordingly in cases of `country` ambiguity.
      // That's how users of this library would expect it to behave anyway.
      //


      if (country) {
        if (country === this.defaultCountry) {
          // `state.country` and `state.callingCode` aren't required to be in sync.
          // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
          // So `state.country` and `state.callingCode` are totally independent.
          var metadata = new Metadata(this.metadata.metadata);
          metadata.selectNumberingPlan(country);

          var _callingCode = metadata.numberingPlan.callingCode();

          var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);

          if (ambiguousCountries.length > 1) {
            var exactCountry = getCountryByNationalNumber(nationalSignificantNumber, {
              countries: ambiguousCountries,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });

            if (exactCountry) {
              country = exactCountry;
            }
          }
        }
      }

      var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string|object} [optionsOrDefaultCountry] - A two-letter ("ISO 3166-1 alpha-2") country code, or an object of shape `{ defaultCountry?: string, defaultCallingCode?: string }`.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, optionsOrDefaultCountry, metadata) {
  if (!metadata) {
    metadata = optionsOrDefaultCountry;
    optionsOrDefaultCountry = undefined;
  }

  return new AsYouType(optionsOrDefaultCountry, metadata).input(value);
}

function getInputValuePrefix(_ref) {
  var country = _ref.country,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      metadata = _ref.metadata;
  return country && international && !withCountryCallingCode ? "+".concat(getCountryCallingCode(country, metadata)) : '';
}
function removeInputValuePrefix(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}

/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object?} context - An optional object that could be used by this function to set arbitrary "flags". The object should be shared within the parsing of the whole string.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter_(character, prevParsedCharacters, context) {
  // `context` argument was added as a third argument of `parse()` function
  // in `input-format` package on Dec 26th, 2023. So it could potentially be
  // `undefined` here if a 3rd-party app somehow ends up with this newer version
  // of `react-phone-number-input` and an older version of `input-format`.
  // Dunno how, but just in case, it could be `undefined` here and it wouldn't break.
  // Maybe it's not required to handle `undefined` case here.
  //
  // The addition of the `context` argument was to fix the slightly-weird behavior
  // of parsing an input string when the user inputs something like `"2+7"
  // https://github.com/catamphetamine/react-phone-number-input/issues/437
  //
  // If the parser encounters an unexpected `+` in a string being parsed
  // then it simply discards that out-of-place `+` and any following characters.
  //
  if (context && context.ignoreRest) {
    return;
  }

  var emitEvent = function emitEvent(eventName) {
    if (context) {
      switch (eventName) {
        case 'end':
          context.ignoreRest = true;
          break;
      }
    }
  };

  return parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent);
}

var _excluded$18 = ["country", "international", "withCountryCallingCode", "metadata"];

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createInput$1(defaultMetadata) {
  /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */
  function InputSmart(_ref, ref) {
    var country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata,
        rest = _objectWithoutProperties$7(_ref, _excluded$18);

    var format = useCallback(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType(country, metadata);
      var prefix = getInputValuePrefix({
        country: country,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        metadata: metadata
      }); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removeInputValuePrefix(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removeInputValuePrefix(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);
    return /*#__PURE__*/React__default$1.createElement(Input$1, _extends$9({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter_,
      format: format
    }));
  }

  InputSmart = /*#__PURE__*/React__default$1.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object
  };
  return InputSmart;
}
var InputSmart = createInput$1();

var _excluded$17 = ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"];

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createInput(defaultMetadata) {
  /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata,
        _ref$inputComponent = _ref.inputComponent,
        Input = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent,
        rest = _objectWithoutProperties$6(_ref, _excluded$17);

    var prefix = getInputValuePrefix({
      country: country,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      metadata: metadata
    });

    var _onChange = useCallback(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.

      if (newValue === value) {
        var newValueFormatted = format$2(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    return /*#__PURE__*/React__default$1.createElement(Input, _extends$8({}, rest, {
      ref: ref,
      value: format$2(prefix, value, country, metadata),
      onChange: _onChange
    }));
  }

  InputBasic = /*#__PURE__*/React__default$1.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object,

    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes.elementType
  };
  return InputBasic;
}
var InputBasic = createInput();

function format$2(prefix, value, country, metadata) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
}

/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */
function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */

function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}

var _excluded$16 = ["value", "onChange", "options", "disabled", "readOnly"],
    _excluded2$8 = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function CountrySelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      rest = _objectWithoutProperties$5(_ref, _excluded$16);

  var onChange_ = useCallback(function (event) {
    var value = event.target.value;
    onChange(value === 'ZZ' ? undefined : value);
  }, [onChange]);
  useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]); // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).

  return /*#__PURE__*/React__default$1.createElement("select", _extends$7({}, rest, {
    disabled: disabled || readOnly,
    readOnly: readOnly,
    value: value || 'ZZ',
    onChange: onChange_
  }), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        divider = _ref2.divider;
    return /*#__PURE__*/React__default$1.createElement("option", {
      key: divider ? '|' : value || 'ZZ',
      value: divider ? '|' : value || 'ZZ',
      disabled: divider ? true : false,
      style: divider ? DIVIDER_STYLE : undefined
    }, label);
  }));
}
CountrySelect.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: PropTypes.string,

  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: PropTypes.func.isRequired,
  // `<select/>` options.
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    divider: PropTypes.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
};
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};
function CountrySelectWithIcon(_ref3) {
  var value = _ref3.value,
      options = _ref3.options,
      className = _ref3.className,
      Icon = _ref3.iconComponent;
      _ref3.getIconAspectRatio;
      var _ref3$arrowComponent = _ref3.arrowComponent,
      Arrow = _ref3$arrowComponent === void 0 ? DefaultArrowComponent : _ref3$arrowComponent,
      unicodeFlags = _ref3.unicodeFlags,
      rest = _objectWithoutProperties$5(_ref3, _excluded2$8);

  var selectedOption = useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return /*#__PURE__*/React__default$1.createElement("div", {
    className: "PhoneInputCountry"
  }, /*#__PURE__*/React__default$1.createElement(CountrySelect, _extends$7({}, rest, {
    value: value,
    options: options,
    className: classNames('PhoneInputCountrySelect', className)
  })), unicodeFlags && value && /*#__PURE__*/React__default$1.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, getCountryFlag(value)), !(unicodeFlags && value) && /*#__PURE__*/React__default$1.createElement(Icon, {
    "aria-hidden": true,
    country: value,
    label: selectedOption && selectedOption.label,
    aspectRatio: unicodeFlags ? 1 : undefined
  }), /*#__PURE__*/React__default$1.createElement(Arrow, null));
}
CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: PropTypes.elementType,
  // Select arrow component.
  arrowComponent: PropTypes.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: PropTypes.bool
};

function DefaultArrowComponent() {
  return /*#__PURE__*/React__default$1.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}

function getSelectedOption(options, value) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(options), _step; !(_step = _iterator()).done;) {
    var option = _step.value;

    if (!option.divider && option.value === value) {
      return option;
    }
  }
}

var _excluded$15 = ["country", "countryName", "flags", "flagUrl"];

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111

function FlagComponent(_ref) {
  var country = _ref.country,
      countryName = _ref.countryName,
      flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      rest = _objectWithoutProperties$4(_ref, _excluded$15);

  if (flags && flags[country]) {
    return flags[country]({
      title: countryName
    });
  }

  return /*#__PURE__*/React__default$1.createElement("img", _extends$6({}, rest, {
    alt: countryName,
    role: countryName ? undefined : "presentation",
    src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
  }));
}
FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: PropTypes.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: PropTypes.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: PropTypes.objectOf(PropTypes.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: PropTypes.string.isRequired
};

var _excluded$14 = ["aspectRatio"],
    _excluded2$7 = ["title"],
    _excluded3$2 = ["title"];

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function InternationalIcon(_ref) {
  var aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties$3(_ref, _excluded$14);

  if (aspectRatio === 1) {
    return /*#__PURE__*/React__default$1.createElement(InternationalIcon1x1, rest);
  } else {
    return /*#__PURE__*/React__default$1.createElement(InternationalIcon3x2, rest);
  }
}
InternationalIcon.propTypes = {
  title: PropTypes.string.isRequired,
  aspectRatio: PropTypes.number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon3x2(_ref2) {
  var title = _ref2.title,
      rest = _objectWithoutProperties$3(_ref2, _excluded2$7);

  return /*#__PURE__*/React__default$1.createElement("svg", _extends$5({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /*#__PURE__*/React__default$1.createElement("title", null, title), /*#__PURE__*/React__default$1.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React__default$1.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /*#__PURE__*/React__default$1.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /*#__PURE__*/React__default$1.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /*#__PURE__*/React__default$1.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}

InternationalIcon3x2.propTypes = {
  title: PropTypes.string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon1x1(_ref3) {
  var title = _ref3.title,
      rest = _objectWithoutProperties$3(_ref3, _excluded3$2);

  return /*#__PURE__*/React__default$1.createElement("svg", _extends$5({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /*#__PURE__*/React__default$1.createElement("title", null, title), /*#__PURE__*/React__default$1.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React__default$1.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /*#__PURE__*/React__default$1.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /*#__PURE__*/React__default$1.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /*#__PURE__*/React__default$1.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /*#__PURE__*/React__default$1.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}

InternationalIcon1x1.propTypes = {
  title: PropTypes.string.isRequired
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Sorts country `<select/>` options.
 * Can move some country `<select/>` options
 * to the top of the list, for example.
 * @param  {object[]} countryOptions — Country `<select/>` options.
 * @param  {string[]} [countryOptionsOrder] — Country `<select/>` options order. Example: `["US", "CA", "AU", "|", "..."]`.
 * @return {object[]}
 */

function sortCountryOptions(options, order) {
  if (!order) {
    return options;
  }

  var optionsOnTop = [];
  var optionsOnBottom = [];
  var appendTo = optionsOnTop;

  for (var _iterator = _createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (element === '|') {
      appendTo.push({
        divider: true
      });
    } else if (element === '...' || element === '…') {
      appendTo = optionsOnBottom;
    } else {
      (function () {
        var countryCode = void 0;

        if (element === '🌐') {
          countryCode = undefined;
        } else {
          countryCode = element;
        } // Find the position of the option.


        var index = options.indexOf(options.filter(function (option) {
          return option.value === countryCode;
        })[0]); // Get the option.

        var option = options[index]; // Remove the option from its default position.

        options.splice(index, 1); // Add the option on top.

        appendTo.push(option);
      })();
    }
  }

  return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions) {
    countryOptions = countryOptions.filter(function (option) {
      switch (option) {
        case '🌐':
        case '|':
        case '...':
        case '…':
          return true;

        default:
          return isCountrySupportedWithError(option, metadata);
      }
    });

    if (countryOptions.length > 0) {
      return countryOptions;
    }
  }
}
function isCountrySupportedWithError(country, metadata) {
  if (isSupportedCountry(country, metadata)) {
    return true;
  } else {
    console.error("Country not found: ".concat(country));
    return false;
  }
}
function getSupportedCountries(countries, metadata) {
  if (countries) {
    countries = countries.filter(function (country) {
      return isCountrySupportedWithError(country, metadata);
    });

    if (countries.length === 0) {
      countries = undefined;
    }
  }

  return countries;
}

var _excluded$13 = ["country", "label", "aspectRatio"];

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createCountryIconComponent(_ref) {
  var flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      FlagComponent = _ref.flagComponent,
      InternationalIcon$1 = _ref.internationalIcon;

  function CountryIcon(_ref2) {
    var country = _ref2.country,
        label = _ref2.label,
        aspectRatio = _ref2.aspectRatio,
        rest = _objectWithoutProperties$2(_ref2, _excluded$13);

    // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.
    var _aspectRatio = InternationalIcon$1 === InternationalIcon ? aspectRatio : undefined;

    return /*#__PURE__*/React__default$1.createElement("div", _extends$4({}, rest, {
      className: classNames('PhoneInputCountryIcon', {
        'PhoneInputCountryIcon--square': _aspectRatio === 1,
        'PhoneInputCountryIcon--border': country
      })
    }), country ? /*#__PURE__*/React__default$1.createElement(FlagComponent, {
      country: country,
      countryName: label,
      flags: flags,
      flagUrl: flagUrl,
      className: "PhoneInputCountryIconImg"
    }) : /*#__PURE__*/React__default$1.createElement(InternationalIcon$1, {
      title: label,
      aspectRatio: _aspectRatio,
      className: "PhoneInputCountryIconImg"
    }));
  }

  CountryIcon.propTypes = {
    country: PropTypes.string,
    label: PropTypes.string.isRequired,
    aspectRatio: PropTypes.number
  };
  return CountryIcon;
}
createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon
});

var metadata = PropTypes.shape({
  country_calling_codes: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
});
var labels = PropTypes.objectOf(PropTypes.string);

function getInternationalPhoneNumberPrefix(country, metadata) {
  // Standard international phone number prefix: "+" and "country calling code".
  var prefix = '+' + getCountryCallingCode(country, metadata); // "Leading digits" can't be used to rule out any countries.
  // So the "pre-fill with leading digits on country selection" feature had to be reverted.
  // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10#note_1231042367
  // // Get "leading digits" for a phone number of the country.
  // // If there're "leading digits" then they can be part of the prefix too.
  // // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10
  // metadata = new Metadata(metadata)
  // metadata.selectNumberingPlan(country)
  // // "Leading digits" patterns are only defined for about 20% of all countries.
  // // By definition, matching "leading digits" is a sufficient but not a necessary
  // // condition for a phone number to belong to a country.
  // // The point of "leading digits" check is that it's the fastest one to get a match.
  // // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
  // const leadingDigits = metadata.numberingPlan.leadingDigits()
  // if (leadingDigits && ONLY_DIGITS_REGEXP.test(leadingDigits)) {
  // 	prefix += leadingDigits
  // }

  return prefix;
}

/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */

function getPreSelectedCountry(_ref) {
  var value = _ref.value,
      phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      getAnyCountry = _ref.getAnyCountry,
      countries = _ref.countries,
      required = _ref.required,
      metadata = _ref.metadata;
  var country; // If can get country from E.164 phone number
  // then it overrides the `country` passed (or not passed).

  if (phoneNumber && phoneNumber.country) {
    // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
  } else if (defaultCountry) {
    if (!value || couldNumberBelongToCountry(value, defaultCountry, metadata)) {
      country = defaultCountry;
    }
  } // Only pre-select a country if it's in the available `countries` list.


  if (countries && countries.indexOf(country) < 0) {
    country = undefined;
  } // If there will be no "International" option
  // then some `country` must be selected.
  // It will still be the wrong country though.
  // But still country `<select/>` can't be left in a broken state.


  if (!country && required && countries && countries.length > 0) {
    country = getAnyCountry(); // noCountryMatchesTheNumber = true
  }

  return country;
}
/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} addInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */

function getCountrySelectOptions(_ref2) {
  var countries = _ref2.countries,
      countryNames = _ref2.countryNames,
      addInternationalOption = _ref2.addInternationalOption,
      compareStringsLocales = _ref2.compareStringsLocales,
      _compareStrings = _ref2.compareStrings;

  // Default country name comparator uses `String.localeCompare()`.
  if (!_compareStrings) {
    _compareStrings = compareStrings;
  } // Generates a `<Select/>` option for each country.


  var countrySelectOptions = countries.map(function (country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: countryNames[country] || country
    };
  }); // Sort the list of countries alphabetically.

  countrySelectOptions.sort(function (a, b) {
    return _compareStrings(a.label, b.label, compareStringsLocales);
  }); // Add the "International" option to the country list (if suitable)

  if (addInternationalOption) {
    countrySelectOptions.unshift({
      label: countryNames.ZZ
    });
  }

  return countrySelectOptions;
}
/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {object} Object having shape `{ country: string?, countryCallingCode: string, number: string }`. `PhoneNumber`: https://gitlab.com/catamphetamine/libphonenumber-js#phonenumber.
 * @example
 * parsePhoneNumber('+78005553535')
 */

function parsePhoneNumber(value, metadata) {
  return parsePhoneNumber$1(value || '', metadata);
}
/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */

function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, '');
}
/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} phoneDigits - Phone number digits (and `+`) parsed from phone number `<input/>` (it's not the same as the `value` property).
 * @param {string?} prevCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} useNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */

function getPhoneDigitsForNewCountry(phoneDigits, _ref3) {
  var prevCountry = _ref3.prevCountry,
      newCountry = _ref3.newCountry,
      metadata = _ref3.metadata,
      useNationalFormat = _ref3.useNationalFormat;

  if (prevCountry === newCountry) {
    return phoneDigits;
  } // If `parsed_input` is empty
  // then no need to migrate anything.


  if (!phoneDigits) {
    if (useNationalFormat) {
      return '';
    } else {
      if (newCountry) {
        // If `phoneDigits` is empty then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.
        return getInternationalPhoneNumberPrefix(newCountry, metadata);
      }

      return '';
    }
  } // If switching to some country.
  // (from "International" or another country)
  // If switching from "International" then `phoneDigits` starts with a `+`.
  // Otherwise it may or may not start with a `+`.


  if (newCountry) {
    // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    if (phoneDigits[0] === '+') {
      // If the international phone number is for the new country
      // then convert it to local if required.
      if (useNationalFormat) {
        // // If a phone number is being input in international form
        // // and the country can already be derived from it,
        // // and if it is the new country, then format as a national number.
        // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
        // if (derived_country === newCountry) {
        // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
        // }
        // Actually, the two countries don't necessarily need to match:
        // the condition could be looser here, because several countries
        // might share the same international phone number format
        // (for example, "NANPA" countries like US, Canada, etc).
        // The looser condition would be just "same nternational phone number format"
        // which would mean "same country calling code" in the context of `libphonenumber-js`.
        if (phoneDigits.indexOf('+' + getCountryCallingCode(newCountry, metadata)) === 0) {
          return stripCountryCallingCode(phoneDigits, newCountry, metadata);
        } // Simply discard the previously entered international phone number,
        // because otherwise any "smart" transformation like getting the
        // "national (significant) number" part and then prepending the
        // newly selected country's "country calling code" to it
        // would just be confusing for a user without being actually useful.


        return ''; // // Simply strip the leading `+` character
        // // therefore simply converting all digits into a "local" phone number.
        // // https://github.com/catamphetamine/react-phone-number-input/issues/287
        // return phoneDigits.slice(1)
      }

      if (prevCountry) {
        var newCountryPrefix = getInternationalPhoneNumberPrefix(newCountry, metadata);

        if (phoneDigits.indexOf(newCountryPrefix) === 0) {
          return phoneDigits;
        } else {
          return newCountryPrefix;
        }
      } else {
        var defaultValue = getInternationalPhoneNumberPrefix(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
        // as for the new `country`, then leave `phoneDigits` as is.

        if (phoneDigits.indexOf(defaultValue) === 0) {
          return phoneDigits;
        } // If `phoneDigits`'s country calling code part is not the same
        // as for the new `country`, then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.


        return defaultValue;
      } // // If the international phone number already contains
      // // any country calling code then trim the country calling code part.
      // // (that could also be the newly selected country phone code prefix as well)
      // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
      // // (e.g. if a user enters an international number
      // //  not belonging to any of the reduced `countries` list).
      // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
      // // Prepend country calling code prefix
      // // for the newly selected country.
      // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`

    }
  } // If switching to "International" from a country.
  else {
    // If the phone number was entered in national format.
    if (phoneDigits[0] !== '+') {
      // Format the national phone number as an international one.
      // The phone number entered not necessarily even starts with
      // the previously selected country phone prefix.
      // Even if the phone number belongs to whole another country
      // it will still be parsed into some national phone number.
      //
      // Ignore the now-uncovered `|| ''` code branch:
      // previously `e164()` function could return an empty string
      // even when `phoneDigits` were not empty.
      // Now it always returns some `value` when there're any `phoneDigits`.
      // Still, didn't remove the `|| ''` code branch just in case
      // that logic changes somehow in some future, so there're no
      // possible bugs related to that.
      //
      // (ignore the `|| ''` code branch)

      /* istanbul ignore next */
      return e164(phoneDigits, prevCountry, metadata) || '';
    }
  }

  return phoneDigits;
}
/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */

function e164(number, country, metadata) {
  if (!number) {
    return;
  } // If the phone number is being input in international format.


  if (number[0] === '+') {
    // If it's just the `+` sign then return nothing.
    if (number === '+') {
      return;
    } // Return a E.164 phone number.
    //
    // Could return `number` "as is" here, but there's a possibility
    // that some user might incorrectly input an international number
    // with a "national prefix". Such numbers aren't considered valid,
    // but `libphonenumber-js` is "forgiving" when it comes to parsing
    // user's input, and this input component follows that behavior.
    //


    var asYouType = new AsYouType(country, metadata);
    asYouType.input(number); // This function would return `undefined` only when `number` is `"+"`,
    // but at this point it is known that `number` is not `"+"`.

    return asYouType.getNumberValue();
  } // For non-international phone numbers
  // an accompanying country code is required.
  // The situation when `country` is `undefined`
  // and a non-international phone number is passed
  // to this function shouldn't happen.


  if (!country) {
    return;
  }

  var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata); //
  // Even if no "national (significant) number" digits have been input,
  // still return a non-`undefined` value.
  // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
  //
  // For example, if the user has selected country `US` and entered `"1"`
  // then that `"1"` is just a "national prefix" and no "national (significant) number"
  // digits have been input yet. Still, return `"+1"` as `value` in such cases,
  // because otherwise the app would think that the input is empty and mark it as such
  // while in reality it isn't empty, which might be thought of as a "bug", or just
  // a "weird" behavior.
  //
  // if (partial_national_significant_number) {

  return "+".concat(getCountryCallingCode(country, metadata)).concat(partial_national_significant_number || ''); // }
}
/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */

function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);

  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);

    if (overflowDigitsCount > 0) {
      return number.slice(0, number.length - overflowDigitsCount);
    }
  }

  return number;
}

function getMaxNumberLength(country, metadata) {
  // Get "possible lengths" for a phone number of the country.
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(country); // Return the last "possible length".

  return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)

/**
 * @param {string} partialE164Number - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryForPartialE164Number(partialE164Number, _ref4) {
  var country = _ref4.country,
      countries = _ref4.countries,
      required = _ref4.required,
      metadata = _ref4.metadata;

  if (partialE164Number === '+') {
    // Don't change the currently selected country yet.
    return country;
  }

  var derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(partialE164Number, metadata); // If a phone number is being input in international form
  // and the country can already be derived from it,
  // then select that country.

  if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
    return derived_country;
  } // If "International" country option has not been disabled
  // and the international phone number entered doesn't correspond
  // to the currently selected country then reset the currently selected country.
  else if (country && !required && !couldNumberBelongToCountry(partialE164Number, country, metadata)) {
    return undefined;
  } // Don't change the currently selected country.


  return country;
}
/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} phoneDigits — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevPhoneDigits — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {boolean} countryRequired - Is selecting some country required.
 * @param  {function} getAnyCountry - Can be used to get any country when selecting some country required.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} international - Set to `true` to force international phone number format (leading `+`). Set to `false` to force "national" phone number format. Is `undefined` by default.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ phoneDigits, country, value }`. `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`. The returned `phoneDigits` shouldn't be used anywhere except for passing it as `prevPhoneDigits` parameter to this same function on next input change event.
 */

function onPhoneDigitsChange(phoneDigits, _ref5) {
  var prevPhoneDigits = _ref5.prevPhoneDigits,
      country = _ref5.country,
      defaultCountry = _ref5.defaultCountry,
      countryRequired = _ref5.countryRequired,
      getAnyCountry = _ref5.getAnyCountry,
      countries = _ref5.countries,
      international = _ref5.international,
      limitMaxLength = _ref5.limitMaxLength,
      countryCallingCodeEditable = _ref5.countryCallingCodeEditable,
      metadata = _ref5.metadata;

  if (international && countryCallingCodeEditable === false) {
    if (country) {
      // For international phone numbers written with non-editable country calling code,
      // the `<input/>` value must always start with that non-editable country calling code.
      var prefix = getInternationalPhoneNumberPrefix(country, metadata); // If the input value doesn't start with the non-editable country calling code,
      // it should be fixed.

      if (phoneDigits.indexOf(prefix) !== 0) {
        var _value; // If a phone number input is declared as
        // `international: true` and `countryCallingCodeEditable: false`,
        // then the value of the `<input/>` is gonna be non-empty at all times,
        // even before the user has started to input any digits in the input field,
        // because the country calling code is always there by design.
        //
        // The fact that the input value is always non-empty results in a side effect:
        // whenever a user tabs into such input field, its value gets automatically selected.
        // If at that moment in time the user starts typing in the national digits of the phone number,
        // the selected `<input/>` value gets automatically replaced by those typed-in digits
        // so the value changes from `+xxx` to `y`, because inputting anything while having
        // the `<input/>` value selected results in erasing that `<input/>` value.
        //
        // This component handles such cases by restoring the `<input/>` value to what
        // it should be in such cases: `+xxxy`.
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
        //


        var hasStartedTypingInNationalNumberDigitsHavingInputValueSelected = phoneDigits && phoneDigits[0] !== '+';

        if (hasStartedTypingInNationalNumberDigitsHavingInputValueSelected) {
          // Fix the input value to what it should be: `y` → `+xxxy`.
          phoneDigits = prefix + phoneDigits;
          _value = e164(phoneDigits, country, metadata);
        } else {
          // In other cases, simply reset the `<input/>` value, because there're only two
          // possible cases:
          // * The user has selected the `<input/>` value and then hit Delete/Backspace to erase it.
          // * The user has pasted an international phone number for another country calling code,
          //   which is considered a non-valid value.
          phoneDigits = prefix;
        }

        return {
          phoneDigits: phoneDigits,
          value: _value,
          country: country
        };
      }
    }
  } // If `international` property is `false`, then it means
  // "enforce national-only format during input",
  // so, if that's the case, then remove all `+` characters,
  // but only if some country is currently selected.
  // (not if "International" country is selected).


  if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
    phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
  } // Trim the input to not exceed the maximum possible number length.


  if (phoneDigits && country && limitMaxLength) {
    phoneDigits = trimNumber(phoneDigits, country, metadata);
  } // If this `onChange()` event was triggered
  // as a result of selecting "International" country,
  // then force-prepend a `+` sign if the phone number
  // `<input/>` value isn't in international format.
  // Also, force-prepend a `+` sign if international
  // phone number input format is set.


  if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) {
    phoneDigits = '+' + phoneDigits;
  } // If the previously entered phone number
  // has been entered in international format
  // and the user decides to erase it,
  // then also reset the `country`
  // because it was most likely automatically selected
  // while the user was typing in the phone number
  // in international format.
  // This fixes the issue when a user is presented
  // with a phone number input with no country selected
  // and then types in their local phone number
  // then discovers that the input's messed up
  // (a `+` has been prepended at the start of their input
  //  and a random country has been selected),
  // decides to undo it all by erasing everything
  // and then types in their local phone number again
  // resulting in a seemingly correct phone number
  // but in reality that phone number has incorrect country.
  // https://github.com/catamphetamine/react-phone-number-input/issues/273


  if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
    if (international) {
      country = undefined;
    } else {
      country = defaultCountry;
    }
  } // Also resets such "randomly" selected country
  // as soon as the user erases the number
  // digit-by-digit up to the leading `+` sign.


  if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > '+'.length) {
    country = undefined;
  } // Generate the new `value` property.


  var value;

  if (phoneDigits) {
    if (phoneDigits[0] === '+') {
      if (phoneDigits === '+') {
        value = undefined;
      } else if (country && getInternationalPhoneNumberPrefix(country, metadata).indexOf(phoneDigits) === 0) {
        // Selected a `country` and started inputting an
        // international phone number for this country
        // but hasn't input any "national (significant) number" digits yet.
        // In that case, assume `value` be `undefined`.
        //
        // For example, if selected `country` `"US"`
        // and started inputting phone number `"+1"`
        // then `value` `undefined` will be returned from this function.
        //
        value = undefined;
      } else {
        value = e164(phoneDigits, country, metadata);
      }
    } else {
      value = e164(phoneDigits, country, metadata);
    }
  } // Derive the country from the phone number.
  // (regardless of whether there's any country currently selected,
  //  because there could be several countries corresponding to one country calling code)


  if (value) {
    country = getCountryForPartialE164Number(value, {
      country: country,
      countries: countries,
      metadata: metadata
    }); // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).

    if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
      phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.

      value = e164(phoneDigits, country, metadata);
    }
  }

  if (!country && countryRequired) {
    country = defaultCountry || getAnyCountry();
  }

  return {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: phoneDigits,
    country: country,
    value: value
  };
}

function convertInternationalPhoneDigitsToNational(input, country, metadata) {
  // Handle the case when a user might have pasted
  // a phone number in international format.
  if (input.indexOf(getInternationalPhoneNumberPrefix(country, metadata)) === 0) {
    // Create "as you type" formatter.
    var formatter = new AsYouType(country, metadata); // Input partial national phone number.

    formatter.input(input); // Return the parsed partial national phone number.

    var phoneNumber = formatter.getNumber();

    if (phoneNumber) {
      // Transform the number to a national one,
      // and remove all non-digits.
      return phoneNumber.formatNational().replace(/\D/g, '');
    } else {
      return '';
    }
  } else {
    // Just remove the `+` sign.
    return input.replace(/\D/g, '');
  }
}
/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryFromPossiblyIncompleteInternationalPhoneNumber(number, metadata) {
  var formatter = new AsYouType(null, metadata);
  formatter.input(number); // // `001` is a special "non-geograpical entity" code
  // // in Google's `libphonenumber` library.
  // if (formatter.getCountry() === '001') {
  // 	return
  // }

  return formatter.getCountry();
}
/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 * @param {string} a — First string.
 * @param {string} b — Second string.
 * @param {(string[]|string)} [locales] — The `locales` argument of `String.localeCompare`.
 */

function compareStrings(a, b, locales) {
  // Use `String.localeCompare` if it's available.
  // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
  // Which means everyone except IE <= 10 and Safari <= 10.
  // `localeCompare()` is available in latest Node.js versions.

  /* istanbul ignore else */
  if (String.prototype.localeCompare) {
    return a.localeCompare(b, locales);
  }
  /* istanbul ignore next */


  return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */

function stripCountryCallingCode(number, country, metadata) {
  // Just an optimization, so that it
  // doesn't have to iterate through all country calling codes.
  if (country) {
    var countryCallingCodePrefix = '+' + getCountryCallingCode(country, metadata); // If `country` fits the actual `number`.

    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(countryCallingCodePrefix) === 0) {
        return number.slice(countryCallingCodePrefix.length);
      }
    }
  } // If `country` doesn't fit the actual `number`.
  // Try all available country calling codes.


  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];

    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}
/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} [result]
 */

function getNationalSignificantNumberDigits(number, country, metadata) {
  // Create "as you type" formatter.
  var formatter = new AsYouType(country, metadata); // Input partial national phone number.

  formatter.input(number); // Return the parsed partial national phone number.

  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */

function couldNumberBelongToCountry(number, country, metadata) {
  var intlPhoneNumberPrefix = getInternationalPhoneNumberPrefix(country, metadata);
  var i = 0;

  while (i < number.length && i < intlPhoneNumberPrefix.length) {
    if (number[i] !== intlPhoneNumberPrefix[i]) {
      return false;
    }

    i++;
  }

  return true;
}
/**
 * Gets initial "phone digits" (including `+`, if using international format).
 * @return {string} [phoneDigits] Returns `undefined` if there should be no initial "phone digits".
 */

function getInitialPhoneDigits(_ref6) {
  var value = _ref6.value,
      phoneNumber = _ref6.phoneNumber,
      defaultCountry = _ref6.defaultCountry,
      international = _ref6.international,
      useNationalFormat = _ref6.useNationalFormat,
      metadata = _ref6.metadata;

  // If the `value` (E.164 phone number)
  // belongs to the currently selected country
  // and `useNationalFormat` is `true`
  // then convert `value` (E.164 phone number)
  // to a local phone number digits.
  // E.g. '+78005553535' -> '88005553535'.
  if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) {
    return generateNationalNumberDigits(phoneNumber);
  } // If `international` property is `true`,
  // meaning "enforce international phone number format",
  // then always show country calling code in the input field.


  if (!value && international && defaultCountry) {
    return getInternationalPhoneNumberPrefix(defaultCountry, metadata);
  }

  return value;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function getPhoneInputWithCountryStateUpdateFromNewProps(props, prevProps, state) {
  var metadata = props.metadata,
      countries = props.countries,
      newDefaultCountry = props.defaultCountry,
      newValue = props.value,
      newReset = props.reset,
      international = props.international,
      displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
      initialValueFormat = props.initialValueFormat;
  var prevDefaultCountry = prevProps.defaultCountry,
      prevValue = prevProps.value,
      prevReset = prevProps.reset;
  state.country;
      var value = state.value,
      hasUserSelectedACountry = state.hasUserSelectedACountry;

  var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
    return getInitialPhoneDigits(_objectSpread$1(_objectSpread$1({}, parameters), {}, {
      international: international,
      useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
      metadata: metadata
    }));
  }; // Some users requested a way to reset the component
  // (both number `<input/>` and country `<select/>`).
  // Whenever `reset` property changes both number `<input/>`
  // and country `<select/>` are reset.
  // It's not implemented as some instance `.reset()` method
  // because `ref` is forwarded to `<input/>`.
  // It's also not replaced with just resetting `country` on
  // external `value` reset, because a user could select a country
  // and then not input any `value`, and so the selected country
  // would be "stuck", if not using this `reset` property.
  // https://github.com/catamphetamine/react-phone-number-input/issues/300


  if (newReset !== prevReset) {
    return {
      phoneDigits: _getInitialPhoneDigits({
        value: undefined,
        defaultCountry: newDefaultCountry
      }),
      value: undefined,
      country: newDefaultCountry,
      hasUserSelectedACountry: undefined
    };
  } // `value` is the value currently shown in the component:
  // it's stored in the component's `state`, and it's not the `value` property.
  // `prevValue` is "previous `value` property".
  // `newValue` is "new `value` property".
  // If the default country changed
  // (e.g. in case of ajax GeoIP detection after page loaded)
  // then select it, but only if the user hasn't already manually
  // selected a country, and no phone number has been manually entered so far.
  // Because if the user has already started inputting a phone number
  // then they're okay with no country being selected at all ("International")
  // and they don't want to be disturbed, don't want their input to be screwed, etc.


  if (newDefaultCountry !== prevDefaultCountry) {
    var isNewDefaultCountrySupported = !newDefaultCountry || isCountrySupportedWithError(newDefaultCountry, metadata);

    var noValueHasBeenEnteredByTheUser = // By default, "no value has been entered" means `value` is `undefined`.
    !value || // When `international` is `true`, and some country has been pre-selected,
    // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
    // so in case of `international` being `true`, "the user hasn't entered anything" situation
    // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
    international && value === _getInitialPhoneDigits({
      value: undefined,
      defaultCountry: prevDefaultCountry
    }); // Only update the `defaultCountry` property if no phone number
    // has been entered by the user or pre-set by the application.


    var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;

    if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) {
      return {
        country: newDefaultCountry,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: _getInitialPhoneDigits({
          value: undefined,
          defaultCountry: newDefaultCountry
        }),
        // `value` is `undefined` and it stays so.
        value: undefined
      };
    }
  } // If a new `value` is set externally.
  // (e.g. as a result of an ajax API request
  //  to get user's phone after page loaded)
  // The first part — `newValue !== prevValue` —
  // is basically `props.value !== prevProps.value`
  // so it means "if value property was changed externally".
  // The second part — `newValue !== value` —
  // is for ignoring the `getDerivedStateFromProps()` call
  // which happens in `this.onChange()` right after `this.setState()`.
  // If this `getDerivedStateFromProps()` call isn't ignored
  // then the country flag would reset on each input.


  if (!valuesAreEqual(newValue, prevValue) && !valuesAreEqual(newValue, value)) {
    var phoneNumber;
    var parsedCountry;

    if (newValue) {
      phoneNumber = parsePhoneNumber(newValue, metadata);
      var supportedCountries = getSupportedCountries(countries, metadata);

      if (phoneNumber && phoneNumber.country) {
        // Ignore `else` because all countries are supported in metadata.

        /* istanbul ignore next */
        if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) {
          parsedCountry = phoneNumber.country;
        }
      } else {
        parsedCountry = getCountryForPartialE164Number(newValue, {
          country: undefined,
          countries: supportedCountries,
          metadata: metadata
        }); // In cases when multiple countries correspond to the same country calling code,
        // the phone number digits of `newValue` have to be matched against country-specific
        // regular expressions in order to determine the exact country.
        // Sometimes, that algorithm can't decide for sure which country does the phone number belong to,
        // for example when the digits of `newValue` don't match any of those regular expressions.
        // and the country of the phone number couldn't be determined.
        // In those cases, people prefer the component to show the flag of the `defaultCountry`
        // if the phone number could potentially belong to that `defaultCountry`.
        // At least that's how the component behaves when a user pastes an international
        // phone number into the input field: for example, when `defaultCountry` is `"US"`
        // and the user pastes value "+1 555 555 5555" into the input field, it keep showing "US" flag.
        // So when setting new `value` property externally, the component should behave the same way:
        // it should select the `defaultCountry` when the new `value` could potentially belong
        // to that country in cases when the exact country can't be determined.
        // https://github.com/catamphetamine/react-phone-number-input/issues/413#issuecomment-1536219404

        if (!parsedCountry) {
          if (newDefaultCountry) {
            if (newValue.indexOf(getInternationalPhoneNumberPrefix(newDefaultCountry, metadata)) === 0) {
              parsedCountry = newDefaultCountry;
            }
          }
        }
      }
    }

    var hasUserSelectedACountryUpdate;

    if (!newValue) {
      // Reset `hasUserSelectedACountry` flag in `state`.
      hasUserSelectedACountryUpdate = {
        hasUserSelectedACountry: undefined
      };
    }

    return _objectSpread$1(_objectSpread$1({}, hasUserSelectedACountryUpdate), {}, {
      phoneDigits: _getInitialPhoneDigits({
        phoneNumber: phoneNumber,
        value: newValue,
        defaultCountry: newDefaultCountry
      }),
      value: newValue,
      country: newValue ? parsedCountry : newDefaultCountry
    });
  } // `defaultCountry` didn't change.
  // `value` didn't change.
  // `phoneDigits` didn't change, because `value` didn't change.
  //
  // So no need to update state.

}

function valuesAreEqual(value1, value2) {
  // If `value` has been set to `null` externally then convert it to `undefined`.
  //
  // For example, `react-hook-form` sets `value` to `null` when the user clears the input.
  // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/164
  // In that case, without this conversion of `null` to `undefined`, it would reset
  // the selected country to `defaultCountry` because in that case `newValue !== value`
  // because `null !== undefined`.
  //
  // Historically, empty `value` is encoded as `undefined`.
  // Perhaps empty `value` would be better encoded as `null` instead.
  // But because that would be a potentially breaking change for some people,
  // it's left as is for the current "major" version of this library.
  //
  if (value1 === null) {
    value1 = undefined;
  }

  if (value2 === null) {
    value2 = undefined;
  }

  return value1 === value2;
}

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

var _excluded$12 = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PhoneNumberInput_ = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PhoneNumberInput_, _React$PureComponent);

  var _super = _createSuper(PhoneNumberInput_);

  function PhoneNumberInput_(props) {
    var _this;

    _classCallCheck(this, PhoneNumberInput_);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (instance) {
      _this.inputRef.current = instance;
      var ref = _this.props.inputRef;

      if (ref) {
        if (typeof ref === 'function') {
          ref(instance);
        } else {
          ref.current = instance;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isCountrySupportedWithError", function (country) {
      var metadata = _this.props.metadata;
      return isCountrySupportedWithError(country, metadata);
    });

    _defineProperty(_assertThisInitialized(_this), "onCountryChange", function (newCountry) {
      var _this$props = _this.props,
          international = _this$props.international,
          metadata = _this$props.metadata,
          onChange = _this$props.onChange,
          focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
      var _this$state = _this.state,
          prevPhoneDigits = _this$state.phoneDigits,
          prevCountry = _this$state.country; // After the new `country` has been selected,
      // if the phone number `<input/>` holds any digits
      // then migrate those digits for the new `country`.

      var newPhoneDigits = getPhoneDigitsForNewCountry(prevPhoneDigits, {
        prevCountry: prevCountry,
        newCountry: newCountry,
        metadata: metadata,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !international
      });
      var newValue = e164(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.

      if (focusInputOnCountrySelection) {
        _this.inputRef.current.focus();
      } // If the user has already manually selected a country
      // then don't override that already selected country
      // if the `defaultCountry` property changes.
      // That's what `hasUserSelectedACountry` flag is for.


      _this.setState({
        country: newCountry,
        hasUserSelectedACountry: true,
        phoneDigits: newPhoneDigits,
        value: newValue
      }, function () {
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        onChange(newValue);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_phoneDigits) {
      var _this$props2 = _this.props,
          defaultCountry = _this$props2.defaultCountry,
          onChange = _this$props2.onChange,
          addInternationalOption = _this$props2.addInternationalOption,
          international = _this$props2.international,
          limitMaxLength = _this$props2.limitMaxLength,
          countryCallingCodeEditable = _this$props2.countryCallingCodeEditable,
          metadata = _this$props2.metadata;
      var _this$state2 = _this.state,
          countries = _this$state2.countries,
          prevPhoneDigits = _this$state2.phoneDigits,
          currentlySelectedCountry = _this$state2.country;

      var _onPhoneDigitsChange = onPhoneDigitsChange(_phoneDigits, {
        prevPhoneDigits: prevPhoneDigits,
        country: currentlySelectedCountry,
        countryRequired: !addInternationalOption,
        defaultCountry: defaultCountry,
        getAnyCountry: function getAnyCountry() {
          return _this.getFirstSupportedCountry({
            countries: countries
          });
        },
        countries: countries,
        international: international,
        limitMaxLength: limitMaxLength,
        countryCallingCodeEditable: countryCallingCodeEditable,
        metadata: metadata
      }),
          phoneDigits = _onPhoneDigitsChange.phoneDigits,
          country = _onPhoneDigitsChange.country,
          value = _onPhoneDigitsChange.value;

      var stateUpdate = {
        phoneDigits: phoneDigits,
        value: value,
        country: country
      };

      if (countryCallingCodeEditable === false) {
        // If it simply did `setState({ phoneDigits: intlPrefix })` here,
        // then it would have no effect when erasing an inital international prefix
        // via Backspace, because `phoneDigits` in `state` wouldn't change
        // as a result, because it was `prefix` and it became `prefix`,
        // so the component wouldn't rerender, and the user would be able
        // to erase the country calling code part, and that part is
        // assumed to be non-eraseable. That's why the component is
        // forcefully rerendered here.
        // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
        if (!value && phoneDigits === _this.state.phoneDigits) {
          // Force a re-render of the `<input/>` in order to reset its value.
          stateUpdate.forceRerender = {};
        }
      }

      _this.setState(stateUpdate, // Update the new `value` property.
      // Doing it after the `state` has been updated
      // because `onChange()` will trigger `getDerivedStateFromProps()`
      // with the new `value` which will be compared to `state.value` there.
      function () {
        return onChange(value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      _this._onFocus();

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this._onBlur();

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCountryFocus", function (event) {
      _this._onFocus(); // this.setState({ countrySelectFocused: true })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onFocus = countrySelectProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCountryBlur", function (event) {
      _this._onBlur(); // this.setState({ countrySelectFocused: false })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onBlur = countrySelectProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      }
    });

    _this.inputRef = /*#__PURE__*/React__default$1.createRef();
    var _this$props3 = _this.props,
        _value = _this$props3.value;
        _this$props3.labels;
        var _international = _this$props3.international,
        _addInternationalOption = _this$props3.addInternationalOption,
        displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber,
        initialValueFormat = _this$props3.initialValueFormat,
        _metadata = _this$props3.metadata;
    var _this$props4 = _this.props,
        _defaultCountry = _this$props4.defaultCountry,
        _countries = _this$props4.countries; // Validate `defaultCountry`.

    if (_defaultCountry) {
      if (!_this.isCountrySupportedWithError(_defaultCountry)) {
        _defaultCountry = undefined;
      }
    } // Validate `countries`.


    _countries = getSupportedCountries(_countries, _metadata);
    var phoneNumber = parsePhoneNumber(_value, _metadata);
    _this.CountryIcon = createCountryIconComponent(_this.props);
    var preSelectedCountry = getPreSelectedCountry({
      value: _value,
      phoneNumber: phoneNumber,
      defaultCountry: _defaultCountry,
      required: !_addInternationalOption,
      countries: _countries || getCountries(_metadata),
      getAnyCountry: function getAnyCountry() {
        return _this.getFirstSupportedCountry({
          countries: _countries
        });
      },
      metadata: _metadata
    });
    _this.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: _this.props,
      // The country selected.
      country: preSelectedCountry,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: _countries,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: getInitialPhoneDigits({
        value: _value,
        phoneNumber: phoneNumber,
        defaultCountry: _defaultCountry,
        international: _international,
        useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
        metadata: _metadata
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: _value
    };
    return _this;
  }

  _createClass(PhoneNumberInput_, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCountryChange = this.props.onCountryChange;
      var defaultCountry = this.props.defaultCountry;
      var selectedCountry = this.state.country;

      if (onCountryChange) {
        if (defaultCountry) {
          if (!this.isCountrySupportedWithError(defaultCountry)) {
            defaultCountry = undefined;
          }
        }

        if (selectedCountry !== defaultCountry) {
          onCountryChange(selectedCountry);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onCountryChange = this.props.onCountryChange;
      var country = this.state.country; // Call `onCountryChange` when user selects another country.

      if (onCountryChange && country !== prevState.country) {
        onCountryChange(country);
      }
    }
  }, {
    key: "getCountrySelectOptions",
    value: function getCountrySelectOptions$1(_ref) {
      var countries = _ref.countries;
      var _this$props5 = this.props,
          international = _this$props5.international,
          countryCallingCodeEditable = _this$props5.countryCallingCodeEditable,
          countryOptionsOrder = _this$props5.countryOptionsOrder,
          addInternationalOption = _this$props5.addInternationalOption,
          labels = _this$props5.labels,
          locales = _this$props5.locales,
          metadata = _this$props5.metadata;
      return this.useMemoCountrySelectOptions(function () {
        return sortCountryOptions(getCountrySelectOptions({
          countries: countries || getCountries(metadata),
          countryNames: labels,
          addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
          compareStringsLocales: locales // compareStrings

        }), getSupportedCountryOptions(countryOptionsOrder, metadata));
      }, [countries, countryOptionsOrder, addInternationalOption, labels, metadata]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function useMemoCountrySelectOptions(generator, dependencies) {
      if (!this.countrySelectOptionsMemoDependencies || !areEqualArrays(dependencies, this.countrySelectOptionsMemoDependencies)) {
        this.countrySelectOptionsMemo = generator();
        this.countrySelectOptionsMemoDependencies = dependencies;
      }

      return this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function getFirstSupportedCountry(_ref2) {
      var countries = _ref2.countries;
      var countryOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return countryOptions[0].value;
    } // A shorthand for not passing `metadata` as a second argument.

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          name = _this$props6.name,
          disabled = _this$props6.disabled,
          readOnly = _this$props6.readOnly,
          autoComplete = _this$props6.autoComplete,
          style = _this$props6.style,
          className = _this$props6.className;
          _this$props6.inputRef;
          var inputComponent = _this$props6.inputComponent,
          numberInputProps = _this$props6.numberInputProps,
          smartCaret = _this$props6.smartCaret,
          CountrySelectComponent = _this$props6.countrySelectComponent,
          countrySelectProps = _this$props6.countrySelectProps,
          ContainerComponent = _this$props6.containerComponent;
          _this$props6.defaultCountry;
          _this$props6.countries;
          _this$props6.countryOptionsOrder;
          var labels = _this$props6.labels;
          _this$props6.flags;
          _this$props6.flagComponent;
          _this$props6.flagUrl;
          _this$props6.addInternationalOption;
          _this$props6.internationalIcon;
          _this$props6.displayInitialValueAsLocalNumber;
          _this$props6.initialValueFormat;
          _this$props6.onCountryChange;
          _this$props6.limitMaxLength;
          _this$props6.countryCallingCodeEditable;
          _this$props6.focusInputOnCountrySelection;
          _this$props6.reset;
          var metadata = _this$props6.metadata;
          _this$props6.international;
          _this$props6.locales;
          var rest = _objectWithoutProperties$1(_this$props6, _excluded$12);

      var _this$state3 = this.state,
          country = _this$state3.country,
          countries = _this$state3.countries,
          phoneDigits = _this$state3.phoneDigits,
          isFocused = _this$state3.isFocused;
      var InputComponent = smartCaret ? InputSmart : InputBasic;
      var countrySelectOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return /*#__PURE__*/React__default$1.createElement(ContainerComponent, {
        style: style,
        className: classNames(className, 'PhoneInput', {
          'PhoneInput--focus': isFocused,
          'PhoneInput--disabled': disabled,
          'PhoneInput--readOnly': readOnly
        })
      }, /*#__PURE__*/React__default$1.createElement(CountrySelectComponent, _extends$3({
        name: name ? "".concat(name, "Country") : undefined,
        "aria-label": labels.country
      }, countrySelectProps, {
        value: country,
        options: countrySelectOptions,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: disabled || countrySelectProps && countrySelectProps.disabled,
        readOnly: readOnly || countrySelectProps && countrySelectProps.readOnly,
        iconComponent: this.CountryIcon
      })), /*#__PURE__*/React__default$1.createElement(InputComponent, _extends$3({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: autoComplete
      }, numberInputProps, rest, {
        name: name,
        metadata: metadata,
        country: country,
        value: phoneDigits || '',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: disabled,
        readOnly: readOnly,
        inputComponent: inputComponent,
        className: classNames('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // `state` holds previous props as `props`, and also:
    // * `country` — The currently selected country, e.g. `"RU"`.
    // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
    // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
    // (and a couple of other less significant properties)
    function getDerivedStateFromProps(props, state) {
      return _objectSpread({
        // Emulate `prevProps` via `state.props`.
        props: props
      }, getPhoneInputWithCountryStateUpdateFromNewProps(props, state.props, state));
    }
  }]);

  return PhoneNumberInput_;
}(React__default$1.PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.


var PhoneNumberInput = /*#__PURE__*/React__default$1.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default$1.createElement(PhoneNumberInput_, _extends$3({}, withDefaultProps(props), {
    inputRef: ref
  }));
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: PropTypes.string,

  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: PropTypes.bool,

  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: PropTypes.bool,

  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: PropTypes.string,

  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: PropTypes.oneOf(['national']),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: PropTypes.bool,

  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: PropTypes.string,

  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: PropTypes.arrayOf(PropTypes.string),

  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: labels,

  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */

  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: PropTypes.string,

  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: PropTypes.objectOf(PropTypes.elementType),

  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: PropTypes.elementType,

  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: PropTypes.bool,

  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: PropTypes.elementType,

  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: PropTypes.arrayOf(PropTypes.string),

  /**
   * `<Phone/>` component CSS style object.
   */
  style: PropTypes.object,

  /**
   * `<Phone/>` component CSS class.
   */
  className: PropTypes.string,

  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: PropTypes.elementType,

  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: PropTypes.object,

  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: PropTypes.elementType,

  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: PropTypes.elementType,

  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: PropTypes.object,

  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: PropTypes.bool,

  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: PropTypes.bool,

  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: PropTypes.bool,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: PropTypes.bool,

  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: metadata,

  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: PropTypes.func,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: PropTypes.bool
};
var defaultProps = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: 'tel',

  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: CountrySelectWithIcon,

  /**
   * Flag icon component.
   */
  flagComponent: FlagComponent,

  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',

  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon,

  /**
   * Phone number `<input/>` component.
   */
  inputComponent: 'input',

  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: 'div',

  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: PropTypes.any,

  /**
   *
   */

  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: true,

  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: true,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: true,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: true
};

function withDefaultProps(props) {
  props = _objectSpread({}, props);

  for (var key in defaultProps) {
    if (props[key] === undefined) {
      props[key] = defaultProps[key];
    }
  }

  return props;
}

function areEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}

var defaultLabels = {
  "ext": "ext.",
  "country": "Phone number country",
  "phone": "Phone",
  "AB": "Abkhazia",
  "AC": "Ascension Island",
  "AD": "Andorra",
  "AE": "United Arab Emirates",
  "AF": "Afghanistan",
  "AG": "Antigua and Barbuda",
  "AI": "Anguilla",
  "AL": "Albania",
  "AM": "Armenia",
  "AO": "Angola",
  "AQ": "Antarctica",
  "AR": "Argentina",
  "AS": "American Samoa",
  "AT": "Austria",
  "AU": "Australia",
  "AW": "Aruba",
  "AX": "Åland Islands",
  "AZ": "Azerbaijan",
  "BA": "Bosnia and Herzegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Belgium",
  "BF": "Burkina Faso",
  "BG": "Bulgaria",
  "BH": "Bahrain",
  "BI": "Burundi",
  "BJ": "Benin",
  "BL": "Saint Barthélemy",
  "BM": "Bermuda",
  "BN": "Brunei Darussalam",
  "BO": "Bolivia",
  "BQ": "Bonaire, Sint Eustatius and Saba",
  "BR": "Brazil",
  "BS": "Bahamas",
  "BT": "Bhutan",
  "BV": "Bouvet Island",
  "BW": "Botswana",
  "BY": "Belarus",
  "BZ": "Belize",
  "CA": "Canada",
  "CC": "Cocos (Keeling) Islands",
  "CD": "Congo, Democratic Republic of the",
  "CF": "Central African Republic",
  "CG": "Congo",
  "CH": "Switzerland",
  "CI": "Cote d'Ivoire",
  "CK": "Cook Islands",
  "CL": "Chile",
  "CM": "Cameroon",
  "CN": "China",
  "CO": "Colombia",
  "CR": "Costa Rica",
  "CU": "Cuba",
  "CV": "Cape Verde",
  "CW": "Curaçao",
  "CX": "Christmas Island",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DE": "Germany",
  "DJ": "Djibouti",
  "DK": "Denmark",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "DZ": "Algeria",
  "EC": "Ecuador",
  "EE": "Estonia",
  "EG": "Egypt",
  "EH": "Western Sahara",
  "ER": "Eritrea",
  "ES": "Spain",
  "ET": "Ethiopia",
  "FI": "Finland",
  "FJ": "Fiji",
  "FK": "Falkland Islands",
  "FM": "Federated States of Micronesia",
  "FO": "Faroe Islands",
  "FR": "France",
  "GA": "Gabon",
  "GB": "United Kingdom",
  "GD": "Grenada",
  "GE": "Georgia",
  "GF": "French Guiana",
  "GG": "Guernsey",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GL": "Greenland",
  "GM": "Gambia",
  "GN": "Guinea",
  "GP": "Guadeloupe",
  "GQ": "Equatorial Guinea",
  "GR": "Greece",
  "GS": "South Georgia and the South Sandwich Islands",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HK": "Hong Kong",
  "HM": "Heard Island and McDonald Islands",
  "HN": "Honduras",
  "HR": "Croatia",
  "HT": "Haiti",
  "HU": "Hungary",
  "ID": "Indonesia",
  "IE": "Ireland",
  "IL": "Israel",
  "IM": "Isle of Man",
  "IN": "India",
  "IO": "British Indian Ocean Territory",
  "IQ": "Iraq",
  "IR": "Iran",
  "IS": "Iceland",
  "IT": "Italy",
  "JE": "Jersey",
  "JM": "Jamaica",
  "JO": "Jordan",
  "JP": "Japan",
  "KE": "Kenya",
  "KG": "Kyrgyzstan",
  "KH": "Cambodia",
  "KI": "Kiribati",
  "KM": "Comoros",
  "KN": "Saint Kitts and Nevis",
  "KP": "North Korea",
  "KR": "South Korea",
  "KW": "Kuwait",
  "KY": "Cayman Islands",
  "KZ": "Kazakhstan",
  "LA": "Laos",
  "LB": "Lebanon",
  "LC": "Saint Lucia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesotho",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "LV": "Latvia",
  "LY": "Libya",
  "MA": "Morocco",
  "MC": "Monaco",
  "MD": "Moldova",
  "ME": "Montenegro",
  "MF": "Saint Martin (French Part)",
  "MG": "Madagascar",
  "MH": "Marshall Islands",
  "MK": "North Macedonia",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Mongolia",
  "MO": "Macao",
  "MP": "Northern Mariana Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Mauritius",
  "MV": "Maldives",
  "MW": "Malawi",
  "MX": "Mexico",
  "MY": "Malaysia",
  "MZ": "Mozambique",
  "NA": "Namibia",
  "NC": "New Caledonia",
  "NE": "Niger",
  "NF": "Norfolk Island",
  "NG": "Nigeria",
  "NI": "Nicaragua",
  "NL": "Netherlands",
  "NO": "Norway",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "New Zealand",
  "OM": "Oman",
  "OS": "South Ossetia",
  "PA": "Panama",
  "PE": "Peru",
  "PF": "French Polynesia",
  "PG": "Papua New Guinea",
  "PH": "Philippines",
  "PK": "Pakistan",
  "PL": "Poland",
  "PM": "Saint Pierre and Miquelon",
  "PN": "Pitcairn",
  "PR": "Puerto Rico",
  "PS": "Palestine",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguay",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Romania",
  "RS": "Serbia",
  "RU": "Russia",
  "RW": "Rwanda",
  "SA": "Saudi Arabia",
  "SB": "Solomon Islands",
  "SC": "Seychelles",
  "SD": "Sudan",
  "SE": "Sweden",
  "SG": "Singapore",
  "SH": "Saint Helena",
  "SI": "Slovenia",
  "SJ": "Svalbard and Jan Mayen",
  "SK": "Slovakia",
  "SL": "Sierra Leone",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somalia",
  "SR": "Suriname",
  "SS": "South Sudan",
  "ST": "Sao Tome and Principe",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Syria",
  "SZ": "Swaziland",
  "TA": "Tristan da Cunha",
  "TC": "Turks and Caicos Islands",
  "TD": "Chad",
  "TF": "French Southern Territories",
  "TG": "Togo",
  "TH": "Thailand",
  "TJ": "Tajikistan",
  "TK": "Tokelau",
  "TL": "Timor-Leste",
  "TM": "Turkmenistan",
  "TN": "Tunisia",
  "TO": "Tonga",
  "TR": "Turkey",
  "TT": "Trinidad and Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "UA": "Ukraine",
  "UG": "Uganda",
  "UM": "United States Minor Outlying Islands",
  "US": "United States",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VA": "Holy See (Vatican City State)",
  "VC": "Saint Vincent and the Grenadines",
  "VE": "Venezuela",
  "VG": "Virgin Islands, British",
  "VI": "Virgin Islands, U.S.",
  "VN": "Vietnam",
  "VU": "Vanuatu",
  "WF": "Wallis and Futuna",
  "WS": "Samoa",
  "XK": "Kosovo",
  "YE": "Yemen",
  "YT": "Mayotte",
  "ZA": "South Africa",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "ZZ": "International"
};

var _excluded$11 = ["metadata", "labels"];

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = /*#__PURE__*/React__default$1.forwardRef(function (_ref, ref) {
    var _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata,
        _ref$labels = _ref.labels,
        labels = _ref$labels === void 0 ? defaultLabels : _ref$labels,
        rest = _objectWithoutProperties(_ref, _excluded$11);

    return /*#__PURE__*/React__default$1.createElement(PhoneNumberInput, _extends$2({}, rest, {
      ref: ref,
      metadata: metadata,
      labels: labels
    }));
  });
  PhoneInputDefault.propTypes = {
    metadata: metadata,
    labels: labels
  };
  return PhoneInputDefault;
}
createPhoneInput();

var PhoneInput = createPhoneInput(metadata$1);

var __defProp$1m = Object.defineProperty;
var __getOwnPropSymbols$1n = Object.getOwnPropertySymbols;
var __hasOwnProp$1n = Object.prototype.hasOwnProperty;
var __propIsEnum$1n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1m = (obj, key, value) => key in obj ? __defProp$1m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1n.call(b, prop))
      __defNormalProp$1m(a, prop, b[prop]);
  if (__getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(b)) {
      if (__propIsEnum$1n.call(b, prop))
        __defNormalProp$1m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledPhoneInput = styled$4(PhoneInput)(({ theme }) => ({
  padding: `${theme.spacing(1.75)} ${theme.spacing(3)}`,
  "& .PhoneInputInput": {
    border: "none",
    outline: "none",
    cursor: "inherit",
    font: "inherit"
  }
}));
const PhoneField = forwardRef((props, ref) => {
  const _a = props, { onChange, name, placeholder, value } = _a, restProps = __objRest$K(_a, ["onChange", "name", "placeholder", "value"]);
  return /* @__PURE__ */ jsx(
    StyledPhoneInput,
    __spreadValues$1m({
      name,
      ref,
      onChange: (value2) => onChange({ target: { value: value2 } }),
      value
    }, restProps)
  );
});

var __defProp$1l = Object.defineProperty;
var __defProps$16 = Object.defineProperties;
var __getOwnPropDescs$16 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1m = Object.getOwnPropertySymbols;
var __hasOwnProp$1m = Object.prototype.hasOwnProperty;
var __propIsEnum$1m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1l = (obj, key, value) => key in obj ? __defProp$1l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1m.call(b, prop))
      __defNormalProp$1l(a, prop, b[prop]);
  if (__getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(b)) {
      if (__propIsEnum$1m.call(b, prop))
        __defNormalProp$1l(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$16 = (a, b) => __defProps$16(a, __getOwnPropDescs$16(b));
var __objRest$J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$c = "";
function FormInput(_a) {
  var _b = _a, {
    name,
    shouldUnregister = false,
    transform = {
      input: (value) => value,
      output: (value) => value.trim() === EMPTY_STRING$c ? null : value
    },
    onChange,
    InputProps: InputProps2
  } = _b, props = __objRest$J(_b, [
    "name",
    "shouldUnregister",
    "transform",
    "onChange",
    "InputProps"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      control,
      name,
      defaultValue: null,
      render: ({
        field: { onChange: controllerOnChange, onBlur: controllerOnBlur, value, ref },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx(
        Input$2,
        __spreadProps$16(__spreadValues$1l({}, props), {
          name,
          value: defaultValue(transform.input(value), EMPTY_STRING$c),
          error: !isNothing(error),
          onBlur: controllerOnBlur,
          onChange: (input) => {
            if (typeof onChange === "function") {
              onChange(input);
            }
            controllerOnChange(transform.output(input, value));
          },
          InputProps: __spreadProps$16(__spreadValues$1l({}, InputProps2), {
            ref
          }),
          helperText: error == null ? void 0 : error.message,
          FormHelperTextProps: {
            sx: {
              marginX: 0
            }
          }
        })
      )
    }
  );
}

var __defProp$1k = Object.defineProperty;
var __defProps$15 = Object.defineProperties;
var __getOwnPropDescs$15 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1l = Object.getOwnPropertySymbols;
var __hasOwnProp$1l = Object.prototype.hasOwnProperty;
var __propIsEnum$1l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1k = (obj, key, value) => key in obj ? __defProp$1k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1l.call(b, prop))
      __defNormalProp$1k(a, prop, b[prop]);
  if (__getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(b)) {
      if (__propIsEnum$1l.call(b, prop))
        __defNormalProp$1k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$15 = (a, b) => __defProps$15(a, __getOwnPropDescs$15(b));
var __objRest$I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function RadioGroupField(_a) {
  var _b = _a, { name, defaultValue, options, onChange } = _b, rest = __objRest$I(_b, ["name", "defaultValue", "options", "onChange"]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      defaultValue,
      render: ({ field }) => /* @__PURE__ */ jsx(RadioGroup, __spreadProps$15(__spreadValues$1k(__spreadValues$1k({ row: true, "aria-label": name }, field), rest), { onChange: (event, value) => {
        field.onChange(event);
        if (onChange) {
          onChange(event, value);
        }
      }, children: /* @__PURE__ */ jsx(Grid$3, { container: true, spacing: 4, children: options.map((option) => /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(Box$1, { children: [
        /* @__PURE__ */ jsx(FormControlLabel, { value: option.value, control: /* @__PURE__ */ jsx(Radio, {}), label: option.label }),
        option.hasTextField && option.customComponent ? /* @__PURE__ */ jsx(option.customComponent, { name: `${name}${option.value}` }) : option.hasTextField && /* @__PURE__ */ jsx(FormInput, { name: `${name}${option.value}` })
      ] }) }, option.value)) }) }))
    }
  );
}

const StyledTextField$1 = styled$4(TextField$1, {
  shouldForwardProp: () => true
})(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    padding: `${theme.spacing(2)}`,
    "& .MuiInputBase-input": {
      padding: 0,
      cursor: "inherit"
    }
  }
}));
function RangeInput({ name, minName, maxName }) {
  const { control } = useFormContext();
  return /* @__PURE__ */ jsxs(Box$1, { width: "100%", display: "flex", alignItems: "center", gap: 4, children: [
    /* @__PURE__ */ jsx(
      Controller,
      {
        name: minName ? minName : `${name}Min`,
        control,
        render: ({
          field: { onChange: controllerOnChange, value }
        }) => /* @__PURE__ */ jsx(
          StyledTextField$1,
          {
            fullWidth: true,
            placeholder: "Min",
            type: "number",
            value: value ? value : "",
            onChange: (e) => controllerOnChange(parseInt(e.target.value)),
            variant: "outlined"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Controller,
      {
        name: maxName ? maxName : `${name}Max`,
        control,
        render: ({
          field: { onChange: controllerOnChange, value }
        }) => /* @__PURE__ */ jsx(
          StyledTextField$1,
          {
            fullWidth: true,
            placeholder: "Max",
            type: "number",
            value: value ? value : "",
            onChange: (e) => controllerOnChange(parseInt(e.target.value)),
            variant: "outlined"
          }
        )
      }
    )
  ] });
}

var __defProp$1j = Object.defineProperty;
var __defProps$14 = Object.defineProperties;
var __getOwnPropDescs$14 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1k = Object.getOwnPropertySymbols;
var __hasOwnProp$1k = Object.prototype.hasOwnProperty;
var __propIsEnum$1k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1j = (obj, key, value) => key in obj ? __defProp$1j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1k.call(b, prop))
      __defNormalProp$1j(a, prop, b[prop]);
  if (__getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(b)) {
      if (__propIsEnum$1k.call(b, prop))
        __defNormalProp$1j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$14 = (a, b) => __defProps$14(a, __getOwnPropDescs$14(b));
var __objRest$H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function RangeSlider(_a) {
  var _b = _a, { name, defaultValue, rangeDisabled = false } = _b, rest = __objRest$H(_b, ["name", "defaultValue", "rangeDisabled"]);
  var _a2, _b2;
  const { control } = useFormContext();
  const defaultMinValue = (_a2 = rest == null ? void 0 : rest.min) != null ? _a2 : 0;
  const defaultMaxValue = (_b2 = rest == null ? void 0 : rest.max) != null ? _b2 : 100;
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      defaultValue,
      render: ({ field }) => /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", marginBottom: "16px", marginRight: 0 }, children: [
        /* @__PURE__ */ jsx(
          TextField$1,
          {
            size: "small",
            type: "number",
            value: field.value[0],
            onChange: (e) => field.onChange([+e.target.value, field.value[1]]),
            inputProps: {
              min: defaultMinValue,
              max: field.value[1] - 1,
              style: { fontSize: "0.9rem", lineHeight: "1.2" }
            },
            style: { marginRight: "18px" },
            disabled: rangeDisabled
          }
        ),
        /* @__PURE__ */ jsx(
          Slider,
          __spreadValues$1j(__spreadProps$14(__spreadValues$1j({}, field), {
            value: field.value || [defaultMinValue, defaultMaxValue],
            valueLabelDisplay: "auto",
            min: defaultMinValue,
            max: defaultMaxValue,
            style: { flexGrow: 1 }
          }), rest)
        ),
        /* @__PURE__ */ jsx(
          TextField$1,
          {
            size: "small",
            type: "number",
            value: field.value[1],
            onChange: (e) => field.onChange([field.value[0], +e.target.value]),
            inputProps: {
              min: field.value[0] + 1,
              max: defaultMaxValue,
              style: { fontSize: "0.9rem", lineHeight: "1.2" }
            },
            style: { marginLeft: "18px", marginRight: 0 },
            disabled: rangeDisabled
          }
        )
      ] })
    }
  );
}

const SearchEvent = "custom:search";
const ClearSearchStateEvent = "custom:clearSearchState";
const strictCustomEvent = (name, payload) => new CustomEvent(name, payload);

const EMPTY_STRING$b = "";
function Search() {
  const theme = useTheme$2();
  const { control, getValues } = useFormContext();
  const [value, setValue] = useState(getValues("search"));
  useEffect(() => {
    const listener = (e) => setValue(e.detail);
    document.addEventListener(ClearSearchStateEvent, listener);
    return () => document.removeEventListener(ClearSearchStateEvent, listener);
  }, []);
  return /* @__PURE__ */ jsx(Box$1, { sx: { display: "flex", alignItems: "flex-end" }, children: /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name: "search",
      render: ({ field: { onChange } }) => /* @__PURE__ */ jsx(
        OutlinedInput,
        {
          value: value != null ? value : EMPTY_STRING$b,
          color: "primary",
          placeholder: "Search",
          startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(
            Search$1,
            {
              sx: {
                mr: 1,
                my: 0.5
              }
            }
          ) }),
          sx: {
            width: "100%",
            backgroundColor: "secondary.main",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none"
            },
            "& .MuiInputBase-input": {
              padding: theme.spacing(2),
              paddingLeft: 0
            }
          },
          onChange: (e) => {
            const input = e.target.value.trim().length > 0 ? e.target.value : null;
            setValue(input);
          },
          onKeyUp: (e) => {
            if (e.key === "Enter") {
              onChange(value);
            }
          }
        }
      )
    }
  ) });
}

var __defProp$1i = Object.defineProperty;
var __defProps$13 = Object.defineProperties;
var __getOwnPropDescs$13 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1i = (obj, key, value) => key in obj ? __defProp$1i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1j.call(b, prop))
      __defNormalProp$1i(a, prop, b[prop]);
  if (__getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(b)) {
      if (__propIsEnum$1j.call(b, prop))
        __defNormalProp$1i(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$13 = (a, b) => __defProps$13(a, __getOwnPropDescs$13(b));
const Section = ({ title, children, sx }) => {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: theme.spacing(2), children: /* @__PURE__ */ jsx(Typography$1, { fontWeight: 600, paddingLeft: theme.spacing(4), children: title }) }),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        bgcolor: theme.palette.common.white,
        border: 1,
        borderColor: theme.palette.grey[300],
        sx: __spreadValues$1i({
          boxShadow: "none"
        }, sx),
        children: /* @__PURE__ */ jsx(
          Box$1,
          {
            sx: __spreadProps$13(__spreadValues$1i({}, sx), {
              padding: theme.spacing(4),
              overflowY: "auto",
              "::-webkit-scrollbar": {
                width: "4px"
              },
              "::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.grey[400],
                borderRadius: "2px"
              },
              "::-webkit-scrollbar-track": {
                backgroundColor: theme.palette.grey[100]
              }
            }),
            children
          }
        )
      }
    )
  ] });
};

const EMPTY_STRING$a = "";
const Skeleton$c = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const Size = {
  sm: 12,
  md: 16,
  lg: 24
};
const isCompleted$1 = (event) => (event == null ? void 0 : event.completedDate) !== null;
const getTitle = (event) => {
  var _a, _b;
  return (_b = (_a = event == null ? void 0 : event.milestoneName) != null ? _a : event == null ? void 0 : event.eventName) != null ? _b : EMPTY_STRING$a;
};
const getSubtitle = (event) => {
  return isCompleted$1(event) ? dayjs(event == null ? void 0 : event.completedDate).format("D MMM") : EMPTY_STRING$a;
};
function SupplyChainTimeline({
  events,
  size = "lg",
  labelPlacement = "bottom",
  isEventCompleted = isCompleted$1,
  displayEventCircle = isCompleted$1,
  getEventCircleColor = () => "auto",
  getEventTitle = getTitle,
  getEventSubtitle = getSubtitle,
  getProgressColor = () => "#008000"
}) {
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const styles = getComputedStyle(document.body);
  const canvasEl = document.createElement("canvas");
  const context = canvasEl.getContext("2d");
  const fontSize = mobileBreakpoint ? "0.75rem" : "0.95rem";
  context.font = `${fontSize} ${styles.fontFamily}`;
  const milestoneSize = Size[size];
  const getTextMetrics = useCallback((text) => context.measureText(text), [context]);
  const eventsLength = events.length;
  const progressUnit = Math.max(100 / (eventsLength - 1), 0);
  const completedEvents = events.filter((x) => isEventCompleted(x));
  const completedEventsLength = (completedEvents == null ? void 0 : completedEvents.length) ? completedEvents == null ? void 0 : completedEvents.length : 0;
  const titleSpacing = `calc(${theme.spacing(3)} + ${fontSize} + ${theme.spacing(1.5)} + 0.95em)`;
  const spacingTop = labelPlacement === "top" ? titleSpacing : 0;
  const spacingBottom = labelPlacement === "bottom" ? titleSpacing : 0;
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      position: "relative",
      height: `${milestoneSize}px`,
      bgcolor: (theme2) => theme2.palette.background.default,
      borderRadius: (theme2) => theme2.shape.borderRadius,
      marginTop: spacingTop,
      marginBottom: spacingBottom,
      children: [
        /* @__PURE__ */ jsx(
          Box$1,
          {
            position: "absolute",
            height: "100%",
            width: `calc(${progressUnit * (completedEventsLength - 1)}% + ${milestoneSize / (eventsLength - 1) * (eventsLength - completedEventsLength)}px)`,
            bgcolor: getProgressColor(events),
            borderRadius: (theme2) => theme2.shape.borderRadius,
            zIndex: 2
          }
        ),
        events == null ? void 0 : events.map((event, i) => {
          const title = getEventTitle(event);
          const subtitle = getEventSubtitle(event);
          const text = title.length > subtitle.length ? title : subtitle;
          const defaultOffset = getTextMetrics(text).width / 2 - milestoneSize / 2;
          const titleLeftPos = i === 0 ? 0 : i === eventsLength - 1 ? getTextMetrics(text).width - milestoneSize : defaultOffset;
          const titleAlignment = i === 0 ? "flex-start" : i === eventsLength - 1 ? "flex-end" : "center";
          return /* @__PURE__ */ jsxs(
            Box$1,
            {
              sx: {
                position: "absolute",
                top: 0,
                left: `calc(
											${progressUnit * i}% 
										- ${i === 0 ? 0 : milestoneSize / (eventsLength - 1) * i}px
										)`,
                lineHeight: "12px",
                zIndex: 3
              },
              children: [
                /* @__PURE__ */ jsx(
                  Circle,
                  {
                    sx: {
                      width: `${Size[size]}px`,
                      height: `${Size[size]}px`,
                      color: displayEventCircle(event) ? getEventCircleColor(event) : "transparent"
                    }
                  }
                ),
                /* @__PURE__ */ jsxs(
                  Box$1,
                  {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: titleAlignment,
                    gap: 1.5,
                    sx: {
                      position: "absolute",
                      top: labelPlacement === "top" ? `calc(0% - ${titleSpacing})` : `calc(100% + ${theme.spacing(3)})`,
                      left: `-${titleLeftPos}px`,
                      fontSize,
                      lineHeight: fontSize
                    },
                    children: [
                      /* @__PURE__ */ jsx(Typography$1, { fontSize: "inherit", lineHeight: "inherit", fontWeight: 600, children: title.replace(/\s/g, "\xA0") }),
                      /* @__PURE__ */ jsx(
                        Typography$1,
                        {
                          fontSize: mobileBreakpoint ? "inherit" : "0.95em",
                          lineHeight: mobileBreakpoint ? "inherit" : "0.95em",
                          children: subtitle.replace(/\s/g, "\xA0")
                        }
                      )
                    ]
                  }
                )
              ]
            },
            event.id
          );
        })
      ]
    }
  );
}
function SupplyChainTimelineLoading({
  size = "lg"
}) {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1.5, children: [
        /* @__PURE__ */ jsx(Skeleton$c, { height: "1rem", width: "5rem" }),
        /* @__PURE__ */ jsx(Skeleton$c, { height: "0.9rem", width: "6rem" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, children: [
        /* @__PURE__ */ jsx(Skeleton$c, { height: "1rem", width: "5rem" }),
        /* @__PURE__ */ jsx(Skeleton$c, { height: "0.9rem", width: "6rem" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, children: [
        /* @__PURE__ */ jsx(Skeleton$c, { height: "1rem", width: "5rem" }),
        /* @__PURE__ */ jsx(Skeleton$c, { height: "0.9rem", width: "6rem" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1.5, children: [
        /* @__PURE__ */ jsx(Skeleton$c, { height: "1rem", width: "5rem" }),
        /* @__PURE__ */ jsx(Skeleton$c, { height: "0.9rem", width: "6rem" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Skeleton$c, { height: `${Size[size]}px`, width: "100%" })
  ] });
}

const SwitchInput = ({ label, name, checked, disabled, onChange }) => {
  return /* @__PURE__ */ jsxs(Box, { mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ jsx(
      Label,
      {
        label,
        name,
        style: {
          fontSize: "0.85rem",
          fontWeight: 600,
          color: (theme) => theme.palette.common.black,
          marginBottom: "0.5rem"
        }
      }
    ),
    /* @__PURE__ */ jsx(Switch, { checked, onChange, disabled })
  ] });
};

var __defProp$1h = Object.defineProperty;
var __defProps$12 = Object.defineProperties;
var __getOwnPropDescs$12 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1h = (obj, key, value) => key in obj ? __defProp$1h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1i.call(b, prop))
      __defNormalProp$1h(a, prop, b[prop]);
  if (__getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(b)) {
      if (__propIsEnum$1i.call(b, prop))
        __defNormalProp$1h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$12 = (a, b) => __defProps$12(a, __getOwnPropDescs$12(b));
var __objRest$G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function CustomTabPanel(props) {
  const _a = props, { children, value, index } = _a, other = __objRest$G(_a, ["children", "value", "index"]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps$12(__spreadValues$1h({
      role: "tabpanel",
      hidden: value !== index,
      id: `tabpanel-${index}`,
      "aria-labelledby": `tab-${index}`
    }, other), {
      children: value === index && /* @__PURE__ */ jsx(Box, { sx: { p: 3 }, children })
    })
  );
}
function Tab({ tabItems, initActiveIndex = 0 }) {
  const [value, setValue] = useState(initActiveIndex);
  const renderTabHeader = useMemo(() => {
    if (Array.isArray(tabItems)) {
      return tabItems.map((item) => {
        return /* @__PURE__ */ jsx(Tab$1, { label: item.label, id: `tab-${item.index}`, "aria-controls": `tabpanel-${item.index}` }, item.index);
      });
    }
  }, [tabItems]);
  const renderTabPanel = useMemo(() => {
    if (Array.isArray(tabItems)) {
      return tabItems.map((item) => {
        return /* @__PURE__ */ jsx(CustomTabPanel, { value, index: item.index, children: item.component }, item.index);
      });
    }
  }, [tabItems, value]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { sx: { borderBottom: 1, borderColor: "divider" }, children: /* @__PURE__ */ jsx(Tabs, { value, onChange: handleChange, "aria-label": "basic tabs", children: renderTabHeader }) }),
    renderTabPanel
  ] });
}

var __defProp$1g = Object.defineProperty;
var __defProps$11 = Object.defineProperties;
var __getOwnPropDescs$11 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1g = (obj, key, value) => key in obj ? __defProp$1g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1h.call(b, prop))
      __defNormalProp$1g(a, prop, b[prop]);
  if (__getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(b)) {
      if (__propIsEnum$1h.call(b, prop))
        __defNormalProp$1g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$11 = (a, b) => __defProps$11(a, __getOwnPropDescs$11(b));
var __objRest$F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledToggleButton = styled$4(ToggleButton)(({ theme }) => ({
  borderRadius: "5px",
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    border: "none",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.common.white,
      border: "none",
      opacity: 0.7
    }
  },
  "&:not(.Mui-selected)": {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.dark,
    border: `1px solid ${theme.palette.secondary.light}`,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: darken(theme.palette.secondary.light, 0.1)
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
      border: "none"
    }
  },
  padding: theme.spacing(1.5, 4)
}));
function ToggleGroup(_a) {
  var _b = _a, {
    options,
    value,
    onChange,
    exclusive = true,
    sortOptions,
    error,
    helperText,
    children
  } = _b, rest = __objRest$F(_b, [
    "options",
    "value",
    "onChange",
    "exclusive",
    "sortOptions",
    "error",
    "helperText",
    "children"
  ]);
  const toggleOptions = options ? options.sort(sortOptions) : [];
  return /* @__PURE__ */ jsx(
    ToggleButtonGroup,
    __spreadProps$11(__spreadValues$1g({}, rest), {
      value,
      exclusive,
      onChange: (event, newValue) => {
        if (typeof onChange === "function") {
          onChange(event, newValue);
        }
      },
      style: {
        border: error ? "1px solid red" : "none"
      },
      children: children ? children : toggleOptions.map((option) => /* @__PURE__ */ jsx(StyledToggleButton, { value: option.value, children: option.label }, option.value))
    })
  );
}

var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
var __objRest$E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$9 = "";
function GridViewHyperlinkCell(_a) {
  var _b = _a, { href, getDisplayText } = _b, props = __objRest$E(_b, ["href", "getDisplayText"]);
  const title = defaultValue(props.colDef.headerName, EMPTY_STRING$9);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Tooltip$1, { title, children: /* @__PURE__ */ jsx(Hyperlink, { to: href(props), children: typeof getDisplayText === "function" ? /* @__PURE__ */ jsx(Fragment, { children: getDisplayText(props) }) : /* @__PURE__ */ jsx(Fragment, { children: defaultValue(props.formattedValue, props.value) }) }) }) });
}

var __defProp$1f = Object.defineProperty;
var __defProps$10 = Object.defineProperties;
var __getOwnPropDescs$10 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1f = (obj, key, value) => key in obj ? __defProp$1f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1f.call(b, prop))
      __defNormalProp$1f(a, prop, b[prop]);
  if (__getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(b)) {
      if (__propIsEnum$1f.call(b, prop))
        __defNormalProp$1f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$10 = (a, b) => __defProps$10(a, __getOwnPropDescs$10(b));
const EMPTY_OBJECT$1 = {};
const EMPTY_STRING$8 = "";
const isEditableApiLookupSelectColDef$1 = (column) => (column == null ? void 0 : column.type) === "lookup";
const _optionEqualToValue$1 = (option, value) => option.id.toString() === value;
function GridViewLookupSelectCell(props) {
  var _a;
  const { colDef } = props;
  const params = isEditableApiLookupSelectColDef$1(colDef) ? colDef.props.params : EMPTY_OBJECT$1;
  const showHyperlink = isEditableApiLookupSelectColDef$1(colDef) && ((_a = colDef.props) == null ? void 0 : _a.hyperlink);
  const optionEqualToValue = isEditableApiLookupSelectColDef$1(colDef) ? defaultValue(colDef.props.optionEqualToValue, _optionEqualToValue$1) : _optionEqualToValue$1;
  const [value, setValue] = useState(null);
  const [{ data, isLoading, isFetched }] = useLookupQuery(params);
  if (props.value && !value && data && !isLoading && isFetched) {
    const option = defaultValue(data == null ? void 0 : data.data.results.find((x) => optionEqualToValue(x, props.value)), null);
    if (option) {
      setValue(option);
    }
  }
  const valueOptions = useMemo(
    () => defaultValue(data == null ? void 0 : data.data.results, []).map((option) => ({ value: +option.id, label: option.name })),
    [data]
  );
  if (isEditableApiLookupSelectColDef$1(colDef)) {
    colDef.valueOptions = valueOptions;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: "MuiDataGrid-cellContent",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      children: [
        showHyperlink ? /* @__PURE__ */ jsx(
          GridViewHyperlinkCell,
          __spreadProps$10(__spreadValues$1f({}, props), {
            href: colDef.props.hyperlink,
            getDisplayText: () => defaultValue(value == null ? void 0 : value.name, EMPTY_STRING$8)
          })
        ) : /* @__PURE__ */ jsx("span", { children: defaultValue(value == null ? void 0 : value.name, null) }),
        isLoading && /* @__PURE__ */ jsx(CircularProgress, { size: 16, thickness: 4, color: "primary" })
      ]
    }
  );
}

var __defProp$1e = Object.defineProperty;
var __defProps$$ = Object.defineProperties;
var __getOwnPropDescs$$ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1e = (obj, key, value) => key in obj ? __defProp$1e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1e.call(b, prop))
      __defNormalProp$1e(a, prop, b[prop]);
  if (__getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(b)) {
      if (__propIsEnum$1e.call(b, prop))
        __defNormalProp$1e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$$ = (a, b) => __defProps$$(a, __getOwnPropDescs$$(b));
var __async$r = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const EMPTY_OBJECT = {};
const isEditableApiLookupSelectColDef = (column) => (column == null ? void 0 : column.type) === "lookup";
const _optionRender$1 = (id, label) => (props, option) => {
  return /* @__PURE__ */ createElement("li", __spreadProps$$(__spreadValues$1e({}, props), { key: option[id] }), option[label]);
};
const _optionEqualToValue = (option, value) => option.id.toString() === value.toString();
const _onApplyEdit$2 = (option) => defaultValue(option == null ? void 0 : option.id, null);
const _onSetEditCellValue$2 = noop$6;
function GridEditLookupSelectCell(props) {
  const { id, field, colDef } = props;
  const apiRef = useGridApiContext$1();
  const ref = useRef(null);
  useEffect(() => {
    var _a;
    if (props.hasFocus) {
      (_a = ref.current) == null ? void 0 : _a.focus();
    }
  }, [props.hasFocus, ref]);
  const isDisabled = isEditableApiLookupSelectColDef(colDef) ? defaultValue(colDef.props.disabled, false) : false;
  const params = isEditableApiLookupSelectColDef(colDef) ? colDef.props.params : EMPTY_OBJECT;
  const onApplyEdit = isEditableApiLookupSelectColDef(colDef) ? defaultValue(colDef.props.onApplyEdit, _onApplyEdit$2) : _onApplyEdit$2;
  const onSetEditCellValue = isEditableApiLookupSelectColDef(colDef) ? defaultValue(colDef.props.onSetEditCellValue, _onSetEditCellValue$2) : _onSetEditCellValue$2;
  const optionRender = isEditableApiLookupSelectColDef(colDef) ? defaultValue(colDef.props.optionRender, _optionRender$1("id", "name")) : _optionRender$1("id", "name");
  const optionEqualToValue = isEditableApiLookupSelectColDef(colDef) ? defaultValue(colDef.props.optionEqualToValue, _optionEqualToValue) : _optionEqualToValue;
  const [value, setValue] = useState(null);
  const [{ data, isFetching, isFetched }] = useLookupQuery(params);
  if (props.value && !value && data && !isFetching && isFetched) {
    const option = defaultValue(data == null ? void 0 : data.data.results.find((x) => optionEqualToValue(x, props.value)), null);
    if (option) {
      setValue(option);
    }
  }
  const onChange = useCallback(
    (e, option) => __async$r(this, null, function* () {
      e.stopPropagation();
      const edit = onApplyEdit(option, props.value);
      const isValid = yield apiRef.current.setEditCellValue({ id, field, value: edit });
      if (isValid) {
        setValue(option);
        onSetEditCellValue({ id, field, value: edit });
        apiRef.current.stopCellEditMode({ id, field });
      }
    }),
    [apiRef, props, onApplyEdit]
  );
  return /* @__PURE__ */ jsx(
    AutocompleteDropdown,
    {
      value,
      options: defaultValue(data == null ? void 0 : data.data.results, []),
      renderOption: optionRender,
      loading: isFetching,
      onChange,
      disablePortal: false,
      InputProps: {
        inputRef: ref
      },
      sx: {
        width: "100%"
      },
      disabled: isDisabled
    }
  );
}

var __async$q = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const EMPTY_STRING$7 = "";
const isEditableApiTextInputColDef = (column) => (column == null ? void 0 : column.type) === "textinput";
const _debounceMs$1 = 300;
const _onApplyEdit$1 = (input) => input;
const _onSetEditCellValue$1 = noop$6;
function GridEditTextInputCell(props) {
  var _a, _b, _c, _d, _e;
  const { id, field, colDef } = props;
  const apiRef = useGridApiContext$1();
  const ref = useRef(null);
  useEffect(() => {
    var _a2;
    if (props.hasFocus) {
      (_a2 = ref.current) == null ? void 0 : _a2.focus();
    }
  }, [props.hasFocus, ref]);
  const isDisabled = isEditableApiTextInputColDef(colDef) ? defaultValue((_a = colDef.props) == null ? void 0 : _a.disabled, false) : false;
  const debounceMs = isEditableApiTextInputColDef(colDef) ? defaultValue((_b = colDef.props) == null ? void 0 : _b.debounceMs, _debounceMs$1) : _debounceMs$1;
  const onApplyEdit = isEditableApiTextInputColDef(colDef) ? defaultValue((_c = colDef.props) == null ? void 0 : _c.onApplyEdit, _onApplyEdit$1) : _onApplyEdit$1;
  const onSetEditCellValue = isEditableApiTextInputColDef(colDef) ? defaultValue((_d = colDef.props) == null ? void 0 : _d.onSetEditCellValue, _onSetEditCellValue$1) : _onSetEditCellValue$1;
  const [value, setValue] = useState(defaultValue((_e = props.value) == null ? void 0 : _e.toString(), EMPTY_STRING$7));
  const onChange = useCallback(
    (input) => __async$q(this, null, function* () {
      setValue(input);
      const value2 = onApplyEdit(input);
      const isValid = yield apiRef.current.setEditCellValue({ id, field, value: value2, debounceMs });
      if (isValid) {
        onSetEditCellValue({ id, field, value: value2 });
        apiRef.current.stopCellEditMode({ id, field });
      }
    }),
    [apiRef, props]
  );
  return /* @__PURE__ */ jsx(
    Input$2,
    {
      value,
      onChange,
      InputProps: {
        inputRef: ref
      },
      disabled: isDisabled
    }
  );
}

var __async$p = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const EMPTY_STRING$6 = "";
const isEditableApiNumberInputColDef = (column) => (column == null ? void 0 : column.type) === "numberinput";
const _debounceMs = 300;
const _onApplyEdit = (input) => {
  const parsed = (input.match(/\d+/g) || []).join(EMPTY_STRING$6);
  const number = parseInt(parsed, 10);
  return Number.isNaN(number) ? null : number;
};
const _onSetEditCellValue = noop$6;
function GridEditNumberInputCell(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { id, field, colDef } = props;
  const apiRef = useGridApiContext$1();
  const ref = useRef(null);
  const rowParamas = apiRef.current.getRowParams(id);
  const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(id);
  useEffect(() => {
    var _a2;
    if (props.hasFocus) {
      (_a2 = ref.current) == null ? void 0 : _a2.focus();
    }
  }, [props.hasFocus, ref]);
  const isDisabled = isEditableApiNumberInputColDef(colDef) ? defaultValue((_a = colDef.props) == null ? void 0 : _a.disabled, false) : false;
  const error = isEditableApiNumberInputColDef(colDef) ? ((_b = colDef.props) == null ? void 0 : _b.error) ? colDef.props.error(rowParamas, rowIndex) : false : false;
  const helperText = isEditableApiNumberInputColDef(colDef) ? ((_c = colDef.props) == null ? void 0 : _c.helperText) ? colDef.props.helperText(rowParamas, rowIndex) : EMPTY_STRING$6 : EMPTY_STRING$6;
  const numberInputFormat = isEditableApiNumberInputColDef(colDef) ? (_d = colDef.props) == null ? void 0 : _d.numberInputFormat : void 0;
  const debounceMs = isEditableApiNumberInputColDef(colDef) ? defaultValue((_e = colDef.props) == null ? void 0 : _e.debounceMs, _debounceMs) : _debounceMs;
  const onApplyEdit = isEditableApiNumberInputColDef(colDef) ? defaultValue((_f = colDef.props) == null ? void 0 : _f.onApplyEdit, _onApplyEdit) : _onApplyEdit;
  const onSetEditCellValue = isEditableApiNumberInputColDef(colDef) ? defaultValue((_g = colDef.props) == null ? void 0 : _g.onSetEditCellValue, _onSetEditCellValue) : _onSetEditCellValue;
  const [value, setValue] = useState(defaultValue((_h = props.value) == null ? void 0 : _h.toString(), EMPTY_STRING$6));
  const onChange = useCallback(
    (input) => __async$p(this, null, function* () {
      setValue(input);
      const value2 = onApplyEdit(input);
      const isValid = yield apiRef.current.setEditCellValue({ id, field, value: value2, debounceMs });
      if (isValid) {
        onSetEditCellValue({ id, field, value: value2 });
        apiRef.current.stopCellEditMode({ id, field });
      }
    }),
    [apiRef, props]
  );
  return /* @__PURE__ */ jsx(
    NumberInput,
    {
      value,
      onChange,
      InputProps: {
        inputRef: ref,
        inputProps: {
          style: {
            textAlign: "right"
          }
        }
      },
      format: numberInputFormat,
      disabled: isDisabled,
      error,
      helperText,
      sx: {
        paddingTop: "40px",
        paddingBottom: "40px"
      }
    }
  );
}

var __defProp$1d = Object.defineProperty;
var __defProps$_ = Object.defineProperties;
var __getOwnPropDescs$_ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1d = (obj, key, value) => key in obj ? __defProp$1d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1d.call(b, prop))
      __defNormalProp$1d(a, prop, b[prop]);
  if (__getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(b)) {
      if (__propIsEnum$1d.call(b, prop))
        __defNormalProp$1d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$_ = (a, b) => __defProps$_(a, __getOwnPropDescs$_(b));
var __objRest$D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EDITABLE_API_COLDEF_TYPES = ["lookup", "textinput", "numberinput"];
const isEditableApiColDef = (column) => {
  return (column == null ? void 0 : column.type) ? EDITABLE_API_COLDEF_TYPES.indexOf(column.type) !== -1 : false;
};
const applyEditableApiLookupSelect = (column) => Object.assign(column, {
  renderCell: (params) => /* @__PURE__ */ jsx(GridViewLookupSelectCell, __spreadValues$1d({}, params)),
  renderEditCell: (params) => /* @__PURE__ */ jsx(GridEditLookupSelectCell, __spreadValues$1d({}, params)),
  filterOperators: getGridSingleSelectOperators$1
});
const applyEditableApiTextInput = (column) => Object.assign(column, {
  renderEditCell: (params) => /* @__PURE__ */ jsx(GridEditTextInputCell, __spreadValues$1d({}, params))
});
const applyEditableApiNumberInput = (column) => Object.assign(column, {
  renderEditCell: (params) => /* @__PURE__ */ jsx(GridEditNumberInputCell, __spreadValues$1d({}, params)),
  filterOperators: getGridNumericOperators$1
});
const applyEditableApiComponents = (column) => {
  const fns = {
    lookup: applyEditableApiLookupSelect,
    textinput: applyEditableApiTextInput,
    numberinput: applyEditableApiNumberInput
  };
  return (column == null ? void 0 : column.type) && Object.keys(fns).indexOf(column.type) !== -1 ? fns[column.type](column) : column;
};
const applyEditableApiColumns = (columns) => {
  return columns.map((column) => {
    return column.editable && isEditableApiColDef(column) ? applyEditableApiComponents(column) : column;
  });
};
function DataGrid$1(_a) {
  var _b = _a, { columns } = _b, props = __objRest$D(_b, ["columns"]);
  return /* @__PURE__ */ jsx(DataGridPro, __spreadProps$_(__spreadValues$1d({}, props), { columns: applyEditableApiColumns(columns) }));
}

var __defProp$1c = Object.defineProperty;
var __defProps$Z = Object.defineProperties;
var __getOwnPropDescs$Z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1c = (obj, key, value) => key in obj ? __defProp$1c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1c.call(b, prop))
      __defNormalProp$1c(a, prop, b[prop]);
  if (__getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(b)) {
      if (__propIsEnum$1c.call(b, prop))
        __defNormalProp$1c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Z = (a, b) => __defProps$Z(a, __getOwnPropDescs$Z(b));
function InlineEditGrid({
  apiRef,
  columns,
  rows,
  onAddRow,
  disabled,
  error = false,
  helperText,
  gridFontSize = "0.75rem",
  hideAddButton = false,
  dataGridSx,
  footer
}) {
  const theme = useTheme$2();
  const rowModesModel = rows.reduce(
    (accum, curr) => __spreadProps$Z(__spreadValues$1c({}, accum), {
      [curr.uuid]: {
        mode: GridRowModes$1.Edit
      }
    }),
    {}
  );
  const defaultSlotsFooter = footer ? { footer } : {
    footer: () => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Box$1, { padding: 4, children: !hideAddButton && /* @__PURE__ */ jsx(
      Button$1,
      {
        variant: "outlined",
        onClick: () => onAddRow(),
        startIcon: /* @__PURE__ */ jsx(Add, {}),
        disabled,
        children: "Add"
      }
    ) }) })
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataGrid$1,
      {
        className: error ? ".MuiDataGrid-error" : EMPTY_STRING$g,
        apiRef,
        columns,
        rows,
        getRowId: (row) => row.uuid,
        disableRowSelectionOnClick: true,
        editMode: "row",
        rowModesModel,
        slots: __spreadProps$Z(__spreadValues$1c({}, defaultSlotsFooter), {
          noRowsOverlay: () => /* @__PURE__ */ jsx("span", {})
        }),
        sx: __spreadValues$1c({
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { p: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          borderColor: error ? theme.palette.error.main : void 0,
          fontSize: gridFontSize
        }, dataGridSx)
      }
    ),
    error && /* @__PURE__ */ jsx(FormHelperText, { error: true, children: helperText })
  ] });
}

var __defProp$1b = Object.defineProperty;
var __defProps$Y = Object.defineProperties;
var __getOwnPropDescs$Y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1b = (obj, key, value) => key in obj ? __defProp$1b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1b.call(b, prop))
      __defNormalProp$1b(a, prop, b[prop]);
  if (__getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(b)) {
      if (__propIsEnum$1b.call(b, prop))
        __defNormalProp$1b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Y = (a, b) => __defProps$Y(a, __getOwnPropDescs$Y(b));
var __objRest$C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormCheckbox(_a) {
  var _b = _a, {
    name,
    label,
    shouldUnregister,
    transform = {
      input: (value) => value,
      output: (value) => value
    },
    onChange
  } = _b, props = __objRest$C(_b, [
    "name",
    "label",
    "shouldUnregister",
    "transform",
    "onChange"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      control,
      defaultValue: false,
      name,
      render: ({ field: { onChange: controllerOnChange, value }, fieldState: { error } }) => {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            FormControlLabel,
            {
              control: /* @__PURE__ */ jsx(
                Checkbox,
                __spreadProps$Y(__spreadValues$1b({}, props), {
                  name,
                  checked: transform.input(value),
                  onChange: (event, checked) => {
                    if (typeof onChange === "function") {
                      onChange(event, checked);
                    }
                    controllerOnChange(transform.output(checked));
                  }
                })
              ),
              label
            }
          ),
          error && /* @__PURE__ */ jsx(FormHelperText, { error: true, children: error == null ? void 0 : error.message })
        ] });
      }
    }
  );
}

var __defProp$1a = Object.defineProperty;
var __defProps$X = Object.defineProperties;
var __getOwnPropDescs$X = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1a = (obj, key, value) => key in obj ? __defProp$1a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1a.call(b, prop))
      __defNormalProp$1a(a, prop, b[prop]);
  if (__getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(b)) {
      if (__propIsEnum$1a.call(b, prop))
        __defNormalProp$1a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$X = (a, b) => __defProps$X(a, __getOwnPropDescs$X(b));
var __objRest$B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormDateTimePicker(_a) {
  var _b = _a, {
    name,
    required,
    shouldUnregister,
    transform = {
      input: (value) => value,
      output: (date) => date
    },
    onChange
  } = _b, rest = __objRest$B(_b, [
    "name",
    "required",
    "shouldUnregister",
    "transform",
    "onChange"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      control,
      name,
      defaultValue: null,
      render: ({ field: { onChange: onChangeHandler, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
        DateTimePicker,
        __spreadProps$X(__spreadValues$1a({}, rest), {
          name,
          value: transform.input(value),
          error: !isNothing(error),
          onChange: (date) => {
            try {
              if (typeof onChange === "function") {
                onChange(value);
              }
              onChangeHandler(transform.output(date, value));
            } catch (e) {
              console.error(e);
            }
          },
          errorMessage: error ? error.message : void 0
        })
      )
    }
  );
}

var __defProp$19 = Object.defineProperty;
var __defProps$W = Object.defineProperties;
var __getOwnPropDescs$W = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$19 = (obj, key, value) => key in obj ? __defProp$19(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$19 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$19.call(b, prop))
      __defNormalProp$19(a, prop, b[prop]);
  if (__getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(b)) {
      if (__propIsEnum$19.call(b, prop))
        __defNormalProp$19(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$W = (a, b) => __defProps$W(a, __getOwnPropDescs$W(b));
var __objRest$A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormLookup(_a) {
  var _b = _a, {
    name,
    shouldUnregister = false,
    transform = {
      input: (value) => {
        return !value ? null : value;
      },
      output: (option, _value) => option
    },
    onChange
  } = _b, props = __objRest$A(_b, [
    "name",
    "shouldUnregister",
    "transform",
    "onChange"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      control,
      name,
      defaultValue: null,
      render: ({ field: { onChange: controllerOnChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
        Lookup,
        __spreadProps$W(__spreadValues$19({}, props), {
          name,
          value: transform.input(value),
          onChange: (event, option, reason, detail) => {
            if (typeof onChange === "function") {
              onChange(event, option, reason, detail);
            }
            controllerOnChange(transform.output(option, value));
          },
          error: !isNothing(error),
          errorMessage: error == null ? void 0 : error.message
        })
      )
    }
  );
}

var __defProp$18 = Object.defineProperty;
var __defProps$V = Object.defineProperties;
var __getOwnPropDescs$V = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$18 = (obj, key, value) => key in obj ? __defProp$18(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$18 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$18.call(b, prop))
      __defNormalProp$18(a, prop, b[prop]);
  if (__getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(b)) {
      if (__propIsEnum$18.call(b, prop))
        __defNormalProp$18(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$V = (a, b) => __defProps$V(a, __getOwnPropDescs$V(b));
var __objRest$z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$18.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$18.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormElementWrap(_a) {
  var _b = _a, { name, label, required, children } = _b, rest = __objRest$z(_b, ["name", "label", "required", "children"]);
  return /* @__PURE__ */ jsxs(Grid$4, __spreadProps$V(__spreadValues$18({ item: true, mb: 5 }, rest), { children: [
    label && /* @__PURE__ */ jsx(
      Label,
      {
        name,
        label,
        required,
        style: {
          fontSize: "0.85rem",
          fontWeight: 600,
          color: (theme) => theme.palette.common.black,
          marginBottom: "0.5rem"
        }
      }
    ),
    children
  ] }));
}

var __defProp$17 = Object.defineProperty;
var __defProps$U = Object.defineProperties;
var __getOwnPropDescs$U = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$17 = (obj, key, value) => key in obj ? __defProp$17(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$17 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$17.call(b, prop))
      __defNormalProp$17(a, prop, b[prop]);
  if (__getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(b)) {
      if (__propIsEnum$17.call(b, prop))
        __defNormalProp$17(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$U = (a, b) => __defProps$U(a, __getOwnPropDescs$U(b));
function FormAutocompleteDropdown(props) {
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name: props.name,
      defaultValue: null,
      render: ({ field: { onChange: controllerOnChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
        AutocompleteDropdown,
        __spreadProps$U(__spreadValues$17({}, props), {
          value,
          onChange: (event, option, reason, detail) => {
            if (typeof props.onChange === "function") {
              props.onChange(event, option, reason, detail);
            }
            controllerOnChange(option);
          },
          error: !isNothing(error),
          errorMessage: error == null ? void 0 : error.message
        })
      )
    }
  );
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* CSS variables. */\r\n:root {\r\n\t--PhoneInput-color--focus: #03b2cb;\r\n\t--PhoneInputInternationalIconPhone-opacity: 0.8;\r\n\t--PhoneInputInternationalIconGlobe-opacity: 0.65;\r\n\t--PhoneInputCountrySelect-marginRight: 0.35em;\r\n\t--PhoneInputCountrySelectArrow-width: 0.3em;\r\n\t--PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);\r\n\t--PhoneInputCountrySelectArrow-borderWidth: 1px;\r\n\t--PhoneInputCountrySelectArrow-opacity: 0.45;\r\n\t--PhoneInputCountrySelectArrow-color: currentColor;\r\n\t--PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);\r\n\t--PhoneInputCountrySelectArrow-transform: rotate(45deg);\r\n\t--PhoneInputCountryFlag-aspectRatio: 1.5;\r\n\t--PhoneInputCountryFlag-height: 1em;\r\n\t--PhoneInputCountryFlag-borderWidth: 1px;\r\n\t--PhoneInputCountryFlag-borderColor: rgba(0,0,0,0.5);\r\n\t--PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);\r\n\t--PhoneInputCountryFlag-backgroundColor--loading: rgba(0,0,0,0.1);\r\n}\r\n\r\n.PhoneInput {\r\n\t/* This is done to stretch the contents of this component. */\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.PhoneInputInput {\r\n\t/* The phone number input stretches to fill all empty space */\r\n\tflex: 1;\r\n\t/* The phone number input should shrink\r\n\t   to make room for the extension input */\r\n\tmin-width: 0;\r\n}\r\n\r\n.PhoneInputCountryIcon {\r\n\twidth: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));\r\n\theight: var(--PhoneInputCountryFlag-height);\r\n}\r\n\r\n.PhoneInputCountryIcon--square {\r\n\twidth: var(--PhoneInputCountryFlag-height);\r\n}\r\n\r\n.PhoneInputCountryIcon--border {\r\n\t/* Removed `background-color` because when an `<img/>` was still loading\r\n\t   it would show a dark gray rectangle. */\r\n\t/* For some reason the `<img/>` is not stretched to 100% width and height\r\n\t   and sometime there can be seen white pixels of the background at top and bottom. */\r\n\tbackground-color: var(--PhoneInputCountryFlag-backgroundColor--loading);\r\n\t/* Border is added via `box-shadow` because `border` interferes with `width`/`height`. */\r\n\t/* For some reason the `<img/>` is not stretched to 100% width and height\r\n\t   and sometime there can be seen white pixels of the background at top and bottom,\r\n\t   so an additional \"inset\" border is added. */\r\n\tbox-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),\r\n\t\tinset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);\r\n}\r\n\r\n.PhoneInputCountryIconImg {\r\n\t/* Fixes weird vertical space above the flag icon. */\r\n\t/* https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/7#note_348586559 */\r\n\tdisplay: block;\r\n\t/* 3rd party <SVG/> flag icons won't stretch if they have `width` and `height`.\r\n\t   Also, if an <SVG/> icon's aspect ratio was different, it wouldn't fit too. */\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n.PhoneInputInternationalIconPhone {\r\n\topacity: var(--PhoneInputInternationalIconPhone-opacity);\r\n}\r\n\r\n.PhoneInputInternationalIconGlobe {\r\n\topacity: var(--PhoneInputInternationalIconGlobe-opacity);\r\n}\r\n\r\n/* Styling native country `<select/>`. */\r\n\r\n.PhoneInputCountry {\r\n\tposition: relative;\r\n\talign-self: stretch;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmargin-right: var(--PhoneInputCountrySelect-marginRight);\r\n}\r\n\r\n.PhoneInputCountrySelect {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tz-index: 1;\r\n\tborder: 0;\r\n\topacity: 0;\r\n\tcursor: pointer;\r\n}\r\n\r\n.PhoneInputCountrySelect[disabled],\r\n.PhoneInputCountrySelect[readonly] {\r\n\tcursor: default;\r\n}\r\n\r\n.PhoneInputCountrySelectArrow {\r\n\tdisplay: block;\r\n\tcontent: '';\r\n\twidth: var(--PhoneInputCountrySelectArrow-width);\r\n\theight: var(--PhoneInputCountrySelectArrow-width);\r\n\tmargin-left: var(--PhoneInputCountrySelectArrow-marginLeft);\r\n\tborder-style: solid;\r\n\tborder-color: var(--PhoneInputCountrySelectArrow-color);\r\n\tborder-top-width: 0;\r\n\tborder-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);\r\n\tborder-left-width: 0;\r\n\tborder-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);\r\n\ttransform: var(--PhoneInputCountrySelectArrow-transform);\r\n\topacity: var(--PhoneInputCountrySelectArrow-opacity);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow {\r\n\topacity: 1;\r\n\tcolor: var(--PhoneInputCountrySelectArrow-color--focus);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\r\n\tbox-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),\r\n\t\tinset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe {\r\n\topacity: 1;\r\n\tcolor: var(--PhoneInputCountrySelectArrow-color--focus);\r\n}";
styleInject(css_248z$1);

var __defProp$16 = Object.defineProperty;
var __defProps$T = Object.defineProperties;
var __getOwnPropDescs$T = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$16 = (obj, key, value) => key in obj ? __defProp$16(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$16 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$16.call(b, prop))
      __defNormalProp$16(a, prop, b[prop]);
  if (__getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(b)) {
      if (__propIsEnum$16.call(b, prop))
        __defNormalProp$16(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$T = (a, b) => __defProps$T(a, __getOwnPropDescs$T(b));
var __objRest$y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$16.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$16.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$5 = "";
const StyledTextField = styled$4(TextField$1, {
  shouldForwardProp: () => true
})(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    "& .MuiInputBase-input": {
      padding: 0,
      cursor: "inherit"
    }
  }
}));
function FormPhoneInput(_a) {
  var _b = _a, { name } = _b, restProps = __objRest$y(_b, ["name"]);
  const { control } = useFormContext();
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name,
      defaultValue: EMPTY_STRING$5,
      render: (_a2) => {
        var _b2 = _a2, { field: _c } = _b2, _d = _c, field = __objRest$y(_d, ["ref"]), { fieldState: { error } } = _b2;
        return /* @__PURE__ */ jsx(
          StyledTextField,
          __spreadProps$T(__spreadValues$16({}, field), {
            variant: "outlined",
            sx: {
              width: "100%",
              "& .MuiInputBase-input": {
                padding: theme.spacing(2),
                paddingLeft: 0
              },
              "& .MuiOutlinedInput-input": { display: "flex" }
            },
            InputProps: {
              inputComponent: PhoneField,
              inputProps: __spreadValues$16({
                name,
                control,
                international: true,
                defaultCountry: "NZ",
                value: defaultValue(field.value, EMPTY_STRING$5)
              }, restProps)
            },
            error: !isNothing(error),
            helperText: error == null ? void 0 : error.message,
            FormHelperTextProps: {
              sx: {
                marginX: 0
              }
            }
          })
        );
      }
    }
  );
}

var __defProp$15 = Object.defineProperty;
var __defProps$S = Object.defineProperties;
var __getOwnPropDescs$S = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$15 = (obj, key, value) => key in obj ? __defProp$15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$15 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$15.call(b, prop))
      __defNormalProp$15(a, prop, b[prop]);
  if (__getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(b)) {
      if (__propIsEnum$15.call(b, prop))
        __defNormalProp$15(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$S = (a, b) => __defProps$S(a, __getOwnPropDescs$S(b));
var __objRest$x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkboxIcon$4 = /* @__PURE__ */ jsx(CheckBoxOutlineBlank, { fontSize: "small" });
const checkboxCheckedIcon$4 = /* @__PURE__ */ jsx(CheckBox, { fontSize: "small" });
const _optionRender = (props, option) => {
  var _a, _b;
  return /* @__PURE__ */ createElement("li", __spreadProps$S(__spreadValues$15({}, props), { key: v4() }), `${option.name} ${((_a = option.additionalData) == null ? void 0 : _a.parentLocationName) && ((_b = option.additionalData) == null ? void 0 : _b.parentLocationName) !== null ? ` - ${option.additionalData.parentLocationName}` : ""}`);
};
const _multipleRenderOption = (props, option, { selected }) => {
  var _a, _b;
  return /* @__PURE__ */ createElement("li", __spreadProps$S(__spreadValues$15({}, props), { key: v4() }), /* @__PURE__ */ jsx(Checkbox$1, { icon: checkboxIcon$4, checkedIcon: checkboxCheckedIcon$4, style: { marginRight: 8 }, checked: selected }), /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.85rem", lineHeight: "0.9rem", children: `${option.name} ${((_a = option.additionalData) == null ? void 0 : _a.parentLocationName) && ((_b = option.additionalData) == null ? void 0 : _b.parentLocationName) !== null ? ` - ${option.additionalData.parentLocationName}` : ""}` }));
};
function FormPortLocationLookup(_a) {
  var _b = _a, {
    name,
    placeholder,
    shouldUnregister = false,
    transform = {
      input: (value) => {
        return !value ? null : value;
      },
      output: (option, _value) => option
    },
    onChange,
    multiple,
    params
  } = _b, props = __objRest$x(_b, [
    "name",
    "placeholder",
    "shouldUnregister",
    "transform",
    "onChange",
    "multiple",
    "params"
  ]);
  const optionRender = multiple ? _multipleRenderOption : _optionRender;
  const _params = defaultValue(params, {
    systemName: "PortalLocation",
    maxResults: "150",
    additionalFilter: {
      locationType: [SystemName.LocationType.Port]
    }
  });
  return /* @__PURE__ */ jsx(
    FormLookup,
    __spreadProps$S(__spreadValues$15({}, props), {
      useSearchTerm: true,
      name,
      placeholder,
      params: _params,
      renderOption: optionRender,
      multiple,
      getOptionLabel: (option) => {
        var _a2, _b2;
        if (typeof option === "string") {
          return option;
        }
        return `${option.name} ${((_a2 = option.additionalData) == null ? void 0 : _a2.parentLocationName) && ((_b2 = option.additionalData) == null ? void 0 : _b2.parentLocationName) !== null ? `- ${option.additionalData.parentLocationName}` : ""}`;
      },
      isOptionEqualToValue: (option, value) => option.id === value.id,
      onSetSearchTerm: (term) => {
        const _term = term ? term.split("-")[0].trim() : void 0;
        return _term;
      }
    })
  );
}

var __defProp$14 = Object.defineProperty;
var __defProps$R = Object.defineProperties;
var __getOwnPropDescs$R = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$14 = (obj, key, value) => key in obj ? __defProp$14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$14 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$14.call(b, prop))
      __defNormalProp$14(a, prop, b[prop]);
  if (__getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(b)) {
      if (__propIsEnum$14.call(b, prop))
        __defNormalProp$14(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$R = (a, b) => __defProps$R(a, __getOwnPropDescs$R(b));
var __objRest$w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$14.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$14.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormCheckboxGroup(_a) {
  var _b = _a, { name, options } = _b, rest = __objRest$w(_b, ["name", "options"]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      render: ({ field }) => {
        const { value, onChange } = field;
        const handleChange = (option) => {
          if (value.includes(option)) {
            onChange(value.filter((item) => item !== option));
          } else {
            onChange([...value, option]);
          }
        };
        return /* @__PURE__ */ jsx(FormGroup, __spreadProps$R(__spreadValues$14({}, rest), { children: options.map((option) => /* @__PURE__ */ jsx(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsx(Checkbox$1, { checked: value.includes(option), onChange: () => handleChange(option) }),
            label: option
          },
          option
        )) }));
      }
    }
  );
}

function FormLookupCheckboxGroup({
  params,
  name,
  shouldUnregister = false,
  estimateSize = 2,
  renderOption = (option) => /* @__PURE__ */ jsx(Typography, { fontSize: "small", sx: { cursor: "pointer" }, children: option.name }),
  optionRecordCount
}) {
  const { control } = useFormContext();
  const [{ data, isFetching }] = useLookupQuery(params, { staleTime: Number.POSITIVE_INFINITY });
  const handleChange = (id, checked, value) => {
    return checked ? [...value, id] : value.filter((x) => x !== id);
  };
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
    isFetching && /* @__PURE__ */ jsx(Fragment, { children: Array(estimateSize).fill(void 0).map((_, i) => /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Checkbox$1, { size: "small", disabled: true, sx: { padding: 0 } }),
      /* @__PURE__ */ jsx(Skeleton$d, { height: "0.85rem", width: "220px" })
    ] }, i)) }),
    !isFetching && data && /* @__PURE__ */ jsx(
      Controller,
      {
        control,
        shouldUnregister,
        name,
        render: ({ field: { onChange, value } }) => /* @__PURE__ */ jsx(Fragment, { children: data.data.results.map((option) => /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsxs(Box, { display: "flex", flexGrow: 1, gap: 2, children: [
            /* @__PURE__ */ jsx(
              Checkbox$1,
              {
                id: option.name,
                name: option.name,
                value: option.id,
                size: "small",
                sx: { padding: 0 },
                onChange: (_, checked) => onChange(handleChange(option.id, checked, value)),
                checked: Array.isArray(value) ? value.indexOf(option.id) !== -1 : value === option.id
              }
            ),
            /* @__PURE__ */ jsx("label", { htmlFor: option.name, children: renderOption(option) })
          ] }),
          optionRecordCount && optionRecordCount[option.id] && /* @__PURE__ */ jsx(Box, { display: "flex", gap: 2, children: /* @__PURE__ */ jsxs(Typography, { fontSize: "small", children: [
            "(",
            optionRecordCount[option.id],
            ")"
          ] }) })
        ] }, v4())) })
      }
    )
  ] });
}

var __defProp$13 = Object.defineProperty;
var __defProps$Q = Object.defineProperties;
var __getOwnPropDescs$Q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$13 = (obj, key, value) => key in obj ? __defProp$13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$13 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$13.call(b, prop))
      __defNormalProp$13(a, prop, b[prop]);
  if (__getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(b)) {
      if (__propIsEnum$13.call(b, prop))
        __defNormalProp$13(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Q = (a, b) => __defProps$Q(a, __getOwnPropDescs$Q(b));
var __objRest$v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$13.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$13.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormToggleGroup(_a) {
  var _b = _a, {
    name,
    options,
    onChange,
    transform = {
      input: (value) => value,
      output: (selectedOption) => selectedOption
    },
    children,
    exclusive = true
  } = _b, rest = __objRest$v(_b, [
    "name",
    "options",
    "onChange",
    "transform",
    "children",
    "exclusive"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      defaultValue: null,
      render: ({ field, fieldState }) => {
        const selectedOption = transform.input(field.value);
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            ToggleGroup,
            __spreadProps$Q(__spreadValues$13({}, rest), {
              options,
              value: selectedOption == null ? void 0 : selectedOption.value,
              exclusive,
              onChange: (event, newValue) => {
                const selectedOption2 = newValue && newValue != null ? options.find((option) => option.value === newValue.toString()) : null;
                if (typeof onChange === "function") {
                  onChange(event, selectedOption2);
                }
                field.onChange(transform.output(selectedOption2, field.value));
              },
              error: !!fieldState.error,
              children
            })
          ),
          fieldState.error && /* @__PURE__ */ jsx(FormHelperText, { error: true, children: fieldState.error.message })
        ] });
      }
    }
  );
}

var __defProp$12 = Object.defineProperty;
var __defProps$P = Object.defineProperties;
var __getOwnPropDescs$P = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$12 = (obj, key, value) => key in obj ? __defProp$12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$12 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$12.call(b, prop))
      __defNormalProp$12(a, prop, b[prop]);
  if (__getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(b)) {
      if (__propIsEnum$12.call(b, prop))
        __defNormalProp$12(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$P = (a, b) => __defProps$P(a, __getOwnPropDescs$P(b));
var __objRest$u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$12.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$12.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormAddressLookup(_a) {
  var _b = _a, {
    name,
    shouldUnregister = false,
    transform = {
      input: (value) => {
        return !value ? null : value;
      },
      output: (option, _value) => option
    },
    onChange
  } = _b, props = __objRest$u(_b, [
    "name",
    "shouldUnregister",
    "transform",
    "onChange"
  ]);
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      control,
      name,
      defaultValue: null,
      render: ({ field: { onChange: controllerOnChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
        AddressFinder,
        __spreadProps$P(__spreadValues$12({}, props), {
          name,
          value: transform.input(value),
          onChange: (event, option, reason, detail) => {
            if (typeof onChange === "function") {
              onChange(event, option, reason, detail);
            }
            controllerOnChange(transform.output(option, value));
          },
          error: !isNothing(error),
          errorMessage: error == null ? void 0 : error.message
        })
      )
    }
  );
}

var __defProp$11 = Object.defineProperty;
var __defProps$O = Object.defineProperties;
var __getOwnPropDescs$O = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$11 = (obj, key, value) => key in obj ? __defProp$11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$11 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$11.call(b, prop))
      __defNormalProp$11(a, prop, b[prop]);
  if (__getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(b)) {
      if (__propIsEnum$11.call(b, prop))
        __defNormalProp$11(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$O = (a, b) => __defProps$O(a, __getOwnPropDescs$O(b));
var __objRest$t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function FormLocationAddressLookup(_a) {
  var _b = _a, { multiple } = _b, props = __objRest$t(_b, ["multiple"]);
  const transform = useMemo(
    () => ({
      input: (value) => {
        let input = value;
        if (isNothing(value)) {
          input = multiple ? [] : null;
        }
        if (Array.isArray(value)) {
          input = value.reduce((accum, curr) => {
            return curr.delete ? accum : [
              ...accum,
              {
                id: curr.locationID.toString(),
                name: defaultValue(curr.lookupDisplayText, curr.locationName)
              }
            ];
          }, []);
        }
        if (isObjectLocation(value) && value.delete) {
          input = null;
        }
        if (isObjectLocation(value) && !value.delete) {
          input = {
            id: value.locationID.toString(),
            name: defaultValue(value.lookupDisplayText, value.locationName)
          };
        }
        if (!isObjectLocation(value) && typeof value !== "string") {
          input = null;
        }
        return input;
      },
      output: (option, value) => {
        var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
        let output = value;
        if (Array.isArray(option)) {
          const locations = Array.isArray(value) ? value.reduce((accum, curr) => {
            const match = option.find((x) => {
              return isLookupItem(x) && +x.id === curr.locationID;
            });
            return match ? !isNothing(curr.id) && curr.delete ? [...accum, __spreadProps$O(__spreadValues$11({}, curr), { delete: false })] : [...accum, curr] : !isNothing(curr.id) ? [...accum, __spreadProps$O(__spreadValues$11({}, curr), { delete: true })] : accum;
          }, []) : [];
          const additions = [...option].reduce((accum, curr) => {
            var _a3, _b3;
            const match = locations.find((x) => {
              return isLookupItem(curr) && +curr.id === x.locationID;
            });
            return match ? accum : isLookupItem(curr) ? [
              ...accum,
              {
                locationID: +curr.id,
                locationName: curr.name,
                lookupDisplayText: curr.name,
                timeZoneID: (_a3 = curr.additionalData) == null ? void 0 : _a3.timeZoneID,
                combinedCode: (_b3 = curr.additionalData) == null ? void 0 : _b3.combinedCode
              }
            ] : accum;
          }, []);
          output = [...locations, ...additions];
        }
        if (isNothing(value) && isLookupItem(option)) {
          output = {
            locationID: +option.id,
            locationName: option.name,
            lookupDisplayText: option.name,
            timeZoneID: (_a2 = option.additionalData) == null ? void 0 : _a2.timeZoneID,
            combinedCode: (_b2 = option.additionalData) == null ? void 0 : _b2.combinedCode,
            address1: (_c = option.additionalData) == null ? void 0 : _c.address1,
            address2: (_d = option.additionalData) == null ? void 0 : _d.address2,
            email: (_e = option.additionalData) == null ? void 0 : _e.email,
            mobile: (_f = option.additionalData) == null ? void 0 : _f.mobile,
            postcode: (_g = option.additionalData) == null ? void 0 : _g.postcode,
            state: (_h = option.additionalData) == null ? void 0 : _h.state,
            suburb: (_i = option.additionalData) == null ? void 0 : _i.suburb,
            contact: (_j = option.additionalData) == null ? void 0 : _j.contact
          };
        }
        if (isObjectLocation(value) && isNothing(value.id) && isNothing(option)) {
          const _k = value, rest = __objRest$t(_k, ["locationID", "locationName", "lookupDisplayText", "delete"]);
          output = Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectLocation(value) && !isNothing(value.id) && isNothing(option)) {
          output = __spreadProps$O(__spreadValues$11({}, value), { delete: true });
        }
        if (!isNothing(value) && !Array.isArray(value) && isLookupItem(option)) {
          output = __spreadProps$O(__spreadValues$11({}, value), {
            locationID: +option.id,
            locationName: option.name,
            lookupDisplayText: option.name,
            delete: false,
            timeZoneID: (_l = option.additionalData) == null ? void 0 : _l.timeZoneID,
            combinedCode: (_m = option.additionalData) == null ? void 0 : _m.combinedCode,
            address1: (_n = option.additionalData) == null ? void 0 : _n.address1,
            address2: (_o = option.additionalData) == null ? void 0 : _o.address2,
            email: (_p = option.additionalData) == null ? void 0 : _p.email,
            mobile: (_q = option.additionalData) == null ? void 0 : _q.mobile,
            postcode: (_r = option.additionalData) == null ? void 0 : _r.postcode,
            state: (_s = option.additionalData) == null ? void 0 : _s.state,
            suburb: (_t = option.additionalData) == null ? void 0 : _t.suburb,
            contact: (_u = option.additionalData) == null ? void 0 : _u.contact
          });
        }
        return output;
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(
    FormAddressLookup,
    __spreadProps$O(__spreadValues$11({}, props), {
      multiple,
      transform
    })
  );
}

function BoatWithContainersIcon() {
  return /* @__PURE__ */ jsx(SvgIcon, { children: /* @__PURE__ */ jsx("svg", { fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 450 450", children: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M148.8,221.024H32.723c-3.904,0-7.07,3.165-7.07,7.07v52.785c0,3.905,3.166,7.072,7.07,7.072H148.8\r\n						c3.905,0,7.071-3.167,7.071-7.072v-52.785C155.871,224.189,152.705,221.024,148.8,221.024z"
      }
    ),
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M376.883,240.743H335.02c-1.672,0-3.029,1.357-3.029,3.031v41.862c0,1.673,1.357,3.03,3.029,3.03h41.863\r\n							c1.672,0,3.028-1.357,3.028-3.03v-41.862C379.911,242.1,378.555,240.743,376.883,240.743z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M309.728,240.743h-41.86c-1.677,0-3.031,1.357-3.031,3.031v41.862c0,1.673,1.354,3.03,3.031,3.03h41.86\r\n							c1.677,0,3.033-1.357,3.033-3.03v-41.862C312.761,242.1,311.404,240.743,309.728,240.743z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M242.575,240.743h-41.86c-1.675,0-3.031,1.357-3.031,3.031v41.862c0,1.673,1.356,3.03,3.031,3.03h41.86\r\n							c1.673,0,3.029-1.357,3.029-3.03v-41.862C245.605,242.1,244.248,240.743,242.575,240.743z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M309.728,177.951h-41.86c-1.677,0-3.031,1.357-3.031,3.03v41.862c0,1.673,1.354,3.03,3.031,3.03h41.86\r\n							c1.677,0,3.033-1.357,3.033-3.03v-41.862C312.761,179.308,311.404,177.951,309.728,177.951z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M242.575,177.951h-41.86c-1.675,0-3.031,1.357-3.031,3.03v41.862c0,1.673,1.356,3.03,3.031,3.03h41.86\r\n							c1.673,0,3.029-1.357,3.029-3.03v-41.862C245.605,179.308,244.248,177.951,242.575,177.951z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M109.627,150.818h-37.73c-2.231,0-4.04,1.81-4.04,4.041v47.854c0,2.231,1.809,4.041,4.04,4.041h37.73\r\n						c2.232,0,4.04-1.809,4.04-4.041v-47.854C113.667,152.628,111.858,150.818,109.627,150.818z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M109.627,117.868H96.822V73.976c0-3.347-2.714-6.06-6.061-6.06c-3.348,0-6.061,2.713-6.061,6.06v43.892H71.897\r\n						c-2.231,0-4.04,1.809-4.04,4.041v10.6c0,2.23,1.809,4.04,4.04,4.04h37.73c2.232,0,4.04-1.81,4.04-4.04v-10.6\r\n						C113.667,119.677,111.858,117.868,109.627,117.868z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M489.682,291.031c-0.444-0.8-1.288-1.296-2.205-1.296h-80.53c-0.776,0-1.511,0.358-1.989,0.97l-10.678,13.662H2.525\r\n						c-0.84,0-1.623,0.418-2.094,1.115c-0.469,0.696-0.563,1.581-0.248,2.359c0,0,34.207,84.507,45.63,112.668\r\n						c0.387,0.953,1.313,1.576,2.341,1.576H408.49c0.876,0,1.766-0.303,2.315-1.195c19.639-31.866,78.817-127.3,78.817-127.3\r\n						C490.104,292.811,490.127,291.832,489.682,291.031z M328.821,354.246c-5.474,0-9.915-4.439-9.915-9.915\r\n						c0-5.477,4.441-9.915,9.915-9.915c5.477,0,9.916,4.439,9.916,9.915C338.737,349.806,334.299,354.246,328.821,354.246z\r\n						M376.883,354.246c-5.478,0-9.916-4.439-9.916-9.915c0-5.477,4.438-9.915,9.916-9.915c5.474,0,9.912,4.439,9.912,9.915\r\n						C386.795,349.806,382.356,354.246,376.883,354.246z"
      }
    )
  ] }) }) });
}

function CartonIcon() {
  return /* @__PURE__ */ jsx(SvgIcon$1, { children: /* @__PURE__ */ jsxs("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 307.9 308.65", children: [
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("style", { children: ".cls-1{fill:#fefefe;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;stroke-width:5px;}.cls-2{fill:#fff;}" }) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-3",
        d: "m5.33,154.18c0-23.3.06-46.6-.06-69.9-.02-3.65,1.22-5.75,4.54-7.41C56.77,53.54,103.68,30.11,150.56,6.62c2.2-1.1,3.98-1.25,6.16-.16,47.36,23.71,94.74,47.38,142.12,71.05,2.67,1.33,4.09,3.24,4.08,6.43-.06,46.92-.06,93.84,0,140.75,0,3.81-2.19,5.7-5.13,7.18-21.6,10.81-43.21,21.62-64.83,32.41-25.13,12.54-50.28,25.03-75.37,37.63-2.69,1.35-4.91,1.36-7.64,0-46.6-23.39-93.23-46.71-139.92-69.93-3.41-1.7-4.77-3.85-4.76-7.59.1-23.41.05-46.81.05-70.22Zm287.29-63.4c-44.69,22.35-88.99,44.5-133.22,66.62v132c.77-.36,1.33-.62,1.89-.9,42.79-21.39,85.56-42.81,128.39-64.12,2.21-1.1,3.01-2.21,3-4.7-.09-41.77-.06-83.54-.06-125.31v-3.58Zm-184.69,46.28v3.46c0,14.43-.03,28.85.02,43.28.01,2.87-1.15,4.77-3.74,5.95-2.66,1.21-4.36-.2-6.08-1.92-5.49-5.54-10.97-11.1-16.58-16.51-.93-.9-2.51-1.51-3.82-1.56-4.91-.18-9.83-.06-14.75-.08-4.87-.02-6.37-1.52-6.37-6.49-.01-16.35-.06-32.7.06-49.05.02-2.15-.69-3.17-2.53-4.07-10.91-5.34-21.77-10.79-32.64-16.2-1.9-.95-3.8-1.89-5.93-2.95,0,43.44.03,86.4-.07,129.36,0,2.37.85,3.44,2.79,4.41,37.01,18.41,74,36.86,110.99,55.32,6.43,3.21,12.83,6.48,19.67,9.93,0-1.72,0-2.87,0-4.02,0-38.15,0-76.3,0-114.46,0-4.59,1.5-10.15-.57-13.49-2.08-3.36-7.7-4.56-11.82-6.63-9.43-4.74-18.89-9.42-28.65-14.28Zm5.84-8.58c.94.52,1.27.72,1.61.89,12.37,6.19,24.73,12.39,37.14,18.49.82.4,2.2.29,3.06-.13,11.08-5.46,22.11-11.04,33.16-16.57,32.23-16.12,64.45-32.24,96.98-48.51-1.12-.72-1.95-1.36-2.87-1.83-12.9-6.49-25.79-13-38.77-19.33-1.23-.6-3.29-.47-4.56.15-4.44,2.14-8.68,4.69-13.03,7.02-13.44,7.18-26.88,14.36-40.34,21.49-17.84,9.45-35.7,18.86-53.55,28.3-6.08,3.21-12.14,6.46-18.82,10.02Zm75.86-94.24c-11.13-5.58-21.74-11.03-32.5-16.15-1.7-.81-4.45-.84-6.12-.03-16.76,8.16-33.39,16.58-50.06,24.91-12.24,6.12-24.48,12.26-36.75,18.33-10.99,5.45-22.02,10.8-33.02,16.23-2.95,1.45-5.83,3.03-9.25,4.82,1.43.93,2.23,1.56,3.12,2,9.3,4.67,18.62,9.31,27.93,13.97,8.88,4.44,9.34,4.43,17.74-.77.95-.59,1.92-1.13,2.9-1.65,13.18-7.04,26.35-14.08,39.54-21.09,17.7-9.42,35.41-18.83,53.12-28.23,7.62-4.05,15.26-8.06,23.35-12.33Zm-116.51,73.71c.45.39.64.63.89.75,9.03,4.52,18.05,9.06,27.14,13.47.76.37,2.12.1,2.95-.34,10.21-5.37,20.35-10.85,30.54-16.25,13.37-7.08,26.78-14.1,40.16-21.18,16.02-8.47,32.02-16.98,48.02-25.48,2.52-1.34,5-2.75,7.74-4.27-9.17-4.56-18.07-8.91-26.88-13.45-2.11-1.09-3.59-1.03-5.7.14-10.71,5.93-21.56,11.62-32.37,17.37-13.82,7.35-27.65,14.7-41.49,22.01-16.21,8.56-32.44,17.08-48.66,25.63-.77.41-1.45.98-2.33,1.58Zm-6.06,8.65v42.82c1.1,0,2.07.14,2.98-.02,10.11-1.81,17.95,1.67,23.86,9.96.85,1.19,2.14,2.07,3.78,3.61,0-13.07-.1-25.21.08-37.34.04-2.84-.78-4.24-3.37-5.47-9.14-4.33-18.14-8.96-27.33-13.55Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-2",
        d: "m292.63,90.78v3.58c0,41.77-.03,83.54.06,125.31,0,2.5-.79,3.6-3,4.7-42.83,21.31-85.61,42.73-128.39,64.12-.56.28-1.12.53-1.89.9v-132c44.23-22.12,88.53-44.27,133.22-66.62Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-2",
        d: "m107.94,137.06c9.76,4.86,19.22,9.55,28.65,14.28,4.11,2.07,9.74,3.27,11.82,6.63,2.06,3.34.57,8.9.57,13.49.01,38.15,0,76.3,0,114.46,0,1.15,0,2.31,0,4.02-6.84-3.46-13.24-6.72-19.67-9.93-36.99-18.46-73.98-36.91-110.99-55.32-1.94-.97-2.8-2.04-2.79-4.41.09-42.96.07-85.92.07-129.36,2.13,1.06,4.03,2,5.93,2.95,10.88,5.41,21.73,10.86,32.64,16.2,1.84.9,2.54,1.92,2.53,4.07-.12,16.35-.07,32.7-.06,49.05,0,4.97,1.5,6.48,6.37,6.49,4.92.02,9.84-.1,14.75.08,1.31.05,2.89.66,3.82,1.56,5.61,5.41,11.09,10.97,16.58,16.51,1.71,1.73,3.42,3.13,6.08,1.92,2.59-1.18,3.75-3.08,3.74-5.95-.05-14.43-.02-28.85-.02-43.28v-3.46Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-1",
        d: "m113.77,128.49c6.68-3.56,12.74-6.81,18.82-10.02,17.85-9.44,35.71-18.85,53.55-28.3,13.46-7.13,26.9-14.31,40.34-21.49,4.35-2.33,8.59-4.87,13.03-7.02,1.27-.62,3.33-.75,4.56-.15,12.98,6.33,25.87,12.84,38.77,19.33.92.46,1.75,1.11,2.87,1.83-32.52,16.27-64.75,32.38-96.98,48.51-11.05,5.53-22.08,11.1-33.16,16.57-.85.42-2.24.53-3.06.13-12.41-6.1-24.77-12.31-37.14-18.49-.34-.17-.67-.37-1.61-.89Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-2",
        d: "m189.64,34.25c-8.09,4.27-15.73,8.29-23.35,12.33-17.71,9.4-35.42,18.81-53.12,28.23-13.19,7.02-26.36,14.06-39.54,21.09-.98.52-1.96,1.07-2.9,1.65-8.41,5.2-8.86,5.22-17.74.77-9.31-4.66-18.63-9.3-27.93-13.97-.89-.45-1.69-1.08-3.12-2,3.42-1.79,6.3-3.36,9.25-4.82,11-5.43,22.03-10.79,33.02-16.23,12.27-6.08,24.5-12.21,36.75-18.33,16.67-8.33,33.3-16.75,50.06-24.91,1.67-.82,4.42-.78,6.12.03,10.76,5.12,21.37,10.57,32.5,16.15Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-2",
        d: "m73.12,107.96c.88-.6,1.56-1.17,2.33-1.58,16.21-8.55,32.45-17.07,48.66-25.63,13.84-7.31,27.67-14.66,41.49-22.01,10.81-5.75,21.66-11.44,32.37-17.37,2.12-1.17,3.6-1.23,5.7-.14,8.81,4.54,17.71,8.88,26.88,13.45-2.75,1.52-5.22,2.93-7.74,4.27-16,8.5-32,17.01-48.02,25.48-13.38,7.08-26.78,14.09-40.16,21.18-10.19,5.4-20.34,10.88-30.54,16.25-.83.44-2.19.71-2.95.34-9.09-4.41-18.11-8.95-27.14-13.47-.25-.12-.44-.36-.89-.75Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "cls-1",
        d: "m67.06,116.61c9.19,4.59,18.19,9.22,27.33,13.55,2.59,1.23,3.41,2.63,3.37,5.47-.18,12.13-.08,24.27-.08,37.34-1.64-1.54-2.93-2.42-3.78-3.61-5.91-8.29-13.75-11.77-23.86-9.96-.91.16-1.88.02-2.98.02v-42.82Z"
      }
    )
  ] }) });
}

var __defProp$10 = Object.defineProperty;
var __defProps$N = Object.defineProperties;
var __getOwnPropDescs$N = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$10 = (obj, key, value) => key in obj ? __defProp$10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$10 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$10.call(b, prop))
      __defNormalProp$10(a, prop, b[prop]);
  if (__getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(b)) {
      if (__propIsEnum$10.call(b, prop))
        __defNormalProp$10(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$N = (a, b) => __defProps$N(a, __getOwnPropDescs$N(b));
function FilterListIcon(props) {
  return /* @__PURE__ */ jsx(SvgIcon$1, __spreadProps$N(__spreadValues$10({}, props), { children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1v126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4c18 0 32.6-14.6 32.6-32.6v-182l93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64H41.2zM145.6 207.7L56.8 112H295.2l-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3V386.8l-48-31.7V224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM320 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zM408 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H408z" })
  ] }) }));
}

function PalletIcon() {
  return /* @__PURE__ */ jsx(SvgIcon$1, { children: /* @__PURE__ */ jsx("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 307.9 138.1", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m177.5,103.6h16.8v26.1c0,4.6-3.8,8.4-8.5,8.4h-63.4c-4.6,0-8.4-3.8-8.5-8.4v-26.1h16.8v17.6h46.7l.1-17.6Zm130.4-25.9v52c0,4.6-3.7,8.3-8.2,8.4h-47.5c-4.6,0-8.4-3.8-8.5-8.4v-26.1h16.8v17.6h30.4v-35.1H17.2v35.1h30.5v-17.6h16.8v26.1h0c0,4.6-3.8,8.4-8.5,8.4H8.5c-4.6,0-8.4-3.8-8.5-8.4v-52c0-1,.2-1.9.6-2.9l.3-.6c.1-.4.3-.7.5-1.1L48.8,3.7c1.5-2.3,4.2-3.7,6.9-3.7h196.7c2.8,0,5.4,1.4,6.9,3.7l47.1,69.3c.2.3.4.7.5,1.1l.3.6c.3.9.5,1.9.6,2.9.1,0,.1.1.1.1h0ZM50.8,30.9h206.6l-9.5-13.9H60.2l-9.4,13.9Zm232.8,38.2l-14.7-21.3H39.3l-14.7,21.3h259Z" }) }) });
}

var __defProp$$ = Object.defineProperty;
var __defProps$M = Object.defineProperties;
var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$$ = (obj, key, value) => key in obj ? __defProp$$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$$.call(b, prop))
      __defNormalProp$$(a, prop, b[prop]);
  if (__getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(b)) {
      if (__propIsEnum$$.call(b, prop))
        __defNormalProp$$(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$M = (a, b) => __defProps$M(a, __getOwnPropDescs$M(b));
var __objRest$s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const shipmentModeIconMap = {
  Air: (_a) => {
    var _b = _a, { sx } = _b, props = __objRest$s(_b, ["sx"]);
    return /* @__PURE__ */ jsx(FlightOutlined, __spreadProps$M(__spreadValues$$({}, props), { sx: __spreadValues$$({ transform: "rotate(90deg)" }, sx) }));
  },
  Sea: (props) => /* @__PURE__ */ jsx(DirectionsBoatOutlined, __spreadValues$$({}, props))
};

function addToWatchlist(objectID, objectType) {
  return onEventAPI.post("Association", {
    objectID,
    objectType,
    associationTypeSystemName: "Watchlist"
  });
}
function removeFromWatchlist(objectID, objectType) {
  return onEventAPI.post("Association/Delete", {
    objectID,
    objectType,
    associationTypeSystemName: "Watchlist"
  });
}

var __defProp$_ = Object.defineProperty;
var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$_ = (obj, key, value) => key in obj ? __defProp$_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$_.call(b, prop))
      __defNormalProp$_(a, prop, b[prop]);
  if (__getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(b)) {
      if (__propIsEnum$_.call(b, prop))
        __defNormalProp$_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$o = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function WatchlistIcon(props) {
  if (props.fetchFromServer)
    return /* @__PURE__ */ jsx(WatchlistIconStandalone, __spreadValues$_({}, props));
  else
    return /* @__PURE__ */ jsx(WatchlistIconControlled, __spreadValues$_({}, props));
}
function WatchlistIconControlled(_a) {
  var _b = _a, { objectID, objectType, isWatchlisted, onComplete, disabled, fetchFromServer, sx } = _b, iconProps = __objRest$r(_b, ["objectID", "objectType", "isWatchlisted", "onComplete", "disabled", "fetchFromServer", "sx"]);
  const [watchlisted, setWatchlisted] = useState(isWatchlisted);
  if (watchlisted === void 0 && isWatchlisted !== void 0) {
    setWatchlisted(isWatchlisted);
  }
  const popup = usePopupAlert();
  const title = !objectID ? "Loading..." : watchlisted ? "Remove from Watchlist" : "Add to Watchlist";
  const icon = !objectID || !watchlisted ? /* @__PURE__ */ jsx(StarBorderOutlined, __spreadValues$_({}, iconProps)) : /* @__PURE__ */ jsx(Star, __spreadValues$_({}, iconProps));
  const auth = useAuth();
  if (auth.userHasPermission("apI_Association", "Read")) {
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        disabled: !!disabled || !objectID || !auth.userHasPermission("apI_Association", "Write"),
        title,
        onClick: (event) => __async$o(this, null, function* () {
          event.stopPropagation();
          if (!objectID)
            return;
          setWatchlisted(!watchlisted);
          if (onComplete)
            onComplete(!watchlisted);
          try {
            yield (watchlisted ? removeFromWatchlist : addToWatchlist)(objectID, objectType);
          } catch (e) {
            setWatchlisted(watchlisted);
            if (onComplete)
              onComplete(!!watchlisted, (e == null ? void 0 : e.toString()) || "error");
            popup({ message: "There was an error saving your favourite", severity: "error" });
          }
        }),
        sx,
        children: icon
      }
    );
  } else {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
}
function WatchlistIconStandalone(_c) {
  var _d = _c, { objectID, objectType, isWatchlisted, onComplete, disabled, fetchFromServer, sx } = _d, iconProps = __objRest$r(_d, ["objectID", "objectType", "isWatchlisted", "onComplete", "disabled", "fetchFromServer", "sx"]);
  var _a;
  const query = useQuery$1(
    ["/Association/Exists", objectID, objectType, "Watchlist"],
    () => httpService$1.get(`Association/Exists?objectID=${objectID}&objectType=${objectType}&associationTypeSystemName=Watchlist`),
    {
      enabled: !!objectID && !!objectType
    }
  );
  const initiallyWatchListed = (_a = query.data) == null ? void 0 : _a.data;
  const [watchlisted, setWatchlisted] = useState(initiallyWatchListed);
  if (watchlisted === void 0 && initiallyWatchListed !== void 0) {
    setWatchlisted(initiallyWatchListed);
  }
  const popup = usePopupAlert();
  const title = query.isLoading ? "Loading..." : initiallyWatchListed ? "Remove from Watchlist" : "Add to Watchlist";
  const icon = !objectID || !watchlisted ? /* @__PURE__ */ jsx(StarBorderOutlined, __spreadValues$_({}, iconProps)) : /* @__PURE__ */ jsx(Star, __spreadValues$_({}, iconProps));
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      disabled: !!disabled || !objectID || query.isLoading,
      title,
      onClick: (event) => __async$o(this, null, function* () {
        event.stopPropagation();
        if (!objectID)
          return;
        setWatchlisted(!watchlisted);
        if (onComplete)
          onComplete(!watchlisted);
        try {
          yield (watchlisted ? removeFromWatchlist : addToWatchlist)(objectID, objectType);
        } catch (e) {
          setWatchlisted(watchlisted);
          if (onComplete)
            onComplete(!!watchlisted, (e == null ? void 0 : e.toString()) || "error");
          popup({ message: "There was an error saving your favourite", severity: "error" });
        }
      }),
      sx,
      children: icon
    }
  );
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$2.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$2.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$2.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$2.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$2.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$2.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$2.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$2.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

const CardValue = styled$4(Typography$1)(() => ({
  display: "inline-flex"
}));
const CardLabel = styled$4(CardValue)(({ theme }) => ({
  color: theme.palette.text.secondary
}));
function OrderCard({ order }) {
  var _a, _b, _c, _d;
  const theme = useTheme$2();
  const tabletBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const [carrierLogoURL, setCarrierLogoURL] = useState(null);
  const enabled = !!order.carrierObjectAttachmentID;
  const [{ data, isLoading }] = useAttachmentDownload(order.carrierObjectAttachmentID, { enabled });
  if (data && !carrierLogoURL) {
    const reader = new FileReader();
    reader.onloadend = () => setCarrierLogoURL(reader.result);
    reader.readAsDataURL(data);
  }
  const loading = enabled && isLoading;
  const statusConfigurationJSON = (order == null ? void 0 : order.statusConfiguration) ? JSON.parse(order.statusConfiguration) : null;
  const statusClassName = (statusConfigurationJSON == null ? void 0 : statusConfigurationJSON.statusClassName) ? statusConfigurationJSON.statusClassName : "";
  const cardLabelFontSize = mobileBreakpoint ? "0.8rem" : "inherit";
  const gridItemSX = 6;
  return /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(CardContent, { children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 8, children: [
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: mobileBreakpoint ? 2 : 4, children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 7, md: 8, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontWeight: "medium", variant: "h5", children: order.customer }),
        loading && /* @__PURE__ */ jsx(Skeleton$d, { height: "2rem", width: "8rem" }),
        mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: !loading && !carrierLogoURL && order.carrier !== null || "" }) : /* @__PURE__ */ jsx(Fragment, { children: !loading && !carrierLogoURL && /* @__PURE__ */ jsx(Box$1, { height: "2rem", maxHeight: "2rem", children: /* @__PURE__ */ jsx(Typography$1, { children: order.carrier }) }) }),
        !loading && carrierLogoURL && /* @__PURE__ */ jsx(
          Box$1,
          {
            height: "2rem",
            maxHeight: "2rem",
            width: "100%",
            style: {
              backgroundImage: `url(${carrierLogoURL})`,
              backgroundSize: "contain",
              backgroundPosition: "left",
              backgroundRepeat: "no-repeat"
            }
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 5, md: 4, children: /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "row", justifyContent: "flex-end", children: statusClassName && statusClassName !== "" ? /* @__PURE__ */ jsx(
        Typography$1,
        {
          component: "span",
          className: statusClassName,
          sx: {
            padding: `${theme.spacing(1)} ${theme.spacing(3)}`
          },
          children: order.status
        }
      ) : /* @__PURE__ */ jsx(
        Typography$1,
        {
          component: "span",
          sx: {
            backgroundColor: "secondary.main",
            padding: `${theme.spacing(1)} ${theme.spacing(3)}`
          },
          children: order.status
        }
      ) }) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: mobileBreakpoint ? 2 : 4, children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Order Number" }),
        /* @__PURE__ */ jsx(CardValue, { children: order.orderNumber })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Tracking Number" }),
        /* @__PURE__ */ jsx(CardValue, { children: order.trackingNumber })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Invoice Number" }),
        /* @__PURE__ */ jsx(CardValue, { children: order.invoiceNumber })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Order Date" }),
        /* @__PURE__ */ jsx(CardValue, { children: (order == null ? void 0 : order.orderDate) && format$1(new Date(order.orderDate), "d MMM y") })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Expected Dispatch" }),
        /* @__PURE__ */ jsx(CardValue, { children: (order == null ? void 0 : order.dueDate) && format$1(new Date(order.dueDate), "d MMM y") })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Expected Delivery Date" }),
        /* @__PURE__ */ jsx(CardValue, { children: (order == null ? void 0 : order.expectedDeliveryDate) && format$1(new Date(order == null ? void 0 : order.expectedDeliveryDate), "d MMM y") })
      ] }) }),
      (order == null ? void 0 : order.expectedDCBookInDate) && /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "DC Book in Date" }),
        /* @__PURE__ */ jsx(CardValue, { children: format$1(new Date(order == null ? void 0 : order.expectedDCBookInDate), "d MMM y") })
      ] }) }),
      (order == null ? void 0 : order.confirmedDCBookInDate) && /* @__PURE__ */ jsx(Grid$3, { item: true, xs: gridItemSX, sm: 4, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(CardLabel, { sx: { fontSize: cardLabelFontSize }, children: "Confirmed DC Book in Date" }),
        /* @__PURE__ */ jsx(CardValue, { children: format$1(new Date(order == null ? void 0 : order.confirmedDCBookInDate), "d MMM y") })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: mobileBreakpoint ? 2 : 4, children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, sm: 6, md: 9, children: tabletBreakpoint ? /* @__PURE__ */ jsxs(
        Box$1,
        {
          display: "flex",
          gap: 4,
          alignSelf: "flex-end",
          paddingTop: mobileBreakpoint ? 2 : 4,
          paddingBottom: mobileBreakpoint ? 2 : 0,
          children: [
            /* @__PURE__ */ jsxs("span", { children: [
              (_a = order.totalVolume) == null ? void 0 : _a.toFixed(2),
              "\xA0",
              order.totalVolumeMeasure
            ] }),
            /* @__PURE__ */ jsx("span", { children: "/" }),
            /* @__PURE__ */ jsxs("span", { children: [
              (_b = order.totalWeight) == null ? void 0 : _b.toFixed(2),
              "\xA0",
              order.totalWeightMeasure
            ] }),
            /* @__PURE__ */ jsx("span", { children: "/" }),
            /* @__PURE__ */ jsxs("span", { children: [
              "QTY\xA0",
              order.totalItemCount
            ] })
          ]
        }
      ) : /* @__PURE__ */ jsxs(Grid$3, { container: true, paddingTop: 4, gap: 24, children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(CardLabel, { children: "Volume" }),
          /* @__PURE__ */ jsxs(CardValue, { children: [
            (_c = order.totalVolume) == null ? void 0 : _c.toFixed(2),
            "\xA0",
            order.totalVolumeMeasure
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(CardLabel, { children: "Weight" }),
          /* @__PURE__ */ jsxs(CardValue, { children: [
            (_d = order.totalWeight) == null ? void 0 : _d.toFixed(2),
            "\xA0",
            order.totalWeightMeasure
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(CardLabel, { children: "Item Count" }),
          /* @__PURE__ */ jsx(CardValue, { children: order.totalItemCount })
        ] }) })
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, sm: 6, md: 3, alignSelf: "flex-end", textAlign: "right", children: /* @__PURE__ */ jsx(
        Link$1,
        {
          to: `/Tracking/${order.id}?${order.consignmentID ? `consignment=${order.consignmentID}` : ""}`,
          style: { textDecoration: mobileBreakpoint ? "none" : "underline" },
          children: /* @__PURE__ */ jsx(
            Button,
            {
              variant: "contained",
              color: "primary",
              sx: { width: mobileBreakpoint ? "100%" : "initial" },
              children: "View Tracking Details"
            }
          )
        }
      ) })
    ] })
  ] }) }) });
}

function TrackingEvent({ event }) {
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      padding: 2,
      border: 1,
      borderColor: theme.palette.grey[300],
      borderRadius: 1,
      children: [
        /* @__PURE__ */ jsx(
          Typography$1,
          {
            color: event.milestoneName === "Delivered" ? "#188718" : "black",
            fontSize: "small",
            component: "span",
            alignSelf: "flex-start",
            sx: {
              padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
              backgroundColor: `${event.milestoneName === "Delivered" ? "#5ac95a38" : "secondary.main"}`,
              borderRadius: 1
            },
            children: event.milestoneName
          }
        ),
        mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Typography$1, { fontSize: "small", children: [
          " ",
          event.completedDate && `${dayjs(event.completedDate.replace(/([+-]\d{2}:\d{2})$/, "")).format(
            "MMMM D YYYY, h:mm A"
          )}`
        ] }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Typography$1, { children: [
          " ",
          event.completedDate && `${dayjs(event.completedDate.replace(/([+-]\d{2}:\d{2})$/, "")).format(
            "MMMM D YYYY, h:mm A"
          )}`
        ] }) })
      ]
    }
  );
}

const GridApiContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  GridApiContext.displayName = 'GridApiContext';
}

function useGridApiContext() {
  const apiRef = React$1.useContext(GridApiContext);
  if (apiRef === undefined) {
    throw new Error(['MUI: Could not find the data grid context.', 'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.', 'This can also happen if you are bundling multiple versions of the data grid.'].join('\n'));
  }
  return apiRef;
}

const GridRootPropsContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  GridRootPropsContext.displayName = 'GridRootPropsContext';
}

const useGridRootProps = () => {
  const contextValue = React$1.useContext(GridRootPropsContext);
  if (!contextValue) {
    throw new Error('MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
  }
  return contextValue;
};

const GridPrivateApiContext = /*#__PURE__*/React$1.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  GridPrivateApiContext.displayName = 'GridPrivateApiContext';
}
function useGridPrivateApiContext() {
  const privateApiRef = React$1.useContext(GridPrivateApiContext);
  if (privateApiRef === undefined) {
    throw new Error(['MUI: Could not find the data grid private context.', 'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.', 'This can also happen if you are bundling multiple versions of the data grid.'].join('\n'));
  }
  return privateApiRef;
}

const UNINITIALIZED = {};

// See https://github.com/facebook/react/issues/14490 for when to use this.
function useLazyRef(init, initArg) {
  const ref = React$1.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}

const EMPTY = [];
function useOnMount(fn) {
  /* eslint-disable react-hooks/exhaustive-deps */
  React$1.useEffect(fn, EMPTY);
  /* eslint-enable react-hooks/exhaustive-deps */
}

const buildWarning = (message, gravity = 'warning') => {
  let alreadyWarned = false;
  const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
  return () => {
    if (!alreadyWarned) {
      alreadyWarned = true;
      if (gravity === 'error') {
        console.error(cleanMessage);
      } else {
        console.warn(cleanMessage);
      }
    }
  };
};

const is = Object.is;
function fastObjectShallowCompare(a, b) {
  if (a === b) {
    return true;
  }
  if (!(a instanceof Object) || !(b instanceof Object)) {
    return false;
  }
  let aLength = 0;
  let bLength = 0;

  /* eslint-disable no-restricted-syntax */
  /* eslint-disable guard-for-in */
  for (const key in a) {
    aLength += 1;
    if (!is(a[key], b[key])) {
      return false;
    }
    if (!(key in b)) {
      return false;
    }
  }

  /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */
  for (const _ in b) {
    bLength += 1;
  }
  /* eslint-enable no-restricted-syntax */
  /* eslint-enable guard-for-in */

  return aLength === bLength;
}

const stateNotInitializedWarning = buildWarning(['MUI: `useGridSelector` has been called before the initialization of the state.', 'This hook can only be used inside the context of the grid.']);
function isOutputSelector(selector) {
  return selector.acceptsApiRef;
}
function applySelector(apiRef, selector) {
  if (isOutputSelector(selector)) {
    return selector(apiRef);
  }
  return selector(apiRef.current.state);
}
const defaultCompare = Object.is;
const objectShallowCompare = fastObjectShallowCompare;
const createRefs = () => ({
  state: null,
  equals: null,
  selector: null
});
const useGridSelector = (apiRef, selector, equals = defaultCompare) => {
  if (process.env.NODE_ENV !== 'production') {
    if (!apiRef.current.state) {
      stateNotInitializedWarning();
    }
  }
  const refs = useLazyRef(createRefs);
  const didInit = refs.current.selector !== null;
  const [state, setState] = React$1.useState(
  // We don't use an initialization function to avoid allocations
  didInit ? null : applySelector(apiRef, selector));
  refs.current.state = state;
  refs.current.equals = equals;
  refs.current.selector = selector;
  useOnMount(() => {
    return apiRef.current.store.subscribe(() => {
      const newState = applySelector(apiRef, refs.current.selector);
      if (!refs.current.equals(refs.current.state, newState)) {
        refs.current.state = newState;
        setState(newState);
      }
    });
  });
  return state;
};

function getDataGridUtilityClass(slot) {
  return generateUtilityClass('MuiDataGrid', slot);
}
const gridClasses = generateUtilityClasses('MuiDataGrid', ['actionsCell', 'aggregationColumnHeader', 'aggregationColumnHeader--alignLeft', 'aggregationColumnHeader--alignCenter', 'aggregationColumnHeader--alignRight', 'aggregationColumnHeaderLabel', 'autoHeight', 'autosizing', 'booleanCell', 'cell--editable', 'cell--editing', 'cell--textCenter', 'cell--textLeft', 'cell--textRight', 'cell--withRenderer', 'cell--rangeTop', 'cell--rangeBottom', 'cell--rangeLeft', 'cell--rangeRight', 'cell--selectionMode', 'cell', 'cellContent', 'cellCheckbox', 'cellSkeleton', 'checkboxInput', 'columnHeader--alignCenter', 'columnHeader--alignLeft', 'columnHeader--alignRight', 'columnHeader--dragging', 'columnHeader--moving', 'columnHeader--numeric', 'columnHeader--sortable', 'columnHeader--sorted', 'columnHeader--filtered', 'columnHeader', 'columnHeaderCheckbox', 'columnHeaderDraggableContainer', 'columnHeaderDropZone', 'columnHeaderTitle', 'columnHeaderTitleContainer', 'columnHeaderTitleContainerContent', 'columnGroupHeader', 'columnHeader--filledGroup', 'columnHeader--emptyGroup', 'columnHeader--showColumnBorder', 'columnHeaders', 'columnHeadersInner', 'columnHeadersInner--scrollable', 'columnSeparator--resizable', 'columnSeparator--resizing', 'columnSeparator--sideLeft', 'columnSeparator--sideRight', 'columnSeparator', 'columnsPanel', 'columnsPanelRow', 'detailPanel', 'detailPanels', 'detailPanelToggleCell', 'detailPanelToggleCell--expanded', 'footerCell', 'panel', 'panelHeader', 'panelWrapper', 'panelContent', 'panelFooter', 'paper', 'editBooleanCell', 'editInputCell', 'filterForm', 'filterFormDeleteIcon', 'filterFormLogicOperatorInput', 'filterFormColumnInput', 'filterFormOperatorInput', 'filterFormValueInput', 'filterIcon', 'footerContainer', 'headerFilterRow', 'iconButtonContainer', 'iconSeparator', 'main', 'menu', 'menuIcon', 'menuIconButton', 'menuOpen', 'menuList', 'overlay', 'overlayWrapper', 'overlayWrapperInner', 'root', 'root--densityStandard', 'root--densityComfortable', 'root--densityCompact', 'root--disableUserSelection', 'row', 'row--editable', 'row--editing', 'row--lastVisible', 'row--dragging', 'row--dynamicHeight', 'row--detailPanelExpanded', 'rowReorderCellPlaceholder', 'rowCount', 'rowReorderCellContainer', 'rowReorderCell', 'rowReorderCell--draggable', 'scrollArea--left', 'scrollArea--right', 'scrollArea', 'selectedRowCount', 'sortIcon', 'toolbarContainer', 'toolbarFilterList', 'virtualScroller', 'virtualScrollerContent', 'virtualScrollerContent--overflowed', 'virtualScrollerRenderZone', 'pinnedColumns', 'pinnedColumns--left', 'pinnedColumns--right', 'pinnedColumnHeaders', 'pinnedColumnHeaders--left', 'pinnedColumnHeaders--right', 'withBorderColor', 'cell--withRightBorder', 'columnHeader--withRightBorder', 'treeDataGroupingCell', 'treeDataGroupingCellToggle', 'groupingCriteriaCell', 'groupingCriteriaCellToggle', 'pinnedRows', 'pinnedRows--top', 'pinnedRows--bottom', 'pinnedRowsRenderZone']);

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector$1 = /* #__PURE__ */createSelectorCreator(defaultMemoize);

const cacheContainer = {
  cache: new WeakMap()
};
const missingInstanceIdWarning = buildWarning(['MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.', 'To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g. `mySelector(state, apiRef.current.instanceId)`.']);
function checkIsAPIRef(value) {
  return 'current' in value && 'instanceId' in value.current;
}
const DEFAULT_INSTANCE_ID = {
  id: 'default'
};
const createSelector = (a, b, c, d, e, f, ...rest) => {
  if (rest.length > 0) {
    throw new Error('Unsupported number of selectors');
  }
  let selector;
  if (a && b && c && d && e && f) {
    selector = (stateOrApiRef, instanceIdParam) => {
      const isAPIRef = checkIsAPIRef(stateOrApiRef);
      const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
      const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
      const va = a(state, instanceId);
      const vb = b(state, instanceId);
      const vc = c(state, instanceId);
      const vd = d(state, instanceId);
      const ve = e(state, instanceId);
      return f(va, vb, vc, vd, ve);
    };
  } else if (a && b && c && d && e) {
    selector = (stateOrApiRef, instanceIdParam) => {
      const isAPIRef = checkIsAPIRef(stateOrApiRef);
      const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
      const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
      const va = a(state, instanceId);
      const vb = b(state, instanceId);
      const vc = c(state, instanceId);
      const vd = d(state, instanceId);
      return e(va, vb, vc, vd);
    };
  } else if (a && b && c && d) {
    selector = (stateOrApiRef, instanceIdParam) => {
      const isAPIRef = checkIsAPIRef(stateOrApiRef);
      const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
      const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
      const va = a(state, instanceId);
      const vb = b(state, instanceId);
      const vc = c(state, instanceId);
      return d(va, vb, vc);
    };
  } else if (a && b && c) {
    selector = (stateOrApiRef, instanceIdParam) => {
      const isAPIRef = checkIsAPIRef(stateOrApiRef);
      const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
      const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
      const va = a(state, instanceId);
      const vb = b(state, instanceId);
      return c(va, vb);
    };
  } else if (a && b) {
    selector = (stateOrApiRef, instanceIdParam) => {
      const isAPIRef = checkIsAPIRef(stateOrApiRef);
      const instanceId = instanceIdParam != null ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
      const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
      const va = a(state, instanceId);
      return b(va);
    };
  } else {
    throw new Error('Missing arguments');
  }

  // We use this property to detect if the selector was created with createSelector
  // or it's only a simple function the receives the state and returns part of it.
  selector.acceptsApiRef = true;
  return selector;
};
const createSelectorMemoized = (...args) => {
  const selector = (...selectorArgs) => {
    var _cache$get, _cache$get3;
    const [stateOrApiRef, instanceId] = selectorArgs;
    const isAPIRef = checkIsAPIRef(stateOrApiRef);
    const cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId != null ? instanceId : DEFAULT_INSTANCE_ID;
    const state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
    if (process.env.NODE_ENV !== 'production') {
      if (cacheKey.id === 'default') {
        missingInstanceIdWarning();
      }
    }
    const {
      cache
    } = cacheContainer;
    if (cache.get(cacheKey) && (_cache$get = cache.get(cacheKey)) != null && _cache$get.get(args)) {
      var _cache$get2;
      // We pass the cache key because the called selector might have as
      // dependency another selector created with this `createSelector`.
      return (_cache$get2 = cache.get(cacheKey)) == null ? void 0 : _cache$get2.get(args)(state, cacheKey);
    }
    const newSelector = createSelector$1(...args);
    if (!cache.get(cacheKey)) {
      cache.set(cacheKey, new Map());
    }
    (_cache$get3 = cache.get(cacheKey)) == null || _cache$get3.set(args, newSelector);
    return newSelector(state, cacheKey);
  };

  // We use this property to detect if the selector was created with createSelector
  // or it's only a simple function the receives the state and returns part of it.
  selector.acceptsApiRef = true;
  return selector;
};

/**
 * Get the columns state
 * @category Columns
 */
const gridColumnsStateSelector = state => state.columns;

/**
 * Get an array of column fields in the order rendered on screen.
 * @category Columns
 */
const gridColumnFieldsSelector = createSelector(gridColumnsStateSelector, columnsState => columnsState.orderedFields);

/**
 * Get the columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */
const gridColumnLookupSelector = createSelector(gridColumnsStateSelector, columnsState => columnsState.lookup);

/**
 * Get an array of column definitions in the order rendered on screen..
 * @category Columns
 */
const gridColumnDefinitionsSelector = createSelectorMemoized(gridColumnFieldsSelector, gridColumnLookupSelector, (allFields, lookup) => allFields.map(field => lookup[field]));

/**
 * Get the column visibility model, containing the visibility status of each column.
 * If a column is not registered in the model, it is visible.
 * @category Visible Columns
 */
const gridColumnVisibilityModelSelector = createSelector(gridColumnsStateSelector, columnsState => columnsState.columnVisibilityModel);

/**
 * Get the visible columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Visible Columns
 */
const gridVisibleColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector, (columns, columnVisibilityModel) => columns.filter(column => columnVisibilityModel[column.field] !== false));

/**
 * Get the field of each visible column.
 * @category Visible Columns
 */
const gridVisibleColumnFieldsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, visibleColumns => visibleColumns.map(column => column.field));

/**
 * Get the left position in pixel of each visible columns relative to the left of the first column.
 * @category Visible Columns
 */
const gridColumnPositionsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, visibleColumns => {
  const positions = [];
  let currentPosition = 0;
  for (let i = 0; i < visibleColumns.length; i += 1) {
    positions.push(currentPosition);
    currentPosition += visibleColumns[i].computedWidth;
  }
  return positions;
});

/**
 * Get the summed width of all the visible columns.
 * @category Visible Columns
 */
const gridColumnsTotalWidthSelector = createSelector(gridVisibleColumnDefinitionsSelector, gridColumnPositionsSelector, (visibleColumns, positions) => {
  const colCount = visibleColumns.length;
  if (colCount === 0) {
    return 0;
  }
  return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});

/**
 * Get the filterable columns as an array.
 * @category Columns
 */
const gridFilterableColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, columns => columns.filter(col => col.filterable));

/**
 * Get the filterable columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */
const gridFilterableColumnLookupSelector = createSelectorMemoized(gridColumnDefinitionsSelector, columns => columns.reduce((acc, col) => {
  if (col.filterable) {
    acc[col.field] = col;
  }
  return acc;
}, {}));

/**
 * @category ColumnGrouping
 * @ignore - do not document.
 */
const gridColumnGroupingSelector = state => state.columnGrouping;
const gridColumnGroupsUnwrappedModelSelector = createSelectorMemoized(gridColumnGroupingSelector, columnGrouping => {
  var _columnGrouping$unwra;
  return (_columnGrouping$unwra = columnGrouping == null ? void 0 : columnGrouping.unwrappedGroupingModel) != null ? _columnGrouping$unwra : {};
});
const gridColumnGroupsLookupSelector = createSelectorMemoized(gridColumnGroupingSelector, columnGrouping => {
  var _columnGrouping$looku;
  return (_columnGrouping$looku = columnGrouping == null ? void 0 : columnGrouping.lookup) != null ? _columnGrouping$looku : {};
});
const gridColumnGroupsHeaderStructureSelector = createSelectorMemoized(gridColumnGroupingSelector, columnGrouping => {
  var _columnGrouping$heade;
  return (_columnGrouping$heade = columnGrouping == null ? void 0 : columnGrouping.headerStructure) != null ? _columnGrouping$heade : [];
});
const gridColumnGroupsHeaderMaxDepthSelector = createSelector(gridColumnGroupingSelector, columnGrouping => {
  var _columnGrouping$maxDe;
  return (_columnGrouping$maxDe = columnGrouping == null ? void 0 : columnGrouping.maxDepth) != null ? _columnGrouping$maxDe : 0;
});

const gridRowsStateSelector = state => state.rows;
const gridRowCountSelector = createSelector(gridRowsStateSelector, rows => rows.totalRowCount);
const gridRowsLoadingSelector = createSelector(gridRowsStateSelector, rows => rows.loading);
const gridTopLevelRowCountSelector = createSelector(gridRowsStateSelector, rows => rows.totalTopLevelRowCount);

// TODO rows v6: Rename
const gridRowsLookupSelector = createSelector(gridRowsStateSelector, rows => rows.dataRowIdToModelLookup);
const gridRowsDataRowIdToIdLookupSelector = createSelector(gridRowsStateSelector, rows => rows.dataRowIdToIdLookup);
const gridRowTreeSelector = createSelector(gridRowsStateSelector, rows => rows.tree);
const gridRowGroupingNameSelector = createSelector(gridRowsStateSelector, rows => rows.groupingName);
const gridRowTreeDepthsSelector = createSelector(gridRowsStateSelector, rows => rows.treeDepths);
const gridRowMaximumTreeDepthSelector = createSelectorMemoized(gridRowsStateSelector, rows => {
  const entries = Object.entries(rows.treeDepths);
  if (entries.length === 0) {
    return 1;
  }
  return entries.filter(([, nodeCount]) => nodeCount > 0).map(([depth]) => Number(depth)).sort((a, b) => b - a)[0] + 1;
});
const gridDataRowIdsSelector = createSelector(gridRowsStateSelector, rows => rows.dataRowIds);

/**
 * @ignore - do not document.
 */
const gridAdditionalRowGroupsSelector = createSelector(gridRowsStateSelector, rows => rows == null ? void 0 : rows.additionalRowGroups);

/**
 * @ignore - do not document.
 */
const gridPinnedRowsSelector = createSelectorMemoized(gridAdditionalRowGroupsSelector, additionalRowGroups => {
  var _rawPinnedRows$bottom, _rawPinnedRows$top;
  const rawPinnedRows = additionalRowGroups == null ? void 0 : additionalRowGroups.pinnedRows;
  return {
    bottom: rawPinnedRows == null || (_rawPinnedRows$bottom = rawPinnedRows.bottom) == null ? void 0 : _rawPinnedRows$bottom.map(rowEntry => {
      var _rowEntry$model;
      return {
        id: rowEntry.id,
        model: (_rowEntry$model = rowEntry.model) != null ? _rowEntry$model : {}
      };
    }),
    top: rawPinnedRows == null || (_rawPinnedRows$top = rawPinnedRows.top) == null ? void 0 : _rawPinnedRows$top.map(rowEntry => {
      var _rowEntry$model2;
      return {
        id: rowEntry.id,
        model: (_rowEntry$model2 = rowEntry.model) != null ? _rowEntry$model2 : {}
      };
    })
  };
});

/**
 * @ignore - do not document.
 */
const gridPinnedRowsCountSelector = createSelector(gridPinnedRowsSelector, pinnedRows => {
  var _pinnedRows$top, _pinnedRows$bottom;
  return ((pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.length) || 0) + ((pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.length) || 0);
});

const useGridAriaAttributes = () => {
  var _rootProps$experiment;
  const apiRef = useGridPrivateApiContext();
  const rootProps = useGridRootProps();
  const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
  const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
  const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
  const pinnedRowsCount = useGridSelector(apiRef, gridPinnedRowsCountSelector);
  let role = 'grid';
  if ((_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 && rootProps.treeData) {
    role = 'treegrid';
  }
  return {
    role,
    'aria-colcount': visibleColumns.length,
    'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
    'aria-multiselectable': !rootProps.disableMultipleRowSelection
  };
};

const useUtilityClasses$I = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['main']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridMainContainerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'Main',
  overridesResolver: (props, styles) => styles.main
})(() => ({
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
}));
const GridMainContainer = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  var _rootProps$experiment;
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$I(rootProps);
  const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
  ? useGridAriaAttributes : null;
  const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
  return /*#__PURE__*/jsx(GridMainContainerRoot, _extends$c({
    ref: ref,
    className: classes.root,
    ownerState: rootProps
  }, ariaAttributes, {
    children: props.children
  }));
});

/**
 * @category Sorting
 * @ignore - do not document.
 */
const gridSortingStateSelector = state => state.sorting;

/**
 * Get the id of the rows after the sorting process.
 * @category Sorting
 */
const gridSortedRowIdsSelector = createSelector(gridSortingStateSelector, sortingState => sortingState.sortedRows);

/**
 * Get the id and the model of the rows after the sorting process.
 * @category Sorting
 */
const gridSortedRowEntriesSelector = createSelectorMemoized(gridSortedRowIdsSelector, gridRowsLookupSelector,
// TODO rows v6: Is this the best approach ?
(sortedIds, idRowsLookup) => sortedIds.map(id => {
  var _idRowsLookup$id;
  return {
    id,
    model: (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
  };
}));

/**
 * Get the current sorting model.
 * @category Sorting
 */
const gridSortModelSelector = createSelector(gridSortingStateSelector, sorting => sorting.sortModel);
/**
 * @category Sorting
 * @ignore - do not document.
 */
const gridSortColumnLookupSelector = createSelectorMemoized(gridSortModelSelector, sortModel => {
  const result = sortModel.reduce((res, sortItem, index) => {
    res[sortItem.field] = {
      sortDirection: sortItem.sort,
      sortIndex: sortModel.length > 1 ? index + 1 : undefined
    };
    return res;
  }, {});
  return result;
});

/**
 * @category Filtering
 */
const gridFilterStateSelector = state => state.filter;

/**
 * Get the current filter model.
 * @category Filtering
 */
const gridFilterModelSelector = createSelector(gridFilterStateSelector, filterState => filterState.filterModel);

/**
 * Get the current quick filter values.
 * @category Filtering
 */
const gridQuickFilterValuesSelector = createSelector(gridFilterModelSelector, filterModel => filterModel.quickFilterValues);

/**
 * @category Visible rows
 * @ignore - do not document.
 */
const gridVisibleRowsLookupSelector = state => state.visibleRowsLookup;

/**
 * @category Filtering
 * @ignore - do not document.
 */
const gridFilteredRowsLookupSelector = createSelector(gridFilterStateSelector, filterState => filterState.filteredRowsLookup);

/**
 * @category Filtering
 * @ignore - do not document.
 */
createSelector(gridFilterStateSelector, filterState => filterState.filteredDescendantCountLookup);

/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */
const gridExpandedSortedRowEntriesSelector = createSelectorMemoized(gridVisibleRowsLookupSelector, gridSortedRowEntriesSelector, (visibleRowsLookup, sortedRows) => sortedRows.filter(row => visibleRowsLookup[row.id] !== false));

/**
 * Get the id of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */
const gridExpandedSortedRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, visibleSortedRowEntries => visibleSortedRowEntries.map(row => row.id));

/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */
const gridFilteredSortedRowEntriesSelector = createSelectorMemoized(gridFilteredRowsLookupSelector, gridSortedRowEntriesSelector, (filteredRowsLookup, sortedRows) => sortedRows.filter(row => filteredRowsLookup[row.id] !== false));

/**
 * Get the id of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */
const gridFilteredSortedRowIdsSelector = createSelectorMemoized(gridFilteredSortedRowEntriesSelector, filteredSortedRowEntries => filteredSortedRowEntries.map(row => row.id));

/**
 * Get the id and the model of the top level rows accessible after the filtering process.
 * @category Filtering
 */
const gridFilteredSortedTopLevelRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, (visibleSortedRows, rowTree, rowTreeDepth) => {
  if (rowTreeDepth < 2) {
    return visibleSortedRows;
  }
  return visibleSortedRows.filter(row => {
    var _rowTree$row$id;
    return ((_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth) === 0;
  });
});

/**
 * Get the amount of rows accessible after the filtering process.
 * @category Filtering
 */
const gridExpandedRowCountSelector = createSelector(gridExpandedSortedRowEntriesSelector, visibleSortedRows => visibleSortedRows.length);

/**
 * Get the amount of top level rows accessible after the filtering process.
 * @category Filtering
 */
const gridFilteredTopLevelRowCountSelector = createSelector(gridFilteredSortedTopLevelRowEntriesSelector, visibleSortedTopLevelRows => visibleSortedTopLevelRows.length);

/**
 * @category Filtering
 * @ignore - do not document.
 */
const gridFilterActiveItemsSelector = createSelectorMemoized(gridFilterModelSelector, gridColumnLookupSelector, (filterModel, columnLookup) => {
  var _filterModel$items;
  return (_filterModel$items = filterModel.items) == null ? void 0 : _filterModel$items.filter(item => {
    var _column$filterOperato, _item$value;
    if (!item.field) {
      return false;
    }
    const column = columnLookup[item.field];
    if (!(column != null && column.filterOperators) || (column == null || (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.length) === 0) {
      return false;
    }
    const filterOperator = column.filterOperators.find(operator => operator.value === item.operator);
    if (!filterOperator) {
      return false;
    }
    return !filterOperator.InputComponent || item.value != null && ((_item$value = item.value) == null ? void 0 : _item$value.toString()) !== '';
  });
});
/**
 * @category Filtering
 * @ignore - do not document.
 */
const gridFilterActiveItemsLookupSelector = createSelectorMemoized(gridFilterActiveItemsSelector, activeFilters => {
  const result = activeFilters.reduce((res, filterItem) => {
    if (!res[filterItem.field]) {
      res[filterItem.field] = [filterItem];
    } else {
      res[filterItem.field].push(filterItem);
    }
    return res;
  }, {});
  return result;
});

const gridFocusStateSelector = state => state.focus;
const gridFocusCellSelector = createSelector(gridFocusStateSelector, focusState => focusState.cell);
const gridFocusColumnHeaderSelector = createSelector(gridFocusStateSelector, focusState => focusState.columnHeader);

// eslint-disable-next-line @typescript-eslint/naming-convention
createSelector(gridFocusStateSelector, focusState => focusState.columnHeaderFilter);

// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_gridFocusColumnGroupHeaderSelector = createSelector(gridFocusStateSelector, focusState => focusState.columnGroupHeader);
const gridTabIndexStateSelector = state => state.tabIndex;
const gridTabIndexCellSelector = createSelector(gridTabIndexStateSelector, state => state.cell);
const gridTabIndexColumnHeaderSelector = createSelector(gridTabIndexStateSelector, state => state.columnHeader);

// eslint-disable-next-line @typescript-eslint/naming-convention
createSelector(gridTabIndexStateSelector, state => state.columnHeaderFilter);

// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_gridTabIndexColumnGroupHeaderSelector = createSelector(gridTabIndexStateSelector, state => state.columnGroupHeader);

const gridDensitySelector = state => state.density;
const gridDensityValueSelector = createSelector(gridDensitySelector, density => density.value);
const gridDensityFactorSelector = createSelector(gridDensitySelector, density => density.factor);

const gridColumnMenuSelector = state => state.columnMenu;

function GridBody(props) {
  const {
    VirtualScrollerComponent,
    ColumnHeadersProps,
    children
  } = props;
  const apiRef = useGridPrivateApiContext();
  const rootProps = useGridRootProps();
  const rootRef = React$1.useRef(null);
  const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
  const filterColumnLookup = useGridSelector(apiRef, gridFilterActiveItemsLookupSelector);
  const sortColumnLookup = useGridSelector(apiRef, gridSortColumnLookupSelector);
  const columnPositions = useGridSelector(apiRef, gridColumnPositionsSelector);
  const columnHeaderTabIndexState = useGridSelector(apiRef, gridTabIndexColumnHeaderSelector);
  const cellTabIndexState = useGridSelector(apiRef, gridTabIndexCellSelector);
  const columnGroupHeaderTabIndexState = useGridSelector(apiRef, unstable_gridTabIndexColumnGroupHeaderSelector);
  const columnHeaderFocus = useGridSelector(apiRef, gridFocusColumnHeaderSelector);
  const columnGroupHeaderFocus = useGridSelector(apiRef, unstable_gridFocusColumnGroupHeaderSelector);
  const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
  const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
  const columnMenuState = useGridSelector(apiRef, gridColumnMenuSelector);
  const columnVisibility = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
  const columnGroupsHeaderStructure = useGridSelector(apiRef, gridColumnGroupsHeaderStructureSelector);
  const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && cellTabIndexState === null);
  useEnhancedEffect(() => {
    apiRef.current.computeSizeAndPublishResizeEvent();
    const elementToObserve = rootRef.current;
    if (typeof ResizeObserver === 'undefined') {
      return () => {};
    }
    let animationFrame;
    const observer = new ResizeObserver(() => {
      // See https://github.com/mui/mui-x/issues/8733
      animationFrame = requestAnimationFrame(() => {
        apiRef.current.computeSizeAndPublishResizeEvent();
      });
    });
    if (elementToObserve) {
      observer.observe(elementToObserve);
    }
    return () => {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }
      if (elementToObserve) {
        observer.unobserve(elementToObserve);
      }
    };
  }, [apiRef]);
  const columnHeadersRef = React$1.useRef(null);
  const columnsContainerRef = React$1.useRef(null);
  const virtualScrollerRef = React$1.useRef(null);
  apiRef.current.register('private', {
    columnHeadersContainerElementRef: columnsContainerRef,
    columnHeadersElementRef: columnHeadersRef,
    virtualScrollerRef,
    mainElementRef: rootRef
  });
  const hasDimensions = !!apiRef.current.getRootDimensions();
  return /*#__PURE__*/jsxs(GridMainContainer, {
    ref: rootRef,
    children: [/*#__PURE__*/jsx(rootProps.slots.columnHeaders, _extends$c({
      ref: columnsContainerRef,
      innerRef: columnHeadersRef,
      visibleColumns: visibleColumns,
      filterColumnLookup: filterColumnLookup,
      sortColumnLookup: sortColumnLookup,
      columnPositions: columnPositions,
      columnHeaderTabIndexState: columnHeaderTabIndexState,
      columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
      columnHeaderFocus: columnHeaderFocus,
      columnGroupHeaderFocus: columnGroupHeaderFocus,
      densityFactor: densityFactor,
      headerGroupingMaxDepth: headerGroupingMaxDepth,
      columnMenuState: columnMenuState,
      columnVisibility: columnVisibility,
      columnGroupsHeaderStructure: columnGroupsHeaderStructure,
      hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, ColumnHeadersProps)), hasDimensions && /*#__PURE__*/jsx(VirtualScrollerComponent
    // The content is only rendered after dimensions are computed because
    // the lazy-loading hook is listening to `renderedRowsIntervalChange`,
    // but only does something if the dimensions are also available.
    // If this event is published while dimensions haven't been computed,
    // the `onFetchRows` prop won't be called during mount.
    , {
      ref: virtualScrollerRef
    }), children]
  });
}
process.env.NODE_ENV !== "production" ? GridBody.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  ColumnHeadersProps: PropTypes.object,
  VirtualScrollerComponent: PropTypes.elementType.isRequired
} : void 0;

function GridFooterPlaceholder() {
  var _rootProps$slotProps;
  const rootProps = useGridRootProps();
  if (rootProps.hideFooter) {
    return null;
  }
  return /*#__PURE__*/jsx(rootProps.slots.footer, _extends$c({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footer));
}

const GRID_ROOT_GROUP_ID = `auto-generated-group-node-root`;
const GRID_ID_AUTOGENERATED = Symbol('mui.id_autogenerated');
const buildRootGroup = () => ({
  type: 'group',
  id: GRID_ROOT_GROUP_ID,
  depth: -1,
  groupingField: null,
  groupingKey: null,
  isAutoGenerated: true,
  children: [],
  childrenFromPath: {},
  childrenExpanded: true,
  parent: null
});

/**
 * A helper function to check if the id provided is valid.
 * @param {GridRowId} id Id as [[GridRowId]].
 * @param {GridRowModel | Partial<GridRowModel>} row Row as [[GridRowModel]].
 * @param {string} detailErrorMessage A custom error message to display for invalid IDs
 */
function checkGridRowIdIsValid(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
  if (id == null) {
    throw new Error(['MUI: The data grid component requires all rows to have a unique `id` property.', 'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.', detailErrorMessage, JSON.stringify(row)].join('\n'));
  }
}
const getRowIdFromRowModel = (rowModel, getRowId, detailErrorMessage) => {
  const id = getRowId ? getRowId(rowModel) : rowModel.id;
  checkGridRowIdIsValid(id, rowModel, detailErrorMessage);
  return id;
};
const createRowsInternalCache = ({
  rows,
  getRowId,
  loading,
  rowCount
}) => {
  const updates = {
    type: 'full',
    rows: []
  };
  const dataRowIdToModelLookup = {};
  const dataRowIdToIdLookup = {};
  for (let i = 0; i < rows.length; i += 1) {
    const model = rows[i];
    const id = getRowIdFromRowModel(model, getRowId);
    dataRowIdToModelLookup[id] = model;
    dataRowIdToIdLookup[id] = id;
    updates.rows.push(id);
  }
  return {
    rowsBeforePartialUpdates: rows,
    loadingPropBeforePartialUpdates: loading,
    rowCountPropBeforePartialUpdates: rowCount,
    updates,
    dataRowIdToIdLookup,
    dataRowIdToModelLookup
  };
};
const getTopLevelRowCount = ({
  tree,
  rowCountProp = 0
}) => {
  const rootGroupNode = tree[GRID_ROOT_GROUP_ID];
  return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const getRowsStateFromCache = ({
  apiRef,
  rowCountProp = 0,
  loadingProp,
  previousTree,
  previousTreeDepths
}) => {
  const cache = apiRef.current.caches.rows;

  // 1. Apply the "rowTreeCreation" family processing.
  const {
    tree: unProcessedTree,
    treeDepths: unProcessedTreeDepths,
    dataRowIds: unProcessedDataRowIds,
    groupingName
  } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
    previousTree,
    previousTreeDepths,
    updates: cache.updates,
    dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
    dataRowIdToModelLookup: cache.dataRowIdToModelLookup
  });

  // 2. Apply the "hydrateRows" pipe-processing.
  const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
    tree: unProcessedTree,
    treeDepths: unProcessedTreeDepths,
    dataRowIdToIdLookup: cache.dataRowIdToIdLookup,
    dataRowIds: unProcessedDataRowIds,
    dataRowIdToModelLookup: cache.dataRowIdToModelLookup
  });

  // 3. Reset the cache updates
  apiRef.current.caches.rows.updates = {
    type: 'partial',
    actions: {
      insert: [],
      modify: [],
      remove: []
    },
    idToActionLookup: {}
  };
  return _extends$c({}, groupingParamsWithHydrateRows, {
    totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
    totalTopLevelRowCount: getTopLevelRowCount({
      tree: groupingParamsWithHydrateRows.tree,
      rowCountProp
    }),
    groupingName,
    loading: loadingProp
  });
};
const isAutoGeneratedRow = rowNode => rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const getTreeNodeDescendants = (tree, parentId, skipAutoGeneratedRows) => {
  const node = tree[parentId];
  if (node.type !== 'group') {
    return [];
  }
  const validDescendants = [];
  for (let i = 0; i < node.children.length; i += 1) {
    const child = node.children[i];
    if (!skipAutoGeneratedRows || !isAutoGeneratedRow(tree[child])) {
      validDescendants.push(child);
    }
    validDescendants.push(...getTreeNodeDescendants(tree, child, skipAutoGeneratedRows));
  }
  if (!skipAutoGeneratedRows && node.footerId != null) {
    validDescendants.push(node.footerId);
  }
  return validDescendants;
};
const updateCacheWithNewRows = ({
  previousCache,
  getRowId,
  updates
}) => {
  var _previousCache$update, _previousCache$update2, _previousCache$update3;
  if (previousCache.updates.type === 'full') {
    throw new Error('MUI: Unable to prepare a partial update if a full update is not applied yet');
  }

  // Remove duplicate updates.
  // A server can batch updates, and send several updates for the same row in one fn call.
  const uniqueUpdates = new Map();
  updates.forEach(update => {
    const id = getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
    if (uniqueUpdates.has(id)) {
      uniqueUpdates.set(id, _extends$c({}, uniqueUpdates.get(id), update));
    } else {
      uniqueUpdates.set(id, update);
    }
  });
  const partialUpdates = {
    type: 'partial',
    actions: {
      insert: [...((_previousCache$update = previousCache.updates.actions.insert) != null ? _previousCache$update : [])],
      modify: [...((_previousCache$update2 = previousCache.updates.actions.modify) != null ? _previousCache$update2 : [])],
      remove: [...((_previousCache$update3 = previousCache.updates.actions.remove) != null ? _previousCache$update3 : [])]
    },
    idToActionLookup: _extends$c({}, previousCache.updates.idToActionLookup)
  };
  const dataRowIdToModelLookup = _extends$c({}, previousCache.dataRowIdToModelLookup);
  const dataRowIdToIdLookup = _extends$c({}, previousCache.dataRowIdToIdLookup);
  const alreadyAppliedActionsToRemove = {
    insert: {},
    modify: {},
    remove: {}
  };

  // Depending on the action already applied to the data row,
  // We might want drop the already-applied-update.
  // For instance:
  // - if you delete then insert, then you don't want to apply the deletion in the tree.
  // - if you insert, then modify, then you just want to apply the insertion in the tree.
  uniqueUpdates.forEach((partialRow, id) => {
    const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];

    // Action === "delete"
    // eslint-disable-next-line no-underscore-dangle
    if (partialRow._action === 'delete') {
      // If the data row has been removed since the last state update,
      // Then do nothing.
      if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) {
        return;
      }

      // If the data row has been inserted / modified since the last state update,
      // Then drop this "insert" / "modify" update.
      if (actionAlreadyAppliedToRow != null) {
        alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
      }

      // Remove the data row from the lookups and add it to the "delete" update.
      partialUpdates.actions.remove.push(id);
      delete dataRowIdToModelLookup[id];
      delete dataRowIdToIdLookup[id];
      return;
    }
    const oldRow = dataRowIdToModelLookup[id];

    // Action === "modify"
    if (oldRow) {
      // If the data row has been removed since the last state update,
      // Then drop this "remove" update and add it to the "modify" update instead.
      if (actionAlreadyAppliedToRow === 'remove') {
        alreadyAppliedActionsToRemove.remove[id] = true;
        partialUpdates.actions.modify.push(id);
      }
      // If the date has not been inserted / modified since the last state update,
      // Then add it to the "modify" update (if it has been inserted it should just remain "inserted").
      else if (actionAlreadyAppliedToRow == null) {
        partialUpdates.actions.modify.push(id);
      }

      // Update the data row lookups.
      dataRowIdToModelLookup[id] = _extends$c({}, oldRow, partialRow);
      return;
    }

    // Action === "insert"
    // If the data row has been removed since the last state update,
    // Then drop the "remove" update and add it to the "insert" update instead.
    if (actionAlreadyAppliedToRow === 'remove') {
      alreadyAppliedActionsToRemove.remove[id] = true;
      partialUpdates.actions.insert.push(id);
    }
    // If the data row has not been inserted since the last state update,
    // Then add it to the "insert" update.
    // `actionAlreadyAppliedToRow` can't be equal to "modify", otherwise we would have an `oldRow` above.
    else if (actionAlreadyAppliedToRow == null) {
      partialUpdates.actions.insert.push(id);
    }

    // Update the data row lookups.
    dataRowIdToModelLookup[id] = partialRow;
    dataRowIdToIdLookup[id] = id;
  });
  const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
  for (let i = 0; i < actionTypeWithActionsToRemove.length; i += 1) {
    const actionType = actionTypeWithActionsToRemove[i];
    const idsToRemove = alreadyAppliedActionsToRemove[actionType];
    if (Object.keys(idsToRemove).length > 0) {
      partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter(id => !idsToRemove[id]);
    }
  }
  return {
    dataRowIdToModelLookup,
    dataRowIdToIdLookup,
    updates: partialUpdates,
    rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
    loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
    rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
  };
};
function calculatePinnedRowsHeight(apiRef) {
  var _pinnedRows$top, _pinnedRows$bottom;
  const pinnedRows = gridPinnedRowsSelector(apiRef);
  const topPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.reduce((acc, value) => {
    acc += apiRef.current.unstable_getRowHeight(value.id);
    return acc;
  }, 0)) || 0;
  const bottomPinnedRowsHeight = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.reduce((acc, value) => {
    acc += apiRef.current.unstable_getRowHeight(value.id);
    return acc;
  }, 0)) || 0;
  return {
    top: topPinnedRowsHeight,
    bottom: bottomPinnedRowsHeight
  };
}
function getMinimalContentHeight(apiRef, rowHeight) {
  const densityFactor = gridDensityFactorSelector(apiRef);
  return `var(--DataGrid-overlayHeight, ${2 * Math.floor(rowHeight * densityFactor)}px)`;
}

const GridOverlayWrapperRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'OverlayWrapper',
  shouldForwardProp: prop => prop !== 'overlayType',
  overridesResolver: (props, styles) => styles.overlayWrapper
})(({
  overlayType
}) => ({
  position: 'sticky',
  // To stay in place while scrolling
  top: 0,
  left: 0,
  width: 0,
  // To stay above the content instead of shifting it down
  height: 0,
  // To stay above the content instead of shifting it down
  zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
  : 4 // Should be above pinned columns and detail panel
}));

const GridOverlayWrapperInner = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'OverlayWrapperInner',
  shouldForwardProp: prop => prop !== 'overlayType',
  overridesResolver: (props, styles) => styles.overlayWrapperInner
})({});
const useUtilityClasses$H = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['overlayWrapper'],
    inner: ['overlayWrapperInner']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridOverlayWrapper(props) {
  var _viewportInnerSize$he, _viewportInnerSize$wi;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const [viewportInnerSize, setViewportInnerSize] = React$1.useState(() => {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    return (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize) != null ? _apiRef$current$getRo : null;
  });
  const handleViewportSizeChange = React$1.useCallback(() => {
    var _apiRef$current$getRo3, _apiRef$current$getRo4;
    setViewportInnerSize((_apiRef$current$getRo3 = (_apiRef$current$getRo4 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo4.viewportInnerSize) != null ? _apiRef$current$getRo3 : null);
  }, [apiRef]);
  useEnhancedEffect(() => {
    return apiRef.current.subscribeEvent('viewportInnerSizeChange', handleViewportSizeChange);
  }, [apiRef, handleViewportSizeChange]);
  let height = (_viewportInnerSize$he = viewportInnerSize == null ? void 0 : viewportInnerSize.height) != null ? _viewportInnerSize$he : 0;
  if (rootProps.autoHeight && height === 0) {
    height = getMinimalContentHeight(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
  }

  const classes = useUtilityClasses$H(_extends$c({}, props, {
    classes: rootProps.classes
  }));
  if (!viewportInnerSize) {
    return null;
  }
  return /*#__PURE__*/jsx(GridOverlayWrapperRoot, {
    className: clsx(classes.root),
    overlayType: props.overlayType,
    children: /*#__PURE__*/jsx(GridOverlayWrapperInner, _extends$c({
      className: clsx(classes.inner),
      style: {
        height,
        width: (_viewportInnerSize$wi = viewportInnerSize == null ? void 0 : viewportInnerSize.width) != null ? _viewportInnerSize$wi : 0
      }
    }, props))
  });
}
process.env.NODE_ENV !== "production" ? GridOverlayWrapper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  overlayType: PropTypes.string.isRequired
} : void 0;
function GridOverlays() {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
  const visibleRowCount = useGridSelector(apiRef, gridExpandedRowCountSelector);
  const loading = useGridSelector(apiRef, gridRowsLoadingSelector);
  const showNoRowsOverlay = !loading && totalRowCount === 0;
  const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
  let overlay = null;
  let overlayType = '';
  if (showNoRowsOverlay) {
    var _rootProps$slotProps;
    overlay = /*#__PURE__*/jsx(rootProps.slots.noRowsOverlay, _extends$c({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.noRowsOverlay));
    overlayType = 'noRowsOverlay';
  }
  if (showNoResultsOverlay) {
    var _rootProps$slotProps2;
    overlay = /*#__PURE__*/jsx(rootProps.slots.noResultsOverlay, _extends$c({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.noResultsOverlay));
    overlayType = 'noResultsOverlay';
  }
  if (loading) {
    var _rootProps$slotProps3;
    overlay = /*#__PURE__*/jsx(rootProps.slots.loadingOverlay, _extends$c({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.loadingOverlay));
    overlayType = 'loadingOverlay';
  }
  if (overlay === null) {
    return null;
  }
  return /*#__PURE__*/jsx(GridOverlayWrapper, {
    overlayType: overlayType,
    children: overlay
  });
}

function fastMemo(component) {
  return /*#__PURE__*/React$1.memo(component, fastObjectShallowCompare);
}

// Based on https://stackoverflow.com/a/59518678
let cachedSupportsPreventScroll;
function doesSupportPreventScroll() {
  if (cachedSupportsPreventScroll === undefined) {
    document.createElement('div').focus({
      get preventScroll() {
        cachedSupportsPreventScroll = true;
        return false;
      }
    });
  }
  return cachedSupportsPreventScroll;
}

var GridEditModes = /*#__PURE__*/function (GridEditModes) {
  GridEditModes["Cell"] = "cell";
  GridEditModes["Row"] = "row";
  return GridEditModes;
}(GridEditModes || {});
var GridCellModes = /*#__PURE__*/function (GridCellModes) {
  GridCellModes["Edit"] = "edit";
  GridCellModes["View"] = "view";
  return GridCellModes;
}(GridCellModes || {});
var GridRowModes = /*#__PURE__*/function (GridRowModes) {
  GridRowModes["Edit"] = "edit";
  GridRowModes["View"] = "view";
  return GridRowModes;
}(GridRowModes || {});

/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */
var GridLogicOperator = /*#__PURE__*/function (GridLogicOperator) {
  GridLogicOperator["And"] = "and";
  GridLogicOperator["Or"] = "or";
  return GridLogicOperator;
}(GridLogicOperator || {});

/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */
var GridCellEditStartReasons = /*#__PURE__*/function (GridCellEditStartReasons) {
  GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
  GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
  GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
  GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
  return GridCellEditStartReasons;
}(GridCellEditStartReasons || {});
/**
 * Params passed to the `cellEditStart` event.
 */
var GridCellEditStopReasons = /*#__PURE__*/function (GridCellEditStopReasons) {
  GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
  GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
  GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
  GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
  GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
  return GridCellEditStopReasons;
}(GridCellEditStopReasons || {});

/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master detail](/x/react-data-grid/master-detail/)
 */
/**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */
/**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */
/**
 * The getRowHeight return value.
 */
var GridRowEditStartReasons = /*#__PURE__*/function (GridRowEditStartReasons) {
  GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
  GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
  GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
  GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
  return GridRowEditStartReasons;
}(GridRowEditStartReasons || {});
/**
 * Params passed to the `rowEditStart` event.
 */
var GridRowEditStopReasons = /*#__PURE__*/function (GridRowEditStopReasons) {
  GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
  GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
  GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
  GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
  GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
  return GridRowEditStopReasons;
}(GridRowEditStopReasons || {});

function isLeaf(node) {
  return node.field !== undefined;
}

/**
 * A function used to process headerClassName params.
 */

/**
 * The union type representing the [[GridColDef]] column header class type.
 */

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function findParentElementFromClassName(elem, className) {
  return elem.closest(`.${className}`);
}
function escapeOperandAttributeSelector(operand) {
  return operand.replace(/["\\]/g, '\\$&');
}
function getGridColumnHeaderElement(root, field) {
  return root.querySelector(`[role="columnheader"][data-field="${escapeOperandAttributeSelector(field)}"]`);
}
function getGridRowElementSelector(id) {
  return `.${gridClasses.row}[data-id="${escapeOperandAttributeSelector(String(id))}"]`;
}
function getGridRowElement(root, id) {
  return root.querySelector(getGridRowElementSelector(id));
}
function getGridCellElement(root, {
  id,
  field
}) {
  const rowSelector = getGridRowElementSelector(id);
  const cellSelector = `.${gridClasses.cell}[data-field="${escapeOperandAttributeSelector(field)}"]`;
  const selector = `${rowSelector} ${cellSelector}`;
  return root.querySelector(selector);
}

function useGridApiMethod(privateApiRef, apiMethods, visibility) {
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    isFirstRender.current = false;
    privateApiRef.current.register(visibility, apiMethods);
  }, [privateApiRef, visibility, apiMethods]);
  if (isFirstRender.current) {
    privateApiRef.current.register(visibility, apiMethods);
  }
}

class MissingRowIdError extends Error {}

/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */
function useGridParamsApi(apiRef, props) {
  const {
    getRowId
  } = props;
  const getColumnHeaderParams = React$1.useCallback(field => ({
    field,
    colDef: apiRef.current.getColumn(field)
  }), [apiRef]);
  const getRowParams = React$1.useCallback(id => {
    const row = apiRef.current.getRow(id);
    if (!row) {
      throw new MissingRowIdError(`No row with id #${id} found`);
    }
    const params = {
      id,
      columns: apiRef.current.getAllColumns(),
      row
    };
    return params;
  }, [apiRef]);
  const getBaseCellParams = React$1.useCallback((id, field) => {
    const row = apiRef.current.getRow(id);
    const rowNode = apiRef.current.getRowNode(id);
    if (!row || !rowNode) {
      throw new MissingRowIdError(`No row with id #${id} found`);
    }
    const cellFocus = gridFocusCellSelector(apiRef);
    const cellTabIndex = gridTabIndexCellSelector(apiRef);
    const params = {
      id,
      field,
      row,
      rowNode,
      value: row[field],
      colDef: apiRef.current.getColumn(field),
      cellMode: apiRef.current.getCellMode(id, field),
      api: apiRef.current,
      hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
      tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
    };
    return params;
  }, [apiRef]);
  const getCellParams = React$1.useCallback((id, field) => {
    const colDef = apiRef.current.getColumn(field);
    const value = apiRef.current.getCellValue(id, field);
    const row = apiRef.current.getRow(id);
    const rowNode = apiRef.current.getRowNode(id);
    if (!row || !rowNode) {
      throw new MissingRowIdError(`No row with id #${id} found`);
    }
    const cellFocus = gridFocusCellSelector(apiRef);
    const cellTabIndex = gridTabIndexCellSelector(apiRef);
    const params = {
      id,
      field,
      row,
      rowNode,
      colDef,
      cellMode: apiRef.current.getCellMode(id, field),
      hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
      tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
      value,
      formattedValue: value,
      isEditable: false
    };
    if (colDef && colDef.valueFormatter) {
      params.formattedValue = colDef.valueFormatter({
        id,
        field: params.field,
        value: params.value,
        api: apiRef.current
      });
    }
    params.isEditable = colDef && apiRef.current.isCellEditable(params);
    return params;
  }, [apiRef]);
  const getCellValue = React$1.useCallback((id, field) => {
    const colDef = apiRef.current.getColumn(field);
    if (!colDef || !colDef.valueGetter) {
      const rowModel = apiRef.current.getRow(id);
      if (!rowModel) {
        throw new MissingRowIdError(`No row with id #${id} found`);
      }
      return rowModel[field];
    }
    return colDef.valueGetter(getBaseCellParams(id, field));
  }, [apiRef, getBaseCellParams]);
  const getRowValue = React$1.useCallback((row, colDef) => {
    var _getRowId;
    const id = GRID_ID_AUTOGENERATED in row ? row[GRID_ID_AUTOGENERATED] : (_getRowId = getRowId == null ? void 0 : getRowId(row)) != null ? _getRowId : row.id;
    const field = colDef.field;
    if (!colDef || !colDef.valueGetter) {
      return row[field];
    }
    return colDef.valueGetter(getBaseCellParams(id, field));
  }, [getBaseCellParams, getRowId]);
  const getRowFormattedValue = React$1.useCallback((row, colDef) => {
    var _ref;
    const value = getRowValue(row, colDef);
    if (!colDef || !colDef.valueFormatter) {
      return value;
    }
    const id = (_ref = getRowId ? getRowId(row) : row.id) != null ? _ref : row[GRID_ID_AUTOGENERATED];
    const field = colDef.field;
    return colDef.valueFormatter({
      id,
      field,
      value,
      api: apiRef.current
    });
  }, [apiRef, getRowId, getRowValue]);
  const getColumnHeaderElement = React$1.useCallback(field => {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridColumnHeaderElement(apiRef.current.rootElementRef.current, field);
  }, [apiRef]);
  const getRowElement = React$1.useCallback(id => {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridRowElement(apiRef.current.rootElementRef.current, id);
  }, [apiRef]);
  const getCellElement = React$1.useCallback((id, field) => {
    if (!apiRef.current.rootElementRef.current) {
      return null;
    }
    return getGridCellElement(apiRef.current.rootElementRef.current, {
      id,
      field
    });
  }, [apiRef]);
  const paramsApi = {
    getCellValue,
    getCellParams,
    getCellElement,
    getRowValue,
    getRowFormattedValue,
    getRowParams,
    getRowElement,
    getColumnHeaderParams,
    getColumnHeaderElement
  };
  useGridApiMethod(apiRef, paramsApi, 'public');
}

const _excluded$10 = ["changeReason", "unstable_updateValueOnRender"],
  _excluded2$6 = ["align", "children", "editCellState", "colIndex", "column", "cellMode", "field", "formattedValue", "hasFocus", "height", "isEditable", "isSelected", "rowId", "tabIndex", "value", "width", "className", "showRightBorder", "extendRowFullWidth", "row", "colSpan", "disableDragEvents", "isNotVisible", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"],
  _excluded3$1 = ["column", "rowId", "editCellState", "align", "children", "colIndex", "height", "width", "className", "showRightBorder", "extendRowFullWidth", "row", "colSpan", "disableDragEvents", "isNotVisible", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"],
  _excluded4 = ["changeReason", "unstable_updateValueOnRender"];
const EMPTY_CELL_PARAMS = {
  id: -1,
  field: '__unset__',
  row: {},
  rowNode: {
    id: -1,
    depth: 0,
    type: 'leaf',
    parent: -1,
    groupingKey: null
  },
  colDef: {
    type: 'string',
    field: '__unset__',
    computedWidth: 0
  },
  cellMode: GridCellModes.View,
  hasFocus: false,
  tabIndex: -1,
  value: null,
  formattedValue: '__unset__',
  isEditable: false,
  api: {}
};
const useUtilityClasses$G = ownerState => {
  const {
    align,
    showRightBorder,
    isEditable,
    isSelected,
    isSelectionMode,
    classes
  } = ownerState;
  const slots = {
    root: ['cell', `cell--text${capitalize(align)}`, isEditable && 'cell--editable', isSelected && 'selected', showRightBorder && 'cell--withRightBorder', isSelectionMode && !isEditable && 'cell--selectionMode', 'withBorderColor'],
    content: ['cellContent']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
let warnedOnce = false;

// GridCellWrapper is a compatibility layer for the V6 cell slot. If we can use the more efficient
// `GridCellV7`, we should. That component is a merge of `GridCellWrapper` and `GridCell`.
// TODO(v7): Remove the wrapper & cellV6 and use the cellV7 exclusively.
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const GridCellWrapper = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  const {
    column,
    rowId,
    editCellState
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const field = column.field;
  const cellParamsWithAPI = useGridSelector(apiRef, () => {
    // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
    // associated with `rowId`/`fieldId`, but this selector runs after the state has been
    // updated, while `rowId`/`fieldId` reference an entry in the old state.
    try {
      const cellParams = apiRef.current.getCellParams(rowId, field);
      const result = cellParams;
      result.api = apiRef.current;
      return result;
    } catch (e) {
      if (e instanceof MissingRowIdError) {
        return EMPTY_CELL_PARAMS;
      }
      throw e;
    }
  }, objectShallowCompare);
  const isSelected = useGridSelector(apiRef, () => apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
    id: rowId,
    field
  }));
  if (cellParamsWithAPI === EMPTY_CELL_PARAMS) {
    return null;
  }
  const {
    cellMode,
    hasFocus,
    isEditable,
    value,
    formattedValue
  } = cellParamsWithAPI;
  const managesOwnFocus = column.type === 'actions';
  const tabIndex = (cellMode === 'view' || !isEditable) && !managesOwnFocus ? cellParamsWithAPI.tabIndex : -1;
  const {
    classes: rootClasses,
    getCellClassName
  } = rootProps;
  const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
    id: rowId,
    field
  });
  if (column.cellClassName) {
    classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
  }
  if (getCellClassName) {
    classNames.push(getCellClassName(cellParamsWithAPI));
  }
  let children;
  if (editCellState == null && column.renderCell) {
    children = column.renderCell(cellParamsWithAPI);
    classNames.push(gridClasses['cell--withRenderer']);
    classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
  }
  if (editCellState != null && column.renderEditCell) {
    const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const editCellStateRest = _objectWithoutPropertiesLoose$b(editCellState, _excluded$10);
    const params = _extends$c({}, cellParamsWithAPI, {
      row: updatedRow
    }, editCellStateRest);
    children = column.renderEditCell(params);
    classNames.push(gridClasses['cell--editing']);
    classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
  }
  const {
    slots
  } = rootProps;
  const CellComponent = slots.cell;
  const cellProps = _extends$c({}, props, {
    ref,
    field,
    formattedValue,
    hasFocus,
    isEditable,
    isSelected,
    value,
    cellMode,
    children,
    tabIndex,
    className: clsx(classNames)
  });
  return /*#__PURE__*/React$1.createElement(CellComponent, cellProps);
});
const GridCell = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  var _rootProps$experiment, _rootProps$experiment2;
  const {
      align,
      children: childrenProp,
      colIndex,
      column,
      cellMode,
      field,
      formattedValue,
      hasFocus,
      height,
      isEditable,
      isSelected,
      rowId,
      tabIndex,
      value,
      width,
      className,
      showRightBorder,
      colSpan,
      disableDragEvents,
      isNotVisible,
      onClick,
      onDoubleClick,
      onMouseDown,
      onMouseUp,
      onMouseOver,
      onKeyDown,
      onKeyUp,
      onDragEnter,
      onDragOver
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded2$6);
  const valueToRender = formattedValue == null ? value : formattedValue;
  const cellRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, cellRef);
  const focusElementRef = React$1.useRef(null);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = {
    align,
    showRightBorder,
    isEditable,
    classes: rootProps.classes,
    isSelected
  };
  const classes = useUtilityClasses$G(ownerState);
  const publishMouseUp = React$1.useCallback(eventName => event => {
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (onMouseUp) {
      onMouseUp(event);
    }
  }, [apiRef, field, onMouseUp, rowId]);
  const publishMouseDown = React$1.useCallback(eventName => event => {
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (onMouseDown) {
      onMouseDown(event);
    }
  }, [apiRef, field, onMouseDown, rowId]);
  const publish = React$1.useCallback((eventName, propHandler) => event => {
    // The row might have been deleted during the click
    if (!apiRef.current.getRow(rowId)) {
      return;
    }
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (propHandler) {
      propHandler(event);
    }
  }, [apiRef, field, rowId]);
  const style = React$1.useMemo(() => {
    if (isNotVisible) {
      return {
        padding: 0,
        opacity: 0,
        width: 0,
        border: 0
      };
    }
    const cellStyle = {
      minWidth: width,
      maxWidth: width,
      minHeight: height,
      maxHeight: height === 'auto' ? 'none' : height // max-height doesn't support "auto"
    };

    return cellStyle;
  }, [width, height, isNotVisible]);
  React$1.useEffect(() => {
    if (!hasFocus || cellMode === GridCellModes.Edit) {
      return;
    }
    const doc = ownerDocument(apiRef.current.rootElementRef.current);
    if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
      const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
      const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
      if (doesSupportPreventScroll()) {
        elementToFocus.focus({
          preventScroll: true
        });
      } else {
        const scrollPosition = apiRef.current.getScrollPosition();
        elementToFocus.focus();
        apiRef.current.scroll(scrollPosition);
      }
    }
  }, [hasFocus, cellMode, apiRef]);
  let handleFocus = other.onFocus;
  if (process.env.NODE_ENV === 'test' && (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.warnIfFocusStateIsNotSynced) {
    handleFocus = event => {
      const focusedCell = gridFocusCellSelector(apiRef);
      if ((focusedCell == null ? void 0 : focusedCell.id) === rowId && focusedCell.field === field) {
        if (typeof other.onFocus === 'function') {
          other.onFocus(event);
        }
        return;
      }
      if (!warnedOnce) {
        console.warn([`MUI: The cell with id=${rowId} and field=${field} received focus.`, `According to the state, the focus should be at id=${focusedCell == null ? void 0 : focusedCell.id}, field=${focusedCell == null ? void 0 : focusedCell.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", 'Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state.'].join('\n'));
        warnedOnce = true;
      }
    };
  }
  const managesOwnFocus = column.type === 'actions';
  let children = childrenProp;
  if (children === undefined) {
    const valueString = valueToRender == null ? void 0 : valueToRender.toString();
    children = /*#__PURE__*/jsx("div", {
      className: classes.content,
      title: valueString,
      role: "presentation",
      children: valueString
    });
  }
  if ( /*#__PURE__*/React$1.isValidElement(children) && managesOwnFocus) {
    children = /*#__PURE__*/React$1.cloneElement(children, {
      focusElementRef
    });
  }
  const draggableEventHandlers = disableDragEvents ? null : {
    onDragEnter: publish('cellDragEnter', onDragEnter),
    onDragOver: publish('cellDragOver', onDragOver)
  };
  const ariaV7 = (_rootProps$experiment2 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment2.ariaV7;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsx("div", _extends$c({
      ref: handleRef,
      className: clsx(className, classes.root),
      role: ariaV7 ? 'gridcell' : 'cell',
      "data-field": field,
      "data-colindex": colIndex,
      "aria-colindex": colIndex + 1,
      "aria-colspan": colSpan,
      style: style,
      tabIndex: tabIndex,
      onClick: publish('cellClick', onClick),
      onDoubleClick: publish('cellDoubleClick', onDoubleClick),
      onMouseOver: publish('cellMouseOver', onMouseOver),
      onMouseDown: publishMouseDown('cellMouseDown'),
      onMouseUp: publishMouseUp('cellMouseUp'),
      onKeyDown: publish('cellKeyDown', onKeyDown),
      onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
      onFocus: handleFocus,
      children: children
    }))
  );
});
const MemoizedCellWrapper = fastMemo(GridCellWrapper);
process.env.NODE_ENV !== "production" ? GridCellWrapper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.oneOf(['center', 'left', 'right']),
  className: PropTypes.string,
  colIndex: PropTypes.number,
  colSpan: PropTypes.number,
  column: PropTypes.object,
  disableDragEvents: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragOver: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showRightBorder: PropTypes.bool,
  width: PropTypes.number
} : void 0;
process.env.NODE_ENV !== "production" ? GridCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.oneOf(['center', 'left', 'right']),
  cellMode: PropTypes.oneOf(['edit', 'view']),
  children: PropTypes.node,
  className: PropTypes.string,
  colIndex: PropTypes.number,
  colSpan: PropTypes.number,
  column: PropTypes.object,
  disableDragEvents: PropTypes.bool,
  editCellState: PropTypes.shape({
    changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
    isProcessingProps: PropTypes.bool,
    isValidating: PropTypes.bool,
    value: PropTypes.any
  }),
  isNotVisible: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragOver: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showRightBorder: PropTypes.bool,
  width: PropTypes.number
} : void 0;
const GridCellV7 = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  var _rootProps$unstable_c, _rootProps$experiment3, _rootProps$experiment4;
  const {
      column,
      rowId,
      editCellState,
      align,
      colIndex,
      height,
      width,
      className,
      showRightBorder,
      colSpan,
      disableDragEvents,
      isNotVisible,
      onClick,
      onDoubleClick,
      onMouseDown,
      onMouseUp,
      onMouseOver,
      onKeyDown,
      onKeyUp,
      onDragEnter,
      onDragOver
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded3$1);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const field = column.field;
  const cellParamsWithAPI = useGridSelector(apiRef, () => {
    // This is required because `.getCellParams` tries to get the `state.rows.tree` entry
    // associated with `rowId`/`fieldId`, but this selector runs after the state has been
    // updated, while `rowId`/`fieldId` reference an entry in the old state.
    try {
      const cellParams = apiRef.current.getCellParams(rowId, field);
      const result = cellParams;
      result.api = apiRef.current;
      return result;
    } catch (e) {
      if (e instanceof MissingRowIdError) {
        return EMPTY_CELL_PARAMS;
      }
      throw e;
    }
  }, objectShallowCompare);
  const isSelected = useGridSelector(apiRef, () => apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
    id: rowId,
    field
  }));
  const {
    cellMode,
    hasFocus,
    isEditable,
    value,
    formattedValue
  } = cellParamsWithAPI;
  const managesOwnFocus = column.type === 'actions';
  const tabIndex = (cellMode === 'view' || !isEditable) && !managesOwnFocus ? cellParamsWithAPI.tabIndex : -1;
  const {
    classes: rootClasses,
    getCellClassName
  } = rootProps;
  const classNames = apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
    id: rowId,
    field
  });
  if (column.cellClassName) {
    classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParamsWithAPI) : column.cellClassName);
  }
  if (getCellClassName) {
    classNames.push(getCellClassName(cellParamsWithAPI));
  }
  const valueToRender = formattedValue == null ? value : formattedValue;
  const cellRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, cellRef);
  const focusElementRef = React$1.useRef(null);
  // @ts-expect-error To access `unstable_cellSelection` flag as it's a `premium` feature
  const isSelectionMode = (_rootProps$unstable_c = rootProps.unstable_cellSelection) != null ? _rootProps$unstable_c : false;
  const ownerState = {
    align,
    showRightBorder,
    isEditable,
    classes: rootProps.classes,
    isSelected,
    isSelectionMode
  };
  const classes = useUtilityClasses$G(ownerState);
  const publishMouseUp = React$1.useCallback(eventName => event => {
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (onMouseUp) {
      onMouseUp(event);
    }
  }, [apiRef, field, onMouseUp, rowId]);
  const publishMouseDown = React$1.useCallback(eventName => event => {
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (onMouseDown) {
      onMouseDown(event);
    }
  }, [apiRef, field, onMouseDown, rowId]);
  const publish = React$1.useCallback((eventName, propHandler) => event => {
    // The row might have been deleted during the click
    if (!apiRef.current.getRow(rowId)) {
      return;
    }
    const params = apiRef.current.getCellParams(rowId, field || '');
    apiRef.current.publishEvent(eventName, params, event);
    if (propHandler) {
      propHandler(event);
    }
  }, [apiRef, field, rowId]);
  const style = React$1.useMemo(() => {
    if (isNotVisible) {
      return {
        padding: 0,
        opacity: 0,
        width: 0,
        border: 0
      };
    }
    const cellStyle = {
      minWidth: width,
      maxWidth: width,
      minHeight: height,
      maxHeight: height === 'auto' ? 'none' : height // max-height doesn't support "auto"
    };

    return cellStyle;
  }, [width, height, isNotVisible]);
  React$1.useEffect(() => {
    if (!hasFocus || cellMode === GridCellModes.Edit) {
      return;
    }
    const doc = ownerDocument(apiRef.current.rootElementRef.current);
    if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
      const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
      const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
      if (doesSupportPreventScroll()) {
        elementToFocus.focus({
          preventScroll: true
        });
      } else {
        const scrollPosition = apiRef.current.getScrollPosition();
        elementToFocus.focus();
        apiRef.current.scroll(scrollPosition);
      }
    }
  }, [hasFocus, cellMode, apiRef]);
  if (cellParamsWithAPI === EMPTY_CELL_PARAMS) {
    return null;
  }
  let handleFocus = other.onFocus;
  if (process.env.NODE_ENV === 'test' && (_rootProps$experiment3 = rootProps.experimentalFeatures) != null && _rootProps$experiment3.warnIfFocusStateIsNotSynced) {
    handleFocus = event => {
      const focusedCell = gridFocusCellSelector(apiRef);
      if ((focusedCell == null ? void 0 : focusedCell.id) === rowId && focusedCell.field === field) {
        if (typeof other.onFocus === 'function') {
          other.onFocus(event);
        }
        return;
      }
      if (!warnedOnce) {
        console.warn([`MUI: The cell with id=${rowId} and field=${field} received focus.`, `According to the state, the focus should be at id=${focusedCell == null ? void 0 : focusedCell.id}, field=${focusedCell == null ? void 0 : focusedCell.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", 'Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state.'].join('\n'));
        warnedOnce = true;
      }
    };
  }
  let children;
  if (editCellState == null && column.renderCell) {
    children = column.renderCell(cellParamsWithAPI);
    classNames.push(gridClasses['cell--withRenderer']);
    classNames.push(rootClasses == null ? void 0 : rootClasses['cell--withRenderer']);
  }
  if (editCellState != null && column.renderEditCell) {
    const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const editCellStateRest = _objectWithoutPropertiesLoose$b(editCellState, _excluded4);
    const params = _extends$c({}, cellParamsWithAPI, {
      row: updatedRow
    }, editCellStateRest);
    children = column.renderEditCell(params);
    classNames.push(gridClasses['cell--editing']);
    classNames.push(rootClasses == null ? void 0 : rootClasses['cell--editing']);
  }
  if (children === undefined) {
    const valueString = valueToRender == null ? void 0 : valueToRender.toString();
    children = /*#__PURE__*/jsx("div", {
      className: classes.content,
      title: valueString,
      role: "presentation",
      children: valueString
    });
  }
  if ( /*#__PURE__*/React$1.isValidElement(children) && managesOwnFocus) {
    children = /*#__PURE__*/React$1.cloneElement(children, {
      focusElementRef
    });
  }
  const draggableEventHandlers = disableDragEvents ? null : {
    onDragEnter: publish('cellDragEnter', onDragEnter),
    onDragOver: publish('cellDragOver', onDragOver)
  };
  const ariaV7 = (_rootProps$experiment4 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment4.ariaV7;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsx("div", _extends$c({
      ref: handleRef,
      className: clsx(className, classNames, classes.root),
      role: ariaV7 ? 'gridcell' : 'cell',
      "data-field": field,
      "data-colindex": colIndex,
      "aria-colindex": colIndex + 1,
      "aria-colspan": colSpan,
      style: style,
      tabIndex: tabIndex,
      onClick: publish('cellClick', onClick),
      onDoubleClick: publish('cellDoubleClick', onDoubleClick),
      onMouseOver: publish('cellMouseOver', onMouseOver),
      onMouseDown: publishMouseDown('cellMouseDown'),
      onMouseUp: publishMouseUp('cellMouseUp'),
      onKeyDown: publish('cellKeyDown', onKeyDown),
      onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
      onFocus: handleFocus,
      children: children
    }))
  );
});
process.env.NODE_ENV !== "production" ? GridCellV7.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
  className: PropTypes.string,
  colIndex: PropTypes.number.isRequired,
  colSpan: PropTypes.number,
  column: PropTypes.object.isRequired,
  disableDragEvents: PropTypes.bool,
  editCellState: PropTypes.shape({
    changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
    isProcessingProps: PropTypes.bool,
    isValidating: PropTypes.bool,
    value: PropTypes.any
  }),
  height: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]).isRequired,
  isNotVisible: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragOver: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  showRightBorder: PropTypes.bool,
  width: PropTypes.number.isRequired
} : void 0;
const MemoizedGridCellV7 = fastMemo(GridCellV7);

const _excluded$$ = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex"];
const useUtilityClasses$F = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['booleanCell']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridBooleanCellRaw(props) {
  const {
      value
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$$);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes
  };
  const classes = useUtilityClasses$F(ownerState);
  const Icon = React$1.useMemo(() => value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [rootProps.slots.booleanCellFalseIcon, rootProps.slots.booleanCellTrueIcon, value]);
  return /*#__PURE__*/jsx(Icon, _extends$c({
    fontSize: "small",
    className: classes.root,
    titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
    "data-value": Boolean(value)
  }, other));
}
process.env.NODE_ENV !== "production" ? GridBooleanCellRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const GridBooleanCell = /*#__PURE__*/React$1.memo(GridBooleanCellRaw);
const renderBooleanCell = params => {
  if (isAutoGeneratedRow(params.rowNode)) {
    return '';
  }
  return /*#__PURE__*/jsx(GridBooleanCell, _extends$c({}, params));
};

const _excluded$_ = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange"];
const useUtilityClasses$E = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['editBooleanCell']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridEditBooleanCell(props) {
  var _rootProps$slotProps;
  const {
      id: idProp,
      value,
      field,
      className,
      hasFocus,
      onValueChange
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$_);
  const apiRef = useGridApiContext();
  const inputRef = React$1.useRef(null);
  const id = useId();
  const [valueState, setValueState] = React$1.useState(value);
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes
  };
  const classes = useUtilityClasses$E(ownerState);
  const handleChange = React$1.useCallback(async event => {
    const newValue = event.target.checked;
    if (onValueChange) {
      await onValueChange(event, newValue);
    }
    setValueState(newValue);
    await apiRef.current.setEditCellValue({
      id: idProp,
      field,
      value: newValue
    }, event);
  }, [apiRef, field, idProp, onValueChange]);
  React$1.useEffect(() => {
    setValueState(value);
  }, [value]);
  useEnhancedEffect(() => {
    if (hasFocus) {
      inputRef.current.focus();
    }
  }, [hasFocus]);
  return /*#__PURE__*/jsx("label", _extends$c({
    htmlFor: id,
    className: clsx(classes.root, className)
  }, other, {
    children: /*#__PURE__*/jsx(rootProps.slots.baseCheckbox, _extends$c({
      id: id,
      inputRef: inputRef,
      checked: Boolean(valueState),
      onChange: handleChange,
      size: "small"
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox))
  }));
}
process.env.NODE_ENV !== "production" ? GridEditBooleanCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const renderEditBooleanCell = params => /*#__PURE__*/jsx(GridEditBooleanCell, _extends$c({}, params));

const _excluded$Z = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"];
const StyledInputBase = styled$3(InputBase)({
  fontSize: 'inherit'
});
const useUtilityClasses$D = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['editInputCell']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridEditDateCell(props) {
  const {
      id,
      value: valueProp,
      field,
      colDef,
      hasFocus,
      inputProps,
      onValueChange
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$Z);
  const isDateTime = colDef.type === 'dateTime';
  const apiRef = useGridApiContext();
  const inputRef = React$1.useRef();
  const valueTransformed = React$1.useMemo(() => {
    let parsedDate;
    if (valueProp == null) {
      parsedDate = null;
    } else if (valueProp instanceof Date) {
      parsedDate = valueProp;
    } else {
      parsedDate = new Date((valueProp != null ? valueProp : '').toString());
    }
    let formattedDate;
    if (parsedDate == null || Number.isNaN(parsedDate.getTime())) {
      formattedDate = '';
    } else {
      const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60 * 1000);
      formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
    }
    return {
      parsed: parsedDate,
      formatted: formattedDate
    };
  }, [valueProp, isDateTime]);
  const [valueState, setValueState] = React$1.useState(valueTransformed);
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes
  };
  const classes = useUtilityClasses$D(ownerState);
  const hasUpdatedEditValueOnMount = React$1.useRef(false);
  const parseValueToDate = React$1.useCallback(value => {
    if (value === '') {
      return null;
    }
    const [date, time] = value.split('T');
    const [year, month, day] = date.split('-');
    const parsedDate = new Date();
    parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
    parsedDate.setHours(0, 0, 0, 0);
    if (time) {
      const [hours, minutes] = time.split(':');
      parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
    }
    return parsedDate;
  }, []);
  const handleChange = React$1.useCallback(async event => {
    const newFormattedDate = event.target.value;
    const newParsedDate = parseValueToDate(newFormattedDate);
    if (onValueChange) {
      await onValueChange(event, newParsedDate);
    }
    setValueState({
      parsed: newParsedDate,
      formatted: newFormattedDate
    });
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newParsedDate
    }, event);
  }, [apiRef, field, id, onValueChange, parseValueToDate]);
  React$1.useEffect(() => {
    setValueState(state => {
      var _valueTransformed$par, _state$parsed;
      if (valueTransformed.parsed !== state.parsed && ((_valueTransformed$par = valueTransformed.parsed) == null ? void 0 : _valueTransformed$par.getTime()) !== ((_state$parsed = state.parsed) == null ? void 0 : _state$parsed.getTime())) {
        return valueTransformed;
      }
      return state;
    });
  }, [valueTransformed]);
  useEnhancedEffect(() => {
    if (hasFocus) {
      inputRef.current.focus();
    }
  }, [hasFocus]);
  const meta = apiRef.current.unstable_getEditCellMeta(id, field);
  const handleInputRef = el => {
    inputRef.current = el;
    if (meta != null && meta.unstable_updateValueOnRender && !hasUpdatedEditValueOnMount.current) {
      const inputValue = inputRef.current.value;
      const parsedDate = parseValueToDate(inputValue);
      setValueState({
        parsed: parsedDate,
        formatted: inputValue
      });
      apiRef.current.setEditCellValue({
        id,
        field,
        value: parsedDate
      });
      hasUpdatedEditValueOnMount.current = true;
    }
  };
  return /*#__PURE__*/jsx(StyledInputBase, _extends$c({
    inputRef: handleInputRef,
    fullWidth: true,
    className: classes.root,
    type: isDateTime ? 'datetime-local' : 'date',
    inputProps: _extends$c({
      max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
    }, inputProps),
    value: valueState.formatted,
    onChange: handleChange
  }, other));
}
process.env.NODE_ENV !== "production" ? GridEditDateCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const renderEditDateCell = params => /*#__PURE__*/jsx(GridEditDateCell, _extends$c({}, params));

const _excluded$Y = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"];
const useUtilityClasses$C = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['editInputCell']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridEditInputCellRoot = styled$3(InputBase, {
  name: 'MuiDataGrid',
  slot: 'EditInputCell',
  overridesResolver: (props, styles) => styles.editInputCell
})(({
  theme
}) => _extends$c({}, theme.typography.body2, {
  padding: '1px 0',
  '& input': {
    padding: '0 16px',
    height: '100%'
  }
}));
const GridEditInputCell = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  const rootProps = useGridRootProps();
  const {
      id,
      value,
      field,
      colDef,
      hasFocus,
      debounceMs = 200,
      isProcessingProps,
      onValueChange
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$Y);
  const apiRef = useGridApiContext();
  const inputRef = React$1.useRef();
  const [valueState, setValueState] = React$1.useState(value);
  const classes = useUtilityClasses$C(rootProps);
  const handleChange = React$1.useCallback(async event => {
    const newValue = event.target.value;
    if (onValueChange) {
      await onValueChange(event, newValue);
    }
    const column = apiRef.current.getColumn(field);
    let parsedValue = newValue;
    if (column.valueParser) {
      parsedValue = column.valueParser(newValue, apiRef.current.getCellParams(id, field));
    }
    setValueState(parsedValue);
    apiRef.current.setEditCellValue({
      id,
      field,
      value: parsedValue,
      debounceMs,
      unstable_skipValueParser: true
    }, event);
  }, [apiRef, debounceMs, field, id, onValueChange]);
  const meta = apiRef.current.unstable_getEditCellMeta(id, field);
  React$1.useEffect(() => {
    if ((meta == null ? void 0 : meta.changeReason) !== 'debouncedSetEditCellValue') {
      setValueState(value);
    }
  }, [meta, value]);
  useEnhancedEffect(() => {
    if (hasFocus) {
      inputRef.current.focus();
    }
  }, [hasFocus]);
  return /*#__PURE__*/jsx(GridEditInputCellRoot, _extends$c({
    ref: ref,
    inputRef: inputRef,
    className: classes.root,
    ownerState: rootProps,
    fullWidth: true,
    type: colDef.type === 'number' ? colDef.type : 'text',
    value: valueState != null ? valueState : '',
    onChange: handleChange,
    endAdornment: isProcessingProps ? /*#__PURE__*/jsx(rootProps.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : undefined
  }, other));
});
process.env.NODE_ENV !== "production" ? GridEditInputCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  debounceMs: PropTypes.number,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const renderEditInputCell = params => /*#__PURE__*/jsx(GridEditInputCell, _extends$c({}, params));

const isEscapeKey = key => key === 'Escape'; // TODO remove
const isEnterKey = key => key === 'Enter'; // TODO remove
const isTabKey = key => key === 'Tab'; // TODO remove

const isSpaceKey = key => key === ' ';
const isArrowKeys = key => key.indexOf('Arrow') === 0;
const isHomeOrEndKeys = key => key === 'Home' || key === 'End';
const isPageKeys = key => key.indexOf('Page') === 0;

// Non printable keys have a name, e.g. "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function isPrintableKey(event) {
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const isNavigationKey = key => isHomeOrEndKeys(key) || isArrowKeys(key) || isPageKeys(key) || isSpaceKey(key);
const isKeyboardEvent$1 = event => !!event.key;
const isHideMenuKey = key => isTabKey(key) || isEscapeKey(key);

function isSingleSelectColDef(colDef) {
  return (colDef == null ? void 0 : colDef.type) === 'singleSelect';
}
function getValueFromValueOptions(value, valueOptions, getOptionValue) {
  if (valueOptions === undefined) {
    return undefined;
  }
  const result = valueOptions.find(option => {
    const optionValue = getOptionValue(option);
    return String(optionValue) === String(value);
  });
  return getOptionValue(result);
}

const _excluded$X = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange", "initialOpen", "getOptionLabel", "getOptionValue"],
  _excluded2$5 = ["MenuProps"];
function isKeyboardEvent(event) {
  return !!event.key;
}
function GridEditSingleSelectCell(props) {
  var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2;
  const rootProps = useGridRootProps();
  const {
      id,
      value: valueProp,
      field,
      row,
      colDef,
      hasFocus,
      error,
      onValueChange,
      initialOpen = rootProps.editMode === GridEditModes.Cell,
      getOptionLabel: getOptionLabelProp,
      getOptionValue: getOptionValueProp
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$X);
  const apiRef = useGridApiContext();
  const ref = React$1.useRef();
  const inputRef = React$1.useRef();
  const [open, setOpen] = React$1.useState(initialOpen);
  const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
  const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : false;
  const _ref = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {},
    {
      MenuProps
    } = _ref,
    otherBaseSelectProps = _objectWithoutPropertiesLoose$b(_ref, _excluded2$5);
  useEnhancedEffect(() => {
    if (hasFocus) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
    }
  }, [hasFocus]);
  if (!isSingleSelectColDef(colDef)) {
    return null;
  }
  let valueOptions;
  if (typeof (colDef == null ? void 0 : colDef.valueOptions) === 'function') {
    valueOptions = colDef == null ? void 0 : colDef.valueOptions({
      id,
      row,
      field
    });
  } else {
    valueOptions = colDef == null ? void 0 : colDef.valueOptions;
  }
  if (!valueOptions) {
    return null;
  }
  const getOptionValue = getOptionValueProp || colDef.getOptionValue;
  const getOptionLabel = getOptionLabelProp || colDef.getOptionLabel;
  const handleChange = async event => {
    if (!isSingleSelectColDef(colDef) || !valueOptions) {
      return;
    }
    setOpen(false);
    const target = event.target;
    // NativeSelect casts the value to a string.
    const formattedTargetValue = getValueFromValueOptions(target.value, valueOptions, getOptionValue);
    if (onValueChange) {
      await onValueChange(event, formattedTargetValue);
    }
    await apiRef.current.setEditCellValue({
      id,
      field,
      value: formattedTargetValue
    }, event);
  };
  const handleClose = (event, reason) => {
    if (rootProps.editMode === GridEditModes.Row) {
      setOpen(false);
      return;
    }
    if (reason === 'backdropClick' || isEscapeKey(event.key)) {
      const params = apiRef.current.getCellParams(id, field);
      apiRef.current.publishEvent('cellEditStop', _extends$c({}, params, {
        reason: isEscapeKey(event.key) ? GridCellEditStopReasons.escapeKeyDown : GridCellEditStopReasons.cellFocusOut
      }));
    }
  };
  const handleOpen = event => {
    if (isKeyboardEvent(event) && event.key === 'Enter') {
      return;
    }
    setOpen(true);
  };
  if (!valueOptions || !colDef) {
    return null;
  }
  return /*#__PURE__*/jsx(rootProps.slots.baseSelect, _extends$c({
    ref: ref,
    inputRef: inputRef,
    value: valueProp,
    onChange: handleChange,
    open: open,
    onOpen: handleOpen,
    MenuProps: _extends$c({
      onClose: handleClose
    }, MenuProps),
    error: error,
    native: isSelectNative,
    fullWidth: true
  }, other, otherBaseSelectProps, {
    children: valueOptions.map(valueOption => {
      var _rootProps$slotProps3;
      const value = getOptionValue(valueOption);
      return /*#__PURE__*/createElement(rootProps.slots.baseSelectOption, _extends$c({}, ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelectOption) || {}, {
        native: isSelectNative,
        key: value,
        value: value
      }), getOptionLabel(valueOption));
    })
  }));
}
process.env.NODE_ENV !== "production" ? GridEditSingleSelectCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  changeReason: PropTypes.oneOf(['debouncedSetEditCellValue', 'setEditCellValue']),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: PropTypes.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: PropTypes.func,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the select opens by default.
   */
  initialOpen: PropTypes.bool,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const renderEditSingleSelectCell = params => /*#__PURE__*/jsx(GridEditSingleSelectCell, _extends$c({}, params));

const _excluded$W = ["open", "target", "onClose", "children", "position", "className", "onExited"];
const useUtilityClasses$B = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['menu']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridMenuRoot = styled$3(Popper, {
  name: 'MuiDataGrid',
  slot: 'Menu',
  overridesResolver: (_, styles) => styles.menu
})(({
  theme
}) => ({
  zIndex: theme.zIndex.modal,
  [`& .${gridClasses.menuList}`]: {
    outline: 0
  }
}));
const transformOrigin = {
  'bottom-start': 'top left',
  'bottom-end': 'top right'
};
function GridMenu(props) {
  var _rootProps$slotProps;
  const {
      open,
      target,
      onClose,
      children,
      position,
      className,
      onExited
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$W);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$B(rootProps);
  const savedFocusRef = React$1.useRef(null);
  useEnhancedEffect(() => {
    if (open) {
      savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    } else {
      var _savedFocusRef$curren, _savedFocusRef$curren2;
      (_savedFocusRef$curren = savedFocusRef.current) == null || (_savedFocusRef$curren2 = _savedFocusRef$curren.focus) == null || _savedFocusRef$curren2.call(_savedFocusRef$curren);
      savedFocusRef.current = null;
    }
  }, [open]);
  React$1.useEffect(() => {
    // Emit menuOpen or menuClose events
    const eventName = open ? 'menuOpen' : 'menuClose';
    apiRef.current.publishEvent(eventName, {
      target
    });
  }, [apiRef, open, target]);
  const handleExited = popperOnExited => node => {
    if (popperOnExited) {
      popperOnExited();
    }
    if (onExited) {
      onExited(node);
    }
  };
  const handleClickAway = event => {
    if (event.target && (target === event.target || target != null && target.contains(event.target))) {
      return;
    }
    onClose(event);
  };
  return /*#__PURE__*/jsx(GridMenuRoot, _extends$c({
    as: rootProps.slots.basePopper,
    className: clsx(className, classes.root),
    ownerState: rootProps,
    open: open,
    anchorEl: target,
    transition: true,
    placement: position
  }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.basePopper, {
    children: ({
      TransitionProps,
      placement
    }) => /*#__PURE__*/jsx(ClickAwayListener, {
      onClickAway: handleClickAway,
      mouseEvent: "onMouseDown",
      children: /*#__PURE__*/jsx(Grow, _extends$c({}, TransitionProps, {
        style: {
          transformOrigin: transformOrigin[placement]
        },
        onExited: handleExited(TransitionProps == null ? void 0 : TransitionProps.onExited),
        children: /*#__PURE__*/jsx(Paper, {
          children: children
        })
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" ? GridMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  target: HTMLElementType
} : void 0;

const _excluded$V = ["api", "colDef", "id", "hasFocus", "isEditable", "field", "value", "formattedValue", "row", "rowNode", "cellMode", "tabIndex", "position", "focusElementRef"];
const hasActions = colDef => typeof colDef.getActions === 'function';
function GridActionsCell(props) {
  var _rootProps$slotProps;
  const {
      colDef,
      id,
      hasFocus,
      tabIndex,
      position = 'bottom-end',
      focusElementRef
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$V);
  const [focusedButtonIndex, setFocusedButtonIndex] = React$1.useState(-1);
  const [open, setOpen] = React$1.useState(false);
  const apiRef = useGridApiContext();
  const rootRef = React$1.useRef(null);
  const buttonRef = React$1.useRef(null);
  const ignoreCallToFocus = React$1.useRef(false);
  const touchRippleRefs = React$1.useRef({});
  const theme = useTheme$3();
  const menuId = useId();
  const buttonId = useId();
  const rootProps = useGridRootProps();
  if (!hasActions(colDef)) {
    throw new Error('MUI: Missing the `getActions` property in the `GridColDef`.');
  }
  const options = colDef.getActions(apiRef.current.getRowParams(id));
  const iconButtons = options.filter(option => !option.props.showInMenu);
  const menuButtons = options.filter(option => option.props.showInMenu);
  const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
  React$1.useLayoutEffect(() => {
    if (!hasFocus) {
      Object.entries(touchRippleRefs.current).forEach(([index, ref]) => {
        ref == null || ref.stop({}, () => {
          delete touchRippleRefs.current[index];
        });
      });
    }
  }, [hasFocus]);
  React$1.useEffect(() => {
    if (focusedButtonIndex < 0 || !rootRef.current) {
      return;
    }
    if (focusedButtonIndex >= rootRef.current.children.length) {
      return;
    }
    const child = rootRef.current.children[focusedButtonIndex];
    child.focus({
      preventScroll: true
    });
  }, [focusedButtonIndex]);
  React$1.useEffect(() => {
    if (!hasFocus) {
      setFocusedButtonIndex(-1);
      ignoreCallToFocus.current = false;
    }
  }, [hasFocus]);
  React$1.useImperativeHandle(focusElementRef, () => ({
    focus() {
      // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
      if (!ignoreCallToFocus.current) {
        setFocusedButtonIndex(0);
      }
    }
  }), []);
  React$1.useEffect(() => {
    if (focusedButtonIndex >= numberOfButtons) {
      setFocusedButtonIndex(numberOfButtons - 1);
    }
  }, [focusedButtonIndex, numberOfButtons]);
  const showMenu = () => {
    setOpen(true);
    setFocusedButtonIndex(numberOfButtons - 1);
    ignoreCallToFocus.current = true;
  };
  const hideMenu = () => {
    setOpen(false);
  };
  const handleTouchRippleRef = index => instance => {
    touchRippleRefs.current[index] = instance;
  };
  const handleButtonClick = (index, onClick) => event => {
    setFocusedButtonIndex(index);
    ignoreCallToFocus.current = true;
    if (onClick) {
      onClick(event);
    }
  };
  const handleRootKeyDown = event => {
    if (numberOfButtons <= 1) {
      return;
    }
    let newIndex = focusedButtonIndex;
    if (event.key === 'ArrowRight') {
      if (theme.direction === 'rtl') {
        newIndex -= 1;
      } else {
        newIndex += 1;
      }
    } else if (event.key === 'ArrowLeft') {
      if (theme.direction === 'rtl') {
        newIndex += 1;
      } else {
        newIndex -= 1;
      }
    }
    if (newIndex < 0 || newIndex >= numberOfButtons) {
      return; // We're already in the first or last item = do nothing and let the grid listen the event
    }

    if (newIndex !== focusedButtonIndex) {
      event.preventDefault(); // Prevent scrolling
      event.stopPropagation(); // Don't stop propagation for other keys, e.g. ArrowUp
      setFocusedButtonIndex(newIndex);
    }
  };
  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
    if (['Tab', 'Enter', 'Escape'].includes(event.key)) {
      hideMenu();
    }
  };
  return /*#__PURE__*/jsxs("div", _extends$c({
    role: "menu",
    ref: rootRef,
    tabIndex: -1,
    className: gridClasses.actionsCell,
    onKeyDown: handleRootKeyDown
  }, other, {
    children: [iconButtons.map((button, index) => /*#__PURE__*/React$1.cloneElement(button, {
      key: index,
      touchRippleRef: handleTouchRippleRef(index),
      onClick: handleButtonClick(index, button.props.onClick),
      tabIndex: focusedButtonIndex === index ? tabIndex : -1
    })), menuButtons.length > 0 && buttonId && /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
      ref: buttonRef,
      id: buttonId,
      "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
      "aria-haspopup": "menu",
      "aria-expanded": open,
      "aria-controls": open ? menuId : undefined,
      role: "menuitem",
      size: "small",
      onClick: showMenu,
      touchRippleRef: handleTouchRippleRef(buttonId),
      tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
      children: /*#__PURE__*/jsx(rootProps.slots.moreActionsIcon, {
        fontSize: "small"
      })
    })), menuButtons.length > 0 && /*#__PURE__*/jsx(GridMenu, {
      open: open,
      target: buttonRef.current,
      position: position,
      onClose: hideMenu,
      onClick: hideMenu,
      children: /*#__PURE__*/jsx(MenuList, {
        id: menuId,
        className: gridClasses.menuList,
        onKeyDown: handleListKeyDown,
        "aria-labelledby": buttonId,
        variant: "menu",
        autoFocusItem: true,
        children: menuButtons.map((button, index) => /*#__PURE__*/React$1.cloneElement(button, {
          key: index
        }))
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" ? GridActionsCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  api: PropTypes.object,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  position: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const renderActionsCell = params => /*#__PURE__*/jsx(GridActionsCell, _extends$c({}, params));

const _excluded$U = ["label", "icon", "showInMenu", "onClick"];
const GridActionsCellItem = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  const {
      label,
      icon,
      showInMenu,
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$U);
  const rootProps = useGridRootProps();
  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
  };
  if (!showInMenu) {
    var _rootProps$slotProps;
    return /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
      ref: ref,
      size: "small",
      role: "menuitem",
      "aria-label": label
    }, other, {
      onClick: handleClick
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
      children: /*#__PURE__*/React$1.cloneElement(icon, {
        fontSize: 'small'
      })
    }));
  }
  return /*#__PURE__*/jsxs(MenuItem, _extends$c({
    ref: ref
  }, other, {
    onClick: onClick,
    children: [icon && /*#__PURE__*/jsx(ListItemIcon, {
      children: icon
    }), label]
  }));
});
process.env.NODE_ENV !== "production" ? GridActionsCellItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  showInMenu: PropTypes.bool
} : void 0;

const _excluded$T = ["field", "align", "width", "contentWidth"];
const useUtilityClasses$A = ownerState => {
  const {
    align,
    classes
  } = ownerState;
  const slots = {
    root: ['cell', 'cellSkeleton', `cell--text${capitalize(align)}`, 'withBorderColor']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridSkeletonCell(props) {
  const {
      align,
      width,
      contentWidth
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$T);
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes,
    align
  };
  const classes = useUtilityClasses$A(ownerState);
  return /*#__PURE__*/jsx("div", _extends$c({
    className: classes.root,
    style: {
      width
    }
  }, other, {
    children: /*#__PURE__*/jsx(Skeleton$e, {
      width: `${contentWidth}%`
    })
  }));
}
process.env.NODE_ENV !== "production" ? GridSkeletonCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.string.isRequired,
  contentWidth: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired
} : void 0;

function getBorderColor(theme) {
  if (theme.vars) {
    return theme.vars.palette.TableCell.border;
  }
  if (theme.palette.mode === 'light') {
    return lighten(alpha(theme.palette.divider, 1), 0.88);
  }
  return darken$1(alpha(theme.palette.divider, 1), 0.68);
}
const columnHeadersStyles = {
  [`.${gridClasses.columnSeparator}, .${gridClasses['columnSeparator--resizing']}`]: {
    visibility: 'visible',
    width: 'auto'
  }
};
const columnHeaderStyles = {
  [`& .${gridClasses.iconButtonContainer}`]: {
    visibility: 'visible',
    width: 'auto'
  },
  [`& .${gridClasses.menuIcon}`]: {
    width: 'auto',
    visibility: 'visible'
  }
};
const GridRootStyles = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => [{
    [`&.${gridClasses.autoHeight}`]: styles.autoHeight
  }, {
    [`&.${gridClasses.aggregationColumnHeader}`]: styles.aggregationColumnHeader
  }, {
    [`&.${gridClasses['aggregationColumnHeader--alignLeft']}`]: styles['aggregationColumnHeader--alignLeft']
  }, {
    [`&.${gridClasses['aggregationColumnHeader--alignCenter']}`]: styles['aggregationColumnHeader--alignCenter']
  }, {
    [`&.${gridClasses['aggregationColumnHeader--alignRight']}`]: styles['aggregationColumnHeader--alignRight']
  }, {
    [`&.${gridClasses.aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
  }, {
    [`&.${gridClasses['root--disableUserSelection']} .${gridClasses.cell}`]: styles['root--disableUserSelection']
  }, {
    [`&.${gridClasses.autosizing}`]: styles.autosizing
  }, {
    [`& .${gridClasses.editBooleanCell}`]: styles.editBooleanCell
  }, {
    [`& .${gridClasses['cell--editing']}`]: styles['cell--editing']
  }, {
    [`& .${gridClasses['cell--textCenter']}`]: styles['cell--textCenter']
  }, {
    [`& .${gridClasses['cell--textLeft']}`]: styles['cell--textLeft']
  }, {
    [`& .${gridClasses['cell--textRight']}`]: styles['cell--textRight']
  },
  // TODO v6: Remove
  {
    [`& .${gridClasses['cell--withRenderer']}`]: styles['cell--withRenderer']
  }, {
    [`& .${gridClasses.cell}`]: styles.cell
  }, {
    [`& .${gridClasses['cell--rangeTop']}`]: styles['cell--rangeTop']
  }, {
    [`& .${gridClasses['cell--rangeBottom']}`]: styles['cell--rangeBottom']
  }, {
    [`& .${gridClasses['cell--rangeLeft']}`]: styles['cell--rangeLeft']
  }, {
    [`& .${gridClasses['cell--rangeRight']}`]: styles['cell--rangeRight']
  }, {
    [`& .${gridClasses['cell--withRightBorder']}`]: styles['cell--withRightBorder']
  }, {
    [`& .${gridClasses.cellContent}`]: styles.cellContent
  }, {
    [`& .${gridClasses.cellCheckbox}`]: styles.cellCheckbox
  }, {
    [`& .${gridClasses.cellSkeleton}`]: styles.cellSkeleton
  }, {
    [`& .${gridClasses.checkboxInput}`]: styles.checkboxInput
  }, {
    [`& .${gridClasses['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
  }, {
    [`& .${gridClasses['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
  }, {
    [`& .${gridClasses['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
  }, {
    [`& .${gridClasses['columnHeader--dragging']}`]: styles['columnHeader--dragging']
  }, {
    [`& .${gridClasses['columnHeader--moving']}`]: styles['columnHeader--moving']
  }, {
    [`& .${gridClasses['columnHeader--numeric']}`]: styles['columnHeader--numeric']
  }, {
    [`& .${gridClasses['columnHeader--sortable']}`]: styles['columnHeader--sortable']
  }, {
    [`& .${gridClasses['columnHeader--sorted']}`]: styles['columnHeader--sorted']
  }, {
    [`& .${gridClasses['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
  }, {
    [`& .${gridClasses.columnHeader}`]: styles.columnHeader
  }, {
    [`& .${gridClasses.headerFilterRow}`]: styles.headerFilterRow
  }, {
    [`& .${gridClasses.columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
  }, {
    [`& .${gridClasses.columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
  }, {
    [`& .${gridClasses.columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
  }, {
    [`& .${gridClasses['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
  }, {
    [`& .${gridClasses['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
  }, {
    [`& .${gridClasses.columnSeparator}`]: styles.columnSeparator
  }, {
    [`& .${gridClasses.filterIcon}`]: styles.filterIcon
  }, {
    [`& .${gridClasses.iconSeparator}`]: styles.iconSeparator
  }, {
    [`& .${gridClasses.menuIcon}`]: styles.menuIcon
  }, {
    [`& .${gridClasses.menuIconButton}`]: styles.menuIconButton
  }, {
    [`& .${gridClasses.menuOpen}`]: styles.menuOpen
  }, {
    [`& .${gridClasses.menuList}`]: styles.menuList
  }, {
    [`& .${gridClasses['row--editable']}`]: styles['row--editable']
  }, {
    [`& .${gridClasses['row--editing']}`]: styles['row--editing']
  }, {
    [`& .${gridClasses['row--dragging']}`]: styles['row--dragging']
  }, {
    [`& .${gridClasses.row}`]: styles.row
  }, {
    [`& .${gridClasses.rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
  }, {
    [`& .${gridClasses.rowReorderCell}`]: styles.rowReorderCell
  }, {
    [`& .${gridClasses['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
  }, {
    [`& .${gridClasses.sortIcon}`]: styles.sortIcon
  }, {
    [`& .${gridClasses.withBorderColor}`]: styles.withBorderColor
  }, {
    [`& .${gridClasses.treeDataGroupingCell}`]: styles.treeDataGroupingCell
  }, {
    [`& .${gridClasses.treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
  }, {
    [`& .${gridClasses.detailPanelToggleCell}`]: styles.detailPanelToggleCell
  }, {
    [`& .${gridClasses['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
  }, styles.root]
})(({
  theme
}) => {
  const borderColor = getBorderColor(theme);
  const radius = theme.shape.borderRadius;
  const gridStyle = _extends$c({
    '--unstable_DataGrid-radius': typeof radius === 'number' ? `${radius}px` : radius,
    '--unstable_DataGrid-headWeight': theme.typography.fontWeightMedium,
    '--unstable_DataGrid-overlayBackground': theme.vars ? `rgba(${theme.vars.palette.background.defaultChannel} / ${theme.vars.palette.action.disabledOpacity})` : alpha(theme.palette.background.default, theme.palette.action.disabledOpacity),
    '--DataGrid-cellOffsetMultiplier': 2,
    flex: 1,
    boxSizing: 'border-box',
    position: 'relative',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor,
    borderRadius: 'var(--unstable_DataGrid-radius)',
    color: (theme.vars || theme).palette.text.primary
  }, theme.typography.body2, {
    outline: 'none',
    height: '100%',
    display: 'flex',
    minWidth: 0,
    // See https://github.com/mui/mui-x/issues/8547
    minHeight: 0,
    flexDirection: 'column',
    overflowAnchor: 'none',
    // Keep the same scrolling position
    [`&.${gridClasses.autoHeight}`]: {
      height: 'auto',
      [`& .${gridClasses['row--lastVisible']} .${gridClasses.cell}`]: {
        borderBottomColor: 'transparent'
      }
    },
    [`&.${gridClasses.autosizing}`]: {
      [`& .${gridClasses.columnHeaderTitleContainerContent} > *`]: {
        overflow: 'visible !important'
      },
      [`& .${gridClasses.cell} > *`]: {
        overflow: 'visible !important'
      }
    },
    [`& .${gridClasses['virtualScrollerContent--overflowed']} .${gridClasses['row--lastVisible']} .${gridClasses.cell}`]: {
      borderBottomColor: 'transparent'
    },
    [`& .${gridClasses.columnHeader}, & .${gridClasses.cell}`]: {
      WebkitTapHighlightColor: 'transparent',
      lineHeight: null,
      padding: '0 10px',
      boxSizing: 'border-box'
    },
    [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
      outline: `solid ${theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.5)` : alpha(theme.palette.primary.main, 0.5)} 1px`,
      outlineWidth: 1,
      outlineOffset: -1
    },
    [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
      outline: `solid ${theme.palette.primary.main} 1px`
    },
    [`& .${gridClasses.columnHeaderCheckbox}, & .${gridClasses.cellCheckbox}`]: {
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    [`& .${gridClasses.columnHeader}`]: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },
    [`& .${gridClasses['columnHeader--sorted']} .${gridClasses.iconButtonContainer}, & .${gridClasses['columnHeader--filtered']} .${gridClasses.iconButtonContainer}`]: {
      visibility: 'visible',
      width: 'auto'
    },
    [`& .${gridClasses.columnHeader}:not(.${gridClasses['columnHeader--sorted']}) .${gridClasses.sortIcon}`]: {
      opacity: 0,
      transition: theme.transitions.create(['opacity'], {
        duration: theme.transitions.duration.shorter
      })
    },
    [`& .${gridClasses.columnHeaderTitleContainer}`]: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      // to anchor the aggregation label
      position: 'relative'
    },
    [`& .${gridClasses.columnHeaderTitleContainerContent}`]: {
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center'
    },
    [`& .${gridClasses['columnHeader--filledGroup']} .${gridClasses.columnHeaderTitleContainer}`]: {
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      boxSizing: 'border-box'
    },
    [`& .${gridClasses['columnHeader--filledGroup']}.${gridClasses['columnHeader--showColumnBorder']} .${gridClasses.columnHeaderTitleContainer}`]: {
      borderBottom: `none`
    },
    [`& .${gridClasses['columnHeader--filledGroup']}.${gridClasses['columnHeader--showColumnBorder']}`]: {
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      boxSizing: 'border-box'
    },
    [`& .${gridClasses.headerFilterRow}`]: {
      borderTop: `1px solid ${borderColor}`
    },
    [`& .${gridClasses.sortIcon}, & .${gridClasses.filterIcon}`]: {
      fontSize: 'inherit'
    },
    [`& .${gridClasses['columnHeader--sortable']}`]: {
      cursor: 'pointer'
    },
    [`& .${gridClasses['columnHeader--alignCenter']} .${gridClasses.columnHeaderTitleContainer}`]: {
      justifyContent: 'center'
    },
    [`& .${gridClasses['columnHeader--alignRight']} .${gridClasses.columnHeaderDraggableContainer}, & .${gridClasses['columnHeader--alignRight']} .${gridClasses.columnHeaderTitleContainer}`]: {
      flexDirection: 'row-reverse'
    },
    [`& .${gridClasses['columnHeader--alignCenter']} .${gridClasses.menuIcon}, & .${gridClasses['columnHeader--alignRight']} .${gridClasses.menuIcon}`]: {
      marginRight: 'auto',
      marginLeft: -6
    },
    [`& .${gridClasses['columnHeader--alignRight']} .${gridClasses.menuIcon}, & .${gridClasses['columnHeader--alignRight']} .${gridClasses.menuIcon}`]: {
      marginRight: 'auto',
      marginLeft: -10
    },
    [`& .${gridClasses['columnHeader--moving']}`]: {
      backgroundColor: (theme.vars || theme).palette.action.hover
    },
    [`& .${gridClasses.columnSeparator}`]: {
      visibility: 'hidden',
      position: 'absolute',
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: borderColor
    },
    '@media (hover: hover)': {
      [`& .${gridClasses.columnHeaders}:hover`]: columnHeadersStyles,
      [`& .${gridClasses.columnHeader}:hover`]: columnHeaderStyles,
      [`& .${gridClasses.columnHeader}:not(.${gridClasses['columnHeader--sorted']}):hover .${gridClasses.sortIcon}`]: {
        opacity: 0.5
      }
    },
    '@media (hover: none)': {
      [`& .${gridClasses.columnHeaders}`]: columnHeadersStyles,
      [`& .${gridClasses.columnHeader}`]: columnHeaderStyles
    },
    [`& .${gridClasses['columnSeparator--sideLeft']}`]: {
      left: -12
    },
    [`& .${gridClasses['columnSeparator--sideRight']}`]: {
      right: -12
    },
    [`& .${gridClasses['columnSeparator--resizable']}`]: {
      cursor: 'col-resize',
      touchAction: 'none',
      '&:hover': {
        color: (theme.vars || theme).palette.text.primary,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: borderColor
        }
      },
      [`&.${gridClasses['columnSeparator--resizing']}`]: {
        color: (theme.vars || theme).palette.text.primary
      },
      '& svg': {
        pointerEvents: 'none'
      }
    },
    [`& .${gridClasses.iconSeparator}`]: {
      color: 'inherit'
    },
    [`& .${gridClasses.menuIcon}`]: {
      width: 0,
      visibility: 'hidden',
      fontSize: 20,
      marginRight: -10,
      display: 'flex',
      alignItems: 'center'
    },
    [`.${gridClasses.menuOpen}`]: {
      visibility: 'visible',
      width: 'auto'
    },
    [`& .${gridClasses.row}`]: {
      display: 'flex',
      width: 'fit-content',
      breakInside: 'avoid',
      // Avoid the row to be broken in two different print pages.
      '&:hover, &.Mui-hovered': {
        backgroundColor: (theme.vars || theme).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&.Mui-selected': {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        '&:hover, &.Mui-hovered': {
          backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(
                ${theme.vars.palette.action.selectedOpacity} + 
                ${theme.vars.palette.action.hoverOpacity}
              ))` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
          }
        }
      }
    },
    [`& .${gridClasses.cell}`]: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid',
      '&.Mui-selected': {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        '&:hover, &.Mui-hovered': {
          backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity + theme.palette.action.hoverOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
          }
        }
      }
    },
    [`&.${gridClasses['root--disableUserSelection']} .${gridClasses.cell}`]: {
      userSelect: 'none'
    },
    [`& .${gridClasses.row}:not(.${gridClasses['row--dynamicHeight']}) > .${gridClasses.cell}`]: {
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    [`& .${gridClasses.cellContent}`]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    [`& .${gridClasses.cell}.${gridClasses['cell--selectionMode']}`]: {
      cursor: 'default'
    },
    [`& .${gridClasses.cell}.${gridClasses['cell--editing']}`]: {
      padding: 1,
      display: 'flex',
      boxShadow: theme.shadows[2],
      backgroundColor: (theme.vars || theme).palette.background.paper,
      '&:focus-within': {
        outline: `solid ${(theme.vars || theme).palette.primary.main} 1px`,
        outlineOffset: '-1px'
      }
    },
    [`& .${gridClasses['row--editing']}`]: {
      boxShadow: theme.shadows[2]
    },
    [`& .${gridClasses['row--editing']} .${gridClasses.cell}`]: {
      boxShadow: theme.shadows[0],
      backgroundColor: (theme.vars || theme).palette.background.paper
    },
    [`& .${gridClasses.editBooleanCell}`]: {
      display: 'flex',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    },
    [`& .${gridClasses.booleanCell}[data-value="true"]`]: {
      color: (theme.vars || theme).palette.text.secondary
    },
    [`& .${gridClasses.booleanCell}[data-value="false"]`]: {
      color: (theme.vars || theme).palette.text.disabled
    },
    [`& .${gridClasses.actionsCell}`]: {
      display: 'inline-flex',
      alignItems: 'center',
      gridGap: theme.spacing(1)
    },
    [`& .${gridClasses.rowReorderCell}`]: {
      display: 'inline-flex',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`& .${gridClasses['rowReorderCell--draggable']}`]: {
      cursor: 'move',
      opacity: 1
    },
    [`& .${gridClasses.rowReorderCellContainer}`]: {
      padding: 0,
      alignItems: 'stretch'
    },
    [`.${gridClasses.withBorderColor}`]: {
      borderColor
    },
    [`& .${gridClasses['cell--withRightBorder']}`]: {
      borderRightWidth: '1px',
      borderRightStyle: 'solid'
    },
    [`& .${gridClasses['columnHeader--withRightBorder']}`]: {
      borderRightWidth: '1px',
      borderRightStyle: 'solid'
    },
    [`& .${gridClasses['cell--textLeft']}`]: {
      justifyContent: 'flex-start'
    },
    [`& .${gridClasses['cell--textRight']}`]: {
      justifyContent: 'flex-end'
    },
    [`& .${gridClasses['cell--textCenter']}`]: {
      justifyContent: 'center'
    },
    [`& .${gridClasses.columnHeaderDraggableContainer}`]: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    [`& .${gridClasses.rowReorderCellPlaceholder}`]: {
      display: 'none'
    },
    [`& .${gridClasses['columnHeader--dragging']}, & .${gridClasses['row--dragging']}`]: {
      background: (theme.vars || theme).palette.background.paper,
      padding: '0 12px',
      borderRadius: 'var(--unstable_DataGrid-radius)',
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`& .${gridClasses['row--dragging']}`]: {
      background: (theme.vars || theme).palette.background.paper,
      padding: '0 12px',
      borderRadius: 'var(--unstable_DataGrid-radius)',
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      [`& .${gridClasses.rowReorderCellPlaceholder}`]: {
        display: 'flex'
      }
    },
    [`& .${gridClasses.treeDataGroupingCell}`]: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    [`& .${gridClasses.treeDataGroupingCellToggle}`]: {
      flex: '0 0 28px',
      alignSelf: 'stretch',
      marginRight: theme.spacing(2)
    },
    [`& .${gridClasses.groupingCriteriaCell}`]: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    [`& .${gridClasses.groupingCriteriaCellToggle}`]: {
      flex: '0 0 28px',
      alignSelf: 'stretch',
      marginRight: theme.spacing(2)
    }
  });
  return gridStyle;
});

const _excluded$S = ["children", "className"];
const useUtilityClasses$z = ownerState => {
  const {
    autoHeight,
    density,
    classes
  } = ownerState;
  const slots = {
    root: ['root', autoHeight && 'autoHeight', `root--density${capitalize(density)}`, 'withBorderColor']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridRoot = /*#__PURE__*/React$1.forwardRef(function GridRoot(props, ref) {
  var _rootProps$experiment;
  const rootProps = useGridRootProps();
  const {
      children,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$S);
  const apiRef = useGridPrivateApiContext();
  const densityValue = useGridSelector(apiRef, gridDensityValueSelector);
  const rootContainerRef = React$1.useRef(null);
  const handleRef = useForkRef(rootContainerRef, ref);
  const getAriaAttributes = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.ariaV7 // ariaV7 should never change
  ? null : useGridAriaAttributes;
  const ariaAttributes = typeof getAriaAttributes === 'function' ? getAriaAttributes() : null;
  const ownerState = _extends$c({}, rootProps, {
    density: densityValue
  });
  const classes = useUtilityClasses$z(ownerState);
  apiRef.current.register('public', {
    rootElementRef: rootContainerRef
  });

  // Our implementation of <NoSsr />
  const [mountedState, setMountedState] = React$1.useState(false);
  useEnhancedEffect(() => {
    setMountedState(true);
  }, []);
  if (!mountedState) {
    return null;
  }
  return /*#__PURE__*/jsx(GridRootStyles, _extends$c({
    ref: handleRef,
    className: clsx(className, classes.root),
    ownerState: ownerState
  }, ariaAttributes, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? GridRoot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$R = ["className"];
const useUtilityClasses$y = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['footerContainer', 'withBorderColor']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridFooterContainerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'FooterContainer',
  overridesResolver: (props, styles) => styles.footerContainer
})({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 52,
  borderTop: '1px solid'
});
const GridFooterContainer = /*#__PURE__*/React$1.forwardRef(function GridFooterContainer(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$R);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$y(rootProps);
  return /*#__PURE__*/jsx(GridFooterContainerRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});
process.env.NODE_ENV !== "production" ? GridFooterContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$Q = ["className"];
const useUtilityClasses$x = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['overlay']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridOverlayRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'Overlay',
  overridesResolver: (_, styles) => styles.overlay
})({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'var(--unstable_DataGrid-overlayBackground)'
});
const GridOverlay = /*#__PURE__*/React$1.forwardRef(function GridOverlay(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$Q);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$x(rootProps);
  return /*#__PURE__*/jsx(GridOverlayRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});
process.env.NODE_ENV !== "production" ? GridOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$P = ["className", "children"];
const useUtilityClasses$w = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['toolbarContainer']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridToolbarContainerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'ToolbarContainer',
  overridesResolver: (_, styles) => styles.toolbarContainer
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 0.5, 0)
}));
const GridToolbarContainer = /*#__PURE__*/React$1.forwardRef(function GridToolbarContainer(props, ref) {
  const {
      className,
      children
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$P);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$w(rootProps);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/jsx(GridToolbarContainerRoot, _extends$c({
    ref: ref,
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? GridToolbarContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$O = ["className"];
const useUtilityClasses$v = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['iconButtonContainer']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridIconButtonContainerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'IconButtonContainer',
  overridesResolver: (props, styles) => styles.iconButtonContainer
})(() => ({
  display: 'flex',
  visibility: 'hidden',
  width: 0
}));
const GridIconButtonContainer = /*#__PURE__*/React$1.forwardRef(function GridIconButtonContainer(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$O);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$v(rootProps);
  return /*#__PURE__*/jsx(GridIconButtonContainerRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});

const useUtilityClasses$u = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    icon: ['sortIcon']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function getIcon(icons, direction, className, sortingOrder) {
  let Icon;
  const iconProps = {};
  if (direction === 'asc') {
    Icon = icons.columnSortedAscendingIcon;
  } else if (direction === 'desc') {
    Icon = icons.columnSortedDescendingIcon;
  } else {
    Icon = icons.columnUnsortedIcon;
    iconProps.sortingOrder = sortingOrder;
  }
  return Icon ? /*#__PURE__*/jsx(Icon, _extends$c({
    fontSize: "small",
    className: className
  }, iconProps)) : null;
}
function GridColumnHeaderSortIconRaw(props) {
  var _rootProps$slotProps;
  const {
    direction,
    index,
    sortingOrder
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = _extends$c({}, props, {
    classes: rootProps.classes
  });
  const classes = useUtilityClasses$u(ownerState);
  const iconElement = getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
  if (!iconElement) {
    return null;
  }
  const iconButton = /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
    tabIndex: -1,
    "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
    title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
    size: "small"
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
    children: iconElement
  }));
  return /*#__PURE__*/jsxs(GridIconButtonContainer, {
    children: [index != null && /*#__PURE__*/jsx(Badge, {
      badgeContent: index,
      color: "default",
      children: iconButton
    }), index == null && iconButton]
  });
}
const GridColumnHeaderSortIcon = /*#__PURE__*/React$1.memo(GridColumnHeaderSortIconRaw);
process.env.NODE_ENV !== "production" ? GridColumnHeaderSortIconRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  direction: PropTypes.oneOf(['asc', 'desc']),
  index: PropTypes.number,
  sortingOrder: PropTypes.arrayOf(PropTypes.oneOf(['asc', 'desc'])).isRequired
} : void 0;

const useUtilityClasses$t = ownerState => {
  const {
    classes,
    open
  } = ownerState;
  const slots = {
    root: ['menuIcon', open && 'menuOpen'],
    button: ['menuIconButton']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const ColumnHeaderMenuIcon = /*#__PURE__*/React$1.memo(props => {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const {
    colDef,
    open,
    columnMenuId,
    columnMenuButtonId,
    iconButtonRef
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = _extends$c({}, props, {
    classes: rootProps.classes
  });
  const classes = useUtilityClasses$t(ownerState);
  const handleMenuIconClick = React$1.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    apiRef.current.toggleColumnMenu(colDef.field);
  }, [apiRef, colDef.field]);
  return /*#__PURE__*/jsx("div", {
    className: classes.root,
    children: /*#__PURE__*/jsx(rootProps.slots.baseTooltip, _extends$c({
      title: apiRef.current.getLocaleText('columnMenuLabel'),
      enterDelay: 1000
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
      children: /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
        ref: iconButtonRef,
        tabIndex: -1,
        className: classes.button,
        "aria-label": apiRef.current.getLocaleText('columnMenuLabel'),
        size: "small",
        onClick: handleMenuIconClick,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? columnMenuId : undefined,
        id: columnMenuButtonId
      }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseIconButton, {
        children: /*#__PURE__*/jsx(rootProps.slots.columnMenuIcon, {
          fontSize: "small"
        })
      }))
    }))
  });
});

function GridColumnHeaderMenu({
  columnMenuId,
  columnMenuButtonId,
  ContentComponent,
  contentComponentProps,
  field,
  open,
  target,
  onExited
}) {
  const apiRef = useGridApiContext();
  const colDef = apiRef.current.getColumn(field);
  const hideMenu = useEventCallback(event => {
    if (event) {
      // Prevent triggering the sorting
      event.stopPropagation();
      if (target != null && target.contains(event.target)) {
        return;
      }
    }
    apiRef.current.hideColumnMenu();
  });
  if (!target || !colDef) {
    return null;
  }
  return /*#__PURE__*/jsx(GridMenu, {
    placement: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
    open: open,
    target: target,
    onClose: hideMenu,
    onExited: onExited,
    children: /*#__PURE__*/jsx(ContentComponent, _extends$c({
      colDef: colDef,
      hideMenu: hideMenu,
      open: open,
      id: columnMenuId,
      labelledby: columnMenuButtonId
    }, contentComponentProps))
  });
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnMenuButtonId: PropTypes.string,
  columnMenuId: PropTypes.string,
  ContentComponent: PropTypes.elementType.isRequired,
  contentComponentProps: PropTypes.any,
  field: PropTypes.string.isRequired,
  onExited: PropTypes.func,
  open: PropTypes.bool.isRequired,
  target: HTMLElementType
} : void 0;

const _excluded$N = ["className"];
const useUtilityClasses$s = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['columnHeaderTitle']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeaderTitleRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'ColumnHeaderTitle',
  overridesResolver: (props, styles) => styles.columnHeaderTitle
})({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontWeight: 'var(--unstable_DataGrid-headWeight)'
});
const ColumnHeaderInnerTitle = /*#__PURE__*/React$1.forwardRef(function ColumnHeaderInnerTitle(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$N);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$s(rootProps);
  return /*#__PURE__*/jsx(GridColumnHeaderTitleRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function GridColumnHeaderTitle(props) {
  var _rootProps$slotProps;
  const {
    label,
    description
  } = props;
  const rootProps = useGridRootProps();
  const titleRef = React$1.useRef(null);
  const [tooltip, setTooltip] = React$1.useState('');
  const handleMouseOver = React$1.useCallback(() => {
    if (!description && titleRef != null && titleRef.current) {
      const isOver = isOverflown(titleRef.current);
      if (isOver) {
        setTooltip(label);
      } else {
        setTooltip('');
      }
    }
  }, [description, label]);
  return /*#__PURE__*/jsx(rootProps.slots.baseTooltip, _extends$c({
    title: description || tooltip
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
    children: /*#__PURE__*/jsx(ColumnHeaderInnerTitle, {
      onMouseOver: handleMouseOver,
      ref: titleRef,
      children: label
    })
  }));
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnWidth: PropTypes.number.isRequired,
  description: PropTypes.node,
  label: PropTypes.string.isRequired
} : void 0;

const _excluded$M = ["resizable", "resizing", "height", "side"];
var GridColumnHeaderSeparatorSides = /*#__PURE__*/function (GridColumnHeaderSeparatorSides) {
  GridColumnHeaderSeparatorSides["Left"] = "left";
  GridColumnHeaderSeparatorSides["Right"] = "right";
  return GridColumnHeaderSeparatorSides;
}(GridColumnHeaderSeparatorSides || {});
const useUtilityClasses$r = ownerState => {
  const {
    resizable,
    resizing,
    classes,
    side
  } = ownerState;
  const slots = {
    root: ['columnSeparator', resizable && 'columnSeparator--resizable', resizing && 'columnSeparator--resizing', side && `columnSeparator--side${capitalize(side)}`],
    icon: ['iconSeparator']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderSeparatorRaw(props) {
  const {
      height,
      side = GridColumnHeaderSeparatorSides.Right
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$M);
  const rootProps = useGridRootProps();
  const ownerState = _extends$c({}, props, {
    side,
    classes: rootProps.classes
  });
  const classes = useUtilityClasses$r(ownerState);
  const stopClick = React$1.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    jsx("div", _extends$c({
      className: classes.root,
      style: {
        minHeight: height,
        opacity: rootProps.showColumnVerticalBorder ? 0 : 1
      }
    }, other, {
      onClick: stopClick,
      children: /*#__PURE__*/jsx(rootProps.slots.columnResizeIcon, {
        className: classes.icon
      })
    }))
  );
}
const GridColumnHeaderSeparator = /*#__PURE__*/React$1.memo(GridColumnHeaderSeparatorRaw);
process.env.NODE_ENV !== "production" ? GridColumnHeaderSeparatorRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  height: PropTypes.number.isRequired,
  resizable: PropTypes.bool.isRequired,
  resizing: PropTypes.bool.isRequired,
  side: PropTypes.oneOf(['left', 'right'])
} : void 0;

const _excluded$L = ["classes", "columnMenuOpen", "colIndex", "height", "isResizing", "sortDirection", "hasFocus", "tabIndex", "separatorSide", "isDraggable", "headerComponent", "description", "elementId", "width", "columnMenuIconButton", "columnMenu", "columnTitleIconButtons", "headerClassName", "label", "resizable", "draggableContainerProps", "columnHeaderSeparatorProps"];
const GridGenericColumnHeaderItem = /*#__PURE__*/React$1.forwardRef(function GridGenericColumnHeaderItem(props, ref) {
  const {
      classes,
      columnMenuOpen,
      colIndex,
      height,
      isResizing,
      sortDirection,
      hasFocus,
      tabIndex,
      separatorSide,
      isDraggable,
      headerComponent,
      description,
      width,
      columnMenuIconButton = null,
      columnMenu = null,
      columnTitleIconButtons = null,
      headerClassName,
      label,
      resizable,
      draggableContainerProps,
      columnHeaderSeparatorProps
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$L);
  const apiRef = useGridPrivateApiContext();
  const rootProps = useGridRootProps();
  const headerCellRef = React$1.useRef(null);
  const [showColumnMenuIcon, setShowColumnMenuIcon] = React$1.useState(columnMenuOpen);
  const handleRef = useForkRef(headerCellRef, ref);
  let ariaSort = 'none';
  if (sortDirection != null) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }
  React$1.useEffect(() => {
    if (!showColumnMenuIcon) {
      setShowColumnMenuIcon(columnMenuOpen);
    }
  }, [showColumnMenuIcon, columnMenuOpen]);
  React$1.useLayoutEffect(() => {
    const columnMenuState = apiRef.current.state.columnMenu;
    if (hasFocus && !columnMenuState.open) {
      const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
      const elementToFocus = focusableElement || headerCellRef.current;
      elementToFocus == null || elementToFocus.focus();
      apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }
  }, [apiRef, hasFocus]);
  return /*#__PURE__*/jsxs("div", _extends$c({
    ref: handleRef,
    className: clsx(classes.root, headerClassName),
    style: {
      height,
      width,
      minWidth: width,
      maxWidth: width
    },
    role: "columnheader",
    tabIndex: tabIndex,
    "aria-colindex": colIndex + 1,
    "aria-sort": ariaSort,
    "aria-label": headerComponent == null ? label : undefined
  }, other, {
    children: [/*#__PURE__*/jsxs("div", _extends$c({
      className: classes.draggableContainer,
      draggable: isDraggable,
      role: "presentation"
    }, draggableContainerProps, {
      children: [/*#__PURE__*/jsxs("div", {
        className: classes.titleContainer,
        role: "presentation",
        children: [/*#__PURE__*/jsx("div", {
          className: classes.titleContainerContent,
          children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/jsx(GridColumnHeaderTitle, {
            label: label,
            description: description,
            columnWidth: width
          })
        }), columnTitleIconButtons]
      }), columnMenuIconButton]
    })), /*#__PURE__*/jsx(GridColumnHeaderSeparator, _extends$c({
      resizable: !rootProps.disableColumnResize && !!resizable,
      resizing: isResizing,
      height: height,
      side: separatorSide
    }, columnHeaderSeparatorProps)), columnMenu]
  }));
});

const useUtilityClasses$q = ownerState => {
  const {
    colDef,
    classes,
    isDragging,
    sortDirection,
    showRightBorder,
    filterItemsCounter
  } = ownerState;
  const isColumnSorted = sortDirection != null;
  const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
  // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
  const isColumnNumeric = colDef.type === 'number';
  const slots = {
    root: ['columnHeader', colDef.headerAlign === 'left' && 'columnHeader--alignLeft', colDef.headerAlign === 'center' && 'columnHeader--alignCenter', colDef.headerAlign === 'right' && 'columnHeader--alignRight', colDef.sortable && 'columnHeader--sortable', isDragging && 'columnHeader--moving', isColumnSorted && 'columnHeader--sorted', isColumnFiltered && 'columnHeader--filtered', isColumnNumeric && 'columnHeader--numeric', 'withBorderColor', showRightBorder && 'columnHeader--withRightBorder'],
    draggableContainer: ['columnHeaderDraggableContainer'],
    titleContainer: ['columnHeaderTitleContainer'],
    titleContainerContent: ['columnHeaderTitleContainerContent']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderItem(props) {
  var _rootProps$slotProps, _colDef$sortingOrder, _rootProps$slotProps2, _colDef$headerName;
  const {
    colDef,
    columnMenuOpen,
    colIndex,
    headerHeight,
    isResizing,
    sortDirection,
    sortIndex,
    filterItemsCounter,
    hasFocus,
    tabIndex,
    disableReorder,
    separatorSide
  } = props;
  const apiRef = useGridPrivateApiContext();
  const rootProps = useGridRootProps();
  const headerCellRef = React$1.useRef(null);
  const columnMenuId = useId();
  const columnMenuButtonId = useId();
  const iconButtonRef = React$1.useRef(null);
  const [showColumnMenuIcon, setShowColumnMenuIcon] = React$1.useState(columnMenuOpen);
  const isDraggable = React$1.useMemo(() => !rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [rootProps.disableColumnReorder, disableReorder, colDef.disableReorder]);
  let headerComponent;
  if (colDef.renderHeader) {
    headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
  }
  const ownerState = _extends$c({}, props, {
    classes: rootProps.classes,
    showRightBorder: rootProps.showColumnVerticalBorder
  });
  const classes = useUtilityClasses$q(ownerState);
  const publish = React$1.useCallback(eventName => event => {
    // Ignore portal
    // See https://github.com/mui/mui-x/issues/1721
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
  }, [apiRef, colDef.field]);
  const mouseEventsHandlers = React$1.useMemo(() => ({
    onClick: publish('columnHeaderClick'),
    onDoubleClick: publish('columnHeaderDoubleClick'),
    onMouseOver: publish('columnHeaderOver'),
    // TODO remove as it's not used
    onMouseOut: publish('columnHeaderOut'),
    // TODO remove as it's not used
    onMouseEnter: publish('columnHeaderEnter'),
    // TODO remove as it's not used
    onMouseLeave: publish('columnHeaderLeave'),
    // TODO remove as it's not used
    onKeyDown: publish('columnHeaderKeyDown'),
    onFocus: publish('columnHeaderFocus'),
    onBlur: publish('columnHeaderBlur')
  }), [publish]);
  const draggableEventHandlers = React$1.useMemo(() => isDraggable ? {
    onDragStart: publish('columnHeaderDragStart'),
    onDragEnter: publish('columnHeaderDragEnter'),
    onDragOver: publish('columnHeaderDragOver'),
    onDragEnd: publish('columnHeaderDragEnd')
  } : {}, [isDraggable, publish]);
  const columnHeaderSeparatorProps = React$1.useMemo(() => ({
    onMouseDown: publish('columnSeparatorMouseDown'),
    onDoubleClick: publish('columnSeparatorDoubleClick')
  }), [publish]);
  React$1.useEffect(() => {
    if (!showColumnMenuIcon) {
      setShowColumnMenuIcon(columnMenuOpen);
    }
  }, [showColumnMenuIcon, columnMenuOpen]);
  const handleExited = React$1.useCallback(() => {
    setShowColumnMenuIcon(false);
  }, []);
  const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/jsx(ColumnHeaderMenuIcon, {
    colDef: colDef,
    columnMenuId: columnMenuId,
    columnMenuButtonId: columnMenuButtonId,
    open: showColumnMenuIcon,
    iconButtonRef: iconButtonRef
  });
  const columnMenu = /*#__PURE__*/jsx(GridColumnHeaderMenu, {
    columnMenuId: columnMenuId,
    columnMenuButtonId: columnMenuButtonId,
    field: colDef.field,
    open: columnMenuOpen,
    target: iconButtonRef.current,
    ContentComponent: rootProps.slots.columnMenu,
    contentComponentProps: (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.columnMenu,
    onExited: handleExited
  });
  const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
  const columnTitleIconButtons = /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [!rootProps.disableColumnFilter && /*#__PURE__*/jsx(rootProps.slots.columnHeaderFilterIconButton, _extends$c({
      field: colDef.field,
      counter: filterItemsCounter
    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.columnHeaderFilterIconButton)), colDef.sortable && !colDef.hideSortIcons && /*#__PURE__*/jsx(GridColumnHeaderSortIcon, {
      direction: sortDirection,
      index: sortIndex,
      sortingOrder: sortingOrder
    })]
  });
  React$1.useLayoutEffect(() => {
    const columnMenuState = apiRef.current.state.columnMenu;
    if (hasFocus && !columnMenuState.open) {
      const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
      const elementToFocus = focusableElement || headerCellRef.current;
      elementToFocus == null || elementToFocus.focus();
      apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }
  }, [apiRef, hasFocus]);
  const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
    field: colDef.field,
    colDef
  }) : colDef.headerClassName;
  const label = (_colDef$headerName = colDef.headerName) != null ? _colDef$headerName : colDef.field;
  return /*#__PURE__*/jsx(GridGenericColumnHeaderItem, _extends$c({
    ref: headerCellRef,
    classes: classes,
    columnMenuOpen: columnMenuOpen,
    colIndex: colIndex,
    height: headerHeight,
    isResizing: isResizing,
    sortDirection: sortDirection,
    hasFocus: hasFocus,
    tabIndex: tabIndex,
    separatorSide: separatorSide,
    isDraggable: isDraggable,
    headerComponent: headerComponent,
    description: colDef.description,
    elementId: colDef.field,
    width: colDef.computedWidth,
    columnMenuIconButton: columnMenuIconButton,
    columnTitleIconButtons: columnTitleIconButtons,
    headerClassName: headerClassName,
    label: label,
    resizable: !rootProps.disableColumnResize && !!colDef.resizable,
    "data-field": colDef.field,
    columnMenu: columnMenu,
    draggableContainerProps: draggableEventHandlers,
    columnHeaderSeparatorProps: columnHeaderSeparatorProps
  }, mouseEventsHandlers));
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  colIndex: PropTypes.number.isRequired,
  columnMenuOpen: PropTypes.bool.isRequired,
  disableReorder: PropTypes.bool,
  filterItemsCounter: PropTypes.number,
  hasFocus: PropTypes.bool,
  headerHeight: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isResizing: PropTypes.bool.isRequired,
  separatorSide: PropTypes.oneOf(['left', 'right']),
  sortDirection: PropTypes.oneOf(['asc', 'desc']),
  sortIndex: PropTypes.number,
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired
} : void 0;

const getDefaultGridFilterModel = () => ({
  items: [],
  logicOperator: GridLogicOperator.And,
  quickFilterValues: [],
  quickFilterLogicOperator: GridLogicOperator.And
});

/**
 * @param {GridRowId} rowId The id of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 */

/**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */

// If no effect ran after this amount of time, we assume that the render was not committed by React
const CLEANUP_TIMER_LOOP_MILLIS = 1000;
class TimerBasedCleanupTracking {
  constructor(timeout = CLEANUP_TIMER_LOOP_MILLIS) {
    this.timeouts = new Map();
    this.cleanupTimeout = CLEANUP_TIMER_LOOP_MILLIS;
    this.cleanupTimeout = timeout;
  }
  register(object, unsubscribe, unregisterToken) {
    if (!this.timeouts) {
      this.timeouts = new Map();
    }
    const timeout = setTimeout(() => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
      this.timeouts.delete(unregisterToken.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(unregisterToken.cleanupToken, timeout);
  }
  unregister(unregisterToken) {
    const timeout = this.timeouts.get(unregisterToken.cleanupToken);
    if (timeout) {
      this.timeouts.delete(unregisterToken.cleanupToken);
      clearTimeout(timeout);
    }
  }
  reset() {
    if (this.timeouts) {
      this.timeouts.forEach((value, key) => {
        this.unregister({
          cleanupToken: key
        });
      });
      this.timeouts = undefined;
    }
  }
}

class FinalizationRegistryBasedCleanupTracking {
  constructor() {
    this.registry = new FinalizationRegistry(unsubscribe => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    });
  }
  register(object, unsubscribe, unregisterToken) {
    this.registry.register(object, unsubscribe, unregisterToken);
  }
  unregister(unregisterToken) {
    this.registry.unregister(unregisterToken);
  }

  // eslint-disable-next-line class-methods-use-this
  reset() {}
}

/**
 * Signal to the underlying logic what version of the public component API
 * of the data grid is exposed.
 */
var GridSignature = /*#__PURE__*/function (GridSignature) {
  GridSignature["DataGrid"] = "DataGrid";
  GridSignature["DataGridPro"] = "DataGridPro";
  return GridSignature;
}(GridSignature || {});
// We use class to make it easier to detect in heap snapshots by name
class ObjectToBeRetainedByReact {}

// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
function createUseGridApiEventHandler(registryContainer) {
  let cleanupTokensCounter = 0;
  return function useGridApiEventHandler(apiRef, eventName, handler, options) {
    if (registryContainer.registry === null) {
      registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new FinalizationRegistryBasedCleanupTracking() : new TimerBasedCleanupTracking();
    }
    const [objectRetainedByReact] = React$1.useState(new ObjectToBeRetainedByReact());
    const subscription = React$1.useRef(null);
    const handlerRef = React$1.useRef();
    handlerRef.current = handler;
    const cleanupTokenRef = React$1.useRef(null);
    if (!subscription.current && handlerRef.current) {
      const enhancedHandler = (params, event, details) => {
        if (!event.defaultMuiPrevented) {
          var _handlerRef$current;
          (_handlerRef$current = handlerRef.current) == null || _handlerRef$current.call(handlerRef, params, event, details);
        }
      };
      subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
      cleanupTokensCounter += 1;
      cleanupTokenRef.current = {
        cleanupToken: cleanupTokensCounter
      };
      registryContainer.registry.register(objectRetainedByReact,
      // The callback below will be called once this reference stops being retained
      () => {
        var _subscription$current;
        (_subscription$current = subscription.current) == null || _subscription$current.call(subscription);
        subscription.current = null;
        cleanupTokenRef.current = null;
      }, cleanupTokenRef.current);
    } else if (!handlerRef.current && subscription.current) {
      subscription.current();
      subscription.current = null;
      if (cleanupTokenRef.current) {
        registryContainer.registry.unregister(cleanupTokenRef.current);
        cleanupTokenRef.current = null;
      }
    }
    React$1.useEffect(() => {
      if (!subscription.current && handlerRef.current) {
        const enhancedHandler = (params, event, details) => {
          if (!event.defaultMuiPrevented) {
            var _handlerRef$current2;
            (_handlerRef$current2 = handlerRef.current) == null || _handlerRef$current2.call(handlerRef, params, event, details);
          }
        };
        subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
      }
      if (cleanupTokenRef.current && registryContainer.registry) {
        // If the effect was called, it means that this render was committed
        // so we can trust the cleanup function to remove the listener.
        registryContainer.registry.unregister(cleanupTokenRef.current);
        cleanupTokenRef.current = null;
      }
      return () => {
        var _subscription$current2;
        (_subscription$current2 = subscription.current) == null || _subscription$current2.call(subscription);
        subscription.current = null;
      };
    }, [apiRef, eventName, options]);
  };
}
const registryContainer = {
  registry: null
};
const useGridApiEventHandler = createUseGridApiEventHandler(registryContainer);
const optionsSubscriberOptions = {
  isFirst: true
};
function useGridApiOptionHandler(apiRef, eventName, handler) {
  // Validate that only one per event name?
  useGridApiEventHandler(apiRef, eventName, handler, optionsSubscriberOptions);
}

function useGridLogger(privateApiRef, name) {
  const logger = React$1.useRef(null);
  if (logger.current) {
    return logger.current;
  }
  const newLogger = privateApiRef.current.getLogger(name);
  logger.current = newLogger;
  return newLogger;
}

function isNumber(value) {
  return typeof value === 'number';
}
function isFunction(value) {
  return typeof value === 'function';
}
function isObject(value) {
  return typeof value === 'object' && value !== null;
}
function localStorageAvailable() {
  try {
    // Incognito mode might reject access to the localStorage for security reasons.
    // window isn't defined on Node.js
    // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
    const key = '__some_random_key_you_are_not_going_to_use__';
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (err) {
    return false;
  }
}
function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

/**
 * Follows the CSS specification behavior for min and max
 * If min > max, then the min have priority
 */
const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

/**
 * Based on `fast-deep-equal`
 *
 * MIT License
 *
 * Copyright (c) 2017 Evgeny Poberezkin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * We only type the public interface to avoid dozens of `as` in the function.
 */

function isDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) {
      return false;
    }
    if (Array.isArray(a)) {
      const length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (let i = 0; i < length; i += 1) {
        if (!isDeepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    if (a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) {
        return false;
      }
      const entriesA = Array.from(a.entries());
      for (let i = 0; i < entriesA.length; i += 1) {
        if (!b.has(entriesA[i][0])) {
          return false;
        }
      }
      for (let i = 0; i < entriesA.length; i += 1) {
        const entryA = entriesA[i];
        if (!isDeepEqual(entryA[1], b.get(entryA[0]))) {
          return false;
        }
      }
      return true;
    }
    if (a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) {
        return false;
      }
      const entries = Array.from(a.entries());
      for (let i = 0; i < entries.length; i += 1) {
        if (!b.has(entries[i][0])) {
          return false;
        }
      }
      return true;
    }
    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      const length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (let i = 0; i < length; i += 1) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    if (a.constructor === RegExp) {
      return a.source === b.source && a.flags === b.flags;
    }
    if (a.valueOf !== Object.prototype.valueOf) {
      return a.valueOf() === b.valueOf();
    }
    if (a.toString !== Object.prototype.toString) {
      return a.toString() === b.toString();
    }
    const keys = Object.keys(a);
    const length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (let i = 0; i < length; i += 1) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (let i = 0; i < length; i += 1) {
      const key = keys[i];
      if (!isDeepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }

  // true if both NaN, false otherwise
  // eslint-disable-next-line no-self-compare
  return a !== a && b !== b;
}

// Pseudo random number. See https://stackoverflow.com/a/47593316
function mulberry32(a) {
  return () => {
    /* eslint-disable */
    let t = a += 0x6d2b79f5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */
  };
}

function randomNumberBetween(seed, min, max) {
  const random = mulberry32(seed);
  return () => min + (max - min) * random();
}
function deepClone(obj) {
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}

const useGridNativeEventListener = (apiRef, ref, eventName, handler, options) => {
  const logger = useGridLogger(apiRef, 'useNativeEventListener');
  const [added, setAdded] = React$1.useState(false);
  const handlerRef = React$1.useRef(handler);
  const wrapHandler = React$1.useCallback(event => {
    return handlerRef.current && handlerRef.current(event);
  }, []);
  React$1.useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);
  React$1.useEffect(() => {
    let targetElement;
    if (isFunction(ref)) {
      targetElement = ref();
    } else {
      targetElement = ref && ref.current ? ref.current : null;
    }
    if (targetElement && eventName && !added) {
      logger.debug(`Binding native ${eventName} event`);
      targetElement.addEventListener(eventName, wrapHandler, options);
      const boundElem = targetElement;
      setAdded(true);
      const unsubscribe = () => {
        logger.debug(`Clearing native ${eventName} event`);
        boundElem.removeEventListener(eventName, wrapHandler, options);
      };
      apiRef.current.subscribeEvent('unmount', unsubscribe);
    }
  }, [ref, wrapHandler, eventName, added, logger, options, apiRef]);
};

const useFirstRender = callback => {
  const isFirstRender = React$1.useRef(true);
  if (isFirstRender.current) {
    isFirstRender.current = false;
    callback();
  }
};

const MAX_PAGE_SIZE = 100;
const defaultPageSize = autoPageSize => autoPageSize ? 0 : 100;
const getPageCount = (rowCount, pageSize) => {
  if (pageSize > 0 && rowCount > 0) {
    return Math.ceil(rowCount / pageSize);
  }
  return 0;
};
const noRowCountInServerMode = buildWarning(["MUI: the 'rowCount' prop is undefined while using paginationMode='server'", 'For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation'], 'error');
const getDefaultGridPaginationModel = autoPageSize => ({
  page: 0,
  pageSize: autoPageSize ? 0 : 100
});
const getValidPage = (page, pageCount = 0) => {
  if (pageCount === 0) {
    return page;
  }
  return Math.max(Math.min(page, pageCount - 1), 0);
};
const throwIfPageSizeExceedsTheLimit = (pageSize, signatureProp) => {
  if (signatureProp === GridSignature.DataGrid && pageSize > MAX_PAGE_SIZE) {
    throw new Error(['MUI: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.', 'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'].join('\n'));
  }
};

/**
 * @category Pagination
 * @ignore - do not document.
 */
const gridPaginationSelector = state => state.pagination;

/**
 * Get the pagination model
 * @category Pagination
 */
const gridPaginationModelSelector = createSelector(gridPaginationSelector, pagination => pagination.paginationModel);

/**
 * Get the index of the page to render if the pagination is enabled
 * @category Pagination
 */
const gridPageSelector = createSelector(gridPaginationModelSelector, paginationModel => paginationModel.page);

/**
 * Get the maximum amount of rows to display on a single page if the pagination is enabled
 * @category Pagination
 */
const gridPageSizeSelector = createSelector(gridPaginationModelSelector, paginationModel => paginationModel.pageSize);

/**
 * Get the amount of pages needed to display all the rows if the pagination is enabled
 * @category Pagination
 */
createSelector(gridPaginationModelSelector, gridFilteredTopLevelRowCountSelector, (paginationModel, visibleTopLevelRowCount) => getPageCount(visibleTopLevelRowCount, paginationModel.pageSize));

/**
 * Get the index of the first and the last row to include in the current page if the pagination is enabled.
 * @category Pagination
 */
const gridPaginationRowRangeSelector = createSelectorMemoized(gridPaginationModelSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, gridExpandedSortedRowEntriesSelector, gridFilteredSortedTopLevelRowEntriesSelector, (paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries) => {
  const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
  const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
  const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);

  // The range contains no element
  if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) {
    return null;
  }

  // The tree is flat, there is no need to look for children
  if (rowTreeDepth < 2) {
    return {
      firstRowIndex: topLevelFirstRowIndex,
      lastRowIndex: topLevelLastRowIndex
    };
  }
  const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
  const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
  const firstRowIndex = visibleSortedRowEntries.findIndex(row => row.id === topLevelFirstRow.id);
  let lastRowIndex = firstRowIndex;
  let topLevelRowAdded = 0;
  while (lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount) {
    var _rowTree$row$id;
    const row = visibleSortedRowEntries[lastRowIndex];
    const depth = (_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth;
    if (depth === undefined) {
      lastRowIndex += 1;
    } else {
      if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) {
        lastRowIndex += 1;
      }
      if (depth === 0) {
        topLevelRowAdded += 1;
      }
    }
  }
  return {
    firstRowIndex,
    lastRowIndex: lastRowIndex - 1
  };
});

/**
 * Get the id and the model of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */
const gridPaginatedVisibleSortedGridRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridPaginationRowRangeSelector, (visibleSortedRowEntries, paginationRange) => {
  if (!paginationRange) {
    return [];
  }
  return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});

/**
 * Get the id of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */
const gridPaginatedVisibleSortedGridRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowIdsSelector, gridPaginationRowRangeSelector, (visibleSortedRowIds, paginationRange) => {
  if (!paginationRange) {
    return [];
  }
  return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});

const gridPreferencePanelStateSelector = state => state.preferencePanel;

var GridPreferencePanelsValue = /*#__PURE__*/function (GridPreferencePanelsValue) {
  GridPreferencePanelsValue["filters"] = "filters";
  GridPreferencePanelsValue["columns"] = "columns";
  return GridPreferencePanelsValue;
}(GridPreferencePanelsValue || {});

const gridRowsMetaSelector = state => state.rowsMeta;

const gridRowSelectionStateSelector = state => state.rowSelection;
const selectedGridRowsCountSelector = createSelector(gridRowSelectionStateSelector, selection => selection.length);
const selectedGridRowsSelector = createSelectorMemoized(gridRowSelectionStateSelector, gridRowsLookupSelector, (selectedRows, rowsLookup) => new Map(selectedRows.map(id => [id, rowsLookup[id]])));
const selectedIdsLookupSelector = createSelectorMemoized(gridRowSelectionStateSelector, selection => selection.reduce((lookup, rowId) => {
  lookup[rowId] = rowId;
  return lookup;
}, {}));

const sortModelDisableMultiColumnsSortingWarning = buildWarning(['MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.', 'If you are using the community version of the `DataGrid`, this prop is always `true`.'], 'error');
const sanitizeSortModel = (model, disableMultipleColumnsSorting) => {
  if (disableMultipleColumnsSorting && model.length > 1) {
    sortModelDisableMultiColumnsSortingWarning();
    return [model[0]];
  }
  return model;
};
const mergeStateWithSortModel = (sortModel, disableMultipleColumnsSorting) => state => _extends$c({}, state, {
  sorting: _extends$c({}, state.sorting, {
    sortModel: sanitizeSortModel(sortModel, disableMultipleColumnsSorting)
  })
});
const isDesc = direction => direction === 'desc';

/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */
const parseSortItem = (sortItem, apiRef) => {
  const column = apiRef.current.getColumn(sortItem.field);
  if (!column) {
    return null;
  }
  const comparator = isDesc(sortItem.sort) ? (...args) => -1 * column.sortComparator(...args) : column.sortComparator;
  const getSortCellParams = id => ({
    id,
    field: column.field,
    rowNode: apiRef.current.getRowNode(id),
    value: apiRef.current.getCellValue(id, column.field),
    api: apiRef.current
  });
  return {
    getSortCellParams,
    comparator
  };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */
const compareRows = (parsedSortItems, row1, row2) => {
  return parsedSortItems.reduce((res, item, index) => {
    if (res !== 0) {
      // return the results of the first comparator which distinguish the two rows
      return res;
    }
    const sortCellParams1 = row1.params[index];
    const sortCellParams2 = row2.params[index];
    res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
    return res;
  }, 0);
};

/**
 * Generates a method to easily sort a list of rows according to the current sort model.
 * @param {GridSortModel} sortModel The model with which we want to sort the rows.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridSortingModelApplier | null} A method that generates a list of sorted row ids from a list of rows according to the current sort model. If `null`, we consider that the rows should remain in the order there were provided.
 */
const buildAggregatedSortingApplier = (sortModel, apiRef) => {
  const comparatorList = sortModel.map(item => parseSortItem(item, apiRef)).filter(comparator => !!comparator);
  if (comparatorList.length === 0) {
    return null;
  }
  return rowList => rowList.map(node => ({
    node,
    params: comparatorList.map(el => el.getSortCellParams(node.id))
  })).sort((a, b) => compareRows(comparatorList, a, b)).map(row => row.node.id);
};
const getNextGridSortDirection = (sortingOrder, current) => {
  const currentIdx = sortingOrder.indexOf(current);
  if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) {
    return sortingOrder[0];
  }
  return sortingOrder[currentIdx + 1];
};
const gridNillComparator = (v1, v2) => {
  if (v1 == null && v2 != null) {
    return -1;
  }
  if (v2 == null && v1 != null) {
    return 1;
  }
  if (v1 == null && v2 == null) {
    return 0;
  }
  return null;
};
const collator$2 = new Intl.Collator();
const gridStringOrNumberComparator = (value1, value2) => {
  const nillResult = gridNillComparator(value1, value2);
  if (nillResult !== null) {
    return nillResult;
  }
  if (typeof value1 === 'string') {
    return collator$2.compare(value1.toString(), value2.toString());
  }
  return value1 - value2;
};
const gridNumberComparator = (value1, value2) => {
  const nillResult = gridNillComparator(value1, value2);
  if (nillResult !== null) {
    return nillResult;
  }
  return Number(value1) - Number(value2);
};
const gridDateComparator = (value1, value2) => {
  const nillResult = gridNillComparator(value1, value2);
  if (nillResult !== null) {
    return nillResult;
  }
  if (value1 > value2) {
    return 1;
  }
  if (value1 < value2) {
    return -1;
  }
  return 0;
};

/* eslint-disable @typescript-eslint/naming-convention */
const unstable_gridHeaderFilteringStateSelector = state => state.headerFiltering;
const unstable_gridHeaderFilteringEditFieldSelector = createSelector(unstable_gridHeaderFilteringStateSelector, headerFilteringState => headerFilteringState.editing);
const unstable_gridHeaderFilteringMenuSelector = createSelector(unstable_gridHeaderFilteringStateSelector, headerFilteringState => headerFilteringState.menuOpen);

const virtualizationStateInitializer = (state, props) => {
  const virtualization = {
    enabled: !props.disableVirtualization,
    enabledForColumns: true
  };
  return _extends$c({}, state, {
    virtualization
  });
};
function useGridVirtualization(apiRef, props) {
  /*
   * API METHODS
   */

  const setVirtualization = enabled => {
    apiRef.current.setState(state => _extends$c({}, state, {
      virtualization: _extends$c({}, state.virtualization, {
        enabled
      })
    }));
  };
  const setColumnVirtualization = enabled => {
    apiRef.current.setState(state => _extends$c({}, state, {
      virtualization: _extends$c({}, state.virtualization, {
        enabledForColumns: enabled
      })
    }));
  };
  const api = {
    unstable_setVirtualization: setVirtualization,
    unstable_setColumnVirtualization: setColumnVirtualization
  };
  useGridApiMethod(apiRef, api, 'public');

  /*
   * EFFECTS
   */

  /* eslint-disable react-hooks/exhaustive-deps */
  React$1.useEffect(() => {
    setVirtualization(!props.disableVirtualization);
  }, [props.disableVirtualization]);
  /* eslint-enable react-hooks/exhaustive-deps */
}

/**
 * Get the columns state
 * @category Virtualization
 */
const gridVirtualizationSelector = state => state.virtualization;

/**
 * Get the enabled state for virtualization
 * @category Virtualization
 */
const gridVirtualizationEnabledSelector = createSelector(gridVirtualizationSelector, state => state.enabled);

/**
 * Get the enabled state for virtualization
 * @category Virtualization
 */
const gridVirtualizationColumnEnabledSelector = createSelector(gridVirtualizationSelector, state => state.enabledForColumns);

const useUtilityClasses$p = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    icon: ['filterIcon']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnHeaderFilterIconButton(props) {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const {
    counter,
    field,
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = _extends$c({}, props, {
    classes: rootProps.classes
  });
  const classes = useUtilityClasses$p(ownerState);
  const preferencePanel = useGridSelector(apiRef, gridPreferencePanelStateSelector);
  const labelId = useId();
  const panelId = useId();
  const toggleFilter = React$1.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    const {
      open,
      openedPanelValue
    } = gridPreferencePanelStateSelector(apiRef.current.state);
    if (open && openedPanelValue === GridPreferencePanelsValue.filters) {
      apiRef.current.hideFilterPanel();
    } else {
      apiRef.current.showFilterPanel(undefined, panelId, labelId);
    }
    if (onClick) {
      onClick(apiRef.current.getColumnHeaderParams(field), event);
    }
  }, [apiRef, field, onClick, panelId, labelId]);
  if (!counter) {
    return null;
  }
  const open = preferencePanel.open && preferencePanel.labelId === labelId;
  const iconButton = /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
    id: labelId,
    onClick: toggleFilter,
    color: "default",
    "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
    size: "small",
    tabIndex: -1,
    "aria-haspopup": "menu",
    "aria-expanded": open,
    "aria-controls": open ? panelId : undefined
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
    children: /*#__PURE__*/jsx(rootProps.slots.columnFilteredIcon, {
      className: classes.icon,
      fontSize: "small"
    })
  }));
  return /*#__PURE__*/jsx(rootProps.slots.baseTooltip, _extends$c({
    title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
    enterDelay: 1000
  }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseTooltip, {
    children: /*#__PURE__*/jsxs(GridIconButtonContainer, {
      children: [counter > 1 && /*#__PURE__*/jsx(Badge, {
        badgeContent: counter,
        color: "default",
        children: iconButton
      }), counter === 1 && iconButton]
    })
  }));
}
process.env.NODE_ENV !== "production" ? GridColumnHeaderFilterIconButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  counter: PropTypes.number,
  field: PropTypes.string.isRequired,
  onClick: PropTypes.func
} : void 0;

const _excluded$K = ["field", "id", "value", "formattedValue", "row", "rowNode", "colDef", "isEditable", "cellMode", "hasFocus", "tabIndex", "api"];
const useUtilityClasses$o = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['checkboxInput']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridCellCheckboxForwardRef = /*#__PURE__*/React$1.forwardRef(function GridCellCheckboxRenderer(props, ref) {
  var _rootProps$slotProps;
  const {
      field,
      id,
      value: isChecked,
      rowNode,
      hasFocus,
      tabIndex
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$K);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes
  };
  const classes = useUtilityClasses$o(ownerState);
  const checkboxElement = React$1.useRef(null);
  const rippleRef = React$1.useRef(null);
  const handleRef = useForkRef(checkboxElement, ref);
  const element = apiRef.current.getCellElement(id, field);
  const handleChange = event => {
    const params = {
      value: event.target.checked,
      id
    };
    apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
  };
  React$1.useLayoutEffect(() => {
    if (tabIndex === 0 && element) {
      element.tabIndex = -1;
    }
  }, [element, tabIndex]);
  React$1.useEffect(() => {
    if (hasFocus) {
      var _checkboxElement$curr;
      const input = (_checkboxElement$curr = checkboxElement.current) == null ? void 0 : _checkboxElement$curr.querySelector('input');
      input == null || input.focus({
        preventScroll: true
      });
    } else if (rippleRef.current) {
      // Only available in @mui/material v5.4.1 or later
      rippleRef.current.stop({});
    }
  }, [hasFocus]);
  const handleKeyDown = React$1.useCallback(event => {
    if (isSpaceKey(event.key)) {
      // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
      // TODO: Remove and add a check inside useGridKeyboardNavigation
      event.stopPropagation();
    }
  }, []);
  if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') {
    return null;
  }
  const isSelectable = apiRef.current.isRowSelectable(id);
  const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
  return /*#__PURE__*/jsx(rootProps.slots.baseCheckbox, _extends$c({
    ref: handleRef,
    tabIndex: tabIndex,
    checked: isChecked,
    onChange: handleChange,
    className: classes.root,
    inputProps: {
      'aria-label': label
    },
    onKeyDown: handleKeyDown,
    disabled: !isSelectable,
    touchRippleRef: rippleRef
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
process.env.NODE_ENV !== "production" ? GridCellCheckboxForwardRef.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(['edit', 'view']).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
} : void 0;
const GridCellCheckboxRenderer = GridCellCheckboxForwardRef;

const _excluded$J = ["field", "colDef"];
const useUtilityClasses$n = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['checkboxInput']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridHeaderCheckbox = /*#__PURE__*/React$1.forwardRef(function GridHeaderCheckbox(props, ref) {
  var _rootProps$slotProps;
  const other = _objectWithoutPropertiesLoose$b(props, _excluded$J);
  const [, forceUpdate] = React$1.useState(false);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = {
    classes: rootProps.classes
  };
  const classes = useUtilityClasses$n(ownerState);
  const tabIndexState = useGridSelector(apiRef, gridTabIndexColumnHeaderSelector);
  const selection = useGridSelector(apiRef, gridRowSelectionStateSelector);
  const visibleRowIds = useGridSelector(apiRef, gridExpandedSortedRowIdsSelector);
  const paginatedVisibleRowIds = useGridSelector(apiRef, gridPaginatedVisibleSortedGridRowIdsSelector);
  const filteredSelection = React$1.useMemo(() => {
    if (typeof rootProps.isRowSelectable !== 'function') {
      return selection;
    }
    return selection.filter(id => {
      // The row might have been deleted
      if (!apiRef.current.getRow(id)) {
        return false;
      }
      return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
    });
  }, [apiRef, rootProps.isRowSelectable, selection]);

  // All the rows that could be selected / unselected by toggling this checkbox
  const selectionCandidates = React$1.useMemo(() => {
    const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly ? visibleRowIds : paginatedVisibleRowIds;

    // Convert to an object to make O(1) checking if a row exists or not
    // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
    return rowIds.reduce((acc, id) => {
      acc[id] = true;
      return acc;
    }, {});
  }, [rootProps.pagination, rootProps.checkboxSelectionVisibleOnly, paginatedVisibleRowIds, visibleRowIds]);

  // Amount of rows selected and that are visible in the current page
  const currentSelectionSize = React$1.useMemo(() => filteredSelection.filter(id => selectionCandidates[id]).length, [filteredSelection, selectionCandidates]);
  const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
  const isChecked = currentSelectionSize > 0;
  const handleChange = event => {
    const params = {
      value: event.target.checked
    };
    apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
  };
  const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
  React$1.useLayoutEffect(() => {
    const element = apiRef.current.getColumnHeaderElement(props.field);
    if (tabIndex === 0 && element) {
      element.tabIndex = -1;
    }
  }, [tabIndex, apiRef, props.field]);
  const handleKeyDown = React$1.useCallback(event => {
    if (event.key === ' ') {
      // imperative toggle the checkbox because Space is disable by some preventDefault
      apiRef.current.publishEvent('headerSelectionCheckboxChange', {
        value: !isChecked
      });
    }
  }, [apiRef, isChecked]);
  const handleSelectionChange = React$1.useCallback(() => {
    forceUpdate(p => !p);
  }, []);
  React$1.useEffect(() => {
    return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
  }, [apiRef, handleSelectionChange]);
  const label = apiRef.current.getLocaleText(isChecked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
  return /*#__PURE__*/jsx(rootProps.slots.baseCheckbox, _extends$c({
    ref: ref,
    indeterminate: isIndeterminate,
    checked: isChecked,
    onChange: handleChange,
    className: classes.root,
    inputProps: {
      'aria-label': label
    },
    tabIndex: tabIndex,
    onKeyDown: handleKeyDown
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseCheckbox, other));
});
process.env.NODE_ENV !== "production" ? GridHeaderCheckbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The column of the current header component.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the column that triggered the event
   */
  field: PropTypes.string.isRequired
} : void 0;

const GridArrowUpwardIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const GridArrowDownwardIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const GridKeyboardArrowRight = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const GridExpandMoreIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const GridFilterListIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const GridFilterAltIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const GridSearchIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const GridColumnIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const GridSeparatorIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M11 19V5h2v14z"
}), 'Separator');
const GridViewHeadlineIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const GridTableRowsIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const GridViewStreamIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const GridTripleDotsVerticalIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const GridCloseIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const GridAddIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const GridRemoveIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 13H5v-2h14v2z"
}), 'Remove');
const GridLoadIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const GridDragIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const GridSaveAltIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const GridCheckIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const GridMoreVertIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const GridVisibilityOffIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const GridViewColumnIcon = createSvgIcon( /*#__PURE__*/jsx("g", {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
  })
}), 'ViewColumn');
const GridClearIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const GridDeleteForeverIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');

const _excluded$I = ["hideMenu", "colDef", "id", "labelledby", "className", "children", "open"];
const StyledMenuList = styled$3(MenuList)(() => ({
  minWidth: 248
}));
const GridColumnMenuContainer = /*#__PURE__*/React$1.forwardRef(function GridColumnMenuContainer(props, ref) {
  const {
      hideMenu,
      id,
      labelledby,
      className,
      children,
      open
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$I);
  const handleListKeyDown = React$1.useCallback(event => {
    if (isTabKey(event.key)) {
      event.preventDefault();
    }
    if (isHideMenuKey(event.key)) {
      hideMenu(event);
    }
  }, [hideMenu]);
  return /*#__PURE__*/jsx(StyledMenuList, _extends$c({
    id: id,
    ref: ref,
    className: clsx(gridClasses.menuList, className),
    "aria-labelledby": labelledby,
    onKeyDown: handleListKeyDown,
    autoFocus: open
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? GridColumnMenuContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  hideMenu: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelledby: PropTypes.string,
  open: PropTypes.bool.isRequired
} : void 0;

const _excluded$H = ["displayOrder"];
const useGridColumnMenuSlots = props => {
  const apiRef = useGridPrivateApiContext();
  const {
    defaultSlots,
    defaultSlotProps,
    slots = {},
    slotProps = {},
    hideMenu,
    colDef,
    addDividers = true
  } = props;
  const processedComponents = React$1.useMemo(() => _extends$c({}, defaultSlots, slots), [defaultSlots, slots]);
  const processedSlotProps = React$1.useMemo(() => {
    if (!slotProps || Object.keys(slotProps).length === 0) {
      return defaultSlotProps;
    }
    const mergedProps = _extends$c({}, slotProps);
    Object.entries(defaultSlotProps).forEach(([key, currentSlotProps]) => {
      mergedProps[key] = _extends$c({}, currentSlotProps, slotProps[key] || {});
    });
    return mergedProps;
  }, [defaultSlotProps, slotProps]);
  const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
  const userItems = React$1.useMemo(() => {
    const defaultComponentKeys = Object.keys(defaultSlots);
    return Object.keys(slots).filter(key => !defaultComponentKeys.includes(key));
  }, [slots, defaultSlots]);
  return React$1.useMemo(() => {
    const uniqueItems = Array.from(new Set([...defaultItems, ...userItems]));
    const cleansedItems = uniqueItems.filter(key => processedComponents[key] != null);
    const sorted = cleansedItems.sort((a, b) => {
      const leftItemProps = processedSlotProps[a];
      const rightItemProps = processedSlotProps[b];
      const leftDisplayOrder = Number.isFinite(leftItemProps == null ? void 0 : leftItemProps.displayOrder) ? leftItemProps.displayOrder : 100;
      const rightDisplayOrder = Number.isFinite(rightItemProps == null ? void 0 : rightItemProps.displayOrder) ? rightItemProps.displayOrder : 100;
      return leftDisplayOrder - rightDisplayOrder;
    });
    return sorted.reduce((acc, key, index) => {
      let itemProps = {
        colDef,
        onClick: hideMenu
      };
      const processedComponentProps = processedSlotProps[key];
      if (processedComponentProps) {
        const customProps = _objectWithoutPropertiesLoose$b(processedComponentProps, _excluded$H);
        itemProps = _extends$c({}, itemProps, customProps);
      }
      return addDividers && index !== sorted.length - 1 ? [...acc, [processedComponents[key], itemProps], [Divider, {}]] : [...acc, [processedComponents[key], itemProps]];
    }, []);
  }, [addDividers, colDef, defaultItems, hideMenu, processedComponents, processedSlotProps, userItems]);
};

function GridColumnMenuHideItem(props) {
  const {
    colDef,
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
  const columnsWithMenu = visibleColumns.filter(col => col.disableColumnMenu !== true);
  // do not allow to hide the last column with menu
  const disabled = columnsWithMenu.length === 1;
  const toggleColumn = React$1.useCallback(event => {
    /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */
    if (disabled) {
      return;
    }
    apiRef.current.setColumnVisibility(colDef.field, false);
    onClick(event);
  }, [apiRef, colDef.field, onClick, disabled]);
  if (rootProps.disableColumnSelector) {
    return null;
  }
  if (colDef.hideable === false) {
    return null;
  }
  return /*#__PURE__*/jsxs(MenuItem, {
    onClick: toggleColumn,
    disabled: disabled,
    children: [/*#__PURE__*/jsx(ListItemIcon, {
      children: /*#__PURE__*/jsx(rootProps.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /*#__PURE__*/jsx(ListItemText, {
      children: apiRef.current.getLocaleText('columnMenuHideColumn')
    })]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuHideItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;

function GridColumnMenuManageItem(props) {
  const {
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const showColumns = React$1.useCallback(event => {
    onClick(event); // hide column menu
    apiRef.current.showPreferences(GridPreferencePanelsValue.columns);
  }, [apiRef, onClick]);
  if (rootProps.disableColumnSelector) {
    return null;
  }
  return /*#__PURE__*/jsxs(MenuItem, {
    onClick: showColumns,
    children: [/*#__PURE__*/jsx(ListItemIcon, {
      children: /*#__PURE__*/jsx(rootProps.slots.columnMenuManageColumnsIcon, {
        fontSize: "small"
      })
    }), /*#__PURE__*/jsx(ListItemText, {
      children: apiRef.current.getLocaleText('columnMenuManageColumns')
    })]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuManageItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;

function GridColumnMenuColumnsItem(props) {
  return /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsx(GridColumnMenuHideItem, _extends$c({}, props)), /*#__PURE__*/jsx(GridColumnMenuManageItem, _extends$c({}, props))]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuColumnsItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;

function GridColumnMenuFilterItem(props) {
  const {
    colDef,
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const showFilter = React$1.useCallback(event => {
    onClick(event);
    apiRef.current.showFilterPanel(colDef.field);
  }, [apiRef, colDef.field, onClick]);
  if (rootProps.disableColumnFilter || !colDef.filterable) {
    return null;
  }
  return /*#__PURE__*/jsxs(MenuItem, {
    onClick: showFilter,
    children: [/*#__PURE__*/jsx(ListItemIcon, {
      children: /*#__PURE__*/jsx(rootProps.slots.columnMenuFilterIcon, {
        fontSize: "small"
      })
    }), /*#__PURE__*/jsx(ListItemText, {
      children: apiRef.current.getLocaleText('columnMenuFilter')
    })]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuFilterItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;

function GridColumnMenuSortItem(props) {
  var _colDef$sortingOrder;
  const {
    colDef,
    onClick
  } = props;
  const apiRef = useGridApiContext();
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  const rootProps = useGridRootProps();
  const sortDirection = React$1.useMemo(() => {
    if (!colDef) {
      return null;
    }
    const sortItem = sortModel.find(item => item.field === colDef.field);
    return sortItem == null ? void 0 : sortItem.sort;
  }, [colDef, sortModel]);
  const sortingOrder = (_colDef$sortingOrder = colDef.sortingOrder) != null ? _colDef$sortingOrder : rootProps.sortingOrder;
  const onSortMenuItemClick = React$1.useCallback(event => {
    onClick(event);
    const direction = event.currentTarget.getAttribute('data-value') || null;
    apiRef.current.sortColumn(colDef, direction === sortDirection ? null : direction);
  }, [apiRef, colDef, onClick, sortDirection]);
  if (!colDef || !colDef.sortable || !sortingOrder.some(item => !!item)) {
    return null;
  }
  return /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/jsxs(MenuItem, {
      onClick: onSortMenuItemClick,
      "data-value": "asc",
      children: [/*#__PURE__*/jsx(ListItemIcon, {
        children: /*#__PURE__*/jsx(rootProps.slots.columnMenuSortAscendingIcon, {
          fontSize: "small"
        })
      }), /*#__PURE__*/jsx(ListItemText, {
        children: apiRef.current.getLocaleText('columnMenuSortAsc')
      })]
    }) : null, sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/jsxs(MenuItem, {
      onClick: onSortMenuItemClick,
      "data-value": "desc",
      children: [/*#__PURE__*/jsx(ListItemIcon, {
        children: /*#__PURE__*/jsx(rootProps.slots.columnMenuSortDescendingIcon, {
          fontSize: "small"
        })
      }), /*#__PURE__*/jsx(ListItemText, {
        children: apiRef.current.getLocaleText('columnMenuSortDesc')
      })]
    }) : null, sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/jsxs(MenuItem, {
      onClick: onSortMenuItemClick,
      children: [/*#__PURE__*/jsx(ListItemIcon, {}), /*#__PURE__*/jsx(ListItemText, {
        children: apiRef.current.getLocaleText('columnMenuUnsort')
      })]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" ? GridColumnMenuSortItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
} : void 0;

const _excluded$G = ["defaultSlots", "defaultSlotProps", "slots", "slotProps"];
const GRID_COLUMN_MENU_SLOTS = {
  columnMenuSortItem: GridColumnMenuSortItem,
  columnMenuFilterItem: GridColumnMenuFilterItem,
  columnMenuColumnsItem: GridColumnMenuColumnsItem
};
const GRID_COLUMN_MENU_SLOT_PROPS = {
  columnMenuSortItem: {
    displayOrder: 10
  },
  columnMenuFilterItem: {
    displayOrder: 20
  },
  columnMenuColumnsItem: {
    displayOrder: 30
  }
};
const GridGenericColumnMenu = /*#__PURE__*/React$1.forwardRef(function GridGenericColumnMenu(props, ref) {
  const {
      defaultSlots,
      defaultSlotProps,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$G);
  const orderedSlots = useGridColumnMenuSlots(_extends$c({}, other, {
    defaultSlots,
    defaultSlotProps,
    slots,
    slotProps
  }));
  return /*#__PURE__*/jsx(GridColumnMenuContainer, _extends$c({
    ref: ref
  }, other, {
    children: orderedSlots.map(([Component, otherProps], index) => /*#__PURE__*/jsx(Component, _extends$c({}, otherProps), index))
  }));
});
const GridColumnMenu = /*#__PURE__*/React$1.forwardRef(function GridColumnMenu(props, ref) {
  return /*#__PURE__*/jsx(GridGenericColumnMenu, _extends$c({}, props, {
    ref: ref,
    defaultSlots: GRID_COLUMN_MENU_SLOTS,
    defaultSlotProps: GRID_COLUMN_MENU_SLOT_PROPS
  }));
});
process.env.NODE_ENV !== "production" ? GridColumnMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  hideMenu: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelledby: PropTypes.string,
  open: PropTypes.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: PropTypes.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: PropTypes.object
} : void 0;

const _excluded$F = ["className"];
const useUtilityClasses$m = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['panelContent']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelContentRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'PanelContent',
  overridesResolver: (props, styles) => styles.panelContent
})({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  flex: '1 1',
  maxHeight: 400
});
function GridPanelContent(props) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$F);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$m(rootProps);
  return /*#__PURE__*/jsx(GridPanelContentRoot, _extends$c({
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other));
}
process.env.NODE_ENV !== "production" ? GridPanelContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$E = ["className"];
const useUtilityClasses$l = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['panelFooter']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelFooterRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'PanelFooter',
  overridesResolver: (props, styles) => styles.panelFooter
})(({
  theme
}) => ({
  padding: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'space-between'
}));
function GridPanelFooter(props) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$E);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$l(rootProps);
  return /*#__PURE__*/jsx(GridPanelFooterRoot, _extends$c({
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other));
}
process.env.NODE_ENV !== "production" ? GridPanelFooter.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$D = ["className"];
const useUtilityClasses$k = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['panelHeader']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelHeaderRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'PanelHeader',
  overridesResolver: (props, styles) => styles.panelHeader
})(({
  theme
}) => ({
  padding: theme.spacing(1)
}));
function GridPanelHeader(props) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$D);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$k(rootProps);
  return /*#__PURE__*/jsx(GridPanelHeaderRoot, _extends$c({
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other));
}
process.env.NODE_ENV !== "production" ? GridPanelHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$C = ["className", "slotProps"];
const useUtilityClasses$j = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['panelWrapper']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridPanelWrapperRoot = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'PanelWrapper',
  overridesResolver: (props, styles) => styles.panelWrapper
})({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  '&:focus': {
    outline: 0
  }
});
const isEnabled = () => true;
const GridPanelWrapper = /*#__PURE__*/React$1.forwardRef(function GridPanelWrapper(props, ref) {
  const {
      className,
      slotProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$C);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$j(rootProps);
  return /*#__PURE__*/jsx(BaseFocusTrap, _extends$c({
    open: true,
    disableEnforceFocus: true,
    isEnabled: isEnabled
  }, slotProps.TrapFocus, {
    children: /*#__PURE__*/jsx(GridPanelWrapperRoot, _extends$c({
      ref: ref,
      tabIndex: -1,
      className: clsx(className, classes.root),
      ownerState: rootProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? GridPanelWrapper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: PropTypes.object
} : void 0;

// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.

const GRID_EXPERIMENTAL_ENABLED = false;

const _excluded$B = ["sort", "searchPredicate", "autoFocusSearchField", "disableHideAllButton", "disableShowAllButton", "getTogglableColumns"];
const useUtilityClasses$i = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['columnsPanel'],
    columnsPanelRow: ['columnsPanelRow']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnsPanelRoot = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'ColumnsPanel',
  overridesResolver: (props, styles) => styles.columnsPanel
})({
  padding: '8px 0px 8px 8px'
});
const GridColumnsPanelRowRoot = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'ColumnsPanelRow',
  overridesResolver: (props, styles) => styles.columnsPanelRow
})(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '1px 8px 1px 7px',
  [`& .${switchClasses.root}`]: {
    marginRight: theme.spacing(0.5)
  }
}));
const GridIconButtonRoot = styled$3(IconButton$1)({
  justifyContent: 'flex-end'
});
const collator$1 = new Intl.Collator();
const defaultSearchPredicate = (column, searchValue) => {
  return (column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
};
function GridColumnsPanel(props) {
  var _rootProps$slotProps, _rootProps$slotProps3, _rootProps$slotProps4;
  const apiRef = useGridApiContext();
  const searchInputRef = React$1.useRef(null);
  const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  const columnVisibilityModel = useGridSelector(apiRef, gridColumnVisibilityModelSelector);
  const rootProps = useGridRootProps();
  const [searchValue, setSearchValue] = React$1.useState('');
  const classes = useUtilityClasses$i(rootProps);
  const {
      sort,
      searchPredicate = defaultSearchPredicate,
      autoFocusSearchField = true,
      disableHideAllButton = false,
      disableShowAllButton = false,
      getTogglableColumns
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$B);
  const sortedColumns = React$1.useMemo(() => {
    switch (sort) {
      case 'asc':
        return [...columns].sort((a, b) => collator$1.compare(a.headerName || a.field, b.headerName || b.field));
      case 'desc':
        return [...columns].sort((a, b) => -collator$1.compare(a.headerName || a.field, b.headerName || b.field));
      default:
        return columns;
    }
  }, [columns, sort]);
  const toggleColumn = event => {
    const {
      name: field
    } = event.target;
    apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
  };
  const toggleAllColumns = React$1.useCallback(isVisible => {
    const currentModel = gridColumnVisibilityModelSelector(apiRef);
    const newModel = _extends$c({}, currentModel);
    const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
    columns.forEach(col => {
      if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
        if (isVisible) {
          // delete the key from the model instead of setting it to `true`
          delete newModel[col.field];
        } else {
          newModel[col.field] = false;
        }
      }
    });
    return apiRef.current.setColumnVisibilityModel(newModel);
  }, [apiRef, columns, getTogglableColumns]);
  const handleSearchValueChange = React$1.useCallback(event => {
    setSearchValue(event.target.value);
  }, []);
  const currentColumns = React$1.useMemo(() => {
    const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
    const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({
      field
    }) => togglableColumns.includes(field)) : sortedColumns;
    if (!searchValue) {
      return togglableSortedColumns;
    }
    return togglableSortedColumns.filter(column => searchPredicate(column, searchValue.toLowerCase()));
  }, [sortedColumns, searchValue, searchPredicate, getTogglableColumns]);
  const firstSwitchRef = React$1.useRef(null);
  React$1.useEffect(() => {
    if (autoFocusSearchField) {
      searchInputRef.current.focus();
    } else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') {
      firstSwitchRef.current.focus();
    }
  }, [autoFocusSearchField]);
  let firstHideableColumnFound = false;
  const isFirstHideableColumn = column => {
    if (firstHideableColumnFound === false && column.hideable !== false) {
      firstHideableColumnFound = true;
      return true;
    }
    return false;
  };
  return /*#__PURE__*/jsxs(GridPanelWrapper, _extends$c({}, other, {
    children: [/*#__PURE__*/jsx(GridPanelHeader, {
      children: /*#__PURE__*/jsx(rootProps.slots.baseTextField, _extends$c({
        label: apiRef.current.getLocaleText('columnsPanelTextFieldLabel'),
        placeholder: apiRef.current.getLocaleText('columnsPanelTextFieldPlaceholder'),
        inputRef: searchInputRef,
        value: searchValue,
        onChange: handleSearchValueChange,
        variant: "standard",
        fullWidth: true
      }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField))
    }), /*#__PURE__*/jsx(GridPanelContent, {
      children: /*#__PURE__*/jsx(GridColumnsPanelRoot, {
        className: classes.root,
        ownerState: rootProps,
        children: currentColumns.map(column => {
          var _rootProps$slotProps2;
          return /*#__PURE__*/jsxs(GridColumnsPanelRowRoot, {
            className: classes.columnsPanelRow,
            ownerState: rootProps,
            children: [/*#__PURE__*/jsx(FormControlLabel$1, {
              control: /*#__PURE__*/jsx(rootProps.slots.baseSwitch, _extends$c({
                disabled: column.hideable === false,
                checked: columnVisibilityModel[column.field] !== false,
                onClick: toggleColumn,
                name: column.field,
                size: "small",
                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
              }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSwitch)),
              label: column.headerName || column.field
            }), !rootProps.disableColumnReorder && GRID_EXPERIMENTAL_ENABLED && /*#__PURE__*/jsx(GridIconButtonRoot, {
              draggable: true,
              "aria-label": apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
              title: apiRef.current.getLocaleText('columnsPanelDragIconLabel'),
              size: "small",
              disabled: true,
              children: /*#__PURE__*/jsx(rootProps.slots.columnReorderIcon, {})
            })]
          }, column.field);
        })
      })
    }), disableShowAllButton && disableHideAllButton ? null : /*#__PURE__*/jsxs(GridPanelFooter, {
      children: [!disableHideAllButton ? /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
        onClick: () => toggleAllColumns(false)
      }, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseButton, {
        disabled: disableHideAllButton,
        children: apiRef.current.getLocaleText('columnsPanelHideAllButton')
      })) : /*#__PURE__*/jsx("span", {}), !disableShowAllButton ? /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
        onClick: () => toggleAllColumns(true)
      }, (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseButton, {
        disabled: disableShowAllButton,
        children: apiRef.current.getLocaleText('columnsPanelShowAllButton')
      })) : null]
    })]
  }));
}
process.env.NODE_ENV !== "production" ? GridColumnsPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */
  autoFocusSearchField: PropTypes.bool,
  /**
   * If `true`, the `Hide all` button will not be displayed.
   * @default false
   */
  disableHideAllButton: PropTypes.bool,
  /**
   * If `true`, the `Show all` button will be disabled
   * @default false
   */
  disableShowAllButton: PropTypes.bool,
  /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */
  getTogglableColumns: PropTypes.func,
  searchPredicate: PropTypes.func,
  slotProps: PropTypes.object,
  sort: PropTypes.oneOf(['asc', 'desc'])
} : void 0;

const _excluded$A = ["children", "className", "classes"];
const gridPanelClasses = generateUtilityClasses('MuiDataGrid', ['panel', 'paper']);
const GridPanelRoot = styled$3(Popper, {
  name: 'MuiDataGrid',
  slot: 'Panel',
  overridesResolver: (props, styles) => styles.panel
})(({
  theme
}) => ({
  zIndex: theme.zIndex.modal
}));
const GridPaperRoot = styled$3(Paper, {
  name: 'MuiDataGrid',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  minWidth: 300,
  maxHeight: 450,
  display: 'flex'
}));
const GridPanel = /*#__PURE__*/React$1.forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$A);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const classes = gridPanelClasses;
  const [isPlaced, setIsPlaced] = React$1.useState(false);
  const handleClickAway = React$1.useCallback(() => {
    apiRef.current.hidePreferences();
  }, [apiRef]);
  const handleKeyDown = React$1.useCallback(event => {
    if (isEscapeKey(event.key)) {
      apiRef.current.hidePreferences();
    }
  }, [apiRef]);
  const modifiers = React$1.useMemo(() => [{
    name: 'flip',
    enabled: false
  }, {
    name: 'isPlaced',
    enabled: true,
    phase: 'main',
    fn: () => {
      setIsPlaced(true);
    },
    effect: () => () => {
      setIsPlaced(false);
    }
  }], []);
  const [anchorEl, setAnchorEl] = React$1.useState(null);
  React$1.useEffect(() => {
    var _apiRef$current$rootE;
    const columnHeadersElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null || (_apiRef$current$rootE = _apiRef$current$rootE.current) == null ? void 0 : _apiRef$current$rootE.querySelector(`.${gridClasses.columnHeaders}`);
    if (columnHeadersElement) {
      setAnchorEl(columnHeadersElement);
    }
  }, [apiRef]);
  if (!anchorEl) {
    return null;
  }
  return /*#__PURE__*/jsx(GridPanelRoot, _extends$c({
    ref: ref,
    placement: "bottom-start",
    className: clsx(className, classes.panel),
    ownerState: rootProps,
    anchorEl: anchorEl,
    modifiers: modifiers
  }, other, {
    children: /*#__PURE__*/jsx(ClickAwayListener, {
      mouseEvent: "onMouseUp",
      onClickAway: handleClickAway,
      children: /*#__PURE__*/jsx(GridPaperRoot, {
        className: classes.paper,
        ownerState: rootProps,
        elevation: 8,
        onKeyDown: handleKeyDown,
        children: isPlaced && children
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? GridPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Popper render function or node.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  ownerState: PropTypes.object
} : void 0;

const GridPreferencesPanel = /*#__PURE__*/React$1.forwardRef(function GridPreferencesPanel(props, ref) {
  var _preferencePanelState, _rootProps$slotProps, _rootProps$slotProps2;
  const apiRef = useGridApiContext();
  const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  const rootProps = useGridRootProps();
  const preferencePanelState = useGridSelector(apiRef, gridPreferencePanelStateSelector);
  const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, (_preferencePanelState = preferencePanelState.openedPanelValue) != null ? _preferencePanelState : GridPreferencePanelsValue.filters);
  return /*#__PURE__*/jsx(rootProps.slots.panel, _extends$c({
    ref: ref,
    as: rootProps.slots.basePopper,
    open: columns.length > 0 && preferencePanelState.open,
    id: preferencePanelState.panelId,
    "aria-labelledby": preferencePanelState.labelId
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.panel, props, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.basePopper, {
    children: panelContent
  }));
});

const _excluded$z = ["item", "hasMultipleFilters", "deleteFilter", "applyFilterChanges", "multiFilterOperator", "showMultiFilterOperators", "disableMultiFilterOperator", "applyMultiFilterOperatorChanges", "focusElementRef", "logicOperators", "columnsSort", "filterColumns", "deleteIconProps", "logicOperatorInputProps", "operatorInputProps", "columnInputProps", "valueInputProps", "children"],
  _excluded2$4 = ["InputComponentProps"];
const useUtilityClasses$h = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['filterForm'],
    deleteIcon: ['filterFormDeleteIcon'],
    logicOperatorInput: ['filterFormLogicOperatorInput'],
    columnInput: ['filterFormColumnInput'],
    operatorInput: ['filterFormOperatorInput'],
    valueInput: ['filterFormValueInput']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridFilterFormRoot = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterForm',
  overridesResolver: (props, styles) => styles.filterForm
})(({
  theme
}) => ({
  display: 'flex',
  padding: theme.spacing(1)
}));
const FilterFormDeleteIcon = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterFormDeleteIcon',
  overridesResolver: (_, styles) => styles.filterFormDeleteIcon
})(({
  theme
}) => ({
  flexShrink: 0,
  justifyContent: 'flex-end',
  marginRight: theme.spacing(0.5),
  marginBottom: theme.spacing(0.2)
}));
const FilterFormLogicOperatorInput = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterFormLogicOperatorInput',
  overridesResolver: (_, styles) => styles.filterFormLogicOperatorInput
})({
  minWidth: 55,
  marginRight: 5,
  justifyContent: 'end'
});
const FilterFormColumnInput = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterFormColumnInput',
  overridesResolver: (_, styles) => styles.filterFormColumnInput
})({
  width: 150
});
const FilterFormOperatorInput = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterFormOperatorInput',
  overridesResolver: (_, styles) => styles.filterFormOperatorInput
})({
  width: 120
});
const FilterFormValueInput = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'FilterFormValueInput',
  overridesResolver: (_, styles) => styles.filterFormValueInput
})({
  width: 190
});
const getLogicOperatorLocaleKey = logicOperator => {
  switch (logicOperator) {
    case GridLogicOperator.And:
      return 'filterPanelOperatorAnd';
    case GridLogicOperator.Or:
      return 'filterPanelOperatorOr';
    default:
      throw new Error('MUI: Invalid `logicOperator` property in the `GridFilterPanel`.');
  }
};
const getColumnLabel = col => col.headerName || col.field;
const collator = new Intl.Collator();
const GridFilterForm = /*#__PURE__*/React$1.forwardRef(function GridFilterForm(props, ref) {
  var _rootProps$slotProps, _rootProps$slotProps2, _baseSelectProps$nati, _rootProps$slotProps3, _rootProps$slotProps4, _rootProps$slotProps5, _rootProps$slotProps6, _rootProps$slotProps7, _rootProps$slotProps8, _currentColumn$filter2;
  const {
      item,
      hasMultipleFilters,
      deleteFilter,
      applyFilterChanges,
      multiFilterOperator,
      showMultiFilterOperators,
      disableMultiFilterOperator,
      applyMultiFilterOperatorChanges,
      focusElementRef,
      logicOperators = [GridLogicOperator.And, GridLogicOperator.Or],
      columnsSort,
      filterColumns,
      deleteIconProps = {},
      logicOperatorInputProps = {},
      operatorInputProps = {},
      columnInputProps = {},
      valueInputProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$z);
  const apiRef = useGridApiContext();
  const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const columnSelectId = useId();
  const columnSelectLabelId = useId();
  const operatorSelectId = useId();
  const operatorSelectLabelId = useId();
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$h(rootProps);
  const valueRef = React$1.useRef(null);
  const filterSelectorRef = React$1.useRef(null);
  const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
  const baseFormControlProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseFormControl) || {};
  const baseSelectProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelect) || {};
  const isBaseSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
  const baseInputLabelProps = ((_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel) || {};
  const baseSelectOptionProps = ((_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption) || {};
  const {
      InputComponentProps
    } = valueInputProps,
    valueInputPropsOther = _objectWithoutPropertiesLoose$b(valueInputProps, _excluded2$4);
  const filteredColumns = React$1.useMemo(() => {
    if (filterColumns === undefined || typeof filterColumns !== 'function') {
      return filterableColumns;
    }
    const filteredFields = filterColumns({
      field: item.field,
      columns: filterableColumns,
      currentFilters: (filterModel == null ? void 0 : filterModel.items) || []
    });
    return filterableColumns.filter(column => filteredFields.includes(column.field));
  }, [filterColumns, filterModel == null ? void 0 : filterModel.items, filterableColumns, item.field]);
  const sortedFilteredColumns = React$1.useMemo(() => {
    switch (columnsSort) {
      case 'asc':
        return filteredColumns.sort((a, b) => collator.compare(getColumnLabel(a), getColumnLabel(b)));
      case 'desc':
        return filteredColumns.sort((a, b) => -collator.compare(getColumnLabel(a), getColumnLabel(b)));
      default:
        return filteredColumns;
    }
  }, [filteredColumns, columnsSort]);
  const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
  const currentOperator = React$1.useMemo(() => {
    var _currentColumn$filter;
    if (!item.operator || !currentColumn) {
      return null;
    }
    return (_currentColumn$filter = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter.find(operator => operator.value === item.operator);
  }, [item, currentColumn]);
  const changeColumn = React$1.useCallback(event => {
    const field = event.target.value;
    const column = apiRef.current.getColumn(field);
    if (column.field === currentColumn.field) {
      // column did not change
      return;
    }

    // try to keep the same operator when column change
    const newOperator = column.filterOperators.find(operator => operator.value === item.operator) || column.filterOperators[0];

    // Erase filter value if the input component is modified
    const eraseItemValue = !newOperator.InputComponent || newOperator.InputComponent !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
    applyFilterChanges(_extends$c({}, item, {
      field,
      operator: newOperator.value,
      value: eraseItemValue ? undefined : item.value
    }));
  }, [apiRef, applyFilterChanges, item, currentColumn, currentOperator]);
  const changeOperator = React$1.useCallback(event => {
    const operator = event.target.value;
    const newOperator = currentColumn == null ? void 0 : currentColumn.filterOperators.find(op => op.value === operator);
    const eraseItemValue = !(newOperator != null && newOperator.InputComponent) || (newOperator == null ? void 0 : newOperator.InputComponent) !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
    applyFilterChanges(_extends$c({}, item, {
      operator,
      value: eraseItemValue ? undefined : item.value
    }));
  }, [applyFilterChanges, item, currentColumn, currentOperator]);
  const changeLogicOperator = React$1.useCallback(event => {
    const logicOperator = event.target.value === GridLogicOperator.And.toString() ? GridLogicOperator.And : GridLogicOperator.Or;
    applyMultiFilterOperatorChanges(logicOperator);
  }, [applyMultiFilterOperatorChanges]);
  const handleDeleteFilter = () => {
    if (rootProps.disableMultipleColumnsFiltering) {
      if (item.value === undefined) {
        deleteFilter(item);
      } else {
        // TODO v6: simplify the behavior by always remove the filter form
        applyFilterChanges(_extends$c({}, item, {
          value: undefined
        }));
      }
    } else {
      deleteFilter(item);
    }
  };
  React$1.useImperativeHandle(focusElementRef, () => ({
    focus: () => {
      if (currentOperator != null && currentOperator.InputComponent) {
        var _valueRef$current;
        valueRef == null || (_valueRef$current = valueRef.current) == null || _valueRef$current.focus();
      } else {
        filterSelectorRef.current.focus();
      }
    }
  }), [currentOperator]);
  return /*#__PURE__*/jsxs(GridFilterFormRoot, _extends$c({
    ref: ref,
    className: classes.root,
    "data-id": item.id,
    ownerState: rootProps
  }, other, {
    children: [/*#__PURE__*/jsx(FilterFormDeleteIcon, _extends$c({
      variant: "standard",
      as: rootProps.slots.baseFormControl
    }, baseFormControlProps, deleteIconProps, {
      className: clsx(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
      ownerState: rootProps,
      children: /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
        "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
        title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
        onClick: handleDeleteFilter,
        size: "small"
      }, (_rootProps$slotProps5 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps5.baseIconButton, {
        children: /*#__PURE__*/jsx(rootProps.slots.filterPanelDeleteIcon, {
          fontSize: "small"
        })
      }))
    })), /*#__PURE__*/jsx(FilterFormLogicOperatorInput, _extends$c({
      variant: "standard",
      as: rootProps.slots.baseFormControl
    }, baseFormControlProps, logicOperatorInputProps, {
      sx: _extends$c({
        display: hasLogicOperatorColumn ? 'flex' : 'none',
        visibility: showMultiFilterOperators ? 'visible' : 'hidden'
      }, baseFormControlProps.sx || {}, logicOperatorInputProps.sx || {}),
      className: clsx(classes.logicOperatorInput, baseFormControlProps.className, logicOperatorInputProps.className),
      ownerState: rootProps,
      children: /*#__PURE__*/jsx(rootProps.slots.baseSelect, _extends$c({
        inputProps: {
          'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
        },
        value: multiFilterOperator,
        onChange: changeLogicOperator,
        disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
        native: isBaseSelectNative
      }, (_rootProps$slotProps6 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps6.baseSelect, {
        children: logicOperators.map(logicOperator => /*#__PURE__*/createElement(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isBaseSelectNative,
          key: logicOperator.toString(),
          value: logicOperator.toString()
        }), apiRef.current.getLocaleText(getLogicOperatorLocaleKey(logicOperator))))
      }))
    })), /*#__PURE__*/jsxs(FilterFormColumnInput, _extends$c({
      variant: "standard",
      as: rootProps.slots.baseFormControl
    }, baseFormControlProps, columnInputProps, {
      className: clsx(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
      ownerState: rootProps,
      children: [/*#__PURE__*/jsx(rootProps.slots.baseInputLabel, _extends$c({}, baseInputLabelProps, {
        htmlFor: columnSelectId,
        id: columnSelectLabelId,
        children: apiRef.current.getLocaleText('filterPanelColumns')
      })), /*#__PURE__*/jsx(rootProps.slots.baseSelect, _extends$c({
        labelId: columnSelectLabelId,
        id: columnSelectId,
        label: apiRef.current.getLocaleText('filterPanelColumns'),
        value: item.field || '',
        onChange: changeColumn,
        native: isBaseSelectNative
      }, (_rootProps$slotProps7 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps7.baseSelect, {
        children: sortedFilteredColumns.map(col => /*#__PURE__*/createElement(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isBaseSelectNative,
          key: col.field,
          value: col.field
        }), getColumnLabel(col)))
      }))]
    })), /*#__PURE__*/jsxs(FilterFormOperatorInput, _extends$c({
      variant: "standard",
      as: rootProps.slots.baseFormControl
    }, baseFormControlProps, operatorInputProps, {
      className: clsx(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
      ownerState: rootProps,
      children: [/*#__PURE__*/jsx(rootProps.slots.baseInputLabel, _extends$c({}, baseInputLabelProps, {
        htmlFor: operatorSelectId,
        id: operatorSelectLabelId,
        children: apiRef.current.getLocaleText('filterPanelOperator')
      })), /*#__PURE__*/jsx(rootProps.slots.baseSelect, _extends$c({
        labelId: operatorSelectLabelId,
        label: apiRef.current.getLocaleText('filterPanelOperator'),
        id: operatorSelectId,
        value: item.operator,
        onChange: changeOperator,
        native: isBaseSelectNative,
        inputRef: filterSelectorRef
      }, (_rootProps$slotProps8 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps8.baseSelect, {
        children: currentColumn == null || (_currentColumn$filter2 = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter2.map(operator => /*#__PURE__*/createElement(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isBaseSelectNative,
          key: operator.value,
          value: operator.value
        }), operator.label || apiRef.current.getLocaleText(`filterOperator${capitalize(operator.value)}`)))
      }))]
    })), /*#__PURE__*/jsx(FilterFormValueInput, _extends$c({
      variant: "standard",
      as: rootProps.slots.baseFormControl
    }, baseFormControlProps, valueInputPropsOther, {
      className: clsx(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
      ownerState: rootProps,
      children: currentOperator != null && currentOperator.InputComponent ? /*#__PURE__*/jsx(currentOperator.InputComponent, _extends$c({
        apiRef: apiRef,
        item: item,
        applyValue: applyFilterChanges,
        focusElementRef: valueRef
      }, currentOperator.InputComponentProps, InputComponentProps)) : null
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? GridFilterForm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */
  applyFilterChanges: PropTypes.func.isRequired,
  /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */
  applyMultiFilterOperatorChanges: PropTypes.func.isRequired,
  /**
   * @ignore - do not document.
   */
  children: PropTypes.node,
  /**
   * Props passed to the column input component.
   * @default {}
   */
  columnInputProps: PropTypes.any,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: PropTypes.oneOf(['asc', 'desc']),
  /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */
  deleteFilter: PropTypes.func.isRequired,
  /**
   * Props passed to the delete icon.
   * @default {}
   */
  deleteIconProps: PropTypes.any,
  /**
   * If `true`, disables the logic operator field but still renders it.
   */
  disableMultiFilterOperator: PropTypes.bool,
  /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */
  filterColumns: PropTypes.func,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */
  hasMultipleFilters: PropTypes.bool.isRequired,
  /**
   * The [[GridFilterItem]] representing this form.
   */
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  /**
   * Props passed to the logic operator input component.
   * @default {}
   */
  logicOperatorInputProps: PropTypes.any,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: PropTypes.arrayOf(PropTypes.oneOf(['and', 'or']).isRequired),
  /**
   * The current logic operator applied.
   */
  multiFilterOperator: PropTypes.oneOf(['and', 'or']),
  /**
   * Props passed to the operator input component.
   * @default {}
   */
  operatorInputProps: PropTypes.any,
  /**
   * If `true`, the logic operator field is visible.
   */
  showMultiFilterOperators: PropTypes.bool,
  /**
   * Props passed to the value input component.
   * @default {}
   */
  valueInputProps: PropTypes.any
} : void 0;

class Timeout {
  constructor() {
    this.currentId = 0;
    this.clear = () => {
      if (this.currentId !== 0) {
        clearTimeout(this.currentId);
        this.currentId = 0;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(fn, delay);
  }
}
function useTimeout() {
  const timeout = useLazyRef(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

const _excluded$y = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps"];
function GridFilterInputValue(props) {
  var _item$value, _rootProps$slotProps;
  const {
      item,
      applyValue,
      type,
      apiRef,
      focusElementRef,
      tabIndex,
      disabled,
      clearButton,
      InputProps
    } = props,
    others = _objectWithoutPropertiesLoose$b(props, _excluded$y);
  const filterTimeout = useTimeout();
  const [filterValueState, setFilterValueState] = React$1.useState((_item$value = item.value) != null ? _item$value : '');
  const [applying, setIsApplying] = React$1.useState(false);
  const id = useId();
  const rootProps = useGridRootProps();
  const onFilterChange = React$1.useCallback(event => {
    const {
      value
    } = event.target;
    setFilterValueState(String(value));
    setIsApplying(true);
    filterTimeout.start(rootProps.filterDebounceMs, () => {
      const newItem = _extends$c({}, item, {
        value,
        fromInput: id
      });
      applyValue(newItem);
      setIsApplying(false);
    });
  }, [id, applyValue, item, rootProps.filterDebounceMs, filterTimeout]);
  React$1.useEffect(() => {
    const itemPlusTag = item;
    if (itemPlusTag.fromInput !== id) {
      var _item$value2;
      setFilterValueState(String((_item$value2 = item.value) != null ? _item$value2 : ''));
    }
  }, [id, item]);
  return /*#__PURE__*/jsx(rootProps.slots.baseTextField, _extends$c({
    id: id,
    label: apiRef.current.getLocaleText('filterPanelInputLabel'),
    placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
    value: filterValueState,
    onChange: onFilterChange,
    variant: "standard",
    type: type || 'text',
    InputProps: _extends$c({}, applying || clearButton ? {
      endAdornment: applying ? /*#__PURE__*/jsx(rootProps.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : clearButton
    } : {}, {
      disabled
    }, InputProps, {
      inputProps: _extends$c({
        tabIndex
      }, InputProps == null ? void 0 : InputProps.inputProps)
    }),
    InputLabelProps: {
      shrink: true
    },
    inputRef: focusElementRef
  }, others, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}
process.env.NODE_ENV !== "production" ? GridFilterInputValue.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
} : void 0;

const _excluded$x = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function GridFilterInputDate(props) {
  var _item$value, _rootProps$slotProps;
  const {
      item,
      applyValue,
      type,
      apiRef,
      focusElementRef,
      InputProps,
      clearButton,
      tabIndex,
      disabled
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$x);
  const filterTimeout = useTimeout();
  const [filterValueState, setFilterValueState] = React$1.useState((_item$value = item.value) != null ? _item$value : '');
  const [applying, setIsApplying] = React$1.useState(false);
  const id = useId();
  const rootProps = useGridRootProps();
  const onFilterChange = React$1.useCallback(event => {
    const value = event.target.value;
    setFilterValueState(String(value));
    setIsApplying(true);
    filterTimeout.start(rootProps.filterDebounceMs, () => {
      applyValue(_extends$c({}, item, {
        value
      }));
      setIsApplying(false);
    });
  }, [applyValue, item, rootProps.filterDebounceMs, filterTimeout]);
  React$1.useEffect(() => {
    var _item$value2;
    const itemValue = (_item$value2 = item.value) != null ? _item$value2 : '';
    setFilterValueState(String(itemValue));
  }, [item.value]);
  return /*#__PURE__*/jsx(rootProps.slots.baseTextField, _extends$c({
    fullWidth: true,
    id: id,
    label: apiRef.current.getLocaleText('filterPanelInputLabel'),
    placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
    value: filterValueState,
    onChange: onFilterChange,
    variant: "standard",
    type: type || 'text',
    InputLabelProps: {
      shrink: true
    },
    inputRef: focusElementRef,
    InputProps: _extends$c({}, applying || clearButton ? {
      endAdornment: applying ? /*#__PURE__*/jsx(rootProps.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : clearButton
    } : {}, {
      disabled
    }, InputProps, {
      inputProps: _extends$c({
        max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
        tabIndex
      }, InputProps == null ? void 0 : InputProps.inputProps)
    })
  }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
}
process.env.NODE_ENV !== "production" ? GridFilterInputDate.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
} : void 0;

const _excluded$w = ["item", "applyValue", "type", "apiRef", "focusElementRef", "getOptionLabel", "getOptionValue", "placeholder", "tabIndex", "label", "isFilterActive", "clearButton", "InputLabelProps"];
const renderSingleSelectOptions = ({
  column: {
    valueOptions,
    field
  },
  OptionComponent,
  getOptionLabel,
  getOptionValue,
  isSelectNative,
  baseSelectOptionProps
}) => {
  const iterableColumnValues = typeof valueOptions === 'function' ? ['', ...valueOptions({
    field
  })] : ['', ...(valueOptions || [])];
  return iterableColumnValues.map(option => {
    const value = getOptionValue(option);
    const label = getOptionLabel(option);
    return /*#__PURE__*/createElement(OptionComponent, _extends$c({}, baseSelectOptionProps, {
      native: isSelectNative,
      key: value,
      value: value
    }), label);
  });
};
const SingleSelectOperatorContainer = styled$3('div')({
  display: 'flex',
  alignItems: 'flex-end',
  width: '100%',
  [`& button`]: {
    margin: 'auto 0px 5px 5px'
  }
});
function GridFilterInputSingleSelect(props) {
  var _item$value, _rootProps$slotProps$, _rootProps$slotProps, _resolvedColumn, _resolvedColumn2, _rootProps$slotProps2, _rootProps$slotProps3, _rootProps$slotProps4;
  const {
      item,
      applyValue,
      type,
      apiRef,
      focusElementRef,
      getOptionLabel: getOptionLabelProp,
      getOptionValue: getOptionValueProp,
      placeholder,
      tabIndex,
      label: labelProp,
      clearButton
    } = props,
    others = _objectWithoutPropertiesLoose$b(props, _excluded$w);
  const [filterValueState, setFilterValueState] = React$1.useState((_item$value = item.value) != null ? _item$value : '');
  const id = useId();
  const labelId = useId();
  const rootProps = useGridRootProps();
  const isSelectNative = (_rootProps$slotProps$ = (_rootProps$slotProps = rootProps.slotProps) == null || (_rootProps$slotProps = _rootProps$slotProps.baseSelect) == null ? void 0 : _rootProps$slotProps.native) != null ? _rootProps$slotProps$ : true;
  let resolvedColumn = null;
  if (item.field) {
    const column = apiRef.current.getColumn(item.field);
    if (isSingleSelectColDef(column)) {
      resolvedColumn = column;
    }
  }
  const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
  const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
  const currentValueOptions = React$1.useMemo(() => {
    if (!resolvedColumn) {
      return undefined;
    }
    return typeof resolvedColumn.valueOptions === 'function' ? resolvedColumn.valueOptions({
      field: resolvedColumn.field
    }) : resolvedColumn.valueOptions;
  }, [resolvedColumn]);
  const onFilterChange = React$1.useCallback(event => {
    let value = event.target.value;

    // NativeSelect casts the value to a string.
    value = getValueFromValueOptions(value, currentValueOptions, getOptionValue);
    setFilterValueState(String(value));
    applyValue(_extends$c({}, item, {
      value
    }));
  }, [currentValueOptions, getOptionValue, applyValue, item]);
  React$1.useEffect(() => {
    var _itemValue;
    let itemValue;
    if (currentValueOptions !== undefined) {
      // sanitize if valueOptions are provided
      itemValue = getValueFromValueOptions(item.value, currentValueOptions, getOptionValue);
      if (itemValue !== item.value) {
        applyValue(_extends$c({}, item, {
          value: itemValue
        }));
        return;
      }
    } else {
      itemValue = item.value;
    }
    itemValue = (_itemValue = itemValue) != null ? _itemValue : '';
    setFilterValueState(String(itemValue));
  }, [item, currentValueOptions, applyValue, getOptionValue]);
  if (!isSingleSelectColDef(resolvedColumn)) {
    return null;
  }
  if (!isSingleSelectColDef(resolvedColumn)) {
    return null;
  }
  const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
  return /*#__PURE__*/jsxs(SingleSelectOperatorContainer, {
    children: [/*#__PURE__*/jsxs(rootProps.slots.baseFormControl, {
      children: [/*#__PURE__*/jsx(rootProps.slots.baseInputLabel, _extends$c({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseInputLabel, {
        id: labelId,
        htmlFor: id,
        shrink: true,
        variant: "standard",
        children: label
      })), /*#__PURE__*/jsx(rootProps.slots.baseSelect, _extends$c({
        id: id,
        label: label,
        labelId: labelId,
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || 'text',
        inputProps: {
          tabIndex,
          ref: focusElementRef,
          placeholder: placeholder != null ? placeholder : apiRef.current.getLocaleText('filterPanelInputPlaceholder')
        },
        native: isSelectNative
      }, others, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseSelect, {
        children: renderSingleSelectOptions({
          column: resolvedColumn,
          OptionComponent: rootProps.slots.baseSelectOption,
          getOptionLabel,
          getOptionValue,
          isSelectNative,
          baseSelectOptionProps: (_rootProps$slotProps4 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps4.baseSelectOption
        })
      }))]
    }), clearButton]
  });
}
process.env.NODE_ENV !== "production" ? GridFilterInputSingleSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: PropTypes.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: PropTypes.func,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
} : void 0;

const _excluded$v = ["item", "applyValue", "apiRef", "focusElementRef", "isFilterActive", "clearButton", "tabIndex", "label", "InputLabelProps"];
const BooleanOperatorContainer = styled$3('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  [`& button`]: {
    margin: 'auto 0px 5px 5px'
  }
});
function GridFilterInputBoolean(props) {
  var _rootProps$slotProps, _baseSelectProps$nati, _rootProps$slotProps2, _rootProps$slotProps3;
  const {
      item,
      applyValue,
      apiRef,
      focusElementRef,
      clearButton,
      tabIndex,
      label: labelProp
    } = props,
    others = _objectWithoutPropertiesLoose$b(props, _excluded$v);
  const [filterValueState, setFilterValueState] = React$1.useState(item.value || '');
  const rootProps = useGridRootProps();
  const labelId = useId();
  const selectId = useId();
  const baseSelectProps = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseSelect) || {};
  const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
  const baseSelectOptionProps = ((_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseSelectOption) || {};
  const onFilterChange = React$1.useCallback(event => {
    const value = event.target.value;
    setFilterValueState(value);
    applyValue(_extends$c({}, item, {
      value
    }));
  }, [applyValue, item]);
  React$1.useEffect(() => {
    setFilterValueState(item.value || '');
  }, [item.value]);
  const label = labelProp != null ? labelProp : apiRef.current.getLocaleText('filterPanelInputLabel');
  return /*#__PURE__*/jsxs(BooleanOperatorContainer, {
    children: [/*#__PURE__*/jsxs(rootProps.slots.baseFormControl, {
      fullWidth: true,
      children: [/*#__PURE__*/jsx(rootProps.slots.baseInputLabel, _extends$c({}, (_rootProps$slotProps3 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps3.baseInputLabel, {
        id: labelId,
        shrink: true,
        variant: "standard",
        children: label
      })), /*#__PURE__*/jsxs(rootProps.slots.baseSelect, _extends$c({
        labelId: labelId,
        id: selectId,
        label: label,
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        native: isSelectNative,
        displayEmpty: true,
        inputProps: {
          ref: focusElementRef,
          tabIndex
        }
      }, others, baseSelectProps, {
        children: [/*#__PURE__*/jsx(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isSelectNative,
          value: "",
          children: apiRef.current.getLocaleText('filterValueAny')
        })), /*#__PURE__*/jsx(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isSelectNative,
          value: "true",
          children: apiRef.current.getLocaleText('filterValueTrue')
        })), /*#__PURE__*/jsx(rootProps.slots.baseSelectOption, _extends$c({}, baseSelectOptionProps, {
          native: isSelectNative,
          value: "false",
          children: apiRef.current.getLocaleText('filterValueFalse')
        }))]
      }))]
    }), clearButton]
  });
}
process.env.NODE_ENV !== "production" ? GridFilterInputBoolean.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: refType$1,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (e.g. `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
} : void 0;

const _excluded$u = ["logicOperators", "columnsSort", "filterFormProps", "getColumnForNewFilter", "children", "disableAddFilterButton", "disableRemoveAllButton"];
const getGridFilter = col => ({
  field: col.field,
  operator: col.filterOperators[0].value,
  id: Math.round(Math.random() * 1e5)
});
const GridFilterPanel = /*#__PURE__*/React$1.forwardRef(function GridFilterPanel(props, ref) {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
  const lastFilterRef = React$1.useRef(null);
  const placeholderFilter = React$1.useRef(null);
  const {
      logicOperators = [GridLogicOperator.And, GridLogicOperator.Or],
      columnsSort,
      filterFormProps,
      getColumnForNewFilter,
      disableAddFilterButton = false,
      disableRemoveAllButton = false
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$u);
  const applyFilter = apiRef.current.upsertFilterItem;
  const applyFilterLogicOperator = React$1.useCallback(operator => {
    apiRef.current.setFilterLogicOperator(operator);
  }, [apiRef]);
  const getDefaultFilter = React$1.useCallback(() => {
    let nextColumnWithOperator;
    if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
      // To allow override the column for default (first) filter
      const nextFieldName = getColumnForNewFilter({
        currentFilters: (filterModel == null ? void 0 : filterModel.items) || [],
        columns: filterableColumns
      });
      if (nextFieldName === null) {
        return null;
      }
      nextColumnWithOperator = filterableColumns.find(({
        field
      }) => field === nextFieldName);
    } else {
      nextColumnWithOperator = filterableColumns.find(colDef => {
        var _colDef$filterOperato;
        return (_colDef$filterOperato = colDef.filterOperators) == null ? void 0 : _colDef$filterOperato.length;
      });
    }
    if (!nextColumnWithOperator) {
      return null;
    }
    return getGridFilter(nextColumnWithOperator);
  }, [filterModel == null ? void 0 : filterModel.items, filterableColumns, getColumnForNewFilter]);
  const getNewFilter = React$1.useCallback(() => {
    if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') {
      return getDefaultFilter();
    }
    const currentFilters = filterModel.items.length ? filterModel.items : [getDefaultFilter()].filter(Boolean);

    // If no items are there in filterModel, we have to pass defaultFilter
    const nextColumnFieldName = getColumnForNewFilter({
      currentFilters: currentFilters,
      columns: filterableColumns
    });
    if (nextColumnFieldName === null) {
      return null;
    }
    const nextColumnWithOperator = filterableColumns.find(({
      field
    }) => field === nextColumnFieldName);
    if (!nextColumnWithOperator) {
      return null;
    }
    return getGridFilter(nextColumnWithOperator);
  }, [filterModel.items, filterableColumns, getColumnForNewFilter, getDefaultFilter]);
  const items = React$1.useMemo(() => {
    if (filterModel.items.length) {
      return filterModel.items;
    }
    if (!placeholderFilter.current) {
      placeholderFilter.current = getDefaultFilter();
    }
    return placeholderFilter.current ? [placeholderFilter.current] : [];
  }, [filterModel.items, getDefaultFilter]);
  const hasMultipleFilters = items.length > 1;
  const addNewFilter = () => {
    const newFilter = getNewFilter();
    if (!newFilter) {
      return;
    }
    apiRef.current.upsertFilterItems([...items, newFilter]);
  };
  const deleteFilter = React$1.useCallback(item => {
    const shouldCloseFilterPanel = items.length === 1;
    apiRef.current.deleteFilterItem(item);
    if (shouldCloseFilterPanel) {
      apiRef.current.hideFilterPanel();
    }
  }, [apiRef, items.length]);
  const handleRemoveAll = () => {
    if (items.length === 1 && items[0].value === undefined) {
      apiRef.current.deleteFilterItem(items[0]);
      apiRef.current.hideFilterPanel();
    }
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      items: []
    }));
  };
  React$1.useEffect(() => {
    if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) {
      applyFilterLogicOperator(logicOperators[0]);
    }
  }, [logicOperators, applyFilterLogicOperator, filterModel.logicOperator]);
  React$1.useEffect(() => {
    if (items.length > 0) {
      lastFilterRef.current.focus();
    }
  }, [items.length]);
  return /*#__PURE__*/jsxs(GridPanelWrapper, _extends$c({
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsx(GridPanelContent, {
      children: items.map((item, index) => /*#__PURE__*/jsx(GridFilterForm, _extends$c({
        item: item,
        applyFilterChanges: applyFilter,
        deleteFilter: deleteFilter,
        hasMultipleFilters: hasMultipleFilters,
        showMultiFilterOperators: index > 0,
        multiFilterOperator: filterModel.logicOperator,
        disableMultiFilterOperator: index !== 1,
        applyMultiFilterOperatorChanges: applyFilterLogicOperator,
        focusElementRef: index === items.length - 1 ? lastFilterRef : null,
        logicOperators: logicOperators,
        columnsSort: columnsSort
      }, filterFormProps), item.id == null ? index : item.id))
    }), !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/jsxs(GridPanelFooter, {
      children: [!disableAddFilterButton ? /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
        onClick: addNewFilter,
        startIcon: /*#__PURE__*/jsx(rootProps.slots.filterPanelAddIcon, {})
      }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
        children: apiRef.current.getLocaleText('filterPanelAddFilter')
      })) : /*#__PURE__*/jsx("span", {}), !disableRemoveAllButton ? /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
        onClick: handleRemoveAll,
        startIcon: /*#__PURE__*/jsx(rootProps.slots.filterPanelRemoveAllIcon, {})
      }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseButton, {
        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
      })) : null]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? GridFilterPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore - do not document.
   */
  children: PropTypes.node,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: PropTypes.oneOf(['asc', 'desc']),
  /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */
  disableAddFilterButton: PropTypes.bool,
  /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */
  disableRemoveAllButton: PropTypes.bool,
  /**
   * Props passed to each filter form.
   */
  filterFormProps: PropTypes.shape({
    columnInputProps: PropTypes.any,
    columnsSort: PropTypes.oneOf(['asc', 'desc']),
    deleteIconProps: PropTypes.any,
    filterColumns: PropTypes.func,
    logicOperatorInputProps: PropTypes.any,
    operatorInputProps: PropTypes.any,
    valueInputProps: PropTypes.any
  }),
  /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */
  getColumnForNewFilter: PropTypes.func,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: PropTypes.arrayOf(PropTypes.oneOf(['and', 'or']).isRequired),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$t = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"];
function GridFilterInputMultipleValue(props) {
  const {
      item,
      applyValue,
      type,
      apiRef,
      focusElementRef,
      color,
      error,
      helperText,
      size,
      variant
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$t);
  const TextFieldProps = {
    color,
    error,
    helperText,
    size,
    variant
  };
  const [filterValueState, setFilterValueState] = React$1.useState(item.value || []);
  const id = useId();
  const rootProps = useGridRootProps();
  React$1.useEffect(() => {
    var _item$value;
    const itemValue = (_item$value = item.value) != null ? _item$value : [];
    setFilterValueState(itemValue.map(String));
  }, [item.value]);
  const handleChange = React$1.useCallback((event, value) => {
    setFilterValueState(value.map(String));
    applyValue(_extends$c({}, item, {
      value: [...value]
    }));
  }, [applyValue, item]);
  return /*#__PURE__*/jsx(Autocomplete$1, _extends$c({
    multiple: true,
    freeSolo: true,
    options: [],
    filterOptions: (options, params) => {
      const {
        inputValue
      } = params;
      return inputValue == null || inputValue === '' ? [] : [inputValue];
    },
    id: id,
    value: filterValueState,
    onChange: handleChange,
    renderTags: (value, getTagProps) => value.map((option, index) => /*#__PURE__*/jsx(rootProps.slots.baseChip, _extends$c({
      variant: "outlined",
      size: "small",
      label: option
    }, getTagProps({
      index
    })))),
    renderInput: params => {
      var _rootProps$slotProps;
      return /*#__PURE__*/jsx(rootProps.slots.baseTextField, _extends$c({}, params, {
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        InputLabelProps: _extends$c({}, params.InputLabelProps, {
          shrink: true
        }),
        inputRef: focusElementRef,
        type: type || 'text'
      }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
    }
  }, other));
}
process.env.NODE_ENV !== "production" ? GridFilterInputMultipleValue.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  type: PropTypes.oneOf(['number', 'text'])
} : void 0;

const _excluded$s = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant", "getOptionLabel", "getOptionValue"];
const filter = createFilterOptions$1();
function GridFilterInputMultipleSingleSelect(props) {
  var _resolvedColumn, _resolvedColumn2;
  const {
      item,
      applyValue,
      apiRef,
      focusElementRef,
      color,
      error,
      helperText,
      size,
      variant = 'standard',
      getOptionLabel: getOptionLabelProp,
      getOptionValue: getOptionValueProp
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$s);
  const TextFieldProps = {
    color,
    error,
    helperText,
    size,
    variant
  };
  const id = useId();
  const rootProps = useGridRootProps();
  let resolvedColumn = null;
  if (item.field) {
    const column = apiRef.current.getColumn(item.field);
    if (isSingleSelectColDef(column)) {
      resolvedColumn = column;
    }
  }
  const getOptionValue = getOptionValueProp || ((_resolvedColumn = resolvedColumn) == null ? void 0 : _resolvedColumn.getOptionValue);
  const getOptionLabel = getOptionLabelProp || ((_resolvedColumn2 = resolvedColumn) == null ? void 0 : _resolvedColumn2.getOptionLabel);
  const isOptionEqualToValue = React$1.useCallback((option, value) => getOptionValue(option) === getOptionValue(value), [getOptionValue]);
  const resolvedValueOptions = React$1.useMemo(() => {
    var _resolvedColumn3;
    if (!((_resolvedColumn3 = resolvedColumn) != null && _resolvedColumn3.valueOptions)) {
      return [];
    }
    if (typeof resolvedColumn.valueOptions === 'function') {
      return resolvedColumn.valueOptions({
        field: resolvedColumn.field
      });
    }
    return resolvedColumn.valueOptions;
  }, [resolvedColumn]);
  const resolvedFormattedValueOptions = React$1.useMemo(() => {
    return resolvedValueOptions == null ? void 0 : resolvedValueOptions.map(getOptionValue);
  }, [resolvedValueOptions, getOptionValue]);

  // The value is computed from the item.value and used directly
  // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
  const filteredValues = React$1.useMemo(() => {
    if (!Array.isArray(item.value)) {
      return [];
    }
    if (resolvedValueOptions !== undefined) {
      const itemValueIndexes = item.value.map(element => {
        // Gets the index matching between values and valueOptions
        return resolvedFormattedValueOptions == null ? void 0 : resolvedFormattedValueOptions.findIndex(formattedOption => formattedOption === element);
      });
      return itemValueIndexes.filter(index => index >= 0).map(index => resolvedValueOptions[index]);
    }
    return item.value;
  }, [item.value, resolvedValueOptions, resolvedFormattedValueOptions]);
  React$1.useEffect(() => {
    if (!Array.isArray(item.value) || filteredValues.length !== item.value.length) {
      // Updates the state if the filter value has been cleaned by the component
      applyValue(_extends$c({}, item, {
        value: filteredValues.map(getOptionValue)
      }));
    }
  }, [item, filteredValues, applyValue, getOptionValue]);
  const handleChange = React$1.useCallback((event, value) => {
    applyValue(_extends$c({}, item, {
      value: value.map(getOptionValue)
    }));
  }, [applyValue, item, getOptionValue]);
  return /*#__PURE__*/jsx(Autocomplete$1, _extends$c({
    multiple: true,
    options: resolvedValueOptions,
    isOptionEqualToValue: isOptionEqualToValue,
    filterOptions: filter,
    id: id,
    value: filteredValues,
    onChange: handleChange,
    getOptionLabel: getOptionLabel,
    renderTags: (value, getTagProps) => value.map((option, index) => /*#__PURE__*/jsx(rootProps.slots.baseChip, _extends$c({
      variant: "outlined",
      size: "small",
      label: getOptionLabel(option)
    }, getTagProps({
      index
    })))),
    renderInput: params => {
      var _rootProps$slotProps;
      return /*#__PURE__*/jsx(rootProps.slots.baseTextField, _extends$c({}, params, {
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        InputLabelProps: _extends$c({}, params.InputLabelProps, {
          shrink: true
        }),
        inputRef: focusElementRef,
        type: "singleSelect"
      }, TextFieldProps, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTextField));
    }
  }, other));
}
process.env.NODE_ENV !== "production" ? GridFilterInputMultipleSingleSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  focusElementRef: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Used to determine the label displayed for a given value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The text to be displayed.
   */
  getOptionLabel: PropTypes.func,
  /**
   * Used to determine the value used for a value option.
   * @param {ValueOptions} value The current value option.
   * @returns {string} The value to be used.
   */
  getOptionValue: PropTypes.func,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  type: PropTypes.oneOf(['singleSelect'])
} : void 0;

const _excluded$r = ["onClick"];
const GridToolbarColumnsButton = /*#__PURE__*/React$1.forwardRef(function GridToolbarColumnsButton(props, ref) {
  var _rootProps$slotProps;
  const {
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$r);
  const columnButtonId = unstable_useId();
  const columnPanelId = unstable_useId();
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const preferencePanel = useGridSelector(apiRef, gridPreferencePanelStateSelector);
  const showColumns = event => {
    if (preferencePanel.open && preferencePanel.openedPanelValue === GridPreferencePanelsValue.columns) {
      apiRef.current.hidePreferences();
    } else {
      apiRef.current.showPreferences(GridPreferencePanelsValue.columns, columnPanelId, columnButtonId);
    }
    onClick == null || onClick(event);
  };

  // Disable the button if the corresponding is disabled
  if (rootProps.disableColumnSelector) {
    return null;
  }
  const isOpen = preferencePanel.open && preferencePanel.panelId === columnPanelId;
  return /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
    ref: ref,
    id: columnButtonId,
    size: "small",
    "aria-label": apiRef.current.getLocaleText('toolbarColumnsLabel'),
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    "aria-controls": isOpen ? columnPanelId : undefined,
    startIcon: /*#__PURE__*/jsx(rootProps.slots.columnSelectorIcon, {})
  }, other, {
    onClick: showColumns
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
    children: apiRef.current.getLocaleText('toolbarColumns')
  }));
});

const _excluded$q = ["onClick"];
const GridToolbarDensitySelector = /*#__PURE__*/React$1.forwardRef(function GridToolbarDensitySelector(props, ref) {
  var _rootProps$slotProps;
  const {
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$q);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const densityValue = useGridSelector(apiRef, gridDensityValueSelector);
  const densityButtonId = useId();
  const densityMenuId = useId();
  const [open, setOpen] = React$1.useState(false);
  const buttonRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, buttonRef);
  const densityOptions = [{
    icon: /*#__PURE__*/jsx(rootProps.slots.densityCompactIcon, {}),
    label: apiRef.current.getLocaleText('toolbarDensityCompact'),
    value: 'compact'
  }, {
    icon: /*#__PURE__*/jsx(rootProps.slots.densityStandardIcon, {}),
    label: apiRef.current.getLocaleText('toolbarDensityStandard'),
    value: 'standard'
  }, {
    icon: /*#__PURE__*/jsx(rootProps.slots.densityComfortableIcon, {}),
    label: apiRef.current.getLocaleText('toolbarDensityComfortable'),
    value: 'comfortable'
  }];
  const startIcon = React$1.useMemo(() => {
    switch (densityValue) {
      case 'compact':
        return /*#__PURE__*/jsx(rootProps.slots.densityCompactIcon, {});
      case 'comfortable':
        return /*#__PURE__*/jsx(rootProps.slots.densityComfortableIcon, {});
      default:
        return /*#__PURE__*/jsx(rootProps.slots.densityStandardIcon, {});
    }
  }, [densityValue, rootProps]);
  const handleDensitySelectorOpen = event => {
    setOpen(prevOpen => !prevOpen);
    onClick == null || onClick(event);
  };
  const handleDensitySelectorClose = () => {
    setOpen(false);
  };
  const handleDensityUpdate = newDensity => {
    apiRef.current.setDensity(newDensity);
    setOpen(false);
  };
  const handleListKeyDown = event => {
    if (isTabKey(event.key)) {
      event.preventDefault();
    }
    if (isHideMenuKey(event.key)) {
      setOpen(false);
    }
  };

  // Disable the button if the corresponding is disabled
  if (rootProps.disableDensitySelector) {
    return null;
  }
  const densityElements = densityOptions.map((option, index) => /*#__PURE__*/jsxs(MenuItem, {
    onClick: () => handleDensityUpdate(option.value),
    selected: option.value === densityValue,
    children: [/*#__PURE__*/jsx(ListItemIcon, {
      children: option.icon
    }), option.label]
  }, index));
  return /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
      ref: handleRef,
      size: "small",
      startIcon: startIcon,
      "aria-label": apiRef.current.getLocaleText('toolbarDensityLabel'),
      "aria-haspopup": "menu",
      "aria-expanded": open,
      "aria-controls": open ? densityMenuId : undefined,
      id: densityButtonId
    }, other, {
      onClick: handleDensitySelectorOpen
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
      children: apiRef.current.getLocaleText('toolbarDensity')
    })), /*#__PURE__*/jsx(GridMenu, {
      open: open,
      target: buttonRef.current,
      onClose: handleDensitySelectorClose,
      position: "bottom-start",
      children: /*#__PURE__*/jsx(MenuList, {
        id: densityMenuId,
        className: gridClasses.menuList,
        "aria-labelledby": densityButtonId,
        onKeyDown: handleListKeyDown,
        autoFocusItem: open,
        children: densityElements
      })
    })]
  });
});

const _excluded$p = ["componentsProps"];
const useUtilityClasses$g = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['toolbarFilterList']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridToolbarFilterListRoot = styled$3('ul', {
  name: 'MuiDataGrid',
  slot: 'ToolbarFilterList',
  overridesResolver: (_props, styles) => styles.toolbarFilterList
})(({
  theme
}) => ({
  margin: theme.spacing(1, 1, 0.5),
  padding: theme.spacing(0, 1)
}));
const GridToolbarFilterButton = /*#__PURE__*/React$1.forwardRef(function GridToolbarFilterButton(props, ref) {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const {
      componentsProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$p);
  const buttonProps = componentsProps.button || {};
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const activeFilters = useGridSelector(apiRef, gridFilterActiveItemsSelector);
  const lookup = useGridSelector(apiRef, gridColumnLookupSelector);
  const preferencePanel = useGridSelector(apiRef, gridPreferencePanelStateSelector);
  const classes = useUtilityClasses$g(rootProps);
  const filterButtonId = useId();
  const filterPanelId = useId();
  const tooltipContentNode = React$1.useMemo(() => {
    if (preferencePanel.open) {
      return apiRef.current.getLocaleText('toolbarFiltersTooltipHide');
    }
    if (activeFilters.length === 0) {
      return apiRef.current.getLocaleText('toolbarFiltersTooltipShow');
    }
    const getOperatorLabel = item => lookup[item.field].filterOperators.find(operator => operator.value === item.operator).label || apiRef.current.getLocaleText(`filterOperator${capitalize(item.operator)}`).toString();
    const getFilterItemValue = item => {
      const {
        getValueAsString
      } = lookup[item.field].filterOperators.find(operator => operator.value === item.operator);
      return getValueAsString ? getValueAsString(item.value) : item.value;
    };
    return /*#__PURE__*/jsxs("div", {
      children: [apiRef.current.getLocaleText('toolbarFiltersTooltipActive')(activeFilters.length), /*#__PURE__*/jsx(GridToolbarFilterListRoot, {
        className: classes.root,
        ownerState: rootProps,
        children: activeFilters.map((item, index) => _extends$c({}, lookup[item.field] && /*#__PURE__*/jsx("li", {
          children: `${lookup[item.field].headerName || item.field}
                  ${getOperatorLabel(item)}
                  ${
          // implicit check for null and undefined
          item.value != null ? getFilterItemValue(item) : ''}`
        }, index)))
      })]
    });
  }, [apiRef, rootProps, preferencePanel.open, activeFilters, lookup, classes]);
  const toggleFilter = event => {
    var _buttonProps$onClick;
    const {
      open,
      openedPanelValue
    } = preferencePanel;
    if (open && openedPanelValue === GridPreferencePanelsValue.filters) {
      apiRef.current.hidePreferences();
    } else {
      apiRef.current.showPreferences(GridPreferencePanelsValue.filters, filterPanelId, filterButtonId);
    }
    (_buttonProps$onClick = buttonProps.onClick) == null || _buttonProps$onClick.call(buttonProps, event);
  };

  // Disable the button if the corresponding is disabled
  if (rootProps.disableColumnFilter) {
    return null;
  }
  const isOpen = preferencePanel.open && preferencePanel.panelId === filterPanelId;
  return /*#__PURE__*/jsx(rootProps.slots.baseTooltip, _extends$c({
    title: tooltipContentNode,
    enterDelay: 1000
  }, other, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
    children: /*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
      ref: ref,
      id: filterButtonId,
      size: "small",
      "aria-label": apiRef.current.getLocaleText('toolbarFiltersLabel'),
      "aria-controls": isOpen ? filterPanelId : undefined,
      "aria-expanded": isOpen,
      "aria-haspopup": true,
      startIcon: /*#__PURE__*/jsx(Badge, {
        badgeContent: activeFilters.length,
        color: "primary",
        children: /*#__PURE__*/jsx(rootProps.slots.openFilterButtonIcon, {})
      })
    }, buttonProps, {
      onClick: toggleFilter
    }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseButton, {
      children: apiRef.current.getLocaleText('toolbarFilters')
    }))
  }));
});
process.env.NODE_ENV !== "production" ? GridToolbarFilterButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.object
} : void 0;

const _excluded$o = ["children", "onClick"];
const GridToolbarExportContainer = /*#__PURE__*/React$1.forwardRef(function GridToolbarExportContainer(props, ref) {
  var _rootProps$slotProps;
  const {
      children,
      onClick
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$o);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const exportButtonId = useId();
  const exportMenuId = useId();
  const [open, setOpen] = React$1.useState(false);
  const buttonRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, buttonRef);
  const handleMenuOpen = event => {
    setOpen(prevOpen => !prevOpen);
    onClick == null || onClick(event);
  };
  const handleMenuClose = () => setOpen(false);
  const handleListKeyDown = event => {
    if (isTabKey(event.key)) {
      event.preventDefault();
    }
    if (isHideMenuKey(event.key)) {
      handleMenuClose();
    }
  };
  if (children == null) {
    return null;
  }
  return /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsx(rootProps.slots.baseButton, _extends$c({
      ref: handleRef,
      size: "small",
      startIcon: /*#__PURE__*/jsx(rootProps.slots.exportIcon, {}),
      "aria-expanded": open,
      "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
      "aria-haspopup": "menu",
      "aria-controls": open ? exportMenuId : undefined,
      id: exportButtonId
    }, other, {
      onClick: handleMenuOpen
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
      children: apiRef.current.getLocaleText('toolbarExport')
    })), /*#__PURE__*/jsx(GridMenu, {
      open: open,
      target: buttonRef.current,
      onClose: handleMenuClose,
      position: "bottom-start",
      children: /*#__PURE__*/jsx(MenuList, {
        id: exportMenuId,
        className: gridClasses.menuList,
        "aria-labelledby": exportButtonId,
        onKeyDown: handleListKeyDown,
        autoFocusItem: open,
        children: React$1.Children.map(children, child => {
          if (! /*#__PURE__*/React$1.isValidElement(child)) {
            return child;
          }
          return /*#__PURE__*/React$1.cloneElement(child, {
            hideMenu: handleMenuClose
          });
        })
      })
    })]
  });
});

const _excluded$n = ["hideMenu", "options"],
  _excluded2$3 = ["hideMenu", "options"],
  _excluded3 = ["csvOptions", "printOptions", "excelOptions"];
function GridCsvExportMenuItem(props) {
  const apiRef = useGridApiContext();
  const {
      hideMenu,
      options
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$n);
  return /*#__PURE__*/jsx(MenuItem, _extends$c({
    onClick: () => {
      apiRef.current.exportDataAsCsv(options);
      hideMenu == null || hideMenu();
    }
  }, other, {
    children: apiRef.current.getLocaleText('toolbarExportCSV')
  }));
}
function GridPrintExportMenuItem(props) {
  const apiRef = useGridApiContext();
  const {
      hideMenu,
      options
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded2$3);
  return /*#__PURE__*/jsx(MenuItem, _extends$c({
    onClick: () => {
      apiRef.current.exportDataAsPrint(options);
      hideMenu == null || hideMenu();
    }
  }, other, {
    children: apiRef.current.getLocaleText('toolbarExportPrint')
  }));
}
const GridToolbarExport = /*#__PURE__*/React$1.forwardRef(function GridToolbarExport(props, ref) {
  const {
      csvOptions = {},
      printOptions = {},
      excelOptions
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded3);
  const apiRef = useGridApiContext();
  const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
    excelOptions,
    csvOptions,
    printOptions
  }).sort((a, b) => a.componentName > b.componentName ? 1 : -1);
  if (preProcessedButtons.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx(GridToolbarExportContainer, _extends$c({}, other, {
    ref: ref,
    children: preProcessedButtons.map((button, index) => /*#__PURE__*/React$1.cloneElement(button.component, {
      key: index
    }))
  }));
});
process.env.NODE_ENV !== "production" ? GridToolbarExport.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  csvOptions: PropTypes.object,
  printOptions: PropTypes.object
} : void 0;

const _excluded$m = ["quickFilterParser", "quickFilterFormatter", "debounceMs"];
const GridToolbarQuickFilterRoot = styled$3(MuiTextField, {
  name: 'MuiDataGrid',
  slot: 'ToolbarQuickFilter',
  overridesResolver: (props, styles) => styles.toolbarQuickFilter
})(({
  theme
}) => ({
  width: 'auto',
  paddingBottom: theme.spacing(0.5),
  '& input': {
    marginLeft: theme.spacing(0.5)
  },
  '& .MuiInput-underline:before': {
    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
  },
  [`& input[type=search]::-ms-clear,
& input[type=search]::-ms-reveal`]: {
    /* clears the 'X' icon from IE */
    display: 'none',
    width: 0,
    height: 0
  },
  [`& input[type="search"]::-webkit-search-decoration,
  & input[type="search"]::-webkit-search-cancel-button,
  & input[type="search"]::-webkit-search-results-button,
  & input[type="search"]::-webkit-search-results-decoration`]: {
    /* clears the 'X' icon from Chrome */
    display: 'none'
  }
}));
const defaultSearchValueParser = searchText => searchText.split(' ').filter(word => word !== '');
const defaultSearchValueFormatter = values => values.join(' ');
function GridToolbarQuickFilter(props) {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const quickFilterValues = useGridSelector(apiRef, gridQuickFilterValuesSelector);
  const {
      quickFilterParser = defaultSearchValueParser,
      quickFilterFormatter = defaultSearchValueFormatter,
      debounceMs = rootProps.filterDebounceMs
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$m);
  const [searchValue, setSearchValue] = React$1.useState(() => quickFilterFormatter(quickFilterValues != null ? quickFilterValues : []));
  const prevQuickFilterValuesRef = React$1.useRef(quickFilterValues);
  React$1.useEffect(() => {
    if (!isDeepEqual(prevQuickFilterValuesRef.current, quickFilterValues)) {
      // The model of quick filter value has been updated
      prevQuickFilterValuesRef.current = quickFilterValues;

      // Update the input value if needed to match the new model
      setSearchValue(prevSearchValue => isDeepEqual(quickFilterParser(prevSearchValue), quickFilterValues) ? prevSearchValue : quickFilterFormatter(quickFilterValues != null ? quickFilterValues : []));
    }
  }, [quickFilterValues, quickFilterFormatter, quickFilterParser]);
  const updateSearchValue = React$1.useCallback(newSearchValue => {
    const newQuickFilterValues = quickFilterParser(newSearchValue);
    prevQuickFilterValuesRef.current = newQuickFilterValues;
    apiRef.current.setQuickFilterValues(newQuickFilterValues);
  }, [apiRef, quickFilterParser]);
  const debouncedUpdateSearchValue = React$1.useMemo(() => debounce(updateSearchValue, debounceMs), [updateSearchValue, debounceMs]);
  const handleSearchValueChange = React$1.useCallback(event => {
    const newSearchValue = event.target.value;
    setSearchValue(newSearchValue);
    debouncedUpdateSearchValue(newSearchValue);
  }, [debouncedUpdateSearchValue]);
  const handleSearchReset = React$1.useCallback(() => {
    setSearchValue('');
    updateSearchValue('');
  }, [updateSearchValue]);
  return /*#__PURE__*/jsx(GridToolbarQuickFilterRoot, _extends$c({
    as: rootProps.slots.baseTextField,
    ownerState: rootProps,
    variant: "standard",
    value: searchValue,
    onChange: handleSearchValueChange,
    placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
    "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
    type: "search"
  }, other, {
    InputProps: _extends$c({
      startAdornment: /*#__PURE__*/jsx(rootProps.slots.quickFilterIcon, {
        fontSize: "small"
      }),
      endAdornment: /*#__PURE__*/jsx(rootProps.slots.baseIconButton, _extends$c({
        "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
        size: "small",
        sx: {
          visibility: searchValue ? 'visible' : 'hidden'
        },
        onClick: handleSearchReset
      }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseIconButton, {
        children: /*#__PURE__*/jsx(rootProps.slots.quickFilterClearIcon, {
          fontSize: "small"
        })
      }))
    }, other.InputProps)
  }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseTextField));
}
process.env.NODE_ENV !== "production" ? GridToolbarQuickFilter.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The debounce time in milliseconds.
   * @default 150
   */
  debounceMs: PropTypes.number,
  /**
   * Function responsible for formatting values of quick filter in a string when the model is modified
   * @param {any[]} values The new values passed to the quick filter model
   * @returns {string} The string to display in the text field
   */
  quickFilterFormatter: PropTypes.func,
  /**
   * Function responsible for parsing text input in an array of independent values for quick filtering.
   * @param {string} input The value entered by the user
   * @returns {any[]} The array of value on which quick filter is applied
   */
  quickFilterParser: PropTypes.func
} : void 0;

const _excluded$l = ["className", "csvOptions", "printOptions", "excelOptions", "showQuickFilter", "quickFilterProps"];
const GridToolbar = /*#__PURE__*/React$1.forwardRef(function GridToolbar(props, ref) {
  // TODO v7: think about where export option should be passed.
  // from slotProps={{ toolbarExport: { ...exportOption } }} seems to be more appropriate
  const {
      csvOptions,
      printOptions,
      excelOptions,
      showQuickFilter = false,
      quickFilterProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$l);
  const rootProps = useGridRootProps();
  if (rootProps.disableColumnFilter && rootProps.disableColumnSelector && rootProps.disableDensitySelector && !showQuickFilter) {
    return null;
  }
  return /*#__PURE__*/jsxs(GridToolbarContainer, _extends$c({
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsx(GridToolbarColumnsButton, {}), /*#__PURE__*/jsx(GridToolbarFilterButton, {}), /*#__PURE__*/jsx(GridToolbarDensitySelector, {}), /*#__PURE__*/jsx(GridToolbarExport, {
      csvOptions: csvOptions,
      printOptions: printOptions
      // TODO: remove the reference to excelOptions in community package
      ,
      excelOptions: excelOptions
    }), /*#__PURE__*/jsx(Box, {
      sx: {
        flex: 1
      }
    }), showQuickFilter && /*#__PURE__*/jsx(GridToolbarQuickFilter, _extends$c({}, quickFilterProps))]
  }));
});
process.env.NODE_ENV !== "production" ? GridToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Props passed to the quick filter component.
   */
  quickFilterProps: PropTypes.object,
  /**
   * Show the quick filter component.
   * @default false
   */
  showQuickFilter: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const _excluded$k = ["className", "selectedRowCount"];
const useUtilityClasses$f = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['selectedRowCount']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridSelectedRowCountRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'SelectedRowCount',
  overridesResolver: (props, styles) => styles.selectedRowCount
})(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  margin: theme.spacing(0, 2),
  visibility: 'hidden',
  width: 0,
  height: 0,
  [theme.breakpoints.up('sm')]: {
    visibility: 'visible',
    width: 'auto',
    height: 'auto'
  }
}));
const GridSelectedRowCount = /*#__PURE__*/React$1.forwardRef(function GridSelectedRowCount(props, ref) {
  const {
      className,
      selectedRowCount
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$k);
  const apiRef = useGridApiContext();
  const ownerState = useGridRootProps();
  const classes = useUtilityClasses$f(ownerState);
  const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
  return /*#__PURE__*/jsx(GridSelectedRowCountRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: rowSelectedText
  }));
});
process.env.NODE_ENV !== "production" ? GridSelectedRowCount.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  selectedRowCount: PropTypes.number.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const GridFooter = /*#__PURE__*/React$1.forwardRef(function GridFooter(props, ref) {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const totalTopLevelRowCount = useGridSelector(apiRef, gridTopLevelRowCountSelector);
  const selectedRowCount = useGridSelector(apiRef, selectedGridRowsCountSelector);
  const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/jsx(GridSelectedRowCount, {
    selectedRowCount: selectedRowCount
  }) : /*#__PURE__*/jsx("div", {});
  const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/jsx(rootProps.slots.footerRowCount, _extends$c({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.footerRowCount, {
    rowCount: totalTopLevelRowCount,
    visibleRowCount: visibleTopLevelRowCount
  })) : null;
  const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/jsx(rootProps.slots.pagination, _extends$c({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.pagination));
  return /*#__PURE__*/jsxs(GridFooterContainer, _extends$c({
    ref: ref
  }, props, {
    children: [selectedRowCountElement, rowCountElement, paginationElement]
  }));
});
process.env.NODE_ENV !== "production" ? GridFooter.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

function GridHeader() {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const rootProps = useGridRootProps();
  return /*#__PURE__*/jsxs(React$1.Fragment, {
    children: [/*#__PURE__*/jsx(rootProps.slots.preferencesPanel, _extends$c({}, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.preferencesPanel)), rootProps.slots.toolbar && /*#__PURE__*/jsx(rootProps.slots.toolbar, _extends$c({}, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.toolbar))]
  });
}

const GridLoadingOverlay = /*#__PURE__*/React$1.forwardRef(function GridLoadingOverlay(props, ref) {
  return /*#__PURE__*/jsx(GridOverlay, _extends$c({
    ref: ref
  }, props, {
    children: /*#__PURE__*/jsx(CircularProgress, {})
  }));
});
process.env.NODE_ENV !== "production" ? GridLoadingOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const GridNoRowsOverlay = /*#__PURE__*/React$1.forwardRef(function GridNoRowsOverlay(props, ref) {
  const apiRef = useGridApiContext();
  const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
  return /*#__PURE__*/jsx(GridOverlay, _extends$c({
    ref: ref
  }, props, {
    children: noRowsLabel
  }));
});
process.env.NODE_ENV !== "production" ? GridNoRowsOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

const GridPaginationRoot = styled$3(TablePagination)(({
  theme
}) => ({
  [`& .${tablePaginationClasses.selectLabel}`]: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  [`& .${tablePaginationClasses.input}`]: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'inline-flex'
    }
  }
}));
const GridPagination = /*#__PURE__*/React$1.forwardRef(function GridPagination(props, ref) {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
  const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const rowCount = React$1.useMemo(() => {
    var _ref, _rootProps$rowCount;
    return (_ref = (_rootProps$rowCount = rootProps.rowCount) != null ? _rootProps$rowCount : visibleTopLevelRowCount) != null ? _ref : 0;
  }, [rootProps.rowCount, visibleTopLevelRowCount]);
  const lastPage = React$1.useMemo(() => Math.floor(rowCount / (paginationModel.pageSize || 1)), [rowCount, paginationModel.pageSize]);
  const handlePageSizeChange = React$1.useCallback(event => {
    const pageSize = Number(event.target.value);
    apiRef.current.setPageSize(pageSize);
  }, [apiRef]);
  const handlePageChange = React$1.useCallback((_, page) => {
    apiRef.current.setPage(page);
  }, [apiRef]);
  const isPageSizeIncludedInPageSizeOptions = pageSize => {
    for (let i = 0; i < rootProps.pageSizeOptions.length; i += 1) {
      const option = rootProps.pageSizeOptions[i];
      if (typeof option === 'number') {
        if (option === pageSize) {
          return true;
        }
      } else if (option.value === pageSize) {
        return true;
      }
    }
    return false;
  };
  if (process.env.NODE_ENV !== 'production') {
    var _rootProps$pagination, _rootProps$pagination2;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const warnedOnceMissingInPageSizeOptions = React$1.useRef(false);
    const pageSize = (_rootProps$pagination = (_rootProps$pagination2 = rootProps.paginationModel) == null ? void 0 : _rootProps$pagination2.pageSize) != null ? _rootProps$pagination : paginationModel.pageSize;
    if (!warnedOnceMissingInPageSizeOptions.current && !rootProps.autoPageSize && !isPageSizeIncludedInPageSizeOptions(pageSize)) {
      console.warn([`MUI: The page size \`${paginationModel.pageSize}\` is not preset in the \`pageSizeOptions\``, `Add it to show the pagination select.`].join('\n'));
      warnedOnceMissingInPageSizeOptions.current = true;
    }
  }
  const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
  return /*#__PURE__*/jsx(GridPaginationRoot, _extends$c({
    ref: ref,
    component: "div",
    count: rowCount,
    page: paginationModel.page <= lastPage ? paginationModel.page : lastPage,
    rowsPerPageOptions: pageSizeOptions,
    rowsPerPage: paginationModel.pageSize,
    onPageChange: handlePageChange,
    onRowsPerPageChange: handlePageSizeChange
  }, apiRef.current.getLocaleText('MuiTablePagination'), props));
});

const _excluded$j = ["className", "rowCount", "visibleRowCount"];
const useUtilityClasses$e = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['rowCount']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridRowCountRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'RowCount',
  overridesResolver: (props, styles) => styles.rowCount
})(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  margin: theme.spacing(0, 2)
}));
const GridRowCount = /*#__PURE__*/React$1.forwardRef(function GridRowCount(props, ref) {
  const {
      className,
      rowCount,
      visibleRowCount
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$j);
  const apiRef = useGridApiContext();
  const ownerState = useGridRootProps();
  const classes = useUtilityClasses$e(ownerState);
  if (rowCount === 0) {
    return null;
  }
  const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
  return /*#__PURE__*/jsxs(GridRowCountRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [apiRef.current.getLocaleText('footerTotalRows'), " ", text]
  }));
});
process.env.NODE_ENV !== "production" ? GridRowCount.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  rowCount: PropTypes.number.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  visibleRowCount: PropTypes.number.isRequired
} : void 0;

const getVisibleRows = (apiRef, props) => {
  let rows;
  let range;
  if (props.pagination && props.paginationMode === 'client') {
    range = gridPaginationRowRangeSelector(apiRef);
    rows = gridPaginatedVisibleSortedGridRowEntriesSelector(apiRef);
  } else {
    rows = gridExpandedSortedRowEntriesSelector(apiRef);
    if (rows.length === 0) {
      range = null;
    } else {
      range = {
        firstRowIndex: 0,
        lastRowIndex: rows.length - 1
      };
    }
  }
  return {
    rows,
    range
  };
};

/**
 * Computes the list of rows that are reachable by scroll.
 * Depending on whether pagination is enabled, it will return the rows in the current page.
 * - If the pagination is disabled or in server mode, it equals all the visible rows.
 * - If the row tree has several layers, it contains up to `state.pageSize` top level rows and all their descendants.
 * - If the row tree is flat, it only contains up to `state.pageSize` rows.
 */
const useGridVisibleRows = (apiRef, props) => {
  const response = getVisibleRows(apiRef, props);
  return React$1.useMemo(() => ({
    rows: response.rows,
    range: response.range
  }), [response.rows, response.range]);
};

/**
 * A global API ref, for v7-to-legacy converter
 */
const GLOBAL_API_REF = {
  current: null
};

/**
 * A tagger to determine if the filter is internal or custom user-supplied.
 * To be a valid internal filter, the v7 function *must* be defined/redefined at
 * the same time as the legacy one.
 * https://github.com/mui/mui-x/pull/9254#discussion_r1231095551
 */
function tagInternalFilter(fn) {
  fn.isInternal = true;
  return fn;
}
function isInternalFilter(fn) {
  return fn !== undefined && fn.isInternal === true;
}
function convertFilterV7ToLegacy(fn) {
  return tagInternalFilter((filterItem, column) => {
    const filterFn = fn(filterItem, column);
    if (!filterFn) {
      return filterFn;
    }
    return cellParams => {
      return filterFn(cellParams.value, cellParams.row, column, GLOBAL_API_REF.current);
    };
  });
}
function convertLegacyOperators(ops) {
  return ops.map(op => {
    return _extends$c({}, op, {
      getApplyFilterFn: convertFilterV7ToLegacy(op.getApplyFilterFnV7),
      getApplyFilterFnV7: tagInternalFilter(op.getApplyFilterFnV7)
    });
  });
}
function convertQuickFilterV7ToLegacy(fn) {
  return tagInternalFilter((filterItem, column, apiRef) => {
    const filterFn = fn(filterItem, column, apiRef);
    if (!filterFn) {
      return filterFn;
    }
    return cellParams => {
      return filterFn(cellParams.value, cellParams.row, column, apiRef);
    };
  });
}

const getGridStringQuickFilterFn = tagInternalFilter(value => {
  if (!value) {
    return null;
  }
  const filterRegex = new RegExp(escapeRegExp(value), 'i');
  return (_, row, column, apiRef) => {
    const columnValue = apiRef.current.getRowFormattedValue(row, column);
    return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
  };
});
const getGridStringOperators = (disableTrim = false) => convertLegacyOperators([{
  value: 'contains',
  getApplyFilterFnV7: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
    const filterRegex = new RegExp(escapeRegExp(filterItemValue), 'i');
    return value => {
      return value != null ? filterRegex.test(String(value)) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'equals',
  getApplyFilterFnV7: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
    const collator = new Intl.Collator(undefined, {
      sensitivity: 'base',
      usage: 'search'
    });
    return value => {
      return value != null ? collator.compare(filterItemValue, value.toString()) === 0 : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'startsWith',
  getApplyFilterFnV7: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
    const filterRegex = new RegExp(`^${escapeRegExp(filterItemValue)}.*$`, 'i');
    return value => {
      return value != null ? filterRegex.test(value.toString()) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'endsWith',
  getApplyFilterFnV7: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
    const filterRegex = new RegExp(`.*${escapeRegExp(filterItemValue)}$`, 'i');
    return value => {
      return value != null ? filterRegex.test(value.toString()) : false;
    };
  },
  InputComponent: GridFilterInputValue
}, {
  value: 'isEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value === '' || value == null;
    };
  },
  requiresFilterValue: false
}, {
  value: 'isNotEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value !== '' && value != null;
    };
  },
  requiresFilterValue: false
}, {
  value: 'isAnyOf',
  getApplyFilterFnV7: filterItem => {
    if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) {
      return null;
    }
    const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map(val => val.trim());
    const collator = new Intl.Collator(undefined, {
      sensitivity: 'base',
      usage: 'search'
    });
    return value => value != null ? filterItemValue.some(filterValue => {
      return collator.compare(filterValue, value.toString() || '') === 0;
    }) : false;
  },
  InputComponent: GridFilterInputMultipleValue
}]);

/**
 * TODO: Move pro and premium properties outside of this Community file
 */
const GRID_STRING_COL_DEF = {
  width: 100,
  minWidth: 50,
  maxWidth: Infinity,
  hideable: true,
  sortable: true,
  resizable: true,
  filterable: true,
  groupable: true,
  pinnable: true,
  // @ts-ignore
  aggregable: true,
  editable: false,
  sortComparator: gridStringOrNumberComparator,
  type: 'string',
  align: 'left',
  filterOperators: getGridStringOperators(),
  renderEditCell: renderEditInputCell,
  getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridStringQuickFilterFn),
  getApplyQuickFilterFnV7: getGridStringQuickFilterFn
};

const getGridBooleanOperators = () => convertLegacyOperators([{
  value: 'is',
  getApplyFilterFnV7: filterItem => {
    if (!filterItem.value) {
      return null;
    }
    const valueAsBoolean = filterItem.value === 'true';
    return value => {
      return Boolean(value) === valueAsBoolean;
    };
  },
  InputComponent: GridFilterInputBoolean
}]);

function gridBooleanFormatter({
  value,
  api
}) {
  return value ? api.getLocaleText('booleanCellTrueLabel') : api.getLocaleText('booleanCellFalseLabel');
}
const stringToBoolean = value => {
  switch (value.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true;
    case 'false':
    case 'no':
    case '0':
    case 'null':
    case 'undefined':
      return false;
    default:
      return undefined;
  }
};
const GRID_BOOLEAN_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  type: 'boolean',
  align: 'center',
  headerAlign: 'center',
  renderCell: renderBooleanCell,
  renderEditCell: renderEditBooleanCell,
  sortComparator: gridNumberComparator,
  valueFormatter: gridBooleanFormatter,
  filterOperators: getGridBooleanOperators(),
  getApplyQuickFilterFn: undefined,
  getApplyQuickFilterFnV7: undefined,
  // @ts-ignore
  aggregable: false,
  // @ts-ignore
  pastedValueParser: value => stringToBoolean(value)
});

const GRID_CHECKBOX_SELECTION_FIELD = '__check__';
const GRID_CHECKBOX_SELECTION_COL_DEF = _extends$c({}, GRID_BOOLEAN_COL_DEF, {
  field: GRID_CHECKBOX_SELECTION_FIELD,
  type: 'checkboxSelection',
  width: 50,
  resizable: false,
  sortable: false,
  filterable: false,
  // @ts-ignore
  aggregable: false,
  disableColumnMenu: true,
  disableReorder: true,
  disableExport: true,
  getApplyQuickFilterFn: undefined,
  getApplyQuickFilterFnV7: undefined,
  valueGetter: params => {
    const selectionLookup = selectedIdsLookupSelector(params.api.state, params.api.instanceId);
    return selectionLookup[params.id] !== undefined;
  },
  renderHeader: params => /*#__PURE__*/jsx(GridHeaderCheckbox, _extends$c({}, params)),
  renderCell: params => /*#__PURE__*/jsx(GridCellCheckboxRenderer, _extends$c({}, params))
});

const GRID_ACTIONS_COLUMN_TYPE = 'actions';
const GRID_ACTIONS_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  sortable: false,
  filterable: false,
  // @ts-ignore
  aggregable: false,
  width: 100,
  align: 'center',
  headerAlign: 'center',
  headerName: '',
  disableColumnMenu: true,
  disableExport: true,
  renderCell: renderActionsCell,
  getApplyQuickFilterFn: undefined,
  getApplyQuickFilterFnV7: undefined
});

// Can't import from pro package - hence duplication
const GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';

// TODO v6: rename to gridEditingStateSelector
const gridEditRowsStateSelector = state => state.editRows;

const _excluded$i = ["selected", "hovered", "rowId", "row", "index", "style", "position", "rowHeight", "className", "visibleColumns", "renderedColumns", "containerWidth", "firstColumnToRender", "lastColumnToRender", "isLastVisible", "focusedCellColumnIndexNotInRange", "isNotVisible", "focusedCell", "tabbableCell", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave", "onMouseOut", "onMouseOver"];
const useUtilityClasses$d = ownerState => {
  const {
    editable,
    editing,
    selected,
    isLastVisible,
    rowHeight,
    classes
  } = ownerState;
  const slots = {
    root: ['row', selected && 'selected', editable && 'row--editable', editing && 'row--editing', isLastVisible && 'row--lastVisible', rowHeight === 'auto' && 'row--dynamicHeight']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function EmptyCell({
  width
}) {
  if (!width) {
    return null;
  }
  const style = {
    width
  };
  return /*#__PURE__*/jsx("div", {
    className: `${gridClasses.cell} ${gridClasses.withBorderColor}`,
    style: style
  }); // TODO change to .MuiDataGrid-emptyCell or .MuiDataGrid-rowFiller
}

const GridRow = /*#__PURE__*/React$1.forwardRef(function GridRow(props, refProp) {
  const {
      selected,
      hovered,
      rowId,
      row,
      index,
      style: styleProp,
      position,
      rowHeight,
      className,
      visibleColumns,
      renderedColumns,
      containerWidth,
      firstColumnToRender,
      isLastVisible = false,
      focusedCellColumnIndexNotInRange,
      isNotVisible,
      focusedCell,
      onClick,
      onDoubleClick,
      onMouseEnter,
      onMouseLeave,
      onMouseOut,
      onMouseOver
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$i);
  const apiRef = useGridApiContext();
  const ref = React$1.useRef(null);
  const rootProps = useGridRootProps();
  const currentPage = useGridVisibleRows(apiRef, rootProps);
  const columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  const treeDepth = useGridSelector(apiRef, gridRowMaximumTreeDepthSelector);
  const headerGroupingMaxDepth = useGridSelector(apiRef, gridColumnGroupsHeaderMaxDepthSelector);
  const editRowsState = useGridSelector(apiRef, gridEditRowsStateSelector);
  const handleRef = useForkRef(ref, refProp);
  const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based

  const ownerState = {
    selected,
    hovered,
    isLastVisible,
    classes: rootProps.classes,
    editing: apiRef.current.getRowMode(rowId) === GridRowModes.Edit,
    editable: rootProps.editMode === GridEditModes.Row,
    rowHeight
  };
  const classes = useUtilityClasses$d(ownerState);
  React$1.useLayoutEffect(() => {
    if (rowHeight === 'auto' && ref.current && typeof ResizeObserver === 'undefined') {
      // Fallback for IE
      apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight, position);
    }
  }, [apiRef, rowHeight, rowId, position]);
  React$1.useLayoutEffect(() => {
    if (currentPage.range) {
      // The index prop is relative to the rows from all pages. As example, the index prop of the
      // first row is 5 if `paginationModel.pageSize=5` and `paginationModel.page=1`. However, the index used by the virtualization
      // doesn't care about pagination and considers the rows from the current page only, so the
      // first row always has index=0. We need to subtract the index of the first row to make it
      // compatible with the index used by the virtualization.
      const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
      // pinned rows are not part of the visible rows
      if (rowIndex != null) {
        apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
      }
    }
    const rootElement = ref.current;
    const hasFixedHeight = rowHeight !== 'auto';
    if (!rootElement || hasFixedHeight || typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const resizeObserver = new ResizeObserver(entries => {
      const [entry] = entries;
      const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
      apiRef.current.unstable_storeRowHeightMeasurement(rowId, height, position);
    });
    resizeObserver.observe(rootElement);
    return () => resizeObserver.disconnect();
  }, [apiRef, currentPage.range, index, rowHeight, rowId, position]);
  const publish = React$1.useCallback((eventName, propHandler) => event => {
    // Ignore portal
    // The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    if (event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) {
      return;
    }

    // The row might have been deleted
    if (!apiRef.current.getRow(rowId)) {
      return;
    }
    apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
    if (propHandler) {
      propHandler(event);
    }
  }, [apiRef, rowId]);
  const publishClick = React$1.useCallback(event => {
    const cell = findParentElementFromClassName(event.target, gridClasses.cell);
    const field = cell == null ? void 0 : cell.getAttribute('data-field');

    // Check if the field is available because the cell that fills the empty
    // space of the row has no field.
    if (field) {
      // User clicked in the checkbox added by checkboxSelection
      if (field === GRID_CHECKBOX_SELECTION_COL_DEF.field) {
        return;
      }

      // User opened a detail panel
      if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) {
        return;
      }

      // User reorders a row
      if (field === '__reorder__') {
        return;
      }

      // User is editing a cell
      if (apiRef.current.getCellMode(rowId, field) === GridCellModes.Edit) {
        return;
      }

      // User clicked a button from the "actions" column type
      const column = apiRef.current.getColumn(field);
      if ((column == null ? void 0 : column.type) === GRID_ACTIONS_COLUMN_TYPE) {
        return;
      }
    }
    publish('rowClick', onClick)(event);
  }, [apiRef, onClick, publish, rowId]);
  const {
    slots,
    slotProps,
    disableColumnReorder
  } = rootProps;
  const CellComponent = slots.cell === MemoizedGridCellV7 ? MemoizedGridCellV7 : MemoizedCellWrapper;
  const rowReordering = rootProps.rowReordering;
  const getCell = (column, cellProps) => {
    var _editRowsState$rowId$, _editRowsState$rowId;
    const disableDragEvents = disableColumnReorder && column.disableReorder || !rowReordering && !!sortModel.length && treeDepth > 1 && Object.keys(editRowsState).length > 0;
    const editCellState = (_editRowsState$rowId$ = (_editRowsState$rowId = editRowsState[rowId]) == null ? void 0 : _editRowsState$rowId[column.field]) != null ? _editRowsState$rowId$ : null;
    let cellIsNotVisible = false;
    if (focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) {
      cellIsNotVisible = true;
    }
    return /*#__PURE__*/jsx(CellComponent, _extends$c({
      column: column,
      width: cellProps.width,
      rowId: rowId,
      height: rowHeight,
      showRightBorder: cellProps.showRightBorder,
      align: column.align || 'left',
      colIndex: cellProps.indexRelativeToAllColumns,
      colSpan: cellProps.colSpan,
      disableDragEvents: disableDragEvents,
      editCellState: editCellState,
      isNotVisible: cellIsNotVisible
    }, slotProps == null ? void 0 : slotProps.cell), column.field);
  };
  const sizes = useGridSelector(apiRef, () => _extends$c({}, apiRef.current.unstable_getRowInternalSizes(rowId)), objectShallowCompare);
  let minHeight = rowHeight;
  if (minHeight === 'auto' && sizes) {
    let numberOfBaseSizes = 0;
    const maximumSize = Object.entries(sizes).reduce((acc, [key, size]) => {
      const isBaseHeight = /^base[A-Z]/.test(key);
      if (!isBaseHeight) {
        return acc;
      }
      numberOfBaseSizes += 1;
      if (size > acc) {
        return size;
      }
      return acc;
    }, 0);
    if (maximumSize > 0 && numberOfBaseSizes > 1) {
      minHeight = maximumSize;
    }
  }
  const style = React$1.useMemo(() => {
    if (isNotVisible) {
      return {
        opacity: 0,
        width: 0,
        height: 0
      };
    }
    const rowStyle = _extends$c({}, styleProp, {
      maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
      // max-height doesn't support "auto"
      minHeight
    });
    if (sizes != null && sizes.spacingTop) {
      const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
      rowStyle[property] = sizes.spacingTop;
    }
    if (sizes != null && sizes.spacingBottom) {
      const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
      let propertyValue = rowStyle[property];
      // avoid overriding existing value
      if (typeof propertyValue !== 'number') {
        propertyValue = parseInt(propertyValue || '0', 10);
      }
      propertyValue += sizes.spacingBottom;
      rowStyle[property] = propertyValue;
    }
    return rowStyle;
  }, [isNotVisible, rowHeight, styleProp, minHeight, sizes, rootProps.rowSpacingType]);
  const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
  if (typeof rootProps.getRowClassName === 'function') {
    var _currentPage$range;
    const indexRelativeToCurrentPage = index - (((_currentPage$range = currentPage.range) == null ? void 0 : _currentPage$range.firstRowIndex) || 0);
    const rowParams = _extends$c({}, apiRef.current.getRowParams(rowId), {
      isFirstVisible: indexRelativeToCurrentPage === 0,
      isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
      indexRelativeToCurrentPage
    });
    rowClassNames.push(rootProps.getRowClassName(rowParams));
  }
  const randomNumber = randomNumberBetween(10000, 20, 80);
  const rowNode = apiRef.current.getRowNode(rowId);
  if (!rowNode) {
    return null;
  }
  const rowType = rowNode.type;
  const cells = [];
  for (let i = 0; i < renderedColumns.length; i += 1) {
    const column = renderedColumns[i];
    let indexRelativeToAllColumns = firstColumnToRender + i;
    if (focusedCellColumnIndexNotInRange !== undefined && focusedCell) {
      if (visibleColumns[focusedCellColumnIndexNotInRange].field === column.field) {
        indexRelativeToAllColumns = focusedCellColumnIndexNotInRange;
      } else {
        indexRelativeToAllColumns -= 1;
      }
    }
    const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
    if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) {
      if (rowType !== 'skeletonRow') {
        const {
          colSpan,
          width
        } = cellColSpanInfo.cellProps;
        const cellProps = {
          width,
          colSpan,
          showRightBorder: rootProps.showCellVerticalBorder,
          indexRelativeToAllColumns
        };
        cells.push(getCell(column, cellProps));
      } else {
        const {
          width
        } = cellColSpanInfo.cellProps;
        const contentWidth = Math.round(randomNumber());
        cells.push( /*#__PURE__*/jsx(slots.skeletonCell, {
          width: width,
          contentWidth: contentWidth,
          field: column.field,
          align: column.align
        }, column.field));
      }
    }
  }
  const emptyCellWidth = containerWidth - columnsTotalWidth;
  const eventHandlers = row ? {
    onClick: publishClick,
    onDoubleClick: publish('rowDoubleClick', onDoubleClick),
    onMouseEnter: publish('rowMouseEnter', onMouseEnter),
    onMouseLeave: publish('rowMouseLeave', onMouseLeave),
    onMouseOut: publish('rowMouseOut', onMouseOut),
    onMouseOver: publish('rowMouseOver', onMouseOver)
  } : null;
  return /*#__PURE__*/jsxs("div", _extends$c({
    ref: handleRef,
    "data-id": rowId,
    "data-rowindex": index,
    role: "row",
    className: clsx(...rowClassNames, classes.root, className, hovered && 'Mui-hovered'),
    "aria-rowindex": ariaRowIndex,
    "aria-selected": selected,
    style: style
  }, eventHandlers, other, {
    children: [cells, emptyCellWidth > 0 && /*#__PURE__*/jsx(EmptyCell, {
      width: emptyCellWidth
    })]
  }));
});
process.env.NODE_ENV !== "production" ? GridRow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  containerWidth: PropTypes.number.isRequired,
  firstColumnToRender: PropTypes.number.isRequired,
  /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */
  focusedCell: PropTypes.string,
  focusedCellColumnIndexNotInRange: PropTypes.number,
  /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */
  index: PropTypes.number.isRequired,
  isLastVisible: PropTypes.bool,
  isNotVisible: PropTypes.bool,
  lastColumnToRender: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  position: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
  renderedColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  row: PropTypes.object,
  rowHeight: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  selected: PropTypes.bool.isRequired,
  /**
   * Determines which cell should be tabbable by having tabIndex=0.
   * If `null`, no cell in this row is in the tab sequence.
   */
  tabbableCell: PropTypes.string,
  visibleColumns: PropTypes.arrayOf(PropTypes.object).isRequired
} : void 0;
const MemoizedGridRow = fastMemo(GridRow);

function GridContextProvider({
  privateApiRef,
  props,
  children
}) {
  const apiRef = React$1.useRef(privateApiRef.current.getPublicApi());
  return /*#__PURE__*/jsx(GridRootPropsContext.Provider, {
    value: props,
    children: /*#__PURE__*/jsx(GridPrivateApiContext.Provider, {
      value: privateApiRef,
      children: /*#__PURE__*/jsx(GridApiContext.Provider, {
        value: apiRef,
        children: children
      })
    })
  });
}

const forceDebug = localStorageAvailable() && window.localStorage.getItem('DEBUG') != null;
const noop = () => {};
const noopLogger = {
  debug: noop,
  info: noop,
  warn: noop,
  error: noop
};
const LOG_LEVELS = ['debug', 'info', 'warn', 'error'];
function getAppender(name, logLevel, appender = console) {
  const minLogLevelIdx = LOG_LEVELS.indexOf(logLevel);
  if (minLogLevelIdx === -1) {
    throw new Error(`MUI: Log level ${logLevel} not recognized.`);
  }
  const logger = LOG_LEVELS.reduce((loggerObj, method, idx) => {
    if (idx >= minLogLevelIdx) {
      loggerObj[method] = (...args) => {
        const [message, ...other] = args;
        appender[method](`MUI: ${name} - ${message}`, ...other);
      };
    } else {
      loggerObj[method] = noop;
    }
    return loggerObj;
  }, {});
  return logger;
}
const useGridLoggerFactory = (apiRef, props) => {
  const getLogger = React$1.useCallback(name => {
    if (forceDebug) {
      return getAppender(name, 'debug', props.logger);
    }
    if (!props.logLevel) {
      return noopLogger;
    }
    return getAppender(name, props.logLevel.toString(), props.logger);
  }, [props.logLevel, props.logger]);
  useGridApiMethod(apiRef, {
    getLogger
  }, 'private');
};

class Store {
  static create(value) {
    return new Store(value);
  }
  constructor(_value) {
    this.value = void 0;
    this.listeners = void 0;
    this.subscribe = fn => {
      this.listeners.add(fn);
      return () => {
        this.listeners.delete(fn);
      };
    };
    this.getSnapshot = () => {
      return this.value;
    };
    this.update = value => {
      this.value = value;
      this.listeners.forEach(l => l(value));
    };
    this.value = _value;
    this.listeners = new Set();
  }
}

// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class EventManager {
  constructor() {
    this.maxListeners = 20;
    this.warnOnce = false;
    this.events = {};
  }
  on(eventName, listener, options = {}) {
    let collection = this.events[eventName];
    if (!collection) {
      collection = {
        highPriority: new Map(),
        regular: new Map()
      };
      this.events[eventName] = collection;
    }
    if (options.isFirst) {
      collection.highPriority.set(listener, true);
    } else {
      collection.regular.set(listener, true);
    }
    if (process.env.NODE_ENV !== 'production') {
      const collectionSize = collection.highPriority.size + collection.regular.size;
      if (collectionSize > this.maxListeners && !this.warnOnce) {
        this.warnOnce = true;
        console.warn([`Possible EventEmitter memory leak detected. ${collectionSize} ${eventName} listeners added.`].join('\n'));
      }
    }
  }
  removeListener(eventName, listener) {
    if (this.events[eventName]) {
      this.events[eventName].regular.delete(listener);
      this.events[eventName].highPriority.delete(listener);
    }
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(eventName, ...args) {
    const collection = this.events[eventName];
    if (!collection) {
      return;
    }
    const highPriorityListeners = Array.from(collection.highPriority.keys());
    const regularListeners = Array.from(collection.regular.keys());
    for (let i = highPriorityListeners.length - 1; i >= 0; i -= 1) {
      const listener = highPriorityListeners[i];
      if (collection.highPriority.has(listener)) {
        listener.apply(this, args);
      }
    }
    for (let i = 0; i < regularListeners.length; i += 1) {
      const listener = regularListeners[i];
      if (collection.regular.has(listener)) {
        listener.apply(this, args);
      }
    }
  }
  once(eventName, listener) {
    // eslint-disable-next-line consistent-this
    const that = this;
    this.on(eventName, function oneTimeListener(...args) {
      that.removeListener(eventName, oneTimeListener);
      listener.apply(that, args);
    });
  }
}

const SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const isSyntheticEvent = event => {
  return event.isPropagationStopped !== undefined;
};
let globalId = 0;
function createPrivateAPI(publicApiRef) {
  var _publicApiRef$current;
  const existingPrivateApi = (_publicApiRef$current = publicApiRef.current) == null ? void 0 : _publicApiRef$current[SYMBOL_API_PRIVATE];
  if (existingPrivateApi) {
    return existingPrivateApi;
  }
  const state = {};
  const privateApi = {
    state,
    store: Store.create(state),
    instanceId: {
      id: globalId
    }
  };
  globalId += 1;
  privateApi.getPublicApi = () => publicApiRef.current;
  privateApi.register = (visibility, methods) => {
    Object.keys(methods).forEach(methodName => {
      const method = methods[methodName];
      const currentPrivateMethod = privateApi[methodName];
      if ((currentPrivateMethod == null ? void 0 : currentPrivateMethod.spying) === true) {
        currentPrivateMethod.target = method;
      } else {
        privateApi[methodName] = method;
      }
      if (visibility === 'public') {
        const publicApi = publicApiRef.current;
        const currentPublicMethod = publicApi[methodName];
        if ((currentPublicMethod == null ? void 0 : currentPublicMethod.spying) === true) {
          currentPublicMethod.target = method;
        } else {
          publicApi[methodName] = method;
        }
      }
    });
  };
  privateApi.register('private', {
    caches: {},
    eventManager: new EventManager()
  });
  return privateApi;
}
function createPublicAPI(privateApiRef) {
  const publicApi = {
    get state() {
      return privateApiRef.current.state;
    },
    get store() {
      return privateApiRef.current.store;
    },
    get instanceId() {
      return privateApiRef.current.instanceId;
    },
    [SYMBOL_API_PRIVATE]: privateApiRef.current
  };
  return publicApi;
}
function useGridApiInitialization(inputApiRef, props) {
  const publicApiRef = React$1.useRef();
  const privateApiRef = React$1.useRef();
  if (!privateApiRef.current) {
    privateApiRef.current = createPrivateAPI(publicApiRef);
  }
  if (!publicApiRef.current) {
    publicApiRef.current = createPublicAPI(privateApiRef);
  }
  const publishEvent = React$1.useCallback((...args) => {
    const [name, params, event = {}] = args;
    event.defaultMuiPrevented = false;
    if (isSyntheticEvent(event) && event.isPropagationStopped()) {
      return;
    }
    const details = props.signature === GridSignature.DataGridPro ? {
      api: privateApiRef.current.getPublicApi()
    } : {};
    privateApiRef.current.eventManager.emit(name, params, event, details);
  }, [privateApiRef, props.signature]);
  const subscribeEvent = React$1.useCallback((event, handler, options) => {
    privateApiRef.current.eventManager.on(event, handler, options);
    const api = privateApiRef.current;
    return () => {
      api.eventManager.removeListener(event, handler);
    };
  }, [privateApiRef]);
  useGridApiMethod(privateApiRef, {
    subscribeEvent,
    publishEvent
  }, 'public');
  React$1.useImperativeHandle(inputApiRef, () => publicApiRef.current, [publicApiRef]);
  React$1.useEffect(() => {
    const api = privateApiRef.current;
    return () => {
      api.publishEvent('unmount');
    };
  }, [privateApiRef]);
  return privateApiRef;
}

const useGridLocaleText = (apiRef, props) => {
  const getLocaleText = React$1.useCallback(key => {
    if (props.localeText[key] == null) {
      throw new Error(`Missing translation for key ${key}.`);
    }
    return props.localeText[key];
  }, [props.localeText]);
  apiRef.current.register('public', {
    getLocaleText
  });
};

/**
 * Implement the Pipeline Pattern
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic to enrich data provided by other plugins or components.
 * For instance, the row grouping plugin needs to add / remove the grouping columns when the grid columns are updated.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterPipeProcessor` to register their processor.
 *
 * - `apiRef.current.requestPipeProcessorsApplication` to imperatively re-apply a group.
 *   This method should be used in last resort.
 *   Most of the time, the application should be triggered by an update on the deps of the processor.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to enrich its data must use:
 *
 * - `apiRef.current.unstable_applyPipeProcessors` to run in chain all the processors of a given group.
 *
 * - `useGridRegisterPipeApplier` to re-apply the whole pipe when requested.
 *   The applier will be called when:
 *   * a processor is registered.
 *   * `apiRef.current.requestPipeProcessorsApplication` is called for the given group.
 */
const useGridPipeProcessing = apiRef => {
  const processorsCache = React$1.useRef({});
  const isRunning = React$1.useRef(false);
  const runAppliers = React$1.useCallback(groupCache => {
    if (isRunning.current || !groupCache) {
      return;
    }
    isRunning.current = true;
    Object.values(groupCache.appliers).forEach(callback => {
      callback();
    });
    isRunning.current = false;
  }, []);
  const registerPipeProcessor = React$1.useCallback((group, id, processor) => {
    if (!processorsCache.current[group]) {
      processorsCache.current[group] = {
        processors: new Map(),
        appliers: {}
      };
    }
    const groupCache = processorsCache.current[group];
    const oldProcessor = groupCache.processors.get(id);
    if (oldProcessor !== processor) {
      groupCache.processors.set(id, processor);
      runAppliers(groupCache);
    }
    return () => {
      processorsCache.current[group].processors.set(id, null);
    };
  }, [runAppliers]);
  const registerPipeApplier = React$1.useCallback((group, id, applier) => {
    if (!processorsCache.current[group]) {
      processorsCache.current[group] = {
        processors: new Map(),
        appliers: {}
      };
    }
    processorsCache.current[group].appliers[id] = applier;
    return () => {
      const _appliers = processorsCache.current[group].appliers,
        otherAppliers = _objectWithoutPropertiesLoose$b(_appliers, [id].map(toPropertyKey));
      processorsCache.current[group].appliers = otherAppliers;
    };
  }, []);
  const requestPipeProcessorsApplication = React$1.useCallback(group => {
    const groupCache = processorsCache.current[group];
    runAppliers(groupCache);
  }, [runAppliers]);
  const applyPipeProcessors = React$1.useCallback((...args) => {
    const [group, value, context] = args;
    if (!processorsCache.current[group]) {
      return value;
    }
    const preProcessors = Array.from(processorsCache.current[group].processors.values());
    return preProcessors.reduce((acc, preProcessor) => {
      if (!preProcessor) {
        return acc;
      }
      return preProcessor(acc, context);
    }, value);
  }, []);
  const preProcessingPrivateApi = {
    registerPipeProcessor,
    registerPipeApplier,
    requestPipeProcessorsApplication
  };
  const preProcessingPublicApi = {
    unstable_applyPipeProcessors: applyPipeProcessors
  };
  useGridApiMethod(apiRef, preProcessingPrivateApi, 'private');
  useGridApiMethod(apiRef, preProcessingPublicApi, 'public');
};

const useGridRegisterPipeProcessor = (apiRef, group, callback) => {
  const cleanup = React$1.useRef();
  const id = React$1.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
  const registerPreProcessor = React$1.useCallback(() => {
    cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
  }, [apiRef, callback, group]);
  useFirstRender(() => {
    registerPreProcessor();
  });
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      registerPreProcessor();
    }
    return () => {
      if (cleanup.current) {
        cleanup.current();
        cleanup.current = null;
      }
    };
  }, [registerPreProcessor]);
};

const useGridRegisterPipeApplier = (apiRef, group, callback) => {
  const cleanup = React$1.useRef();
  const id = React$1.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
  const registerPreProcessor = React$1.useCallback(() => {
    cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
  }, [apiRef, callback, group]);
  useFirstRender(() => {
    registerPreProcessor();
  });
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      registerPreProcessor();
    }
    return () => {
      if (cleanup.current) {
        cleanup.current();
        cleanup.current = null;
      }
    };
  }, [registerPreProcessor]);
};

const useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor) => {
  const registerPreProcessor = React$1.useCallback(() => {
    apiRef.current.registerStrategyProcessor(strategyName, group, processor);
  }, [apiRef, processor, group, strategyName]);
  useFirstRender(() => {
    registerPreProcessor();
  });
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      registerPreProcessor();
    }
  }, [registerPreProcessor]);
};

const GRID_DEFAULT_STRATEGY = 'none';
const GRID_STRATEGIES_PROCESSORS = {
  rowTreeCreation: 'rowTree',
  filtering: 'rowTree',
  sorting: 'rowTree',
  visibleRowsLookupCreation: 'rowTree'
};
/**
 * Implements a variant of the Strategy Pattern (see https://en.wikipedia.org/wiki/Strategy_pattern)
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic that must only be applied if the right strategy is active.
 * For instance, the row grouping plugin has a custom filtering algorithm.
 * This algorithm must be applied by the filtering plugin if the row grouping is the current way of grouping rows,
 * but not if the tree data is the current way of grouping rows.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterStrategyProcessor` to register their processor.
 *   When the processor of the active strategy changes, it will fire `"activeStrategyProcessorChange"` to re-apply the processor.
 *
 * - `apiRef.current.setStrategyAvailability` to tell if their strategy can be used.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to apply the custom logic of the current strategy must use:
 *
 * - `apiRef.current.applyStrategyProcessor` to run the processor of the active strategy for a given processor name.
 *
 * - the "strategyAvailabilityChange" event to update something when the active strategy changes.
 *    Warning: Be careful not to apply the processor several times.
 *    For instance "rowsSet" is fired by `useGridRows` whenever the active strategy changes.
 *    So listening to both would most likely run your logic twice.
 *
 * - The "activeStrategyProcessorChange" event to update something when the processor of the active strategy changes.
 *
 * =====================================================================================================================
 *
 * Each processor name is part of a strategy group which can only have one active strategy at the time.
 * For now, there is only one strategy group named `rowTree` which customize
 * - row tree creation algorithm.
 * - sorting algorithm.
 * - filtering algorithm.
 */
const useGridStrategyProcessing = apiRef => {
  const availableStrategies = React$1.useRef(new Map());
  const strategiesCache = React$1.useRef({});
  const registerStrategyProcessor = React$1.useCallback((strategyName, processorName, processor) => {
    const cleanup = () => {
      const _ref = strategiesCache.current[processorName],
        otherProcessors = _objectWithoutPropertiesLoose$b(_ref, [strategyName].map(toPropertyKey));
      strategiesCache.current[processorName] = otherProcessors;
    };
    if (!strategiesCache.current[processorName]) {
      strategiesCache.current[processorName] = {};
    }
    const groupPreProcessors = strategiesCache.current[processorName];
    const previousProcessor = groupPreProcessors[strategyName];
    groupPreProcessors[strategyName] = processor;
    if (!previousProcessor || previousProcessor === processor) {
      return cleanup;
    }
    if (strategyName === apiRef.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName])) {
      apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
    }
    return cleanup;
  }, [apiRef]);
  const applyStrategyProcessor = React$1.useCallback((processorName, params) => {
    const activeStrategy = apiRef.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName]);
    if (activeStrategy == null) {
      throw new Error("Can't apply a strategy processor before defining an active strategy");
    }
    const groupCache = strategiesCache.current[processorName];
    if (!groupCache || !groupCache[activeStrategy]) {
      throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
    }
    const processor = groupCache[activeStrategy];
    return processor(params);
  }, [apiRef]);
  const getActiveStrategy = React$1.useCallback(strategyGroup => {
    var _availableStrategyEnt;
    const strategyEntries = Array.from(availableStrategies.current.entries());
    const availableStrategyEntry = strategyEntries.find(([, strategy]) => {
      if (strategy.group !== strategyGroup) {
        return false;
      }
      return strategy.isAvailable();
    });
    return (_availableStrategyEnt = availableStrategyEntry == null ? void 0 : availableStrategyEntry[0]) != null ? _availableStrategyEnt : GRID_DEFAULT_STRATEGY;
  }, []);
  const setStrategyAvailability = React$1.useCallback((strategyGroup, strategyName, isAvailable) => {
    availableStrategies.current.set(strategyName, {
      group: strategyGroup,
      isAvailable
    });
    apiRef.current.publishEvent('strategyAvailabilityChange');
  }, [apiRef]);
  const strategyProcessingApi = {
    registerStrategyProcessor,
    applyStrategyProcessor,
    getActiveStrategy,
    setStrategyAvailability
  };
  useGridApiMethod(apiRef, strategyProcessingApi, 'private');
};

const useGridStateInitialization = (apiRef, props) => {
  const controlStateMapRef = React$1.useRef({});
  const [, rawForceUpdate] = React$1.useState();
  const registerControlState = React$1.useCallback(controlStateItem => {
    controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
  }, []);
  const setState = React$1.useCallback((state, reason) => {
    let newState;
    if (isFunction(state)) {
      newState = state(apiRef.current.state);
    } else {
      newState = state;
    }
    if (apiRef.current.state === newState) {
      return false;
    }
    let ignoreSetState = false;

    // Apply the control state constraints
    const updatedControlStateIds = [];
    Object.keys(controlStateMapRef.current).forEach(stateId => {
      const controlState = controlStateMapRef.current[stateId];
      const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
      const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
      if (newSubState === oldSubState) {
        return;
      }
      updatedControlStateIds.push({
        stateId: controlState.stateId,
        hasPropChanged: newSubState !== controlState.propModel
      });

      // The state is controlled, the prop should always win
      if (controlState.propModel !== undefined && newSubState !== controlState.propModel) {
        ignoreSetState = true;
      }
    });
    if (updatedControlStateIds.length > 1) {
      // Each hook modify its own state, and it should not leak
      // Events are here to forward to other hooks and apply changes.
      // You are trying to update several states in a no isolated way.
      throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map(el => el.stateId).join(', ')} in the same transaction.`);
    }
    if (!ignoreSetState) {
      // We always assign it as we mutate rows for perf reason.
      apiRef.current.state = newState;
      if (apiRef.current.publishEvent) {
        apiRef.current.publishEvent('stateChange', newState);
      }
      apiRef.current.store.update(newState);
    }
    if (updatedControlStateIds.length === 1) {
      const {
        stateId,
        hasPropChanged
      } = updatedControlStateIds[0];
      const controlState = controlStateMapRef.current[stateId];
      const model = controlState.stateSelector(newState, apiRef.current.instanceId);
      if (controlState.propOnChange && hasPropChanged) {
        const details = props.signature === GridSignature.DataGridPro ? {
          api: apiRef.current,
          reason
        } : {
          reason
        };
        controlState.propOnChange(model, details);
      }
      if (!ignoreSetState) {
        apiRef.current.publishEvent(controlState.changeEvent, model, {
          reason
        });
      }
    }
    return !ignoreSetState;
  }, [apiRef, props.signature]);
  const updateControlState = React$1.useCallback((key, state, reason) => {
    return apiRef.current.setState(previousState => {
      return _extends$c({}, previousState, {
        [key]: state(previousState[key])
      });
    }, reason);
  }, [apiRef]);
  const forceUpdate = React$1.useCallback(() => rawForceUpdate(() => apiRef.current.state), [apiRef]);
  const publicStateApi = {
    setState,
    forceUpdate
  };
  const privateStateApi = {
    updateControlState,
    registerControlState
  };
  useGridApiMethod(apiRef, publicStateApi, 'public');
  useGridApiMethod(apiRef, privateStateApi, 'private');
};

/**
 * Initialize the technical pieces of the DataGrid (logger, state, ...) that any DataGrid implementation needs
 */
const useGridInitialization = (inputApiRef, props) => {
  const privateApiRef = useGridApiInitialization(inputApiRef, props);
  useGridLoggerFactory(privateApiRef, props);
  useGridStateInitialization(privateApiRef, props);
  useGridPipeProcessing(privateApiRef);
  useGridStrategyProcessing(privateApiRef);
  useGridLocaleText(privateApiRef, props);
  return privateApiRef;
};

const useGridInitializeState = (initializer, privateApiRef, props) => {
  const isInitialized = React$1.useRef(false);
  if (!isInitialized.current) {
    privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
    isInitialized.current = true;
  }
};

const dateRegex = /(\d+)-(\d+)-(\d+)/;
const dateTimeRegex = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
  if (!filterItem.value) {
    return null;
  }
  const [year, month, day, hour, minute] = filterItem.value.match(showTime ? dateTimeRegex : dateRegex).slice(1).map(Number);
  const time = new Date(year, month - 1, day, hour || 0, minute || 0).getTime();
  return value => {
    if (!value) {
      return false;
    }
    if (keepHours) {
      return compareFn(value.getTime(), time);
    }

    // Make a copy of the date to not reset the hours in the original object
    const dateCopy = new Date(value);
    const timeToCompare = dateCopy.setHours(showTime ? value.getHours() : 0, showTime ? value.getMinutes() : 0, 0, 0);
    return compareFn(timeToCompare, time);
  };
}
const getGridDateOperators = showTime => convertLegacyOperators([{
  value: 'is',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 === value2, showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'not',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 !== value2, showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'after',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 > value2, showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'onOrAfter',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 >= value2, showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'before',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 < value2, showTime, !showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'onOrBefore',
  getApplyFilterFnV7: filterItem => {
    return buildApplyFilterFn(filterItem, (value1, value2) => value1 <= value2, showTime);
  },
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: showTime ? 'datetime-local' : 'date'
  }
}, {
  value: 'isEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value == null;
    };
  },
  requiresFilterValue: false
}, {
  value: 'isNotEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value != null;
    };
  },
  requiresFilterValue: false
}]);

function throwIfNotDateObject({
  value,
  columnType,
  rowId,
  field
}) {
  if (!(value instanceof Date)) {
    throw new Error([`MUI: \`${columnType}\` column type only accepts \`Date\` objects as values.`, 'Use `valueGetter` to transform the value into a `Date` object.', `Row ID: ${rowId}, field: "${field}".`].join('\n'));
  }
}
function gridDateFormatter({
  value,
  field,
  id
}) {
  if (!value) {
    return '';
  }
  throwIfNotDateObject({
    value,
    columnType: 'date',
    rowId: id,
    field
  });
  return value.toLocaleDateString();
}
function gridDateTimeFormatter({
  value,
  field,
  id
}) {
  if (!value) {
    return '';
  }
  throwIfNotDateObject({
    value,
    columnType: 'dateTime',
    rowId: id,
    field
  });
  return value.toLocaleString();
}
const GRID_DATE_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  type: 'date',
  sortComparator: gridDateComparator,
  valueFormatter: gridDateFormatter,
  filterOperators: getGridDateOperators(),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: value => new Date(value)
});
const GRID_DATETIME_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  type: 'dateTime',
  sortComparator: gridDateComparator,
  valueFormatter: gridDateTimeFormatter,
  filterOperators: getGridDateOperators(true),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: value => new Date(value)
});

const parseNumericValue = value => {
  if (value == null) {
    return null;
  }
  return Number(value);
};
const getGridNumericQuickFilterFn = tagInternalFilter(value => {
  if (value == null || Number.isNaN(value) || value === '') {
    return null;
  }
  return columnValue => {
    return parseNumericValue(columnValue) === parseNumericValue(value);
  };
});
const getGridNumericOperators = () => convertLegacyOperators([{
  value: '=',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      return parseNumericValue(value) === filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: '!=',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      return parseNumericValue(value) !== filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: '>',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      if (value == null) {
        return false;
      }
      return parseNumericValue(value) > filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: '>=',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      if (value == null) {
        return false;
      }
      return parseNumericValue(value) >= filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: '<',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      if (value == null) {
        return false;
      }
      return parseNumericValue(value) < filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: '<=',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || Number.isNaN(filterItem.value)) {
      return null;
    }
    return value => {
      if (value == null) {
        return false;
      }
      return parseNumericValue(value) <= filterItem.value;
    };
  },
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: 'number'
  }
}, {
  value: 'isEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value == null;
    };
  },
  requiresFilterValue: false
}, {
  value: 'isNotEmpty',
  getApplyFilterFnV7: () => {
    return value => {
      return value != null;
    };
  },
  requiresFilterValue: false
}, {
  value: 'isAnyOf',
  getApplyFilterFnV7: filterItem => {
    if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) {
      return null;
    }
    return value => {
      return value != null && filterItem.value.includes(Number(value));
    };
  },
  InputComponent: GridFilterInputMultipleValue,
  InputComponentProps: {
    type: 'number'
  }
}]);

const GRID_NUMERIC_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  type: 'number',
  align: 'right',
  headerAlign: 'right',
  sortComparator: gridNumberComparator,
  valueParser: value => value === '' ? null : Number(value),
  valueFormatter: ({
    value
  }) => isNumber(value) ? value.toLocaleString() : value || '',
  filterOperators: getGridNumericOperators(),
  getApplyQuickFilterFn: convertQuickFilterV7ToLegacy(getGridNumericQuickFilterFn),
  getApplyQuickFilterFnV7: getGridNumericQuickFilterFn
});

const parseObjectValue = value => {
  if (value == null || !isObject(value)) {
    return value;
  }
  return value.value;
};
const getGridSingleSelectOperators = () => convertLegacyOperators([{
  value: 'is',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || filterItem.value === '') {
      return null;
    }
    return value => parseObjectValue(value) === parseObjectValue(filterItem.value);
  },
  InputComponent: GridFilterInputSingleSelect
}, {
  value: 'not',
  getApplyFilterFnV7: filterItem => {
    if (filterItem.value == null || filterItem.value === '') {
      return null;
    }
    return value => parseObjectValue(value) !== parseObjectValue(filterItem.value);
  },
  InputComponent: GridFilterInputSingleSelect
}, {
  value: 'isAnyOf',
  getApplyFilterFnV7: filterItem => {
    if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) {
      return null;
    }
    const filterItemValues = filterItem.value.map(parseObjectValue);
    return value => filterItemValues.includes(parseObjectValue(value));
  },
  InputComponent: GridFilterInputMultipleSingleSelect
}]);

const isArrayOfObjects = options => {
  return typeof options[0] === 'object';
};
const defaultGetOptionValue = value => {
  return isObject(value) ? value.value : value;
};
const defaultGetOptionLabel = value => {
  return isObject(value) ? value.label : String(value);
};
const GRID_SINGLE_SELECT_COL_DEF = _extends$c({}, GRID_STRING_COL_DEF, {
  type: 'singleSelect',
  getOptionLabel: defaultGetOptionLabel,
  getOptionValue: defaultGetOptionValue,
  valueFormatter(params) {
    const {
      id,
      field,
      value,
      api
    } = params;
    const colDef = params.api.getColumn(field);
    if (!isSingleSelectColDef(colDef)) {
      return '';
    }
    let valueOptions;
    if (typeof colDef.valueOptions === 'function') {
      valueOptions = colDef.valueOptions({
        id,
        row: id ? api.getRow(id) : null,
        field
      });
    } else {
      valueOptions = colDef.valueOptions;
    }
    if (value == null) {
      return '';
    }
    if (!valueOptions) {
      return value;
    }
    if (!isArrayOfObjects(valueOptions)) {
      return colDef.getOptionLabel(value);
    }
    const valueOption = valueOptions.find(option => colDef.getOptionValue(option) === value);
    return valueOption ? colDef.getOptionLabel(valueOption) : '';
  },
  renderEditCell: renderEditSingleSelectCell,
  filterOperators: getGridSingleSelectOperators(),
  // @ts-ignore
  pastedValueParser: (value, params) => {
    const colDef = params.colDef;
    const colDefValueOptions = colDef.valueOptions;
    const valueOptions = typeof colDefValueOptions === 'function' ? colDefValueOptions({
      field: colDef.field
    }) : colDefValueOptions || [];
    const getOptionValue = colDef.getOptionValue;
    const valueOption = valueOptions.find(option => {
      if (getOptionValue(option) === value) {
        return true;
      }
      return false;
    });
    if (valueOption) {
      return value;
    }
    // do not paste the value if it is not in the valueOptions
    return undefined;
  }
});

const DEFAULT_GRID_COL_TYPE_KEY = '__default__';
const getGridDefaultColumnTypes = () => {
  const nativeColumnTypes = {
    string: GRID_STRING_COL_DEF,
    number: GRID_NUMERIC_COL_DEF,
    date: GRID_DATE_COL_DEF,
    dateTime: GRID_DATETIME_COL_DEF,
    boolean: GRID_BOOLEAN_COL_DEF,
    singleSelect: GRID_SINGLE_SELECT_COL_DEF,
    [GRID_ACTIONS_COLUMN_TYPE]: GRID_ACTIONS_COL_DEF,
    [DEFAULT_GRID_COL_TYPE_KEY]: GRID_STRING_COL_DEF
  };
  return nativeColumnTypes;
};

function sanitizeCellValue(value, delimiterCharacter) {
  if (typeof value === 'string') {
    // Make sure value containing delimiter or line break won't be split into multiple rows
    if ([delimiterCharacter, '\n', '\r', '"'].some(delimiter => value.includes(delimiter))) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }
  return value;
}
const serializeCellValue = (cellParams, options) => {
  const {
    delimiterCharacter,
    ignoreValueFormatter
  } = options;
  let value;
  if (ignoreValueFormatter) {
    var _cellParams$value2;
    const columnType = cellParams.colDef.type;
    if (columnType === 'number') {
      value = String(cellParams.value);
    } else if (columnType === 'date' || columnType === 'dateTime') {
      var _cellParams$value;
      value = (_cellParams$value = cellParams.value) == null ? void 0 : _cellParams$value.toISOString();
    } else if (typeof ((_cellParams$value2 = cellParams.value) == null ? void 0 : _cellParams$value2.toString) === 'function') {
      value = cellParams.value.toString();
    } else {
      value = cellParams.value;
    }
  } else {
    value = cellParams.formattedValue;
  }
  return sanitizeCellValue(value, delimiterCharacter);
};
const objectFormattedValueWarning = buildWarning(['MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.', 'You can provide a `valueFormatter` with a string representation to be used.']);
class CSVRow {
  constructor(options) {
    this.options = void 0;
    this.rowString = '';
    this.isEmpty = true;
    this.options = options;
  }
  addValue(value) {
    if (!this.isEmpty) {
      this.rowString += this.options.delimiterCharacter;
    }
    if (value === null || value === undefined) {
      this.rowString += '';
    } else if (typeof this.options.sanitizeCellValue === 'function') {
      this.rowString += this.options.sanitizeCellValue(value, this.options.delimiterCharacter);
    } else {
      this.rowString += value;
    }
    this.isEmpty = false;
  }
  getRowString() {
    return this.rowString;
  }
}
const serializeRow = ({
  id,
  columns,
  getCellParams,
  delimiterCharacter,
  ignoreValueFormatter
}) => {
  const row = new CSVRow({
    delimiterCharacter
  });
  columns.forEach(column => {
    const cellParams = getCellParams(id, column.field);
    if (process.env.NODE_ENV !== 'production') {
      if (String(cellParams.formattedValue) === '[object Object]') {
        objectFormattedValueWarning();
      }
    }
    row.addValue(serializeCellValue(cellParams, {
      delimiterCharacter,
      ignoreValueFormatter
    }));
  });
  return row.getRowString();
};
function buildCSV(options) {
  const {
    columns,
    rowIds,
    delimiterCharacter,
    includeHeaders,
    includeColumnGroupsHeaders,
    ignoreValueFormatter,
    apiRef
  } = options;
  const CSVBody = rowIds.reduce((acc, id) => `${acc}${serializeRow({
    id,
    columns,
    getCellParams: apiRef.current.getCellParams,
    delimiterCharacter,
    ignoreValueFormatter
  })}\r\n`, '').trim();
  if (!includeHeaders) {
    return CSVBody;
  }
  const filteredColumns = columns.filter(column => column.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field);
  const headerRows = [];
  if (includeColumnGroupsHeaders) {
    const columnGroupLookup = apiRef.current.unstable_getAllGroupDetails();
    let maxColumnGroupsDepth = 0;
    const columnGroupPathsLookup = filteredColumns.reduce((acc, column) => {
      const columnGroupPath = apiRef.current.unstable_getColumnGroupPath(column.field);
      acc[column.field] = columnGroupPath;
      maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
      return acc;
    }, {});
    for (let i = 0; i < maxColumnGroupsDepth; i += 1) {
      const headerGroupRow = new CSVRow({
        delimiterCharacter,
        sanitizeCellValue
      });
      headerRows.push(headerGroupRow);
      filteredColumns.forEach(column => {
        const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
        const columnGroup = columnGroupLookup[columnGroupId];
        headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
      });
    }
  }
  const mainHeaderRow = new CSVRow({
    delimiterCharacter,
    sanitizeCellValue
  });
  filteredColumns.forEach(column => {
    mainHeaderRow.addValue(column.headerName || column.field);
  });
  headerRows.push(mainHeaderRow);
  const CSVHead = `${headerRows.map(row => row.getRowString()).join('\r\n')}\r\n`;
  return `${CSVHead}${CSVBody}`.trim();
}

function writeToClipboardPolyfill(data) {
  const span = document.createElement('span');
  span.style.whiteSpace = 'pre';
  span.style.userSelect = 'all';
  span.style.opacity = '0px';
  span.textContent = data;
  document.body.appendChild(span);
  const range = document.createRange();
  range.selectNode(span);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(span);
  }
}
function copyToClipboard(data) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(data).catch(() => {
      writeToClipboardPolyfill(data);
    });
  } else {
    writeToClipboardPolyfill(data);
  }
}
function hasNativeSelection(element) {
  var _window$getSelection;
  // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
  if ((_window$getSelection = window.getSelection()) != null && _window$getSelection.toString()) {
    return true;
  }

  // window.getSelection() returns an empty string in Firefox for selections inside a form element.
  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
  // Instead, we can use element.selectionStart that is only defined on form elements.
  if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) {
    return true;
  }
  return false;
}

/**
 * @requires useGridCsvExport (method)
 * @requires useGridSelection (method)
 */
const useGridClipboard = (apiRef, props) => {
  const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
  const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.clipboardExport : ignoreValueFormatterProp) || false;
  const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
  const handleCopy = React$1.useCallback(event => {
    if (!((event.ctrlKey || event.metaKey) && event.key === 'c')) {
      return;
    }

    // Do nothing if there's a native selection
    if (hasNativeSelection(event.target)) {
      return;
    }
    let textToCopy = '';
    const selectedRows = apiRef.current.getSelectedRows();
    if (selectedRows.size > 0) {
      textToCopy = apiRef.current.getDataAsCsv({
        includeHeaders: false,
        // TODO: make it configurable
        delimiter: clipboardCopyCellDelimiter
      });
    } else {
      const focusedCell = gridFocusCellSelector(apiRef);
      if (focusedCell) {
        const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
        textToCopy = serializeCellValue(cellParams, {
          delimiterCharacter: clipboardCopyCellDelimiter,
          ignoreValueFormatter
        });
      }
    }
    textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
    if (textToCopy) {
      copyToClipboard(textToCopy);
      apiRef.current.publishEvent('clipboardCopy', textToCopy);
    }
  }, [apiRef, ignoreValueFormatter, clipboardCopyCellDelimiter]);
  useGridNativeEventListener(apiRef, apiRef.current.rootElementRef, 'keydown', handleCopy);
  useGridApiOptionHandler(apiRef, 'clipboardCopy', props.onClipboardCopy);
};

const columnMenuStateInitializer = state => _extends$c({}, state, {
  columnMenu: {
    open: false
  }
});

/**
 * @requires useGridColumnResize (event)
 * @requires useGridInfiniteLoader (event)
 */
const useGridColumnMenu = apiRef => {
  const logger = useGridLogger(apiRef, 'useGridColumnMenu');

  /**
   * API METHODS
   */
  const showColumnMenu = React$1.useCallback(field => {
    const shouldUpdate = apiRef.current.setState(state => {
      if (state.columnMenu.open && state.columnMenu.field === field) {
        return state;
      }
      logger.debug('Opening Column Menu');
      return _extends$c({}, state, {
        columnMenu: {
          open: true,
          field
        }
      });
    });
    if (shouldUpdate) {
      apiRef.current.hidePreferences();
      apiRef.current.forceUpdate();
    }
  }, [apiRef, logger]);
  const hideColumnMenu = React$1.useCallback(() => {
    const columnMenuState = gridColumnMenuSelector(apiRef.current.state);
    if (columnMenuState.field) {
      const columnLookup = gridColumnLookupSelector(apiRef);
      const columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef);
      const orderedFields = gridColumnFieldsSelector(apiRef);
      let fieldToFocus = columnMenuState.field;

      // If the column was removed from the grid, we need to find the closest visible field
      if (!columnLookup[fieldToFocus]) {
        fieldToFocus = orderedFields[0];
      }

      // If the field to focus is hidden, we need to find the closest visible field
      if (columnVisibilityModel[fieldToFocus] === false) {
        // contains visible column fields + the field that was just hidden
        const visibleOrderedFields = orderedFields.filter(field => {
          if (field === fieldToFocus) {
            return true;
          }
          return columnVisibilityModel[field] !== false;
        });
        const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
        fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
      }
      apiRef.current.setColumnHeaderFocus(fieldToFocus);
    }
    const shouldUpdate = apiRef.current.setState(state => {
      if (!state.columnMenu.open && state.columnMenu.field === undefined) {
        return state;
      }
      logger.debug('Hiding Column Menu');
      return _extends$c({}, state, {
        columnMenu: _extends$c({}, state.columnMenu, {
          open: false,
          field: undefined
        })
      });
    });
    if (shouldUpdate) {
      apiRef.current.forceUpdate();
    }
  }, [apiRef, logger]);
  const toggleColumnMenu = React$1.useCallback(field => {
    logger.debug('Toggle Column Menu');
    const columnMenu = gridColumnMenuSelector(apiRef.current.state);
    if (!columnMenu.open || columnMenu.field !== field) {
      showColumnMenu(field);
    } else {
      hideColumnMenu();
    }
  }, [apiRef, logger, showColumnMenu, hideColumnMenu]);
  const columnMenuApi = {
    showColumnMenu,
    hideColumnMenu,
    toggleColumnMenu
  };
  useGridApiMethod(apiRef, columnMenuApi, 'public');
  useGridApiEventHandler(apiRef, 'columnResizeStart', hideColumnMenu);
  useGridApiEventHandler(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
  useGridApiEventHandler(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};

const COLUMNS_DIMENSION_PROPERTIES = ['maxWidth', 'minWidth', 'width', 'flex'];
/**
 * Computes width for flex columns.
 * Based on CSS Flexbox specification:
 * https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
 */
function computeFlexColumnsWidth({
  initialFreeSpace,
  totalFlexUnits,
  flexColumns
}) {
  const uniqueFlexColumns = new Set(flexColumns.map(col => col.field));
  const flexColumnsLookup = {
    all: {},
    frozenFields: [],
    freeze: field => {
      const value = flexColumnsLookup.all[field];
      if (value && value.frozen !== true) {
        flexColumnsLookup.all[field].frozen = true;
        flexColumnsLookup.frozenFields.push(field);
      }
    }
  };

  // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
  function loopOverFlexItems() {
    // 5a: If all the flex items on the line are frozen, free space has been distributed.
    if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) {
      return;
    }
    const violationsLookup = {
      min: {},
      max: {}
    };
    let remainingFreeSpace = initialFreeSpace;
    let flexUnits = totalFlexUnits;
    let totalViolation = 0;

    // 5b: Calculate the remaining free space
    flexColumnsLookup.frozenFields.forEach(field => {
      remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
      flexUnits -= flexColumnsLookup.all[field].flex;
    });
    for (let i = 0; i < flexColumns.length; i += 1) {
      const column = flexColumns[i];
      if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) {
        continue;
      }

      // 5c: Distribute remaining free space proportional to the flex factors
      const widthPerFlexUnit = remainingFreeSpace / flexUnits;
      let computedWidth = widthPerFlexUnit * column.flex;

      // 5d: Fix min/max violations
      if (computedWidth < column.minWidth) {
        totalViolation += column.minWidth - computedWidth;
        computedWidth = column.minWidth;
        violationsLookup.min[column.field] = true;
      } else if (computedWidth > column.maxWidth) {
        totalViolation += column.maxWidth - computedWidth;
        computedWidth = column.maxWidth;
        violationsLookup.max[column.field] = true;
      }
      flexColumnsLookup.all[column.field] = {
        frozen: false,
        computedWidth,
        flex: column.flex
      };
    }

    // 5e: Freeze over-flexed items
    if (totalViolation < 0) {
      // Freeze all the items with max violations
      Object.keys(violationsLookup.max).forEach(field => {
        flexColumnsLookup.freeze(field);
      });
    } else if (totalViolation > 0) {
      // Freeze all the items with min violations
      Object.keys(violationsLookup.min).forEach(field => {
        flexColumnsLookup.freeze(field);
      });
    } else {
      // Freeze all items
      flexColumns.forEach(({
        field
      }) => {
        flexColumnsLookup.freeze(field);
      });
    }

    // 5f: Return to the start of this loop
    loopOverFlexItems();
  }
  loopOverFlexItems();
  return flexColumnsLookup.all;
}

/**
 * Compute the `computedWidth` (ie: the width the column should have during rendering) based on the `width` / `flex` / `minWidth` / `maxWidth` properties of `GridColDef`.
 * The columns already have been merged with there `type` default values for `minWidth`, `maxWidth` and `width`, thus the `!` for those properties below.
 * TODO: Unit test this function in depth and only keep basic cases for the whole grid testing.
 * TODO: Improve the `GridColDef` typing to reflect the fact that `minWidth` / `maxWidth` and `width` can't be null after the merge with the `type` default values.
 */
const hydrateColumnsWidth = (rawState, viewportInnerWidth) => {
  const columnsLookup = {};
  let totalFlexUnits = 0;
  let widthAllocatedBeforeFlex = 0;
  const flexColumns = [];

  // For the non-flex columns, compute their width
  // For the flex columns, compute there minimum width and how much width must be allocated during the flex allocation
  rawState.orderedFields.forEach(columnField => {
    const newColumn = _extends$c({}, rawState.lookup[columnField]);
    if (rawState.columnVisibilityModel[columnField] === false) {
      newColumn.computedWidth = 0;
    } else {
      let computedWidth;
      if (newColumn.flex && newColumn.flex > 0) {
        totalFlexUnits += newColumn.flex;
        computedWidth = 0;
        flexColumns.push(newColumn);
      } else {
        computedWidth = clamp(newColumn.width || GRID_STRING_COL_DEF.width, newColumn.minWidth || GRID_STRING_COL_DEF.minWidth, newColumn.maxWidth || GRID_STRING_COL_DEF.maxWidth);
      }
      widthAllocatedBeforeFlex += computedWidth;
      newColumn.computedWidth = computedWidth;
    }
    columnsLookup[columnField] = newColumn;
  });
  const initialFreeSpace = Math.max(viewportInnerWidth - widthAllocatedBeforeFlex, 0);

  // Allocate the remaining space to the flex columns
  if (totalFlexUnits > 0 && viewportInnerWidth > 0) {
    const computedColumnWidths = computeFlexColumnsWidth({
      initialFreeSpace,
      totalFlexUnits,
      flexColumns
    });
    Object.keys(computedColumnWidths).forEach(field => {
      columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
    });
  }
  return _extends$c({}, rawState, {
    lookup: columnsLookup
  });
};

/**
 * Apply the order and the dimensions of the initial state.
 * The columns not registered in `orderedFields` will be placed after the imported columns.
 */
const applyInitialState = (columnsState, initialState) => {
  if (!initialState) {
    return columnsState;
  }
  const {
    orderedFields = [],
    dimensions = {}
  } = initialState;
  const columnsWithUpdatedDimensions = Object.keys(dimensions);
  if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) {
    return columnsState;
  }
  const orderedFieldsLookup = {};
  const cleanOrderedFields = [];
  for (let i = 0; i < orderedFields.length; i += 1) {
    const field = orderedFields[i];

    // Ignores the fields in the initialState that matches no field on the current column state
    if (columnsState.lookup[field]) {
      orderedFieldsLookup[field] = true;
      cleanOrderedFields.push(field);
    }
  }
  const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [...cleanOrderedFields, ...columnsState.orderedFields.filter(field => !orderedFieldsLookup[field])];
  const newColumnLookup = _extends$c({}, columnsState.lookup);
  for (let i = 0; i < columnsWithUpdatedDimensions.length; i += 1) {
    const field = columnsWithUpdatedDimensions[i];
    const newColDef = _extends$c({}, newColumnLookup[field], {
      hasBeenResized: true
    });
    Object.entries(dimensions[field]).forEach(([key, value]) => {
      newColDef[key] = value === -1 ? Infinity : value;
    });
    newColumnLookup[field] = newColDef;
  }
  const newColumnsState = _extends$c({}, columnsState, {
    orderedFields: newOrderedFields,
    lookup: newColumnLookup
  });
  return newColumnsState;
};
function getDefaultColTypeDef(columnTypes, type) {
  let colDef = columnTypes[DEFAULT_GRID_COL_TYPE_KEY];
  if (type && columnTypes[type]) {
    colDef = columnTypes[type];
  }
  return colDef;
}
const createColumnsState = ({
  apiRef,
  columnsToUpsert,
  initialState,
  columnTypes,
  columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef),
  keepOnlyColumnsToUpsert = false
}) => {
  var _apiRef$current$getRo, _apiRef$current$getRo2, _apiRef$current;
  const isInsideStateInitializer = !apiRef.current.state.columns;
  let columnsState;
  if (isInsideStateInitializer) {
    columnsState = {
      orderedFields: [],
      lookup: {},
      columnVisibilityModel
    };
  } else {
    const currentState = gridColumnsStateSelector(apiRef.current.state);
    columnsState = {
      orderedFields: keepOnlyColumnsToUpsert ? [] : [...currentState.orderedFields],
      lookup: _extends$c({}, currentState.lookup),
      // Will be cleaned later if keepOnlyColumnsToUpsert=true
      columnVisibilityModel
    };
  }
  let columnsToKeep = {};
  if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
    columnsToKeep = Object.keys(columnsState.lookup).reduce((acc, key) => _extends$c({}, acc, {
      [key]: false
    }), {});
  }
  columnsToUpsert.forEach(newColumn => {
    const {
      field
    } = newColumn;
    columnsToKeep[field] = true;
    let existingState = columnsState.lookup[field];
    if (existingState == null) {
      existingState = _extends$c({}, getDefaultColTypeDef(columnTypes, newColumn.type), {
        field,
        hasBeenResized: false
      });
      columnsState.orderedFields.push(field);
    } else if (keepOnlyColumnsToUpsert) {
      columnsState.orderedFields.push(field);
    }

    // If the column type has changed - merge the existing state with the default column type definition
    if (existingState && existingState.type !== newColumn.type) {
      existingState = _extends$c({}, getDefaultColTypeDef(columnTypes, newColumn.type), {
        field
      });
    }
    let hasBeenResized = existingState.hasBeenResized;
    COLUMNS_DIMENSION_PROPERTIES.forEach(key => {
      if (newColumn[key] !== undefined) {
        hasBeenResized = true;
        if (newColumn[key] === -1) {
          newColumn[key] = Infinity;
        }
      }
    });
    columnsState.lookup[field] = _extends$c({}, existingState, newColumn, {
      hasBeenResized
    });
  });
  if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
    Object.keys(columnsState.lookup).forEach(field => {
      if (!columnsToKeep[field]) {
        delete columnsState.lookup[field];
      }
    });
  }
  const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
  const columnsStateWithPortableColumns = applyInitialState(columnsStateWithPreProcessing, initialState);
  return hydrateColumnsWidth(columnsStateWithPortableColumns, (_apiRef$current$getRo = (_apiRef$current$getRo2 = (_apiRef$current = apiRef.current).getRootDimensions) == null || (_apiRef$current$getRo2 = _apiRef$current$getRo2.call(_apiRef$current)) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0);
};
const mergeColumnsState = columnsState => state => _extends$c({}, state, {
  columns: columnsState
});
function getFirstNonSpannedColumnToRender({
  firstColumnToRender,
  apiRef,
  firstRowToRender,
  lastRowToRender,
  visibleRows
}) {
  let firstNonSpannedColumnToRender = firstColumnToRender;
  for (let i = firstRowToRender; i < lastRowToRender; i += 1) {
    const row = visibleRows[i];
    if (row) {
      const rowId = visibleRows[i].id;
      const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
      if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) {
        firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
      }
    }
  }
  return firstNonSpannedColumnToRender;
}
function getFirstColumnIndexToRender({
  firstColumnIndex,
  minColumnIndex,
  columnBuffer,
  firstRowToRender,
  lastRowToRender,
  apiRef,
  visibleRows
}) {
  const initialFirstColumnToRender = Math.max(firstColumnIndex - columnBuffer, minColumnIndex);
  const firstColumnToRender = getFirstNonSpannedColumnToRender({
    firstColumnToRender: initialFirstColumnToRender,
    apiRef,
    firstRowToRender,
    lastRowToRender,
    visibleRows
  });
  return firstColumnToRender;
}
function getTotalHeaderHeight(apiRef, headerHeight) {
  const densityFactor = gridDensityFactorSelector(apiRef);
  const maxDepth = gridColumnGroupsHeaderMaxDepthSelector(apiRef);
  return Math.floor(headerHeight * densityFactor) * ((maxDepth != null ? maxDepth : 0) + 1);
}

const defaultColumnTypes = getGridDefaultColumnTypes();
const columnsStateInitializer = (state, props, apiRef) => {
  var _props$initialState, _ref, _props$columnVisibili, _props$initialState2;
  const columnsState = createColumnsState({
    apiRef,
    columnTypes: defaultColumnTypes,
    columnsToUpsert: props.columns,
    initialState: (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.columns,
    columnVisibilityModel: (_ref = (_props$columnVisibili = props.columnVisibilityModel) != null ? _props$columnVisibili : (_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.columns) == null ? void 0 : _props$initialState2.columnVisibilityModel) != null ? _ref : {},
    keepOnlyColumnsToUpsert: true
  });
  return _extends$c({}, state, {
    columns: columnsState
  });
};

/**
 * @requires useGridParamsApi (method)
 * @requires useGridDimensions (method, event) - can be after
 * TODO: Impossible priority - useGridParamsApi also needs to be after useGridColumns
 */
function useGridColumns(apiRef, props) {
  var _props$initialState4, _props$slotProps2;
  const logger = useGridLogger(apiRef, 'useGridColumns');
  const columnTypes = defaultColumnTypes;
  const previousColumnsProp = React$1.useRef(props.columns);
  const previousColumnTypesProp = React$1.useRef(columnTypes);
  apiRef.current.registerControlState({
    stateId: 'visibleColumns',
    propModel: props.columnVisibilityModel,
    propOnChange: props.onColumnVisibilityModelChange,
    stateSelector: gridColumnVisibilityModelSelector,
    changeEvent: 'columnVisibilityModelChange'
  });
  const setGridColumnsState = React$1.useCallback(columnsState => {
    logger.debug('Updating columns state.');
    apiRef.current.setState(mergeColumnsState(columnsState));
    apiRef.current.forceUpdate();
    apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
  }, [logger, apiRef]);

  /**
   * API METHODS
   */
  const getColumn = React$1.useCallback(field => gridColumnLookupSelector(apiRef)[field], [apiRef]);
  const getAllColumns = React$1.useCallback(() => gridColumnDefinitionsSelector(apiRef), [apiRef]);
  const getVisibleColumns = React$1.useCallback(() => gridVisibleColumnDefinitionsSelector(apiRef), [apiRef]);
  const getColumnIndex = React$1.useCallback((field, useVisibleColumns = true) => {
    const columns = useVisibleColumns ? gridVisibleColumnDefinitionsSelector(apiRef) : gridColumnDefinitionsSelector(apiRef);
    return columns.findIndex(col => col.field === field);
  }, [apiRef]);
  const getColumnPosition = React$1.useCallback(field => {
    const index = getColumnIndex(field);
    return gridColumnPositionsSelector(apiRef)[index];
  }, [apiRef, getColumnIndex]);
  const setColumnVisibilityModel = React$1.useCallback(model => {
    const currentModel = gridColumnVisibilityModelSelector(apiRef);
    if (currentModel !== model) {
      apiRef.current.setState(state => _extends$c({}, state, {
        columns: createColumnsState({
          apiRef,
          columnTypes,
          columnsToUpsert: [],
          initialState: undefined,
          columnVisibilityModel: model,
          keepOnlyColumnsToUpsert: false
        })
      }));
      apiRef.current.forceUpdate();
    }
  }, [apiRef, columnTypes]);
  const updateColumns = React$1.useCallback(columns => {
    const columnsState = createColumnsState({
      apiRef,
      columnTypes,
      columnsToUpsert: columns,
      initialState: undefined,
      keepOnlyColumnsToUpsert: false
    });
    setGridColumnsState(columnsState);
  }, [apiRef, setGridColumnsState, columnTypes]);
  const setColumnVisibility = React$1.useCallback((field, isVisible) => {
    var _columnVisibilityMode;
    const columnVisibilityModel = gridColumnVisibilityModelSelector(apiRef);
    const isCurrentlyVisible = (_columnVisibilityMode = columnVisibilityModel[field]) != null ? _columnVisibilityMode : true;
    if (isVisible !== isCurrentlyVisible) {
      const newModel = _extends$c({}, columnVisibilityModel, {
        [field]: isVisible
      });
      apiRef.current.setColumnVisibilityModel(newModel);
    }
  }, [apiRef]);
  const getColumnIndexRelativeToVisibleColumns = React$1.useCallback(field => {
    const allColumns = gridColumnFieldsSelector(apiRef);
    return allColumns.findIndex(col => col === field);
  }, [apiRef]);
  const setColumnIndex = React$1.useCallback((field, targetIndexPosition) => {
    const allColumns = gridColumnFieldsSelector(apiRef);
    const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
    if (oldIndexPosition === targetIndexPosition) {
      return;
    }
    logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
    const updatedColumns = [...allColumns];
    const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
    updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
    setGridColumnsState(_extends$c({}, gridColumnsStateSelector(apiRef.current.state), {
      orderedFields: updatedColumns
    }));
    const params = {
      column: apiRef.current.getColumn(field),
      targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
      oldIndex: oldIndexPosition
    };
    apiRef.current.publishEvent('columnIndexChange', params);
  }, [apiRef, logger, setGridColumnsState, getColumnIndexRelativeToVisibleColumns]);
  const setColumnWidth = React$1.useCallback((field, width) => {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    logger.debug(`Updating column ${field} width to ${width}`);
    const columnsState = gridColumnsStateSelector(apiRef.current.state);
    const column = columnsState.lookup[field];
    const newColumn = _extends$c({}, column, {
      width,
      hasBeenResized: true
    });
    setGridColumnsState(hydrateColumnsWidth(_extends$c({}, columnsState, {
      lookup: _extends$c({}, columnsState.lookup, {
        [field]: newColumn
      })
    }), (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0));
    apiRef.current.publishEvent('columnWidthChange', {
      element: apiRef.current.getColumnHeaderElement(field),
      colDef: newColumn,
      width
    });
  }, [apiRef, logger, setGridColumnsState]);
  const columnApi = {
    getColumn,
    getAllColumns,
    getColumnIndex,
    getColumnPosition,
    getVisibleColumns,
    getColumnIndexRelativeToVisibleColumns,
    updateColumns,
    setColumnVisibilityModel,
    setColumnVisibility,
    setColumnWidth
  };
  const columnReorderApi = {
    setColumnIndex
  };
  useGridApiMethod(apiRef, columnApi, 'public');
  useGridApiMethod(apiRef, columnReorderApi, props.signature === GridSignature.DataGrid ? 'private' : 'public');

  /**
   * PRE-PROCESSING
   */
  const stateExportPreProcessing = React$1.useCallback((prevState, context) => {
    var _props$initialState$c, _props$initialState3;
    const columnsStateToExport = {};
    const columnVisibilityModelToExport = gridColumnVisibilityModelSelector(apiRef);
    const shouldExportColumnVisibilityModel =
    // Always export if the `exportOnlyDirtyModels` property is not activated
    !context.exportOnlyDirtyModels ||
    // Always export if the model is controlled
    props.columnVisibilityModel != null ||
    // Always export if the model has been initialized
    // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
    Object.keys((_props$initialState$c = (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.columns) == null ? void 0 : _props$initialState3.columnVisibilityModel) != null ? _props$initialState$c : {}).length > 0 ||
    // Always export if the model is not empty
    Object.keys(columnVisibilityModelToExport).length > 0;
    if (shouldExportColumnVisibilityModel) {
      columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
    }
    columnsStateToExport.orderedFields = gridColumnFieldsSelector(apiRef);
    const columns = gridColumnDefinitionsSelector(apiRef);
    const dimensions = {};
    columns.forEach(colDef => {
      if (colDef.hasBeenResized) {
        const colDefDimensions = {};
        COLUMNS_DIMENSION_PROPERTIES.forEach(propertyName => {
          let propertyValue = colDef[propertyName];
          if (propertyValue === Infinity) {
            propertyValue = -1;
          }
          colDefDimensions[propertyName] = propertyValue;
        });
        dimensions[colDef.field] = colDefDimensions;
      }
    });
    if (Object.keys(dimensions).length > 0) {
      columnsStateToExport.dimensions = dimensions;
    }
    return _extends$c({}, prevState, {
      columns: columnsStateToExport
    });
  }, [apiRef, props.columnVisibilityModel, (_props$initialState4 = props.initialState) == null ? void 0 : _props$initialState4.columns]);
  const stateRestorePreProcessing = React$1.useCallback((params, context) => {
    var _context$stateToResto;
    const columnVisibilityModelToImport = (_context$stateToResto = context.stateToRestore.columns) == null ? void 0 : _context$stateToResto.columnVisibilityModel;
    const initialState = context.stateToRestore.columns;
    if (columnVisibilityModelToImport == null && initialState == null) {
      return params;
    }
    const columnsState = createColumnsState({
      apiRef,
      columnTypes,
      columnsToUpsert: [],
      initialState,
      columnVisibilityModel: columnVisibilityModelToImport,
      keepOnlyColumnsToUpsert: false
    });
    apiRef.current.setState(mergeColumnsState(columnsState));
    if (initialState != null) {
      apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }
    return params;
  }, [apiRef, columnTypes]);
  const preferencePanelPreProcessing = React$1.useCallback((initialValue, value) => {
    if (value === GridPreferencePanelsValue.columns) {
      var _props$slotProps;
      const ColumnsPanel = props.slots.columnsPanel;
      return /*#__PURE__*/jsx(ColumnsPanel, _extends$c({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.columnsPanel));
    }
    return initialValue;
  }, [props.slots.columnsPanel, (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.columnsPanel]);
  const addColumnMenuItems = React$1.useCallback(columnMenuItems => {
    if (props.disableColumnSelector) {
      return columnMenuItems;
    }
    return [...columnMenuItems, 'columnMenuColumnsItem'];
  }, [props.disableColumnSelector]);
  useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItems);
  useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'preferencePanel', preferencePanelPreProcessing);

  /**
   * EVENTS
   */
  const prevInnerWidth = React$1.useRef(null);
  const handleGridSizeChange = viewportInnerSize => {
    if (prevInnerWidth.current !== viewportInnerSize.width) {
      prevInnerWidth.current = viewportInnerSize.width;
      setGridColumnsState(hydrateColumnsWidth(gridColumnsStateSelector(apiRef.current.state), viewportInnerSize.width));
    }
  };
  useGridApiEventHandler(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);

  /**
   * APPLIERS
   */
  const hydrateColumns = React$1.useCallback(() => {
    logger.info(`Columns pipe processing have changed, regenerating the columns`);
    const columnsState = createColumnsState({
      apiRef,
      columnTypes,
      columnsToUpsert: [],
      initialState: undefined,
      keepOnlyColumnsToUpsert: false
    });
    setGridColumnsState(columnsState);
  }, [apiRef, logger, setGridColumnsState, columnTypes]);
  useGridRegisterPipeApplier(apiRef, 'hydrateColumns', hydrateColumns);

  /**
   * EFFECTS
   */
  // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
  // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    logger.info(`GridColumns have changed, new length ${props.columns.length}`);
    if (previousColumnsProp.current === props.columns && previousColumnTypesProp.current === columnTypes) {
      return;
    }
    const columnsState = createColumnsState({
      apiRef,
      columnTypes,
      initialState: undefined,
      // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
      columnsToUpsert: props.columns,
      keepOnlyColumnsToUpsert: true
    });
    previousColumnsProp.current = props.columns;
    previousColumnTypesProp.current = columnTypes;
    setGridColumnsState(columnsState);
  }, [logger, apiRef, setGridColumnsState, props.columns, columnTypes]);
  React$1.useEffect(() => {
    if (props.columnVisibilityModel !== undefined) {
      apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }
  }, [apiRef, logger, props.columnVisibilityModel]);
}

const COMPACT_DENSITY_FACTOR = 0.7;
const COMFORTABLE_DENSITY_FACTOR = 1.3;
const DENSITY_FACTORS = {
  compact: COMPACT_DENSITY_FACTOR,
  comfortable: COMFORTABLE_DENSITY_FACTOR,
  standard: 1
};
const densityStateInitializer = (state, props) => _extends$c({}, state, {
  density: {
    value: props.density,
    factor: DENSITY_FACTORS[props.density]
  }
});
const useGridDensity = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useDensity');
  const setDensity = React$1.useCallback(newDensity => {
    logger.debug(`Set grid density to ${newDensity}`);
    apiRef.current.setState(state => {
      const currentDensityState = gridDensitySelector(state);
      const newDensityState = {
        value: newDensity,
        factor: DENSITY_FACTORS[newDensity]
      };
      if (isDeepEqual(currentDensityState, newDensityState)) {
        return state;
      }
      return _extends$c({}, state, {
        density: newDensityState
      });
    });
    apiRef.current.forceUpdate();
  }, [logger, apiRef]);
  React$1.useEffect(() => {
    apiRef.current.setDensity(props.density);
  }, [apiRef, props.density]);
  const densityApi = {
    setDensity
  };
  useGridApiMethod(apiRef, densityApi, 'public');
};

/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */

function exportAs(blob, extension = 'csv', filename = document.title || 'untitled') {
  const fullName = `${filename}.${extension}`;

  // Test download attribute first
  // https://github.com/eligrey/FileSaver.js/issues/193
  if ('download' in HTMLAnchorElement.prototype) {
    // Create an object URL for the blob object
    const url = URL.createObjectURL(blob);

    // Create a new anchor element
    const a = document.createElement('a');
    a.href = url;
    a.download = fullName;

    // Programmatically trigger a click on the anchor element
    // Useful if you want the download to happen automatically
    // Without attaching the anchor element to the DOM
    a.click();

    // https://github.com/eligrey/FileSaver.js/issues/205
    setTimeout(() => {
      URL.revokeObjectURL(url);
    });
    return;
  }
  throw new Error('MUI: exportAs not supported');
}

const getColumnsToExport = ({
  apiRef,
  options
}) => {
  const columns = gridColumnDefinitionsSelector(apiRef);
  if (options.fields) {
    return options.fields.reduce((currentColumns, field) => {
      const column = columns.find(col => col.field === field);
      if (column) {
        currentColumns.push(column);
      }
      return currentColumns;
    }, []);
  }
  const validColumns = options.allColumns ? columns : gridVisibleColumnDefinitionsSelector(apiRef);
  return validColumns.filter(column => !column.disableExport);
};
const defaultGetRowsToExport = ({
  apiRef
}) => {
  var _pinnedRows$top, _pinnedRows$bottom;
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const rowTree = gridRowTreeSelector(apiRef);
  const selectedRows = apiRef.current.getSelectedRows();
  const bodyRows = filteredSortedRowIds.filter(id => rowTree[id].type !== 'footer');
  const pinnedRows = gridPinnedRowsSelector(apiRef);
  const topPinnedRowsIds = (pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.map(row => row.id)) || [];
  const bottomPinnedRowsIds = (pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.map(row => row.id)) || [];
  bodyRows.unshift(...topPinnedRowsIds);
  bodyRows.push(...bottomPinnedRowsIds);
  if (selectedRows.size > 0) {
    return bodyRows.filter(id => selectedRows.has(id));
  }
  return bodyRows;
};

/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridSelection (state)
 * @requires useGridParamsApi (method)
 */
const useGridCsvExport = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useGridCsvExport');
  const ignoreValueFormatterProp = props.unstable_ignoreValueFormatterDuringExport;
  const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp == null ? void 0 : ignoreValueFormatterProp.csvExport : ignoreValueFormatterProp) || false;
  const getDataAsCsv = React$1.useCallback((options = {}) => {
    var _options$getRowsToExp, _options$includeHeade, _options$includeColum;
    logger.debug(`Get data as CSV`);
    const exportedColumns = getColumnsToExport({
      apiRef,
      options
    });
    const getRowsToExport = (_options$getRowsToExp = options.getRowsToExport) != null ? _options$getRowsToExp : defaultGetRowsToExport;
    const exportedRowIds = getRowsToExport({
      apiRef
    });
    return buildCSV({
      columns: exportedColumns,
      rowIds: exportedRowIds,
      delimiterCharacter: options.delimiter || ',',
      includeHeaders: (_options$includeHeade = options.includeHeaders) != null ? _options$includeHeade : true,
      includeColumnGroupsHeaders: (_options$includeColum = options.includeColumnGroupsHeaders) != null ? _options$includeColum : true,
      ignoreValueFormatter,
      apiRef
    });
  }, [logger, apiRef, ignoreValueFormatter]);
  const exportDataAsCsv = React$1.useCallback(options => {
    logger.debug(`Export data as CSV`);
    const csv = getDataAsCsv(options);
    const blob = new Blob([options != null && options.utf8WithBom ? new Uint8Array([0xef, 0xbb, 0xbf]) : '', csv], {
      type: 'text/csv'
    });
    exportAs(blob, 'csv', options == null ? void 0 : options.fileName);
  }, [logger, getDataAsCsv]);
  const csvExportApi = {
    getDataAsCsv,
    exportDataAsCsv
  };
  useGridApiMethod(apiRef, csvExportApi, 'public');

  /**
   * PRE-PROCESSING
   */
  const addExportMenuButtons = React$1.useCallback((initialValue, options) => {
    var _options$csvOptions;
    if ((_options$csvOptions = options.csvOptions) != null && _options$csvOptions.disableToolbarButton) {
      return initialValue;
    }
    return [...initialValue, {
      component: /*#__PURE__*/jsx(GridCsvExportMenuItem, {
        options: options.csvOptions
      }),
      componentName: 'csvExport'
    }];
  }, []);
  useGridRegisterPipeProcessor(apiRef, 'exportMenu', addExportMenuButtons);
};

const paginationStateInitializer = (state, props) => {
  var _props$paginationMode, _props$initialState;
  const paginationModel = _extends$c({}, getDefaultGridPaginationModel(props.autoPageSize), (_props$paginationMode = props.paginationModel) != null ? _props$paginationMode : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.pagination) == null ? void 0 : _props$initialState.paginationModel);
  throwIfPageSizeExceedsTheLimit(paginationModel.pageSize, props.signature);
  return _extends$c({}, state, {
    pagination: {
      paginationModel
    }
  });
};
const mergeStateWithPaginationModel = (rowCount, signature, paginationModelProp) => paginationState => {
  var _paginationModelProp$;
  let paginationModel = paginationState.paginationModel;
  const pageSize = (_paginationModelProp$ = paginationModelProp == null ? void 0 : paginationModelProp.pageSize) != null ? _paginationModelProp$ : paginationModel.pageSize;
  const pageCount = getPageCount(rowCount, pageSize);
  if (paginationModelProp && ((paginationModelProp == null ? void 0 : paginationModelProp.page) !== paginationModel.page || (paginationModelProp == null ? void 0 : paginationModelProp.pageSize) !== paginationModel.pageSize)) {
    paginationModel = paginationModelProp;
  }
  const validPage = getValidPage(paginationModel.page, pageCount);
  if (validPage !== paginationModel.page) {
    paginationModel = _extends$c({}, paginationModel, {
      page: validPage
    });
  }
  throwIfPageSizeExceedsTheLimit(paginationModel.pageSize, signature);
  return {
    paginationModel
  };
};

/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */
const useGridPagination = (apiRef, props) => {
  var _props$initialState3;
  const logger = useGridLogger(apiRef, 'useGridPagination');
  const visibleTopLevelRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
  const rowHeight = Math.floor(props.rowHeight * densityFactor);
  apiRef.current.registerControlState({
    stateId: 'pagination',
    propModel: props.paginationModel,
    propOnChange: props.onPaginationModelChange,
    stateSelector: gridPaginationModelSelector,
    changeEvent: 'paginationModelChange'
  });

  /**
   * API METHODS
   */
  const setPage = React$1.useCallback(page => {
    const currentModel = gridPaginationModelSelector(apiRef);
    if (page === currentModel.page) {
      return;
    }
    logger.debug(`Setting page to ${page}`);
    apiRef.current.setPaginationModel({
      page,
      pageSize: currentModel.pageSize
    });
  }, [apiRef, logger]);
  const setPageSize = React$1.useCallback(pageSize => {
    const currentModel = gridPaginationModelSelector(apiRef);
    if (pageSize === currentModel.pageSize) {
      return;
    }
    logger.debug(`Setting page size to ${pageSize}`);
    apiRef.current.setPaginationModel({
      pageSize,
      page: currentModel.page
    });
  }, [apiRef, logger]);
  const setPaginationModel = React$1.useCallback(paginationModel => {
    var _props$rowCount;
    const currentModel = gridPaginationModelSelector(apiRef);
    if (paginationModel === currentModel) {
      return;
    }
    logger.debug("Setting 'paginationModel' to", paginationModel);
    apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel((_props$rowCount = props.rowCount) != null ? _props$rowCount : visibleTopLevelRowCount, props.signature, paginationModel), 'setPaginationModel');
    apiRef.current.forceUpdate();
  }, [apiRef, logger, props.rowCount, props.signature, visibleTopLevelRowCount]);
  const pageApi = {
    setPage,
    setPageSize,
    setPaginationModel
  };
  useGridApiMethod(apiRef, pageApi, 'public');

  /**
   * PRE-PROCESSING
   */
  const stateExportPreProcessing = React$1.useCallback((prevState, context) => {
    var _props$initialState2;
    const paginationModel = gridPaginationModelSelector(apiRef);
    const shouldExportPaginationModel =
    // Always export if the `exportOnlyDirtyModels` property is not activated
    !context.exportOnlyDirtyModels ||
    // Always export if the `paginationModel` is controlled
    props.paginationModel != null ||
    // Always export if the `paginationModel` has been initialized
    ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.pagination) == null ? void 0 : _props$initialState2.paginationModel) != null ||
    // Export if `page` or `pageSize` is not equal to the default value
    paginationModel.page !== 0 && paginationModel.pageSize !== defaultPageSize(props.autoPageSize);
    if (!shouldExportPaginationModel) {
      return prevState;
    }
    return _extends$c({}, prevState, {
      pagination: _extends$c({}, prevState.pagination, {
        paginationModel
      })
    });
  }, [apiRef, props.paginationModel, (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.pagination) == null ? void 0 : _props$initialState3.paginationModel, props.autoPageSize]);
  const stateRestorePreProcessing = React$1.useCallback((params, context) => {
    var _context$stateToResto, _context$stateToResto2, _props$rowCount2;
    const paginationModel = (_context$stateToResto = context.stateToRestore.pagination) != null && _context$stateToResto.paginationModel ? _extends$c({}, getDefaultGridPaginationModel(props.autoPageSize), (_context$stateToResto2 = context.stateToRestore.pagination) == null ? void 0 : _context$stateToResto2.paginationModel) : gridPaginationModelSelector(apiRef);
    apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel((_props$rowCount2 = props.rowCount) != null ? _props$rowCount2 : visibleTopLevelRowCount, props.signature, paginationModel), 'stateRestorePreProcessing');
    return params;
  }, [apiRef, props.autoPageSize, props.rowCount, props.signature, visibleTopLevelRowCount]);
  useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);

  /**
   * EVENTS
   */
  const handlePaginationModelChange = () => {
    var _apiRef$current$virtu;
    const paginationModel = gridPaginationModelSelector(apiRef);
    if ((_apiRef$current$virtu = apiRef.current.virtualScrollerRef) != null && _apiRef$current$virtu.current) {
      apiRef.current.scrollToIndexes({
        rowIndex: paginationModel.page * paginationModel.pageSize
      });
    }
    apiRef.current.forceUpdate();
  };
  const handleUpdateAutoPageSize = React$1.useCallback(() => {
    const dimensions = apiRef.current.getRootDimensions();
    if (!props.autoPageSize || !dimensions) {
      return;
    }
    const pinnedRowsHeight = calculatePinnedRowsHeight(apiRef);
    const maximumPageSizeWithoutScrollBar = Math.floor((dimensions.viewportInnerSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom) / rowHeight);
    apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
  }, [apiRef, props.autoPageSize, rowHeight]);
  useGridApiEventHandler(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
  useGridApiEventHandler(apiRef, 'paginationModelChange', handlePaginationModelChange);

  /**
   * EFFECTS
   */
  React$1.useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (props.paginationMode === 'server' && props.rowCount == null) {
        noRowCountInServerMode();
      }
    }
  }, [props.rowCount, props.paginationMode]);
  React$1.useEffect(() => {
    var _props$rowCount3;
    apiRef.current.updateControlState('pagination', mergeStateWithPaginationModel((_props$rowCount3 = props.rowCount) != null ? _props$rowCount3 : visibleTopLevelRowCount, props.signature, props.paginationModel));
  }, [apiRef, props.paginationModel, props.rowCount, props.paginationMode, visibleTopLevelRowCount, props.signature]);
  React$1.useEffect(() => {
    handleUpdateAutoPageSize();
  }, [handleUpdateAutoPageSize]);
};

function raf() {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      resolve();
    });
  });
}
function buildPrintWindow(title) {
  const iframeEl = document.createElement('iframe');
  iframeEl.style.position = 'absolute';
  iframeEl.style.width = '0px';
  iframeEl.style.height = '0px';
  iframeEl.title = title || document.title;
  return iframeEl;
}

/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridParamsApi (method)
 */
const useGridPrintExport = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useGridPrintExport');
  const doc = React$1.useRef(null);
  const previousGridState = React$1.useRef(null);
  const previousColumnVisibility = React$1.useRef({});
  const previousRows = React$1.useRef([]);
  React$1.useEffect(() => {
    doc.current = ownerDocument(apiRef.current.rootElementRef.current);
  }, [apiRef]);

  // Returns a promise because updateColumns triggers state update and
  // the new state needs to be in place before the grid can be sized correctly
  const updateGridColumnsForPrint = React$1.useCallback((fields, allColumns, includeCheckboxes) => new Promise(resolve => {
    const exportedColumnFields = getColumnsToExport({
      apiRef,
      options: {
        fields,
        allColumns
      }
    }).map(column => column.field);
    const columns = gridColumnDefinitionsSelector(apiRef);
    const newColumnVisibilityModel = {};
    columns.forEach(column => {
      newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
    });
    if (includeCheckboxes) {
      newColumnVisibilityModel[GRID_CHECKBOX_SELECTION_COL_DEF.field] = true;
    }
    apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
    resolve();
  }), [apiRef]);
  const updateGridRowsForPrint = React$1.useCallback(getRowsToExport => {
    const rowsToExportIds = getRowsToExport({
      apiRef
    });
    const newRows = rowsToExportIds.map(id => apiRef.current.getRow(id));
    apiRef.current.setRows(newRows);
  }, [apiRef]);
  const handlePrintWindowLoad = React$1.useCallback((printWindow, options) => {
    var _querySelector, _querySelector2;
    const normalizeOptions = _extends$c({
      copyStyles: true,
      hideToolbar: false,
      hideFooter: false,
      includeCheckboxes: false
    }, options);
    const printDoc = printWindow.contentDocument;
    if (!printDoc) {
      return;
    }
    const rowsMeta = gridRowsMetaSelector(apiRef.current.state);
    const gridRootElement = apiRef.current.rootElementRef.current;
    const gridClone = gridRootElement.cloneNode(true);

    // Allow to overflow to not hide the border of the last row
    const gridMain = gridClone.querySelector(`.${gridClasses.main}`);
    gridMain.style.overflow = 'visible';

    // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
    gridClone.style.contain = 'size';
    const columnHeaders = gridClone.querySelector(`.${gridClasses.columnHeaders}`);
    const columnHeadersInner = columnHeaders.querySelector(`.${gridClasses.columnHeadersInner}`);
    columnHeadersInner.style.width = '100%';
    let gridToolbarElementHeight = ((_querySelector = gridRootElement.querySelector(`.${gridClasses.toolbarContainer}`)) == null ? void 0 : _querySelector.offsetHeight) || 0;
    let gridFooterElementHeight = ((_querySelector2 = gridRootElement.querySelector(`.${gridClasses.footerContainer}`)) == null ? void 0 : _querySelector2.offsetHeight) || 0;
    if (normalizeOptions.hideToolbar) {
      var _gridClone$querySelec;
      (_gridClone$querySelec = gridClone.querySelector(`.${gridClasses.toolbarContainer}`)) == null || _gridClone$querySelec.remove();
      gridToolbarElementHeight = 0;
    }
    if (normalizeOptions.hideFooter) {
      var _gridClone$querySelec2;
      (_gridClone$querySelec2 = gridClone.querySelector(`.${gridClasses.footerContainer}`)) == null || _gridClone$querySelec2.remove();
      gridFooterElementHeight = 0;
    }

    // Expand container height to accommodate all rows
    const computedTotalHeight = rowsMeta.currentPageTotalHeight + getTotalHeaderHeight(apiRef, props.columnHeaderHeight) + gridToolbarElementHeight + gridFooterElementHeight;
    gridClone.style.height = `${computedTotalHeight}px`;
    // The height above does not include grid border width, so we need to exclude it
    gridClone.style.boxSizing = 'content-box';

    // the footer is always being placed at the bottom of the page as if all rows are exported
    // so if getRowsToExport is being used to only export a subset of rows then we need to
    // adjust the footer position to be correctly placed at the bottom of the grid
    if (options != null && options.getRowsToExport) {
      const gridFooterElement = gridClone.querySelector(`.${gridClasses.footerContainer}`);
      gridFooterElement.style.position = 'absolute';
      gridFooterElement.style.width = '100%';
      gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
    }

    // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
    // prevents us to do it
    const container = document.createElement('div');
    container.appendChild(gridClone);
    printDoc.body.innerHTML = container.innerHTML;
    const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
    if (typeof defaultPageStyle === 'string') {
      // TODO custom styles should always win
      const styleElement = printDoc.createElement('style');
      styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
      printDoc.head.appendChild(styleElement);
    }
    if (normalizeOptions.bodyClassName) {
      printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
    }
    const stylesheetLoadPromises = [];
    if (normalizeOptions.copyStyles) {
      const rootCandidate = gridRootElement.getRootNode();
      const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
      const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
      for (let i = 0; i < headStyleElements.length; i += 1) {
        const node = headStyleElements[i];
        if (node.tagName === 'STYLE') {
          const newHeadStyleElements = printDoc.createElement(node.tagName);
          const sheet = node.sheet;
          if (sheet) {
            let styleCSS = '';
            // NOTE: for-of is not supported by IE
            for (let j = 0; j < sheet.cssRules.length; j += 1) {
              if (typeof sheet.cssRules[j].cssText === 'string') {
                styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
              }
            }
            newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
            printDoc.head.appendChild(newHeadStyleElements);
          }
        } else if (node.getAttribute('href')) {
          // If `href` tag is empty, avoid loading these links

          const newHeadStyleElements = printDoc.createElement(node.tagName);
          for (let j = 0; j < node.attributes.length; j += 1) {
            const attr = node.attributes[j];
            if (attr) {
              newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
            }
          }
          stylesheetLoadPromises.push(new Promise(resolve => {
            newHeadStyleElements.addEventListener('load', () => resolve());
          }));
          printDoc.head.appendChild(newHeadStyleElements);
        }
      }
    }

    // Trigger print
    if (process.env.NODE_ENV !== 'test') {
      // wait for remote stylesheets to load
      Promise.all(stylesheetLoadPromises).then(() => {
        printWindow.contentWindow.print();
      });
    }
  }, [apiRef, doc, props.columnHeaderHeight]);
  const handlePrintWindowAfterPrint = React$1.useCallback(printWindow => {
    var _previousGridState$cu;
    // Remove the print iframe
    doc.current.body.removeChild(printWindow);

    // Revert grid to previous state
    apiRef.current.restoreState(previousGridState.current || {});
    if (!((_previousGridState$cu = previousGridState.current) != null && (_previousGridState$cu = _previousGridState$cu.columns) != null && _previousGridState$cu.columnVisibilityModel)) {
      // if the apiRef.current.exportState(); did not exported the column visibility, we update it
      apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
    }
    apiRef.current.unstable_setVirtualization(true);
    apiRef.current.setRows(previousRows.current);

    // Clear local state
    previousGridState.current = null;
    previousColumnVisibility.current = {};
    previousRows.current = [];
  }, [apiRef]);
  const exportDataAsPrint = React$1.useCallback(async options => {
    logger.debug(`Export data as Print`);
    if (!apiRef.current.rootElementRef.current) {
      throw new Error('MUI: No grid root element available.');
    }
    previousGridState.current = apiRef.current.exportState();
    // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
    previousColumnVisibility.current = gridColumnVisibilityModelSelector(apiRef);
    previousRows.current = apiRef.current.getSortedRows();
    if (props.pagination) {
      const visibleRowCount = gridExpandedRowCountSelector(apiRef);
      const paginationModel = {
        page: 0,
        pageSize: visibleRowCount
      };
      apiRef.current.updateControlState('pagination',
      // Using signature `DataGridPro` to allow more than 100 rows in the print export
      mergeStateWithPaginationModel(visibleRowCount, 'DataGridPro', paginationModel));
      apiRef.current.forceUpdate();
    }
    await updateGridColumnsForPrint(options == null ? void 0 : options.fields, options == null ? void 0 : options.allColumns, options == null ? void 0 : options.includeCheckboxes);
    if (options != null && options.getRowsToExport) {
      updateGridRowsForPrint(options.getRowsToExport);
    }
    apiRef.current.unstable_setVirtualization(false);
    await raf(); // wait for the state changes to take action
    const printWindow = buildPrintWindow(options == null ? void 0 : options.fileName);
    if (process.env.NODE_ENV === 'test') {
      doc.current.body.appendChild(printWindow);
      // In test env, run the all pipeline without waiting for loading
      handlePrintWindowLoad(printWindow, options);
      handlePrintWindowAfterPrint(printWindow);
    } else {
      printWindow.onload = () => {
        handlePrintWindowLoad(printWindow, options);
        const mediaQueryList = printWindow.contentWindow.matchMedia('print');
        mediaQueryList.addEventListener('change', mql => {
          const isAfterPrint = mql.matches === false;
          if (isAfterPrint) {
            handlePrintWindowAfterPrint(printWindow);
          }
        });
      };
      doc.current.body.appendChild(printWindow);
    }
  }, [props, logger, apiRef, handlePrintWindowLoad, handlePrintWindowAfterPrint, updateGridColumnsForPrint, updateGridRowsForPrint]);
  const printExportApi = {
    exportDataAsPrint
  };
  useGridApiMethod(apiRef, printExportApi, 'public');

  /**
   * PRE-PROCESSING
   */
  const addExportMenuButtons = React$1.useCallback((initialValue, options) => {
    var _options$printOptions;
    if ((_options$printOptions = options.printOptions) != null && _options$printOptions.disableToolbarButton) {
      return initialValue;
    }
    return [...initialValue, {
      component: /*#__PURE__*/jsx(GridPrintExportMenuItem, {
        options: options.printOptions
      }),
      componentName: 'printExport'
    }];
  }, []);
  useGridRegisterPipeProcessor(apiRef, 'exportMenu', addExportMenuButtons);
};

// Fixes https://github.com/mui/mui-x/issues/10056
const globalScope = typeof window === 'undefined' ? globalThis : window;
const evalCode = globalScope[atob('ZXZhbA==')];
let hasEval;
try {
  hasEval = evalCode('true');
} catch (_) {
  hasEval = false;
}
/**
 * Adds default values to the optional fields of a filter items.
 * @param {GridFilterItem} item The raw filter item.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @return {GridFilterItem} The clean filter item with an uniq ID and an always-defined operator.
 * TODO: Make the typing reflect the different between GridFilterInputItem and GridFilterItem.
 */
const cleanFilterItem = (item, apiRef) => {
  const cleanItem = _extends$c({}, item);
  if (cleanItem.id == null) {
    cleanItem.id = Math.round(Math.random() * 1e5);
  }
  if (cleanItem.operator == null) {
    // Selects a default operator
    // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
    const column = gridColumnLookupSelector(apiRef)[cleanItem.field];
    cleanItem.operator = column && column.filterOperators[0].value;
  }
  return cleanItem;
};
const filterModelDisableMultiColumnsFilteringWarning = buildWarning(['MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.', 'If you are using the community version of the `DataGrid`, this prop is always `true`.'], 'error');
const filterModelMissingItemIdWarning = buildWarning('MUI: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
const filterModelMissingItemOperatorWarning = buildWarning('MUI: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
const sanitizeFilterModel = (model, disableMultipleColumnsFiltering, apiRef) => {
  const hasSeveralItems = model.items.length > 1;
  let items;
  if (hasSeveralItems && disableMultipleColumnsFiltering) {
    filterModelDisableMultiColumnsFilteringWarning();
    items = [model.items[0]];
  } else {
    items = model.items;
  }
  const hasItemsWithoutIds = hasSeveralItems && items.some(item => item.id == null);
  const hasItemWithoutOperator = items.some(item => item.operator == null);
  if (hasItemsWithoutIds) {
    filterModelMissingItemIdWarning();
  }
  if (hasItemWithoutOperator) {
    filterModelMissingItemOperatorWarning();
  }
  if (hasItemWithoutOperator || hasItemsWithoutIds) {
    return _extends$c({}, model, {
      items: items.map(item => cleanFilterItem(item, apiRef))
    });
  }
  if (model.items !== items) {
    return _extends$c({}, model, {
      items
    });
  }
  return model;
};
const mergeStateWithFilterModel = (filterModel, disableMultipleColumnsFiltering, apiRef) => filteringState => _extends$c({}, filteringState, {
  filterModel: sanitizeFilterModel(filterModel, disableMultipleColumnsFiltering, apiRef)
});
const getFilterCallbackFromItem = (filterItem, apiRef) => {
  if (!filterItem.field || !filterItem.operator) {
    return null;
  }
  const column = apiRef.current.getColumn(filterItem.field);
  if (!column) {
    return null;
  }
  let parsedValue;
  if (column.valueParser) {
    var _filterItem$value;
    const parser = column.valueParser;
    parsedValue = Array.isArray(filterItem.value) ? (_filterItem$value = filterItem.value) == null ? void 0 : _filterItem$value.map(x => parser(x)) : parser(filterItem.value);
  } else {
    parsedValue = filterItem.value;
  }
  const newFilterItem = _extends$c({}, filterItem, {
    value: parsedValue
  });
  const filterOperators = column.filterOperators;
  if (!(filterOperators != null && filterOperators.length)) {
    throw new Error(`MUI: No filter operators found for column '${column.field}'.`);
  }
  const filterOperator = filterOperators.find(operator => operator.value === newFilterItem.operator);
  if (!filterOperator) {
    throw new Error(`MUI: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
  }
  const hasUserFunctionLegacy = !isInternalFilter(filterOperator.getApplyFilterFn);
  const hasUserFunctionV7 = !isInternalFilter(filterOperator.getApplyFilterFnV7);
  if (filterOperator.getApplyFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) {
    const applyFilterOnRow = filterOperator.getApplyFilterFnV7(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') {
      return null;
    }
    return {
      v7: true,
      item: newFilterItem,
      fn: row => {
        const value = apiRef.current.getRowValue(row, column);
        return applyFilterOnRow(value, row, column, apiRef);
      }
    };
  }
  const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
  if (typeof applyFilterOnRow !== 'function') {
    return null;
  }
  return {
    v7: false,
    item: newFilterItem,
    fn: rowId => {
      const params = apiRef.current.getCellParams(rowId, newFilterItem.field);
      GLOBAL_API_REF.current = apiRef;
      const result = applyFilterOnRow(params);
      GLOBAL_API_REF.current = null;
      return result;
    }
  };
};
let filterItemsApplierId = 1;

/**
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridRowIdGetter | undefined} getRowId The getter for row's id.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */
const buildAggregatedFilterItemsApplier = (getRowId, filterModel, apiRef, disableEval) => {
  const {
    items
  } = filterModel;
  const appliers = items.map(item => getFilterCallbackFromItem(item, apiRef)).filter(callback => !!callback);
  if (appliers.length === 0) {
    return null;
  }
  if (!hasEval || disableEval) {
    // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter) => {
      const resultPerItemId = {};
      for (let i = 0; i < appliers.length; i += 1) {
        const applier = appliers[i];
        if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) {
          resultPerItemId[applier.item.id] = applier.v7 ? applier.fn(row) : applier.fn(getRowId ? getRowId(row) : row.id);
        }
      }
      return resultPerItemId;
    };
  }

  // We generate a new function with `eval()` to avoid expensive patterns for JS engines
  // such as a dynamic object assignment, e.g. `{ [dynamicKey]: value }`.
  const filterItemTemplate = `(function filterItem$$(getRowId, appliers, row, shouldApplyFilter) {
      ${appliers.map((applier, i) => `const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

      const result$$ = {
      ${appliers.map((applier, i) => `${JSON.stringify(String(applier.item.id))}:
          !shouldApply${i} ?
            false :
            ${applier.v7 ? `appliers[${i}].fn(row)` : `appliers[${i}].fn(${getRowId ? 'getRowId(row)' : 'row.id'})`},
      `).join('\n')}};

      return result$$;
    })`;
  const filterItemCore = evalCode(filterItemTemplate.replaceAll('$$', String(filterItemsApplierId)));
  const filterItem = (row, shouldApplyItem) => {
    return filterItemCore(getRowId, appliers, row, shouldApplyItem);
  };
  filterItemsApplierId += 1;
  return filterItem;
};

/**
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {GridRowIdGetter | undefined} getRowId The getter for row's id.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */
const buildAggregatedQuickFilterApplier = (getRowId, filterModel, apiRef) => {
  var _filterModel$quickFil, _filterModel$quickFil2, _filterModel$quickFil3;
  const quickFilterValues = (_filterModel$quickFil = (_filterModel$quickFil2 = filterModel.quickFilterValues) == null ? void 0 : _filterModel$quickFil2.filter(Boolean)) != null ? _filterModel$quickFil : [];
  if (quickFilterValues.length === 0) {
    return null;
  }
  const quickFilterExcludeHiddenColumns = (_filterModel$quickFil3 = filterModel.quickFilterExcludeHiddenColumns) != null ? _filterModel$quickFil3 : false;
  const columnFields = quickFilterExcludeHiddenColumns ? gridVisibleColumnFieldsSelector(apiRef) : gridColumnFieldsSelector(apiRef);
  const appliersPerField = [];
  columnFields.forEach(field => {
    const column = apiRef.current.getColumn(field);
    const getApplyQuickFilterFn = column == null ? void 0 : column.getApplyQuickFilterFn;
    const getApplyQuickFilterFnV7 = column == null ? void 0 : column.getApplyQuickFilterFnV7;
    const hasUserFunctionLegacy = !isInternalFilter(getApplyQuickFilterFn);
    const hasUserFunctionV7 = !isInternalFilter(getApplyQuickFilterFnV7);
    if (getApplyQuickFilterFnV7 && !(hasUserFunctionLegacy && !hasUserFunctionV7)) {
      appliersPerField.push({
        column,
        appliers: quickFilterValues.map(value => ({
          v7: true,
          fn: getApplyQuickFilterFnV7(value, column, apiRef)
        }))
      });
    } else if (getApplyQuickFilterFn) {
      appliersPerField.push({
        column,
        appliers: quickFilterValues.map(value => ({
          v7: false,
          fn: getApplyQuickFilterFn(value, column, apiRef)
        }))
      });
    }
  });
  return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
    const result = {};
    const usedCellParams = {};

    /* eslint-disable no-restricted-syntax, no-labels */
    outer: for (let v = 0; v < quickFilterValues.length; v += 1) {
      const filterValue = quickFilterValues[v];
      for (let i = 0; i < appliersPerField.length; i += 1) {
        const {
          column,
          appliers
        } = appliersPerField[i];
        const {
          field
        } = column;
        if (shouldApplyFilter && !shouldApplyFilter(field)) {
          continue;
        }
        const applier = appliers[v];
        const value = apiRef.current.getRowValue(row, column);
        if (applier.fn === null) {
          continue;
        }
        if (applier.v7) {
          const isMatching = applier.fn(value, row, column, apiRef);
          if (isMatching) {
            result[filterValue] = true;
            continue outer;
          }
        } else {
          var _usedCellParams$field;
          const cellParams = (_usedCellParams$field = usedCellParams[field]) != null ? _usedCellParams$field : apiRef.current.getCellParams(getRowId ? getRowId(row) : row.id, field);
          usedCellParams[field] = cellParams;
          const isMatching = applier.fn(cellParams);
          if (isMatching) {
            result[filterValue] = true;
            continue outer;
          }
        }
      }
      result[filterValue] = false;
    }
    /* eslint-enable no-restricted-syntax, no-labels */

    return result;
  };
};
const buildAggregatedFilterApplier = (getRowId, filterModel, apiRef, disableEval) => {
  const isRowMatchingFilterItems = buildAggregatedFilterItemsApplier(getRowId, filterModel, apiRef, disableEval);
  const isRowMatchingQuickFilter = buildAggregatedQuickFilterApplier(getRowId, filterModel, apiRef);
  return function isRowMatchingFilters(row, shouldApplyFilter, result) {
    var _isRowMatchingFilterI, _isRowMatchingQuickFi;
    result.passingFilterItems = (_isRowMatchingFilterI = isRowMatchingFilterItems == null ? void 0 : isRowMatchingFilterItems(row, shouldApplyFilter)) != null ? _isRowMatchingFilterI : null;
    result.passingQuickFilterValues = (_isRowMatchingQuickFi = isRowMatchingQuickFilter == null ? void 0 : isRowMatchingQuickFilter(row, shouldApplyFilter)) != null ? _isRowMatchingQuickFi : null;
  };
};
const isNotNull = result => result != null;
const filterModelItems = (cache, apiRef, items) => {
  if (!cache.cleanedFilterItems) {
    cache.cleanedFilterItems = items.filter(item => getFilterCallbackFromItem(item, apiRef) !== null);
  }
  return cache.cleanedFilterItems;
};
const passFilterLogic = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef, cache) => {
  const cleanedFilterItems = filterModelItems(cache, apiRef, filterModel.items);
  const cleanedFilterItemResults = allFilterItemResults.filter(isNotNull);
  const cleanedQuickFilterResults = allQuickFilterResults.filter(isNotNull);

  // get result for filter items model
  if (cleanedFilterItemResults.length > 0) {
    var _filterModel$logicOpe;
    // Return true if the item pass with one of the rows
    const filterItemPredicate = item => {
      return cleanedFilterItemResults.some(filterItemResult => filterItemResult[item.id]);
    };
    const logicOperator = (_filterModel$logicOpe = filterModel.logicOperator) != null ? _filterModel$logicOpe : getDefaultGridFilterModel().logicOperator;
    if (logicOperator === GridLogicOperator.And) {
      const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
      if (!passesAllFilters) {
        return false;
      }
    } else {
      const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
      if (!passesSomeFilters) {
        return false;
      }
    }
  }

  // get result for quick filter model
  if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
    var _filterModel$quickFil4;
    // Return true if the item pass with one of the rows
    const quickFilterValuePredicate = value => {
      return cleanedQuickFilterResults.some(quickFilterValueResult => quickFilterValueResult[value]);
    };
    const quickFilterLogicOperator = (_filterModel$quickFil4 = filterModel.quickFilterLogicOperator) != null ? _filterModel$quickFil4 : getDefaultGridFilterModel().quickFilterLogicOperator;
    if (quickFilterLogicOperator === GridLogicOperator.And) {
      const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
      if (!passesAllQuickFilterValues) {
        return false;
      }
    } else {
      const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
      if (!passesSomeQuickFilterValues) {
        return false;
      }
    }
  }
  return true;
};

const filterStateInitializer = (state, props, apiRef) => {
  var _ref, _props$filterModel, _props$initialState;
  const filterModel = (_ref = (_props$filterModel = props.filterModel) != null ? _props$filterModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.filter) == null ? void 0 : _props$initialState.filterModel) != null ? _ref : getDefaultGridFilterModel();
  return _extends$c({}, state, {
    filter: {
      filterModel: sanitizeFilterModel(filterModel, props.disableMultipleColumnsFiltering, apiRef),
      filteredRowsLookup: {},
      filteredDescendantCountLookup: {}
    },
    visibleRowsLookup: {}
  });
};
const getVisibleRowsLookup = params => {
  // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
  return params.filteredRowsLookup;
};
function getVisibleRowsLookupState(apiRef, state) {
  return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
    tree: state.rows.tree,
    filteredRowsLookup: state.filter.filteredRowsLookup
  });
}
function createMemoizedValues() {
  return defaultMemoize(Object.values);
}

/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 * @requires useGridRows (event)
 */
const useGridFilter = (apiRef, props) => {
  var _props$initialState3, _props$slotProps2;
  const logger = useGridLogger(apiRef, 'useGridFilter');
  apiRef.current.registerControlState({
    stateId: 'filter',
    propModel: props.filterModel,
    propOnChange: props.onFilterModelChange,
    stateSelector: gridFilterModelSelector,
    changeEvent: 'filterModelChange'
  });
  const updateFilteredRows = React$1.useCallback(() => {
    apiRef.current.setState(state => {
      const filterModel = gridFilterModelSelector(state, apiRef.current.instanceId);
      const isRowMatchingFilters = props.filterMode === 'client' ? buildAggregatedFilterApplier(props.getRowId, filterModel, apiRef, props.disableEval) : null;
      const filteringResult = apiRef.current.applyStrategyProcessor('filtering', {
        isRowMatchingFilters,
        filterModel: filterModel != null ? filterModel : getDefaultGridFilterModel()
      });
      const newState = _extends$c({}, state, {
        filter: _extends$c({}, state.filter, filteringResult)
      });
      const visibleRowsLookupState = getVisibleRowsLookupState(apiRef, newState);
      return _extends$c({}, newState, {
        visibleRowsLookup: visibleRowsLookupState
      });
    });
    apiRef.current.publishEvent('filteredRowsSet');
  }, [apiRef, props.filterMode, props.getRowId, props.disableEval]);
  const addColumnMenuItem = React$1.useCallback((columnMenuItems, colDef) => {
    if (colDef == null || colDef.filterable === false || props.disableColumnFilter) {
      return columnMenuItems;
    }
    return [...columnMenuItems, 'columnMenuFilterItem'];
  }, [props.disableColumnFilter]);

  /**
   * API METHODS
   */
  const applyFilters = React$1.useCallback(() => {
    updateFilteredRows();
    apiRef.current.forceUpdate();
  }, [apiRef, updateFilteredRows]);
  const upsertFilterItem = React$1.useCallback(item => {
    const filterModel = gridFilterModelSelector(apiRef);
    const items = [...filterModel.items];
    const itemIndex = items.findIndex(filterItem => filterItem.id === item.id);
    if (itemIndex === -1) {
      items.push(item);
    } else {
      items[itemIndex] = item;
    }
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      items
    }), 'upsertFilterItem');
  }, [apiRef]);
  const upsertFilterItems = React$1.useCallback(items => {
    const filterModel = gridFilterModelSelector(apiRef);
    const existingItems = [...filterModel.items];
    items.forEach(item => {
      const itemIndex = items.findIndex(filterItem => filterItem.id === item.id);
      if (itemIndex === -1) {
        existingItems.push(item);
      } else {
        existingItems[itemIndex] = item;
      }
    });
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      items
    }), 'upsertFilterItems');
  }, [apiRef]);
  const deleteFilterItem = React$1.useCallback(itemToDelete => {
    const filterModel = gridFilterModelSelector(apiRef);
    const items = filterModel.items.filter(item => item.id !== itemToDelete.id);
    if (items.length === filterModel.items.length) {
      return;
    }
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      items
    }), 'deleteFilterItem');
  }, [apiRef]);
  const showFilterPanel = React$1.useCallback((targetColumnField, panelId, labelId) => {
    logger.debug('Displaying filter panel');
    if (targetColumnField) {
      const filterModel = gridFilterModelSelector(apiRef);
      const filterItemsWithValue = filterModel.items.filter(item => {
        var _column$filterOperato;
        if (item.value !== undefined) {
          // Some filters like `isAnyOf` support array as `item.value`.
          // If array is empty, we want to remove it from the filter model.
          if (Array.isArray(item.value) && item.value.length === 0) {
            return false;
          }
          return true;
        }
        const column = apiRef.current.getColumn(item.field);
        const filterOperator = (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.find(operator => operator.value === item.operator);
        const requiresFilterValue = typeof (filterOperator == null ? void 0 : filterOperator.requiresFilterValue) === 'undefined' ? true : filterOperator == null ? void 0 : filterOperator.requiresFilterValue;

        // Operators like `isEmpty` don't have and don't require `item.value`.
        // So we don't want to remove them from the filter model if `item.value === undefined`.
        // See https://github.com/mui/mui-x/issues/5402
        if (requiresFilterValue) {
          return false;
        }
        return true;
      });
      let newFilterItems;
      const filterItemOnTarget = filterItemsWithValue.find(item => item.field === targetColumnField);
      const targetColumn = apiRef.current.getColumn(targetColumnField);
      if (filterItemOnTarget) {
        newFilterItems = filterItemsWithValue;
      } else if (props.disableMultipleColumnsFiltering) {
        newFilterItems = [cleanFilterItem({
          field: targetColumnField,
          operator: targetColumn.filterOperators[0].value
        }, apiRef)];
      } else {
        newFilterItems = [...filterItemsWithValue, cleanFilterItem({
          field: targetColumnField,
          operator: targetColumn.filterOperators[0].value
        }, apiRef)];
      }
      apiRef.current.setFilterModel(_extends$c({}, filterModel, {
        items: newFilterItems
      }));
    }
    apiRef.current.showPreferences(GridPreferencePanelsValue.filters, panelId, labelId);
  }, [apiRef, logger, props.disableMultipleColumnsFiltering]);
  const hideFilterPanel = React$1.useCallback(() => {
    logger.debug('Hiding filter panel');
    apiRef.current.hidePreferences();
  }, [apiRef, logger]);
  const setFilterLogicOperator = React$1.useCallback(logicOperator => {
    const filterModel = gridFilterModelSelector(apiRef);
    if (filterModel.logicOperator === logicOperator) {
      return;
    }
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      logicOperator
    }), 'changeLogicOperator');
  }, [apiRef]);
  const setQuickFilterValues = React$1.useCallback(values => {
    const filterModel = gridFilterModelSelector(apiRef);
    if (isDeepEqual(filterModel.quickFilterValues, values)) {
      return;
    }
    apiRef.current.setFilterModel(_extends$c({}, filterModel, {
      quickFilterValues: [...values]
    }));
  }, [apiRef]);
  const setFilterModel = React$1.useCallback((model, reason) => {
    const currentModel = gridFilterModelSelector(apiRef);
    if (currentModel !== model) {
      logger.debug('Setting filter model');
      apiRef.current.updateControlState('filter', mergeStateWithFilterModel(model, props.disableMultipleColumnsFiltering, apiRef), reason);
      apiRef.current.unstable_applyFilters();
    }
  }, [apiRef, logger, props.disableMultipleColumnsFiltering]);
  const filterApi = {
    setFilterLogicOperator,
    unstable_applyFilters: applyFilters,
    deleteFilterItem,
    upsertFilterItem,
    upsertFilterItems,
    setFilterModel,
    showFilterPanel,
    hideFilterPanel,
    setQuickFilterValues
  };
  useGridApiMethod(apiRef, filterApi, 'public');

  /**
   * PRE-PROCESSING
   */
  const stateExportPreProcessing = React$1.useCallback((prevState, context) => {
    var _props$initialState2;
    const filterModelToExport = gridFilterModelSelector(apiRef);
    const shouldExportFilterModel =
    // Always export if the `exportOnlyDirtyModels` property is not activated
    !context.exportOnlyDirtyModels ||
    // Always export if the model is controlled
    props.filterModel != null ||
    // Always export if the model has been initialized
    ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.filter) == null ? void 0 : _props$initialState2.filterModel) != null ||
    // Export if the model is not equal to the default value
    !isDeepEqual(filterModelToExport, getDefaultGridFilterModel());
    if (!shouldExportFilterModel) {
      return prevState;
    }
    return _extends$c({}, prevState, {
      filter: {
        filterModel: filterModelToExport
      }
    });
  }, [apiRef, props.filterModel, (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.filter) == null ? void 0 : _props$initialState3.filterModel]);
  const stateRestorePreProcessing = React$1.useCallback((params, context) => {
    var _context$stateToResto;
    const filterModel = (_context$stateToResto = context.stateToRestore.filter) == null ? void 0 : _context$stateToResto.filterModel;
    if (filterModel == null) {
      return params;
    }
    apiRef.current.updateControlState('filter', mergeStateWithFilterModel(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
    return _extends$c({}, params, {
      callbacks: [...params.callbacks, apiRef.current.unstable_applyFilters]
    });
  }, [apiRef, props.disableMultipleColumnsFiltering]);
  const preferencePanelPreProcessing = React$1.useCallback((initialValue, value) => {
    if (value === GridPreferencePanelsValue.filters) {
      var _props$slotProps;
      const FilterPanel = props.slots.filterPanel;
      return /*#__PURE__*/jsx(FilterPanel, _extends$c({}, (_props$slotProps = props.slotProps) == null ? void 0 : _props$slotProps.filterPanel));
    }
    return initialValue;
  }, [props.slots.filterPanel, (_props$slotProps2 = props.slotProps) == null ? void 0 : _props$slotProps2.filterPanel]);
  const {
    getRowId
  } = props;
  const getRowsRef = useLazyRef(createMemoizedValues);
  const flatFilteringMethod = React$1.useCallback(params => {
    if (props.filterMode !== 'client' || !params.isRowMatchingFilters) {
      return {
        filteredRowsLookup: {},
        filteredDescendantCountLookup: {}
      };
    }
    const dataRowIdToModelLookup = gridRowsLookupSelector(apiRef);
    const filteredRowsLookup = {};
    const {
      isRowMatchingFilters
    } = params;
    const filterCache = {};
    const result = {
      passingFilterItems: null,
      passingQuickFilterValues: null
    };
    const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
    for (let i = 0; i < rows.length; i += 1) {
      const row = rows[i];
      const id = getRowId ? getRowId(row) : row.id;
      isRowMatchingFilters(row, undefined, result);
      const isRowPassing = passFilterLogic([result.passingFilterItems], [result.passingQuickFilterValues], params.filterModel, apiRef, filterCache);
      filteredRowsLookup[id] = isRowPassing;
    }
    const footerId = 'auto-generated-group-footer-root';
    const footer = dataRowIdToModelLookup[footerId];
    if (footer) {
      filteredRowsLookup[footerId] = true;
    }
    return {
      filteredRowsLookup,
      filteredDescendantCountLookup: {}
    };
  }, [apiRef, props.filterMode, getRowId, getRowsRef]);
  useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItem);
  useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'preferencePanel', preferencePanelPreProcessing);
  useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'filtering', flatFilteringMethod);
  useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'visibleRowsLookupCreation', getVisibleRowsLookup);

  /**
   * EVENTS
   */
  const handleColumnsChange = React$1.useCallback(() => {
    logger.debug('onColUpdated - GridColumns changed, applying filters');
    const filterModel = gridFilterModelSelector(apiRef);
    const filterableColumnsLookup = gridFilterableColumnLookupSelector(apiRef);
    const newFilterItems = filterModel.items.filter(item => item.field && filterableColumnsLookup[item.field]);
    if (newFilterItems.length < filterModel.items.length) {
      apiRef.current.setFilterModel(_extends$c({}, filterModel, {
        items: newFilterItems
      }));
    }
  }, [apiRef, logger]);
  const handleStrategyProcessorChange = React$1.useCallback(methodName => {
    if (methodName === 'filtering') {
      apiRef.current.unstable_applyFilters();
    }
  }, [apiRef]);
  const updateVisibleRowsLookupState = React$1.useCallback(() => {
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        visibleRowsLookup: getVisibleRowsLookupState(apiRef, state)
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);

  // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
  // Otherwise, the state is not consistent during the render
  useGridApiEventHandler(apiRef, 'rowsSet', updateFilteredRows);
  useGridApiEventHandler(apiRef, 'columnsChange', handleColumnsChange);
  useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
  useGridApiEventHandler(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
  useGridApiEventHandler(apiRef, 'columnVisibilityModelChange', () => {
    const filterModel = gridFilterModelSelector(apiRef);
    if (filterModel.quickFilterValues && filterModel.quickFilterExcludeHiddenColumns) {
      // re-apply filters because the quick filter results may have changed
      apiRef.current.unstable_applyFilters();
    }
  });

  /**
   * 1ST RENDER
   */
  useFirstRender(() => {
    apiRef.current.unstable_applyFilters();
  });

  /**
   * EFFECTS
   */
  useEnhancedEffect(() => {
    if (props.filterModel !== undefined) {
      apiRef.current.setFilterModel(props.filterModel);
    }
  }, [apiRef, logger, props.filterModel]);
};

const focusStateInitializer = state => _extends$c({}, state, {
  focus: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  },
  tabIndex: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  }
});

/**
 * @requires useGridParamsApi (method)
 * @requires useGridRows (method)
 * @requires useGridEditing (event)
 */
const useGridFocus = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useGridFocus');
  const lastClickedCell = React$1.useRef(null);
  const publishCellFocusOut = React$1.useCallback((cell, event) => {
    if (cell) {
      // The row might have been deleted
      if (apiRef.current.getRow(cell.id)) {
        apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
      }
    }
  }, [apiRef]);
  const setCellFocus = React$1.useCallback((id, field) => {
    const focusedCell = gridFocusCellSelector(apiRef);
    if ((focusedCell == null ? void 0 : focusedCell.id) === id && (focusedCell == null ? void 0 : focusedCell.field) === field) {
      return;
    }
    apiRef.current.setState(state => {
      logger.debug(`Focusing on cell with id=${id} and field=${field}`);
      return _extends$c({}, state, {
        tabIndex: {
          cell: {
            id,
            field
          },
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        },
        focus: {
          cell: {
            id,
            field
          },
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      });
    });
    apiRef.current.forceUpdate();

    // The row might have been deleted
    if (!apiRef.current.getRow(id)) {
      return;
    }
    if (focusedCell) {
      // There's a focused cell but another cell was clicked
      // Publishes an event to notify that the focus was lost
      publishCellFocusOut(focusedCell, {});
    }
    apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
  }, [apiRef, logger, publishCellFocusOut]);
  const setColumnHeaderFocus = React$1.useCallback((field, event = {}) => {
    const cell = gridFocusCellSelector(apiRef);
    publishCellFocusOut(cell, event);
    apiRef.current.setState(state => {
      logger.debug(`Focusing on column header with colIndex=${field}`);
      return _extends$c({}, state, {
        tabIndex: {
          columnHeader: {
            field
          },
          columnHeaderFilter: null,
          cell: null,
          columnGroupHeader: null
        },
        focus: {
          columnHeader: {
            field
          },
          columnHeaderFilter: null,
          cell: null,
          columnGroupHeader: null
        }
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef, logger, publishCellFocusOut]);
  const setColumnHeaderFilterFocus = React$1.useCallback((field, event = {}) => {
    const cell = gridFocusCellSelector(apiRef);
    publishCellFocusOut(cell, event);
    apiRef.current.setState(state => {
      logger.debug(`Focusing on column header filter with colIndex=${field}`);
      return _extends$c({}, state, {
        tabIndex: {
          columnHeader: null,
          columnHeaderFilter: {
            field
          },
          cell: null,
          columnGroupHeader: null
        },
        focus: {
          columnHeader: null,
          columnHeaderFilter: {
            field
          },
          cell: null,
          columnGroupHeader: null
        }
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef, logger, publishCellFocusOut]);
  const setColumnGroupHeaderFocus = React$1.useCallback((field, depth, event = {}) => {
    const cell = gridFocusCellSelector(apiRef);
    if (cell) {
      apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
    }
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        tabIndex: {
          columnGroupHeader: {
            field,
            depth
          },
          columnHeader: null,
          columnHeaderFilter: null,
          cell: null
        },
        focus: {
          columnGroupHeader: {
            field,
            depth
          },
          columnHeader: null,
          columnHeaderFilter: null,
          cell: null
        }
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);
  const getColumnGroupHeaderFocus = React$1.useCallback(() => unstable_gridFocusColumnGroupHeaderSelector(apiRef), [apiRef]);
  const moveFocusToRelativeCell = React$1.useCallback((id, field, direction) => {
    let columnIndexToFocus = apiRef.current.getColumnIndex(field);
    const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
    const currentPage = getVisibleRows(apiRef, {
      pagination: props.pagination,
      paginationMode: props.paginationMode
    });
    const pinnedRows = gridPinnedRowsSelector(apiRef);

    // Include pinned rows as well
    const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
    let rowIndexToFocus = currentPageRows.findIndex(row => row.id === id);
    if (direction === 'right') {
      columnIndexToFocus += 1;
    } else if (direction === 'left') {
      columnIndexToFocus -= 1;
    } else {
      rowIndexToFocus += 1;
    }
    if (columnIndexToFocus >= visibleColumns.length) {
      // Go to next row if we are after the last column
      rowIndexToFocus += 1;
      if (rowIndexToFocus < currentPageRows.length) {
        // Go to first column of the next row if there's one more row
        columnIndexToFocus = 0;
      }
    } else if (columnIndexToFocus < 0) {
      // Go to previous row if we are before the first column
      rowIndexToFocus -= 1;
      if (rowIndexToFocus >= 0) {
        // Go to last column of the previous if there's one more row
        columnIndexToFocus = visibleColumns.length - 1;
      }
    }
    rowIndexToFocus = clamp(rowIndexToFocus, 0, currentPageRows.length - 1);
    const rowToFocus = currentPageRows[rowIndexToFocus];
    if (!rowToFocus) {
      return;
    }
    const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
    if (colSpanInfo && colSpanInfo.spannedByColSpan) {
      if (direction === 'left' || direction === 'below') {
        columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
      } else if (direction === 'right') {
        columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
      }
    }
    columnIndexToFocus = clamp(columnIndexToFocus, 0, visibleColumns.length - 1);
    const columnToFocus = visibleColumns[columnIndexToFocus];
    apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
  }, [apiRef, props.pagination, props.paginationMode]);
  const handleCellDoubleClick = React$1.useCallback(({
    id,
    field
  }) => {
    apiRef.current.setCellFocus(id, field);
  }, [apiRef]);
  const handleCellKeyDown = React$1.useCallback((params, event) => {
    // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
    if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || isNavigationKey(event.key)) {
      return;
    }
    apiRef.current.setCellFocus(params.id, params.field);
  }, [apiRef]);
  const handleColumnHeaderFocus = React$1.useCallback(({
    field
  }, event) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    apiRef.current.setColumnHeaderFocus(field, event);
  }, [apiRef]);
  const handleColumnGroupHeaderFocus = React$1.useCallback(({
    fields,
    depth
  }, event) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    const focusedColumnGroup = unstable_gridFocusColumnGroupHeaderSelector(apiRef);
    if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) {
      // This group cell has already been focused
      return;
    }
    apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
  }, [apiRef]);
  const handleBlur = React$1.useCallback((_, event) => {
    var _event$relatedTarget;
    if ((_event$relatedTarget = event.relatedTarget) != null && _event$relatedTarget.className.includes(gridClasses.columnHeader)) {
      return;
    }
    logger.debug(`Clearing focus`);
    apiRef.current.setState(state => _extends$c({}, state, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }));
  }, [logger, apiRef]);
  const handleCellMouseDown = React$1.useCallback(params => {
    lastClickedCell.current = params;
  }, []);
  const handleDocumentClick = React$1.useCallback(event => {
    const cellParams = lastClickedCell.current;
    lastClickedCell.current = null;
    const focusedCell = gridFocusCellSelector(apiRef);
    const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
      event,
      cell: cellParams
    });
    if (!canUpdateFocus) {
      return;
    }
    if (!focusedCell) {
      if (cellParams) {
        apiRef.current.setCellFocus(cellParams.id, cellParams.field);
      }
      return;
    }
    if ((cellParams == null ? void 0 : cellParams.id) === focusedCell.id && (cellParams == null ? void 0 : cellParams.field) === focusedCell.field) {
      return;
    }
    const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
    if (cellElement != null && cellElement.contains(event.target)) {
      return;
    }
    if (cellParams) {
      apiRef.current.setCellFocus(cellParams.id, cellParams.field);
    } else {
      apiRef.current.setState(state => _extends$c({}, state, {
        focus: {
          cell: null,
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      }));
      apiRef.current.forceUpdate();

      // There's a focused cell but another element (not a cell) was clicked
      // Publishes an event to notify that the focus was lost
      publishCellFocusOut(focusedCell, event);
    }
  }, [apiRef, publishCellFocusOut]);
  const handleCellModeChange = React$1.useCallback(params => {
    if (params.cellMode === 'view') {
      return;
    }
    const cell = gridFocusCellSelector(apiRef);
    if ((cell == null ? void 0 : cell.id) !== params.id || (cell == null ? void 0 : cell.field) !== params.field) {
      apiRef.current.setCellFocus(params.id, params.field);
    }
  }, [apiRef]);
  const handleRowSet = React$1.useCallback(() => {
    const cell = gridFocusCellSelector(apiRef);

    // If the focused cell is in a row which does not exist anymore, then remove the focus
    if (cell && !apiRef.current.getRow(cell.id)) {
      apiRef.current.setState(state => _extends$c({}, state, {
        focus: {
          cell: null,
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      }));
    }
  }, [apiRef]);
  const handlePaginationModelChange = useEventCallback(() => {
    const currentFocusedCell = gridFocusCellSelector(apiRef);
    if (!currentFocusedCell) {
      return;
    }
    const currentPage = getVisibleRows(apiRef, {
      pagination: props.pagination,
      paginationMode: props.paginationMode
    });
    const rowIsInCurrentPage = currentPage.rows.find(row => row.id === currentFocusedCell.id);
    if (rowIsInCurrentPage) {
      return;
    }
    const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        tabIndex: {
          cell: {
            id: currentPage.rows[0].id,
            field: visibleColumns[0].field
          },
          columnGroupHeader: null,
          columnHeader: null,
          columnHeaderFilter: null
        }
      });
    });
  });
  const focusApi = {
    setCellFocus,
    setColumnHeaderFocus,
    setColumnHeaderFilterFocus
  };
  const focusPrivateApi = {
    moveFocusToRelativeCell,
    setColumnGroupHeaderFocus,
    getColumnGroupHeaderFocus
  };
  useGridApiMethod(apiRef, focusApi, 'public');
  useGridApiMethod(apiRef, focusPrivateApi, 'private');
  React$1.useEffect(() => {
    const doc = ownerDocument(apiRef.current.rootElementRef.current);
    doc.addEventListener('mouseup', handleDocumentClick);
    return () => {
      doc.removeEventListener('mouseup', handleDocumentClick);
    };
  }, [apiRef, handleDocumentClick]);
  useGridApiEventHandler(apiRef, 'columnHeaderBlur', handleBlur);
  useGridApiEventHandler(apiRef, 'cellDoubleClick', handleCellDoubleClick);
  useGridApiEventHandler(apiRef, 'cellMouseDown', handleCellMouseDown);
  useGridApiEventHandler(apiRef, 'cellKeyDown', handleCellKeyDown);
  useGridApiEventHandler(apiRef, 'cellModeChange', handleCellModeChange);
  useGridApiEventHandler(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
  useGridApiEventHandler(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
  useGridApiEventHandler(apiRef, 'rowsSet', handleRowSet);
  useGridApiEventHandler(apiRef, 'paginationModelChange', handlePaginationModelChange);
};

function enrichPageRowsWithPinnedRows(apiRef, rows) {
  const pinnedRows = gridPinnedRowsSelector(apiRef) || {};
  return [...(pinnedRows.top || []), ...rows, ...(pinnedRows.bottom || [])];
}
const getLeftColumnIndex = ({
  currentColIndex,
  firstColIndex,
  lastColIndex,
  direction
}) => {
  if (direction === 'rtl') {
    if (currentColIndex < lastColIndex) {
      return currentColIndex + 1;
    }
  } else if (direction === 'ltr') {
    if (currentColIndex > firstColIndex) {
      return currentColIndex - 1;
    }
  }
  return null;
};
const getRightColumnIndex = ({
  currentColIndex,
  firstColIndex,
  lastColIndex,
  direction
}) => {
  if (direction === 'rtl') {
    if (currentColIndex > firstColIndex) {
      return currentColIndex - 1;
    }
  } else if (direction === 'ltr') {
    if (currentColIndex < lastColIndex) {
      return currentColIndex + 1;
    }
  }
  return null;
};

/**
 * @requires useGridSorting (method) - can be after
 * @requires useGridFilter (state) - can be after
 * @requires useGridColumns (state, method) - can be after
 * @requires useGridDimensions (method) - can be after
 * @requires useGridFocus (method) - can be after
 * @requires useGridScroll (method) - can be after
 * @requires useGridColumnSpanning (method) - can be after
 */
const useGridKeyboardNavigation = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useGridKeyboardNavigation');
  const initialCurrentPageRows = useGridVisibleRows(apiRef, props).rows;
  const theme = useTheme$3();
  const currentPageRows = React$1.useMemo(() => enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [apiRef, initialCurrentPageRows]);
  const headerFilteringEnabled =
  // @ts-expect-error // TODO move relevant code to the `DataGridPro`
  props.signature !== 'DataGrid' && props.unstable_headerFilters;

  /**
   * @param {number} colIndex Index of the column to focus
   * @param {number} rowIndex index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */
  const goToCell = React$1.useCallback((colIndex, rowId, closestColumnToUse = 'left') => {
    const visibleSortedRows = gridExpandedSortedRowEntriesSelector(apiRef);
    const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
    if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
      if (closestColumnToUse === 'left') {
        colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
      } else if (closestColumnToUse === 'right') {
        colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
      }
    }
    // `scrollToIndexes` requires a rowIndex relative to all visible rows.
    // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
    const rowIndexRelativeToAllRows = visibleSortedRows.findIndex(row => row.id === rowId);
    logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
    apiRef.current.scrollToIndexes({
      colIndex,
      rowIndex: rowIndexRelativeToAllRows
    });
    const field = apiRef.current.getVisibleColumns()[colIndex].field;
    apiRef.current.setCellFocus(rowId, field);
  }, [apiRef, logger]);
  const goToHeader = React$1.useCallback((colIndex, event) => {
    logger.debug(`Navigating to header col ${colIndex}`);
    apiRef.current.scrollToIndexes({
      colIndex
    });
    const field = apiRef.current.getVisibleColumns()[colIndex].field;
    apiRef.current.setColumnHeaderFocus(field, event);
  }, [apiRef, logger]);
  const goToHeaderFilter = React$1.useCallback((colIndex, event) => {
    logger.debug(`Navigating to header filter col ${colIndex}`);
    apiRef.current.scrollToIndexes({
      colIndex
    });
    const field = apiRef.current.getVisibleColumns()[colIndex].field;
    apiRef.current.setColumnHeaderFilterFocus(field, event);
  }, [apiRef, logger]);
  const goToGroupHeader = React$1.useCallback((colIndex, depth, event) => {
    logger.debug(`Navigating to header col ${colIndex}`);
    apiRef.current.scrollToIndexes({
      colIndex
    });
    const {
      field
    } = apiRef.current.getVisibleColumns()[colIndex];
    apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
  }, [apiRef, logger]);
  const getRowIdFromIndex = React$1.useCallback(rowIndex => {
    var _currentPageRows$rowI;
    return (_currentPageRows$rowI = currentPageRows[rowIndex]) == null ? void 0 : _currentPageRows$rowI.id;
  }, [currentPageRows]);
  const handleColumnHeaderKeyDown = React$1.useCallback((params, event) => {
    const headerTitleNode = event.currentTarget.querySelector(`.${gridClasses.columnHeaderTitleContainerContent}`);
    const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
    if (isFromInsideContent && params.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field) {
      // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
      // There is one exception for the checkBoxHeader
      return;
    }
    const dimensions = apiRef.current.getRootDimensions();
    if (!dimensions) {
      return;
    }
    const viewportPageSize = apiRef.current.getViewportPageSize();
    const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
    const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
    const lastRowIndexInPage = currentPageRows.length - 1;
    const firstColIndex = 0;
    const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
    const columnGroupMaxDepth = gridColumnGroupsHeaderMaxDepthSelector(apiRef);
    let shouldPreventDefault = true;
    switch (event.key) {
      case 'ArrowDown':
        {
          if (firstRowIndexInPage !== null) {
            if (headerFilteringEnabled) {
              goToHeaderFilter(colIndexBefore, event);
            } else {
              goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
            }
          }
          break;
        }
      case 'ArrowRight':
        {
          const rightColIndex = getRightColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction: theme.direction
          });
          if (rightColIndex !== null) {
            goToHeader(rightColIndex, event);
          }
          break;
        }
      case 'ArrowLeft':
        {
          const leftColIndex = getLeftColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction: theme.direction
          });
          if (leftColIndex !== null) {
            goToHeader(leftColIndex, event);
          }
          break;
        }
      case 'ArrowUp':
        {
          if (columnGroupMaxDepth > 0) {
            goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
          }
          break;
        }
      case 'PageDown':
        {
          if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) {
            goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
          }
          break;
        }
      case 'Home':
        {
          goToHeader(firstColIndex, event);
          break;
        }
      case 'End':
        {
          goToHeader(lastColIndex, event);
          break;
        }
      case 'Enter':
        {
          if (event.ctrlKey || event.metaKey) {
            apiRef.current.toggleColumnMenu(params.field);
          }
          break;
        }
      case ' ':
        {
          // prevent Space event from scrolling
          break;
        }
      default:
        {
          shouldPreventDefault = false;
        }
    }
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }, [apiRef, currentPageRows.length, headerFilteringEnabled, goToHeaderFilter, goToCell, getRowIdFromIndex, theme.direction, goToHeader, goToGroupHeader]);
  const handleHeaderFilterKeyDown = React$1.useCallback((params, event) => {
    const dimensions = apiRef.current.getRootDimensions();
    if (!dimensions) {
      return;
    }
    const isEditing = unstable_gridHeaderFilteringEditFieldSelector(apiRef) === params.field;
    const isHeaderMenuOpen = unstable_gridHeaderFilteringMenuSelector(apiRef) === params.field;
    if (isEditing || isHeaderMenuOpen || !isNavigationKey(event.key)) {
      return;
    }
    const viewportPageSize = apiRef.current.getViewportPageSize();
    const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
    const firstRowIndexInPage = 0;
    const lastRowIndexInPage = currentPageRows.length - 1;
    const firstColIndex = 0;
    const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
    let shouldPreventDefault = true;
    switch (event.key) {
      case 'ArrowDown':
        {
          const rowId = getRowIdFromIndex(firstRowIndexInPage);
          if (rowId != null) {
            goToCell(colIndexBefore, rowId);
          }
          break;
        }
      case 'ArrowRight':
        {
          const rightColIndex = getRightColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction: theme.direction
          });
          if (rightColIndex !== null) {
            goToHeaderFilter(rightColIndex, event);
          }
          break;
        }
      case 'ArrowLeft':
        {
          const leftColIndex = getLeftColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction: theme.direction
          });
          if (leftColIndex !== null) {
            goToHeaderFilter(leftColIndex, event);
          } else {
            apiRef.current.setColumnHeaderFilterFocus(params.field, event);
          }
          break;
        }
      case 'ArrowUp':
        {
          goToHeader(colIndexBefore, event);
          break;
        }
      case 'PageDown':
        {
          if (lastRowIndexInPage !== null) {
            goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
          }
          break;
        }
      case 'Home':
        {
          goToHeaderFilter(firstColIndex, event);
          break;
        }
      case 'End':
        {
          goToHeaderFilter(lastColIndex, event);
          break;
        }
      case ' ':
        {
          // prevent Space event from scrolling
          break;
        }
      default:
        {
          shouldPreventDefault = false;
        }
    }
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }, [apiRef, currentPageRows.length, goToHeaderFilter, theme.direction, goToHeader, goToCell, getRowIdFromIndex]);
  const handleColumnGroupHeaderKeyDown = React$1.useCallback((params, event) => {
    const dimensions = apiRef.current.getRootDimensions();
    if (!dimensions) {
      return;
    }
    const focusedColumnGroup = unstable_gridFocusColumnGroupHeaderSelector(apiRef);
    if (focusedColumnGroup === null) {
      return;
    }
    const {
      field: currentField,
      depth: currentDepth
    } = focusedColumnGroup;
    const {
      fields,
      depth,
      maxDepth
    } = params;
    const viewportPageSize = apiRef.current.getViewportPageSize();
    const currentColIndex = apiRef.current.getColumnIndex(currentField);
    const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
    const firstRowIndexInPage = 0;
    const lastRowIndexInPage = currentPageRows.length - 1;
    const firstColIndex = 0;
    const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
    let shouldPreventDefault = true;
    switch (event.key) {
      case 'ArrowDown':
        {
          if (depth === maxDepth - 1) {
            goToHeader(currentColIndex, event);
          } else {
            goToGroupHeader(currentColIndex, currentDepth + 1, event);
          }
          break;
        }
      case 'ArrowUp':
        {
          if (depth > 0) {
            goToGroupHeader(currentColIndex, currentDepth - 1, event);
          }
          break;
        }
      case 'ArrowRight':
        {
          const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
          if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) {
            goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
          }
          break;
        }
      case 'ArrowLeft':
        {
          const remainingLeftColumns = fields.indexOf(currentField);
          if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) {
            goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
          }
          break;
        }
      case 'PageDown':
        {
          if (lastRowIndexInPage !== null) {
            goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
          }
          break;
        }
      case 'Home':
        {
          goToGroupHeader(firstColIndex, currentDepth, event);
          break;
        }
      case 'End':
        {
          goToGroupHeader(lastColIndex, currentDepth, event);
          break;
        }
      case ' ':
        {
          // prevent Space event from scrolling
          break;
        }
      default:
        {
          shouldPreventDefault = false;
        }
    }
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }, [apiRef, currentPageRows.length, goToHeader, goToGroupHeader, goToCell, getRowIdFromIndex]);
  const handleCellKeyDown = React$1.useCallback((params, event) => {
    // Ignore portal
    if (!event.currentTarget.contains(event.target)) {
      return;
    }

    // Get the most recent params because the cell mode may have changed by another listener
    const cellParams = apiRef.current.getCellParams(params.id, params.field);
    if (cellParams.cellMode === GridCellModes.Edit || !isNavigationKey(event.key)) {
      return;
    }
    const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
      event,
      cell: cellParams
    });
    if (!canUpdateFocus) {
      return;
    }
    const dimensions = apiRef.current.getRootDimensions();
    if (currentPageRows.length === 0 || !dimensions) {
      return;
    }
    const direction = theme.direction;
    const viewportPageSize = apiRef.current.getViewportPageSize();
    const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
    const rowIndexBefore = currentPageRows.findIndex(row => row.id === params.id);
    const firstRowIndexInPage = 0;
    const lastRowIndexInPage = currentPageRows.length - 1;
    const firstColIndex = 0;
    const lastColIndex = gridVisibleColumnDefinitionsSelector(apiRef).length - 1;
    let shouldPreventDefault = true;
    switch (event.key) {
      case 'ArrowDown':
        {
          // "Enter" is only triggered by the row / cell editing feature
          if (rowIndexBefore < lastRowIndexInPage) {
            goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
          }
          break;
        }
      case 'ArrowUp':
        {
          if (rowIndexBefore > firstRowIndexInPage) {
            goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
          } else if (headerFilteringEnabled) {
            goToHeaderFilter(colIndexBefore, event);
          } else {
            goToHeader(colIndexBefore, event);
          }
          break;
        }
      case 'ArrowRight':
        {
          const rightColIndex = getRightColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction
          });
          if (rightColIndex !== null) {
            goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'left' : 'right');
          }
          break;
        }
      case 'ArrowLeft':
        {
          const leftColIndex = getLeftColumnIndex({
            currentColIndex: colIndexBefore,
            firstColIndex,
            lastColIndex,
            direction
          });
          if (leftColIndex !== null) {
            goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), direction === 'rtl' ? 'right' : 'left');
          }
          break;
        }
      case 'Tab':
        {
          // "Tab" is only triggered by the row / cell editing feature
          if (event.shiftKey && colIndexBefore > firstColIndex) {
            goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
          } else if (!event.shiftKey && colIndexBefore < lastColIndex) {
            goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
          }
          break;
        }
      case ' ':
        {
          const field = params.field;
          if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) {
            break;
          }
          const colDef = params.colDef;
          if (colDef && colDef.type === 'treeDataGroup') {
            break;
          }
          if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) {
            goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
          }
          break;
        }
      case 'PageDown':
        {
          if (rowIndexBefore < lastRowIndexInPage) {
            goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
          }
          break;
        }
      case 'PageUp':
        {
          // Go to the first row before going to header
          const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
          if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) {
            goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
          } else {
            goToHeader(colIndexBefore, event);
          }
          break;
        }
      case 'Home':
        {
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
          } else {
            goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
          }
          break;
        }
      case 'End':
        {
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
          } else {
            goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
          }
          break;
        }
      default:
        {
          shouldPreventDefault = false;
        }
    }
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }, [apiRef, currentPageRows, theme.direction, goToCell, getRowIdFromIndex, headerFilteringEnabled, goToHeaderFilter, goToHeader]);
  const checkIfCanStartEditing = React$1.useCallback((initialValue, {
    event
  }) => {
    if (event.key === ' ') {
      // Space scrolls to the last row
      return false;
    }
    return initialValue;
  }, []);
  useGridRegisterPipeProcessor(apiRef, 'canStartEditing', checkIfCanStartEditing);
  useGridApiEventHandler(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
  useGridApiEventHandler(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
  useGridApiEventHandler(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
  useGridApiEventHandler(apiRef, 'cellKeyDown', handleCellKeyDown);
};

const preferencePanelStateInitializer = (state, props) => {
  var _props$initialState$p, _props$initialState;
  return _extends$c({}, state, {
    preferencePanel: (_props$initialState$p = (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.preferencePanel) != null ? _props$initialState$p : {
      open: false
    }
  });
};

/**
 * TODO: Add a single `setPreferencePanel` method to avoid multiple `setState`
 */
const useGridPreferencesPanel = (apiRef, props) => {
  var _props$initialState3;
  const logger = useGridLogger(apiRef, 'useGridPreferencesPanel');
  const hideTimeout = React$1.useRef();
  const immediateTimeout = React$1.useRef();

  /**
   * API METHODS
   */
  const hidePreferences = React$1.useCallback(() => {
    logger.debug('Hiding Preferences Panel');
    const preferencePanelState = gridPreferencePanelStateSelector(apiRef.current.state);
    if (preferencePanelState.openedPanelValue) {
      apiRef.current.publishEvent('preferencePanelClose', {
        openedPanelValue: preferencePanelState.openedPanelValue
      });
    }
    apiRef.current.setState(state => _extends$c({}, state, {
      preferencePanel: {
        open: false
      }
    }));
    apiRef.current.forceUpdate();
  }, [apiRef, logger]);

  // This is to prevent the preferences from closing when you open a select box or another panel,
  // The issue is in MUI core V4 => Fixed in V5
  const doNotHidePanel = React$1.useCallback(() => {
    immediateTimeout.current = setTimeout(() => clearTimeout(hideTimeout.current), 0);
  }, []);

  // This is a hack for the issue with Core V4, by delaying hiding the panel on the clickAwayListener,
  // we can cancel the action if the trigger element still need the panel...
  const hidePreferencesDelayed = React$1.useCallback(() => {
    hideTimeout.current = setTimeout(hidePreferences, 100);
  }, [hidePreferences]);
  const showPreferences = React$1.useCallback((newValue, panelId, labelId) => {
    logger.debug('Opening Preferences Panel');
    doNotHidePanel();
    apiRef.current.setState(state => _extends$c({}, state, {
      preferencePanel: _extends$c({}, state.preferencePanel, {
        open: true,
        openedPanelValue: newValue,
        panelId,
        labelId
      })
    }));
    apiRef.current.publishEvent('preferencePanelOpen', {
      openedPanelValue: newValue
    });
    apiRef.current.forceUpdate();
  }, [logger, doNotHidePanel, apiRef]);
  useGridApiMethod(apiRef, {
    showPreferences,
    hidePreferences: hidePreferencesDelayed
  }, 'public');

  /**
   * PRE-PROCESSING
   */
  const stateExportPreProcessing = React$1.useCallback((prevState, context) => {
    var _props$initialState2;
    const preferencePanelToExport = gridPreferencePanelStateSelector(apiRef.current.state);
    const shouldExportPreferencePanel =
    // Always export if the `exportOnlyDirtyModels` property is not activated
    !context.exportOnlyDirtyModels ||
    // Always export if the panel was initialized
    ((_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.preferencePanel) != null ||
    // Always export if the panel is opened
    preferencePanelToExport.open;
    if (!shouldExportPreferencePanel) {
      return prevState;
    }
    return _extends$c({}, prevState, {
      preferencePanel: preferencePanelToExport
    });
  }, [apiRef, (_props$initialState3 = props.initialState) == null ? void 0 : _props$initialState3.preferencePanel]);
  const stateRestorePreProcessing = React$1.useCallback((params, context) => {
    const preferencePanel = context.stateToRestore.preferencePanel;
    if (preferencePanel != null) {
      apiRef.current.setState(state => _extends$c({}, state, {
        preferencePanel
      }));
    }
    return params;
  }, [apiRef]);
  useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);

  /**
   * EFFECTS
   */
  React$1.useEffect(() => {
    return () => {
      clearTimeout(hideTimeout.current);
      clearTimeout(immediateTimeout.current);
    };
  }, []);
};

const _excluded$h = ["id", "field"],
  _excluded2$2 = ["id", "field"];
const missingOnProcessRowUpdateErrorWarning$1 = buildWarning(['MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.', 'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.', 'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'], 'error');
const useGridCellEditing = (apiRef, props) => {
  const [cellModesModel, setCellModesModel] = React$1.useState({});
  const cellModesModelRef = React$1.useRef(cellModesModel);
  const prevCellModesModel = React$1.useRef({});
  const {
    processRowUpdate,
    onProcessRowUpdateError,
    cellModesModel: cellModesModelProp,
    onCellModesModelChange
  } = props;
  const runIfEditModeIsCell = callback => (...args) => {
    if (props.editMode === GridEditModes.Cell) {
      callback(...args);
    }
  };
  const throwIfNotEditable = React$1.useCallback((id, field) => {
    const params = apiRef.current.getCellParams(id, field);
    if (!apiRef.current.isCellEditable(params)) {
      throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }
  }, [apiRef]);
  const throwIfNotInMode = React$1.useCallback((id, field, mode) => {
    if (apiRef.current.getCellMode(id, field) !== mode) {
      throw new Error(`MUI: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }
  }, [apiRef]);
  const handleCellDoubleClick = React$1.useCallback((params, event) => {
    if (!params.isEditable) {
      return;
    }
    if (params.cellMode === GridCellModes.Edit) {
      return;
    }
    const newParams = _extends$c({}, params, {
      reason: GridCellEditStartReasons.cellDoubleClick
    });
    apiRef.current.publishEvent('cellEditStart', newParams, event);
  }, [apiRef]);
  const handleCellFocusOut = React$1.useCallback((params, event) => {
    if (params.cellMode === GridCellModes.View) {
      return;
    }
    if (apiRef.current.getCellMode(params.id, params.field) === GridCellModes.View) {
      return;
    }
    const newParams = _extends$c({}, params, {
      reason: GridCellEditStopReasons.cellFocusOut
    });
    apiRef.current.publishEvent('cellEditStop', newParams, event);
  }, [apiRef]);
  const handleCellKeyDown = React$1.useCallback((params, event) => {
    if (params.cellMode === GridCellModes.Edit) {
      // Wait until IME is settled for Asian languages like Japanese and Chinese
      // TODO: `event.which` is deprecated but this is a temporary workaround
      if (event.which === 229) {
        return;
      }
      let reason;
      if (event.key === 'Escape') {
        reason = GridCellEditStopReasons.escapeKeyDown;
      } else if (event.key === 'Enter') {
        reason = GridCellEditStopReasons.enterKeyDown;
      } else if (event.key === 'Tab') {
        reason = event.shiftKey ? GridCellEditStopReasons.shiftTabKeyDown : GridCellEditStopReasons.tabKeyDown;
        event.preventDefault(); // Prevent going to the next element in the tab sequence
      }

      if (reason) {
        const newParams = _extends$c({}, params, {
          reason
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
      }
    } else if (params.isEditable) {
      let reason;
      const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
        event,
        cellParams: params,
        editMode: 'cell'
      });
      if (!canStartEditing) {
        return;
      }
      if (isPrintableKey(event)) {
        reason = GridCellEditStartReasons.printableKeyDown;
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
        reason = GridCellEditStartReasons.printableKeyDown;
      } else if (event.key === 'Enter') {
        reason = GridCellEditStartReasons.enterKeyDown;
      } else if (event.key === 'Delete' || event.key === 'Backspace') {
        // Delete on Windows, Backspace on macOS
        reason = GridCellEditStartReasons.deleteKeyDown;
      }
      if (reason) {
        const newParams = _extends$c({}, params, {
          reason,
          key: event.key
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
      }
    }
  }, [apiRef]);
  const handleCellEditStart = React$1.useCallback(params => {
    const {
      id,
      field,
      reason,
      key,
      colDef
    } = params;
    const startCellEditModeParams = {
      id,
      field
    };
    if (reason === GridCellEditStartReasons.printableKeyDown) {
      if (React$1.version.startsWith('17')) {
        // In React 17, cleaning the input is enough.
        // The sequence of events makes the key pressed by the end-users update the textbox directly.
        startCellEditModeParams.deleteValue = true;
      } else {
        const initialValue = colDef.valueParser ? colDef.valueParser(key) : key;
        startCellEditModeParams.initialValue = initialValue;
      }
    } else if (reason === GridCellEditStartReasons.deleteKeyDown) {
      startCellEditModeParams.deleteValue = true;
    }
    apiRef.current.startCellEditMode(startCellEditModeParams);
  }, [apiRef]);
  const handleCellEditStop = React$1.useCallback(params => {
    const {
      id,
      field,
      reason
    } = params;
    apiRef.current.runPendingEditCellValueMutation(id, field);
    let cellToFocusAfter;
    if (reason === GridCellEditStopReasons.enterKeyDown) {
      cellToFocusAfter = 'below';
    } else if (reason === GridCellEditStopReasons.tabKeyDown) {
      cellToFocusAfter = 'right';
    } else if (reason === GridCellEditStopReasons.shiftTabKeyDown) {
      cellToFocusAfter = 'left';
    }
    const ignoreModifications = reason === 'escapeKeyDown';
    apiRef.current.stopCellEditMode({
      id,
      field,
      ignoreModifications,
      cellToFocusAfter
    });
  }, [apiRef]);
  useGridApiEventHandler(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
  useGridApiEventHandler(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
  useGridApiEventHandler(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
  useGridApiEventHandler(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
  useGridApiEventHandler(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
  useGridApiOptionHandler(apiRef, 'cellEditStart', props.onCellEditStart);
  useGridApiOptionHandler(apiRef, 'cellEditStop', props.onCellEditStop);
  const getCellMode = React$1.useCallback((id, field) => {
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const isEditing = editingState[id] && editingState[id][field];
    return isEditing ? GridCellModes.Edit : GridCellModes.View;
  }, [apiRef]);
  const updateCellModesModel = useEventCallback(newModel => {
    const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
    if (onCellModesModelChange && isNewModelDifferentFromProp) {
      onCellModesModelChange(newModel, {});
    }
    if (props.cellModesModel && isNewModelDifferentFromProp) {
      return; // The prop always win
    }

    setCellModesModel(newModel);
    cellModesModelRef.current = newModel;
    apiRef.current.publishEvent('cellModesModelChange', newModel);
  });
  const updateFieldInCellModesModel = React$1.useCallback((id, field, newProps) => {
    // We use the ref because it always contain the up-to-date value, different from the state
    // that needs a rerender to reflect the new value
    const newModel = _extends$c({}, cellModesModelRef.current);
    if (newProps !== null) {
      newModel[id] = _extends$c({}, newModel[id], {
        [field]: _extends$c({}, newProps)
      });
    } else {
      const _newModel$id = newModel[id],
        otherFields = _objectWithoutPropertiesLoose$b(_newModel$id, [field].map(toPropertyKey)); // Ensure that we have a new object, not a reference
      newModel[id] = otherFields;
      if (Object.keys(newModel[id]).length === 0) {
        delete newModel[id];
      }
    }
    updateCellModesModel(newModel);
  }, [updateCellModesModel]);
  const updateOrDeleteFieldState = React$1.useCallback((id, field, newProps) => {
    apiRef.current.setState(state => {
      const newEditingState = _extends$c({}, state.editRows);
      if (newProps !== null) {
        newEditingState[id] = _extends$c({}, newEditingState[id], {
          [field]: _extends$c({}, newProps)
        });
      } else {
        delete newEditingState[id][field];
        if (Object.keys(newEditingState[id]).length === 0) {
          delete newEditingState[id];
        }
      }
      return _extends$c({}, state, {
        editRows: newEditingState
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);
  const startCellEditMode = React$1.useCallback(params => {
    const {
        id,
        field
      } = params,
      other = _objectWithoutPropertiesLoose$b(params, _excluded$h);
    throwIfNotEditable(id, field);
    throwIfNotInMode(id, field, GridCellModes.View);
    updateFieldInCellModesModel(id, field, _extends$c({
      mode: GridCellModes.Edit
    }, other));
  }, [throwIfNotEditable, throwIfNotInMode, updateFieldInCellModesModel]);
  const updateStateToStartCellEditMode = useEventCallback(params => {
    const {
      id,
      field,
      deleteValue,
      initialValue
    } = params;
    let newValue = apiRef.current.getCellValue(id, field);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let unstable_updateValueOnRender = false;
    if (deleteValue || initialValue) {
      newValue = deleteValue ? '' : initialValue;
      unstable_updateValueOnRender = true;
    }
    const newProps = {
      value: newValue,
      error: false,
      isProcessingProps: false,
      unstable_updateValueOnRender
    };
    updateOrDeleteFieldState(id, field, newProps);
    apiRef.current.setCellFocus(id, field);
  });
  const stopCellEditMode = React$1.useCallback(params => {
    const {
        id,
        field
      } = params,
      other = _objectWithoutPropertiesLoose$b(params, _excluded2$2);
    throwIfNotInMode(id, field, GridCellModes.Edit);
    updateFieldInCellModesModel(id, field, _extends$c({
      mode: GridCellModes.View
    }, other));
  }, [throwIfNotInMode, updateFieldInCellModesModel]);
  const updateStateToStopCellEditMode = useEventCallback(async params => {
    const {
      id,
      field,
      ignoreModifications,
      cellToFocusAfter = 'none'
    } = params;
    throwIfNotInMode(id, field, GridCellModes.Edit);
    apiRef.current.runPendingEditCellValueMutation(id, field);
    const finishCellEditMode = () => {
      updateOrDeleteFieldState(id, field, null);
      updateFieldInCellModesModel(id, field, null);
      if (cellToFocusAfter !== 'none') {
        apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
      }
    };
    if (ignoreModifications) {
      finishCellEditMode();
      return;
    }
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const {
      error,
      isProcessingProps
    } = editingState[id][field];
    if (error || isProcessingProps) {
      // Attempt to change cell mode to "view" was not successful
      // Update previous mode to allow another attempt
      prevCellModesModel.current[id][field].mode = GridCellModes.Edit;
      // Revert the mode in the cellModesModel prop back to "edit"
      updateFieldInCellModesModel(id, field, {
        mode: GridCellModes.Edit
      });
      return;
    }
    const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
    if (processRowUpdate) {
      const handleError = errorThrown => {
        prevCellModesModel.current[id][field].mode = GridCellModes.Edit;
        // Revert the mode in the cellModesModel prop back to "edit"
        updateFieldInCellModesModel(id, field, {
          mode: GridCellModes.Edit
        });
        if (onProcessRowUpdateError) {
          onProcessRowUpdateError(errorThrown);
        } else {
          missingOnProcessRowUpdateErrorWarning$1();
        }
      };
      try {
        const row = apiRef.current.getRow(id);
        Promise.resolve(processRowUpdate(rowUpdate, row)).then(finalRowUpdate => {
          apiRef.current.updateRows([finalRowUpdate]);
          finishCellEditMode();
        }).catch(handleError);
      } catch (errorThrown) {
        handleError(errorThrown);
      }
    } else {
      apiRef.current.updateRows([rowUpdate]);
      finishCellEditMode();
    }
  });
  const setCellEditingEditCellValue = React$1.useCallback(async params => {
    var _editingState$id;
    const {
      id,
      field,
      value,
      debounceMs,
      unstable_skipValueParser: skipValueParser
    } = params;
    throwIfNotEditable(id, field);
    throwIfNotInMode(id, field, GridCellModes.Edit);
    const column = apiRef.current.getColumn(field);
    const row = apiRef.current.getRow(id);
    let parsedValue = value;
    if (column.valueParser && !skipValueParser) {
      parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
    }
    let editingState = gridEditRowsStateSelector(apiRef.current.state);
    let newProps = _extends$c({}, editingState[id][field], {
      value: parsedValue,
      changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
    });
    if (column.preProcessEditCellProps) {
      const hasChanged = value !== editingState[id][field].value;
      newProps = _extends$c({}, newProps, {
        isProcessingProps: true
      });
      updateOrDeleteFieldState(id, field, newProps);
      newProps = await Promise.resolve(column.preProcessEditCellProps({
        id,
        row,
        props: newProps,
        hasChanged
      }));
    }

    // Check again if the cell is in edit mode because the user may have
    // discarded the changes while the props were being processed.
    if (apiRef.current.getCellMode(id, field) === GridCellModes.View) {
      return false;
    }
    editingState = gridEditRowsStateSelector(apiRef.current.state);
    newProps = _extends$c({}, newProps, {
      isProcessingProps: false
    });
    // We don't update the value with the one coming from the props pre-processing
    // because when the promise resolves it may be already outdated. The only
    // exception to this rule is when there's no pre-processing.
    newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
    updateOrDeleteFieldState(id, field, newProps);
    editingState = gridEditRowsStateSelector(apiRef.current.state);
    return !((_editingState$id = editingState[id]) != null && (_editingState$id = _editingState$id[field]) != null && _editingState$id.error);
  }, [apiRef, throwIfNotEditable, throwIfNotInMode, updateOrDeleteFieldState]);
  const getRowWithUpdatedValuesFromCellEditing = React$1.useCallback((id, field) => {
    const column = apiRef.current.getColumn(field);
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const row = apiRef.current.getRow(id);
    if (!editingState[id] || !editingState[id][field]) {
      return apiRef.current.getRow(id);
    }
    const {
      value
    } = editingState[id][field];
    return column.valueSetter ? column.valueSetter({
      value,
      row
    }) : _extends$c({}, row, {
      [field]: value
    });
  }, [apiRef]);
  const editingApi = {
    getCellMode,
    startCellEditMode,
    stopCellEditMode
  };
  const editingPrivateApi = {
    setCellEditingEditCellValue,
    getRowWithUpdatedValuesFromCellEditing
  };
  useGridApiMethod(apiRef, editingApi, 'public');
  useGridApiMethod(apiRef, editingPrivateApi, 'private');
  React$1.useEffect(() => {
    if (cellModesModelProp) {
      updateCellModesModel(cellModesModelProp);
    }
  }, [cellModesModelProp, updateCellModesModel]);
  React$1.useEffect(() => {
    const idToIdLookup = gridRowsDataRowIdToIdLookupSelector(apiRef);

    // Update the ref here because updateStateToStopCellEditMode may change it later
    const copyOfPrevCellModes = prevCellModesModel.current;
    prevCellModesModel.current = deepClone(cellModesModel); // Do a deep-clone because the attributes might be changed later

    Object.entries(cellModesModel).forEach(([id, fields]) => {
      Object.entries(fields).forEach(([field, params]) => {
        var _copyOfPrevCellModes$, _idToIdLookup$id;
        const prevMode = ((_copyOfPrevCellModes$ = copyOfPrevCellModes[id]) == null || (_copyOfPrevCellModes$ = _copyOfPrevCellModes$[field]) == null ? void 0 : _copyOfPrevCellModes$.mode) || GridCellModes.View;
        const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
        if (params.mode === GridCellModes.Edit && prevMode === GridCellModes.View) {
          updateStateToStartCellEditMode(_extends$c({
            id: originalId,
            field
          }, params));
        } else if (params.mode === GridCellModes.View && prevMode === GridCellModes.Edit) {
          updateStateToStopCellEditMode(_extends$c({
            id: originalId,
            field
          }, params));
        }
      });
    });
  }, [apiRef, cellModesModel, updateStateToStartCellEditMode, updateStateToStopCellEditMode]);
};

const _excluded$g = ["id"],
  _excluded2$1 = ["id"];
const missingOnProcessRowUpdateErrorWarning = buildWarning(['MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.', 'To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.', 'For more detail, see http://mui.com/components/data-grid/editing/#server-side-persistence.'], 'error');
const useGridRowEditing = (apiRef, props) => {
  const [rowModesModel, setRowModesModel] = React$1.useState({});
  const rowModesModelRef = React$1.useRef(rowModesModel);
  const prevRowModesModel = React$1.useRef({});
  const focusTimeout = React$1.useRef(null);
  const nextFocusedCell = React$1.useRef(null);
  const {
    processRowUpdate,
    onProcessRowUpdateError,
    rowModesModel: rowModesModelProp,
    onRowModesModelChange
  } = props;
  const runIfEditModeIsRow = callback => (...args) => {
    if (props.editMode === GridEditModes.Row) {
      callback(...args);
    }
  };
  const throwIfNotEditable = React$1.useCallback((id, field) => {
    const params = apiRef.current.getCellParams(id, field);
    if (!apiRef.current.isCellEditable(params)) {
      throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }
  }, [apiRef]);
  const throwIfNotInMode = React$1.useCallback((id, mode) => {
    if (apiRef.current.getRowMode(id) !== mode) {
      throw new Error(`MUI: The row with id=${id} is not in ${mode} mode.`);
    }
  }, [apiRef]);
  const handleCellDoubleClick = React$1.useCallback((params, event) => {
    if (!params.isEditable) {
      return;
    }
    if (apiRef.current.getRowMode(params.id) === GridRowModes.Edit) {
      return;
    }
    const rowParams = apiRef.current.getRowParams(params.id);
    const newParams = _extends$c({}, rowParams, {
      field: params.field,
      reason: GridRowEditStartReasons.cellDoubleClick
    });
    apiRef.current.publishEvent('rowEditStart', newParams, event);
  }, [apiRef]);
  const handleCellFocusIn = React$1.useCallback(params => {
    nextFocusedCell.current = params;
  }, []);
  const handleCellFocusOut = React$1.useCallback((params, event) => {
    if (!params.isEditable) {
      return;
    }
    if (apiRef.current.getRowMode(params.id) === GridRowModes.View) {
      return;
    }
    // The mechanism to detect if we can stop editing a row is different from
    // the cell editing. Instead of triggering it when clicking outside a cell,
    // we must check if another cell in the same row was not clicked. To achieve
    // that, first we keep track of all cells that gained focus. When a cell loses
    // focus we check if the next cell that received focus is from a different row.
    nextFocusedCell.current = null;
    focusTimeout.current = setTimeout(() => {
      var _nextFocusedCell$curr;
      focusTimeout.current = null;
      if (((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
        // The row might have been deleted during the click
        if (!apiRef.current.getRow(params.id)) {
          return;
        }

        // The row may already changed its mode
        if (apiRef.current.getRowMode(params.id) === GridRowModes.View) {
          return;
        }
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = _extends$c({}, rowParams, {
          field: params.field,
          reason: GridRowEditStopReasons.rowFocusOut
        });
        apiRef.current.publishEvent('rowEditStop', newParams, event);
      }
    });
  }, [apiRef]);
  React$1.useEffect(() => {
    return () => {
      clearTimeout(focusTimeout.current);
    };
  }, []);
  const handleCellKeyDown = React$1.useCallback((params, event) => {
    if (params.cellMode === GridRowModes.Edit) {
      // Wait until IME is settled for Asian languages like Japanese and Chinese
      // TODO: `event.which` is deprecated but this is a temporary workaround
      if (event.which === 229) {
        return;
      }
      let reason;
      if (event.key === 'Escape') {
        reason = GridRowEditStopReasons.escapeKeyDown;
      } else if (event.key === 'Enter') {
        reason = GridRowEditStopReasons.enterKeyDown;
      } else if (event.key === 'Tab') {
        const columnFields = gridVisibleColumnFieldsSelector(apiRef).filter(field => {
          const column = apiRef.current.getColumn(field);
          if (column.type === GRID_ACTIONS_COLUMN_TYPE) {
            return true;
          }
          return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
        });
        if (event.shiftKey) {
          if (params.field === columnFields[0]) {
            // Exit if user pressed Shift+Tab on the first field
            reason = GridRowEditStopReasons.shiftTabKeyDown;
          }
        } else if (params.field === columnFields[columnFields.length - 1]) {
          // Exit if user pressed Tab on the last field
          reason = GridRowEditStopReasons.tabKeyDown;
        }

        // Always prevent going to the next element in the tab sequence because the focus is
        // handled manually to support edit components rendered inside Portals
        event.preventDefault();
        if (!reason) {
          const index = columnFields.findIndex(field => field === params.field);
          const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
          apiRef.current.setCellFocus(params.id, nextFieldToFocus);
        }
      }
      if (reason) {
        const newParams = _extends$c({}, apiRef.current.getRowParams(params.id), {
          reason,
          field: params.field
        });
        apiRef.current.publishEvent('rowEditStop', newParams, event);
      }
    } else if (params.isEditable) {
      let reason;
      const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
        event,
        cellParams: params,
        editMode: 'row'
      });
      if (!canStartEditing) {
        return;
      }
      if (isPrintableKey(event)) {
        reason = GridRowEditStartReasons.printableKeyDown;
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
        reason = GridRowEditStartReasons.printableKeyDown;
      } else if (event.key === 'Enter') {
        reason = GridRowEditStartReasons.enterKeyDown;
      } else if (event.key === 'Delete' || event.key === 'Backspace') {
        // Delete on Windows, Backspace on macOS
        reason = GridRowEditStartReasons.deleteKeyDown;
      }
      if (reason) {
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = _extends$c({}, rowParams, {
          field: params.field,
          key: event.key,
          reason
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
      }
    }
  }, [apiRef]);
  const handleRowEditStart = React$1.useCallback(params => {
    const {
      id,
      field,
      reason,
      key,
      columns
    } = params;
    const startRowEditModeParams = {
      id,
      fieldToFocus: field
    };
    if (reason === GridRowEditStartReasons.printableKeyDown) {
      if (React$1.version.startsWith('17')) {
        // In React 17, cleaning the input is enough.
        // The sequence of events makes the key pressed by the end-users update the textbox directly.
        startRowEditModeParams.deleteValue = !!field;
      } else {
        const colDef = columns.find(col => col.field === field);
        startRowEditModeParams.initialValue = colDef.valueParser ? colDef.valueParser(key) : key;
      }
    } else if (reason === GridRowEditStartReasons.deleteKeyDown) {
      startRowEditModeParams.deleteValue = !!field;
    }
    apiRef.current.startRowEditMode(startRowEditModeParams);
  }, [apiRef]);
  const handleRowEditStop = React$1.useCallback(params => {
    const {
      id,
      reason,
      field
    } = params;
    apiRef.current.runPendingEditCellValueMutation(id);
    let cellToFocusAfter;
    if (reason === GridRowEditStopReasons.enterKeyDown) {
      cellToFocusAfter = 'below';
    } else if (reason === GridRowEditStopReasons.tabKeyDown) {
      cellToFocusAfter = 'right';
    } else if (reason === GridRowEditStopReasons.shiftTabKeyDown) {
      cellToFocusAfter = 'left';
    }
    const ignoreModifications = reason === 'escapeKeyDown';
    apiRef.current.stopRowEditMode({
      id,
      ignoreModifications,
      field,
      cellToFocusAfter
    });
  }, [apiRef]);
  useGridApiEventHandler(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
  useGridApiEventHandler(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
  useGridApiEventHandler(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
  useGridApiEventHandler(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
  useGridApiEventHandler(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
  useGridApiEventHandler(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
  useGridApiOptionHandler(apiRef, 'rowEditStart', props.onRowEditStart);
  useGridApiOptionHandler(apiRef, 'rowEditStop', props.onRowEditStop);
  const getRowMode = React$1.useCallback(id => {
    if (props.editMode === GridEditModes.Cell) {
      return GridRowModes.View;
    }
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
    return isEditing ? GridRowModes.Edit : GridRowModes.View;
  }, [apiRef, props.editMode]);
  const updateRowModesModel = useEventCallback(newModel => {
    const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
    if (onRowModesModelChange && isNewModelDifferentFromProp) {
      onRowModesModelChange(newModel, {});
    }
    if (props.rowModesModel && isNewModelDifferentFromProp) {
      return; // The prop always win
    }

    setRowModesModel(newModel);
    rowModesModelRef.current = newModel;
    apiRef.current.publishEvent('rowModesModelChange', newModel);
  });
  const updateRowInRowModesModel = React$1.useCallback((id, newProps) => {
    const newModel = _extends$c({}, rowModesModelRef.current);
    if (newProps !== null) {
      newModel[id] = _extends$c({}, newProps);
    } else {
      delete newModel[id];
    }
    updateRowModesModel(newModel);
  }, [updateRowModesModel]);
  const updateOrDeleteRowState = React$1.useCallback((id, newProps) => {
    apiRef.current.setState(state => {
      const newEditingState = _extends$c({}, state.editRows);
      if (newProps !== null) {
        newEditingState[id] = newProps;
      } else {
        delete newEditingState[id];
      }
      return _extends$c({}, state, {
        editRows: newEditingState
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);
  const updateOrDeleteFieldState = React$1.useCallback((id, field, newProps) => {
    apiRef.current.setState(state => {
      const newEditingState = _extends$c({}, state.editRows);
      if (newProps !== null) {
        newEditingState[id] = _extends$c({}, newEditingState[id], {
          [field]: _extends$c({}, newProps)
        });
      } else {
        delete newEditingState[id][field];
        if (Object.keys(newEditingState[id]).length === 0) {
          delete newEditingState[id];
        }
      }
      return _extends$c({}, state, {
        editRows: newEditingState
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);
  const startRowEditMode = React$1.useCallback(params => {
    const {
        id
      } = params,
      other = _objectWithoutPropertiesLoose$b(params, _excluded$g);
    throwIfNotInMode(id, GridRowModes.View);
    updateRowInRowModesModel(id, _extends$c({
      mode: GridRowModes.Edit
    }, other));
  }, [throwIfNotInMode, updateRowInRowModesModel]);
  const updateStateToStartRowEditMode = useEventCallback(params => {
    const {
      id,
      fieldToFocus,
      deleteValue,
      initialValue
    } = params;
    const columnFields = gridColumnFieldsSelector(apiRef);
    const newProps = columnFields.reduce((acc, field) => {
      const cellParams = apiRef.current.getCellParams(id, field);
      if (!cellParams.isEditable) {
        return acc;
      }
      let newValue = apiRef.current.getCellValue(id, field);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      let unstable_updateValueOnRender = false;
      if (fieldToFocus === field && (deleteValue || initialValue)) {
        newValue = deleteValue ? '' : initialValue;
        unstable_updateValueOnRender = true;
      }
      acc[field] = {
        value: newValue,
        error: false,
        isProcessingProps: false,
        unstable_updateValueOnRender
      };
      return acc;
    }, {});
    updateOrDeleteRowState(id, newProps);
    if (fieldToFocus) {
      apiRef.current.setCellFocus(id, fieldToFocus);
    }
  });
  const stopRowEditMode = React$1.useCallback(params => {
    const {
        id
      } = params,
      other = _objectWithoutPropertiesLoose$b(params, _excluded2$1);
    throwIfNotInMode(id, GridRowModes.Edit);
    updateRowInRowModesModel(id, _extends$c({
      mode: GridRowModes.View
    }, other));
  }, [throwIfNotInMode, updateRowInRowModesModel]);
  const updateStateToStopRowEditMode = useEventCallback(params => {
    const {
      id,
      ignoreModifications,
      field: focusedField,
      cellToFocusAfter = 'none'
    } = params;
    apiRef.current.runPendingEditCellValueMutation(id);
    const finishRowEditMode = () => {
      if (cellToFocusAfter !== 'none' && focusedField) {
        apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
      }
      updateOrDeleteRowState(id, null);
      updateRowInRowModesModel(id, null);
    };
    if (ignoreModifications) {
      finishRowEditMode();
      return;
    }
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const row = apiRef.current.getRow(id);
    const isSomeFieldProcessingProps = Object.values(editingState[id]).some(fieldProps => fieldProps.isProcessingProps);
    if (isSomeFieldProcessingProps) {
      prevRowModesModel.current[id].mode = GridRowModes.Edit;
      return;
    }
    const hasSomeFieldWithError = Object.values(editingState[id]).some(fieldProps => fieldProps.error);
    if (hasSomeFieldWithError) {
      prevRowModesModel.current[id].mode = GridRowModes.Edit;
      // Revert the mode in the rowModesModel prop back to "edit"
      updateRowInRowModesModel(id, {
        mode: GridRowModes.Edit
      });
      return;
    }
    const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    if (processRowUpdate) {
      const handleError = errorThrown => {
        prevRowModesModel.current[id].mode = GridRowModes.Edit;
        // Revert the mode in the rowModesModel prop back to "edit"
        updateRowInRowModesModel(id, {
          mode: GridRowModes.Edit
        });
        if (onProcessRowUpdateError) {
          onProcessRowUpdateError(errorThrown);
        } else {
          missingOnProcessRowUpdateErrorWarning();
        }
      };
      try {
        Promise.resolve(processRowUpdate(rowUpdate, row)).then(finalRowUpdate => {
          apiRef.current.updateRows([finalRowUpdate]);
          finishRowEditMode();
        }).catch(handleError);
      } catch (errorThrown) {
        handleError(errorThrown);
      }
    } else {
      apiRef.current.updateRows([rowUpdate]);
      finishRowEditMode();
    }
  });
  const setRowEditingEditCellValue = React$1.useCallback(params => {
    const {
      id,
      field,
      value,
      debounceMs,
      unstable_skipValueParser: skipValueParser
    } = params;
    throwIfNotEditable(id, field);
    const column = apiRef.current.getColumn(field);
    const row = apiRef.current.getRow(id);
    let parsedValue = value;
    if (column.valueParser && !skipValueParser) {
      parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
    }
    let editingState = gridEditRowsStateSelector(apiRef.current.state);
    let newProps = _extends$c({}, editingState[id][field], {
      value: parsedValue,
      changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
    });
    if (!column.preProcessEditCellProps) {
      updateOrDeleteFieldState(id, field, newProps);
    }
    return new Promise(resolve => {
      const promises = [];
      if (column.preProcessEditCellProps) {
        const hasChanged = newProps.value !== editingState[id][field].value;
        newProps = _extends$c({}, newProps, {
          isProcessingProps: true
        });
        updateOrDeleteFieldState(id, field, newProps);
        const _editingState$id = editingState[id],
          otherFieldsProps = _objectWithoutPropertiesLoose$b(_editingState$id, [field].map(toPropertyKey));
        const promise = Promise.resolve(column.preProcessEditCellProps({
          id,
          row,
          props: newProps,
          hasChanged,
          otherFieldsProps
        })).then(processedProps => {
          // Check again if the row is in edit mode because the user may have
          // discarded the changes while the props were being processed.
          if (apiRef.current.getRowMode(id) === GridRowModes.View) {
            resolve(false);
            return;
          }
          editingState = gridEditRowsStateSelector(apiRef.current.state);
          processedProps = _extends$c({}, processedProps, {
            isProcessingProps: false
          });
          // We don't reuse the value from the props pre-processing because when the
          // promise resolves it may be already outdated. The only exception to this rule
          // is when there's no pre-processing.
          processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
          updateOrDeleteFieldState(id, field, processedProps);
        });
        promises.push(promise);
      }
      Object.entries(editingState[id]).forEach(([thisField, fieldProps]) => {
        if (thisField === field) {
          return;
        }
        const fieldColumn = apiRef.current.getColumn(thisField);
        if (!fieldColumn.preProcessEditCellProps) {
          return;
        }
        fieldProps = _extends$c({}, fieldProps, {
          isProcessingProps: true
        });
        updateOrDeleteFieldState(id, thisField, fieldProps);
        editingState = gridEditRowsStateSelector(apiRef.current.state);
        const _editingState$id2 = editingState[id],
          otherFieldsProps = _objectWithoutPropertiesLoose$b(_editingState$id2, [thisField].map(toPropertyKey));
        const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
          id,
          row,
          props: fieldProps,
          hasChanged: false,
          otherFieldsProps
        })).then(processedProps => {
          // Check again if the row is in edit mode because the user may have
          // discarded the changes while the props were being processed.
          if (apiRef.current.getRowMode(id) === GridRowModes.View) {
            resolve(false);
            return;
          }
          processedProps = _extends$c({}, processedProps, {
            isProcessingProps: false
          });
          updateOrDeleteFieldState(id, thisField, processedProps);
        });
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        if (apiRef.current.getRowMode(id) === GridRowModes.Edit) {
          editingState = gridEditRowsStateSelector(apiRef.current.state);
          resolve(!editingState[id][field].error);
        } else {
          resolve(false);
        }
      });
    });
  }, [apiRef, throwIfNotEditable, updateOrDeleteFieldState]);
  const getRowWithUpdatedValuesFromRowEditing = React$1.useCallback(id => {
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    const row = apiRef.current.getRow(id);
    if (!editingState[id]) {
      return apiRef.current.getRow(id);
    }
    let rowUpdate = _extends$c({}, row);
    Object.entries(editingState[id]).forEach(([field, fieldProps]) => {
      const column = apiRef.current.getColumn(field);
      if (column.valueSetter) {
        rowUpdate = column.valueSetter({
          value: fieldProps.value,
          row: rowUpdate
        });
      } else {
        rowUpdate[field] = fieldProps.value;
      }
    });
    return rowUpdate;
  }, [apiRef]);
  const editingApi = {
    getRowMode,
    startRowEditMode,
    stopRowEditMode
  };
  const editingPrivateApi = {
    setRowEditingEditCellValue,
    getRowWithUpdatedValuesFromRowEditing
  };
  useGridApiMethod(apiRef, editingApi, 'public');
  useGridApiMethod(apiRef, editingPrivateApi, 'private');
  React$1.useEffect(() => {
    if (rowModesModelProp) {
      updateRowModesModel(rowModesModelProp);
    }
  }, [rowModesModelProp, updateRowModesModel]);
  React$1.useEffect(() => {
    const idToIdLookup = gridRowsDataRowIdToIdLookupSelector(apiRef);

    // Update the ref here because updateStateToStopRowEditMode may change it later
    const copyOfPrevRowModesModel = prevRowModesModel.current;
    prevRowModesModel.current = deepClone(rowModesModel); // Do a deep-clone because the attributes might be changed later

    Object.entries(rowModesModel).forEach(([id, params]) => {
      var _copyOfPrevRowModesMo, _idToIdLookup$id;
      const prevMode = ((_copyOfPrevRowModesMo = copyOfPrevRowModesModel[id]) == null ? void 0 : _copyOfPrevRowModesMo.mode) || GridRowModes.View;
      const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
      if (params.mode === GridRowModes.Edit && prevMode === GridRowModes.View) {
        updateStateToStartRowEditMode(_extends$c({
          id: originalId
        }, params));
      } else if (params.mode === GridRowModes.View && prevMode === GridRowModes.Edit) {
        updateStateToStopRowEditMode(_extends$c({
          id: originalId
        }, params));
      }
    });
  }, [apiRef, rowModesModel, updateStateToStartRowEditMode, updateStateToStopRowEditMode]);
};

const editingStateInitializer = state => _extends$c({}, state, {
  editRows: {}
});
const useGridEditing = (apiRef, props) => {
  useGridCellEditing(apiRef, props);
  useGridRowEditing(apiRef, props);
  const debounceMap = React$1.useRef({});
  const {
    isCellEditable: isCellEditableProp
  } = props;
  const isCellEditable = React$1.useCallback(params => {
    if (isAutoGeneratedRow(params.rowNode)) {
      return false;
    }
    if (!params.colDef.editable) {
      return false;
    }
    if (!params.colDef.renderEditCell) {
      return false;
    }
    if (isCellEditableProp) {
      return isCellEditableProp(params);
    }
    return true;
  }, [isCellEditableProp]);
  const maybeDebounce = (id, field, debounceMs, callback) => {
    if (!debounceMs) {
      callback();
      return;
    }
    if (!debounceMap.current[id]) {
      debounceMap.current[id] = {};
    }
    if (debounceMap.current[id][field]) {
      const [timeout] = debounceMap.current[id][field];
      clearTimeout(timeout);
    }

    // To run the callback immediately without waiting the timeout
    const runImmediately = () => {
      const [timeout] = debounceMap.current[id][field];
      clearTimeout(timeout);
      callback();
      delete debounceMap.current[id][field];
    };
    const timeout = setTimeout(() => {
      callback();
      delete debounceMap.current[id][field];
    }, debounceMs);
    debounceMap.current[id][field] = [timeout, runImmediately];
  };
  React$1.useEffect(() => {
    const debounces = debounceMap.current;
    return () => {
      Object.entries(debounces).forEach(([id, fields]) => {
        Object.keys(fields).forEach(field => {
          const [timeout] = debounces[id][field];
          clearTimeout(timeout);
          delete debounces[id][field];
        });
      });
    };
  }, []);
  const runPendingEditCellValueMutation = React$1.useCallback((id, field) => {
    if (!debounceMap.current[id]) {
      return;
    }
    if (!field) {
      Object.keys(debounceMap.current[id]).forEach(debouncedField => {
        const [, runCallback] = debounceMap.current[id][debouncedField];
        runCallback();
      });
    } else if (debounceMap.current[id][field]) {
      const [, runCallback] = debounceMap.current[id][field];
      runCallback();
    }
  }, []);
  const setEditCellValue = React$1.useCallback(params => {
    const {
      id,
      field,
      debounceMs
    } = params;
    return new Promise(resolve => {
      maybeDebounce(id, field, debounceMs, async () => {
        const setEditCellValueToCall = props.editMode === GridEditModes.Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;

        // Check if the cell is in edit mode
        // By the time this callback runs the user may have cancelled the editing
        if (apiRef.current.getCellMode(id, field) === GridCellModes.Edit) {
          const result = await setEditCellValueToCall(params);
          resolve(result);
        }
      });
    });
  }, [apiRef, props.editMode]);
  const getRowWithUpdatedValues = React$1.useCallback((id, field) => {
    return props.editMode === GridEditModes.Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
  }, [apiRef, props.editMode]);
  const getEditCellMeta = React$1.useCallback((id, field) => {
    var _editingState$id$fiel, _editingState$id;
    const editingState = gridEditRowsStateSelector(apiRef.current.state);
    return (_editingState$id$fiel = (_editingState$id = editingState[id]) == null ? void 0 : _editingState$id[field]) != null ? _editingState$id$fiel : null;
  }, [apiRef]);
  const editingSharedApi = {
    isCellEditable,
    setEditCellValue,
    getRowWithUpdatedValues,
    unstable_getEditCellMeta: getEditCellMeta
  };
  const editingSharedPrivateApi = {
    runPendingEditCellValueMutation
  };
  useGridApiMethod(apiRef, editingSharedApi, 'public');
  useGridApiMethod(apiRef, editingSharedPrivateApi, 'private');
};

const rowsStateInitializer = (state, props, apiRef) => {
  apiRef.current.caches.rows = createRowsInternalCache({
    rows: props.rows,
    getRowId: props.getRowId,
    loading: props.loading,
    rowCount: props.rowCount
  });
  return _extends$c({}, state, {
    rows: getRowsStateFromCache({
      apiRef,
      rowCountProp: props.rowCount,
      loadingProp: props.loading,
      previousTree: null,
      previousTreeDepths: null
    })
  });
};
const useGridRows = (apiRef, props) => {
  if (process.env.NODE_ENV !== 'production') {
    try {
      // Freeze the `rows` prop so developers have a fast failure if they try to use Array.prototype.push().
      Object.freeze(props.rows);
    } catch (error) {
      // Sometimes, it's impossible to freeze, so we give up on it.
    }
  }
  const logger = useGridLogger(apiRef, 'useGridRows');
  const currentPage = useGridVisibleRows(apiRef, props);
  const lastUpdateMs = React$1.useRef(Date.now());
  const timeout = useTimeout();
  const getRow = React$1.useCallback(id => {
    const model = gridRowsLookupSelector(apiRef)[id];
    if (model) {
      return model;
    }
    const node = apiRef.current.getRowNode(id);
    if (node && isAutoGeneratedRow(node)) {
      return {
        [GRID_ID_AUTOGENERATED]: id
      };
    }
    return null;
  }, [apiRef]);
  const getRowIdProp = props.getRowId;
  const getRowId = React$1.useCallback(row => {
    if (GRID_ID_AUTOGENERATED in row) {
      return row[GRID_ID_AUTOGENERATED];
    }
    if (getRowIdProp) {
      return getRowIdProp(row);
    }
    return row.id;
  }, [getRowIdProp]);
  const lookup = React$1.useMemo(() => currentPage.rows.reduce((acc, {
    id
  }, index) => {
    acc[id] = index;
    return acc;
  }, {}), [currentPage.rows]);
  const throttledRowsChange = React$1.useCallback(({
    cache,
    throttle
  }) => {
    const run = () => {
      lastUpdateMs.current = Date.now();
      apiRef.current.setState(state => _extends$c({}, state, {
        rows: getRowsStateFromCache({
          apiRef,
          rowCountProp: props.rowCount,
          loadingProp: props.loading,
          previousTree: gridRowTreeSelector(apiRef),
          previousTreeDepths: gridRowTreeDepthsSelector(apiRef)
        })
      }));
      apiRef.current.publishEvent('rowsSet');
      apiRef.current.forceUpdate();
    };
    timeout.clear();
    apiRef.current.caches.rows = cache;
    if (!throttle) {
      run();
      return;
    }
    const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
    if (throttleRemainingTimeMs > 0) {
      timeout.start(throttleRemainingTimeMs, run);
      return;
    }
    run();
  }, [props.throttleRowsMs, props.rowCount, props.loading, apiRef, timeout]);

  /**
   * API METHODS
   */
  const setRows = React$1.useCallback(rows => {
    logger.debug(`Updating all rows, new length ${rows.length}`);
    const cache = createRowsInternalCache({
      rows,
      getRowId: props.getRowId,
      loading: props.loading,
      rowCount: props.rowCount
    });
    const prevCache = apiRef.current.caches.rows;
    cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
    throttledRowsChange({
      cache,
      throttle: true
    });
  }, [logger, props.getRowId, props.loading, props.rowCount, throttledRowsChange, apiRef]);
  const updateRows = React$1.useCallback(updates => {
    if (props.signature === GridSignature.DataGrid && updates.length > 1) {
      throw new Error(["MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.", 'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'].join('\n'));
    }
    const nonPinnedRowsUpdates = [];
    updates.forEach(update => {
      const id = getRowIdFromRowModel(update, props.getRowId, 'A row was provided without id when calling updateRows():');
      const rowNode = apiRef.current.getRowNode(id);
      if ((rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') {
        // @ts-ignore because otherwise `release:build` doesn't work
        const pinnedRowsCache = apiRef.current.caches.pinnedRows;
        const prevModel = pinnedRowsCache.idLookup[id];
        if (prevModel) {
          pinnedRowsCache.idLookup[id] = _extends$c({}, prevModel, update);
        }
      } else {
        nonPinnedRowsUpdates.push(update);
      }
    });
    const cache = updateCacheWithNewRows({
      updates: nonPinnedRowsUpdates,
      getRowId: props.getRowId,
      previousCache: apiRef.current.caches.rows
    });
    throttledRowsChange({
      cache,
      throttle: true
    });
  }, [props.signature, props.getRowId, throttledRowsChange, apiRef]);
  const getRowModels = React$1.useCallback(() => {
    const dataRows = gridDataRowIdsSelector(apiRef);
    const idRowsLookup = gridRowsLookupSelector(apiRef);
    return new Map(dataRows.map(id => {
      var _idRowsLookup$id;
      return [id, (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}];
    }));
  }, [apiRef]);
  const getRowsCount = React$1.useCallback(() => gridRowCountSelector(apiRef), [apiRef]);
  const getAllRowIds = React$1.useCallback(() => gridDataRowIdsSelector(apiRef), [apiRef]);
  const getRowIndexRelativeToVisibleRows = React$1.useCallback(id => lookup[id], [lookup]);
  const setRowChildrenExpansion = React$1.useCallback((id, isExpanded) => {
    const currentNode = apiRef.current.getRowNode(id);
    if (!currentNode) {
      throw new Error(`MUI: No row with id #${id} found`);
    }
    if (currentNode.type !== 'group') {
      throw new Error('MUI: Only group nodes can be expanded or collapsed');
    }
    const newNode = _extends$c({}, currentNode, {
      childrenExpanded: isExpanded
    });
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        rows: _extends$c({}, state.rows, {
          tree: _extends$c({}, state.rows.tree, {
            [id]: newNode
          })
        })
      });
    });
    apiRef.current.forceUpdate();
    apiRef.current.publishEvent('rowExpansionChange', newNode);
  }, [apiRef]);
  const getRowNode = React$1.useCallback(id => {
    var _ref;
    return (_ref = gridRowTreeSelector(apiRef)[id]) != null ? _ref : null;
  }, [apiRef]);
  const getRowGroupChildren = React$1.useCallback(({
    skipAutoGeneratedRows = true,
    groupId,
    applySorting,
    applyFiltering
  }) => {
    const tree = gridRowTreeSelector(apiRef);
    let children;
    if (applySorting) {
      const groupNode = tree[groupId];
      if (!groupNode) {
        return [];
      }
      const sortedRowIds = gridSortedRowIdsSelector(apiRef);
      children = [];
      const startIndex = sortedRowIds.findIndex(id => id === groupId) + 1;
      for (let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1) {
        const id = sortedRowIds[index];
        if (!skipAutoGeneratedRows || !isAutoGeneratedRow(tree[id])) {
          children.push(id);
        }
      }
    } else {
      children = getTreeNodeDescendants(tree, groupId, skipAutoGeneratedRows);
    }
    if (applyFiltering) {
      const filteredRowsLookup = gridFilteredRowsLookupSelector(apiRef);
      children = children.filter(childId => filteredRowsLookup[childId] !== false);
    }
    return children;
  }, [apiRef]);
  const setRowIndex = React$1.useCallback((rowId, targetIndex) => {
    const node = apiRef.current.getRowNode(rowId);
    if (!node) {
      throw new Error(`MUI: No row with id #${rowId} found`);
    }
    if (node.parent !== GRID_ROOT_GROUP_ID) {
      throw new Error(`MUI: The row reordering do not support reordering of grouped rows yet`);
    }
    if (node.type !== 'leaf') {
      throw new Error(`MUI: The row reordering do not support reordering of footer or grouping rows`);
    }
    apiRef.current.setState(state => {
      const group = gridRowTreeSelector(state, apiRef.current.instanceId)[GRID_ROOT_GROUP_ID];
      const allRows = group.children;
      const oldIndex = allRows.findIndex(row => row === rowId);
      if (oldIndex === -1 || oldIndex === targetIndex) {
        return state;
      }
      logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
      const updatedRows = [...allRows];
      updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
      return _extends$c({}, state, {
        rows: _extends$c({}, state.rows, {
          tree: _extends$c({}, state.rows.tree, {
            [GRID_ROOT_GROUP_ID]: _extends$c({}, group, {
              children: updatedRows
            })
          })
        })
      });
    });
    apiRef.current.publishEvent('rowsSet');
  }, [apiRef, logger]);
  const replaceRows = React$1.useCallback((firstRowToRender, newRows) => {
    if (props.signature === GridSignature.DataGrid && newRows.length > 1) {
      throw new Error(["MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.", 'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'].join('\n'));
    }
    if (newRows.length === 0) {
      return;
    }
    const treeDepth = gridRowMaximumTreeDepthSelector(apiRef);
    if (treeDepth > 1) {
      throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
    }
    const tree = _extends$c({}, gridRowTreeSelector(apiRef));
    const dataRowIdToModelLookup = _extends$c({}, gridRowsLookupSelector(apiRef));
    const dataRowIdToIdLookup = _extends$c({}, gridRowsDataRowIdToIdLookupSelector(apiRef));
    const rootGroup = tree[GRID_ROOT_GROUP_ID];
    const rootGroupChildren = [...rootGroup.children];
    for (let i = 0; i < newRows.length; i += 1) {
      const rowModel = newRows[i];
      const rowId = getRowIdFromRowModel(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
      const [replacedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
      delete dataRowIdToModelLookup[replacedRowId];
      delete dataRowIdToIdLookup[replacedRowId];
      delete tree[replacedRowId];
      const rowTreeNodeConfig = {
        id: rowId,
        depth: 0,
        parent: GRID_ROOT_GROUP_ID,
        type: 'leaf',
        groupingKey: null
      };
      dataRowIdToModelLookup[rowId] = rowModel;
      dataRowIdToIdLookup[rowId] = rowId;
      tree[rowId] = rowTreeNodeConfig;
    }
    tree[GRID_ROOT_GROUP_ID] = _extends$c({}, rootGroup, {
      children: rootGroupChildren
    });

    // Removes potential remaining skeleton rows from the dataRowIds.
    const dataRowIds = rootGroupChildren.filter(childId => tree[childId].type === 'leaf');
    apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
    apiRef.current.caches.rows.dataRowIdToIdLookup = dataRowIdToIdLookup;
    apiRef.current.setState(state => _extends$c({}, state, {
      rows: _extends$c({}, state.rows, {
        dataRowIdToModelLookup,
        dataRowIdToIdLookup,
        dataRowIds,
        tree
      })
    }));
    apiRef.current.publishEvent('rowsSet');
  }, [apiRef, props.signature, props.getRowId]);
  const rowApi = {
    getRow,
    getRowId,
    getRowModels,
    getRowsCount,
    getAllRowIds,
    setRows,
    updateRows,
    getRowNode,
    getRowIndexRelativeToVisibleRows,
    unstable_replaceRows: replaceRows
  };
  const rowProApi = {
    setRowIndex,
    setRowChildrenExpansion,
    getRowGroupChildren
  };

  /**
   * EVENTS
   */
  const groupRows = React$1.useCallback(() => {
    logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
    let cache;
    if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) {
      // The `props.rows` did not change since the last row grouping
      // We can use the current rows cache which contains the partial updates done recently.
      cache = _extends$c({}, apiRef.current.caches.rows, {
        updates: {
          type: 'full',
          rows: gridDataRowIdsSelector(apiRef)
        }
      });
    } else {
      // The `props.rows` has changed since the last row grouping
      // We must use the new `props.rows` on the new grouping
      // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
      cache = createRowsInternalCache({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
      });
    }
    throttledRowsChange({
      cache,
      throttle: false
    });
  }, [logger, apiRef, props.rows, props.getRowId, props.loading, props.rowCount, throttledRowsChange]);
  const handleStrategyProcessorChange = React$1.useCallback(methodName => {
    if (methodName === 'rowTreeCreation') {
      groupRows();
    }
  }, [groupRows]);
  const handleStrategyActivityChange = React$1.useCallback(() => {
    // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
    // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
    if (apiRef.current.getActiveStrategy('rowTree') !== gridRowGroupingNameSelector(apiRef)) {
      groupRows();
    }
  }, [apiRef, groupRows]);
  useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
  useGridApiEventHandler(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);

  /**
   * APPLIERS
   */
  const applyHydrateRowsProcessor = React$1.useCallback(() => {
    apiRef.current.setState(state => {
      const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: gridRowTreeSelector(state, apiRef.current.instanceId),
        treeDepths: gridRowTreeDepthsSelector(state, apiRef.current.instanceId),
        dataRowIds: gridDataRowIdsSelector(state, apiRef.current.instanceId),
        dataRowIdToModelLookup: gridRowsLookupSelector(state, apiRef.current.instanceId),
        dataRowIdToIdLookup: gridRowsDataRowIdToIdLookupSelector(state, apiRef.current.instanceId)
      });
      return _extends$c({}, state, {
        rows: _extends$c({}, state.rows, response, {
          totalTopLevelRowCount: getTopLevelRowCount({
            tree: response.tree,
            rowCountProp: props.rowCount
          })
        })
      });
    });
    apiRef.current.publishEvent('rowsSet');
    apiRef.current.forceUpdate();
  }, [apiRef, props.rowCount]);
  useGridRegisterPipeApplier(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
  useGridApiMethod(apiRef, rowApi, 'public');
  useGridApiMethod(apiRef, rowProApi, props.signature === GridSignature.DataGrid ? 'private' : 'public');

  // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
  // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
  const isFirstRender = React$1.useRef(true);
  React$1.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows;
    const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
    const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;

    // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
    if (areNewRowsAlreadyInState) {
      // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
      if (!isNewLoadingAlreadyInState) {
        apiRef.current.setState(state => _extends$c({}, state, {
          rows: _extends$c({}, state.rows, {
            loading: props.loading
          })
        }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
        apiRef.current.forceUpdate();
      }
      if (!isNewRowCountAlreadyInState) {
        apiRef.current.setState(state => _extends$c({}, state, {
          rows: _extends$c({}, state.rows, {
            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
          })
        }));
        apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
        apiRef.current.forceUpdate();
      }
      return;
    }
    logger.debug(`Updating all rows, new length ${props.rows.length}`);
    throttledRowsChange({
      cache: createRowsInternalCache({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
      }),
      throttle: false
    });
  }, [props.rows, props.rowCount, props.getRowId, props.loading, logger, throttledRowsChange, apiRef]);
};

const createFlatRowTree = rows => {
  const tree = {
    [GRID_ROOT_GROUP_ID]: _extends$c({}, buildRootGroup(), {
      children: rows
    })
  };
  for (let i = 0; i < rows.length; i += 1) {
    const rowId = rows[i];
    tree[rowId] = {
      id: rowId,
      depth: 0,
      parent: GRID_ROOT_GROUP_ID,
      type: 'leaf',
      groupingKey: null
    };
  }
  return {
    groupingName: GRID_DEFAULT_STRATEGY,
    tree,
    treeDepths: {
      0: rows.length
    },
    dataRowIds: rows
  };
};
const updateFlatRowTree = ({
  previousTree,
  actions
}) => {
  const tree = _extends$c({}, previousTree);
  const idsToRemoveFromRootGroup = {};
  for (let i = 0; i < actions.remove.length; i += 1) {
    const idToDelete = actions.remove[i];
    idsToRemoveFromRootGroup[idToDelete] = true;
    delete tree[idToDelete];
  }
  for (let i = 0; i < actions.insert.length; i += 1) {
    const idToInsert = actions.insert[i];
    tree[idToInsert] = {
      id: idToInsert,
      depth: 0,
      parent: GRID_ROOT_GROUP_ID,
      type: 'leaf',
      groupingKey: null
    };
  }

  // TODO rows v6: Support row unpinning

  const rootGroup = tree[GRID_ROOT_GROUP_ID];
  let rootGroupChildren = [...rootGroup.children, ...actions.insert];
  if (Object.values(idsToRemoveFromRootGroup).length) {
    rootGroupChildren = rootGroupChildren.filter(id => !idsToRemoveFromRootGroup[id]);
  }
  tree[GRID_ROOT_GROUP_ID] = _extends$c({}, rootGroup, {
    children: rootGroupChildren
  });
  return {
    groupingName: GRID_DEFAULT_STRATEGY,
    tree,
    treeDepths: {
      0: rootGroupChildren.length
    },
    dataRowIds: rootGroupChildren
  };
};
const flatRowTreeCreationMethod = params => {
  if (params.updates.type === 'full') {
    return createFlatRowTree(params.updates.rows);
  }
  return updateFlatRowTree({
    previousTree: params.previousTree,
    actions: params.updates.actions
  });
};
const useGridRowsPreProcessors = apiRef => {
  useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'rowTreeCreation', flatRowTreeCreationMethod);
};

const getSelectionModelPropValue = (selectionModelProp, prevSelectionModel) => {
  if (selectionModelProp == null) {
    return selectionModelProp;
  }
  if (Array.isArray(selectionModelProp)) {
    return selectionModelProp;
  }
  if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) {
    return prevSelectionModel;
  }
  return [selectionModelProp];
};
const rowSelectionStateInitializer = (state, props) => {
  var _getSelectionModelPro;
  return _extends$c({}, state, {
    rowSelection: props.rowSelection ? (_getSelectionModelPro = getSelectionModelPropValue(props.rowSelectionModel)) != null ? _getSelectionModelPro : [] : []
  });
};

/**
 * @requires useGridRows (state, method) - can be after
 * @requires useGridParamsApi (method) - can be after
 * @requires useGridFocus (state) - can be after
 * @requires useGridKeyboardNavigation (`cellKeyDown` event must first be consumed by it)
 */
const useGridRowSelection = (apiRef, props) => {
  const logger = useGridLogger(apiRef, 'useGridSelection');
  const runIfRowSelectionIsEnabled = callback => (...args) => {
    if (props.rowSelection) {
      callback(...args);
    }
  };
  const propRowSelectionModel = React$1.useMemo(() => {
    return getSelectionModelPropValue(props.rowSelectionModel, gridRowSelectionStateSelector(apiRef.current.state));
  }, [apiRef, props.rowSelectionModel]);
  const lastRowToggled = React$1.useRef(null);
  apiRef.current.registerControlState({
    stateId: 'rowSelection',
    propModel: propRowSelectionModel,
    propOnChange: props.onRowSelectionModelChange,
    stateSelector: gridRowSelectionStateSelector,
    changeEvent: 'rowSelectionChange'
  });
  const {
    checkboxSelection,
    disableMultipleRowSelection,
    disableRowSelectionOnClick,
    isRowSelectable: propIsRowSelectable
  } = props;
  const canHaveMultipleSelection = !disableMultipleRowSelection || checkboxSelection;
  const visibleRows = useGridVisibleRows(apiRef, props);
  const expandMouseRowRangeSelection = React$1.useCallback(id => {
    var _lastRowToggled$curre;
    let endId = id;
    const startId = (_lastRowToggled$curre = lastRowToggled.current) != null ? _lastRowToggled$curre : id;
    const isSelected = apiRef.current.isRowSelected(id);
    if (isSelected) {
      const visibleRowIds = gridExpandedSortedRowIdsSelector(apiRef);
      const startIndex = visibleRowIds.findIndex(rowId => rowId === startId);
      const endIndex = visibleRowIds.findIndex(rowId => rowId === endId);
      if (startIndex === endIndex) {
        return;
      }
      if (startIndex > endIndex) {
        endId = visibleRowIds[endIndex + 1];
      } else {
        endId = visibleRowIds[endIndex - 1];
      }
    }
    lastRowToggled.current = id;
    apiRef.current.selectRowRange({
      startId,
      endId
    }, !isSelected);
  }, [apiRef]);

  /**
   * API METHODS
   */
  const setRowSelectionModel = React$1.useCallback(model => {
    if (props.signature === GridSignature.DataGrid && !props.checkboxSelection && Array.isArray(model) && model.length > 1) {
      throw new Error(['MUI: `rowSelectionModel` can only contain 1 item in DataGrid.', 'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'].join('\n'));
    }
    const currentModel = gridRowSelectionStateSelector(apiRef.current.state);
    if (currentModel !== model) {
      logger.debug(`Setting selection model`);
      apiRef.current.setState(state => _extends$c({}, state, {
        rowSelection: props.rowSelection ? model : []
      }));
      apiRef.current.forceUpdate();
    }
  }, [apiRef, logger, props.rowSelection, props.signature, props.checkboxSelection]);
  const isRowSelected = React$1.useCallback(id => gridRowSelectionStateSelector(apiRef.current.state).includes(id), [apiRef]);
  const isRowSelectable = React$1.useCallback(id => {
    if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) {
      return false;
    }
    const rowNode = apiRef.current.getRowNode(id);
    if ((rowNode == null ? void 0 : rowNode.type) === 'footer' || (rowNode == null ? void 0 : rowNode.type) === 'pinnedRow') {
      return false;
    }
    return true;
  }, [apiRef, propIsRowSelectable]);
  const getSelectedRows = React$1.useCallback(() => selectedGridRowsSelector(apiRef), [apiRef]);
  const selectRow = React$1.useCallback((id, isSelected = true, resetSelection = false) => {
    if (!apiRef.current.isRowSelectable(id)) {
      return;
    }
    lastRowToggled.current = id;
    if (resetSelection) {
      logger.debug(`Setting selection for row ${id}`);
      apiRef.current.setRowSelectionModel(isSelected ? [id] : []);
    } else {
      logger.debug(`Toggling selection for row ${id}`);
      const selection = gridRowSelectionStateSelector(apiRef.current.state);
      const newSelection = selection.filter(el => el !== id);
      if (isSelected) {
        newSelection.push(id);
      }
      const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
      if (isSelectionValid) {
        apiRef.current.setRowSelectionModel(newSelection);
      }
    }
  }, [apiRef, logger, canHaveMultipleSelection]);
  const selectRows = React$1.useCallback((ids, isSelected = true, resetSelection = false) => {
    logger.debug(`Setting selection for several rows`);
    const selectableIds = ids.filter(id => apiRef.current.isRowSelectable(id));
    let newSelection;
    if (resetSelection) {
      newSelection = isSelected ? selectableIds : [];
    } else {
      // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
      const selectionLookup = _extends$c({}, selectedIdsLookupSelector(apiRef));
      selectableIds.forEach(id => {
        if (isSelected) {
          selectionLookup[id] = id;
        } else {
          delete selectionLookup[id];
        }
      });
      newSelection = Object.values(selectionLookup);
    }
    const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
    if (isSelectionValid) {
      apiRef.current.setRowSelectionModel(newSelection);
    }
  }, [apiRef, logger, canHaveMultipleSelection]);
  const selectRowRange = React$1.useCallback(({
    startId,
    endId
  }, isSelected = true, resetSelection = false) => {
    if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) {
      return;
    }
    logger.debug(`Expanding selection from row ${startId} to row ${endId}`);

    // Using rows from all pages allow to select a range across several pages
    const allPagesRowIds = gridExpandedSortedRowIdsSelector(apiRef);
    const startIndex = allPagesRowIds.indexOf(startId);
    const endIndex = allPagesRowIds.indexOf(endId);
    const [start, end] = startIndex > endIndex ? [endIndex, startIndex] : [startIndex, endIndex];
    const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
    apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
  }, [apiRef, logger]);
  const selectionPublicApi = {
    selectRow,
    setRowSelectionModel,
    getSelectedRows,
    isRowSelected,
    isRowSelectable
  };
  const selectionPrivateApi = {
    selectRows,
    selectRowRange
  };
  useGridApiMethod(apiRef, selectionPublicApi, 'public');
  useGridApiMethod(apiRef, selectionPrivateApi, props.signature === GridSignature.DataGrid ? 'private' : 'public');

  /**
   * EVENTS
   */
  const removeOutdatedSelection = React$1.useCallback(() => {
    if (props.keepNonExistentRowsSelected) {
      return;
    }
    const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
    const rowsLookup = gridRowsLookupSelector(apiRef);

    // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
    const selectionLookup = _extends$c({}, selectedIdsLookupSelector(apiRef));
    let hasChanged = false;
    currentSelection.forEach(id => {
      if (!rowsLookup[id]) {
        delete selectionLookup[id];
        hasChanged = true;
      }
    });
    if (hasChanged) {
      apiRef.current.setRowSelectionModel(Object.values(selectionLookup));
    }
  }, [apiRef, props.keepNonExistentRowsSelected]);
  const handleSingleRowSelection = React$1.useCallback((id, event) => {
    const hasCtrlKey = event.metaKey || event.ctrlKey;

    // multiple selection is only allowed if:
    // - it is a checkboxSelection
    // - it is a keyboard selection
    // - Ctrl is pressed

    const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !isKeyboardEvent$1(event);
    const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
    const isSelected = apiRef.current.isRowSelected(id);
    if (resetSelection) {
      apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
    } else {
      apiRef.current.selectRow(id, !isSelected, false);
    }
  }, [apiRef, canHaveMultipleSelection, checkboxSelection]);
  const handleRowClick = React$1.useCallback((params, event) => {
    var _closest;
    if (disableRowSelectionOnClick) {
      return;
    }
    const field = (_closest = event.target.closest(`.${gridClasses.cell}`)) == null ? void 0 : _closest.getAttribute('data-field');
    if (field === GRID_CHECKBOX_SELECTION_COL_DEF.field) {
      // click on checkbox should not trigger row selection
      return;
    }
    if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) {
      // click to open the detail panel should not select the row
      return;
    }
    if (field) {
      const column = apiRef.current.getColumn(field);
      if ((column == null ? void 0 : column.type) === GRID_ACTIONS_COLUMN_TYPE) {
        return;
      }
    }
    const rowNode = apiRef.current.getRowNode(params.id);
    if (rowNode.type === 'pinnedRow') {
      return;
    }
    if (event.shiftKey && (canHaveMultipleSelection || checkboxSelection)) {
      expandMouseRowRangeSelection(params.id);
    } else {
      handleSingleRowSelection(params.id, event);
    }
  }, [disableRowSelectionOnClick, canHaveMultipleSelection, checkboxSelection, apiRef, expandMouseRowRangeSelection, handleSingleRowSelection]);
  const preventSelectionOnShift = React$1.useCallback((params, event) => {
    if (canHaveMultipleSelection && event.shiftKey) {
      var _window$getSelection;
      (_window$getSelection = window.getSelection()) == null || _window$getSelection.removeAllRanges();
    }
  }, [canHaveMultipleSelection]);
  const handleRowSelectionCheckboxChange = React$1.useCallback((params, event) => {
    if (event.nativeEvent.shiftKey) {
      expandMouseRowRangeSelection(params.id);
    } else {
      apiRef.current.selectRow(params.id, params.value);
    }
  }, [apiRef, expandMouseRowRangeSelection]);
  const handleHeaderSelectionCheckboxChange = React$1.useCallback(params => {
    const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
    const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? gridPaginatedVisibleSortedGridRowIdsSelector(apiRef) : gridExpandedSortedRowIdsSelector(apiRef);
    apiRef.current.selectRows(rowsToBeSelected, params.value);
  }, [apiRef, props.checkboxSelectionVisibleOnly, props.pagination]);
  const handleCellKeyDown = React$1.useCallback((params, event) => {
    // Get the most recent cell mode because it may have been changed by another listener
    if (apiRef.current.getCellMode(params.id, params.field) === GridCellModes.Edit) {
      return;
    }

    // Ignore portal
    // Do not apply shortcuts if the focus is not on the cell root component
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    if (isNavigationKey(event.key) && event.shiftKey) {
      // The cell that has focus after the keyboard navigation
      const focusCell = gridFocusCellSelector(apiRef);
      if (focusCell && focusCell.id !== params.id) {
        event.preventDefault();
        const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
        if (!canHaveMultipleSelection) {
          apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
          return;
        }
        const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
        const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
        let start;
        let end;
        if (newRowIndex > previousRowIndex) {
          if (isNextRowSelected) {
            // We are navigating to the bottom of the page and adding selected rows
            start = previousRowIndex;
            end = newRowIndex - 1;
          } else {
            // We are navigating to the bottom of the page and removing selected rows
            start = previousRowIndex;
            end = newRowIndex;
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (isNextRowSelected) {
            // We are navigating to the top of the page and removing selected rows
            start = newRowIndex + 1;
            end = previousRowIndex;
          } else {
            // We are navigating to the top of the page and adding selected rows
            start = newRowIndex;
            end = previousRowIndex;
          }
        }
        const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map(row => row.id);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
        return;
      }
    }
    if (event.key === ' ' && event.shiftKey) {
      event.preventDefault();
      handleSingleRowSelection(params.id, event);
      return;
    }
    if (event.key === 'a' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      selectRows(apiRef.current.getAllRowIds(), true);
    }
  }, [apiRef, handleSingleRowSelection, selectRows, visibleRows.rows, canHaveMultipleSelection]);
  useGridApiEventHandler(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(removeOutdatedSelection));
  useGridApiEventHandler(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
  useGridApiEventHandler(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
  useGridApiEventHandler(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
  useGridApiEventHandler(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
  useGridApiEventHandler(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));

  /**
   * EFFECTS
   */
  React$1.useEffect(() => {
    if (propRowSelectionModel !== undefined) {
      apiRef.current.setRowSelectionModel(propRowSelectionModel);
    }
  }, [apiRef, propRowSelectionModel, props.rowSelection]);
  React$1.useEffect(() => {
    if (!props.rowSelection) {
      apiRef.current.setRowSelectionModel([]);
    }
  }, [apiRef, props.rowSelection]);
  const isStateControlled = propRowSelectionModel != null;
  React$1.useEffect(() => {
    if (isStateControlled || !props.rowSelection) {
      return;
    }

    // props.isRowSelectable changed
    const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
    if (isRowSelectable) {
      const newSelection = currentSelection.filter(id => isRowSelectable(id));
      if (newSelection.length < currentSelection.length) {
        apiRef.current.setRowSelectionModel(newSelection);
      }
    }
  }, [apiRef, isRowSelectable, isStateControlled, props.rowSelection]);
  React$1.useEffect(() => {
    if (!props.rowSelection || isStateControlled) {
      return;
    }
    const currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
    if (!canHaveMultipleSelection && currentSelection.length > 1) {
      // See https://github.com/mui/mui-x/issues/8455
      apiRef.current.setRowSelectionModel([]);
    }
  }, [apiRef, canHaveMultipleSelection, checkboxSelection, isStateControlled, props.rowSelection]);
};

const GRID_DEFAULT_LOCALE_TEXT = {
  // Root
  noRowsLabel: 'No rows',
  noResultsOverlayLabel: 'No results found.',
  // Density selector toolbar button text
  toolbarDensity: 'Density',
  toolbarDensityLabel: 'Density',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Standard',
  toolbarDensityComfortable: 'Comfortable',
  // Columns selector toolbar button text
  toolbarColumns: 'Columns',
  toolbarColumnsLabel: 'Select columns',
  // Filters toolbar button text
  toolbarFilters: 'Filters',
  toolbarFiltersLabel: 'Show filters',
  toolbarFiltersTooltipHide: 'Hide filters',
  toolbarFiltersTooltipShow: 'Show filters',
  toolbarFiltersTooltipActive: count => count !== 1 ? `${count} active filters` : `${count} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Search…',
  toolbarQuickFilterLabel: 'Search',
  toolbarQuickFilterDeleteIconLabel: 'Clear',
  // Export selector toolbar button text
  toolbarExport: 'Export',
  toolbarExportLabel: 'Export',
  toolbarExportCSV: 'Download as CSV',
  toolbarExportPrint: 'Print',
  toolbarExportExcel: 'Download as Excel',
  // Columns panel text
  columnsPanelTextFieldLabel: 'Find column',
  columnsPanelTextFieldPlaceholder: 'Column title',
  columnsPanelDragIconLabel: 'Reorder column',
  columnsPanelShowAllButton: 'Show all',
  columnsPanelHideAllButton: 'Hide all',
  // Filter panel text
  filterPanelAddFilter: 'Add filter',
  filterPanelRemoveAll: 'Remove all',
  filterPanelDeleteIconLabel: 'Delete',
  filterPanelLogicOperator: 'Logic operator',
  filterPanelOperator: 'Operator',
  filterPanelOperatorAnd: 'And',
  filterPanelOperatorOr: 'Or',
  filterPanelColumns: 'Columns',
  filterPanelInputLabel: 'Value',
  filterPanelInputPlaceholder: 'Filter value',
  // Filter operators text
  filterOperatorContains: 'contains',
  filterOperatorEquals: 'equals',
  filterOperatorStartsWith: 'starts with',
  filterOperatorEndsWith: 'ends with',
  filterOperatorIs: 'is',
  filterOperatorNot: 'is not',
  filterOperatorAfter: 'is after',
  filterOperatorOnOrAfter: 'is on or after',
  filterOperatorBefore: 'is before',
  filterOperatorOnOrBefore: 'is on or before',
  filterOperatorIsEmpty: 'is empty',
  filterOperatorIsNotEmpty: 'is not empty',
  filterOperatorIsAnyOf: 'is any of',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',
  // Header filter operators text
  headerFilterOperatorContains: 'Contains',
  headerFilterOperatorEquals: 'Equals',
  headerFilterOperatorStartsWith: 'Starts with',
  headerFilterOperatorEndsWith: 'Ends with',
  headerFilterOperatorIs: 'Is',
  headerFilterOperatorNot: 'Is not',
  headerFilterOperatorAfter: 'Is after',
  headerFilterOperatorOnOrAfter: 'Is on or after',
  headerFilterOperatorBefore: 'Is before',
  headerFilterOperatorOnOrBefore: 'Is on or before',
  headerFilterOperatorIsEmpty: 'Is empty',
  headerFilterOperatorIsNotEmpty: 'Is not empty',
  headerFilterOperatorIsAnyOf: 'Is any of',
  'headerFilterOperator=': 'Equals',
  'headerFilterOperator!=': 'Not equals',
  'headerFilterOperator>': 'Greater than',
  'headerFilterOperator>=': 'Greater than or equal to',
  'headerFilterOperator<': 'Less than',
  'headerFilterOperator<=': 'Less than or equal to',
  // Filter values text
  filterValueAny: 'any',
  filterValueTrue: 'true',
  filterValueFalse: 'false',
  // Column menu text
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Show columns',
  columnMenuManageColumns: 'Manage columns',
  columnMenuFilter: 'Filter',
  columnMenuHideColumn: 'Hide column',
  columnMenuUnsort: 'Unsort',
  columnMenuSortAsc: 'Sort by ASC',
  columnMenuSortDesc: 'Sort by DESC',
  // Column header text
  columnHeaderFiltersTooltipActive: count => count !== 1 ? `${count} active filters` : `${count} active filter`,
  columnHeaderFiltersLabel: 'Show filters',
  columnHeaderSortIconLabel: 'Sort',
  // Rows selected footer text
  footerRowSelected: count => count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: 'Total Rows:',
  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) => `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: 'Checkbox selection',
  checkboxSelectionSelectAllRows: 'Select all rows',
  checkboxSelectionUnselectAllRows: 'Unselect all rows',
  checkboxSelectionSelectRow: 'Select row',
  checkboxSelectionUnselectRow: 'Unselect row',
  // Boolean cell text
  booleanCellTrueLabel: 'yes',
  booleanCellFalseLabel: 'no',
  // Actions cell more text
  actionsCellMore: 'more',
  // Column pinning text
  pinToLeft: 'Pin to left',
  pinToRight: 'Pin to right',
  unpin: 'Unpin',
  // Tree Data
  treeDataGroupingHeaderName: 'Group',
  treeDataExpand: 'see children',
  treeDataCollapse: 'hide children',
  // Grouping columns
  groupingColumnHeaderName: 'Group',
  groupColumn: name => `Group by ${name}`,
  unGroupColumn: name => `Stop grouping by ${name}`,
  // Master/detail
  detailPanelToggle: 'Detail panel toggle',
  expandDetailPanel: 'Expand',
  collapseDetailPanel: 'Collapse',
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: 'Row reordering',
  // Aggregation
  aggregationMenuItemHeader: 'Aggregation',
  aggregationFunctionLabelSum: 'sum',
  aggregationFunctionLabelAvg: 'avg',
  aggregationFunctionLabelMin: 'min',
  aggregationFunctionLabelMax: 'max',
  aggregationFunctionLabelSize: 'size'
};

const useUtilityClasses$c = ownerState => {
  const {
    classes
  } = ownerState;
  return React$1.useMemo(() => {
    const slots = {
      cellCheckbox: ['cellCheckbox'],
      columnHeaderCheckbox: ['columnHeaderCheckbox']
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
  }, [classes]);
};
const useGridRowSelectionPreProcessors = (apiRef, props) => {
  const ownerState = {
    classes: props.classes
  };
  const classes = useUtilityClasses$c(ownerState);
  const updateSelectionColumn = React$1.useCallback(columnsState => {
    const selectionColumn = _extends$c({}, GRID_CHECKBOX_SELECTION_COL_DEF, {
      cellClassName: classes.cellCheckbox,
      headerClassName: classes.columnHeaderCheckbox,
      headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
    });
    const shouldHaveSelectionColumn = props.checkboxSelection;
    const haveSelectionColumn = columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD] != null;
    if (shouldHaveSelectionColumn && !haveSelectionColumn) {
      columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
      columnsState.orderedFields = [GRID_CHECKBOX_SELECTION_FIELD, ...columnsState.orderedFields];
    } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
      delete columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD];
      columnsState.orderedFields = columnsState.orderedFields.filter(field => field !== GRID_CHECKBOX_SELECTION_FIELD);
    } else if (shouldHaveSelectionColumn && haveSelectionColumn) {
      columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD] = _extends$c({}, selectionColumn, columnsState.lookup[GRID_CHECKBOX_SELECTION_FIELD]);
    }
    return columnsState;
  }, [apiRef, classes, props.checkboxSelection]);
  useGridRegisterPipeProcessor(apiRef, 'hydrateColumns', updateSelectionColumn);
};

const sortingStateInitializer = (state, props) => {
  var _ref, _props$sortModel, _props$initialState;
  const sortModel = (_ref = (_props$sortModel = props.sortModel) != null ? _props$sortModel : (_props$initialState = props.initialState) == null || (_props$initialState = _props$initialState.sorting) == null ? void 0 : _props$initialState.sortModel) != null ? _ref : [];
  return _extends$c({}, state, {
    sorting: {
      sortModel: sanitizeSortModel(sortModel, props.disableMultipleColumnsSorting),
      sortedRows: []
    }
  });
};

/**
 * @requires useGridRows (event)
 * @requires useGridColumns (event)
 */
const useGridSorting = (apiRef, props) => {
  var _props$initialState3;
  const logger = useGridLogger(apiRef, 'useGridSorting');
  apiRef.current.registerControlState({
    stateId: 'sortModel',
    propModel: props.sortModel,
    propOnChange: props.onSortModelChange,
    stateSelector: gridSortModelSelector,
    changeEvent: 'sortModelChange'
  });
  const upsertSortModel = React$1.useCallback((field, sortItem) => {
    const sortModel = gridSortModelSelector(apiRef);
    const existingIdx = sortModel.findIndex(c => c.field === field);
    let newSortModel = [...sortModel];
    if (existingIdx > -1) {
      if (!sortItem) {
        newSortModel.splice(existingIdx, 1);
      } else {
        newSortModel.splice(existingIdx, 1, sortItem);
      }
    } else {
      newSortModel = [...sortModel, sortItem];
    }
    return newSortModel;
  }, [apiRef]);
  const createSortItem = React$1.useCallback((col, directionOverride) => {
    var _col$sortingOrder2;
    const sortModel = gridSortModelSelector(apiRef);
    const existing = sortModel.find(c => c.field === col.field);
    if (existing) {
      var _col$sortingOrder;
      const nextSort = directionOverride === undefined ? getNextGridSortDirection((_col$sortingOrder = col.sortingOrder) != null ? _col$sortingOrder : props.sortingOrder, existing.sort) : directionOverride;
      return nextSort == null ? undefined : _extends$c({}, existing, {
        sort: nextSort
      });
    }
    return {
      field: col.field,
      sort: directionOverride === undefined ? getNextGridSortDirection((_col$sortingOrder2 = col.sortingOrder) != null ? _col$sortingOrder2 : props.sortingOrder) : directionOverride
    };
  }, [apiRef, props.sortingOrder]);
  const addColumnMenuItem = React$1.useCallback((columnMenuItems, colDef) => {
    if (colDef == null || colDef.sortable === false) {
      return columnMenuItems;
    }
    const sortingOrder = colDef.sortingOrder || props.sortingOrder;
    if (sortingOrder.some(item => !!item)) {
      return [...columnMenuItems, 'columnMenuSortItem'];
    }
    return columnMenuItems;
  }, [props.sortingOrder]);

  /**
   * API METHODS
   */
  const applySorting = React$1.useCallback(() => {
    apiRef.current.setState(state => {
      if (props.sortingMode === 'server') {
        logger.debug('Skipping sorting rows as sortingMode = server');
        return _extends$c({}, state, {
          sorting: _extends$c({}, state.sorting, {
            sortedRows: getTreeNodeDescendants(gridRowTreeSelector(apiRef), GRID_ROOT_GROUP_ID, false)
          })
        });
      }
      const sortModel = gridSortModelSelector(state, apiRef.current.instanceId);
      const sortRowList = buildAggregatedSortingApplier(sortModel, apiRef);
      const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
        sortRowList
      });
      return _extends$c({}, state, {
        sorting: _extends$c({}, state.sorting, {
          sortedRows
        })
      });
    });
    apiRef.current.publishEvent('sortedRowsSet');
    apiRef.current.forceUpdate();
  }, [apiRef, logger, props.sortingMode]);
  const setSortModel = React$1.useCallback(model => {
    const currentModel = gridSortModelSelector(apiRef);
    if (currentModel !== model) {
      logger.debug(`Setting sort model`);
      apiRef.current.setState(mergeStateWithSortModel(model, props.disableMultipleColumnsSorting));
      apiRef.current.forceUpdate();
      apiRef.current.applySorting();
    }
  }, [apiRef, logger, props.disableMultipleColumnsSorting]);
  const sortColumn = React$1.useCallback((column, direction, allowMultipleSorting) => {
    if (!column.sortable) {
      return;
    }
    const sortItem = createSortItem(column, direction);
    let sortModel;
    if (!allowMultipleSorting || props.disableMultipleColumnsSorting) {
      sortModel = !sortItem ? [] : [sortItem];
    } else {
      sortModel = upsertSortModel(column.field, sortItem);
    }
    apiRef.current.setSortModel(sortModel);
  }, [apiRef, upsertSortModel, createSortItem, props.disableMultipleColumnsSorting]);
  const getSortModel = React$1.useCallback(() => gridSortModelSelector(apiRef), [apiRef]);
  const getSortedRows = React$1.useCallback(() => {
    const sortedRows = gridSortedRowEntriesSelector(apiRef);
    return sortedRows.map(row => row.model);
  }, [apiRef]);
  const getSortedRowIds = React$1.useCallback(() => gridSortedRowIdsSelector(apiRef), [apiRef]);
  const getRowIdFromRowIndex = React$1.useCallback(index => apiRef.current.getSortedRowIds()[index], [apiRef]);
  const sortApi = {
    getSortModel,
    getSortedRows,
    getSortedRowIds,
    getRowIdFromRowIndex,
    setSortModel,
    sortColumn,
    applySorting
  };
  useGridApiMethod(apiRef, sortApi, 'public');

  /**
   * PRE-PROCESSING
   */
  const stateExportPreProcessing = React$1.useCallback((prevState, context) => {
    var _props$initialState2;
    const sortModelToExport = gridSortModelSelector(apiRef);
    const shouldExportSortModel =
    // Always export if the `exportOnlyDirtyModels` property is not activated
    !context.exportOnlyDirtyModels ||
    // Always export if the model is controlled
    props.sortModel != null ||
    // Always export if the model has been initialized
    ((_props$initialState2 = props.initialState) == null || (_props$initialState2 = _props$initialState2.sorting) == null ? void 0 : _props$initialState2.sortModel) != null ||
    // Export if the model is not empty
    sortModelToExport.length > 0;
    if (!shouldExportSortModel) {
      return prevState;
    }
    return _extends$c({}, prevState, {
      sorting: {
        sortModel: sortModelToExport
      }
    });
  }, [apiRef, props.sortModel, (_props$initialState3 = props.initialState) == null || (_props$initialState3 = _props$initialState3.sorting) == null ? void 0 : _props$initialState3.sortModel]);
  const stateRestorePreProcessing = React$1.useCallback((params, context) => {
    var _context$stateToResto;
    const sortModel = (_context$stateToResto = context.stateToRestore.sorting) == null ? void 0 : _context$stateToResto.sortModel;
    if (sortModel == null) {
      return params;
    }
    apiRef.current.setState(mergeStateWithSortModel(sortModel, props.disableMultipleColumnsSorting));
    return _extends$c({}, params, {
      callbacks: [...params.callbacks, apiRef.current.applySorting]
    });
  }, [apiRef, props.disableMultipleColumnsSorting]);
  const flatSortingMethod = React$1.useCallback(params => {
    const rowTree = gridRowTreeSelector(apiRef);
    const rootGroupNode = rowTree[GRID_ROOT_GROUP_ID];
    const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map(childId => rowTree[childId])) : [...rootGroupNode.children];
    if (rootGroupNode.footerId != null) {
      sortedChildren.push(rootGroupNode.footerId);
    }
    return sortedChildren;
  }, [apiRef]);
  useGridRegisterPipeProcessor(apiRef, 'exportState', stateExportPreProcessing);
  useGridRegisterPipeProcessor(apiRef, 'restoreState', stateRestorePreProcessing);
  useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'sorting', flatSortingMethod);

  /**
   * EVENTS
   */
  const handleColumnHeaderClick = React$1.useCallback(({
    colDef
  }, event) => {
    const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
    sortColumn(colDef, undefined, allowMultipleSorting);
  }, [sortColumn]);
  const handleColumnHeaderKeyDown = React$1.useCallback(({
    colDef
  }, event) => {
    // Ctrl + Enter opens the column menu
    if (isEnterKey(event.key) && !event.ctrlKey && !event.metaKey) {
      sortColumn(colDef, undefined, event.shiftKey);
    }
  }, [sortColumn]);
  const handleColumnsChange = React$1.useCallback(() => {
    // When the columns change we check that the sorted columns are still part of the dataset
    const sortModel = gridSortModelSelector(apiRef);
    const latestColumns = gridColumnLookupSelector(apiRef);
    if (sortModel.length > 0) {
      const newModel = sortModel.filter(sortItem => latestColumns[sortItem.field]);
      if (newModel.length < sortModel.length) {
        apiRef.current.setSortModel(newModel);
      }
    }
  }, [apiRef]);
  const handleStrategyProcessorChange = React$1.useCallback(methodName => {
    if (methodName === 'sorting') {
      apiRef.current.applySorting();
    }
  }, [apiRef]);
  useGridRegisterPipeProcessor(apiRef, 'columnMenu', addColumnMenuItem);
  useGridApiEventHandler(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
  useGridApiEventHandler(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
  useGridApiEventHandler(apiRef, 'rowsSet', apiRef.current.applySorting);
  useGridApiEventHandler(apiRef, 'columnsChange', handleColumnsChange);
  useGridApiEventHandler(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);

  /**
   * 1ST RENDER
   */
  useFirstRender(() => {
    apiRef.current.applySorting();
  });

  /**
   * EFFECTS
   */
  useEnhancedEffect(() => {
    if (props.sortModel !== undefined) {
      apiRef.current.setSortModel(props.sortModel);
    }
  }, [apiRef, props.sortModel]);
};

// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function scrollIntoView(dimensions) {
  const {
    clientHeight,
    scrollTop,
    offsetHeight,
    offsetTop
  } = dimensions;
  const elementBottom = offsetTop + offsetHeight;
  // Always scroll to top when cell is higher than viewport to avoid scroll jump
  // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
  if (offsetHeight > clientHeight) {
    return offsetTop;
  }
  if (elementBottom - clientHeight > scrollTop) {
    return elementBottom - clientHeight;
  }
  if (offsetTop < scrollTop) {
    return offsetTop;
  }
  return undefined;
}

/**
 * @requires useGridPagination (state) - can be after, async only
 * @requires useGridColumns (state) - can be after, async only
 * @requires useGridRows (state) - can be after, async only
 * @requires useGridRowsMeta (state) - can be after, async only
 * @requires useGridFilter (state)
 * @requires useGridColumnSpanning (method)
 */
const useGridScroll = (apiRef, props) => {
  const theme = useTheme$3();
  const logger = useGridLogger(apiRef, 'useGridScroll');
  const colRef = apiRef.current.columnHeadersElementRef;
  const virtualScrollerRef = apiRef.current.virtualScrollerRef;
  const visibleSortedRows = useGridSelector(apiRef, gridExpandedSortedRowEntriesSelector);
  const scrollToIndexes = React$1.useCallback(params => {
    const totalRowCount = gridRowCountSelector(apiRef);
    const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
    const scrollToHeader = params.rowIndex == null;
    if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) {
      return false;
    }
    logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
    let scrollCoordinates = {};
    if (params.colIndex != null) {
      const columnPositions = gridColumnPositionsSelector(apiRef);
      let cellWidth;
      if (typeof params.rowIndex !== 'undefined') {
        var _visibleSortedRows$pa;
        const rowId = (_visibleSortedRows$pa = visibleSortedRows[params.rowIndex]) == null ? void 0 : _visibleSortedRows$pa.id;
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
        if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) {
          cellWidth = cellColSpanInfo.cellProps.width;
        }
      }
      if (typeof cellWidth === 'undefined') {
        cellWidth = visibleColumns[params.colIndex].computedWidth;
      }
      // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
      scrollCoordinates.left = scrollIntoView({
        clientHeight: virtualScrollerRef.current.clientWidth,
        scrollTop: Math.abs(virtualScrollerRef.current.scrollLeft),
        offsetHeight: cellWidth,
        offsetTop: columnPositions[params.colIndex]
      });
    }
    if (params.rowIndex != null) {
      var _querySelector, _querySelector2;
      const rowsMeta = gridRowsMetaSelector(apiRef.current.state);
      const page = gridPageSelector(apiRef);
      const pageSize = gridPageSizeSelector(apiRef);
      const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
      const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
      const topPinnedRowsHeight = ((_querySelector = virtualScrollerRef.current.querySelector(`.${gridClasses['pinnedRows--top']}`)) == null ? void 0 : _querySelector.clientHeight) || 0;
      const bottomPinnedRowsHeight = ((_querySelector2 = virtualScrollerRef.current.querySelector(`.${gridClasses['pinnedRows--bottom']}`)) == null ? void 0 : _querySelector2.clientHeight) || 0;
      scrollCoordinates.top = scrollIntoView({
        clientHeight: virtualScrollerRef.current.clientHeight - topPinnedRowsHeight - bottomPinnedRowsHeight,
        scrollTop: virtualScrollerRef.current.scrollTop,
        offsetHeight: targetOffsetHeight,
        offsetTop: rowsMeta.positions[elementIndex]
      });
    }
    scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
    if (typeof scrollCoordinates.left !== undefined || typeof scrollCoordinates.top !== undefined) {
      apiRef.current.scroll(scrollCoordinates);
      return true;
    }
    return false;
  }, [logger, apiRef, virtualScrollerRef, props.pagination, visibleSortedRows]);
  const scroll = React$1.useCallback(params => {
    if (virtualScrollerRef.current && params.left != null && colRef.current) {
      const direction = theme.direction === 'rtl' ? -1 : 1;
      colRef.current.scrollLeft = params.left;
      virtualScrollerRef.current.scrollLeft = direction * params.left;
      logger.debug(`Scrolling left: ${params.left}`);
    }
    if (virtualScrollerRef.current && params.top != null) {
      virtualScrollerRef.current.scrollTop = params.top;
      logger.debug(`Scrolling top: ${params.top}`);
    }
    logger.debug(`Scrolling, updating container, and viewport`);
  }, [virtualScrollerRef, theme.direction, colRef, logger]);
  const getScrollPosition = React$1.useCallback(() => {
    if (!(virtualScrollerRef != null && virtualScrollerRef.current)) {
      return {
        top: 0,
        left: 0
      };
    }
    return {
      top: virtualScrollerRef.current.scrollTop,
      left: virtualScrollerRef.current.scrollLeft
    };
  }, [virtualScrollerRef]);
  const scrollApi = {
    scroll,
    scrollToIndexes,
    getScrollPosition
  };
  useGridApiMethod(apiRef, scrollApi, 'public');
};

/**
 * @requires useGridFocus (event) - can be after, async only
 * @requires useGridColumns (event) - can be after, async only
 */
function useGridEvents(apiRef, props) {
  useGridApiOptionHandler(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
  useGridApiOptionHandler(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
  useGridApiOptionHandler(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
  useGridApiOptionHandler(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
  useGridApiOptionHandler(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
  useGridApiOptionHandler(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
  useGridApiOptionHandler(apiRef, 'cellClick', props.onCellClick);
  useGridApiOptionHandler(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
  useGridApiOptionHandler(apiRef, 'cellKeyDown', props.onCellKeyDown);
  useGridApiOptionHandler(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
  useGridApiOptionHandler(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
  useGridApiOptionHandler(apiRef, 'menuOpen', props.onMenuOpen);
  useGridApiOptionHandler(apiRef, 'menuClose', props.onMenuClose);
  useGridApiOptionHandler(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
  useGridApiOptionHandler(apiRef, 'rowClick', props.onRowClick);
  useGridApiOptionHandler(apiRef, 'stateChange', props.onStateChange);
}

const isTestEnvironment = process.env.NODE_ENV === 'test';
const hasScroll = ({
  content,
  container,
  scrollBarSize
}) => {
  const hasScrollXIfNoYScrollBar = content.width > container.width;
  const hasScrollYIfNoXScrollBar = content.height > container.height;
  let hasScrollX = false;
  let hasScrollY = false;
  if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
    hasScrollX = hasScrollXIfNoYScrollBar;
    hasScrollY = content.height + (hasScrollX ? scrollBarSize : 0) > container.height;

    // We recalculate the scroll x to consider the size of the y scrollbar.
    if (hasScrollY) {
      hasScrollX = content.width + scrollBarSize > container.width;
    }
  }
  return {
    hasScrollX,
    hasScrollY
  };
};
function useGridDimensions(apiRef, props) {
  const logger = useGridLogger(apiRef, 'useResizeContainer');
  const errorShown = React$1.useRef(false);
  const rootDimensionsRef = React$1.useRef(null);
  const fullDimensionsRef = React$1.useRef(null);
  const rowsMeta = useGridSelector(apiRef, gridRowsMetaSelector);
  const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
  const rowHeight = Math.floor(props.rowHeight * densityFactor);
  const totalHeaderHeight = getTotalHeaderHeight(apiRef, props.columnHeaderHeight);
  const updateGridDimensionsRef = React$1.useCallback(() => {
    var _apiRef$current$rootE;
    const rootElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null ? void 0 : _apiRef$current$rootE.current;
    const columnsTotalWidth = gridColumnsTotalWidthSelector(apiRef);
    const pinnedRowsHeight = calculatePinnedRowsHeight(apiRef);
    if (!rootDimensionsRef.current) {
      return;
    }
    let scrollBarSize;
    if (props.scrollbarSize != null) {
      scrollBarSize = props.scrollbarSize;
    } else if (!columnsTotalWidth || !rootElement) {
      scrollBarSize = 0;
    } else {
      const doc = ownerDocument(rootElement);
      const scrollDiv = doc.createElement('div');
      scrollDiv.style.width = '99px';
      scrollDiv.style.height = '99px';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.className = 'scrollDiv';
      rootElement.appendChild(scrollDiv);
      scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      rootElement.removeChild(scrollDiv);
    }
    let viewportOuterSize;
    let hasScrollX;
    let hasScrollY;
    if (props.autoHeight) {
      hasScrollY = false;
      hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootDimensionsRef.current.width);
      viewportOuterSize = {
        width: rootDimensionsRef.current.width,
        height: rowsMeta.currentPageTotalHeight + (hasScrollX ? scrollBarSize : 0)
      };
    } else {
      viewportOuterSize = {
        width: rootDimensionsRef.current.width,
        height: Math.max(rootDimensionsRef.current.height - totalHeaderHeight, 0)
      };
      const scrollInformation = hasScroll({
        content: {
          width: Math.round(columnsTotalWidth),
          height: rowsMeta.currentPageTotalHeight
        },
        container: {
          width: Math.round(viewportOuterSize.width),
          height: viewportOuterSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom
        },
        scrollBarSize
      });
      hasScrollY = scrollInformation.hasScrollY;
      hasScrollX = scrollInformation.hasScrollX;
    }
    const viewportInnerSize = {
      width: viewportOuterSize.width - (hasScrollY ? scrollBarSize : 0),
      height: viewportOuterSize.height - (hasScrollX ? scrollBarSize : 0)
    };
    const newFullDimensions = {
      viewportOuterSize,
      viewportInnerSize,
      hasScrollX,
      hasScrollY,
      scrollBarSize
    };
    const prevDimensions = fullDimensionsRef.current;
    fullDimensionsRef.current = newFullDimensions;
    if (newFullDimensions.viewportInnerSize.width !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.width) || newFullDimensions.viewportInnerSize.height !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.height)) {
      apiRef.current.publishEvent('viewportInnerSizeChange', newFullDimensions.viewportInnerSize);
    }
  }, [apiRef, props.scrollbarSize, props.autoHeight, rowsMeta.currentPageTotalHeight, totalHeaderHeight]);
  const [savedSize, setSavedSize] = React$1.useState();
  const debouncedSetSavedSize = React$1.useMemo(() => debounce(setSavedSize, 60), []);
  const previousSize = React$1.useRef();
  useEnhancedEffect(() => {
    if (savedSize) {
      updateGridDimensionsRef();
      apiRef.current.publishEvent('debouncedResize', rootDimensionsRef.current);
    }
  }, [apiRef, savedSize, updateGridDimensionsRef]);

  // This is the function called by apiRef.current.resize()
  const resize = React$1.useCallback(() => {
    apiRef.current.computeSizeAndPublishResizeEvent();
  }, [apiRef]);
  const getRootDimensions = React$1.useCallback(() => fullDimensionsRef.current, []);
  const getViewportPageSize = React$1.useCallback(() => {
    const dimensions = apiRef.current.getRootDimensions();
    if (!dimensions) {
      return 0;
    }
    const currentPage = getVisibleRows(apiRef, {
      pagination: props.pagination,
      paginationMode: props.paginationMode
    });

    // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
    // to find out the maximum number of rows that can fit in the visible part of the grid
    if (props.getRowHeight) {
      const renderContext = apiRef.current.getRenderContext();
      const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
      return Math.min(viewportPageSize - 1, currentPage.rows.length);
    }
    const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / rowHeight);
    return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
  }, [apiRef, props.pagination, props.paginationMode, props.getRowHeight, rowHeight]);
  const computeSizeAndPublishResizeEvent = React$1.useCallback(() => {
    var _apiRef$current$mainE, _previousSize$current, _previousSize$current2;
    const mainEl = (_apiRef$current$mainE = apiRef.current.mainElementRef) == null ? void 0 : _apiRef$current$mainE.current;
    if (!mainEl) {
      return;
    }
    const win = ownerWindow(mainEl);
    const computedStyle = win.getComputedStyle(mainEl);
    const height = parseFloat(computedStyle.height) || 0;
    const width = parseFloat(computedStyle.width) || 0;
    const hasHeightChanged = height !== ((_previousSize$current = previousSize.current) == null ? void 0 : _previousSize$current.height);
    const hasWidthChanged = width !== ((_previousSize$current2 = previousSize.current) == null ? void 0 : _previousSize$current2.width);
    if (!previousSize.current || hasHeightChanged || hasWidthChanged) {
      const size = {
        width,
        height
      };
      apiRef.current.publishEvent('resize', size);
      previousSize.current = size;
    }
  }, [apiRef]);
  const dimensionsApi = {
    resize,
    getRootDimensions
  };
  const dimensionsPrivateApi = {
    getViewportPageSize,
    updateGridDimensionsRef,
    computeSizeAndPublishResizeEvent
  };
  useGridApiMethod(apiRef, dimensionsApi, 'public');
  useGridApiMethod(apiRef, dimensionsPrivateApi, 'private');
  const isFirstSizing = React$1.useRef(true);
  const handleResize = React$1.useCallback(size => {
    rootDimensionsRef.current = size;

    // jsdom has no layout capabilities
    const isJSDOM = /jsdom/.test(window.navigator.userAgent);
    if (size.height === 0 && !errorShown.current && !props.autoHeight && !isJSDOM) {
      logger.error(['The parent DOM element of the data grid has an empty height.', 'Please make sure that this element has an intrinsic height.', 'The grid displays with a height of 0px.', '', 'More details: https://mui.com/r/x-data-grid-no-dimensions.'].join('\n'));
      errorShown.current = true;
    }
    if (size.width === 0 && !errorShown.current && !isJSDOM) {
      logger.error(['The parent DOM element of the data grid has an empty width.', 'Please make sure that this element has an intrinsic width.', 'The grid displays with a width of 0px.', '', 'More details: https://mui.com/r/x-data-grid-no-dimensions.'].join('\n'));
      errorShown.current = true;
    }
    if (isTestEnvironment) {
      // We don't need to debounce the resize for tests.
      setSavedSize(size);
      isFirstSizing.current = false;
      return;
    }
    if (isFirstSizing.current) {
      // We want to initialize the grid dimensions as soon as possible to avoid flickering
      setSavedSize(size);
      isFirstSizing.current = false;
      return;
    }
    debouncedSetSavedSize(size);
  }, [props.autoHeight, debouncedSetSavedSize, logger]);
  useEnhancedEffect(() => updateGridDimensionsRef(), [updateGridDimensionsRef]);
  useGridApiOptionHandler(apiRef, 'sortedRowsSet', updateGridDimensionsRef);
  useGridApiOptionHandler(apiRef, 'paginationModelChange', updateGridDimensionsRef);
  useGridApiOptionHandler(apiRef, 'columnsChange', updateGridDimensionsRef);
  useGridApiEventHandler(apiRef, 'resize', handleResize);
  useGridApiOptionHandler(apiRef, 'debouncedResize', props.onResize);
}

const _excluded$f = ["style"],
  _excluded2 = ["style"];
function binarySearch(offset, positions, sliceStart = 0, sliceEnd = positions.length) {
  if (positions.length <= 0) {
    return -1;
  }
  if (sliceStart >= sliceEnd) {
    return sliceStart;
  }
  const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
  const itemOffset = positions[pivot];
  return offset <= itemOffset ? binarySearch(offset, positions, sliceStart, pivot) : binarySearch(offset, positions, pivot + 1, sliceEnd);
}
function exponentialSearch(offset, positions, index) {
  let interval = 1;
  while (index < positions.length && Math.abs(positions[index]) < offset) {
    index += interval;
    interval *= 2;
  }
  return binarySearch(offset, positions, Math.floor(index / 2), Math.min(index, positions.length));
}
const getRenderableIndexes = ({
  firstIndex,
  lastIndex,
  buffer,
  minFirstIndex,
  maxLastIndex
}) => {
  return [clamp(firstIndex - buffer, minFirstIndex, maxLastIndex), clamp(lastIndex + buffer, minFirstIndex, maxLastIndex)];
};
const areRenderContextsEqual = (context1, context2) => {
  if (context1 === context2) {
    return true;
  }
  return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
};
// The `maxSize` is 3 so that reselect caches the `renderedColumns` values for the pinned left,
// unpinned, and pinned right sections.
const MEMOIZE_OPTIONS = {
  maxSize: 3
};
const useGridVirtualScroller = props => {
  var _currentPage$range3, _currentPage$range4;
  const apiRef = useGridPrivateApiContext();
  const rootProps = useGridRootProps();
  const visibleColumns = useGridSelector(apiRef, gridVisibleColumnDefinitionsSelector);
  const enabled = useGridSelector(apiRef, gridVirtualizationEnabledSelector);
  const enabledForColumns = useGridSelector(apiRef, gridVirtualizationColumnEnabledSelector);
  const {
    ref,
    onRenderZonePositioning,
    renderZoneMinColumnIndex = 0,
    renderZoneMaxColumnIndex = visibleColumns.length,
    getRowProps
  } = props;
  const theme = useTheme$3();
  const columnPositions = useGridSelector(apiRef, gridColumnPositionsSelector);
  const columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
  const cellFocus = useGridSelector(apiRef, gridFocusCellSelector);
  const cellTabIndex = useGridSelector(apiRef, gridTabIndexCellSelector);
  const rowsMeta = useGridSelector(apiRef, gridRowsMetaSelector);
  const selectedRowsLookup = useGridSelector(apiRef, selectedIdsLookupSelector);
  const currentPage = useGridVisibleRows(apiRef, rootProps);
  const renderZoneRef = React$1.useRef(null);
  const rootRef = React$1.useRef(null);
  const handleRef = useForkRef(ref, rootRef);
  const [renderContext, setRenderContextState] = React$1.useState(null);
  const prevRenderContext = React$1.useRef(renderContext);
  const scrollPosition = React$1.useRef({
    top: 0,
    left: 0
  });
  const [containerDimensions, setContainerDimensions] = React$1.useState({
    width: null,
    height: null
  });
  const prevTotalWidth = React$1.useRef(columnsTotalWidth);
  // Each visible row (not to be confused with a filter result) is composed of a central row element
  // and up to two additional row elements for pinned columns (left and right).
  // When hovering any of these elements, the :hover styles are applied only to the row element that
  // was actually hovered, not its additional siblings. To make it look like a contiguous row,
  // we add/remove the .Mui-hovered class to all of the row elements inside one visible row.
  const [hoveredRowId, setHoveredRowId] = React$1.useState(null);
  const rowStyleCache = React$1.useRef(Object.create(null));
  const prevGetRowProps = React$1.useRef();
  const prevRootRowStyle = React$1.useRef();
  const getRenderedColumnsRef = React$1.useRef(defaultMemoize((columns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, indexOfColumnWithFocusedCell) => {
    // If the selected column is not within the current range of columns being displayed,
    // we need to render it at either the left or right of the columns,
    // depending on whether it is above or below the range.
    let focusedCellColumnIndexNotInRange;
    const renderedColumns = columns.slice(firstColumnToRender, lastColumnToRender);
    if (indexOfColumnWithFocusedCell > -1) {
      // check if it is not on the left pinned column.
      if (firstColumnToRender > indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell >= minFirstColumn) {
        focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
      }
      // check if it is not on the right pinned column.
      else if (lastColumnToRender < indexOfColumnWithFocusedCell && indexOfColumnWithFocusedCell < maxLastColumn) {
        focusedCellColumnIndexNotInRange = indexOfColumnWithFocusedCell;
      }
    }
    return {
      focusedCellColumnIndexNotInRange,
      renderedColumns
    };
  }, MEMOIZE_OPTIONS));
  const indexOfColumnWithFocusedCell = React$1.useMemo(() => {
    if (cellFocus !== null) {
      return visibleColumns.findIndex(column => column.field === cellFocus.field);
    }
    return -1;
  }, [cellFocus, visibleColumns]);
  const getNearestIndexToRender = React$1.useCallback(offset => {
    var _currentPage$range, _currentPage$range2;
    const lastMeasuredIndexRelativeToAllRows = apiRef.current.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if ((_currentPage$range = currentPage.range) != null && _currentPage$range.lastRowIndex && !allRowsMeasured) {
      // Check if all rows in this page are already measured
      allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= currentPage.range.lastRowIndex;
    }
    const lastMeasuredIndexRelativeToCurrentPage = clamp(lastMeasuredIndexRelativeToAllRows - (((_currentPage$range2 = currentPage.range) == null ? void 0 : _currentPage$range2.firstRowIndex) || 0), 0, rowsMeta.positions.length);
    if (allRowsMeasured || rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) {
      // If all rows were measured (when no row has "auto" as height) or all rows before the offset
      // were measured, then use a binary search because it's faster.
      return binarySearch(offset, rowsMeta.positions);
    }

    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return exponentialSearch(offset, rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage);
  }, [apiRef, (_currentPage$range3 = currentPage.range) == null ? void 0 : _currentPage$range3.firstRowIndex, (_currentPage$range4 = currentPage.range) == null ? void 0 : _currentPage$range4.lastRowIndex, rowsMeta.positions]);
  const computeRenderContext = React$1.useCallback(() => {
    if (!enabled) {
      return {
        firstRowIndex: 0,
        lastRowIndex: currentPage.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: visibleColumns.length
      };
    }
    const {
      top,
      left
    } = scrollPosition.current;

    // Clamp the value because the search may return an index out of bounds.
    // In the last index, this is not needed because Array.slice doesn't include it.
    const firstRowIndex = Math.min(getNearestIndexToRender(top), rowsMeta.positions.length - 1);
    const lastRowIndex = rootProps.autoHeight ? firstRowIndex + currentPage.rows.length : getNearestIndexToRender(top + containerDimensions.height);
    let firstColumnIndex = 0;
    let lastColumnIndex = columnPositions.length;
    if (enabledForColumns) {
      let hasRowWithAutoHeight = false;
      const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
        firstIndex: firstRowIndex,
        lastIndex: lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: currentPage.rows.length,
        buffer: rootProps.rowBuffer
      });
      for (let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1) {
        const row = currentPage.rows[i];
        hasRowWithAutoHeight = apiRef.current.rowHasAutoHeight(row.id);
      }
      if (!hasRowWithAutoHeight) {
        firstColumnIndex = binarySearch(Math.abs(left), columnPositions);
        lastColumnIndex = binarySearch(Math.abs(left) + containerDimensions.width, columnPositions);
      }
    }
    return {
      firstRowIndex,
      lastRowIndex,
      firstColumnIndex,
      lastColumnIndex
    };
  }, [enabled, enabledForColumns, getNearestIndexToRender, rowsMeta.positions.length, rootProps.autoHeight, rootProps.rowBuffer, currentPage.rows, columnPositions, visibleColumns.length, apiRef, containerDimensions]);
  useEnhancedEffect(() => {
    if (enabled) {
      // TODO a scroll reset should not be necessary
      rootRef.current.scrollLeft = 0;
      rootRef.current.scrollTop = 0;
    } else {
      renderZoneRef.current.style.transform = `translate3d(0px, 0px, 0px)`;
    }
  }, [enabled]);
  useEnhancedEffect(() => {
    setContainerDimensions({
      width: rootRef.current.clientWidth,
      height: rootRef.current.clientHeight
    });
  }, [rowsMeta.currentPageTotalHeight]);
  const handleResize = React$1.useCallback(() => {
    if (rootRef.current) {
      setContainerDimensions({
        width: rootRef.current.clientWidth,
        height: rootRef.current.clientHeight
      });
    }
  }, []);
  useGridApiEventHandler(apiRef, 'debouncedResize', handleResize);
  const updateRenderZonePosition = React$1.useCallback(nextRenderContext => {
    const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstRowIndex,
      lastIndex: nextRenderContext.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: currentPage.rows.length,
      buffer: rootProps.rowBuffer
    });
    const [initialFirstColumnToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstColumnIndex,
      lastIndex: nextRenderContext.lastColumnIndex,
      minFirstIndex: renderZoneMinColumnIndex,
      maxLastIndex: renderZoneMaxColumnIndex,
      buffer: rootProps.columnBuffer
    });
    const firstColumnToRender = getFirstNonSpannedColumnToRender({
      firstColumnToRender: initialFirstColumnToRender,
      apiRef,
      firstRowToRender,
      lastRowToRender,
      visibleRows: currentPage.rows
    });
    const direction = theme.direction === 'ltr' ? 1 : -1;
    const top = gridRowsMetaSelector(apiRef.current.state).positions[firstRowToRender];
    const left = direction * gridColumnPositionsSelector(apiRef)[firstColumnToRender]; // Call directly the selector because it might be outdated when this method is called
    renderZoneRef.current.style.transform = `translate3d(${left}px, ${top}px, 0px)`;
    if (typeof onRenderZonePositioning === 'function') {
      onRenderZonePositioning({
        top,
        left
      });
    }
  }, [apiRef, currentPage.rows, onRenderZonePositioning, renderZoneMinColumnIndex, renderZoneMaxColumnIndex, rootProps.columnBuffer, rootProps.rowBuffer, theme.direction]);
  const getRenderContext = React$1.useCallback(() => prevRenderContext.current, []);
  const setRenderContext = React$1.useCallback(nextRenderContext => {
    if (prevRenderContext.current && areRenderContextsEqual(nextRenderContext, prevRenderContext.current)) {
      updateRenderZonePosition(nextRenderContext);
      return;
    }
    setRenderContextState(nextRenderContext);
    updateRenderZonePosition(nextRenderContext);
    const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstRowIndex,
      lastIndex: nextRenderContext.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: currentPage.rows.length,
      buffer: rootProps.rowBuffer
    });
    apiRef.current.publishEvent('renderedRowsIntervalChange', {
      firstRowToRender,
      lastRowToRender
    });
    prevRenderContext.current = nextRenderContext;
  }, [apiRef, setRenderContextState, prevRenderContext, currentPage.rows.length, rootProps.rowBuffer, updateRenderZonePosition]);
  useEnhancedEffect(() => {
    if (containerDimensions.width == null) {
      return;
    }
    const initialRenderContext = computeRenderContext();
    setRenderContext(initialRenderContext);
    const {
      top,
      left
    } = scrollPosition.current;
    const params = {
      top,
      left,
      renderContext: initialRenderContext
    };
    apiRef.current.publishEvent('scrollPositionChange', params);
  }, [apiRef, computeRenderContext, containerDimensions.width, setRenderContext]);
  const handleScroll = useEventCallback(event => {
    const {
      scrollTop,
      scrollLeft
    } = event.currentTarget;
    scrollPosition.current.top = scrollTop;
    scrollPosition.current.left = scrollLeft;

    // On iOS and macOS, negative offsets are possible when swiping past the start
    if (!prevRenderContext.current || scrollTop < 0) {
      return;
    }
    if (theme.direction === 'ltr') {
      if (scrollLeft < 0) {
        return;
      }
    }
    if (theme.direction === 'rtl') {
      if (scrollLeft > 0) {
        return;
      }
    }

    // When virtualization is disabled, the context never changes during scroll
    const nextRenderContext = enabled ? computeRenderContext() : prevRenderContext.current;
    const topRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstRowIndex - prevRenderContext.current.firstRowIndex);
    const bottomRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastRowIndex - prevRenderContext.current.lastRowIndex);
    const topColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstColumnIndex - prevRenderContext.current.firstColumnIndex);
    const bottomColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastColumnIndex - prevRenderContext.current.lastColumnIndex);
    const shouldSetState = topRowsScrolledSincePreviousRender >= rootProps.rowThreshold || bottomRowsScrolledSincePreviousRender >= rootProps.rowThreshold || topColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || bottomColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || prevTotalWidth.current !== columnsTotalWidth;
    apiRef.current.publishEvent('scrollPositionChange', {
      top: scrollTop,
      left: scrollLeft,
      renderContext: shouldSetState ? nextRenderContext : prevRenderContext.current
    }, event);
    if (shouldSetState) {
      // Prevents batching render context changes
      ReactDOM.flushSync(() => {
        setRenderContext(nextRenderContext);
      });
      prevTotalWidth.current = columnsTotalWidth;
    }
  });
  const handleWheel = useEventCallback(event => {
    apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
  });
  const handleTouchMove = useEventCallback(event => {
    apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
  });
  const indexOfRowWithFocusedCell = React$1.useMemo(() => {
    if (cellFocus !== null) {
      return currentPage.rows.findIndex(row => row.id === cellFocus.id);
    }
    return -1;
  }, [cellFocus, currentPage.rows]);
  useGridApiEventHandler(apiRef, 'rowMouseOver', (params, event) => {
    var _params$id;
    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setHoveredRowId((_params$id = params.id) != null ? _params$id : null);
  });
  useGridApiEventHandler(apiRef, 'rowMouseOut', (params, event) => {
    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setHoveredRowId(null);
  });
  const getRows = (params = {
    renderContext
  }) => {
    var _rootProps$slotProps;
    const {
      onRowRender,
      renderContext: nextRenderContext,
      minFirstColumn = renderZoneMinColumnIndex,
      maxLastColumn = renderZoneMaxColumnIndex,
      availableSpace = containerDimensions.width,
      rowIndexOffset = 0,
      position = 'center'
    } = params;
    if (!nextRenderContext || availableSpace == null) {
      return null;
    }
    const rowBuffer = enabled ? rootProps.rowBuffer : 0;
    const columnBuffer = enabled ? rootProps.columnBuffer : 0;
    const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstRowIndex,
      lastIndex: nextRenderContext.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: currentPage.rows.length,
      buffer: rowBuffer
    });
    const renderedRows = [];
    if (params.rows) {
      params.rows.forEach(row => {
        renderedRows.push(row);
        apiRef.current.calculateColSpan({
          rowId: row.id,
          minFirstColumn,
          maxLastColumn,
          columns: visibleColumns
        });
      });
    } else {
      if (!currentPage.range) {
        return null;
      }
      for (let i = firstRowToRender; i < lastRowToRender; i += 1) {
        const row = currentPage.rows[i];
        renderedRows.push(row);
        apiRef.current.calculateColSpan({
          rowId: row.id,
          minFirstColumn,
          maxLastColumn,
          columns: visibleColumns
        });
      }
    }
    // If the selected row is not within the current range of rows being displayed,
    // we need to render it at either the top or bottom of the rows,
    // depending on whether it is above or below the range.

    let isRowWithFocusedCellNotInRange = false;
    if (indexOfRowWithFocusedCell > -1) {
      const rowWithFocusedCell = currentPage.rows[indexOfRowWithFocusedCell];
      if (firstRowToRender > indexOfRowWithFocusedCell || lastRowToRender < indexOfRowWithFocusedCell) {
        isRowWithFocusedCellNotInRange = true;
        if (indexOfRowWithFocusedCell > firstRowToRender) {
          renderedRows.push(rowWithFocusedCell);
        } else {
          renderedRows.unshift(rowWithFocusedCell);
        }
        apiRef.current.calculateColSpan({
          rowId: rowWithFocusedCell.id,
          minFirstColumn,
          maxLastColumn,
          columns: visibleColumns
        });
      }
    }
    const [initialFirstColumnToRender, lastColumnToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstColumnIndex,
      lastIndex: nextRenderContext.lastColumnIndex,
      minFirstIndex: minFirstColumn,
      maxLastIndex: maxLastColumn,
      buffer: columnBuffer
    });
    const firstColumnToRender = getFirstNonSpannedColumnToRender({
      firstColumnToRender: initialFirstColumnToRender,
      apiRef,
      firstRowToRender,
      lastRowToRender,
      visibleRows: currentPage.rows
    });
    let isColumnWihFocusedCellNotInRange = false;
    if (firstColumnToRender > indexOfColumnWithFocusedCell || lastColumnToRender < indexOfColumnWithFocusedCell) {
      isColumnWihFocusedCellNotInRange = true;
    }
    const {
      focusedCellColumnIndexNotInRange,
      renderedColumns
    } = getRenderedColumnsRef.current(visibleColumns, firstColumnToRender, lastColumnToRender, minFirstColumn, maxLastColumn, isColumnWihFocusedCellNotInRange ? indexOfColumnWithFocusedCell : -1);
    const _ref = ((_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.row) || {},
      {
        style: rootRowStyle
      } = _ref,
      rootRowProps = _objectWithoutPropertiesLoose$b(_ref, _excluded$f);
    const invalidatesCachedRowStyle = prevGetRowProps.current !== getRowProps || prevRootRowStyle.current !== rootRowStyle;
    if (invalidatesCachedRowStyle) {
      rowStyleCache.current = Object.create(null);
    }
    const rows = [];
    for (let i = 0; i < renderedRows.length; i += 1) {
      var _currentPage$range5;
      const {
        id,
        model
      } = renderedRows[i];
      const isRowNotVisible = isRowWithFocusedCellNotInRange && cellFocus.id === id;
      const lastVisibleRowIndex = isRowWithFocusedCellNotInRange ? firstRowToRender + i === currentPage.rows.length : firstRowToRender + i === currentPage.rows.length - 1;
      const baseRowHeight = !apiRef.current.rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : 'auto';
      let isSelected;
      if (selectedRowsLookup[id] == null) {
        isSelected = false;
      } else {
        isSelected = apiRef.current.isRowSelectable(id);
      }
      if (onRowRender) {
        onRowRender(id);
      }
      const focusedCell = cellFocus !== null && cellFocus.id === id ? cellFocus.field : null;
      const columnWithFocusedCellNotInRange = focusedCellColumnIndexNotInRange !== undefined && visibleColumns[focusedCellColumnIndexNotInRange];
      const renderedColumnsWithFocusedCell = columnWithFocusedCellNotInRange && focusedCell ? [columnWithFocusedCellNotInRange, ...renderedColumns] : renderedColumns;
      let tabbableCell = null;
      if (cellTabIndex !== null && cellTabIndex.id === id) {
        const cellParams = apiRef.current.getCellParams(id, cellTabIndex.field);
        tabbableCell = cellParams.cellMode === 'view' ? cellTabIndex.field : null;
      }
      const _ref2 = typeof getRowProps === 'function' && getRowProps(id, model) || {},
        {
          style: rowStyle
        } = _ref2,
        rowProps = _objectWithoutPropertiesLoose$b(_ref2, _excluded2);
      if (!rowStyleCache.current[id]) {
        const style = _extends$c({}, rowStyle, rootRowStyle);
        rowStyleCache.current[id] = style;
      }
      rows.push( /*#__PURE__*/jsx(rootProps.slots.row, _extends$c({
        row: model,
        rowId: id,
        focusedCellColumnIndexNotInRange: focusedCellColumnIndexNotInRange,
        isNotVisible: isRowNotVisible,
        rowHeight: baseRowHeight,
        focusedCell: focusedCell,
        tabbableCell: tabbableCell,
        renderedColumns: renderedColumnsWithFocusedCell,
        visibleColumns: visibleColumns,
        firstColumnToRender: firstColumnToRender,
        lastColumnToRender: lastColumnToRender,
        selected: isSelected,
        index: rowIndexOffset + ((currentPage == null || (_currentPage$range5 = currentPage.range) == null ? void 0 : _currentPage$range5.firstRowIndex) || 0) + firstRowToRender + i,
        containerWidth: availableSpace,
        isLastVisible: lastVisibleRowIndex,
        position: position
      }, rowProps, rootRowProps, {
        hovered: hoveredRowId === id,
        style: rowStyleCache.current[id]
      }), id));
    }
    prevGetRowProps.current = getRowProps;
    prevRootRowStyle.current = rootRowStyle;
    return rows;
  };
  const needsHorizontalScrollbar = containerDimensions.width && columnsTotalWidth >= containerDimensions.width;
  const contentSize = React$1.useMemo(() => {
    // In cases where the columns exceed the available width,
    // the horizontal scrollbar should be shown even when there're no rows.
    // Keeping 1px as minimum height ensures that the scrollbar will visible if necessary.
    const height = Math.max(rowsMeta.currentPageTotalHeight, 1);
    let shouldExtendContent = false;
    if (rootRef != null && rootRef.current && height <= (rootRef == null ? void 0 : rootRef.current.clientHeight)) {
      shouldExtendContent = true;
    }
    const size = {
      width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
      height,
      minHeight: shouldExtendContent ? '100%' : 'auto'
    };
    if (rootProps.autoHeight && currentPage.rows.length === 0) {
      size.height = getMinimalContentHeight(apiRef, rootProps.rowHeight); // Give room to show the overlay when there no rows.
    }

    return size;
  }, [apiRef, rootRef, columnsTotalWidth, rowsMeta.currentPageTotalHeight, needsHorizontalScrollbar, rootProps.autoHeight, rootProps.rowHeight, currentPage.rows.length]);
  React$1.useEffect(() => {
    apiRef.current.publishEvent('virtualScrollerContentSizeChange');
  }, [apiRef, contentSize]);
  const rootStyle = React$1.useMemo(() => {
    const style = {};
    if (!needsHorizontalScrollbar) {
      style.overflowX = 'hidden';
    }
    if (rootProps.autoHeight) {
      style.overflowY = 'hidden';
    }
    return style;
  }, [needsHorizontalScrollbar, rootProps.autoHeight]);
  apiRef.current.register('private', {
    getRenderContext
  });
  return {
    renderContext,
    updateRenderZonePosition,
    getRows,
    getRootProps: (inputProps = {}) => _extends$c({
      ref: handleRef,
      onScroll: handleScroll,
      onWheel: handleWheel,
      onTouchMove: handleTouchMove
    }, inputProps, {
      style: inputProps.style ? _extends$c({}, inputProps.style, rootStyle) : rootStyle,
      role: 'presentation'
    }),
    getContentProps: ({
      style
    } = {}) => ({
      style: style ? _extends$c({}, style, contentSize) : contentSize,
      role: 'presentation'
    }),
    getRenderZoneProps: () => ({
      ref: renderZoneRef,
      role: 'rowgroup'
    })
  };
};

const useUtilityClasses$b = ownerState => {
  const {
    classes,
    headerAlign,
    isDragging,
    showColumnBorder,
    groupId
  } = ownerState;
  const slots = {
    root: ['columnHeader', headerAlign === 'left' && 'columnHeader--alignLeft', headerAlign === 'center' && 'columnHeader--alignCenter', headerAlign === 'right' && 'columnHeader--alignRight', isDragging && 'columnHeader--moving', showColumnBorder && 'columnHeader--showColumnBorder', showColumnBorder && 'columnHeader--withRightBorder', 'withBorderColor', groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup'],
    draggableContainer: ['columnHeaderDraggableContainer'],
    titleContainer: ['columnHeaderTitleContainer', 'withBorderColor'],
    titleContainerContent: ['columnHeaderTitleContainerContent']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
function GridColumnGroupHeader(props) {
  var _columnGroupsLookup$g;
  const {
    groupId,
    width,
    depth,
    maxDepth,
    fields,
    height,
    colIndex,
    hasFocus,
    tabIndex,
    isLastColumn
  } = props;
  const rootProps = useGridRootProps();
  const headerCellRef = React$1.useRef(null);
  const apiRef = useGridApiContext();
  const columnGroupsLookup = useGridSelector(apiRef, gridColumnGroupsLookupSelector);
  const group = groupId ? columnGroupsLookup[groupId] : {};
  const {
    headerName = groupId != null ? groupId : '',
    description = '',
    headerAlign = undefined
  } = group;
  let headerComponent;
  const render = groupId && ((_columnGroupsLookup$g = columnGroupsLookup[groupId]) == null ? void 0 : _columnGroupsLookup$g.renderHeaderGroup);
  const renderParams = React$1.useMemo(() => ({
    groupId,
    headerName,
    description,
    depth,
    maxDepth,
    fields,
    colIndex,
    isLastColumn
  }), [groupId, headerName, description, depth, maxDepth, fields, colIndex, isLastColumn]);
  if (groupId && render) {
    headerComponent = render(renderParams);
  }
  const showColumnBorder = rootProps.showColumnVerticalBorder;
  const ownerState = _extends$c({}, props, {
    classes: rootProps.classes,
    showColumnBorder,
    headerAlign,
    depth,
    isDragging: false
  });
  const label = headerName != null ? headerName : groupId;
  const id = useId();
  const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
  const classes = useUtilityClasses$b(ownerState);
  React$1.useLayoutEffect(() => {
    if (hasFocus) {
      const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
      const elementToFocus = focusableElement || headerCellRef.current;
      elementToFocus == null || elementToFocus.focus();
    }
  }, [apiRef, hasFocus]);
  const publish = React$1.useCallback(eventName => event => {
    // Ignore portal
    // See https://github.com/mui/mui-x/issues/1721
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    apiRef.current.publishEvent(eventName, renderParams, event);
  },
  // For now this is stupid, because renderParams change all the time.
  // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
  [apiRef, renderParams]);
  const mouseEventsHandlers = React$1.useMemo(() => ({
    onKeyDown: publish('columnGroupHeaderKeyDown'),
    onFocus: publish('columnGroupHeaderFocus'),
    onBlur: publish('columnGroupHeaderBlur')
  }), [publish]);
  const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
  return /*#__PURE__*/jsx(GridGenericColumnHeaderItem, _extends$c({
    ref: headerCellRef,
    classes: classes,
    columnMenuOpen: false,
    colIndex: colIndex,
    height: height,
    isResizing: false,
    sortDirection: null,
    hasFocus: false,
    tabIndex: tabIndex,
    isDraggable: false,
    headerComponent: headerComponent,
    headerClassName: headerClassName,
    description: description,
    elementId: elementId,
    width: width,
    columnMenuIconButton: null,
    columnTitleIconButtons: null,
    resizable: false,
    label: label,
    "aria-colspan": fields.length
    // The fields are wrapped between |-...-| to avoid confusion between fields "id" and "id2" when using selector data-fields~=
    ,
    "data-fields": `|-${fields.join('-|-')}-|`
  }, mouseEventsHandlers));
}

const GridColumnHeaderRow = styled$3('div', {
  name: 'MuiDataGrid',
  slot: 'ColumnHeaderRow',
  overridesResolver: (props, styles) => styles.columnHeaderRow
})(() => ({
  display: 'flex'
}));
function isUIEvent(event) {
  return !!event.target;
}
const useGridColumnHeaders = props => {
  const {
    innerRef: innerRefProp,
    minColumnIndex = 0,
    visibleColumns,
    sortColumnLookup,
    filterColumnLookup,
    columnPositions,
    columnHeaderTabIndexState,
    columnGroupHeaderTabIndexState,
    columnHeaderFocus,
    columnGroupHeaderFocus,
    densityFactor,
    headerGroupingMaxDepth,
    columnMenuState,
    columnVisibility,
    columnGroupsHeaderStructure,
    hasOtherElementInTabSequence
  } = props;
  const theme = useTheme$3();
  const [dragCol, setDragCol] = React$1.useState('');
  const [resizeCol, setResizeCol] = React$1.useState('');
  const apiRef = useGridPrivateApiContext();
  const hasVirtualization = useGridSelector(apiRef, gridVirtualizationColumnEnabledSelector);
  const rootProps = useGridRootProps();
  const innerRef = React$1.useRef(null);
  const handleInnerRef = useForkRef(innerRefProp, innerRef);
  const [renderContext, setRenderContextRaw] = React$1.useState(null);
  const prevRenderContext = React$1.useRef(renderContext);
  const prevScrollLeft = React$1.useRef(0);
  const currentPage = useGridVisibleRows(apiRef, rootProps);
  const totalHeaderHeight = getTotalHeaderHeight(apiRef, rootProps.columnHeaderHeight);
  const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
  const setRenderContext = React$1.useCallback(nextRenderContext => {
    if (renderContext && nextRenderContext && areRenderContextsEqual(renderContext, nextRenderContext)) {
      return;
    }
    setRenderContextRaw(nextRenderContext);
  }, [renderContext]);
  React$1.useEffect(() => {
    apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
  }, [apiRef]);

  // memoize `getFirstColumnIndexToRender`, since it's called on scroll
  const getFirstColumnIndexToRenderRef = React$1.useRef(defaultMemoize(getFirstColumnIndexToRender, {
    equalityCheck: (a, b) => ['firstColumnIndex', 'minColumnIndex', 'columnBuffer'].every(key => a[key] === b[key])
  }));
  const updateInnerPosition = React$1.useCallback(nextRenderContext => {
    const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstRowIndex,
      lastIndex: nextRenderContext.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: currentPage.rows.length,
      buffer: rootProps.rowBuffer
    });
    const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
      firstColumnIndex: nextRenderContext.firstColumnIndex,
      minColumnIndex,
      columnBuffer: rootProps.columnBuffer,
      firstRowToRender,
      lastRowToRender,
      apiRef,
      visibleRows: currentPage.rows
    });
    const direction = theme.direction === 'ltr' ? 1 : -1;
    const offset = firstColumnToRender > 0 ? prevScrollLeft.current - direction * columnPositions[firstColumnToRender] : prevScrollLeft.current;
    innerRef.current.style.transform = `translate3d(${-offset}px, 0px, 0px)`;
  }, [columnPositions, minColumnIndex, rootProps.columnBuffer, apiRef, currentPage.rows, rootProps.rowBuffer, theme.direction]);
  React$1.useLayoutEffect(() => {
    if (renderContext) {
      updateInnerPosition(renderContext);
    }
  }, [renderContext, updateInnerPosition]);
  const handleScroll = React$1.useCallback(({
    left,
    renderContext: nextRenderContext = null
  }, event) => {
    var _prevRenderContext$cu, _prevRenderContext$cu2;
    if (!innerRef.current) {
      return;
    }

    // Ignore vertical scroll.
    // Excepts the first event which sets the previous render context.
    if (prevScrollLeft.current === left && ((_prevRenderContext$cu = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu.firstColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.firstColumnIndex) && ((_prevRenderContext$cu2 = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu2.lastColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.lastColumnIndex)) {
      return;
    }
    prevScrollLeft.current = left;

    // We can only update the position when we guarantee that the render context has been
    // rendered. This is achieved using ReactDOM.flushSync or when the context doesn't change.
    let canUpdateInnerPosition = false;
    if (nextRenderContext !== prevRenderContext.current || !prevRenderContext.current) {
      // ReactDOM.flushSync cannot be called on `scroll` events fired inside effects
      if (isUIEvent(event)) {
        // To prevent flickering, the inner position can only be updated after the new context has
        // been rendered. ReactDOM.flushSync ensures that the state changes will happen before
        // updating the position.
        ReactDOM.flushSync(() => {
          setRenderContext(nextRenderContext);
        });
        canUpdateInnerPosition = true;
      } else {
        setRenderContext(nextRenderContext);
      }
      prevRenderContext.current = nextRenderContext;
    } else {
      canUpdateInnerPosition = true;
    }

    // Pass directly the render context to avoid waiting for the next render
    if (nextRenderContext && canUpdateInnerPosition) {
      updateInnerPosition(nextRenderContext);
    }
  }, [updateInnerPosition, setRenderContext]);
  const handleColumnResizeStart = React$1.useCallback(params => setResizeCol(params.field), []);
  const handleColumnResizeStop = React$1.useCallback(() => setResizeCol(''), []);
  const handleColumnReorderStart = React$1.useCallback(params => setDragCol(params.field), []);
  const handleColumnReorderStop = React$1.useCallback(() => setDragCol(''), []);
  useGridApiEventHandler(apiRef, 'columnResizeStart', handleColumnResizeStart);
  useGridApiEventHandler(apiRef, 'columnResizeStop', handleColumnResizeStop);
  useGridApiEventHandler(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
  useGridApiEventHandler(apiRef, 'columnHeaderDragEnd', handleColumnReorderStop);
  useGridApiEventHandler(apiRef, 'scrollPositionChange', handleScroll);

  // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
  const getColumnsToRender = params => {
    const {
      renderContext: nextRenderContext = renderContext,
      minFirstColumn = minColumnIndex,
      maxLastColumn = visibleColumns.length
    } = params || {};
    if (!nextRenderContext) {
      return null;
    }
    const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
      firstIndex: nextRenderContext.firstRowIndex,
      lastIndex: nextRenderContext.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: currentPage.rows.length,
      buffer: rootProps.rowBuffer
    });
    const firstColumnToRender = !hasVirtualization ? 0 : getFirstColumnIndexToRenderRef.current({
      firstColumnIndex: nextRenderContext.firstColumnIndex,
      minColumnIndex: minFirstColumn,
      columnBuffer: rootProps.columnBuffer,
      apiRef,
      firstRowToRender,
      lastRowToRender,
      visibleRows: currentPage.rows
    });
    const lastColumnToRender = !hasVirtualization ? maxLastColumn : Math.min(nextRenderContext.lastColumnIndex + rootProps.columnBuffer, maxLastColumn);
    const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
    return {
      renderedColumns,
      firstColumnToRender,
      lastColumnToRender,
      minFirstColumn,
      maxLastColumn
    };
  };
  const getColumnHeaders = (params, other = {}) => {
    const columnsToRender = getColumnsToRender(params);
    if (columnsToRender == null) {
      return null;
    }
    const {
      renderedColumns,
      firstColumnToRender
    } = columnsToRender;
    const columns = [];
    for (let i = 0; i < renderedColumns.length; i += 1) {
      const colDef = renderedColumns[i];
      const columnIndex = firstColumnToRender + i;
      const isFirstColumn = columnIndex === 0;
      const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
      const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
      const open = columnMenuState.open && columnMenuState.field === colDef.field;
      columns.push( /*#__PURE__*/jsx(GridColumnHeaderItem, _extends$c({}, sortColumnLookup[colDef.field], {
        columnMenuOpen: open,
        filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
        headerHeight: headerHeight,
        isDragging: colDef.field === dragCol,
        colDef: colDef,
        colIndex: columnIndex,
        isResizing: resizeCol === colDef.field,
        hasFocus: hasFocus,
        tabIndex: tabIndex
      }, other), colDef.field));
    }
    return /*#__PURE__*/jsx(GridColumnHeaderRow, {
      role: "row",
      "aria-rowindex": headerGroupingMaxDepth + 1,
      ownerState: rootProps,
      children: columns
    });
  };
  const getColumnGroupHeaders = params => {
    if (headerGroupingMaxDepth === 0) {
      return null;
    }
    const columnsToRender = getColumnsToRender(params);
    if (columnsToRender == null || columnsToRender.renderedColumns.length === 0) {
      return null;
    }
    const {
      firstColumnToRender,
      lastColumnToRender
    } = columnsToRender;
    const columns = [];
    const headerToRender = [];
    for (let depth = 0; depth < headerGroupingMaxDepth; depth += 1) {
      var _apiRef$current$unsta, _apiRef$current$unsta2;
      const rowStructure = columnGroupsHeaderStructure[depth];
      const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
      const firstGroupToRender = (_apiRef$current$unsta = apiRef.current.unstable_getColumnGroupPath(firstColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta : null;
      const firstGroupIndex = rowStructure.findIndex(({
        groupId,
        columnFields
      }) => groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
      const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
      const lastGroupToRender = (_apiRef$current$unsta2 = apiRef.current.unstable_getColumnGroupPath(lastColumnFieldToRender)[depth]) != null ? _apiRef$current$unsta2 : null;
      const lastGroupIndex = rowStructure.findIndex(({
        groupId,
        columnFields
      }) => groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
      const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map(groupStructure => {
        return _extends$c({}, groupStructure, {
          columnFields: groupStructure.columnFields.filter(field => columnVisibility[field] !== false)
        });
      }).filter(groupStructure => groupStructure.columnFields.length > 0);
      const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
      const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
      const leftOverflow = hiddenGroupColumns.reduce((acc, field) => {
        var _column$computedWidth;
        const column = apiRef.current.getColumn(field);
        return acc + ((_column$computedWidth = column.computedWidth) != null ? _column$computedWidth : 0);
      }, 0);
      let columnIndex = firstColumnToRender;
      const elements = visibleColumnGroupHeader.map(({
        groupId,
        columnFields
      }) => {
        const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
        const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
        const headerInfo = {
          groupId,
          width: columnFields.reduce((acc, field) => acc + apiRef.current.getColumn(field).computedWidth, 0),
          fields: columnFields,
          colIndex: columnIndex,
          hasFocus,
          tabIndex
        };
        columnIndex += columnFields.length;
        return headerInfo;
      });
      headerToRender.push({
        leftOverflow,
        elements
      });
    }
    headerToRender.forEach((depthInfo, depthIndex) => {
      columns.push( /*#__PURE__*/jsx(GridColumnHeaderRow, {
        style: {
          height: `${headerHeight}px`,
          transform: `translateX(-${depthInfo.leftOverflow}px)`
        },
        role: "row",
        "aria-rowindex": depthIndex + 1,
        ownerState: rootProps,
        children: depthInfo.elements.map(({
          groupId,
          width,
          fields,
          colIndex,
          hasFocus,
          tabIndex
        }, groupIndex) => {
          return /*#__PURE__*/jsx(GridColumnGroupHeader, {
            groupId: groupId,
            width: width,
            fields: fields,
            colIndex: colIndex,
            depth: depthIndex,
            isLastColumn: colIndex === visibleColumns.length - fields.length,
            maxDepth: headerToRender.length,
            height: headerHeight,
            hasFocus: hasFocus,
            tabIndex: tabIndex
          }, groupIndex);
        })
      }, depthIndex));
    });
    return columns;
  };
  const rootStyle = {
    minHeight: totalHeaderHeight,
    maxHeight: totalHeaderHeight,
    lineHeight: `${headerHeight}px`
  };
  return {
    renderContext,
    getColumnHeaders,
    getColumnsToRender,
    getColumnGroupHeaders,
    isDragging: !!dragCol,
    getRootProps: (other = {}) => _extends$c({
      style: rootStyle
    }, other),
    getInnerProps: () => ({
      ref: handleInnerRef,
      role: 'rowgroup'
    }),
    headerHeight
  };
};

const _excluded$e = ["className"];
const useUtilityClasses$a = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['columnHeaders', 'withBorderColor']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeadersRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'ColumnHeaders',
  overridesResolver: (props, styles) => styles.columnHeaders
})({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderBottom: '1px solid',
  borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
  borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const GridBaseColumnHeaders = /*#__PURE__*/React$1.forwardRef(function GridColumnHeaders(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$e);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$a(rootProps);
  return /*#__PURE__*/jsx(GridColumnHeadersRoot, _extends$c({
    ref: ref,
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other, {
    role: "presentation"
  }));
});

const _excluded$d = ["isDragging", "className"];
const useUtilityClasses$9 = ownerState => {
  const {
    isDragging,
    hasScrollX,
    classes
  } = ownerState;
  const slots = {
    root: ['columnHeadersInner', isDragging && 'columnHeaderDropZone', hasScrollX && 'columnHeadersInner--scrollable']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeadersInnerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'columnHeadersInner',
  overridesResolver: (props, styles) => [{
    [`&.${gridClasses.columnHeaderDropZone}`]: styles.columnHeaderDropZone
  }, styles.columnHeadersInner]
})(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  [`&.${gridClasses.columnHeaderDropZone} .${gridClasses.columnHeaderDraggableContainer}`]: {
    cursor: 'move'
  },
  [`&.${gridClasses['columnHeadersInner--scrollable']} .${gridClasses.columnHeader}:last-child`]: {
    borderRight: 'none'
  }
}));
const GridColumnHeadersInner = /*#__PURE__*/React$1.forwardRef(function GridColumnHeadersInner(props, ref) {
  var _apiRef$current$getRo, _apiRef$current$getRo2;
  const {
      isDragging,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$d);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = _extends$c({}, rootProps, {
    isDragging,
    hasScrollX: (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.hasScrollX) != null ? _apiRef$current$getRo : false
  });
  const classes = useUtilityClasses$9(ownerState);
  return /*#__PURE__*/jsx(GridColumnHeadersInnerRoot, _extends$c({
    ref: ref,
    className: clsx(className, classes.root),
    ownerState: ownerState
  }, other));
});

const _excluded$c = ["innerRef", "className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnPositions", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "densityFactor", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"];
const GridColumnHeaders = /*#__PURE__*/React$1.forwardRef(function GridColumnsHeaders(props, ref) {
  const {
      innerRef,
      visibleColumns,
      sortColumnLookup,
      filterColumnLookup,
      columnPositions,
      columnHeaderTabIndexState,
      columnGroupHeaderTabIndexState,
      columnHeaderFocus,
      columnGroupHeaderFocus,
      densityFactor,
      headerGroupingMaxDepth,
      columnMenuState,
      columnVisibility,
      columnGroupsHeaderStructure,
      hasOtherElementInTabSequence
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$c);
  const {
    isDragging,
    getRootProps,
    getInnerProps,
    getColumnHeaders,
    getColumnGroupHeaders
  } = useGridColumnHeaders({
    innerRef,
    visibleColumns,
    sortColumnLookup,
    filterColumnLookup,
    columnPositions,
    columnHeaderTabIndexState,
    columnGroupHeaderTabIndexState,
    columnHeaderFocus,
    columnGroupHeaderFocus,
    densityFactor,
    headerGroupingMaxDepth,
    columnMenuState,
    columnVisibility,
    columnGroupsHeaderStructure,
    hasOtherElementInTabSequence
  });
  return /*#__PURE__*/jsx(GridBaseColumnHeaders, _extends$c({
    ref: ref
  }, getRootProps(other), {
    children: /*#__PURE__*/jsxs(GridColumnHeadersInner, _extends$c({
      isDragging: isDragging
    }, getInnerProps(), {
      children: [getColumnGroupHeaders(), getColumnHeaders()]
    }))
  }));
});
process.env.NODE_ENV !== "production" ? GridColumnHeaders.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: PropTypes.shape({
    depth: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired
  }),
  columnGroupHeaderTabIndexState: PropTypes.shape({
    depth: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired
  }),
  columnGroupsHeaderStructure: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    columnFields: PropTypes.arrayOf(PropTypes.string).isRequired,
    groupId: PropTypes.string
  }))).isRequired,
  columnHeaderFocus: PropTypes.shape({
    field: PropTypes.string.isRequired
  }),
  columnHeaderTabIndexState: PropTypes.shape({
    field: PropTypes.string.isRequired
  }),
  columnMenuState: PropTypes.shape({
    field: PropTypes.string,
    open: PropTypes.bool.isRequired
  }).isRequired,
  columnPositions: PropTypes.arrayOf(PropTypes.number).isRequired,
  columnVisibility: PropTypes.object.isRequired,
  densityFactor: PropTypes.number.isRequired,
  filterColumnLookup: PropTypes.object.isRequired,
  hasOtherElementInTabSequence: PropTypes.bool.isRequired,
  headerGroupingMaxDepth: PropTypes.number.isRequired,
  innerRef: refType$1,
  minColumnIndex: PropTypes.number,
  sortColumnLookup: PropTypes.object.isRequired,
  visibleColumns: PropTypes.arrayOf(PropTypes.object).isRequired
} : void 0;
const MemoizedGridColumnHeaders = fastMemo(GridColumnHeaders);

const GridNoResultsOverlay = /*#__PURE__*/React$1.forwardRef(function GridNoResultsOverlay(props, ref) {
  const apiRef = useGridApiContext();
  const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
  return /*#__PURE__*/jsx(GridOverlay, _extends$c({
    ref: ref
  }, props, {
    children: noResultsOverlayLabel
  }));
});

const _excluded$b = ["sortingOrder"];
const GridColumnUnsortedIcon = /*#__PURE__*/React$1.memo(function GridColumnHeaderSortIcon(props) {
  const {
      sortingOrder
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$b);
  const rootProps = useGridRootProps();
  const [nextSortDirection] = sortingOrder;
  const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
  return Icon ? /*#__PURE__*/jsx(Icon, _extends$c({}, other)) : null;
});

const _excluded$a = ["native"];
function MUISelectOption(_ref) {
  let {
      native
    } = _ref,
    props = _objectWithoutPropertiesLoose$b(_ref, _excluded$a);
  if (native) {
    return /*#__PURE__*/jsx("option", _extends$c({}, props));
  }
  return /*#__PURE__*/jsx(MenuItem, _extends$c({}, props));
}

const iconSlots = {
  BooleanCellTrueIcon: GridCheckIcon,
  BooleanCellFalseIcon: GridCloseIcon,
  ColumnMenuIcon: GridTripleDotsVerticalIcon,
  OpenFilterButtonIcon: GridFilterListIcon,
  FilterPanelDeleteIcon: GridCloseIcon,
  ColumnFilteredIcon: GridFilterAltIcon,
  ColumnSelectorIcon: GridColumnIcon,
  ColumnUnsortedIcon: GridColumnUnsortedIcon,
  ColumnSortedAscendingIcon: GridArrowUpwardIcon,
  ColumnSortedDescendingIcon: GridArrowDownwardIcon,
  ColumnResizeIcon: GridSeparatorIcon,
  DensityCompactIcon: GridViewHeadlineIcon,
  DensityStandardIcon: GridTableRowsIcon,
  DensityComfortableIcon: GridViewStreamIcon,
  ExportIcon: GridSaveAltIcon,
  MoreActionsIcon: GridMoreVertIcon,
  TreeDataCollapseIcon: GridExpandMoreIcon,
  TreeDataExpandIcon: GridKeyboardArrowRight,
  GroupingCriteriaCollapseIcon: GridExpandMoreIcon,
  GroupingCriteriaExpandIcon: GridKeyboardArrowRight,
  DetailPanelExpandIcon: GridAddIcon,
  DetailPanelCollapseIcon: GridRemoveIcon,
  RowReorderIcon: GridDragIcon,
  QuickFilterIcon: GridSearchIcon,
  QuickFilterClearIcon: GridCloseIcon,
  ColumnMenuHideIcon: GridVisibilityOffIcon,
  ColumnMenuSortAscendingIcon: GridArrowUpwardIcon,
  ColumnMenuSortDescendingIcon: GridArrowDownwardIcon,
  ColumnMenuFilterIcon: GridFilterAltIcon,
  ColumnMenuManageColumnsIcon: GridViewColumnIcon,
  ColumnMenuClearIcon: GridClearIcon,
  LoadIcon: GridLoadIcon,
  FilterPanelAddIcon: GridAddIcon,
  FilterPanelRemoveAllIcon: GridDeleteForeverIcon,
  ColumnReorderIcon: GridDragIcon
};
const materialSlots = _extends$c({}, iconSlots, {
  BaseCheckbox: MUICheckbox,
  BaseTextField: MuiTextField,
  BaseFormControl: m,
  BaseSelect: p,
  BaseSwitch: Switch,
  BaseButton: Button$1,
  BaseIconButton: IconButton$1,
  BaseInputAdornment: MuiInputAdornment,
  BaseTooltip: Tooltip$1,
  BasePopper: Popper,
  BaseInputLabel: MUIInputLabel,
  BaseSelectOption: MUISelectOption,
  BaseChip: Chip
});

// TODO: camelCase these key. It's a private helper now.
// Remove then need to call `uncapitalizeObjectKeys`.
const DATA_GRID_DEFAULT_SLOTS_COMPONENTS = _extends$c({}, materialSlots, {
  Cell: MemoizedGridCellV7,
  SkeletonCell: GridSkeletonCell,
  ColumnHeaderFilterIconButton: GridColumnHeaderFilterIconButton,
  ColumnMenu: GridColumnMenu,
  ColumnHeaders: MemoizedGridColumnHeaders,
  Footer: GridFooter,
  FooterRowCount: GridRowCount,
  Toolbar: null,
  PreferencesPanel: GridPreferencesPanel,
  LoadingOverlay: GridLoadingOverlay,
  NoResultsOverlay: GridNoResultsOverlay,
  NoRowsOverlay: GridNoRowsOverlay,
  Pagination: GridPagination,
  FilterPanel: GridFilterPanel,
  ColumnsPanel: GridColumnsPanel,
  Panel: GridPanel,
  Row: MemoizedGridRow
});

// TODO v7: This file exist only to simplify typing between
// components/componentsProps and slots/slotProps
// Should be deleted when components/componentsProps are removed

const uncapitalizeObjectKeys = capitalizedObject => {
  if (capitalizedObject === undefined) {
    return undefined;
  }
  return Object.keys(capitalizedObject).reduce((acc, key) => _extends$c({}, acc, {
    [`${key.charAt(0).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
  }), {});
};

// TODO v7: Remove `components` and usages of `UncapitalizeObjectKeys` type
// after converting keys in Grid(Pro|Premium)SlotsComponent to camelCase.
// https://github.com/mui/mui-x/issues/7940
function computeSlots({
  defaultSlots,
  slots,
  components
}) {
  const overrides = slots != null ? slots : components ? uncapitalizeObjectKeys(components) : null;
  if (!overrides || Object.keys(overrides).length === 0) {
    return defaultSlots;
  }
  return _extends$c({}, defaultSlots, overrides);
}

const _excluded$9 = ["components", "componentsProps"];
/** Gathers props for the root element into a single `.forwardedProps` field */
function groupForwardedProps(props) {
  var _props$forwardedProps;
  const keys = Object.keys(props);
  if (!keys.some(key => key.startsWith('aria-') || key.startsWith('data-'))) {
    return props;
  }
  const newProps = {};
  const forwardedProps = (_props$forwardedProps = props.forwardedProps) != null ? _props$forwardedProps : {};
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (key.startsWith('aria-') || key.startsWith('data-')) {
      forwardedProps[key] = props[key];
    } else {
      newProps[key] = props[key];
    }
  }
  newProps.forwardedProps = forwardedProps;
  return newProps;
}
function useProps(allProps) {
  return React$1.useMemo(() => {
    const {
        components,
        componentsProps
      } = allProps,
      themedProps = _objectWithoutPropertiesLoose$b(allProps, _excluded$9);
    return [components, componentsProps, groupForwardedProps(themedProps)];
  }, [allProps]);
}

const DATA_GRID_FORCED_PROPS = {
  disableMultipleColumnsFiltering: true,
  disableMultipleColumnsSorting: true,
  disableMultipleRowSelection: true,
  throttleRowsMs: undefined,
  hideFooterRowCount: false,
  pagination: true,
  checkboxSelectionVisibleOnly: false,
  disableColumnReorder: true,
  disableColumnResize: true,
  keepColumnPositionIfDraggedOutside: false,
  signature: 'DataGrid'
};

/**
 * The default values of `DataGridPropsWithDefaultValues` to inject in the props of DataGrid.
 */
const DATA_GRID_PROPS_DEFAULT_VALUES = {
  autoHeight: false,
  autoPageSize: false,
  checkboxSelection: false,
  checkboxSelectionVisibleOnly: false,
  columnBuffer: 3,
  rowBuffer: 3,
  columnThreshold: 3,
  rowThreshold: 3,
  rowSelection: true,
  density: 'standard',
  disableColumnFilter: false,
  disableColumnMenu: false,
  disableColumnSelector: false,
  disableDensitySelector: false,
  disableEval: false,
  disableMultipleColumnsFiltering: false,
  disableMultipleRowSelection: false,
  disableMultipleColumnsSorting: false,
  disableRowSelectionOnClick: false,
  disableVirtualization: false,
  editMode: GridEditModes.Cell,
  filterMode: 'client',
  filterDebounceMs: 150,
  columnHeaderHeight: 56,
  hideFooter: false,
  hideFooterPagination: false,
  hideFooterRowCount: false,
  hideFooterSelectedRowCount: false,
  logger: console,
  logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'warn',
  pagination: false,
  paginationMode: 'client',
  rowHeight: 52,
  pageSizeOptions: [25, 50, 100],
  rowSpacingType: 'margin',
  showCellVerticalBorder: false,
  showColumnVerticalBorder: false,
  sortingOrder: ['asc', 'desc', null],
  sortingMode: 'client',
  throttleRowsMs: 0,
  disableColumnReorder: false,
  disableColumnResize: false,
  keepNonExistentRowsSelected: false,
  keepColumnPositionIfDraggedOutside: false,
  unstable_ignoreValueFormatterDuringExport: false,
  clipboardCopyCellDelimiter: '\t'
};
const defaultSlots = uncapitalizeObjectKeys(DATA_GRID_DEFAULT_SLOTS_COMPONENTS);
const useDataGridProps = inProps => {
  const [components, componentsProps, themedProps] = useProps(useThemeProps({
    props: inProps,
    name: 'MuiDataGrid'
  }));
  const localeText = React$1.useMemo(() => _extends$c({}, GRID_DEFAULT_LOCALE_TEXT, themedProps.localeText), [themedProps.localeText]);
  const slots = React$1.useMemo(() => computeSlots({
    defaultSlots,
    slots: themedProps.slots,
    components
  }), [components, themedProps.slots]);
  return React$1.useMemo(() => {
    var _themedProps$slotProp;
    return _extends$c({}, DATA_GRID_PROPS_DEFAULT_VALUES, themedProps, {
      localeText,
      slots,
      slotProps: (_themedProps$slotProp = themedProps.slotProps) != null ? _themedProps$slotProp : componentsProps
    }, DATA_GRID_FORCED_PROPS);
  }, [themedProps, localeText, slots, componentsProps]);
};

const rowsMetaStateInitializer = state => _extends$c({}, state, {
  rowsMeta: {
    currentPageTotalHeight: 0,
    positions: []
  }
});
let warnedOnceInvalidRowHeight = false;
const getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage) => {
  if (typeof rowHeightProp === 'number' && rowHeightProp > 0) {
    return rowHeightProp;
  }
  if (process.env.NODE_ENV !== 'production' && !warnedOnceInvalidRowHeight && typeof rowHeightProp !== 'undefined' && rowHeightProp !== null) {
    console.warn(warningMessage);
    warnedOnceInvalidRowHeight = true;
  }
  return defaultRowHeight;
};
const rowHeightWarning = [`MUI: The \`rowHeight\` prop should be a number greater than 0.`, `The default value will be used instead.`].join('\n');
const getRowHeightWarning = [`MUI: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`, `The default value will be used instead.`].join('\n');

/**
 * @requires useGridPageSize (method)
 * @requires useGridPage (method)
 */
const useGridRowsMeta = (apiRef, props) => {
  const {
    getRowHeight: getRowHeightProp,
    getRowSpacing,
    getEstimatedRowHeight
  } = props;
  const rowsHeightLookup = React$1.useRef(Object.create(null));

  // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
  const lastMeasuredRowIndex = React$1.useRef(-1);
  const hasRowWithAutoHeight = React$1.useRef(false);
  const densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const paginationState = useGridSelector(apiRef, gridPaginationSelector);
  const sortModel = useGridSelector(apiRef, gridSortModelSelector);
  const currentPage = useGridVisibleRows(apiRef, props);
  const pinnedRows = useGridSelector(apiRef, gridPinnedRowsSelector);
  const validRowHeight = getValidRowHeight(props.rowHeight, DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, rowHeightWarning);
  const rowHeight = Math.floor(validRowHeight * densityFactor);
  const hydrateRowsMeta = React$1.useCallback(() => {
    var _pinnedRows$top, _pinnedRows$bottom;
    hasRowWithAutoHeight.current = false;
    const calculateRowProcessedSizes = row => {
      if (!rowsHeightLookup.current[row.id]) {
        rowsHeightLookup.current[row.id] = {
          sizes: {
            baseCenter: rowHeight
          },
          isResized: false,
          autoHeight: false,
          needsFirstMeasurement: true // Assume all rows will need to be measured by default
        };
      }

      const {
        isResized,
        needsFirstMeasurement,
        sizes
      } = rowsHeightLookup.current[row.id];
      let baseRowHeight = typeof rowHeight === 'number' && rowHeight > 0 ? rowHeight : 52;
      const existingBaseRowHeight = sizes.baseCenter;
      if (isResized) {
        // Do not recalculate resized row height and use the value from the lookup
        baseRowHeight = existingBaseRowHeight;
      } else if (getRowHeightProp) {
        const rowHeightFromUser = getRowHeightProp(_extends$c({}, row, {
          densityFactor
        }));
        if (rowHeightFromUser === 'auto') {
          if (needsFirstMeasurement) {
            const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight(_extends$c({}, row, {
              densityFactor
            })) : rowHeight;

            // If the row was not measured yet use the estimated row height
            baseRowHeight = estimatedRowHeight != null ? estimatedRowHeight : rowHeight;
          } else {
            baseRowHeight = existingBaseRowHeight;
          }
          hasRowWithAutoHeight.current = true;
          rowsHeightLookup.current[row.id].autoHeight = true;
        } else {
          // Default back to base rowHeight if getRowHeight returns invalid value.
          baseRowHeight = getValidRowHeight(rowHeightFromUser, rowHeight, getRowHeightWarning);
          rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
          rowsHeightLookup.current[row.id].autoHeight = false;
        }
      } else {
        rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
      }
      const initialHeights = {};
      /* eslint-disable-next-line no-restricted-syntax */
      for (const key in sizes) {
        if (/^base[A-Z]/.test(key)) {
          initialHeights[key] = sizes[key];
        }
      }
      initialHeights.baseCenter = baseRowHeight;
      if (getRowSpacing) {
        var _spacing$top, _spacing$bottom;
        const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
        const spacing = getRowSpacing(_extends$c({}, row, {
          isFirstVisible: indexRelativeToCurrentPage === 0,
          isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
          indexRelativeToCurrentPage
        }));
        initialHeights.spacingTop = (_spacing$top = spacing.top) != null ? _spacing$top : 0;
        initialHeights.spacingBottom = (_spacing$bottom = spacing.bottom) != null ? _spacing$bottom : 0;
      }
      const processedSizes = apiRef.current.unstable_applyPipeProcessors('rowHeight', initialHeights, row);
      rowsHeightLookup.current[row.id].sizes = processedSizes;
      return processedSizes;
    };
    const positions = [];
    const currentPageTotalHeight = currentPage.rows.reduce((acc, row) => {
      positions.push(acc);
      let maximumBaseSize = 0;
      let otherSizes = 0;
      const processedSizes = calculateRowProcessedSizes(row);
      /* eslint-disable-next-line no-restricted-syntax, guard-for-in */
      for (const key in processedSizes) {
        const value = processedSizes[key];
        if (/^base[A-Z]/.test(key)) {
          maximumBaseSize = value > maximumBaseSize ? value : maximumBaseSize;
        } else {
          otherSizes += value;
        }
      }
      return acc + maximumBaseSize + otherSizes;
    }, 0);
    pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null || _pinnedRows$top.forEach(row => {
      calculateRowProcessedSizes(row);
    });
    pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null || _pinnedRows$bottom.forEach(row => {
      calculateRowProcessedSizes(row);
    });
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        rowsMeta: {
          currentPageTotalHeight,
          positions
        }
      });
    });
    if (!hasRowWithAutoHeight.current) {
      // No row has height=auto, so all rows are already measured
      lastMeasuredRowIndex.current = Infinity;
    }
    apiRef.current.forceUpdate();
  }, [apiRef, currentPage.rows, rowHeight, getRowHeightProp, getRowSpacing, getEstimatedRowHeight, pinnedRows, densityFactor]);
  const getRowHeight = React$1.useCallback(rowId => {
    const height = rowsHeightLookup.current[rowId];
    return height ? height.sizes.baseCenter : rowHeight;
  }, [rowHeight]);
  const getRowInternalSizes = rowId => {
    var _rowsHeightLookup$cur;
    return (_rowsHeightLookup$cur = rowsHeightLookup.current[rowId]) == null ? void 0 : _rowsHeightLookup$cur.sizes;
  };
  const setRowHeight = React$1.useCallback((id, height) => {
    rowsHeightLookup.current[id].sizes.baseCenter = height;
    rowsHeightLookup.current[id].isResized = true;
    rowsHeightLookup.current[id].needsFirstMeasurement = false;
    hydrateRowsMeta();
  }, [hydrateRowsMeta]);
  const debouncedHydrateRowsMeta = React$1.useMemo(() => debounce(hydrateRowsMeta), [hydrateRowsMeta]);
  const storeMeasuredRowHeight = React$1.useCallback((id, height, position) => {
    if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) {
      return;
    }

    // Only trigger hydration if the value is different, otherwise we trigger a loop
    const needsHydration = rowsHeightLookup.current[id].sizes[`base${capitalize(position)}`] !== height;
    rowsHeightLookup.current[id].needsFirstMeasurement = false;
    rowsHeightLookup.current[id].sizes[`base${capitalize(position)}`] = height;
    if (needsHydration) {
      debouncedHydrateRowsMeta();
    }
  }, [debouncedHydrateRowsMeta]);
  const rowHasAutoHeight = React$1.useCallback(id => {
    var _rowsHeightLookup$cur2;
    return ((_rowsHeightLookup$cur2 = rowsHeightLookup.current[id]) == null ? void 0 : _rowsHeightLookup$cur2.autoHeight) || false;
  }, []);
  const getLastMeasuredRowIndex = React$1.useCallback(() => {
    return lastMeasuredRowIndex.current;
  }, []);
  const setLastMeasuredRowIndex = React$1.useCallback(index => {
    if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) {
      lastMeasuredRowIndex.current = index;
    }
  }, []);
  const resetRowHeights = React$1.useCallback(() => {
    rowsHeightLookup.current = {};
    hydrateRowsMeta();
  }, [hydrateRowsMeta]);

  // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
  // Because of variable row height this is needed for the virtualization
  React$1.useEffect(() => {
    hydrateRowsMeta();
  }, [rowHeight, filterModel, paginationState, sortModel, hydrateRowsMeta]);
  useGridRegisterPipeApplier(apiRef, 'rowHeight', hydrateRowsMeta);
  const rowsMetaApi = {
    unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
    unstable_getRowHeight: getRowHeight,
    unstable_getRowInternalSizes: getRowInternalSizes,
    unstable_setRowHeight: setRowHeight,
    unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
    resetRowHeights
  };
  const rowsMetaPrivateApi = {
    getLastMeasuredRowIndex,
    rowHasAutoHeight
  };
  useGridApiMethod(apiRef, rowsMetaApi, 'public');
  useGridApiMethod(apiRef, rowsMetaPrivateApi, 'private');
};

const useGridStatePersistence = apiRef => {
  const exportState = React$1.useCallback((params = {}) => {
    const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
    return stateToExport;
  }, [apiRef]);
  const restoreState = React$1.useCallback(stateToRestore => {
    const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
      callbacks: []
    }, {
      stateToRestore
    });
    response.callbacks.forEach(callback => {
      callback();
    });
    apiRef.current.forceUpdate();
  }, [apiRef]);
  const statePersistenceApi = {
    exportState,
    restoreState
  };
  useGridApiMethod(apiRef, statePersistenceApi, 'public');
};

/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */
const useGridColumnSpanning = apiRef => {
  const lookup = React$1.useRef({});
  const setCellColSpanInfo = React$1.useCallback((rowId, columnIndex, cellColSpanInfo) => {
    const sizes = lookup.current;
    if (!sizes[rowId]) {
      sizes[rowId] = {};
    }
    sizes[rowId][columnIndex] = cellColSpanInfo;
  }, []);
  const getCellColSpanInfo = React$1.useCallback((rowId, columnIndex) => {
    var _lookup$current$rowId;
    return (_lookup$current$rowId = lookup.current[rowId]) == null ? void 0 : _lookup$current$rowId[columnIndex];
  }, []);

  // Calculate `colSpan` for the cell.
  const calculateCellColSpan = React$1.useCallback(params => {
    const {
      columnIndex,
      rowId,
      minFirstColumnIndex,
      maxLastColumnIndex,
      columns
    } = params;
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const colSpan = typeof column.colSpan === 'function' ? column.colSpan(apiRef.current.getCellParams(rowId, column.field)) : column.colSpan;
    if (!colSpan || colSpan === 1) {
      setCellColSpanInfo(rowId, columnIndex, {
        spannedByColSpan: false,
        cellProps: {
          colSpan: 1,
          width: column.computedWidth
        }
      });
      return {
        colSpan: 1
      };
    }
    let width = column.computedWidth;
    for (let j = 1; j < colSpan; j += 1) {
      const nextColumnIndex = columnIndex + j;
      // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
      if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
        const nextColumn = columns[nextColumnIndex];
        width += nextColumn.computedWidth;
        setCellColSpanInfo(rowId, columnIndex + j, {
          spannedByColSpan: true,
          rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
          leftVisibleCellIndex: columnIndex
        });
      }
      setCellColSpanInfo(rowId, columnIndex, {
        spannedByColSpan: false,
        cellProps: {
          colSpan,
          width
        }
      });
    }
    return {
      colSpan
    };
  }, [apiRef, setCellColSpanInfo]);

  // Calculate `colSpan` for each cell in the row
  const calculateColSpan = React$1.useCallback(({
    rowId,
    minFirstColumn,
    maxLastColumn,
    columns
  }) => {
    for (let i = minFirstColumn; i < maxLastColumn; i += 1) {
      const cellProps = calculateCellColSpan({
        columnIndex: i,
        rowId,
        minFirstColumnIndex: minFirstColumn,
        maxLastColumnIndex: maxLastColumn,
        columns
      });
      if (cellProps.colSpan > 1) {
        i += cellProps.colSpan - 1;
      }
    }
  }, [calculateCellColSpan]);
  const columnSpanningPublicApi = {
    unstable_getCellColSpanInfo: getCellColSpanInfo
  };
  const columnSpanningPrivateApi = {
    calculateColSpan
  };
  useGridApiMethod(apiRef, columnSpanningPublicApi, 'public');
  useGridApiMethod(apiRef, columnSpanningPrivateApi, 'private');
  const handleColumnReorderChange = React$1.useCallback(() => {
    // `colSpan` needs to be recalculated after column reordering
    lookup.current = {};
  }, []);
  useGridApiEventHandler(apiRef, 'columnOrderChange', handleColumnReorderChange);
};

// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete) => {
  if (isLeaf(columnGroupNode)) {
    if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) {
      throw new Error([`MUI: columnGroupingModel contains duplicated field`, `column field ${columnGroupNode.field} occurs two times in the grouping model:`, `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`, `- ${parents.join(' > ')}`].join('\n'));
    }
    unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
    return;
  }
  const {
    groupId,
    children
  } = columnGroupNode;
  children.forEach(child => {
    recurrentUnwrapGroupingColumnModel(child, [...parents, groupId], unwrappedGroupingModelToComplete);
  });
};

/**
 * This is a function that provide for each column the array of its parents.
 * Parents are ordered from the root to the leaf.
 * @param columnGroupingModel The model such as provided in DataGrid props
 * @returns An object `{[field]: groupIds}` where `groupIds` is the parents of the column `field`
 */
const unwrapGroupingColumnModel = columnGroupingModel => {
  if (!columnGroupingModel) {
    return {};
  }
  const unwrappedSubTree = {};
  columnGroupingModel.forEach(columnGroupNode => {
    recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
  });
  return unwrappedSubTree;
};
const getColumnGroupsHeaderStructure = (orderedColumns, unwrappedGroupingModel, pinnedFields) => {
  const getParents = field => {
    var _unwrappedGroupingMod;
    return (_unwrappedGroupingMod = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod : [];
  };
  const groupingHeaderStructure = [];
  const maxDepth = Math.max(...orderedColumns.map(field => getParents(field).length));
  const haveSameParents = (field1, field2, depth) => isDeepEqual(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
  const haveDifferentContainers = (field1, field2) => {
    if (pinnedFields != null && pinnedFields.left && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) {
      return true;
    }
    if (pinnedFields != null && pinnedFields.right && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) {
      return true;
    }
    return false;
  };
  for (let depth = 0; depth < maxDepth; depth += 1) {
    const depthStructure = orderedColumns.reduce((structure, newField) => {
      var _getParents$depth;
      const groupId = (_getParents$depth = getParents(newField)[depth]) != null ? _getParents$depth : null;
      if (structure.length === 0) {
        return [{
          columnFields: [newField],
          groupId
        }];
      }
      const lastGroup = structure[structure.length - 1];
      const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
      const prevGroupId = lastGroup.groupId;
      if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) ||
      // Fix for https://github.com/mui/mui-x/issues/7041
      haveDifferentContainers(prevField, newField)) {
        // It's a new group
        return [...structure, {
          columnFields: [newField],
          groupId
        }];
      }

      // It extends the previous group
      return [...structure.slice(0, structure.length - 1), {
        columnFields: [...lastGroup.columnFields, newField],
        groupId
      }];
    }, []);
    groupingHeaderStructure.push(depthStructure);
  }
  return groupingHeaderStructure;
};

const _excluded$8 = ["groupId", "children"];
const createGroupLookup = columnGroupingModel => {
  let groupLookup = {};
  columnGroupingModel.forEach(node => {
    if (isLeaf(node)) {
      return;
    }
    const {
        groupId,
        children
      } = node,
      other = _objectWithoutPropertiesLoose$b(node, _excluded$8);
    if (!groupId) {
      throw new Error('MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.');
    }
    if (!children) {
      console.warn(`MUI: group groupId=${groupId} has no children.`);
    }
    const groupParam = _extends$c({}, other, {
      groupId
    });
    const subTreeLookup = createGroupLookup(children);
    if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) {
      throw new Error(`MUI: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
    }
    groupLookup = _extends$c({}, groupLookup, subTreeLookup, {
      [groupId]: groupParam
    });
  });
  return _extends$c({}, groupLookup);
};
const columnGroupsStateInitializer = (state, props, apiRef) => {
  var _props$experimentalFe, _props$columnGrouping, _props$columnGrouping2, _apiRef$current$state;
  if (!((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.columnGrouping)) {
    return state;
  }
  const columnFields = gridColumnFieldsSelector(apiRef);
  const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
  const groupLookup = createGroupLookup((_props$columnGrouping = props.columnGroupingModel) != null ? _props$columnGrouping : []);
  const unwrappedGroupingModel = unwrapGroupingColumnModel((_props$columnGrouping2 = props.columnGroupingModel) != null ? _props$columnGrouping2 : []);
  const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, // @ts-expect-error Move this part to `Pro` package
  (_apiRef$current$state = apiRef.current.state.pinnedColumns) != null ? _apiRef$current$state : {});
  const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map(field => {
    var _unwrappedGroupingMod, _unwrappedGroupingMod2;
    return (_unwrappedGroupingMod = (_unwrappedGroupingMod2 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod2.length) != null ? _unwrappedGroupingMod : 0;
  }));
  return _extends$c({}, state, {
    columnGrouping: {
      lookup: groupLookup,
      unwrappedGroupingModel,
      headerStructure: columnGroupsHeaderStructure,
      maxDepth
    }
  });
};

/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */
const useGridColumnGrouping = (apiRef, props) => {
  var _props$experimentalFe3;
  /**
   * API METHODS
   */
  const getColumnGroupPath = React$1.useCallback(field => {
    var _unwrappedGroupingMod3;
    const unwrappedGroupingModel = gridColumnGroupsUnwrappedModelSelector(apiRef);
    return (_unwrappedGroupingMod3 = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod3 : [];
  }, [apiRef]);
  const getAllGroupDetails = React$1.useCallback(() => {
    const columnGroupLookup = gridColumnGroupsLookupSelector(apiRef);
    return columnGroupLookup;
  }, [apiRef]);
  const columnGroupingApi = {
    unstable_getColumnGroupPath: getColumnGroupPath,
    unstable_getAllGroupDetails: getAllGroupDetails
  };
  useGridApiMethod(apiRef, columnGroupingApi, 'public');
  const handleColumnIndexChange = React$1.useCallback(() => {
    var _props$columnGrouping3;
    const unwrappedGroupingModel = unwrapGroupingColumnModel((_props$columnGrouping3 = props.columnGroupingModel) != null ? _props$columnGrouping3 : []);
    apiRef.current.setState(state => {
      var _state$columns$ordere, _state$columns, _state$pinnedColumns;
      const orderedFields = (_state$columns$ordere = (_state$columns = state.columns) == null ? void 0 : _state$columns.orderedFields) != null ? _state$columns$ordere : [];

      // @ts-expect-error Move this logic to `Pro` package
      const pinnedColumns = (_state$pinnedColumns = state.pinnedColumns) != null ? _state$pinnedColumns : {};
      const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(orderedFields, unwrappedGroupingModel, pinnedColumns);
      return _extends$c({}, state, {
        columnGrouping: _extends$c({}, state.columnGrouping, {
          headerStructure: columnGroupsHeaderStructure
        })
      });
    });
  }, [apiRef, props.columnGroupingModel]);
  const updateColumnGroupingState = React$1.useCallback(columnGroupingModel => {
    var _props$experimentalFe2, _apiRef$current$getPi, _apiRef$current$getPi2, _apiRef$current;
    if (!((_props$experimentalFe2 = props.experimentalFeatures) != null && _props$experimentalFe2.columnGrouping)) {
      return;
    }
    // @ts-expect-error Move this logic to `Pro` package
    const pinnedColumns = (_apiRef$current$getPi = (_apiRef$current$getPi2 = (_apiRef$current = apiRef.current).getPinnedColumns) == null ? void 0 : _apiRef$current$getPi2.call(_apiRef$current)) != null ? _apiRef$current$getPi : {};
    const columnFields = gridColumnFieldsSelector(apiRef);
    const visibleColumnFields = gridVisibleColumnFieldsSelector(apiRef);
    const groupLookup = createGroupLookup(columnGroupingModel != null ? columnGroupingModel : []);
    const unwrappedGroupingModel = unwrapGroupingColumnModel(columnGroupingModel != null ? columnGroupingModel : []);
    const columnGroupsHeaderStructure = getColumnGroupsHeaderStructure(columnFields, unwrappedGroupingModel, pinnedColumns);
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map(field => {
      var _unwrappedGroupingMod4, _unwrappedGroupingMod5;
      return (_unwrappedGroupingMod4 = (_unwrappedGroupingMod5 = unwrappedGroupingModel[field]) == null ? void 0 : _unwrappedGroupingMod5.length) != null ? _unwrappedGroupingMod4 : 0;
    }));
    apiRef.current.setState(state => {
      return _extends$c({}, state, {
        columnGrouping: {
          lookup: groupLookup,
          unwrappedGroupingModel,
          headerStructure: columnGroupsHeaderStructure,
          maxDepth
        }
      });
    });
  }, [apiRef, (_props$experimentalFe3 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe3.columnGrouping]);
  useGridApiEventHandler(apiRef, 'columnIndexChange', handleColumnIndexChange);
  useGridApiEventHandler(apiRef, 'columnsChange', () => {
    updateColumnGroupingState(props.columnGroupingModel);
  });
  useGridApiEventHandler(apiRef, 'columnVisibilityModelChange', () => {
    updateColumnGroupingState(props.columnGroupingModel);
  });

  /**
   * EFFECTS
   */
  React$1.useEffect(() => {
    updateColumnGroupingState(props.columnGroupingModel);
  }, [updateColumnGroupingState, props.columnGroupingModel]);
};

const useDataGridComponent = (inputApiRef, props) => {
  const apiRef = useGridInitialization(inputApiRef, props);

  /**
   * Register all pre-processors called during state initialization here.
   */
  useGridRowSelectionPreProcessors(apiRef, props);
  useGridRowsPreProcessors(apiRef);

  /**
   * Register all state initializers here.
   */
  useGridInitializeState(rowSelectionStateInitializer, apiRef, props);
  useGridInitializeState(columnsStateInitializer, apiRef, props);
  useGridInitializeState(rowsStateInitializer, apiRef, props);
  useGridInitializeState(editingStateInitializer, apiRef, props);
  useGridInitializeState(focusStateInitializer, apiRef, props);
  useGridInitializeState(sortingStateInitializer, apiRef, props);
  useGridInitializeState(preferencePanelStateInitializer, apiRef, props);
  useGridInitializeState(filterStateInitializer, apiRef, props);
  useGridInitializeState(densityStateInitializer, apiRef, props);
  useGridInitializeState(paginationStateInitializer, apiRef, props);
  useGridInitializeState(rowsMetaStateInitializer, apiRef, props);
  useGridInitializeState(columnMenuStateInitializer, apiRef, props);
  useGridInitializeState(columnGroupsStateInitializer, apiRef, props);
  useGridInitializeState(virtualizationStateInitializer, apiRef, props);
  useGridKeyboardNavigation(apiRef, props);
  useGridRowSelection(apiRef, props);
  useGridColumns(apiRef, props);
  useGridRows(apiRef, props);
  useGridParamsApi(apiRef, props);
  useGridColumnSpanning(apiRef);
  useGridColumnGrouping(apiRef, props);
  useGridEditing(apiRef, props);
  useGridFocus(apiRef, props);
  useGridPreferencesPanel(apiRef, props);
  useGridFilter(apiRef, props);
  useGridSorting(apiRef, props);
  useGridDensity(apiRef, props);
  useGridPagination(apiRef, props);
  useGridRowsMeta(apiRef, props);
  useGridScroll(apiRef, props);
  useGridColumnMenu(apiRef);
  useGridCsvExport(apiRef, props);
  useGridPrintExport(apiRef, props);
  useGridClipboard(apiRef, props);
  useGridDimensions(apiRef, props);
  useGridEvents(apiRef, props);
  useGridStatePersistence(apiRef);
  useGridVirtualization(apiRef, props);
  return apiRef;
};

const useUtilityClasses$8 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['virtualScroller']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'VirtualScroller',
  overridesResolver: (props, styles) => styles.virtualScroller
})({
  overflow: 'auto',
  height: '100%',
  // See https://github.com/mui/mui-x/issues/4360
  position: 'relative',
  '@media print': {
    overflow: 'hidden'
  },
  zIndex: 0 // See https://github.com/mui/mui-x/issues/10547
});

const GridVirtualScroller = /*#__PURE__*/React$1.forwardRef(function GridVirtualScroller(props, ref) {
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$8(rootProps);
  return /*#__PURE__*/jsx(VirtualScrollerRoot, _extends$c({
    ref: ref
  }, props, {
    className: clsx(classes.root, props.className),
    ownerState: rootProps
  }));
});

const useUtilityClasses$7 = (props, overflowedContent) => {
  const {
    classes
  } = props;
  const slots = {
    root: ['virtualScrollerContent', overflowedContent && 'virtualScrollerContent--overflowed']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerContentRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'VirtualScrollerContent',
  overridesResolver: (props, styles) => styles.virtualScrollerContent
})({});
const GridVirtualScrollerContent = /*#__PURE__*/React$1.forwardRef(function GridVirtualScrollerContent(props, ref) {
  var _props$style;
  const rootProps = useGridRootProps();
  const overflowedContent = !rootProps.autoHeight && ((_props$style = props.style) == null ? void 0 : _props$style.minHeight) === 'auto';
  const classes = useUtilityClasses$7(rootProps, overflowedContent);
  return /*#__PURE__*/jsx(VirtualScrollerContentRoot, _extends$c({
    ref: ref
  }, props, {
    ownerState: rootProps,
    className: clsx(classes.root, props.className)
  }));
});

const _excluded$7 = ["className"];
const useUtilityClasses$6 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['virtualScrollerRenderZone']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerRenderZoneRoot = styled$1('div', {
  name: 'MuiDataGrid',
  slot: 'VirtualScrollerRenderZone',
  overridesResolver: (props, styles) => styles.virtualScrollerRenderZone
})({
  position: 'absolute',
  display: 'flex',
  // Prevents margin collapsing when using `getRowSpacing`
  flexDirection: 'column'
});
const GridVirtualScrollerRenderZone = /*#__PURE__*/React$1.forwardRef(function GridVirtualScrollerRenderZone(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$7);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses$6(rootProps);
  return /*#__PURE__*/jsx(VirtualScrollerRenderZoneRoot, _extends$c({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: rootProps
  }, other));
});

const _excluded$6 = ["className"];
const DataGridVirtualScroller = /*#__PURE__*/React$1.forwardRef(function DataGridVirtualScroller(props, ref) {
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$6);
  const {
    getRootProps,
    getContentProps,
    getRenderZoneProps,
    getRows
  } = useGridVirtualScroller({
    ref
  });
  return /*#__PURE__*/jsxs(GridVirtualScroller, _extends$c({
    className: className
  }, getRootProps(other), {
    children: [/*#__PURE__*/jsx(GridOverlays, {}), /*#__PURE__*/jsx(GridVirtualScrollerContent, _extends$c({}, getContentProps(), {
      children: /*#__PURE__*/jsx(GridVirtualScrollerRenderZone, _extends$c({}, getRenderZoneProps(), {
        children: getRows()
      }))
    }))]
  }));
});

const DataGridRaw = /*#__PURE__*/React$1.forwardRef(function DataGrid(inProps, ref) {
  const props = useDataGridProps(inProps);
  const privateApiRef = useDataGridComponent(props.apiRef, props);
  return /*#__PURE__*/jsx(GridContextProvider, {
    privateApiRef: privateApiRef,
    props: props,
    children: /*#__PURE__*/jsxs(GridRoot, _extends$c({
      className: props.className,
      style: props.style,
      sx: props.sx,
      ref: ref
    }, props.forwardedProps, {
      children: [/*#__PURE__*/jsx(GridHeader, {}), /*#__PURE__*/jsx(GridBody, {
        VirtualScrollerComponent: DataGridVirtualScroller
      }), /*#__PURE__*/jsx(GridFooterPlaceholder, {})]
    }))
  });
});
/**
 * Demos:
 * - [DataGrid](https://mui.com/x/react-data-grid/demo/)
 *
 * API:
 * - [DataGrid API](https://mui.com/x/api/data-grid/data-grid/)
 */
const DataGrid = /*#__PURE__*/React$1.memo(DataGridRaw);

/**
 * Remove at v7
 * @deprecated
 */
DATA_GRID_PROPS_DEFAULT_VALUES.filterDebounceMs;

/**
 * Remove at v7
 * @deprecated
 */
DATA_GRID_PROPS_DEFAULT_VALUES.filterDebounceMs;
DataGridRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }),
  /**
   * The label of the grid.
   */
  'aria-label': PropTypes.string,
  /**
   * The id of the element containing a label for the grid.
   */
  'aria-labelledby': PropTypes.string,
  /**
   * If `true`, the grid height is dynamic and follow the number of rows in the grid.
   * @default false
   */
  autoHeight: PropTypes.bool,
  /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */
  autoPageSize: PropTypes.bool,
  /**
   * Controls the modes of the cells.
   */
  cellModesModel: PropTypes.object,
  /**
   * If `true`, the grid get a first column with a checkbox that allows to select rows.
   * @default false
   */
  checkboxSelection: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */
  clipboardCopyCellDelimiter: PropTypes.string,
  /**
   * Number of extra columns to be rendered before/after the visible slice.
   * @default 3
   */
  columnBuffer: PropTypes.number,
  columnGroupingModel: PropTypes.arrayOf(PropTypes.object),
  /**
   * Sets the height in pixel of the column headers in the grid.
   * @default 56
   */
  columnHeaderHeight: PropTypes.number,
  /**
   * Set of columns of type [[GridColDef[]]].
   */
  columns: chainPropTypes(PropTypes.array.isRequired, props => {
    // @ts-ignore because otherwise `build:api` doesn't work
    if (props.columns && props.columns.some(column => column.resizable)) {
      return new Error([`MUI: \`column.resizable = true\` is not a valid prop.`, 'Column resizing is not available in the MIT version.', '', 'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'].join('\n'));
    }
    return null;
  }),
  /**
   * Number of rows from the `columnBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */
  columnThreshold: PropTypes.number,
  /**
   * Set the column visibility model of the grid.
   * If defined, the grid will ignore the `hide` property in [[GridColDef]].
   */
  columnVisibilityModel: PropTypes.object,
  /**
   * Overridable components.
   * @deprecated Use `slots` instead.
   */
  components: PropTypes.object,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   * @deprecated Use the `slotProps` prop instead.
   */
  componentsProps: PropTypes.object,
  /**
   * Set the density of the grid.
   * @default "standard"
   */
  density: PropTypes.oneOf(['comfortable', 'compact', 'standard']),
  /**
   * If `true`, column filters are disabled.
   * @default false
   */
  disableColumnFilter: PropTypes.bool,
  /**
   * If `true`, the column menu is disabled.
   * @default false
   */
  disableColumnMenu: PropTypes.bool,
  /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */
  disableColumnSelector: PropTypes.bool,
  /**
   * If `true`, the density selector is disabled.
   * @default false
   */
  disableDensitySelector: PropTypes.bool,
  /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   * @ignore - do not document
   */
  disableEval: PropTypes.bool,
  /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */
  disableRowSelectionOnClick: PropTypes.bool,
  /**
   * If `true`, the virtualization is disabled.
   * @default false
   */
  disableVirtualization: PropTypes.bool,
  /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */
  editMode: PropTypes.oneOf(['cell', 'row']),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: PropTypes.shape({
    ariaV7: PropTypes.bool,
    columnGrouping: PropTypes.bool,
    warnIfFocusStateIsNotSynced: PropTypes.bool
  }),
  /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */
  filterDebounceMs: PropTypes.number,
  /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */
  filterMode: PropTypes.oneOf(['client', 'server']),
  /**
   * Set the filter model of the grid.
   */
  filterModel: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      operator: PropTypes.string.isRequired,
      value: PropTypes.any
    })).isRequired,
    logicOperator: PropTypes.oneOf(['and', 'or']),
    quickFilterExcludeHiddenColumns: PropTypes.bool,
    quickFilterLogicOperator: PropTypes.oneOf(['and', 'or']),
    quickFilterValues: PropTypes.array
  }),
  /**
   * Forwarded props for the grid root element.
   * @ignore - do not document.
   */
  forwardedProps: PropTypes.object,
  /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */
  getCellClassName: PropTypes.func,
  /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */
  getDetailPanelContent: PropTypes.func,
  /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */
  getEstimatedRowHeight: PropTypes.func,
  /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */
  getRowClassName: PropTypes.func,
  /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */
  getRowHeight: PropTypes.func,
  /**
   * Return the id of a given [[GridRowModel]].
   */
  getRowId: PropTypes.func,
  /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */
  getRowSpacing: PropTypes.func,
  /**
   * If `true`, the footer component is hidden.
   * @default false
   */
  hideFooter: PropTypes.bool,
  /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */
  hideFooterPagination: PropTypes.bool,
  /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */
  hideFooterSelectedRowCount: PropTypes.bool,
  /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */
  initialState: PropTypes.object,
  /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */
  isCellEditable: PropTypes.func,
  /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */
  isRowSelectable: PropTypes.func,
  /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */
  keepNonExistentRowsSelected: PropTypes.bool,
  /**
   * If `true`, a  loading overlay is displayed.
   */
  loading: PropTypes.bool,
  /**
   * Set the locale text of the grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/grid/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */
  localeText: PropTypes.object,
  /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */
  logger: PropTypes.shape({
    debug: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
    info: PropTypes.func.isRequired,
    warn: PropTypes.func.isRequired
  }),
  /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */
  logLevel: PropTypes.oneOf(['debug', 'error', 'info', 'warn', false]),
  /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */
  nonce: PropTypes.string,
  /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellClick: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellDoubleClick: PropTypes.func,
  /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStart: PropTypes.func,
  /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStop: PropTypes.func,
  /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellKeyDown: PropTypes.func,
  /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellModesModelChange: PropTypes.func,
  /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */
  onClipboardCopy: PropTypes.func,
  /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderClick: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderDoubleClick: PropTypes.func,
  /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderEnter: PropTypes.func,
  /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderLeave: PropTypes.func,
  /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOut: PropTypes.func,
  /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOver: PropTypes.func,
  /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnOrderChange: PropTypes.func,
  /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnVisibilityModelChange: PropTypes.func,
  /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFilterModelChange: PropTypes.func,
  /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuClose: PropTypes.func,
  /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuOpen: PropTypes.func,
  /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPaginationModelChange: PropTypes.func,
  /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelClose: PropTypes.func,
  /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelOpen: PropTypes.func,
  /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */
  onProcessRowUpdateError: PropTypes.func,
  /**
   * Callback fired when the grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onResize: PropTypes.func,
  /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowClick: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowDoubleClick: PropTypes.func,
  /**
   * Callback fired when the row changes are committed.
   * @param {GridRowId} id The row id.
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditCommit: PropTypes.func,
  /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStart: PropTypes.func,
  /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStop: PropTypes.func,
  /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowModesModelChange: PropTypes.func,
  /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowSelectionModelChange: PropTypes.func,
  /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onSortModelChange: PropTypes.func,
  /**
   * Callback fired when the state of the grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */
  onStateChange: PropTypes.func,
  /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */
  pageSizeOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })]).isRequired),
  pagination: props => {
    if (props.pagination === false) {
      return new Error(['MUI: `<DataGrid pagination={false} />` is not a valid prop.', 'Infinite scrolling is not available in the MIT version.', '', 'You need to upgrade to DataGridPro or DataGridPremium component to disable the pagination.'].join('\n'));
    }
    return null;
  },
  /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */
  paginationMode: PropTypes.oneOf(['client', 'server']),
  /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */
  paginationModel: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired
  }),
  /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */
  processRowUpdate: PropTypes.func,
  /**
   * Number of extra rows to be rendered before/after the visible slice.
   * @default 3
   */
  rowBuffer: PropTypes.number,
  /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   */
  rowCount: PropTypes.number,
  /**
   * Sets the height in pixel of a row in the grid.
   * @default 52
   */
  rowHeight: PropTypes.number,
  /**
   * Controls the modes of the rows.
   */
  rowModesModel: PropTypes.object,
  /**
   * Set of rows of type [[GridRowsProp]].
   */
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */
  rowSelection: PropTypes.bool,
  /**
   * Sets the row selection model of the grid.
   */
  rowSelectionModel: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired), PropTypes.number, PropTypes.string]),
  /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */
  rowSpacingType: PropTypes.oneOf(['border', 'margin']),
  /**
   * Number of rows from the `rowBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */
  rowThreshold: PropTypes.number,
  /**
   * Override the height/width of the grid inner scrollbar.
   */
  scrollbarSize: PropTypes.number,
  /**
   * If `true`, the vertical borders of the cells are displayed.
   * @default false
   */
  showCellVerticalBorder: PropTypes.bool,
  /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */
  showColumnVerticalBorder: PropTypes.bool,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable components.
   */
  slots: PropTypes.object,
  /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */
  sortingMode: PropTypes.oneOf(['client', 'server']),
  /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */
  sortingOrder: PropTypes.arrayOf(PropTypes.oneOf(['asc', 'desc'])),
  /**
   * Set the sort model of the grid.
   */
  sortModel: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired,
    sort: PropTypes.oneOf(['asc', 'desc'])
  })),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */
  unstable_ignoreValueFormatterDuringExport: PropTypes.oneOfType([PropTypes.shape({
    clipboardExport: PropTypes.bool,
    csvExport: PropTypes.bool
  }), PropTypes.bool])
};

const StyledTableRow$8 = styled$4(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0
  },
  backgroundColor: "#eedbdb",
  borderTop: "1px solid #b42121",
  borderBottom: "#b42121 2px solid"
}));
const StyledText$8 = styled$4(Typography$1)(({ theme }) => ({
  fontSize: "0.8rem",
  display: "inline"
}));
const CellHeaderText$8 = styled$4(StyledText$8)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const CellValueText$8 = styled$4(StyledText$8)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const StyledTableContainer$8 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function TrackingOrderCutLines() {
  const theme = useTheme$2();
  const { jobID } = useParams();
  const isHandheldDevice = useTabletBreakpoint();
  const mobileBreakpoint = useMobileBreakpoint();
  const { isLoading, isError, data, error } = useQuery$1(
    ["/Tracking/Details", jobID],
    () => httpService$1.get(`Consignment/${jobID}`)
  );
  const gridStyles = {
    "& .MuiDataGrid-footerContainer": {
      display: "none"
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 600,
      fontSize: "1rem"
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.secondary.main
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#eedbdb",
      borderBottom: "#b42121 2px solid"
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#f7d9d9"
    },
    "& .MuiDataGrid-cell:focus": {
      outline: "none"
    },
    "& .MuiDataGrid-virtualScroller": {
      overflow: "hidden"
    },
    "& .MuiDataGrid-row:first-of-type": {
      borderTop: "1px solid #b42121",
      borderBottom: "#b42121 1px solid"
    }
  };
  const defaultColumns = [
    {
      field: "reference",
      headerName: "Description",
      flex: 3,
      disableColumnMenu: isHandheldDevice
    },
    {
      field: "cutQuantity",
      headerName: "Quantity Cut",
      type: "number",
      flex: 1,
      disableColumnMenu: isHandheldDevice,
      valueGetter: ({ row }) => {
        var _a, _b, _c, _d;
        const orderedMeasure = (_b = (_a = row.measures.find((measure) => measure.measureTypeSystemName === "OrderedQuantity")) == null ? void 0 : _a.measure) != null ? _b : 0;
        const suppliedMeasure = (_d = (_c = row.measures.find((measure) => measure.measureTypeSystemName === "SuppliedQuantity")) == null ? void 0 : _c.measure) != null ? _d : 0;
        return orderedMeasure - suppliedMeasure;
      },
      filterable: false
    }
  ];
  const filterRows = (rows) => {
    return rows.filter((row) => {
      var _a, _b, _c, _d;
      const orderedMeasure = (_b = (_a = row == null ? void 0 : row.measures.find((measure) => measure.measureTypeSystemName === "OrderedQuantity")) == null ? void 0 : _a.measure) != null ? _b : 0;
      const suppliedMeasure = (_d = (_c = row == null ? void 0 : row.measures.find((measure) => measure.measureTypeSystemName === "SuppliedQuantity")) == null ? void 0 : _c.measure) != null ? _d : 0;
      return orderedMeasure - suppliedMeasure;
    });
  };
  const getQuantityCut = (row) => {
    var _a, _b, _c, _d;
    const orderedMeasure = (_b = (_a = row == null ? void 0 : row.measures.find((measure) => measure.measureTypeSystemName === "OrderedQuantity")) == null ? void 0 : _a.measure) != null ? _b : 0;
    const suppliedMeasure = (_d = (_c = row == null ? void 0 : row.measures.find((measure) => measure.measureTypeSystemName === "SuppliedQuantity")) == null ? void 0 : _c.measure) != null ? _d : 0;
    return orderedMeasure - suppliedMeasure;
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (isError) {
    if (error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        error.message
      ] });
    }
  }
  if (data) {
    if (filterRows(data.data.jobLines).length === 0) {
      return /* @__PURE__ */ jsx(Box$1, {});
    }
  }
  return /* @__PURE__ */ jsxs(Box$1, { sx: { marginTop: 8 }, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ jsx(WarningAmber, { sx: { width: ".75em", height: ".75em" } }),
      /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", sx: { padding: 2 }, children: "Cut Lines" })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { children: [
      data && !mobileBreakpoint && /* @__PURE__ */ jsx(
        DataGrid,
        {
          loading: isLoading,
          rows: filterRows(data.data.jobLines),
          columns: defaultColumns,
          disableRowSelectionOnClick: true,
          sx: gridStyles
        }
      ),
      data && mobileBreakpoint && /* @__PURE__ */ jsx(StyledTableContainer$8, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: filterRows(data.data.jobLines).map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$8, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
        /* @__PURE__ */ jsx(StyledText$8, { children: row.reference }),
        /* @__PURE__ */ jsx(Grid$3, { container: true, justifyItems: "space-between", children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$8, { children: "Quantity Cut: " }),
          /* @__PURE__ */ jsx(CellValueText$8, { children: getQuantityCut(row) })
        ] }) })
      ] }) }, i)) }) }) })
    ] })
  ] });
}

const StyledStack$1 = styled$4(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 6, 0, 2),
  backgroundColor: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.divider}`
}));
const StyledTypography = styled$4(Typography$1)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));
function TrackingOrderDetailsTotal({ totalItems, weight, volume, unit }) {
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const fontSize = mobileBreakpoint ? "0.83rem" : "inherit";
  return /* @__PURE__ */ jsxs(
    StyledStack$1,
    {
      direction: "row",
      spacing: 5,
      sx: { width: mobileBreakpoint ? "100%" : "60%", marginTop: 6 },
      justifyContent: "space-evenly",
      divider: /* @__PURE__ */ jsx(Divider$1, { orientation: "vertical", flexItem: true }),
      children: [
        /* @__PURE__ */ jsx(StyledTypography, { variant: "subtitle1", fontSize, children: "Total:" }),
        totalItems !== 0 ? /* @__PURE__ */ jsx(StyledTypography, { variant: "subtitle1", fontSize, children: `${totalItems} ${unit}s` }) : "",
        weight !== 0 ? /* @__PURE__ */ jsxs(StyledTypography, { variant: "subtitle1", fontSize, children: [
          weight.toFixed(2),
          " kg"
        ] }) : "",
        volume !== 0 ? /* @__PURE__ */ jsxs(StyledTypography, { variant: "subtitle1", fontSize, children: [
          volume.toFixed(2),
          " m3"
        ] }) : ""
      ]
    }
  );
}

var __defProp$Z = Object.defineProperty;
var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Z = (obj, key, value) => key in obj ? __defProp$Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Z.call(b, prop))
      __defNormalProp$Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(b)) {
      if (__propIsEnum$Z.call(b, prop))
        __defNormalProp$Z(a, prop, b[prop]);
    }
  return a;
};
function OrderSummaryHeaderText({
  text,
  mobileStyle,
  style,
  isMobile,
  mobileVariant = "subtitle2",
  variant = "subtitle1"
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: isMobile ? /* @__PURE__ */ jsx(
    Typography$1,
    {
      variant: mobileVariant,
      sx: __spreadValues$Z({
        fontWeight: "600",
        lineHeight: "1.75"
      }, mobileStyle),
      children: text
    }
  ) : /* @__PURE__ */ jsx(
    Typography$1,
    {
      variant,
      sx: __spreadValues$Z({}, style),
      children: text
    }
  ) });
}
function OrderSummaryText({
  text,
  mobileStyle,
  style,
  isMobile,
  mobileVariant = "subtitle2",
  variant = "body1"
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: isMobile ? /* @__PURE__ */ jsx(
    Typography$1,
    {
      variant: mobileVariant,
      sx: __spreadValues$Z({
        lineHeight: "1.75"
      }, mobileStyle),
      children: text
    }
  ) : /* @__PURE__ */ jsx(
    Typography$1,
    {
      variant,
      sx: __spreadValues$Z({}, style),
      children: text
    }
  ) });
}
const StyledTableCell = styled$4(TableCell)(({ theme }) => ({
  borderBottom: "none",
  padding: 0
}));
function TrackingOrderSummaryCard({ data }) {
  var _a, _b, _c, _d, _e, _f, _g;
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  const isMobileBreakPoint = mobileBreakpoint ? true : false;
  var [totalWeight, totalVolume, totalItems] = [0, 0, 0];
  for (const measure of data == null ? void 0 : data.measures) {
    if (measure.measure && measure.measureTypeSystemName === "Weight") {
      totalWeight = measure.measure;
    } else if (measure.measure && measure.measureTypeSystemName === "Volume") {
      totalVolume = measure.measure;
    } else if (measure.measure && measure.measureTypeSystemName === "Quantity") {
      totalItems = measure.measure;
    }
  }
  return /* @__PURE__ */ jsx(CardContent, { sx: { padding: theme.spacing(4), paddingTop: mobileBreakpoint ? 0 : theme.spacing(4) }, children: !isMobileBreakPoint ? /* @__PURE__ */ jsx(TableContainer, { style: { marginLeft: "1.25rem" }, children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsxs(TableBody, { style: { border: "none" }, children: [
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { sx: { width: "20%" }, children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Pickup Location", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: `${(_a = data == null ? void 0 : data.pickup) == null ? void 0 : _a.address1}`,
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Delivery Location", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: `${(_b = data == null ? void 0 : data.dropoff) == null ? void 0 : _b.address1}`,
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Weight", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: (totalWeight == null ? void 0 : totalWeight.toFixed(2)) + " kg",
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Volume", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: (totalVolume == null ? void 0 : totalVolume.toFixed(2)) + " m3",
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Item Count", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: totalItems,
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Carrier", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: (_c = data == null ? void 0 : data.carrier) == null ? void 0 : _c.fileAs,
          isMobile: isMobileBreakPoint,
          style: { paddingLeft: theme.spacing(8) }
        }
      ) })
    ] })
  ] }) }) }) : /* @__PURE__ */ jsx(TableContainer, { style: { marginLeft: "1.25rem" }, children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsxs(TableBody, { style: { border: "none" }, children: [
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Pickup Location", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: `${(_d = data == null ? void 0 : data.pickup) == null ? void 0 : _d.address1}`,
          isMobile: isMobileBreakPoint
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Delivery Location", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: `${(_e = data == null ? void 0 : data.dropoff) == null ? void 0 : _e.suburb}, ${(_f = data == null ? void 0 : data.dropoff) == null ? void 0 : _f.address1}`,
          isMobile: isMobileBreakPoint
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Weight", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: (totalWeight == null ? void 0 : totalWeight.toFixed(2)) + " kg",
          isMobile: isMobileBreakPoint
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Volume", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(
        OrderSummaryText,
        {
          text: (totalVolume == null ? void 0 : totalVolume.toFixed(2)) + " m3",
          isMobile: isMobileBreakPoint
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Item Count", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryText, { text: totalItems, isMobile: isMobileBreakPoint }) })
    ] }),
    /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryHeaderText, { text: "Carrier", isMobile: isMobileBreakPoint }) }),
      /* @__PURE__ */ jsx(StyledTableCell, { children: /* @__PURE__ */ jsx(OrderSummaryText, { text: (_g = data == null ? void 0 : data.carrier) == null ? void 0 : _g.fileAs, isMobile: isMobileBreakPoint }) })
    ] })
  ] }) }) }) });
}

var __defProp$Y = Object.defineProperty;
var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Y = (obj, key, value) => key in obj ? __defProp$Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Y.call(b, prop))
      __defNormalProp$Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(b)) {
      if (__propIsEnum$Y.call(b, prop))
        __defNormalProp$Y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ExpandMoreIcon = styled$4((props) => {
  const _a = props, rest = __objRest$q(_a, ["expand"]);
  return /* @__PURE__ */ jsx(IconButton$1, __spreadValues$Y({}, rest));
})(({ theme, expand }) => ({
  padding: 0,
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest
  })
}));
function TrackingOrderSummary({ data, title }) {
  const theme = useTheme$2();
  const [expanded, setExpanded] = useState(true);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsx(Fragment, { children: !mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Card, { sx: { boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }, children: [
    /* @__PURE__ */ jsxs(
      Stack,
      {
        paddingY: 3,
        paddingX: 4,
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: "600" }, children: `${title != null ? title : "Order Summary"}` }),
          /* @__PURE__ */ jsx(ExpandMoreIcon, { expand: expanded, onClick: handleExpandClick, children: /* @__PURE__ */ jsx(ExpandMore, {}) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsx(Collapse$1, { in: expanded, timeout: "auto", unmountOnExit: true, children: /* @__PURE__ */ jsx(TrackingOrderSummaryCard, { data }) })
  ] }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    Box$1,
    {
      sx: {
        backgroundColor: "#fff",
        height: "100%"
      },
      children: [
        /* @__PURE__ */ jsx(Divider$1, {}),
        /* @__PURE__ */ jsx(
          Stack,
          {
            paddingY: 3,
            paddingX: 4,
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            children: /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: "600" }, children: `${title != null ? title : "Order Summary"}` })
          }
        ),
        /* @__PURE__ */ jsx(TrackingOrderSummaryCard, { data })
      ]
    }
  ) }) });
}

const StyledTableRow$7 = styled$4(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.secondary.main
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const StyledText$7 = styled$4(Typography$1)(({ theme }) => ({
  fontSize: "0.8rem",
  display: "inline"
}));
const CellHeaderText$7 = styled$4(StyledText$7)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const CellValueText$7 = styled$4(StyledText$7)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const StyledTableContainer$7 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function TrackingPalletTableSupplied({ rows }) {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(StyledTableContainer$7, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody$1, { children: rows.map((row, i) => {
    var _a, _b, _c, _d;
    return /* @__PURE__ */ jsx(StyledTableRow$7, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
      /* @__PURE__ */ jsx(StyledText$7, { children: (_a = row.description) == null ? void 0 : _a.reference }),
      /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$7, { children: "Type: " }),
          /* @__PURE__ */ jsx(CellValueText$7, { children: row.breakBulkType })
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$7, { children: "Quantity: " }),
          /* @__PURE__ */ jsx(CellValueText$7, { children: (_b = row.measures.find(
            (measure) => measure.measureTypeSystemName === "Quantity"
          )) == null ? void 0 : _b.measure })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$7, { children: "Weight: " }),
          /* @__PURE__ */ jsx(CellValueText$7, { children: (_c = row.weight) == null ? void 0 : _c.measure })
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, children: [
          /* @__PURE__ */ jsx(CellHeaderText$7, { children: "Volume: " }),
          /* @__PURE__ */ jsx(CellValueText$7, { children: (_d = row.volume) == null ? void 0 : _d.measure })
        ] })
      ] })
    ] }) }, i);
  }) }) }) }) });
}

const StyledTableRow$6 = styled$4(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.secondary.main
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const StyledText$6 = styled$4(Typography$1)(({ theme }) => ({
  fontSize: "0.8rem",
  display: "inline"
}));
const CellHeaderText$6 = styled$4(StyledText$6)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const CellValueText$6 = styled$4(StyledText$6)(({ theme }) => ({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
}));
const StyledTableContainer$6 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function TrackingPalletTableOrdered({ rows }) {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(StyledTableContainer$6, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody$1, { children: rows.map((row, i) => {
    var _a, _b, _c, _d;
    return /* @__PURE__ */ jsx(StyledTableRow$6, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
      /* @__PURE__ */ jsx(StyledText$6, { children: row.reference }),
      /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$6, { children: "Ordered: " }),
          /* @__PURE__ */ jsx(CellValueText$6, { children: (_a = row.measures.find(
            (measure) => measure.measureTypeSystemName === "OrderedQuantity"
          )) == null ? void 0 : _a.measure })
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$6, { children: "Supplied: " }),
          /* @__PURE__ */ jsx(CellValueText$6, { children: (_b = row.measures.find(
            (measure) => measure.measureTypeSystemName === "SuppliedQuantity"
          )) == null ? void 0 : _b.measure })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
          /* @__PURE__ */ jsx(CellHeaderText$6, { children: "Weight: " }),
          /* @__PURE__ */ jsx(CellValueText$6, { children: (_c = row.measures.find(
            (measure) => measure.measureTypeSystemName === "Weight"
          )) == null ? void 0 : _c.measure })
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, children: [
          /* @__PURE__ */ jsx(CellHeaderText$6, { children: "Volume: " }),
          /* @__PURE__ */ jsx(CellValueText$6, { children: (_d = row.measures.find(
            (measure) => measure.measureTypeSystemName === "Volume"
          )) == null ? void 0 : _d.measure })
        ] })
      ] })
    ] }) }, i);
  }) }) }) }) });
}

class Lion {
	constructor(settings) {
		if (settings.defaultLocale == null) {
			throw "<SAL.Lion> You needs to set a defaultLocale to use Lion.";
		}
		this.settings = settings;
		this.termStore = {};
	}
	getTerm(term) {
		var locale = this.settings.currentLocale != undefined ? this.settings.currentLocale : this.settings.defaultLocale;
		var termOut = null;
		
		// get the term from the current locale
		if (this.termStore[locale][term] != null) {
			termOut = this.getTermFromStore(locale, term);
		}
	
		// get it from the default if it fails.
		if (termOut == null && locale != this.settings.defaultLocale) {
			termOut = this.getTermFromStore(this.settings.defaultLocale, term);
		}
	
		if (termOut == null) {
			return "{TERM MISSING: " + term + "}";
		}
		
		if (arguments.length > 1) {
			// do any replacements
			var tokens = arguments;
			
			if (typeof tokens[1] == "object") {
				// object (named) tokens
				termOut = termOut.replace(/{([^}]+)}/g, function (_, token) { 
					var token = tokens[1][token];
	
					return token != undefined ? token.toString() : "";
				});
			} else {
				// ordinal tokens - blank out any numbers that make no sense.
				termOut = termOut.replace(/\{([0-9]+)\}/g, function (_, token) {
					var token = tokens[parseInt(token, 10) + 1];
	
					return token != undefined ? token.toString() : "";
				});
			}
	
		} else if (termOut.match(/{([^}]+)}/g)) {
			// the string expects replacements, but no arguments were added - hide the ugliness.
			termOut = termOut.replace(/{([^}]+)}/g,"");
		}
		
		// Return the result, with whitespace trimmed (http://blog.stevenlevithan.com/archives/faster-trim-javascript)
		return termOut.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	addTerms(termStore) {
		// append new items into our private _termStore
		for (var locale in termStore) {
			if (this.termStore[locale] == undefined) {
				this.termStore[locale] = { };
			}
			
			for (var term in termStore[locale]) {
				this.termStore[locale][term] = termStore[locale][term];
			}
		}
	}
	getTermFromStore(locale, term) {
		var termOut = null;
		
		if (typeof this.termStore[locale][term] == "undefined") {
			throw "<SAL.Lion> The Term \"" + term + "\" does not exist in the locale \"" + locale + "\"";
		}
	
		if (typeof this.termStore[locale][term] == "function") {
			termOut = _termStore[locale][term]();
		} else {
			termOut = this.termStore[locale][term].toString();
		}
		
		return termOut;
	}
}

const track_filters = {
  "track.filters.mode": "Mode",
  "track.filters.cargoType": "Cargo Type",
  "track.filters.departureDate": "Departure Date",
  "track.filters.arrivalDate": "Arrival Date",
  "track.filters.origin": "Origin",
  "track.filters.destination": "Destination",
  "track.filters.supplier": "Supplier",
  "track.filters.consignee": "Consignee",
  "track.filters.expectedReady": "Cargo Ready",
  "track.filters.requiredIntoStore": "Required into Store",
  "track.filters.delays": "Delays",
  "track.filters.status": "Status"
};

var __defProp$X = Object.defineProperty;
var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
var __hasOwnProp$X = Object.prototype.hasOwnProperty;
var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$X = (obj, key, value) => key in obj ? __defProp$X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$X.call(b, prop))
      __defNormalProp$X(a, prop, b[prop]);
  if (__getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(b)) {
      if (__propIsEnum$X.call(b, prop))
        __defNormalProp$X(a, prop, b[prop]);
    }
  return a;
};
const track = __spreadValues$X({}, track_filters);

const consignmentGrid_filters = {
  "consignmentGrid.filters.jobType": "Job Type",
  "consignmentGrid.filters.status": "Status",
  "consignmentGrid.filters.bookedDate": "Booked Date",
  "consignmentGrid.filters.deliveryDate": "Delivery Date",
  "consignmentGrid.filters.origin": "Origin",
  "consignmentGrid.filters.destination": "Destination",
  "consignmentGrid.filters.receiver": "Receiver",
  "consignmentGrid.filters.shipper": "Shipper",
  "consignmentGrid.filters.eddDelay": "Delays"
};

var __defProp$W = Object.defineProperty;
var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
var __hasOwnProp$W = Object.prototype.hasOwnProperty;
var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$W = (obj, key, value) => key in obj ? __defProp$W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$W.call(b, prop))
      __defNormalProp$W(a, prop, b[prop]);
  if (__getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(b)) {
      if (__propIsEnum$W.call(b, prop))
        __defNormalProp$W(a, prop, b[prop]);
    }
  return a;
};
const consignmentGrid = __spreadValues$W({}, consignmentGrid_filters);

const consignment = {
  "consignment.freightPayer": "Freight Payer",
  "consignment.orderReference": "Order Reference",
  "consignment.pickupReference": "Pickup Reference",
  "consignment.deliveryReference": "Delivery Reference",
  "consignment.dangerousGoods": "Dangerous Goods",
  "consignment.unNumber": "DG UN No.",
  "consignment.dgClass": "DG Class",
  "consignment.dgDocuments": "DG Documents",
  "consignment.address": "Address",
  "consignment.requiredPickup": "Required Pickup",
  "consignment.pickedUpRequiredBy": "Pickup Required By",
  "consignment.ratingArea": "Rating Area",
  "consignment.draft": "Draft",
  "consignment.consignment": "Consignment",
  "consignment.quote": "Quote",
  "consignment.submitted": "Submitted",
  "consignment.shipper": "Shipper",
  "consignment.receiver": "Receiver"
};

const containerConsignment = {
  "consignment.container.containerNumber": "Container Number",
  "consignment.container.containerOwner": "Container Owner",
  "consignment.container.movementType": "Movement Type",
  "consignment.container.fullOrEmpty": "Full or Empty",
  "consignment.container.weight": "Weight",
  "consignment.container.volume": "Volume",
  "consignment.container.size": "Size",
  "consignment.container.vessel": "Vessel",
  "consignment.container.voyage": "Voyage",
  "consignment.container.type": "Type",
  "consignment.container.releaseNumber": "Release Number",
  "consignment.container.pin": "Pin",
  "consignment.container.sealNumber": "Seal No.",
  "consignment.container.doors": "Doors",
  "consignment.container.load": "Load",
  "consignment.container.commodity": "Commodity",
  "consignment.container.pickupName": "Pickup - Name",
  "consignment.container.pickupLocation": "Pickup Address",
  "consignment.container.unpackName": "Unpack - Name",
  "consignment.container.unpack": "Unpack Address",
  "consignment.container.unpackDate": "Unpack Date",
  "consignment.container.dehireName": "Dehire - Name",
  "consignment.container.dehire": "Dehire Address",
  "consignment.container.dehireDate": "Dehire Date",
  "consignment.container.packName": "Pack - Name",
  "consignment.container.pack": "Pack Address",
  "consignment.container.packDate": "Pack Date",
  "consignment.container.exportName": "Export - Name",
  "consignment.container.exportLocation": "Export Address",
  "consignment.container.exportDate": "Export Date",
  "consignment.container.dropoffName": "Dropoff - Name",
  "consignment.container.dropoffLocation": "Dropoff Address",
  "consignment.container.requiredDropoff": "Dropoff Date",
  "consignment.container.deliveryName": "Delivery - Name",
  "consignment.container.deliveryLocation": "Delivery Address",
  "consignment.container.deliveryDate": "Delivery Date"
};

const freightConsignment = {
  "consignment.freight.receiverName": "Receiver Name",
  "consignment.freight.receiverEmail": "Receiver Email",
  "consignment.freight.receiverPhone": "Receiver Phone",
  "consignment.freight.export": "Export",
  "consignment.freight.exportCertificateNumber": "Export Cert No",
  "consignment.freight.pallets": "Pallets",
  "consignment.freight.hpQuantity": "HP Quantity",
  "consignment.freight.quantity": "Quantity",
  "consignment.freight.hirePallets": "Hire Pallets",
  "consignment.freight.nonHirePallets": "Non-Hire Pallets",
  "consignment.freight.palletsNotRequired": "Pallets Not Required"
};

var __defProp$V = Object.defineProperty;
var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
var __hasOwnProp$V = Object.prototype.hasOwnProperty;
var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$V = (obj, key, value) => key in obj ? __defProp$V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$V.call(b, prop))
      __defNormalProp$V(a, prop, b[prop]);
  if (__getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(b)) {
      if (__propIsEnum$V.call(b, prop))
        __defNormalProp$V(a, prop, b[prop]);
    }
  return a;
};
const consignmentBooking = __spreadValues$V(__spreadValues$V(__spreadValues$V({}, consignment), freightConsignment), containerConsignment);

var __defProp$U = Object.defineProperty;
var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
var __hasOwnProp$U = Object.prototype.hasOwnProperty;
var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$U = (obj, key, value) => key in obj ? __defProp$U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$U.call(b, prop))
      __defNormalProp$U(a, prop, b[prop]);
  if (__getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(b)) {
      if (__propIsEnum$U.call(b, prop))
        __defNormalProp$U(a, prop, b[prop]);
    }
  return a;
};
const format = {
  "format_decimalSeparator": ".",
  "format_digitGroupSeparator": ",",
  "format_digitGroupSeparatorInterval": 3,
  "format_decimalPlaces": 2,
  "format_termSeparator": ", ",
  "format_conjunction": " and ",
  "format_disjunction": " or ",
  "format_datetime": "DD MMM YYYY hh:mm a",
  "format_datetime_iso": "YYYY-MM-DDThh:mm:ss",
  "format_date_iso": "YYYY-MM-DD",
  "format_date_data": "DD MMM YYYY",
  "format_date_short": "DD MMM YYYY",
  "format_date_long": "DD MMMM YYYY",
  "format_date_shortest": "DD MMM",
  "format_time_data": "HH:mm",
  "format_time_short": "HH:mm",
  "format_time_long": "HH:mm:ss",
  "format_time_shortest": "HH:mm",
  "format_true": "Yes",
  "format_false": "No"
};
const incoterms = {
  "incotermDescription": "Incoterms are a set of 11 individual rules issued by the International Chamber of Commerce (ICC) which define the responsibilities of sellers and buyers for the sale of goods in international transactions.",
  "EXW": "The Seller\u2019s only responsibility is to make the goods available at the Seller\u2019s premises. The Buyer bears full costs and risks of loading and moving the goods from there to destination, including arranging for the export clearance.",
  "DAP": "The Seller delivers when the goods are placed at the Buyer\u2019s disposal on the arriving means of transport ready for unloading at the named place of destination or at the agreed point within that place, if any such point is agreed. The Seller bears all risks involved in bringing the goods to the named place. Delivery & Arrival at destination are the same.",
  "DDP": "The Seller delivers the goods to the buyer when the goods are placed at the disposal of the buyer, cleared for import, on the arriving means of transport, ready for unloading, at the named place of destination. The Seller bears all costs and risks of moving the goods to destination, including the payment of Customs duties and taxes. There are limitations to DDP, as Customs formalities in the importing country may not readily allow the seller to be the legal importer of record; DAP or DPU are suggested Incoterms in such cases.",
  "CIP": "The Seller delivers and transfers risk of loss or damage by handing over goods to the carrier chosen by the seller, cleared for export, who pays for moving the goods to the named place of destination. From the time the goods are transferred to the first carrier, the Buyer bears the risks of loss or damage. The Seller, however, purchases cargo insurance thru to the named place of destination.",
  "DPU": "The Seller delivers when the goods, once unloaded from the arriving means of transport, are placed at the Buyer\u2019s disposal at a place of destination. The Seller bears all risks involved in bringing the goods to and unloading them at the terminal at the named port or place of destination. DPU is the only Incoterms where the Seller must pay for unloading at destination. As seller is responsible for unloading the goods at destination it is highly recommended to be as specific as possible as to the named address/place of destination as all costs thru to unloading are for the seller\u2019s account.",
  "FCA": "Delivery is made either when goods are (1) loaded on the means of transport provided by the buyer at the seller\u2019s stated location; or (2) when placed at the disposal of the buyer\u2019s carrier, cleared for export by the seller. From either point of delivery, the Buyer bears the costs and risks of moving the goods to destination. The named place/address is required when FCA is used.",
  "CPT": "The Seller delivers and transfers risk of loss or damage by handing over goods to the carrier chosen by the seller, cleared for export, who pays for moving the goods to the named place of destination. From the time the goods are transferred to the first carrier, the Buyer bears the risks of loss or damage.",
  "FAS": "The Seller delivers the goods to the buyer when the goods are cleared for export then placed alongside the ship nominated by the buyer at the named port of shipment. From that point, the Buyer bears all costs and risks of loss or damage.",
  "FOB": "The Seller delivers the goods to the buyer on board the vessel nominated by the buyer, cleared for export, at the named wharf/seaport of shipment. From that point, the Buyer bears all costs and risks of loss or damage.",
  "CFR": "The Seller delivers the goods to the buyer on board the vessel, cleared for export to the named port of destination. The Buyer bears all risks of loss or damage once on board. Where more than one mode of transport is to be used, such as when goods are handed over to a carrier at a container terminal, it is highly recommended to use CPT instead.",
  "CIF": "The Seller delivers the goods to the buyer on board the vessel, cleared for export to the named port of destination. The Buyer bears all risks of loss or damage once on board. The Seller, however, purchases the cargo insurance to the named wharf/seaport of destination. Where more than one mode of transport is to be used, such as when goods are handed over to a carrier at a container terminal, it is highly recommended to use CPT instead.",
  "DAT": "The buyer is responsible for import clearance and any applicable local taxes or import duties."
};
const base = __spreadValues$U(__spreadValues$U(__spreadValues$U(__spreadValues$U(__spreadValues$U({
  "projectTitle": "CDBVisbility",
  // New Order
  "orderDetails": "Order Details",
  "estimatedWeight": "Estimated Weight (kg)",
  "estimatedVolume": "Estimated Volume (m3)",
  "comments": "Comments",
  "requiredintoStore": "Required into Store",
  "additionalReference": "Additional Reference",
  "expectedReady": "Expected Ready",
  "orderNumber": "Order Number",
  "goodsReady": "Goods Ready",
  "incoterm": "Incoterm",
  "shippingOption": "Shipping Option",
  "mode": "Mode",
  "deliveryAddress": "Delivery Address",
  "pickupAddress": "Pickup Address",
  "consignee": "Consignee",
  "supplier": "Supplier",
  "consignor": "Consignor",
  "from": "From",
  "to": "To",
  "documents": "Documents",
  "origin": "Origin",
  "destination": "Destination",
  "cargoType": "Cargo Type",
  //estimates
  "newEstimate_Summary_Grid_Button_Book": "Book",
  "newEstimate_Summary_Disclaimer_Title_Text": "Disclaimer",
  "newEstimate_Summary_Disclaimer_Caption_Text": "Estimates Only",
  "newEstimate_Summary_Disclaimer_Caption_No_Results_Text": "No rates were found"
}, track), consignmentGrid), incoterms), format), consignmentBooking);

const enAU = {
  "overlappingManifestErrorMsg": "Unable to create overlapping manifests.",
  "week": "Week",
  "day": "Day",
  "threeDays": "3 Days",
  "specialInstructions": "Special Instructions"
};

const enNZ = {
  "overlappingManifestErrorMsg": "Unable to create overlapping manifests.",
  "week": "Week",
  "day": "Day",
  "threeDays": "3 Days",
  "specialInstructions": "Special Instructions"
};

var __defProp$T = Object.defineProperty;
var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
var __hasOwnProp$T = Object.prototype.hasOwnProperty;
var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$T = (obj, key, value) => key in obj ? __defProp$T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$T.call(b, prop))
      __defNormalProp$T(a, prop, b[prop]);
  if (__getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(b)) {
      if (__propIsEnum$T.call(b, prop))
        __defNormalProp$T(a, prop, b[prop]);
    }
  return a;
};
let browserLocale = navigator.language;
let lion = new Lion({ defaultLocale: "default", currentLocale: browserLocale });
let terms = {
  "default": __spreadValues$T({}, base),
  "en-AU": __spreadValues$T(__spreadValues$T({}, base), enAU),
  "en-NZ": __spreadValues$T(__spreadValues$T({}, base), enNZ)
};
if (!terms[browserLocale]) {
  terms[browserLocale] = __spreadValues$T({}, base);
}
lion.addTerms(terms);
function getTerm(term, args = {}) {
  if (!term || typeof term === "string" && term.trim() === "") {
    return void 0;
  }
  try {
    return lion.getTerm(term, args);
  } catch (error) {
    console.warn(error);
    return void 0;
  }
}
function getTermFromStore(term) {
  return lion.getTermFromStore(term);
}
function addTerms(terms2) {
  lion.addTerms(terms2);
}

const Skeleton$b = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function AgentDetails$3({ data }) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const fontSize = mobileBreakPoint ? "0.85rem" : "0.9rem";
  const originAgent = data == null ? void 0 : data.originAgent;
  const destinationAgent = data == null ? void 0 : data.destinationAgent;
  const customsBroker = data == null ? void 0 : data.customsBroker;
  const transportProvider = data == null ? void 0 : data.transportProvider;
  const defaultAgent = getTerm("defaultAgent");
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Origin Agent" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_b = (_a = originAgent == null ? void 0 : originAgent.fileAs) != null ? _a : originAgent == null ? void 0 : originAgent.fullName) != null ? _b : defaultAgent })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Destination Agent" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_d = (_c = destinationAgent == null ? void 0 : destinationAgent.fileAs) != null ? _c : destinationAgent == null ? void 0 : destinationAgent.fullName) != null ? _d : defaultAgent })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Customs Broker" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_f = (_e = customsBroker == null ? void 0 : customsBroker.fileAs) != null ? _e : customsBroker == null ? void 0 : customsBroker.fullName) != null ? _f : defaultAgent })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Transport Provider" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_h = (_g = transportProvider == null ? void 0 : transportProvider.fileAs) != null ? _g : transportProvider == null ? void 0 : transportProvider.fullName) != null ? _h : defaultAgent })
        ] })
      }
    )
  ] });
}
function AgentDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.815rem", width: "80px" }),
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.9rem", width: "90px" })
    ] }) }),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.815rem", width: "115px" }),
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.9rem", width: "80px" })
    ] }) }),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.815rem", width: "100px" }),
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.9rem", width: "85px" })
    ] }) }),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.815rem", width: "115px" }),
      /* @__PURE__ */ jsx(Skeleton$b, { height: "0.9rem", width: "75px" })
    ] }) })
  ] });
}

const Skeleton$a = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function CommentsDetails$3({ comments }) {
  var _a;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const fontSize = mobileBreakPoint ? "0.85rem" : "0.9rem";
  return /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_a = comments == null ? void 0 : comments.note) != null ? _a : EMPTY_STRING$g });
}
function CommentsDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ jsx(Skeleton$a, { height: "0.9rem", width: "180px" }),
    /* @__PURE__ */ jsx(Skeleton$a, { height: "0.9rem", width: "90px" })
  ] });
}

const EMPTY_STRING$4 = "";
const Skeleton$9 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function ConsignmentDetailsLocationDetails({ location, area, textFontSize }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, fontWeight: "600", children: location == null ? void 0 : location.locationName }) }),
    (location == null ? void 0 : location.address1) && /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: location == null ? void 0 : location.address1 }) }),
    (location == null ? void 0 : location.address2) && /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: location == null ? void 0 : location.address2 }) }),
    (location == null ? void 0 : location.suburb) && /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: location == null ? void 0 : location.suburb }) }),
    ((location == null ? void 0 : location.state) || (location == null ? void 0 : location.postcode)) && /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsxs(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: [
      location == null ? void 0 : location.state,
      " ",
      location == null ? void 0 : location.postcode
    ] }) }),
    (area == null ? void 0 : area.locationName) && /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: area == null ? void 0 : area.locationName }) })
  ] });
}
function ConsignmentDetails$2({ data, shipper, receiver, shipperArea, receiverArea }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const textFontSize = mobileBreakPoint ? "0.75rem" : "0.9rem";
  const headerFontSize = mobileBreakPoint ? "0.75rem" : "small";
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Shipper" }),
        /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: /* @__PURE__ */ jsx(
          ConsignmentDetailsLocationDetails,
          {
            location: shipper,
            area: shipperArea,
            textFontSize
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Receiver" }),
        /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: /* @__PURE__ */ jsx(
          ConsignmentDetailsLocationDetails,
          {
            location: receiver,
            area: receiverArea,
            textFontSize
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Required Pickup" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: ((_a = data == null ? void 0 : data.pickupRequiredBy) == null ? void 0 : _a.dateAndTime) && dayjs(data.pickupRequiredBy.dateAndTime).format("DD MMM YYYY hh:mm a") })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Estimated Delivery" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: data && "estimatedDelivery" in data && ((_b = data == null ? void 0 : data.estimatedDelivery) == null ? void 0 : _b.dateAndTime) && dayjs(data.estimatedDelivery.dateAndTime).format("DD MMM YYYY") })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Pickup Reference" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_c = data == null ? void 0 : data.pickupReference) == null ? void 0 : _c.reference })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Delivery Reference" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_d = data == null ? void 0 : data.deliveryReference) == null ? void 0 : _d.reference })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Order Reference" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_e = data == null ? void 0 : data.orderReference) == null ? void 0 : _e.reference })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Dangerous Goods (DG's)" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: ((_f = data == null ? void 0 : data.dgClass) == null ? void 0 : _f.code) || ((_g = data == null ? void 0 : data.unNumber) == null ? void 0 : _g.note) ? `Yes-${(_i = (_h = data == null ? void 0 : data.dgClass) == null ? void 0 : _h.code) != null ? _i : EMPTY_STRING$4}-${(_k = (_j = data == null ? void 0 : data.unNumber) == null ? void 0 : _j.note) != null ? _k : EMPTY_STRING$4}` : `No` })
      ] })
    ] })
  ] });
}
function ConsignmentDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "40px" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            /* @__PURE__ */ jsx(Skeleton$9, { height: "20px", width: "24px" }),
            /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "185px" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "75px" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            /* @__PURE__ */ jsx(Skeleton$9, { height: "20px", width: "24px" }),
            /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "185px" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "130px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "85px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "125px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "85px" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "130px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "90px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "30px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "22px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.815rem", width: "30px" }),
        /* @__PURE__ */ jsx(Skeleton$9, { height: "0.9rem", width: "22px" })
      ] })
    ] })
  ] });
}

var __defProp$S = Object.defineProperty;
var __defProps$L = Object.defineProperties;
var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
var __hasOwnProp$S = Object.prototype.hasOwnProperty;
var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$S = (obj, key, value) => key in obj ? __defProp$S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$S.call(b, prop))
      __defNormalProp$S(a, prop, b[prop]);
  if (__getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(b)) {
      if (__propIsEnum$S.call(b, prop))
        __defNormalProp$S(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$L = (a, b) => __defProps$L(a, __getOwnPropDescs$L(b));
const emptyEvent = {
  eventDate: null,
  jobID: null,
  supplyChainMemberID: null,
  eventCode: null,
  eventName: null,
  eventDateUtc: null,
  timeZoneID: null,
  timeZoneCode: null,
  isRelated: null,
  isParent: null,
  isChild: null,
  milestone: null,
  milestoneName: null,
  parties: null,
  locations: null,
  measures: null,
  notes: null,
  codes: null,
  geoLocations: null,
  active: false,
  id: 0,
  created: "",
  createdBy: "",
  lastModified: "",
  lastModifiedBy: "",
  supplyChainID: 0,
  objectType: "",
  objectID: 0
};
function ConsignmentSupplyChainTimeline({ events, estimatedDelivery }) {
  var _a;
  const theme = useTheme$2();
  let timelineEvents = [];
  const bookedEvent = events.find((event) => event.eventCode === "Booked");
  if (bookedEvent) {
    timelineEvents.push(bookedEvent);
  } else {
    timelineEvents.push(__spreadProps$L(__spreadValues$S({}, emptyEvent), {
      milestoneName: "Booked"
    }));
  }
  const pickedUpEvent = events.find((event) => event.eventCode === "PickedUp");
  if (pickedUpEvent) {
    timelineEvents.push(__spreadProps$L(__spreadValues$S({}, pickedUpEvent), {
      milestoneName: "In Transit"
    }));
  } else {
    timelineEvents.push(__spreadProps$L(__spreadValues$S({}, emptyEvent), {
      milestoneName: "In Transit"
    }));
  }
  const deliveredEvent = events.find((event) => event.eventCode === "Delivered");
  if (deliveredEvent) {
    timelineEvents.push(deliveredEvent);
  } else {
    timelineEvents.push(__spreadProps$L(__spreadValues$S({}, emptyEvent), {
      milestoneName: "Estimated Delivery",
      eventDate: (_a = estimatedDelivery == null ? void 0 : estimatedDelivery.dateAndTime) != null ? _a : null
    }));
  }
  const getEventSubtitle = (event) => {
    if (event.milestoneName === "In Transit")
      return EMPTY_STRING$g;
    return event.eventDate ? dayjs(event.eventDate).format("DD MMM YYYY") : EMPTY_STRING$g;
  };
  const isEventCompleted = (event) => {
    if (event.milestoneName === "Estimated Delivery")
      return false;
    return event.eventDate ? true : false;
  };
  return /* @__PURE__ */ jsx(
    SupplyChainTimeline,
    {
      events: timelineEvents,
      size: "sm",
      labelPlacement: "top",
      getEventSubtitle,
      isEventCompleted,
      displayEventCircle: () => false,
      getProgressColor: () => theme.palette.secondary.main
    }
  );
}

function ConsignmentTrackingHistory({
  query,
  eventCodes,
  sort,
  filterEvents,
  getEventIcon,
  getEventContent
}) {
  var _a, _b, _c, _d, _e, _f;
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  const id = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id;
  const documentQuery = useQuery$1(
    ["/Document/DocumentType", id],
    () => httpService$1.get(`Document/DocumentType?objectID=${id}&objectType=Job&documentType=PODSignature`),
    { enabled: !!id }
  );
  const documents = (_c = documentQuery.data) == null ? void 0 : _c.data;
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "flex-start", children: [
    /* @__PURE__ */ jsx(Box$1, { flexGrow: 1, display: "flex", children: /* @__PURE__ */ jsx(
      EventsTimeline,
      {
        events: (_f = (_e = (_d = query.data) == null ? void 0 : _d.data) == null ? void 0 : _e.events) != null ? _f : [],
        filter: eventCodes.length > 0 ? (e) => !!e.eventCode && eventCodes.indexOf(e.eventCode) >= 0 : void 0,
        sort,
        filterEvents,
        getEventIcon,
        getEventContent
      }
    ) }),
    documents && documents.length > 0 && /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "50%", children: documents.map((document) => {
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        document.attachmentID && /* @__PURE__ */ jsx(
          "img",
          {
            src: `${process.env.ONEVENT_API_PATHNAME}/Attachment/Download/${document.attachmentID}`,
            style: { height: "5rem", fontSize: "0.8rem" },
            alt: "Invalid POD image"
          }
        ),
        document.reference && /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.8rem", children: document.reference })
      ] }, document.documentID);
    }) })
  ] });
}

const StyledTableRow$5 = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText$5 = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText$5 = styled$4(StyledText$5)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText$5 = styled$4(StyledText$5)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer$5 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function MobileContainerConsignmentOrderDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer$5, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$5, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
    /* @__PURE__ */ jsx(StyledText$5, { children: row.containerNumber }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "FULL/MT: " }),
        /* @__PURE__ */ jsxs(CellValueText$5, { children: [
          " ",
          row.fullOrMT
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "Movement Type: " }),
        /* @__PURE__ */ jsx(CellValueText$5, { children: row.movementType })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "Type: " }),
        /* @__PURE__ */ jsx(CellValueText$5, { children: row.type })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "Commodity: " }),
        /* @__PURE__ */ jsx(CellValueText$5, { children: row.commodity })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "Size: " }),
        /* @__PURE__ */ jsx(CellValueText$5, { children: row.size })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$5, { children: "Weight (kgs): " }),
        /* @__PURE__ */ jsx(CellValueText$5, { children: row.weight })
      ] })
    ] })
  ] }) }, i)) }) }) });
}
const gridColumns$5 = [
  {
    field: "containerNumber",
    flex: 1,
    headerName: "Container No"
  },
  {
    field: "fullOrMT",
    flex: 1,
    headerName: "FULL/MT"
  },
  {
    field: "movementType",
    flex: 1,
    headerName: "Movement Type"
  },
  {
    field: "type",
    flex: 1,
    headerName: "Type"
  },
  {
    field: "commodity",
    flex: 1,
    headerName: "Commodity"
  },
  {
    field: "size",
    flex: 1,
    headerName: "Size"
  },
  {
    field: "weight",
    type: "number",
    flex: 1,
    align: "left",
    headerName: "Weight (kgs)",
    headerAlign: "left"
  }
];
function ContainerConsignmentOrderDetails$1({ gridRows, gridLoading }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakPoint ? /* @__PURE__ */ jsx(MobileContainerConsignmentOrderDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: gridColumns$5,
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      autoHeight: true,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.common.black,
          fontWeight: 600
        },
        borderRadius: 0
      }
    }
  ) });
}

const StyledTableRow$4 = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText$4 = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText$4 = styled$4(StyledText$4)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText$4 = styled$4(StyledText$4)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer$4 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function MobileContainerDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer$4, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$4, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
    /* @__PURE__ */ jsx(StyledText$4, { children: row.containerNumber }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$4, { children: "Type:" }),
        /* @__PURE__ */ jsx(CellValueText$4, { children: row.type })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$4, { children: "Seal:" }),
        /* @__PURE__ */ jsx(CellValueText$4, { children: row.seal })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$4, { children: "Pieces:" }),
        /* @__PURE__ */ jsx(CellValueText$4, { children: row.pieces })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$4, { children: "Actual Weight: " }),
        /* @__PURE__ */ jsx(CellValueText$4, { children: row.actualWeight })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, justifyItems: "space-between", children: /* @__PURE__ */ jsxs(Grid$3, { item: true, children: [
      /* @__PURE__ */ jsx(CellHeaderText$4, { children: "Volume:" }),
      /* @__PURE__ */ jsx(CellValueText$4, { children: row.volume })
    ] }) })
  ] }) }, i)) }) }) });
}
function ContainerDetails$4({ gridRows, gridLoading, shipment }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const containerGridColumns = [
    {
      field: "containerNumber",
      headerName: "CONTAINER",
      resizable: true,
      flex: 1,
      renderCell: (params) => shipment ? /* @__PURE__ */ jsx("a", { href: `/#/Containers?q=${params.id}&intent=tab`, target: "_blank", rel: "noopener noreferrer", children: params.value }) : params.value
    },
    {
      field: "type",
      headerName: "TYPE",
      resizable: true,
      flex: 1
    },
    {
      field: "seal",
      headerName: "SEAL",
      resizable: true,
      flex: 1
    },
    {
      field: "pieces",
      headerName: "PIECES",
      resizable: true,
      flex: 1
    },
    {
      field: "actualWeight",
      headerName: "ACTUAL WEIGHT",
      resizable: true,
      flex: 1
    },
    {
      field: "volume",
      headerName: "VOLUME",
      resizable: true,
      flex: 1
    }
  ];
  return mobileBreakPoint ? /* @__PURE__ */ jsx(MobileContainerDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 8, children: /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: containerGridColumns,
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      autoHeight: true,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        }
      }
    }
  ) }) });
}

var __async$n = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const StyledTableRow$3 = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText$3 = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText$3 = styled$4(StyledText$3)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText$3 = styled$4(StyledText$3)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer$3 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function MobileDocumentsDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer$3, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$3, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
    /* @__PURE__ */ jsx(StyledText$3, { children: row.reference }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$3, { children: "Type: " }),
        /* @__PURE__ */ jsxs(CellValueText$3, { children: [
          " ",
          row.fileType
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$3, { children: "Size: " }),
        /* @__PURE__ */ jsx(CellValueText$3, { children: row.fileSize })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, justifyItems: "space-between", children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, children: [
      /* @__PURE__ */ jsx(CellHeaderText$3, { children: "Date Added: " }),
      /* @__PURE__ */ jsx(CellValueText$3, { children: row.created ? dayjs(row.created).format("DD/MM/YYYY") : null })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, justifyItems: "space-between", paddingTop: 2, children: /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(
      Button,
      {
        variant: "contained",
        color: "primary",
        size: "small",
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 1
        },
        children: [
          /* @__PURE__ */ jsx(DownloadSharp, { fontSize: "small" }),
          /* @__PURE__ */ jsx("span", { children: "Download" })
        ]
      }
    ) }) })
  ] }) }, i)) }) }) });
}
const DocumentsGridColumns = ({
  handleDownloadAction
}) => {
  const downloadDocuments = defaultValue(handleDownloadAction, () => {
  });
  return [
    {
      field: "filename",
      flex: 1,
      headerName: "DESCRIPTION"
    },
    {
      field: "fileType",
      flex: 1,
      headerName: "TYPE",
      valueFormatter: ({ value }) => value ? value.toUpperCase() : null
    },
    {
      field: "fileSize",
      flex: 1,
      headerName: "SIZE",
      valueFormatter: ({ value }) => value ? `${Math.round(value / 1e3)}KB` : null
    },
    {
      field: "created",
      type: "date",
      flex: 1,
      headerName: "DATE ADDED",
      valueGetter: ({ value }) => value ? new Date(value) : null,
      valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YYYY") : null
    },
    {
      field: "actions",
      type: "actions",
      flex: 1,
      getActions: (_params) => [
        /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "contained",
            color: "primary",
            size: "small",
            sx: {
              display: "flex",
              alignItems: "center",
              gap: 1
            },
            onClick: () => {
              downloadDocuments(_params.row.objectAttachmentID);
            },
            children: [
              /* @__PURE__ */ jsx(DownloadSharp, { fontSize: "small" }),
              /* @__PURE__ */ jsx("span", { children: "Download" })
            ]
          }
        )
      ]
    }
  ];
};
function DocumentsDetails$4({ gridRows, handleDownloadAction, gridLoading }) {
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const handleDownload = (objectAttachmentID) => __async$n(this, null, function* () {
    if (objectAttachmentID) {
      try {
        const fileDownload = yield httpService$1.download(`Attachment/Download/${objectAttachmentID}`);
        const fileUrl = URL.createObjectURL(fileDownload);
        const windowObject = window.open(fileUrl);
        if (windowObject) {
          windowObject.onpagehide = () => {
            URL.revokeObjectURL(fileUrl);
          };
        }
      } catch (e) {
        popup({
          message: `There's an error occurred downloading the file ${objectAttachmentID}`,
          severity: "error"
        });
        return;
      }
    }
  });
  const downloadAction = defaultValue(handleDownloadAction, handleDownload);
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakPoint ? /* @__PURE__ */ jsx(MobileDocumentsDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: DocumentsGridColumns({
        handleDownloadAction: downloadAction
      }),
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      autoHeight: true,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        }
      }
    }
  ) }) });
}

var __defProp$R = Object.defineProperty;
var __defProps$K = Object.defineProperties;
var __getOwnPropDescs$K = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
var __hasOwnProp$R = Object.prototype.hasOwnProperty;
var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$R = (obj, key, value) => key in obj ? __defProp$R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$R.call(b, prop))
      __defNormalProp$R(a, prop, b[prop]);
  if (__getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(b)) {
      if (__propIsEnum$R.call(b, prop))
        __defNormalProp$R(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$K = (a, b) => __defProps$K(a, __getOwnPropDescs$K(b));
var __objRest$p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function CodeLookup(_a) {
  var _b = _a, { multiple, getLookupDisplayText = (option) => option.name } = _b, props = __objRest$p(_b, ["multiple", "getLookupDisplayText"]);
  const transform = useMemo(
    () => ({
      input: (value) => {
        let input = value;
        if (isNothing(value)) {
          input = multiple ? [] : null;
        }
        if (Array.isArray(value)) {
          input = value.reduce((accum, curr) => {
            return curr.delete ? accum : [
              ...accum,
              {
                id: curr.codeID.toString(),
                name: defaultValue(curr.lookupDisplayText, curr.name),
                additionalData: {
                  code: curr.code
                }
              }
            ];
          }, []);
        }
        if (isObjectCode(value) && value.delete) {
          input = null;
        }
        if (isObjectCode(value) && !value.delete) {
          input = {
            id: value.codeID.toString(),
            name: defaultValue(value.lookupDisplayText, value.name),
            additionalData: {
              code: value.code
            }
          };
        }
        if (!isObjectCode(value) && typeof value !== "string") {
          input = null;
        }
        return input;
      },
      output: (option, value) => {
        var _a2, _c;
        let output = value;
        if (Array.isArray(option)) {
          const codes = Array.isArray(value) ? value.reduce((accum, curr) => {
            const match = option.find((x) => {
              return isLookupItem(x) && +x.id === curr.codeID;
            });
            return match ? !isNothing(curr.id) && curr.delete ? [...accum, __spreadProps$K(__spreadValues$R({}, curr), { delete: false })] : [...accum, curr] : !isNothing(curr.id) ? [...accum, __spreadProps$K(__spreadValues$R({}, curr), { delete: true })] : accum;
          }, []) : [];
          const additions = [...option].reduce((accum, curr) => {
            var _a3;
            const match = codes.find((x) => {
              return isLookupItem(curr) && +curr.id === x.codeID;
            });
            return match ? accum : isLookupItem(curr) ? [
              ...accum,
              {
                codeID: +curr.id,
                name: curr.name,
                code: (_a3 = curr.additionalData) == null ? void 0 : _a3.code,
                lookupDisplayText: getLookupDisplayText(curr)
              }
            ] : accum;
          }, []);
          output = [...codes, ...additions];
        }
        if (isNothing(value) && isLookupItem(option)) {
          output = {
            codeID: +option.id,
            name: option.name,
            code: (_a2 = option.additionalData) == null ? void 0 : _a2.code,
            lookupDisplayText: getLookupDisplayText(option)
          };
        }
        if (isObjectCode(value) && isNothing(value.id) && isNothing(option)) {
          const _b2 = value, rest = __objRest$p(_b2, ["codeID", "name", "code", "lookupDisplayText", "delete"]);
          output = Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectCode(value) && !isNothing(value.id) && isNothing(option)) {
          output = __spreadProps$K(__spreadValues$R({}, value), { delete: true });
        }
        if (!isNothing(value) && !Array.isArray(value) && isLookupItem(option)) {
          output = __spreadProps$K(__spreadValues$R({}, value), {
            codeID: +option.id,
            name: option.name,
            code: (_c = option.additionalData) == null ? void 0 : _c.code,
            lookupDisplayText: getLookupDisplayText(option),
            delete: false
          });
        }
        return output;
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormLookup, __spreadProps$K(__spreadValues$R({}, props), { multiple, transform }));
}

const removeTimezoneOffset = (value) => {
  var _a;
  return (_a = value == null ? void 0 : value.slice(0, 19)) != null ? _a : "";
};
const removeDateTime = (value) => value.slice(0, 10);
const formatDate$2 = (date, format) => {
  if (dayjs(date).isValid()) {
    return dayjs(date).format(format);
  }
  return "Invalid Date";
};

var __defProp$Q = Object.defineProperty;
var __defProps$J = Object.defineProperties;
var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Q = (obj, key, value) => key in obj ? __defProp$Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Q.call(b, prop))
      __defNormalProp$Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(b)) {
      if (__propIsEnum$Q.call(b, prop))
        __defNormalProp$Q(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$J = (a, b) => __defProps$J(a, __getOwnPropDescs$J(b));
var __objRest$o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const hasInputValue$4 = (value) => typeof value === "string" && value.trim().length > 0;
function DateTimeInput(props) {
  var _a, _b;
  const { data: localisationSettings } = useLocalisationSettings({ enabled: true });
  const omitTimezoneOffset = !((_b = (_a = localisationSettings == null ? void 0 : localisationSettings.dateTimeFormatting) == null ? void 0 : _a.enableBackwardCompatibility) != null ? _b : false);
  const transform = useMemo(
    () => ({
      input: (value) => {
        if (isNothing(value)) {
          return null;
        }
        if (isObjectDate(value) && value.delete) {
          return null;
        }
        if (isObjectDate(value)) {
          return omitTimezoneOffset ? removeTimezoneOffset(value.dateAndTime) : value.dateAndTime;
        }
        return null;
      },
      output: (input, value) => {
        const dateAndTime = omitTimezoneOffset ? removeTimezoneOffset(input) : input;
        if (isNothing(value) && isNothing(input)) {
          return null;
        }
        if (isNothing(value) && !hasInputValue$4(input)) {
          return null;
        }
        if (isObjectDate(value) && isNothing(value.id) && !hasInputValue$4(input)) {
          const _a2 = value, rest = __objRest$o(_a2, ["dateAndTime"]);
          return Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectDate(value) && !isNothing(value.id) && !hasInputValue$4(input)) {
          return __spreadProps$J(__spreadValues$Q({}, value), { delete: true });
        }
        if (isObjectDate(value) && !isNothing(value.id) && hasInputValue$4(input)) {
          return __spreadProps$J(__spreadValues$Q({}, value), { dateAndTime, delete: false });
        }
        return __spreadProps$J(__spreadValues$Q({}, value), { dateAndTime });
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormDateTimePicker, __spreadProps$J(__spreadValues$Q({}, props), { transform }));
}

var __defProp$P = Object.defineProperty;
var __defProps$I = Object.defineProperties;
var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
var __hasOwnProp$P = Object.prototype.hasOwnProperty;
var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$P = (obj, key, value) => key in obj ? __defProp$P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$P.call(b, prop))
      __defNormalProp$P(a, prop, b[prop]);
  if (__getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(b)) {
      if (__propIsEnum$P.call(b, prop))
        __defNormalProp$P(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$I = (a, b) => __defProps$I(a, __getOwnPropDescs$I(b));
var __objRest$n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function LocationLookup(_a) {
  var _b = _a, { multiple } = _b, props = __objRest$n(_b, ["multiple"]);
  const transform = useMemo(
    () => ({
      input: (value) => {
        let input = value;
        if (isNothing(value)) {
          input = multiple ? [] : null;
        }
        if (Array.isArray(value)) {
          input = value.reduce((accum, curr) => {
            return curr.delete ? accum : [
              ...accum,
              {
                id: curr.locationID.toString(),
                name: defaultValue(curr.lookupDisplayText, curr.locationName)
              }
            ];
          }, []);
        }
        if (isObjectLocation(value) && value.delete) {
          input = null;
        }
        if (isObjectLocation(value) && !value.delete) {
          input = {
            id: value.locationID.toString(),
            name: defaultValue(value.lookupDisplayText, value.locationName)
          };
        }
        if (!isObjectLocation(value) && typeof value !== "string") {
          input = null;
        }
        return input;
      },
      output: (option, value) => {
        var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
        let output = value;
        if (Array.isArray(option)) {
          const locations = Array.isArray(value) ? value.reduce((accum, curr) => {
            const match = option.find((x) => {
              return isLookupItem(x) && +x.id === curr.locationID;
            });
            return match ? !isNothing(curr.id) && curr.delete ? [...accum, __spreadProps$I(__spreadValues$P({}, curr), { delete: false })] : [...accum, curr] : !isNothing(curr.id) ? [...accum, __spreadProps$I(__spreadValues$P({}, curr), { delete: true })] : accum;
          }, []) : [];
          const additions = [...option].reduce((accum, curr) => {
            var _a3, _b3;
            const match = locations.find((x) => {
              return isLookupItem(curr) && +curr.id === x.locationID;
            });
            return match ? accum : isLookupItem(curr) ? [
              ...accum,
              {
                locationID: +curr.id,
                locationName: curr.name,
                lookupDisplayText: curr.name,
                timeZoneID: (_a3 = curr.additionalData) == null ? void 0 : _a3.timeZoneID,
                combinedCode: (_b3 = curr.additionalData) == null ? void 0 : _b3.combinedCode
              }
            ] : accum;
          }, []);
          output = [...locations, ...additions];
        }
        if (isNothing(value) && isLookupItem(option)) {
          output = {
            locationID: +option.id,
            locationName: option.name,
            lookupDisplayText: option.name,
            timeZoneID: (_a2 = option.additionalData) == null ? void 0 : _a2.timeZoneID,
            combinedCode: (_b2 = option.additionalData) == null ? void 0 : _b2.combinedCode,
            address1: (_c = option.additionalData) == null ? void 0 : _c.address1,
            address2: (_d = option.additionalData) == null ? void 0 : _d.address2,
            email: (_e = option.additionalData) == null ? void 0 : _e.email,
            mobile: (_f = option.additionalData) == null ? void 0 : _f.mobile,
            postcode: (_g = option.additionalData) == null ? void 0 : _g.postcode,
            state: (_h = option.additionalData) == null ? void 0 : _h.state,
            suburb: (_i = option.additionalData) == null ? void 0 : _i.suburb,
            contact: (_j = option.additionalData) == null ? void 0 : _j.contact
          };
        }
        if (isObjectLocation(value) && isNothing(value.id) && isNothing(option)) {
          const _k = value, rest = __objRest$n(_k, ["locationID", "locationName", "lookupDisplayText", "delete"]);
          output = Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectLocation(value) && !isNothing(value.id) && isNothing(option)) {
          output = __spreadProps$I(__spreadValues$P({}, value), { delete: true });
        }
        if (!isNothing(value) && !Array.isArray(value) && isLookupItem(option)) {
          output = __spreadProps$I(__spreadValues$P({}, value), {
            locationID: +option.id,
            locationName: option.name,
            lookupDisplayText: option.name,
            delete: false,
            timeZoneID: (_l = option.additionalData) == null ? void 0 : _l.timeZoneID,
            combinedCode: (_m = option.additionalData) == null ? void 0 : _m.combinedCode,
            address1: (_n = option.additionalData) == null ? void 0 : _n.address1,
            address2: (_o = option.additionalData) == null ? void 0 : _o.address2,
            email: (_p = option.additionalData) == null ? void 0 : _p.email,
            mobile: (_q = option.additionalData) == null ? void 0 : _q.mobile,
            postcode: (_r = option.additionalData) == null ? void 0 : _r.postcode,
            state: (_s = option.additionalData) == null ? void 0 : _s.state,
            suburb: (_t = option.additionalData) == null ? void 0 : _t.suburb,
            contact: (_u = option.additionalData) == null ? void 0 : _u.contact
          });
        }
        return output;
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormLookup, __spreadProps$I(__spreadValues$P({}, props), { multiple, transform }));
}

class FormInputOnChangeCancellationException extends Error {
  constructor() {
    super("[FormInput] The `onChange` action was cancelled");
    Object.setPrototypeOf(this, FormInputOnChangeCancellationException.prototype);
    this.name = "FormInputOnChangeCancellationException";
  }
}

var __defProp$O = Object.defineProperty;
var __defProps$H = Object.defineProperties;
var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
var __hasOwnProp$O = Object.prototype.hasOwnProperty;
var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$O = (obj, key, value) => key in obj ? __defProp$O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$O.call(b, prop))
      __defNormalProp$O(a, prop, b[prop]);
  if (__getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(b)) {
      if (__propIsEnum$O.call(b, prop))
        __defNormalProp$O(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$H = (a, b) => __defProps$H(a, __getOwnPropDescs$H(b));
var __objRest$m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$3 = "";
const hasInputValue$3 = (value) => typeof value === "string" && value.trim().length > 0;
const parseNumber$3 = (value, pattern) => {
  return (value.match(pattern) || []).join(EMPTY_STRING$3);
};
const MuiDiv = styled$4("div")(() => ({
  "&:focus-within ~ div": {
    borderWidth: "2px",
    borderLeftWidth: "1px"
  }
}));
const UnitOfMeasureEl = styled$4("div")(({ theme, error }) => ({
  padding: "4px",
  font: "normal normal normal 13px/15.5px 'Open Sans'",
  backgroundColor: theme.palette.grey[50],
  border: "1px solid",
  borderColor: error ? "#FF0000" : theme.palette.grey[400],
  borderLeftColor: theme.palette.grey[400],
  borderTopRightRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center"
}));
function MeasureInput(_a) {
  var _b = _a, {
    name,
    required,
    primary = false,
    decimalPlaces = 4,
    shouldUnregister,
    accept = /[\d.]+/g,
    mask = false,
    format = (input) => {
      const parsed = parseNumber$3(input, accept);
      const [head, tail] = parsed.split(".");
      const truncatedTail = !isNothing(tail) ? tail.slice(0, decimalPlaces) : EMPTY_STRING$3;
      const number = Number.parseFloat(`${head}.${truncatedTail}`);
      if (Number.isNaN(number)) {
        return EMPTY_STRING$3;
      }
      const formatted = number.toLocaleString(window.navigator.language, {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimalPlaces
      });
      if (parsed.includes(".")) {
        const [formattedHead] = formatted.split(".");
        const formattedTail = truncatedTail !== EMPTY_STRING$3 && truncatedTail[decimalPlaces - 1] === "0" ? truncatedTail.slice(0, -1) : truncatedTail;
        return `${formattedHead}.${formattedTail}`;
      }
      return formatted;
    },
    onChange
  } = _b, props = __objRest$m(_b, [
    "name",
    "required",
    "primary",
    "decimalPlaces",
    "shouldUnregister",
    "accept",
    "mask",
    "format",
    "onChange"
  ]);
  const { control } = useFormContext();
  const formatRef = useRef();
  const transform = useMemo(
    () => ({
      input: (value) => {
        if (isNothing(value)) {
          return null;
        }
        if (isObjectMeasure(value) && value.delete) {
          return null;
        }
        if (isObjectMeasure(value)) {
          return defaultValue(formatRef.current, defaultValue(value == null ? void 0 : value.measure, EMPTY_STRING$3).toString());
        }
        return null;
      },
      output: (input, value) => {
        if (isNothing(value) && isNothing(input)) {
          return null;
        }
        if (isNothing(value) && !hasInputValue$3(input)) {
          return null;
        }
        if (isObjectMeasure(value) && isNothing(value.id) && !hasInputValue$3(input)) {
          const _a2 = value, rest = __objRest$m(_a2, ["measure", "primary", "delete"]);
          return Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectMeasure(value) && !isNothing(value.id) && !hasInputValue$3(input)) {
          return __spreadProps$H(__spreadValues$O({}, value), { delete: true });
        }
        if (isObjectMeasure(value) && !isNothing(value.id) && hasInputValue$3(input)) {
          return __spreadProps$H(__spreadValues$O({}, value), { primary, measure: +input, delete: false });
        }
        return __spreadProps$H(__spreadValues$O({}, value), { primary, measure: +input });
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(
    Controller,
    {
      shouldUnregister,
      name,
      control,
      defaultValue: null,
      render: ({
        field: { onChange: controllerOnChange, onBlur: controllerOnBlur, value, ref },
        fieldState: { error }
      }) => /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "stretch", children: [
        /* @__PURE__ */ jsx(MuiDiv, { sx: { display: "flex", flexGrow: 1, alignItems: "flex-end" }, children: /* @__PURE__ */ jsx(
          Input$2,
          __spreadProps$H(__spreadValues$O({}, props), {
            type: "tel",
            name,
            accept,
            mask,
            format,
            value: defaultValue(transform.input(value), EMPTY_STRING$3),
            error: !isNothing(error),
            sx: __spreadValues$O(__spreadValues$O({}, isNothing(value == null ? void 0 : value.measureUnitType) ? {} : {
              "& .MuiOutlinedInput-root": {
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRight: "none"
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  top: "-4px",
                  borderRightWidth: "1px"
                }
              }
            }), props.sx),
            onBlur: controllerOnBlur,
            onChange: (input) => {
              try {
                if (typeof onChange === "function") {
                  onChange(input);
                }
                const output = formatRef.current = parseNumber$3(input, accept);
                controllerOnChange(transform.output(output, value));
              } catch (e) {
                if (e instanceof Error) {
                  switch (e.constructor) {
                    case FormInputOnChangeCancellationException:
                      break;
                    default:
                      console.error(e.message);
                  }
                }
              }
            },
            InputProps: {
              ref
            },
            helperText: error == null ? void 0 : error.message,
            FormHelperTextProps: {
              sx: {
                marginX: 0
              }
            }
          })
        ) }),
        !isNothing(value == null ? void 0 : value.measureUnitType) && /* @__PURE__ */ jsx(UnitOfMeasureEl, { error: !isNothing(error), children: /* @__PURE__ */ jsx("span", { children: inflect(
          pluralize(`${value.measureUnitType}`),
          defaultValue(value == null ? void 0 : value.measure, 0)
        ) }) })
      ] })
    }
  );
}

var __defProp$N = Object.defineProperty;
var __defProps$G = Object.defineProperties;
var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
var __hasOwnProp$N = Object.prototype.hasOwnProperty;
var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$N = (obj, key, value) => key in obj ? __defProp$N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$N.call(b, prop))
      __defNormalProp$N(a, prop, b[prop]);
  if (__getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(b)) {
      if (__propIsEnum$N.call(b, prop))
        __defNormalProp$N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$G = (a, b) => __defProps$G(a, __getOwnPropDescs$G(b));
var __objRest$l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const hasInputValue$2 = (value) => typeof value === "string" && value.trim().length > 0;
function NoteInput(props) {
  const transform = useMemo(
    () => ({
      input: (value) => {
        if (isNothing(value)) {
          return null;
        }
        if (isObjectNote(value) && value.delete) {
          return null;
        }
        if (isObjectNote(value)) {
          return value.note;
        }
        return null;
      },
      output: (input, value) => {
        if (isNothing(value) && isNothing(input)) {
          return null;
        }
        if (isNothing(value) && !hasInputValue$2(input)) {
          return null;
        }
        if (isObjectNote(value) && isNothing(value.id) && !hasInputValue$2(input)) {
          const _a = value, rest = __objRest$l(_a, ["note", "delete"]);
          return Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectNote(value) && !isNothing(value.id) && !hasInputValue$2(input)) {
          return __spreadProps$G(__spreadValues$N({}, value), { delete: true });
        }
        if (isObjectNote(value) && !isNothing(value.id) && hasInputValue$2(input)) {
          return __spreadProps$G(__spreadValues$N({}, value), { note: input, delete: false });
        }
        return __spreadProps$G(__spreadValues$N({}, value), { note: input });
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormInput, __spreadProps$G(__spreadValues$N({}, props), { transform }));
}

var __defProp$M = Object.defineProperty;
var __defProps$F = Object.defineProperties;
var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
var __hasOwnProp$M = Object.prototype.hasOwnProperty;
var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$M = (obj, key, value) => key in obj ? __defProp$M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$M.call(b, prop))
      __defNormalProp$M(a, prop, b[prop]);
  if (__getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(b)) {
      if (__propIsEnum$M.call(b, prop))
        __defNormalProp$M(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$F = (a, b) => __defProps$F(a, __getOwnPropDescs$F(b));
var __objRest$k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function PartyLookup(_a) {
  var _b = _a, { multiple } = _b, props = __objRest$k(_b, ["multiple"]);
  const transform = useMemo(
    () => ({
      input: (value) => {
        let input = value;
        if (isNothing(value)) {
          input = multiple ? [] : null;
        }
        if (Array.isArray(value)) {
          input = value.reduce((accum, curr) => {
            return curr.delete ? accum : [
              ...accum,
              {
                id: curr.contactID.toString(),
                name: defaultValue(curr.lookupDisplayText, curr.fileAs)
              }
            ];
          }, []);
        }
        if (isObjectParty(value) && value.delete) {
          input = null;
        }
        if (isObjectParty(value) && !value.delete) {
          input = {
            id: value.contactID.toString(),
            name: defaultValue(value.lookupDisplayText, value.fileAs)
          };
        }
        if (!isObjectParty(value) && typeof value !== "string") {
          input = null;
        }
        return input;
      },
      output: (option, value) => {
        var _a2, _c;
        let output = value;
        if (Array.isArray(option)) {
          const parties = Array.isArray(value) ? value.reduce((accum, curr) => {
            const match = option.find((x) => {
              return isLookupItem(x) && +x.id === curr.contactID;
            });
            return match ? !isNothing(curr.id) && curr.delete ? [...accum, __spreadProps$F(__spreadValues$M({}, curr), { delete: false })] : [...accum, curr] : !isNothing(curr.id) ? [...accum, __spreadProps$F(__spreadValues$M({}, curr), { delete: true })] : accum;
          }, []) : [];
          const additions = [...option].reduce((accum, curr) => {
            var _a3;
            const match = parties.find((x) => {
              return isLookupItem(curr) && +curr.id === x.contactID;
            });
            return match ? accum : isLookupItem(curr) ? [
              ...accum,
              {
                contactID: +curr.id,
                fileAs: curr.name,
                lookupDisplayText: curr.name,
                code: (_a3 = curr.additionalData) == null ? void 0 : _a3.code
              }
            ] : accum;
          }, []);
          output = [...parties, ...additions];
        }
        if (isNothing(value) && isLookupItem(option)) {
          output = {
            contactID: +option.id,
            fileAs: option.name,
            lookupDisplayText: option.name,
            code: (_a2 = option.additionalData) == null ? void 0 : _a2.code
          };
        }
        if (isObjectParty(value) && isNothing(value.id) && isNothing(option)) {
          const _b2 = value, rest = __objRest$k(_b2, ["contactID", "fileAs", "lookupDisplayText"]);
          output = Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectParty(value) && !isNothing(value.id) && isNothing(option)) {
          output = __spreadProps$F(__spreadValues$M({}, value), { delete: true });
        }
        if (!isNothing(value) && !Array.isArray(value) && isLookupItem(option)) {
          output = __spreadProps$F(__spreadValues$M({}, value), {
            contactID: +option.id,
            fileAs: option.name,
            lookupDisplayText: option.name,
            delete: false,
            code: (_c = option.additionalData) == null ? void 0 : _c.code
          });
        }
        return output;
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormLookup, __spreadProps$F(__spreadValues$M({}, props), { multiple, transform }));
}

var __defProp$L = Object.defineProperty;
var __defProps$E = Object.defineProperties;
var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
var __hasOwnProp$L = Object.prototype.hasOwnProperty;
var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$L = (obj, key, value) => key in obj ? __defProp$L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$L.call(b, prop))
      __defNormalProp$L(a, prop, b[prop]);
  if (__getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(b)) {
      if (__propIsEnum$L.call(b, prop))
        __defNormalProp$L(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$E = (a, b) => __defProps$E(a, __getOwnPropDescs$E(b));
var __objRest$j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const hasInputValue$1 = (value) => typeof value === "string" && value.trim().length > 0;
function ReferenceInput(props) {
  const transform = useMemo(
    () => ({
      input: (value) => {
        if (isNothing(value)) {
          return null;
        }
        if (isObjectReference(value) && value.delete) {
          return null;
        }
        if (isObjectReference(value)) {
          return value.reference;
        }
        return null;
      },
      output: (input, value) => {
        if (isNothing(value) && isNothing(input)) {
          return null;
        }
        if (isNothing(value) && !hasInputValue$1(input)) {
          return null;
        }
        if (isObjectReference(value) && isNothing(value.id) && !hasInputValue$1(input)) {
          const _a = value, rest = __objRest$j(_a, ["reference", "delete"]);
          return Object.keys(rest).length > 0 ? rest : null;
        }
        if (isObjectReference(value) && !isNothing(value.id) && !hasInputValue$1(input)) {
          return __spreadProps$E(__spreadValues$L({}, value), { delete: true });
        }
        if (isObjectReference(value) && !isNothing(value.id) && hasInputValue$1(input)) {
          return __spreadProps$E(__spreadValues$L({}, value), { reference: input, delete: false });
        }
        return __spreadProps$E(__spreadValues$L({}, value), { reference: input });
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(FormInput, __spreadProps$E(__spreadValues$L({}, props), { transform }));
}

var __defProp$K = Object.defineProperty;
var __defProps$D = Object.defineProperties;
var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
var __hasOwnProp$K = Object.prototype.hasOwnProperty;
var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$K = (obj, key, value) => key in obj ? __defProp$K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$K.call(b, prop))
      __defNormalProp$K(a, prop, b[prop]);
  if (__getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(b)) {
      if (__propIsEnum$K.call(b, prop))
        __defNormalProp$K(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$D = (a, b) => __defProps$D(a, __getOwnPropDescs$D(b));
var __objRest$i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const hasInputValue = (value) => typeof value === "string" && value.trim().length > 0;
function MarkInput(props) {
  const transform = {
    input: (value) => {
      if (isNothing(value)) {
        return null;
      }
      if (isObjectMark(value)) {
        if (value.delete) {
          return null;
        }
        return value.value;
      }
      return null;
    },
    output: (input, value) => {
      if (isNothing(value) && isNothing(input)) {
        return null;
      }
      if (isNothing(value) && !hasInputValue(input)) {
        return null;
      }
      if (isObjectMark(value) && isNothing(value.id) && !hasInputValue(input)) {
        const _a = value, rest = __objRest$i(_a, ["value"]);
        return Object.keys(rest).length > 0 ? rest : null;
      }
      if (isObjectMark(value) && !isNothing(value.id) && !hasInputValue(input)) {
        return __spreadProps$D(__spreadValues$K({}, value), { delete: true });
      }
      if (isObjectMark(value) && !isNothing(value.id) && hasInputValue(input)) {
        return __spreadProps$D(__spreadValues$K({}, value), { value: input, delete: false });
      }
      return __spreadProps$D(__spreadValues$K({}, value), { value: input });
    }
  };
  return /* @__PURE__ */ jsx(
    FormInput,
    __spreadProps$D(__spreadValues$K({}, props), {
      transform,
      inputProps: {
        maxLength: 1e3
      }
    })
  );
}

var __defProp$J = Object.defineProperty;
var __defProps$C = Object.defineProperties;
var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
var __hasOwnProp$J = Object.prototype.hasOwnProperty;
var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$J = (obj, key, value) => key in obj ? __defProp$J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$J.call(b, prop))
      __defNormalProp$J(a, prop, b[prop]);
  if (__getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(b)) {
      if (__propIsEnum$J.call(b, prop))
        __defNormalProp$J(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$C = (a, b) => __defProps$C(a, __getOwnPropDescs$C(b));
var __async$m = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const enquiryModalValidation = z$1.object({
  jobReference: z$1.string(),
  subject: z$1.object({
    lookupDisplayText: z$1.string()
  }, {
    invalid_type_error: "Please select an enquiry subject for your enquiry.",
    required_error: "Please select an enquiry subject for your enquiry."
  }),
  comments: z$1.string({
    invalid_type_error: "Please provide comments on your enquiry.",
    required_error: "Please provide comments on your enquiry."
  }),
  name: z$1.string({
    invalid_type_error: "Please provde your name on your enquiry.",
    required_error: "Please provde your name on your enquiry."
  })
}).and(
  z$1.object({
    phone: z$1.string({
      invalid_type_error: "Please provide a phone number.",
      required_error: "Please provide a phone number."
    }).min(1, "Please provide a phone number."),
    email: z$1.string().email("Please provide a valid email address.").nullable()
  }).or(z$1.object({
    phone: z$1.string().nullable(),
    email: z$1.string({
      invalid_type_error: "Please provide an email address.",
      required_error: "Please provide an email address."
    }).email("Please provide a valid email address.")
  }))
);
function EnquiryModal({ setOpen, enquiryDefaultValues, handleSendInvoiceEnquiry }) {
  const theme = useTheme$2();
  const onSubmitHandler = (state) => {
    if (typeof handleSendInvoiceEnquiry === "function") {
      handleSendInvoiceEnquiry(state);
    }
    void setOpen(false);
  };
  const [_, Form] = useForm({
    defaultValues: enquiryDefaultValues,
    onSubmit: onSubmitHandler,
    validationSchema: enquiryModalValidation
  });
  return /* @__PURE__ */ jsxs(
    Dialog$1,
    {
      fullWidth: true,
      open: true,
      onClose: (_2, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setOpen(false);
        }
      },
      scroll: "paper",
      children: [
        /* @__PURE__ */ jsxs(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: [
              /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: "Enquiry" }),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  onClick: () => setOpen(false),
                  sx: {
                    padding: 0
                  },
                  edge: "end",
                  color: "inherit",
                  "aria-label": "close",
                  children: /* @__PURE__ */ jsx(Close, { sx: { flexGrow: 1 } })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Form, { children: [
          /* @__PURE__ */ jsx(DialogContent$1, { children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "jobReference", label: "Consignment Number" }),
              /* @__PURE__ */ jsx(Input$2, { name: "jobReference", value: enquiryDefaultValues.jobReference, readOnly: true })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "subject", label: "Enquiry Subject", required: true }),
              /* @__PURE__ */ jsx(
                CodeLookup,
                {
                  name: "subject",
                  params: {
                    systemName: "Code",
                    additionalFilter: {
                      codeQualifier: "ConsignmentEnquirySubject"
                    }
                  },
                  renderOption: (props, option) => {
                    var _a;
                    return /* @__PURE__ */ jsx("li", __spreadProps$C(__spreadValues$J({}, props), { children: (_a = option.additionalData) == null ? void 0 : _a.codeName }));
                  },
                  getLookupDisplayText: (option) => {
                    var _a;
                    return defaultValue((_a = option.additionalData) == null ? void 0 : _a.codeName, option.name);
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "comments", label: "Comments", required: true }),
              /* @__PURE__ */ jsx(FormInput, { name: "comments", multiline: true, minRows: 4 })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "name", label: "Sender Name", required: true }),
              /* @__PURE__ */ jsx(FormInput, { name: "name" })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "phone", label: "Phone" }),
              /* @__PURE__ */ jsx(FormPhoneInput, { name: "phone" })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "email", label: "Email" }),
              /* @__PURE__ */ jsx(FormInput, { name: "email" })
            ] })
          ] }) }),
          /* @__PURE__ */ jsx(DialogActions$1, { sx: { padding: 4 }, children: /* @__PURE__ */ jsx(Button, { type: "submit", variant: "contained", color: "primary", children: "Send" }) })
        ] })
      ]
    }
  );
}
function Enquiry({ setIsOpenEnquiryDialog, defaultValues }) {
  const popup = usePopupAlert();
  const handleCloseEnquiryDialog = () => {
    setIsOpenEnquiryDialog(false);
  };
  const handleSendEnquiryButton = (data) => __async$m(this, null, function* () {
    var _a;
    const enquiryPayload = {
      reference: data == null ? void 0 : data.jobReference,
      reason: (_a = data == null ? void 0 : data.subject) == null ? void 0 : _a.lookupDisplayText,
      comments: data == null ? void 0 : data.comments,
      name: data == null ? void 0 : data.name,
      phone: data == null ? void 0 : data.phone,
      email: data == null ? void 0 : data.email
    };
    try {
      const response = yield httpService$1.post("JobEnquiry/SendJobEnquiry", enquiryPayload);
      if (response) {
        popup({
          message: "Enquiry is successfully sent",
          severity: "success"
        });
      }
    } catch (error) {
      popup({
        message: "Error on sending enquiry",
        severity: "error"
      });
    }
  });
  return createPortal(
    /* @__PURE__ */ jsx(
      EnquiryModal,
      {
        enquiryDefaultValues: defaultValues,
        setOpen: handleCloseEnquiryDialog,
        handleSendInvoiceEnquiry: handleSendEnquiryButton
      }
    ),
    document.body
  );
}

/**
 * @ignore - internal component.
 */
const TimelineContext = /*#__PURE__*/React$1.createContext({});
if (process.env.NODE_ENV !== 'production') {
  TimelineContext.displayName = 'TimelineContext';
}

function getTimelineUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimeline', slot);
}
generateUtilityClasses$1('MuiTimeline', ['root', 'positionLeft', 'positionRight', 'positionAlternate', 'positionAlternateReverse']);

function convertTimelinePositionToClass(position) {
  return position === 'alternate-reverse' ? 'positionAlternateReverse' : `position${capitalize$1(position)}`;
}

const _excluded$5 = ["position", "className"];
const useUtilityClasses$5 = ownerState => {
  const {
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', position && convertTimelinePositionToClass(position)]
  };
  return composeClasses(slots, getTimelineUtilityClass, classes);
};
const TimelineRoot = styled$3('ul', {
  name: 'MuiTimeline',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.position && styles[convertTimelinePositionToClass(ownerState.position)]];
  }
})({
  display: 'flex',
  flexDirection: 'column',
  padding: '6px 16px',
  flexGrow: 1
});

/**
 *
 * Demos:
 *
 * - [Timeline](https://mui.com/material-ui/react-timeline/)
 *
 * API:
 *
 * - [Timeline API](https://mui.com/material-ui/api/timeline/)
 */
const Timeline = /*#__PURE__*/React$1.forwardRef(function Timeline(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimeline'
  });
  const {
      position = 'right',
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$5);
  const ownerState = _extends$c({}, props, {
    position
  });
  const classes = useUtilityClasses$5(ownerState);
  const contextValue = React$1.useMemo(() => ({
    position
  }), [position]);
  return /*#__PURE__*/jsx(TimelineContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx(TimelineRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState
      // @ts-expect-error TypeScript bug, need to keep unknown for DX
      ,
      ref: ref
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Timeline.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The position where the TimelineContent should appear relative to the time axis.
   * @default 'right'
   */
  position: PropTypes.oneOf(['alternate-reverse', 'alternate', 'left', 'right']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;

/**
 *
 * Demos:
 *
 * - [Timeline](https://mui.com/components/timeline/)
 *
 * API:
 *
 * - [Timeline API](https://mui.com/api/timeline/)
 */
var Timeline$1 = Timeline;

function getTimelineConnectorUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimelineConnector', slot);
}
generateUtilityClasses$1('MuiTimelineConnector', ['root']);

const _excluded$4 = ["className"];
const useUtilityClasses$4 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTimelineConnectorUtilityClass, classes);
};
const TimelineConnectorRoot = styled$3('span', {
  name: 'MuiTimelineConnector',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  return {
    width: 2,
    backgroundColor: (theme.vars || theme).palette.grey[400],
    flexGrow: 1
  };
});
const TimelineConnector = /*#__PURE__*/React$1.forwardRef(function TimelineConnector(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimelineConnector'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$4);
  const ownerState = props;
  const classes = useUtilityClasses$4(ownerState);
  return /*#__PURE__*/jsx(TimelineConnectorRoot, _extends$c({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? TimelineConnector.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TimelineConnector$1 = TimelineConnector;

function getTimelineContentUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimelineContent', slot);
}
const timelineContentClasses = generateUtilityClasses$1('MuiTimelineContent', ['root', 'positionLeft', 'positionRight', 'positionAlternate', 'positionAlternateReverse']);
var timelineContentClasses$1 = timelineContentClasses;

const _excluded$3 = ["className"];
const useUtilityClasses$3 = ownerState => {
  const {
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', convertTimelinePositionToClass(position)]
  };
  return composeClasses(slots, getTimelineContentUtilityClass, classes);
};
const TimelineContentRoot = styled$3(Typography, {
  name: 'MuiTimelineContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[convertTimelinePositionToClass(ownerState.position)]];
  }
})(({
  ownerState
}) => _extends$c({
  flex: 1,
  padding: '6px 16px',
  textAlign: 'left'
}, ownerState.position === 'left' && {
  textAlign: 'right'
}));
const TimelineContent = /*#__PURE__*/React$1.forwardRef(function TimelineContent(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimelineContent'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$3);
  const {
    position: positionContext
  } = React$1.useContext(TimelineContext);
  const ownerState = _extends$c({}, props, {
    position: positionContext || 'right'
  });
  const classes = useUtilityClasses$3(ownerState);
  return /*#__PURE__*/jsx(TimelineContentRoot, _extends$c({
    component: "div",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? TimelineContent.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TimelineContent$1 = TimelineContent;

function getTimelineOppositeContentUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimelineOppositeContent', slot);
}
const timelineOppositeContentClasses = generateUtilityClasses$1('MuiTimelineOppositeContent', ['root', 'positionLeft', 'positionRight', 'positionAlternate', 'positionAlternateReverse']);

const _excluded$2 = ["className"];
const useUtilityClasses$2 = ownerState => {
  const {
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', convertTimelinePositionToClass(position)]
  };
  return composeClasses(slots, getTimelineOppositeContentUtilityClass, classes);
};
const TimelineOppositeContentRoot = styled$3(Typography, {
  name: 'MuiTimelineOppositeContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[convertTimelinePositionToClass(ownerState.position)]];
  }
})(({
  ownerState
}) => _extends$c({
  padding: '6px 16px',
  marginRight: 'auto',
  textAlign: 'right',
  flex: 1
}, ownerState.position === 'left' && {
  textAlign: 'left'
}));
const TimelineOppositeContent = /*#__PURE__*/React$1.forwardRef(function TimelineOppositeContent(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimelineOppositeContent'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$2);
  const {
    position: positionContext
  } = React$1.useContext(TimelineContext);
  const ownerState = _extends$c({}, props, {
    position: positionContext || 'left'
  });
  const classes = useUtilityClasses$2(ownerState);
  return /*#__PURE__*/jsx(TimelineOppositeContentRoot, _extends$c({
    component: "div",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? TimelineOppositeContent.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
TimelineOppositeContent.muiName = 'TimelineOppositeContent';

function getTimelineItemUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimelineItem', slot);
}
const timelineItemClasses = generateUtilityClasses$1('MuiTimelineItem', ['root', 'positionLeft', 'positionRight', 'positionAlternate', 'positionAlternateReverse', 'missingOppositeContent']);
var timelineItemClasses$1 = timelineItemClasses;

const _excluded$1 = ["position", "className"];
const useUtilityClasses$1 = ownerState => {
  const {
    position,
    classes,
    hasOppositeContent
  } = ownerState;
  const slots = {
    root: ['root', convertTimelinePositionToClass(position), !hasOppositeContent && 'missingOppositeContent']
  };
  return composeClasses(slots, getTimelineItemUtilityClass, classes);
};
const TimelineItemRoot = styled$3('li', {
  name: 'MuiTimelineItem',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[convertTimelinePositionToClass(ownerState.position)]];
  }
})(({
  ownerState
}) => _extends$c({
  listStyle: 'none',
  display: 'flex',
  position: 'relative',
  minHeight: 70
}, ownerState.position === 'left' && {
  flexDirection: 'row-reverse'
}, (ownerState.position === 'alternate' || ownerState.position === 'alternate-reverse') && {
  [`&:nth-of-type(${ownerState.position === 'alternate' ? 'even' : 'odd'})`]: {
    flexDirection: 'row-reverse',
    [`& .${timelineContentClasses$1.root}`]: {
      textAlign: 'right'
    },
    [`& .${timelineOppositeContentClasses.root}`]: {
      textAlign: 'left'
    }
  }
}, !ownerState.hasOppositeContent && {
  '&:before': {
    content: '""',
    flex: 1,
    padding: '6px 16px'
  }
}));
const TimelineItem = /*#__PURE__*/React$1.forwardRef(function TimelineItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimelineItem'
  });
  const {
      position: positionProp,
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded$1);
  const {
    position: positionContext
  } = React$1.useContext(TimelineContext);
  let hasOppositeContent = false;
  React$1.Children.forEach(props.children, child => {
    if (isMuiElement(child, ['TimelineOppositeContent'])) {
      hasOppositeContent = true;
    }
  });
  const ownerState = _extends$c({}, props, {
    position: positionProp || positionContext || 'right',
    hasOppositeContent
  });
  const classes = useUtilityClasses$1(ownerState);
  const contextValue = React$1.useMemo(() => ({
    position: ownerState.position
  }), [ownerState.position]);
  return /*#__PURE__*/jsx(TimelineContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx(TimelineItemRoot, _extends$c({
      className: clsx(classes.root, className),
      ownerState: ownerState,
      ref: ref
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TimelineItem.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The position where the timeline's item should appear.
   */
  position: PropTypes.oneOf(['alternate-reverse', 'alternate', 'left', 'right']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TimelineItem$1 = TimelineItem;

function getTimelineSeparatorUtilityClass(slot) {
  return generateUtilityClass$1('MuiTimelineSeparator', slot);
}
generateUtilityClasses$1('MuiTimelineSeparator', ['root']);

const _excluded = ["className"];
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTimelineSeparatorUtilityClass, classes);
};
const TimelineSeparatorRoot = styled$3('div', {
  name: 'MuiTimelineSeparator',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column',
  flex: 0,
  alignItems: 'center'
});
const TimelineSeparator = /*#__PURE__*/React$1.forwardRef(function TimelineSeparator(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTimelineSeparator'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose$b(props, _excluded);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/jsx(TimelineSeparatorRoot, _extends$c({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? TimelineSeparator.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TimelineSeparator$1 = TimelineSeparator;

function TrackingTimeline$5({
  events = [],
  getEventIcon = (event) => {
    var _a;
    return /* @__PURE__ */ jsx(
      CheckCircle,
      {
        sx: {
          color: ((_a = event == null ? void 0 : event.eventCode) == null ? void 0 : _a.toLowerCase()) === "delivered" && (event == null ? void 0 : event.completedDate) !== null ? "green" : "initial"
        }
      }
    );
  },
  getEventSeparator = (_) => /* @__PURE__ */ jsx(TimelineConnector$1, {}),
  getEventContent = (_) => /* @__PURE__ */ jsx(Fragment, {})
}) {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(
    Timeline$1,
    {
      sx: {
        margin: 0,
        padding: 0,
        [`& .${timelineItemClasses$1.root}:before`]: {
          flex: 0,
          padding: 0
        },
        [`& .${timelineContentClasses$1.root}`]: {
          marginLeft: theme.spacing(4),
          marginBottom: theme.spacing(4)
        }
      },
      children: events.map((event, index) => {
        var _a;
        return /* @__PURE__ */ jsxs(TimelineItem$1, { children: [
          /* @__PURE__ */ jsxs(TimelineSeparator$1, { children: [
            getEventIcon(event),
            index < events.length - 1 && getEventSeparator(event)
          ] }),
          /* @__PURE__ */ jsx(TimelineContent$1, { sx: { padding: 0 }, children: getEventContent(event) })
        ] }, (_a = event.id) != null ? _a : v4());
      })
    }
  );
}

const Skeleton$8 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const combineEvents = (addtionalEvents, eventsQuery) => {
  const combined = [...addtionalEvents];
  const eventCodes = new Set(addtionalEvents.map((event) => event.eventCode));
  if (eventsQuery && eventsQuery.length > 0) {
    for (const event of eventsQuery) {
      if (!eventCodes.has(event.eventCode)) {
        combined.push(event);
      } else {
        const index = combined.findIndex((e) => e.eventCode === event.eventCode);
        combined[index] = event;
      }
      eventCodes.add(event.eventCode);
    }
  }
  return combined;
};
const defaultFilterEvents = (events) => {
  const latestEventsMap = /* @__PURE__ */ new Map();
  if (events) {
    events.forEach((event) => {
      const { eventCode, eventDate } = event;
      const existingEvent = latestEventsMap.get(eventCode);
      if (!existingEvent || new Date(eventDate) > new Date(existingEvent.eventDate)) {
        latestEventsMap.set(eventCode, event);
      }
    });
  }
  return Array.from(latestEventsMap.values()).filter((val) => val.milestone === true);
};
function EventsTimeline({
  jobID,
  events,
  objectType = "Job",
  filter = () => true,
  addtionalEvents,
  sort = (a, b) => {
    var _a, _b, _c, _d;
    const aDate = (_b = (_a = a.eventDateOffset) != null ? _a : a.eventDate) != null ? _b : a.created;
    const bDate = (_d = (_c = b.eventDateOffset) != null ? _c : b.eventDate) != null ? _d : b.created;
    return new Date(bDate).getTime() - new Date(aDate).getTime();
  },
  filterEvents = defaultFilterEvents,
  getEventIcon,
  getEventContent
}) {
  var _a;
  const theme = useTheme$2();
  if (!jobID && !events)
    return /* @__PURE__ */ jsx(Fragment, {});
  if (jobID) {
    const [eventsQuery] = useSupplyChainEventList(jobID, objectType, { enabled: !!jobID });
    events = (_a = eventsQuery == null ? void 0 : eventsQuery.data) == null ? void 0 : _a.data;
  }
  let eventsData;
  if (addtionalEvents) {
    const combinedEvents = combineEvents(addtionalEvents, events);
    const filteredEvents = filterEvents(combinedEvents);
    eventsData = defaultValue(filteredEvents, []).filter(filter).sort(sort).map((event) => {
      var _a2, _b, _c, _d, _e;
      return {
        id: event.id,
        eventCode: (_a2 = event.eventCode) != null ? _a2 : void 0,
        eventName: (_b = event.eventName) != null ? _b : void 0,
        milestoneName: event.milestoneName,
        completedDate: defaultValue(event.eventDateOffset, event.eventDate),
        locationName: (_e = (_d = (_c = event.locations) == null ? void 0 : _c[0]) == null ? void 0 : _d.locationName) != null ? _e : void 0
      };
    });
  } else {
    const filteredEvents = filterEvents(events);
    eventsData = defaultValue(filteredEvents, []).filter(filter).sort(sort).map((event) => {
      var _a2, _b, _c, _d, _e;
      return {
        id: event.id,
        eventCode: (_a2 = event.eventCode) != null ? _a2 : void 0,
        eventName: (_b = event.eventName) != null ? _b : void 0,
        milestoneName: event.milestoneName,
        completedDate: defaultValue(event.eventDateOffset, event.eventDate),
        locationName: (_e = (_d = (_c = event.locations) == null ? void 0 : _c[0]) == null ? void 0 : _d.locationName) != null ? _e : void 0
      };
    });
  }
  if (!getEventIcon) {
    getEventIcon = (_) => /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        border: 1,
        bgcolor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08),
        borderColor: theme.palette.primary.main,
        borderRadius: theme.shape.borderRadius * 9999,
        color: theme.palette.primary.main,
        fontSize: "0.9rem",
        children: /* @__PURE__ */ jsx(Check, { color: "inherit", fontSize: "inherit" })
      }
    );
  }
  const getEventSeparator = (_) => /* @__PURE__ */ jsx(TimelineConnector$1, { sx: { width: "4px", bgcolor: theme.palette.grey[200] } });
  if (!getEventContent) {
    getEventContent = (event) => {
      var _a2;
      return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(
          Box$1,
          {
            alignSelf: "flex-start",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingY: 1,
            paddingX: 3,
            bgcolor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08),
            border: 1,
            borderColor: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius * 2,
            children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.8rem", fontWeight: 500, color: theme.palette.primary.main, children: (_a2 = event.milestoneName) != null ? _a2 : event.eventName })
          }
        ),
        event.completedDate && /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.8rem", color: theme.palette.grey[600], children: dayjs(event.completedDate).format("hh:mm A, DD MMM YYYY") })
      ] });
    };
  }
  return /* @__PURE__ */ jsx(
    TrackingTimeline$5,
    {
      events: eventsData,
      getEventIcon,
      getEventSeparator,
      getEventContent
    }
  );
}
function EventsTimelineLoading() {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(
    TrackingTimeline$5,
    {
      events: Array(5).fill(void 0).map((_, i) => ({ id: i })),
      getEventIcon: () => /* @__PURE__ */ jsx(Skeleton$8, { height: "20px", width: "20px", sx: { borderRadius: "9999px" } }),
      getEventSeparator: () => /* @__PURE__ */ jsx(TimelineConnector$1, { sx: { width: "4px", bgcolor: theme.palette.grey[200] } }),
      getEventContent: () => /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$8, { height: "28px", width: "180px", sx: { borderRadius: theme.shape.borderRadius * 2 } }),
        /* @__PURE__ */ jsx(Skeleton$8, { height: "0.9rem", width: "140px" })
      ] })
    }
  );
}

const StyledTableRow$2 = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText$2 = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText$2 = styled$4(StyledText$2)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText$2 = styled$4(StyledText$2)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer$2 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function MobileFreightLineDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer$2, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$2, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
    /* @__PURE__ */ jsx(StyledText$2, { children: row.description }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$2, { children: "Quantity: " }),
        /* @__PURE__ */ jsxs(CellValueText$2, { children: [
          " ",
          row.quantity,
          "\xA0",
          row.package
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$2, { children: "Commodity: " }),
        /* @__PURE__ */ jsx(CellValueText$2, { children: row.commodity })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$2, { children: "Weight (kgs): " }),
        /* @__PURE__ */ jsx(CellValueText$2, { children: row.weight })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$2, { children: "Cubic (m\xB3): " }),
        /* @__PURE__ */ jsx(CellValueText$2, { children: row.volume })
      ] })
    ] })
  ] }) }, i)) }) }) });
}
const gridColumns$4 = [
  {
    field: "quantity",
    type: "number",
    flex: 1,
    align: "left",
    headerName: "Quantity",
    headerAlign: "left"
  },
  {
    field: "package",
    flex: 1,
    headerName: "Package"
  },
  {
    field: "commodity",
    flex: 1,
    headerName: "Commodity"
  },
  {
    field: "description",
    flex: 1,
    minWidth: 450,
    headerName: "Description"
  },
  {
    field: "weight",
    type: "number",
    flex: 1,
    align: "left",
    headerName: "Weight (kgs)",
    headerAlign: "left"
  },
  {
    field: "volume",
    type: "number",
    flex: 1,
    align: "left",
    headerName: "Cubic (m\xB3)",
    headerAlign: "left"
  }
];
function FreightLineDetails$1({ gridRows, gridLoading }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakPoint ? /* @__PURE__ */ jsx(MobileFreightLineDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: gridColumns$4,
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.common.black,
          fontWeight: 600
        },
        borderRadius: 0
      }
    }
  ) });
}

var css_248z = ".pulse {\r\n\toverflow: visible;\r\n\tposition: relative;\r\n}\r\n\r\n.pulse::before {\r\n\tcontent: '';\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbackground-color: inherit;\r\n\tborder-radius: inherit;\r\n\t-webkit-transition: opacity .3s, -webkit-transform .3s;\r\n\ttransition: opacity .3s, -webkit-transform .3s;\r\n\ttransition: opacity .3s, transform .3s;\r\n\ttransition: opacity .3s, transform .3s, -webkit-transform .3s;\r\n\t-webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\r\n\tanimation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\r\n\tz-index: 1;\r\n}\r\n\r\n@-webkit-keyframes pulse-animation {\r\n\t0% {\r\n\t\topacity: 1;\r\n\t\t-webkit-transform: scale(1);\r\n\t\ttransform: scale(1);\r\n\t}\r\n\r\n\t50% {\r\n\t\topacity: 0;\r\n\t\t-webkit-transform: scale(1.5);\r\n\t\ttransform: scale(1.5);\r\n\t}\r\n\r\n\t100% {\r\n\t\topacity: 0;\r\n\t\t-webkit-transform: scale(1.5);\r\n\t\ttransform: scale(1.5);\r\n\t}\r\n}\r\n\r\n@keyframes pulse-animation {\r\n\t0% {\r\n\t\topacity: 1;\r\n\t\t-webkit-transform: scale(1);\r\n\t\ttransform: scale(1);\r\n\t}\r\n\r\n\t50% {\r\n\t\topacity: 0;\r\n\t\t-webkit-transform: scale(1.5);\r\n\t\ttransform: scale(1.5);\r\n\t}\r\n\r\n\t100% {\r\n\t\topacity: 0;\r\n\t\t-webkit-transform: scale(1.5);\r\n\t\ttransform: scale(1.5);\r\n\t}\r\n}\r\n";
styleInject(css_248z);

var __defProp$I = Object.defineProperty;
var __defProps$B = Object.defineProperties;
var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
var __hasOwnProp$I = Object.prototype.hasOwnProperty;
var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$I = (obj, key, value) => key in obj ? __defProp$I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$I.call(b, prop))
      __defNormalProp$I(a, prop, b[prop]);
  if (__getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(b)) {
      if (__propIsEnum$I.call(b, prop))
        __defNormalProp$I(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$B = (a, b) => __defProps$B(a, __getOwnPropDescs$B(b));
var __objRest$h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MapMarker$2 = () => {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(
    Avatar,
    {
      sx: {
        height: "24px",
        width: "24px",
        bgcolor: theme.palette.primary.main,
        fontSize: "20px"
      },
      children: /* @__PURE__ */ jsx(Place, { fontSize: "inherit", color: "inherit" })
    }
  );
};
function Map$8(_a) {
  var _b = _a, { data = [], transportComplete = false, isAirFreight = false, children } = _b, props = __objRest$h(_b, ["data", "transportComplete", "isAirFreight", "children"]);
  var _a2;
  const theme = useTheme$2();
  const sortedTransportLegs = useSortedTransportLegs(defaultValue(data, []));
  const { data: lineCoordsData } = useVesselMovementCoordinates(sortedTransportLegs);
  const { data: portCoordsData } = useVesselMovementLocations(sortedTransportLegs);
  const mapData = sortedTransportLegs.reduce(
    (accum, curr, index) => {
      if (!lineCoordsData || !portCoordsData) {
        return accum;
      }
      const port = portCoordsData == null ? void 0 : portCoordsData.find((x) => x.data.locationID === curr.transport.portID);
      return !(port == null ? void 0 : port.data.latitude) && !(port == null ? void 0 : port.data.longitude) ? accum : [
        ...accum,
        [port, lineCoordsData[index]]
        // port is unique, line coords will match index of transport leg
      ];
    },
    []
  ).map(([port, line]) => [
    {
      key: v4(),
      lat: port.data.latitude,
      lng: port.data.longitude,
      label: port.data.name
    },
    line.data.map((coord) => ({ lat: coord.latitude, lng: coord.longitude, time: dayjs(coord.dateAndTime) })).sort((a, b) => a.time.diff(b.time))
  ]);
  const currentPositionCoords = (_a2 = mapData.toReversed().find(([_, coords]) => coords.length > 0)) == null ? void 0 : _a2[1];
  const currentPosition = currentPositionCoords == null ? void 0 : currentPositionCoords[currentPositionCoords.length - 1];
  return /* @__PURE__ */ jsxs(GoogleMap, __spreadProps$B(__spreadValues$I({}, props), { children: [
    mapData.map(
      ([port, coords], index) => {
        var _a3;
        return /* @__PURE__ */ jsxs(Fragment$1, { children: [
          /* @__PURE__ */ jsx(GoogleMap.AdvancedMarker, { position: port, children: /* @__PURE__ */ jsx(MapMarker$2, {}) }),
          /* @__PURE__ */ jsx(GoogleMap.OverlayView, { position: port, pane: "markerLayer", offset: { x: 14, y: -22 }, children: /* @__PURE__ */ jsx(
            Box$1,
            {
              paddingY: 1,
              paddingX: 3,
              bgcolor: theme.palette.primary.main,
              borderRadius: theme.shape.borderRadius * 2,
              children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.75rem", lineHeight: "0.75rem", color: theme.palette.common.white, children: port.label })
            }
          ) }),
          /* @__PURE__ */ jsx(Fragment, { children: !transportComplete && isAirFreight && coords.length > 0 && coords === currentPositionCoords && /* @__PURE__ */ jsx(
            GoogleMap.Polyline,
            {
              path: [coords[coords.length - 1], (_a3 = mapData[index + 1]) == null ? void 0 : _a3[0]].filter(Boolean),
              geodesic: true,
              strokeColor: theme.palette.grey[600],
              strokeOpacity: 0,
              icons: [
                {
                  icon: {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 1,
                    scale: 3
                  },
                  offset: "0",
                  repeat: "12px"
                }
              ]
            }
          ) }),
          /* @__PURE__ */ jsx(Fragment, { children: coords.length > 0 && index !== mapData.length - 1 && /* @__PURE__ */ jsx(
            GoogleMap.Polyline,
            {
              path: [port, ...coords].filter(Boolean),
              geodesic: true,
              strokeColor: theme.palette.primary.main,
              strokeWeight: 2
            }
          ) })
        ] }, port.key);
      }
    ),
    currentPosition && !transportComplete && /* @__PURE__ */ jsx(GoogleMap.OverlayView, { position: currentPosition, pane: "markerLayer", offset: { x: -10, y: -10 }, children: /* @__PURE__ */ jsx(
      Box$1,
      {
        className: "pulse",
        bgcolor: theme.palette.primary.main,
        width: "20px",
        height: "20px",
        borderRadius: "50%"
      }
    ) }),
    children
  ] }));
}
function ConsignmentMap(_c) {
  var _d = _c, { data = [], children } = _d, props = __objRest$h(_d, ["data", "children"]);
  const theme = useTheme$2();
  for (var i = 0; i < data.length; i++) {
    if (i === 0 || data[i].linePath)
      continue;
    const currentData = data[i];
    const previousData = data[i - 1];
    if (currentData.lat != previousData.lat || currentData.lng != previousData.lng) {
      currentData.linePath = [
        { lat: previousData.lat, lng: previousData.lng },
        { lat: currentData.lat, lng: currentData.lng }
      ];
    }
  }
  return /* @__PURE__ */ jsxs(GoogleMap, __spreadProps$B(__spreadValues$I({}, props), { children: [
    data.map((location) => {
      var _a, _b;
      let polyline = /* @__PURE__ */ jsx(Fragment, {});
      if (location.linePath && location.linePath.length > 1) {
        polyline = location.isSolidLine ? /* @__PURE__ */ jsx(
          GoogleMap.Polyline,
          {
            path: location.linePath,
            geodesic: true,
            strokeColor: theme.palette.primary.main,
            strokeWeight: 2
          }
        ) : /* @__PURE__ */ jsx(
          GoogleMap.Polyline,
          {
            path: location.linePath,
            geodesic: true,
            strokeColor: theme.palette.primary.main,
            strokeOpacity: 0,
            icons: [
              {
                icon: {
                  path: "M 0,-1 0,1",
                  strokeOpacity: 1,
                  scale: 3
                },
                offset: "0",
                repeat: "12px"
              }
            ]
          }
        );
      }
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(GoogleMap.AdvancedMarker, { position: location, children: /* @__PURE__ */ jsx(MapMarker$2, {}) }),
        location.label && /* @__PURE__ */ jsx(GoogleMap.OverlayView, { position: location, pane: "markerLayer", offset: { x: 14, y: -22 }, children: /* @__PURE__ */ jsx(
          Box$1,
          {
            paddingY: 1,
            paddingX: 3,
            bgcolor: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius * 2,
            children: /* @__PURE__ */ jsx(
              Typography$1,
              {
                fontSize: (_a = location.labelFontSize) != null ? _a : "0.75rem",
                lineHeight: (_b = location.labelFontSize) != null ? _b : "0.75rem",
                color: theme.palette.common.white,
                children: location.label
              }
            )
          }
        ) }),
        polyline
      ] }, location.key);
    }),
    children
  ] }));
}

const StyledTableRow$1 = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText$1 = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText$1 = styled$4(StyledText$1)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText$1 = styled$4(StyledText$1)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer$1 = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
function MobileOrderDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer$1, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow$1, { children: /* @__PURE__ */ jsxs(TableCell, { children: [
    /* @__PURE__ */ jsx(StyledText$1, { children: row.description }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$1, { children: "Order No: " }),
        /* @__PURE__ */ jsxs(CellValueText$1, { children: [
          " ",
          row.orderNumber
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$1, { children: "SKU: " }),
        /* @__PURE__ */ jsx(CellValueText$1, { children: row.sku })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, justifyItems: "space-between", children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$1, { children: "Ordered: " }),
        /* @__PURE__ */ jsx(CellValueText$1, { children: row.ordered })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, children: [
        /* @__PURE__ */ jsx(CellHeaderText$1, { children: "Confirmed: " }),
        /* @__PURE__ */ jsx(CellValueText$1, { children: row.confirmed })
      ] })
    ] })
  ] }) }, i)) }) }) });
}
function OrderDetails$5({ gridRows, gridLoading }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const gridColumns = [
    {
      field: "orderNumber",
      flex: 1,
      headerName: "ORDER NUMBER",
      renderCell: (params) => /* @__PURE__ */ jsx("a", { href: `/#/Orders?q=${params.id}&intent=tab`, target: "_blank", rel: "noopener noreferrer", children: params.row.orderNumber })
    },
    {
      field: "sku",
      flex: 1,
      headerName: "SKU"
    },
    {
      field: "description",
      flex: 1,
      minWidth: 450,
      headerName: "DESCRIPTION"
    },
    {
      field: "ordered",
      type: "number",
      flex: 1,
      align: "left",
      headerName: "ORDERED",
      headerAlign: "left"
    },
    {
      field: "confirmed",
      type: "number",
      flex: 1,
      align: "left",
      headerName: "CONFIRMED",
      headerAlign: "left"
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakPoint ? /* @__PURE__ */ jsx(MobileOrderDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: gridColumns,
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      autoHeight: true,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        }
      }
    }
  ) });
}

const StyledTableRow = styled$4(TableRow)({
  "&:last-child td, &:last-child th": {
    border: 0
  }
});
const StyledText = styled$4(Typography$1)({
  fontSize: "0.8rem",
  display: "inline"
});
const CellHeaderText = styled$4(StyledText)({
  alignSelf: "left",
  fontWeight: "600",
  padding: 2
});
const CellValueText = styled$4(StyledText)({
  alignSelf: "left",
  padding: 2
});
const StyledTableContainer = styled$4(TableContainer)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`
}));
const getFormattedPieces = (value, unitOfMeasure) => {
  return value && unitOfMeasure ? `${value.toLocaleString(window.navigator.language)} ${inflect(unitOfMeasure, value)}` : value;
};
const getFormattedWeight = (value, unitOfMeasure) => {
  return value && unitOfMeasure ? `${value.toLocaleString(window.navigator.language)} ${unitOfMeasure}` : value;
};
const getFormattedVolume = (value, unitOfMeasure) => {
  return value && unitOfMeasure ? `${value.toLocaleString(window.navigator.language)} ${unitOfMeasure}` : value;
};
function MobilePackingLineDetails({ rows }) {
  return /* @__PURE__ */ jsx(StyledTableContainer, { children: /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children: rows.map((row, i) => /* @__PURE__ */ jsx(StyledTableRow, { children: /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsxs(Grid$3, { container: true, rowGap: 2, children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, children: [
      /* @__PURE__ */ jsx(CellHeaderText, { children: "Description" }),
      /* @__PURE__ */ jsx(CellValueText, { children: row.description })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, children: [
      /* @__PURE__ */ jsx(CellHeaderText, { children: "Pieces" }),
      /* @__PURE__ */ jsx(CellValueText, { children: getFormattedPieces(row.pieces, row.piecesUnitOfMeasure) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, children: [
      /* @__PURE__ */ jsx(CellHeaderText, { children: "Weight" }),
      /* @__PURE__ */ jsx(CellValueText, { children: getFormattedWeight(row.weight, row.weightUnitOfMeasure) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, children: [
      /* @__PURE__ */ jsx(CellHeaderText, { children: "Volume" }),
      /* @__PURE__ */ jsx(CellValueText, { children: getFormattedVolume(row.volume, row.volumeUnitOfMeasure) })
    ] })
  ] }) }) }, i)) }) }) });
}
const gridColumns$3 = [
  {
    field: "description",
    headerName: "DESCRIPTION",
    flex: 1
  },
  {
    field: "pieces",
    headerName: "PIECES",
    flex: 1,
    renderCell: ({ value, row }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: getFormattedPieces(value, row.piecesUnitOfMeasure) })
  },
  {
    field: "weight",
    headerName: "WEIGHT",
    flex: 1,
    renderCell: ({ value, row }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: getFormattedWeight(value, row.weightUnitOfMeasure) })
  },
  {
    field: "volume",
    headerName: "VOLUME",
    flex: 1,
    renderCell: ({ value, row }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: getFormattedVolume(value, row.volumeUnitOfMeasure) })
  }
];
function PackingLineDetails$1({ gridRows, gridLoading }) {
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakpoint ? /* @__PURE__ */ jsx(MobilePackingLineDetails, { rows: gridRows != null ? gridRows : [] }) : /* @__PURE__ */ jsx(
    DataGridPro,
    {
      columns: gridColumns$3,
      rows: gridRows != null ? gridRows : [],
      loading: gridLoading,
      rowSelection: false,
      hideFooter: true,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        }
      }
    }
  ) });
}

var __defProp$H = Object.defineProperty;
var __defProps$A = Object.defineProperties;
var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
var __hasOwnProp$H = Object.prototype.hasOwnProperty;
var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$H = (obj, key, value) => key in obj ? __defProp$H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$H.call(b, prop))
      __defNormalProp$H(a, prop, b[prop]);
  if (__getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(b)) {
      if (__propIsEnum$H.call(b, prop))
        __defNormalProp$H(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$A = (a, b) => __defProps$A(a, __getOwnPropDescs$A(b));
const producePortalSupplyChainEvent$1 = (data) => {
  const id = Math.random() * 1e3;
  return __spreadValues$H({
    active: true,
    id,
    eventID: id,
    eventDateUtc: null,
    eventTemplateID: null,
    eventTemplateName: null,
    created: dayjs().format(),
    createdBy: "producePortalSupplyChainEvent",
    lastModified: dayjs().format(),
    lastModifiedBy: "producePortalSupplyChainEvent",
    objectParties: [],
    milestone: false,
    milestoneName: null,
    locationID: null,
    hasLocation: false,
    timeZoneID: null,
    timeZoneCode: null,
    timeZone: null
  }, data);
};
const formatDate$1 = (date) => dayjs(date).format("D MMM");
function PortalOrderSupplyChainTimeline({
  jobID,
  supplyChainID,
  orderPlaced,
  estimatedCargoReady
}) {
  const theme = useTheme$2();
  const [{ data, isFetching }] = useSupplyChainEventList(jobID, "Job", { enabled: !!jobID });
  const events = defaultValue(data == null ? void 0 : data.data, []).map((x) => __spreadProps$A(__spreadValues$H({}, x), { id: x.eventID }));
  const actualCargoReadyEvent = events.find((x) => x.eventCode === EventCode.Order.ActualCargoReady);
  const orderPlacedEvent = producePortalSupplyChainEvent$1({
    objectID: jobID,
    objectType: "Job",
    supplyChainID,
    eventName: "Order Placed",
    eventCode: "OrderPlaced",
    eventDate: orderPlaced ? formatDate$1(orderPlaced) : null,
    completed: !!orderPlaced
  });
  let timelineEvents = [
    orderPlacedEvent
  ];
  const isCurrentDatePassEstimateCargoReady = estimatedCargoReady && dayjs().isAfter(dayjs(estimatedCargoReady), "day");
  if (actualCargoReadyEvent) {
    timelineEvents = [
      ...timelineEvents,
      producePortalSupplyChainEvent$1(__spreadProps$A(__spreadValues$H({}, actualCargoReadyEvent), {
        eventName: "Cargo Ready",
        eventCode: "CargoReady",
        eventDate: actualCargoReadyEvent.eventDate ? formatDate$1(actualCargoReadyEvent.eventDate) : null,
        completed: true
      }))
    ];
  } else {
    timelineEvents = [
      ...timelineEvents,
      producePortalSupplyChainEvent$1({
        objectID: jobID,
        objectType: "Job",
        supplyChainID,
        eventName: "Cargo Ready",
        eventCode: "CargoReady",
        eventDate: estimatedCargoReady ? `${formatDate$1(estimatedCargoReady)}${!isCurrentDatePassEstimateCargoReady ? " (Estimated)" : ""}` : null,
        completed: !!isCurrentDatePassEstimateCargoReady
      })
    ];
  }
  if (isFetching) {
    return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
  }
  return /* @__PURE__ */ jsx(
    SupplyChainTimeline,
    {
      events: timelineEvents,
      size: "sm",
      labelPlacement: "top",
      displayEventCircle: () => false,
      isEventCompleted: (event) => event.completed,
      getProgressColor: () => theme.palette.success.main,
      getEventSubtitle: (event) => {
        const date = event.eventDate;
        return date != null ? date : "To be confirmed";
      }
    }
  );
}

var __defProp$G = Object.defineProperty;
var __defProps$z = Object.defineProperties;
var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
var __hasOwnProp$G = Object.prototype.hasOwnProperty;
var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$G = (obj, key, value) => key in obj ? __defProp$G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$G.call(b, prop))
      __defNormalProp$G(a, prop, b[prop]);
  if (__getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(b)) {
      if (__propIsEnum$G.call(b, prop))
        __defNormalProp$G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$z = (a, b) => __defProps$z(a, __getOwnPropDescs$z(b));
const producePortalSupplyChainEvent = (data) => {
  const id = Math.random() * 1e3;
  return __spreadValues$G({
    active: true,
    id,
    eventID: id,
    eventDateUtc: null,
    eventTemplateID: null,
    eventTemplateName: null,
    created: dayjs().format(),
    createdBy: "producePortalSupplyChainEvent",
    lastModified: dayjs().format(),
    lastModifiedBy: "producePortalSupplyChainEvent",
    objectParties: [],
    milestone: false,
    milestoneName: null,
    locationID: null,
    hasLocation: false,
    timeZoneID: null,
    timeZoneCode: null,
    timeZone: null
  }, data);
};
function addBusinessDays(date, businessDays) {
  let result = date;
  let addedDays = 0;
  while (addedDays < businessDays) {
    result = result.add(1, "day");
    const dayOfWeek = result.day();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      addedDays += 1;
    }
  }
  return result;
}
const formatDate = (date) => dayjs(date).format("D MMM");
function PortalShipmentSupplyChainTimeline({
  jobID,
  supplyChainID,
  containerID,
  shipmentMode,
  shipmentType,
  estimatedDeparture,
  actualDeparture,
  estimatedArrival,
  actualArrival,
  bookingConfirmed
}) {
  const theme = useTheme$2();
  const [{ data, isFetching }] = useSupplyChainEventList(jobID, "Job", { enabled: !!jobID });
  const [{ data: containerEventData, isFetching: isFetchingContainerEvent }] = useSupplyChainEventList(
    containerID || 0,
    "Container",
    { enabled: !!containerID }
  );
  const events = defaultValue(data == null ? void 0 : data.data, []).map((x) => __spreadProps$z(__spreadValues$G({}, x), { id: x.eventID }));
  const containerEvents = defaultValue(containerEventData == null ? void 0 : containerEventData.data, []).map((x) => __spreadProps$z(__spreadValues$G({}, x), { id: x.eventID }));
  const supplyChainTemplate = shipmentMode === SystemName.ShipmentMode.Air ? "Air" : shipmentType === SystemName.ShipmentType.FCL ? "FCL" : "LCL";
  const bookingConfirmedEvent = events.find((x) => x.eventCode === EventCode[supplyChainTemplate].BookingConfirmed);
  const shipmentDeliveredEvent = events.find((x) => x.eventCode === EventCode[supplyChainTemplate].Delivered);
  const containerDeliveredEvent = containerEvents.find((x) => x.eventCode === EventCode.Container.Delivered);
  const deliveredEvent = defaultValue(containerDeliveredEvent, shipmentDeliveredEvent);
  let estimatedDeliveryTime = null;
  if (estimatedArrival || actualArrival) {
    switch (supplyChainTemplate) {
      case "Air":
        estimatedDeliveryTime = addBusinessDays(
          dayjs(defaultValue(actualArrival, estimatedArrival)),
          1
        ).format();
        break;
      case "LCL":
        estimatedDeliveryTime = addBusinessDays(
          dayjs(defaultValue(actualArrival, estimatedArrival)),
          4
        ).format();
        break;
      case "FCL":
        estimatedDeliveryTime = addBusinessDays(
          dayjs(defaultValue(actualArrival, estimatedArrival)),
          3
        ).format();
        break;
      default:
        estimatedDeliveryTime = defaultValue(actualArrival, estimatedArrival);
    }
  }
  const isCurrentDatePassETD = estimatedDeparture && dayjs().isAfter(dayjs(estimatedDeparture), "day");
  const departedEvent = producePortalSupplyChainEvent({
    objectID: jobID,
    objectType: "Job",
    supplyChainID,
    eventName: "Departed",
    eventCode: "Departed",
    eventDate: actualDeparture ? formatDate(actualDeparture) : estimatedDeparture ? `${formatDate(estimatedDeparture)}${!isCurrentDatePassETD ? " (Estimated)" : ""}` : null,
    completed: !!actualDeparture || !!isCurrentDatePassETD
  });
  const isCurrentDatePassETA = estimatedArrival && dayjs().isAfter(dayjs(estimatedArrival), "day");
  const arrivedEvent = producePortalSupplyChainEvent({
    objectID: jobID,
    objectType: "Job",
    supplyChainID,
    eventName: "Arrived",
    eventCode: "Arrived",
    eventDate: actualArrival ? formatDate(actualArrival) : estimatedArrival ? `${formatDate(estimatedArrival)}${!isCurrentDatePassETA ? " (Estimated)" : ""}` : null,
    completed: !!actualArrival || !!isCurrentDatePassETA
  });
  const isCurrentDatePassEstimateDelivery = estimatedDeliveryTime && dayjs().isAfter(dayjs(estimatedDeliveryTime), "day");
  const estimatedDelivery = producePortalSupplyChainEvent({
    objectID: jobID,
    objectType: "Job",
    supplyChainID,
    eventName: isCurrentDatePassEstimateDelivery ? "Delivered" : "Estimated Delivery",
    eventCode: "EstimatedDelivery",
    eventDate: estimatedDeliveryTime ? formatDate(estimatedDeliveryTime) : null,
    completed: !!isCurrentDatePassEstimateDelivery
  });
  let timelineEvents = [];
  const getBookedDisplayTime = (bookedTime) => {
    if (actualDeparture) {
      if (dayjs(bookedTime).isAfter(dayjs(actualDeparture), "day")) {
        return "";
      }
    } else if (estimatedDeparture) {
      if (dayjs(bookedTime).isAfter(dayjs(estimatedDeparture), "day")) {
        return "";
      }
    }
    return formatDate(bookedTime);
  };
  if (bookingConfirmedEvent) {
    timelineEvents = [
      producePortalSupplyChainEvent(__spreadProps$z(__spreadValues$G({}, bookingConfirmedEvent), {
        eventName: "Booked",
        eventDate: bookingConfirmedEvent.eventDate ? getBookedDisplayTime(bookingConfirmedEvent.eventDate) : null,
        completed: true
      }))
    ];
  } else {
    timelineEvents = [
      producePortalSupplyChainEvent({
        objectID: jobID,
        objectType: "Job",
        supplyChainID,
        eventName: "Booked",
        eventCode: "Booked",
        eventDate: bookingConfirmed ? getBookedDisplayTime(bookingConfirmed) : null,
        completed: !!bookingConfirmed
      })
    ];
  }
  timelineEvents = [...timelineEvents, departedEvent];
  timelineEvents = [...timelineEvents, arrivedEvent];
  if (deliveredEvent) {
    timelineEvents = [
      ...timelineEvents,
      producePortalSupplyChainEvent(__spreadProps$z(__spreadValues$G({}, deliveredEvent), {
        eventName: "Delivered",
        eventDate: deliveredEvent.eventDate ? formatDate(deliveredEvent.eventDate) : null,
        completed: true
      }))
    ];
  } else {
    timelineEvents = [...timelineEvents, estimatedDelivery];
  }
  for (let i = timelineEvents.length - 1; i > 0; i--) {
    const event = timelineEvents[i];
    const preEvent = timelineEvents[i - 1];
    if (event == null ? void 0 : event.completed) {
      preEvent.completed = true;
    }
  }
  if (isFetching) {
    return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
  }
  return /* @__PURE__ */ jsx(
    SupplyChainTimeline,
    {
      events: timelineEvents,
      size: "sm",
      labelPlacement: "top",
      displayEventCircle: () => false,
      isEventCompleted: (event) => event.completed,
      getProgressColor: () => theme.palette.success.main,
      getEventSubtitle: (event) => {
        const date = event.eventDate;
        return date != null ? date : "To be confirmed";
      }
    }
  );
}

var __async$l = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function ShareWithMagicLink({
  intent,
  magicLinkValue,
  disabled,
  isLoadingMagicLink,
  children,
  onGenerateMagicLink
}) {
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const handleShareIconClick = () => {
    openDialog();
  };
  const handleSubmitBtnClick = () => {
    typeof onGenerateMagicLink === "function" && onGenerateMagicLink();
  };
  const handleCopyToClipboard = () => __async$l(this, null, function* () {
    if (magicLinkValue) {
      try {
        yield navigator.clipboard.writeText(magicLinkValue);
      } catch (e) {
        if (e instanceof Error) {
          console.log("Copy to clipboard failed:", e);
        }
      }
    }
  });
  const renderMagicLinkContent = useMemo(() => {
    if (isLoadingMagicLink) {
      return /* @__PURE__ */ jsx(CircularProgress$1, {});
    }
    return magicLinkValue ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Box$1, { sx: { lineBreak: "anywhere" }, children: magicLinkValue }),
      /* @__PURE__ */ jsx(Button, { onClick: handleCopyToClipboard, children: "Copy to clipboard" })
    ] }) : "Click the Generate button to create the magic link";
  }, [magicLinkValue, isLoadingMagicLink]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IconButton, { title: "Share", disabled, onClick: handleShareIconClick, children }),
    /* @__PURE__ */ jsxs(DialogWrap, { fullWidth: true, open: isDialogOpen, onClose: closeDialog, title: `Share ${intent} with magic link`, children: [
      /* @__PURE__ */ jsx(Box$1, { py: 5, children: /* @__PURE__ */ jsx(FormElementWrap, { name: "magicLink", label: "Magic Link:", children: renderMagicLinkContent }) }),
      /* @__PURE__ */ jsx(Box$1, { children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: handleSubmitBtnClick,
          color: "primary",
          variant: "contained",
          disabled: isLoadingMagicLink || !!magicLinkValue,
          children: "Generate"
        }
      ) })
    ] })
  ] });
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var countryCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LGBT', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'XK', 'YE', 'YT', 'ZA', 'ZM', 'ZW', 'EU', 'GB-ENG', 'GB-NIR', 'GB-SCT', 'GB-WLS', 'GB-ZET', 'US-CA'];

// see: https://github.com/storybookjs/storybook/issues/9556

var Flag = function Flag(_ref) {
  var _ref$country = _ref.country,
      country = _ref$country === void 0 ? 'US' : _ref$country,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'img' : _ref$role,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      alt = _ref.alt,
      props = _objectWithoutPropertiesLoose(_ref, ["country", "role", "size", "alt"]);

  if (country) {
    var countryCode = country.toUpperCase();

    if (countryCodes.find(function (el) {
      return el === country;
    }) !== undefined) {
      var jsDelivr = 'https://cdn.jsdelivr.net/gh/madebybowtie/FlagKit@2.2/Assets/SVG';
      var flagSrc = jsDelivr + "/" + countryCode + ".svg";
      return React__default$1.createElement("img", Object.assign({
        src: flagSrc,
        role: role,
        alt: alt != null ? alt : countryCode + " Flag",
        height: size,
        width: size
      }, props));
    }

    return React__default$1.createElement("span", null, countryCode);
  }

  return null;
};

const EMPTY_STRING$2 = "";
const Skeleton$7 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function isPortalShipment$1(data) {
  if (data && data.jobTypeSystemName) {
    return data.jobTypeSystemName === SystemName.JobType.PortalShipment;
  }
  return false;
}
function ShipmentDetails$3({ data }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const iconButtonSize = mobileBreakPoint ? 20 : 24;
  const textFontSize = mobileBreakPoint ? "0.75rem" : "0.9rem";
  const headerFontSize = mobileBreakPoint ? "0.75rem" : "small";
  const isAir = (data == null ? void 0 : data.shipmentMode) && data.shipmentMode.code === SystemName.ShipmentMode.Air;
  const scheduledDepartureDate = useMemo(() => {
    var _a2, _b2;
    if ((_a2 = data == null ? void 0 : data.actualDeparture) == null ? void 0 : _a2.dateAndTime) {
      return dayjs(data.actualDeparture.dateAndTime).format("DD MMM YYYY");
    }
    if ((_b2 = data == null ? void 0 : data.estimatedDeparture) == null ? void 0 : _b2.dateAndTime) {
      return dayjs(data.estimatedDeparture.dateAndTime).format("DD MMM YYYY");
    }
    return "To be confirmed";
  }, [data]);
  const scheduledArrivalDate = useMemo(() => {
    var _a2, _b2;
    if ((_a2 = data == null ? void 0 : data.actualArrival) == null ? void 0 : _a2.dateAndTime) {
      return dayjs(data.actualArrival.dateAndTime).format("DD MMM YYYY");
    }
    if ((_b2 = data == null ? void 0 : data.estimatedArrival) == null ? void 0 : _b2.dateAndTime) {
      return dayjs(data.estimatedArrival.dateAndTime).format("DD MMM YYYY");
    }
    return "To be confirmed";
  }, [data]);
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Origin" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            ((_a = data == null ? void 0 : data.portOfOrigin) == null ? void 0 : _a.combinedCode) && /* @__PURE__ */ jsx(Flag, { country: `${data.portOfOrigin.combinedCode.slice(0, 2)}`, size: iconButtonSize }),
            /* @__PURE__ */ jsxs(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: [
              (_b = data == null ? void 0 : data.portOfOrigin) == null ? void 0 : _b.combinedCode,
              "\xA0",
              ((_c = data == null ? void 0 : data.portOfOrigin) == null ? void 0 : _c.locationName) ? `(${data.portOfOrigin.locationName})` : EMPTY_STRING$2
            ] })
          ] }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_f = (_d = data == null ? void 0 : data.consignor) == null ? void 0 : _d.fullName) != null ? _f : (_e = data == null ? void 0 : data.consignor) == null ? void 0 : _e.fileAs })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Destination" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            ((_g = data == null ? void 0 : data.destinationPort) == null ? void 0 : _g.combinedCode) && /* @__PURE__ */ jsx(
              Flag,
              {
                country: `${data.destinationPort.combinedCode.slice(0, 2)}`,
                size: iconButtonSize
              }
            ),
            /* @__PURE__ */ jsxs(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: [
              (_h = data == null ? void 0 : data.destinationPort) == null ? void 0 : _h.combinedCode,
              "\xA0",
              ((_i = data == null ? void 0 : data.destinationPort) == null ? void 0 : _i.locationName) ? `(${data.destinationPort.locationName})` : EMPTY_STRING$2
            ] })
          ] }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_l = (_j = data == null ? void 0 : data.consignee) == null ? void 0 : _j.fileAs) != null ? _l : (_k = data == null ? void 0 : data.consignee) == null ? void 0 : _k.fullName })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Scheduled Departure" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: scheduledDepartureDate })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Scheduled Arrival" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: scheduledArrivalDate })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "1fr 1fr 15% 15%", children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, paddingRight: mobileBreakPoint ? 2 : "inherit", children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Masterbill" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: isPortalShipment$1(data) && ((_m = data == null ? void 0 : data.masterbill) == null ? void 0 : _m.reference) })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Housebill" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: isPortalShipment$1(data) && ((_n = data == null ? void 0 : data.housebill) == null ? void 0 : _n.reference) })
      ] }),
      !isAir && /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Type" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_o = data == null ? void 0 : data.shipmentType) == null ? void 0 : _o.code })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: headerFontSize, color: theme.palette.grey[700], children: "Mode" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: textFontSize, lineHeight: textFontSize, children: (_p = data == null ? void 0 : data.shipmentMode) == null ? void 0 : _p.shortName })
      ] })
    ] })
  ] });
}
function ShipmentDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "40px" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            /* @__PURE__ */ jsx(Skeleton$7, { height: "20px", width: "24px" }),
            /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "185px" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "75px" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
            /* @__PURE__ */ jsx(Skeleton$7, { height: "20px", width: "24px" }),
            /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "185px" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "130px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "85px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "125px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "85px" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "1fr 1fr 15% 15%", children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "130px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "90px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "30px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "22px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.25, children: [
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.815rem", width: "30px" }),
        /* @__PURE__ */ jsx(Skeleton$7, { height: "0.9rem", width: "22px" })
      ] })
    ] })
  ] });
}

const Skeleton$6 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function StaffContacts$3({ data, mailToSubject }) {
  var _a, _b, _c, _d, _e;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const fontSize = mobileBreakPoint ? "0.85rem" : "0.9rem";
  const customerRep = data == null ? void 0 : data.customerServiceRepresentative;
  const salesExecutive = data == null ? void 0 : data.salesRepresentative;
  const keyAccountManager = data == null ? void 0 : data.accountManager;
  const customsAgent = data == null ? void 0 : data.customsAgent;
  const customerRepName = (_a = customerRep == null ? void 0 : customerRep.fileAs) != null ? _a : customerRep == null ? void 0 : customerRep.fullName;
  const salesExecutiveName = (_b = salesExecutive == null ? void 0 : salesExecutive.fileAs) != null ? _b : salesExecutive == null ? void 0 : salesExecutive.fullName;
  const keyAccountManagerName = (_c = keyAccountManager == null ? void 0 : keyAccountManager.fileAs) != null ? _c : keyAccountManager == null ? void 0 : keyAccountManager.fullName;
  const customsAgentName = (_d = customsAgent == null ? void 0 : customsAgent.fileAs) != null ? _d : customsAgent == null ? void 0 : customsAgent.fullName;
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsxs(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: [
          /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Customer Service Representative" }) }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: customerRepName && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Person, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", color: "initial", children: (_e = customerRep == null ? void 0 : customerRep.fileAs) != null ? _e : customerRep == null ? void 0 : customerRep.fullName })
            ] }) }),
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: (customerRep == null ? void 0 : customerRep.email) && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(MailOutline, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(
                Typography$1,
                {
                  component: "a",
                  href: `mailto:${customerRep.email}?subject=${encodeURIComponent(mailToSubject)}`,
                  fontSize,
                  lineHeight: "0.9rem",
                  color: "initial",
                  sx: {
                    wordWrap: "break-word",
                    wordBreak: "break-all",
                    cursor: "pointer",
                    pointerEvents: "auto",
                    textDecoration: "underline"
                  },
                  children: customerRep.email
                }
              )
            ] }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: [
          /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Sales Executive" }) }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: salesExecutiveName && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Person, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", color: "initial", children: salesExecutiveName })
            ] }) }),
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: (salesExecutive == null ? void 0 : salesExecutive.email) && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(MailOutline, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(
                Typography$1,
                {
                  component: "a",
                  href: `mailto:${salesExecutive.email}?subject=${encodeURIComponent(mailToSubject)}`,
                  fontSize,
                  lineHeight: "0.9rem",
                  color: "initial",
                  sx: {
                    wordWrap: "break-word",
                    wordBreak: "break-all",
                    cursor: "pointer",
                    pointerEvents: "auto",
                    textDecoration: "underline"
                  },
                  children: salesExecutive.email
                }
              )
            ] }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: [
          /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Key Account Manager" }) }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: keyAccountManagerName && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Person, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", color: "initial", children: keyAccountManagerName })
            ] }) }),
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: (keyAccountManager == null ? void 0 : keyAccountManager.email) && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(MailOutline, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(
                Typography$1,
                {
                  component: "a",
                  href: `mailto:${keyAccountManager.email}?subject=${encodeURIComponent(mailToSubject)}`,
                  fontSize,
                  lineHeight: "0.9rem",
                  color: "initial",
                  sx: {
                    wordWrap: "break-word",
                    wordBreak: "break-all",
                    cursor: "pointer",
                    pointerEvents: "auto",
                    textDecoration: "underline"
                  },
                  children: keyAccountManager.email
                }
              )
            ] }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: [
          /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Customs Broker" }) }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: customsAgentName && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Person, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", color: "initial", children: customsAgentName })
            ] }) }),
            /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: 2, color: theme.palette.primary.main, minHeight: "20px", children: (customsAgent == null ? void 0 : customsAgent.email) && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(MailOutline, { fontSize: "small", color: "inherit", sx: { opacity: 0.8 } }),
              /* @__PURE__ */ jsx(
                Typography$1,
                {
                  component: "a",
                  href: `mailto:${customsAgent.email}?subject=${encodeURIComponent(mailToSubject)}`,
                  fontSize,
                  lineHeight: "0.9rem",
                  color: "initial",
                  sx: {
                    wordWrap: "break-word",
                    wordBreak: "break-all",
                    cursor: "pointer",
                    pointerEvents: "auto",
                    textDecoration: "underline"
                  },
                  children: customsAgent.email
                }
              )
            ] }) })
          ] })
        ]
      }
    )
  ] });
}
function StaffContactsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.815rem", width: "80px" }),
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "90px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "100px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "140px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "165px" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "80px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "165px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "135px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "180px" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.815rem", width: "100px" }),
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "85px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "100px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "135px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "160px" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "75px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "110px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "135px" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
          /* @__PURE__ */ jsx(Skeleton$6, { height: "18px", width: "18px" }),
          /* @__PURE__ */ jsx(Skeleton$6, { height: "0.9rem", width: "160px" })
        ] })
      ] })
    ] })
  ] });
}

var y=function(){return y=Object.assign||function(e){for(var i,r=1,o=arguments.length;r<o;r++)for(var l in i=arguments[r])Object.prototype.hasOwnProperty.call(i,l)&&(e[l]=i[l]);return e},y.apply(this,arguments)};"function"==typeof SuppressedError&&SuppressedError;var f=[{name:"@yearly",value:"0 0 1 1 *"},{name:"@annually",value:"0 0 1 1 *"},{name:"@monthly",value:"0 0 1 * *"},{name:"@weekly",value:"0 0 * * 0"},{name:"@daily",value:"0 0 * * *"},{name:"@midnight",value:"0 0 * * *"},{name:"@hourly",value:"0 * * * *"}],g=[{type:"minutes",min:0,max:59,total:60},{type:"hours",min:0,max:23,total:24},{type:"month-days",min:1,max:31,total:31},{type:"months",min:1,max:12,total:12,alt:["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"]},{type:"week-days",min:0,max:6,total:7,alt:["SUN","MON","TUE","WED","THU","FRI","SAT"]}],x={everyText:"every",emptyMonths:"every month",emptyMonthDays:"every day of the month",emptyMonthDaysShort:"day of the month",emptyWeekDays:"every day of the week",emptyWeekDaysShort:"day of the week",emptyHours:"every hour",emptyMinutes:"every minute",emptyMinutesForHourPeriod:"every",yearOption:"year",monthOption:"month",weekOption:"week",dayOption:"day",hourOption:"hour",minuteOption:"minute",rebootOption:"reboot",prefixPeriod:"Every",prefixMonths:"in",prefixMonthDays:"on",prefixWeekDays:"on",prefixWeekDaysForMonthAndYearPeriod:"and",prefixHours:"at",prefixMinutes:":",prefixMinutesForHourPeriod:"at",suffixMinutesForHourPeriod:"minute(s)",errorInvalidCron:"Invalid cron expression",clearButtonText:"Clear",weekDays:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],altWeekDays:["SUN","MON","TUE","WED","THU","FRI","SAT"],altMonths:["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"]};function O(e,i){for(var r=[],o=e;o<=i;o++)r.push(o);return r}function w(e){return e.sort((function(e,i){return e-i})),e}function b(e){var i=[];return e.forEach((function(e){i.indexOf(e)<0&&i.push(e);})),i}function k(e,i){e&&e({type:"invalid_cron",description:i.errorInvalidCron||x.errorInvalidCron});}function D(e){var i=parseInt(e,10),r=Number(e);return i===r?r:NaN}function C(e,i,r,o,l,n,t,a,d,u,v,s,c,m){r&&r(void 0),i(!1);var p=!1;if(!e){if("always"===o||n&&"for-default-value"===o)return;p=!0;}if(!p){if(a&&(!0===a||a.includes(e))){if("@reboot"===e)return void m("reboot");var h=f.find((function(i){return i.name===e}));h&&(e=h.value);}try{var y=function(e){if("string"!=typeof e)throw new Error("Invalid cron string");var i=e.replace(/\s+/g," ").trim().split(" ");if(5===i.length)return i.map((function(e,i){return function(e,i){if("*"===e||"*/1"===e)return [];var r=w(b(S(function(e,i,r){if(r){e=e.toUpperCase();for(var o=0;o<r.length;o++)e=e.replace(r[o],"".concat(o+i));}return e}(e,i.min,i.alt).split(",").map((function(r){var o,l=r.split("/");if(l.length>2)throw new Error('Invalid value "'.concat(e,' for "').concat(i.type,'"'));var n=l[0],t=l[1];o="*"===n?O(i.min,i.max):function(e,i,r){var o=e.split("-");if(1===o.length){var l=D(o[0]);if(isNaN(l))throw new Error('Invalid value "'.concat(i,'" for ').concat(r.type));return [l]}if(2===o.length){var n=D(o[0]),t=D(o[1]);if(isNaN(n)||isNaN(t))throw new Error('Invalid value "'.concat(i,'" for ').concat(r.type));if(t<n)throw new Error('Max range is less than min range in "'.concat(e,'" for ').concat(r.type));return O(n,t)}throw new Error('Invalid value "'.concat(e,'" for ').concat(r.type))}(n,e,i);var a=function(e,i){if(void 0!==e){var r=D(e);if(isNaN(r)||r<1)throw new Error('Invalid interval step value "'.concat(e,'" for ').concat(i.type));return r}}(t,i),d=function(e,i){if(i){var r=e[0];e=e.filter((function(e){return e%i==r%i||e===r}));}return e}(o,a);return d})).flat(),i))),o=z(r,i);if(void 0!==o)throw new Error('Value "'.concat(o,'" out of range for ').concat(i.type));if(r.length===i.total)return [];return r}(e,g[i])}));throw new Error("Invalid cron string format")}(e),x=function(e){if(e[3].length>0)return "year";if(e[2].length>0)return "month";if(e[4].length>0)return "week";if(e[1].length>0)return "day";if(e[0].length>0)return "hour";return "minute"}(y);m(x),d(y[0]),u(y[1]),v(y[2]),s(y[3]),c(y[4]);}catch(e){p=!0;}}p&&(l.current=e,i(!0),k(r,t));}function N(e,i,r,o,l,n,t,a){if("reboot"===e)return "@reboot";var d=function(e,i,r){return e.map((function(e,o){var l,n=g[o],t=A(e,n),a=null==r?void 0:r[n.type];return M(t,n,null!==(l=null==a?void 0:a.humanizeValue)&&void 0!==l?l:i)}))}(["minute"!==e&&n?n:[],"minute"!==e&&"hour"!==e&&l?l:[],"year"!==e&&"month"!==e||!r?[]:r,"year"===e&&i?i:[],"year"!==e&&"month"!==e&&"week"!==e||!o?[]:o],t,a);return d.join(" ")}function M(e,i,r,o,l){var n="";if(function(e,i){return e.length===i.max-i.min+1}(e,i)||0===e.length)n="*";else {var t=function(e){if(e.length>2){var i=e[1]-e[0];if(i>1)return i}}(e);n=t&&function(e,i){for(var r=1;r<e.length;r++){var o=e[r-1];if(e[r]-o!==i)return !1}return !0}(e,t)?function(e,i,r){var o=P(e),l=F(e),n=e.length===(l-o)/r+1;if(o===i.min&&l+r>i.max&&n)return !0;return !1}(e,i,t)?"*/".concat(t):"".concat(T(P(e),i,r,o,l),"-").concat(T(F(e),i,r,o,l),"/").concat(t):function(e){var i=[],r=null;return e.forEach((function(e,o,l){e!==l[o+1]-1?null!==r?(i.push([r,e]),r=null):i.push(e):null===r&&(r=e);})),i}(e).map((function(e){return Array.isArray(e)?"".concat(T(e[0],i,r,o,l),"-").concat(T(e[1],i,r,o,l)):T(e,i,r,o,l)})).join(",");}return n}function T(e,i,r,o,l){var n=e.toString(),t=i.type,a=i.alt,d=i.min,u=o&&(!0===o||o.includes(t)),v="24-hour-clock"===l&&("hours"===t||"minutes"===t);if(r&&"week-days"===t||r&&"months"===t?n=a[e-d]:e<10&&(u||v)&&(n=n.padStart(2,"0")),"hours"===t&&"12-hour-clock"===l){var s=e>=12?"PM":"AM",c=e%12||12;c<10&&u&&(c=c.toString().padStart(2,"0")),n="".concat(c).concat(s);}return n}function A(e,i){var r=w(b(S(e,i)));if(0===r.length)return r;var o=z(r,i);if(void 0!==o)throw new Error('Value "'.concat(o,'" out of range for ').concat(i.type));return r}function S(e,i){return "week-days"===i.type&&(e=e.map((function(e){return 7===e?0:e}))),e}function z(e,i){var r=e[0],o=e[e.length-1];return r<i.min?r:o>i.max?o:void 0}function P(e){return e[0]}function F(e){return e[e.length-1]}function V(r){var l=r.variant,t=void 0===l?"outlined":l,u=r.size,v=void 0===u?"small":u,s=r.value,f=r.optionsList,g=r.error,O=r.setValue,b=r.locale,k=r.className,D=r.humanizeLabels,C=r.placeholder,N=r.disabled,S=r.readOnly,z=r.leadingZero,P=r.clockFormat,F=r.unit,E=r.periodicityOnDoubleClick,V=r.mode,I=r.allowClear,W=void 0===I||I,H=r.filterOption,L=void 0===H?function(){return !0}:H,J=useMemo((function(){return s&&Array.isArray(s)?s.map((function(e){return e.toString()})):"single"===V?"":[]}),[s]),Z=useMemo((function(){return f?f.map((function(e,i){return {value:(0===F.min?i:i+1).toString(),label:e}})).filter(L):function(e,i,r){if(r||2===arguments.length)for(var o,l=0,n=i.length;l<n;l++)!o&&l in i||(o||(o=Array.prototype.slice.call(i,0,l)),o[l]=i[l]);return e.concat(o||Array.prototype.slice.call(i))}([],Array(F.total),!0).map((function(e,i){var r=0===F.min?i:i+1;return {value:r.toString(),label:T(r,F,D,z,P)}})).filter(L)}),[f,z,D,P]),U=useCallback((function(){S||O([]);}),[O,S]),R=JSON.stringify(b),B=useCallback((function(r){if(!s||!r||Array.isArray(r)&&!r.length)return jsx("div",{children:C},void 0);var l=M(A(Array.isArray(r)?r.map((function(e){return Number(e)})):[Number(r)],F),F,D,z,P),n=l.match(/^\*\/([0-9]+),?/)||[];return jsxs(Box,y({display:"flex",alignItems:"center",gap:4},{children:[jsx("span",{children:n[1]?"".concat(b.everyText||x.everyText," ").concat(n[1]):l},void 0),W&&!S&&jsx(Box,y({display:"inline-block",width:"16px",height:"16px",fontSize:"16px",color:"grey.500",sx:{"&:hover":{color:"grey.600"}}},{children:jsx(Cancel,{fontSize:"inherit",color:"inherit",onMouseDown:function(e){e.stopPropagation(),U();}},void 0)}),void 0)]}),void 0)}),[s,R,D,z,P,C,W,S]),j=useCallback((function(e){var i=Array.isArray(e)?w(e):[e];i.length===F.total?O([]):O(i);}),[O,s]),Y=useCallback((function(e){var i=Array.isArray(e)?e[e.length-1]:e;if(0!==i&&1!==i){for(var r=F.total+F.min,o=[],l=F.min;l<r;l++)l%i==0&&o.push(l);var n=s&&o&&s.length===o.length&&s.every((function(e,i){return e===o[i]})),t=o.length===Z.length;O(t||n?[]:o);}else O([]);}),[s,Z,O]),_=useRef([]),G=useRef(),q=useCallback((function(e){if(!S){var i=_.current,r=e.target.value,o=Array.isArray(r)?r.map((function(e){return Number(e)})):Number(r);i.push({time:(new Date).getTime(),value:o}),G.current&&window.clearTimeout(G.current),G.current=window.setTimeout((function(){E&&i.length>1&&i[i.length-1].time-i[i.length-2].time<300?JSON.stringify(i[i.length-1].value)===JSON.stringify(i[i.length-2].value)?Y(o):j([i[i.length-2].value,i[i.length-1].value].flatMap((function(e){return e}))):j(o),_.current=[],G.current=void 0;}),300);}}),[_,j,Y,S,E]);return jsx(m,y({sx:{minWidth:75},variant:t,size:v},{children:jsx(p,y({displayEmpty:!0,multiple:"single"!==V&&E,value:J,renderValue:B,className:k,onChange:q,disabled:N,error:g},{children:Z.map((function(i){var r=i.value,o=i.label;return jsx(MenuItem,y({value:r},{children:o}),r)}))}),void 0)}),void 0)}function I(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,a=void 0===t?"small":t,d=r.value,u=r.setValue,c=r.error,m=r.errorText,p=r.locale,h=r.className,f=r.disabled,O=r.readOnly,w=r.leadingZero,b=r.clockFormat,k=r.period,D=r.periodicityOnDoubleClick,C=r.mode,N=r.allowClear,M=r.filterOption;return jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:h},{children:[""!==p.prefixHours&&jsx(Typography,{children:p.prefixHours||x.prefixHours},void 0),jsx(V,{variant:n,size:a,placeholder:p.emptyHours||x.emptyHours,value:d,unit:g[1],setValue:u,locale:p,className:h,disabled:f,readOnly:O,leadingZero:w,clockFormat:b,period:k,periodicityOnDoubleClick:D,mode:C,allowClear:N,filterOption:M,error:c},void 0)]}),void 0),c&&m&&jsx(v,y({error:!0,sx:{marginLeft:"24px",marginRight:0}},{children:m}),void 0)]}),void 0)}function W(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,a=void 0===t?"small":t,d=r.value,u=r.setValue,c=r.error,m=r.errorText,p=r.locale,h=r.className,f=r.disabled,O=r.readOnly,w=r.leadingZero,b=r.clockFormat,k=r.period,D=r.periodicityOnDoubleClick,C=r.mode,N=r.allowClear,M=r.filterOption;return jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:h},{children:["hour"===k?""!==p.prefixMinutesForHourPeriod&&jsx(Typography,{children:p.prefixMinutesForHourPeriod||x.prefixMinutesForHourPeriod},void 0):""!==p.prefixMinutes&&jsx(Typography,{children:p.prefixMinutes||x.prefixMinutes},void 0),jsx(V,{variant:n,size:a,placeholder:"hour"===k?p.emptyMinutesForHourPeriod||x.emptyMinutesForHourPeriod:p.emptyMinutes||x.emptyMinutes,value:d,unit:g[0],setValue:u,locale:p,className:h,disabled:f,readOnly:O,leadingZero:w,clockFormat:b,period:k,periodicityOnDoubleClick:D,mode:C,allowClear:N,filterOption:M,error:c},void 0),"hour"===k&&""!==p.suffixMinutesForHourPeriod&&jsx(Typography,{children:p.suffixMinutesForHourPeriod||x.suffixMinutesForHourPeriod},void 0)]}),void 0),c&&m&&jsx(v,y({error:!0,sx:{marginLeft:"14px",marginRight:0}},{children:m}),void 0)]}),void 0)}function H(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,d=void 0===t?"small":t,u=r.value,c=r.setValue,m=r.error,p=r.errorText,h=r.locale,f=r.className,O=r.weekDays,w=r.disabled,b=r.readOnly,k=r.leadingZero,D=r.period,C=r.periodicityOnDoubleClick,N=r.mode,M=r.allowClear,T=r.filterOption,A=!O||0===O.length,S=JSON.stringify(h),z=useMemo((function(){return A?h.emptyMonthDays||x.emptyMonthDays:h.emptyMonthDaysShort||x.emptyMonthDaysShort}),[A,S]);return !b||u&&u.length>0||(!u||0===u.length)&&(!O||0===O.length)?jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:f},{children:[""!==h.prefixMonthDays&&jsx(Typography,{children:h.prefixMonthDays||x.prefixMonthDays},void 0),jsx(V,{variant:n,size:d,placeholder:z,value:u,setValue:c,unit:g[2],locale:h,className:f,disabled:w,readOnly:b,leadingZero:k,period:D,periodicityOnDoubleClick:C,mode:N,allowClear:M,filterOption:T,error:m},void 0)]}),void 0),m&&p&&jsx(v,y({error:!0,sx:{marginLeft:"28px",marginRight:0}},{children:p}),void 0)]}),void 0):null}function L(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,a=void 0===t?"small":t,d=r.value,u=r.setValue,c=r.error,m=r.errorText,p=r.locale,h=r.className,f=r.humanizeLabels,O=r.disabled,w=r.readOnly,b=r.period,k=r.periodicityOnDoubleClick,D=r.mode,C=r.allowClear,N=r.filterOption,M=p.months||x.months;return jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:h},{children:[""!==p.prefixMonths&&jsx(Typography,{children:p.prefixMonths||x.prefixMonths},void 0),jsx(V,{variant:n,size:a,placeholder:p.emptyMonths||x.emptyMonths,optionsList:M,value:d,unit:y(y({},g[3]),{alt:p.altMonths||x.altMonths}),setValue:u,locale:p,className:h,humanizeLabels:f,disabled:O,readOnly:w,period:b,periodicityOnDoubleClick:k,mode:D,allowClear:C,filterOption:N,error:c},void 0)]}),void 0),c&&m&&jsx(v,y({error:!0,sx:{marginLeft:"28px",marginRight:0}},{children:m}),void 0)]}),void 0)}function J(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,a=void 0===t?"small":t,u=r.value,c=r.setValue,f=r.error,g=r.errorText,O=r.locale,w=r.className,b=r.disabled,k=r.readOnly,D=r.shortcuts,C=r.allowedPeriods,N=[];C.includes("year")&&N.push({value:"year",label:O.yearOption||x.yearOption}),C.includes("month")&&N.push({value:"month",label:O.monthOption||x.monthOption}),C.includes("week")&&N.push({value:"week",label:O.weekOption||x.weekOption}),C.includes("day")&&N.push({value:"day",label:O.dayOption||x.dayOption}),C.includes("hour")&&N.push({value:"hour",label:O.hourOption||x.hourOption}),C.includes("minute")&&N.push({value:"minute",label:O.minuteOption||x.minuteOption}),C.includes("reboot")&&D&&(!0===D||D.includes("@reboot"))&&N.push({value:"reboot",label:O.rebootOption||x.rebootOption});var M=useCallback((function(e,i){k||c(e.target.value);}),[c,k]);return jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:w},{children:[""!==O.prefixPeriod&&jsx(Typography,{children:O.prefixPeriod||x.prefixPeriod},void 0),jsx(m,y({sx:{minWidth:75},variant:n,size:a},{children:jsx(p,y({defaultValue:u,value:u,onChange:M,disabled:b,error:f},{children:N.map((function(i){var r=i.value,o=i.label;return jsx(MenuItem,y({value:r},{children:o}),r)}))}),JSON.stringify(O))}),void 0)]}),void 0),f&&g&&jsx(v,y({error:!0,sx:{marginLeft:"52px",marginRight:0}},{children:g}),void 0)]}),void 0)}function Z(r){var l=r.variant,n=void 0===l?"outlined":l,t=r.size,d=void 0===t?"small":t,u=r.value,c=r.setValue,m=r.error,p=r.errorText,h=r.locale,f=r.className,O=r.humanizeLabels,w=r.monthDays,b=r.disabled,k=r.readOnly,D=r.period,C=r.periodicityOnDoubleClick,N=r.mode,M=r.allowClear,T=r.filterOption,A=h.weekDays||x.weekDays,S="week"===D||!w||0===w.length,z=JSON.stringify(h),P=useMemo((function(){return S?h.emptyWeekDays||x.emptyWeekDays:h.emptyWeekDaysShort||x.emptyWeekDaysShort}),[S,z]),F="week"===D||!k||u&&u.length>0||(!u||0===u.length)&&(!w||0===w.length),E=!k||w&&w.length>0||(!w||0===w.length)&&(!u||0===u.length);return F?jsxs(Box,y({display:"flex",flexDirection:"column"},{children:[jsxs(Box,y({display:"flex",alignItems:"center",gap:2,className:f},{children:[""!==h.prefixWeekDays&&("week"===D||!E)&&jsx(Typography,{children:h.prefixWeekDays||x.prefixWeekDays},void 0),""!==h.prefixWeekDaysForMonthAndYearPeriod&&"week"!==D&&E&&jsx(Typography,{children:h.prefixWeekDaysForMonthAndYearPeriod||x.prefixWeekDaysForMonthAndYearPeriod},void 0),jsx(V,{variant:n,size:d,placeholder:P,optionsList:A,value:u,unit:y(y({},g[4]),{alt:h.altWeekDays||x.altWeekDays}),setValue:c,locale:h,className:f,humanizeLabels:O,disabled:b,readOnly:k,period:D,periodicityOnDoubleClick:C,mode:N,allowClear:M,filterOption:T,error:m},void 0)]}),void 0),m&&p&&jsx(v,y({error:!0,sx:{marginLeft:"28px",marginRight:0}},{children:p}),void 0)]}),void 0):null}var U={variant:"contained",color:"error"},R={period:["period"],year:["months","month-days","week-days","hours","minutes"],month:["month-days","week-days","hours","minutes"],week:["week-days","hours","minutes"],day:["hours","minutes"],hour:["minutes"]},B={get:function(e,i){return e.hasOwnProperty(i)?e[i]:R[i]}};function j(v){var s,c,m,p,h,f,g,O,w,b,D,M,T,A,S,z,P,F,E,V,j,Y,_,G,q,K,Q,X,$,ee,ie,re,oe,le,ne,te,ae,de,ue,ve,se,ce,me,pe,he,ye,fe,ge,xe,Oe,we,be,ke,De,Ce,Ne,Me,Te,Ae,Se,ze,Pe,Fe,Ee,Ve,Ie,We,He,Le,Je,Ze,Ue,Re,Be,je,Ye,_e,Ge,qe,Ke,Qe,Xe,$e,ei,ii,ri,oi,li,ni,ti=v.variant,ai=void 0===ti?"outlined":ti,di=v.size,ui=void 0===di?"small":di,vi=v.clearButton,si=void 0===vi||vi,ci=v.clearButtonProps,mi=void 0===ci?{}:ci,pi=v.clearButtonAction,hi=void 0===pi?"fill-with-every":pi,yi=v.locale,fi=void 0===yi?x:yi,gi=v.value,xi=void 0===gi?"":gi,Oi=v.setValue,wi=v.validationErrors,bi=v.displayError,ki=void 0===bi||bi,Di=v.onError,Ci=v.className,Ni=v.defaultPeriod,Mi=void 0===Ni?"day":Ni,Ti=v.allowEmpty,Ai=void 0===Ti?"for-default-value":Ti,Si=v.humanizeLabels,zi=void 0===Si||Si,Pi=v.humanizeValue,Fi=void 0!==Pi&&Pi,Ei=v.disabled,Vi=void 0!==Ei&&Ei,Ii=v.readOnly,Wi=void 0!==Ii&&Ii,Hi=v.leadingZero,Li=void 0!==Hi&&Hi,Ji=v.shortcuts,Zi=void 0===Ji?["@yearly","@annually","@monthly","@weekly","@daily","@midnight","@hourly"]:Ji,Ui=v.clockFormat,Ri=v.periodicityOnDoubleClick,Bi=void 0===Ri||Ri,ji=v.mode,Yi=void 0===ji?"multiple":ji,_i=v.allowedDropdowns,Gi=void 0===_i?R:_i,qi=v.allowedPeriods,Ki=void 0===qi?["year","month","week","day","hour","minute","reboot"]:qi,Qi=v.allowClear,Xi=v.dropdownsConfig,$i=useRef(xi),er=useRef(Mi),ir=useState(null),rr=ir[0],or=ir[1],lr=useState(null),nr=lr[0],tr=lr[1],ar=useState(null),dr=ar[0],ur=ar[1],vr=useState(null),sr=vr[0],cr=vr[1],mr=useState(null),pr=mr[0],hr=mr[1],yr=useState(null),fr=yr[0],gr=yr[1],xr=useState(!1),Or=xr[0],wr=xr[1],br=useState(!1),kr=br[0],Dr=br[1],Cr=function(e){var i=useRef(e);return useEffect((function(){i.current=e;}),[e]),i.current}(kr),Nr=JSON.stringify(fi),Mr=new Proxy(Gi,B);useEffect((function(){C(xi,wr,Di,Ai,$i,!0,fi,Zi,gr,hr,tr,ur,cr,or);}),[]),useEffect((function(){xi!==$i.current&&C(xi,wr,Di,Ai,$i,!1,fi,Zi,gr,hr,tr,ur,cr,or);}),[xi,$i,Nr,Ai,Zi]),useEffect((function(){if(!(rr||fr||dr||nr||sr||pr)||kr||Cr)kr&&Dr(!1);else {var e=rr||er.current,i=N(e,dr,nr,sr,pr,fr,Fi,Xi);Oi(i,{selectedPeriod:e}),$i.current=i,Di&&Di(void 0),wr(!1);}}),[rr,nr,dr,sr,pr,fr,Fi,kr,Xi]);var Tr=useCallback((function(){tr(null),ur(null),cr(null),hr(null),gr(null);var e="",i="reboot"!==rr&&rr?rr:er.current;(i!==rr&&or(i),"fill-with-every"===hi)&&(e=N(i,null,null,null,null,null,void 0,void 0));Oi(e,{selectedPeriod:i}),$i.current=e,Dr(!0),"never"===Ai&&"empty"===hi?(wr(!0),k(Di,fi)):(Di&&Di(void 0),wr(!1));}),[rr,Oi,Di,hi]),Ar=Object.assign(U,mi),Sr=JSON.stringify(Ar),zr=useMemo((function(){return si&&!Wi?jsx(Button$1,y({disabled:Vi,onClick:Tr},Ar,{children:fi.clearButtonText||x.clearButtonText}),void 0):null}),[si,Wi,Nr,Vi,Sr,Tr]),Pr=rr||er.current;return jsxs(Box,y({display:"flex",alignItems:"flex-start",gap:2},{children:[(null===(s=Mr.period)||void 0===s?void 0:s.includes("period"))&&jsx(J,{variant:ai,size:ui,value:Pr,setValue:or,locale:fi,className:Ci,disabled:null!==(m=null===(c=null==Xi?void 0:Xi.period)||void 0===c?void 0:c.disabled)&&void 0!==m?m:Vi,readOnly:null!==(h=null===(p=null==Xi?void 0:Xi.period)||void 0===p?void 0:p.readOnly)&&void 0!==h?h:Wi,shortcuts:Zi,allowedPeriods:Ki,allowClear:null!==(g=null===(f=null==Xi?void 0:Xi.period)||void 0===f?void 0:f.allowClear)&&void 0!==g?g:Qi,error:ki&&(Or||(null===(O=null==wi?void 0:wi.period)||void 0===O?void 0:O.error)),errorText:null===(w=null==wi?void 0:wi.period)||void 0===w?void 0:w.errorText},void 0),"reboot"===Pr?zr:jsxs(Fragment,{children:["year"===Pr&&(null===(b=Mr[Pr])||void 0===b?void 0:b.includes("months"))&&jsx(L,{variant:ai,size:ui,value:dr,setValue:ur,locale:fi,className:Ci,humanizeLabels:null!==(M=null===(D=null==Xi?void 0:Xi.months)||void 0===D?void 0:D.humanizeLabels)&&void 0!==M?M:zi,disabled:null!==(A=null===(T=null==Xi?void 0:Xi.months)||void 0===T?void 0:T.disabled)&&void 0!==A?A:Vi,readOnly:null!==(z=null===(S=null==Xi?void 0:Xi.months)||void 0===S?void 0:S.readOnly)&&void 0!==z?z:Wi,period:Pr,periodicityOnDoubleClick:null!==(F=null===(P=null==Xi?void 0:Xi.months)||void 0===P?void 0:P.periodicityOnDoubleClick)&&void 0!==F?F:Bi,mode:null!==(V=null===(E=null==Xi?void 0:Xi.months)||void 0===E?void 0:E.mode)&&void 0!==V?V:Yi,allowClear:null!==(Y=null===(j=null==Xi?void 0:Xi.months)||void 0===j?void 0:j.allowClear)&&void 0!==Y?Y:Qi,filterOption:null===(_=null==Xi?void 0:Xi.months)||void 0===_?void 0:_.filterOption,error:ki&&(Or||(null===(G=null==wi?void 0:wi.months)||void 0===G?void 0:G.error)),errorText:null===(q=null==wi?void 0:wi.months)||void 0===q?void 0:q.errorText},void 0),("year"===Pr||"month"===Pr)&&(null===(K=Mr[Pr])||void 0===K?void 0:K.includes("month-days"))&&jsx(H,{variant:ai,size:ui,value:nr,setValue:tr,locale:fi,className:Ci,weekDays:sr,disabled:null!==(X=null===(Q=null==Xi?void 0:Xi["month-days"])||void 0===Q?void 0:Q.disabled)&&void 0!==X?X:Vi,readOnly:null!==(ee=null===($=null==Xi?void 0:Xi["month-days"])||void 0===$?void 0:$.readOnly)&&void 0!==ee?ee:Wi,leadingZero:null!==(re=null===(ie=null==Xi?void 0:Xi["month-days"])||void 0===ie?void 0:ie.leadingZero)&&void 0!==re?re:Li,period:Pr,periodicityOnDoubleClick:null!==(le=null===(oe=null==Xi?void 0:Xi["month-days"])||void 0===oe?void 0:oe.periodicityOnDoubleClick)&&void 0!==le?le:Bi,mode:null!==(te=null===(ne=null==Xi?void 0:Xi["month-days"])||void 0===ne?void 0:ne.mode)&&void 0!==te?te:Yi,allowClear:null!==(de=null===(ae=null==Xi?void 0:Xi["month-days"])||void 0===ae?void 0:ae.allowClear)&&void 0!==de?de:Qi,filterOption:null===(ue=null==Xi?void 0:Xi["month-days"])||void 0===ue?void 0:ue.filterOption,error:ki&&(Or||(null===(ve=null==wi?void 0:wi["month-days"])||void 0===ve?void 0:ve.error)),errorText:null===(se=null==wi?void 0:wi["month-days"])||void 0===se?void 0:se.errorText},void 0),("year"===Pr||"month"===Pr||"week"===Pr)&&(null===(ce=Mr[Pr])||void 0===ce?void 0:ce.includes("week-days"))&&jsx(Z,{variant:ai,size:ui,value:sr,setValue:cr,locale:fi,className:Ci,humanizeLabels:null!==(pe=null===(me=null==Xi?void 0:Xi["week-days"])||void 0===me?void 0:me.humanizeLabels)&&void 0!==pe?pe:zi,monthDays:nr,disabled:null!==(ye=null===(he=null==Xi?void 0:Xi["week-days"])||void 0===he?void 0:he.disabled)&&void 0!==ye?ye:Vi,readOnly:null!==(ge=null===(fe=null==Xi?void 0:Xi["week-days"])||void 0===fe?void 0:fe.readOnly)&&void 0!==ge?ge:Wi,period:Pr,periodicityOnDoubleClick:null!==(Oe=null===(xe=null==Xi?void 0:Xi["week-days"])||void 0===xe?void 0:xe.periodicityOnDoubleClick)&&void 0!==Oe?Oe:Bi,mode:null!==(be=null===(we=null==Xi?void 0:Xi["week-days"])||void 0===we?void 0:we.mode)&&void 0!==be?be:Yi,allowClear:null!==(De=null===(ke=null==Xi?void 0:Xi["week-days"])||void 0===ke?void 0:ke.allowClear)&&void 0!==De?De:Qi,filterOption:null===(Ce=null==Xi?void 0:Xi["week-days"])||void 0===Ce?void 0:Ce.filterOption,error:ki&&(Or||(null===(Ne=null==wi?void 0:wi["week-days"])||void 0===Ne?void 0:Ne.error)),errorText:null===(Me=null==wi?void 0:wi["week-days"])||void 0===Me?void 0:Me.errorText},void 0),"minute"!==Pr&&"hour"!==Pr&&(null===(Te=Mr[Pr])||void 0===Te?void 0:Te.includes("hours"))&&jsx(I,{variant:ai,size:ui,value:pr,setValue:hr,locale:fi,className:Ci,disabled:null!==(Se=null===(Ae=null==Xi?void 0:Xi.hours)||void 0===Ae?void 0:Ae.disabled)&&void 0!==Se?Se:Vi,readOnly:null!==(Pe=null===(ze=null==Xi?void 0:Xi.hours)||void 0===ze?void 0:ze.readOnly)&&void 0!==Pe?Pe:Wi,leadingZero:null!==(Ee=null===(Fe=null==Xi?void 0:Xi.hours)||void 0===Fe?void 0:Fe.leadingZero)&&void 0!==Ee?Ee:Li,clockFormat:Ui,period:Pr,periodicityOnDoubleClick:null!==(Ie=null===(Ve=null==Xi?void 0:Xi.hours)||void 0===Ve?void 0:Ve.periodicityOnDoubleClick)&&void 0!==Ie?Ie:Bi,mode:null!==(He=null===(We=null==Xi?void 0:Xi.hours)||void 0===We?void 0:We.mode)&&void 0!==He?He:Yi,allowClear:null!==(Je=null===(Le=null==Xi?void 0:Xi.hours)||void 0===Le?void 0:Le.allowClear)&&void 0!==Je?Je:Qi,filterOption:null===(Ze=null==Xi?void 0:Xi.hours)||void 0===Ze?void 0:Ze.filterOption,error:ki&&(Or||(null===(Ue=null==wi?void 0:wi.hours)||void 0===Ue?void 0:Ue.error)),errorText:null===(Re=null==wi?void 0:wi.hours)||void 0===Re?void 0:Re.errorText},void 0),"minute"!==Pr&&(null===(Be=Mr[Pr])||void 0===Be?void 0:Be.includes("minutes"))&&jsx(W,{variant:ai,size:ui,value:fr,setValue:gr,locale:fi,period:Pr,className:Ci,disabled:null!==(Ye=null===(je=null==Xi?void 0:Xi.minutes)||void 0===je?void 0:je.disabled)&&void 0!==Ye?Ye:Vi,readOnly:null!==(Ge=null===(_e=null==Xi?void 0:Xi.minutes)||void 0===_e?void 0:_e.readOnly)&&void 0!==Ge?Ge:Wi,leadingZero:null!==(Ke=null===(qe=null==Xi?void 0:Xi.minutes)||void 0===qe?void 0:qe.leadingZero)&&void 0!==Ke?Ke:Li,clockFormat:Ui,periodicityOnDoubleClick:null!==(Xe=null===(Qe=null==Xi?void 0:Xi.minutes)||void 0===Qe?void 0:Qe.periodicityOnDoubleClick)&&void 0!==Xe?Xe:Bi,mode:null!==(ei=null===($e=null==Xi?void 0:Xi.minutes)||void 0===$e?void 0:$e.mode)&&void 0!==ei?ei:Yi,allowClear:null!==(ri=null===(ii=null==Xi?void 0:Xi.minutes)||void 0===ii?void 0:ii.allowClear)&&void 0!==ri?ri:Qi,filterOption:null===(oi=null==Xi?void 0:Xi.minutes)||void 0===oi?void 0:oi.filterOption,error:ki&&(Or||(null===(li=null==wi?void 0:wi.minutes)||void 0===li?void 0:li.error)),errorText:null===(ni=null==wi?void 0:wi.minutes)||void 0===ni?void 0:ni.errorText},void 0),zr]},void 0)]}),void 0)}

var __defProp$F = Object.defineProperty;
var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
var __hasOwnProp$F = Object.prototype.hasOwnProperty;
var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$F = (obj, key, value) => key in obj ? __defProp$F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$F.call(b, prop))
      __defNormalProp$F(a, prop, b[prop]);
  if (__getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(b)) {
      if (__propIsEnum$F.call(b, prop))
        __defNormalProp$F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$k = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function SubscriptionForm({
  notificationTypeOptions,
  notificationMethodOptions,
  formState,
  formValue,
  onSubmit = noop$6
}) {
  var _a, _b;
  const defaultValue = {
    notificationType: {},
    numberOfDays: {},
    summarySchedule: {},
    notificationMethod: {
      Messaging: false,
      Email: false
    },
    notifyEmail: "",
    notifyPhone: ""
  };
  const defaultValidationSchema = z$1.object({
    notificationType: z$1.object({}),
    notificationMethod: z$1.object({
      [SystemName.NotificationTransportType.Messaging]: z$1.boolean(),
      [SystemName.NotificationTransportType.Email]: z$1.boolean()
    }),
    numberOfDays: z$1.object({}),
    summarySchedule: z$1.object({}),
    notifyEmail: zodValidator.email.or(zodValidator.empty),
    notifyPhone: zodValidator.phone.or(zodValidator.empty)
  });
  const dynamicNotificationTypeSchema = {};
  const dynamicNumberOfDaysSchema = {};
  const dynamicSummaryScheduleSchema = {};
  notificationTypeOptions.forEach((option) => {
    dynamicNotificationTypeSchema[option.notificationTypeID] = z$1.boolean();
    if (option.hasNumberOfDays) {
      dynamicNumberOfDaysSchema[option.notificationTypeID] = z$1.string();
    }
    if (option.isSummary) {
      dynamicSummaryScheduleSchema[option.notificationTypeID] = z$1.string().optional();
    }
  });
  const validationSchema = defaultValidationSchema.extend({
    notificationType: z$1.object(dynamicNotificationTypeSchema),
    numberOfDays: z$1.object(dynamicNumberOfDaysSchema),
    summarySchedule: z$1.object(dynamicSummaryScheduleSchema)
  }).superRefine((schema, ctx) => __async$k(this, null, function* () {
    if (!schema.notificationMethod[SystemName.NotificationTransportType.Messaging] && !schema.notificationMethod[SystemName.NotificationTransportType.Email]) {
      ctx.addIssue({
        code: z$1.ZodIssueCode.custom,
        message: "Notify method is required",
        path: ["notificationMethod"]
      });
    }
    if (schema.notificationMethod[SystemName.NotificationTransportType.Email]) {
      try {
        yield zodValidator.email.parseAsync(schema.notifyEmail);
      } catch (e) {
        let message = "Invalid email";
        if (e instanceof ZodError) {
          const error = JSON.parse(e.message);
          message = error[0].message;
        }
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          message,
          path: ["notifyEmail"]
        });
      }
    }
    if (schema.notificationMethod[SystemName.NotificationTransportType.Messaging]) {
      try {
        yield zodValidator.phone.parseAsync(schema.notifyPhone);
      } catch (e) {
        let message = "Invalid phone number";
        if (e instanceof ZodError) {
          const error = JSON.parse(e.message);
          message = error[0].message;
        }
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          message,
          path: ["notifyPhone"]
        });
      }
    }
    for (let i = 0; i < notificationTypeOptions.length; i++) {
      const option = notificationTypeOptions[i];
      if (schema.notificationType[option.notificationTypeID]) {
        if (option.hasNumberOfDays) {
          const value = schema.numberOfDays[option.notificationTypeID];
          try {
            yield z$1.number().positive().parseAsync(+value);
          } catch (e) {
            ctx.addIssue({
              code: z$1.ZodIssueCode.custom,
              message: "Positive number required",
              path: [`numberOfDays.${option.notificationTypeID}`]
            });
          }
        }
        if (option.isSummary) {
          const value = schema.summarySchedule[option.notificationTypeID];
          try {
            const regex = new RegExp(/((\*\/)?\d{1}(\-)?\d{0,1})\s{1}((\*\/)?\d{1}(\-)?\d{0,1})/g);
            yield z$1.string().regex(regex).parseAsync(value);
          } catch (e) {
            ctx.addIssue({
              code: z$1.ZodIssueCode.custom,
              message: "Schedule input required",
              path: [`summarySchedule.${option.notificationTypeID}`]
            });
          }
        }
      }
    }
  }));
  const [context, Form] = useForm({
    defaultValues: formValue || defaultValue,
    validationSchema,
    reValidateMode: "onSubmit",
    onSubmit,
    onError: (error) => console.log(error)
  });
  const { control, clearErrors, reset, trigger, formState: { errors } } = context;
  useEffect(() => {
    if (formValue) {
      reset(formValue);
    }
  }, [formValue]);
  const renderNotificationTypeOptions = Array.isArray(notificationTypeOptions) && notificationTypeOptions.length > 0 ? notificationTypeOptions.filter((option) => {
    return !option.isSummary;
  }).map((option) => {
    const id = option.notificationTypeID;
    if (option.hasNumberOfDays) {
      return /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: `notificationType.${id}`,
          value: id,
          label: /* @__PURE__ */ jsx(
            Controller,
            {
              name: `numberOfDays.${id}`,
              control,
              render: ({ field: { onChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
                LabelInput,
                {
                  label: option.label,
                  name: `numberOfDays.${id}`,
                  onChange: (x) => {
                    onChange(x);
                    trigger(`numberOfDays.${id}`);
                  },
                  value,
                  error: !!error
                }
              )
            }
          )
        },
        id
      );
    } else {
      return /* @__PURE__ */ jsx(FormCheckbox, { name: `notificationType.${id}`, label: option.label, value: id }, id);
    }
  }) : "No available events";
  const renderSummaryNotificationTypeOptions = Array.isArray(notificationTypeOptions) && notificationTypeOptions.length > 0 ? notificationTypeOptions.filter((option) => {
    return option.isSummary;
  }).map((option) => {
    const id = option.notificationTypeID;
    return /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: `notificationType.${id}`,
          value: id,
          label: /* @__PURE__ */ jsx(Fragment, { children: option.label })
        }
      ),
      /* @__PURE__ */ jsx(
        Controller,
        {
          name: `summarySchedule.${id}`,
          control,
          render: ({ field: { onChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
            j,
            {
              value,
              setValue: onChange,
              allowedPeriods: [
                "month",
                "week",
                "day"
              ],
              allowedDropdowns: {
                "month": [
                  "month-days",
                  "hours",
                  "minutes"
                ]
              },
              dropdownsConfig: {
                "minutes": {
                  "mode": "single",
                  "periodicityOnDoubleClick": false
                }
              },
              validationErrors: {
                hours: {
                  error: !!error && (!value || !!value && value.split(" ")[1] === "*"),
                  errorText: "Hour is required"
                },
                minutes: {
                  error: !!error && (!value || !!value && value.split(" ")[0] === "*"),
                  errorText: "Minute is required"
                }
              },
              leadingZero: true,
              displayError: true
            }
          )
        }
      )
    ] }, id);
  }) : "No available events";
  const renderNotificationMethod = Array.isArray(notificationMethodOptions) ? notificationMethodOptions.map((option) => {
    const id = option.notificationTransportTypeID;
    return /* @__PURE__ */ jsx(
      FormCheckbox,
      {
        name: `notificationMethod.${option.systemName}`,
        label: option.name,
        value: id,
        onChange: () => clearErrors("notificationMethod.root")
      },
      id
    );
  }) : null;
  return /* @__PURE__ */ jsx(
    LoadingWrap,
    {
      isLoading: formState == null ? void 0 : formState.isLoading,
      isError: formState == null ? void 0 : formState.hasError,
      errorMessage: "Something went wrong. Please try again later.",
      children: /* @__PURE__ */ jsxs(Form, { children: [
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsx(Box, { py: 5, children: /* @__PURE__ */ jsx(FormElementWrap, { name: "notifyType", label: "Notify me when:", children: /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start", children: renderNotificationTypeOptions }) }) }),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsx(Box, { py: 5, children: /* @__PURE__ */ jsx(FormElementWrap, { name: "notifyType", label: "Schedule update:", children: /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", children: renderSummaryNotificationTypeOptions }) }) }),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", py: 5, children: [
          /* @__PURE__ */ jsxs(FormElementWrap, { name: "notifyMethod", label: "Notify method:", children: [
            renderNotificationMethod,
            /* @__PURE__ */ jsx(FormHelperText, { error: true, children: (_b = (_a = errors == null ? void 0 : errors.notificationMethod) == null ? void 0 : _a.root) == null ? void 0 : _b.message })
          ] }),
          /* @__PURE__ */ jsx(FormElementWrap, { name: "notifyEmail", label: "Email", children: /* @__PURE__ */ jsx(FormInput, { name: "notifyEmail", placeholder: "Email" }) })
        ] }),
        /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Button$1, { type: "submit", color: "primary", variant: "contained", children: "Subscribe" }) })
      ] })
    }
  );
}
const LabelInput = (props) => {
  const _a = props, { label, name, value, onChange } = _a, others = __objRest$g(_a, ["label", "name", "value", "onChange"]);
  const handleOnChange = (input) => {
    typeof onChange === "function" && onChange(input);
  };
  return /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ jsx(Box, { children: label.beforeInput }),
    /* @__PURE__ */ jsx(Box, { width: 45, mx: 2, children: /* @__PURE__ */ jsx(
      NumberInput,
      __spreadValues$F({
        name,
        value,
        onChange: handleOnChange,
        inputProps: { maxLength: 2 }
      }, others)
    ) }),
    /* @__PURE__ */ jsx(Box, { children: label.afterInput })
  ] });
};

var __defProp$E = Object.defineProperty;
var __defProps$y = Object.defineProperties;
var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
var __hasOwnProp$E = Object.prototype.hasOwnProperty;
var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$E = (obj, key, value) => key in obj ? __defProp$E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$E.call(b, prop))
      __defNormalProp$E(a, prop, b[prop]);
  if (__getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(b)) {
      if (__propIsEnum$E.call(b, prop))
        __defNormalProp$E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$y = (a, b) => __defProps$y(a, __getOwnPropDescs$y(b));
var __objRest$f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function SubscriptionDialog(_a) {
  var _b = _a, { title, subscriptionProps, children } = _b, rest = __objRest$f(_b, ["title", "subscriptionProps", "children"]);
  const { notificationTypeOptions, notificationMethodOptions, formState, formValue, onSubmit } = subscriptionProps;
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const handleIconClick = () => {
    openDialog();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IconButton, { title: "Notify me", onClick: handleIconClick, children }),
    /* @__PURE__ */ jsx(
      DialogWrap,
      __spreadProps$y(__spreadValues$E({}, rest), {
        maxWidth: "md",
        fullWidth: true,
        open: isDialogOpen,
        onCloseBtnClick: closeDialog,
        title,
        children: /* @__PURE__ */ jsx(
          SubscriptionForm,
          {
            notificationTypeOptions,
            notificationMethodOptions,
            formValue,
            formState,
            onSubmit
          }
        )
      })
    )
  ] });
}

var __defProp$D = Object.defineProperty;
var __defProps$x = Object.defineProperties;
var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
var __hasOwnProp$D = Object.prototype.hasOwnProperty;
var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$D.call(b, prop))
      __defNormalProp$D(a, prop, b[prop]);
  if (__getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(b)) {
      if (__propIsEnum$D.call(b, prop))
        __defNormalProp$D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$x = (a, b) => __defProps$x(a, __getOwnPropDescs$x(b));
function TrackerControls({ disabled, watchlist, subscriptionDialog, shareMagicLink }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const iconColor = disabled ? "disabled" : "primary";
  const iconButtonSize = mobileBreakPoint ? "small" : "medium";
  return /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: mobileBreakPoint ? 1 : 4, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", children: [
    watchlist ? /* @__PURE__ */ jsx(
      WatchlistIcon,
      __spreadValues$D({
        color: iconColor,
        fontSize: iconButtonSize,
        disabled: disabled || !watchlist.objectID
      }, watchlist)
    ) : /* @__PURE__ */ jsx(Fragment, {}),
    subscriptionDialog ? /* @__PURE__ */ jsx(SubscriptionDialog, __spreadProps$x(__spreadValues$D({}, subscriptionDialog), { children: /* @__PURE__ */ jsx(NotificationsNone, { color: iconColor, fontSize: iconButtonSize }) })) : null,
    shareMagicLink ? /* @__PURE__ */ jsx(ShareWithMagicLink, __spreadProps$x(__spreadValues$D({ disabled }, shareMagicLink), { children: /* @__PURE__ */ jsx(Share, { color: iconColor, fontSize: iconButtonSize }) })) : null
  ] }) });
}

var __defProp$C = Object.defineProperty;
var __defProps$w = Object.defineProperties;
var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
var __hasOwnProp$C = Object.prototype.hasOwnProperty;
var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$C.call(b, prop))
      __defNormalProp$C(a, prop, b[prop]);
  if (__getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(b)) {
      if (__propIsEnum$C.call(b, prop))
        __defNormalProp$C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$w = (a, b) => __defProps$w(a, __getOwnPropDescs$w(b));
function getCurrentTransport(transportLegs, geoCoordinates) {
  for (let i = 0; i < transportLegs.length - 1; i++) {
    const coords = geoCoordinates.flatMap((x) => x.data);
    const a = transportLegs[i];
    let isCurrent = !!a.transport.etd || !!coords.find((x) => +x.objectID === +a.transportID);
    if (i + 1 < transportLegs.length - 1) {
      isCurrent = !transportLegs[i + 1].transport.berthed || !coords.find((x) => +x.objectID === +transportLegs[i + 1].transportID);
    }
    if (isCurrent)
      return a;
    continue;
  }
}
function isPortalShipment(data) {
  if (data && data.jobTypeSystemName) {
    return data.jobTypeSystemName === SystemName.JobType.PortalShipment;
  }
  return false;
}
const Skeleton$5 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
function HeadingIcon({ degrees }) {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(
    Box$1,
    {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "18px",
      height: "18px",
      bgcolor: theme.palette.common.black,
      borderRadius: "50%",
      color: theme.palette.common.white,
      sx: {
        transform: `rotate(${degrees}deg)`
      },
      children: /* @__PURE__ */ jsx(Navigation, { fontSize: "inherit", color: "inherit", sx: { marginBottom: "2px" } })
    }
  );
}
function PortDetails({ transport, intent }) {
  var _a;
  const [{ data, isFetching }] = useLookupQuery({
    systemName: "PortalLocation",
    additionalFilter: {
      locationID: transport.portID
    }
  });
  if (isFetching) {
    return /* @__PURE__ */ jsx(PortDetailsLoading, {});
  }
  const location = data == null ? void 0 : data.data.results[0];
  const estimated = intent === "departure" ? transport.etd : transport.eta;
  const estimatedFormatted = estimated ? dayjs(estimated).format("DD MMM YYYY HH:mm") : void 0;
  const actual = intent === "departure" ? transport.departed : transport.berthed;
  const actualFormatted = actual ? dayjs(actual).format("DD MMM YYYY HH:mm") : void 0;
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
      ((_a = location == null ? void 0 : location.additionalData) == null ? void 0 : _a.combinedCode) && /* @__PURE__ */ jsx(Flag, { country: `${location.additionalData.combinedCode.slice(0, 2)}` }),
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: location == null ? void 0 : location.name })
    ] }),
    /* @__PURE__ */ jsxs(
      "ul",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          rowGap: "0.5rem",
          margin: 0,
          padding: 0,
          paddingLeft: "3rem"
        },
        children: [
          /* @__PURE__ */ jsxs("li", { style: { fontSize: "0.8rem", lineHeight: "0.85rem" }, children: [
            "Estimated:\xA0",
            estimatedFormatted
          ] }),
          /* @__PURE__ */ jsxs("li", { style: { fontSize: "0.8rem", lineHeight: "0.85rem" }, children: [
            "Actual:\xA0",
            actualFormatted
          ] })
        ]
      }
    )
  ] });
}
function VoyageDetails$3({ data }) {
  var _a, _b, _c, _d;
  const theme = useTheme$2();
  const { data: geoCoordinates, isFetching: geoCoordinatesFetching } = useVesselMovementCoordinates(
    defaultValue(data == null ? void 0 : data.transportLegs, [])
  );
  const isAirFreight = ((_a = data == null ? void 0 : data.shipmentMode) == null ? void 0 : _a.code) === SystemName.ShipmentMode.Air;
  const sortedTransportLegs = useSortedTransportLegs(defaultValue(data == null ? void 0 : data.transportLegs, []));
  const transportComplete = !!((_b = sortedTransportLegs[sortedTransportLegs.length - 1]) == null ? void 0 : _b.transport.berthed) || !!((_c = data == null ? void 0 : data.actualArrival) == null ? void 0 : _c.dateAndTime);
  const currentTransport = getCurrentTransport(sortedTransportLegs, geoCoordinates ? geoCoordinates : []);
  const lastPositionUpdate = geoCoordinates && !geoCoordinatesFetching ? geoCoordinates.flatMap((x) => x.data.map((coord) => __spreadProps$w(__spreadValues$C({}, coord), { time: dayjs(coord.dateAndTime) }))).sort((a, b) => a.time.diff(b.time)).pop() : void 0;
  const now = dayjs();
  const lastPositionUpdateFormatted = lastPositionUpdate ? dayjs.duration(lastPositionUpdate.time.diff(now)).humanize(true) : void 0;
  const lastPositionTransport = sortedTransportLegs.find((x) => x.transportID === (lastPositionUpdate == null ? void 0 : lastPositionUpdate.objectID));
  const speed = lastPositionTransport == null ? void 0 : lastPositionTransport.transport.speed;
  const speedFormatted = (speed == null ? void 0 : speed.measure) && (speed == null ? void 0 : speed.measureUnitType) ? `
			${speed.measure.toLocaleString(window.navigator.language)} 
			${inflect(defaultValue(Symbol$1[speed.measureUnitTypeSystemName], speed.measureUnitType), speed.measure)}
		` : speed == null ? void 0 : speed.measure;
  const course = lastPositionTransport == null ? void 0 : lastPositionTransport.transport.course;
  const courseFormatted = (course == null ? void 0 : course.measure) && (course == null ? void 0 : course.measureUnitType) ? `${Math.round(course.measure)}\xB0` : course == null ? void 0 : course.measure;
  const CourseIcon = (course == null ? void 0 : course.measure) ? /* @__PURE__ */ jsx(HeadingIcon, { degrees: Math.round(course.measure) }) : null;
  const lastPort = currentTransport;
  const nextPort = sortedTransportLegs[sortedTransportLegs.indexOf(currentTransport) + 1];
  const status = transportComplete ? "Completed" : speed && defaultValue(speed == null ? void 0 : speed.measure, 0) > 0 ? isAirFreight ? "In Flight" : "Sailing" : isAirFreight ? "Awaiting Uplift" : "At Anchor";
  if (geoCoordinatesFetching) {
    return /* @__PURE__ */ jsx(VoyageDetailsLoading, {});
  }
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Vessel" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: (_d = currentTransport == null ? void 0 : currentTransport.transport) == null ? void 0 : _d.vesselName })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: isAirFreight ? "Flight No." : "Voyage" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: currentTransport == null ? void 0 : currentTransport.transport.reference })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Speed/Course" }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 1, children: [
          /* @__PURE__ */ jsxs(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: [
            speedFormatted,
            "\xA0/\xA0",
            courseFormatted
          ] }),
          CourseIcon
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Last Position Update" }),
        /* @__PURE__ */ jsx(Fragment, { children: geoCoordinatesFetching ? /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "85px" }) : /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: lastPositionUpdateFormatted }) })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Status" }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: status })
      ] }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: !isAirFreight && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Lloyds No." }),
        /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: currentTransport == null ? void 0 : currentTransport.transport.vesselLloyds })
      ] }) })
    ] }),
    isPortalShipment(data) ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider$1, {}),
      /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Last Port" }),
          lastPort && /* @__PURE__ */ jsx(PortDetails, { transport: lastPort.transport, intent: "departure" })
        ] }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Next Port" }),
          nextPort && /* @__PURE__ */ jsx(PortDetails, { transport: nextPort.transport, intent: "arrival" })
        ] })
      ] })
    ] }) : null
  ] });
}
function VoyageDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, paddingTop: 0.5, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "40px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "145px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "75px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "155px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "45px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "30px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "90px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "85px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "65px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "60px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.5, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "130px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "100px" })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, paddingTop: 1, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(PortDetailsLoading, {})
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 3, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.815rem", width: "60px" }),
        /* @__PURE__ */ jsx(PortDetailsLoading, {})
      ] })
    ] })
  ] });
}
function PortDetailsLoading() {
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(Skeleton$5, { height: "20px", width: "24px" }),
      /* @__PURE__ */ jsx(Skeleton$5, { height: "0.9rem", width: "225px" })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingLeft: 8, children: [
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "5px", width: "5px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.8rem", width: "190px" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$5, { height: "5px", width: "5px" }),
        /* @__PURE__ */ jsx(Skeleton$5, { height: "0.8rem", width: "170px" })
      ] })
    ] })
  ] });
}

const parseNumber$2 = (value, pattern) => {
  return (value.match(pattern) || []).join(EMPTY_STRING$g);
};
const formatNumber = (input, decimalPlaces = 4) => {
  const accept = /[\d.]+/g;
  const parsed = parseNumber$2(input, accept);
  const [head, tail] = parsed.split(".");
  const truncatedTail = !isNothing(tail) ? tail.slice(0, decimalPlaces) : EMPTY_STRING$g;
  const number = Number.parseFloat(`${head}.${truncatedTail}`);
  if (Number.isNaN(number)) {
    return EMPTY_STRING$g;
  }
  const formatted = number.toLocaleString(window.navigator.language, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimalPlaces
  });
  if (parsed.includes(".")) {
    const [formattedHead] = formatted.split(".");
    const formattedTail = truncatedTail !== EMPTY_STRING$g && truncatedTail[decimalPlaces - 1] === "0" ? truncatedTail.slice(0, -1) : truncatedTail;
    return `${formattedHead}.${formattedTail}`;
  }
  return formatted;
};

const gridColumns$2 = [
  {
    field: "rateType",
    headerName: "Charge Item",
    width: 300
  },
  {
    field: "description",
    flex: 1,
    headerName: "Description"
  },
  {
    field: "amount",
    type: "number",
    align: "left",
    headerName: "Charge",
    headerAlign: "left",
    width: 200,
    valueFormatter: ({ value }) => value ? "$" + formatNumber(value.toString()) : null
  }
];
function ConsignmentChargeDetails$2({
  gridRows,
  gridLoading,
  estimatedCharge,
  gridFooter
}) {
  var _a;
  const theme = useTheme$2();
  const total = gridRows.reduce((sum, row) => {
    var _a2;
    return sum + ((_a2 = row.amount) != null ? _a2 : 0);
  }, 0);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataGridPro,
      {
        columns: gridColumns$2,
        rows: gridRows != null ? gridRows : [],
        loading: gridLoading,
        rowSelection: false,
        autoHeight: true,
        disableColumnReorder: true,
        disableColumnMenu: true,
        disableColumnResize: true,
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.common.black,
            fontWeight: 600
          },
          borderRadius: 0
        },
        slots: {
          footer: () => /* @__PURE__ */ jsxs(
            Box$1,
            {
              sx: {
                width: "100%",
                height: "52px",
                display: "flex",
                alignItems: "center",
                padding: "10px",
                borderTop: `1px solid ${theme.palette.divider}`,
                fontWeight: "bold",
                backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
              },
              children: [
                /* @__PURE__ */ jsx(Box$1, { sx: { width: 300 } }),
                /* @__PURE__ */ jsx(Box$1, { sx: { flexGrow: 1, textAlign: "right" }, children: "Total Charge (NZD)" }),
                /* @__PURE__ */ jsxs(Box$1, { sx: { width: 200, paddingLeft: "20px" }, children: [
                  "$",
                  formatNumber(total.toString())
                ] })
              ]
            }
          )
        }
      }
    ),
    /* @__PURE__ */ jsxs(Box$1, { sx: { width: "100%", display: "flex", padding: "10px" }, children: [
      /* @__PURE__ */ jsx(Box$1, { sx: { flexGrow: 1 }, children: (estimatedCharge == null ? void 0 : estimatedCharge.measure) && /* @__PURE__ */ jsxs(Typography$1, { variant: "caption", children: [
        "*Original estimate $",
        formatNumber((_a = estimatedCharge.measure) == null ? void 0 : _a.toString())
      ] }) }),
      gridFooter ? gridFooter : /* @__PURE__ */ jsx(Box$1, { sx: { width: 200, display: "flex", paddingLeft: "20px" }, children: /* @__PURE__ */ jsxs(Box$1, { sx: { display: "flex", flexDirection: "column" }, children: [
        /* @__PURE__ */ jsx(Typography$1, { variant: "caption", children: "* Charges excl GST & FAF" }),
        /* @__PURE__ */ jsx(Typography$1, { variant: "caption", sx: { textAlign: "right" }, children: "FAF % XXXX" })
      ] }) })
    ] })
  ] });
}

function UserGrid({
  rows,
  columns,
  columnKeys,
  isExcludeColumnKey,
  customiseColumns,
  loading,
  getRowId,
  onRowClick
}) {
  const theme = useTheme$2();
  const handleOnRowClick = (data) => {
    typeof onRowClick === "function" && onRowClick(data == null ? void 0 : data.row);
  };
  const displayColumns = useMemo(() => {
    const defaultSetting = {
      name: {
        field: "name",
        flex: 1,
        headerName: "Full Name",
        disableColumnMenu: true
      },
      username: {
        field: "username",
        flex: 1,
        headerName: "Username",
        disableColumnMenu: true
      },
      phone: {
        field: "phone",
        flex: 1,
        headerName: "Phone",
        disableColumnMenu: true
      },
      email: {
        field: "email",
        flex: 1,
        headerName: "Email",
        disableColumnMenu: true
      },
      company: {
        field: "company",
        flex: 1,
        headerName: "Organisation",
        disableColumnMenu: true
      },
      branch: {
        field: "branch",
        flex: 1,
        headerName: "Branch",
        disableColumnMenu: true
      },
      country: {
        field: "country",
        flex: 1,
        headerName: "Country",
        disableColumnMenu: true
      },
      active: {
        field: "active",
        flex: 1,
        headerName: "Active",
        disableColumnMenu: true,
        type: "boolean"
      }
    };
    let initSetting = {};
    if (Array.isArray(columns)) {
      columns.forEach((col) => {
        if (col.field) {
          initSetting[col.field] = col;
        }
      });
    } else {
      initSetting = defaultSetting;
    }
    let setting = {};
    if (Array.isArray(columnKeys)) {
      if (isExcludeColumnKey) {
        setting = initSetting;
        columnKeys.forEach((columnKey) => {
          delete setting[columnKey];
        });
      } else {
        columnKeys.forEach((columnKey) => {
          setting[columnKey] = initSetting[columnKey] || {
            field: columnKey,
            flex: 1,
            headerName: columnKey,
            disableColumnMenu: true
          };
        });
      }
    } else {
      setting = initSetting;
    }
    if (Array.isArray(customiseColumns)) {
      customiseColumns.forEach((column) => {
        const settingKey = column.field;
        setting[settingKey] = column;
      });
    }
    return Object.keys(setting).map((key) => {
      return setting[key];
    });
  }, [columnKeys, isExcludeColumnKey, customiseColumns]);
  return /* @__PURE__ */ jsx(
    DataGridPro,
    {
      loading,
      hideFooter: true,
      onRowClick: handleOnRowClick,
      columns: displayColumns,
      rows,
      getRowId: typeof getRowId === "function" ? (row) => getRowId(row) : (row) => row.userID,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        fontSize: "0.85rem"
      },
      autoHeight: true
    }
  );
}

function UserFilter({ onSubmit }) {
  const [context, Form] = useForm({
    defaultValues: {
      organisation: null,
      name: "",
      active: null,
      country: null
    }
  });
  const { handleSubmit, reset } = context;
  const { organisationLookupParams, renderOption, filterOptions } = useOrganisationLookupHelper();
  const handleApplyClick = () => {
    handleSubmit((state) => {
      var _a, _b, _c;
      const filterData = {
        nameOrUsername: state.name,
        activeID: ((_a = state == null ? void 0 : state.active) == null ? void 0 : _a.id) || null,
        countryName: ((_b = state == null ? void 0 : state.country) == null ? void 0 : _b.name) || null,
        companyID: ((_c = state == null ? void 0 : state.organisation) == null ? void 0 : _c.id) || null
      };
      onSubmit(filterData);
    })();
  };
  const handleClearClick = () => {
    reset();
  };
  return /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(Typography, { variant: "body1", gutterBottom: true, children: "Filters" }),
    /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, md: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "country", label: "Country" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "country",
            placeholder: "Country",
            params: {
              systemName: "ContactCountry",
              additionalFilter: {
                contactType: "User"
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, md: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "organisation", label: "Organisation" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            useSearchTerm: true,
            name: "organisation",
            placeholder: "Organisation",
            params: organisationLookupParams,
            renderOption,
            filterOptions
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, md: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "active", label: "Name" }),
        /* @__PURE__ */ jsx(FormInput, { name: "name", placeholder: "Name" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, md: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "active", label: "Active" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "active",
            placeholder: "Active",
            params: {
              systemName: "ActiveType"
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Grid$4, { item: true, md: 2, alignSelf: "end", marginLeft: 10, children: /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(Button$1, { onClick: handleApplyClick, color: "primary", variant: "contained", children: "Apply" }),
        /* @__PURE__ */ jsx(Button$1, { onClick: handleClearClick, color: "primary", variant: "outlined", children: "Clear" })
      ] }) })
    ] })
  ] });
}

var __defProp$B = Object.defineProperty;
var __defProps$v = Object.defineProperties;
var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
var __hasOwnProp$B = Object.prototype.hasOwnProperty;
var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$B.call(b, prop))
      __defNormalProp$B(a, prop, b[prop]);
  if (__getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(b)) {
      if (__propIsEnum$B.call(b, prop))
        __defNormalProp$B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$v = (a, b) => __defProps$v(a, __getOwnPropDescs$v(b));
function UserForm({ userData, isEdit, validationSchema, onSubmit }) {
  const defaultValues = useMemo(() => {
    return {
      userName: (userData == null ? void 0 : userData.userName) || "",
      identityType: (userData == null ? void 0 : userData.identityType) || void 0,
      firstName: (userData == null ? void 0 : userData.firstName) || "",
      middleName: (userData == null ? void 0 : userData.middleName) || "",
      lastName: (userData == null ? void 0 : userData.lastName) || "",
      phoneNumber: (userData == null ? void 0 : userData.phoneNumber) || "",
      email: (userData == null ? void 0 : userData.email) || "",
      country: (userData == null ? void 0 : userData.country) || "",
      notes: (userData == null ? void 0 : userData.notes) || "",
      profilePicture: (userData == null ? void 0 : userData.profilePicture) || ""
    };
  }, [userData]);
  const userSchema = z$1.object({
    userName: zodValidator.inputRequired,
    identityType: isEdit ? zodValidator.optional : z$1.object({ id: z$1.string(), name: zodValidator.inputRequired }),
    firstName: zodValidator.inputRequired,
    middleName: zodValidator.stringOptional,
    lastName: zodValidator.inputRequired,
    phoneNumber: zodValidator.phone.or(zodValidator.empty),
    email: zodValidator.email,
    country: zodValidator.stringOptional,
    notes: zodValidator.stringOptional
  });
  const [context, Form] = useForm({
    validationSchema: validationSchema || userSchema,
    defaultValues
  });
  const { handleSubmit, reset } = context;
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);
  const handleSubmitBtnClick = () => {
    handleSubmit(
      (state) => {
        if (!isEdit) {
          if (isLookupItem(state.identityType)) {
            const data = __spreadProps$v(__spreadValues$B({}, state), {
              identityTypeID: state.identityType.id,
              identityType: state.identityType.name,
              active: true
            });
            typeof onSubmit === "function" && onSubmit(data);
          }
        } else {
          typeof onSubmit === "function" && onSubmit(state);
        }
      },
      (error) => {
        console.log("submit failed:", error);
      }
    )();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  return /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(Grid$4, { container: true, children: /* @__PURE__ */ jsxs(Grid$4, { item: true, lg: 6, md: 12, sm: 12, children: [
      /* @__PURE__ */ jsx(FormElementWrap, { name: "userName", label: "Username", children: /* @__PURE__ */ jsx(FormInput, { required: true, name: "userName", placeholder: "Username" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "identityType", label: "Identity Type", children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "identityType",
          placeholder: "Identity Type",
          disabled: isEdit,
          params: {
            systemName: "IdentityTypes"
          }
        }
      ) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "firstName", label: "First Name", children: /* @__PURE__ */ jsx(FormInput, { name: "firstName", placeholder: "First Name" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "middleName", label: "Middle Name", children: /* @__PURE__ */ jsx(FormInput, { name: "middleName", placeholder: "Middle Name" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "lastName", label: "Last Name", children: /* @__PURE__ */ jsx(FormInput, { name: "lastName", placeholder: "Last Name" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "phoneNumber", label: "Phone", children: /* @__PURE__ */ jsx(FormInput, { name: "phoneNumber", placeholder: "Phone" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "email", label: "Email", children: /* @__PURE__ */ jsx(FormInput, { name: "email", placeholder: "Email" }) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "country", label: "Country", children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "country",
          placeholder: "Country",
          params: {
            systemName: "Location",
            additionalFilter: {
              locationType: ["Country"]
            }
          },
          transform: {
            input: (value) => {
              return !value ? null : value;
            },
            output: (option, _value) => option == null ? void 0 : option.name
          }
        }
      ) }),
      /* @__PURE__ */ jsx(FormElementWrap, { name: "notes", label: "Notes", children: /* @__PURE__ */ jsx(FormInput, { name: "notes", placeholder: "Notes", multiline: true, rows: 4 }) })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { display: "flex", gap: 3, children: isEdit ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Update" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] }) : /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Create" }) })
  ] });
}

var __defProp$A = Object.defineProperty;
var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
var __hasOwnProp$A = Object.prototype.hasOwnProperty;
var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$A.call(b, prop))
      __defNormalProp$A(a, prop, b[prop]);
  if (__getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(b)) {
      if (__propIsEnum$A.call(b, prop))
        __defNormalProp$A(a, prop, b[prop]);
    }
  return a;
};
const generalConfigKey = {
  currency: "Currency",
  home: "Home",
  timezone: "Timezone",
  distance: "Distance",
  weight: "Weight",
  size: "Size"
};
function PreferenceForm({
  preferenceData,
  generalConfig,
  otherSettings,
  validationSchema,
  onSubmit
}) {
  const { currency, home, timezone, distance, weight, size } = generalConfigKey;
  const {
    getHidedValue,
    getRequiredValue,
    validationSchema: defaultSchema
  } = useFormConfigure({ config: generalConfig, otherSettings });
  const getOtherSettingDefaultValue = useCallback(() => {
    let value = {};
    if (Array.isArray(otherSettings)) {
      otherSettings.forEach((setting) => {
        if (preferenceData) {
          value[setting.name] = convertDataToBoolean(preferenceData[setting.name]);
        } else {
          value[setting.name] = false;
        }
      });
    }
    return value;
  }, [preferenceData, otherSettings]);
  const [context, Form] = useForm({
    validationSchema: validationSchema || defaultSchema,
    defaultValues: __spreadValues$A(__spreadValues$A({}, preferenceData), getOtherSettingDefaultValue())
  });
  const { control, handleSubmit, reset } = context;
  useEffect(() => {
    reset(__spreadValues$A(__spreadValues$A({}, preferenceData), getOtherSettingDefaultValue()));
  }, [preferenceData, getOtherSettingDefaultValue]);
  const handleSubmitBtnClick = () => {
    handleSubmit(
      (state) => {
        typeof onSubmit === "function" && onSubmit(state);
      },
      (err) => {
        console.log("Submit preference form with error:", err);
      }
    )();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  const renderSettings = useMemo(() => {
    if (Array.isArray(otherSettings)) {
      return otherSettings.map((setting) => {
        return /* @__PURE__ */ jsx(
          Controller,
          {
            control,
            name: setting.name,
            render: ({ field: { onChange, value } }) => {
              return /* @__PURE__ */ jsx(
                SwitchInput,
                {
                  label: setting.label,
                  name: setting.name,
                  checked: value,
                  onChange
                }
              );
            }
          },
          setting.name
        );
      });
    }
  }, [otherSettings]);
  return /* @__PURE__ */ jsxs(Form, { children: [
    !getHidedValue(currency) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Currency", name: currency, required: getRequiredValue(currency), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: currency,
        placeholder: "Currency",
        params: {
          systemName: "Code",
          additionalFilter: "Currency"
        },
        transform: {
          input: (value) => {
            return !value ? null : value;
          },
          output: (option, _value) => option == null ? void 0 : option.name
        }
      }
    ) }),
    !getHidedValue(home) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Home", name: home, required: getRequiredValue(home), children: /* @__PURE__ */ jsx(FormInput, { name: home, placeholder: "Home" }) }),
    !getHidedValue(timezone) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Timezone", name: timezone, required: getRequiredValue(timezone), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: timezone,
        placeholder: "Timezone",
        params: {
          systemName: "TimeZone"
        },
        transform: {
          input: (value) => {
            return !value ? null : value;
          },
          output: (option, _value) => option == null ? void 0 : option.name
        }
      }
    ) }),
    !getHidedValue(distance) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Distance", name: distance, required: getRequiredValue(distance), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: distance,
        placeholder: "Distance",
        params: {
          systemName: "MeasureUnitType",
          additionalFilter: "Length"
        },
        transform: {
          input: (value) => {
            return !value ? null : value;
          },
          output: (option, _value) => option == null ? void 0 : option.name
        }
      }
    ) }),
    !getHidedValue(weight) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Weight", name: weight, required: getRequiredValue(weight), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: weight,
        placeholder: "Weight",
        params: {
          systemName: "MeasureUnitType",
          additionalFilter: "Weight"
        },
        transform: {
          input: (value) => {
            return !value ? null : value;
          },
          output: (option, _value) => option == null ? void 0 : option.name
        }
      }
    ) }),
    !getHidedValue(size) && /* @__PURE__ */ jsx(FormElementWrap, { label: "Size", name: size, required: getRequiredValue(size), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: size,
        placeholder: "Size",
        params: {
          systemName: "MeasureUnitType",
          additionalFilter: "Volume"
        },
        transform: {
          input: (value) => {
            return !value ? null : value;
          },
          output: (option, _value) => option == null ? void 0 : option.name
        }
      }
    ) }),
    renderSettings,
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 3, children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Update" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] })
  ] });
}

const passwordSchema = z$1.object({
  oldPassword: zodValidator.inputRequired,
  newPassword: zodValidator.password,
  confirmNewPassword: zodValidator.inputRequired
}).refine((data) => data.newPassword === data.confirmNewPassword, {
  message: "Passwords don't match",
  path: ["confirmNewPassword"]
});
const ChangePasswordForm = ({ validationSchema, onSubmit }) => {
  const [context, Form] = useForm({
    validationSchema: validationSchema || passwordSchema,
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    }
  });
  const { handleSubmit, reset, trigger } = context;
  const handleUpdateBtnClick = () => {
    return trigger();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  const handleUpdatePassword = () => {
    handleSubmit((state) => {
      typeof onSubmit === "function" && onSubmit(state);
    })();
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(FormElementWrap, { required: true, name: "oldPassword", label: "Old Password", children: /* @__PURE__ */ jsx(FormInput, { type: "password", name: "oldPassword", placeholder: "Old Password" }) }),
    /* @__PURE__ */ jsx(FormElementWrap, { required: true, name: "newPassword", label: "New Password", children: /* @__PURE__ */ jsx(FormInput, { type: "password", name: "newPassword", placeholder: "New Password" }) }),
    /* @__PURE__ */ jsx(FormElementWrap, { required: true, name: "confirmNewPassword", label: "Confirm Password", children: /* @__PURE__ */ jsx(FormInput, { type: "password", name: "confirmNewPassword", placeholder: "Confirm Password" }) }),
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 3, children: [
      /* @__PURE__ */ jsx(
        ConfirmActionButton,
        {
          modalTitle: "Confirm Change Password",
          modalContent: "Do you want to change the user\u2019s password?",
          onClick: handleUpdateBtnClick,
          onConfirm: handleUpdatePassword,
          color: "primary",
          variant: "contained",
          children: "Update"
        }
      ),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] })
  ] }) });
};

const pinSchema = z$1.object({
  newPin: zodValidator.inputRequired,
  confirmNewPin: zodValidator.inputRequired
}).refine((data) => data.newPin === data.confirmNewPin, {
  message: "Pin don't match",
  path: ["confirmNewPin"]
});
const ChangePinForm = ({ validationSchema, onSubmit }) => {
  const [context, Form] = useForm({
    validationSchema: validationSchema || pinSchema,
    defaultValues: {
      newPin: "",
      confirmNewPin: ""
    }
  });
  const { handleSubmit, reset, trigger } = context;
  const handleUpdateBtnClick = () => {
    return trigger();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  const handleUpdatePin = () => {
    handleSubmit((state) => {
      typeof onSubmit === "function" && onSubmit(state);
    })();
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(FormElementWrap, { required: true, name: "newPin", label: "New Pin", children: /* @__PURE__ */ jsx(FormInput, { type: "password", name: "newPin", placeholder: "New Pin" }) }),
    /* @__PURE__ */ jsx(FormElementWrap, { required: true, name: "confirmNewPin", label: "Confirm Pin", children: /* @__PURE__ */ jsx(FormInput, { type: "password", name: "confirmNewPin", placeholder: "Confirm Pin" }) }),
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 3, children: [
      /* @__PURE__ */ jsx(
        ConfirmActionButton,
        {
          modalTitle: "Confirm Change Pin",
          modalContent: "Do you want to change the user\u2019s pin?",
          onConfirm: handleUpdatePin,
          onClick: handleUpdateBtnClick,
          color: "primary",
          variant: "contained",
          children: "Update"
        }
      ),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] })
  ] }) });
};

var __defProp$z = Object.defineProperty;
var __defProps$u = Object.defineProperties;
var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
var __hasOwnProp$z = Object.prototype.hasOwnProperty;
var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$z.call(b, prop))
      __defNormalProp$z(a, prop, b[prop]);
  if (__getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(b)) {
      if (__propIsEnum$z.call(b, prop))
        __defNormalProp$z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$u = (a, b) => __defProps$u(a, __getOwnPropDescs$u(b));
function PermissionForm({ permissionContext, permissionValue, onSubmit }) {
  const defaultValue = useMemo(() => {
    let result = {};
    if (Array.isArray(permissionValue) && Array.isArray(permissionContext)) {
      permissionContext.forEach((permissionItem) => {
        const id = permissionItem.permissionID;
        const hasPermission = permissionValue.findIndex((value) => value.permissionID === id) !== -1;
        result[id] = hasPermission;
      });
    }
    return result;
  }, [permissionValue, permissionContext]);
  const [context, Form] = useForm({
    defaultValues: defaultValue || {}
  });
  const { control, handleSubmit, reset } = context;
  useEffect(() => {
    reset(defaultValue || {});
  }, [defaultValue]);
  const handleSubmitBtnClick = () => {
    handleSubmit((state) => {
      let result = [];
      if (Array.isArray(permissionContext)) {
        result = permissionContext.map((permission) => {
          return __spreadProps$u(__spreadValues$z({}, permission), {
            value: state[permission.permissionID] || false
          });
        });
      }
      typeof onSubmit === "function" && onSubmit(result);
    })();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  const groupPermissions = useMemo(() => {
    let groupPermissionSetting = {};
    if (Array.isArray(permissionContext)) {
      permissionContext.forEach((context2) => {
        const contextKey = context2.securityContextSystemName;
        if (groupPermissionSetting[contextKey]) {
          groupPermissionSetting[contextKey].groupPermission.push(context2);
        } else {
          groupPermissionSetting[contextKey] = {
            securityContextSystemName: context2.securityContextSystemName,
            securityContextName: context2.securityContextName,
            groupPermission: [context2]
          };
        }
      });
    }
    return Object.keys(groupPermissionSetting).map((key) => {
      return groupPermissionSetting[key];
    });
  }, [permissionContext]);
  const renderPermission = useMemo(() => {
    return groupPermissions.map((group) => {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { children: group.securityContextName }),
        /* @__PURE__ */ jsx(Box, { paddingLeft: "2rem", children: group.groupPermission.map((permission) => {
          return /* @__PURE__ */ jsx(
            Controller,
            {
              control,
              name: `${permission.permissionID}`,
              render: ({ field: { onChange, value } }) => {
                return /* @__PURE__ */ jsx(
                  SwitchInput,
                  {
                    name: permission.permissionSystemName,
                    label: permission.permissionName,
                    checked: value,
                    onChange
                  }
                );
              }
            },
            permission.permissionID
          );
        }) })
      ] }, group.securityContextSystemName);
    });
  }, [groupPermissions]);
  return /* @__PURE__ */ jsxs(Form, { children: [
    renderPermission,
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 3, children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Update" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] })
  ] });
}

var __defProp$y = Object.defineProperty;
var __defProps$t = Object.defineProperties;
var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$y.call(b, prop))
      __defNormalProp$y(a, prop, b[prop]);
  if (__getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(b)) {
      if (__propIsEnum$y.call(b, prop))
        __defNormalProp$y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$t = (a, b) => __defProps$t(a, __getOwnPropDescs$t(b));
function UserOrganisationForm({
  organisations = [],
  onSubmit,
  organisationLookupParam = {
    systemName: "PortalContact",
    additionalFilter: { contactType: "Organisation" }
  },
  lookupToOrganisationMapper = (data) => {
    var _a;
    return {
      organisationID: data.id,
      organisationName: data.name,
      organisationContactContactTypeID: (_a = data.additionalData) == null ? void 0 : _a.contactContactTypeID
    };
  }
}) {
  const [selectOrgs, setSelectOrgs] = useState(organisations);
  const [isAddDialogOpen, openAddDialog, closeAddDialog] = useToggle(false);
  const theme = useTheme$2();
  useEffect(() => {
    setSelectOrgs(organisations);
  }, [organisations]);
  const handleAddOrgs = (orgs) => {
    const addOrgs = orgs.map((org) => {
      return lookupToOrganisationMapper(org);
    }).filter((org) => {
      const findIndex = selectOrgs.findIndex(
        (selectedOrg) => selectedOrg.organisationID.toString() === org.organisationID.toString()
      );
      return findIndex === -1;
    });
    setSelectOrgs([...selectOrgs, ...addOrgs]);
    closeAddDialog();
  };
  const handleRemoveOrg = useCallback(
    (orgId) => {
      if (Array.isArray(selectOrgs) && orgId) {
        const removeItemIndex = selectOrgs.findIndex((org) => {
          return org.organisationID.toString() === orgId.toString();
        });
        if (removeItemIndex !== -1) {
          setSelectOrgs(selectOrgs.toSpliced(removeItemIndex, 1));
        }
      }
    },
    [selectOrgs]
  );
  const handleSubmitBtnClick = () => {
    if (Array.isArray(selectOrgs) && Array.isArray(organisations)) {
      const orgToAdd = selectOrgs.filter((selectedOrg) => {
        const findIndex = organisations.findIndex((org) => {
          return org.organisationID === selectedOrg.organisationID;
        });
        return findIndex === -1;
      }).map((org) => {
        return __spreadProps$t(__spreadValues$y({}, org), {
          delete: false
        });
      });
      const orgToRemove = organisations.filter((org) => {
        const findIndex = selectOrgs.findIndex((selectedOrg) => {
          return org.organisationID === selectedOrg.organisationID;
        });
        return findIndex === -1;
      }).map((org) => {
        return __spreadProps$t(__spreadValues$y({}, org), {
          delete: true
        });
      });
      typeof onSubmit === "function" && onSubmit([...orgToAdd, ...orgToRemove]);
    }
  };
  const handleResetBtnClick = () => {
    setSelectOrgs(organisations);
  };
  const orgListColumns = [
    {
      field: "organisationName",
      flex: 1,
      headerName: "Organisation",
      disableColumnMenu: true
    },
    {
      field: "organisationID",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: ({ value }) => {
        return /* @__PURE__ */ jsx(IconButton$1, { onClick: () => handleRemoveOrg(value), color: "primary", children: /* @__PURE__ */ jsx(Tooltip$1, { title: "Delete", children: /* @__PURE__ */ jsx(DeleteForever, {}) }) });
      }
    }
  ];
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h5", children: "Organisation List" }),
      /* @__PURE__ */ jsx(IconButton$1, { onClick: openAddDialog, color: "primary", children: /* @__PURE__ */ jsx(AddCircleOutline, {}) })
    ] }),
    /* @__PURE__ */ jsx(
      DataGridPro,
      {
        autoHeight: true,
        hideFooter: true,
        columns: orgListColumns,
        rows: selectOrgs,
        getRowId: (row) => row.organisationID,
        slots: {
          noRowsOverlay: NoRowOverlay
        },
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          fontSize: "0.85rem"
        }
      }
    ),
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: "1rem", py: "1rem", children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Update" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] }),
    /* @__PURE__ */ jsx(DialogWrap, { open: isAddDialogOpen, onCloseBtnClick: closeAddDialog, title: "Add organisation", children: /* @__PURE__ */ jsx(Box, { width: 550, minHeight: 450, children: /* @__PURE__ */ jsx(
      AddOrganisationForm,
      {
        organisationLookupParam,
        onSubmit: handleAddOrgs,
        onCancel: closeAddDialog
      }
    ) }) })
  ] });
}
function NoRowOverlay() {
  return /* @__PURE__ */ jsx(Box, { height: "100%", display: "flex", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsxs(Typography, { variant: "body1", children: [
    "No organisation, click the",
    " ",
    /* @__PURE__ */ jsxs(Box, { display: "inline", alignSelf: "baseline", children: [
      /* @__PURE__ */ jsx(AddCircleOutline, {}),
      " "
    ] }),
    "to add organisation"
  ] }) });
}
function AddOrganisationForm({ organisationLookupParam, onSubmit, onCancel }) {
  const [{ handleSubmit }, Form] = useForm({
    defaultValues: {
      organisations: []
    }
  });
  const { organisationLookupParams, renderOption, filterOptions } = useOrganisationLookupHelper();
  const handleAddClick = () => {
    handleSubmit((state) => {
      if (typeof onSubmit === "function") {
        onSubmit(state.organisations);
      }
    })();
  };
  const handleCancelClick = () => {
    typeof onCancel === "function" && onCancel();
  };
  return /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(
      FormLookup,
      {
        useSearchTerm: true,
        name: "organisations",
        multiple: true,
        params: organisationLookupParams,
        renderOption,
        filterOptions,
        placeholder: "Search",
        disableCloseOnSelect: true,
        blurOnSelect: false
      }
    ),
    /* @__PURE__ */ jsxs(Box, { display: "flex", justifyContent: "center", gap: "1rem", py: "1rem", children: [
      /* @__PURE__ */ jsx(Button$1, { variant: "contained", onClick: handleAddClick, children: "Add" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleCancelClick, children: "Cancel" })
    ] })
  ] });
}

function groupArrayByStringField(targetArray, fieldName) {
  let groupSetting = {};
  if (Array.isArray(targetArray)) {
    targetArray.forEach((context) => {
      if (typeof context[fieldName] === "string") {
        const contextKey = context[fieldName];
        if (groupSetting[contextKey]) {
          groupSetting[contextKey].groupContexts.push(context);
        } else {
          groupSetting[contextKey] = {
            groupingName: contextKey,
            groupContexts: [context]
          };
        }
      }
    });
  }
  return Object.keys(groupSetting).map((key) => {
    return groupSetting[key];
  });
}

function UserGroupForm({ groupOptions, userGroupData, adminGroup, onSubmit }) {
  const defaultValue = useMemo(() => {
    let result = {};
    if (adminGroup) {
      const id = adminGroup.id;
      const hasGroup = userGroupData.findIndex((value) => value.id.toString() === id.toString()) !== -1;
      result[id] = hasGroup;
    }
    if (Array.isArray(groupOptions) && Array.isArray(userGroupData)) {
      groupOptions.forEach((option) => {
        const id = option.id;
        const hasGroup = userGroupData.findIndex((value) => value.id.toString() === id.toString()) !== -1;
        result[id] = hasGroup;
      });
    }
    return result;
  }, [groupOptions, userGroupData]);
  const [context, Form] = useForm({
    defaultValues: defaultValue
  });
  const { control, watch, handleSubmit, reset } = context;
  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue]);
  const adminSelectValue = adminGroup ? watch(adminGroup.id.toString()) : false;
  const disableSelect = useMemo(() => {
    if (adminGroup) {
      return adminSelectValue;
    }
    return false;
  }, [adminGroup, adminSelectValue]);
  const handleSubmitBtnClick = () => {
    handleSubmit((state) => {
      if (typeof onSubmit === "function") {
        const data = Object.keys(state).map((key) => {
          return {
            id: key,
            delete: !state[key]
          };
        });
        onSubmit(data);
      }
    })();
  };
  const handleResetBtnClick = () => {
    reset();
  };
  const groupingGroups = useMemo(() => {
    return groupArrayByStringField(groupOptions, "categoryName");
  }, [groupOptions]);
  const renderAdminGroup = useMemo(() => {
    if (adminGroup) {
      return /* @__PURE__ */ jsx(
        Controller,
        {
          control,
          name: `${adminGroup.id}`,
          render: ({ field: { onChange, value } }) => {
            return /* @__PURE__ */ jsx(
              SwitchInput,
              {
                name: adminGroup.name,
                label: adminGroup.name,
                checked: value,
                onChange
              }
            );
          }
        },
        adminGroup.id
      );
    }
    return null;
  }, [adminGroup]);
  const renderGroups = useMemo(() => {
    return groupingGroups.map((group) => {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { children: group.groupingName }),
        /* @__PURE__ */ jsx(Box, { paddingLeft: "2rem", children: group.groupContexts.map((userGroup) => {
          return /* @__PURE__ */ jsx(
            Controller,
            {
              control,
              name: `${userGroup.id}`,
              render: ({ field: { onChange, value } }) => {
                return /* @__PURE__ */ jsx(
                  SwitchInput,
                  {
                    name: userGroup.name,
                    label: userGroup.name,
                    checked: value,
                    onChange,
                    disabled: disableSelect
                  }
                );
              }
            },
            userGroup.id
          );
        }) })
      ] }, group.groupingName);
    });
  }, [groupingGroups, disableSelect]);
  return /* @__PURE__ */ jsxs(Form, { children: [
    renderAdminGroup,
    renderGroups,
    /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 3, children: [
      /* @__PURE__ */ jsx(Button$1, { onClick: handleSubmitBtnClick, color: "primary", variant: "contained", children: "Update" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleResetBtnClick, color: "primary", variant: "outlined", children: "Reset" })
    ] })
  ] });
}

var __defProp$x = Object.defineProperty;
var __defProps$s = Object.defineProperties;
var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$x.call(b, prop))
      __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(b)) {
      if (__propIsEnum$x.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$s = (a, b) => __defProps$s(a, __getOwnPropDescs$s(b));
const checkboxIcon$3 = /* @__PURE__ */ jsx(CheckBoxOutlineBlank, { fontSize: "small" });
const checkboxCheckedIcon$3 = /* @__PURE__ */ jsx(CheckBox, { fontSize: "small" });
const lookupSx = {
  ".MuiInputBase-root > input": {
    padding: "4px 8px !important"
  },
  ".MuiAutocomplete-input": {
    fontSize: "0.85rem"
  },
  ".MuiButtonBase-root.MuiChip-root": {
    height: "inherit",
    maxWidth: "calc(60% - 6px)",
    ".MuiSvgIcon-root": {
      margin: 0
    }
  }
};
function UserOrganisationToggle({ allowSingleSelect }) {
  var _a, _b;
  const { organisations } = usePortalApplicationContext();
  const auth = useAuth();
  const unrestrictedUser = auth.userHasPermission("restrictByAssociation", "False");
  const renderOption = (props, option, { selected }) => {
    var _a2, _b2;
    return /* @__PURE__ */ createElement("li", __spreadProps$s(__spreadValues$x({}, props), { key: v4() }), /* @__PURE__ */ jsx(
      Checkbox$1,
      {
        icon: checkboxIcon$3,
        checkedIcon: checkboxCheckedIcon$3,
        style: { marginRight: 5 },
        checked: selected
      }
    ), /* @__PURE__ */ jsxs(Box$1, { children: [
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.85rem", lineHeight: "0.9rem", children: `${option.name} ${((_a2 = option.additionalData) == null ? void 0 : _a2.parentLocationName) && ((_b2 = option.additionalData) == null ? void 0 : _b2.parentLocationName) !== null ? ` - ${option.additionalData.parentLocationName}` : ""} 
				` }),
      unrestrictedUser ? /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.85rem", lineHeight: "0.9rem", children: `Code: ${option.additionalData.ediCode || "Not available"}` }) : null
    ] }));
  };
  const { organisationLookupParams, filterOptions } = useOrganisationLookupHelper();
  const [initialised, setInitialised] = useState(false);
  const [isMultiple, setIsMultiple] = useState(true);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(void 0);
  const [inputValue, setInputValue] = useState(EMPTY_STRING$g);
  const [{ data, isFetching, isFetched }] = useLookupQuery(
    Object.assign({ searchTerm }, organisationLookupParams),
    {
      keepPreviousData: true
    }
  );
  useEffect(() => {
    if (!initialised && !isFetching && isFetched) {
      setInitialised(true);
      if ((data == null ? void 0 : data.data.results.length) === 1) {
        setIsMultiple(false);
        organisations.setOrganisations([{ id: data.data.results[0].id, name: data.data.results[0].name }]);
      }
    }
  }, [data, isFetched, initialised]);
  const handleOnChange = (value) => {
    if (allowSingleSelect && value) {
      organisations.setOrganisations([{ id: value.id, name: value.name, additionalData: { ediCode: value.additionalData.ediCode } }]);
    }
    if (allowSingleSelect && !value) {
      organisations.setOrganisations([]);
    }
    if (!allowSingleSelect) {
      const orgs = value.map((org) => ({ id: org.id, name: org.name }));
      organisations.setOrganisations(orgs);
    }
  };
  const applySearchTerm = useMemo(() => debounce$1((value) => setSearchTerm(value), 300), []);
  return /* @__PURE__ */ jsx(Fragment, { children: allowSingleSelect ? /* @__PURE__ */ jsx(Box$1, { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsx(
    AutocompleteDropdown,
    {
      options: (_a = data == null ? void 0 : data.data.results) != null ? _a : [],
      filterOptions,
      value: organisations.getOrganisations()[0] || null,
      placeholder: "Organisations",
      disableCloseOnSelect: true,
      blurOnSelect: true,
      clearOnBlur: false,
      open,
      onChange: (_, value) => handleOnChange(value),
      onOpen: () => setOpen(true),
      onClose: () => setOpen(false),
      loading: isFetching,
      isOptionEqualToValue: (option, value) => option.id === value.id,
      limitTags: 1,
      renderOption,
      onInputChange: (_event, value, reason) => {
        const term = reason === "clear" || inputValue === EMPTY_STRING$g ? void 0 : value;
        setInputValue(value);
        applySearchTerm(term);
      },
      sx: __spreadValues$x({
        minWidth: 200
      }, lookupSx)
    }
  ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    isMultiple && /* @__PURE__ */ jsx(Box$1, { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsx(
      AutocompleteDropdown,
      {
        options: (_b = data == null ? void 0 : data.data.results) != null ? _b : [],
        filterOptions,
        value: organisations.getOrganisations(),
        placeholder: "Organisations",
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: true,
        clearOnBlur: false,
        open,
        onChange: (_, value) => handleOnChange(value),
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        loading: isFetching,
        isOptionEqualToValue: (option, value) => option.id === value.id,
        limitTags: 1,
        renderOption,
        onInputChange: (_event, value, reason) => {
          const term = reason === "clear" || inputValue === EMPTY_STRING$g ? void 0 : value;
          setInputValue(value);
          applySearchTerm(term);
        },
        sx: __spreadValues$x({
          minWidth: 200
        }, lookupSx)
      }
    ) }),
    !isMultiple && /* @__PURE__ */ jsx(
      Label,
      {
        name: "organisations",
        label: organisations.getOrganisations()[0].name,
        style: {
          lineHeight: "1rem",
          color: (theme) => theme.palette.common.black,
          fontWeight: 600,
          paddingTop: "0.125rem"
        }
      }
    )
  ] }) });
}

var __async$j = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function saveFilters(pivotGridParameters) {
  return __async$j(this, null, function* () {
    return yield onEventCoreAPI.post("PivotGrid/SaveFilters", pivotGridParameters);
  });
}

var __defProp$w = Object.defineProperty;
var __defProps$r = Object.defineProperties;
var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$w.call(b, prop))
      __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(b)) {
      if (__propIsEnum$w.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$r = (a, b) => __defProps$r(a, __getOwnPropDescs$r(b));
var __async$i = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const dateStringNullable = (d) => d === null || (d == null ? void 0 : d.isValid()) === false ? null : d == null ? void 0 : d.format("YYYY-MM-DD");
const dateRangeType = (t) => Object.freeze({
  systemName: t,
  name: t,
  id: t,
  additionalData: {
    lookupType: "daterange",
    startDate: dateStringNullable(getDate("start", t)),
    endDate: dateStringNullable(getDate("end", t))
  }
});
const dateRangeTypeOptions = Object.freeze([
  dateRangeType("Today"),
  dateRangeType("Tomorrow"),
  dateRangeType("Yesterday"),
  dateRangeType("This Week"),
  dateRangeType("Last Week"),
  dateRangeType("This Month"),
  dateRangeType("Last Month"),
  dateRangeType("This Year"),
  dateRangeType("Last Year"),
  dateRangeType("Between"),
  dateRangeType("Before"),
  dateRangeType("After")
]);
const defaultDateRange = dateRangeTypeOptions.find((o) => o.id === "This Week");
function getDate(pos, type) {
  const dateOffset = pos === "start" ? 0 : 1;
  switch (type) {
    case "Today":
      return dayjs().add(0 + dateOffset, "day").startOf("day");
    case "Tomorrow":
      return dayjs().add(1 + dateOffset, "day").startOf("day");
    case "Yesterday":
      return dayjs().add(-1 + dateOffset, "day").startOf("day");
    case "This Week":
      return pos === "start" ? dayjs().startOf("week") : dayjs().add(1, "week").startOf("week");
    case "Last Week":
      return pos === "start" ? dayjs().add(-1, "week").startOf("week") : dayjs().startOf("week");
    case "This Month":
      return pos === "start" ? dayjs().startOf("month") : dayjs().add(1, "month").startOf("month");
    case "Last Month":
      return pos === "start" ? dayjs().add(-1, "month").startOf("month") : dayjs().startOf("month");
    case "This Year":
      return pos === "start" ? dayjs().startOf("year") : dayjs().add(1, "year").startOf("year");
    case "Last Year":
      return pos === "start" ? dayjs().add(-1, "year").startOf("year") : dayjs().startOf("year");
    case "Between":
      return void 0;
    case "After":
      return pos === "end" ? null : void 0;
    case "Before":
      return pos === "start" ? null : void 0;
  }
}
function toReportParams(state, filters, paramsFor, favouriteID, organisations, contactID) {
  var _a, _b, _c, _d, _e, _f, _g;
  const params = filters.filter((filter) => filter.include.indexOf(paramsFor) !== -1).map((filter) => {
    var _a2, _b2;
    switch (filter.type) {
      case "datepicker":
      case "text":
        return {
          name: filter.systemName,
          value: (_a2 = state[filter.systemName]) != null ? _a2 : null
        };
      case "lookup":
      case "daterangelookup":
        const lkupValue = state[filter.systemName];
        return { name: filter.systemName, displayValue: lkupValue == null ? void 0 : lkupValue.name, value: (_b2 = lkupValue == null ? void 0 : lkupValue.id) != null ? _b2 : null };
    }
  });
  params.push({ name: "userID", value: null });
  if (paramsFor === "load") {
    if ((_a = state.report) == null ? void 0 : _a.id) {
      params.push({ name: "ReportID", value: (_b = state.report) == null ? void 0 : _b.id, displayValue: (_c = state == null ? void 0 : state.report) == null ? void 0 : _c.name });
    }
    if (((_d = state.favourite) == null ? void 0 : _d.id) && ((_f = (_e = state.favourite) == null ? void 0 : _e.additionalData) == null ? void 0 : _f.pivotSettingJson)) {
      params.push({
        name: "ReportUserFavouritePivotSettingJson",
        value: state.favourite.additionalData.pivotSettingJson,
        displayValue: state.favourite.name
      });
    }
  } else if (paramsFor === "export") {
    params.push({ name: "ReportUserFavouriteID", value: favouriteID || ((_g = state.favourite) == null ? void 0 : _g.id) || null });
  }
  const additionalFilter = {};
  if (organisations && organisations.length > 0) {
    additionalFilter.organisationIDs = organisations;
  }
  if (contactID) {
    additionalFilter.userID = contactID;
  }
  if (state.etaFrom) {
    additionalFilter.etaFrom = state.etaFrom.dateAndTime;
  }
  if (state.etaTo) {
    additionalFilter.etaTo = state.etaTo.dateAndTime;
  }
  if (state.etdFrom) {
    additionalFilter.etdFrom = state.etdFrom.dateAndTime;
  }
  if (state.etdTo) {
    additionalFilter.etdTo = state.etdTo.dateAndTime;
  }
  params.push({ name: "AdditionalFilter", value: JSON.stringify(additionalFilter) });
  return params;
}
function ReportActionButton(props) {
  return /* @__PURE__ */ jsx(
    Button,
    __spreadProps$r(__spreadValues$w({}, props), {
      variant: props.variant || "outlined",
      sx: __spreadValues$w({
        border: (theme) => `2px solid ${theme.palette.primary.main}`,
        marginRight: "8px"
      }, props.sx),
      children: props.children
    })
  );
}
function defaultFormContextFromParams(filters, params) {
  const uiFilters = filterDefinitionsToUIFilters({}, filters);
  return Object.fromEntries(
    uiFilters.map((filter) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const param = params.find((p) => p.name === (filter == null ? void 0 : filter.systemName));
      switch (filter.type) {
        case "text":
          return [filter.systemName, (_a = param == null ? void 0 : param.value) != null ? _a : null];
        case "lookup":
          let lkupItem = null;
          if ((param == null ? void 0 : param.value) && (param == null ? void 0 : param.displayValue))
            lkupItem = { id: param.value.toString(), name: param.displayValue.toString() };
          return [filter.systemName, lkupItem];
        case "daterangelookup":
          let option = (_b = dateRangeTypeOptions.find((o) => o.id === (param == null ? void 0 : param.value))) != null ? _b : null;
          if (!option && filter.required)
            option = defaultDateRange;
          return [filter.systemName, option];
        case "datepicker":
          const parentParam = params.find((p) => p.name === filter.parentFilterName);
          let parentOption = (_c = dateRangeTypeOptions.find((o) => o.id === (parentParam == null ? void 0 : parentParam.value))) != null ? _c : null;
          if (!parentOption && filter.required && filter.parentFilterName)
            parentOption = defaultDateRange;
          if (parentOption && filter.systemName.endsWith("Start"))
            return [filter.systemName, (_e = (_d = parentOption.additionalData) == null ? void 0 : _d.startDate) != null ? _e : param == null ? void 0 : param.value];
          else if (parentOption && filter.systemName.endsWith("End"))
            return [filter.systemName, (_g = (_f = parentOption.additionalData) == null ? void 0 : _f.endDate) != null ? _g : param == null ? void 0 : param.value];
          else
            return [filter.systemName, param == null ? void 0 : param.value];
        default:
          return [];
      }
    })
  );
}
function CleanUpPivotGrid() {
  $(".salpvt-dialog").css({ display: "none" });
  $(".salpvt-dialog-n").css({ display: "none" });
}
function filterDefinitionsToUIFilters(state, filters) {
  return filters.flatMap((filterDef) => {
    switch (filterDef.type) {
      case "text":
      case "datepicker":
      case "lookup":
        return [__spreadProps$r(__spreadValues$w({}, filterDef), { include: ["load", "export"] })];
      case "variabledaterange":
        return [
          __spreadProps$r(__spreadValues$w({}, filterDef), { type: "lookup", include: ["load", "export"] }),
          ...dateRangeUIFilter(
            Object.assign({}, filterDef, {
              name: filterDef.name + " Range",
              systemName: filterDef.systemName + "RangeType"
            }),
            state,
            filterDef
          )
        ];
      case "daterange":
        return dateRangeUIFilter(filterDef, state);
      default:
        return [];
    }
  });
}
function dateRangeUIFilter(filterDef, state, parentFilter) {
  var _a, _b, _c, _d;
  const hideRangeType = parentFilter ? !state[parentFilter.systemName] : false;
  const currentRange = state[filterDef.systemName];
  return [
    __spreadProps$r(__spreadValues$w({}, filterDef), {
      parentFilterName: parentFilter == null ? void 0 : parentFilter.systemName,
      type: "daterangelookup",
      include: ["export"],
      hidden: hideRangeType
    }),
    __spreadProps$r(__spreadValues$w({}, filterDef), {
      parentFilterName: filterDef.systemName,
      systemName: ((_a = parentFilter == null ? void 0 : parentFilter.systemName) != null ? _a : filterDef.systemName) + "Start",
      name: "Start",
      type: "datepicker",
      include: ["load", "export"],
      hidden: hideRangeType || !currentRange || ((_b = currentRange.additionalData) == null ? void 0 : _b.startDate) !== void 0
    }),
    __spreadProps$r(__spreadValues$w({}, filterDef), {
      parentFilterName: filterDef.systemName,
      systemName: ((_c = parentFilter == null ? void 0 : parentFilter.systemName) != null ? _c : filterDef.systemName) + "End",
      name: "End",
      type: "datepicker",
      include: ["load", "export"],
      hidden: hideRangeType || !currentRange || ((_d = currentRange.additionalData) == null ? void 0 : _d.endDate) !== void 0
    })
  ];
}
function buildFilters(filters, context) {
  return filters.map((filter) => {
    switch (filter.type) {
      case "datepicker":
        return /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: 12,
            sm: 2,
            md: 2,
            lg: 2,
            sx: { display: filter.hidden ? "none" : "block" },
            children: [
              /* @__PURE__ */ jsx(FormLabel, { required: filter.required, children: filter.name }),
              /* @__PURE__ */ jsx(FormDateTimePicker, { name: filter.systemName, required: filter.required })
            ]
          },
          filter.systemName
        );
      case "text":
        return /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: 12,
            sm: 2,
            md: 2,
            lg: 2,
            sx: { display: filter.hidden ? "none" : "block" },
            children: [
              /* @__PURE__ */ jsx(FormLabel, { required: filter.required, children: filter.name }),
              /* @__PURE__ */ jsx(
                FormInput,
                {
                  name: filter.systemName,
                  placeholder: filter.name,
                  required: filter.required,
                  transform: {
                    input: (value) => value == null ? void 0 : value.toString(),
                    output: (input, _value) => input.substring(0, 50)
                  }
                }
              )
            ]
          },
          filter.systemName
        );
      case "lookup":
        return /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: 12,
            sm: 2,
            md: 2,
            lg: 2,
            sx: { display: filter.hidden ? "none" : "block" },
            children: [
              /* @__PURE__ */ jsx(FormLabel, { required: filter.required, children: filter.name }),
              /* @__PURE__ */ jsx(
                FormLookup,
                {
                  name: filter.systemName,
                  placeholder: filter.name,
                  params: { systemName: filter.systemName },
                  useSearchTerm: true,
                  onChange: (_event, option) => {
                    var _a, _b;
                    if (!option) {
                      if (filter.parentFilterName)
                        context.setValue(filter.parentFilterName + "RangeType", null);
                      context.setValue(((_a = filter.parentFilterName) != null ? _a : filter.systemName) + "Start", null);
                      context.setValue(((_b = filter.parentFilterName) != null ? _b : filter.systemName) + "End", null);
                    }
                  }
                }
              )
            ]
          },
          filter.systemName
        );
      case "daterangelookup":
        return /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: 12,
            sm: 2,
            md: 2,
            lg: 2,
            sx: { display: filter.hidden ? "none" : "block" },
            children: [
              /* @__PURE__ */ jsx(FormLabel, { children: filter.name }),
              /* @__PURE__ */ jsx(
                FormAutocompleteDropdown,
                {
                  name: filter.systemName,
                  placeholder: filter.name,
                  options: dateRangeTypeOptions,
                  disableClearable: filter.required,
                  isOptionEqualToValue: (option, val) => option.id === val.id,
                  onChange: (_event, option) => {
                    var _a, _b, _c, _d;
                    const lookupItem = option;
                    context.setValue(
                      ((_a = filter.parentFilterName) != null ? _a : filter.systemName) + "Start",
                      ((_b = lookupItem == null ? void 0 : lookupItem.additionalData) == null ? void 0 : _b.startDate) || null
                    );
                    context.setValue(
                      ((_c = filter.parentFilterName) != null ? _c : filter.systemName) + "End",
                      ((_d = lookupItem == null ? void 0 : lookupItem.additionalData) == null ? void 0 : _d.endDate) || null
                    );
                  }
                }
              )
            ]
          },
          filter.systemName
        );
      default:
        return /* @__PURE__ */ jsx(Fragment, {});
    }
  });
}
function parseFilters(filterDef) {
  let filterDefs = [];
  try {
    if (filterDef) {
      const parsed = JSON.parse(filterDef);
      if (Array.isArray(parsed)) {
        filterDefs = parsed;
      }
    }
  } catch (e) {
    return { filterDefs, error: "Error loading report filters" };
  }
  return { filterDefs };
}
function Reports({ reportGroupLookupParam = { systemName: "reportGroup" } }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const { hasAdminGroup } = useUserGroupHelper({});
  const auth = useAuth();
  const adminValidation = useMemo(() => {
    if (hasAdminGroup && organisations.length === 0) {
      if (auth.userHasPermission("additionAdmin", "UnrestrictReport")) {
        return true;
      }
      return false;
    }
    return true;
  }, [hasAdminGroup, organisations, auth]);
  const { userDetail } = useMyAccount();
  const id = "reports-pivot-grid";
  const [pivotGridState, setPGS] = useState({ isLoading: false, pivotGrid: null, hide: false });
  const popup = usePopupAlert();
  const [context, Form] = useForm({});
  const filterState = context.watch();
  const { filterDefs, error } = useMemo(
    () => {
      var _a2, _b2;
      return parseFilters((_b2 = (_a2 = filterState == null ? void 0 : filterState.report) == null ? void 0 : _a2.additionalData) == null ? void 0 : _b2.filters);
    },
    [(_b = (_a = filterState == null ? void 0 : filterState.report) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.filters]
  );
  const filters = filterDefinitionsToUIFilters(filterState, filterDefs);
  const params = toReportParams(filterState, filters, "load", void 0, organisations, userDetail == null ? void 0 : userDetail.id);
  const allRequired = params.reduce((acc, param) => {
    var _a2;
    const filter = filters.find((f) => f.systemName === param.name);
    return acc && (!(filter == null ? void 0 : filter.required) || ((_a2 = param == null ? void 0 : param.value) != null ? _a2 : null) !== null);
  }, true);
  if (error)
    popup({ message: error, severity: "error" });
  const formRef = useRef(null);
  const containerRef = useRef(null);
  const [reportWrapperHeight, setReportWrapperHeight] = useState("0px");
  useLayoutEffect(() => {
    var _a2, _b2, _c2, _d2, _e2;
    const containerTop = ((_b2 = (_a2 = containerRef.current) == null ? void 0 : _a2.getBoundingClientRect()) == null ? void 0 : _b2.top) || NaN;
    const formHeight = ((_d2 = (_c2 = formRef.current) == null ? void 0 : _c2.getBoundingClientRect()) == null ? void 0 : _d2.height) || NaN;
    const gridSize = window.innerHeight - (containerTop + formHeight + 50);
    if (gridSize) {
      setReportWrapperHeight(gridSize + "px");
      (_e2 = pivotGridState.pivotGrid) == null ? void 0 : _e2.setHeight(gridSize);
    }
  }, [filters.filter((f) => !f.hidden).length]);
  function initJqueryPivotGrid() {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    const url = "../OnEvent.Core.Api/PivotGrid";
    let pivotGrid = pivotGridState.pivotGrid;
    let capturedPivotGridState = pivotGridState;
    if (!((_a2 = filterState.report) == null ? void 0 : _a2.id)) {
      return;
    } else if (pivotGrid && filterState.report.id === ((_b2 = pivotGridState.report) == null ? void 0 : _b2.id) && ((_c2 = filterState.favourite) == null ? void 0 : _c2.id) === ((_d2 = pivotGridState.favourite) == null ? void 0 : _d2.id)) {
      if ((_e2 = pivotGrid.options) == null ? void 0 : _e2.dataSourceParams) {
        Object.assign((_g2 = (_f2 = pivotGridState.pivotGrid) == null ? void 0 : _f2.options) == null ? void 0 : _g2.dataSourceParams, params);
      } else if (pivotGrid.options) {
        pivotGrid.options = __spreadProps$r(__spreadValues$w({}, pivotGrid.options), { dataSourceParams: params });
      }
      pivotGrid.refresh();
    } else {
      pivotGrid = (_h2 = $.pivotGrid) == null ? void 0 : _h2.create(`div.${id} > div:first-child`, {
        namespaceVersion: 2,
        dataSourceParams: params,
        initCompleteFn: () => {
          var _a3;
          if (!((_a3 = pivotGridState.report) == null ? void 0 : _a3.id)) {
            setTimeout(() => {
              try {
                let adjustRows = function($container2, section, shiftLeft) {
                  const $header = $container2.find(`.salpvt-${section}AreaHeader`);
                  const $details = $container2.find(`.salpvt-${section}AreaDetail`);
                  if (shiftLeft && $header.length && $details.length) {
                    $header[0].style.left = shiftLeft + "px";
                    $details[0].style.left = shiftLeft + "px";
                  }
                  const $tds = $details.last().find("td");
                  let total = 0;
                  $header.first().find("td").each(function(i) {
                    const newWidth = Math.ceil($tds[i].getBoundingClientRect().width * 100) / 100;
                    total += newWidth;
                    $(this).outerWidth(newWidth);
                  });
                  return total;
                };
                const $container = $("." + id);
                adjustRows($container, "data", adjustRows($container, "row"));
              } catch (e) {
              }
            }, 200);
          }
        },
        url: url + "/Create",
        cssRoot: "salpvt",
        exportUrl: url + "/Export",
        saveUrl: url + "/Save",
        deleteUrl: url + "/Delete",
        alternateViewSelector: `div.${id} > div:last-child`,
        exportFileNameFn: () => {
          var _a3, _b3;
          return `${(_a3 = capturedPivotGridState == null ? void 0 : capturedPivotGridState.reportGroup) == null ? void 0 : _a3.name} - ${((_b3 = capturedPivotGridState.report) == null ? void 0 : _b3.name) || "Export"} - ${dayjs().format("DD-MM-YYYY")}`;
        },
        saveFileNameFn: () => {
          var _a3, _b3, _c3;
          return ((_a3 = capturedPivotGridState.favourite) == null ? void 0 : _a3.name) || `${(_b3 = capturedPivotGridState == null ? void 0 : capturedPivotGridState.reportGroup) == null ? void 0 : _b3.name} - ${(_c3 = capturedPivotGridState.report) == null ? void 0 : _c3.name} - ${dayjs().format("DD-MM-YYYY")}`;
        },
        saveObjectIDFn: () => {
          var _a3, _b3;
          return [(_a3 = capturedPivotGridState.report) == null ? void 0 : _a3.id, (_b3 = capturedPivotGridState.favourite) == null ? void 0 : _b3.id].join("-");
        },
        copyObjectIDFn: () => {
          var _a3;
          return (_a3 = capturedPivotGridState.favourite) == null ? void 0 : _a3.id;
        },
        deleteObjectIDFn: () => {
          var _a3;
          return (_a3 = capturedPivotGridState.favourite) == null ? void 0 : _a3.id;
        },
        saveCompleteFn: (saveResponse, name) => __async$i(this, null, function* () {
          try {
            if (saveResponse == null ? void 0 : saveResponse.objectID) {
              context.setValue("favourite", {
                id: saveResponse.objectID.toString(),
                name
              });
              yield saveFilters({
                pivotGridParams: toReportParams(
                  filterState,
                  filters,
                  "export",
                  saveResponse == null ? void 0 : saveResponse.objectID,
                  organisations,
                  userDetail == null ? void 0 : userDetail.id
                )
              });
            }
          } catch (e) {
            popup({
              message: "There was an error saving your filters",
              severity: "error"
            });
          }
        }),
        deleteCompleteFn: () => {
        },
        allowSaveFn: () => true,
        onDataSourceRowsTruncatedFn: function(message) {
          alert(message);
        },
        isExportOnly: false,
        allowCachedFileRetreival: false,
        ajaxBaseOptions: {
          beforeSend: () => setPGS(__spreadProps$r(__spreadValues$w({}, pivotGridState), { isLoading: true })),
          error: () => {
            popup({ message: "There was an error loading the report.", severity: "error" });
            pivotGrid = null;
          },
          complete: (_, status) => {
            capturedPivotGridState = __spreadProps$r(__spreadValues$w({}, pivotGridState), {
              pivotGrid,
              report: status === "success" ? filterState.report : null,
              reportGroup: status === "success" ? filterState.reportGroup : null,
              favourite: status === "success" ? filterState.favourite : null,
              isLoading: false,
              hide: status !== "success"
            });
            setPGS(capturedPivotGridState);
          }
        },
        ajaxFn: (ajaxOptions) => {
          const pivotGridSuccess = Array.isArray(ajaxOptions.success) ? ajaxOptions.success : [ajaxOptions.success];
          const pivotGridError = Array.isArray(ajaxOptions.error) ? ajaxOptions.success : [ajaxOptions.error];
          const successWrapper = function(data) {
            var _a3, _b3;
            if (!data || data === "null") {
              for (let i = 0; i < pivotGridSuccess.length; i++) {
                (_a3 = pivotGridError[i]) == null ? void 0 : _a3.call(this, data);
              }
            } else {
              for (let i = 0; i < pivotGridSuccess.length; i++) {
                (_b3 = pivotGridSuccess[i]) == null ? void 0 : _b3.call(this, data);
              }
            }
          };
          ajaxOptions.success = successWrapper;
          return $.ajax(ajaxOptions);
        },
        exportDialogOptions: { classSuffix: "-n", position: { my: "top", at: "right+100% bottom+30%" } },
        copyDialogOptions: { classSuffix: "-n", position: { my: "top", at: "right+100% bottom+100%" } },
        saveDialogOptions: { classSuffix: "-n", position: { my: "top", at: "right+60% bottom+30%" } }
      });
    }
  }
  return /* @__PURE__ */ jsxs("div", { ref: containerRef, style: { height: "100%" }, children: [
    /* @__PURE__ */ jsxs(Form, { style: { marginBottom: "10px" }, children: [
      /* @__PURE__ */ jsxs(Grid$3, { ref: formRef, container: true, spacing: 4, children: [
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
          /* @__PURE__ */ jsx(FormLabel, { children: "Report Group" }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "reportGroup",
              placeholder: "Report Group",
              params: reportGroupLookupParam,
              onChange: (_e2, _value) => {
                context.setValue("report", null);
                context.setValue("favourite", null);
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 5, md: 5, lg: 2, children: [
          /* @__PURE__ */ jsx(FormLabel, { children: "Premade Reports" }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "report",
              placeholder: "Premade Reports",
              params: { systemName: "report", additionalFilter: (_c = filterState.reportGroup) == null ? void 0 : _c.id },
              disabled: !((_d = filterState.reportGroup) == null ? void 0 : _d.id),
              onChange: (_e2, report) => {
                var _a2, _b2;
                try {
                  if (report && typeof report === "object" && !Array.isArray(report)) {
                    context.reset(__spreadProps$r(__spreadValues$w({}, defaultFormContextFromParams(
                      JSON.parse(((_b2 = (_a2 = report.additionalData) == null ? void 0 : _a2.filters) == null ? void 0 : _b2.toString()) || "[]"),
                      []
                    )), {
                      report,
                      reportGroup: filterState.reportGroup
                    }));
                  }
                } catch (e) {
                  popup({
                    message: `There was an error loading "${report == null ? void 0 : report.name}"`,
                    severity: "error"
                  });
                }
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
          /* @__PURE__ */ jsx(FormLabel, { children: "Saved Reports" }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "favourite",
              placeholder: "Saved Reports",
              params: { systemName: "reportUserFavourite", additionalFilter: (_e = filterState.report) == null ? void 0 : _e.id },
              onChange: (_e2, value) => {
                var _a2, _b2, _c2, _d2;
                const fave = value;
                try {
                  if (fave) {
                    context.reset(__spreadProps$r(__spreadValues$w({}, defaultFormContextFromParams(
                      JSON.parse(((_b2 = (_a2 = fave.additionalData) == null ? void 0 : _a2.filters) == null ? void 0 : _b2.toString()) || "[]"),
                      JSON.parse(((_d2 = (_c2 = fave.additionalData) == null ? void 0 : _c2.filterJson) == null ? void 0 : _d2.toString()) || "[]")
                    )), {
                      report: {
                        name: fave.additionalData.reportName,
                        id: fave.additionalData.reportID.toString(),
                        additionalData: { filters: fave.additionalData.filters }
                      },
                      reportGroup: {
                        name: fave.additionalData.reportGroupName,
                        id: fave.additionalData.reportGroupID.toString()
                      },
                      favourite: fave
                    }));
                  }
                } catch (e) {
                  popup({
                    message: `There was an error restoring "${fave == null ? void 0 : fave.name}"`,
                    severity: "error"
                  });
                }
              }
            }
          )
        ] }),
        ...buildFilters(filters, context),
        /* @__PURE__ */ jsxs(Grid$3, { container: true, item: true, spacing: 4, xs: 12, sm: 12, md: 12, lg: 12, children: [
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
            /* @__PURE__ */ jsx(FormLabel, { children: "ETA From" }),
            /* @__PURE__ */ jsx(DateTimeInput, { name: "etaFrom" })
          ] }),
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
            /* @__PURE__ */ jsx(FormLabel, { children: "ETA To" }),
            /* @__PURE__ */ jsx(DateTimeInput, { name: "etaTo" })
          ] }),
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
            /* @__PURE__ */ jsx(FormLabel, { children: "ETD From" }),
            /* @__PURE__ */ jsx(DateTimeInput, { name: "etdFrom" })
          ] }),
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 3, md: 3, lg: 2, children: [
            /* @__PURE__ */ jsx(FormLabel, { children: "ETD To" }),
            /* @__PURE__ */ jsx(DateTimeInput, { name: "etdTo" })
          ] })
        ] }),
        /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 12, md: 12, lg: 12, children: [
          /* @__PURE__ */ jsx(
            ReportActionButton,
            {
              variant: "contained",
              onClick: initJqueryPivotGrid,
              disabled: !(((_f = filterState.report) == null ? void 0 : _f.id) && allRequired && adminValidation),
              children: "Run Report"
            }
          ),
          /* @__PURE__ */ jsx(
            ReportActionButton,
            {
              onClick: (event) => {
                var _a2;
                return (_a2 = pivotGridState.pivotGrid) == null ? void 0 : _a2.showSave(event);
              },
              disabled: !(pivotGridState.report && pivotGridState.report.id === ((_g = filterState.report) == null ? void 0 : _g.id) && allRequired),
              children: "Favourites"
            }
          ),
          /* @__PURE__ */ jsx(
            ReportActionButton,
            {
              onClick: () => {
                var _a2;
                return (_a2 = pivotGridState.pivotGrid) == null ? void 0 : _a2.showFieldList();
              },
              disabled: !(pivotGridState.report && pivotGridState.report.id === ((_h = filterState.report) == null ? void 0 : _h.id) && allRequired),
              children: "Options"
            }
          ),
          /* @__PURE__ */ jsx(
            ReportActionButton,
            {
              onClick: (event) => {
                var _a2;
                return (_a2 = pivotGridState.pivotGrid) == null ? void 0 : _a2.showExport(event);
              },
              disabled: !(pivotGridState.report && pivotGridState.report.id === ((_i = filterState.report) == null ? void 0 : _i.id) && allRequired),
              children: "Export"
            }
          ),
          /* @__PURE__ */ jsx(
            ReportActionButton,
            {
              onClick: () => {
                context.reset({ reportGroup: null, report: null, favourite: null });
                setPGS({
                  isLoading: false,
                  pivotGrid: null,
                  hide: true,
                  report: null,
                  favourite: null
                });
              },
              children: "Reset"
            }
          ),
          /* @__PURE__ */ jsx(ReportScheduling, {})
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { style: { height: "15px", paddingTop: "10px" }, children: pivotGridState.isLoading ? /* @__PURE__ */ jsx(LinearProgress, {}) : void 0 })
    ] }),
    /* @__PURE__ */ jsx("div", { style: { height: reportWrapperHeight }, children: /* @__PURE__ */ jsx("div", { className: id + "-wrapper", style: { height: "100%" }, children: /* @__PURE__ */ jsxs("div", { className: id, style: { height: "100%", display: pivotGridState.hide ? "none" : "block" }, children: [
      /* @__PURE__ */ jsx("div", { "skip-node": "true", style: { height: "100%" } }),
      /* @__PURE__ */ jsx("div", { "skip-node": "true", style: { height: "100%", display: "none" } }),
      " "
    ] }) }) })
  ] });
}

function ReportSchedulingForm({
  formValue,
  isLoading,
  onSubmit = noop$6
}) {
  const validationSchema = z$1.object({
    notifyEmail: zodValidator.email,
    scheduleCron: z$1.string().optional().superRefine((value, ctx) => {
      try {
        const regex = new RegExp(/((\*\/)?\d{1}(\-)?\d{0,1})\s{1}((\*\/)?\d{1}(\-)?\d{0,1})/g);
        z$1.string().regex(regex).parse(value);
      } catch (e) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          message: "Schedule input required",
          path: ["scheduleCron"]
        });
      }
    })
  });
  const [context, Form] = useForm({
    defaultValues: formValue,
    validationSchema,
    reValidateMode: "onSubmit",
    onError: (error) => console.log(error)
  });
  const { control, reset, handleSubmit } = context;
  const handleOnSubmit = useCallback(
    () => handleSubmit(
      (formData) => {
        typeof onSubmit === "function" && onSubmit(formData);
      },
      (error) => {
        console.debug("submit failed:", error);
      }
    )(),
    [onSubmit]
  );
  useEffect(() => {
    if (formValue) {
      reset(formValue);
    }
  }, [reset, formValue]);
  return /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(FormElementWrap, { name: "notifyEmail", label: "Email", children: /* @__PURE__ */ jsx(FormInput, { name: "notifyEmail", placeholder: "Email" }) }),
    /* @__PURE__ */ jsx(FormElementWrap, { name: "scheduleCron", label: "Schedule", children: /* @__PURE__ */ jsx(
      Controller,
      {
        name: "scheduleCron",
        control,
        render: ({ field: { onChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx(
          j,
          {
            value,
            setValue: onChange,
            allowedPeriods: [
              "month",
              "week",
              "day"
            ],
            allowedDropdowns: {
              "month": [
                "month-days",
                "hours",
                "minutes"
              ]
            },
            dropdownsConfig: {
              "minutes": {
                "mode": "single",
                "periodicityOnDoubleClick": false
              }
            },
            validationErrors: {
              hours: {
                error: !!error && (!value || !!value && value.split(" ")[1] === "*"),
                errorText: "Hour is required"
              },
              minutes: {
                error: !!error && (!value || !!value && value.split(" ")[0] === "*"),
                errorText: "Minute is required"
              }
            },
            leadingZero: true,
            displayError: true
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx(Box$1, { children: /* @__PURE__ */ jsx(Button, { onClick: handleOnSubmit, disabled: isLoading, color: "primary", variant: "contained", children: "Submit" }) })
  ] });
}

var __async$h = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function ReportSchedulingActionCell({
  favouriteId,
  favouriteName,
  reportNotificationTypeId,
  emailTransportTypeId,
  timeZoneId,
  contactId,
  contactEmail,
  onUpdateSuccess
}) {
  const popup = usePopupAlert();
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const {
    state: { isLoading, isError },
    reportNotificationConfiguration,
    reportScheduleJob,
    handleRemoveFavouriteScheduleReport,
    handleSubmit,
    handleInvalidateQuery
  } = useFavouriteReportSchedulingData({
    favouriteId,
    reportNotificationTypeId,
    timeZoneId,
    emailTransportTypeId,
    contactId
  });
  const handleFormSubmit = useCallback(
    (formData) => __async$h(this, null, function* () {
      yield handleSubmit(formData);
      popup({
        message: "Update report scheduling success",
        severity: "success"
      });
      handleInvalidateQuery();
      typeof onUpdateSuccess === "function" && onUpdateSuccess();
    }),
    [handleSubmit, handleInvalidateQuery, onUpdateSuccess, popup]
  );
  const handleRemoveScheduleJob = useCallback(() => __async$h(this, null, function* () {
    try {
      yield handleRemoveFavouriteScheduleReport();
      popup({
        message: "Delete schedule report success.",
        severity: "success"
      });
      typeof onUpdateSuccess === "function" && onUpdateSuccess();
    } catch (e) {
      popup({
        message: "Delete schedule report failed.",
        severity: "error"
      });
    }
  }), [handleRemoveFavouriteScheduleReport, handleInvalidateQuery, popup, onUpdateSuccess]);
  const handleOpenDialog = useCallback(() => {
    openDialog();
  }, [openDialog]);
  const schedulingFormValue = useMemo(() => {
    let email = contactEmail || "";
    let cronExpress = "";
    if (reportNotificationConfiguration == null ? void 0 : reportNotificationConfiguration.email) {
      email = reportNotificationConfiguration.email;
    }
    if (reportScheduleJob == null ? void 0 : reportScheduleJob.cronExpression) {
      cronExpress = reportScheduleJob.cronExpression;
    }
    return {
      notifyEmail: email,
      scheduleCron: cronExpress
    };
  }, [reportNotificationConfiguration, reportScheduleJob, contactEmail]);
  const renderUpdate = useMemo(() => {
    return /* @__PURE__ */ jsxs(Box$1, { display: "flex", children: [
      /* @__PURE__ */ jsx(Button, { onClick: handleOpenDialog, children: /* @__PURE__ */ jsx(Edit, {}) }),
      /* @__PURE__ */ jsx(
        ConfirmActionButton,
        {
          modalContent: "The schedule report will be removed",
          onConfirm: handleRemoveScheduleJob,
          children: /* @__PURE__ */ jsx(Delete, {})
        }
      )
    ] });
  }, [handleOpenDialog, handleRemoveScheduleJob]);
  const renderContent = useMemo(() => {
    if (reportNotificationConfiguration == null ? void 0 : reportNotificationConfiguration.active) {
      return renderUpdate;
    }
    return null;
  }, [reportNotificationConfiguration, renderUpdate]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(LoadingWrap, { isLoading, isError, errorMessage: "Loading failed. Please try again later", children: renderContent }),
    /* @__PURE__ */ jsx(DialogWrap, { open: isDialogOpen, onCloseBtnClick: closeDialog, title: favouriteName || "Report schedule", children: /* @__PURE__ */ jsx(ReportSchedulingForm, { formValue: schedulingFormValue, onSubmit: handleFormSubmit }) })
  ] });
}

var __async$g = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function ReportSchedulingAdd({
  reportNotificationTypeId,
  contactId,
  contactEmail,
  emailTransportTypeId,
  timeZoneId,
  onSuccess
}) {
  const [favouriteId, setFavouriteId] = useState(void 0);
  const [favouriteError, setFavouriteError] = useState(null);
  const popup = usePopupAlert();
  const {
    state: { isLoading },
    reportNotificationConfiguration,
    reportScheduleJob,
    handleSubmit,
    handleInvalidateQuery
  } = useFavouriteReportSchedulingData({
    favouriteId,
    reportNotificationTypeId,
    timeZoneId,
    emailTransportTypeId,
    contactId
  });
  const hasExistingSchedule = useMemo(() => {
    if (reportNotificationConfiguration && reportScheduleJob) {
      return true;
    }
    return false;
  }, [reportScheduleJob]);
  const schedulingFormValue = useMemo(() => {
    return {
      notifyEmail: contactEmail || "",
      scheduleCron: ""
    };
  }, [contactEmail]);
  const handleFavouriteReportChange = useCallback((_event, option, _reason, _detail) => {
    setFavouriteError(null);
    if (option) {
      setFavouriteId(option.id);
    } else {
      setFavouriteId(void 0);
    }
  }, []);
  const handleCreateSchedule = useCallback(
    (formData) => __async$g(this, null, function* () {
      try {
        yield handleSubmit(formData);
        popup({
          message: `${hasExistingSchedule ? "Update" : "Add"} report scheduling success`,
          severity: "success"
        });
        handleInvalidateQuery();
        typeof onSuccess === "function" && onSuccess();
      } catch (e) {
        popup({
          message: `${hasExistingSchedule ? "Update" : "Add"} report scheduling failed`,
          severity: "error"
        });
      }
    }),
    [handleSubmit, handleInvalidateQuery, hasExistingSchedule]
  );
  const handleFormSubmit = useCallback(
    (formData) => {
      if (favouriteId) {
        handleCreateSchedule(formData);
      } else {
        setFavouriteError("Favourite report is required");
      }
    },
    [favouriteId, handleCreateSchedule]
  );
  return /* @__PURE__ */ jsxs("div", { children: [
    hasExistingSchedule ? /* @__PURE__ */ jsx(Alert$1, { severity: "warning", children: "This favourite report has schedule, the existing schedule will be updated" }) : null,
    /* @__PURE__ */ jsx(FormElementWrap, { label: "Favourite Report", name: "favouriteReport", children: /* @__PURE__ */ jsx(
      Lookup,
      {
        name: "favouriteReport",
        params: {
          systemName: "reportUserFavourite"
        },
        onChange: handleFavouriteReportChange,
        error: !!favouriteError,
        errorMessage: favouriteError || ""
      }
    ) }),
    /* @__PURE__ */ jsx(ReportSchedulingForm, { formValue: schedulingFormValue, isLoading, onSubmit: handleFormSubmit })
  ] });
}

function ReportScheduling({ reportId = null }) {
  const theme = useTheme$2();
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const [isAddScheduleOpen, openAddSchedule, closeAddSchedule] = useToggle(false);
  const myAccountService = new MyAccountService();
  const queryClient = useQueryClient();
  const { timeZoneId } = useMyTimeZone();
  const { data: userData } = useQuery$1(["myDetail"], () => myAccountService.getMe());
  const userDetail = useMemo(() => {
    return userData == null ? void 0 : userData.data;
  }, [userData]);
  const [
    {
      isLoading: loadingFavouriteReportSchedule,
      data: FavouriteReportScheduleData
    },
    reportScheduleGridQueryKey
  ] = useGridQuery(
    {
      systemName: "PortalFavouriteReportSchedule",
      parameters: {
        reportId
        // Can filter with reportId from props
      }
    },
    { cacheTime: 0 }
  );
  const [emailTransportTypeQuery] = useLookupQuery({
    systemName: "NotificationTransportType",
    additionalFilter: {
      systemName: SystemName.NotificationTransportType.Email
    }
  });
  const emailTransportTypeId = useMemo(() => {
    var _a, _b;
    const result = (_b = (_a = emailTransportTypeQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results[0];
    return result == null ? void 0 : result.id;
  }, [emailTransportTypeQuery]);
  const [reportNotificationTypeQuery] = useLookupQuery({
    systemName: "NotificationType",
    additionalFilter: {
      systemName: SystemName.NotificationType.Report
    }
  });
  const reportNotificationTypeId = useMemo(() => {
    var _a, _b;
    const result = (_b = (_a = reportNotificationTypeQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.results[0];
    return result == null ? void 0 : result.id;
  }, [reportNotificationTypeQuery]);
  const handleSchedulingBtnClick = () => {
    openDialog();
  };
  const handleAddScheduleBtnClick = () => {
    openAddSchedule();
  };
  const handleAddNewScheduleSuccess = useCallback(() => {
    queryClient.invalidateQueries(reportScheduleGridQueryKey);
    closeAddSchedule();
  }, [queryClient, reportScheduleGridQueryKey]);
  const handleUpdateScheduleSuccess = useCallback(() => {
    queryClient.invalidateQueries(reportScheduleGridQueryKey);
  }, [queryClient, reportScheduleGridQueryKey]);
  const scheduleGridRows = useMemo(() => {
    var _a;
    const favouriteResults = (_a = FavouriteReportScheduleData == null ? void 0 : FavouriteReportScheduleData.data) == null ? void 0 : _a.rows;
    if (favouriteResults && Array.isArray(favouriteResults)) {
      return favouriteResults;
    }
    return [];
  }, [FavouriteReportScheduleData]);
  const scheduleGridColumns = useMemo(() => {
    return [
      {
        field: "name",
        flex: 1,
        headerName: "Favourite Name",
        disableColumnMenu: true
      },
      {
        field: "email",
        flex: 1,
        headerName: "To Email",
        disableColumnMenu: true
      },
      {
        field: "cronExpression",
        flex: 1,
        headerName: "Schedule",
        disableColumnMenu: true,
        renderCell: ({
          value
        }) => /* @__PURE__ */ jsx(
          j,
          {
            value: value || "",
            setValue: () => null,
            allowedPeriods: [
              "month",
              "week",
              "day"
            ],
            allowedDropdowns: {
              "month": [
                "month-days",
                "hours",
                "minutes"
              ]
            },
            leadingZero: true,
            readOnly: true
          }
        )
      },
      {
        field: "reportUserFavouriteID",
        flex: 1,
        headerName: "Actions",
        disableColumnMenu: true,
        sortable: false,
        renderCell: ({
          value,
          row
        }) => /* @__PURE__ */ jsx(
          ReportSchedulingActionCell,
          {
            favouriteId: value,
            favouriteName: row.name,
            reportNotificationTypeId,
            timeZoneId,
            emailTransportTypeId,
            contactId: userDetail == null ? void 0 : userDetail.id,
            contactEmail: userDetail == null ? void 0 : userDetail.email,
            onUpdateSuccess: handleUpdateScheduleSuccess
          }
        )
      }
    ];
  }, [reportNotificationTypeId, emailTransportTypeId, timeZoneId, userDetail, handleUpdateScheduleSuccess]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ReportActionButton, { onClick: handleSchedulingBtnClick, children: "Scheduling" }),
    /* @__PURE__ */ jsx(
      DialogWrap,
      {
        open: isDialogOpen,
        onCloseBtnClick: closeDialog,
        title: "Favourite Report Schedule Setting",
        fullWidth: true,
        maxWidth: "lg",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Button, { onClick: handleAddScheduleBtnClick, sx: { alignSelf: "flex-start" }, children: "Add Report Schedule" }),
          /* @__PURE__ */ jsx(
            DataGridPro,
            {
              columns: scheduleGridColumns,
              rows: scheduleGridRows,
              loading: loadingFavouriteReportSchedule,
              getRowId: (row) => row.reportUserFavouriteID,
              autoHeight: true,
              hideFooter: true,
              sx: {
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: theme.palette.primary.main,
                  fontWeight: 600
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
                fontSize: "0.85rem"
              }
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      DialogWrap,
      {
        open: isAddScheduleOpen,
        onCloseBtnClick: closeAddSchedule,
        title: "Add Report Schedule",
        fullWidth: true,
        maxWidth: "md",
        children: /* @__PURE__ */ jsx(
          ReportSchedulingAdd,
          {
            reportNotificationTypeId,
            emailTransportTypeId,
            timeZoneId,
            contactId: userDetail == null ? void 0 : userDetail.id,
            contactEmail: userDetail == null ? void 0 : userDetail.email,
            onSuccess: handleAddNewScheduleSuccess
          }
        )
      }
    )
  ] });
}

const additionalLookupItem = {
  id: "-1",
  name: "Add New"
};

const addAddress = (objectLocation) => {
  if (!objectLocation) {
    return null;
  }
  const address = [
    objectLocation == null ? void 0 : objectLocation.address1,
    objectLocation == null ? void 0 : objectLocation.address2,
    objectLocation == null ? void 0 : objectLocation.suburb,
    objectLocation == null ? void 0 : objectLocation.postcode
  ].filter((part) => part !== null && part !== "").join(", ");
  return address;
};
const serializeAddress = (address) => {
  var _a, _b, _c, _d, _e, _f;
  if (!address) {
    return null;
  }
  const addressParts = address.split(",");
  const address1 = (_a = addressParts[0]) == null ? void 0 : _a.trim();
  const address2 = (_b = addressParts[1]) == null ? void 0 : _b.trim();
  let suburb = (_c = addressParts[2]) == null ? void 0 : _c.trim();
  let lastPart = (_d = addressParts[3]) == null ? void 0 : _d.trim();
  let postcode = null;
  if (suburb && /\d{4}$/.test(suburb)) {
    const surburbPartParts = suburb.split(" ");
    suburb = surburbPartParts[0];
    postcode = (_e = surburbPartParts.pop()) != null ? _e : null;
  }
  if (lastPart && /\d{4}$/.test(lastPart)) {
    const lastPartParts = lastPart.split(" ");
    postcode = (_f = lastPartParts.pop()) != null ? _f : null;
    suburb = lastPartParts.join(" ");
  }
  return {
    address1,
    address2,
    suburb,
    postcode
  };
};
const addLookupAddress = (additionalData) => {
  if (!additionalData) {
    return "";
  }
  const address = [
    additionalData == null ? void 0 : additionalData.address1,
    additionalData == null ? void 0 : additionalData.address2,
    additionalData == null ? void 0 : additionalData.suburb,
    additionalData == null ? void 0 : additionalData.postcode
  ].filter((part) => part !== null && part !== "").join(", ");
  return address;
};
const createConsignmentEvent = (event, eventCode) => {
  const newEvent = {
    eventCode,
    eventDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    active: true,
    timeZone: "NZT"
    //TODO: Change this to the current local timezone
  };
  return event && event != null ? [...event, newEvent] : [newEvent];
};
const prepareObjectLocation = (data) => {
  if (!data) {
    return void 0;
  }
  if (Object.keys(data).length === 1 && data.address1 === null) {
    return void 0;
  }
  return data;
};

function ConsignmentLocationField({
  locationLookupName,
  locationNewFieldName,
  locationFieldNameLabel,
  locationFieldAddressLabel,
  locationFieldAddress,
  onChange,
  params,
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  const theme = useTheme$2();
  const { setValue, clearErrors, formState } = useFormContext();
  const [showNewLocation, setShowNewLocation] = useState(false);
  const [locationAddressKey, setLocationAddressKey] = useState(v4());
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: locationLookupName, label: locationFieldNameLabel }),
      /* @__PURE__ */ jsx(
        LocationLookup,
        {
          name: locationLookupName,
          params,
          useSearchTerm: true,
          prefetch: true,
          applyOptions: (options) => {
            if (locationNewFieldName) {
              const newOptions = [...options, additionalLookupItem];
              return newOptions;
            }
            return options;
          },
          onChange: (event, value) => {
            var _a;
            if (typeof onChange === "function") {
              return onChange(event, value, "select", { name: locationLookupName });
            }
            setLocationAddressKey(v4());
            if (!value) {
              setValue(locationFieldAddress, null);
              if (locationNewFieldName) {
                setValue(`${locationNewFieldName}`, null);
                setShowNewLocation(false);
              }
              return;
            }
            if (value.id === "-1") {
              setShowNewLocation(true);
              setValue(locationFieldAddress, null);
              return;
            }
            if (locationNewFieldName) {
              setShowNewLocation(false);
              setValue(`${locationNewFieldName}`, null);
            }
            if (value.additionalData) {
              setValue(locationFieldAddress, {
                id: (_a = value.additionalData.combinedCode) != null ? _a : value.id,
                name: addLookupAddress(value.additionalData)
              });
            } else {
              setValue(locationFieldAddress, null);
            }
            if (formState.errors && formState.errors[locationFieldAddress]) {
              clearErrors(locationFieldAddress);
            }
          }
        }
      ),
      showNewLocation && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
        Box$1,
        {
          sx: {
            padding: theme.spacing(4),
            backgroundColor: theme.palette.grey[100],
            marginTop: theme.spacing(4)
          },
          children: [
            /* @__PURE__ */ jsx(
              InputLabel,
              {
                name: "New" + locationFieldNameLabel,
                label: "New " + locationFieldNameLabel,
                required: true
              }
            ),
            /* @__PURE__ */ jsx(
              FormAddressLookup,
              {
                name: locationNewFieldName,
                placesAPIKey,
                autocompleteRequestOptions,
                placeDetailsRequestOptions,
                onChange: (event, value) => {
                  var _a, _b, _c;
                  setLocationAddressKey(v4());
                  if (value && (value == null ? void 0 : value.additionalData)) {
                    setValue(locationFieldAddress, {
                      id: (_b = (_a = value == null ? void 0 : value.additionalData) == null ? void 0 : _a.placeId) != null ? _b : value == null ? void 0 : value.id,
                      name: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.formattedAddress
                    });
                  } else {
                    setValue(locationFieldAddress, null);
                  }
                },
                useSearchTerm: true
              }
            )
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: locationFieldAddress, label: locationFieldAddressLabel }),
      /* @__PURE__ */ jsx(
        FormAddressLookup,
        {
          name: locationFieldAddress,
          placesAPIKey,
          autocompleteRequestOptions,
          placeDetailsRequestOptions,
          useSearchTerm: true
        },
        locationAddressKey
      )
    ] })
  ] });
}

function ImportMovementFromAndToDetails({
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  var _a;
  const { watch } = useFormContext();
  const freightPayerID = (_a = watch("freightPayer")) == null ? void 0 : _a.contactID;
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "pickupLocation",
        locationFieldAddressLabel: "Pickup Address",
        locationFieldNameLabel: "Pickup - Name",
        locationFieldAddress: "pickupAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Port]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "pickupRequiredBy", label: getTerm("consignment.requiredPickup") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "pickupRequiredBy" })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "unpack",
        locationNewFieldName: "newUnpackLocation",
        locationFieldAddressLabel: "Unpack Address",
        locationFieldNameLabel: "Unpack - Name",
        locationFieldAddress: "unpackAddress",
        params: {
          systemName: "LocationByAssociation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Client],
            freightPayerID
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "unpackDate", label: getTerm("consignment.container.unpackDate") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "unpackDate" })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "dehire",
        locationFieldAddressLabel: "Dehire Address",
        locationFieldNameLabel: "Dehire - Name",
        locationFieldAddress: "dehireAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Park]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "dehireDate", label: getTerm("consignment.container.dehireDate") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "dehireDate" })
    ] }) })
  ] });
}

function ExportMovementFromAndToDetails({
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "pickupLocation",
        locationNewFieldName: "pickupName",
        locationFieldNameLabel: "Pickup - Name",
        locationFieldAddressLabel: "Pickup Address",
        locationFieldAddress: "pickupAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Park]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "pickupRequiredBy", label: getTerm("consignment.requiredPickup") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "pickupRequiredBy" })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "pack",
        locationNewFieldName: "packName",
        locationFieldAddressLabel: "Pack Address",
        locationFieldNameLabel: "Pack - Name",
        locationFieldAddress: "packAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Client]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "deliveryLocation",
        locationNewFieldName: "deliveryName",
        locationFieldNameLabel: "Export - Name",
        locationFieldAddressLabel: "Export Address",
        locationFieldAddress: "deliveryAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [SystemName.LocationType.Port]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) })
  ] });
}

function MoveMovementFromAndToDetails({
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "pickupLocation",
        locationNewFieldName: "pickupName",
        locationFieldAddressLabel: "Pickup Address",
        locationFieldNameLabel: "Pickup - Name",
        locationFieldAddress: "pickupAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [
              SystemName.LocationType.Park,
              SystemName.LocationType.Port,
              SystemName.LocationType.Client
            ]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "pickupRequiredBy", label: getTerm("consignment.requiredPickup") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "pickupRequiredBy" })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsx(
      ConsignmentLocationField,
      {
        locationLookupName: "deliveryLocation",
        locationNewFieldName: "deliveryName",
        locationFieldAddressLabel: "Dropoff Address",
        locationFieldNameLabel: "Dropoff - Name",
        locationFieldAddress: "deliveryAddress",
        params: {
          systemName: "PortalLocation",
          additionalFilter: {
            locationType: [
              SystemName.LocationType.Park,
              SystemName.LocationType.Port,
              SystemName.LocationType.Client
            ]
          }
        },
        placesAPIKey,
        autocompleteRequestOptions,
        placeDetailsRequestOptions
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, item: true, spacing: 8, children: /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "dropoffRequiredBy", label: getTerm("consignment.requiredDropoff") }),
      /* @__PURE__ */ jsx(DateTimeInput, { name: "dropoffRequiredBy" })
    ] }) })
  ] });
}

function ConsignmentReferences({ form }) {
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "freightPayer", label: getTerm("consignment.freightPayer"), required: true }),
      /* @__PURE__ */ jsx(
        PartyLookup,
        {
          name: "freightPayer",
          params: {
            systemName: "PortalContact",
            additionalFilter: {
              contactType: "Client"
            },
            maxResults: "100"
          },
          useSearchTerm: true
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "orderReference", label: getTerm("consignment.orderReference"), required: true }),
      /* @__PURE__ */ jsx(ReferenceInput, { name: "orderReference" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "pickupReference", label: getTerm("consignment.pickupReference") }),
      /* @__PURE__ */ jsx(ReferenceInput, { name: "pickupReference" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "deliveryReference", label: getTerm("consignment.deliveryReference") }),
      /* @__PURE__ */ jsx(ReferenceInput, { name: "deliveryReference" })
    ] })
  ] });
}

var __defProp$v = Object.defineProperty;
var __defProps$q = Object.defineProperties;
var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$v.call(b, prop))
      __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(b)) {
      if (__propIsEnum$v.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$q = (a, b) => __defProps$q(a, __getOwnPropDescs$q(b));
const onMeasureApplyEdit = (input) => {
  const measureCurrentValue = formatNumber(input);
  return measureCurrentValue;
};
const parseNumber$1 = (value) => {
  if (typeof value === "string") {
    return parseFloat(value.replace(/,/g, ""));
  }
  return value;
};
function ProductLine({
  form,
  disabled,
  error,
  helperText,
  commodityLookupParams,
  defaultMeasureUnitType
}) {
  var _a;
  const theme = useTheme$2();
  const apiRef = useGridApiRef();
  const { watch } = form;
  (_a = watch("freightPayer")) == null ? void 0 : _a.contactID;
  const productLines = useFieldArray({
    control: form.control,
    keyName: "__id",
    name: "freightLines"
  });
  const onAddRow = () => {
    productLines.append({
      uuid: v4(),
      quantityType: defaultMeasureUnitType
    });
  };
  const onSetEditCellValue = ({ id, field, value }) => {
    const index = productLines.fields.findIndex((x) => x.uuid === id);
    productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), { [field]: value }));
  };
  const onMeasureSetEditCellValue = ({ id, field, value }) => {
    const index = productLines.fields.findIndex((x) => x.uuid === id);
    if (index === -1)
      return;
    if (field in productLines.fields[index]) {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: __spreadProps$q(__spreadValues$v({}, productLines.fields[index][field]), {
          measure: value
        })
      }));
    } else {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: {
          measure: value
        }
      }));
    }
  };
  const onObjectCodeSetEditCellValue = ({ id, field, value }) => {
    var _a2, _b, _c, _d;
    const index = productLines.fields.findIndex((x) => x.uuid === id);
    if (index === -1)
      return;
    if (field in productLines.fields[index]) {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: __spreadProps$q(__spreadValues$v({}, productLines.fields[index][field]), {
          code: (_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.code,
          codeID: (_b = value == null ? void 0 : value.additionalData) == null ? void 0 : _b.codeID
        })
      }));
    } else {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: {
          code: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.code,
          codeID: (_d = value == null ? void 0 : value.additionalData) == null ? void 0 : _d.codeID
        }
      }));
    }
  };
  const onObjectMarkSetEditCellValue = ({ id, field, value }) => {
    const index = productLines.fields.findIndex((x) => x.uuid === id);
    if (index === -1)
      return;
    if (field in productLines.fields[index]) {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: __spreadProps$q(__spreadValues$v({}, productLines.fields[index][field]), {
          value
        })
      }));
    } else {
      return productLines.update(index, __spreadProps$q(__spreadValues$v({}, productLines.fields[index]), {
        [field]: {
          value
        }
      }));
    }
  };
  let columns = [];
  columns = useMemo(() => {
    return [
      {
        field: "quantity",
        type: "numberinput",
        headerName: "Quantity",
        headerAlign: "left",
        disableColumnMenu: true,
        editable: !disabled,
        width: 150,
        props: {
          onSetEditCellValue: onMeasureSetEditCellValue,
          disabled
          // error: (_params, index) => {
          // 	return !!form.formState.errors.freightLines?.[index]?.quantity;
          // },
          // helperText: (_params, index) => {
          // 	return form.formState.errors.freightLines?.[index]?.quantity?.message;
          // }
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.quantity) == null ? void 0 : _a2.measure;
        }
      },
      {
        field: "quantityType",
        type: "lookup",
        headerName: "Package",
        disableColumnMenu: true,
        editable: true,
        width: 200,
        props: {
          params: {
            systemName: "MeasureUnitType",
            additionalFilter: "Quantity"
          },
          onSetEditCellValue,
          onApplyEdit: (option, _value) => {
            return defaultValue(option, null);
          },
          disabled
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.quantityType) == null ? void 0 : _a2.id;
        }
      },
      {
        field: "commodity",
        type: "lookup",
        headerName: "Commodity",
        disableColumnMenu: true,
        editable: true,
        width: 200,
        props: {
          params: defaultValue(commodityLookupParams, {
            systemName: "Code",
            additionalFilter: {
              codeQualifier: "Commodity"
            }
          }),
          onSetEditCellValue: onObjectCodeSetEditCellValue,
          onApplyEdit: (option, _value) => {
            return defaultValue(option, null);
          },
          disabled
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.commodity) == null ? void 0 : _a2.codeID;
        }
      },
      {
        field: "description",
        type: "textinput",
        flex: 2,
        headerName: "Description",
        disableColumnMenu: true,
        width: 200,
        editable: true,
        props: {
          onSetEditCellValue: onObjectMarkSetEditCellValue,
          disabled
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.description) == null ? void 0 : _a2.value;
        }
      },
      {
        field: "weight",
        type: "numberinput",
        flex: 1,
        align: "left",
        headerName: "Weight (kgs)",
        headerAlign: "left",
        disableColumnMenu: true,
        editable: true,
        props: {
          onSetEditCellValue: onMeasureSetEditCellValue,
          onApplyEdit: (input) => onMeasureApplyEdit(input),
          numberInputFormat: (input) => onMeasureApplyEdit(input)
          // error: (_params, index) => {
          // 	return !!form.formState.errors.freightLines?.[index]?.weight;
          // },
          // helperText: (_params, index) => {
          // 	return form.formState.errors.freightLines?.[index]?.weight?.message;
          // }
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.weight) == null ? void 0 : _a2.measure;
        }
      },
      {
        field: "volume",
        type: "numberinput",
        flex: 1,
        align: "left",
        headerName: "Volume m\xB3",
        headerAlign: "left",
        disableColumnMenu: true,
        editable: true,
        props: {
          onSetEditCellValue: onMeasureSetEditCellValue,
          onApplyEdit: (input) => onMeasureApplyEdit(input),
          numberInputFormat: (input) => onMeasureApplyEdit(input)
          // error: (_params, index) => {
          // 	return !!form.formState.errors.freightLines?.[index]?.volume;
          // },
          // helperText: (_params, index) => {
          // 	return form.formState.errors.freightLines?.[index]?.volume?.message;
          // }
        },
        valueGetter: (params) => {
          var _a2;
          return (_a2 = params.row.volume) == null ? void 0 : _a2.measure;
        }
      },
      {
        field: "actions",
        type: "actions",
        minWidth: 125,
        maxWidth: 125,
        disableColumnMenu: true,
        resizable: false,
        sortable: false,
        getActions: ({ id }) => {
          const index = productLines.fields.findIndex((x) => x.__id === id);
          return [
            /* @__PURE__ */ jsx(
              IconButton,
              {
                size: "small",
                onClick: () => {
                  productLines.remove(index);
                },
                children: /* @__PURE__ */ jsx(DeleteOutline, { fontSize: "small", color: "error" })
              }
            )
          ];
        }
      }
    ];
  }, [
    productLines.fields,
    disabled,
    onMeasureSetEditCellValue,
    onObjectCodeSetEditCellValue,
    onObjectMarkSetEditCellValue,
    onMeasureApplyEdit
  ]);
  const totalQuantity = productLines.fields.reduce((acc, row) => {
    var _a2;
    return acc + defaultValue((_a2 = row.quantity) == null ? void 0 : _a2.measure, 0);
  }, 0);
  const totalWeight = productLines.fields.reduce(
    (acc, row) => {
      var _a2;
      return acc + parseNumber$1(defaultValue((_a2 = row.weight) == null ? void 0 : _a2.measure, "0"));
    },
    0
  );
  const totalCubic = productLines.fields.reduce(
    (acc, row) => {
      var _a2;
      return acc + parseNumber$1(defaultValue((_a2 = row.volume) == null ? void 0 : _a2.measure, "0"));
    },
    0
  );
  const footer = () => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", justifyContent: "space-between", alignItems: "center", p: 2, children: [
    /* @__PURE__ */ jsxs(Grid$3, { container: true, children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, width: 25, children: /* @__PURE__ */ jsxs(Typography$1, { variant: "body2", align: "center", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            style: {
              fontWeight: 600
            },
            children: "Total:"
          }
        ),
        " ",
        !isNaN(totalQuantity) ? totalQuantity : 0
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, width: 200, children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2" }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, width: 200, children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2" }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, width: 250, children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2" }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, children: /* @__PURE__ */ jsxs(Typography$1, { variant: "body2", align: "center", children: [
        !isNaN(totalWeight) ? formatNumber(totalWeight.toString()) : 0,
        " kgs"
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, children: /* @__PURE__ */ jsxs(Typography$1, { variant: "body2", align: "center", children: [
        !isNaN(totalCubic) ? formatNumber(totalCubic.toString()) : 0,
        " m\xB3"
      ] }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 2, maxWidth: 125, children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2" }) })
    ] }),
    /* @__PURE__ */ jsx(Box$1, { display: "flex" }),
    /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => onAddRow(), children: /* @__PURE__ */ jsx(Add, { fontSize: "small" }) })
  ] }) });
  return /* @__PURE__ */ jsx(
    InlineEditGrid,
    {
      apiRef,
      columns,
      rows: productLines.fields,
      onAddRow,
      disabled,
      error,
      helperText,
      dataGridSx: {
        minHeight: "5rem",
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.common.black,
          fontWeight: 600
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { padding: "14px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        borderColor: error ? theme.palette.error.main : void 0,
        "& .MuiDataGrid-footerContainer": {
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          textAlign: "center"
        }
      },
      footer
    }
  );
}

const getKeyName = (value) => {
  var _a;
  return (_a = Object.entries(MimeTypes).find(([key, val]) => val === value)) == null ? void 0 : _a[0];
};
const imageFileValidation = (fileRejection, defaultImageSize, acceptedFileTypes) => {
  defaultImageSize = parseInt((defaultImageSize / (1024 * 1024)).toFixed(2));
  let errorMessages = [];
  fileRejection.map((rejectedFile) => {
    let error = rejectedFile.errors[0];
    if (error) {
      switch (error.code) {
        case "file-too-large": {
          errorMessages.push(`${rejectedFile.file.name} was rejected because file size is greater than ${defaultImageSize}MB`);
          break;
        }
        case "too-many-files": {
          errorMessages.push(`${rejectedFile.file.name} was rejected because ${error.message}, please choose one`);
          break;
        }
        case "file-invalid-type": {
          const types = acceptedFileTypes.map((type) => getKeyName(type));
          errorMessages.push(`${rejectedFile.file.name} was rejected because file type must be a valid image (${types.join()})`);
          break;
        }
        default: {
          errorMessages.push(`${rejectedFile.file.name} was rejected because something went wrong`);
          break;
        }
      }
    }
  });
  return errorMessages;
};
const documentFileValidation = (fileRejection, acceptedFileTypes) => {
  let errorMessages = [];
  fileRejection.map((rejectedFile) => {
    let error = rejectedFile.errors[0];
    if (error) {
      switch (error.code) {
        case "too-many-files": {
          errorMessages.push(`${rejectedFile.file.name} was rejected because ${error.message}, please choose one`);
          break;
        }
        case "file-invalid-type": {
          const types = acceptedFileTypes.map((type) => getKeyName(type));
          errorMessages.push(`${rejectedFile.file.name} was rejected because file type must be valid (${types.join()})`);
          break;
        }
        default: {
          errorMessages.push(`${rejectedFile.file.name} was rejected because something went wrong`);
          break;
        }
      }
    }
  });
  return errorMessages;
};
const fileValidationHelper = {
  imageFileValidation,
  documentFileValidation
};

var __defProp$u = Object.defineProperty;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$u.call(b, prop))
      __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(b)) {
      if (__propIsEnum$u.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    }
  return a;
};
function FileUploader({
  acceptedFileTypes = [
    MimeTypes.pdf,
    MimeTypes.jpeg,
    MimeTypes.doc,
    MimeTypes.docx,
    MimeTypes.png,
    MimeTypes.csv,
    MimeTypes.xls,
    MimeTypes.xlsx,
    MimeTypes.msg
  ],
  onFilesChange,
  multiple = true,
  boxStyle
}) {
  const popup = usePopupAlert();
  useTheme$2();
  const [files, setFiles] = useState([]);
  const onDrop = useCallback((acceptedFiles, fileRejection) => {
    if (fileRejection.length > 0) {
      const errorMessageList = fileValidationHelper.documentFileValidation(
        fileRejection,
        acceptedFileTypes
      );
      popup({
        severity: "error",
        message: errorMessageList
      });
    }
    if (acceptedFiles.length > 0) {
      const updatedFiles = [...files, ...acceptedFiles];
      setFiles(updatedFiles);
      onFilesChange(updatedFiles);
    }
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Box$1,
    {
      sx: __spreadValues$u({
        width: "100%",
        height: "150px"
      }, boxStyle),
      children: /* @__PURE__ */ jsx(
        Dropzone,
        {
          accept: acceptedFileTypes,
          onDrop,
          label: "Drag & drop files or Browse",
          multiple
        }
      )
    }
  ) });
}

var __async$f = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function DGDocuments({
  folderDirectory = "",
  layout = "horizontal",
  control
}) {
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const apiRef = useGridApiRef();
  const { watch } = useFormContext();
  const { listFolderContentsQuery, downloadFile, error: dropboxError } = useDropbox();
  const documents = watch("dgDocuments");
  const reference = watch("reference");
  const dgDocumentsRows = useFieldArray({
    control,
    keyName: "__id",
    name: "dgDocuments"
  });
  const handleOnChangeFile = (files) => {
    const filesToUpload = files.map((file) => {
      var _a;
      return {
        id: v4(),
        file,
        name: `DG_${file.name}`,
        fileType: (_a = file.name.split(".").pop()) != null ? _a : "unknown",
        uploadDate: "",
        existing: false,
        uuid: v4()
      };
    });
    dgDocumentsRows.append(filesToUpload);
  };
  const handleDelete = (id) => {
    dgDocumentsRows.remove(id);
  };
  const { data: contents, refetch } = listFolderContentsQuery(folderDirectory, !!reference);
  if (dropboxError && dropboxError === "AuthenticationError") {
    refetch();
  }
  const gridRows = useMemo(() => {
    var _a;
    const existingFilesContents = contents;
    const existingFiles = existingFilesContents ? (_a = existingFilesContents.map((content) => {
      var _a2, _b;
      return {
        id: content.id,
        name: content.name,
        fileType: (_a2 = content.name.split(".").pop()) != null ? _a2 : "unknown",
        uploadDate: (_b = content.server_modified) != null ? _b : "",
        existing: true,
        uuid: v4()
      };
    })) != null ? _a : [] : [];
    let allFiles = Array.isArray(documents) ? [...documents, ...existingFiles] : existingFiles;
    allFiles = allFiles.filter((file) => file.name.startsWith("DG_"));
    return allFiles;
  }, [contents, documents]);
  const handleDownload = (folderPath, fileName) => __async$f(this, null, function* () {
    try {
      yield downloadFile.mutateAsync({
        path: folderPath,
        fileName
      });
    } catch (error) {
      popup({ severity: "error", message: "Failed to retrieve DG Document" });
    }
  });
  const documentsGridColumns = useMemo(
    () => [
      {
        field: "fileName",
        headerName: "Filename",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return /* @__PURE__ */ jsx("div", { children: params.row.name });
        }
      },
      {
        field: "fileType",
        headerName: "File Type",
        flex: 1,
        maxWidth: 80,
        renderCell: (params) => {
          return /* @__PURE__ */ jsx("div", { children: params.row.fileType });
        }
      },
      {
        field: "uploadDate",
        headerName: "Upload Date",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          const formattedDate = params.row.uploadDate ? dayjs(params.row.uploadDate).format("DD/MM/YYYY HH:mm") : "";
          return /* @__PURE__ */ jsx("div", { children: formattedDate });
        }
      },
      {
        field: "actions",
        headerName: "",
        flex: 1,
        renderCell: (params) => {
          if (params.row.existing)
            return /* @__PURE__ */ jsx(
              IconButton,
              {
                onClick: () => handleDownload(folderDirectory, params.row.name),
                sx: { color: theme.palette.primary.main },
                children: /* @__PURE__ */ jsx(DownloadSharp, {})
              }
            );
          return /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: () => {
                const index = dgDocumentsRows.fields.findIndex((x) => x.uuid === params.id);
                if (index >= 0) {
                  handleDelete(index);
                }
              },
              sx: { color: "#d32f2f" },
              children: /* @__PURE__ */ jsx(DeleteOutline, {})
            }
          );
        },
        maxWidth: 50,
        disableColumnMenu: true
      }
    ],
    [dgDocumentsRows.fields]
  );
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: layout === "horizontal" ? 6 : 12, children: /* @__PURE__ */ jsx(
      FileUploader,
      {
        onFilesChange: (files) => handleOnChangeFile(files),
        boxStyle: layout === "horizontal" ? { height: "100%" } : {}
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: layout === "horizontal" ? 6 : 12, minHeight: "117px", maxHeight: "222px", children: /* @__PURE__ */ jsx(
      DataGridPro,
      {
        rows: gridRows,
        apiRef,
        columns: documentsGridColumns,
        rowSelection: false,
        getRowId: (row) => row.uuid,
        sx: {
          minHeight: "5rem",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.common.black,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { p: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "& .MuiDataGrid-footerContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            textAlign: "center"
          }
        },
        hideFooter: true,
        localeText: {
          noRowsLabel: "No documents uploaded"
        }
      }
    ) })
  ] });
}

function DangerousGoods$2({
  form,
  isDropboxDocuments,
  folderPath
}) {
  const labelFontSize = "0.85rem";
  const isDangerousGoods = form.watch("isDangerousGoods");
  return /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 12, md: 12, children: /* @__PURE__ */ jsx(
      FormCheckbox,
      {
        name: "isDangerousGoods",
        label: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          Typography,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize
            },
            children: "Dangerous Goods"
          }
        ) })
      }
    ) }),
    isDangerousGoods && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, md: 3, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "unNumber", label: getTerm("consignment.unNumber"), required: true }),
        /* @__PURE__ */ jsx(NoteInput, { name: "unNumber" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, md: 3, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "dgClass", label: getTerm("consignment.dgClass"), required: true }),
        /* @__PURE__ */ jsx(
          CodeLookup,
          {
            name: "dgClass",
            params: {
              systemName: "Code",
              additionalFilter: {
                codeQualifier: "DangerousGoodsClass"
              }
            }
          }
        )
      ] }),
      !isDropboxDocuments && /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, md: 6, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "DG Documents", label: getTerm("consignment.dgDocuments") }),
        /* @__PURE__ */ jsx(
          Alert$1,
          {
            severity: "info",
            style: {
              padding: "0.15rem"
            },
            children: "Feature to be implemented"
          }
        )
      ] }),
      isDropboxDocuments && /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, md: 12, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "DG Documents", label: getTerm("consignment.dgDocuments") }),
        /* @__PURE__ */ jsx(DGDocuments, { folderDirectory: folderPath != null ? folderPath : "", control: form.control })
      ] })
    ] })
  ] });
}

function EstimateCharge$2() {
  return /* @__PURE__ */ jsxs(Box$1, { sx: { textAlign: "right", padding: "16px" }, children: [
    /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", sx: { fontWeight: "bold" }, children: "Estimated Charge (NZD)" }),
    /* @__PURE__ */ jsx(Typography$1, { variant: "h6", sx: { fontWeight: "bold", color: "#000" }, children: "XXXX" }),
    /* @__PURE__ */ jsx(Typography$1, { variant: "caption", display: "block", sx: { marginTop: "8px" }, children: "*Estimate excl GST, FAF & Surcharges" }),
    /* @__PURE__ */ jsx(Typography$1, { variant: "body2", sx: { marginTop: "8px" }, children: "XXXX" })
  ] });
}

var __defProp$t = Object.defineProperty;
var __defProps$p = Object.defineProperties;
var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$t.call(b, prop))
      __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(b)) {
      if (__propIsEnum$t.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$p = (a, b) => __defProps$p(a, __getOwnPropDescs$p(b));
var __objRest$e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function ToggleGroupSkeleton() {
  return /* @__PURE__ */ jsx(Box$1, { sx: { display: "flex" }, children: /* @__PURE__ */ jsx(Skeleton$d, { variant: "rounded", width: "20rem", height: "40px" }) });
}
function ContainerToggleGroup(_a) {
  var _b = _a, { name, options, isLoading } = _b, props = __objRest$e(_b, ["name", "options", "isLoading"]);
  const transform = {
    input: (value) => {
      if (isNothing(value)) {
        return null;
      }
      if (isObjectCode(value) && value.delete) {
        return null;
      }
      if (isObjectCode(value) && !value.delete) {
        return {
          value: value.codeID.toString(),
          label: defaultValue(value.shortName, value.name),
          additionalData: {
            code: value.code,
            shortName: value.shortName
          }
        };
      }
      if (!isObjectCode(value) && typeof value !== "string") {
        return null;
      }
      return null;
    },
    output: (selectedOption, value) => {
      var _a2, _c;
      let output = value;
      if (isNothing(value) && isToggleItem(selectedOption)) {
        output = {
          codeID: +selectedOption.value,
          name: (_a2 = selectedOption.additionalData.codeName) != null ? _a2 : selectedOption.label,
          code: selectedOption.additionalData.code,
          shortName: selectedOption.additionalData.shortName
        };
      }
      if (isObjectCode(value) && isNothing(value.id) && isNothing(selectedOption)) {
        const _b2 = value, rest = __objRest$e(_b2, ["codeID", "name", "code", "shortName", "delete"]);
        output = Object.keys(rest).length > 0 ? rest : null;
      }
      if (isObjectCode(value) && !isNothing(value.id) && isNothing(selectedOption)) {
        output = __spreadProps$p(__spreadValues$t({}, value), { delete: true });
      }
      if (!isNothing(value) && !Array.isArray(value) && isToggleItem(selectedOption)) {
        output = __spreadProps$p(__spreadValues$t({}, value), {
          codeID: +selectedOption.value,
          name: (_c = selectedOption.additionalData.codeName) != null ? _c : selectedOption.name,
          code: selectedOption.additionalData.code,
          shortName: selectedOption.additionalData.shortName,
          delete: false
        });
      }
      return output;
    }
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx(ToggleGroupSkeleton, {});
  }
  return /* @__PURE__ */ jsx(FormToggleGroup, __spreadProps$p(__spreadValues$t({}, props), { name, options, transform }));
}

var __async$e = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function DropboxDocuments({
  folderDirectory = "",
  filterDocuments,
  layout = "vertical",
  setIsFormDirty,
  control
}) {
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const apiRef = useGridApiRef();
  const { watch } = useFormContext();
  const { listFolderContentsQuery, downloadFile, error: dropboxError } = useDropbox();
  const documents = watch("dropBoxDocuments");
  const reference = watch("reference");
  const dropboxDocumentsRows = useFieldArray({
    control,
    keyName: "__id",
    name: "dropBoxDocuments"
  });
  const handleOnChangeFile = (files) => {
    const filesToUpload = files.map((file) => {
      var _a;
      return {
        id: v4(),
        file,
        name: file.name,
        fileType: (_a = file.name.split(".").pop()) != null ? _a : "unknown",
        uploadDate: "",
        existing: false,
        uuid: v4()
      };
    });
    dropboxDocumentsRows.append(filesToUpload);
    if (typeof setIsFormDirty === "function") {
      setIsFormDirty(filesToUpload.length > 0);
    }
  };
  const handleDelete = (id, rowID) => {
    dropboxDocumentsRows.remove(id);
    const newDocuments = dropboxDocumentsRows.fields && dropboxDocumentsRows.fields.length > 0 ? dropboxDocumentsRows.fields.filter((x) => x.uuid !== rowID && x.existing === false) : [];
    if (typeof setIsFormDirty === "function" && newDocuments.length === 0) {
      setIsFormDirty(false);
    }
  };
  const {
    data: contents,
    isLoading: isListFolderContentLoading,
    refetch
  } = listFolderContentsQuery(folderDirectory, !!reference);
  const gridRows = useMemo(() => {
    var _a;
    const existingFilesContents = contents;
    const existingFiles = existingFilesContents ? (_a = existingFilesContents.map((content) => {
      var _a2, _b;
      return {
        id: content.id,
        name: content.name,
        fileType: (_a2 = content.name.split(".").pop()) != null ? _a2 : "unknown",
        uploadDate: (_b = content.server_modified) != null ? _b : "",
        existing: true,
        uuid: v4()
      };
    })) != null ? _a : [] : [];
    let allFiles = Array.isArray(documents) ? [...documents, ...existingFiles] : existingFiles;
    if (filterDocuments) {
      allFiles = allFiles.filter(filterDocuments);
    }
    return allFiles;
  }, [contents, documents, filterDocuments]);
  const handleDownload = (folderPath, fileName) => __async$e(this, null, function* () {
    try {
      yield downloadFile.mutateAsync({
        path: folderPath,
        fileName
      });
    } catch (error) {
      popup({ severity: "error", message: "Failed to retrieve document" });
    }
  });
  const documentsGridColumns = useMemo(
    () => [
      {
        field: "fileName",
        headerName: "Filename",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return /* @__PURE__ */ jsx("div", { children: params.row.name });
        }
      },
      {
        field: "fileType",
        headerName: "File Type",
        flex: 1,
        maxWidth: 80,
        renderCell: (params) => {
          return /* @__PURE__ */ jsx("div", { children: params.row.fileType });
        }
      },
      {
        field: "uploadDate",
        headerName: "Upload Date",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          const formattedDate = params.row.uploadDate ? dayjs(params.row.uploadDate).format("DD/MM/YYYY HH:mm") : "";
          return /* @__PURE__ */ jsx("div", { children: formattedDate });
        }
      },
      {
        field: "actions",
        headerName: "",
        flex: 1,
        renderCell: (params) => {
          if (params.row.existing) {
            return /* @__PURE__ */ jsx(
              IconButton,
              {
                onClick: () => handleDownload(folderDirectory, params.row.name),
                sx: { color: theme.palette.primary.main },
                children: /* @__PURE__ */ jsx(DownloadSharp, {})
              }
            );
          }
          return /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: () => {
                const index = dropboxDocumentsRows.fields.findIndex((x) => {
                  return x.uuid === params.id;
                });
                if (index >= 0) {
                  handleDelete(index, params.row.uuid);
                }
              },
              sx: { color: "#d32f2f" },
              children: /* @__PURE__ */ jsx(DeleteOutline, {})
            }
          );
        },
        maxWidth: 50,
        disableColumnMenu: true
      }
    ],
    [dropboxDocumentsRows.fields]
  );
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: layout === "horizontal" ? 6 : 12, children: /* @__PURE__ */ jsx(
      FileUploader,
      {
        onFilesChange: (files) => handleOnChangeFile(files),
        boxStyle: layout === "horizontal" ? { height: "100%" } : {}
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: layout === "horizontal" ? 6 : 12, minHeight: "117px", maxHeight: "222px", children: /* @__PURE__ */ jsx(
      DataGridPro,
      {
        rows: gridRows,
        apiRef,
        columns: documentsGridColumns,
        rowSelection: false,
        getRowId: (row) => row.uuid,
        sx: {
          minHeight: "5rem",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.grey[600]), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.common.black,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { p: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "& .MuiDataGrid-footerContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            textAlign: "center"
          }
        },
        hideFooter: true,
        localeText: {
          noRowsLabel: "No documents uploaded"
        }
      }
    ) })
  ] });
}

function DropboxConnect() {
  const clientId = "";
  const handleConnect = () => {
    const dropboxAuthUrl = `https://www.dropbox.com/oauth2/authorize?client_id=${clientId}&token_access_type=offline&response_type=code`;
    window.location.href = dropboxAuthUrl;
  };
  return /* @__PURE__ */ jsx(Box$1, { children: /* @__PURE__ */ jsx(Button, { variant: "contained", color: "primary", onClick: handleConnect, children: "Connect to Dropbox" }) });
}

var __defProp$s = Object.defineProperty;
var __defProps$o = Object.defineProperties;
var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$s.call(b, prop))
      __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(b)) {
      if (__propIsEnum$s.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$o = (a, b) => __defProps$o(a, __getOwnPropDescs$o(b));
function BlockFilter({ active, title, value, loading, onClick, sx, activeBGColor, boxFlex }) {
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-active": active,
      flex: boxFlex != null ? boxFlex : "0 0 20%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: mobileBreakPoint ? 1 : 4,
      padding: mobileBreakPoint ? 3 : 10,
      bgcolor: active ? activeBGColor != null ? activeBGColor : theme.palette.primary.main : theme.palette.common.white,
      sx: __spreadProps$o(__spreadValues$s({}, sx), {
        cursor: "pointer",
        transition: "background-color 0.2s",
        "&:hover:not([data-active=true])": {
          backgroundColor: theme.palette.grey[100]
        }
      }),
      onClick,
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            color: active ? theme.palette.common.white : theme.palette.grey[600],
            fontWeight: 600,
            fontSize: mobileBreakPoint ? "0.75rem" : "initial",
            children: title
          }
        ),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "h5",
            color: active ? theme.palette.common.white : "initial",
            fontWeight: 600,
            fontSize: mobileBreakPoint ? "1rem" : "3rem",
            children: loading ? /* @__PURE__ */ jsx(CircularProgress$1, { color: "inherit" }) : /* @__PURE__ */ jsx(Fragment, { children: value })
          }
        )
      ]
    }
  );
}

var dist = {};

function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

Object.defineProperty(dist, '__esModule', { value: true });

var React = React__default$1;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

var _default = dist.default = Marquee;

var __defProp$r = Object.defineProperty;
var __defProps$n = Object.defineProperties;
var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$r.call(b, prop))
      __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(b)) {
      if (__propIsEnum$r.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$n = (a, b) => __defProps$n(a, __getOwnPropDescs$n(b));
const activeFrom = dayjs().format("YYYY-MM-DD HH:mm:ss");
function GeoCoordinateInformationBanner({ getIcon, setBannerHeight }) {
  var _a, _b, _c, _d, _e, _f;
  const theme = useTheme$2();
  const [query] = useGridQuery(
    {
      systemName: "GeoCoordinateInformation",
      parameters: {
        activeFrom,
        displayOn: "BANNER"
      }
    },
    { cacheTime: 0 }
  );
  if (!getIcon) {
    getIcon = (geoCoordinateInformationTypeSystemName) => {
      let icon;
      let sx = { fontSize: "0.85rem", marginRight: 2 };
      switch (geoCoordinateInformationTypeSystemName) {
        case "GeneralEvent":
          icon = /* @__PURE__ */ jsx(Warning, {});
          sx = __spreadProps$n(__spreadValues$r({}, sx), { color: theme.palette.warning.main });
          break;
        case "SignificantEvent":
          icon = /* @__PURE__ */ jsx(Warning, {});
          sx = __spreadProps$n(__spreadValues$r({}, sx), { color: theme.palette.error.main });
          break;
      }
      return icon ? /* @__PURE__ */ jsx(Typography, { sx, children: icon }) : /* @__PURE__ */ jsx(Fragment, {});
    };
  }
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      if (typeof setBannerHeight === "function") {
        setBannerHeight(ref.current.offsetHeight);
      }
    }
  }, [query.isFetching]);
  return /* @__PURE__ */ jsx(Box, { ref, flexGrow: 0, display: ((_d = (_c = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows) == null ? void 0 : _c.length) != null ? _d : 0 > 0) ? "block" : "none", children: /* @__PURE__ */ jsx(Alert$1, { icon: false, severity: "info", sx: { " & .MuiAlert-message": { width: "100%" } }, children: /* @__PURE__ */ jsx(_default, { pauseOnHover: true, autoFill: true, children: /* @__PURE__ */ jsx(Box, { sx: { display: "flex", flexWrap: "nowrap" }, children: (_f = (_e = query.data) == null ? void 0 : _e.data) == null ? void 0 : _f.rows.map((info, index) => {
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      typeof getIcon === "function" && getIcon(info.geoCoordinateInformationTypeSystemName),
      /* @__PURE__ */ jsxs(Typography, { children: [
        info.locationName,
        " - ",
        info.informationTitle,
        " - ",
        info.informationDescription
      ] }),
      /* @__PURE__ */ jsx(Typography, { sx: { marginX: 10 }, children: "|" })
    ] }, index);
  }) }) }) }) });
}

var __async$d = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function NetworkHealthGrid({
  rows,
  columns,
  columnKeys,
  isExcludeColumnKey,
  customiseColumns,
  loading,
  getRowId,
  onRowClick,
  setEditID,
  setIsOpenModal,
  invalidateGridQuery
}) {
  const theme = useTheme$2();
  const handleOnRowClick = (data) => {
    typeof onRowClick === "function" && onRowClick(data == null ? void 0 : data.row);
  };
  const handleEditOnClick = (id) => {
    setEditID(id);
    setIsOpenModal(true);
  };
  const handleDeleteOnClick = (id) => __async$d(this, null, function* () {
    const confirmDelete = yield confirm("Confirm", "Are you sure you want to delete this network notification?");
    if (confirmDelete) {
      try {
        const response = yield httpService$1.post("GeoCoordinateInformation/Delete", { id });
        if (response) {
          popup({
            message: "Network notification is deleted successfully",
            severity: "success"
          });
          if (typeof invalidateGridQuery === "function") {
            invalidateGridQuery();
          }
        }
      } catch (error) {
        popup({
          message: "Error on deleting network notification",
          severity: "error"
        });
      }
    }
  });
  const confirm = useConfirmationDialog();
  const popup = usePopupAlert();
  const displayColumns = useMemo(() => {
    const defaultSetting = {
      informationTitle: {
        field: "informationTitle",
        flex: 1,
        headerName: "Summary"
      },
      informationDescription: {
        field: "informationDescription",
        flex: 1,
        headerName: "Notification"
      },
      locationName: {
        field: "locationName",
        flex: 1,
        headerName: "Region"
      },
      displayOnMap: {
        field: "displayOnMap",
        flex: 1,
        headerName: "Map",
        maxWidth: 68,
        type: "boolean"
      },
      displayOnBanner: {
        field: "displayOnBanner",
        flex: 1,
        headerName: "Banner",
        maxWidth: 68,
        type: "boolean"
      },
      geoCoordinateInformationTypeName: {
        field: "geoCoordinateInformationTypeName",
        flex: 1,
        headerName: "Type"
      },
      startDate: {
        field: "startDate",
        flex: 1,
        headerName: "Start Date",
        type: "datetime",
        valueGetter: ({ value }) => value ? dayjs(value) : null,
        valueFormatter: ({ value }) => value ? value.format("DD-MM-YYYY | hh:mma") : null
      },
      expiryDate: {
        field: "expiryDate",
        flex: 1,
        headerName: "Expiry Date",
        type: "datetime",
        valueGetter: ({ value }) => value ? dayjs(value) : null,
        valueFormatter: ({ value }) => value ? value.format("DD-MM-YYYY | hh:mma") : null
      },
      active: {
        field: "active",
        flex: 1,
        headerName: "Active",
        maxWidth: 68,
        type: "boolean"
      },
      action: {
        field: "action",
        flex: 1,
        headerName: "Actions",
        maxWidth: 100,
        renderCell: (params) => {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(IconButton, { color: "primary", onClick: () => handleEditOnClick(params.row.id), children: /* @__PURE__ */ jsx(Edit, {}) }),
            /* @__PURE__ */ jsx(IconButton, { color: "primary", onClick: () => handleDeleteOnClick(params.row.id), children: /* @__PURE__ */ jsx(Delete, {}) })
          ] });
        }
      }
    };
    let initSetting = {};
    if (Array.isArray(columns)) {
      columns.forEach((col) => {
        if (col.field) {
          initSetting[col.field] = col;
        }
      });
    } else {
      initSetting = defaultSetting;
    }
    let setting = {};
    if (Array.isArray(columnKeys)) {
      if (isExcludeColumnKey) {
        setting = initSetting;
        columnKeys.forEach((columnKey) => {
          delete setting[columnKey];
        });
      } else {
        columnKeys.forEach((columnKey) => {
          setting[columnKey] = initSetting[columnKey] || {
            field: columnKey,
            flex: 1,
            headerName: columnKey,
            disableColumnMenu: true
          };
        });
      }
    } else {
      setting = initSetting;
    }
    if (Array.isArray(customiseColumns)) {
      customiseColumns.forEach((column) => {
        const settingKey = column.field;
        setting[settingKey] = column;
      });
    }
    return Object.keys(setting).map((key) => {
      return setting[key];
    });
  }, [columnKeys, isExcludeColumnKey, customiseColumns]);
  return /* @__PURE__ */ jsx(
    DataGridPro,
    {
      loading,
      hideFooter: true,
      onRowClick: handleOnRowClick,
      columns: displayColumns,
      rows,
      getRowId: typeof getRowId === "function" ? (row) => getRowId(row) : (row) => row.id,
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.common.black), 0.8)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.common.white,
          fontWeight: 600
        },
        "& .MuiDataGrid-sortIcon": {
          color: theme.palette.common.white
        },
        "& .MuiDataGrid-menuIconButton": {
          color: theme.palette.common.white
        },
        "& .MuiDataGrid-columnSeparator:hover": {
          color: darken(theme.palette.common.white, 0.3)
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        fontSize: "0.85rem"
      },
      autoHeight: true
    }
  );
}

function NetworkHealthFilter({ onSubmit }) {
  const [context, Form] = useForm({
    defaultValues: {
      location: null,
      geoCoordinateInformationType: null,
      startDate: null,
      expiryDate: null,
      active: null
    }
  });
  const { handleSubmit, reset } = context;
  const handleApplyClick = () => {
    handleSubmit((state) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const filterData = {
        locationID: ((_a = state == null ? void 0 : state.location) == null ? void 0 : _a.id) || null,
        geoCoordinateInformationTypeID: ((_b = state == null ? void 0 : state.geoCoordinateInformationType) == null ? void 0 : _b.id) || null,
        startDate: ((_c = state.startDate) == null ? void 0 : _c.dateAndTime) ? dayjs((_d = state.startDate) == null ? void 0 : _d.dateAndTime).format("YYYY-MM-DD") : null,
        expiryDate: ((_e = state.expiryDate) == null ? void 0 : _e.dateAndTime) ? dayjs((_f = state.expiryDate) == null ? void 0 : _f.dateAndTime).format("YYYY-MM-DD") : null,
        activeID: (_h = (_g = state == null ? void 0 : state.active) == null ? void 0 : _g.id) != null ? _h : "1"
      };
      onSubmit(filterData);
    })();
  };
  const handleClearClick = () => {
    reset();
  };
  return /* @__PURE__ */ jsxs(Form, { children: [
    /* @__PURE__ */ jsx(Typography, { variant: "body1", gutterBottom: true, children: "Filters" }),
    /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "location", label: "Region" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "location",
            placeholder: "Region",
            params: {
              systemName: "Location",
              additionalFilter: {
                locationType: ["GeoInformationRegion"]
              },
              maxResults: "100"
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "geoCoordinateInformationType", label: "Type" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "geoCoordinateInformationType",
            placeholder: "Type",
            params: {
              systemName: "GeoCoordinateInformationType"
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "startDate", label: "Start Date" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "startDate" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "expiryDate", label: "Expiry Date" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "expiryDate" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "active", label: "Active" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "active",
            placeholder: "Active Only",
            params: {
              systemName: "ActiveType"
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, alignSelf: "end", children: /* @__PURE__ */ jsxs(Box, { display: "flex", gap: 2, marginLeft: 10, children: [
        /* @__PURE__ */ jsx(Button$1, { onClick: handleApplyClick, color: "primary", variant: "contained", children: "Apply" }),
        /* @__PURE__ */ jsx(Button$1, { onClick: handleClearClick, color: "primary", variant: "outlined", children: "Clear" })
      ] }) })
    ] })
  ] });
}

var __defProp$q = Object.defineProperty;
var __defProps$m = Object.defineProperties;
var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$q.call(b, prop))
      __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(b)) {
      if (__propIsEnum$q.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$m = (a, b) => __defProps$m(a, __getOwnPropDescs$m(b));
var __async$c = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const modalValidation = z$1.object({
  id: z$1.number().optional(),
  location: z$1.object(
    {
      id: z$1.string(),
      name: z$1.string(),
      additionalData: z$1.object({
        latitude: z$1.number(),
        longitude: z$1.number()
      })
    },
    {
      invalid_type_error: "Please select a region.",
      required_error: "Please select a region."
    }
  ),
  geoCoordinateInformationType: z$1.object(
    {
      id: z$1.string(),
      name: z$1.string()
    },
    {
      invalid_type_error: "Please select a notification type.",
      required_error: "Please select a notification type."
    }
  ),
  informationTitle: z$1.string({
    invalid_type_error: "Please enter notification summary.",
    required_error: "Please enter notification summary."
  }),
  informationDescription: z$1.string({
    invalid_type_error: "Please enter notification.",
    required_error: "Please enter notification."
  }),
  activeFrom: z$1.object({
    dateAndTime: z$1.string()
  }, {
    invalid_type_error: "Please enter start date time.",
    required_error: "Please enter start date time."
  }),
  activeTo: z$1.object({
    dateAndTime: z$1.string()
  }, {
    invalid_type_error: "Please enter expiry date time.",
    required_error: "Please enter expiry date time."
  }),
  viewedIn: z$1.object(
    {
      id: z$1.string(),
      name: z$1.string()
    },
    {
      invalid_type_error: "Please select where this notification to be viewed.",
      required_error: "Please select where this notification to be viewed."
    }
  ),
  active: z$1.boolean()
});
function Modal({ setOpen, handleSubmit, id }) {
  const theme = useTheme$2();
  const onSubmitHandler = (state) => {
    if (typeof handleSubmit === "function") {
      handleSubmit(state);
    }
    void setOpen(false);
  };
  const [context, Form] = useForm({
    onSubmit: onSubmitHandler,
    validationSchema: modalValidation,
    defaultValues: { active: true }
  });
  const { reset } = context;
  const query = useQuery$1(
    ["/GeoCoordinateInformation", id],
    () => httpService$1.get(`GeoCoordinateInformation/${id}`),
    {
      enabled: !!id
    }
  );
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    if ((_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) {
      let viewedIn = void 0;
      if (((_c = (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.data) == null ? void 0 : _c.displayOnMap) && ((_e = (_d = query == null ? void 0 : query.data) == null ? void 0 : _d.data) == null ? void 0 : _e.displayOnBanner)) {
        viewedIn = "Both";
      } else if ((_g = (_f = query == null ? void 0 : query.data) == null ? void 0 : _f.data) == null ? void 0 : _g.displayOnMap) {
        viewedIn = "Map";
      } else if ((_i = (_h = query == null ? void 0 : query.data) == null ? void 0 : _h.data) == null ? void 0 : _i.displayOnBanner) {
        viewedIn = "Banner";
      }
      reset(__spreadProps$m(__spreadValues$q({}, query.data.data), {
        location: {
          id: (_l = (_k = (_j = query.data) == null ? void 0 : _j.data) == null ? void 0 : _k.locationID) == null ? void 0 : _l.toString(),
          name: (_n = (_m = query.data) == null ? void 0 : _m.data) == null ? void 0 : _n.locationName,
          additionalData: {
            latitude: (_p = (_o = query.data) == null ? void 0 : _o.data) == null ? void 0 : _p.latitude,
            longitude: (_r = (_q = query.data) == null ? void 0 : _q.data) == null ? void 0 : _r.longitude
          }
        },
        geoCoordinateInformationType: {
          id: (_u = (_t = (_s = query.data) == null ? void 0 : _s.data) == null ? void 0 : _t.geoCoordinateInformationTypeID) == null ? void 0 : _u.toString(),
          name: (_w = (_v = query.data) == null ? void 0 : _v.data) == null ? void 0 : _w.geoCoordinateInformationTypeName
        },
        viewedIn: {
          id: viewedIn,
          name: viewedIn
        }
      }));
    }
  }, [query.data]);
  const viewedInLookup = [
    { id: "Map", name: "Map" },
    { id: "Banner", name: "Banner" },
    { id: "Both", name: "Both" }
  ];
  return /* @__PURE__ */ jsxs(
    Dialog$1,
    {
      fullWidth: true,
      open: true,
      onClose: (_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setOpen(false);
        }
      },
      scroll: "paper",
      children: [
        /* @__PURE__ */ jsxs(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: [
              /* @__PURE__ */ jsxs(Typography$1, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: [
                id ? "Edit" : "New",
                " Network Notification"
              ] }),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  onClick: () => setOpen(false),
                  sx: {
                    padding: 0
                  },
                  edge: "end",
                  color: "inherit",
                  "aria-label": "close",
                  children: /* @__PURE__ */ jsx(Close, { sx: { flexGrow: 1 } })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Form, { children: [
          /* @__PURE__ */ jsx(DialogContent$1, { children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
            query.isFetching && /* @__PURE__ */ jsx(Loader, {}),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "location", label: "Region", required: true }),
              /* @__PURE__ */ jsx(
                FormLookup,
                {
                  name: "location",
                  params: {
                    systemName: "Location",
                    additionalFilter: {
                      locationType: ["GeoInformationRegion"]
                    },
                    maxResults: "100"
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "geoCoordinateInformationType", label: "Notification Type", required: true }),
              /* @__PURE__ */ jsx(
                FormLookup,
                {
                  name: "geoCoordinateInformationType",
                  params: {
                    systemName: "GeoCoordinateInformationType"
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "informationTitle", label: "Notification Summary", required: true }),
              /* @__PURE__ */ jsx(FormInput, { name: "informationTitle", inputProps: { maxLength: 20 } })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "informationDescription", label: "Notification", required: true }),
              /* @__PURE__ */ jsx(FormInput, { name: "informationDescription", inputProps: { maxLength: 150 } })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "activeFrom", label: "Start Date | Time", required: true }),
              /* @__PURE__ */ jsx(DateTimeInput, { name: "activeFrom", timePicker: true })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "activeTo", label: "Expiry Date | Time", required: true }),
              /* @__PURE__ */ jsx(DateTimeInput, { name: "activeTo", timePicker: true })
            ] }),
            /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "viewedIn", label: "Viewed in", required: true }),
              /* @__PURE__ */ jsx(
                FormAutocompleteDropdown,
                {
                  name: "viewedIn",
                  options: viewedInLookup,
                  isOptionEqualToValue: (option, val) => option.id === val.id
                }
              )
            ] }),
            /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: /* @__PURE__ */ jsx(
              FormCheckbox,
              {
                name: "active",
                label: /* @__PURE__ */ jsx(
                  Typography$1,
                  {
                    sx: {
                      fontWeight: 600,
                      fontSize: "0.85rem"
                    },
                    children: "Active"
                  }
                )
              }
            ) })
          ] }) }),
          /* @__PURE__ */ jsx(DialogActions$1, { sx: { padding: 4 }, children: /* @__PURE__ */ jsx(Button, { type: "submit", variant: "contained", color: "primary", children: "Save" }) })
        ] })
      ]
    }
  );
}
function NetworkHealthModal({ setIsOpenModal, id, invalidateGridQuery }) {
  const popup = usePopupAlert();
  const handleCloseFormDialog = () => {
    setIsOpenModal(false);
  };
  const handleSubmitButton = (data) => __async$c(this, null, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const payload = __spreadProps$m(__spreadValues$q({}, data), {
      locationID: (_a = data.location) == null ? void 0 : _a.id,
      locationName: (_b = data.location) == null ? void 0 : _b.name,
      latitude: (_d = (_c = data.location) == null ? void 0 : _c.additionalData) == null ? void 0 : _d.latitude,
      longitude: (_f = (_e = data.location) == null ? void 0 : _e.additionalData) == null ? void 0 : _f.longitude,
      geoCoordinateInformationTypeID: (_g = data.geoCoordinateInformationType) == null ? void 0 : _g.id,
      displayOnMap: ["Map", "Both"].includes((_h = data.viewedIn) == null ? void 0 : _h.id),
      displayOnBanner: ["Banner", "Both"].includes((_i = data.viewedIn) == null ? void 0 : _i.id)
    });
    try {
      const response = id ? yield httpService$1.put("GeoCoordinateInformation", payload) : yield httpService$1.post("GeoCoordinateInformation", payload);
      if (response) {
        popup({
          message: "Network notification is saved successfully",
          severity: "success"
        });
        if (typeof invalidateGridQuery === "function") {
          invalidateGridQuery();
        }
      }
    } catch (error) {
      popup({
        message: "Error on saving network notification",
        severity: "error"
      });
    }
  });
  return createPortal(
    /* @__PURE__ */ jsx(
      Modal,
      {
        setOpen: handleCloseFormDialog,
        handleSubmit: handleSubmitButton,
        id
      }
    ),
    document.body
  );
}

/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function memo(getDeps, fn, opts) {
  var _opts$initialDeps;
  var deps = (_opts$initialDeps = opts.initialDeps) != null ? _opts$initialDeps : [];
  var result;
  return function () {
    var depTime;
    if (opts.key && opts.debug != null && opts.debug()) depTime = Date.now();
    var newDeps = getDeps();
    var depsChanged = newDeps.length !== deps.length || newDeps.some(function (dep, index) {
      return deps[index] !== dep;
    });
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    var resultTime;
    if (opts.key && opts.debug != null && opts.debug()) resultTime = Date.now();
    result = fn.apply(void 0, newDeps);
    if (opts.key && opts.debug != null && opts.debug()) {
      var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      var resultFpsPercentage = resultEndTime / 16;
      var pad = function pad(str, num) {
        str = String(str);
        while (str.length < num) {
          str = ' ' + str;
        }
        return str;
      };
      console.info("%c\u23F1 " + pad(resultEndTime, 5) + " /" + pad(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
    }
    opts == null ? void 0 : opts.onChange == null ? void 0 : opts.onChange(result);
    return result;
  };
}
function notUndefined(value, msg) {
  if (value === undefined) {
    throw new Error("Unexpected undefined" + (msg ? ": " + msg : ''));
  } else {
    return value;
  }
}
var approxEqual = function approxEqual(a, b) {
  return Math.abs(a - b) < 1;
};

/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

//

//

var defaultKeyExtractor = function defaultKeyExtractor(index) {
  return index;
};
var defaultRangeExtractor = function defaultRangeExtractor(range) {
  var start = Math.max(range.startIndex - range.overscan, 0);
  var end = Math.min(range.endIndex + range.overscan, range.count - 1);
  var arr = [];
  for (var _i = start; _i <= end; _i++) {
    arr.push(_i);
  }
  return arr;
};
var observeElementRect = function observeElementRect(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler(rect) {
    var width = rect.width,
      height = rect.height;
    cb({
      width: Math.round(width),
      height: Math.round(height)
    });
  };
  handler(element.getBoundingClientRect());
  var observer = new ResizeObserver(function (entries) {
    var entry = entries[0];
    if (entry != null && entry.borderBoxSize) {
      var box = entry.borderBoxSize[0];
      if (box) {
        handler({
          width: box.inlineSize,
          height: box.blockSize
        });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, {
    box: 'border-box'
  });
  return function () {
    observer.unobserve(element);
  };
};
var observeElementOffset = function observeElementOffset(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler() {
    cb(element[instance.options.horizontal ? 'scrollLeft' : 'scrollTop']);
  };
  handler();
  element.addEventListener('scroll', handler, {
    passive: true
  });
  return function () {
    element.removeEventListener('scroll', handler);
  };
};
var measureElement = function measureElement(element, entry, instance) {
  if (entry != null && entry.borderBoxSize) {
    var box = entry.borderBoxSize[0];
    if (box) {
      var size = Math.round(box[instance.options.horizontal ? 'inlineSize' : 'blockSize']);
      return size;
    }
  }
  return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? 'width' : 'height']);
};
var elementScroll = function elementScroll(offset, _ref2, instance) {
  var _instance$scrollEleme3, _instance$scrollEleme4;
  var _ref2$adjustments = _ref2.adjustments,
    adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments,
    behavior = _ref2.behavior;
  var toOffset = offset + adjustments;
  (_instance$scrollEleme3 = instance.scrollElement) == null ? void 0 : _instance$scrollEleme3.scrollTo == null ? void 0 : _instance$scrollEleme3.scrollTo((_instance$scrollEleme4 = {}, _instance$scrollEleme4[instance.options.horizontal ? 'left' : 'top'] = toOffset, _instance$scrollEleme4.behavior = behavior, _instance$scrollEleme4));
};
var Virtualizer = function Virtualizer(_opts) {
  var _this = this;
  this.unsubs = [];
  this.scrollElement = null;
  this.isScrolling = false;
  this.isScrollingTimeoutId = null;
  this.scrollToIndexTimeoutId = null;
  this.measurementsCache = [];
  this.itemSizeCache = new Map();
  this.pendingMeasuredCacheIndexes = [];
  this.scrollDirection = null;
  this.scrollAdjustments = 0;
  this.measureElementCache = new Map();
  this.observer = function () {
    var _ro = null;
    var get = function get() {
      if (_ro) {
        return _ro;
      } else if (typeof ResizeObserver !== 'undefined') {
        return _ro = new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            _this._measureElement(entry.target, entry);
          });
        });
      } else {
        return null;
      }
    };
    return {
      disconnect: function disconnect() {
        var _get;
        return (_get = get()) == null ? void 0 : _get.disconnect();
      },
      observe: function observe(target) {
        var _get2;
        return (_get2 = get()) == null ? void 0 : _get2.observe(target, {
          box: 'border-box'
        });
      },
      unobserve: function unobserve(target) {
        var _get3;
        return (_get3 = get()) == null ? void 0 : _get3.unobserve(target);
      }
    };
  }();
  this.range = {
    startIndex: 0,
    endIndex: 0
  };
  this.setOptions = function (opts) {
    Object.entries(opts).forEach(function (_ref3) {
      var key = _ref3[0],
        value = _ref3[1];
      if (typeof value === 'undefined') delete opts[key];
    });
    _this.options = _extends({
      debug: false,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: false,
      getItemKey: defaultKeyExtractor,
      rangeExtractor: defaultRangeExtractor,
      onChange: function onChange() {},
      measureElement: measureElement,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: 'data-index',
      initialMeasurementsCache: [],
      lanes: 1
    }, opts);
  };
  this.notify = function () {
    _this.options.onChange == null ? void 0 : _this.options.onChange(_this);
  };
  this.cleanup = function () {
    _this.unsubs.filter(Boolean).forEach(function (d) {
      return d();
    });
    _this.unsubs = [];
    _this.scrollElement = null;
  };
  this._didMount = function () {
    _this.measureElementCache.forEach(_this.observer.observe);
    return function () {
      _this.observer.disconnect();
      _this.cleanup();
    };
  };
  this._willUpdate = function () {
    var scrollElement = _this.options.getScrollElement();
    if (_this.scrollElement !== scrollElement) {
      _this.cleanup();
      _this.scrollElement = scrollElement;
      _this._scrollToOffset(_this.scrollOffset, {
        adjustments: undefined,
        behavior: undefined
      });
      _this.unsubs.push(_this.options.observeElementRect(_this, function (rect) {
        var prev = _this.scrollRect;
        _this.scrollRect = rect;
        if (_this.options.horizontal ? rect.width !== prev.width : rect.height !== prev.height) {
          _this.maybeNotify();
        }
      }));
      _this.unsubs.push(_this.options.observeElementOffset(_this, function (offset) {
        _this.scrollAdjustments = 0;
        if (_this.scrollOffset === offset) {
          return;
        }
        if (_this.isScrollingTimeoutId !== null) {
          clearTimeout(_this.isScrollingTimeoutId);
          _this.isScrollingTimeoutId = null;
        }
        _this.isScrolling = true;
        _this.scrollDirection = _this.scrollOffset < offset ? 'forward' : 'backward';
        _this.scrollOffset = offset;
        _this.maybeNotify();
        _this.isScrollingTimeoutId = setTimeout(function () {
          _this.isScrollingTimeoutId = null;
          _this.isScrolling = false;
          _this.scrollDirection = null;
          _this.maybeNotify();
        }, _this.options.scrollingDelay);
      }));
    }
  };
  this.getSize = function () {
    return _this.scrollRect[_this.options.horizontal ? 'width' : 'height'];
  };
  this.memoOptions = memo(function () {
    return [_this.options.count, _this.options.paddingStart, _this.options.scrollMargin, _this.options.getItemKey];
  }, function (count, paddingStart, scrollMargin, getItemKey) {
    _this.pendingMeasuredCacheIndexes = [];
    return {
      count: count,
      paddingStart: paddingStart,
      scrollMargin: scrollMargin,
      getItemKey: getItemKey
    };
  }, {
    key: false
  });
  this.getFurthestMeasurement = function (measurements, index) {
    var furthestMeasurementsFound = new Map();
    var furthestMeasurements = new Map();
    for (var m = index - 1; m >= 0; m--) {
      var measurement = measurements[m];
      if (furthestMeasurementsFound.has(measurement.lane)) {
        continue;
      }
      var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
      if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
        furthestMeasurements.set(measurement.lane, measurement);
      } else if (measurement.end < previousFurthestMeasurement.end) {
        furthestMeasurementsFound.set(measurement.lane, true);
      }
      if (furthestMeasurementsFound.size === _this.options.lanes) {
        break;
      }
    }
    return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function (a, b) {
      return a.end - b.end;
    })[0] : undefined;
  };
  this.getMeasurements = memo(function () {
    return [_this.memoOptions(), _this.itemSizeCache];
  }, function (_ref4, itemSizeCache) {
    var count = _ref4.count,
      paddingStart = _ref4.paddingStart,
      scrollMargin = _ref4.scrollMargin,
      getItemKey = _ref4.getItemKey;
    var min = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _this.pendingMeasuredCacheIndexes) : 0;
    _this.pendingMeasuredCacheIndexes = [];
    var measurements = _this.measurementsCache.slice(0, min);
    for (var _i2 = min; _i2 < count; _i2++) {
      var key = getItemKey(_i2);
      var furthestMeasurement = _this.options.lanes === 1 ? measurements[_i2 - 1] : _this.getFurthestMeasurement(measurements, _i2);
      var start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
      var measuredSize = itemSizeCache.get(key);
      var size = typeof measuredSize === 'number' ? measuredSize : _this.options.estimateSize(_i2);
      var end = start + size;
      var lane = furthestMeasurement ? furthestMeasurement.lane : _i2 % _this.options.lanes;
      measurements[_i2] = {
        index: _i2,
        start: start,
        size: size,
        end: end,
        key: key,
        lane: lane
      };
    }
    _this.measurementsCache = measurements;
    return measurements;
  }, {
    key: process.env.NODE_ENV !== 'production' && 'getMeasurements',
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.calculateRange = memo(function () {
    return [_this.getMeasurements(), _this.getSize(), _this.scrollOffset];
  }, function (measurements, outerSize, scrollOffset) {
    return _this.range = calculateRange({
      measurements: measurements,
      outerSize: outerSize,
      scrollOffset: scrollOffset
    });
  }, {
    key: process.env.NODE_ENV !== 'production' && 'calculateRange',
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.maybeNotify = memo(function () {
    var range = _this.calculateRange();
    return [range.startIndex, range.endIndex, _this.isScrolling];
  }, function () {
    _this.notify();
  }, {
    key: process.env.NODE_ENV !== 'production' && 'maybeNotify',
    debug: function debug() {
      return _this.options.debug;
    },
    initialDeps: [this.range.startIndex, this.range.endIndex, this.isScrolling]
  });
  this.getIndexes = memo(function () {
    return [_this.options.rangeExtractor, _this.calculateRange(), _this.options.overscan, _this.options.count];
  }, function (rangeExtractor, range, overscan, count) {
    return rangeExtractor(_extends({}, range, {
      overscan: overscan,
      count: count
    }));
  }, {
    key: process.env.NODE_ENV !== 'production' && 'getIndexes',
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.indexFromElement = function (node) {
    var attributeName = _this.options.indexAttribute;
    var indexStr = node.getAttribute(attributeName);
    if (!indexStr) {
      console.warn("Missing attribute name '" + attributeName + "={index}' on measured element.");
      return -1;
    }
    return parseInt(indexStr, 10);
  };
  this._measureElement = function (node, entry) {
    var _this$itemSizeCache$g;
    var index = _this.indexFromElement(node);
    var item = _this.measurementsCache[index];
    if (!item) {
      return;
    }
    var prevNode = _this.measureElementCache.get(item.key);
    if (!node.isConnected) {
      _this.observer.unobserve(node);
      if (node === prevNode) {
        _this.measureElementCache["delete"](item.key);
      }
      return;
    }
    if (prevNode !== node) {
      if (prevNode) {
        _this.observer.unobserve(prevNode);
      }
      _this.observer.observe(node);
      _this.measureElementCache.set(item.key, node);
    }
    var measuredItemSize = _this.options.measureElement(node, entry, _this);
    var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) != null ? _this$itemSizeCache$g : item.size;
    var delta = measuredItemSize - itemSize;
    if (delta !== 0) {
      if (item.start < _this.scrollOffset) {
        if (process.env.NODE_ENV !== 'production' && _this.options.debug) {
          console.info('correction', delta);
        }
        _this._scrollToOffset(_this.scrollOffset, {
          adjustments: _this.scrollAdjustments += delta,
          behavior: undefined
        });
      }
      _this.pendingMeasuredCacheIndexes.push(index);
      _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, measuredItemSize));
      _this.notify();
    }
  };
  this.measureElement = function (node) {
    if (!node) {
      return;
    }
    _this._measureElement(node, undefined);
  };
  this.getVirtualItems = memo(function () {
    return [_this.getIndexes(), _this.getMeasurements()];
  }, function (indexes, measurements) {
    var virtualItems = [];
    for (var k = 0, len = indexes.length; k < len; k++) {
      var _i3 = indexes[k];
      var measurement = measurements[_i3];
      virtualItems.push(measurement);
    }
    return virtualItems;
  }, {
    key: process.env.NODE_ENV !== 'production' && 'getIndexes',
    debug: function debug() {
      return _this.options.debug;
    }
  });
  this.getVirtualItemForOffset = function (offset) {
    var measurements = _this.getMeasurements();
    return notUndefined(measurements[findNearestBinarySearch(0, measurements.length - 1, function (index) {
      return notUndefined(measurements[index]).start;
    }, offset)]);
  };
  this.getOffsetForAlignment = function (toOffset, align) {
    var size = _this.getSize();
    if (align === 'auto') {
      if (toOffset <= _this.scrollOffset) {
        align = 'start';
      } else if (toOffset >= _this.scrollOffset + size) {
        align = 'end';
      } else {
        align = 'start';
      }
    }
    if (align === 'start') {
      toOffset = toOffset;
    } else if (align === 'end') {
      toOffset = toOffset - size;
    } else if (align === 'center') {
      toOffset = toOffset - size / 2;
    }
    var scrollSizeProp = _this.options.horizontal ? 'scrollWidth' : 'scrollHeight';
    var scrollSize = _this.scrollElement ? 'document' in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
    var maxOffset = scrollSize - _this.getSize();
    return Math.max(Math.min(maxOffset, toOffset), 0);
  };
  this.getOffsetForIndex = function (index, align) {
    if (align === void 0) {
      align = 'auto';
    }
    index = Math.max(0, Math.min(index, _this.options.count - 1));
    var measurement = notUndefined(_this.getMeasurements()[index]);
    if (align === 'auto') {
      if (measurement.end >= _this.scrollOffset + _this.getSize() - _this.options.scrollPaddingEnd) {
        align = 'end';
      } else if (measurement.start <= _this.scrollOffset + _this.options.scrollPaddingStart) {
        align = 'start';
      } else {
        return [_this.scrollOffset, align];
      }
    }
    var toOffset = align === 'end' ? measurement.end + _this.options.scrollPaddingEnd : measurement.start - _this.options.scrollPaddingStart;
    return [_this.getOffsetForAlignment(toOffset, align), align];
  };
  this.isDynamicMode = function () {
    return _this.measureElementCache.size > 0;
  };
  this.cancelScrollToIndex = function () {
    if (_this.scrollToIndexTimeoutId !== null) {
      clearTimeout(_this.scrollToIndexTimeoutId);
      _this.scrollToIndexTimeoutId = null;
    }
  };
  this.scrollToOffset = function (toOffset, _temp) {
    var _ref5 = _temp === void 0 ? {} : _temp,
      _ref5$align = _ref5.align,
      align = _ref5$align === void 0 ? 'start' : _ref5$align,
      behavior = _ref5.behavior;
    _this.cancelScrollToIndex();
    if (behavior === 'smooth' && _this.isDynamicMode()) {
      console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
    }
    _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
      adjustments: undefined,
      behavior: behavior
    });
  };
  this.scrollToIndex = function (index, _temp2) {
    var _ref6 = _temp2 === void 0 ? {} : _temp2,
      _ref6$align = _ref6.align,
      initialAlign = _ref6$align === void 0 ? 'auto' : _ref6$align,
      behavior = _ref6.behavior;
    index = Math.max(0, Math.min(index, _this.options.count - 1));
    _this.cancelScrollToIndex();
    if (behavior === 'smooth' && _this.isDynamicMode()) {
      console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
    }
    var _this$getOffsetForInd = _this.getOffsetForIndex(index, initialAlign),
      toOffset = _this$getOffsetForInd[0],
      align = _this$getOffsetForInd[1];
    _this._scrollToOffset(toOffset, {
      adjustments: undefined,
      behavior: behavior
    });
    if (behavior !== 'smooth' && _this.isDynamicMode()) {
      _this.scrollToIndexTimeoutId = setTimeout(function () {
        _this.scrollToIndexTimeoutId = null;
        var elementInDOM = _this.measureElementCache.has(_this.options.getItemKey(index));
        if (elementInDOM) {
          var _this$getOffsetForInd2 = _this.getOffsetForIndex(index, align),
            _toOffset = _this$getOffsetForInd2[0];
          if (!approxEqual(_toOffset, _this.scrollOffset)) {
            _this.scrollToIndex(index, {
              align: align,
              behavior: behavior
            });
          }
        } else {
          _this.scrollToIndex(index, {
            align: align,
            behavior: behavior
          });
        }
      });
    }
  };
  this.scrollBy = function (delta, _temp3) {
    var _ref7 = _temp3 === void 0 ? {} : _temp3,
      behavior = _ref7.behavior;
    _this.cancelScrollToIndex();
    if (behavior === 'smooth' && _this.isDynamicMode()) {
      console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
    }
    _this._scrollToOffset(_this.scrollOffset + delta, {
      adjustments: undefined,
      behavior: behavior
    });
  };
  this.getTotalSize = function () {
    var _this$getMeasurements;
    return (((_this$getMeasurements = _this.getMeasurements()[_this.options.count - 1]) == null ? void 0 : _this$getMeasurements.end) || _this.options.paddingStart) - _this.options.scrollMargin + _this.options.paddingEnd;
  };
  this._scrollToOffset = function (offset, _ref8) {
    var adjustments = _ref8.adjustments,
      behavior = _ref8.behavior;
    _this.options.scrollToFn(offset, {
      behavior: behavior,
      adjustments: adjustments
    }, _this);
  };
  this.measure = function () {
    _this.itemSizeCache = new Map();
    _this.notify();
  };
  this.setOptions(_opts);
  this.scrollRect = this.options.initialRect;
  this.scrollOffset = this.options.initialOffset;
  this.measurementsCache = this.options.initialMeasurementsCache;
  this.measurementsCache.forEach(function (item) {
    _this.itemSizeCache.set(item.key, item.size);
  });
  this.maybeNotify();
};
var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange(_ref9) {
  var measurements = _ref9.measurements,
    outerSize = _ref9.outerSize,
    scrollOffset = _ref9.scrollOffset;
  var count = measurements.length - 1;
  var getOffset = function getOffset(index) {
    return measurements[index].start;
  };
  var startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
  var endIndex = startIndex;
  while (endIndex < count && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return {
    startIndex: startIndex,
    endIndex: endIndex
  };
}

/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

//

var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? React$1.useLayoutEffect : React$1.useEffect;
function useVirtualizerBase(options) {
  var rerender = React$1.useReducer(function () {
    return {};
  }, {})[1];
  var resolvedOptions = _extends$1({}, options, {
    onChange: function onChange(instance) {
      rerender();
      options.onChange == null ? void 0 : options.onChange(instance);
    }
  });
  var _React$useState = React$1.useState(function () {
      return new Virtualizer(resolvedOptions);
    }),
    instance = _React$useState[0];
  instance.setOptions(resolvedOptions);
  React$1.useEffect(function () {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect(function () {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options) {
  return useVirtualizerBase(_extends$1({
    observeElementRect: observeElementRect,
    observeElementOffset: observeElementOffset,
    scrollToFn: elementScroll
  }, options));
}

const SECURITY_CONTEXT$5 = SecurityContext.DistributionOrder;
const PERMISSION_DASHBOARD_READ = "Web_Dashboard_Read";
const PERMISSION_DASHBOARD_FILTER = "Web_Dashboard_Filter";
const PERMISSION_DASHBOARD_SORT = "Web_Dashboard_Sort";
const PERMISSION_DASHBOARD_SEARCH = "Web_Dashboard_Search";
const permissions$5 = {
  [SECURITY_CONTEXT$5]: [
    PERMISSION_DASHBOARD_READ,
    PERMISSION_DASHBOARD_FILTER,
    PERMISSION_DASHBOARD_SORT,
    PERMISSION_DASHBOARD_SEARCH
  ]
};
function hasOrdersDashboardPermission(auth) {
  return permissions$5[SECURITY_CONTEXT$5].reduce((accum, curr) => {
    return accum ? accum : auth.userHasPermission(SECURITY_CONTEXT$5, curr);
  }, false);
}

var __defProp$p = Object.defineProperty;
var __defProps$l = Object.defineProperties;
var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$p.call(b, prop))
      __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(b)) {
      if (__propIsEnum$p.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$l = (a, b) => __defProps$l(a, __getOwnPropDescs$l(b));
var __objRest$d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING$1 = "";
const initialFilters$5 = {
  company: null,
  branch: null,
  country: null,
  reference: null,
  status: null,
  sortBy: null,
  search: null
};
const TransitionUp = forwardRef(function Transition(props, ref) {
  return /* @__PURE__ */ jsx(Slide, __spreadValues$p({ direction: "up", ref }, props));
});
const TransitionLeft = forwardRef(function Transition2(props, ref) {
  return /* @__PURE__ */ jsx(Slide, __spreadValues$p({ direction: "left", ref }, props));
});
function DesktopDashboardFilters$1({
  hasSortPermission = false,
  queryKey
}) {
  const { watch, resetField, setValue, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();
  const company = watch("company");
  const onFilterApply = () => {
    setValue("search", null);
    document.dispatchEvent(
      strictCustomEvent(ClearSearchStateEvent, {
        detail: null
      })
    );
    handleSubmit(noop$6)();
    if (queryKey) {
      queryClient.invalidateQueries([...queryKey]);
    }
  };
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, alignItems: "center", children: [
    /* @__PURE__ */ jsx(Grid$3, { item: true, md: 10, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "company",
          params: {
            systemName: "CoreContact",
            additionalFilter: "Customer"
          },
          placeholder: "Company"
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "branch",
          params: {
            systemName: "CustomerBranch",
            additionalFilter: {
              parentContactID: company == null ? void 0 : company.id
            }
          },
          placeholder: "Branch"
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "country",
          params: {
            systemName: "LocationByContactType",
            additionalFilter: {
              locationType: ["Country"]
            }
          },
          placeholder: "Country"
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsx(FormInput, { name: "reference", placeholder: "Reference" }) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "status",
          params: {
            systemName: "StatusByEventName"
          },
          placeholder: "Status"
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: 2, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => {
              const options = { defaultValue: null };
              resetField("company", options);
              resetField("branch", options);
              resetField("country", options);
              resetField("reference", options);
              resetField("status", options);
            },
            children: "Clear"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            variant: "outlined",
            color: "primary",
            sx: {
              backgroundColor: (theme) => theme.palette.common.white
            },
            onClick: onFilterApply,
            children: "Apply"
          }
        )
      ] }) })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 6, md: 2, display: "flex", justifyContent: "flex-end", children: hasSortPermission && /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: "sortBy",
        params: {
          systemName: "OrderSortBy"
        },
        placeholder: "Sort by",
        style: { width: "220px" }
      }
    ) })
  ] });
}
function MobileSelectedFilter({ value }) {
  return /* @__PURE__ */ jsx(
    Typography$1,
    {
      lineHeight: 1,
      variant: "button",
      sx: {
        minHeight: "14px"
      },
      children: value == null ? void 0 : value.name
    }
  );
}
const MobileFilterList = forwardRef(({ name, params }, ref) => {
  const EMPTY_STRING2 = "";
  const [{ data, isLoading }] = useLookupQuery(params);
  const { getValues, setValue } = useFormContext();
  const options = useMemo(() => {
    var _a;
    return (_a = data == null ? void 0 : data.data.results) != null ? _a : [];
  }, [data]);
  const [inputValue, setInputValue] = useState(EMPTY_STRING2);
  const { getRootProps, getInputProps, getOptionProps, groupedOptions, value } = useAutocomplete({
    open: true,
    blurOnSelect: true,
    options,
    value: getValues(name),
    inputValue,
    getOptionLabel: (option) => option.name,
    onChange: (_, value2) => setValue(name, value2),
    onInputChange: (e, value2, reason) => {
      if (e) {
        e.stopPropagation();
      }
      setInputValue(reason === "input" ? value2 : EMPTY_STRING2);
    }
  });
  return /* @__PURE__ */ jsxs(Box$1, __spreadProps$l(__spreadValues$p({ ref, flexGrow: 1, display: "flex", flexDirection: "column", gap: 4, overflow: "hidden" }, getRootProps()), { children: [
    /* @__PURE__ */ jsx(Box$1, { flexGrow: 0, paddingX: 4, gap: 8, children: /* @__PURE__ */ jsx(
      TextField$1,
      {
        fullWidth: true,
        variant: "standard",
        inputProps: getInputProps(),
        size: "small",
        color: "primary",
        placeholder: uc_first(name)
      }
    ) }),
    /* @__PURE__ */ jsxs(Box$1, { flexGrow: 1, display: "flex", flexDirection: "column", overflow: "scroll", children: [
      isLoading && /* @__PURE__ */ jsx(Box$1, { height: "100%", display: "flex", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsx(CircularProgress$1, {}) }),
      !isLoading && groupedOptions.length <= 0 && /* @__PURE__ */ jsx(Box$1, { paddingX: 4, paddingY: 8, children: /* @__PURE__ */ jsx(Typography$1, { textAlign: "center", children: "No results" }) }),
      groupedOptions.map((option, index) => /* @__PURE__ */ jsxs(React__default$1.Fragment, { children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          __spreadProps$l(__spreadValues$p({}, getOptionProps({ option, index })), {
            component: "li",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingX: 4,
            paddingY: 3,
            sx: {
              listStyle: "none"
            },
            children: [
              /* @__PURE__ */ jsx(Typography$1, { children: option.name }),
              (value == null ? void 0 : value.id) === option.id && /* @__PURE__ */ jsx(Check, {})
            ]
          })
        ),
        index < groupedOptions.length - 1 && /* @__PURE__ */ jsx(Box$1, { paddingX: 4, children: /* @__PURE__ */ jsx(Divider$1, { flexItem: true }) })
      ] }, option.id))
    ] })
  ] }));
});
function MobileDashboardFilters({ open, setOpen }) {
  const theme = useTheme$2();
  const { setValue, watch } = useFormContext();
  const [intent, setIntent] = useState("fields");
  const [filterListProps, setFilterListProps] = useState(null);
  const company = watch("company");
  const branch = watch("branch");
  const country = watch("country");
  const reference = watch("reference");
  const status = watch("status");
  const onFilterApply = () => {
    setOpen(false);
    setIntent("fields");
    setFilterListProps(null);
    setValue("search", null);
    document.dispatchEvent(
      strictCustomEvent(ClearSearchStateEvent, {
        detail: null
      })
    );
  };
  return createPortal(
    /* @__PURE__ */ jsx(
      Dialog$1,
      {
        fullWidth: true,
        keepMounted: true,
        open,
        TransitionComponent: TransitionUp,
        onClose: () => {
          setOpen(false);
          setFilterListProps(null);
          setIntent("fields");
        },
        sx: {
          ".MuiDialog-container": {
            alignItems: "flex-end"
          },
          ".MuiDialog-paper": {
            margin: 0,
            maxWidth: "100%",
            width: "100%",
            overflowX: "hidden",
            maxHeight: "100%",
            height: "calc(100% - 3.5rem)",
            borderRadius: "12px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px"
          }
        },
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", height: "100%", children: [
          /* @__PURE__ */ jsxs(Box$1, { flexGrow: 0, padding: 4, display: "flex", alignItems: "center", justifyContent: "space-between", children: [
            /* @__PURE__ */ jsx(
              IconButton,
              {
                onClick: () => {
                  if (intent === "list") {
                    setIntent("fields");
                    setFilterListProps(null);
                  }
                  if (intent === "fields") {
                    setOpen(false);
                  }
                },
                children: /* @__PURE__ */ jsx(ArrowBackIosNew, {})
              }
            ),
            /* @__PURE__ */ jsx(Typography$1, { variant: "h5", children: "Filter" }),
            /* @__PURE__ */ jsx(
              IconButton,
              {
                onClick: () => {
                  if (intent === "fields") {
                    setValue("company", null);
                    setValue("branch", null);
                    setValue("country", null);
                    setValue("reference", null);
                    setValue("status", null);
                  }
                  if (intent === "list" && filterListProps) {
                    setValue(filterListProps.name, null);
                  }
                },
                children: /* @__PURE__ */ jsx(Typography$1, { children: "Clear" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx(Box$1, { flexGrow: 1, marginTop: 8, overflow: "scroll", children: /* @__PURE__ */ jsx(Container$1, { disableGutters: true, maxWidth: "sm", sx: { height: "100%" }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 8, height: "100%", overflow: "hidden", children: [
            intent === "fields" && /* @__PURE__ */ jsx(TransitionLeft, { appear: true, in: true, children: /* @__PURE__ */ jsxs(Box$1, { flexGrow: 1, display: "flex", flexDirection: "column", children: [
              /* @__PURE__ */ jsxs(
                Box$1,
                {
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  paddingY: 3,
                  paddingX: 4,
                  onClick: () => {
                    setFilterListProps({
                      name: "company",
                      params: {
                        systemName: "CoreContact",
                        additionalFilter: "Customer"
                      }
                    });
                    setIntent("list");
                  },
                  children: [
                    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
                      /* @__PURE__ */ jsx(
                        FormLabel,
                        {
                          sx: {
                            color: (theme2) => theme2.palette.common.black,
                            fontWeight: (theme2) => theme2.typography.subtitle1
                          },
                          children: "Company"
                        }
                      ),
                      /* @__PURE__ */ jsx(KeyboardArrowRightSharp, {})
                    ] }),
                    /* @__PURE__ */ jsx(MobileSelectedFilter, { value: company })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Divider$1, {}),
              /* @__PURE__ */ jsxs(
                Box$1,
                {
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  paddingY: 3,
                  paddingX: 4,
                  onClick: () => {
                    setFilterListProps({
                      name: "branch",
                      params: {
                        systemName: "CustomerBranch",
                        additionalFilter: {
                          parentContactID: company == null ? void 0 : company.id
                        }
                      }
                    });
                    setIntent("list");
                  },
                  children: [
                    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
                      /* @__PURE__ */ jsx(
                        FormLabel,
                        {
                          sx: {
                            color: (theme2) => theme2.palette.common.black,
                            fontWeight: (theme2) => theme2.typography.subtitle1
                          },
                          children: "Branch"
                        }
                      ),
                      /* @__PURE__ */ jsx(KeyboardArrowRightSharp, {})
                    ] }),
                    /* @__PURE__ */ jsx(MobileSelectedFilter, { value: branch })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Divider$1, {}),
              /* @__PURE__ */ jsxs(
                Box$1,
                {
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  paddingY: 3,
                  paddingX: 4,
                  onClick: () => {
                    setFilterListProps({
                      name: "country",
                      params: {
                        systemName: "LocationByContactType",
                        additionalFilter: {
                          locationType: ["Country"]
                        }
                      }
                    });
                    setIntent("list");
                  },
                  children: [
                    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
                      /* @__PURE__ */ jsx(
                        FormLabel,
                        {
                          sx: {
                            color: (theme2) => theme2.palette.common.black,
                            fontWeight: (theme2) => theme2.typography.subtitle1
                          },
                          children: "Country"
                        }
                      ),
                      /* @__PURE__ */ jsx(KeyboardArrowRightSharp, {})
                    ] }),
                    /* @__PURE__ */ jsx(MobileSelectedFilter, { value: country })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Divider$1, {}),
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 0.5, paddingY: 3, children: [
                /* @__PURE__ */ jsx(Box$1, { paddingX: 4, children: /* @__PURE__ */ jsx(
                  FormLabel,
                  {
                    sx: {
                      color: (theme2) => theme2.palette.common.black,
                      fontWeight: (theme2) => theme2.typography.subtitle1
                    },
                    children: "Reference"
                  }
                ) }),
                /* @__PURE__ */ jsx(
                  TextField$1,
                  {
                    fullWidth: true,
                    variant: "standard",
                    size: "small",
                    color: "primary",
                    value: defaultValue(reference, EMPTY_STRING$1),
                    onChange: (e) => {
                      const input = e.target.value;
                      const value = input.trim() === EMPTY_STRING$1 ? null : input;
                      setValue("reference", value);
                    },
                    sx: {
                      "& .MuiInput-root": {
                        fontSize: "0.875rem",
                        paddingX: theme.spacing(4),
                        "&::before": {
                          borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                        }
                      },
                      "& .MuiInput-input": {
                        height: "1em",
                        paddingBottom: theme.spacing(3)
                      }
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs(
                Box$1,
                {
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  paddingY: 3,
                  paddingX: 4,
                  onClick: () => {
                    setFilterListProps({
                      name: "status",
                      params: {
                        systemName: "StatusByEventName"
                      }
                    });
                    setIntent("list");
                  },
                  children: [
                    /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
                      /* @__PURE__ */ jsx(
                        FormLabel,
                        {
                          sx: {
                            color: (theme2) => theme2.palette.common.black,
                            fontWeight: (theme2) => theme2.typography.subtitle1
                          },
                          children: "Status"
                        }
                      ),
                      /* @__PURE__ */ jsx(KeyboardArrowRightSharp, {})
                    ] }),
                    /* @__PURE__ */ jsx(MobileSelectedFilter, { value: status })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Divider$1, {})
            ] }) }),
            intent === "list" && filterListProps && /* @__PURE__ */ jsx(TransitionLeft, { appear: true, in: true, children: /* @__PURE__ */ jsx(MobileFilterList, __spreadValues$p({}, filterListProps)) })
          ] }) }) }),
          /* @__PURE__ */ jsx(Box$1, { flexGrow: 0, padding: 4, marginBottom: 4, children: /* @__PURE__ */ jsx(Container$1, { disableGutters: true, maxWidth: "sm", children: /* @__PURE__ */ jsx(
            Button,
            {
              type: "submit",
              form: "filter-form",
              variant: "contained",
              color: "primary",
              sx: { width: "100%" },
              onClick: onFilterApply,
              children: "Apply"
            }
          ) }) })
        ] })
      }
    ),
    document.body
  );
}
function MobileSortByFilter({ open, setOpen }) {
  const { control, resetField } = useFormContext();
  const [{ data }] = useLookupQuery({
    systemName: "OrderSortBy"
  });
  return createPortal(
    /* @__PURE__ */ jsx(
      Dialog$1,
      {
        fullWidth: true,
        keepMounted: true,
        open,
        TransitionComponent: TransitionUp,
        onClose: () => setOpen(false),
        sx: {
          ".MuiDialog-container": {
            alignItems: "flex-end"
          },
          ".MuiDialog-paper": {
            margin: 0,
            maxWidth: "100%",
            width: "100%",
            maxHeight: "100%",
            height: "auto",
            borderRadius: "12px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px"
          }
        },
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 8, height: "100%", children: [
          /* @__PURE__ */ jsxs(Box$1, { flexGrow: 0, padding: 4, display: "flex", alignItems: "center", justifyContent: "space-between", children: [
            /* @__PURE__ */ jsx(IconButton, { onClick: () => setOpen(false), children: /* @__PURE__ */ jsx(ArrowBackIosNew, {}) }),
            /* @__PURE__ */ jsx(Typography$1, { variant: "h5", children: "Sort By" }),
            /* @__PURE__ */ jsx(IconButton, { onClick: () => resetField("sortBy"), children: /* @__PURE__ */ jsx(FormLabel, { children: "Clear" }) })
          ] }),
          /* @__PURE__ */ jsx(Box$1, { flexGrow: 1, display: "flex", flexDirection: "column", marginBottom: 16, children: /* @__PURE__ */ jsx(
            Controller,
            {
              control,
              name: "sortBy",
              defaultValue: null,
              render: ({ field: { onChange, value } }) => {
                var _a;
                return /* @__PURE__ */ jsx(
                  RadioGroup,
                  {
                    value: (_a = value == null ? void 0 : value.id) != null ? _a : null,
                    onChange: (e) => {
                      var _a2;
                      return onChange((_a2 = data == null ? void 0 : data.data.results.find((x) => x.id === e.target.value)) != null ? _a2 : null);
                    },
                    children: /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: data && data.data.results.map((item) => /* @__PURE__ */ jsxs(
                      Box$1,
                      {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingX: 8,
                        children: [
                          /* @__PURE__ */ jsx(
                            FormLabel,
                            {
                              htmlFor: item.id,
                              sx: {
                                flexGrow: 1,
                                color: (theme) => theme.palette.common.black,
                                fontWeight: (theme) => theme.typography.subtitle1
                              },
                              children: item.name
                            }
                          ),
                          /* @__PURE__ */ jsx(Radio, { id: item.id, value: item.id, sx: { padding: 0 } })
                        ]
                      },
                      item.id
                    )) })
                  }
                );
              }
            }
          ) })
        ] })
      }
    ),
    document.body
  );
}
function NoResults({ handheldBreakpoint = false }) {
  return /* @__PURE__ */ jsx(Card, { sx: { boxShadow: "none", marginTop: handheldBreakpoint ? 4 : 0 }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, paddingY: 16, children: [
    /* @__PURE__ */ jsx(SearchSharp, { fontSize: "large" }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(Typography$1, { variant: "h5", children: "No results found" }),
      /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", children: "Try adjusting your search criteria" })
    ] })
  ] }) });
}
function OrdersDashboard() {
  var _a, _b, _c, _d, _e;
  const auth = useAuth();
  const hasFilterPermission = auth.userHasPermission(SecurityContext.DistributionOrder, PERMISSION_DASHBOARD_FILTER);
  const hasSortPermission = auth.userHasPermission(SecurityContext.DistributionOrder, PERMISSION_DASHBOARD_SORT);
  const hasSearchPermission = auth.userHasPermission(SecurityContext.DistributionOrder, PERMISSION_DASHBOARD_SEARCH);
  const unrestricted = auth.userHasPermission("restrictByAssociation", "False");
  const theme = useTheme$2();
  const tabletBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = !mobileBreakpoint && !tabletBreakpoint;
  const paddingX = tabletBreakpoint ? 4 : 12;
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [mobileSortByOpen, setMobileSortByOpen] = useState(false);
  const storageKey = `${window.btoa(auth.user.userName)}_orders-dashboard`;
  const filtersKey = `${storageKey}_filters`;
  const sortByKey = `${storageKey}_sort`;
  const searchKey = `${storageKey}_search`;
  const defaultParse = "{}";
  const storedFilterValues = JSON.parse((_a = window.localStorage.getItem(filtersKey)) != null ? _a : defaultParse);
  const storedSortValue = JSON.parse((_b = window.sessionStorage.getItem(sortByKey)) != null ? _b : defaultParse);
  const storedSearchValue = JSON.parse((_c = window.sessionStorage.getItem(searchKey)) != null ? _c : defaultParse);
  const defaultValues = Object.assign(initialFilters$5, storedFilterValues, storedSortValue, storedSearchValue);
  const [context, Form] = useForm({
    defaultValues
  });
  const sortBy = context.watch("sortBy");
  const search = context.watch("search");
  useEffect(() => {
    const listener = (e) => context.setValue("search", e.detail);
    document.addEventListener(SearchEvent, listener);
    return () => document.removeEventListener(SearchEvent, listener);
  }, []);
  useEffect(() => {
    const _a2 = context.getValues(), { sortBy: sortBy2, search: search2 } = _a2, values = __objRest$d(_a2, ["sortBy", "search"]);
    window.localStorage.setItem(filtersKey, JSON.stringify(values));
    window.sessionStorage.setItem(sortByKey, JSON.stringify({ sortBy: sortBy2 }));
    window.sessionStorage.setItem(searchKey, JSON.stringify({ search: search2 }));
  }, [context.formState.submitCount, sortBy, search]);
  const selectFilterRequired = useMemo(() => {
    if (unrestricted) {
      const { company, branch, country, reference, status, search: searchFilter } = context.getValues();
      const allValuesNull = [company, branch, country, reference, status, sortBy, searchFilter].every(
        (value) => value === null || value === void 0
      );
      return allValuesNull;
    }
    return false;
  }, [context.formState.submitCount, search]);
  const queryParameters = useMemo(
    () => {
      var _a2, _b2, _c2, _d2, _e2, _f, _g, _h, _i;
      return {
        customerID: (_b2 = (_a2 = context.getValues("company")) == null ? void 0 : _a2.id) != null ? _b2 : null,
        branchID: (_d2 = (_c2 = context.getValues("branch")) == null ? void 0 : _c2.id) != null ? _d2 : null,
        countryID: (_f = (_e2 = context.getValues("country")) == null ? void 0 : _e2.id) != null ? _f : null,
        reference: context.getValues("reference"),
        status: (_h = (_g = context.getValues("status")) == null ? void 0 : _g.id) != null ? _h : null,
        sortByID: (_i = sortBy == null ? void 0 : sortBy.id) != null ? _i : null,
        searchTerm: search
      };
    },
    [context.formState.submitCount, sortBy, search]
  );
  const [{ isFetching, isError, data, error }, dashboardGridQueryKey] = useGridQuery(
    {
      systemName: "Order",
      parameters: queryParameters
    },
    { cacheTime: 0, enabled: !selectFilterRequired }
  );
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count: (_e = (_d = data == null ? void 0 : data.data) == null ? void 0 : _d.rows.length) != null ? _e : 0,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 200,
    paddingStart: tabletBreakpoint ? 16 : 0
  });
  if (isError) {
    if (error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        error.message
      ] });
    }
  }
  return /* @__PURE__ */ jsx(Form, { id: "filter-form", style: { height: "100%" }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", height: "100%", overflow: "hidden", children: [
    /* @__PURE__ */ jsx(
      Box$1,
      {
        flexGrow: 0,
        display: "flex",
        flexDirection: tabletBreakpoint && !hasFilterPermission ? "row-reverse" : "row",
        alignItems: "center",
        gap: 4,
        bgcolor: "background.paper",
        paddingY: 4,
        paddingX,
        children: tabletBreakpoint ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Box$1, { flexBasis: "20%", flexGrow: mobileBreakpoint ? 1 : 0, children: hasFilterPermission && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outlined",
                sx: { width: "100%" },
                onClick: () => setMobileFiltersOpen(true),
                children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 1, children: [
                  /* @__PURE__ */ jsx(FilterListOutlined, { fontSize: "small" }),
                  /* @__PURE__ */ jsx(Typography$1, { children: "Filter" })
                ] })
              }
            ),
            /* @__PURE__ */ jsx(
              MobileDashboardFilters,
              {
                open: mobileFiltersOpen,
                setOpen: setMobileFiltersOpen
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx(Box$1, { flexBasis: "20%", flexGrow: mobileBreakpoint ? 1 : 0, children: hasSortPermission && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outlined",
                sx: { width: "100%" },
                onClick: () => setMobileSortByOpen(true),
                children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 1, children: [
                  /* @__PURE__ */ jsx(SortOutlined, { fontSize: "small" }),
                  /* @__PURE__ */ jsx(Typography$1, { children: "Sort By" })
                ] })
              }
            ),
            /* @__PURE__ */ jsx(MobileSortByFilter, { open: mobileSortByOpen, setOpen: setMobileSortByOpen })
          ] }) })
        ] }) : /* @__PURE__ */ jsxs(Box$1, { flexGrow: 1, display: "flex", gap: 4, alignItems: "center", paddingTop: 2, children: [
          /* @__PURE__ */ jsx(Box$1, { flexGrow: 1, children: /* @__PURE__ */ jsx(Typography$1, { variant: "h4", sx: { fontWeight: 600, lineHeight: 1 }, children: /* @__PURE__ */ jsx("span", { children: "Orders Dashboard" }) }) }),
          hasSearchPermission && /* @__PURE__ */ jsx(Box$1, { flex: "0 1 300px", children: /* @__PURE__ */ jsx(Search, {}) }),
          hasSortPermission && !hasFilterPermission && /* @__PURE__ */ jsx(Box$1, { flex: "0 1 220px", children: /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "sortBy",
              params: {
                systemName: "OrderSortBy"
              },
              placeholder: "Sort by"
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ jsxs(
      Box$1,
      {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        sx: {
          backgroundColor: "secondary.main",
          paddingX
        },
        children: [
          !tabletBreakpoint && hasFilterPermission && /* @__PURE__ */ jsx(
            Box$1,
            {
              flexGrow: 0,
              sx: {
                paddingY: theme.spacing(4)
              },
              children: /* @__PURE__ */ jsx(
                DesktopDashboardFilters$1,
                {
                  hasSortPermission,
                  queryKey: dashboardGridQueryKey
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs(
            Box$1,
            {
              ref: virtualizerRef,
              flexGrow: 1,
              height: "0px",
              marginTop: !hasFilterPermission && isDesktop ? 4 : 0,
              marginBottom: 4,
              paddingX: "4px",
              sx: {
                overflowY: "auto"
              },
              children: [
                isFetching && /* @__PURE__ */ jsx(Loader, {}),
                selectFilterRequired && /* @__PURE__ */ jsx(Box$1, { position: "relative", children: /* @__PURE__ */ jsx(Card, { sx: { boxShadow: "none" }, children: /* @__PURE__ */ jsxs(
                  Box$1,
                  {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    paddingY: 16,
                    children: [
                      /* @__PURE__ */ jsx(SearchSharp, { fontSize: "large" }),
                      /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
                        /* @__PURE__ */ jsx(Typography$1, { variant: "h5", children: "No results found" }),
                        /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", children: "Please select at least 1 filter" })
                      ] })
                    ]
                  }
                ) }) }),
                !selectFilterRequired && /* @__PURE__ */ jsx(
                  Box$1,
                  {
                    position: "relative",
                    height: `${virtualizer.getTotalSize()}px`,
                    sx: {
                      "& > div:not(:last-of-type)": {
                        paddingBottom: theme.spacing(4)
                      },
                      "& > div:last-of-type": {
                        paddingBottom: "2px"
                        // box-shadow
                      }
                    },
                    children: data && data.data.rows.length ? virtualizer.getVirtualItems().map((item) => /* @__PURE__ */ jsx(
                      Box$1,
                      {
                        "data-index": item.index,
                        ref: virtualizer.measureElement,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        sx: {
                          transform: `translateY(${item.start}px)`
                        },
                        children: /* @__PURE__ */ jsx(OrderCard, { order: data.data.rows[item.index] })
                      },
                      item.key
                    )) : /* @__PURE__ */ jsx(Fragment, { children: !isFetching && /* @__PURE__ */ jsx(NoResults, { handheldBreakpoint: tabletBreakpoint }) })
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] }) });
}

const OrdersDashboardMenuItem = {
  label: "Orders",
  path: "/Orders",
  securityContext: SecurityContext.Menu,
  securityContextPermission: "Web_DistributionOrder_Dashboard"
};

var __defProp$o = Object.defineProperty;
var __defProps$k = Object.defineProperties;
var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$k = (a, b) => __defProps$k(a, __getOwnPropDescs$k(b));
var __objRest$c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EMPTY_STRING = "";
const checkboxIcon$2 = /* @__PURE__ */ jsx(CheckBoxOutlineBlank, { fontSize: "small" });
const checkboxCheckedIcon$2 = /* @__PURE__ */ jsx(CheckBox, { fontSize: "small" });
const Context$d = createContext({});
const shipmentGridColumns = (props) => {
  const href = defaultValue(props.hyperlinkRef, (_, id) => `/Shipment/${id}`);
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  return [
    {
      field: "isWatchlisted",
      flex: 0,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      maxWidth: 50,
      type: "boolean",
      renderHeader: () => /* @__PURE__ */ jsx(Star, {}),
      renderCell: ({
        row
      }) => {
        var _a;
        return /* @__PURE__ */ jsx(
          WatchlistIcon,
          {
            objectID: row.id,
            objectType: "Job",
            isWatchlisted: (_a = state == null ? void 0 : state.edits[row.id]) != null ? _a : row.isWatchlisted,
            onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: row } })
          }
        );
      }
    },
    {
      field: "reference",
      flex: 1,
      headerName: "SHIPMENT",
      hideable: false,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalShipment", row.id), children: value }) })
    },
    {
      field: "orderDetails",
      flex: 1,
      headerName: "ORDER",
      renderCell: ({
        value
      }) => {
        try {
          const orderDetails = JSON.parse(value || "");
          if (Array.isArray(orderDetails)) {
            return orderDetails.map((detail, index) => {
              return /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalOrder", detail.orderId), children: detail.orderNumber }) }),
                index !== orderDetails.length - 1 ? /* @__PURE__ */ jsx(Fragment, { children: ",\xA0" }) : null
              ] });
            });
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    },
    {
      field: "jobModeName",
      flex: 1,
      headerName: "MODE",
      maxWidth: 150,
      renderCell: ({
        row,
        value
      }) => {
        const Icon = shipmentModeIconMap[row.jobMode];
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [
          Icon ? /* @__PURE__ */ jsx(Icon, { fontSize: "small", color: "primary", sx: { opacity: 0.8 } }) : "",
          value
        ] }) });
      }
    },
    {
      field: "service",
      flex: 1,
      headerName: "SERVICE"
    },
    {
      field: "status",
      flex: 1,
      headerName: "STATUS",
      renderCell: ({
        value
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
        Box,
        {
          paddingY: 1,
          paddingX: 2,
          bgcolor: "primary.main",
          borderRadius: (theme) => theme.shape.borderRadius,
          textAlign: "center",
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              fontSize: "0.75rem",
              lineHeight: 1,
              color: (theme) => theme.palette.common.white,
              textTransform: "uppercase",
              children: value
            }
          )
        }
      ) })
    },
    {
      field: "consignor",
      flex: 1,
      headerName: "SUPPLIER"
    },
    {
      field: "consignee",
      flex: 1,
      headerName: "CONSIGNEE"
    },
    {
      field: "origin",
      flex: 1,
      headerName: "ORIGIN",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.originCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: combinedCode.slice(0, 2) }),
          value
        ] }) });
      }
    },
    {
      field: "destination",
      flex: 1,
      headerName: "DESTINATION",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.destinationCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: `${combinedCode.slice(0, 2)}` }),
          value
        ] }) });
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      maxWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      maxWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "voyage",
      flex: 1,
      headerName: "VESSEL / FLIGHT",
      valueGetter: ({
        value,
        row
      }) => {
        const mode = row.jobMode;
        const vessel = row.vessel;
        return mode === SystemName.ShipmentMode.Sea && vessel && value ? `${vessel} - ${value}` : value;
      }
    }
  ];
};
const orderGridColumns = (props) => {
  const href = defaultValue(props.hyperlinkRef, (_, id) => `/Order/${id}`);
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  return [
    {
      field: "isWatchlisted",
      flex: 0,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      maxWidth: 50,
      type: "boolean",
      renderHeader: () => /* @__PURE__ */ jsx(Star, {}),
      renderCell: ({
        row
      }) => {
        var _a;
        return /* @__PURE__ */ jsx(
          WatchlistIcon,
          {
            objectID: row.id,
            objectType: "Job",
            isWatchlisted: (_a = state == null ? void 0 : state.edits[row.id]) != null ? _a : row.isWatchlisted,
            onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: row } })
          }
        );
      }
    },
    {
      field: "orderNumber",
      flex: 1,
      headerName: "ORDER",
      hideable: false,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalOrder", row.id), children: value }) })
    },
    {
      field: "shipmentDetails",
      flex: 1,
      headerName: "SHIPMENT",
      renderCell: ({
        value
      }) => {
        try {
          const details = JSON.parse(value || "");
          if (Array.isArray(details)) {
            const shipmentDetail = details[0];
            console.log("shipmentDetail:", shipmentDetail);
            return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalShipment", shipmentDetail.shipmentId), children: shipmentDetail.shipmentReference }) });
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    },
    {
      field: "otherReference",
      flex: 1,
      headerName: "OTHER REFERENCE"
    },
    {
      field: "jobModeName",
      flex: 1,
      headerName: "MODE",
      renderCell: ({
        row,
        value
      }) => {
        const Icon = shipmentModeIconMap[row.jobMode];
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [
          Icon ? /* @__PURE__ */ jsx(Icon, { fontSize: "small", color: "primary", sx: { opacity: 0.8 } }) : "",
          value
        ] }) });
      }
    },
    {
      field: "status",
      flex: 1,
      headerName: "STATUS",
      renderCell: ({ value }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
        Box,
        {
          paddingY: 1,
          paddingX: 2,
          bgcolor: "primary.main",
          borderRadius: (theme) => theme.shape.borderRadius,
          textAlign: "center",
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              fontSize: "0.75rem",
              lineHeight: 1,
              color: (theme) => theme.palette.common.white,
              textTransform: "uppercase",
              children: value
            }
          )
        }
      ) })
    },
    {
      field: "expectedReady",
      flex: 1,
      headerName: "ESTIMATED CARGO READY",
      type: "datetime",
      valueGetter: ({
        value
      }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "consignor",
      flex: 1,
      headerName: "SUPPLIER"
    },
    {
      field: "consignee",
      flex: 1,
      headerName: "CONSIGNEE"
    },
    {
      field: "origin",
      flex: 1,
      headerName: "ORIGIN",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.originCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: combinedCode.slice(0, 2) }),
          value
        ] }) });
      }
    },
    {
      field: "destination",
      flex: 1,
      headerName: "DESTINATION",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.destinationCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: `${combinedCode.slice(0, 2)}` }),
          value
        ] }) });
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      maxWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      maxWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    }
  ];
};
const containerGridColumns = (props) => {
  const href = defaultValue(props.hyperlinkRef, (_, id) => `/Container/${id}`);
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  return [
    {
      field: "isWatchlisted",
      flex: 0,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      maxWidth: 50,
      type: "boolean",
      renderHeader: () => /* @__PURE__ */ jsx(Star, {}),
      renderCell: ({
        row
      }) => {
        var _a;
        return /* @__PURE__ */ jsx(
          WatchlistIcon,
          {
            objectID: row.id,
            objectType: "Container",
            isWatchlisted: (_a = state == null ? void 0 : state.edits[row.id]) != null ? _a : row.isWatchlisted,
            onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: row } })
          }
        );
      }
    },
    {
      field: "containerNumber",
      flex: 1,
      headerName: "CONTAINER",
      hideable: false,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalContainer", row.id), children: value }) })
    },
    {
      field: "shipmentDetails",
      flex: 1,
      headerName: "SHIPMENT",
      renderCell: ({
        value
      }) => {
        try {
          const shipmentDetails = JSON.parse(value || "");
          if (Array.isArray(shipmentDetails)) {
            return shipmentDetails.map((detail, index) => {
              return /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalShipment", detail.shipmentId), children: detail.shipmentReference }) }),
                index !== shipmentDetails.length - 1 ? /* @__PURE__ */ jsx(Fragment, { children: ",\xA0" }) : null
              ] });
            });
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    },
    {
      field: "orderDetails",
      flex: 1,
      headerName: "ORDER",
      renderCell: ({
        value
      }) => {
        try {
          const orderDetails = JSON.parse(value || "");
          if (Array.isArray(orderDetails)) {
            return orderDetails.map((detail, index) => {
              return /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href("PortalOrder", detail.orderId), children: detail.orderNumber }) }),
                index !== orderDetails.length - 1 ? /* @__PURE__ */ jsx(Fragment, { children: ",\xA0" }) : null
              ] });
            });
          }
          return null;
        } catch (e) {
          return null;
        }
      }
    },
    {
      field: "service",
      flex: 1,
      headerName: "SERVICE"
    },
    {
      field: "status",
      flex: 1,
      headerName: "STATUS",
      renderCell: ({
        value
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
        Box,
        {
          paddingY: 1,
          paddingX: 2,
          bgcolor: "primary.main",
          borderRadius: (theme) => theme.shape.borderRadius,
          textAlign: "center",
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              fontSize: "0.75rem",
              lineHeight: 1,
              color: (theme) => theme.palette.common.white,
              textTransform: "uppercase",
              children: value
            }
          )
        }
      ) })
    },
    {
      field: "consignor",
      flex: 1,
      headerName: "SUPPLIER"
    },
    {
      field: "consignee",
      flex: 1,
      headerName: "CONSIGNEE"
    },
    {
      field: "origin",
      flex: 1,
      headerName: "ORIGIN",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.originCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: combinedCode.slice(0, 2) }),
          value
        ] }) });
      }
    },
    {
      field: "destination",
      flex: 1,
      headerName: "DESTINATION",
      renderCell: ({
        value,
        row
      }) => {
        const combinedCode = row.destinationCombinedCode;
        return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
          combinedCode && /* @__PURE__ */ jsx(Flag, { country: `${combinedCode.slice(0, 2)}` }),
          value
        ] }) });
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      maxWidth: 200,
      type: "datetime",
      valueGetter: ({
        value
      }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      maxWidth: 200,
      type: "datetime",
      valueGetter: ({
        value
      }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD MMM YYYY") : null
    },
    {
      field: "voyage",
      flex: 1,
      headerName: "VESSEL",
      valueGetter: ({
        value,
        row
      }) => {
        const mode = row.shipmentMode;
        const vessel = row.vessel;
        return mode === SystemName.ShipmentMode.Sea && vessel && value ? `${vessel} - ${value}` : value;
      }
    }
  ];
};
const portalShipmentConstruct = {
  gridColumns: shipmentGridColumns,
  listItem: ShipmentListItem,
  blockFilters: ShipmentBlockFilters
};
const portalOrderConstruct = {
  gridColumns: orderGridColumns,
  listItem: OrderListItem,
  blockFilters: OrderBlockFilters
};
const portalContainerConstruct = {
  gridColumns: containerGridColumns,
  listItem: ContainerListItem,
  blockFilters: ContainerBlockFilters
};
const resourceConstructs = {
  PortalShipment: portalShipmentConstruct,
  PortalOrder: portalOrderConstruct,
  PortalContainer: portalContainerConstruct
};
const initialResourceTypeState = {
  type: "PortalShipment",
  grid: {
    systemName: "ShipmentDashboardGrid",
    additionalFilter: void 0
  }
};
const resourceTypeReducer = (state, action) => {
  switch (action.type) {
    case "SET_RESOURCE_TYPE":
      return __spreadProps$k(__spreadValues$o({}, state), { type: action.payload });
    case "SET_RESOURCE_GRID_SYSTEMNAME":
      return __spreadProps$k(__spreadValues$o({}, state), { grid: action.payload });
    default:
      return state;
  }
};
const initialWatchlistState$2 = {
  editCount: 0,
  edits: {}
};
const getWatchlistEdits$2 = (watchlist, data) => {
  var _a;
  let editCount = (_a = watchlist == null ? void 0 : watchlist.editCount) != null ? _a : 0;
  editCount += data.isWatchlisted ? 1 : -1;
  return { editCount, edits: __spreadProps$k(__spreadValues$o({}, watchlist == null ? void 0 : watchlist.edits), { [data.original.id]: data.isWatchlisted }) };
};
const watchlistReducer$2 = (state, action) => {
  switch (action.type) {
    case "WATCHLIST_RESET":
      return { editCount: 0, edits: {} };
    case "WATCHLIST_EDIT":
      return getWatchlistEdits$2(state, action.payload);
    default:
      return state;
  }
};
const initialFilters$4 = {
  active: 1,
  mode: [],
  cargoType: [],
  departureFrom: null,
  departureTo: null,
  arrivalFrom: null,
  arrivalTo: null,
  origin: [],
  destination: [],
  consignor: [],
  consignee: [],
  requiredIntoStoreFrom: null,
  requiredIntoStoreTo: null,
  expectedReadyFrom: null,
  expectedReadyTo: null,
  etaDelay: null,
  shipmentStatus: [],
  containerStatus: []
};
function StatusControl({ shouldUnregister }) {
  const theme = useTheme$2();
  const { form } = useContext(Context$d);
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control: form.control,
      shouldUnregister,
      name: "active",
      render: ({ field: { value, onChange } }) => /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 3, children: [
        /* @__PURE__ */ jsxs(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              columnGap: theme.spacing(1),
              cursor: "pointer"
            },
            children: [
              /* @__PURE__ */ jsx(
                Radio,
                {
                  name: "active",
                  value: "all",
                  checked: value === null,
                  size: "small",
                  sx: { padding: 0 },
                  onChange: () => onChange(null)
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "All" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              columnGap: theme.spacing(1),
              cursor: "pointer"
            },
            children: [
              /* @__PURE__ */ jsx(
                Radio,
                {
                  name: "active",
                  value: "all",
                  checked: value === 1,
                  size: "small",
                  sx: { padding: 0 },
                  onChange: () => onChange(1)
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Active" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              columnGap: theme.spacing(1),
              cursor: "pointer"
            },
            children: [
              /* @__PURE__ */ jsx(
                Radio,
                {
                  name: "active",
                  value: 0,
                  checked: value === 0,
                  size: "small",
                  sx: { padding: 0 },
                  onChange: () => onChange(0)
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Closed" })
            ]
          }
        )
      ] })
    }
  );
}
function ResourceTypeControl() {
  const theme = useTheme$2();
  const {
    resourceType: [{ type }, dispatch],
    watchlist: [_, watchlistDispatch]
  } = useContext(Context$d);
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 3, children: [
    /* @__PURE__ */ jsxs(
      "label",
      {
        style: {
          display: "flex",
          alignItems: "center",
          columnGap: theme.spacing(1),
          cursor: "pointer"
        },
        children: [
          /* @__PURE__ */ jsx(
            Radio,
            {
              name: "resourceType",
              value: "PortalShipment",
              checked: type === "PortalShipment",
              size: "small",
              sx: { padding: 0 },
              onChange: () => {
                dispatch({ type: "SET_RESOURCE_TYPE", payload: "PortalShipment" });
                dispatch({
                  type: "SET_RESOURCE_GRID_SYSTEMNAME",
                  payload: {
                    systemName: "ShipmentDashboardGrid",
                    additionalFilter: void 0
                  }
                });
                watchlistDispatch({ type: "WATCHLIST_RESET", payload: null });
              }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Shipments" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "label",
      {
        style: {
          display: "flex",
          alignItems: "center",
          columnGap: theme.spacing(1),
          cursor: "pointer"
        },
        children: [
          /* @__PURE__ */ jsx(
            Radio,
            {
              name: "resourceType",
              value: "PortalOrder",
              checked: type === "PortalOrder",
              size: "small",
              sx: { padding: 0 },
              onChange: () => {
                dispatch({ type: "SET_RESOURCE_TYPE", payload: "PortalOrder" });
                dispatch({
                  type: "SET_RESOURCE_GRID_SYSTEMNAME",
                  payload: {
                    systemName: "PortalOrderDashboardGrid",
                    additionalFilter: void 0
                  }
                });
                watchlistDispatch({ type: "WATCHLIST_RESET", payload: null });
              }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Orders" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "label",
      {
        style: {
          display: "flex",
          alignItems: "center",
          columnGap: theme.spacing(1),
          cursor: "pointer"
        },
        children: [
          /* @__PURE__ */ jsx(
            Radio,
            {
              name: "resourceType",
              value: "PortalContainer",
              checked: type === "PortalContainer",
              size: "small",
              sx: { padding: 0 },
              onChange: () => {
                dispatch({ type: "SET_RESOURCE_TYPE", payload: "PortalContainer" });
                dispatch({
                  type: "SET_RESOURCE_GRID_SYSTEMNAME",
                  payload: {
                    systemName: "PortalContainerDashboardGrid",
                    additionalFilter: void 0
                  }
                });
                watchlistDispatch({ type: "WATCHLIST_RESET", payload: null });
              }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Containers" })
        ]
      }
    )
  ] });
}
function FormDelayFilterControl$1({
  name,
  label,
  delay = 3,
  shouldUnregister
}) {
  const theme = useTheme$2();
  const { control, watch } = useFormContext();
  const value = watch(name);
  const [checked, setChecked] = useState(value !== null);
  const [error, setError] = useState(false);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value != null ? value : delay);
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      shouldUnregister,
      name,
      render: ({ field: { onChange } }) => /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(
          Checkbox$1,
          {
            id: `${name}_checkbox`,
            name: `${name}_checkbox`,
            size: "small",
            sx: { padding: 0 },
            value: checked,
            onChange: (e) => {
              const value2 = e.target.checked;
              const error2 = value2 && !inputValue;
              setChecked(value2);
              setError(error2);
              if (!error2) {
                onChange(value2 ? inputValue : null);
              }
            }
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ jsx(
            "label",
            {
              htmlFor: `${name}_checkbox`,
              style: { display: "flex", alignItems: "center", width: "calc(100% - 2rem)" },
              children: /* @__PURE__ */ jsx(
                Typography,
                {
                  noWrap: true,
                  fontSize: "small",
                  lineHeight: "1.1",
                  sx: { display: "inline-block", cursor: "pointer" },
                  children: label
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            NumberInput,
            {
              value: defaultValue(inputValue == null ? void 0 : inputValue.toString(), EMPTY_STRING),
              error,
              sx: {
                ".MuiInputBase-root": {
                  padding: "4px 8px !important",
                  fontSize: "0.85rem"
                }
              },
              onChange: (input) => {
                const value2 = input.trim();
                const output = value2 === EMPTY_STRING ? null : +value2;
                const error2 = checked && !output;
                setInputValue(output);
                setError(error2);
                if (checked && !error2) {
                  onChange(output);
                }
              },
              onKeyDown: (e) => {
                var _a, _b;
                if (e.key === "ArrowUp") {
                  e.preventDefault();
                  const len = defaultValue(inputValue == null ? void 0 : inputValue.toString().length, 0);
                  (_a = inputRef.current) == null ? void 0 : _a.setSelectionRange(len, len);
                  (_b = inputRef.current) == null ? void 0 : _b.focus();
                }
              },
              onKeyUp: (e) => {
                let output = inputValue;
                if (e.key === "ArrowUp") {
                  output = output ? ++output : 1;
                  setInputValue(output);
                  setError(false);
                  if (checked) {
                    onChange(output);
                  }
                }
                if (e.key === "ArrowDown") {
                  output = output ? Math.max(output - 1, 0) : 0;
                  setInputValue(output);
                  setError(false);
                  if (checked) {
                    onChange(output);
                  }
                }
              },
              InputProps: {
                inputRef,
                endAdornment: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                  /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 0.5, children: [
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        display: "flex",
                        alignItems: "flex-start",
                        alignSelf: "stretch",
                        height: "8px",
                        sx: {
                          backgroundColor: theme.palette.grey[200],
                          borderRadius: "2px",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: theme.palette.grey[300]
                          }
                        },
                        onClick: (e) => {
                          e.preventDefault();
                          let output = inputValue;
                          output = output ? ++output : 1;
                          setInputValue(output);
                          setError(false);
                          if (checked) {
                            onChange(output);
                          }
                        },
                        children: /* @__PURE__ */ jsx(
                          "svg",
                          {
                            focusable: false,
                            "aria-hidden": "true",
                            height: "8px",
                            width: "20px",
                            viewBox: "0 0 16 16",
                            children: /* @__PURE__ */ jsx("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" })
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        display: "flex",
                        alignItems: "flex-end",
                        alignSelf: "stretch",
                        height: "8px",
                        sx: {
                          backgroundColor: theme.palette.grey[200],
                          borderRadius: "2px",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: theme.palette.grey[300]
                          }
                        },
                        onClick: (e) => {
                          e.preventDefault();
                          let output = inputValue;
                          output = output ? Math.max(output - 1, 0) : 0;
                          setInputValue(output);
                          setError(false);
                          if (checked) {
                            onChange(output);
                          }
                        },
                        children: /* @__PURE__ */ jsx(
                          "svg",
                          {
                            focusable: false,
                            "aria-hidden": "true",
                            height: "8px",
                            width: "20px",
                            viewBox: "0 0 16 16",
                            style: { transform: "rotate(180deg)" },
                            children: /* @__PURE__ */ jsx("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" })
                          }
                        )
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      fontSize: "0.8rem",
                      lineHeight: "0.8rem",
                      color: theme.palette.grey[500],
                      sx: { minWidth: "4ch" },
                      children: inflect("Day", defaultValue(inputValue, 0))
                    }
                  )
                ] })
              }
            }
          )
        ] })
      ] })
    }
  );
}
const Filters$2 = memo$1(function Filters2() {
  const {
    form,
    resourceType: [state]
  } = useContext(Context$d);
  const [etaDelayKey, setEtaDelayKey] = useState(`eta_${v4()}`);
  const lookupRenderOption = (props, option, { selected }) => /* @__PURE__ */ createElement("li", __spreadProps$k(__spreadValues$o({}, props), { key: v4() }), /* @__PURE__ */ jsx(
    Checkbox$1,
    {
      icon: checkboxIcon$2,
      checkedIcon: checkboxCheckedIcon$2,
      style: { marginRight: 8 },
      checked: selected
    }
  ), /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.9rem", children: option.name }));
  const lookupSx = {
    ".MuiInputBase-root > input": {
      padding: "4px 8px !important"
    },
    ".MuiAutocomplete-input": {
      fontSize: "0.85rem"
    },
    ".MuiButtonBase-root.MuiChip-root": {
      height: "inherit",
      maxWidth: "calc(60% - 6px)",
      ".MuiSvgIcon-root": {
        margin: 0
      }
    }
  };
  const datePickerSlotProps = (placeholder) => ({
    textField: {
      size: "small",
      placeholder,
      inputProps: {
        sx: {
          padding: 0
        }
      },
      sx: {
        "& .MuiInputBase-root": { padding: "4px 8px", fontSize: "0.85rem" }
      }
    },
    openPickerButton: {
      size: "small",
      color: "primary",
      sx: { padding: 0, "& .MuiSvgIcon-root": { fontSize: "inherit" } }
    }
  });
  const datePickerTransform = {
    input: (value) => value ? removeTimezoneOffset(value) : null,
    output: (value) => value ? removeTimezoneOffset(value) : null
  };
  const departureFrom = form.watch("departureFrom");
  const departureTo = form.watch("departureTo");
  const arrivalFrom = form.watch("arrivalFrom");
  const arrivalTo = form.watch("arrivalTo");
  const requiredIntoStoreFrom = form.watch("requiredIntoStoreFrom");
  const requiredIntoStoreTo = form.watch("requiredIntoStoreTo");
  const expectedReadyFrom = form.watch("expectedReadyFrom");
  const expectedReadyTo = form.watch("expectedReadyTo");
  const statusSystemNames = [
    SystemName.Status.BookingInProgress,
    SystemName.Status.ShipmentBookedWithCarrier,
    SystemName.Status.GoodsReadyAtSupplier,
    SystemName.Status.GoodsDispatchedAtSupplier,
    SystemName.Status.GoodsInInternationalTransit,
    SystemName.Status.GoodsArrivedAtTranshipmentPort,
    SystemName.Status.GoodsInInternationalTransitToDestination,
    SystemName.Status.GoodsCustomsClearedAtDestination,
    SystemName.Status.GoodsArrivedAtDestination,
    SystemName.Status.GoodsCustomsClearedAndArrivedAtDestination,
    SystemName.Status.GoodsBookedForDelivery,
    SystemName.Status.GoodsDelivered,
    SystemName.Status.EmptyContainerDehired
  ];
  const handleClearAll = () => {
    const _a = initialFilters$4, resetState = __objRest$c(_a, ["active"]);
    form.reset(__spreadValues$o({ active: form.getValues("active") }, resetState));
    setEtaDelayKey(`eta_${v4()}`);
  };
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontWeight: "bold", noWrap: true, children: "Filter By" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleClearAll, children: /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontSize: "small", noWrap: true, children: "Clear all" }) })
    ] }),
    state.type !== "PortalContainer" && /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.mode"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        params: {
          systemName: "Code",
          additionalFilter: { codeQualifier: "ShipmentMode" }
        },
        name: "mode",
        renderOption: (option) => {
          var _a, _b, _c;
          const Icon = (_b = shipmentModeIconMap) == null ? void 0 : _b[(_a = option.additionalData) == null ? void 0 : _a.code];
          return /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [
            Icon && /* @__PURE__ */ jsx(Icon, { color: "primary", fontSize: "small", sx: { opacity: 0.8 } }),
            /* @__PURE__ */ jsx(Typography, { fontSize: "small", sx: { cursor: "pointer" }, children: (_c = option.additionalData) == null ? void 0 : _c.code })
          ] }) });
        }
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.cargoType"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        estimateSize: 3,
        params: {
          systemName: "Code",
          additionalFilter: { codeQualifier: "CargoType" }
        },
        name: "cargoType"
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.departureDate"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "departureFrom",
          maxDate: defaultValue(departureTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "departureTo",
          minDate: defaultValue(departureFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.arrivalDate"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "arrivalFrom",
          maxDate: defaultValue(arrivalTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "arrivalTo",
          minDate: defaultValue(arrivalFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.origin"), children: /* @__PURE__ */ jsx(
      FormPortLocationLookup,
      {
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "origin",
        placeholder: "Search",
        sx: lookupSx
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.destination"), children: /* @__PURE__ */ jsx(
      FormPortLocationLookup,
      {
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "destination",
        placeholder: "Search",
        sx: lookupSx
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.supplier"), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        multiple: true,
        useSearchTerm: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "consignor",
        placeholder: "Search",
        params: {
          systemName: "PortalContact",
          maxResults: "250",
          additionalFilter: {
            contactType: SystemName.ContactType.Consignor
          }
        },
        renderOption: lookupRenderOption,
        sx: lookupSx
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.consignee"), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        multiple: true,
        useSearchTerm: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "consignee",
        placeholder: "Search",
        params: {
          systemName: "PortalContact",
          maxResults: "250",
          additionalFilter: {
            contactType: SystemName.ContactType.Consignee
          }
        },
        renderOption: lookupRenderOption,
        sx: lookupSx
      }
    ) }),
    state.type === "PortalOrder" && /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.expectedReady"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "expectedReadyFrom",
          maxDate: defaultValue(expectedReadyTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "expectedReadyTo",
          minDate: defaultValue(expectedReadyFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.requiredIntoStore"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "requiredIntoStoreFrom",
          maxDate: defaultValue(requiredIntoStoreTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "requiredIntoStoreTo",
          minDate: defaultValue(requiredIntoStoreFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.delays"), children: /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(FormDelayFilterControl$1, { name: "etaDelay", label: "ETA Delay" }, etaDelayKey) }) }),
    state.type === "PortalShipment" && /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.status"), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "shipmentStatus",
        placeholder: "Search",
        params: {
          systemName: "Status",
          additionalFilter: {
            type: ["Job"],
            systemNames: statusSystemNames
          }
        },
        renderOption: lookupRenderOption,
        sx: lookupSx
      }
    ) }),
    state.type === "PortalContainer" && /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("track.filters.status"), children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "containerStatus",
        placeholder: "Search",
        params: {
          systemName: "Status",
          additionalFilter: {
            type: ["Container"],
            systemNames: statusSystemNames
          }
        },
        renderOption: lookupRenderOption,
        sx: lookupSx
      }
    ) })
  ] });
});
function ShipmentBlockFilters() {
  var _a, _b, _c, _d, _e, _f, _g;
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const theme = useTheme$2();
  const {
    form,
    resourceType: [state, dispatch],
    watchlist: [watchlistState]
  } = useContext(Context$d);
  const [activeFilter, setActiveFilter] = useState(0);
  const values = form.watch();
  const filterParams = useMemo(
    () => produceQueryParameters(values, state, organisations),
    [values, state, organisations]
  );
  const additionalFilter = produceLookupFilters(filterParams);
  const notDepartedSystemName = "PortalShipmentNotDeparted";
  const inTransitSystemName = "PortalShipmentInTransit";
  const arrivingInDaysSystemName = "PortalShipmentArrivingInDays";
  const watchlistSystemName = "PortalShipmentWatchlist";
  const [total] = useLookupQuery({
    systemName: "PortalShipmentDashboard",
    additionalFilter
  });
  const [notDeparted] = useLookupQuery({
    systemName: notDepartedSystemName,
    additionalFilter
  });
  const [inTransit] = useLookupQuery({
    systemName: inTransitSystemName,
    additionalFilter
  });
  const [arrivingInDays] = useLookupQuery({
    systemName: arrivingInDaysSystemName,
    additionalFilter: produceLookupFilters(filterParams, { days: 7 })
  });
  const [watchlist] = useLookupQuery({
    systemName: watchlistSystemName,
    additionalFilter
  });
  const filters = [
    {
      title: "Total shipments",
      value: defaultValue((_a = total.data) == null ? void 0 : _a.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: total.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: "ShipmentDashboardGrid",
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Not yet departed",
      value: defaultValue((_b = notDeparted.data) == null ? void 0 : _b.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: notDeparted.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: notDepartedSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "In transit",
      value: defaultValue((_c = inTransit.data) == null ? void 0 : _c.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: inTransit.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: inTransitSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Arriving in 7 days",
      value: defaultValue((_d = arrivingInDays.data) == null ? void 0 : _d.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: arrivingInDays.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: arrivingInDaysSystemName,
          additionalFilter: { days: 7 }
        }
      })
    },
    {
      title: "Watchlist",
      value: defaultValue(
        ((_f = (_e = watchlist.data) == null ? void 0 : _e.data.totalResults) != null ? _f : 0) + ((_g = watchlistState == null ? void 0 : watchlistState.editCount) != null ? _g : 0),
        0
      ).toLocaleString(window.navigator.language),
      loading: watchlist.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: watchlistSystemName,
          additionalFilter: void 0
        }
      })
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: filters.map((filter, i) => {
    const isActiveFilter = activeFilter === i;
    return /* @__PURE__ */ jsx(
      BlockFilter,
      {
        active: isActiveFilter,
        title: filter.title,
        value: filter.value,
        loading: filter.loading,
        onClick: () => {
          setActiveFilter(i);
          filter.onClick();
        },
        sx: {
          borderRight: "1px solid",
          borderColor: i < filters.length - 1 ? theme.palette.grey[300] : "transparent"
        }
      },
      `shipments_${i}`
    );
  }) });
}
function OrderBlockFilters() {
  var _a, _b, _c, _d, _e, _f, _g;
  const theme = useTheme$2();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const {
    form,
    resourceType: [state, dispatch],
    watchlist: [watchlistState]
  } = useContext(Context$d);
  const [activeFilter, setActiveFilter] = useState(0);
  const values = form.watch();
  const filterParams = useMemo(
    () => produceQueryParameters(values, state, organisations),
    [values, state, organisations]
  );
  const additionalFilter = produceLookupFilters(filterParams);
  const unshippedSystemName = "PortalOrderUnshipped";
  const delayedSystemName = "PortalOrderDelayed";
  const readySystemName = "PortalOrderReady";
  const watchlistSystemName = "PortalOrderWatchlist";
  const [total] = useLookupQuery({
    systemName: "PortalOrderDashboard",
    additionalFilter
  });
  const [unshipped] = useLookupQuery({
    systemName: unshippedSystemName,
    additionalFilter
  });
  const [delayed] = useLookupQuery({
    systemName: delayedSystemName,
    additionalFilter
  });
  const [ready] = useLookupQuery({
    systemName: readySystemName,
    additionalFilter
  });
  const [watchlist] = useLookupQuery({
    systemName: watchlistSystemName,
    additionalFilter
  });
  const filters = [
    {
      title: "Total orders",
      value: defaultValue((_a = total.data) == null ? void 0 : _a.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: total.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: "PortalOrderDashboardGrid",
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Unshipped orders",
      value: defaultValue((_b = unshipped.data) == null ? void 0 : _b.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: unshipped.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: unshippedSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Late orders",
      value: defaultValue((_c = delayed.data) == null ? void 0 : _c.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: delayed.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: delayedSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Ready orders",
      value: defaultValue((_d = ready.data) == null ? void 0 : _d.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: ready.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: readySystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Watchlist",
      value: defaultValue(
        ((_f = (_e = watchlist.data) == null ? void 0 : _e.data.totalResults) != null ? _f : 0) + ((_g = watchlistState == null ? void 0 : watchlistState.editCount) != null ? _g : 0),
        0
      ).toLocaleString(window.navigator.language),
      loading: watchlist.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: watchlistSystemName,
          additionalFilter: void 0
        }
      })
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: filters.map((filter, i) => {
    const isActiveFilter = activeFilter === i;
    return /* @__PURE__ */ jsx(
      BlockFilter,
      {
        active: isActiveFilter,
        title: filter.title,
        value: filter.value,
        loading: filter.loading,
        onClick: () => {
          setActiveFilter(i);
          filter.onClick();
        },
        sx: {
          borderRight: "1px solid",
          borderColor: i < filters.length - 1 ? theme.palette.grey[300] : "transparent"
        }
      },
      `orders_${i}`
    );
  }) });
}
function ContainerBlockFilters() {
  var _a, _b, _c, _d, _e, _f, _g;
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const theme = useTheme$2();
  const {
    form,
    resourceType: [state, dispatch],
    watchlist: [watchlistState]
  } = useContext(Context$d);
  const [activeFilter, setActiveFilter] = useState(0);
  const values = form.watch();
  const filterParams = useMemo(
    () => produceQueryParameters(values, state, organisations),
    [values, state, organisations]
  );
  const additionalFilter = produceLookupFilters(filterParams);
  const notDepartedSystemName = "PortalContainerNotDeparted";
  const inTransitSystemName = "PortalContainerInTransit";
  const arrivingInDaysSystemName = "PortalContainerArrivingInDays";
  const watchlistSystemName = "PortalContainerWatchlist";
  const [total] = useLookupQuery({
    systemName: "PortalContainerDashboard",
    additionalFilter
  });
  const [notDeparted] = useLookupQuery({
    systemName: notDepartedSystemName,
    additionalFilter
  });
  const [inTransit] = useLookupQuery({
    systemName: inTransitSystemName,
    additionalFilter
  });
  const [arrivingInDays] = useLookupQuery({
    systemName: arrivingInDaysSystemName,
    additionalFilter: produceLookupFilters(filterParams, { days: 7 })
  });
  const [watchlist] = useLookupQuery({
    systemName: watchlistSystemName,
    additionalFilter
  });
  const filters = [
    {
      title: "Total containers",
      value: defaultValue((_a = total.data) == null ? void 0 : _a.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: total.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: "PortalContainerDashboardGrid",
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Not yet departed",
      value: defaultValue((_b = notDeparted.data) == null ? void 0 : _b.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: notDeparted.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: notDepartedSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "In transit",
      value: defaultValue((_c = inTransit.data) == null ? void 0 : _c.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: inTransit.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: inTransitSystemName,
          additionalFilter: void 0
        }
      })
    },
    {
      title: "Arriving in 7 days",
      value: defaultValue((_d = arrivingInDays.data) == null ? void 0 : _d.data.totalResults, 0).toLocaleString(window.navigator.language),
      loading: arrivingInDays.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: arrivingInDaysSystemName,
          additionalFilter: { days: 7 }
        }
      })
    },
    {
      title: "Watchlist",
      value: defaultValue(
        ((_f = (_e = watchlist.data) == null ? void 0 : _e.data.totalResults) != null ? _f : 0) + ((_g = watchlistState == null ? void 0 : watchlistState.editCount) != null ? _g : 0),
        0
      ).toLocaleString(window.navigator.language),
      loading: watchlist.isFetching,
      onClick: () => dispatch({
        type: "SET_RESOURCE_GRID_SYSTEMNAME",
        payload: {
          systemName: watchlistSystemName,
          additionalFilter: void 0
        }
      })
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: filters.map((filter, i) => {
    const isActiveFilter = activeFilter === i;
    return /* @__PURE__ */ jsx(
      BlockFilter,
      {
        active: isActiveFilter,
        title: filter.title,
        value: filter.value,
        loading: filter.loading,
        onClick: () => {
          setActiveFilter(i);
          filter.onClick();
        },
        sx: {
          borderRight: "1px solid",
          borderColor: i < filters.length - 1 ? theme.palette.grey[300] : "transparent"
        }
      },
      `conatiners_${i}`
    );
  }) });
}
function BlockFilters$2() {
  const theme = useTheme$2();
  const {
    resourceType: [{ type }]
  } = useContext(Context$d);
  const { blockFilters: Filters3 } = resourceConstructs[type];
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: /* @__PURE__ */ jsx(Filters3, {})
    }
  );
}
function VirtualizedList$1(_a) {
  var _b = _a, { gap = 4, listItem, listItemProps, sx } = _b, rest = __objRest$c(_b, ["gap", "listItem", "listItemProps", "sx"]);
  var _a2, _b2, _c;
  const theme = useTheme$2();
  const {
    query,
    resourceType: [{ type }]
  } = useContext(Context$d);
  const construct = resourceConstructs[type];
  const Item = defaultValue(listItem, construct.listItem);
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count: (_b2 = (_a2 = query.data) == null ? void 0 : _a2.data.rows.length) != null ? _b2 : 0,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 200
  });
  return /* @__PURE__ */ jsx(
    Box,
    __spreadProps$k(__spreadValues$o({
      ref: virtualizerRef,
      position: "relative",
      height: "0px",
      width: "100%"
    }, rest), {
      sx: __spreadValues$o({
        overflowY: "auto"
      }, sx),
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          height: `${virtualizer.getTotalSize()}px`,
          sx: {
            "& > div:not(:last-of-type)": {
              paddingBottom: theme.spacing(gap)
            }
          },
          children: [
            query.isFetching && /* @__PURE__ */ jsx(
              Loader,
              {
                sx: {
                  position: "absolute",
                  height: "100%",
                  top: 0 + virtualizer.scrollOffset
                }
              }
            ),
            ((_c = query.data) == null ? void 0 : _c.data.rows) && virtualizer.getVirtualItems().map((item) => /* @__PURE__ */ jsx(
              Box,
              {
                "data-index": item.index,
                ref: virtualizer.measureElement,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                sx: {
                  transform: `translateY(${item.start}px)`
                },
                children: /* @__PURE__ */ jsx(
                  Item,
                  __spreadProps$k(__spreadValues$o({}, listItemProps), {
                    data: (
                      // This is a dumb hack - intersecting the grid model types to shut it up
                      // But I'm not a Typescript guru yet... BMI
                      query.data.data.rows[item.index]
                    )
                  })
                )
              },
              item.key
            ))
          ]
        }
      )
    })
  );
}
function ShipmentListItem({ data, hyperlinkRef }) {
  var _a, _b;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  const href = defaultValue(hyperlinkRef, (_, id) => `/Shipment/${id}`);
  const mode = data.jobMode;
  const vessel = data.vessel;
  const voyage = data.voyage;
  const originCombinedCode = data.originCombinedCode;
  const destinationCombinedCode = data.destinationCombinedCode;
  const vesselFlight = mode === SystemName.ShipmentMode.Sea && vessel && voyage ? `${vessel} - ${voyage}` : voyage;
  const ModeIcon = shipmentModeIconMap[mode];
  const maxCssGridColCellWidth = `calc(165px - ${theme.spacing(2)})`;
  return /* @__PURE__ */ jsx(Fragment, { children: mobileBreakPoint ? /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      children: [
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", paddingX: 3, children: [
          /* @__PURE__ */ jsx(
            WatchlistIcon,
            {
              objectID: data.id,
              objectType: "Job",
              isWatchlisted: (_a = state == null ? void 0 : state.edits[data.id]) != null ? _a : data.isWatchlisted,
              onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: data } }),
              sx: { paddingLeft: 0 }
            }
          ),
          /* @__PURE__ */ jsx(
            Box,
            {
              paddingY: 1,
              paddingX: 2,
              bgcolor: "primary.main",
              borderRadius: theme.shape.borderRadius,
              textAlign: "center",
              children: /* @__PURE__ */ jsx(
                Typography,
                {
                  fontSize: "0.75rem",
                  lineHeight: 1,
                  color: theme.palette.common.white,
                  textTransform: "uppercase",
                  children: data.status
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 4,
            rowGap: 2,
            borderColor: theme.palette.grey[300],
            children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SHIPMENT" }),
                /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(
                  Hyperlink,
                  {
                    to: href("PortalShipment", data.id),
                    sx: {
                      marginTop: theme.spacing(1),
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    },
                    children: data.reference
                  }
                ) })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "MODE" }),
                /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                  ModeIcon && /* @__PURE__ */ jsx(ModeIcon, { color: "primary", sx: { opacity: 0.8, fontSize: "1.2rem" } }),
                  /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.jobModeName })
                ] })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { xs: 4, paddingBottom: 2 }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SUPPLIER" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, noWrap: true, children: data.consignor })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "CONSIGNEE" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, noWrap: true, children: data.consignee })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { xs: 4, paddingBottom: 2 }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ORIGIN" }),
                /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                  originCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${originCombinedCode.slice(0, 2)}` }),
                  /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.origin })
                ] })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "DESTINATION" }),
                /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                  destinationCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${destinationCombinedCode.slice(0, 2)}` }),
                  /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.destination })
                ] })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SERVICE" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, marginTop: 1, children: data.service })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETD" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, children: data.etd && dayjs(data.etd).format("DD MMM YYYY") })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETA" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, children: data.eta && dayjs(data.eta).format("DD MMM YYYY") })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "VESSEL / FLIGHT" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, noWrap: true, children: vesselFlight })
              ] }) })
            ] })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "grid",
            gridTemplateColumns: "50px minmax(0, 175px) minmax(0, 130px) minmax(0, 175px) minmax(0, 130px) repeat(7, minmax(0, 175px))",
            columnGap: 2,
            rowGap: 6,
            alignItems: "center",
            justifyItems: "start",
            padding: 6,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsx(
                WatchlistIcon,
                {
                  objectID: data.id,
                  objectType: "Job",
                  isWatchlisted: (_b = state == null ? void 0 : state.edits[data.id]) != null ? _b : data.isWatchlisted,
                  sx: { padding: "0px" },
                  onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: data } })
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SHIPMENT" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "MODE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SERVICE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "STATUS" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SUPPLIER" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "CONSIGNEE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ORIGIN" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "DESTINATION" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETD" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETA" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "VESSEL / FLIGHT" }),
              /* @__PURE__ */ jsx(Box, {}),
              /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(
                Hyperlink,
                {
                  to: href("PortalShipment", data.id),
                  sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: maxCssGridColCellWidth
                  },
                  children: data.reference
                }
              ) }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [
                ModeIcon && /* @__PURE__ */ jsx(ModeIcon, { color: "primary", fontSize: "small", sx: { opacity: 0.8 } }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    fontSize: "0.85rem",
                    lineHeight: "0.95rem",
                    noWrap: true,
                    maxWidth: maxCssGridColCellWidth,
                    children: data.jobModeName
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.service }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  paddingY: 1,
                  paddingX: 2,
                  bgcolor: "primary.main",
                  borderRadius: theme.shape.borderRadius,
                  textAlign: "center",
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      fontSize: "0.75rem",
                      lineHeight: 1,
                      color: theme.palette.common.white,
                      textTransform: "uppercase",
                      children: data.status
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignor }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignee }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                originCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${originCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    fontSize: "0.85rem",
                    lineHeight: "0.95rem",
                    noWrap: true,
                    maxWidth: maxCssGridColCellWidth,
                    children: data.origin
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                destinationCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${destinationCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    fontSize: "0.85rem",
                    lineHeight: "0.95rem",
                    noWrap: true,
                    maxWidth: maxCssGridColCellWidth,
                    children: data.destination
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.etd && dayjs(data.etd).format("DD MMM YYYY") }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.eta && dayjs(data.eta).format("DD MMM YYYY") }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: vesselFlight })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", padding: 4, children: [
          /* @__PURE__ */ jsx(Box, { flexGrow: 1 }),
          /* @__PURE__ */ jsx(Box, { flexGrow: 0, children: /* @__PURE__ */ jsx(Button$1, { variant: "contained", size: "small", disabled: true, children: "Arrange Transport" }) })
        ] })
      ]
    }
  ) });
}
function OrderListItem({ data, hyperlinkRef }) {
  var _a;
  const theme = useTheme$2();
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  const href = defaultValue(hyperlinkRef, (_, id) => `/Order/${id}`);
  const originCombinedCode = data.originCombinedCode;
  const destinationCombinedCode = data.destinationCombinedCode;
  const ModeIcon = shipmentModeIconMap[data.jobMode];
  const maxCssGridColCellWidth = `calc(225px - ${theme.spacing(2)})`;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "grid",
            gridTemplateColumns: "50px minmax(0, 175px) repeat(2, minmax(0, 130px)) repeat(5, minmax(0, 1fr))",
            columnGap: 2,
            rowGap: 6,
            alignItems: "center",
            justifyItems: "start",
            padding: 6,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsx(
                WatchlistIcon,
                {
                  objectID: data.id,
                  objectType: "Job",
                  isWatchlisted: (_a = state == null ? void 0 : state.edits[data.id]) != null ? _a : data.isWatchlisted,
                  sx: { padding: "0px" },
                  onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: data } })
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ORDER" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "MODE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "STATUS" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ESTIMATED CARGO READY" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SUPPLIER" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "CONSIGNEE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ORIGIN" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "DESTINATION" }),
              /* @__PURE__ */ jsx(Box, {}),
              /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(
                Hyperlink,
                {
                  to: href("PortalOrder", data.id),
                  sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: `calc(165px - ${theme.spacing(2)})`
                  },
                  children: data.orderNumber
                }
              ) }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [
                ModeIcon && /* @__PURE__ */ jsx(ModeIcon, { color: "primary", fontSize: "small", sx: { opacity: 0.8 } }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", children: data.jobModeName })
              ] }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  paddingY: 1,
                  paddingX: 2,
                  bgcolor: "primary.main",
                  borderRadius: theme.shape.borderRadius,
                  textAlign: "center",
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      fontSize: "0.75rem",
                      lineHeight: 1,
                      color: theme.palette.common.white,
                      textTransform: "uppercase",
                      children: data.status
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.expectedReady && dayjs(data.expectedReady).format("DD MMM YYYY") }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignor }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignee }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                originCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${originCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.origin })
              ] }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                destinationCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${destinationCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.destination })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", padding: 4, children: [
          /* @__PURE__ */ jsx(Box, { flexGrow: 1 }),
          /* @__PURE__ */ jsx(Box, { flexGrow: 0, children: /* @__PURE__ */ jsx(Button$1, { variant: "contained", size: "small", disabled: true, children: "Arrange Transport" }) })
        ] })
      ]
    }
  );
}
function ContainerListItem({ data, hyperlinkRef }) {
  var _a;
  const theme = useTheme$2();
  const {
    watchlist: [state, dispatch]
  } = useShipmentDashboardContext();
  const href = defaultValue(hyperlinkRef, (_, id) => `/Container/${id}`);
  const mode = data.shipmentMode;
  const vessel = data.vessel;
  const voyage = data.voyage;
  const originCombinedCode = data.originCombinedCode;
  const destinationCombinedCode = data.destinationCombinedCode;
  const vesselFlight = mode === SystemName.ShipmentMode.Sea && vessel && voyage ? `${vessel} - ${voyage}` : voyage;
  const maxCssGridColCellWidth = `calc(165px - ${theme.spacing(2)})`;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "grid",
            gridTemplateColumns: "50px repeat(2, minmax(0, 175px)) minmax(0, 130px) repeat(7, minmax(0, 175px))",
            columnGap: 6,
            rowGap: 6,
            alignItems: "center",
            justifyItems: "start",
            padding: 6,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsx(
                WatchlistIcon,
                {
                  objectID: data.id,
                  objectType: "Container",
                  isWatchlisted: (_a = state == null ? void 0 : state.edits[data.id]) != null ? _a : data.isWatchlisted,
                  sx: { padding: "0px" },
                  onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: data } })
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "CONTAINER" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SERVICE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "STATUS" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "SUPPLIER" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "CONSIGNEE" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ORIGIN" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "DESTINATION" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETD" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "ETA" }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "VESSEL" }),
              /* @__PURE__ */ jsx(Box, {}),
              /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(
                Hyperlink,
                {
                  to: href("PortalContainer", data.id),
                  sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: maxCssGridColCellWidth
                  },
                  children: data.containerNumber
                }
              ) }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.service }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  paddingY: 1,
                  paddingX: 2,
                  bgcolor: "primary.main",
                  borderRadius: theme.shape.borderRadius,
                  textAlign: "center",
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      fontSize: "0.75rem",
                      lineHeight: 1,
                      color: theme.palette.common.white,
                      textTransform: "uppercase",
                      children: data.status
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignor }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.consignee }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                originCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${originCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.origin })
              ] }),
              /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                destinationCombinedCode && /* @__PURE__ */ jsx(Flag, { country: `${destinationCombinedCode.slice(0, 2)}` }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.destination })
              ] }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.etd && dayjs(data.etd).format("DD MMM YYYY") }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: data.eta && dayjs(data.eta).format("DD MMM YYYY") }),
              /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.95rem", noWrap: true, maxWidth: maxCssGridColCellWidth, children: vesselFlight })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", padding: 4, children: [
          /* @__PURE__ */ jsx(Box, { flexGrow: 1 }),
          /* @__PURE__ */ jsx(Box, { flexGrow: 0, children: /* @__PURE__ */ jsx(Button$1, { variant: "contained", size: "small", disabled: true, children: "Arrange Transport" }) })
        ] })
      ]
    }
  );
}
function Grid$2(_c) {
  var _d = _c, { hyperlinkRef, components } = _d, props = __objRest$c(_d, ["hyperlinkRef", "components"]);
  var _a, _b;
  const theme = useTheme$2();
  const {
    query,
    resourceType: [{ type }]
  } = useContext(Context$d);
  const { gridColumns } = resourceConstructs[type];
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, () => /* @__PURE__ */ jsx(Fragment, {}));
  return /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ jsx(GridToolbar, {}),
    /* @__PURE__ */ jsx(
      DataGridPro,
      __spreadProps$k(__spreadValues$o({}, props), {
        columns: gridColumns({ hyperlinkRef }),
        rows: (_b = (_a = query.data) == null ? void 0 : _a.data.rows) != null ? _b : [],
        loading: query.isFetching,
        getRowId: (row) => row.id,
        hideFooter: true,
        checkboxSelection: true,
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "& .MuiDataGrid-row": {
            backgroundColor: theme.palette.common.white
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "white"
          },
          "& .MuiDataGrid-virtualScrollerContent": {
            backgroundColor: "white",
            overflow: "auto",
            scrollbarGutter: "stable"
          }
        }
      })
    )
  ] });
}
const MapMarker$1 = React__default$1.memo(() => /* @__PURE__ */ jsx(
  Avatar,
  {
    sx: {
      height: "24px",
      width: "24px",
      bgcolor: "primary.main",
      fontSize: "20px"
    },
    children: /* @__PURE__ */ jsx(Place, { fontSize: "inherit", color: "inherit" })
  }
));
function Map$7(_e) {
  var _f = _e, { onClusterClick, onMarkerClick } = _f, props = __objRest$c(_f, ["onClusterClick", "onMarkerClick"]);
  var _a;
  const theme = useTheme$2();
  const isMounted = useIsMounted();
  const { query } = useContext(Context$d);
  const menuAnchorEl = useRef(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [markerSource, setMarkerSource] = useState("originLatLon");
  const [mapUiKey, setMapUiKey] = useState();
  useEffect(() => {
    if (isMounted() && query.isFetched) {
      setMapUiKey(v4());
    }
  }, [query.isFetched]);
  const markerLiterals = !query.isLoading && query.isFetched && ((_a = query.data) == null ? void 0 : _a.data) ? query.data.data.rows.reduce((accum, { id, [markerSource]: latlng }) => {
    if (!latlng) {
      return accum;
    }
    const parsed = JSON.parse(latlng);
    return [...accum, [id, { lat: parsed.latitude, lng: parsed.longitude }]];
  }, []) : [];
  const mapClusterClickHandler = useCallback(
    (event, cluster, map) => {
      if (onClusterClick) {
        return onClusterClick(markerLiterals)(event, cluster, map);
      }
    },
    [markerLiterals]
  );
  const mapMarkerClickHandler = useCallback(
    (literal) => (event, marker) => {
      if (onMarkerClick) {
        return onMarkerClick(literal)(event, marker);
      }
    },
    []
  );
  return /* @__PURE__ */ jsxs(Box, { position: "relative", width: "100%", height: "100%", children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: menuAnchorEl,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "0.5rem",
        right: "0.5rem",
        zIndex: theme.zIndex.modal,
        height: "2.5rem",
        width: "2.5rem",
        color: theme.palette.grey[700],
        bgcolor: alpha$1(hexToRgb(theme.palette.common.white), 0.3),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: `1px 1px 1px ${alpha$1(hexToRgb(theme.palette.grey[400]), 0.3)}`,
        sx: {
          cursor: "pointer",
          "&:hover": {
            color: theme.palette.grey[800]
          }
        },
        onClick: () => setSettingsOpen((x) => !x),
        children: /* @__PURE__ */ jsx(Settings, { fontSize: "large" })
      }
    ),
    /* @__PURE__ */ jsxs(
      Menu,
      {
        sx: {
          ".MuiList-root": {
            paddingTop: 0
          }
        },
        slotProps: {
          paper: {
            sx: { width: 320 }
          }
        },
        anchorEl: menuAnchorEl.current,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        open: settingsOpen,
        onClose: () => setSettingsOpen(false),
        children: [
          /* @__PURE__ */ jsx(
            ListItemText$1,
            {
              sx: {
                marginTop: 0,
                paddingX: theme.spacing(4),
                paddingY: theme.spacing(2),
                bgcolor: theme.palette.grey[100],
                color: theme.palette.grey[500]
              },
              children: "Markers"
            }
          ),
          /* @__PURE__ */ jsxs(MenuList$1, { children: [
            /* @__PURE__ */ jsx(MenuItem$1, { onClick: () => setMarkerSource("originLatLon"), children: /* @__PURE__ */ jsx(ListItemText$1, { inset: true, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
              "Origin",
              markerSource === "originLatLon" && /* @__PURE__ */ jsx(Check, { color: "primary" })
            ] }) }) }),
            /* @__PURE__ */ jsx(MenuItem$1, { onClick: () => setMarkerSource("destinationLatLon"), children: /* @__PURE__ */ jsx(ListItemText$1, { inset: true, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
              "Destination",
              markerSource === "destinationLatLon" && /* @__PURE__ */ jsx(Check, { color: "primary" })
            ] }) }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(GoogleMap, __spreadProps$k(__spreadValues$o({}, props), { children: mapUiKey && /* @__PURE__ */ jsx(
      GoogleMap.MarkerClusterer,
      {
        onClusterClick: mapClusterClickHandler,
        children: markerLiterals.map(([id, latlng]) => /* @__PURE__ */ jsx(
          GoogleMap.AdvancedMarker,
          {
            position: latlng,
            onClick: mapMarkerClickHandler([id, latlng]),
            children: /* @__PURE__ */ jsx(MapMarker$1, {})
          },
          `${id}_${markerSource}`
        ))
      },
      `${mapUiKey}_${markerSource}`
    ) }))
  ] });
}
function commonQueryParameters(filterState, organisations) {
  return {
    active: filterState.active,
    arrivalFrom: filterState.arrivalFrom ? removeDateTime(filterState.arrivalFrom) : null,
    arrivalTo: filterState.arrivalTo ? removeDateTime(filterState.arrivalTo) : null,
    departureFrom: filterState.departureFrom ? removeDateTime(filterState.departureFrom) : null,
    departureTo: filterState.departureTo ? removeDateTime(filterState.departureTo) : null,
    requiredIntoStoreFrom: filterState.requiredIntoStoreFrom ? removeDateTime(filterState.requiredIntoStoreFrom) : null,
    requiredIntoStoreTo: filterState.requiredIntoStoreTo ? removeDateTime(filterState.requiredIntoStoreTo) : null,
    etaDelay: filterState.etaDelay,
    additionalFilter: {
      cargoType: filterState.cargoType.length ? filterState.cargoType : void 0,
      consignee: filterState.consignee.length ? filterState.consignee.map((x) => +x.id) : void 0,
      consignor: filterState.consignor.length ? filterState.consignor.map((x) => +x.id) : void 0,
      destination: filterState.destination.length ? filterState.destination.map((x) => +x.id) : void 0,
      mode: filterState.mode.length ? filterState.mode : void 0,
      origin: filterState.origin.length ? filterState.origin.map((x) => +x.id) : void 0,
      organisationIDs: organisations && organisations.length > 0 ? organisations : void 0
    }
  };
}
function portalShipmentQueryParameters(filterState, params) {
  return __spreadProps$k(__spreadValues$o({}, params), {
    additionalFilter: __spreadProps$k(__spreadValues$o({}, params.additionalFilter), {
      status: filterState.shipmentStatus.length ? filterState.shipmentStatus.map((x) => +x.id) : void 0
    })
  });
}
function portalOrderQueryParameters(filterState, params) {
  var _a;
  (_a = params.additionalFilter) == null ? true : delete _a.status;
  return __spreadProps$k(__spreadValues$o({}, params), {
    expectedReadyFrom: filterState.expectedReadyFrom ? removeDateTime(filterState.expectedReadyFrom) : null,
    expectedReadyTo: filterState.expectedReadyTo ? removeDateTime(filterState.expectedReadyTo) : null
  });
}
function portalContainerQueryParameters(filterState, params) {
  var _a;
  (_a = params.additionalFilter) == null ? true : delete _a.mode;
  return __spreadProps$k(__spreadValues$o({}, params), {
    additionalFilter: __spreadProps$k(__spreadValues$o({}, params.additionalFilter), {
      status: filterState.containerStatus.length ? filterState.containerStatus.map((x) => +x.id) : void 0
    })
  });
}
function produceQueryParameters(filterState, resourceTypeState, organisations) {
  switch (resourceTypeState.type) {
    case "PortalShipment":
      return portalShipmentQueryParameters(filterState, commonQueryParameters(filterState, organisations));
    case "PortalOrder":
      return portalOrderQueryParameters(filterState, commonQueryParameters(filterState, organisations));
    case "PortalContainer":
      return portalContainerQueryParameters(filterState, commonQueryParameters(filterState, organisations));
    default:
      return commonQueryParameters(filterState, organisations);
  }
}
function produceLookupFilters(filters, additional) {
  const _a = filters, { additionalFilter } = _a, rest = __objRest$c(_a, ["additionalFilter"]);
  return __spreadProps$k(__spreadValues$o({}, rest), {
    additionalFilter: JSON.stringify(__spreadValues$o(__spreadValues$o({}, additionalFilter), additional))
  });
}
function Base$5({ children }) {
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const [context, Form] = useForm({
    defaultValues: initialFilters$4
  });
  const values = context.watch();
  const [resourceTypeState, resourceTypeDispatch] = useReducer(resourceTypeReducer, initialResourceTypeState);
  const [watchlistState, watchlistDispatch] = useReducer(watchlistReducer$2, initialWatchlistState$2);
  const queryParameters = useMemo(
    () => produceQueryParameters(values, resourceTypeState, organisations),
    [values, resourceTypeState, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: resourceTypeState.grid.systemName,
      parameters: __spreadProps$k(__spreadValues$o({}, queryParameters), {
        additionalFilter: __spreadValues$o(__spreadValues$o({}, queryParameters.additionalFilter), resourceTypeState.grid.additionalFilter)
      })
    },
    { cacheTime: 0 }
  );
  return /* @__PURE__ */ jsx(
    Context$d.Provider,
    {
      value: {
        form: context,
        query,
        resourceType: [resourceTypeState, resourceTypeDispatch],
        watchlist: [watchlistState, watchlistDispatch]
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const ShipmentDashboard = Object.assign(Base$5, {
  BlockFilters: BlockFilters$2,
  Filters: Filters$2,
  Grid: Grid$2,
  Map: Map$7,
  // MobileDashboardFilters,
  ResourceTypeControl,
  StatusControl,
  VirtualizedList: VirtualizedList$1
});
const useShipmentDashboardContext = () => {
  return useContext(Context$d);
};

const ShipmentDashboardMenuItem = {
  label: "Shipments",
  path: "/Shipments",
  securityContext: SecurityContext.Menu,
  securityContextPermission: "Web_Shipments_Dashboard"
};

var __defProp$n = Object.defineProperty;
var __defProps$j = Object.defineProperties;
var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$n.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(b)) {
      if (__propIsEnum$n.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
var __objRest$b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Skeleton$4 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const Context$c = createContext({});
const ShipmentContext = createContext({});
function MasonryGrid$2(_a) {
  var _b = _a, {
    gridItem: Item = GridItem$2,
    gridItemProps,
    loadingState = {
      component: GridItemLoading$2,
      count: 6
    },
    sx
  } = _b, rest = __objRest$b(_b, [
    "gridItem",
    "gridItemProps",
    "loadingState",
    "sx"
  ]);
  var _a2, _b2, _c;
  const theme = useTheme$2();
  const { grid } = useContext(Context$c);
  const LoadingItem = defaultValue(loadingState.component, GridItemLoading$2);
  const count = (_c = (_b2 = (_a2 = grid.data) == null ? void 0 : _a2.data.rows.length) != null ? _b2 : loadingState == null ? void 0 : loadingState.count) != null ? _c : 6;
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 400,
    overscan: 2,
    lanes: 2,
    rangeExtractor: (r) => {
      var _a3, _b3, _c2, _d;
      if (count <= 0) {
        return [];
      }
      const itemSize = virtualizer.getVirtualItemForOffset(r.startIndex).size;
      const scrollTop = (_b3 = (_a3 = virtualizerRef.current) == null ? void 0 : _a3.scrollTop) != null ? _b3 : 0;
      const boundingRect = (_c2 = virtualizerRef.current) == null ? void 0 : _c2.getBoundingClientRect();
      const rangeSize = Math.ceil(((_d = boundingRect == null ? void 0 : boundingRect.height) != null ? _d : itemSize) / itemSize * 2);
      const offset = Math.floor(scrollTop / itemSize) * 2;
      const range = [];
      for (let i = offset; i <= Math.min(r.count, offset + rangeSize + r.overscan) - 1; i++) {
        range.push(i);
      }
      return range;
    }
  });
  return /* @__PURE__ */ jsx(
    Box$1,
    __spreadProps$j(__spreadValues$n({
      ref: virtualizerRef,
      height: "0px",
      width: "100%",
      padding: "4px"
    }, rest), {
      sx: __spreadValues$n({
        overflowY: "auto"
      }, sx),
      children: /* @__PURE__ */ jsx(
        Box$1,
        {
          position: "relative",
          height: `${virtualizer.getTotalSize()}px`,
          sx: {
            marginRight: `-${theme.spacing(4)}`,
            marginBottom: `-${theme.spacing(4)}`,
            "& >div": {
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(4)
            }
          },
          children: virtualizer.getVirtualItems().map((virtualRow) => {
            var _a3;
            return /* @__PURE__ */ jsx(
              Box$1,
              {
                "data-index": virtualRow.index,
                ref: virtualizer.measureElement,
                position: "absolute",
                top: 0,
                left: `${virtualRow.lane * 50}%`,
                width: "50%",
                sx: {
                  transform: `translateY(${virtualRow.start}px)`
                },
                children: grid.isFetching && !((_a3 = grid.data) == null ? void 0 : _a3.data) ? /* @__PURE__ */ jsx(LoadingItem, {}) : /* @__PURE__ */ jsx(Item, __spreadValues$n({ data: grid.data.data.rows[virtualRow.index] }, gridItemProps))
              },
              virtualRow.index
            );
          })
        }
      )
    })
  );
}
function GridItem$2({ data, onExpandClick }) {
  const theme = useTheme$2();
  const Icon = shipmentModeIconMap[data.shipmentMode];
  const pieces = data.pieces && data.piecesUnitOfMeasure ? `${data.pieces.toLocaleString(window.navigator.language)} ${inflect(
    data.piecesUnitOfMeasure,
    data.pieces
  )}` : data.pieces;
  const weight = data.weight && data.weightUnitOfMeasure ? `${data.weight.toLocaleString(window.navigator.language)} ${inflect(
    data.weightUnitOfMeasure,
    data.weight
  )}` : data.weight;
  const handleExpandClick = (data2) => (e) => {
    e.stopPropagation();
    if (typeof onExpandClick === "function") {
      onExpandClick(data2);
    }
  };
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
                  Icon && /* @__PURE__ */ jsx(Icon, { fontSize: "inherit" }),
                  /* @__PURE__ */ jsx(Typography$1, { fontSize: "1.1rem", lineHeight: "1.1rem", fontWeight: 600, children: data.shipmentReference })
                ] }),
                /* @__PURE__ */ jsx(
                  Box$1,
                  {
                    alignSelf: "flex-start",
                    paddingY: 1,
                    paddingX: 2,
                    bgcolor: "primary.main",
                    borderRadius: (theme2) => theme2.shape.borderRadius,
                    textAlign: "center",
                    children: /* @__PURE__ */ jsx(
                      Typography$1,
                      {
                        fontSize: "0.75rem",
                        lineHeight: 1,
                        color: (theme2) => theme2.palette.common.white,
                        textTransform: "uppercase",
                        children: data.status
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(
                IconButton,
                {
                  size: "small",
                  title: "Expand to tab",
                  sx: {
                    alignSelf: "flex-end"
                  },
                  onClick: handleExpandClick(data),
                  children: /* @__PURE__ */ jsx(OpenInFullRounded, { fontSize: "inherit" })
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 2, children: /* @__PURE__ */ jsx(
          PortalShipmentSupplyChainTimeline,
          {
            jobID: data.id,
            supplyChainID: data.supplyChainID,
            shipmentMode: data.shipmentMode,
            shipmentType: data.shipmentType,
            estimatedDeparture: data.estimatedDeparture,
            actualDeparture: data.actualDeparture,
            estimatedArrival: data.estimatedArrival,
            actualArrival: data.actualArrival,
            bookingConfirmed: data.bookingConfirmed
          }
        ) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 8, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Shipper" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignor })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Consignee" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignee })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Origin" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.origin })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Destination" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.destination })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Units" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: pieces })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Weight" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: weight })
          ] })
        ] })
      ]
    }
  );
}
function GridItemLoading$2() {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsx(Skeleton$4, { height: "1.1rem", width: "120px" }),
                /* @__PURE__ */ jsx(
                  Skeleton$4,
                  {
                    height: "22px",
                    width: "45px",
                    sx: { alignSelf: "flex-start", borderRadius: theme.shape.borderRadius }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Skeleton$4, { height: "28px", width: "28px", sx: { alignSelf: "flex-end", borderRadius: "9999px" } }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 3, children: /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" }) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 9, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "55px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "210px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "70px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "40px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "80px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "90px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "45px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "50px" }),
            /* @__PURE__ */ jsx(Skeleton$4, { height: "0.9rem", width: "75px" })
          ] })
        ] })
      ]
    }
  );
}
function Map$6(props) {
  var _a, _b, _c, _d, _e;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(
    Map$8,
    __spreadProps$j(__spreadValues$n({}, props), {
      data: (_a = query.data) == null ? void 0 : _a.data.transportLegs,
      transportComplete: !!((_c = (_b = query.data) == null ? void 0 : _b.data.actualArrival) == null ? void 0 : _c.dateAndTime),
      isAirFreight: ((_e = (_d = query.data) == null ? void 0 : _d.data.shipmentMode) == null ? void 0 : _e.code) === SystemName.ShipmentMode.Air
    })
  );
}
function DocumentsGrid() {
  var _a, _b, _c;
  const { query } = useContext(ShipmentContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const document = useQuery$1(
    ["/Document/DocumentType", objectID],
    () => httpService$1.get(`Document/DocumentType?objectID=${objectID}&objectType=Job`)
  );
  const documentsRow = [];
  (_c = (_b = document == null ? void 0 : document.data) == null ? void 0 : _b.data) == null ? void 0 : _c.forEach((document2) => {
    documentsRow.push({
      filename: document2.fileName,
      fileSize: document2.fileSize,
      attachmentID: document2.attachmentID,
      documentID: document2.documentID,
      id: document2.id,
      objectAttachmentID: document2.objectAttachmentID,
      reference: document2.reference,
      created: document2.created,
      fileType: document2.documentTypeName
    });
  });
  return /* @__PURE__ */ jsx(DocumentsDetails$4, { gridLoading: document.isFetching, gridRows: documentsRow });
}
function OrderDetails$4() {
  var _a, _b;
  const { query } = useContext(ShipmentContext);
  const orderDetails = ((_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.orders) || [];
  const gridRows = useMemo(() => {
    const orderDetailsRows = [];
    orderDetails.map((order) => {
      var _a2;
      if (order && order.orderLines && order.orderLines.length > 0) {
        order.orderLines.map((line) => {
          var _a3, _b2, _c, _d, _e, _f;
          line && orderDetailsRows.push({
            id: order.id,
            orderNumber: (_a3 = order.orderNumber) == null ? void 0 : _a3.reference,
            sku: (_b2 = line.sku) == null ? void 0 : _b2.reference,
            description: (_d = (_c = line.description) == null ? void 0 : _c.value) != null ? _d : EMPTY_STRING$g,
            ordered: ((_e = line.ordered) == null ? void 0 : _e.measure) ? line.ordered.measure : void 0,
            confirmed: ((_f = line.confirmed) == null ? void 0 : _f.measure) ? line.confirmed.measure : void 0
          });
        });
      } else if (order) {
        orderDetailsRows.push({
          id: order.id,
          orderNumber: (_a2 = order.orderNumber) == null ? void 0 : _a2.reference,
          sku: EMPTY_STRING$g,
          description: EMPTY_STRING$g,
          ordered: EMPTY_STRING$g,
          confirmed: EMPTY_STRING$g
        });
      }
    });
    return orderDetailsRows;
  }, [orderDetails]);
  return /* @__PURE__ */ jsx(OrderDetails$5, { gridLoading: query.isFetching, gridRows });
}
function PackingLineDetails() {
  var _a;
  const { query } = useContext(ShipmentContext);
  const gridRows = defaultValue((_a = query.data) == null ? void 0 : _a.data.packingLines, []).map((line) => {
    var _a2, _b, _c, _d, _e, _f, _g;
    return {
      id: line.id,
      description: (_a2 = line.description) == null ? void 0 : _a2.value,
      pieces: (_b = line.pieces) == null ? void 0 : _b.measure,
      piecesUnitOfMeasure: (_c = line.pieces) == null ? void 0 : _c.measureUnitType,
      weight: (_d = line.weight) == null ? void 0 : _d.measure,
      weightUnitOfMeasure: (_e = line.weight) == null ? void 0 : _e.measureUnitType,
      volume: (_f = line.volume) == null ? void 0 : _f.measure,
      volumeUnitOfMeasure: (_g = line.volume) == null ? void 0 : _g.measureUnitType
    };
  });
  return /* @__PURE__ */ jsx(PackingLineDetails$1, { gridRows, gridLoading: query.isFetching });
}
function ShipmentControls({ subscriptionFormProps, shareMagicLinkProps }) {
  var _a, _b, _c, _d, _e, _f;
  const { query } = useContext(ShipmentContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const disabled = query.isFetching;
  const watchlist = {
    objectID,
    objectType: "Job",
    isWatchlisted: (_b = query.data) == null ? void 0 : _b.data.isWatchlisted
  };
  const shareMagicLink = shareMagicLinkProps && __spreadValues$n({
    intent: "Shipment",
    objectId: (_c = query.data) == null ? void 0 : _c.data.id,
    objectType: "Job"
  }, shareMagicLinkProps);
  const shipmentNumber = (_f = (_e = (_d = query.data) == null ? void 0 : _d.data.shipmentReference) == null ? void 0 : _e.reference) != null ? _f : "";
  const subscriptionDialogState = subscriptionFormProps && {
    title: `Subscribe to shipment ${shipmentNumber}`,
    subscriptionProps: subscriptionFormProps
  };
  return /* @__PURE__ */ jsx(
    TrackerControls,
    {
      disabled,
      watchlist,
      subscriptionDialog: subscriptionDialogState,
      shareMagicLink
    }
  );
}
function ShipmentDetails$2() {
  var _a;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(ShipmentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(ShipmentDetails$3, { data: (_a = query.data) == null ? void 0 : _a.data });
}
function AgentDetails$2() {
  var _a;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(AgentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(AgentDetails$3, { data: (_a = query.data) == null ? void 0 : _a.data });
}
function StaffContacts$2() {
  var _a, _b;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(StaffContactsLoading, {});
  }
  return /* @__PURE__ */ jsx(StaffContacts$3, { data: (_a = query.data) == null ? void 0 : _a.data, mailToSubject: (_b = query.data) == null ? void 0 : _b.data.shipmentReference.reference });
}
function ContainerDetails$3() {
  var _a, _b, _c;
  const { query } = useContext(ShipmentContext);
  const containerDetails = (_c = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.containers) != null ? _c : [];
  const gridRows = containerDetails.map((container) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
    const pieces = (_b2 = (_a2 = container.good) == null ? void 0 : _a2.pieces) == null ? void 0 : _b2.measure;
    const piecesMeasureUnitType = (_d = (_c2 = container.good) == null ? void 0 : _c2.pieces) == null ? void 0 : _d.measureUnitType;
    const actualWeight = (_f = (_e = container.good) == null ? void 0 : _e.gross) == null ? void 0 : _f.measure;
    const actualWeightUnitType = (_h = (_g = container.good) == null ? void 0 : _g.gross) == null ? void 0 : _h.measureUnitType;
    const volume = (_j = (_i = container.good) == null ? void 0 : _i.volume) == null ? void 0 : _j.measure;
    const volumeUnitType = (_l = (_k = container.good) == null ? void 0 : _k.volume) == null ? void 0 : _l.measureUnitType;
    return {
      id: container.goodID,
      containerNumber: (_n = (_m = container.good) == null ? void 0 : _m.containerAsset) == null ? void 0 : _n.containerNumber,
      type: (_r = (_q = (_p = (_o = container.good) == null ? void 0 : _o.containerAsset) == null ? void 0 : _p.containerType) == null ? void 0 : _q.shortName) != null ? _r : void 0,
      seal: (_s = container.good) == null ? void 0 : _s.sealNumber,
      pieces: pieces && piecesMeasureUnitType ? `${pieces.toLocaleString(window.navigator.language)} ${inflect(piecesMeasureUnitType, pieces)}` : void 0,
      actualWeight: actualWeight && actualWeightUnitType ? `${actualWeight.toLocaleString(window.navigator.language)} ${inflect(
        actualWeightUnitType,
        actualWeight
      )}` : void 0,
      volume: volume && volumeUnitType ? `${volume.toLocaleString(window.navigator.language)} ${inflect(volumeUnitType, volume)}` : void 0
    };
  });
  return /* @__PURE__ */ jsx(ContainerDetails$4, { gridLoading: query.isFetching, gridRows, shipment: true });
}
function CustomsTimeline$2(props) {
  var _a, _b;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0
    }
  );
}
function TrackingTimeline$4(props) {
  var _a, _b;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: props.eventCodes.length > 0 ? (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0 : void 0
    }
  );
}
function TransportTimeline$2(props) {
  var _a, _b;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0
    }
  );
}
function VoyageDetails$2() {
  var _a;
  const { query } = useContext(ShipmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(VoyageDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(VoyageDetails$3, { data: (_a = query.data) == null ? void 0 : _a.data });
}
function _Shipment({ id, children }) {
  const query = useQuery$1(
    ["PortalShipment", id],
    () => httpService$1.get(`PortalShipment/${id}`)
  );
  return /* @__PURE__ */ jsx(ShipmentContext.Provider, { value: { query }, children });
}
function Base$4({ ids = null, children }) {
  const [gridQuery] = useGridQuery({
    systemName: "Shipments",
    parameters: {
      includeIDs: ids
    }
  });
  return /* @__PURE__ */ jsx(
    Context$c.Provider,
    {
      value: {
        grid: gridQuery
      },
      children
    }
  );
}
const Shipment = Object.assign(_Shipment, {
  EventsProgress: () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    const { query } = useContext(ShipmentContext);
    if (query.isFetching) {
      return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
    }
    return /* @__PURE__ */ jsx(
      PortalShipmentSupplyChainTimeline,
      {
        jobID: (_a = query.data) == null ? void 0 : _a.data.id,
        supplyChainID: (_b = query.data) == null ? void 0 : _b.data.supplyChainID,
        shipmentMode: (_d = (_c = query.data) == null ? void 0 : _c.data.shipmentMode) == null ? void 0 : _d.code,
        shipmentType: (_f = (_e = query.data) == null ? void 0 : _e.data.shipmentType) == null ? void 0 : _f.code,
        estimatedDeparture: (_h = (_g = query.data) == null ? void 0 : _g.data.estimatedDeparture) == null ? void 0 : _h.dateAndTime,
        actualDeparture: (_j = (_i = query.data) == null ? void 0 : _i.data.actualDeparture) == null ? void 0 : _j.dateAndTime,
        estimatedArrival: (_l = (_k = query.data) == null ? void 0 : _k.data.estimatedArrival) == null ? void 0 : _l.dateAndTime,
        actualArrival: (_n = (_m = query.data) == null ? void 0 : _m.data.actualArrival) == null ? void 0 : _n.dateAndTime,
        bookingConfirmed: (_p = (_o = query.data) == null ? void 0 : _o.data.housebill) == null ? void 0 : _p.created
      }
    );
  },
  Map: Map$6,
  ShipmentControls,
  ShipmentDetails: ShipmentDetails$2,
  AgentDetails: AgentDetails$2,
  StaffContacts: StaffContacts$2,
  ContainerDetails: ContainerDetails$3,
  CustomsTimeline: CustomsTimeline$2,
  DocumentsGrid,
  OrderDetails: OrderDetails$4,
  PackingLineDetails,
  TrackingTimeline: TrackingTimeline$4,
  TransportTimeline: TransportTimeline$2,
  VoyageDetails: VoyageDetails$2
});
const ShipmentTrackerPage = Object.assign(Base$4, {
  EventsProgress: PortalShipmentSupplyChainTimeline,
  EventsTimeline,
  MasonryGrid: MasonryGrid$2,
  Shipment
});
const useShipmentTrackerContext = () => {
  return useContext(Context$c);
};
const useShipmentContext = () => {
  return useContext(ShipmentContext);
};

const statusStyles = {
  Quote: { dotColor: "#55683C", boxColor: "#EEEFEB" },
  Draft: { dotColor: "#55683C", boxColor: "#EEEFEB" },
  Submitted: { dotColor: "#55683C", boxColor: "#EEEFEB" },
  Booked: { dotColor: "#00AAE7", boxColor: "#EBF3F8" },
  Collected: { dotColor: "#00AAE7", boxColor: "#EBF3F8" },
  OutforDelivery: { dotColor: "#B000E7", boxColor: "#F9E5FC" },
  InTransit: { dotColor: "#E73D00", boxColor: "#FCF1E5" },
  Pack: { dotColor: "#E73D00", boxColor: "#FCF1E5" },
  Unpack: { dotColor: "#E73D00", boxColor: "#FCF1E5" },
  ReadyForCollection: { dotColor: "#E73D00", boxColor: "#FCF1E5" },
  Delivered: { dotColor: "#1D9000", boxColor: "#F1FCE5" },
  Cancelled: { dotColor: "black", boxColor: "#D9D6D6" },
  Default: { dotColor: "black", boxColor: "#D9D6D6" }
};
const StatusCell = ({ systemName, value }) => {
  const { dotColor, boxColor } = systemName && statusStyles[systemName] ? statusStyles[systemName] : statusStyles["Default"];
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        backgroundColor: boxColor,
        borderRadius: "999px",
        padding: "4px 9px",
        overflow: "hidden",
        fontSize: "10px"
      },
      children: [
        /* @__PURE__ */ jsx(
          Box$1,
          {
            sx: {
              width: "14px",
              height: "14px",
              borderRadius: "50%",
              backgroundColor: dotColor,
              marginRight: "9px"
            }
          }
        ),
        /* @__PURE__ */ jsx(Typography$1, { sx: { color: "black", fontSize: "0.8rem" }, children: value })
      ]
    }
  );
};

var __defProp$m = Object.defineProperty;
var __defProps$i = Object.defineProperties;
var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$m.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(b)) {
      if (__propIsEnum$m.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
var __objRest$a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initialFilters$3 = {
  searchTerm: "",
  consignmentNumber: false,
  orderReference: false,
  pickupReference: false,
  receiver: false,
  containerNumber: false,
  deliveryReference: false,
  bookedDateFrom: null,
  bookedDateTo: null,
  deliveryDateFrom: null,
  deliveryDateTo: null
};
const Context$b = createContext({});
const DateReferenceCell$3 = (dateFieldValue, dateFieldFormat) => {
  const dateFormat = dateFieldFormat != null ? dateFieldFormat : "dd-MMM-yyyy";
  const date = dateFieldValue ? format$1(new Date(dateFieldValue), dateFormat) : null;
  return /* @__PURE__ */ jsx(Fragment$1, { children: date }, "__static");
};
const labelFontSize$1 = "0.85rem";
const filterValidationSchema = z$1.object({
  consignmentNumber: z$1.boolean().optional(),
  orderReference: z$1.boolean().optional(),
  pickupReference: z$1.boolean().optional(),
  receiver: z$1.boolean().optional(),
  containerNumber: z$1.boolean().optional(),
  deliveryReference: z$1.boolean().optional()
}).superRefine((data, ctx) => {
  const atLeastOneSelected = data.consignmentNumber || data.orderReference || data.pickupReference || data.receiver || data.containerNumber || data.deliveryReference;
  if (!atLeastOneSelected) {
    ctx.addIssue({
      code: z$1.ZodIssueCode.custom,
      message: "At least one of the filters must be selected.",
      path: []
    });
  }
});
function TrackSearch() {
  const { form, dataGridApiRef, mutation } = useContext(Context$b);
  const {
    reset,
    watch,
    handleSubmit,
    setError,
    setValue,
    getValues,
    formState: { errors, isValid, submitCount }
  } = form;
  getValues();
  const { control } = useFormContext();
  const theme = useTheme$2();
  const onSubmit = (data) => {
    mutation.mutateAsync(getValues());
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleFilterSubmit();
    }
  };
  const handleFilterSubmit = handleSubmit((data) => {
    return onSubmit();
  });
  useEffect(() => {
    mutation.mutateAsync(getValues());
  }, []);
  return /* @__PURE__ */ jsxs(Box$1, { children: [
    /* @__PURE__ */ jsx(Typography$1, { fontWeight: 600, lineHeight: "1rem", sx: { paddingBottom: "8px" }, children: "Please input your tracking number" }),
    /* @__PURE__ */ jsx(
      Controller,
      {
        name: "searchTerm",
        control,
        defaultValue: "",
        render: ({ field }) => {
          var _a;
          return /* @__PURE__ */ jsx(
            TextField,
            __spreadProps$i(__spreadValues$m({}, field), {
              fullWidth: true,
              placeholder: "Search",
              onKeyDown: handleKeyDown,
              value: (_a = field.value) != null ? _a : "",
              InputProps: {
                endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(Search$1, { onClick: handleFilterSubmit, style: { cursor: "pointer" } }) })
              },
              sx: {
                "& .MuiInput-root": {
                  fontSize: "0.875rem",
                  paddingX: theme.spacing(4),
                  "&::before": {
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                  }
                },
                "& .MuiInput-input": {
                  height: "0.75rem",
                  paddingY: "0.5rem",
                  boxSizing: "content-box"
                }
              }
            })
          );
        }
      }
    )
  ] });
}
function TrackFilters() {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, alignItems: "center", children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "consignmentNumber",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Consignment #"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "orderReference",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Order Reference"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "pickupReference",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Pickup Reference"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize$1,
              marginRight: 3
            },
            children: "Booked Date"
          }
        ) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(DateTimeInput, { name: "bookedDateFrom" }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(DateTimeInput, { name: "bookedDateTo" }) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, alignItems: "center", children: [
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "receiver",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Receiver"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "containerNumber",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Container Number"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 2, children: /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "deliveryReference",
          label: /* @__PURE__ */ jsx(
            Typography$1,
            {
              sx: {
                fontWeight: 600,
                fontSize: labelFontSize$1
              },
              children: "Delivery Reference"
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize$1,
              marginRight: 2
            },
            children: "Delivery Date"
          }
        ) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(DateTimeInput, { name: "deliveryDateFrom" }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(DateTimeInput, { name: "deliveryDateTo" }) })
      ] }) })
    ] })
  ] });
}
function TrackPageGrid(_a) {
  var _b = _a, { hyperlinkRef, components, sectionSx } = _b, props = __objRest$a(_b, ["hyperlinkRef", "components", "sectionSx"]);
  var _a2, _b2;
  const { dataGridApiRef, mutation } = useContext(Context$b);
  const theme = useTheme$2();
  useFormContext();
  const href = defaultValue(hyperlinkRef, (jobTypeSystemName, id, _) => `/${jobTypeSystemName}/${id}`);
  const columns = [
    {
      // Needs to be a hyperLink
      field: "consignmentNumber",
      flex: 1,
      headerName: "Consignment #",
      minWidth: 150,
      renderCell: (params) => {
        var _a3, _b3, _c, _d;
        switch (params.row.jobTypeSystemName) {
          case "FreightConsignment":
          case "ContainerConsignment":
            return /* @__PURE__ */ jsx(
              "a",
              {
                href: `/#${href(params.row.jobTypeSystemName, (_b3 = (_a3 = params.row) == null ? void 0 : _a3.jobID) != null ? _b3 : EMPTY_STRING$g, (_d = (_c = params.row) == null ? void 0 : _c.statusSystemName) != null ? _d : EMPTY_STRING$g)}`,
                target: "_blank",
                rel: "noopener noreferrer",
                children: params.row.consignmentNumber
              }
            );
          default:
            return /* @__PURE__ */ jsx("span", { children: params.row.consignmentNumber });
        }
      }
    },
    {
      field: "status",
      flex: 1,
      headerName: "Status",
      minWidth: 190,
      renderCell: (params) => /* @__PURE__ */ jsx(StatusCell, { systemName: params.row.statusSystemName, value: params.row.status })
    },
    {
      field: "eta",
      flex: 1,
      headerName: "EDD",
      minWidth: 100,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell$3(removeTimezoneOffset(value));
      }
    },
    {
      field: "orderReference",
      flex: 1,
      headerName: "Order Ref",
      minWidth: 200
    },
    {
      field: "receiver",
      flex: 1,
      headerName: "Receiver",
      minWidth: 200
    },
    {
      field: "origin",
      flex: 1,
      headerName: "Origin",
      minWidth: 200
    },
    {
      field: "destination",
      flex: 1,
      headerName: "Destination",
      minWidth: 200
    },
    {
      field: "containerNumber",
      flex: 1,
      headerName: "Container #",
      minWidth: 150
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Box$1, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, sx: sectionSx, children: /* @__PURE__ */ jsx(
    DataGridPro,
    __spreadProps$i(__spreadValues$m({}, props), {
      apiRef: dataGridApiRef,
      columns,
      rows: (_b2 = (_a2 = mutation == null ? void 0 : mutation.data) == null ? void 0 : _a2.data.rows) != null ? _b2 : [],
      loading: mutation.isLoading,
      getRowId: () => v4(),
      hideFooter: true,
      density: "compact",
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.common.black), 0.8)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.common.white,
          fontWeight: 600
        },
        "& .MuiDataGrid-sortIcon": {
          color: theme.palette.common.white
        },
        "& .MuiDataGrid-menuIconButton": {
          color: theme.palette.common.white
        },
        "& .MuiDataGrid-columnSeparator:hover": {
          color: darken(theme.palette.common.white, 0.3)
        },
        "& .MuiDataGrid-row": {
          backgroundColor: theme.palette.common.white
          // Set row background to white
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        "& .MuiDataGrid-overlay": {
          backgroundColor: theme.palette.common.white
          // Set loading overlay background to white
        },
        "--DataGrid-overlayHeight": "45px"
      },
      autoHeight: true
    })
  ) }) });
}
function TrackPageBase({ children }) {
  var _a;
  const [context, Form] = useForm({
    defaultValues: initialFilters$3,
    validationSchema: filterValidationSchema,
    onError: (errors) => {
      console.log(errors);
    }
  });
  const popup = usePopupAlert();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisationID = (_a = getOrganisations()[0]) == null ? void 0 : _a.id;
  useEffect(() => {
    var _a2, _b, _c, _d;
    if ((_b = (_a2 = context.formState.errors) == null ? void 0 : _a2[""]) == null ? void 0 : _b.message) {
      popup({ severity: "error", message: (_d = (_c = context.formState.errors) == null ? void 0 : _c[""]) == null ? void 0 : _d.message });
    }
  }, [context.formState.errors]);
  const trackMutation = useMutation$1(["/Grid"], (filters) => {
    var _a2, _b, _c, _d, _e, _f, _g;
    return JSON.stringify(filters) != JSON.stringify(initialFilters$3) ? httpService$1.post("Grid/Select", {
      systemName: "TrackPageGrid",
      parameters: {
        searchTerm: filters.searchTerm,
        additionalFilter: {
          organisationID,
          searchTerm: (_a2 = filters.searchTerm) != null ? _a2 : "",
          consignmentNumber: (_b = filters.consignmentNumber) != null ? _b : false,
          orderReference: (_c = filters.orderReference) != null ? _c : false,
          pickupReference: (_d = filters.pickupReference) != null ? _d : false,
          receiver: (_e = filters.receiver) != null ? _e : false,
          containerNumber: (_f = filters.containerNumber) != null ? _f : false,
          deliveryReference: (_g = filters.deliveryReference) != null ? _g : false,
          bookedDateFrom: filters.bookedDateFrom ? removeDateTime(defaultValue(filters.bookedDateFrom.dateAndTime, "")) : null,
          bookedDateTo: filters.bookedDateTo ? removeDateTime(defaultValue(filters.bookedDateTo.dateAndTime, "")) : null,
          deliveryDateFrom: filters.deliveryDateFrom ? removeDateTime(defaultValue(filters.deliveryDateFrom.dateAndTime, "")) : null,
          deliveryDateTo: filters.deliveryDateTo ? removeDateTime(defaultValue(filters.deliveryDateTo.dateAndTime, "")) : null
        }
      }
    }) : new Promise((resolve) => resolve());
  });
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(Context$b.Provider, { value: { form: context, dataGridApiRef: apiRef, mutation: trackMutation }, children: /* @__PURE__ */ jsx(Form, { style: { paddingTop: theme.spacing(2) }, children }) });
}
const TrackPage = Object.assign(TrackPageBase, {
  TrackPageGrid,
  TrackFilters,
  TrackSearch
});
const useTrackPage = () => {
  return useContext(Context$b);
};

var img$2 = "data:image/png;base64,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";

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,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";

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
var __async$b = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function DisplayDocumentIcon({ fileExtension, style }) {
  fileExtension = fileExtension.toLowerCase();
  if (fileExtension === "pdf") {
    return /* @__PURE__ */ jsx(
      "img",
      {
        src: img$2,
        alt: "Click to download/view PDF",
        style: __spreadValues$l({ width: "4rem", height: "5rem", padding: 4, alignSelf: "center" }, style)
      }
    );
  } else if (fileExtension === "jpg" || fileExtension === "jpeg" || fileExtension === "png") {
    return /* @__PURE__ */ jsx(
      "img",
      {
        src: img,
        alt: "Click to download/view Image",
        style: __spreadValues$l({ width: "4rem", height: "4rem", padding: 4, alignSelf: "center" }, style)
      }
    );
  } else {
    return /* @__PURE__ */ jsx(
      "img",
      {
        src: img$1,
        alt: "Click to download/view File",
        style: __spreadValues$l({ width: "4rem", height: "4rem", padding: 4, alignSelf: "center" }, style)
      }
    );
  }
}
function TrackingDocuments({ handleInvoiceAndPOD }) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const theme = useTheme$4();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const { jobID } = useParams();
  const location = useLocation();
  const consignmentID = location.search.split("=")[1];
  const auth = useAuth();
  const popup = usePopupAlert();
  let userHasPODManifestBtnPermission = auth.userHasPermission("podManifest_Document_Button", "Read");
  const [{ isFetching, isLoading, isError, data: gridDocumentData, error }] = useGridQuery(
    {
      systemName: "Documents",
      parameters: {
        objectID: jobID,
        objectType: "Job"
      }
    },
    { cacheTime: 0 }
  );
  const attachmentNumber = (_b = (_a = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _a.rows) == null ? void 0 : _b.length;
  if (isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (isError) {
    if (error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        error.message
      ] });
    }
  }
  const handleReportDownload = (reportSytemName, jobID2, popup2) => () => __async$b(this, null, function* () {
    const body = {
      reportName: reportSytemName,
      ReportParameters: JSON.stringify({
        dateTo: dayjs(/* @__PURE__ */ new Date()).format("YYYY-MM-DD"),
        consignmentID,
        orderID: jobID2
      })
    };
    try {
      const statuses = yield httpService$1.downloadReport("Report/Download2", "POST", body);
      const fileUrl = URL.createObjectURL(statuses);
      const windowObject = window.open(fileUrl);
      if (windowObject) {
        windowObject.onpagehide = () => {
          URL.revokeObjectURL(fileUrl);
        };
      }
    } catch (e) {
      popup2({
        message: "No order records found to generate the report!",
        severity: "warning"
      });
      return;
    }
  });
  const handleView = (data) => __async$b(this, null, function* () {
    try {
      const fileDownload = yield httpService$1.download(`Attachment/Download/${data.objectAttachmentID}`);
      const fileUrl = URL.createObjectURL(fileDownload);
      const windowObject = window.open(fileUrl);
      if (windowObject) {
        windowObject.onpagehide = () => {
          URL.revokeObjectURL(fileUrl);
        };
      }
    } catch (e) {
      popup({
        message: "There's an error occurred retrieving the file",
        severity: "error"
      });
      return;
    }
  });
  const handleDownload = (data) => __async$b(this, null, function* () {
    try {
      const fileDownload = yield httpService$1.download(`Attachment/Download/${data.objectAttachmentID}`);
      const fileUrl = URL.createObjectURL(fileDownload);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileUrl;
      downloadLink.download = data.filename;
      downloadLink.click();
      window.URL.revokeObjectURL(fileUrl);
    } catch (e) {
      popup({
        message: "There's an error occurred downloading the file",
        severity: "error"
      });
      return;
    }
  });
  const handleDownloadAll = (data) => {
    if (data) {
      data.forEach((document2) => {
        handleDownload(document2);
      });
    }
  };
  const hasInvoice = (_d = (_c = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _c.rows) == null ? void 0 : _d.some((file) => file.documentTypeSystemName === "Invoice");
  const hasPOD = (_f = (_e = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _e.rows) == null ? void 0 : _f.some((file) => file.documentTypeSystemName === "ProofOfDelivery");
  const hasInvoiceAndPOD = hasInvoice && hasPOD;
  const handleDownloadInvoiceAndPOD = (data) => __async$b(this, null, function* () {
    var _a2;
    if (typeof handleInvoiceAndPOD === "function") {
      return handleInvoiceAndPOD(data);
    }
    const orderNumber = (_a2 = data == null ? void 0 : data.find((file) => file.orderNumber)) == null ? void 0 : _a2.orderNumber;
    const objectAttachmentIDs = data == null ? void 0 : data.reduce((acc, file) => {
      if ((file.documentTypeSystemName === "Invoice" || file.documentTypeSystemName === "ProofOfDelivery") && file.fileType === "pdf") {
        acc.push(file.objectAttachmentID);
      }
      return acc;
    }, []);
    if (!objectAttachmentIDs) {
      popup({
        message: "No attachment records found to generate the report!",
        severity: "warning"
      });
      return;
    }
    try {
      const attachmentParams = (objectAttachmentIDs != null ? objectAttachmentIDs : []).map((id) => `objectAttachmentIDs=${id}`).join("&");
      const fileName = orderNumber + ".pdf";
      const response = yield httpService$1.download(
        `Attachment/MergePDFs?${attachmentParams}&filename=${fileName}`
      );
      if (response) {
        const fileUrl = URL.createObjectURL(response);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;
        downloadLink.download = fileName;
        downloadLink.click();
        window.URL.revokeObjectURL(fileUrl);
      }
    } catch (e) {
      popup({
        message: "There's an error occurred downloading Invoice/POD combined file",
        severity: "error"
      });
      return;
    }
  });
  return /* @__PURE__ */ jsxs(Box, { sx: { marginX: !mobileBreakpoint ? 10 : 8, marginY: 4 }, children: [
    /* @__PURE__ */ jsxs(Stack$1, { direction: "row", children: [
      /* @__PURE__ */ jsx(AttachFile, { sx: { transform: "rotate(45deg)" } }),
      /* @__PURE__ */ jsxs(Typography, { sx: { fontWeight: "600" }, children: [
        attachmentNumber,
        " Attachment(s)"
      ] })
    ] }),
    /* @__PURE__ */ jsx(Grid$3, { container: true, spacing: 2, padding: 4, direction: "row", children: (_h = (_g = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _g.rows) == null ? void 0 : _h.map((file, key) => /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 6, md: 3, children: /* @__PURE__ */ jsxs(
      Stack$1,
      {
        direction: "column",
        alignItems: "center",
        padding: 4,
        sx: { cursor: "pointer" },
        children: [
          /* @__PURE__ */ jsx(
            Paper$1,
            {
              sx: {
                padding: 4,
                display: "flex",
                width: "6rem",
                height: "7rem"
              },
              variant: "outlined",
              elevation: 0,
              onClick: () => handleView(file),
              children: /* @__PURE__ */ jsx(DisplayDocumentIcon, { fileExtension: file.fileType })
            },
            key
          ),
          /* @__PURE__ */ jsx(
            Typography,
            {
              sx: {
                fontWeight: "600",
                fontSize: !mobileBreakpoint ? "0.8rem" : "0.7rem",
                maxWidth: "100%",
                wordWrap: "break-word",
                paddingTop: 4
              },
              onClick: () => handleView(file),
              children: file.filename
            },
            file.objectAttachmentID
          )
        ]
      },
      key
    ) }, key)) }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, justifyContent: "center", alignContent: "center", children: [
      attachmentNumber > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
          Button$1,
          {
            variant: "contained",
            color: "primary",
            startIcon: /* @__PURE__ */ jsx(SaveAlt, {}),
            onClick: () => {
              var _a2;
              return handleDownloadAll((_a2 = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _a2.rows);
            },
            children: "Download all files"
          }
        ) }),
        hasInvoiceAndPOD && /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
          Button$1,
          {
            variant: "contained",
            color: "primary",
            startIcon: /* @__PURE__ */ jsx(SaveAlt, {}),
            onClick: () => {
              var _a2;
              return handleDownloadInvoiceAndPOD((_a2 = gridDocumentData == null ? void 0 : gridDocumentData.data) == null ? void 0 : _a2.rows);
            },
            children: "Invoice/POD Combined"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
        Button$1,
        {
          variant: "contained",
          color: "primary",
          onClick: () => handleReportDownload("RPT_PODDocument", jobID != null ? jobID : null, popup)(),
          startIcon: /* @__PURE__ */ jsx(TextSnippet, {}),
          children: "Generate POD Document"
        }
      ) }),
      userHasPODManifestBtnPermission && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Grid$3, { item: true, children: /* @__PURE__ */ jsx(
        Button$1,
        {
          variant: "contained",
          color: "primary",
          onClick: () => handleReportDownload("RPT_PODManifest", jobID != null ? jobID : null, popup)(),
          startIcon: /* @__PURE__ */ jsx(TextSnippet, {}),
          children: "Generate POD Manifest"
        }
      ) }) })
    ] })
  ] });
}

const SECURITY_CONTEXT$4 = SecurityContext.Consignment;
const PERMISSION_DETAIL_DOCUMENTS_READ = "Web_Details_Documents_Read";
const permissions$4 = {
  [SECURITY_CONTEXT$4]: [
    PERMISSION_DETAIL_DOCUMENTS_READ
  ]
};
function hasTrackingDocumentsPermission(auth) {
  return auth.userHasPermission(SECURITY_CONTEXT$4, permissions$4[SECURITY_CONTEXT$4]);
}

const isCompleted = (event) => event.completedDate !== null;
function TrackingHistory() {
  var _a, _b;
  const theme = useTheme$2();
  const { jobID } = useParams();
  const distributionOrderQuery = useQuery$1(
    ["DistributionOrder", jobID],
    () => httpService$1.get(`DistributionOrder/${jobID}`)
  );
  const supplyChainListQuery = useQuery$1(
    ["SupplyChainMember/List", jobID],
    () => {
      var _a2;
      return httpService$1.get("SupplyChainMember/List", {
        supplyChainID: (_a2 = distributionOrderQuery == null ? void 0 : distributionOrderQuery.data) == null ? void 0 : _a2.data.supplyChainID
      });
    },
    {
      enabled: distributionOrderQuery.isFetched
    }
  );
  const isLoading = distributionOrderQuery.isLoading || supplyChainListQuery.isLoading;
  if (isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (supplyChainListQuery.isError) {
    if (supplyChainListQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        supplyChainListQuery.error.message
      ] });
    }
  }
  if (distributionOrderQuery.isError) {
    if (distributionOrderQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        distributionOrderQuery.error.message
      ] });
    }
  }
  const completedEvents = (_b = (_a = supplyChainListQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.filter((x) => isCompleted(x)).sort((a, b) => dayjs(b.completedDate).valueOf() - dayjs(a.completedDate).valueOf());
  return /* @__PURE__ */ jsx(Box$1, { padding: `${theme.spacing(6)} ${theme.spacing(8)} ${theme.spacing(4)} ${theme.spacing(8)}`, children: /* @__PURE__ */ jsxs(
    Timeline$1,
    {
      sx: {
        [`& .${timelineItemClasses$1.root}:before`]: {
          flex: 0,
          padding: 0
        },
        [`& .${timelineContentClasses$1.root}`]: {
          marginLeft: theme.spacing(4),
          marginBottom: theme.spacing(4)
        },
        margin: 0,
        padding: 0
      },
      children: [
        completedEvents && completedEvents.map((event, index) => /* @__PURE__ */ jsxs(TimelineItem$1, { children: [
          /* @__PURE__ */ jsxs(TimelineSeparator$1, { children: [
            /* @__PURE__ */ jsx(
              CheckCircle,
              {
                sx: {
                  color: event.milestoneName === "Delivered" ? "green" : "initial"
                }
              }
            ),
            index < (completedEvents == null ? void 0 : completedEvents.length) - 1 && /* @__PURE__ */ jsx(TimelineConnector$1, {})
          ] }),
          /* @__PURE__ */ jsx(TimelineContent$1, { sx: { padding: 0 }, children: /* @__PURE__ */ jsx(TrackingEvent, { event }) })
        ] }, index)),
        (completedEvents == null ? void 0 : completedEvents.length) === 0 && /* @__PURE__ */ jsx(Box$1, { children: "No Tracking History.." })
      ]
    }
  ) });
}

const SECURITY_CONTEXT$3 = SecurityContext.DistributionOrder;
const PERMISSION_DETAILS_HISTORY_READ = "Web_Details_History_Read";
const permissions$3 = {
  [SECURITY_CONTEXT$3]: [
    PERMISSION_DETAILS_HISTORY_READ
  ]
};
function hasTrackingHistoryPermission(auth) {
  return auth.userHasPermission(SECURITY_CONTEXT$3, permissions$3[SECURITY_CONTEXT$3]);
}

var __defProp$k = Object.defineProperty;
var __defProps$h = Object.defineProperties;
var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
function calculateTotalValues(goodsArray, joblinesArray) {
  var _a;
  var totalWeight = 0;
  var totalVolume = 0;
  var totalQuantity = 0;
  if (goodsArray.length !== 0) {
    var SSCCNumbers = /* @__PURE__ */ new Set();
    for (const goods of goodsArray) {
      if (goods.weight && goods.weight.measure) {
        totalWeight += goods.weight.measure;
      }
      if (goods.volume && ((_a = goods == null ? void 0 : goods.volume) == null ? void 0 : _a.measure)) {
        totalVolume += goods.volume.measure;
      }
      if (goods.ssccNumber && goods.ssccNumber.value) {
        SSCCNumbers.add(goods.ssccNumber.value);
      }
    }
    totalQuantity = SSCCNumbers.size;
  } else if (joblinesArray.length !== 0) {
    totalQuantity = 0;
    for (const line of joblinesArray) {
      if (line.measures) {
        for (const measure of line.measures) {
          if (measure.measure && measure.measureTypeSystemName === "Weight") {
            totalWeight += measure.measure;
          } else if (measure.measure && measure.measureTypeSystemName === "Volume") {
            totalVolume += measure.measure;
          } else if (measure.measure && measure.measureTypeSystemName === "SuppliedQuantity") {
            totalQuantity += measure.measure;
          }
        }
      }
    }
  }
  return [totalWeight, totalVolume, totalQuantity];
}
const StyledStack = styled$4(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.divider}`
}));
function TrackingOrderDetails({ ReportDamageDialog = () => /* @__PURE__ */ jsx(Fragment, {}) }) {
  var _a, _b, _c, _d;
  const { jobID } = useParams();
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const [checked, setChecked] = useState(false);
  const [trackingReportDamageOpen, setTrackingReportDamageOpen] = useState(false);
  const [selectedSSCCNumber, setSelectedSSCCNumber] = useState("");
  const [expandedPallets, setExpandedPallets] = useState([]);
  const gridStyles = {
    "& .alternate-row": {
      backgroundColor: theme.palette.secondary.main
    },
    "& .MuiDataGrid-footerContainer": {
      display: "none"
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.secondary.main
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 600,
      fontSize: "1rem"
    },
    "& .MuiDataGrid-cell:focus": {
      outline: "none"
    }
  };
  const { isLoading, isError, data, error } = useQuery$1(
    ["Consignment", jobID],
    () => httpService$1.get(`Consignment/${jobID}`)
  );
  const {
    isLoading: isEventsLoading,
    isError: isEventsError,
    data: eventsData,
    error: eventsError
  } = useQuery$1(
    ["SupplyChainMember/List", jobID],
    () => {
      var _a2;
      return httpService$1.get("SupplyChainMember/List", {
        supplyChainID: (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.supplyChainID
      });
    },
    {
      enabled: !!(data == null ? void 0 : data.data)
    }
  );
  const getLatestMilestone = (events) => {
    let latestMilestone = null;
    let latestDate = null;
    events.forEach((event) => {
      if (event.completedDate) {
        const milestoneDate = new Date(event.completedDate);
        if (!latestDate || milestoneDate > latestDate) {
          latestDate = milestoneDate;
          latestMilestone = event;
        }
      }
    });
    return latestMilestone;
  };
  const inProgress = useMemo(() => {
    var _a2;
    const latestMileStone = getLatestMilestone((_a2 = eventsData == null ? void 0 : eventsData.data) != null ? _a2 : []);
    if (!latestMileStone || latestMileStone === null) {
      return false;
    }
    if ((latestMileStone == null ? void 0 : latestMileStone.milestoneName) === "Ordered" || (latestMileStone == null ? void 0 : latestMileStone.milestoneName) === "Awaiting Pickup") {
      return false;
    }
    return true;
  }, [data == null ? void 0 : data.data]);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleReportDamage = (ssccNumber) => {
    setSelectedSSCCNumber(ssccNumber);
    setTrackingReportDamageOpen(true);
  };
  var [totalWeight, totalVolume, totalItems] = [0, 0, 0];
  if (!checked) {
    [totalWeight, totalVolume, totalItems] = calculateTotalValues([], (data == null ? void 0 : data.data) ? data == null ? void 0 : data.data.jobLines : []);
  } else {
    [totalWeight, totalVolume, totalItems] = calculateTotalValues((data == null ? void 0 : data.data) ? data == null ? void 0 : data.data.goods : [], []);
  }
  const defaultColumns = [
    {
      field: "reference",
      headerName: "Description",
      flex: 3
    },
    {
      field: "orderedQuantity",
      headerName: "Ordered",
      type: "number",
      flex: 1,
      valueGetter: ({ row }) => {
        var _a2;
        return (_a2 = row.measures.find((x) => x.measureTypeSystemName === "OrderedQuantity")) == null ? void 0 : _a2.measure;
      }
    },
    {
      field: "suppliedQuantity",
      headerName: "Supplied",
      type: "number",
      flex: 1,
      valueGetter: ({ row }) => {
        var _a2;
        return (_a2 = row.measures.find((x) => x.measureTypeSystemName === "SuppliedQuantity")) == null ? void 0 : _a2.measure;
      }
    },
    {
      field: "weight",
      headerName: "Weight",
      type: "number",
      flex: 1,
      valueGetter: ({ row }) => {
        var _a2;
        return (_a2 = row.measures.find((x) => x.measureTypeSystemName === "Weight")) == null ? void 0 : _a2.measure;
      },
      valueFormatter: ({ value }) => value == null ? void 0 : value.toFixed(2)
    },
    {
      field: "volume",
      headerName: "Volume",
      type: "number",
      flex: 1,
      valueGetter: ({ row }) => {
        var _a2;
        return (_a2 = row.measures.find((x) => x.measureTypeSystemName === "Volume")) == null ? void 0 : _a2.measure;
      },
      valueFormatter: ({ value }) => value == null ? void 0 : value.toFixed(2)
    }
  ];
  const suppliedCols = [
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      valueGetter: ({ value }) => value == null ? void 0 : value.reference
    },
    {
      field: "quantity",
      headerName: "Quantity",
      type: "number",
      flex: 1,
      valueGetter: ({ row }) => {
        var _a2;
        return (_a2 = row.measures.find((x) => x.measureTypeSystemName === "Quantity")) == null ? void 0 : _a2.measure;
      }
    },
    {
      field: "weight",
      headerName: "Weight",
      type: "number",
      flex: 1,
      valueGetter: ({ value }) => value == null ? void 0 : value.measure,
      valueFormatter: ({ value }) => value == null ? void 0 : value.toFixed(2)
    },
    {
      field: "volume",
      headerName: "Volume",
      type: "number",
      flex: 1,
      valueGetter: ({ value }) => value == null ? void 0 : value.measure,
      valueFormatter: ({ value }) => value == null ? void 0 : value.toFixed(2)
    }
  ];
  const goodsData = data && __spreadValues$k({}, data.data);
  const drillDownData = goodsData && goodsData.goods.reduce(function(r, a) {
    if (a.ssccNumber) {
      r[String(a.ssccNumber.value)] = r[String(a.ssccNumber.value)] || [];
      r[String(a.ssccNumber.value)].push(a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
  const handleExpandClick = (pallet) => {
    setExpandedPallets(
      (prevExpandedPallets) => prevExpandedPallets.includes(pallet) ? prevExpandedPallets.filter((item) => item !== pallet) : [...prevExpandedPallets, pallet]
    );
  };
  var logisticalUnit = ((_a = data == null ? void 0 : data.data.goods[0]) == null ? void 0 : _a.breakBulkType) || "Pallet";
  if (isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (isError || isEventsError) {
    if (error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        error.message
      ] });
    }
    if (eventsError instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        eventsError.message
      ] });
    }
  }
  const fontSize = mobileBreakpoint ? "0.85rem" : "inherit";
  let hasSSCCNumber = false;
  Object.entries(drillDownData).map(([ssccNumber]) => {
    if (ssccNumber != "undefined" && hasSSCCNumber == false) {
      hasSSCCNumber = true;
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ReportDamageDialog,
      {
        open: trackingReportDamageOpen,
        setOpen: setTrackingReportDamageOpen,
        jobID,
        ssccNumber: selectedSSCCNumber
      }
    ),
    /* @__PURE__ */ jsxs(Box$1, { sx: { backgroundColor: "#fff", marginY: 4, marginX: 8 }, children: [
      hasSSCCNumber && /* @__PURE__ */ jsx(Box$1, { sx: { marginBottom: 2, padding: "6, 12, 12, 12" }, children: ((_b = data == null ? void 0 : data.data) == null ? void 0 : _b.goods) && ((_c = data == null ? void 0 : data.data) == null ? void 0 : _c.goods.length) > 0 ? /* @__PURE__ */ jsx(
        FormControlLabel,
        {
          control: /* @__PURE__ */ jsx(Switch$1, { color: "primary", onChange: handleChange, value: checked }),
          label: `View by ${logisticalUnit}`,
          labelPlacement: "start",
          sx: { marginLeft: 0 }
        }
      ) : "" }),
      /* @__PURE__ */ jsx(Box$1, { children: !checked && data && /* @__PURE__ */ jsx(Fragment, { children: !mobileBreakpoint ? /* @__PURE__ */ jsx(
        DataGrid,
        {
          loading: isLoading,
          rows: (_d = data.data) == null ? void 0 : _d.jobLines,
          columns: defaultColumns,
          disableRowSelectionOnClick: true,
          getRowClassName: (params) => params.indexRelativeToCurrentPage % 2 === 1 ? "alternate-row" : "",
          sx: gridStyles
        }
      ) : /* @__PURE__ */ jsx(TrackingPalletTableOrdered, { rows: data.data.jobLines }) }) }),
      checked && Object.entries(drillDownData).map(([ssccNumber, rowData], index) => /* @__PURE__ */ jsxs(Box$1, { children: [
        /* @__PURE__ */ jsxs(StyledStack, { direction: "row", alignItems: "center", spacing: 2, children: [
          /* @__PURE__ */ jsx(
            IconButton,
            {
              onClick: () => handleExpandClick(ssccNumber),
              sx: {
                border: "2px solid black",
                borderRadius: "5px",
                padding: 0
              },
              size: "small",
              children: expandedPallets.includes(ssccNumber) ? /* @__PURE__ */ jsx(Remove, { fontSize: "small", sx: { flexGrow: 1, color: "black" } }) : /* @__PURE__ */ jsx(Add, { fontSize: "small", sx: { flexGrow: 1, color: "black" } })
            }
          ),
          /* @__PURE__ */ jsxs(Typography$1, { sx: { flexGrow: 3, fontSize }, component: "span", children: [
            logisticalUnit,
            " ",
            index + 1,
            " ",
            ssccNumber !== "undefined" ? ssccNumber : ""
          ] }),
          mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
            IconButton,
            {
              sx: {
                border: "2px solid black",
                borderRadius: "12px",
                paddingY: "4px",
                paddingX: "10px"
              },
              onClick: () => handleReportDamage(ssccNumber),
              children: /* @__PURE__ */ jsx(WarningAmber, { sx: { flexGrow: 1, color: "black", fontSize: "1.2rem" } })
            }
          ) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
            Button,
            {
              sx: { paddingY: "2px", paddingX: "7px" },
              startIcon: /* @__PURE__ */ jsx(WarningAmber, {}),
              variant: "outlined",
              onClick: () => handleReportDamage(ssccNumber),
              children: "Report Damage"
            }
          ) }),
          logisticalUnit === "Carton" || logisticalUnit === "Unit" ? /* @__PURE__ */ jsx(CartonIcon, {}) : /* @__PURE__ */ jsx(PalletIcon, {})
        ] }),
        /* @__PURE__ */ jsx(Collapse$1, { in: expandedPallets.includes(ssccNumber), timeout: "auto", unmountOnExit: true, children: /* @__PURE__ */ jsx(Box$1, { children: !mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          DataGrid,
          {
            loading: isLoading,
            rows: rowData,
            columns: suppliedCols,
            disableRowSelectionOnClick: true,
            getRowClassName: (params) => params.indexRelativeToCurrentPage % 2 === 1 ? "" : "alternate-row",
            sx: __spreadProps$h(__spreadValues$k({}, gridStyles), {
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.common.white
              }
            })
          }
        ) }) : /* @__PURE__ */ jsx(TrackingPalletTableSupplied, { rows: rowData }) }) })
      ] }, ssccNumber)),
      /* @__PURE__ */ jsx(
        TrackingOrderDetailsTotal,
        {
          weight: totalWeight,
          volume: totalVolume,
          totalItems,
          unit: !checked ? "Item" : logisticalUnit
        }
      ),
      inProgress && /* @__PURE__ */ jsx(TrackingOrderCutLines, {})
    ] })
  ] });
}

const SECURITY_CONTEXT$2 = SecurityContext.Consignment;
const PERMISSION_DETAILS_DETAILS_READ = "Web_Details_Details_Read";
const permissions$2 = {
  [SECURITY_CONTEXT$2]: [
    PERMISSION_DETAILS_DETAILS_READ
  ]
};
function hasTrackingOrderDetailsPermission(auth) {
  return auth.userHasPermission(SECURITY_CONTEXT$2, permissions$2[SECURITY_CONTEXT$2]);
}

var __async$a = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function TrackingPOD() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const theme = useTheme$2();
  const mobileBreakpoint = useMobileBreakpoint();
  const { jobID } = useParams();
  const [podPhotoURLs, setPodPhotoURLs] = useState([]);
  const [signaturePhotoURL, setSignaturePhotoURL] = useState();
  const supplyChainEventQuery = useQuery$1(
    ["/SupplyChainEvent/List", jobID],
    () => httpService$1.get("SupplyChainEvent/List", {
      objectID: jobID,
      objectType: "Job"
    })
  );
  if (supplyChainEventQuery.isError) {
    if (supplyChainEventQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        supplyChainEventQuery.error.message
      ] });
    }
  }
  const deliveredEvent = (_a = supplyChainEventQuery == null ? void 0 : supplyChainEventQuery.data) == null ? void 0 : _a.data.find((event) => event.eventCode === "DELIVERED");
  const signee = (_b = deliveredEvent == null ? void 0 : deliveredEvent.objectParties) == null ? void 0 : _b.find((party) => party.partyTypeSystemName === "Signee");
  const createFileURL = (objectAttachmentID) => __async$a(this, null, function* () {
    try {
      const fileDownload = yield httpService$1.download(`Attachment/Download/${objectAttachmentID}`);
      if (fileDownload) {
        return URL.createObjectURL(fileDownload);
      }
    } catch (e) {
      return "";
    }
  });
  const createPODPhotoURL = (podPhotos) => __async$a(this, null, function* () {
    const podURLs = [];
    for (const pod of podPhotos) {
      const fileURL = yield createFileURL(pod.objectAttachmentID);
      podURLs.push({
        photoURL: fileURL,
        objectAttachmentID: pod.objectAttachmentID,
        fileName: pod.reference !== null ? pod.reference : ""
      });
    }
    setPodPhotoURLs(podURLs);
    return podURLs;
  });
  const createSignaturePhotoURL = (podPhotos) => __async$a(this, null, function* () {
    const fileURL = yield createFileURL(podPhotos.objectAttachmentID);
    setSignaturePhotoURL({
      photoURL: fileURL,
      objectAttachmentID: podPhotos.objectAttachmentID,
      fileName: podPhotos.reference !== null ? podPhotos.reference : ""
    });
    return fileURL;
  });
  const notesQuery = useQuery$1(
    ["/Tracking/POD/Notes", jobID],
    () => httpService$1.get("Note/List", {
      objectID: jobID,
      objectType: "Job"
    })
  );
  const signatureQuery = useQuery$1(
    ["/Tracking/POD/Signature", jobID],
    () => httpService$1.get("Document/DocumentType", {
      objectID: jobID,
      objectType: "Job",
      documentType: "PODSignature"
    })
  );
  useQuery$1(
    ["Attachment/Download/", signatureQuery],
    () => {
      var _a2, _b2, _c2, _d2;
      return ((_b2 = (_a2 = signatureQuery.data) == null ? void 0 : _a2.data) == null ? void 0 : _b2[0]) ? createSignaturePhotoURL((_d2 = (_c2 = signatureQuery.data) == null ? void 0 : _c2.data) == null ? void 0 : _d2[0]) : void 0;
    },
    {
      enabled: !!((_e = (_d = (_c = signatureQuery == null ? void 0 : signatureQuery.data) == null ? void 0 : _c.data) == null ? void 0 : _d[0]) == null ? void 0 : _e.objectAttachmentID)
    }
  );
  const photosQuery = useQuery$1(
    ["/Tracking/POD/Photos", jobID],
    () => httpService$1.get("Document/DocumentType", {
      objectID: jobID,
      objectType: "Job",
      documentType: "PODPhoto"
    })
  );
  useQuery$1(
    ["Attachment/Download/", photosQuery],
    () => {
      var _a2, _b2;
      return ((_a2 = photosQuery.data) == null ? void 0 : _a2.data) ? createPODPhotoURL((_b2 = photosQuery.data) == null ? void 0 : _b2.data) : void 0;
    },
    {
      enabled: !!((_f = photosQuery.data) == null ? void 0 : _f.data)
    }
  );
  useEffect(() => {
    return () => {
      if (podPhotoURLs.length > 0) {
        podPhotoURLs.forEach((pod) => {
          URL.revokeObjectURL(pod.photoURL);
        });
      }
      if (signaturePhotoURL) {
        URL.revokeObjectURL(signaturePhotoURL.photoURL);
      }
    };
  }, []);
  if (notesQuery.isLoading || signatureQuery.isLoading || photosQuery.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (notesQuery.isError) {
    if (notesQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        notesQuery.error.message
      ] });
    }
  }
  if (signatureQuery.isError) {
    if (signatureQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        signatureQuery.error.message
      ] });
    }
  }
  if (photosQuery.isError) {
    if (photosQuery.error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        photosQuery.error.message
      ] });
    }
  }
  return /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { paddingX: 6, paddingY: 8 }, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, children: [
      /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", children: "Signature" }),
      /* @__PURE__ */ jsx(Box$1, { sx: { border: "1px solid #d9d6d6", minHeight: "5rem" }, children: signaturePhotoURL && signaturePhotoURL && /* @__PURE__ */ jsx(Box$1, { display: "flex", flexWrap: "wrap", justifyContent: "center", children: /* @__PURE__ */ jsx("img", { src: signaturePhotoURL.photoURL, style: { maxWidth: "50%" } }) }) }),
      deliveredEvent && mobileBreakpoint && /* @__PURE__ */ jsxs(Grid$3, { container: true, children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, flexGrow: 1, children: /* @__PURE__ */ jsx(Typography$1, { children: signee && signee.fullName && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsxs("strong", { children: [
            "Signed By: ",
            " "
          ] }),
          signee.fullName
        ] }) }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, flexGrow: 1, children: deliveredEvent.eventDate && /* @__PURE__ */ jsx("span", { style: { fontWeight: "bold", marginLeft: "auto" }, children: format$1(new Date(deliveredEvent.eventDate), "d MMM y hh:mm a") }) })
      ] }),
      deliveredEvent && !mobileBreakpoint && /* @__PURE__ */ jsxs(Typography$1, { style: { display: "flex", justifyContent: "space-between" }, children: [
        signee && signee.fullName && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsxs("strong", { children: [
            "Signed By: ",
            " "
          ] }),
          signee.fullName
        ] }),
        deliveredEvent.eventDate && /* @__PURE__ */ jsx("span", { style: { fontWeight: "bold", marginLeft: "auto" }, children: format$1(new Date(deliveredEvent.eventDate), "d MMM y hh:mm a") })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { marginTop: theme.spacing(4) }, spacing: 2, children: [
      /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", children: `Photos ${podPhotoURLs && podPhotoURLs.length ? `(` + podPhotoURLs.length + `)` : ""}` }),
      /* @__PURE__ */ jsx(Box$1, { sx: { border: "1px solid #d9d6d6", minHeight: "5rem" }, children: /* @__PURE__ */ jsx(
        Grid$3,
        {
          container: true,
          spacing: 2,
          padding: 4,
          direction: "row",
          sx: { justifyItems: "center", alignItems: "center" },
          gap: mobileBreakpoint ? 2 : 0,
          children: podPhotoURLs && (podPhotoURLs == null ? void 0 : podPhotoURLs.map((file, key) => /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 4, children: /* @__PURE__ */ jsx(Box$1, { display: "flex", flexWrap: "wrap", justifyContent: "center", children: /* @__PURE__ */ jsx("img", { src: file == null ? void 0 : file.photoURL, alt: file == null ? void 0 : file.fileName, style: { maxWidth: "100%" } }) }) }, key)))
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { marginTop: theme.spacing(4) }, spacing: 2, children: [
      /* @__PURE__ */ jsx(Typography$1, { variant: "subtitle1", children: "Notes" }),
      /* @__PURE__ */ jsx(
        Box$1,
        {
          sx: {
            border: "1px solid #d9d6d6",
            minHeight: "5rem",
            padding: theme.spacing(2)
          },
          children: (_i = (_h = (_g = notesQuery == null ? void 0 : notesQuery.data) == null ? void 0 : _g.data) == null ? void 0 : _h.notes) == null ? void 0 : _i.map((note) => /* @__PURE__ */ jsx(Typography$1, { children: note.note }, note.id))
        }
      )
    ] })
  ] });
}

const SECURITY_CONTEXT$1 = SecurityContext.DistributionOrder;
const PERMISSION_DETAILS_POD_READ = "Web_Details_POD_Read";
const permissions$1 = {
  [SECURITY_CONTEXT$1]: [
    PERMISSION_DETAILS_POD_READ
  ]
};
function hasTrackingPODPermission(auth) {
  return auth.userHasPermission(SECURITY_CONTEXT$1, permissions$1[SECURITY_CONTEXT$1]);
}

const SECURITY_CONTEXT = SecurityContext.DistributionOrder;
const PERMISSION_DETAILS_TIMELINE_READ = "Web_Details_Timeline_Read";
const PERMISSION_DETAILS_SUMMARY_READ = "Web_Details_Summary_Read";
const permissions = {
  [SECURITY_CONTEXT]: [
    PERMISSION_DETAILS_TIMELINE_READ,
    PERMISSION_DETAILS_HISTORY_READ,
    PERMISSION_DETAILS_SUMMARY_READ,
    PERMISSION_DETAILS_DETAILS_READ,
    PERMISSION_DETAIL_DOCUMENTS_READ,
    PERMISSION_DETAILS_POD_READ
  ]
};
function hasTrackingPagePermission(auth) {
  return permissions[SECURITY_CONTEXT].reduce((accum, curr) => {
    return accum ? accum : auth.userHasPermission(SECURITY_CONTEXT, curr);
  }, false);
}

var __defProp$j = Object.defineProperty;
var __defProps$g = Object.defineProperties;
var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
const StyledTab = styled$4(Tab$2)({
  flexGrow: 1,
  color: "black",
  "&.Mui-selected": {
    fontWeight: "600"
  }
});
function getCDBGroupMilestiones(events) {
  let CDBGroupedMilestones = {
    ordered: [],
    dispatched: [],
    delivered: []
  };
  events.forEach((event) => {
    if (event.milestoneName === "Ordered" || event.milestoneName === "Awaiting Picking") {
      CDBGroupedMilestones.ordered = [...CDBGroupedMilestones.ordered, event];
    }
    if (event.milestoneName === "Dispatched" || event.milestoneName === "Picked Up" || event.milestoneName === "In Transit" || event.milestoneName === "At Delivery Depot" || event.milestoneName === "On Delivery Vehicle" || event.milestoneName === "POD Received") {
      CDBGroupedMilestones.dispatched = [...CDBGroupedMilestones.dispatched, event];
    }
    if (event.milestoneName === "Delivered" || event.milestoneName === "Return to Depot" || event.milestoneName === "Cancelled") {
      CDBGroupedMilestones.delivered = [...CDBGroupedMilestones.delivered, event];
    }
  });
  return CDBGroupedMilestones;
}
function updateIsCompleted(events) {
  const updatedEvents = [...events];
  for (let i = 0; i < updatedEvents.length; i++) {
    const currentEvent = updatedEvents[i];
    if (currentEvent.isCompleted) {
      for (let j = 0; j < i; j++) {
        updatedEvents[j].isCompleted = true;
      }
    }
  }
  return updatedEvents;
}
function getLatestCDBGroupedMilestone(events) {
  let highestSequenceEvent = null;
  let lowestSequenceEvent = null;
  let eventWithCompletedDate = null;
  for (const event of events) {
    if (event.completedDate !== null) {
      if (eventWithCompletedDate === null || event.sequence > highestSequenceEvent.sequence) {
        eventWithCompletedDate = event;
      }
    } else {
      if (lowestSequenceEvent === null || event.sequence < lowestSequenceEvent.sequence) {
        lowestSequenceEvent = event;
      }
    }
    if (highestSequenceEvent === null || event.sequence > highestSequenceEvent.sequence) {
      highestSequenceEvent = event;
    }
  }
  if (eventWithCompletedDate !== null) {
    const updatedEvent = __spreadProps$g(__spreadValues$j({}, eventWithCompletedDate), { isCompleted: true });
    return updatedEvent;
  }
  if (lowestSequenceEvent !== null) {
    __spreadProps$g(__spreadValues$j({}, lowestSequenceEvent), { isCompleted: true });
    return lowestSequenceEvent;
  }
  return null;
}
function TrackingPage() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  const auth = useAuth();
  const hasSummaryPermission = auth.userHasPermission(
    SecurityContext.DistributionOrder,
    PERMISSION_DETAILS_SUMMARY_READ
  );
  const hasTimelinePermission = auth.userHasPermission(
    SecurityContext.DistributionOrder,
    PERMISSION_DETAILS_TIMELINE_READ
  );
  const theme = useTheme$2();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const { jobID } = useParams();
  const indexRoute = `/Tracking/${jobID}${location.search}`;
  const filteredIndexRoute = `/Tracking/${jobID}`;
  const detailsRoute = `/Tracking/${jobID}/Details${location.search}`;
  const documentsRoute = `/Tracking/${jobID}/Documents${location.search}`;
  const podRoute = `/Tracking/${jobID}/POD${location.search}`;
  const [currentTab, setCurrentTab] = useState(location.pathname);
  const [carrierLogoURL, setCarrierLogoURL] = useState(null);
  const { isLoading, isError, data, error } = useQuery$1(
    ["DistributionOrder", jobID],
    () => httpService$1.get(`DistributionOrder/${jobID}`)
  );
  let consignmentID = location.search.split("=")[1];
  if (consignmentID === void 0 && ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.parentJobs) && data.data.parentJobs.length > 0) {
    const parentJob = data.data.parentJobs.filter(
      (parentJob2) => {
        var _a2;
        return ((_a2 = parentJob2.relatedJob) == null ? void 0 : _a2.jobTypeSystemName) === "Consignment";
      }
    );
    if (parentJob.length > 0 && ((_b = parentJob[0].relatedJob) == null ? void 0 : _b.id)) {
      consignmentID = parentJob[0].relatedJob.id.toString();
    }
  }
  const {
    isLoading: consignmentIsLoading,
    isError: consignmentIsError,
    data: consignmentData,
    error: consignmentError
  } = useQuery$1(
    ["Consignment", consignmentID],
    () => httpService$1.get(`Consignment/${consignmentID}`),
    {
      enabled: !!consignmentID
    }
  );
  const {
    isLoading: isEventsLoading,
    isError: isEventsError,
    data: eventsData,
    error: eventsError
  } = useQuery$1(
    ["SupplyChainMember/List", jobID],
    () => {
      var _a2;
      return httpService$1.get("SupplyChainMember/List", {
        supplyChainID: (_a2 = data == null ? void 0 : data.data) == null ? void 0 : _a2.supplyChainID
      });
    },
    {
      enabled: !!(data == null ? void 0 : data.data)
    }
  );
  const [{ isFetching, isError: GridIsError, data: carrierLogoData, error: GridError }] = useGridQuery(
    {
      systemName: "CarrierLogo",
      parameters: {
        contactID: (_d = (_c = data == null ? void 0 : data.data) == null ? void 0 : _c.carrier) == null ? void 0 : _d.contactID
      }
    },
    { cacheTime: 0, enabled: ((_f = (_e = data == null ? void 0 : data.data) == null ? void 0 : _e.carrier) == null ? void 0 : _f.contactID) ? true : false }
  );
  const enabled = !!(carrierLogoData == null ? void 0 : carrierLogoData.data.rows[0].objectAttachmentID);
  const [{ data: carrierLogo }] = useAttachmentDownload(carrierLogoData == null ? void 0 : carrierLogoData.data.rows[0].objectAttachmentID, {
    enabled
  });
  if (carrierLogo && !carrierLogoURL) {
    const reader = new FileReader();
    reader.onloadend = () => setCarrierLogoURL(reader.result);
    reader.readAsDataURL(carrierLogo);
  }
  const events = useMemo(() => {
    if ((eventsData == null ? void 0 : eventsData.data) && eventsData.data.length > 0) {
      const groupedEvents = getCDBGroupMilestiones(eventsData.data);
      const dispatchedEvent = eventsData.data.find((event) => event.eventName === "Dispatched");
      const milestoneEvents = [
        getLatestCDBGroupedMilestone(groupedEvents.ordered),
        getLatestCDBGroupedMilestone(groupedEvents.dispatched),
        getLatestCDBGroupedMilestone(groupedEvents.delivered)
      ];
      if (milestoneEvents[2].isCompleted) {
        milestoneEvents[1].milestoneName = milestoneEvents[1].milestoneName = "Dispatched";
        milestoneEvents[1].completedDate = dispatchedEvent ? dispatchedEvent.completedDate : null;
      }
      return milestoneEvents;
    }
    return [];
  }, [eventsData == null ? void 0 : eventsData.data]);
  const currentEventName = useMemo(() => {
    let event = events.findLast((e) => e.isCompleted === true);
    if (event) {
      return event.eventName;
    } else {
      return "New";
    }
  }, [events]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  if (isError || isEventsError) {
    if (error instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        error.message
      ] });
    }
    if (eventsError instanceof Error) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Error: ",
        eventsError.message
      ] });
    }
  }
  const containerPadding = mobileBreakpoint ? 0 : 4;
  const styledTabFontSize = mobileBreakpoint ? "0.9rem" : "16pt";
  const showOrderSummary = hasSummaryPermission && location.pathname === filteredIndexRoute && (consignmentData == null ? void 0 : consignmentData.data);
  const trackingNumber = (_h = (_g = data == null ? void 0 : data.data) == null ? void 0 : _g.trackingNumber) == null ? void 0 : _h.reference;
  const invoiceNumber = (_j = (_i = data == null ? void 0 : data.data) == null ? void 0 : _i.invoiceNumber) == null ? void 0 : _j.reference;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box$1,
      {
        sx: {
          paddingBottom: theme.spacing(4),
          paddingTop: 0,
          paddingX: theme.spacing(mobileBreakpoint ? 1.5 : 0),
          backgroundColor: theme.palette.common.white
        },
        children: mobileBreakpoint ? /* @__PURE__ */ jsx(Fragment, { children: data && /* @__PURE__ */ jsx(Container$1, { maxWidth: "md", style: { position: "relative", paddingTop: theme.spacing(5) }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { variant: "h5", children: currentEventName != null ? currentEventName : "New" }),
          /* @__PURE__ */ jsxs(Stack, { spacing: 4, direction: "row", alignItems: "center", sx: { width: "50%" }, children: [
            /* @__PURE__ */ jsx(
              Box$1,
              {
                flex: 1,
                height: "1.5rem",
                maxHeight: "1.5rem",
                width: "50%",
                style: {
                  backgroundImage: `url(${carrierLogoURL})`,
                  backgroundSize: "contain",
                  backgroundPosition: "left",
                  backgroundRepeat: "no-repeat",
                  position: "absolute",
                  top: 0,
                  right: 0
                }
              }
            ),
            " "
          ] }),
          /* @__PURE__ */ jsx(Typography$1, { children: ((_l = (_k = data == null ? void 0 : data.data) == null ? void 0 : _k.expectedDeliveryDate) == null ? void 0 : _l.dateAndTime) && `${format$1(
            new Date(data.data.expectedDeliveryDate.dateAndTime),
            "MMMM d Y 'at' h:mm aaa"
          )}` }),
          hasTimelinePermission && /* @__PURE__ */ jsx(Box$1, { width: "100%", marginTop: 0, children: /* @__PURE__ */ jsx(
            SupplyChainTimeline,
            {
              events: updateIsCompleted(events),
              isEventCompleted: (event) => event.isCompleted
            }
          ) }),
          /* @__PURE__ */ jsxs(Grid$3, { container: true, children: [
            /* @__PURE__ */ jsx(Grid$3, { item: true, flexGrow: 1, children: trackingNumber && /* @__PURE__ */ jsx(
              Typography$1,
              {
                fontWeight: "bold",
                style: { bottom: 0, left: 0, fontSize: "14px" },
                children: `Tracking No. ${trackingNumber}`
              }
            ) }),
            /* @__PURE__ */ jsx(Grid$3, { item: true, flexGrow: 1, children: ((_n = (_m = data == null ? void 0 : data.data) == null ? void 0 : _m.orderNumber) == null ? void 0 : _n.reference) && /* @__PURE__ */ jsx(
              Typography$1,
              {
                fontWeight: "bold",
                style: { bottom: 0, right: 0, fontSize: "14px" },
                children: `Order No. #${(_p = (_o = data == null ? void 0 : data.data) == null ? void 0 : _o.orderNumber) == null ? void 0 : _p.reference}`
              }
            ) })
          ] })
        ] }) }) }) : /* @__PURE__ */ jsx(Fragment, { children: data && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(
            Box$1,
            {
              style: {
                backgroundImage: "linear-gradient(to right, #D43E32, #9F2C21)",
                backgroundColor: "#0047AB",
                paddingBottom: "10px"
              },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              color: theme.palette.common.white,
              children: [
                /* @__PURE__ */ jsx(Typography$1, { sx: { color: "inherit" }, variant: "h4", children: currentEventName != null ? currentEventName : "New" }),
                !carrierLogoURL && /* @__PURE__ */ jsx(Typography$1, { flex: 1, textAlign: "right", children: `Order No. #${(_r = (_q = data == null ? void 0 : data.data) == null ? void 0 : _q.orderNumber) == null ? void 0 : _r.reference}` }),
                carrierLogoURL && /* @__PURE__ */ jsxs(
                  Stack,
                  {
                    spacing: 4,
                    direction: "row",
                    alignItems: "center",
                    sx: { width: "50%" },
                    children: [
                      /* @__PURE__ */ jsx(Typography$1, { flex: 1, textAlign: "right", children: `Order No. ${(_t = (_s = data == null ? void 0 : data.data) == null ? void 0 : _s.orderNumber) == null ? void 0 : _t.reference}` }),
                      /* @__PURE__ */ jsx(
                        Box$1,
                        {
                          flex: 1,
                          height: "1.5rem",
                          maxHeight: "1.5rem",
                          width: "50%",
                          style: {
                            backgroundImage: `url(${carrierLogoURL})`,
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            backgroundRepeat: "no-repeat"
                          }
                        }
                      )
                    ]
                  }
                ),
                trackingNumber && /* @__PURE__ */ jsx(Typography$1, { children: `Tracking No. ${trackingNumber}` }),
                invoiceNumber && /* @__PURE__ */ jsx(Typography$1, { children: `Invoice No. ${invoiceNumber}` }),
                /* @__PURE__ */ jsx(Typography$1, { children: ((_v = (_u = data == null ? void 0 : data.data) == null ? void 0 : _u.expectedDeliveryDate) == null ? void 0 : _v.dateAndTime) && `${format$1(
                  new Date(data.data.expectedDeliveryDate.dateAndTime),
                  "MMMM d Y 'at' h:mm aaa"
                )}` })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Container$1, { maxWidth: "md", style: { position: "relative", marginTop: theme.spacing(8) }, children: hasTimelinePermission && /* @__PURE__ */ jsx(Box$1, { width: "100%", marginTop: mobileBreakpoint ? 0 : 4, children: /* @__PURE__ */ jsx(
            SupplyChainTimeline,
            {
              events: updateIsCompleted(events),
              isEventCompleted: (event) => event.isCompleted
            }
          ) }) })
        ] }) })
      }
    ),
    /* @__PURE__ */ jsx(
      Stack,
      {
        sx: {
          paddingY: theme.spacing(4)
        },
        children: /* @__PURE__ */ jsx(
          Container$1,
          {
            maxWidth: "md",
            sx: {
              paddingLeft: theme.spacing(containerPadding),
              paddingRight: theme.spacing(containerPadding)
            },
            children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: mobileBreakpoint ? 0 : 4, children: [
              /* @__PURE__ */ jsxs(
                Box$1,
                {
                  sx: {
                    backgroundColor: "#fff",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                  },
                  children: [
                    /* @__PURE__ */ jsxs(
                      Tabs$1,
                      {
                        value: currentTab,
                        onChange: (_, value) => setCurrentTab(value),
                        TabIndicatorProps: { sx: { height: 4 } },
                        sx: {
                          borderBottom: `2px solid${theme.palette.secondary.main}`,
                          "&.Mui-selected": {
                            fontWeight: "600"
                          },
                          "&.MuiTabs-indicator": {
                            height: "3px"
                          }
                        },
                        variant: "scrollable",
                        scrollButtons: "auto",
                        children: [
                          hasTrackingHistoryPermission(auth) && /* @__PURE__ */ jsx(
                            StyledTab,
                            {
                              value: indexRoute,
                              label: "Tracking History",
                              component: Link$1,
                              to: indexRoute,
                              sx: { fontSize: styledTabFontSize }
                            }
                          ),
                          hasTrackingOrderDetailsPermission(auth) && /* @__PURE__ */ jsx(
                            StyledTab,
                            {
                              value: detailsRoute,
                              label: "Order Details",
                              component: Link$1,
                              to: detailsRoute,
                              sx: { fontSize: styledTabFontSize }
                            }
                          ),
                          hasTrackingDocumentsPermission(auth) && /* @__PURE__ */ jsx(
                            StyledTab,
                            {
                              value: documentsRoute,
                              label: "Documents",
                              component: Link$1,
                              to: documentsRoute,
                              sx: { fontSize: styledTabFontSize }
                            }
                          ),
                          hasTrackingPODPermission(auth) && /* @__PURE__ */ jsx(
                            StyledTab,
                            {
                              value: podRoute,
                              label: "Proof of Delivery",
                              component: Link$1,
                              to: podRoute,
                              sx: { fontSize: styledTabFontSize }
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx(Outlet, {})
                  ]
                }
              ),
              showOrderSummary && /* @__PURE__ */ jsx(TrackingOrderSummary, { data: consignmentData.data, title: "Consignment Details" })
            ] })
          }
        )
      }
    )
  ] });
}

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __async$9 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Context$a = createContext({});
const TransportType = {
  PortalContainerTransportJob: "PortalContainerTransportJob",
  PortalTransportJob: "PortalTransportJob"
};
const TransportJobType = {
  EmptyContainerDelivery: TransportType.PortalContainerTransportJob,
  PackedContainerPickup: TransportType.PortalContainerTransportJob,
  LCLAirPickup: TransportType.PortalTransportJob,
  FullContainerDelivery: TransportType.PortalContainerTransportJob,
  EmpyContainerPickup: TransportType.PortalTransportJob,
  LCLAirDelivery: TransportType.PortalTransportJob
};
const gridFontSize$1 = "0.75rem";
function gridParamaters(jobType, filters, organisations) {
  var _a, _b, _c, _d, _e, _f;
  const queryParameters = {
    jobType,
    origin: filters.origin.length ? filters.origin.map((x) => x.id) : null,
    destination: filters.destination.length ? filters.destination.map((x) => x.id) : null,
    mode: (_b = (_a = filters == null ? void 0 : filters.mode) == null ? void 0 : _a.id) != null ? _b : null,
    searchTerm: (_c = filters == null ? void 0 : filters.searchTerm) != null ? _c : null,
    status: (_f = (_e = (_d = filters == null ? void 0 : filters.status) == null ? void 0 : _d.additionalData) == null ? void 0 : _e.systemName) != null ? _f : null,
    pendingOnly: getPendingOnly(filters.pendingOnly),
    additionalFilter: organisations && organisations.length > 0 ? JSON.stringify({
      organisationIDs: organisations
    }) : null
  };
  return queryParameters;
}
function DesktopDashboardFilters() {
  const { form } = useContext(Context$a);
  const { reset } = form;
  const handleOnReset = () => {
    reset();
  };
  return /* @__PURE__ */ jsx(Grid$4, { container: true, spacing: 2, alignItems: "center", children: /* @__PURE__ */ jsx(Grid$4, { item: true, md: 12, children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 2, children: [
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 2, children: /* @__PURE__ */ jsx(FormInput, { name: "searchTerm", placeholder: "Search" }) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 2, children: /* @__PURE__ */ jsx(
      FormPortLocationLookup,
      {
        name: "origin",
        placeholder: "Origin",
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 2, children: /* @__PURE__ */ jsx(
      FormPortLocationLookup,
      {
        name: "destination",
        placeholder: "Destination",
        multiple: true,
        disableClearOnSelect: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 1, children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: "mode",
        params: {
          systemName: "TransportMode",
          additionalFilter: { type: "Transport" }
        },
        placeholder: "Mode"
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 2, children: /* @__PURE__ */ jsx(
      FormLookup,
      {
        name: "status",
        params: {
          systemName: "Status",
          additionalFilter: JSON.stringify({
            type: ["Job"]
          })
        },
        placeholder: "Status"
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, md: 3, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormCheckbox,
        {
          name: "pendingOnly",
          label: /* @__PURE__ */ jsx(
            Typography,
            {
              fontSize: "0.9rem",
              color: (theme) => theme.palette.primary.main,
              fontWeight: "600",
              children: "Pending Only"
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, children: [
        /* @__PURE__ */ jsx(Button$1, { type: "submit", variant: "contained", color: "primary", children: "Apply" }),
        /* @__PURE__ */ jsx(
          Button$1,
          {
            type: "button",
            variant: "contained",
            color: "primary",
            onClick: () => handleOnReset(),
            children: "Reset"
          }
        )
      ] })
    ] }) })
  ] }) }) });
}
const DateReferenceCell$2 = (dateFieldValue, dateFieldFormat) => {
  const dateFormat = dateFieldFormat != null ? dateFieldFormat : "DD MMM YYYY";
  const date = dateFieldValue ? formatDate$2(dateFieldValue, dateFormat) : null;
  return /* @__PURE__ */ jsx(Fragment$1, { children: date }, "__static");
};
const TransportGridColumns = ({
  hyperlinkRefs,
  handleAction
}) => {
  const shipmentHref = defaultValue(hyperlinkRefs == null ? void 0 : hyperlinkRefs.shipment, (id) => `/Shipment/${id}`);
  const orderHref = defaultValue(hyperlinkRefs == null ? void 0 : hyperlinkRefs.order, (id) => `/Order/${id}`);
  const handleBooked = (row) => {
    if (typeof handleAction === "function") {
      return handleAction(row);
    }
  };
  const getActionColumns = (row) => {
    switch (row.statusSystemName) {
      case SystemName.Status.BookingRequested:
        return /* @__PURE__ */ jsx(
          Typography,
          {
            sx: {
              color: (theme) => theme.palette.secondary.main,
              fontSize: gridFontSize$1
            },
            children: "Booking Requested"
          }
        );
      case SystemName.Status.BookingConfirmed:
        return /* @__PURE__ */ jsx(
          Typography,
          {
            sx: {
              color: (theme) => theme.palette.secondary.main,
              fontSize: gridFontSize$1
            },
            children: "Booking Confirmed"
          }
        );
      default:
        return /* @__PURE__ */ jsx(
          Button$1,
          {
            type: "submit",
            variant: "contained",
            color: "primary",
            sx: {
              fontSize: gridFontSize$1,
              padding: "2px 8px"
            },
            onClick: () => handleBooked(row),
            children: "Book"
          }
        );
    }
  };
  return [
    {
      field: "containerNumber",
      flex: 1,
      headerName: "CONTAINER #",
      disableColumnMenu: true
    },
    {
      field: "containerType",
      flex: 1,
      headerName: "CNT TYPE",
      disableColumnMenu: true
    },
    {
      field: "orderNumber",
      flex: 1,
      headerName: "ORDER #",
      disableColumnMenu: true,
      renderCell: (params) => {
        return /* @__PURE__ */ jsx("div", { children: params.row.orders && JSON.parse(params.row.orders).map((order) => {
          return /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
            Hyperlink,
            {
              to: orderHref(order.ChildJobID),
              sx: {
                color: (theme) => theme.palette.secondary.main,
                textDecorationColor: (theme) => theme.palette.secondary.main,
                fontSize: gridFontSize$1,
                fontWeight: 500
              },
              target: "_blank",
              children: order.Reference
            }
          ) });
        }) });
      }
    },
    {
      field: "shipmentNumber",
      flex: 1,
      headerName: "SHIPMENT #",
      disableColumnMenu: true,
      renderCell: (params) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
        Hyperlink,
        {
          to: shipmentHref(params.row.shipmentID),
          sx: {
            color: (theme) => theme.palette.secondary.main,
            textDecorationColor: (theme) => theme.palette.secondary.main,
            fontSize: gridFontSize$1,
            fontWeight: 500
          },
          target: "_blank",
          children: params.row.shipmentNumber
        }
      ) })
    },
    {
      field: "status",
      flex: 1,
      disableColumnMenu: true,
      headerName: "STATUS",
      renderCell: ({ value }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(
        Box,
        {
          paddingY: 1,
          paddingX: 2,
          bgcolor: "primary.main",
          borderRadius: (theme) => theme.shape.borderRadius,
          textAlign: "center",
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              fontSize: "0.7rem",
              lineHeight: 1,
              color: (theme) => theme.palette.common.white,
              textTransform: "uppercase",
              children: value
            }
          )
        }
      ) })
    },
    {
      field: "mode",
      flex: 1,
      disableColumnMenu: true,
      headerName: "MODE",
      maxWidth: 100
    },
    {
      field: "origin",
      flex: 1,
      disableColumnMenu: true,
      headerName: "ORIGIN",
      renderCell: ({ value }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(Flag, { country: "AU" }),
        value
      ] }) })
    },
    {
      field: "destination",
      flex: 1,
      disableColumnMenu: true,
      headerName: "DESTINATION",
      renderCell: ({ value }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(Flag, { country: "NZ" }),
        value
      ] }) })
    },
    {
      field: "requestedDateTime",
      flex: 1,
      headerName: "REQUESTED DATE & TIME",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell$2(value);
      }
    },
    {
      field: "confirmedDateTime",
      flex: 1,
      headerName: "CONFIRMED DATE & TIME",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell$2(value);
      }
    },
    {
      field: "actions",
      type: "actions",
      flex: 1,
      renderCell: (params) => {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          " ",
          getActionColumns(params.row)
        ] });
      }
    }
  ];
};
const getPendingOnly = (pendingOnly) => {
  switch (pendingOnly) {
    case true:
      return 1;
    case false:
      return 0;
    default:
      return null;
  }
};
function ModalInputLabel$1({ name, label }) {
  return /* @__PURE__ */ jsx(
    Label,
    {
      name,
      label,
      style: {
        fontSize: "0.85rem",
        fontWeight: 600,
        color: (theme) => theme.palette.common.black,
        marginBottom: "0.5rem"
      }
    }
  );
}
const fetchDataErrorMessage = "An error has occurred while fetching the data, please try again!";
const getLocationData = (transportJobDetails, type) => {
  var _a, _b;
  const transportType = TransportJobType[type];
  let location;
  switch (transportType) {
    case TransportType.PortalTransportJob:
      location = (_a = transportJobDetails == null ? void 0 : transportJobDetails.pickupAddress) != null ? _a : null;
      break;
    case TransportType.PortalContainerTransportJob:
      location = (_b = transportJobDetails == null ? void 0 : transportJobDetails.deliveryAddress) != null ? _b : null;
      break;
  }
  return location;
};
function TransportModal({ title, type, open, setOpen, jobID, transportJobDetails }) {
  var _a;
  const queryClient = useQueryClient();
  const popup = usePopupAlert();
  const theme = useTheme$2();
  const locationAddress = getLocationData(transportJobDetails, type);
  const [context, Form] = useForm({
    defaultValues: {
      vehicleType: transportJobDetails == null ? void 0 : transportJobDetails.dropMode,
      doorDirection: transportJobDetails == null ? void 0 : transportJobDetails.doorDirection,
      gridLocation: transportJobDetails == null ? void 0 : transportJobDetails.gridLocation,
      address: locationAddress && (locationAddress == null ? void 0 : locationAddress.locationID) == null ? null : locationAddress,
      preferredDateTime: transportJobDetails == null ? void 0 : transportJobDetails.preferredDate,
      comments: (_a = transportJobDetails == null ? void 0 : transportJobDetails.comments) != null ? _a : { note: null },
      isNewAddress: locationAddress && (locationAddress == null ? void 0 : locationAddress.locationID) == null ? true : false,
      newAddress: locationAddress && (locationAddress == null ? void 0 : locationAddress.locationID) == null ? locationAddress == null ? void 0 : locationAddress.address1 : void 0
    }
  });
  const { watch, handleSubmit } = context;
  const isNewAddress = watch("isNewAddress");
  const transportType = TransportJobType[type];
  const eventMutation = useMutation$1({
    mutationKey: [`SupplyChainEvent/${jobID}`],
    mutationFn: (event) => httpService$1.post(`SupplyChainEvent`, __spreadValues$i({}, event)),
    onSuccess: () => {
      popup({
        message: "Your booking has been requested!",
        severity: "success"
      });
      queryClient.invalidateQueries([transportType, jobID]);
      queryClient.invalidateQueries([`SupplyChainEvent/${jobID}`]);
    },
    onError: (err) => {
      console.log("Error", err);
      popup({
        message: `An error has occurred while sending the booking!`,
        severity: "error"
      });
    }
  });
  const transportMutation = useMutation$1({
    mutationKey: [transportType, jobID],
    mutationFn: (payload) => {
      return httpService$1.put(`${transportType}/${jobID}`, __spreadValues$i({}, payload));
    },
    onSuccess: () => {
      return queryClient.invalidateQueries([transportType, jobID]);
    },
    onError: (err) => {
      console.log("Error", err);
      popup({
        message: `An error has occurred while saving!`,
        severity: "error"
      });
    }
  });
  const onSubmit = (data) => __async$9(this, null, function* () {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    const transport = transportJobDetails;
    let formPayload = {
      dropMode: __spreadValues$i(__spreadValues$i({}, transport.dropMode), data.vehicleType),
      doorDirection: __spreadValues$i(__spreadValues$i({}, transport.doorDirection), data.doorDirection),
      gridLocation: __spreadValues$i(__spreadValues$i({}, transport.gridLocation), data.gridLocation),
      preferredDate: __spreadValues$i(__spreadValues$i({}, transport.preferredDate), data.preferredDateTime),
      comments: __spreadValues$i(__spreadValues$i({}, transport.comments), data.comments)
    };
    if (transportType === TransportType.PortalContainerTransportJob) {
      formPayload.deliveryAddress = __spreadValues$i(__spreadValues$i({}, transportJobDetails == null ? void 0 : transportJobDetails.deliveryAddress), data.address);
      if (isNewAddress && data.newAddress && data.newAddress !== "") {
        formPayload.deliveryAddress = {
          id: (_b = (_a2 = transportJobDetails == null ? void 0 : transportJobDetails.deliveryAddress) == null ? void 0 : _a2.id) != null ? _b : null,
          objectID: (_d = (_c = transportJobDetails == null ? void 0 : transportJobDetails.deliveryAddress) == null ? void 0 : _c.objectID) != null ? _d : jobID,
          objectType: (_f = (_e = transportJobDetails == null ? void 0 : transportJobDetails.deliveryAddress) == null ? void 0 : _e.objectType) != null ? _f : "Job",
          locationName: data.newAddress,
          address1: data.newAddress
        };
      }
    }
    if (transportType === TransportType.PortalTransportJob) {
      formPayload.pickupAddress = __spreadValues$i(__spreadValues$i({}, transportJobDetails == null ? void 0 : transportJobDetails.pickupAddress), data.address);
      if (isNewAddress && data.newAddress && data.newAddress !== "") {
        formPayload.pickupAddress = {
          id: (_h = (_g = transportJobDetails == null ? void 0 : transportJobDetails.pickupAddress) == null ? void 0 : _g.id) != null ? _h : null,
          objectID: (_j = (_i = transportJobDetails == null ? void 0 : transportJobDetails.pickupAddress) == null ? void 0 : _i.objectID) != null ? _j : jobID,
          objectType: (_l = (_k = transportJobDetails == null ? void 0 : transportJobDetails.pickupAddress) == null ? void 0 : _k.objectType) != null ? _l : "Job",
          locationName: data.newAddress,
          address1: data.newAddress
        };
      }
    }
    const payload = __spreadValues$i(__spreadValues$i({}, transportJobDetails), formPayload);
    const eventPayload = {
      active: true,
      eventCode: "BookingRequested",
      eventDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      objectID: jobID,
      objectType: "Job",
      supplyChainID: (_m = transportJobDetails.supplyChainID) != null ? _m : null,
      timeZoneID: 85
    };
    yield transportMutation.mutateAsync(payload);
    yield eventMutation.mutateAsync(eventPayload);
  });
  const handleBooking = handleSubmit((data) => {
    onSubmit(data).then(() => {
      setOpen(false);
    }).catch((e) => {
      console.log("Error", e);
    });
  });
  if (transportMutation.isLoading || eventMutation.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(Form, { children: /* @__PURE__ */ jsxs(
    Dialog$1,
    {
      fullWidth: true,
      open,
      onClose: (_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setOpen(false);
        }
      },
      scroll: "paper",
      children: [
        /* @__PURE__ */ jsxs(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: [
              /* @__PURE__ */ jsx(Typography, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: title ? title : type }),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  onClick: () => setOpen(false),
                  sx: {
                    padding: 0
                  },
                  edge: "end",
                  color: "inherit",
                  "aria-label": "close",
                  children: /* @__PURE__ */ jsx(Close, { sx: { flexGrow: 1 } })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(DialogContent$1, { children: [
          /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 2, children: [
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "vehicleType", label: "Vehicle Type" }),
              /* @__PURE__ */ jsx(
                CodeLookup,
                {
                  params: {
                    systemName: "Code",
                    additionalFilter: {
                      codeQualifier: "DropMode"
                    }
                  },
                  name: "vehicleType"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 6, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "doorDirection", label: "Door Direction" }),
              /* @__PURE__ */ jsx(
                CodeLookup,
                {
                  params: {
                    systemName: "Code",
                    additionalFilter: {
                      codeQualifier: "DoorDirection"
                    }
                  },
                  name: "doorDirection"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "row", children: [
                /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "gridLocation", label: "Grid/Bay Location" }),
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    style: {
                      fontSize: "0.7rem",
                      color: "grey",
                      marginBottom: "0.45rem",
                      paddingLeft: "0.5rem"
                    },
                    children: "*if applicable"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(NoteInput, { name: "gridLocation", multiline: true })
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "address", label: "Address" }),
              /* @__PURE__ */ jsx(
                LocationLookup,
                {
                  params: {
                    systemName: "Address"
                  },
                  name: "address",
                  disabled: isNewAddress
                }
              ),
              /* @__PURE__ */ jsx(
                FormCheckbox,
                {
                  name: "isNewAddress",
                  label: /* @__PURE__ */ jsx(Typography, { fontSize: "0.9rem", color: (theme2) => theme2.palette.primary.main, children: "New Address" })
                }
              ),
              isNewAddress && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "address", label: "New Address" }),
                /* @__PURE__ */ jsx(FormInput, { name: "newAddress" })
              ] })
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 12, md: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "preferredDateTime", label: "Preferred Date & Time" }),
              /* @__PURE__ */ jsx(DateTimeInput, { timePicker: true, name: "preferredDateTime" })
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(ModalInputLabel$1, { name: "comments", label: "Comments" }),
              /* @__PURE__ */ jsx(NoteInput, { name: "comments", multiline: true, minRows: 2 })
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            DialogActions$1,
            {
              style: { justifyContent: "space-between", paddingTop: theme.spacing(2), paddingLeft: 0 },
              children: /* @__PURE__ */ jsx(Button$1, { type: "submit", variant: "contained", color: "primary", onClick: handleBooking, children: "Book" })
            }
          )
        ] })
      ]
    }
  ) });
}
function _NeedContainers({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.EmptyContainerDelivery, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function NeedContainersGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c, _d;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.Containers, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.EmptyContainerDelivery;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_c = (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows) != null ? _c : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && transportJobQuery.isSuccess && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          setOpen: setIsOpenBookingDialog,
          title: "Empty Container Delivery",
          transportJobDetails: (_d = transportJobQuery.data) == null ? void 0 : _d.data
        }
      ),
      document.body
    )
  ] });
}
function _PackedContainers({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.PackedContainerPickup, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function PackedContainersGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c, _d;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.PackedContainers, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.PackedContainerPickup;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_c = (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows) != null ? _c : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          setOpen: setIsOpenBookingDialog,
          title: "Packed Container Pickup",
          transportJobDetails: (_d = transportJobQuery.data) == null ? void 0 : _d.data
        }
      ),
      document.body
    )
  ] });
}
function _Deliveries({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.FullContainerDelivery, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function DeliveriesGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.Deliveries, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.FullContainerDelivery;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data.rows) != null ? _b : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          setOpen: setIsOpenBookingDialog,
          title: "Full Container Delivery",
          transportJobDetails: (_c = transportJobQuery.data) == null ? void 0 : _c.data
        }
      ),
      document.body
    )
  ] });
}
function _EmptyContainers({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.EmpyContainerPickup, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function EmptyContainersGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.EmptyContainer, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.EmpyContainerPickup;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data.rows) != null ? _b : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          setOpen: setIsOpenBookingDialog,
          title: "Empty Container Pickup",
          transportJobDetails: (_c = transportJobQuery.data) == null ? void 0 : _c.data
        }
      ),
      document.body
    )
  ] });
}
function _LCLPickups({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.LCLAirPickup, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function LCLPickupGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.LCLPickup, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.LCLAirPickup;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data.rows) != null ? _b : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          setOpen: setIsOpenBookingDialog,
          title: "LCL Air Pickup",
          transportJobDetails: (_c = transportJobQuery.data) == null ? void 0 : _c.data
        }
      ),
      document.body
    )
  ] });
}
function _LCLDeliveries({ children }) {
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const queryParameters = useMemo(
    () => gridParamaters(SystemName.JobType.LCLAirDelivery, filters, organisations),
    [formState.submitCount, filters, organisations]
  );
  const [query] = useGridQuery(
    {
      systemName: "Transport",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const count = useMemo(() => {
    var _a, _b;
    return defaultValue((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows.length, 0);
  }, [query == null ? void 0 : query.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ query, count }) : children });
}
function LCLDeliveriesGrid({ hyperlinkRefs, components, gridColumns, query }) {
  var _a, _b, _c;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const containerGridColumn = defaultValue(gridColumns == null ? void 0 : gridColumns.LCLDelivery, TransportGridColumns);
  const [isOpenBookingDialog, setIsOpenBookingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const type = SystemName.JobType.LCLAirDelivery;
  const transportType = TransportJobType[type];
  const transportJobQuery = useQuery$1(
    [transportType, selectedRow == null ? void 0 : selectedRow.jobID],
    () => httpService$1.get(`${transportType}/${selectedRow == null ? void 0 : selectedRow.jobID}`),
    {
      enabled: !!(selectedRow == null ? void 0 : selectedRow.jobID),
      cacheTime: 0
    }
  );
  const handleOpenBookingDialog = (row) => {
    setSelectedRow(row);
    if (!transportJobQuery.isFetching) {
      setIsOpenBookingDialog(true);
    }
  };
  if (transportJobQuery.isError) {
    popup({
      message: fetchDataErrorMessage,
      severity: "error"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: containerGridColumn({
            hyperlinkRefs,
            handleAction: (row) => handleOpenBookingDialog(row)
          }),
          rows: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data.rows) != null ? _b : [],
          loading: query.isFetching,
          getRowId: () => v4(),
          hideFooter: true,
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            fontSize: gridFontSize$1,
            "--DataGrid-overlayHeight": "45px"
          },
          autoHeight: true
        }
      )
    ] }),
    isOpenBookingDialog && createPortal(
      /* @__PURE__ */ jsx(
        TransportModal,
        {
          open: isOpenBookingDialog,
          type,
          shipmentID: selectedRow == null ? void 0 : selectedRow.shipmentID,
          jobID: selectedRow == null ? void 0 : selectedRow.jobID,
          setOpen: setIsOpenBookingDialog,
          title: "LCL Air Delivery",
          transportJobDetails: (_c = transportJobQuery.data) == null ? void 0 : _c.data
        }
      ),
      document.body
    )
  ] });
}
function TransportBase({ children }) {
  const [context, Form] = useForm({
    defaultValues: {
      origin: [],
      destination: []
    }
  });
  return /* @__PURE__ */ jsx(Context$a.Provider, { value: { form: context }, children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children }) });
}
const NeedContainers = Object.assign(_NeedContainers, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(_NeedContainers, { children: (props) => /* @__PURE__ */ jsx(NeedContainersGrid, __spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props)) }))
});
const PackedContainers = Object.assign(_PackedContainers, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(_PackedContainers, { children: (props) => /* @__PURE__ */ jsx(PackedContainersGrid, __spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props)) }))
});
const Deliveries = Object.assign(_Deliveries, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(_Deliveries, { children: (props) => /* @__PURE__ */ jsx(DeliveriesGrid, __spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props)) }))
});
const EmptyContainers = Object.assign(_EmptyContainers, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(_EmptyContainers, { children: (props) => /* @__PURE__ */ jsx(EmptyContainersGrid, __spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props)) }))
});
const LCLPickup = Object.assign(_LCLPickups, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(_LCLPickups, { children: (props) => /* @__PURE__ */ jsx(LCLPickupGrid, __spreadValues$i(__spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props), props)) }))
});
const LCLDeliveries = Object.assign(_LCLDeliveries, {
  Grid: React__default$1.memo(({ hyperLinkRefs }) => /* @__PURE__ */ jsx(
    _LCLDeliveries,
    {
      children: (props) => /* @__PURE__ */ jsx(LCLDeliveriesGrid, __spreadValues$i(__spreadValues$i({ hyperlinkRefs: hyperLinkRefs }, props), props))
    }
  ))
});
const TransportPage = Object.assign(TransportBase, {
  DesktopDashboardFilters,
  NeedContainers,
  PackedContainers,
  Deliveries,
  EmptyContainers,
  LCLPickup,
  LCLDeliveries
});
const useTransportPageContext = () => {
  return useContext(Context$a);
};

var __defProp$h = Object.defineProperty;
var __defProps$f = Object.defineProperties;
var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
var __async$8 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Context$9 = createContext({});
const checkOverdue = (params) => {
  var _a;
  const currentDate = /* @__PURE__ */ new Date();
  const dueDateValue = new Date((_a = params.row.dueDate) != null ? _a : "");
  const status = params.row.status;
  if (status === "Pending" || status === "Unpaid" || status === "Overdue") {
    if (currentDate > dueDateValue) {
      return true;
    }
  }
  return false;
};
const invoiceCreditColumns = ({ handleAction }) => {
  const popup = usePopupAlert();
  const auth = useAuth();
  const canEnquire = auth.userHasPermission("apI_Accounts", "Enquire_Invoice");
  const handleEnquiry = defaultValue(handleAction, noop$6);
  const handleDownload = (data) => __async$8(void 0, null, function* () {
    if (data.attachmentID) {
      try {
        const fileDownload = yield httpService$1.download(`Attachment/Download/${data.attachmentID}`);
        const fileUrl = URL.createObjectURL(fileDownload);
        const windowObject = window.open(fileUrl);
        if (windowObject) {
          windowObject.onpagehide = () => {
            URL.revokeObjectURL(fileUrl);
          };
        }
      } catch (e) {
        popup({
          message: `An error occurred downloading the file: ${data.attachmentFileName}`,
          severity: "error"
        });
        return;
      }
    }
  });
  const columns = [
    {
      field: "invoiceNumber",
      flex: 1,
      headerName: "INVOICE #",
      disableColumnMenu: true
    },
    {
      field: "invoiceType",
      flex: 1,
      headerName: "TYPE",
      disableColumnMenu: true,
      valueFormatter: ({ value }) => value == null ? void 0 : value.toLocaleUpperCase()
    },
    {
      field: "shipmentNumber",
      flex: 1,
      headerName: "SHIPMENT #",
      disableColumnMenu: true
    },
    {
      field: "currencyCode",
      flex: 1,
      headerName: "CURRENCY",
      disableColumnMenu: true
    },
    {
      field: "amount",
      flex: 1,
      headerName: "AMOUNT",
      disableColumnMenu: true,
      valueFormatter: ({ value }) => value ? value < 0 ? `-$${Math.abs(value)}` : `$${value}` : value
    },
    {
      field: "dueDate",
      flex: 1,
      headerName: "DUE DATE",
      disableColumnMenu: true,
      valueFormatter: ({ value }) => value ? dayjs(value).format("DD MMM YYYY") : value
    },
    {
      field: "generatedDate",
      flex: 1,
      headerName: "GENERATED DATE",
      disableColumnMenu: true,
      valueFormatter: ({ value }) => value ? dayjs(value).format("DD MMM YYYY") : value
    },
    {
      field: "status",
      flex: 0,
      width: 125,
      headerName: "STATUS",
      disableColumnMenu: true,
      renderCell: ({ value }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", style: { width: "100%" }, children: /* @__PURE__ */ jsx(
        Box$1,
        {
          width: "100%",
          paddingY: 1,
          paddingX: 2,
          bgcolor: (theme) => value === "Overdue" ? theme.palette.error.main : theme.palette.primary.main,
          borderRadius: (theme) => theme.shape.borderRadius,
          textAlign: "center",
          children: /* @__PURE__ */ jsx(
            Typography$1,
            {
              fontSize: "0.75rem",
              lineHeight: 1,
              color: (theme) => theme.palette.common.white,
              textTransform: "uppercase",
              children: value
            }
          )
        }
      ) })
    },
    {
      field: "attachmentFileName",
      flex: 0,
      headerName: "DOCUMENT",
      disableColumnMenu: true,
      width: 175,
      renderCell: (params) => {
        return /* @__PURE__ */ jsx(Fragment, { children: params.row.attachmentFileName && params.row.attachmentFileName !== "" && /* @__PURE__ */ jsx(
          Button,
          {
            endIcon: /* @__PURE__ */ jsx(FileDownload, {}),
            variant: "outlined",
            color: "primary",
            onClick: (e) => {
              e.stopPropagation();
              handleDownload(params.row);
            },
            sx: { width: "100%" },
            children: /* @__PURE__ */ jsx(
              Typography$1,
              {
                fontSize: "0.75rem",
                sx: {
                  color: (theme) => theme.palette.common.black,
                  paddingLeft: 1,
                  paddingRight: 1
                },
                children: params.row.attachmentFileName
              }
            )
          }
        ) });
      }
    }
  ];
  if (canEnquire) {
    columns.push({
      field: "actions",
      type: "actions",
      maxWidth: 50,
      getActions: ({ row }) => [
        /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Tooltip, { title: "Enquire", children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
          GridActionsCellItem$1,
          {
            label: "Enquire",
            icon: /* @__PURE__ */ jsx(HelpOutline, { color: "primary" }),
            onClick: () => handleEnquiry({
              invoices: [{ invoiceID: row == null ? void 0 : row.invoiceID, invoiceNumber: row == null ? void 0 : row.invoiceNumber }]
            })
          }
        ) }) }) })
      ]
    });
  }
  return columns;
};
function InvoiceCreditGrid({ components, handleSendInvoiceEnquiry }) {
  var _a, _b, _c;
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const handleSendEnquiryButton = defaultValue(handleSendInvoiceEnquiry, noop$6);
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const amountRangeMin = typeof (filters == null ? void 0 : filters.amountRangeMin) !== "number" ? defaultValue(filters == null ? void 0 : filters.amountRangeMin, null) : filters == null ? void 0 : filters.amountRangeMin;
  const amountRangeMax = typeof (filters == null ? void 0 : filters.amountRangeMax) !== "number" ? defaultValue(filters == null ? void 0 : filters.amountRangeMax, null) : filters == null ? void 0 : filters.amountRangeMax;
  const queryParameters = useMemo(
    () => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
      return {
        searchTerm: (_a2 = filters == null ? void 0 : filters.searchTerm) != null ? _a2 : null,
        invoiceType: (_b2 = filters == null ? void 0 : filters.type) != null ? _b2 : null,
        status: (_e = (_d = (_c2 = filters == null ? void 0 : filters.status) == null ? void 0 : _c2.additionalData) == null ? void 0 : _d.systemName) != null ? _e : null,
        dueDateFrom: ((_f = filters == null ? void 0 : filters.dueDateFrom) == null ? void 0 : _f.dateAndTime) && dayjs((_g = filters == null ? void 0 : filters.dueDateFrom) == null ? void 0 : _g.dateAndTime).isValid() ? dayjs((_h = filters == null ? void 0 : filters.dueDateFrom) == null ? void 0 : _h.dateAndTime).format("YYYY-MM-DD") : null,
        dueDateTo: ((_i = filters == null ? void 0 : filters.dueDateTo) == null ? void 0 : _i.dateAndTime) && dayjs((_j = filters == null ? void 0 : filters.dueDateTo) == null ? void 0 : _j.dateAndTime).isValid() ? dayjs((_k = filters == null ? void 0 : filters.dueDateTo) == null ? void 0 : _k.dateAndTime).format("YYYY-MM-DD") : null,
        generatedDateFrom: ((_l = filters == null ? void 0 : filters.generatedDateFrom) == null ? void 0 : _l.dateAndTime) && dayjs((_m = filters == null ? void 0 : filters.generatedDateFrom) == null ? void 0 : _m.dateAndTime).isValid() ? dayjs((_n = filters == null ? void 0 : filters.generatedDateFrom) == null ? void 0 : _n.dateAndTime).format("YYYY-MM-DD") : null,
        generatedDateTo: ((_o = filters == null ? void 0 : filters.generatedDateTo) == null ? void 0 : _o.dateAndTime) && dayjs((_p = filters == null ? void 0 : filters.generatedDateTo) == null ? void 0 : _p.dateAndTime).isValid() ? dayjs((_q = filters == null ? void 0 : filters.generatedDateTo) == null ? void 0 : _q.dateAndTime).format("YYYY-MM-DD") : null,
        amountRange: amountRangeMin === null && amountRangeMax === null ? null : JSON.stringify([amountRangeMin, amountRangeMax]),
        currency: (_r = filters == null ? void 0 : filters.currency) != null ? _r : null,
        additionalFilter: organisations && organisations.length > 0 ? JSON.stringify({
          organisationIDs: organisations
        }) : null
      };
    },
    [formState.submitCount, filters]
  );
  const [{ isFetching, data: query }] = useGridQuery(
    {
      systemName: "Accounts",
      parameters: queryParameters
    },
    { cacheTime: 0 }
  );
  const [isOpenEnquireDialog, setIsOpenEnquireDialog] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState({ invoices: [] });
  const [rowSelected, setRowSelected] = useState([]);
  const handleOpenEnquireDialog = ({ invoices }) => {
    if (!invoices || invoices.length === 0) {
      popup({
        message: "Please select at least one invoice to enquire upon",
        severity: "warning"
      });
      return;
    }
    setSelectedInvoice({ invoices });
    setIsOpenEnquireDialog(true);
  };
  const handleDownload = (data) => __async$8(this, null, function* () {
    try {
      const fileDownload = yield httpService$1.download(`Attachment/Download/${data.attachmentID}`);
      const fileUrl = URL.createObjectURL(fileDownload);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileUrl;
      downloadLink.download = data.attachmentFileName;
      downloadLink.click();
      window.URL.revokeObjectURL(fileUrl);
    } catch (e) {
      popup({
        message: `An error occurred downloading the file ${data.attachmentFileName}`,
        severity: "error"
      });
      return;
    }
  });
  const handleDownloadAll = (data) => {
    var _a2;
    const selectedInvoices = (_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.rows.filter((row) => rowSelected.includes(row.invoiceID));
    if (data && selectedInvoices) {
      selectedInvoices.forEach((document2) => {
        handleDownload(document2);
      });
    }
    if ((selectedInvoices == null ? void 0 : selectedInvoices.length) === 0) {
      popup({
        message: "Please select at least one invoice to download",
        severity: "warning"
      });
      return;
    }
  };
  const onRowSelectionHandler = (selectionModel) => {
    var _a2;
    const selectedInvoices = (_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.rows.filter((row) => selectionModel.includes(row.invoiceID));
    setRowSelected(selectionModel);
    if (selectedInvoices) {
      setSelectedInvoice({ invoices: selectedInvoices });
    }
  };
  const handleCloseEnquireDialog = () => {
    setSelectedInvoice({ invoices: [] });
    setRowSelected([]);
    setIsOpenEnquireDialog(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box$1, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
      /* @__PURE__ */ jsx(GridToolbar, { apiRef }),
      /* @__PURE__ */ jsx(
        DataGridPro,
        {
          apiRef,
          columns: invoiceCreditColumns({
            handleAction: ({ invoices }) => {
              handleOpenEnquireDialog({ invoices });
            }
          }),
          rows: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.rows) != null ? _b : [],
          loading: isFetching,
          getRowId: (row) => row.invoiceID,
          getRowHeight: () => "auto",
          getRowClassName: (params) => checkOverdue(params) ? "MuiError" : "",
          density: "compact",
          sx: {
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: theme.palette.primary.main,
              fontWeight: 600
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
            "& .MuiError": {
              color: theme.palette.error.main
            },
            fontSize: "0.85rem"
          },
          checkboxSelection: true,
          onRowSelectionModelChange: (ids) => onRowSelectionHandler(ids),
          rowSelectionModel: rowSelected,
          autoHeight: true,
          hideFooter: true
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", justifyContent: "flex-end", marginTop: 4, children: /* @__PURE__ */ jsx(
      InvoiceCreditButtons,
      {
        onClickEnquire: () => {
          handleOpenEnquireDialog(selectedInvoice);
        },
        onClickDownload: () => {
          var _a2;
          handleDownloadAll((_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.rows);
        }
      }
    ) }),
    isOpenEnquireDialog && createPortal(
      /* @__PURE__ */ jsx(
        EnquireModal,
        {
          open: isOpenEnquireDialog,
          enquireDefaultValues: {
            invoices: (_c = selectedInvoice == null ? void 0 : selectedInvoice.invoices) != null ? _c : [],
            preferredContact: "phone"
          },
          setOpen: handleCloseEnquireDialog,
          handleSendInvoiceEnquiry: handleSendEnquiryButton
        }
      ),
      document.body
    )
  ] });
}
const enquireModalValidation = z$1.object({
  invoices: z$1.array(z$1.object({ invoiceID: z$1.number(), invoiceNumber: z$1.string() })),
  reason: z$1.object({
    codeID: z$1.number(),
    name: z$1.string(),
    code: z$1.string().optional(),
    lookupDisplayText: z$1.string()
  }).nullable(),
  comments: z$1.string({
    invalid_type_error: "Please provide comments on your enquiry",
    required_error: "Please provide comments on your enquiry"
  })
}).and(
  z$1.discriminatedUnion("preferredContact", [
    z$1.object({
      preferredContact: z$1.literal("phone"),
      preferredContactphone: z$1.string({
        invalid_type_error: "Please provide a phone number",
        required_error: "Please provide a phone number"
      }).min(1, "Please provide a phone number"),
      preferredContactemail: z$1.string().email("Please provide a valid email address").nullable()
    }),
    z$1.object({
      preferredContact: z$1.literal("email"),
      preferredContactphone: z$1.string().nullable(),
      preferredContactemail: z$1.string({
        invalid_type_error: "Please provide an email address",
        required_error: "Please provide an email address"
      }).email("Please provide a valid email address")
    })
  ])
);
function EnquireModal({ open, setOpen, enquireDefaultValues, handleSendInvoiceEnquiry }) {
  var _a;
  const theme = useTheme$2();
  const onSubmitHandler = (state) => {
    if (typeof handleSendInvoiceEnquiry === "function") {
      handleSendInvoiceEnquiry(state);
    }
    void setOpen(false);
  };
  const [context, Form] = useForm({
    defaultValues: enquireDefaultValues,
    onSubmit: onSubmitHandler,
    validationSchema: enquireModalValidation
  });
  const {
    watch,
    trigger,
    formState: { submitCount }
  } = context;
  useEffect(() => {
    const subscription = watch((_, { name }) => {
      if (name === "preferredContact" && submitCount > 0) {
        void trigger(["preferredContactphone", "preferredContactemail"]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, trigger, submitCount]);
  const invoiceValue = (_a = enquireDefaultValues.invoices) == null ? void 0 : _a.map((invoice) => invoice.invoiceNumber).join(", ");
  const preferredContactOptions = [
    { value: "phone", label: "Phone", hasTextField: true, customComponent: FormPhoneInput },
    { value: "email", label: "Email", hasTextField: true }
  ];
  return /* @__PURE__ */ jsxs(
    Dialog$1,
    {
      fullWidth: true,
      open,
      onClose: (_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setOpen(false);
        }
      },
      scroll: "paper",
      children: [
        /* @__PURE__ */ jsxs(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: [
              /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: "Enquire" }),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  onClick: () => setOpen(false),
                  sx: {
                    padding: 0
                  },
                  edge: "end",
                  color: "inherit",
                  "aria-label": "close",
                  children: /* @__PURE__ */ jsx(Close, { sx: { flexGrow: 1 } })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Form, { children: [
          /* @__PURE__ */ jsx(DialogContent$1, { children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 2, children: [
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 8, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "invoice", label: "Invoice" }),
              /* @__PURE__ */ jsx(Input$2, { name: "invoice", value: invoiceValue, readOnly: true })
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 8, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "reason", label: "Reason" }),
              /* @__PURE__ */ jsx(
                CodeLookup,
                {
                  name: "reason",
                  params: {
                    systemName: "Code",
                    additionalFilter: {
                      codeQualifier: "InvoiceEnquiryReason"
                    }
                  },
                  renderOption: (props, option) => {
                    var _a2;
                    return /* @__PURE__ */ jsx("li", __spreadProps$f(__spreadValues$h({}, props), { children: (_a2 = option.additionalData) == null ? void 0 : _a2.codeName }));
                  },
                  getLookupDisplayText: (option) => {
                    var _a2;
                    return defaultValue((_a2 = option.additionalData) == null ? void 0 : _a2.codeName, option.name);
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sm: 8, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "comments", label: "Comments", required: true }),
              /* @__PURE__ */ jsx(FormInput, { name: "comments", multiline: true, minRows: 4 })
            ] }),
            /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: [
              /* @__PURE__ */ jsx(InputLabel, { name: "preferredContact", label: "Preferred Contact", required: true }),
              /* @__PURE__ */ jsx(RadioGroupField, { name: "preferredContact", options: preferredContactOptions })
            ] })
          ] }) }),
          /* @__PURE__ */ jsx(DialogActions$1, { sx: { padding: 4 }, children: /* @__PURE__ */ jsx(Button, { type: "submit", variant: "contained", color: "primary", children: "Send" }) })
        ] })
      ]
    }
  );
}
function InvoiceCreditButtons({
  onClickEnquire,
  onClickDownload
  // onClickExport,
  // onClickPay
}) {
  const auth = useAuth();
  const canEnquire = auth.userHasPermission("apI_Accounts", "Enquire_Invoice");
  const handleOnClickEnquire = defaultValue(onClickEnquire, noop$6);
  const handleOnClickDownload = defaultValue(onClickDownload, noop$6);
  return /* @__PURE__ */ jsxs(Box$1, { height: "inherit", display: "flex", flexDirection: "row", gap: 2, children: [
    canEnquire && /* @__PURE__ */ jsx(
      Button,
      {
        startIcon: /* @__PURE__ */ jsx(HelpOutline, { sx: { color: (theme) => theme.palette.primary.main } }),
        variant: "outlined",
        color: "primary",
        onClick: () => handleOnClickEnquire(),
        children: "Enquire"
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        startIcon: /* @__PURE__ */ jsx(FileDownload, { sx: { color: (theme) => theme.palette.primary.main } }),
        variant: "outlined",
        color: "primary",
        onClick: () => handleOnClickDownload(),
        children: "Download Files"
      }
    )
  ] });
}
function InvoiceCreditFilters() {
  const { form } = useContext(Context$9);
  const { reset } = form;
  return /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, rowGap: 2, children: [
    /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "Search", label: "Search" }),
        /* @__PURE__ */ jsx(FormInput, { name: "searchTerm", placeholder: "Search" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "type", label: "Type" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "type",
            params: {
              systemName: "InvoiceType"
            },
            placeholder: "Show all"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "dueDateFrom", label: "Due Date From" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "dueDateFrom", required: true })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "dueDateTo", label: "Due Date To" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "dueDateTo", required: true })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "generatedDateFrom", label: "Generated Date From" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "generatedDateFrom", required: true })
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "generatedDateTo", label: "Generated Date To" }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "generatedDateTo", required: true })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "status", label: "Status" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "status",
            params: {
              systemName: "Status",
              additionalFilter: {
                type: ["JournalHeader"]
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 8, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "amountRange", label: "Invoice amount range" }),
        /* @__PURE__ */ jsx(RangeInput, { name: "amountRange" })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 6, children: /* @__PURE__ */ jsxs(Grid$4, { container: true, spacing: 4, children: [
      /* @__PURE__ */ jsxs(Grid$4, { item: true, xs: 4, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "currency", label: "Currency" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "currency",
            params: {
              systemName: "Code",
              additionalFilter: {
                codeQualifier: "CurrencyCode"
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Grid$4, { item: true, xs: 8, display: "flex", children: /* @__PURE__ */ jsxs(Box$1, { width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end", gap: 2, children: [
        /* @__PURE__ */ jsx(Button, { type: "submit", variant: "contained", color: "primary", children: "Apply" }),
        /* @__PURE__ */ jsx(Button, { type: "button", variant: "contained", color: "primary", onClick: () => reset(), children: "Reset" })
      ] }) })
    ] }) })
  ] });
}
function AccountsPageBase({ children }) {
  const [context, Form] = useForm({});
  return /* @__PURE__ */ jsx(Context$9.Provider, { value: { form: context }, children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children }) });
}
const AccountsPage = Object.assign(AccountsPageBase, {
  InvoiceCreditFilters,
  InvoiceCreditGrid,
  InvoiceCreditButtons
});
const useAccountsPage = () => {
  return useContext(Context$9);
};

var __defProp$g = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
var __objRest$9 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function IncotermLookup(_a) {
  var _b = _a, { incoterm, disabled, name } = _b, props = __objRest$9(_b, ["incoterm", "disabled", "name"]);
  const theme = useTheme$2();
  const [showDescription, setShowDescription] = useState(false);
  const handleDescriptionMouseEnter = () => {
    setShowDescription(true);
  };
  const handleDescriptionMouseLeave = () => {
    setShowDescription(false);
  };
  var description = getTerm((incoterm == null ? void 0 : incoterm.code) || "");
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, sx: { width: "90%" }, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, sx: { width: "90%" }, children: [
      /* @__PURE__ */ jsx(
        CodeLookup,
        __spreadProps$e(__spreadValues$g({}, props), {
          name: name != null ? name : "incoterm",
          params: {
            systemName: "Code",
            additionalFilter: {
              codeQualifier: "Incoterm"
            }
          },
          sx: { width: "90%" },
          disabled
        })
      ),
      /* @__PURE__ */ jsx(
        IconButton,
        {
          sx: { padding: 0 },
          onMouseEnter: handleDescriptionMouseEnter,
          onMouseLeave: handleDescriptionMouseLeave,
          children: /* @__PURE__ */ jsx(InfoOutlined, { color: "primary" })
        }
      )
    ] }),
    showDescription && incoterm && /* @__PURE__ */ jsx(Box$1, { position: "relative", children: /* @__PURE__ */ jsx(Box$1, { position: "absolute", sx: { zIndex: 2, top: "calc(-44%)" }, children: /* @__PURE__ */ jsxs(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        bgcolor: theme.palette.common.white,
        border: 1,
        borderColor: theme.palette.grey[200],
        sx: {
          boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`,
          maxWidth: "700px",
          minWidth: "300px",
          zIndex: 2
        },
        padding: 4,
        marginTop: 2,
        maxWidth: "1000px",
        children: [
          /* @__PURE__ */ jsx(Typography$1, { fontWeight: 600, fontSize: "1rem", paddingBottom: 1, children: incoterm.name }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize: ".9rem", children: description })
        ]
      }
    ) }) })
  ] });
}

var __defProp$f = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
const parseNumber = (value, pattern) => {
  return (value.match(pattern) || []).join(EMPTY_STRING$g);
};
function OrderLines$2({ form, disabled, error, helperText }) {
  const apiRef = useGridApiRef();
  const { setValue, watch, formState } = useFormContext();
  watch("estimatedVolume");
  watch("estimatedWeight");
  const orderLines = useFieldArray({
    control: form.control,
    keyName: "__id",
    name: "orderLinesLCL"
  });
  const onAddRow = () => {
    orderLines.append({
      uuid: v4(),
      ordered: 1
    });
  };
  const onSetEditCellValue = ({ id, field, value }) => {
    const index = orderLines.fields.findIndex((x) => x.uuid === id);
    orderLines.update(index, __spreadProps$d(__spreadValues$f({}, orderLines.fields[index]), { [field]: value }));
  };
  const onWeightChangeCellValue = ({ id, field, value }) => {
    const index = orderLines.fields.findIndex((x) => x.uuid === id);
    orderLines.update(index, __spreadProps$d(__spreadValues$f({}, orderLines.fields[index]), { [field]: value }));
    let totalWeight = 0;
    const sanitizedCurrentValue = value.replace(",", "");
    orderLines.fields.forEach((line, idx) => {
      if (idx !== index && line.weight && !isNaN(parseFloat(line.weight.toString().replace(",", "")))) {
        const sanitizedValue = line.weight.toString().replace(",", "");
        const weightInt = parseFloat(sanitizedValue);
        totalWeight += weightInt;
      }
    });
    if (!isNaN(parseFloat(sanitizedCurrentValue))) {
      const updatedWeightInt = parseFloat(sanitizedCurrentValue);
      totalWeight += updatedWeightInt;
    }
    setValue("estimatedWeight.measure", totalWeight);
  };
  const onVolumeChangeCellValue = ({ id, field, value }) => {
    const index = orderLines.fields.findIndex((x) => x.uuid === id);
    orderLines.update(index, __spreadProps$d(__spreadValues$f({}, orderLines.fields[index]), { [field]: value }));
    let totalVolume = 0;
    const sanitizedCurrentValue = value.replace(",", "");
    orderLines.fields.forEach((line, idx) => {
      if (idx !== index && line.volume && !isNaN(parseFloat(line.volume.toString().replace(",", "")))) {
        const sanitizedValue = line.volume.toString().replace(",", "");
        const volumeInt = parseFloat(sanitizedValue);
        totalVolume += volumeInt;
      }
    });
    if (!isNaN(parseFloat(sanitizedCurrentValue))) {
      const updatedVolumeInt = parseFloat(sanitizedCurrentValue);
      totalVolume += updatedVolumeInt;
    }
    setValue("estimatedVolume.measure", totalVolume);
  };
  const removeRow = (index) => {
    var totalVolume = 0;
    orderLines.fields.forEach((line, idx) => {
      if (idx !== index && line.volume && !isNaN(line.volume)) {
        totalVolume += line.volume;
      }
    });
    setValue("estimatedVolume.measure", totalVolume);
    var totalWeight = 0;
    orderLines.fields.forEach((line, idx) => {
      if (idx !== index && line.weight && !isNaN(line.weight)) {
        totalWeight += line.weight;
      }
    });
    setValue("estimatedWeight.measure", totalWeight);
    orderLines.remove(index);
  };
  const accept = /[\d.]+/g;
  const decimalPlaces = 4;
  const onMeasureApplyEdit = (input) => {
    const parsed = parseNumber(input, accept);
    const [head, tail] = parsed.split(".");
    const truncatedTail = !isNothing(tail) ? tail.slice(0, decimalPlaces) : EMPTY_STRING$g;
    const number = Number.parseFloat(`${head}.${truncatedTail}`);
    if (Number.isNaN(number)) {
      return EMPTY_STRING$g;
    }
    const formatted = number.toLocaleString(window.navigator.language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimalPlaces
    });
    if (parsed.includes(".")) {
      const [formattedHead] = formatted.split(".");
      const formattedTail = truncatedTail !== EMPTY_STRING$g && truncatedTail[decimalPlaces - 1] === "0" ? truncatedTail.slice(0, -1) : truncatedTail;
      return `${formattedHead}.${formattedTail}`;
    }
    return formatted;
  };
  const columns = [
    {
      field: "sku",
      type: "textinput",
      flex: 1,
      headerName: "SKU",
      disableColumnMenu: true,
      editable: true,
      props: { onSetEditCellValue, disabled }
    },
    {
      field: "description",
      type: "textinput",
      flex: 2,
      headerName: "DESCRIPTION",
      disableColumnMenu: true,
      editable: true,
      props: { onSetEditCellValue, disabled }
    },
    {
      field: "ordered",
      type: "numberinput",
      flex: 1,
      align: "left",
      headerName: "ORDERED",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: true,
      props: { onSetEditCellValue, disabled }
    },
    {
      field: "weight",
      type: "numberinput",
      flex: 1,
      align: "left",
      headerName: "WEIGHT KG",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: true,
      props: {
        onSetEditCellValue: onWeightChangeCellValue,
        onApplyEdit: (input) => onMeasureApplyEdit(input),
        numberInputFormat: (input) => onMeasureApplyEdit(input),
        disabled
      }
    },
    {
      field: "volume",
      type: "numberinput",
      flex: 1,
      align: "left",
      headerName: "VOLUME M\xB3",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: true,
      props: {
        onSetEditCellValue: onVolumeChangeCellValue,
        onApplyEdit: (input) => onMeasureApplyEdit(input),
        numberInputFormat: (input) => onMeasureApplyEdit(input),
        disabled
      }
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 125,
      maxWidth: 125,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      getActions: ({ id }) => {
        const index = orderLines.fields.findIndex((x) => x.__id === id);
        return [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "outlined",
              startIcon: /* @__PURE__ */ jsx(Close, { fontSize: "small" }),
              onClick: () => {
                removeRow(index);
              },
              disabled,
              children: "Remove"
            }
          )
        ];
      }
    }
  ];
  return /* @__PURE__ */ jsx(
    InlineEditGrid,
    {
      apiRef,
      columns,
      rows: orderLines.fields,
      onAddRow,
      disabled,
      error,
      helperText
    }
  );
}

var __defProp$e = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
function OrderContainerLines({ form, disabled, error, helperText, hideAddButton }) {
  const apiRef = useGridApiRef();
  const containers = useFieldArray({
    control: form.control,
    keyName: "__id",
    name: "containerLines"
  });
  const onAddRow = () => {
    containers.append({ uuid: v4(), quantity: 1 });
  };
  const onSetEditCellValue = ({ id, field, value }) => {
    const index = containers.fields.findIndex((x) => x.uuid === id);
    return containers.update(index, __spreadProps$c(__spreadValues$e({}, containers.fields[index]), { [field]: value }));
  };
  const columns = [
    {
      field: "quantity",
      type: "numberinput",
      headerName: "QUANTITY",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: !disabled,
      width: 200,
      props: {
        onSetEditCellValue,
        disabled
      }
    },
    {
      field: "containerType",
      type: "lookup",
      headerName: "CONTAINER TYPE",
      disableColumnMenu: true,
      editable: true,
      width: 300,
      props: {
        params: {
          systemName: "ContainerType"
        },
        onSetEditCellValue,
        optionEqualToValue: (option, value) => {
          var _a, _b;
          return ((_a = option.additionalData) == null ? void 0 : _a.isoCode) === ((_b = value.additionalData) == null ? void 0 : _b.isoCode);
        },
        onApplyEdit: (option, _value) => {
          return defaultValue(option, null);
        },
        disabled
      }
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 125,
      maxWidth: 125,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      getActions: ({ id }) => {
        const index = containers.fields.findIndex((x) => x.uuid === id);
        return [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "outlined",
              startIcon: /* @__PURE__ */ jsx(Close, { fontSize: "small" }),
              onClick: () => {
                containers.remove(index);
              },
              disabled,
              children: "Remove"
            }
          )
        ];
      }
    }
  ];
  return /* @__PURE__ */ jsx(
    InlineEditGrid,
    {
      apiRef,
      columns,
      rows: containers.fields,
      onAddRow,
      disabled,
      error,
      helperText,
      hideAddButton
    }
  );
}

var __defProp$d = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
const cargoDetailsGridTitle$1 = (shipmentType, shipmentMode) => {
  const isLCL = shipmentType === SystemName.ShipmentType.LCL;
  const isAir = shipmentMode === SystemName.ShipmentMode.Air;
  if (isLCL && isAir) {
    return "Air - Cargo Details";
  }
  if (isLCL && !isAir) {
    return getTerm("newEstimate_LCLGrid_Title");
  }
  return getTerm("newEstimate_ContainerGrid_Title");
};
function OrderDetailsForm({ form, disabledFields }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const theme = useTheme$2();
  const { shipmentTypeLookup } = useShipmentOptionLookup();
  const { data: shipmentTypeData } = shipmentTypeLookup;
  const incoterm = form.watch("incoterm");
  const shipmentType = form.watch("shipmentType");
  const shipmentMode = form.watch("shipmentMode");
  const isLCL = ((_a = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _a.code) === SystemName.ShipmentType.LCL;
  const orderLinesFormRequiredError = form.formState.submitCount > 0 && form.getValues("orderLinesLCL").length <= 0;
  const orderLinesFormHelperText = (_d = (_c = (_b = form.formState.errors) == null ? void 0 : _b.orderLinesLCL) == null ? void 0 : _c.message) != null ? _d : "Please provide LCL Details";
  const containerFormRequiredError = form.formState.submitCount > 0 && form.getValues("containerLines").length <= 0;
  const containerFormHelperText = (_g = (_f = (_e = form.formState.errors) == null ? void 0 : _e.containerLines) == null ? void 0 : _f.message) != null ? _g : "Please provide Container Details";
  const [showInfo, setShowInfo] = useState(false);
  const handleIncotermMouseEnter = () => {
    setShowInfo(true);
  };
  const handleIncotermMouseLeave = () => {
    setShowInfo(false);
  };
  return /* @__PURE__ */ jsxs(Stack, { spacing: 8, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingLeft: theme.spacing(4), paddingRight: theme.spacing(4) }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "shipmentMode", label: getTerm("mode"), required: true }),
        /* @__PURE__ */ jsx(
          CodeLookup,
          {
            name: "shipmentMode",
            params: {
              systemName: "Code",
              additionalFilter: {
                codeQualifier: "ShipmentMode"
              }
            },
            onChange: (e, value) => {
              var _a2, _b2;
              if (((_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentMode.Air) {
                const lcl = (_b2 = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _b2.results.find(
                  (x) => {
                    var _a3;
                    return ((_a3 = x.additionalData) == null ? void 0 : _a3.code) === SystemName.ShipmentType.LCL;
                  }
                );
                if (lcl) {
                  form.setValue("shipmentType", __spreadValues$d({}, lcl));
                }
              }
            },
            disabled: disabledFields == null ? void 0 : disabledFields.includes("shipmentMode")
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "shippingOption", label: getTerm("shippingOption"), required: true }),
        /* @__PURE__ */ jsx(
          FormAutocompleteDropdown,
          {
            name: "shipmentType",
            options: ((_h = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _h.results) ? [...shipmentTypeData.data.results] : [],
            disabled: disabledFields == null ? void 0 : disabledFields.includes("shipmentType")
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "25%" }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "incoterm", label: getTerm("incoterm"), required: true }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              sx: { padding: 0 },
              onMouseEnter: handleIncotermMouseEnter,
              onMouseLeave: handleIncotermMouseLeave,
              children: /* @__PURE__ */ jsx(HelpOutlineOutlined, { color: "primary", sx: { width: ".5em", height: ".5em" } })
            }
          ),
          showInfo && /* @__PURE__ */ jsx(Box$1, { position: "relative", children: /* @__PURE__ */ jsx(Box$1, { position: "absolute", sx: { zIndex: 2, top: "calc(-44%)" }, children: /* @__PURE__ */ jsx(
            Box$1,
            {
              display: "flex",
              flexDirection: "column",
              bgcolor: theme.palette.common.white,
              border: 1,
              borderColor: theme.palette.grey[200],
              sx: {
                boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`,
                minWidth: "500px"
              },
              padding: 4,
              marginTop: 2,
              maxWidth: "1000px",
              children: /* @__PURE__ */ jsx(Typography$1, { fontSize: ".9rem", children: getTerm("incotermDescription") })
            }
          ) }) })
        ] }),
        /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 2, children: /* @__PURE__ */ jsx(IncotermLookup, { incoterm, disabled: disabledFields == null ? void 0 : disabledFields.includes("incoterm") }) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsxs(Section, { title: `${getTerm("from")} and ${getTerm("to")}`, sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
            /* @__PURE__ */ jsx(MyLocationOutlined, { color: "primary", sx: { fontSize: "1.15rem" } }),
            /* @__PURE__ */ jsx(InputLabel, { name: "origin", label: getTerm("origin"), required: true })
          ] }),
          /* @__PURE__ */ jsx(
            FormPortLocationLookup,
            {
              name: "portOfOrigin",
              disabled: disabledFields == null ? void 0 : disabledFields.includes("portOfOrigin")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
            /* @__PURE__ */ jsx(LocationOnOutlined, { color: "primary", sx: { fontSize: "1.15rem" } }),
            /* @__PURE__ */ jsx(InputLabel, { name: "destination", label: getTerm("destination"), required: true })
          ] }),
          /* @__PURE__ */ jsx(
            FormPortLocationLookup,
            {
              name: "destinationPort",
              disabled: disabledFields == null ? void 0 : disabledFields.includes("destinationPort")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "supplier", label: getTerm("supplier"), required: true }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "consignor",
              params: {
                systemName: "PortalContact",
                additionalFilter: {
                  contactType: "Consignor"
                }
              },
              disabled: disabledFields == null ? void 0 : disabledFields.includes("consignor"),
              useSearchTerm: true
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "consignee", label: getTerm("consignee"), required: true }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "consignee",
              params: {
                systemName: "PortalContact",
                additionalFilter: {
                  contactType: "Consignee"
                }
              },
              useSearchTerm: true,
              disabled: disabledFields == null ? void 0 : disabledFields.includes("consignee")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "deliveryAddress", label: getTerm("deliveryAddress") }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "deliveryAddress",
              params: {
                systemName: "Location",
                additionalFilter: {
                  locationType: ["Address"]
                }
              },
              useSearchTerm: true,
              disabled: disabledFields == null ? void 0 : disabledFields.includes("deliveryAddress")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "pickupAddress", label: getTerm("pickupAddress") }),
          /* @__PURE__ */ jsx(
            FormLookup,
            {
              name: "pickupAddress",
              params: {
                systemName: "Location",
                additionalFilter: {
                  locationType: ["Address"]
                }
              },
              useSearchTerm: true,
              disabled: disabledFields == null ? void 0 : disabledFields.includes("pickupAddress")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "20%" }, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "expectedReady", label: getTerm("expectedReady") }),
          /* @__PURE__ */ jsx(DateTimeInput, { name: "expectedReady", disabled: disabledFields == null ? void 0 : disabledFields.includes("expectedReady") })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "20%" }, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "requiredintoStore", label: getTerm("requiredintoStore") }),
          /* @__PURE__ */ jsx(
            DateTimeInput,
            {
              name: "requiredIntoStore",
              disabled: disabledFields == null ? void 0 : disabledFields.includes("requiredIntoStore")
            }
          )
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Section, { title: "References", sx: { width: "100%" }, children: /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "20%" }, children: [
        /* @__PURE__ */ jsxs(Stack, { children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "orderNumber", label: getTerm("orderNumber") }),
          /* @__PURE__ */ jsx(ReferenceInput, { name: "orderNumber", disabled: disabledFields == null ? void 0 : disabledFields.includes("orderNumber") })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { spacing: 2, sx: { paddingTop: theme.spacing(4) }, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "additionalReference", label: getTerm("additionalReference") }),
          /* @__PURE__ */ jsx(
            ReferenceInput,
            {
              name: "additionalReference",
              disabled: disabledFields == null ? void 0 : disabledFields.includes("additionalReference")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "20%" }, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "comments", label: getTerm("comments") }),
        /* @__PURE__ */ jsx(NoteInput, { name: "comments", multiline: true, minRows: 5 })
      ] })
    ] }) }) }),
    /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsxs(Section, { title: "Cargo Details", sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "cargoType", label: getTerm("cargoType") }),
          /* @__PURE__ */ jsx(
            CodeLookup,
            {
              name: "cargoType",
              params: {
                systemName: "Code",
                additionalFilter: {
                  codeQualifier: "CargoType"
                }
              },
              disabled: disabledFields == null ? void 0 : disabledFields.includes("shipmentMode")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(
            InputLabel,
            {
              name: "estimatedWeight",
              label: getTerm("estimatedWeight"),
              required: isLCL ? true : false
            }
          ),
          /* @__PURE__ */ jsx(MeasureInput, { name: "estimatedWeight", label: "" })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
          /* @__PURE__ */ jsx(
            InputLabel,
            {
              name: "estimatedVolume",
              label: getTerm("estimatedVolume"),
              required: isLCL ? true : false
            }
          ),
          /* @__PURE__ */ jsx(MeasureInput, { name: "estimatedVolume", label: "" })
        ] })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, children: [
        /* @__PURE__ */ jsx(
          InputLabel,
          {
            name: cargoDetailsGridTitle$1((_i = shipmentType == null ? void 0 : shipmentType.code) != null ? _i : "", (_j = shipmentMode == null ? void 0 : shipmentMode.code) != null ? _j : ""),
            label: cargoDetailsGridTitle$1((_k = shipmentType == null ? void 0 : shipmentType.code) != null ? _k : "", (_l = shipmentMode == null ? void 0 : shipmentMode.code) != null ? _l : ""),
            required: true
          }
        ),
        isLCL ? /* @__PURE__ */ jsx(
          OrderLines$2,
          {
            form,
            error: orderLinesFormRequiredError,
            helperText: orderLinesFormHelperText,
            disabled: disabledFields == null ? void 0 : disabledFields.includes("orderLinesLCL")
          }
        ) : /* @__PURE__ */ jsx(
          OrderContainerLines,
          {
            form,
            error: containerFormRequiredError,
            helperText: containerFormHelperText,
            disabled: disabledFields == null ? void 0 : disabledFields.includes("containerLines")
          }
        )
      ] })
    ] }) })
  ] });
}

function OrderFormControls$1({ handleOnClick, buttonTitle }) {
  return /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOnClick, children: buttonTitle ? buttonTitle : getTerm("newOrder_DialogButton_BackToOrders") });
}

function ModalInputLabel({ name, label, required }) {
  return /* @__PURE__ */ jsx(
    Label,
    {
      name,
      label,
      required,
      style: {
        fontSize: "0.85rem",
        fontWeight: 600,
        color: (theme) => theme.palette.common.black,
        marginBottom: "0.5rem"
      }
    }
  );
}
const validationSchema$2 = z$1.object({
  documentType: z$1.object(
    {
      id: z$1.string(),
      additionalData: z$1.object({
        systemName: z$1.string()
      })
    },
    {
      invalid_type_error: `Please provide select a Document Type`,
      required_error: `Please provide select a Document Type`
    }
  ),
  reference: z$1.string().nullable(),
  attachment: z$1.object({
    data: z$1.string(),
    fileName: z$1.string(),
    type: z$1.string()
  }).optional(),
  name: z$1.string().optional(),
  id: z$1.string().optional()
});
function AddDocumentDialog({
  open,
  onUpload,
  onCancel,
  acceptedFileTypes,
  title = "Add Document",
  documentTypeGroupSystemName
}) {
  const popup = usePopupAlert();
  const theme = useTheme$2();
  const [attachment, setAttachment] = useState();
  const onError = () => popup({ severity: "error", message: "Failed to retrieve Attachment" });
  const [context, Form] = useForm({
    validationSchema: validationSchema$2,
    onError
  });
  const { getValues, reset, formState, handleSubmit } = context;
  const documentValues = getValues();
  const handleOnUpload = handleSubmit((data) => {
    if (attachment) {
      onUpload([
        {
          attachment,
          documentType: documentValues.documentType,
          reference: documentValues.reference,
          name: attachment.fileName,
          id: v4()
        }
      ]);
      reset();
      setAttachment(void 0);
    }
  });
  const onDrop = useCallback((acceptedFiles, fileRejection) => {
    if (fileRejection.length > 0) {
      const errorMessageList = fileValidationHelper.documentFileValidation(
        fileRejection,
        acceptedFileTypes
      );
      popup({
        severity: "error",
        message: errorMessageList
      });
    }
    if (acceptedFiles.length > 0) {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.readAsDataURL(file);
        reader.onload = () => {
          var _a;
          const binaryStr = (_a = reader.result) == null ? void 0 : _a.toString().replace(RegExp("^data:[a-zA-Z]+/[a-zA-Z.-]+;base64,"), "");
          if (binaryStr) {
            setAttachment({
              data: binaryStr,
              fileName: file.name,
              type: file.type
            });
          }
        };
      });
    }
  }, []);
  const handleOnCancel = () => {
    reset();
    setAttachment(void 0);
    onCancel();
  };
  const documentTypeLookupParams = documentTypeGroupSystemName ? {
    systemName: "DocumentType",
    additionalFilter: {
      documentTypeGroup: documentTypeGroupSystemName
    }
  } : {
    systemName: "DocumentType"
  };
  return /* @__PURE__ */ jsxs(
    DialogWrap,
    {
      open,
      onClose: () => handleOnCancel,
      PaperProps: {
        className: "no-overflow",
        style: { overflowY: "inherit" }
      },
      children: [
        /* @__PURE__ */ jsx(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: 300 }, children: title })
          }
        ),
        /* @__PURE__ */ jsx(DialogContent$1, { children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 6, sx: { padding: theme.spacing(2) }, children: [
            /* @__PURE__ */ jsx(ModalInputLabel, { name: "documentType", label: "Document Type", required: true }),
            /* @__PURE__ */ jsx(FormLookup, { params: documentTypeLookupParams, name: "documentType" })
          ] }),
          /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, sm: 6, sx: { padding: theme.spacing(2) }, children: [
            /* @__PURE__ */ jsx(ModalInputLabel, { name: "reference", label: "Reference" }),
            /* @__PURE__ */ jsx(FormInput, { name: "reference" })
          ] }),
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, sx: { padding: theme.spacing(2) }, children: /* @__PURE__ */ jsx(Box$1, { sx: { width: "100%", height: "150px" }, children: /* @__PURE__ */ jsx(
            Dropzone,
            {
              accept: acceptedFileTypes,
              onDrop,
              label: attachment && attachment.fileName ? attachment.fileName : "Drag and drop a file here, or click to select a file"
            }
          ) }) })
        ] }) }) }),
        /* @__PURE__ */ jsxs(DialogActions$1, { children: [
          /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOnCancel, children: "Cancel" }),
          /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOnUpload, type: "submit", children: "Upload" })
        ] })
      ]
    }
  );
}

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$8 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getFileType = (fileType) => {
  switch (fileType) {
    case "msword":
      return "doc";
    case "vnd.ms-excel":
      return "xls";
    case "vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx";
    case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "vnd.ms-outlook":
      return "msg";
    default:
      return fileType;
  }
};
const getUploadDocumentWithAttachments = (uploads) => {
  var _a;
  const { attachment, documentType, reference } = uploads;
  let fileType = attachment.type.substring(attachment.type.indexOf("/") + 1);
  const currentDay = dayjs();
  const timeStamp = currentDay.format("YYYY-MM-DD_hh-mm");
  const documentReference = reference ? `${reference}_${timeStamp}` : `${attachment.fileName}_${timeStamp}`;
  const attachmentFormatSystemName = getFileType(fileType);
  const documentWithAttachments = {
    objectDocument: {
      documentTypeSystemName: (_a = documentType.additionalData) == null ? void 0 : _a.systemName,
      reference: documentReference
    },
    objectAttachments: [
      {
        fileName: attachment.fileName,
        attachmentTypeSystemName: "Document",
        attachmentFormatSystemName: attachmentFormatSystemName.toLowerCase(),
        data: attachment.data
      }
    ]
  };
  return documentWithAttachments;
};
function DocumentUploader({ documentTypeGroupSystemName }) {
  const theme = useTheme$2();
  const { setValue, watch } = useFormContext();
  const [uploadAttachmentOpen, setUploadAttachmentOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const documents = watch("documents");
  const handleOpenUploadButton = () => {
    setUploadAttachmentOpen(true);
  };
  const handleOnUpload = (uploads) => {
    const partialRows = uploads.map((upload) => {
      const _a = upload, rest = __objRest$8(_a, ["attachment"]);
      return __spreadValues$c({}, rest);
    });
    setRows((prevRows) => [...prevRows, ...partialRows]);
    const documentToUpload = uploads.map((upload) => getUploadDocumentWithAttachments(upload));
    const newDocuments = documents ? [...documents, ...documentToUpload] : documentToUpload;
    setValue("documents", newDocuments);
    setUploadAttachmentOpen(false);
  };
  const handleDelete = (id) => {
    const newRows = rows.filter((row) => row.id !== id);
    setRows(newRows);
  };
  const documentsGridColumns = [
    {
      field: "documentType",
      headerName: "Document Type",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        var _a;
        return /* @__PURE__ */ jsx("div", { children: (_a = params.row.documentType) == null ? void 0 : _a.name });
      }
    },
    {
      field: "name",
      headerName: "Filename",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return /* @__PURE__ */ jsx("div", { children: params.row.name });
      }
    },
    {
      field: "reference",
      headerName: "Reference",
      flex: 1,
      renderCell: (params) => {
        return /* @__PURE__ */ jsx("div", { children: params.row.reference });
      }
    },
    {
      field: "actions",
      headerName: "",
      flex: 1,
      renderCell: (params) => {
        return /* @__PURE__ */ jsx(IconButton, { onClick: () => handleDelete(params.row.id), children: /* @__PURE__ */ jsx(Delete, {}) });
      },
      maxWidth: 50,
      disableColumnMenu: true
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Stack, { spacing: 2, sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsx(Stack, { direction: "row", sx: { width: "100%" }, children: /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOpenUploadButton, children: "Upload" }) }),
    /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, sx: { width: "100%" }, children: documents && documents.length > 0 && /* @__PURE__ */ jsx(
      DataGrid$1,
      {
        rows,
        columns: documentsGridColumns,
        autoHeight: true,
        rowSelection: false,
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          }
        },
        hideFooter: true,
        localeText: {
          noRowsLabel: "No documents uploaded"
        }
      }
    ) }),
    /* @__PURE__ */ jsx(
      AddDocumentDialog,
      {
        open: uploadAttachmentOpen,
        onUpload: (uploads) => handleOnUpload(uploads),
        onCancel: () => setUploadAttachmentOpen(false),
        acceptedFileTypes: [
          MimeTypes.pdf,
          MimeTypes.jpeg,
          MimeTypes.doc,
          MimeTypes.docx,
          MimeTypes.png,
          MimeTypes.csv,
          MimeTypes.xls,
          MimeTypes.xlsx,
          MimeTypes.msg
        ],
        documentTypeGroupSystemName
      }
    )
  ] }) });
}

var __defProp$b = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
var __async$7 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const orderPageValidation = z$1.object({
  shipmentMode: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number(),
      lookupDisplayText: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("mode")}`,
      required_error: `Please provide a ${getTerm("mode")}`
    }
  ),
  shipmentType: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("shippingOption")}`,
      required_error: `Please provide a ${getTerm("shippingOption")}`
    }
  ),
  incoterm: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number()
    },
    {
      invalid_type_error: `Please provide an ${getTerm("incoterm")}`,
      required_error: `Please provide an ${getTerm("incoterm")}`
    }
  ),
  portOfOrigin: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string(),
        combinedCode: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("from")} Location`,
      required_error: `Please provide a ${getTerm("from")} Location`
    }
  ),
  destinationPort: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string(),
        combinedCode: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("to")} Location`,
      required_error: `Please provide a ${getTerm("to")} Location`
    }
  ),
  expectedReady: z$1.object(
    {
      dateAndTime: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("goodsReady")} date`,
      required_error: `Please provide a ${getTerm("goodsReady")} date`
    }
  ),
  cargoType: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("cargoType")}`,
      required_error: `Please provide a ${getTerm("cargoType")}`
    }
  ).nullable(),
  estimatedWeight: z$1.object(
    {
      measure: z$1.number()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("estimatedWeight")}`,
      required_error: `Please provide a ${getTerm("estimatedWeight")}`
    }
  ).nullable(),
  estimatedVolume: z$1.object(
    {
      measure: z$1.number()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("estimatedVolume")}`,
      required_error: `Please provide a ${getTerm("estimatedVolume")}`
    }
  ).nullable(),
  containerLines: z$1.array(
    z$1.object({
      quantity: z$1.number(),
      containerType: z$1.object({
        id: z$1.string(),
        name: z$1.string()
      })
    })
  ),
  orderLinesLCL: z$1.array(
    z$1.object({
      ordered: z$1.number(),
      description: z$1.string(),
      weight: z$1.string().transform((val) => {
        return parseFloat(val);
      }),
      volume: z$1.string().transform((val) => {
        return parseFloat(val);
      })
    })
  ),
  consignor: z$1.object(
    {
      id: z$1.string(),
      name: z$1.string(),
      additionalData: z$1.object({
        code: z$1.string()
      })
    },
    {
      invalid_type_error: `Please provide a ${getTerm("supplier")}`,
      required_error: `Please provide a ${getTerm("supplier")}`
    }
  ),
  consignee: z$1.object(
    {
      id: z$1.string(),
      name: z$1.string(),
      additionalData: z$1.object({
        code: z$1.string()
      })
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignee")}`,
      required_error: `Please provide a ${getTerm("consignee")}`
    }
  ),
  deliveryAddress: z$1.object(
    {
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignee")}`,
      required_error: `Please provide a ${getTerm("consignee")}`
    }
  ).nullable(),
  pickupAddress: z$1.object(
    {
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignee")}`,
      required_error: `Please provide a ${getTerm("consignee")}`
    }
  ).nullable(),
  additionalReference: z$1.object(
    {
      reference: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("additionalReference")}`,
      required_error: `Please provide a ${getTerm("additionalReference")}`
    }
  ).nullable(),
  orderNumber: z$1.object(
    {
      reference: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("orderNumber")}`,
      required_error: `Please provide a ${getTerm("orderNumber")}`
    }
  ).nullable(),
  comments: z$1.object(
    {
      note: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("comments")}`,
      required_error: `Please provide a ${getTerm("comments")}`
    }
  ).nullable(),
  requiredIntoStore: z$1.object(
    {
      dateAndTime: z$1.string()
    },
    {
      invalid_type_error: `Please provide the ${getTerm("requiredintoStore")}`,
      required_error: `Please provide the ${getTerm("requiredintoStore")}`
    }
  ).nullable(),
  documents: z$1.array(
    z$1.object({
      objectDocument: z$1.object({
        documentTypeSystemName: z$1.string(),
        reference: z$1.string()
      }),
      objectAttachments: z$1.array(
        z$1.object({
          fileName: z$1.string(),
          attachmentTypeSystemName: z$1.string(),
          attachmentFormatSystemName: z$1.string(),
          data: z$1.any()
        })
      )
    }).optional()
  ).optional()
}).superRefine(({ shipmentType, containerLines, orderLinesLCL }, context) => {
  var _a, _b;
  if (((_a = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _a.code) === SystemName.ShipmentType.FCL && defaultValue(containerLines == null ? void 0 : containerLines.length, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["containerLines"],
      message: "Please provide Container Details"
    });
  }
  if (((_b = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.LCL && defaultValue(orderLinesLCL == null ? void 0 : orderLinesLCL.length, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["orderLinesLCL"],
      message: "Please provide LCL Details"
    });
  }
});
const Context$8 = createContext({});
const createContainerPayload = (state) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const containers = [];
  for (let i = 0; i < state.containerLines.length; i++) {
    for (let j = 0; j < ((_a = state.containerLines[i].quantity) != null ? _a : 0); j++) {
      if (state.containerLines[i].containerType !== void 0 && ((_b = state.containerLines[i].containerType) == null ? void 0 : _b.id) !== null) {
        containers.push({
          typeCode: "Container",
          good: {
            containerType: {
              id: ((_c = state.containerLines[i].containerType) == null ? void 0 : _c.id) ? parseInt((_e = (_d = state.containerLines[i].containerType) == null ? void 0 : _d.id) != null ? _e : "", 10) : void 0,
              name: (_f = state.containerLines[i].containerType) == null ? void 0 : _f.name,
              isoCode: (_h = (_g = state.containerLines[i].containerType) == null ? void 0 : _g.additionalData) == null ? void 0 : _h.isoCode
            },
            active: true
          }
        });
      }
    }
  }
  return containers;
};
const createOrderLinesPayload = (state) => {
  const orderLines = [];
  for (let i = 0; i < state.orderLinesLCL.length; i++) {
    orderLines.push({
      description: {
        value: state.orderLinesLCL[i].description
      },
      sku: {
        reference: state.orderLinesLCL[i].sku
      },
      ordered: {
        measure: state.orderLinesLCL[i].ordered
      },
      weight: {
        measure: state.orderLinesLCL[i].weight
      },
      volume: {
        measure: state.orderLinesLCL[i].volume
      }
    });
  }
  return orderLines;
};
function serializePortalOrder(state) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  var payload;
  payload = {
    active: true,
    orderNumber: {
      reference: (_a = state.orderNumber) == null ? void 0 : _a.reference
    },
    additionalReference: __spreadValues$b({}, state.additionalReference),
    consignee: {
      contactID: (_b = state.consignee) == null ? void 0 : _b.id
    },
    consignor: {
      contactID: (_c = state.consignor) == null ? void 0 : _c.id
    },
    portOfOrigin: {
      locationID: (_d = state.portOfOrigin) == null ? void 0 : _d.id
    },
    destinationPort: {
      locationID: (_e = state.destinationPort) == null ? void 0 : _e.id
    },
    deliveryAddress: ((_f = state.deliveryAddress) == null ? void 0 : _f.id) ? __spreadValues$b({}, state.deliveryAddress) : null,
    pickupAddress: ((_g = state.pickupAddress) == null ? void 0 : _g.id) ? __spreadValues$b({}, state.pickupAddress) : null,
    expectedReady: {
      dateAndTime: (_h = state.expectedReady) == null ? void 0 : _h.dateAndTime
    },
    requiredIntoStore: {
      dateAndTime: (_i = state.requiredIntoStore) == null ? void 0 : _i.dateAndTime
    },
    shipmentType: {
      code: (_k = (_j = state.shipmentType) == null ? void 0 : _j.additionalData) == null ? void 0 : _k.code,
      codeID: (_l = state.shipmentType) == null ? void 0 : _l.id
    },
    shipmentMode: {
      code: (_m = state.shipmentMode) == null ? void 0 : _m.code,
      codeID: (_n = state.shipmentMode) == null ? void 0 : _n.codeID
    },
    incoterm: {
      code: (_o = state.incoterm) == null ? void 0 : _o.code,
      codeID: (_p = state.incoterm) == null ? void 0 : _p.codeID
    },
    cargoType: {
      code: (_q = state.cargoType) == null ? void 0 : _q.code,
      codeID: (_r = state.cargoType) == null ? void 0 : _r.codeID
    },
    estimatedWeight: ((_s = state.estimatedWeight) == null ? void 0 : _s.measure) && ((_t = state.estimatedWeight) == null ? void 0 : _t.measure) > 0 ? __spreadValues$b({}, state.estimatedWeight) : null,
    estimatedVolume: ((_u = state.estimatedVolume) == null ? void 0 : _u.measure) && ((_v = state.estimatedVolume) == null ? void 0 : _v.measure) > 0 ? __spreadValues$b({}, state.estimatedVolume) : null,
    comments: __spreadValues$b({}, state.comments),
    documents: ((_w = state.documents) == null ? void 0 : _w.length) > 0 ? [...state.documents] : null
  };
  if (state.containerLines && state.containerLines.length > 0 && ((_y = (_x = state.shipmentType) == null ? void 0 : _x.additionalData) == null ? void 0 : _y.code) === "FCL") {
    const containersPayload = createContainerPayload(state);
    payload = __spreadProps$b(__spreadValues$b({}, payload), {
      orderLines: [],
      containers: containersPayload
    });
  } else if (state.orderLinesLCL && state.orderLinesLCL.length > 0 && ((_A = (_z = state.shipmentType) == null ? void 0 : _z.additionalData) == null ? void 0 : _A.code) === "LCL") {
    const orderLinesPayload = createOrderLinesPayload(state);
    payload = __spreadProps$b(__spreadValues$b({}, payload), {
      orderLines: orderLinesPayload
    });
  }
  return payload;
}
function OrderDetails$3() {
  const { form } = useContext(Context$8);
  return /* @__PURE__ */ jsx(OrderDetailsForm, { form });
}
function Containers() {
  const { form } = useContext(Context$8);
  return /* @__PURE__ */ jsx(OrderContainerLines, { form });
}
function OrderLines$1() {
  const { form } = useContext(Context$8);
  return /* @__PURE__ */ jsx(OrderLines$2, { form });
}
function OrderFormControls({ handleOnClick }) {
  const { createOrder } = useContext(Context$8);
  const auth = useAuth();
  const onClick = () => {
    if (typeof handleOnClick === "function") {
      return createOrder(handleOnClick);
    }
    return createOrder;
  };
  const canCreateOrder = auth.userHasPermission("apI_PortalOrder", "Write");
  return canCreateOrder ? /* @__PURE__ */ jsx(OrderFormControls$1, { handleOnClick: onClick, buttonTitle: getTerm("newOrder_Button_CreateOrder") }) : /* @__PURE__ */ jsx(Fragment, {});
}
function OrderUploadDocuments({ documentTypeGroupSystemName }) {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Section, { title: "Documents", sx: { width: "100%" }, children: /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(2) }, children: /* @__PURE__ */ jsx(DocumentUploader, { documentTypeGroupSystemName }) }) }) });
}
function OrderBase({ children }) {
  const mutation = useMutation$1(
    ["/PortalOrder"],
    (state) => httpService$1.post("PortalOrder", __spreadValues$b({}, serializePortalOrder(state)))
  );
  const [context, Form] = useForm({
    validationSchema: orderPageValidation,
    defaultValues: {
      containerLines: [],
      orderLinesLCL: []
    }
  });
  const createOrder = (onSuccess, onError) => context.handleSubmit((state) => __async$7(this, null, function* () {
    try {
      yield mutation.mutateAsync(state);
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (e) {
      if (e instanceof Error) {
        if (typeof onError === "function") {
          onError(e);
        }
      }
    }
  }))();
  useEffect(() => {
    const subscription = context.watch(() => {
      if (context.formState.submitCount > 0) {
        context.trigger(["containerLines", "orderLinesLCL"]);
      }
    });
    return () => subscription.unsubscribe();
  }, [context.watch, context.trigger]);
  return /* @__PURE__ */ jsx(
    Context$8.Provider,
    {
      value: {
        form: context,
        createOrder,
        state: {
          isLoading: mutation.isLoading
        }
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const OrderPage = Object.assign(OrderBase, {
  OrderDetails: OrderDetails$3,
  OrderDetailsForm,
  OrderFormControls,
  Containers,
  OrderLines: OrderLines$1,
  OrderUploadDocuments
});
const useOrderPageContext = () => {
  return useContext(Context$8);
};

var __defProp$a = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Skeleton$3 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const Context$7 = createContext({});
const OrderContext = createContext({});
function Map$5(props) {
  var _a, _b, _c, _d, _e, _f;
  const { shipmentQuery } = useContext(OrderContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const shipmentMode = (_b = (_a = shipmentQuery.data) == null ? void 0 : _a.data.shipmentMode) == null ? void 0 : _b.code;
  return /* @__PURE__ */ jsx(
    Map$8,
    __spreadProps$a(__spreadValues$a({}, props), {
      data: (_d = (_c = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _c.data) == null ? void 0 : _d.transportLegs,
      transportComplete: !!((_f = (_e = shipmentQuery.data) == null ? void 0 : _e.data.actualArrival) == null ? void 0 : _f.dateAndTime),
      isAirFreight: shipmentMode === SystemName.ShipmentMode.Air
    })
  );
}
function OrderControls({ subscriptionFormProps, shareMagicLinkProps }) {
  var _a, _b, _c, _d, _e, _f;
  const { query } = useContext(OrderContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const disabled = query.isFetching;
  const watchlist = {
    objectID,
    objectType: "Job",
    isWatchlisted: (_b = query.data) == null ? void 0 : _b.data.isWatchlisted
  };
  const shareMagicLink = shareMagicLinkProps && __spreadValues$a({
    intent: "Order",
    objectId: (_c = query.data) == null ? void 0 : _c.data.id,
    objectType: "Job"
  }, shareMagicLinkProps);
  const orderNumber = (_f = (_e = (_d = query.data) == null ? void 0 : _d.data.orderNumber) == null ? void 0 : _e.reference) != null ? _f : "";
  const subscriptionDialogState = subscriptionFormProps && {
    title: `Subscribe to order ${orderNumber}`,
    subscriptionProps: subscriptionFormProps
  };
  return /* @__PURE__ */ jsx(
    TrackerControls,
    {
      disabled,
      watchlist,
      subscriptionDialog: subscriptionDialogState,
      shareMagicLink
    }
  );
}
function ShipmentDetails$1() {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(ShipmentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(ShipmentDetails$3, { data: (_c = (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data) != null ? _c : (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.data });
}
function AgentDetails$1() {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(AgentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(AgentDetails$3, { data: (_c = (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data) != null ? _c : (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.data });
}
function StaffContacts$1() {
  var _a, _b, _c, _d;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(StaffContactsLoading, {});
  }
  return /* @__PURE__ */ jsx(StaffContacts$3, { data: (_c = (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data) != null ? _c : (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.data, mailToSubject: String((_d = query.data) == null ? void 0 : _d.data.orderNumber) });
}
function ContainerDetails$2() {
  var _a, _b, _c;
  const { query } = useContext(OrderContext);
  const containerDetails = (_c = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.containers) != null ? _c : [];
  const gridRows = containerDetails.map((container) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
    const pieces = (_b2 = (_a2 = container.good) == null ? void 0 : _a2.pieces) == null ? void 0 : _b2.measure;
    const piecesMeasureUnitType = (_d = (_c2 = container.good) == null ? void 0 : _c2.pieces) == null ? void 0 : _d.measureUnitType;
    const actualWeight = (_f = (_e = container.good) == null ? void 0 : _e.gross) == null ? void 0 : _f.measure;
    const actualWeightUnitType = (_h = (_g = container.good) == null ? void 0 : _g.gross) == null ? void 0 : _h.measureUnitType;
    const volume = (_j = (_i = container.good) == null ? void 0 : _i.volume) == null ? void 0 : _j.measure;
    const volumeUnitType = (_l = (_k = container.good) == null ? void 0 : _k.volume) == null ? void 0 : _l.measureUnitType;
    return {
      id: container.id,
      containerNumber: (_n = (_m = container.good) == null ? void 0 : _m.containerAsset) == null ? void 0 : _n.containerNumber,
      type: (_r = (_q = (_p = (_o = container.good) == null ? void 0 : _o.containerAsset) == null ? void 0 : _p.containerType) == null ? void 0 : _q.shortName) != null ? _r : void 0,
      seal: (_s = container.good) == null ? void 0 : _s.sealNumber,
      pieces: pieces && piecesMeasureUnitType ? `${pieces.toLocaleString(window.navigator.language)} ${inflect(piecesMeasureUnitType, pieces)}` : void 0,
      actualWeight: actualWeight && actualWeightUnitType ? `${actualWeight.toLocaleString(window.navigator.language)} ${inflect(actualWeightUnitType, actualWeight)}` : void 0,
      volume: volume && volumeUnitType ? `${volume.toLocaleString(window.navigator.language)} ${inflect(volumeUnitType, volume)}` : void 0
    };
  });
  return /* @__PURE__ */ jsx(ContainerDetails$4, { gridLoading: query.isFetching, gridRows });
}
function DocumentsDetails$3() {
  var _a, _b, _c;
  const { query } = useContext(OrderContext);
  const objectID = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id;
  const documents = useQuery$1(
    ["/Document/DocumentType", objectID],
    () => httpService$1.get(`Document/DocumentType?objectID=${objectID}&objectType=Job`),
    {
      enabled: !!objectID && !query.isFetching
    }
  );
  const gridRows = defaultValue((_c = documents.data) == null ? void 0 : _c.data, []).map((document) => {
    var _a2;
    return {
      filename: document.fileName,
      attachmentID: document == null ? void 0 : document.attachmentID,
      attachmentFormat: document == null ? void 0 : document.attachmentFormat,
      documentID: document.documentID,
      id: document.id,
      objectAttachmentID: document == null ? void 0 : document.objectAttachmentID,
      created: document.created,
      reference: document.reference,
      fileSize: document.fileSize,
      fileType: (_a2 = document.documentTypeName) != null ? _a2 : ""
    };
  });
  return /* @__PURE__ */ jsx(DocumentsDetails$4, { gridLoading: query.isFetching || documents.isFetching, gridRows });
}
function CustomsTimeline$1(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0,
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function TrackingTimeline$3(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (query.isFetching || shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: props.eventCodes.length > 0 ? (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0 : void 0,
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function TransportTimeline$1(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0,
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function VoyageDetails$1() {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(OrderContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(VoyageDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(VoyageDetails$3, { data: (_c = (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data) != null ? _c : (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.data });
}
function OrderDetails$2() {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { query } = useContext(OrderContext);
  const orderId = (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id;
  const orderLines = ((_d = (_c = query == null ? void 0 : query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.orderLines) || [];
  const orderNumber = (_h = (_g = (_f = (_e = query == null ? void 0 : query.data) == null ? void 0 : _e.data) == null ? void 0 : _f.orderNumber) == null ? void 0 : _g.reference) != null ? _h : EMPTY_STRING$g;
  const gridRows = orderId ? orderLines == null ? void 0 : orderLines.map((line) => {
    var _a2, _b2, _c2, _d2, _e2;
    return {
      id: orderId,
      orderNumber,
      sku: (_a2 = line.sku) == null ? void 0 : _a2.reference,
      description: (_c2 = (_b2 = line.description) == null ? void 0 : _b2.value) != null ? _c2 : EMPTY_STRING$g,
      ordered: (_d2 = line.ordered) == null ? void 0 : _d2.measure,
      confirmed: (_e2 = line.confirmed) == null ? void 0 : _e2.measure
    };
  }) : [];
  return /* @__PURE__ */ jsx(OrderDetails$5, { gridLoading: query.isFetching, gridRows });
}
function CommentsDetails$2() {
  var _a, _b;
  const { query } = useContext(OrderContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(CommentsDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(CommentsDetails$3, { comments: (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.comments });
}
function MasonryGrid$1(_a) {
  var _b = _a, {
    gridItem: Item = GridItem$1,
    gridItemProps,
    loadingState = {
      component: GridItemLoading$1,
      count: 6
    },
    sx
  } = _b, rest = __objRest$7(_b, [
    "gridItem",
    "gridItemProps",
    "loadingState",
    "sx"
  ]);
  var _a2, _b2, _c;
  const theme = useTheme$2();
  const { grid } = useContext(Context$7);
  const LoadingItem = defaultValue(loadingState.component, GridItemLoading$1);
  const count = (_c = (_b2 = (_a2 = grid.data) == null ? void 0 : _a2.data.rows.length) != null ? _b2 : loadingState == null ? void 0 : loadingState.count) != null ? _c : 6;
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 400,
    overscan: 2,
    lanes: 2,
    rangeExtractor: (r) => {
      var _a3, _b3, _c2, _d;
      if (count <= 0) {
        return [];
      }
      const itemSize = virtualizer.getVirtualItemForOffset(r.startIndex).size;
      const scrollTop = (_b3 = (_a3 = virtualizerRef.current) == null ? void 0 : _a3.scrollTop) != null ? _b3 : 0;
      const boundingRect = (_c2 = virtualizerRef.current) == null ? void 0 : _c2.getBoundingClientRect();
      const rangeSize = Math.ceil(((_d = boundingRect == null ? void 0 : boundingRect.height) != null ? _d : itemSize) / itemSize * 2);
      const offset = Math.floor(scrollTop / itemSize) * 2;
      const range = [];
      for (let i = offset; i <= Math.min(r.count, offset + rangeSize + r.overscan) - 1; i++) {
        range.push(i);
      }
      return range;
    }
  });
  return /* @__PURE__ */ jsx(
    Box$1,
    __spreadProps$a(__spreadValues$a({
      ref: virtualizerRef,
      height: "0px",
      width: "100%",
      padding: "4px"
    }, rest), {
      sx: __spreadValues$a({
        overflowY: "auto"
      }, sx),
      children: /* @__PURE__ */ jsx(
        Box$1,
        {
          position: "relative",
          height: `${virtualizer.getTotalSize()}px`,
          sx: {
            marginRight: `-${theme.spacing(4)}`,
            marginBottom: `-${theme.spacing(4)}`,
            "& >div": {
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(4)
            }
          },
          children: virtualizer.getVirtualItems().map((virtualRow) => {
            var _a3;
            return /* @__PURE__ */ jsx(
              Box$1,
              {
                "data-index": virtualRow.index,
                ref: virtualizer.measureElement,
                position: "absolute",
                top: 0,
                left: `${virtualRow.lane * 50}%`,
                width: "50%",
                sx: {
                  transform: `translateY(${virtualRow.start}px)`
                },
                children: grid.isFetching && !((_a3 = grid.data) == null ? void 0 : _a3.data) ? /* @__PURE__ */ jsx(LoadingItem, {}) : /* @__PURE__ */ jsx(Item, __spreadValues$a({ data: grid.data.data.rows[virtualRow.index] }, gridItemProps))
              },
              virtualRow.index
            );
          })
        }
      )
    })
  );
}
function GridItem$1({ data, onExpandClick }) {
  const theme = useTheme$2();
  const units = data.ordered && data.orderedUnitOfMeasure ? `${data.ordered.toLocaleString(window.navigator.language)} ${inflect(
    data.orderedUnitOfMeasure,
    data.ordered
  )}` : data.containersCount ? `${data.containersCount.toLocaleString(window.navigator.language)} ${inflect(
    "Container",
    data.containersCount
  )}` : data.ordered;
  const weight = data.weight && data.weightUnitOfMeasure ? `${data.weight.toLocaleString(window.navigator.language)} ${inflect(
    data.weightUnitOfMeasure,
    data.weight
  )}` : data.weight;
  const handleExpandClick = (data2) => (e) => {
    e.stopPropagation();
    if (typeof onExpandClick === "function") {
      onExpandClick(data2);
    }
  };
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
                  /* @__PURE__ */ jsx(InsertDriveFile, { fontSize: "inherit" }),
                  /* @__PURE__ */ jsx(Typography$1, { fontSize: "1.1rem", lineHeight: "1.1rem", fontWeight: 600, children: data.orderNumber })
                ] }),
                /* @__PURE__ */ jsx(
                  Box$1,
                  {
                    alignSelf: "flex-start",
                    paddingY: 1,
                    paddingX: 2,
                    bgcolor: "primary.main",
                    borderRadius: (theme2) => theme2.shape.borderRadius,
                    textAlign: "center",
                    children: /* @__PURE__ */ jsx(
                      Typography$1,
                      {
                        fontSize: "0.75rem",
                        lineHeight: 1,
                        color: (theme2) => theme2.palette.common.white,
                        textTransform: "uppercase",
                        children: data.status
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(
                IconButton,
                {
                  size: "small",
                  title: "Expand to tab",
                  sx: {
                    alignSelf: "flex-end"
                  },
                  onClick: handleExpandClick(data),
                  children: /* @__PURE__ */ jsx(OpenInFullRounded, { fontSize: "inherit" })
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 2, children: data.shipmentID ? /* @__PURE__ */ jsx(
          PortalShipmentSupplyChainTimeline,
          {
            jobID: data.shipmentID,
            supplyChainID: data.shipmentSupplyChainID,
            shipmentMode: defaultValue(data.shipmentMode, SystemName.ShipmentMode.Sea),
            shipmentType: defaultValue(data.shipmentType, SystemName.ShipmentType.FCL),
            estimatedDeparture: data.estimatedDeparture,
            actualDeparture: data.actualDeparture,
            estimatedArrival: data.estimatedArrival,
            actualArrival: data.actualArrival,
            bookingConfirmed: data.bookingConfirmed
          }
        ) : /* @__PURE__ */ jsx(
          PortalOrderSupplyChainTimeline,
          {
            jobID: data.id,
            supplyChainID: data.supplyChainID,
            orderPlaced: data.created,
            estimatedCargoReady: data.expectedReady
          }
        ) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 8, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Shipper" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignor })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Consignee" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignee })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Origin" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.origin })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Destination" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.destination })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Units" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: units })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Weight" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: weight })
          ] })
        ] })
      ]
    }
  );
}
function GridItemLoading$1() {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsx(Skeleton$3, { height: "1.1rem", width: "120px" }),
                /* @__PURE__ */ jsx(
                  Skeleton$3,
                  {
                    height: "22px",
                    width: "45px",
                    sx: { alignSelf: "flex-start", borderRadius: theme.shape.borderRadius }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Skeleton$3, { height: "28px", width: "28px", sx: { alignSelf: "flex-end", borderRadius: "9999px" } }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 3, children: /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" }) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 9, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "55px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "210px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "70px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "40px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "80px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "90px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "45px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "50px" }),
            /* @__PURE__ */ jsx(Skeleton$3, { height: "0.9rem", width: "75px" })
          ] })
        ] })
      ]
    }
  );
}
function _OrderTracker({ id, children }) {
  var _a, _b;
  const query = useQuery$1(
    ["/PortalOrder", id],
    () => httpService$1.get(`PortalOrder/${id}`)
  );
  const portalShipmentJobID = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.shipmentJobID;
  const shipmentQuery = useQuery$1(
    ["/PortalShipment", portalShipmentJobID],
    () => httpService$1.get(`PortalShipment/${portalShipmentJobID}`),
    {
      enabled: !!portalShipmentJobID && !query.isLoading
    }
  );
  return /* @__PURE__ */ jsx(OrderContext.Provider, { value: { query, shipmentQuery }, children });
}
function Base$3({ ids = null, children }) {
  const [gridQuery] = useGridQuery({
    systemName: "PortalOrder",
    parameters: {
      orderIDsJSON: ids
    }
  });
  return /* @__PURE__ */ jsx(
    Context$7.Provider,
    {
      value: {
        grid: gridQuery
      },
      children
    }
  );
}
const Order = Object.assign(_OrderTracker, {
  EventsProgress: () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
    const { shipmentQuery, query } = useContext(OrderContext);
    if (shipmentQuery.isFetching || query.isFetching) {
      return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
    }
    if (!!shipmentQuery.data) {
      return /* @__PURE__ */ jsx(
        PortalShipmentSupplyChainTimeline,
        {
          jobID: (_a = shipmentQuery.data) == null ? void 0 : _a.data.id,
          supplyChainID: (_b = shipmentQuery.data) == null ? void 0 : _b.data.supplyChainID,
          shipmentMode: (_d = (_c = shipmentQuery.data) == null ? void 0 : _c.data.shipmentMode) == null ? void 0 : _d.code,
          shipmentType: (_f = (_e = shipmentQuery.data) == null ? void 0 : _e.data.shipmentType) == null ? void 0 : _f.code,
          estimatedDeparture: (_h = (_g = shipmentQuery.data) == null ? void 0 : _g.data.estimatedDeparture) == null ? void 0 : _h.dateAndTime,
          actualDeparture: (_j = (_i = shipmentQuery.data) == null ? void 0 : _i.data.actualDeparture) == null ? void 0 : _j.dateAndTime,
          estimatedArrival: (_l = (_k = shipmentQuery.data) == null ? void 0 : _k.data.estimatedArrival) == null ? void 0 : _l.dateAndTime,
          actualArrival: (_n = (_m = shipmentQuery.data) == null ? void 0 : _m.data.actualArrival) == null ? void 0 : _n.dateAndTime,
          bookingConfirmed: (_p = (_o = shipmentQuery.data) == null ? void 0 : _o.data.housebill) == null ? void 0 : _p.created
        }
      );
    }
    return /* @__PURE__ */ jsx(
      PortalOrderSupplyChainTimeline,
      {
        jobID: (_q = query.data) == null ? void 0 : _q.data.id,
        supplyChainID: (_r = query.data) == null ? void 0 : _r.data.supplyChainID,
        orderPlaced: (_s = query.data) == null ? void 0 : _s.data.created,
        estimatedCargoReady: (_u = (_t = query.data) == null ? void 0 : _t.data.expectedReady) == null ? void 0 : _u.dateAndTime
      }
    );
  },
  Map: Map$5,
  OrderControls,
  ShipmentDetails: ShipmentDetails$1,
  AgentDetails: AgentDetails$1,
  StaffContacts: StaffContacts$1,
  ContainerDetails: ContainerDetails$2,
  CustomsTimeline: CustomsTimeline$1,
  DocumentsDetails: DocumentsDetails$3,
  OrderDetails: OrderDetails$2,
  TrackingTimeline: TrackingTimeline$3,
  TransportTimeline: TransportTimeline$1,
  VoyageDetails: VoyageDetails$1,
  CommentsDetails: CommentsDetails$2
});
const OrderTrackerPage = Object.assign(Base$3, {
  EventsProgress: PortalOrderSupplyChainTimeline,
  EventsTimeline,
  MasonryGrid: MasonryGrid$1,
  Order
});
const useOrderTrackerContext = () => {
  return useContext(Context$7);
};
const useOrderContext = () => {
  return useContext(OrderContext);
};

function EstimateFormSummary$1({ shipmentType }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  console.log("shipmentType", shipmentType);
  const auth = useAuth();
  const { estimatesForm: Estimate, selectedEstimates } = useEstimatePageContext();
  const estimatesForm = Estimate.context;
  const bookingCarrierPermission = auth.userHasPermission("bookings_Carrier", "Read");
  const formSummary = estimatesForm.getValues();
  const theme = useTheme$2();
  let containerCount = 0;
  (_a = formSummary == null ? void 0 : formSummary.containerLines) == null ? void 0 : _a.forEach((e) => {
    containerCount += e.quantity;
  });
  let lclCount = 0;
  (_b = formSummary == null ? void 0 : formSummary.orderLinesLCL) == null ? void 0 : _b.forEach((e) => {
    lclCount += e.ordered;
  });
  const goodsReadyDate = ((_c = formSummary == null ? void 0 : formSummary.expectedReady) == null ? void 0 : _c.dateAndTime) ? dayjs(new Date(formSummary.expectedReady.dateAndTime)).format("DD MMMM YYYY") : "";
  return /* @__PURE__ */ jsx(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      paddingX: 4,
      marginTop: 2,
      children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, padding: 2, alignItems: "center", children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: (_d = formSummary == null ? void 0 : formSummary.shipmentMode) == null ? void 0 : _d.code }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: shipmentType ? shipmentType : (_e = formSummary == null ? void 0 : formSummary.shipmentType) == null ? void 0 : _e.name }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: (_f = formSummary == null ? void 0 : formSummary.incoterm) == null ? void 0 : _f.code }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        bookingCarrierPermission && /* @__PURE__ */ jsxs(Fragment, { children: [
          " ",
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: (_h = (_g = selectedEstimates == null ? void 0 : selectedEstimates.value) == null ? void 0 : _g.carrier) == null ? void 0 : _h.fullName }) }),
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) })
        ] }),
        /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: "auto",
            display: "flex",
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            children: [
              /* @__PURE__ */ jsx(Typography$1, { children: (_i = formSummary == null ? void 0 : formSummary.portOfOrigin) == null ? void 0 : _i.name }),
              /* @__PURE__ */ jsx(Box$1, { alignSelf: "end", paddingX: 4, marginTop: 2, children: /* @__PURE__ */ jsx(ArrowForward, { color: "primary" }) }),
              /* @__PURE__ */ jsx(Typography$1, { children: (_j = formSummary == null ? void 0 : formSummary.destinationPort) == null ? void 0 : _j.name })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(
          Grid$3,
          {
            item: true,
            xs: "auto",
            display: "flex",
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            children: /* @__PURE__ */ jsx(Typography$1, { children: goodsReadyDate })
          }
        ),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: ((_k = formSummary == null ? void 0 : formSummary.shipmentType) == null ? void 0 : _k.code) === "LCL" ? `${getTerm("newEstimate_Summary_LCL_Header")}: ${lclCount}` : `${getTerm("newEstimate_Summary_Containers_Header")}: ${containerCount}` }) }),
        shipmentType && shipmentType === SystemName.ShipmentType.LCL && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: ((_l = formSummary == null ? void 0 : formSummary.estimatedWeight) == null ? void 0 : _l.measure) + " kg" }) }),
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
          /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography$1, { children: ((_m = formSummary == null ? void 0 : formSummary.estimatedVolume) == null ? void 0 : _m.measure) + "m3" }) })
        ] })
      ] })
    }
  );
}

function EstimatesBreakdownPopup({ open, selectedRowDetails, onClose, title }) {
  var _a;
  const theme = useTheme$2();
  const gridFontSize = "0.75rem";
  const breakdown = (_a = selectedRowDetails == null ? void 0 : selectedRowDetails.breakdown) != null ? _a : [];
  const handleClose = () => {
    onClose();
  };
  const detailstitle = title || "Estimates Breakdown";
  const breakdownColumns = [
    {
      field: "type",
      flex: 1,
      headerName: "Description",
      disableColumnMenu: true,
      minWidth: 300
    },
    {
      field: "rate",
      flex: 1,
      headerName: "Rate",
      disableColumnMenu: true,
      maxWidth: 150,
      renderCell: (params) => {
        var _a2, _b;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: ((_a2 = params.row.rate) == null ? void 0 : _a2.measure) && priceFormatter((_b = params.row.rate) == null ? void 0 : _b.measure).replace("NZD", "") }) });
      }
    },
    {
      field: "quantity",
      flex: 1,
      headerName: "Units",
      disableColumnMenu: true,
      maxWidth: 150,
      renderCell: (params) => {
        var _a2;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: (_a2 = params.row.quantity) == null ? void 0 : _a2.measure }) });
      }
    },
    {
      field: "amount",
      flex: 1,
      headerName: "Amount",
      disableColumnMenu: true,
      maxWidth: 150,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        var _a2, _b;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: ((_a2 = params.row.amount) == null ? void 0 : _a2.measure) && priceFormatter((_b = params.row.amount) == null ? void 0 : _b.measure).replace("NZD", "") }) });
      }
    },
    {
      field: "currency",
      flex: 1,
      headerName: "Currency",
      disableColumnMenu: true,
      maxWidth: 150,
      renderCell: (params) => {
        var _a2;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: (_a2 = params.row.currency) == null ? void 0 : _a2.code }) });
      }
    },
    {
      field: "price",
      flex: 1,
      headerName: "Local Amount",
      disableColumnMenu: true,
      align: "right",
      headerAlign: "right",
      maxWidth: 200,
      renderCell: (params) => {
        var _a2, _b;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: ((_a2 = params.row.price) == null ? void 0 : _a2.measure) && priceFormatter((_b = params.row.price) == null ? void 0 : _b.measure).replace("NZD", "") }) });
      }
    },
    {
      field: "localCurrency",
      flex: 1,
      headerName: "Local Currency",
      disableColumnMenu: true,
      maxWidth: 200,
      renderCell: (params) => {
        var _a2;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: (_a2 = params.row.localCurrency) == null ? void 0 : _a2.code }) });
      }
    },
    {
      field: "exchangeRate",
      flex: 1,
      headerName: "Exchange Rate",
      disableColumnMenu: true,
      maxWidth: 200,
      renderCell: (params) => {
        var _a2;
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", color: "textSecondary", children: (_a2 = params.row.exchangeRate) == null ? void 0 : _a2.measure }) });
      }
    }
  ];
  return /* @__PURE__ */ jsxs(
    Dialog$1,
    {
      open,
      onClose: handleClose,
      fullWidth: true,
      sx: {
        ".MuiDialog-paper": {
          maxWidth: "100%",
          width: "100%"
        }
      },
      children: [
        /* @__PURE__ */ jsx(
          DialogTitle$1,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: theme.palette.common.black
            },
            children: /* @__PURE__ */ jsx(Typography$1, { sx: { fontWeight: 300, fontSize: "1.5rem" }, children: detailstitle })
          }
        ),
        /* @__PURE__ */ jsxs(DialogContent$1, { children: [
          /* @__PURE__ */ jsxs(Box$1, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
            /* @__PURE__ */ jsx(Box$1, { sx: { paddingY: theme.spacing(2) }, children: /* @__PURE__ */ jsx(EstimateFormSummary$1, { shipmentType: selectedRowDetails == null ? void 0 : selectedRowDetails.shippingOption }) }),
            /* @__PURE__ */ jsx(
              DataGridPro,
              {
                columns: breakdownColumns,
                rows: breakdown != null ? breakdown : [],
                getRowId: () => v4(),
                hideFooter: true,
                density: "compact",
                sx: {
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: theme.palette.primary.main,
                    fontWeight: 600
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
                  "--DataGrid-overlayHeight": "45px",
                  fontSize: gridFontSize,
                  "& .MuiDataGrid-cell:focus": {
                    outline: "none"
                  },
                  "& .MuiDataGrid-cell:focus-within": {
                    outline: "none"
                  }
                },
                autoHeight: true
              }
            )
          ] }),
          /* @__PURE__ */ jsx(Box$1, { sx: { padding: theme.spacing(2), alignItems: "center" }, children: /* @__PURE__ */ jsx(Typography$1, { children: getTerm("newEstimate_Summary_Disclaimer_Caption_Text") }) })
        ] }),
        /* @__PURE__ */ jsx(DialogActions$1, { children: /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleClose, children: "Close" }) })
      ]
    }
  );
}

var __defProp$9 = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$6 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Context$6 = createContext({});
const gridFontSize = "0.75rem";
const currentDateTime$1 = dayjs();
const afterWeek$1 = currentDateTime$1.add(7, "day");
const DateReferenceCell$1 = (dateFieldValue, dateFieldFormat) => {
  const dateFormat = dateFieldFormat != null ? dateFieldFormat : "DD MMM YYYY";
  const date = dateFieldValue ? formatDate$2(dateFieldValue, dateFormat) : null;
  return /* @__PURE__ */ jsx(Fragment$1, { children: date }, "__static");
};
const estimatesValidation = z$1.object({
  shipmentMode: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("mode")}`,
      required_error: `Please provide a ${getTerm("mode")}`
    }
  ),
  shipmentType: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("shippingOption")}`,
      required_error: `Please provide a ${getTerm("shippingOption")}`
    }
  ),
  incoterm: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number()
    },
    {
      invalid_type_error: `Please provide an ${getTerm("incoterm")}`,
      required_error: `Please provide an ${getTerm("incoterm")}`
    }
  ),
  portOfOrigin: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string(),
        combinedCode: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("from")} Location`,
      required_error: `Please provide a ${getTerm("from")} Location`
    }
  ),
  destinationPort: z$1.object(
    {
      additionalData: z$1.object({
        code: z$1.string(),
        combinedCode: z$1.string()
      }),
      name: z$1.string(),
      id: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("to")} Location`,
      required_error: `Please provide a ${getTerm("to")} Location`
    }
  ),
  // consignor: z
  // 	.object({
  // 		id: z.string(),
  // 		name: z.string(),
  // 		additionalData: z.object({
  // 			code: z.string(),
  // 			ediCode: z.string().nullable()
  // 		})
  // 	})
  // 	.nullable(),
  // consignee: z
  // 	.object({
  // 		id: z.string(),
  // 		name: z.string(),
  // 		additionalData: z.object({
  // 			code: z.string(),
  // 			ediCode: z.string().nullable()
  // 		})
  // 	})
  // 	.nullable(),
  expectedReady: z$1.object(
    {
      dateAndTime: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("goodsReady")} date`,
      required_error: `Please provide a ${getTerm("goodsReady")} date`
    }
  ),
  cargoType: z$1.object(
    {
      code: z$1.string(),
      codeID: z$1.number()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("cargoType")}`,
      required_error: `Please provide a ${getTerm("cargoType")}`
    }
  ),
  estimatedWeight: z$1.object(
    {
      measure: z$1.preprocess((val) => {
        if (typeof val === "string")
          return parseFloat(val);
        return val;
      }, z$1.number())
    },
    {
      invalid_type_error: `Please provide a ${getTerm("estimatedWeight")}`,
      required_error: `Please provide a ${getTerm("estimatedWeight")}`
    }
  ),
  estimatedVolume: z$1.object(
    {
      measure: z$1.preprocess((val) => {
        if (typeof val === "string")
          return parseFloat(val);
        return val;
      }, z$1.number())
    },
    {
      invalid_type_error: `Please provide a ${getTerm("estimatedVolume")}`,
      required_error: `Please provide a ${getTerm("estimatedVolume")}`
    }
  ),
  containerLines: z$1.array(
    z$1.object({
      quantity: z$1.number(),
      containerType: z$1.object(
        {
          id: z$1.string(),
          name: z$1.string(),
          additionalData: z$1.object({
            isoCode: z$1.string()
          })
        },
        {
          invalid_type_error: `Please provide a Container Type`,
          required_error: `Please provide a Container Type`
        }
      )
    })
  ),
  orderLinesLCL: z$1.array(
    z$1.object({
      ordered: z$1.number(),
      description: z$1.string(),
      weight: z$1.string().transform((val) => {
        return parseFloat(val);
      }),
      volume: z$1.string().transform((val) => {
        return parseFloat(val);
      })
    })
  )
}).superRefine((_0, _1) => __async$6(void 0, [_0, _1], function* ({ shipmentType, containerLines, orderLinesLCL, estimatedWeight, estimatedVolume }, context) {
  var _a, _b, _c, _d, _e;
  if (((_a = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _a.code) === SystemName.ShipmentType.FCL && defaultValue(containerLines == null ? void 0 : containerLines.length, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["containerLines"],
      message: "Please provide Container Details"
    });
  }
  if (((_b = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.LCL) {
    if (defaultValue(orderLinesLCL == null ? void 0 : orderLinesLCL.length, 0) <= 0 && defaultValue(estimatedWeight == null ? void 0 : estimatedWeight.measure, 0) <= 0) {
      context.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["estimatedWeight"],
        message: `Please provide an ${getTerm("estimatedWeight")}`
      });
    }
    if (defaultValue(orderLinesLCL == null ? void 0 : orderLinesLCL.length, 0) <= 0 && defaultValue(estimatedVolume == null ? void 0 : estimatedVolume.measure, 0) <= 0) {
      context.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["estimatedVolume"],
        message: `Please provide an ${getTerm("estimatedVolume")}`
      });
    }
    if (defaultValue(estimatedWeight == null ? void 0 : estimatedWeight.measure, 0) <= 0) {
      context.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["estimatedWeight"],
        message: `Please provide an ${getTerm("estimatedWeight")}`
      });
    }
    if (defaultValue(estimatedVolume == null ? void 0 : estimatedVolume.measure, 0) <= 0) {
      context.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["estimatedVolume"],
        message: `Please provide an ${getTerm("estimatedVolume")}`
      });
    }
  }
  if (((_c = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _c.code) === SystemName.ShipmentType.FCLOrLCL && defaultValue(containerLines == null ? void 0 : containerLines.length, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["containerLines"],
      message: "Please provide Container Details"
    });
  }
  if (((_d = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _d.code) === SystemName.ShipmentType.FCLOrLCL && defaultValue(estimatedWeight == null ? void 0 : estimatedWeight.measure, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["estimatedWeight"],
      message: `Please provide an ${getTerm("estimatedWeight")}`
    });
  }
  if (((_e = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _e.code) === SystemName.ShipmentType.FCLOrLCL && defaultValue(estimatedVolume == null ? void 0 : estimatedVolume.measure, 0) <= 0) {
    context.addIssue({
      code: z$1.ZodIssueCode.custom,
      path: ["estimatedVolume"],
      message: `Please provide an ${getTerm("estimatedVolume")}`
    });
  }
}));
const estimatesGridColumns = [
  {
    field: "shippingOption",
    flex: 1,
    headerName: "SHIPPING OPTION",
    disableColumnMenu: true
  },
  {
    field: "frequency",
    flex: 1,
    headerName: "FREQUENCY",
    disableColumnMenu: true
  },
  {
    field: "transit",
    flex: 1,
    headerName: "TRANSIT",
    disableColumnMenu: true,
    renderCell: ({ value }) => {
      return value && value != "" ? value + " days" : "";
    }
  },
  {
    field: "validity",
    flex: 1,
    headerName: "VALIDITY",
    disableColumnMenu: true,
    renderCell: ({ value }) => {
      return isNothing(value) ? "" : DateReferenceCell$1(removeTimezoneOffset(value));
    }
  }
];
const serializeEstimatesResultsRow = (estimate) => {
  const rows = [];
  estimate.filter((estimate2) => {
    var _a;
    return ((_a = estimate2 == null ? void 0 : estimate2.price) == null ? void 0 : _a.measure) && estimate2.price.measure != null && estimate2.price.measure > 0;
  }).forEach((estimate2) => {
    var _a, _b, _c, _d, _e;
    rows.push({
      uuid: estimate2.uuid,
      carrier: defaultValue((_a = estimate2.carrier) == null ? void 0 : _a.fullName, ""),
      price: (_b = estimate2.price.measure) != null ? _b : 0,
      validity: ((_c = estimate2.expiryDate) == null ? void 0 : _c.dateAndTime) || "",
      shippingOption: ((_e = (_d = estimate2.shipmentType) == null ? void 0 : _d.additionalData) == null ? void 0 : _e.code) || "",
      frequency: estimate2.frequency || "",
      transit: estimate2.transit || "",
      breakdown: estimate2.breakdown
    });
  });
  return rows;
};
const createEstimatesContainerPayload = (state) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const containers = [];
  for (let i = 0; i < state.containerLines.length; i++) {
    for (let j = 0; j < ((_a = state.containerLines[i].quantity) != null ? _a : 0); j++) {
      if (state.containerLines[i].containerType !== void 0 && ((_b = state.containerLines[i].containerType) == null ? void 0 : _b.id) !== null) {
        containers.push({
          typeCode: "Container",
          good: {
            containerAsset: {
              containerType: {
                id: ((_c = state.containerLines[i].containerType) == null ? void 0 : _c.id) ? parseInt((_e = (_d = state.containerLines[i].containerType) == null ? void 0 : _d.id) != null ? _e : "", 10) : void 0,
                name: (_f = state.containerLines[i].containerType) == null ? void 0 : _f.name,
                isoCode: (_h = (_g = state.containerLines[i].containerType) == null ? void 0 : _g.additionalData) == null ? void 0 : _h.isoCode
              },
              active: true
            },
            active: true
          }
        });
      }
    }
  }
  return containers;
};
const findVesselDetails = (legs) => {
  var _a, _b;
  const origin = (_a = legs == null ? void 0 : legs.find((x) => x.eta && x.eta !== "" && !x.etd)) == null ? void 0 : _a.eta;
  const destination = ((_b = legs == null ? void 0 : legs.find((x) => x.etd && x.etd !== "" && !x.eta)) == null ? void 0 : _b.etd) || "";
  const transhipmentLegs = legs == null ? void 0 : legs.filter((x) => x.eta && x.etd);
  const via = transhipmentLegs ? transhipmentLegs.map((x) => x.portName).join(", ") : null;
  return {
    eta: defaultValue(origin, ""),
    etd: defaultValue(destination, ""),
    via
  };
};
function estimatesPayload(state) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  var payload;
  payload = {
    date: ((_a = state.expectedReady) == null ? void 0 : _a.dateAndTime) ? { dateAndTime: state.expectedReady.dateAndTime } : null,
    origin: state.portOfOrigin ? {
      locationID: state.portOfOrigin.id,
      combinedCode: (_b = state.portOfOrigin.additionalData) == null ? void 0 : _b.combinedCode,
      code: (_c = state.portOfOrigin.additionalData) == null ? void 0 : _c.code
    } : null,
    destination: state.destinationPort ? {
      locationID: state.destinationPort.id,
      combinedCode: (_d = state.destinationPort.additionalData) == null ? void 0 : _d.combinedCode,
      code: (_e = state.destinationPort.additionalData) == null ? void 0 : _e.code
    } : null,
    shipmentMode: {
      code: (_g = (_f = state.shipmentMode) == null ? void 0 : _f.code) == null ? void 0 : _g.toLocaleUpperCase(),
      codeID: (_h = state.shipmentMode) == null ? void 0 : _h.codeID
    },
    shipmentType: { code: (_j = (_i = state.shipmentType) == null ? void 0 : _i.additionalData) == null ? void 0 : _j.code, codeID: (_k = state.shipmentType) == null ? void 0 : _k.id },
    incoterm: { code: (_l = state.incoterm) == null ? void 0 : _l.code, codeID: (_m = state.incoterm) == null ? void 0 : _m.codeID },
    totalVolume: ((_n = state.estimatedVolume) == null ? void 0 : _n.measure) && state.estimatedVolume.measure > 0 ? { measure: (_o = state.estimatedVolume) == null ? void 0 : _o.measure } : void 0,
    totalWeight: ((_p = state.estimatedWeight) == null ? void 0 : _p.measure) && state.estimatedWeight.measure > 0 ? { measure: (_q = state.estimatedWeight) == null ? void 0 : _q.measure } : void 0,
    consignee: state.consignee ? { code: (_s = (_r = state.consignee) == null ? void 0 : _r.additionalData) == null ? void 0 : _s.ediCode, codeID: (_t = state.consignee) == null ? void 0 : _t.id } : null,
    organisation: state.organisation ? __spreadValues$9({}, state.organisation) : null,
    cargoType: state.cargoType ? { code: state.cargoType.code, codeID: state.cargoType.id } : null
  };
  if (state.containerLines && state.containerLines.length > 0 && ((_v = (_u = state.shipmentType) == null ? void 0 : _u.additionalData) == null ? void 0 : _v.code) === "FCL") {
    const containerPayload = createEstimatesContainerPayload(state);
    payload.containers = containerPayload;
  }
  return __spreadValues$9({}, payload);
}
function serializePortalOrderFromEstimates(state) {
  var _a, _b, _c, _d, _e, _f, _g;
  var payload;
  const formattedEstimateDetail = state.estimates ? {
    carrier: defaultValue((_b = (_a = state.estimates) == null ? void 0 : _a.carrier) == null ? void 0 : _b.fullName, ""),
    price: ((_d = (_c = state.estimates) == null ? void 0 : _c.price) == null ? void 0 : _d.measure) || 0,
    validity: ((_f = (_e = state.estimates) == null ? void 0 : _e.expiryDate) == null ? void 0 : _f.dateAndTime) || "",
    shippingOption: ((_g = state.shipmentMode) == null ? void 0 : _g.code) || ""
  } : null;
  const estimateDetail = formattedEstimateDetail && formattedEstimateDetail !== null ? Object.entries(formattedEstimateDetail).map(([key, value]) => `${key}: ${value}`).join(", ") : null;
  const orderPayload = serializePortalOrder(state);
  payload = __spreadProps$9(__spreadValues$9({}, orderPayload), {
    estimateDetails: estimateDetail && estimateDetail !== null ? { note: estimateDetail } : null
  });
  return payload;
}
function serializeTransportLegs(transportLegs) {
  const transportLegsPayload = transportLegs == null ? void 0 : transportLegs.map((leg, index) => {
    const lastPort = leg.portCode;
    const nextPort = index + 1 < transportLegs.length ? transportLegs[index + 1].portCode : leg.portCode;
    return {
      transport: __spreadProps$9(__spreadValues$9({}, leg), {
        lastPort: { combinedCode: lastPort },
        nextPort: { combinedCode: nextPort }
      }),
      typeCode: "VesselMovement"
    };
  });
  return transportLegsPayload;
}
function serializePortalShipment(state) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
  var payload;
  let payloadTransport;
  if (((_a = state.shipmentMode) == null ? void 0 : _a.code) && ((_b = state.shipmentMode) == null ? void 0 : _b.code) == SystemName.ShipmentMode.Sea) {
    const seaTransport = (_d = (_c = state == null ? void 0 : state.transport) == null ? void 0 : _c.Sea) == null ? void 0 : _d.value;
    payloadTransport = (seaTransport == null ? void 0 : seaTransport.legs) ? serializeTransportLegs(seaTransport.legs) : null;
  }
  if (((_e = state.shipmentMode) == null ? void 0 : _e.code) && ((_f = state.shipmentMode) == null ? void 0 : _f.code) == SystemName.ShipmentMode.Air) {
    const airTransport = (_h = (_g = state == null ? void 0 : state.transport) == null ? void 0 : _g.Air) == null ? void 0 : _h.value;
    payloadTransport = (airTransport == null ? void 0 : airTransport.legs) ? serializeTransportLegs(airTransport.legs) : null;
  }
  const order = serializePortalOrderFromEstimates(state);
  payload = {
    transportLegs: payloadTransport,
    active: true,
    orders: [__spreadProps$9(__spreadValues$9({}, order), { documents: null })],
    shipmentType: {
      code: (_j = (_i = state.shipmentType) == null ? void 0 : _i.additionalData) == null ? void 0 : _j.code
    },
    shipmentMode: {
      code: (_k = state.shipmentMode) == null ? void 0 : _k.code
    },
    portOfOrigin: {
      locationID: (_l = state.portOfOrigin) == null ? void 0 : _l.id
    },
    destinationPort: {
      locationID: (_m = state.destinationPort) == null ? void 0 : _m.id
    },
    consignor: {
      code: (_o = (_n = state.consignor) == null ? void 0 : _n.additionalData) == null ? void 0 : _o.code,
      codeID: (_p = state.consignor) == null ? void 0 : _p.id
    },
    consignee: {
      code: (_r = (_q = state.consignee) == null ? void 0 : _q.additionalData) == null ? void 0 : _r.code,
      codeID: (_s = state.consignee) == null ? void 0 : _s.id
    },
    totalWeight: ((_t = state.estimatedWeight) == null ? void 0 : _t.measure) && ((_u = state.estimatedWeight) == null ? void 0 : _u.measure) > 0 ? __spreadValues$9({}, state.estimatedWeight) : null,
    totalVolume: ((_v = state.estimatedVolume) == null ? void 0 : _v.measure) && ((_w = state.estimatedVolume) == null ? void 0 : _w.measure) > 0 ? __spreadValues$9({}, state.estimatedVolume) : null,
    documents: ((_x = state.documents) == null ? void 0 : _x.length) > 0 ? [...state.documents] : null
  };
  if (((_y = state.containerLines) == null ? void 0 : _y.length) > 0 && ((_z = state.shipmentType) == null ? void 0 : _z.code) === "FCL") {
    const containersPayload = createContainerPayload(state);
    payload = __spreadProps$9(__spreadValues$9({}, payload), {
      containers: containersPayload
    });
  }
  return payload;
}
function getShippingOption() {
  var _a, _b;
  const { shipmentTypeLookup } = useShipmentOptionLookup();
  const { data: shipmentTypeData } = shipmentTypeLookup;
  const FCL = (_a = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _a.results.find((x) => {
    var _a2;
    return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentType.FCL;
  });
  const LCL = (_b = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _b.results.find((x) => {
    var _a2;
    return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentType.LCL;
  });
  return {
    shipmentTypeLookup,
    FCL,
    LCL
  };
}
function OrderLines() {
  var _a, _b, _c;
  const { estimatesForm } = useContext(Context$6);
  const form = estimatesForm.context;
  const weight = form.getValues("estimatedWeight");
  const volume = form.getValues("estimatedVolume");
  const formRequiredError = form.formState.submitCount > 0 && form.getValues("orderLinesLCL").length <= 0 && defaultValue(weight == null ? void 0 : weight.measure, 0) <= 0 && defaultValue(volume == null ? void 0 : volume.measure, 0) <= 0;
  const formHelperText = (_c = (_b = (_a = form.formState.errors) == null ? void 0 : _a.orderLinesLCL) == null ? void 0 : _b.message) != null ? _c : "Please provide LCL Details";
  return /* @__PURE__ */ jsx(OrderLines$2, { form, error: formRequiredError, helperText: formHelperText });
}
function ContainerLines() {
  var _a, _b, _c;
  const { estimatesForm } = useContext(Context$6);
  const form = estimatesForm.context;
  const formRequiredError = form.formState.submitCount > 0 && form.getValues("containerLines").length <= 0;
  const formHelperText = (_c = (_b = (_a = form.formState.errors) == null ? void 0 : _a.containerLines) == null ? void 0 : _b.message) != null ? _c : "Please provide Container Details";
  const containerLines = form.watch("containerLines");
  return /* @__PURE__ */ jsx(
    OrderContainerLines,
    {
      form,
      error: formRequiredError,
      helperText: formHelperText,
      hideAddButton: containerLines.length >= 1
    }
  );
}
const cargoDetailsGridTitle = (shipmentType, shipmentMode) => {
  const isLCL = shipmentType === SystemName.ShipmentType.LCL;
  const isAir = shipmentMode === SystemName.ShipmentMode.Air;
  if (isLCL && isAir) {
    return "Air - Cargo Details";
  }
  if (isLCL && !isAir) {
    return getTerm("newEstimate_LCLGrid_Title");
  }
  return getTerm("newEstimate_ContainerGrid_Title");
};
function EstimatesCargoDetails() {
  var _a, _b, _c, _d, _e, _f, _g;
  const theme = useTheme$2();
  const { estimatesForm } = useContext(Context$6);
  const form = estimatesForm.context;
  const shipmentType = form.watch("shipmentType");
  const shipmentMode = form.watch("shipmentMode");
  const isLCL = ((_a = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _a.code) === "LCL";
  return /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsxs(Section, { title: "Cargo Details", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "cargoType", label: getTerm("cargoType") }),
        /* @__PURE__ */ jsx(
          CodeLookup,
          {
            name: "cargoType",
            params: {
              systemName: "Code",
              additionalFilter: {
                codeQualifier: "CargoType"
              }
            },
            prefetch: true,
            onDataLoad: (options) => {
              const GEN = options.find((x) => {
                var _a2;
                return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === "GEN";
              });
              if (GEN) {
                form.setValue(
                  "cargoType",
                  {
                    codeID: +GEN.id,
                    name: GEN.name,
                    code: GEN.additionalData.code,
                    lookupDisplayText: GEN.name
                  },
                  {
                    shouldValidate: false
                  }
                );
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(
          InputLabel,
          {
            name: "estimatedWeight",
            label: getTerm("estimatedWeight"),
            required: isLCL ? true : false
          }
        ),
        /* @__PURE__ */ jsx(MeasureInput, { name: "estimatedWeight", label: "" })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(
          InputLabel,
          {
            name: "estimatedVolume",
            label: getTerm("estimatedVolume"),
            required: isLCL ? true : false
          }
        ),
        /* @__PURE__ */ jsx(MeasureInput, { name: "estimatedVolume", label: "" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, children: [
      /* @__PURE__ */ jsx(
        InputLabel,
        {
          name: cargoDetailsGridTitle((_c = (_b = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _b.code) != null ? _c : "", (_d = shipmentMode == null ? void 0 : shipmentMode.code) != null ? _d : ""),
          label: cargoDetailsGridTitle(
            (_f = (_e = shipmentType == null ? void 0 : shipmentType.additionalData) == null ? void 0 : _e.code) != null ? _f : "",
            (_g = shipmentMode == null ? void 0 : shipmentMode.code) != null ? _g : ""
          ),
          required: true
        }
      ),
      isLCL ? /* @__PURE__ */ jsx(OrderLines, {}) : /* @__PURE__ */ jsx(ContainerLines, {})
    ] })
  ] }) });
}
function EstimateLocation() {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(4) }, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
        /* @__PURE__ */ jsx(MyLocationOutlined, { color: "primary", sx: { fontSize: "1.15rem" } }),
        /* @__PURE__ */ jsx(InputLabel, { name: "origin", label: getTerm("origin"), required: true })
      ] }),
      /* @__PURE__ */ jsx(FormPortLocationLookup, { name: "portOfOrigin" })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
        /* @__PURE__ */ jsx(LocationOnOutlined, { color: "primary", sx: { fontSize: "1.15rem" } }),
        /* @__PURE__ */ jsx(InputLabel, { name: "destination", label: getTerm("destination"), required: true })
      ] }),
      /* @__PURE__ */ jsx(FormPortLocationLookup, { name: "destinationPort" })
    ] })
  ] });
}
function EstimateDetails({ locationFieldsComponent }) {
  var _a;
  const theme = useTheme$2();
  const { estimatesForm } = useContext(Context$6);
  const { shipmentTypeLookup } = useShipmentOptionLookup();
  const form = estimatesForm.context;
  const incoterm = form.watch("incoterm");
  const shipmentMode = form.watch("shipmentMode");
  const isAir = (shipmentMode == null ? void 0 : shipmentMode.code) === SystemName.ShipmentMode.Air;
  const [showInfo, setShowInfo] = useState(false);
  const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
  const locationFields = defaultValue(locationFieldsComponent, /* @__PURE__ */ jsx(EstimateLocation, {}));
  const handleIncotermMouseEnter = () => {
    setShowInfo(true);
  };
  const handleIncotermMouseLeave = () => {
    setShowInfo(false);
  };
  const { data: shipmentTypeData, isFetched } = shipmentTypeLookup;
  const presetFCLorLCL = {
    id: "_01",
    name: "FCL or LCL",
    additionalData: { code: "FCLOrLCL" }
  };
  useEffect(() => {
    if (isFetched && !initialLoadCompleted) {
      if (shipmentTypeData && shipmentTypeData.data.results.length > 0) {
        const FCL = shipmentTypeData.data.results.find(
          (x) => {
            var _a2;
            return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentType.FCL;
          }
        );
        if (FCL && form.getValues("shipmentType") === void 0) {
          form.setValue(
            "shipmentType",
            __spreadValues$9({}, FCL),
            {
              shouldValidate: false
            }
          );
        }
      }
      setInitialLoadCompleted(true);
    }
  }, [isFetched, shipmentTypeData, initialLoadCompleted]);
  return /* @__PURE__ */ jsxs(Stack, { spacing: 8, children: [
    /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 8, sx: { paddingLeft: theme.spacing(4), paddingRight: theme.spacing(4) }, children: [
      /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "mode", label: getTerm("mode"), required: true }),
        /* @__PURE__ */ jsx(
          CodeLookup,
          {
            name: "shipmentMode",
            params: {
              systemName: "Code",
              additionalFilter: {
                codeQualifier: "ShipmentMode"
              }
            },
            prefetch: true,
            onDataLoad: (options) => {
              const sea = options.find((x) => {
                var _a2;
                return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentMode.Sea;
              });
              if (sea) {
                form.setValue(
                  "shipmentMode",
                  {
                    codeID: +sea.id,
                    name: sea.name,
                    code: sea.additionalData.code,
                    codeQualifierSystemName: sea.codeQualifierSystemName,
                    shortName: sea.shortName
                  },
                  {
                    shouldValidate: false
                  }
                );
              }
            },
            onChange: (_e, value) => {
              var _a2, _b;
              if (((_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentMode.Air) {
                const lcl = (_b = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _b.results.find(
                  (x) => {
                    var _a3;
                    return ((_a3 = x.additionalData) == null ? void 0 : _a3.code) === SystemName.ShipmentType.LCL;
                  }
                );
                if (lcl) {
                  form.setValue("shipmentType", __spreadValues$9({}, lcl));
                }
              }
            },
            disabled: true
          }
        )
      ] }),
      !isAir && /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "shippingOption", label: getTerm("shippingOption"), required: true }),
        /* @__PURE__ */ jsx(
          FormAutocompleteDropdown,
          {
            name: "shipmentType",
            options: ((_a = shipmentTypeData == null ? void 0 : shipmentTypeData.data) == null ? void 0 : _a.results) ? [...shipmentTypeData.data.results, __spreadValues$9({}, presetFCLorLCL)] : [],
            onChange: (_e, value) => {
              var _a2, _b;
              if (((_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.code) === SystemName.ShipmentType.LCL) {
                form.setValue("containerLines", []);
              }
              if (((_b = value == null ? void 0 : value.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.FCL) {
                form.setValue("orderLinesLCL", []);
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "25%" }, children: [
        /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, children: [
          /* @__PURE__ */ jsx(InputLabel, { name: "incoterm", label: getTerm("incoterm"), required: true }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              sx: { padding: 0 },
              onMouseEnter: handleIncotermMouseEnter,
              onMouseLeave: handleIncotermMouseLeave,
              children: /* @__PURE__ */ jsx(HelpOutlineOutlined, { color: "primary", sx: { width: ".5em", height: ".5em" } })
            }
          ),
          showInfo && /* @__PURE__ */ jsx(Box, { position: "relative", children: /* @__PURE__ */ jsx(Box, { position: "absolute", sx: { zIndex: 2, top: "calc(-44%)" }, children: /* @__PURE__ */ jsx(
            Box,
            {
              display: "flex",
              flexDirection: "column",
              bgcolor: theme.palette.common.white,
              border: 1,
              borderColor: theme.palette.grey[200],
              sx: {
                boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`,
                minWidth: "500px"
              },
              padding: 4,
              marginTop: 2,
              maxWidth: "1000px",
              children: /* @__PURE__ */ jsx(Typography, { fontSize: ".9rem", children: getTerm("incotermDescription") })
            }
          ) }) })
        ] }),
        /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 2, children: /* @__PURE__ */ jsx(
          IncotermLookup,
          {
            incoterm,
            prefetch: true,
            onDataLoad: (options) => {
              const fob = options.find((x) => {
                var _a2;
                return ((_a2 = x.additionalData) == null ? void 0 : _a2.code) === "FOB";
              });
              if (fob) {
                form.setValue(
                  "incoterm",
                  {
                    codeID: +fob.id,
                    name: fob.name,
                    code: fob.additionalData.code,
                    codeQualifierSystemName: fob.codeQualifierSystemName,
                    shortName: fob.shortName
                  },
                  {
                    shouldValidate: false
                  }
                );
              }
            },
            disabled: true
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsxs(Section, { title: `${getTerm("from")} and ${getTerm("to")}`, sx: { width: "100%" }, children: [
      locationFields,
      /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(2) }, children: /* @__PURE__ */ jsxs(Stack, { direction: "column", sx: { flexBasis: "20%" }, spacing: 2, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "goodsReady", label: getTerm("goodsReady"), required: true }),
        /* @__PURE__ */ jsx(DateTimeInput, { name: "expectedReady" })
      ] }) })
    ] }) }),
    /* @__PURE__ */ jsx(EstimatesCargoDetails, {})
  ] });
}
function SeaFreightSchedulesGrid$1(_a) {
  var _b = _a, {
    sectionSx,
    rows,
    isLoading,
    additionalColumns = []
  } = _b, props = __objRest$6(_b, [
    "sectionSx",
    "rows",
    "isLoading",
    "additionalColumns"
  ]);
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const seaFreightColumns = [
    {
      field: "vesselName",
      flex: 1,
      headerName: "VESSEL NAME",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        return ((_a2 = params.row) == null ? void 0 : _a2.legs) ? params.row.legs[0].vesselName : null;
      }
    },
    {
      field: "voyage",
      flex: 1,
      headerName: "VOYAGE",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        return ((_a2 = params.row) == null ? void 0 : _a2.legs) ? params.row.legs[0].reference : null;
      }
    },
    {
      field: "originCutOff",
      flex: 1,
      headerName: "ORIGIN CUT OFF",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2, _b2;
        return isNothing((_a2 = params.row) == null ? void 0 : _a2.ctoCutOff) ? "" : DateReferenceCell$1(removeTimezoneOffset((_b2 = params.row.ctoCutOff.dateAndTime) != null ? _b2 : ""));
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        const { etd } = findVesselDetails((_a2 = params.row) == null ? void 0 : _a2.legs);
        return isNothing(etd) ? "" : DateReferenceCell$1(removeTimezoneOffset(etd));
      }
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        const { eta } = findVesselDetails((_a2 = params.row) == null ? void 0 : _a2.legs);
        return isNothing(eta) ? "" : DateReferenceCell$1(removeTimezoneOffset(eta));
      }
    },
    {
      field: "transit",
      flex: 1,
      headerName: "TRANSIT",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2, _b2;
        return ((_a2 = params.row.transitTime) == null ? void 0 : _a2.toString()) ? ((_b2 = params.row.transitTime) == null ? void 0 : _b2.toString()) + " days" : "";
      }
    },
    {
      field: "via",
      flex: 1,
      headerName: "VIA",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        const { via } = findVesselDetails((_a2 = params.row) == null ? void 0 : _a2.legs);
        return via;
      }
    },
    ...additionalColumns
  ];
  return /* @__PURE__ */ jsx(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, sx: sectionSx, children: /* @__PURE__ */ jsx(
    DataGridPro,
    __spreadProps$9(__spreadValues$9({}, props), {
      apiRef,
      columns: seaFreightColumns,
      rows: rows != null ? rows : [],
      loading: isLoading,
      getRowId: () => v4(),
      hideFooter: true,
      density: "compact",
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        "--DataGrid-overlayHeight": "45px",
        fontSize: gridFontSize,
        "& .MuiDataGrid-cell:focus": {
          outline: "none"
        },
        "& .MuiDataGrid-cell:focus-within": {
          outline: "none"
        }
      },
      autoHeight: true
    })
  ) });
}
function _SeaFreightSchedulesGrid({ bookTransport }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const apiRef = useGridApiRef();
  const auth = useAuth();
  const { selectedTransport, estimatesForm, selectedEstimates } = useContext(Context$6);
  const formValues = estimatesForm.context.getValues();
  const selectedEstimateResult = selectedEstimates == null ? void 0 : selectedEstimates.value;
  const queryParameters = {
    loadPort: (_c = (_b = (_a = formValues == null ? void 0 : formValues.portOfOrigin) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.combinedCode) != null ? _c : null,
    dischargePort: (_f = (_e = (_d = formValues == null ? void 0 : formValues.destinationPort) == null ? void 0 : _d.additionalData) == null ? void 0 : _e.combinedCode) != null ? _f : null,
    carrierCode: (_h = (_g = selectedEstimateResult == null ? void 0 : selectedEstimateResult.carrier) == null ? void 0 : _g.code) != null ? _h : null,
    etdFrom: ((_i = formValues.expectedReady) == null ? void 0 : _i.dateAndTime) ? removeDateTime(defaultValue((_j = formValues.expectedReady) == null ? void 0 : _j.dateAndTime, "")) : null
  };
  const queryParams = createURLParams(queryParameters).toString();
  const query = useQuery$1(
    ["/VesselMovement/GetSchedules", queryParameters],
    () => httpService$1.get(`VesselMovement/GetSchedules?${queryParams}`)
  );
  const onClickBookTransport = (row) => {
    selectedTransport.Sea.setValue(row);
    if (typeof bookTransport === "function") {
      bookTransport();
    }
  };
  const canCreateShipment = auth.userHasPermission("apI_PortalShipment", "Write");
  const additionalColumns = [
    {
      field: "actions",
      type: "actions",
      renderCell: (params) => {
        return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          Button$1,
          {
            variant: "contained",
            color: "primary",
            sx: {
              fontSize: gridFontSize,
              padding: "2px 8px"
            },
            onClick: () => {
              return onClickBookTransport(params.row);
            },
            children: "Book"
          }
        ) });
      }
    }
  ];
  return /* @__PURE__ */ jsx(
    SeaFreightSchedulesGrid$1,
    {
      apiRef,
      rows: (_l = (_k = query == null ? void 0 : query.data) == null ? void 0 : _k.data) != null ? _l : [],
      isLoading: query.isFetching,
      additionalColumns: canCreateShipment ? additionalColumns : []
    }
  );
}
function AirFreightSchedulesGrid$1(_c) {
  var _d = _c, {
    sectionSx,
    rows,
    isLoading,
    additionalColumns = []
  } = _d, props = __objRest$6(_d, [
    "sectionSx",
    "rows",
    "isLoading",
    "additionalColumns"
  ]);
  const apiRef = useGridApiRef();
  const theme = useTheme$2();
  const airFreightColumns = [
    {
      field: "flightName",
      flex: 1,
      headerName: "FLIGHT NAME",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a;
        return defaultValue((_a = params.row) == null ? void 0 : _a.flightNumber, "");
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a;
        const { etd } = findVesselDetails((_a = params.row) == null ? void 0 : _a.legs);
        return isNothing(etd) ? "" : DateReferenceCell$1(removeTimezoneOffset(etd));
      }
    },
    {
      field: "etdTime",
      flex: 1,
      headerName: "DEPARTURE TIME",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a;
        const { etd } = findVesselDetails((_a = params.row) == null ? void 0 : _a.legs);
        return isNothing(etd) ? "" : DateReferenceCell$1(removeTimezoneOffset(etd), "hh:mm a");
      }
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a;
        const { eta } = findVesselDetails((_a = params.row) == null ? void 0 : _a.legs);
        return isNothing(eta) ? "" : DateReferenceCell$1(removeTimezoneOffset(eta));
      }
    },
    {
      field: "etaTime",
      flex: 1,
      headerName: "ARRIVAL TIME",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a;
        const { eta } = findVesselDetails((_a = params.row) == null ? void 0 : _a.legs);
        return isNothing(eta) ? "" : DateReferenceCell$1(removeTimezoneOffset(eta), "hh:mm a");
      }
    },
    {
      field: "totalTransitTime",
      flex: 1,
      headerName: "TOTAL TRANSIT TIME",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a, _b;
        return ((_a = params.row.transitTime) == null ? void 0 : _a.toString()) ? ((_b = params.row.transitTime) == null ? void 0 : _b.toString()) + " hours" : "";
      }
    },
    {
      field: "stops",
      flex: 1,
      headerName: "STOPS",
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.stops;
      }
    },
    ...additionalColumns
  ];
  return /* @__PURE__ */ jsx(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, sx: sectionSx, children: /* @__PURE__ */ jsx(
    DataGridPro,
    __spreadProps$9(__spreadValues$9({}, props), {
      apiRef,
      columns: airFreightColumns,
      rows: rows != null ? rows : [],
      loading: isLoading,
      getRowId: () => v4(),
      hideFooter: true,
      density: "compact",
      sx: {
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.primary.main,
          fontWeight: 600
        },
        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
        "--DataGrid-overlayHeight": "45px",
        fontSize: gridFontSize
      },
      autoHeight: true
    })
  ) });
}
function _AirFreightScheduleGrid({ bookTransport }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { selectedTransport, estimatesForm, selectedEstimates } = useContext(Context$6);
  const formValues = estimatesForm.context.getValues();
  const auth = useAuth();
  const apiRef = useGridApiRef();
  const selectedEstimateResult = selectedEstimates == null ? void 0 : selectedEstimates.value;
  const queryParameters = {
    departureAirport: (_c = (_b = (_a = formValues == null ? void 0 : formValues.portOfOrigin) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.code) != null ? _c : null,
    arrivalAirport: (_f = (_e = (_d = formValues == null ? void 0 : formValues.destinationPort) == null ? void 0 : _d.additionalData) == null ? void 0 : _e.code) != null ? _f : null,
    carrierCode: (_h = (_g = selectedEstimateResult == null ? void 0 : selectedEstimateResult.carrier) == null ? void 0 : _g.code) != null ? _h : null,
    etdFrom: ((_i = formValues.expectedReady) == null ? void 0 : _i.dateAndTime) ? removeDateTime(defaultValue((_j = formValues.expectedReady) == null ? void 0 : _j.dateAndTime, "")) : null,
    etdTo: afterWeek$1.toDate().toISOString()
    // stops: selectedEstimateResult?.via?.combinedCode && selectedEstimateResult.via.combinedCode !== null ? 1 : 0
  };
  const queryParams = createURLParams(queryParameters).toString();
  const query = useQuery$1(
    ["/Flight/GetSchedules", queryParameters],
    () => httpService$1.get(`Flight/GetSchedules?${queryParams}`)
  );
  const onClickBookTransport = (row) => {
    selectedTransport.Air.setValue(row);
    if (typeof bookTransport === "function") {
      bookTransport();
    }
  };
  const canCreateShipment = auth.userHasPermission("apI_PortalShipment", "Write");
  const additionalColumns = [
    {
      field: "actions",
      type: "actions",
      renderCell: (params) => {
        return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          Button$1,
          {
            variant: "contained",
            color: "primary",
            sx: {
              fontSize: gridFontSize,
              padding: "2px 8px"
            },
            onClick: () => {
              return onClickBookTransport(params.row);
            },
            children: "Book"
          }
        ) });
      }
    }
  ];
  return /* @__PURE__ */ jsx(
    AirFreightSchedulesGrid$1,
    {
      apiRef,
      rows: (_l = (_k = query == null ? void 0 : query.data) == null ? void 0 : _k.data) != null ? _l : [],
      additionalColumns: canCreateShipment ? additionalColumns : [],
      isLoading: query.isFetching
    }
  );
}
function EstimateResultsGrid({ bookTransport }) {
  const theme = useTheme$2();
  const apiRef = useGridApiRef();
  const auth = useAuth();
  const { estimatesResults, selectedEstimates, estimatesForm, orderForm } = useContext(Context$6);
  const formValues = estimatesForm.context.getValues();
  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState([]);
  const [openBreakdownDialog, setOpenBreakdownDialog] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState();
  const estimateResultsRow = useMemo(() => {
    const rows = serializeEstimatesResultsRow(estimatesResults.data);
    return rows;
  }, [estimatesResults.data]);
  const closeBreakdownDialog = () => {
    setOpenBreakdownDialog(false);
  };
  const priceColumnAddition = {
    field: "price",
    flex: 1,
    headerName: "PRICE",
    disableColumnMenu: true,
    renderCell: (params) => {
      var _a;
      return ((_a = params == null ? void 0 : params.row) == null ? void 0 : _a.price) ? /* @__PURE__ */ jsxs(
        Typography,
        {
          fontSize: "0.75rem",
          sx: {
            color: (theme2) => theme2.palette.secondary.main,
            textDecoration: "underline",
            cursor: "pointer"
          },
          onClick: () => {
            var _a2;
            if ((_a2 = params.row) == null ? void 0 : _a2.breakdown) {
              setSelectedRowDetails(params.row);
            }
            setOpenBreakdownDialog(true);
          },
          children: [
            priceFormatter(params.row.price).replace("NZD", "") + " ",
            /* @__PURE__ */ jsx(
              "span",
              {
                style: {
                  color: "#808080"
                },
                children: "NZD"
              }
            )
          ]
        }
      ) : "";
    }
  };
  const columns = [
    priceColumnAddition,
    ...estimatesGridColumns
    // {
    // 	field: "actions",
    // 	headerName: "",
    // 	width: 50,
    // 	renderCell: (params: GridRenderCellParams<GridEstimatesResults>) => renderExpandableCell(params),
    // 	sortable: false
    // }
  ];
  const estimatesCarrierPermission = auth.userHasPermission("estimates_Carrier", "Read");
  if (estimatesCarrierPermission) {
    columns.unshift({
      field: "carrier",
      flex: 1,
      headerName: "CARRIER",
      disableColumnMenu: true
    });
  }
  const handleBookTransport = () => {
    if (typeof bookTransport === "function") {
      bookTransport();
    }
  };
  useCallback(() => 200, []);
  useCallback(() => {
    const renderSchedulesPanel = () => {
      var _a;
      switch ((_a = formValues.shipmentMode) == null ? void 0 : _a.code) {
        case "Sea":
          return /* @__PURE__ */ jsx(_SeaFreightSchedulesGrid, { bookTransport: handleBookTransport });
        case "Air":
          return /* @__PURE__ */ jsx(_AirFreightScheduleGrid, { bookTransport: handleBookTransport });
        default:
          return /* @__PURE__ */ jsx(Fragment, {});
      }
    };
    return /* @__PURE__ */ jsx(Box, { sx: { padding: 2 }, children: renderSchedulesPanel() });
  }, []);
  useCallback((newIds) => {
    setDetailPanelExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds);
  }, []);
  const handleSelectedEstimate = (id, _data) => {
    var _a;
    const selectedEstimate = (_a = estimatesResults == null ? void 0 : estimatesResults.data) == null ? void 0 : _a.find((x) => x.uuid === id);
    if (selectedEstimate) {
      selectedEstimates.setValue(selectedEstimate);
    }
  };
  const onRowClick = useCallback(
    (params) => {
      var _a, _b, _c;
      handleSelectedEstimate(params.id);
      if (((_b = (_a = formValues.shipmentType) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.FCLOrLCL) {
        const selectedEstimate = (_c = estimatesResults == null ? void 0 : estimatesResults.data) == null ? void 0 : _c.find((x) => x.uuid === params.id);
        if (selectedEstimate) {
          orderForm.context.setValue("shipmentType", __spreadValues$9({}, selectedEstimate == null ? void 0 : selectedEstimate.shipmentType));
        }
      }
      apiRef.current.toggleDetailPanel(params.id);
    },
    [apiRef, estimateResultsRow]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataGridPro,
      {
        columns,
        rows: estimateResultsRow,
        loading: estimatesResults == null ? void 0 : estimatesResults.isLoading,
        apiRef,
        onRowClick,
        density: "compact",
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "--DataGrid-overlayHeight": "45px",
          "& .MuiDataGrid-cell:focus": {
            outline: "none"
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none"
          }
        },
        autoHeight: true,
        hideFooter: true,
        getRowId: (row) => row.uuid
      }
    ),
    /* @__PURE__ */ jsx(
      EstimatesBreakdownPopup,
      {
        open: openBreakdownDialog,
        onClose: closeBreakdownDialog,
        selectedRowDetails
      }
    )
  ] });
}
function SingleEstimateResult() {
  const theme = useTheme$2();
  const auth = useAuth();
  const { selectedEstimates } = useContext(Context$6);
  const selectedEstimatesValue = (selectedEstimates == null ? void 0 : selectedEstimates.value) ? [selectedEstimates.value] : [];
  const [openBreakdownDialog, setOpenBreakdownDialog] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState();
  const closeBreakdownDialog = () => {
    setOpenBreakdownDialog(false);
  };
  const priceColumnAddition = {
    field: "price",
    flex: 1,
    headerName: "PRICE",
    disableColumnMenu: true,
    renderCell: (params) => {
      var _a;
      return ((_a = params == null ? void 0 : params.row) == null ? void 0 : _a.price) ? /* @__PURE__ */ jsxs(
        Typography,
        {
          fontSize: "0.75rem",
          sx: {
            color: (theme2) => theme2.palette.secondary.main,
            textDecoration: "underline",
            cursor: "pointer"
          },
          onClick: () => {
            var _a2;
            if ((_a2 = params.row) == null ? void 0 : _a2.breakdown) {
              setSelectedRowDetails(params.row);
            }
            setOpenBreakdownDialog(true);
          },
          children: [
            priceFormatter(params.row.price).replace("NZD", "") + " ",
            /* @__PURE__ */ jsx(
              "span",
              {
                style: {
                  color: "#808080"
                },
                children: "NZD"
              }
            )
          ]
        }
      ) : "";
    }
  };
  const estimateResultsRow = useMemo(() => {
    const rows = serializeEstimatesResultsRow(selectedEstimatesValue);
    return rows;
  }, [selectedEstimatesValue]);
  const selectedColumns = [priceColumnAddition, ...estimatesGridColumns];
  const bookingCarrierPermission = auth.userHasPermission("bookings_Carrier", "Read");
  if (bookingCarrierPermission) {
    selectedColumns.unshift({
      field: "carrier",
      flex: 1,
      headerName: "Carrier",
      disableColumnMenu: true
    });
  }
  return estimateResultsRow.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DataGridPro,
      {
        columns: selectedColumns,
        rows: estimateResultsRow,
        density: "compact",
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "--DataGrid-overlayHeight": "45px",
          fontSize: gridFontSize
        },
        autoHeight: true,
        hideFooter: true,
        getRowId: (row) => row.uuid
      }
    ),
    /* @__PURE__ */ jsx(
      EstimatesBreakdownPopup,
      {
        open: openBreakdownDialog,
        onClose: closeBreakdownDialog,
        selectedRowDetails
      }
    )
  ] });
}
function NewEstimateFormControls({ handleOnCalculate, handleOnError }) {
  const popup = usePopupAlert();
  const { calculateEstimate, estimatesDetails, estimatesForm, estimatesResults, orderForm, organisations } = useContext(Context$6);
  const onClick = () => __async$6(this, null, function* () {
    const estimatesFormValues = estimatesForm.context.getValues();
    const fieldsToMap = Object.keys(
      estimatesFormValues
    );
    let estimateFormDetails = {};
    fieldsToMap.forEach((fieldName) => {
      let value;
      value = estimatesForm.context.getValues(fieldName);
      if (value) {
        estimateFormDetails = __spreadProps$9(__spreadValues$9({}, estimateFormDetails), {
          [fieldName]: value
        });
        orderForm.context.setValue(fieldName, value);
      }
    });
    if (Object.keys(estimateFormDetails).length > 0) {
      estimatesDetails.setValue(estimateFormDetails);
    }
    yield calculateEstimate(
      () => {
        if (typeof handleOnCalculate === "function") {
          handleOnCalculate();
        }
      },
      (error) => {
        if (typeof handleOnError === "function") {
          handleOnError(error);
        }
      }
    );
  });
  const handleOnClick = () => __async$6(this, null, function* () {
    if (organisations === null || organisations === void 0 || (organisations == null ? void 0 : organisations.length) === 0) {
      return popup({
        message: "Please select an Organisation",
        severity: "error"
      });
    }
    if ((organisations == null ? void 0 : organisations.length) > 1) {
      return popup({
        message: "There are more than one selected Organisation! Please select only one to proceed",
        severity: "error"
      });
    }
    onClick();
  });
  if (estimatesResults.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(Button$1, { variant: "contained", onClick: () => handleOnClick(), children: getTerm("newEstimate_Button_Calculate") });
}
function EstimateFormControls({ handleBookWithoutSelecting }) {
  var _a;
  const { estimatesForm, orderForm, shippingOptionData } = useContext(Context$6);
  const { FCL } = shippingOptionData;
  const auth = useAuth();
  const canCreateOrder = auth.userHasPermission("apI_PortalOrder", "Write");
  const bookOnClick = () => {
    var _a2, _b, _c, _d;
    if (((_b = (_a2 = estimatesForm.context.getValues("shipmentType")) == null ? void 0 : _a2.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.FCLOrLCL) {
      if (FCL && ((_d = (_c = orderForm.context.getValues("shipmentType")) == null ? void 0 : _c.additionalData) == null ? void 0 : _d.code) == SystemName.ShipmentType.FCLOrLCL) {
        orderForm.context.setValue("shipmentType", __spreadValues$9({}, FCL));
      }
    }
    if (typeof handleBookWithoutSelecting === "function") {
      handleBookWithoutSelecting();
    }
  };
  const buttonTitle = ((_a = estimatesForm.context.getValues("shipmentMode")) == null ? void 0 : _a.code) === SystemName.ShipmentMode.Sea ? "Book without selecting service" : "Book without selecting flight";
  return canCreateOrder ? /* @__PURE__ */ jsx(Button$1, { variant: "contained", onClick: () => bookOnClick(), children: buttonTitle }) : /* @__PURE__ */ jsx(Fragment, {});
}
function EstimateFormSummary({ handleEstimateEdit }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { estimatesForm } = useContext(Context$6);
  const formSummary = estimatesForm.context.getValues();
  const theme = useTheme$2();
  const _handleEstimateEdit = () => {
    if (typeof handleEstimateEdit === "function") {
      handleEstimateEdit();
    }
  };
  let containerCount = 0;
  (_a = formSummary == null ? void 0 : formSummary.containerLines) == null ? void 0 : _a.forEach((e) => {
    containerCount += e.quantity;
  });
  let lclCount = 0;
  (_b = formSummary == null ? void 0 : formSummary.orderLinesLCL) == null ? void 0 : _b.forEach((e) => {
    lclCount += e.ordered;
  });
  const goodsReadyDate = ((_c = formSummary == null ? void 0 : formSummary.expectedReady) == null ? void 0 : _c.dateAndTime) ? dayjs(new Date(formSummary.expectedReady.dateAndTime)).format("DD MMMM YYYY") : "";
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      paddingX: 4,
      marginTop: 2,
      children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, padding: 2, alignItems: "center", children: [
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography, { children: (_d = formSummary == null ? void 0 : formSummary.shipmentMode) == null ? void 0 : _d.code }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography, { children: (_e = formSummary == null ? void 0 : formSummary.shipmentType) == null ? void 0 : _e.name }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography, { children: (_f = formSummary == null ? void 0 : formSummary.incoterm) == null ? void 0 : _f.code }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsxs(
          Grid$3,
          {
            item: true,
            xs: "auto",
            display: "flex",
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            children: [
              /* @__PURE__ */ jsx(Typography, { children: (_g = formSummary == null ? void 0 : formSummary.portOfOrigin) == null ? void 0 : _g.name }),
              /* @__PURE__ */ jsx(Box, { alignSelf: "end", paddingX: 4, marginTop: 2, children: /* @__PURE__ */ jsx(ArrowForward, { color: "primary" }) }),
              /* @__PURE__ */ jsx(Typography, { children: (_h = formSummary == null ? void 0 : formSummary.destinationPort) == null ? void 0 : _h.name })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(
          Grid$3,
          {
            item: true,
            xs: "auto",
            display: "flex",
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            children: /* @__PURE__ */ jsx(Typography, { children: goodsReadyDate })
          }
        ),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(FiberManualRecord, { sx: { color: theme.palette.grey[300], height: "12px", width: "12px" } }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", children: /* @__PURE__ */ jsx(Typography, { children: ((_i = formSummary == null ? void 0 : formSummary.shipmentType) == null ? void 0 : _i.code) === "LCL" ? `${getTerm("newEstimate_Summary_LCL_Header")}: ${lclCount}` : `${getTerm("newEstimate_Summary_Containers_Header")}: ${containerCount}` }) }),
        /* @__PURE__ */ jsx(Grid$3, { item: true, xs: "auto", marginLeft: "auto", display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            onClick: () => {
              _handleEstimateEdit();
            },
            children: /* @__PURE__ */ jsx(Edit, { sx: { color: theme.palette.grey[400] } })
          }
        ) })
      ] })
    }
  );
}
function OrderDetails$1() {
  const { orderForm, estimatesDetails } = useContext(Context$6);
  const estimateDetailsValue = estimatesDetails.value && estimatesDetails.value != null ? estimatesDetails.value : {};
  const disabledFields = Object.keys(estimateDetailsValue).filter(
    (key) => estimateDetailsValue[key] !== null && estimateDetailsValue[key] !== ""
  );
  return /* @__PURE__ */ jsx(OrderDetailsForm, { form: orderForm.context, disabledFields });
}
function OrderOrderFormControls({ onSuccess }) {
  const auth = useAuth();
  const { orderForm, selectedTransport, selectedEstimates } = useContext(Context$6);
  const form = orderForm.context;
  const orderMutation = useMutation$1(
    ["/PortalOrder"],
    (state) => httpService$1.post("PortalOrder", __spreadValues$9({}, serializePortalOrderFromEstimates(state)))
  );
  const shipmentMutation = useMutation$1(
    ["/PortalShipment"],
    (state) => httpService$1.post("PortalShipment", __spreadValues$9({}, serializePortalShipment(state)))
  );
  const shipmentOrOrder = selectedTransport && (selectedTransport.Sea.value || selectedTransport.Air.value) ? "shipment" : "order";
  const handleClick = () => {
    form.handleSubmit((state) => __async$6(this, null, function* () {
      try {
        if (shipmentOrOrder === "shipment") {
          yield shipmentMutation.mutateAsync(__spreadProps$9(__spreadValues$9({}, state), {
            estimates: selectedEstimates && selectedEstimates.value != null ? selectedEstimates.value : void 0,
            transport: selectedTransport
          }));
        } else {
          yield orderMutation.mutateAsync(__spreadProps$9(__spreadValues$9({}, state), {
            estimates: selectedEstimates && selectedEstimates.value != null ? selectedEstimates.value : void 0
          }));
        }
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      } catch (e) {
        console.log("error", e);
      }
    }))();
  };
  if (shipmentMutation.isLoading || orderMutation.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  const canCreateOrder = auth.userHasPermission("apI_PortalOrder", "Write");
  const canCreateShipment = auth.userHasPermission("apI_PortalShipment", "Write");
  const renderOrderFormControls = () => {
    if (shipmentOrOrder === "shipment") {
      if (canCreateShipment) {
        return /* @__PURE__ */ jsx(
          OrderFormControls$1,
          {
            handleOnClick: handleClick,
            buttonTitle: getTerm("newOrder_Button_CreateBooking")
          }
        );
      }
    } else {
      if (canCreateOrder) {
        return /* @__PURE__ */ jsx(
          OrderFormControls$1,
          {
            handleOnClick: handleClick,
            buttonTitle: getTerm("newOrder_Button_CreateOrder")
          }
        );
      }
    }
    return /* @__PURE__ */ jsx(Fragment, {});
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderOrderFormControls() });
}
function UploadDocuments({ documentTypeGroupSystemName }) {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Section, { title: "Documents", sx: { width: "100%" }, children: /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 8, sx: { paddingBottom: theme.spacing(2) }, children: /* @__PURE__ */ jsx(DocumentUploader, { documentTypeGroupSystemName }) }) }) });
}
function EstimateForm({ children }) {
  const { estimatesForm } = useContext(Context$6);
  return /* @__PURE__ */ jsx(estimatesForm.component, { style: { height: "100%", width: "100%" }, children });
}
function OrderForm({ children }) {
  const { orderForm } = useContext(Context$6);
  return /* @__PURE__ */ jsx(orderForm.component, { style: { height: "100%", width: "100%" }, children });
}
function EstimateBase({ children }) {
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisations = getOrganisations().map((x) => x.id);
  const [estimatesDetails, setEstimatesDetails] = useState(null);
  const [estimateResult, setEstimateResult] = useState([]);
  const [selectedEstimateResult, setSelectedEstimateResult] = useState(null);
  const [selectedFlightSchedule, setSelectedFlightSchedule] = useState(null);
  const [selectedSeaSchedule, setSelectedSeaSchedule] = useState(null);
  const [shipmentTypeAPI, setShipmentTypeAPI] = useState(null);
  const [estimateContext, estimateForm] = useForm({
    defaultValues: {
      estimatedWeight: {
        measure: 0
      },
      estimatedVolume: {
        measure: 0
      },
      containerLines: [],
      orderLinesLCL: []
    },
    validationSchema: estimatesValidation
  });
  const [orderContext, orderForm] = useForm({
    validationSchema: orderPageValidation
  });
  useEffect(() => {
    const subscription = estimateContext.watch(() => {
      if (estimateContext.formState.submitCount > 0) {
        estimateContext.trigger(["containerLines", "orderLinesLCL"]);
      }
    });
    return () => subscription.unsubscribe();
  }, [estimateContext.watch, estimateContext.trigger]);
  const shippingOptionData = getShippingOption();
  const estimatesResultQuery = useMutation$1(
    ["/Estimates"],
    (state) => httpService$1.post("Estimates", __spreadValues$9({}, estimatesPayload(state))),
    {
      onSuccess: (data) => {
        var _a, _b;
        if ((data == null ? void 0 : data.data) && data.data.length > 0) {
          const results = data.data.map((result) => {
            return __spreadProps$9(__spreadValues$9({}, result), {
              uuid: v4(),
              shipmentType: shipmentTypeAPI
            });
          });
          if (((_b = (_a = estimateContext.getValues("shipmentType")) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.FCLOrLCL) {
            setEstimateResult((prevState) => {
              return [...prevState, ...results];
            });
          } else {
            setEstimateResult(results);
          }
        }
      }
    }
  );
  const callEstimatesAPI = (state, onSuccess, onError) => __async$6(this, null, function* () {
    setShipmentTypeAPI(__spreadValues$9({}, state.shipmentType));
    try {
      yield estimatesResultQuery.mutateAsync(state);
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (e) {
      if (e instanceof Error) {
        console.log("error", e);
        if (typeof onError === "function") {
          onError(e);
        }
      }
    }
  });
  const calculateEstimate = (onSuccess, onError) => estimateContext.handleSubmit((state) => __async$6(this, null, function* () {
    var _a, _b;
    if ((organisations == null ? void 0 : organisations.length) === 1) {
      state.organisation = {
        contactID: Number(organisations[0])
      };
    }
    setEstimateResult([]);
    if (((_b = (_a = state.shipmentType) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.code) === SystemName.ShipmentType.FCLOrLCL) {
      if (shippingOptionData.FCL) {
        state.shipmentType = __spreadValues$9({}, shippingOptionData.FCL);
      }
      yield callEstimatesAPI(state, onSuccess, onError);
      if (shippingOptionData.LCL) {
        state.shipmentType = __spreadValues$9({}, shippingOptionData.LCL);
      }
      yield callEstimatesAPI(state, onSuccess, onError);
    } else {
      yield callEstimatesAPI(state, onSuccess, onError);
    }
  }))();
  return /* @__PURE__ */ jsx(
    Context$6.Provider,
    {
      value: {
        estimatesForm: { context: estimateContext, component: estimateForm },
        orderForm: { context: orderContext, component: orderForm },
        calculateEstimate,
        estimatesResults: {
          isLoading: estimatesResultQuery.isLoading,
          data: estimateResult
        },
        selectedEstimates: {
          value: selectedEstimateResult,
          setValue: setSelectedEstimateResult
        },
        selectedTransport: {
          Sea: {
            value: selectedSeaSchedule,
            setValue: setSelectedSeaSchedule
          },
          Air: {
            value: selectedFlightSchedule,
            setValue: setSelectedFlightSchedule
          }
        },
        estimatesDetails: {
          value: estimatesDetails,
          setValue: setEstimatesDetails
        },
        state: {
          isLoading: estimatesResultQuery.isLoading
        },
        shippingOptionData,
        organisations
      },
      children
    }
  );
}
const EstimatePage = Object.assign(EstimateBase, {
  EstimateForm,
  EstimateDetails,
  ContainerLines,
  OrderLines,
  EstimateResultsGrid,
  EstimateFormSummary,
  NewEstimateFormControls,
  EstimateFormControls,
  SingleEstimateResult,
  SeaFreightSchedulesGrid: SeaFreightSchedulesGrid$1,
  AirFreightSchedulesGrid: AirFreightSchedulesGrid$1,
  OrderForm,
  OrderDetails: OrderDetails$1,
  OrderOrderFormControls,
  UploadDocuments
});
const useEstimatePageContext = () => {
  return useContext(Context$6);
};

var __defProp$8 = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const currentDateTime = dayjs();
const afterWeek = currentDateTime.add(7, "day");
const initialFilters$2 = {
  origin: null,
  destination: null,
  carrier: null,
  mode: null,
  etdFrom: currentDateTime.toDate().toISOString(),
  etdTo: afterWeek.toDate().toISOString(),
  etaFrom: null,
  etaTo: null,
  serviceType: null,
  stops: null
};
const Context$5 = createContext({});
const DateReferenceCell = (dateFieldValue, dateFieldFormat) => {
  const dateFormat = dateFieldFormat != null ? dateFieldFormat : "dd-MMM-yyyy";
  const date = dateFieldValue ? format$1(new Date(dateFieldValue), dateFormat) : null;
  return /* @__PURE__ */ jsx(Fragment$1, { children: date }, "__static");
};
const datePickerTransform = {
  input: (value) => value ? removeTimezoneOffset(value) : null,
  output: (value) => value ? removeTimezoneOffset(value) : null
};
const filterValidation = z$1.object({
  origin: z$1.object(
    {
      id: z$1.string()
    },
    {
      invalid_type_error: "Please select a valid Origin"
    }
  ).required(),
  destination: z$1.object(
    {
      id: z$1.string({
        invalid_type_error: "Please select a valid Destination"
      })
    },
    {
      invalid_type_error: "Please select a valid Destination"
    }
  ).required(),
  mode: z$1.object(
    {
      id: z$1.string()
    },
    {
      required_error: "Mode is required",
      invalid_type_error: "Please select a valid Mode"
    }
  ).required(),
  etaFrom: z$1.string().nullish().optional(),
  etaTo: z$1.string().nullish().optional(),
  etdFrom: z$1.string().nullish().optional(),
  etdTo: z$1.string().nullish().optional()
}).superRefine(({ etaFrom, etaTo, etdFrom, etdTo, mode }, refinementContext) => {
  if ((mode == null ? void 0 : mode.id) === SystemName.ShipmentMode.Air) {
    if ((etaFrom || etaTo) && (etdFrom || etdTo)) {
      const datesPath = [];
      if (etaFrom)
        datesPath.push("etaFrom");
      if (etaTo)
        datesPath.push("etaTo");
      if (etdFrom)
        datesPath.push("etdFrom");
      if (etdTo)
        datesPath.push("etdTo");
      refinementContext.addIssue({
        message: "ETA and ETD cannot be used together",
        path: datesPath,
        code: z$1.ZodIssueCode.custom
      });
    }
  }
  if (etaFrom && etaTo && dayjs(etaFrom).isAfter(etaTo)) {
    refinementContext.addIssue({
      message: "ETA From must be before ETA To",
      path: ["etaFrom"],
      code: z$1.ZodIssueCode.custom
    });
  }
  if (etdFrom && etdTo && dayjs(etdFrom).isAfter(etdTo)) {
    refinementContext.addIssue({
      message: "ETD From must be before ETD To",
      path: ["etdFrom"],
      code: z$1.ZodIssueCode.custom
    });
  }
  if (etaFrom && etdTo && dayjs(etaFrom).isAfter(etdTo)) {
    refinementContext.addIssue({
      message: "ETA From must be before ETD To",
      path: ["etaFrom"],
      code: z$1.ZodIssueCode.custom
    });
  }
});
const SchedulesDashboardFilters = memo$1(function SchedulesDashboardFilters2({
  hasSortPermission = false
}) {
  const auth = useAuth();
  const { form, dataGridApiRef } = useContext(Context$5);
  const {
    reset,
    watch,
    handleSubmit,
    setError,
    setValue,
    formState: { errors, isValid, submitCount }
  } = form;
  const onSubmit = (data) => {
    const result = filterValidation.safeParse(data);
    if (result.success) ; else {
      console.log("result.error", result.error);
      result.error.errors.forEach((error) => {
        const fieldName = error.path.join(".");
        if (error.path.length > 1) {
          error.path.forEach((p, index) => {
            setError(p, { type: "custom", message: error.message });
          });
        } else {
          setError(fieldName, { type: "custom", message: error.message });
        }
      });
    }
    return result;
  };
  const handleFilterSubmit = handleSubmit((data) => {
    return onSubmit(data);
  });
  const handleOnReset = () => {
    reset();
  };
  const handleExport = () => {
    console.log("dataGridApiRef.current", dataGridApiRef.current);
    if (dataGridApiRef.current) {
      dataGridApiRef.current.exportDataAsCsv();
    }
  };
  const etdFrom = watch("etdFrom");
  const etdTo = watch("etdTo");
  const etaFrom = watch("etaFrom");
  const etaTo = watch("etaTo");
  const mode = watch("mode");
  const gridMd = 3;
  const serviceTypeLookup = [
    { id: "Direct", name: "Direct" },
    { id: "Transhipment", name: "Transhipment" }
  ];
  const stopsLookup = Array.from({ length: 6 }, (_, index) => ({
    id: index.toString(),
    name: index.toString()
  }));
  const carrierLookupParams = useMemo(() => {
    const params = {
      systemName: "CoreContact",
      additionalFilter: {
        contactType: (mode == null ? void 0 : mode.id) === SystemName.ShipmentMode.Sea ? "ShippingLine" : "Airline"
      }
    };
    return params;
  }, [mode == null ? void 0 : mode.id]);
  const hasCarrierPermission = auth.userHasPermission("schedules_Carrier", "Read");
  const disabledExport = submitCount <= 0 || !isValid || Object.keys(errors).length > 0;
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, alignItems: "center", children: [
    /* @__PURE__ */ jsx(Grid$3, { item: true, md: 12, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "origin", label: "Origin", required: true }),
        /* @__PURE__ */ jsx(FormPortLocationLookup, { name: "origin", placeholder: "Origin" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "destination", label: "Destination", required: true }),
        /* @__PURE__ */ jsx(FormPortLocationLookup, { name: "destination", placeholder: "Destination" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "mode", label: "Mode", required: true }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "mode",
            params: {
              systemName: "TransportMode",
              additionalFilter: {
                type: "Schedules"
              }
            },
            placeholder: "Mode"
          }
        )
      ] }),
      hasCarrierPermission && /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "carrier", label: "Carrier" }),
        /* @__PURE__ */ jsx(
          FormLookup,
          {
            name: "carrier",
            params: carrierLookupParams,
            placeholder: "Carrier",
            disabled: mode == null
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, md: 12, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "etdFrom", label: "ETD From" }),
        /* @__PURE__ */ jsx(
          FormDateTimePicker,
          {
            name: "etdFrom",
            maxDate: defaultValue(etdTo, void 0),
            transform: datePickerTransform,
            required: true,
            dateTimePickerStyle: { width: "100%" }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "etdTo", label: "ETD To" }),
        /* @__PURE__ */ jsx(
          FormDateTimePicker,
          {
            name: "etdTo",
            minDate: defaultValue(etdFrom, void 0),
            transform: datePickerTransform,
            required: true,
            dateTimePickerStyle: { width: "100%" }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "etaFrom", label: "ETA From" }),
        /* @__PURE__ */ jsx(
          FormDateTimePicker,
          {
            name: "etaFrom",
            maxDate: defaultValue(etaTo, void 0),
            transform: datePickerTransform,
            required: true,
            dateTimePickerStyle: { width: "100%" }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "etaTo", label: "ETA To" }),
        /* @__PURE__ */ jsx(
          FormDateTimePicker,
          {
            name: "etaTo",
            minDate: defaultValue(etaFrom, void 0),
            transform: datePickerTransform,
            required: true,
            dateTimePickerStyle: { width: "100%" }
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, md: 12, children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
      (mode == null ? void 0 : mode.id) === SystemName.ShipmentMode.Sea && /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "serviceType", label: "Service Type" }),
        /* @__PURE__ */ jsx(
          FormAutocompleteDropdown,
          {
            name: "serviceType",
            options: serviceTypeLookup,
            placeholder: "Service Type",
            isOptionEqualToValue: (option, val) => option.id === val.id
          }
        )
      ] }),
      (mode == null ? void 0 : mode.id) === SystemName.ShipmentMode.Air && /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "stops", label: "Stops" }),
        /* @__PURE__ */ jsx(
          FormAutocompleteDropdown,
          {
            name: "stops",
            options: stopsLookup,
            placeholder: "Stops",
            isOptionEqualToValue: (option, val) => option.id === val.id
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, md: mode != null ? 6 : 9, sx: { padding: (theme) => theme.spacing(2) } }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: gridMd, sx: { padding: (theme) => theme.spacing(2) }, children: [
        /* @__PURE__ */ jsx(Box$1, { height: "1.75rem", gap: 2 }),
        /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "submit",
              variant: "contained",
              color: "primary",
              onClick: () => handleExport(),
              disabled: disabledExport,
              children: "Export"
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "submit",
              variant: "contained",
              color: "primary",
              onClick: (data) => handleFilterSubmit(data),
              children: "Search"
            }
          ),
          /* @__PURE__ */ jsx(Button, { type: "button", variant: "contained", color: "primary", onClick: () => handleOnReset(), children: "Reset" })
        ] })
      ] })
    ] }) })
  ] });
});
function SeaFreightSchedulesGrid(_a) {
  var _b = _a, { components, sectionSx } = _b, props = __objRest$5(_b, ["components", "sectionSx"]);
  var _a2;
  const auth = useAuth();
  const { dataGridApiRef } = useContext(Context$5);
  const theme = useTheme$2();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const getIsDirect = (serviceTypeID) => {
    switch (serviceTypeID) {
      case SystemName.ServiceType.Direct:
        return 1;
      case SystemName.ServiceType.Transhipment:
        return 0;
      default:
        return null;
    }
  };
  const queryParameters = useMemo(
    () => {
      var _a3, _b2, _c, _d, _e, _f, _g, _h, _i, _j;
      return {
        loadPort: (_c = (_b2 = (_a3 = filters == null ? void 0 : filters.origin) == null ? void 0 : _a3.additionalData) == null ? void 0 : _b2.combinedCode) != null ? _c : null,
        dischargePort: (_f = (_e = (_d = filters == null ? void 0 : filters.destination) == null ? void 0 : _d.additionalData) == null ? void 0 : _e.combinedCode) != null ? _f : null,
        carrierCode: (_i = (_h = (_g = filters.carrier) == null ? void 0 : _g.additionalData) == null ? void 0 : _h.ediCode) != null ? _i : null,
        etdFrom: filters.etdFrom ? removeDateTime(defaultValue(filters.etdFrom, "")) : null,
        etdTo: filters.etdTo ? removeDateTime(defaultValue(filters.etdTo, "")) : null,
        etaFrom: filters.etaFrom ? removeDateTime(defaultValue(filters.etaFrom, "")) : null,
        etaTo: filters.etaTo ? removeDateTime(defaultValue(filters.etaTo, "")) : null,
        directService: getIsDirect(defaultValue((_j = filters.serviceType) == null ? void 0 : _j.id, null))
      };
    },
    [formState.submitCount]
  );
  const hasCarrierPermission = auth.userHasPermission("schedules_Carrier", "Read");
  const seaFreightColumns = [
    ...hasCarrierPermission ? [
      {
        field: "carrier",
        flex: 1,
        headerName: "Carrier",
        disableColumnMenu: true,
        minWidth: 250
      }
    ] : [],
    {
      field: "originVoyage",
      flex: 1,
      headerName: "Origin Voyage",
      disableColumnMenu: true,
      minWidth: 250
    },
    {
      field: "destinationVoyage",
      flex: 1,
      headerName: "Destination Voyage",
      disableColumnMenu: true
    },
    {
      field: "originCutOff",
      flex: 1,
      headerName: "Origin Cutoff",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "destinationAvailability",
      flex: 1,
      headerName: "Destination Available",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "transit",
      flex: 1,
      headerName: "Transit",
      disableColumnMenu: true
    },
    {
      field: "via",
      flex: 1,
      headerName: "Via",
      disableColumnMenu: true
    }
  ];
  const queryParams = createURLParams(queryParameters).toString();
  const query = useQuery$1(
    ["/VesselMovement/GetSchedules", queryParameters],
    () => httpService$1.get(`VesselMovement/GetSchedules?${queryParams}`),
    {
      cacheTime: 0,
      enabled: formState.isSubmitted && Object.keys(formState.errors).length > 0 ? false : true
    }
  );
  const seaFreightRows = useMemo(() => {
    var _a3, _b2;
    const rows = [];
    (_b2 = (_a3 = query == null ? void 0 : query.data) == null ? void 0 : _a3.data) == null ? void 0 : _b2.forEach((ship) => {
      var _a4, _b3, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const filteredShipment = (_a4 = ship == null ? void 0 : ship.legs) == null ? void 0 : _a4.filter((leg) => leg.vesselName !== "TRUCK" && leg.vesselName !== "RAIL");
      const eta = (_b3 = filteredShipment == null ? void 0 : filteredShipment.find((x) => x.eta && x.eta !== "" && !x.etd)) == null ? void 0 : _b3.eta;
      const etd = ((_c = filteredShipment == null ? void 0 : filteredShipment.find((x) => x.etd && x.etd !== "" && !x.eta)) == null ? void 0 : _c.etd) || "";
      const etaAndetd = filteredShipment == null ? void 0 : filteredShipment.filter((x) => x.eta && x.etd);
      const via = etaAndetd ? etaAndetd.map((x) => x.portName).join(", ") : null;
      rows.push({
        carrier: ((_d = ship == null ? void 0 : ship.carrier) == null ? void 0 : _d.fullName) || null,
        originVoyage: filteredShipment ? `${(_e = filteredShipment[0]) == null ? void 0 : _e.vesselName} ${(_f = filteredShipment[0]) == null ? void 0 : _f.reference}` : null,
        destinationVoyage: filteredShipment ? `${(_g = filteredShipment.slice(-1)[0]) == null ? void 0 : _g.vesselName} ${(_h = filteredShipment.slice(-1)[0]) == null ? void 0 : _h.reference}` : null,
        originCutOff: (ship == null ? void 0 : ship.ctoCutOff) ? (_i = ship.ctoCutOff) == null ? void 0 : _i.dateAndTime : null,
        etd: defaultValue(etd, ""),
        eta: defaultValue(eta, ""),
        destinationAvailability: defaultValue((_j = ship.ctoAvailable) == null ? void 0 : _j.dateAndTime, ""),
        transit: ((_k = ship.transitTime) == null ? void 0 : _k.toString()) ? ((_l = ship.transitTime) == null ? void 0 : _l.toString()) + " days" : "",
        via
      });
    });
    return rows;
  }, [(_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.data]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box$1, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, sx: sectionSx, children: [
    /* @__PURE__ */ jsx(GridToolbar, {}),
    /* @__PURE__ */ jsx(
      DataGridPro,
      __spreadProps$8(__spreadValues$8({}, props), {
        apiRef: dataGridApiRef,
        columns: seaFreightColumns,
        rows: seaFreightRows != null ? seaFreightRows : [],
        loading: query.isFetching,
        getRowId: () => v4(),
        hideFooter: true,
        density: "compact",
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "--DataGrid-overlayHeight": "45px"
        },
        autoHeight: true
      })
    )
  ] }) });
}
function AirFreightSchedulesGrid(_c) {
  var _d = _c, { components, sectionSx } = _d, props = __objRest$5(_d, ["components", "sectionSx"]);
  var _a;
  const auth = useAuth();
  const { dataGridApiRef } = useContext(Context$5);
  const theme = useTheme$2();
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, (_) => /* @__PURE__ */ jsx(Fragment, {}));
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const queryParameters = useMemo(
    () => {
      var _a2, _b, _c2, _d2, _e, _f, _g, _h, _i, _j;
      return {
        departureAirport: (_c2 = (_b = (_a2 = filters == null ? void 0 : filters.origin) == null ? void 0 : _a2.additionalData) == null ? void 0 : _b.code) != null ? _c2 : null,
        arrivalAirport: (_f = (_e = (_d2 = filters == null ? void 0 : filters.destination) == null ? void 0 : _d2.additionalData) == null ? void 0 : _e.code) != null ? _f : null,
        carrierCode: (_i = (_h = (_g = filters.carrier) == null ? void 0 : _g.additionalData) == null ? void 0 : _h.ediCode) != null ? _i : null,
        etdFrom: filters.etdFrom ? removeDateTime(defaultValue(filters.etdFrom, "")) : null,
        etdTo: filters.etdTo ? removeDateTime(defaultValue(filters.etdTo, "")) : null,
        etaFrom: filters.etaFrom ? removeDateTime(defaultValue(filters.etaFrom, "")) : null,
        etaTo: filters.etaTo ? removeDateTime(defaultValue(filters.etaTo, "")) : null,
        stops: ((_j = filters == null ? void 0 : filters.stops) == null ? void 0 : _j.id) ? parseInt(filters.stops.id) : null
      };
    },
    [formState.submitCount]
  );
  const queryParams = createURLParams(queryParameters).toString();
  const query = useQuery$1(
    ["/Flight/GetSchedules", queryParameters],
    () => httpService$1.get(`Flight/GetSchedules?${queryParams}`),
    {
      cacheTime: 0,
      enabled: formState.isSubmitted && Object.keys(formState.errors).length > 0 ? false : true
    }
  );
  const airFreightRows = useMemo(() => {
    var _a2, _b;
    const rows = [];
    (_b = (_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.data) == null ? void 0 : _b.forEach((flight) => {
      var _a3, _b2, _c2, _d2, _e, _f, _g, _h, _i, _j;
      const eta = (_b2 = (_a3 = flight.legs) == null ? void 0 : _a3.find((x) => x.eta && x.eta !== "" && !x.etd)) == null ? void 0 : _b2.eta;
      const etd = ((_d2 = (_c2 = flight.legs) == null ? void 0 : _c2.find((x) => x.etd && x.etd !== "" && !x.eta)) == null ? void 0 : _d2.etd) || "";
      const etaAndetd = (_e = flight.legs) == null ? void 0 : _e.filter((x) => x.eta && x.etd);
      const via = etaAndetd ? etaAndetd.map((x) => x.portName).join(", ") : null;
      rows.push({
        carrier: ((_f = flight == null ? void 0 : flight.carrier) == null ? void 0 : _f.fullName) || null,
        flightName: defaultValue(flight.flightNumber, ""),
        etd: defaultValue(etd, ""),
        eta: defaultValue(eta, ""),
        totalTransitTime: ((_g = flight.transitTime) == null ? void 0 : _g.toString()) ? ((_h = flight.transitTime) == null ? void 0 : _h.toString()) + " hours" : "",
        stops: flight.stops,
        transit: ((_i = flight.transitTime) == null ? void 0 : _i.toString()) ? ((_j = flight.transitTime) == null ? void 0 : _j.toString()) + " hours" : "",
        via
      });
    });
    return rows;
  }, [(_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data]);
  const hasCarrierPermission = auth.userHasPermission("schedules_Carrier", "Read");
  const airFreightColumns = [
    ...hasCarrierPermission ? [
      {
        field: "carrier",
        flex: 1,
        headerName: "Carrier",
        disableColumnMenu: true
      }
    ] : [],
    {
      field: "flightName",
      flex: 1,
      headerName: "Flight Name",
      disableColumnMenu: true
    },
    {
      field: "etd",
      flex: 1,
      headerName: "ETD",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "etdTime",
      flex: 1,
      headerName: "Departure Time",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        return isNothing((_a2 = params.row) == null ? void 0 : _a2.etd) ? "" : DateReferenceCell(removeTimezoneOffset(params.row.etd), "hh:mm a");
      }
    },
    {
      field: "eta",
      flex: 1,
      headerName: "ETA",
      disableColumnMenu: true,
      renderCell: ({ value }) => {
        return isNothing(value) ? "" : DateReferenceCell(removeTimezoneOffset(value));
      }
    },
    {
      field: "etaTime",
      flex: 1,
      headerName: "Arrival Time",
      disableColumnMenu: true,
      renderCell: (params) => {
        var _a2;
        return isNothing((_a2 = params.row) == null ? void 0 : _a2.eta) ? "" : DateReferenceCell(removeTimezoneOffset(params.row.eta), "hh:mm a");
      }
    },
    {
      field: "totalTransitTime",
      flex: 1,
      headerName: "Total Transit Time",
      disableColumnMenu: true
    },
    {
      field: "stops",
      flex: 1,
      headerName: "Stops",
      disableColumnMenu: true
    }
  ];
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box$1, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, sx: sectionSx, children: [
    /* @__PURE__ */ jsx(GridToolbar, {}),
    /* @__PURE__ */ jsx(
      DataGridPro,
      __spreadProps$8(__spreadValues$8({}, props), {
        apiRef: dataGridApiRef,
        columns: airFreightColumns,
        rows: airFreightRows != null ? airFreightRows : [],
        loading: query.isFetching,
        getRowId: () => v4(),
        hideFooter: true,
        density: "compact",
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), 0.08)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.primary.main,
            fontWeight: 600
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "6px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "10px" },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "18px" },
          "--DataGrid-overlayHeight": "45px"
        },
        autoHeight: true
      })
    )
  ] }) });
}
const GridTitles = (systemName) => {
  switch (systemName) {
    case SystemName.ShipmentMode.Sea:
      return "Sea Freight";
    case SystemName.ShipmentMode.Air:
      return "Air Freight";
    default:
      return "";
  }
};
function SchedulesGrid(_e) {
  var _f = _e, { components } = _f, props = __objRest$5(_f, ["components"]);
  const theme = useTheme$2();
  const { getValues, formState } = useFormContext();
  const filters = getValues();
  const mode = useMemo(() => {
    var _a, _b;
    return (_b = (_a = filters == null ? void 0 : filters.mode) == null ? void 0 : _a.id) != null ? _b : null;
  }, [formState.submitCount]);
  const title = GridTitles(defaultValue(mode, ""));
  const isError = Object.keys(formState.errors).length > 0;
  return /* @__PURE__ */ jsx(Fragment, { children: mode != null && !isError && /* @__PURE__ */ jsxs(
    Box$1,
    {
      border: 1,
      borderColor: theme.palette.grey[200],
      flexDirection: "column",
      flexGrow: 1,
      display: "flex",
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsx(Typography$1, { padding: 4, fontWeight: "bold", children: title }),
        mode === SystemName.ShipmentMode.Sea && /* @__PURE__ */ jsx(
          SeaFreightSchedulesGrid,
          __spreadProps$8(__spreadValues$8({}, props), {
            components,
            sectionSx: { paddingX: 4, paddingBottom: 4 }
          })
        ),
        mode === SystemName.ShipmentMode.Air && /* @__PURE__ */ jsx(
          AirFreightSchedulesGrid,
          __spreadProps$8(__spreadValues$8({}, props), {
            components,
            sectionSx: { paddingX: 4, paddingBottom: 4 }
          })
        )
      ]
    }
  ) });
}
function SchedulesPageBase({ children }) {
  const [context, Form] = useForm({
    defaultValues: initialFilters$2
  });
  const apiRef = useGridApiRef();
  return /* @__PURE__ */ jsx(Context$5.Provider, { value: { form: context, dataGridApiRef: apiRef }, children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children }) });
}
const SchedulesPage = Object.assign(SchedulesPageBase, {
  SchedulesDashboardFilters,
  SeaFreightSchedulesGrid,
  AirFreightSchedulesGrid,
  SchedulesGrid
});
const useSchedulesPage = () => {
  return useContext(Context$5);
};

var __defProp$7 = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Skeleton$2 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const Context$4 = createContext({});
const ContainerContext = createContext({});
function MasonryGrid(_a) {
  var _b = _a, {
    gridItem: Item = GridItem,
    gridItemProps,
    loadingState = {
      component: GridItemLoading,
      count: 6
    },
    sx
  } = _b, rest = __objRest$4(_b, [
    "gridItem",
    "gridItemProps",
    "loadingState",
    "sx"
  ]);
  var _a2, _b2, _c;
  const theme = useTheme$2();
  const { grid } = useContext(Context$4);
  const LoadingItem = defaultValue(loadingState.component, GridItemLoading);
  const count = (_c = (_b2 = (_a2 = grid.data) == null ? void 0 : _a2.data.rows.length) != null ? _b2 : loadingState == null ? void 0 : loadingState.count) != null ? _c : 6;
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 400,
    overscan: 2,
    lanes: 2,
    rangeExtractor: (r) => {
      var _a3, _b3, _c2, _d;
      if (count <= 0) {
        return [];
      }
      const itemSize = virtualizer.getVirtualItemForOffset(r.startIndex).size;
      const scrollTop = (_b3 = (_a3 = virtualizerRef.current) == null ? void 0 : _a3.scrollTop) != null ? _b3 : 0;
      const boundingRect = (_c2 = virtualizerRef.current) == null ? void 0 : _c2.getBoundingClientRect();
      const rangeSize = Math.ceil(((_d = boundingRect == null ? void 0 : boundingRect.height) != null ? _d : itemSize) / itemSize * 2);
      const offset = Math.floor(scrollTop / itemSize) * 2;
      const range = [];
      for (let i = offset; i <= Math.min(r.count, offset + rangeSize + r.overscan) - 1; i++) {
        range.push(i);
      }
      return range;
    }
  });
  return /* @__PURE__ */ jsx(
    Box$1,
    __spreadProps$7(__spreadValues$7({
      ref: virtualizerRef,
      height: "0px",
      width: "100%",
      padding: "4px"
    }, rest), {
      sx: __spreadValues$7({
        overflowY: "auto"
      }, sx),
      children: /* @__PURE__ */ jsx(
        Box$1,
        {
          position: "relative",
          height: `${virtualizer.getTotalSize()}px`,
          sx: {
            marginRight: `-${theme.spacing(4)}`,
            marginBottom: `-${theme.spacing(4)}`,
            "& >div": {
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(4)
            }
          },
          children: virtualizer.getVirtualItems().map((virtualRow) => {
            var _a3;
            return /* @__PURE__ */ jsx(
              Box$1,
              {
                "data-index": virtualRow.index,
                ref: virtualizer.measureElement,
                position: "absolute",
                top: 0,
                left: `${virtualRow.lane * 50}%`,
                width: "50%",
                sx: {
                  transform: `translateY(${virtualRow.start}px)`
                },
                children: grid.isFetching && !((_a3 = grid.data) == null ? void 0 : _a3.data) ? /* @__PURE__ */ jsx(LoadingItem, {}) : /* @__PURE__ */ jsx(Item, __spreadValues$7({ data: grid.data.data.rows[virtualRow.index] }, gridItemProps))
              },
              virtualRow.index
            );
          })
        }
      )
    })
  );
}
function GridItem({ data, onExpandClick }) {
  const theme = useTheme$2();
  const pieces = data.pieces && data.piecesUnitOfMeasure ? `${data.pieces.toLocaleString(window.navigator.language)} ${inflect(
    data.piecesUnitOfMeasure,
    data.pieces
  )}` : data.pieces;
  const weight = data.weight && data.weightUnitOfMeasure ? `${data.weight.toLocaleString(window.navigator.language)} ${inflect(
    data.weightUnitOfMeasure,
    data.weight
  )}` : data.weight;
  const handleExpandClick = (data2) => (e) => {
    e.stopPropagation();
    if (typeof onExpandClick === "function") {
      onExpandClick(data2);
    }
  };
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [
                  /* @__PURE__ */ jsx(VerticalShadesClosed, { fontSize: "inherit" }),
                  /* @__PURE__ */ jsx(Typography$1, { fontSize: "1.1rem", lineHeight: "1.1rem", fontWeight: 600, children: data.containerNumber })
                ] }),
                /* @__PURE__ */ jsx(
                  Box$1,
                  {
                    alignSelf: "flex-start",
                    paddingY: 1,
                    paddingX: 2,
                    bgcolor: "primary.main",
                    borderRadius: (theme2) => theme2.shape.borderRadius,
                    textAlign: "center",
                    children: /* @__PURE__ */ jsx(
                      Typography$1,
                      {
                        fontSize: "0.75rem",
                        lineHeight: 1,
                        color: (theme2) => theme2.palette.common.white,
                        textTransform: "uppercase",
                        children: data.status
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(
                IconButton,
                {
                  size: "small",
                  title: "Expand to tab",
                  sx: {
                    alignSelf: "flex-end"
                  },
                  onClick: handleExpandClick(data),
                  children: /* @__PURE__ */ jsx(OpenInFullRounded, { fontSize: "inherit" })
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 2, children: /* @__PURE__ */ jsx(
          PortalShipmentSupplyChainTimeline,
          {
            jobID: data.shipmentID,
            supplyChainID: data.shipmentSupplyChainID,
            shipmentMode: data.shipmentMode,
            shipmentType: data.shipmentType,
            estimatedDeparture: data.estimatedDeparture,
            actualDeparture: data.actualDeparture,
            estimatedArrival: data.estimatedArrival,
            actualArrival: data.actualArrival,
            bookingConfirmed: data.bookingConfirmed
          }
        ) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 8, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Shipper" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignor })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Consignee" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.consignee })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Origin" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.origin })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Destination" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: data.destination })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Units" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: pieces })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", color: theme.palette.grey[500], children: "Weight" }),
            /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", children: weight })
          ] })
        ] })
      ]
    }
  );
}
function GridItemLoading() {
  const theme = useTheme$2();
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: [
        /* @__PURE__ */ jsxs(
          Box$1,
          {
            display: "flex",
            alignItems: "stretch",
            justifyContent: "space-between",
            padding: 2,
            borderBottom: 1,
            borderColor: theme.palette.grey[300],
            children: [
              /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingY: 1, children: [
                /* @__PURE__ */ jsx(Skeleton$2, { height: "1.1rem", width: "120px" }),
                /* @__PURE__ */ jsx(
                  Skeleton$2,
                  {
                    height: "22px",
                    width: "45px",
                    sx: { alignSelf: "flex-start", borderRadius: theme.shape.borderRadius }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ jsx(Skeleton$2, { height: "28px", width: "28px", sx: { alignSelf: "flex-end", borderRadius: "9999px" } }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box$1, { paddingX: 4, marginBottom: 3, children: /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" }) }),
        /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 4, paddingX: 4, paddingBottom: 9, children: [
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "55px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "210px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "70px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "225px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "40px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, marginBottom: 2.5, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "80px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "90px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "45px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "75px" })
          ] }),
          /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2.15, children: [
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "50px" }),
            /* @__PURE__ */ jsx(Skeleton$2, { height: "0.9rem", width: "75px" })
          ] })
        ] })
      ]
    }
  );
}
function ShipmentDetails() {
  var _a;
  const { shipmentQuery } = useContext(ContainerContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(ShipmentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(ShipmentDetails$3, { data: (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data });
}
function AgentDetails() {
  var _a;
  const { shipmentQuery } = useContext(ContainerContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(AgentDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(AgentDetails$3, { data: (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data });
}
function StaffContacts() {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(ContainerContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(StaffContactsLoading, {});
  }
  return /* @__PURE__ */ jsx(StaffContacts$3, { data: (_a = shipmentQuery == null ? void 0 : shipmentQuery.data) == null ? void 0 : _a.data, mailToSubject: (_c = (_b = query.data) == null ? void 0 : _b.data.containerAsset) == null ? void 0 : _c.containerNumber });
}
function ContainerControls({ subscriptionFormProps, shareMagicLinkProps }) {
  var _a, _b, _c, _d;
  const { query } = useContext(ContainerContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const disabled = query.isFetching;
  const watchlist = {
    objectID,
    objectType: "Container",
    fetchFromServer: true
  };
  const shareMagicLink = shareMagicLinkProps && __spreadValues$7({
    intent: "Container",
    objectId: objectID,
    objectType: "Container"
  }, shareMagicLinkProps);
  const containerNumber = (_d = (_c = (_b = query.data) == null ? void 0 : _b.data.containerAsset) == null ? void 0 : _c.containerNumber) != null ? _d : "";
  const subscriptionDialogState = subscriptionFormProps && {
    title: `Subscribe to container ${containerNumber}`,
    subscriptionProps: subscriptionFormProps
  };
  return /* @__PURE__ */ jsx(
    TrackerControls,
    {
      disabled,
      watchlist,
      subscriptionDialog: subscriptionDialogState,
      shareMagicLink
    }
  );
}
function ContainerDetails$1() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w;
  const { query } = useContext(ContainerContext);
  const pieces = (_c = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.pieces) == null ? void 0 : _c.measure;
  const piecesMeasureUnitType = (_f = (_e = (_d = query.data) == null ? void 0 : _d.data) == null ? void 0 : _e.pieces) == null ? void 0 : _f.measureUnitType;
  const actualWeight = (_i = (_h = (_g = query.data) == null ? void 0 : _g.data) == null ? void 0 : _h.gross) == null ? void 0 : _i.measure;
  const actualWeightUnitType = (_l = (_k = (_j = query.data) == null ? void 0 : _j.data) == null ? void 0 : _k.gross) == null ? void 0 : _l.measureUnitType;
  const volume = (_o = (_n = (_m = query.data) == null ? void 0 : _m.data) == null ? void 0 : _n.volume) == null ? void 0 : _o.measure;
  const volumeUnitType = (_r = (_q = (_p = query.data) == null ? void 0 : _p.data) == null ? void 0 : _q.volume) == null ? void 0 : _r.measureUnitType;
  const gridRows = ((_s = query.data) == null ? void 0 : _s.data) ? [
    {
      id: query.data.data.id,
      containerNumber: (_t = query.data.data.containerAsset) == null ? void 0 : _t.containerNumber,
      type: (_w = (_v = (_u = query.data.data.containerAsset) == null ? void 0 : _u.containerType) == null ? void 0 : _v.shortName) != null ? _w : void 0,
      seal: query.data.data.sealNumber,
      pieces: pieces && piecesMeasureUnitType ? `${pieces.toLocaleString(window.navigator.language)} ${inflect(piecesMeasureUnitType, pieces)}` : void 0,
      actualWeight: actualWeight && actualWeightUnitType ? `${actualWeight.toLocaleString(window.navigator.language)} ${inflect(actualWeightUnitType, actualWeight)}` : void 0,
      volume: volume && volumeUnitType ? `${volume.toLocaleString(window.navigator.language)} ${inflect(volumeUnitType, volume)}` : void 0
    }
  ] : [];
  return /* @__PURE__ */ jsx(ContainerDetails$4, { gridLoading: query.isFetching, gridRows });
}
function DocumentsDetails$2() {
  var _a, _b, _c, _d;
  const { query } = useContext(ContainerContext);
  const objectID = (_c = (_b = (_a = query.data) == null ? void 0 : _a.data.relatedJobs) == null ? void 0 : _b.find((job) => job.jobTypeSystemName === "PortalShipment")) == null ? void 0 : _c.id;
  const documents = useQuery$1(
    ["/Document/DocumentType", objectID],
    () => httpService$1.get(`Document/DocumentType?objectID=${objectID}&objectType=Job`),
    {
      enabled: !!objectID && !query.isFetching
    }
  );
  const gridRows = defaultValue((_d = documents.data) == null ? void 0 : _d.data, []).map((document) => {
    var _a2;
    return {
      filename: document.fileName,
      attachmentID: document == null ? void 0 : document.attachmentID,
      attachmentFormat: document == null ? void 0 : document.attachmentFormat,
      documentID: document.documentID,
      id: document.id,
      objectAttachmentID: document == null ? void 0 : document.objectAttachmentID,
      created: document.created,
      reference: document.reference,
      fileSize: document.fileSize,
      fileType: (_a2 = document.documentTypeName) != null ? _a2 : ""
    };
  });
  return /* @__PURE__ */ jsx(DocumentsDetails$4, { gridLoading: query.isFetching || documents.isFetching, gridRows });
}
function CustomsTimeline(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(ContainerContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      objectType: "Container",
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0,
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function TrackingTimeline$2(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(ContainerContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      objectType: "Container",
      filter: props.eventCodes.length > 0 ? (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0 : void 0,
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function TransportTimeline(props) {
  var _a, _b, _c;
  const { shipmentQuery, query } = useContext(ContainerContext);
  if (shipmentQuery.isFetching || query.isFetching) {
    return /* @__PURE__ */ jsx(EventsTimelineLoading, {});
  }
  return /* @__PURE__ */ jsx(
    EventsTimeline,
    {
      jobID: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.id,
      filter: (e) => !!e.eventCode && props.eventCodes.indexOf(e.eventCode) >= 0,
      objectType: "Container",
      addtionalEvents: (_c = shipmentQuery.data) == null ? void 0 : _c.data.events
    }
  );
}
function VoyageDetails() {
  var _a;
  const { shipmentQuery } = useContext(ContainerContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(VoyageDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(VoyageDetails$3, { data: (_a = shipmentQuery.data) == null ? void 0 : _a.data });
}
function OrderDetails() {
  var _a, _b;
  const { shipmentQuery } = useContext(ContainerContext);
  const orders = ((_b = (_a = shipmentQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.orders) || [];
  const gridRows = orders.flatMap(
    (order) => {
      var _a2, _b2;
      return (_b2 = (_a2 = order == null ? void 0 : order.orderLines) == null ? void 0 : _a2.map((line) => {
        var _a3, _b3, _c, _d, _e, _f;
        return {
          id: order.id,
          orderNumber: (_a3 = order.orderNumber) == null ? void 0 : _a3.reference,
          sku: (_b3 = line.sku) == null ? void 0 : _b3.reference,
          description: (_d = (_c = line.description) == null ? void 0 : _c.value) != null ? _d : EMPTY_STRING$g,
          ordered: (_e = line.ordered) == null ? void 0 : _e.measure,
          confirmed: (_f = line.confirmed) == null ? void 0 : _f.measure
        };
      })) != null ? _b2 : [];
    }
  );
  return /* @__PURE__ */ jsx(OrderDetails$5, { gridLoading: shipmentQuery.isFetching, gridRows });
}
function Map$4(props) {
  var _a, _b, _c, _d, _e;
  const { shipmentQuery } = useContext(ContainerContext);
  if (shipmentQuery.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(
    Map$8,
    __spreadProps$7(__spreadValues$7({}, props), {
      data: (_a = shipmentQuery.data) == null ? void 0 : _a.data.transportLegs,
      transportComplete: !!((_c = (_b = shipmentQuery.data) == null ? void 0 : _b.data.actualArrival) == null ? void 0 : _c.dateAndTime),
      isAirFreight: ((_e = (_d = shipmentQuery.data) == null ? void 0 : _d.data.shipmentMode) == null ? void 0 : _e.code) === SystemName.ShipmentMode.Air
    })
  );
}
function _Container({ id, children }) {
  var _a, _b, _c, _d;
  const query = useQuery$1(
    ["/PortalContainer", id],
    () => httpService$1.get(`PortalContainer/${id}`)
  );
  const portalShipmentJobID = (_d = (_c = (_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.relatedJobs) == null ? void 0 : _c.find(
    (job) => job.jobTypeSystemName === "PortalShipment"
  )) == null ? void 0 : _d.id;
  const shipmentQuery = useQuery$1(
    ["/PortalShipment", portalShipmentJobID],
    () => httpService$1.get(`PortalShipment/${portalShipmentJobID}`),
    {
      enabled: !!portalShipmentJobID && !query.isLoading
    }
  );
  return /* @__PURE__ */ jsx(ContainerContext.Provider, { value: { query, shipmentQuery }, children });
}
function Base$2({ ids = null, children }) {
  const [gridQuery] = useGridQuery({
    systemName: "PortalContainer",
    parameters: {
      containerIDsJSON: ids
    }
  });
  return /* @__PURE__ */ jsx(
    Context$4.Provider,
    {
      value: {
        grid: gridQuery
      },
      children
    }
  );
}
const Container = Object.assign(_Container, {
  EventsProgress: () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
    const { shipmentQuery, query } = useContext(ContainerContext);
    if (shipmentQuery.isFetching) {
      return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
    }
    return /* @__PURE__ */ jsx(
      PortalShipmentSupplyChainTimeline,
      {
        jobID: (_a = shipmentQuery.data) == null ? void 0 : _a.data.id,
        containerID: (_b = query.data) == null ? void 0 : _b.data.id,
        supplyChainID: (_c = shipmentQuery.data) == null ? void 0 : _c.data.supplyChainID,
        shipmentMode: (_e = (_d = shipmentQuery.data) == null ? void 0 : _d.data.shipmentMode) == null ? void 0 : _e.code,
        shipmentType: (_g = (_f = shipmentQuery.data) == null ? void 0 : _f.data.shipmentType) == null ? void 0 : _g.code,
        estimatedDeparture: (_i = (_h = shipmentQuery.data) == null ? void 0 : _h.data.estimatedDeparture) == null ? void 0 : _i.dateAndTime,
        actualDeparture: (_k = (_j = shipmentQuery.data) == null ? void 0 : _j.data.actualDeparture) == null ? void 0 : _k.dateAndTime,
        estimatedArrival: (_m = (_l = shipmentQuery.data) == null ? void 0 : _l.data.estimatedArrival) == null ? void 0 : _m.dateAndTime,
        actualArrival: (_o = (_n = shipmentQuery.data) == null ? void 0 : _n.data.actualArrival) == null ? void 0 : _o.dateAndTime,
        bookingConfirmed: (_q = (_p = shipmentQuery.data) == null ? void 0 : _p.data.housebill) == null ? void 0 : _q.created
      }
    );
  },
  Map: Map$4,
  ContainerControls,
  ShipmentDetails,
  AgentDetails,
  StaffContacts,
  ContainerDetails: ContainerDetails$1,
  CustomsTimeline,
  DocumentsDetails: DocumentsDetails$2,
  OrderDetails,
  TrackingTimeline: TrackingTimeline$2,
  TransportTimeline,
  VoyageDetails
});
const ContainerTrackerPage = Object.assign(Base$2, {
  EventsProgress: PortalShipmentSupplyChainTimeline,
  EventsTimeline,
  MasonryGrid,
  Container
});
const useContainerTrackerContext = () => {
  return useContext(Context$4);
};
const useContainerContext = () => {
  return useContext(ContainerContext);
};

var __async$5 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const baseValidationSchema$1 = z$1.object({
  freightPayer: z$1.object(
    {
      fileAs: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.freightPayer")}`,
      required_error: `Please provide a ${getTerm("consignment.freightPayer")}`
    }
  ).passthrough()
});
const freightDraftValidationSchema = baseValidationSchema$1.extend({
  submitType: z$1.literal("draft")
}).passthrough();
const freightQuoteValidationSchema = baseValidationSchema$1.extend({
  submitType: z$1.literal("quote")
}).passthrough();
const freightSubmitValidationSchema = baseValidationSchema$1.extend({
  submitType: z$1.literal("submit"),
  orderReference: z$1.object(
    {
      reference: z$1.string()
    },
    {
      invalid_type_error: `Please provide an ${getTerm("consignment.orderReference")}`,
      required_error: `Please provide an ${getTerm("consignment.orderReference")}`
    }
  ).passthrough(),
  pickupLocation: z$1.object(
    {
      locationID: z$1.number(),
      locationName: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.shipper")}`,
      required_error: `Please provide a ${getTerm("consignment.shipper")}`
    }
  ).passthrough(),
  pickupAddress: z$1.object(
    {
      name: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.address")}`,
      required_error: `Please provide a ${getTerm("consignment.address")}`
    }
  ),
  deliveryLocation: z$1.object(
    {
      locationID: z$1.number(),
      locationName: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.receiver")}`,
      required_error: `Please provide a ${getTerm("consignment.receiver")}`
    }
  ).passthrough(),
  deliveryAddress: z$1.object(
    {
      name: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.address")}`,
      required_error: `Please provide a ${getTerm("consignment.address")}`
    }
  ),
  //To be put back in later
  // freightLines: z
  // 	.array(
  // 		z
  // 			.object({
  // 				quantity: z
  // 					.object(
  // 						{
  // 							measure: z.number()
  // 						},
  // 						{
  // 							invalid_type_error: "Please provide a Quantity",
  // 							required_error: "Please provide a Quantity"
  // 						}
  // 					)
  // 					.passthrough(),
  // 				weight: z
  // 					.object(
  // 						{
  // 							measure: z.number().or(z.string())
  // 						},
  // 						{
  // 							invalid_type_error: "Please provide a Weight",
  // 							required_error: "Please provide a Weight"
  // 						}
  // 					)
  // 					.passthrough(),
  // 				volume: z.object(
  // 					{
  // 						measure: z.number().or(z.string())
  // 					},
  // 					{
  // 						invalid_type_error: "Please provide a Volume",
  // 						required_error: "Please provide a Volume"
  // 					}
  // 				)
  // 			})
  // 			.passthrough()
  // 	)
  // 	.nonempty(),
  isPalletsNotRequired: z$1.boolean().optional(),
  isNonHirePallets: z$1.boolean().optional(),
  isHirePallets: z$1.boolean().optional(),
  hirePallets: z$1.object(
    {
      measure: z$1.number().nullable().optional()
    },
    {
      invalid_type_error: "Please provide a Hire Pallet Quantity.",
      required_error: "Please provide a Hire Pallet Quantity."
    }
  ).passthrough().nullable().optional(),
  nonHirePallets: z$1.object(
    {
      measure: z$1.number().nullable().optional()
    },
    {
      invalid_type_error: "Please provide a Non-Hire Pallet Quantity",
      required_error: "Please provide a Non-Hire Pallet Quantity"
    }
  ).passthrough().nullable().optional()
}).passthrough();
const validationSchema$1 = z$1.discriminatedUnion("submitType", [
  freightDraftValidationSchema,
  freightQuoteValidationSchema,
  freightSubmitValidationSchema
]);
const freightFormValidation = validationSchema$1.refine(
  (data) => __async$5(void 0, null, function* () {
    return data.submitType !== "submit" || data.isHirePallets || data.isNonHirePallets || data.isPalletsNotRequired;
  }),
  {
    message: "Please select either Hire Pallets, Non-Hire Pallets or Pallets Not Required.",
    path: ["isPalletsNotRequired"]
  }
).refine(
  (data) => __async$5(void 0, null, function* () {
    var _a;
    return data.submitType !== "submit" || !data.isHirePallets || ((_a = data.hirePallets) == null ? void 0 : _a.measure) && data.hirePallets.measure > 0;
  }),
  {
    message: "Please provide a hire pallet quantity.",
    path: ["hirePallets"]
  }
).refine(
  (data) => __async$5(void 0, null, function* () {
    var _a;
    return data.submitType !== "submit" || !data.isNonHirePallets || ((_a = data.nonHirePallets) == null ? void 0 : _a.measure) && data.nonHirePallets.measure > 0;
  }),
  {
    message: "Please provide a non-hire pallet quantity.",
    path: ["nonHirePallets"]
  }
).superRefine((data, ctx) => __async$5(void 0, null, function* () {
  if (data.submitType === "submit") {
    if (data.isDangerousGoods) {
      if (!data.unNumber) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["unNumber"],
          message: `Please provide a ${getTerm("consignment.unNumber")}`
        });
      }
      if (!data.dgClass) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["dgClass"],
          message: `Please provide a ${getTerm("consignment.dgClass")}`
        });
      }
    }
    if (!isEmpty$2(data.pickupLocation) && data.pickupLocation.locationID < 0 && isEmpty$2(data.newPickupLocation)) {
      ctx.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["newPickupLocation"],
        message: `Please provide a New ${getTerm("consignment.shipper")}`
      });
    }
    if (!isEmpty$2(data.deliveryLocation) && data.deliveryLocation.locationID < 0 && isEmpty$2(data.newDeliveryLocation)) {
      ctx.addIssue({
        code: z$1.ZodIssueCode.custom,
        path: ["newDeliveryLocation"],
        message: `Please provide a New ${getTerm("consignment.receiver")}`
      });
    }
  }
}));

var __defProp$6 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Context$3 = createContext({});
const labelFontSize = "0.85rem";
const formatObjectLocation$1 = (propertyName, propertyNameLocationName, freightData, addressName) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const objectLocation = freightData[propertyName];
  const objectLocationName = freightData[propertyNameLocationName];
  if (!objectLocation) {
    return null;
  }
  const locationAddress = addressName ? freightData[addressName] : null;
  const addressFields = addressName && freightData[addressName] ? serializeAddress((_a = locationAddress == null ? void 0 : locationAddress.name) != null ? _a : "") : null;
  if (addressFields) {
    const { address1, address2, suburb, postcode } = addressFields;
    objectLocation.address1 = address1;
    objectLocation.address2 = address2;
    objectLocation.suburb = suburb;
    objectLocation.postcode = postcode;
  }
  if ((objectLocation == null ? void 0 : objectLocation.locationID) && objectLocation.locationID > 0) {
    return __spreadValues$6({}, objectLocation);
  }
  return __spreadProps$6(__spreadValues$6({}, objectLocation), {
    locationID: null,
    locationName: (_c = (_b = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _b.locationName) != null ? _c : objectLocationName == null ? void 0 : objectLocationName.name,
    latitude: (_f = (_d = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _d.latitude) != null ? _f : (_e = locationAddress == null ? void 0 : locationAddress.additionalData) == null ? void 0 : _e.latitude,
    longitude: (_i = (_g = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _g.longitude) != null ? _i : (_h = locationAddress == null ? void 0 : locationAddress.additionalData) == null ? void 0 : _h.longitude,
    combinedCode: (_j = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _j.combinedCode
  });
};
const serializeConsignment = (consignmentState) => {
  const consignment = __spreadValues$6({}, consignmentState);
  if (consignment.pickupLocation) {
    consignment.pickupLocation = prepareObjectLocation(consignment.pickupLocation);
  }
  if (isObjectLocation(consignment.pickupLocation)) {
    consignment.pickupLocation = consignment.pickupLocation ? formatObjectLocation$1(
      "pickupLocation",
      "newPickupLocation",
      consignment,
      "pickupAddress"
    ) : void 0;
  }
  if (consignment.deliveryLocation) {
    consignment.deliveryLocation = prepareObjectLocation(consignment.deliveryLocation);
  }
  if (isObjectLocation(consignment.deliveryLocation)) {
    consignment.deliveryLocation = formatObjectLocation$1(
      "deliveryLocation",
      "newDeliveryLocation",
      consignment,
      "deliveryAddress"
    );
    if (consignment.receiverName) {
      consignment.deliveryLocation.contact = consignment.receiverName;
    }
    if (consignment.receiverEmail) {
      consignment.deliveryLocation.email = consignment.receiverEmail;
    }
    if (consignment.receiverPhone) {
      consignment.deliveryLocation.phone = consignment.receiverPhone;
    }
  }
  if (consignment.freightLines && consignment.freightLines.length > 0) {
    const currentFreightLines = consignment.freightLines.map((line) => {
      var _a, _b, _c, _d, _e, _f;
      const quantityType = (_c = (_b = (_a = line.quantityType) == null ? void 0 : _a.additionalData) == null ? void 0 : _b.systemName) != null ? _c : "";
      return __spreadProps$6(__spreadValues$6({}, line), {
        quantity: ((_d = line.quantity) == null ? void 0 : _d.measure) ? __spreadProps$6(__spreadValues$6({}, line.quantity), {
          measureUnitTypeSystemName: quantityType
        }) : void 0,
        weight: ((_e = line.weight) == null ? void 0 : _e.measure) ? __spreadProps$6(__spreadValues$6({}, line.weight), { measureUnitTypeSystemName: "Kilogram" }) : void 0,
        //FIXME: This is hardcoded for now till the Backend is sorted
        volume: ((_f = line.volume) == null ? void 0 : _f.measure) ? __spreadProps$6(__spreadValues$6({}, line.volume), { measureUnitTypeSystemName: "CubicMetres" }) : void 0
      });
    });
    consignment.freightLines = currentFreightLines;
  }
  if (consignment.isPalletsNotRequired) {
    consignment.palletsNotRequired = {
      value: "1"
    };
  }
  return __spreadValues$6({}, consignment);
};
function ConsignmentReferenceDetails$1() {
  const { form } = useContext(Context$3);
  return /* @__PURE__ */ jsx(ConsignmentReferences, { form });
}
function DangerousGoods$1() {
  const { form, isDropboxDocuments, mainDropboxDirectory } = useContext(Context$3);
  const { watch } = form;
  const reference = watch("reference");
  const folderPath = isDropboxDocuments ? mainDropboxDirectory + "/" + reference : mainDropboxDirectory;
  return /* @__PURE__ */ jsx(DangerousGoods$2, { form, isDropboxDocuments, folderPath });
}
function FromAndToDetails$1({
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  var _a;
  const theme = useTheme$2();
  const { form } = useContext(Context$3);
  const { setValue, watch } = form;
  const freightPayerID = (_a = watch("freightPayer")) == null ? void 0 : _a.contactID;
  const [showNewPickupLocation, setShowNewPickupLocation] = useState(false);
  const [showNewDeliveryLocation, setShowNewDeliveryLocation] = useState(false);
  const [pickupLocationKey, setPickupLocationKey] = useState(v4());
  const [deliveryLocationKey, setDeliveryLocationKey] = useState(v4());
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsxs(Grid$3, { container: true, item: true, spacing: 8, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "pickupLocation", label: getTerm("consignment.shipper"), required: true }),
        /* @__PURE__ */ jsx(
          LocationLookup,
          {
            name: "pickupLocation",
            params: {
              systemName: "LocationByAssociation",
              additionalFilter: {
                locationType: [SystemName.LocationType.Client],
                freightPayerID
              }
            },
            useSearchTerm: true,
            prefetch: true,
            applyOptions: (options) => {
              const newOptions = [...options, additionalLookupItem];
              return newOptions;
            },
            onChange: (event, value) => {
              var _a2;
              setPickupLocationKey(v4());
              if (!value) {
                setValue("pickupAddress", null);
                setValue("newPickupLocation", null);
                setShowNewPickupLocation(false);
                return;
              }
              if (value.id === "-1") {
                setShowNewPickupLocation(true);
                setValue("pickupAddress", null);
                return;
              }
              setShowNewPickupLocation(false);
              setValue("newPickupLocation", null);
              if (value.additionalData) {
                setValue("pickupAddress", {
                  id: (_a2 = value.additionalData.combinedCode) != null ? _a2 : value.id,
                  name: addLookupAddress(value.additionalData)
                });
              } else {
                setValue("pickupAddress", null);
              }
            }
          }
        ),
        showNewPickupLocation && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
          Box$1,
          {
            sx: {
              padding: theme.spacing(4),
              backgroundColor: theme.palette.grey[100],
              marginTop: theme.spacing(4)
            },
            children: [
              /* @__PURE__ */ jsx(
                InputLabel,
                {
                  name: "pickupName",
                  label: "New " + getTerm("consignment.shipper"),
                  required: true
                }
              ),
              /* @__PURE__ */ jsx(
                FormAddressLookup,
                {
                  name: "newPickupLocation",
                  placesAPIKey,
                  autocompleteRequestOptions,
                  placeDetailsRequestOptions,
                  onChange: (event, value) => {
                    var _a2, _b, _c;
                    setPickupLocationKey(v4());
                    if (value && (value == null ? void 0 : value.additionalData)) {
                      setValue("pickupAddress", {
                        id: (_b = (_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.placeId) != null ? _b : value == null ? void 0 : value.id,
                        name: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.formattedAddress
                      });
                    } else {
                      setValue("pickupAddress", null);
                    }
                  },
                  useSearchTerm: true
                }
              )
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "consignee", label: getTerm("consignment.receiver"), required: true }),
        /* @__PURE__ */ jsx(
          LocationLookup,
          {
            name: "deliveryLocation",
            params: {
              systemName: "LocationByAssociation",
              additionalFilter: {
                locationType: [SystemName.LocationType.Client],
                freightPayerID
              }
            },
            useSearchTerm: true,
            prefetch: true,
            applyOptions: (options) => {
              const newOptions = [...options, additionalLookupItem];
              return newOptions;
            },
            onChange: (event, value) => {
              var _a2;
              setDeliveryLocationKey(v4());
              if (!value) {
                setValue("deliveryAddress", null);
                setValue("newDeliveryLocation", null);
                setShowNewDeliveryLocation(false);
                return;
              }
              if (value.id === "-1") {
                setShowNewDeliveryLocation(true);
                setValue("deliveryAddress", null);
                return;
              }
              setShowNewDeliveryLocation(false);
              setValue("newDeliveryLocation", null);
              if (value.additionalData) {
                setValue("deliveryAddress", {
                  id: (_a2 = value.additionalData.combinedCode) != null ? _a2 : value.id,
                  name: addLookupAddress(value.additionalData)
                });
              } else {
                setValue("deliveryAddress", null);
              }
            }
          }
        ),
        showNewDeliveryLocation && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
          Box$1,
          {
            sx: {
              padding: theme.spacing(4),
              backgroundColor: theme.palette.grey[100],
              marginTop: theme.spacing(4)
            },
            children: [
              /* @__PURE__ */ jsx(
                InputLabel,
                {
                  name: "deliveryName",
                  label: "New " + getTerm("consignment.receiver"),
                  required: true
                }
              ),
              /* @__PURE__ */ jsx(
                FormAddressLookup,
                {
                  name: "newDeliveryLocation",
                  placesAPIKey,
                  autocompleteRequestOptions,
                  placeDetailsRequestOptions,
                  onChange: (event, value) => {
                    var _a2, _b, _c;
                    setDeliveryLocationKey(v4());
                    if (value && (value == null ? void 0 : value.additionalData)) {
                      setValue("deliveryAddress", {
                        id: (_b = (_a2 = value == null ? void 0 : value.additionalData) == null ? void 0 : _a2.placeId) != null ? _b : value == null ? void 0 : value.id,
                        name: (_c = value == null ? void 0 : value.additionalData) == null ? void 0 : _c.formattedAddress
                      });
                    } else {
                      setValue("deliveryAddress", null);
                    }
                  },
                  useSearchTerm: true
                }
              )
            ]
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, item: true, spacing: 8, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "pickupLocation", label: getTerm("consignment.address") }),
        /* @__PURE__ */ jsx(
          FormAddressLookup,
          {
            name: "pickupAddress",
            placesAPIKey,
            autocompleteRequestOptions,
            placeDetailsRequestOptions,
            useSearchTerm: true
          },
          pickupLocationKey
        )
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "deliveryLocation", label: getTerm("consignment.address") }),
        /* @__PURE__ */ jsx(
          FormAddressLookup,
          {
            name: "deliveryAddress",
            placesAPIKey,
            autocompleteRequestOptions,
            placeDetailsRequestOptions,
            useSearchTerm: true
          },
          deliveryLocationKey
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { container: true, item: true, spacing: 8, children: [
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 3, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "receiverName", label: getTerm("consignment.freight.receiverName") }),
        /* @__PURE__ */ jsx(FormInput, { name: "receiverName" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 3, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "receiverEmail", label: getTerm("consignment.freight.receiverEmail") }),
        /* @__PURE__ */ jsx(FormInput, { name: "receiverEmail" })
      ] }),
      /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 3, children: [
        /* @__PURE__ */ jsx(InputLabel, { name: "receiverPhone", label: getTerm("consignment.freight.receiverPhone") }),
        /* @__PURE__ */ jsx(FormInput, { name: "receiverPhone" })
      ] }),
      /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 3, children: /* @__PURE__ */ jsx(Box$1, { display: "flex", height: "6rem", alignItems: "center", children: /* @__PURE__ */ jsx(FormCheckbox, { name: "receiveNotifications", label: "Receive notifications" }) }) })
    ] })
  ] });
}
function ProductLineDetails() {
  const { form } = useContext(Context$3);
  return /* @__PURE__ */ jsx(ProductLine, { form });
}
function PalletsSection() {
  const { form } = useContext(Context$3);
  const theme = useTheme$2();
  const hirePallets = form.watch("hirePallets");
  const nonHirePallets = form.watch("nonHirePallets");
  const isHirePallets = form.watch("isHirePallets");
  const isNonHirePallets = form.watch("isNonHirePallets");
  const total = defaultValue(hirePallets == null ? void 0 : hirePallets.measure, 0) + defaultValue(nonHirePallets == null ? void 0 : nonHirePallets.measure, 0);
  return /* @__PURE__ */ jsxs(
    Box$1,
    {
      display: "flex",
      gap: 2,
      flexDirection: "column",
      sx: { backgroundColor: theme.palette.secondary.light, padding: theme.spacing(4) },
      children: [
        /* @__PURE__ */ jsx(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize
            },
            children: "Pallets"
          }
        ),
        /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", children: [
          /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "60%" }, children: /* @__PURE__ */ jsx(
            FormCheckbox,
            {
              name: "isHirePallets",
              label: getTerm("consignment.freight.hirePallets"),
              onChange: (e, value) => {
                if (value === true) {
                  form.setValue("isPalletsNotRequired", false);
                }
              }
            }
          ) }),
          /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, children: /* @__PURE__ */ jsx(
            MeasureInput,
            {
              variant: "outlined",
              label: getTerm("hpQuantity"),
              size: "small",
              name: "hirePallets",
              sx: {
                backgroundColor: isHirePallets ? theme.palette.common.white : theme.palette.action.disabledBackground
              },
              disabled: !isHirePallets
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", children: [
          /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "60%" }, children: /* @__PURE__ */ jsx(
            FormCheckbox,
            {
              name: "isNonHirePallets",
              label: getTerm("consignment.freight.nonHirePallets"),
              onChange: (e, value) => {
                if (value === true) {
                  form.setValue("isPalletsNotRequired", false);
                }
              }
            }
          ) }),
          /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, children: /* @__PURE__ */ jsx(
            MeasureInput,
            {
              variant: "outlined",
              label: getTerm("quantity"),
              size: "small",
              name: "nonHirePallets",
              sx: {
                backgroundColor: isNonHirePallets ? theme.palette.common.white : theme.palette.action.disabledBackground
              },
              disabled: !isNonHirePallets
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", children: /* @__PURE__ */ jsx(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize
            },
            children: "OR"
          }
        ) }),
        /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 2, justifyContent: "space-between", children: /* @__PURE__ */ jsx(Stack, { direction: "column", spacing: 2, sx: { flexBasis: "60%" }, children: /* @__PURE__ */ jsx(
          FormCheckbox,
          {
            name: "isPalletsNotRequired",
            label: getTerm("consignment.freight.palletsNotRequired"),
            onChange: (e, value) => {
              if (value === true) {
                form.setValue("isHirePallets", false);
                form.setValue("isNonHirePallets", false);
                form.setValue("hirePallets", null);
                form.setValue("nonHirePallets", null);
              }
            }
          }
        ) }) }),
        /* @__PURE__ */ jsx(Divider$1, {}),
        /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 2, justifyContent: "flex-end", children: /* @__PURE__ */ jsxs(
          Typography$1,
          {
            sx: {
              fontWeight: 600,
              fontSize: labelFontSize
            },
            children: [
              "Total:",
              " ",
              /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    paddingLeft: "2px",
                    fontWeight: 600,
                    fontSize: labelFontSize
                  },
                  children: total
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}
function AdditionalDetails$3() {
  const { form, mainDropboxDirectory, isDropboxDocuments } = useContext(Context$3);
  const theme = useTheme$2();
  const isExportCertificate = form.watch("isExportCertificate");
  const reference = form.watch("reference");
  const dropboxDirectory = reference ? mainDropboxDirectory + "/" + reference : "";
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "comments", label: getTerm("comments") }),
      /* @__PURE__ */ jsx(NoteInput, { name: "comments", multiline: true, minRows: 5 })
    ] }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 6, children: /* @__PURE__ */ jsx(PalletsSection, {}) }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 6, md: 6, container: true, justifyContent: "flex-start", sx: { mt: -20 }, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "documents", label: "Upload Documents" }),
      isDropboxDocuments ? /* @__PURE__ */ jsx(Box$1, { width: "100%", children: /* @__PURE__ */ jsx(
        DropboxDocuments,
        {
          folderDirectory: dropboxDirectory,
          filterDocuments: (documents) => !documents.name.startsWith("DG_"),
          control: form.control
        }
      ) }) : /* @__PURE__ */ jsx(Box$1, { width: "100%", sx: { mt: -5 }, children: /* @__PURE__ */ jsx(Alert$1, { severity: "info", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", children: "Feature to be implemented" }) }) })
    ] }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, md: 3, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", gap: 2, flexDirection: "column", sx: { paddingX: theme.spacing(7) }, children: [
      /* @__PURE__ */ jsx(FormCheckbox, { name: "isExportCertificate", label: getTerm("consignment.freight.export") }),
      /* @__PURE__ */ jsx(
        NoteInput,
        {
          name: "exportCertificateNumber",
          variant: "outlined",
          label: getTerm("consignment.freight.exportCertificateNumber"),
          size: "small",
          sx: {
            backgroundColor: "transparent"
          },
          disabled: !isExportCertificate
        }
      )
    ] }) })
  ] });
}
function EstimateCharge$1() {
  return /* @__PURE__ */ jsx(EstimateCharge$2, {});
}
const ConsignmentDashboardChannelName = "ConsignmentDashboard";
const ConsignmentMessage = "refreshDashboard";
function FreightBookingButtonControls({
  onSaveDraft,
  onSaveQuote,
  onCreateBooking
}) {
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { checkFolderExists, createFolder, uploadFile, error: dropboxError } = useDropbox();
  const { form, mutation, mainDropboxDirectory, isDropboxDocuments } = useContext(Context$3);
  const { getValues, setValue, handleSubmit } = form;
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const handleSaveDropBoxDocument = (filePath, selectedFiles, filterType) => __async$4(this, null, function* () {
    if (!selectedFiles || selectedFiles.length === 0) {
      return;
    }
    const filteredSelectedFiles = selectedFiles.filter((file) => file.file);
    try {
      const isFolderExists = yield checkFolderExists(filePath);
      if (!isFolderExists) {
        yield createFolder.mutateAsync(filePath);
      }
      const uploadResults = yield Promise.allSettled(
        filteredSelectedFiles.map((file) => __async$4(this, null, function* () {
          const fileName = filterType ? `${filterType}_${file.file.name}` : file.file.name;
          return yield uploadFile.mutateAsync({ file: file.file, folderPath: filePath, fileName });
        }))
      );
      if (uploadResults.length > 0) {
        popup({
          message: "Documents have been saved successfully.",
          severity: "success"
        });
        setValue("dgDocuments", []);
        setValue("dropBoxDocuments", []);
        queryClient.invalidateQueries(["folderContents"]);
      }
    } catch (error) {
      popup({
        message: "An error occurred while saving Documents.",
        severity: "error"
      });
    }
  });
  const createNewChannel = () => {
    const channel = new BroadcastChannel(ConsignmentDashboardChannelName);
    channel.postMessage(ConsignmentMessage);
    channel.close();
  };
  const navigateToBooking = (id) => {
    navigate(`/FreightBooking/${id}`);
  };
  const onConfirmDialog = () => {
    closeDialog();
    createBooking();
  };
  const createBooking = () => __async$4(this, null, function* () {
    var _a;
    const values = getValues();
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const submittedValues = __spreadProps$6(__spreadValues$6({}, values), {
      status: SystemName.Status.Submitted,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Submitted)
    });
    try {
      const data = yield mutation.mutateAsync(submittedValues);
      popup({
        message: `Your booking has been ${getTerm("consignment.submitted")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigate(`/Freight/${data.data}`);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while sending the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  const handleOnCreateBooking = () => {
    openDialog();
    if (typeof onCreateBooking === "function") {
      onCreateBooking();
      return;
    }
  };
  const getFullPath = (id) => __async$4(this, null, function* () {
    var _a, _b;
    const jobDetails = yield httpService$1.get(`FreightConsignment/${id}`);
    const filePath = (_b = (_a = jobDetails == null ? void 0 : jobDetails.data) == null ? void 0 : _a.reference) != null ? _b : "";
    const fullPath = `${mainDropboxDirectory}/${filePath}`;
    return fullPath;
  });
  const handleOnSaveDraft = (values) => __async$4(this, null, function* () {
    var _a;
    if (typeof onSaveDraft === "function") {
      onSaveDraft();
      return;
    }
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const draftValues = __spreadProps$6(__spreadValues$6({}, values), {
      status: SystemName.Status.Draft,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Draft),
      submitType: "draft"
    });
    try {
      const data = yield mutation.mutateAsync(draftValues);
      popup({
        message: `Your booking has been saved as ${getTerm("consignment.draft")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigateToBooking(data.data);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while saving the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  const handleSubmitClick = (submitType) => {
    setValue("submitType", submitType);
    handleSubmitHandler();
  };
  const handleSubmitHandler = () => {
    handleSubmit((data) => {
      if (data.submitType === "quote") {
        handleOnSaveQuote(data);
        return;
      }
      if (data.submitType === "draft") {
        handleOnSaveDraft(data);
        return;
      }
      if (data.submitType === "submit") {
        handleOnCreateBooking();
        return;
      }
    })();
  };
  const handleOnSaveQuote = (values) => __async$4(this, null, function* () {
    var _a;
    if (typeof onSaveQuote === "function") {
      onSaveQuote();
      return;
    }
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const quoteValues = __spreadProps$6(__spreadValues$6({}, values), {
      status: SystemName.Status.Quote,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Quote)
    });
    try {
      const data = yield mutation.mutateAsync(quoteValues);
      popup({
        message: `Your booking has been saved as ${getTerm("consignment.quote")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigateToBooking(data.data);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while saving the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  if (mutation.isLoading || uploadFile.isLoading || createFolder.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box$1, { display: "flex", children: /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, justifyContent: "flex-end", display: "flex", gap: 2, children: [
      /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => handleSubmitClick("quote"), children: "Save as Quote" }),
      /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => handleSubmitClick("draft"), children: "Save as Draft" }),
      /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: () => handleSubmitClick("submit"), children: "Create Booking" })
    ] }) }),
    /* @__PURE__ */ jsx(
      DialogWrap,
      {
        fullWidth: true,
        open: isDialogOpen,
        onClose: closeDialog,
        title: "Confirm Booking",
        content: "You are now creating a live booking.  Please confirm you wish to proceed",
        children: /* @__PURE__ */ jsxs(DialogActions$1, { children: [
          /* @__PURE__ */ jsx(Button, { onClick: closeDialog, autoFocus: true, variant: "contained", children: "Cancel" }),
          /* @__PURE__ */ jsx(Button, { onClick: onConfirmDialog, autoFocus: true, variant: "outlined", children: "Confirm" })
        ] })
      }
    )
  ] });
}
const defaultValues$1 = {
  pickupRequiredBy: {
    dateAndTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
  }
};
function FreightBookingBase({
  id,
  formDefaultValues,
  mainDropboxDirectory = "",
  isDropboxDocuments = false,
  children
}) {
  useTheme$2();
  const _defaultValues = formDefaultValues ? __spreadValues$6({}, formDefaultValues) : __spreadValues$6({}, defaultValues$1);
  const [context, Form] = useForm({
    defaultValues: _defaultValues,
    validationSchema: freightFormValidation
  });
  const {
    reset,
    formState: { isValid, errors }
  } = context;
  const [searchParams] = useSearchParams();
  const query = useQuery$1(
    ["/FreightConsignment", id],
    () => httpService$1.get(`FreightConsignment/${id}`),
    {
      enabled: !!id
    }
  );
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const isDuplicate = searchParams.get("duplicate") === "true";
    if ((_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) {
      reset(__spreadProps$6(__spreadValues$6({}, query.data.data), {
        isDangerousGoods: !isPropertyEmpty(query.data.data.dgClass, "code"),
        dgClass: !isPropertyEmpty(query.data.data.dgClass, "code") ? __spreadProps$6(__spreadValues$6({}, query.data.data.dgClass), {
          lookupDisplayText: query.data.data.dgClass.code + " - " + query.data.data.dgClass.name
        }) : null,
        isHirePallets: !isPropertyEmpty(query.data.data.hirePallets, "measure"),
        isNonHirePallets: !isPropertyEmpty(query.data.data.nonHirePallets, "measure"),
        isExportCertificate: !isPropertyEmpty(query.data.data.exportCertificateNumber, "note"),
        receiverEmail: (_b = query.data.data.deliveryLocation) == null ? void 0 : _b.email,
        receiverName: (_c = query.data.data.deliveryLocation) == null ? void 0 : _c.contact,
        receiverPhone: (_d = query.data.data.deliveryLocation) == null ? void 0 : _d.phone,
        freightLines: query.data.data.freightLines.map((line) => {
          return __spreadProps$6(__spreadValues$6({}, line), {
            quantityType: line.quantity ? {
              id: line.quantity.measureUnitTypeID,
              name: line.quantity.measureUnitType,
              additionalData: {
                systemName: line.quantity.measureUnitTypeSystemName
              }
            } : void 0,
            uuid: v4()
          });
        }),
        pickupAddress: !isPropertyEmpty(query.data.data.pickupLocation, "locationID") ? {
          id: (_g = (_e = query.data.data.pickupLocation) == null ? void 0 : _e.combinedCode) != null ? _g : (_f = query.data.data.pickupLocation) == null ? void 0 : _f.locationID,
          name: addAddress(query.data.data.pickupLocation)
        } : null,
        deliveryAddress: !isPropertyEmpty(query.data.data.deliveryLocation, "locationID") ? {
          id: (_j = (_h = query.data.data.deliveryLocation) == null ? void 0 : _h.combinedCode) != null ? _j : (_i = query.data.data.deliveryLocation) == null ? void 0 : _i.locationID,
          name: addAddress(query.data.data.deliveryLocation)
        } : null
      }));
    } else if (isDuplicate) {
      const channel = new BroadcastChannel("FreightBooking");
      channel.postMessage({ type: "connected", payload: true });
      channel.onmessage = function(event) {
        var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K;
        if (event.data.type === "duplicate") {
          reset(__spreadProps$6(__spreadValues$6({}, event.data.payload), {
            isHirePallets: !isPropertyEmpty((_b2 = (_a2 = event.data) == null ? void 0 : _a2.payload) == null ? void 0 : _b2.hirePallets, "measure"),
            isNonHirePallets: !isPropertyEmpty((_d2 = (_c2 = event.data) == null ? void 0 : _c2.payload) == null ? void 0 : _d2.nonHirePallets, "measure"),
            receiverEmail: (_g2 = (_f2 = (_e2 = event.data) == null ? void 0 : _e2.payload) == null ? void 0 : _f2.deliveryLocation) == null ? void 0 : _g2.email,
            receiverName: (_j2 = (_i2 = (_h2 = event.data) == null ? void 0 : _h2.payload) == null ? void 0 : _i2.deliveryLocation) == null ? void 0 : _j2.contact,
            receiverPhone: (_m = (_l = (_k = event.data) == null ? void 0 : _k.payload) == null ? void 0 : _l.deliveryLocation) == null ? void 0 : _m.phone,
            freightLines: (_o = (_n = event.data) == null ? void 0 : _n.payload) == null ? void 0 : _o.freightLines.map((line) => {
              return __spreadProps$6(__spreadValues$6({}, line), {
                quantityType: line.quantity ? {
                  id: line.quantity.measureUnitTypeID,
                  name: line.quantity.measureUnitType,
                  additionalData: {
                    systemName: line.quantity.measureUnitTypeSystemName
                  }
                } : void 0,
                uuid: v4()
              });
            }),
            pickupAddress: !isPropertyEmpty((_q = (_p = event.data) == null ? void 0 : _p.payload) == null ? void 0 : _q.pickupLocation, "locationID") ? {
              id: (_x = (_t = (_s = (_r = event.data) == null ? void 0 : _r.payload) == null ? void 0 : _s.pickupLocation) == null ? void 0 : _t.combinedCode) != null ? _x : (_w = (_v = (_u = event.data) == null ? void 0 : _u.payload) == null ? void 0 : _v.pickupLocation) == null ? void 0 : _w.locationID,
              name: addAddress((_z = (_y = event.data) == null ? void 0 : _y.payload) == null ? void 0 : _z.pickupLocation)
            } : null,
            deliveryAddress: !isPropertyEmpty((_B = (_A = event.data) == null ? void 0 : _A.payload) == null ? void 0 : _B.deliveryLocation, "locationID") ? {
              id: (_I = (_E = (_D = (_C = event.data) == null ? void 0 : _C.payload) == null ? void 0 : _D.deliveryLocation) == null ? void 0 : _E.combinedCode) != null ? _I : (_H = (_G = (_F = event.data) == null ? void 0 : _F.payload) == null ? void 0 : _G.deliveryLocation) == null ? void 0 : _H.locationID,
              name: addAddress((_K = (_J = event.data) == null ? void 0 : _J.payload) == null ? void 0 : _K.deliveryLocation)
            } : null
          }));
        }
      };
      return () => {
        channel.close();
      };
    }
  }, [query.data]);
  const mutation = useMutation$1({
    mutationKey: [`FreightConsignment/Save`],
    mutationFn: (consignment) => httpService$1.post(`FreightConsignment`, __spreadValues$6({}, serializeConsignment(consignment)))
  });
  if (!isEmpty$2(id) && (query && query.isLoading || query.isFetching)) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(
    Context$3.Provider,
    {
      value: {
        form: context,
        mutation,
        query,
        isDropboxDocuments,
        mainDropboxDirectory
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const FreightBookingPage = Object.assign(FreightBookingBase, {
  ConsignmentReferenceDetails: ConsignmentReferenceDetails$1,
  DangerousGoods: DangerousGoods$1,
  FromAndToDetails: FromAndToDetails$1,
  ProductLineDetails,
  AdditionalDetails: AdditionalDetails$3,
  EstimateCharge: EstimateCharge$1,
  FreightBookingButtonControls
});
const useFreightBookingPageContext = () => {
  return useContext(Context$3);
};

var __defProp$5 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Skeleton$1 = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const FreightContext = createContext({});
function Map$3(_a) {
  var _b = _a, { children } = _b, props = __objRest$3(_b, ["children"]);
  var _a2, _b2, _c, _d, _e, _f, _g;
  const { query } = useContext(FreightContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const data = [];
  const pickupLocation = (_b2 = (_a2 = query.data) == null ? void 0 : _a2.data) == null ? void 0 : _b2.pickupLocation;
  if (pickupLocation && pickupLocation.latitude && pickupLocation.longitude) {
    data.push({
      key: v4(),
      lat: pickupLocation.latitude,
      lng: pickupLocation.longitude,
      label: pickupLocation.locationName,
      labelFontSize: "1rem"
    });
  }
  const events = (_e = (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.events) != null ? _e : [];
  const filteredEvents = events.filter(
    (event) => {
      var _a3, _b3, _c2, _d2;
      return event.eventCode === "AtLocation" && ((_b3 = (_a3 = event.locations) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.latitude) && ((_d2 = (_c2 = event.locations) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.longitude);
    }
  );
  filteredEvents.sort((a, b) => {
    var _a3, _b3;
    const aDate = (_a3 = a.eventDate) != null ? _a3 : a.created;
    const bDate = (_b3 = b.eventDate) != null ? _b3 : b.created;
    return new Date(aDate).getTime() - new Date(bDate).getTime() || new Date(a.created).getTime() - new Date(b.created).getTime();
  });
  filteredEvents.map((event) => {
    const location = event.locations[0];
    data.push({
      key: v4(),
      lat: location.latitude,
      lng: location.longitude,
      label: location.locationName,
      isSolidLine: true
    });
  });
  const deliveryLocation = (_g = (_f = query.data) == null ? void 0 : _f.data) == null ? void 0 : _g.deliveryLocation;
  if (deliveryLocation && deliveryLocation.latitude && deliveryLocation.longitude) {
    data.push({
      key: v4(),
      lat: deliveryLocation.latitude,
      lng: deliveryLocation.longitude,
      label: deliveryLocation.locationName,
      isSolidLine: events.find((event) => event.eventCode === "Delivered") ? true : false,
      labelFontSize: "1rem"
    });
  }
  return /* @__PURE__ */ jsx(ConsignmentMap, __spreadProps$5(__spreadValues$5({}, props), { data, children }));
}
function FreightTopControls({ setNotificationDialog, subscribed, setIsOpenShareDialog }) {
  var _a, _b;
  const { query } = useContext(FreightContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const disabled = query.isFetching;
  const watchlist = {
    objectID,
    objectType: "Job",
    isWatchlisted: (_b = query.data) == null ? void 0 : _b.data.isWatchlisted
  };
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const iconColor = disabled ? "disabled" : "primary";
  const iconButtonSize = mobileBreakPoint ? "small" : "medium";
  const onNotificationClick = () => {
    setNotificationDialog(true);
  };
  const onShareClick = () => {
    if (typeof setIsOpenShareDialog === "function") {
      setIsOpenShareDialog(true);
    }
  };
  return /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: mobileBreakPoint ? 1 : 4, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", children: [
    watchlist ? /* @__PURE__ */ jsx(
      WatchlistIcon,
      __spreadValues$5({
        color: iconColor,
        fontSize: iconButtonSize,
        disabled: disabled || !watchlist.objectID
      }, watchlist)
    ) : /* @__PURE__ */ jsx(Fragment, {}),
    /* @__PURE__ */ jsx(IconButton, { title: "Notification", disabled, onClick: onNotificationClick, children: subscribed ? /* @__PURE__ */ jsx(Notifications, { color: iconColor, fontSize: iconButtonSize }) : /* @__PURE__ */ jsx(NotificationsNone, { color: iconColor, fontSize: iconButtonSize }) }),
    /* @__PURE__ */ jsx(IconButton, { title: "Share", disabled, onClick: onShareClick, children: /* @__PURE__ */ jsx(Share, { color: iconColor }) })
  ] }) });
}
function ConsignmentDetails$1(props) {
  return props.isFetching ? /* @__PURE__ */ jsx(ConsignmentDetailsLoading, {}) : /* @__PURE__ */ jsx(ConsignmentDetails$2, __spreadValues$5({}, props));
}
function DocumentsDetails$1({ mainDropboxDirectory = "" }) {
  var _a, _b;
  const theme = useTheme$2();
  const queryClient = useQueryClient();
  const confirm = useConfirmationDialog();
  const { query, popup } = useContext(FreightContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const reference = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.reference;
  const [context, Form] = useForm({
    defaultValues: {
      reference
    }
  });
  const { getValues, setValue, control } = context;
  const { checkFolderExists, createFolder, uploadFile } = useDropbox();
  const dropboxDirectory = reference ? mainDropboxDirectory + "/" + reference : "";
  const [isFormDirty, setIsFormDirty] = useState(false);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    const originalHref = window.location.href;
    const handlePopState = (event) => __async$3(this, null, function* () {
      var _a2, _b2;
      const targetHref = (_b2 = (_a2 = event.target) == null ? void 0 : _a2.location) == null ? void 0 : _b2.href;
      if (isFormDirty && targetHref !== originalHref) {
        window.location.href = originalHref;
        const confirmUpload = yield confirm("Confirm", "Do you want to Save or Cancel the upload?", void 0, "Save");
        if (confirmUpload) {
          handleOnUploadDocument();
        } else {
          window.removeEventListener("beforeunload", handleBeforeUnload);
          window.removeEventListener("popstate", handlePopState);
          window.location.href = targetHref;
        }
      }
    });
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isFormDirty]);
  const handleSaveDropBoxDocument = (filePath, selectedFiles) => __async$3(this, null, function* () {
    if (!selectedFiles || selectedFiles.length === 0) {
      return;
    }
    const filteredSelectedFiles = selectedFiles.filter((file) => file.file);
    try {
      const isFolderExists = yield checkFolderExists(filePath);
      if (!isFolderExists) {
        yield createFolder.mutateAsync(filePath);
      }
      const uploadResults = yield Promise.allSettled(
        filteredSelectedFiles.map((file) => __async$3(this, null, function* () {
          return yield uploadFile.mutateAsync({ file: file.file, folderPath: filePath });
        }))
      );
      if (uploadResults.length > 0) {
        popup({
          message: "Document(s) has been uploaded successfully.",
          severity: "success"
        });
        setValue("dropBoxDocuments", []);
        queryClient.invalidateQueries(["folderContents"]);
        setIsFormDirty(false);
      }
    } catch (error) {
      popup({
        message: "An error occurred while saving Documents.",
        severity: "error"
      });
    }
  });
  const handleOnUploadDocument = () => __async$3(this, null, function* () {
    const values = getValues();
    try {
      if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0) {
        const fullPath = dropboxDirectory;
        yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while uploading the file!`,
          severity: "error"
        });
      }
    }
  });
  if (uploadFile.isLoading || createFolder.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
    /* @__PURE__ */ jsx(
      DropboxDocuments,
      {
        folderDirectory: dropboxDirectory,
        layout: "horizontal",
        control,
        setIsFormDirty
      }
    ),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", justifyContent: "flex-end", marginTop: theme.spacing(2), children: /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOnUploadDocument, children: "Upload" }) })
  ] }) });
}
function TrackingTimeline$1(props) {
  const { query } = useContext(FreightContext);
  return /* @__PURE__ */ jsx(
    ConsignmentTrackingHistory,
    __spreadProps$5(__spreadValues$5({}, props), {
      query
    })
  );
}
function FreightLineDetails() {
  var _a, _b;
  const { query } = useContext(FreightContext);
  const lines = ((_b = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.freightLines) || [];
  const gridRows = lines == null ? void 0 : lines.map((line) => {
    var _a2, _b2, _c, _d, _e, _f, _g, _h;
    return {
      id: line.id,
      quantity: (_a2 = line.quantity) == null ? void 0 : _a2.measure,
      package: (_c = (_b2 = line.quantity) == null ? void 0 : _b2.measureUnitType) != null ? _c : EMPTY_STRING$g,
      commodity: (_d = line.commodity) == null ? void 0 : _d.name,
      description: (_f = (_e = line.description) == null ? void 0 : _e.value) != null ? _f : EMPTY_STRING$g,
      weight: (_g = line.weight) == null ? void 0 : _g.measure,
      volume: (_h = line.volume) == null ? void 0 : _h.measure
    };
  });
  return /* @__PURE__ */ jsx(FreightLineDetails$1, { gridLoading: query.isFetching, gridRows });
}
function AdditionalDetails$2() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const fontSize = mobileBreakPoint ? "0.85rem" : "0.9rem";
  const { query } = useContext(FreightContext);
  const data = (_a = query.data) == null ? void 0 : _a.data;
  if (query.isFetching) {
    return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.815rem", width: "80px" }),
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.9rem", width: "90px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.9rem", width: "80px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.815rem", width: "100px" }),
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.9rem", width: "85px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton$1, { height: "0.9rem", width: "75px" })
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Hire Pallets (CHEP/LOSCAM)" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: ((_c = (_b = data == null ? void 0 : data.hirePallets) == null ? void 0 : _b.measure) != null ? _c : false) ? (_d = data == null ? void 0 : data.hirePallets) == null ? void 0 : _d.measure : "-" })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Non-Hire Pallets" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: ((_f = (_e = data == null ? void 0 : data.nonHirePallets) == null ? void 0 : _e.measure) != null ? _f : false) ? (_g = data == null ? void 0 : data.nonHirePallets) == null ? void 0 : _g.measure : "-" })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Export Cert. No.*" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_i = (_h = data == null ? void 0 : data.exportCertificateNumber) == null ? void 0 : _h.note) != null ? _i : EMPTY_STRING$g })
        ] })
      }
    )
  ] });
}
function CommentsDetails$1() {
  var _a, _b;
  const { query } = useContext(FreightContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(CommentsDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(CommentsDetails$3, { comments: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.comments });
}
function deleteIds$1(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        deleteIds$1(obj[key]);
      } else if (key === "id") {
        delete obj[key];
      } else if (key === "objectID") {
        delete obj[key];
      }
    }
  }
}
function FreightBottomControls({ prepareDuplicateValue }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const theme = useTheme$2();
  const { query, currentUser, popup } = useContext(FreightContext);
  const [isOpenEnquiryDialog, setIsOpenEnquiryDialog] = useState(false);
  if (query.isFetching)
    return /* @__PURE__ */ jsx(Fragment, {});
  const enquiryOnClick = () => {
    setIsOpenEnquiryDialog(true);
  };
  const duplicateOnClick = () => {
    var _a2, _b2, _c2;
    if (!((_a2 = query.data) == null ? void 0 : _a2.data))
      return;
    const values = typeof prepareDuplicateValue === "function" ? prepareDuplicateValue((_b2 = query.data) == null ? void 0 : _b2.data) : (_c2 = query.data) == null ? void 0 : _c2.data;
    deleteIds$1(values);
    const newTab = window.open(`${window.location.origin}/#/FreightBooking?duplicate=true`);
    if (newTab) {
      newTab.addEventListener("load", () => {
        const channel = new BroadcastChannel("FreightBooking");
        channel.onmessage = function(event) {
          if (event.data.type === "connected" && event.data.payload === true) {
            channel.postMessage({ type: "duplicate", payload: values });
            channel.close();
          }
        };
      });
    }
  };
  const promptFeatureNotImplemented = () => {
    popup({
      message: "Feature is not implemented yet.",
      severity: "info"
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", children: [
      /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: promptFeatureNotImplemented, children: "Print Consignment" }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: promptFeatureNotImplemented, children: "Print Labels" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, justifyContent: "flex-end", display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: enquiryOnClick, children: "Enquiry" }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: duplicateOnClick, children: "Duplicate" })
      ] })
    ] }),
    isOpenEnquiryDialog && !query.isFetching && ((_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.reference) && /* @__PURE__ */ jsx(
      Enquiry,
      {
        setIsOpenEnquiryDialog,
        defaultValues: {
          jobReference: (_c = query.data) == null ? void 0 : _c.data.reference,
          name: (_e = (_d = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _d.fullName) != null ? _e : void 0,
          phone: (_g = (_f = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _f.phoneNumber) != null ? _g : void 0,
          email: (_i = (_h = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _h.email) != null ? _i : void 0
        }
      }
    )
  ] });
}
function FreightDetails() {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const theme = useTheme$2();
  const { query } = useContext(FreightContext);
  const totalWeight = ((_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.freightLines) ? (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.freightLines.reduce(
    (totalWeight2, line) => {
      var _a2, _b2;
      return totalWeight2 = totalWeight2 + ((_b2 = (_a2 = line.weight) == null ? void 0 : _a2.measure) != null ? _b2 : 0);
    },
    0
  ) : 0;
  const totalVolume = ((_f = (_e = query.data) == null ? void 0 : _e.data) == null ? void 0 : _f.freightLines) ? (_h = (_g = query.data) == null ? void 0 : _g.data) == null ? void 0 : _h.freightLines.reduce(
    (totalVolume2, line) => {
      var _a2, _b2;
      return totalVolume2 = totalVolume2 + ((_b2 = (_a2 = line.volume) == null ? void 0 : _a2.measure) != null ? _b2 : 0);
    },
    0
  ) : 0;
  return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Weight (kgs)" }),
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: formatNumber(totalWeight.toString()) })
    ] }),
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 1, children: [
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", color: theme.palette.grey[700], children: "Cubic (m\xB3)" }),
      /* @__PURE__ */ jsx(Typography$1, { fontSize: "0.9rem", lineHeight: "0.9rem", children: formatNumber(totalVolume.toString()) })
    ] })
  ] }) });
}
function ConsignmentChargeDetails$1({ gridFooter }) {
  var _a, _b, _c, _d;
  const { query, chargeQuery } = useContext(FreightContext);
  const rows = ((_b = (_a = chargeQuery == null ? void 0 : chargeQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows) || [];
  return /* @__PURE__ */ jsx(
    ConsignmentChargeDetails$2,
    {
      gridLoading: chargeQuery.isFetching,
      gridRows: rows,
      estimatedCharge: (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.estimatedCharge,
      gridFooter
    }
  );
}
function _FreightConsignmentTracker({ id, children }) {
  const myAccountService = new MyAccountService();
  const query = useQuery$1(
    ["/FreightConsignment", id],
    () => httpService$1.get(`FreightConsignment/${id}`)
  );
  const { data: currentUser } = useQuery$1(["myDetail"], () => myAccountService.getMe());
  const [chargeQuery] = useGridQuery({
    systemName: "ConsignmentSummaryChargeGrid",
    parameters: {
      additionalFilter: {
        jobID: id
      }
    }
  });
  const popup = usePopupAlert();
  return /* @__PURE__ */ jsx(
    FreightContext.Provider,
    {
      value: {
        query,
        currentUser,
        chargeQuery,
        popup
      },
      children
    }
  );
}
const Freight = Object.assign(_FreightConsignmentTracker, {
  EventsProgress: () => {
    var _a, _b, _c, _d;
    const { query } = useContext(FreightContext);
    if (query.isFetching)
      return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
    if (!((_a = query.data) == null ? void 0 : _a.data.events))
      return /* @__PURE__ */ jsx(Fragment, {});
    return /* @__PURE__ */ jsx(
      ConsignmentSupplyChainTimeline,
      {
        events: (_b = query.data) == null ? void 0 : _b.data.events,
        estimatedDelivery: (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.estimatedDelivery
      }
    );
  },
  Map: Map$3,
  FreightTopControls,
  ConsignmentDetails: ConsignmentDetails$1,
  DocumentsDetails: DocumentsDetails$1,
  FreightLineDetails,
  TrackingTimeline: TrackingTimeline$1,
  AdditionalDetails: AdditionalDetails$2,
  CommentsDetails: CommentsDetails$1,
  FreightBottomControls,
  FreightDetails,
  ConsignmentChargeDetails: ConsignmentChargeDetails$1
});
const FreightTrackerPage = Object.assign({
  EventsProgress: ConsignmentSupplyChainTimeline,
  EventsTimeline,
  Freight
});
const useFreightContext = () => {
  return useContext(FreightContext);
};

var __defProp$4 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Skeleton = styled$4(Skeleton$d)({
  transform: "scale(1, 1)"
});
const ContainerConsignmentContext = createContext({});
function Map$2(_a) {
  var _b = _a, { children } = _b, props = __objRest$2(_b, ["children"]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { query } = useContext(ContainerConsignmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const data = [];
  const pickupLocation = (_b2 = (_a2 = query.data) == null ? void 0 : _a2.data) == null ? void 0 : _b2.pickupLocation;
  if (pickupLocation && pickupLocation.latitude && pickupLocation.longitude) {
    data.push({
      key: v4(),
      lat: pickupLocation.latitude,
      lng: pickupLocation.longitude,
      label: pickupLocation.locationName,
      labelFontSize: "1rem"
    });
  }
  const events = (_e = (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.events) != null ? _e : [];
  const filteredEvents = events == null ? void 0 : events.filter(
    (event) => {
      var _a3, _b3, _c2, _d2;
      return event.eventCode === "AtLocation" && ((_b3 = (_a3 = event.locations) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.latitude) && ((_d2 = (_c2 = event.locations) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.longitude);
    }
  );
  filteredEvents.sort((a, b) => {
    var _a3, _b3;
    const aDate = (_a3 = a.eventDate) != null ? _a3 : a.created;
    const bDate = (_b3 = b.eventDate) != null ? _b3 : b.created;
    return new Date(aDate).getTime() - new Date(bDate).getTime() || new Date(a.created).getTime() - new Date(b.created).getTime();
  });
  let activityLocation;
  switch ((_f = query.data) == null ? void 0 : _f.data.movementType.code) {
    case "Import":
      activityLocation = (_h = (_g = query.data) == null ? void 0 : _g.data) == null ? void 0 : _h.unpack;
      break;
    case "Export":
      activityLocation = (_j = (_i = query.data) == null ? void 0 : _i.data) == null ? void 0 : _j.pack;
      break;
  }
  const activityIndex = filteredEvents.findIndex(
    (event) => {
      var _a3, _b3;
      return ((_b3 = (_a3 = event.locations) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.locationID) === (activityLocation == null ? void 0 : activityLocation.locationID);
    }
  );
  if (activityIndex === -1) {
    if (activityLocation && activityLocation.latitude && activityLocation.longitude) {
      data.push({
        key: v4(),
        lat: activityLocation.latitude,
        lng: activityLocation.longitude,
        label: activityLocation.locationName,
        labelFontSize: "1rem"
      });
    }
  } else {
    for (var i = 0; i <= activityIndex; i++) {
      const location = filteredEvents[i].locations[0];
      data.push({
        key: v4(),
        lat: location.latitude,
        lng: location.longitude,
        label: location.locationName,
        isSolidLine: true,
        labelFontSize: i === activityIndex ? "1rem" : void 0
      });
    }
  }
  for (var i = activityIndex + 1; i < filteredEvents.length; i++) {
    const location = filteredEvents[i].locations[0];
    data.push({
      key: v4(),
      lat: location.latitude,
      lng: location.longitude,
      label: location.locationName,
      isSolidLine: true
    });
  }
  const deliveryLocation = (_l = (_k = query.data) == null ? void 0 : _k.data) == null ? void 0 : _l.deliveryLocation;
  if (deliveryLocation && deliveryLocation.latitude && deliveryLocation.longitude) {
    data.push({
      key: v4(),
      lat: deliveryLocation.latitude,
      lng: deliveryLocation.longitude,
      label: deliveryLocation.locationName,
      isSolidLine: events.find((event) => event.eventCode === "Delivered") ? true : false,
      labelFontSize: "1rem"
    });
  }
  return /* @__PURE__ */ jsx(ConsignmentMap, __spreadProps$4(__spreadValues$4({}, props), { data, children }));
}
function ContainerConsignmentTopControls({
  setNotificationDialog,
  subscribed,
  setIsOpenShareDialog
}) {
  var _a, _b;
  const { query } = useContext(ContainerConsignmentContext);
  const objectID = (_a = query.data) == null ? void 0 : _a.data.id;
  const disabled = query.isFetching;
  const watchlist = {
    objectID,
    objectType: "Job",
    isWatchlisted: (_b = query.data) == null ? void 0 : _b.data.isWatchlisted
  };
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const iconColor = disabled ? "disabled" : "primary";
  const iconButtonSize = mobileBreakPoint ? "small" : "medium";
  const onNotificationClick = () => {
    setNotificationDialog(true);
  };
  const onShareClick = () => {
    if (typeof setIsOpenShareDialog === "function") {
      setIsOpenShareDialog(true);
    }
  };
  return /* @__PURE__ */ jsx(Box$1, { display: "flex", alignItems: "center", gap: mobileBreakPoint ? 1 : 4, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", children: [
    watchlist ? /* @__PURE__ */ jsx(
      WatchlistIcon,
      __spreadValues$4({
        color: iconColor,
        fontSize: iconButtonSize,
        disabled: disabled || !watchlist.objectID
      }, watchlist)
    ) : /* @__PURE__ */ jsx(Fragment, {}),
    /* @__PURE__ */ jsxs(IconButton, { title: "Notification", disabled, onClick: onNotificationClick, children: [
      subscribed ? /* @__PURE__ */ jsx(Notifications, { color: iconColor, fontSize: iconButtonSize }) : /* @__PURE__ */ jsx(NotificationsNone, { color: iconColor, fontSize: iconButtonSize }),
      " "
    ] }),
    /* @__PURE__ */ jsx(IconButton, { title: "Share", disabled, onClick: onShareClick, children: /* @__PURE__ */ jsx(Share, { color: iconColor }) })
  ] }) });
}
function ConsignmentDetails(props) {
  return props.isFetching ? /* @__PURE__ */ jsx(ConsignmentDetailsLoading, {}) : /* @__PURE__ */ jsx(ConsignmentDetails$2, __spreadValues$4({}, props));
}
function DocumentsDetails({ mainDropboxDirectory = "" }) {
  var _a, _b;
  const theme = useTheme$2();
  const queryClient = useQueryClient();
  const confirm = useConfirmationDialog();
  const { query, popup } = useContext(ContainerConsignmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const reference = (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.reference;
  const [context, Form] = useForm({
    defaultValues: {
      reference
    }
  });
  const { getValues, setValue, control } = context;
  const { checkFolderExists, createFolder, uploadFile } = useDropbox();
  const dropboxDirectory = reference ? mainDropboxDirectory + "/" + reference : "";
  const [isFormDirty, setIsFormDirty] = useState(false);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    const originalHref = window.location.href;
    const handlePopState = (event) => __async$2(this, null, function* () {
      var _a2, _b2;
      const targetHref = (_b2 = (_a2 = event.target) == null ? void 0 : _a2.location) == null ? void 0 : _b2.href;
      if (isFormDirty && targetHref !== originalHref) {
        window.location.href = originalHref;
        const confirmUpload = yield confirm("Confirm", "Do you want to Save or Cancel the upload?", void 0, "Save");
        if (confirmUpload) {
          handleOnUploadDocument();
        } else {
          window.removeEventListener("beforeunload", handleBeforeUnload);
          window.removeEventListener("popstate", handlePopState);
          window.location.href = targetHref;
        }
      }
    });
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isFormDirty]);
  const handleSaveDropBoxDocument = (filePath, selectedFiles) => __async$2(this, null, function* () {
    if (!selectedFiles || selectedFiles.length === 0) {
      return;
    }
    const filteredSelectedFiles = selectedFiles.filter((file) => file.file);
    try {
      const isFolderExists = yield checkFolderExists(filePath);
      if (!isFolderExists) {
        yield createFolder.mutateAsync(filePath);
      }
      const uploadResults = yield Promise.allSettled(
        filteredSelectedFiles.map((file) => __async$2(this, null, function* () {
          return yield uploadFile.mutateAsync({ file: file.file, folderPath: filePath });
        }))
      );
      if (uploadResults.length > 0) {
        popup({
          message: "Document(s) has been uploaded successfully.",
          severity: "success"
        });
        setValue("dropBoxDocuments", []);
        queryClient.invalidateQueries(["folderContents"]);
        setIsFormDirty(false);
      }
    } catch (error) {
      popup({
        message: "An error occurred while saving Documents.",
        severity: "error"
      });
    }
  });
  const handleOnUploadDocument = () => __async$2(this, null, function* () {
    const values = getValues();
    try {
      if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0) {
        const fullPath = dropboxDirectory;
        yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while uploading the file!`,
          severity: "error"
        });
      }
    }
  });
  if (uploadFile.isLoading || createFolder.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", children: [
    /* @__PURE__ */ jsx(
      DropboxDocuments,
      {
        folderDirectory: dropboxDirectory,
        layout: "horizontal",
        control,
        setIsFormDirty
      }
    ),
    /* @__PURE__ */ jsx(Box$1, { display: "flex", justifyContent: "flex-end", marginTop: theme.spacing(2), children: /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: handleOnUploadDocument, children: "Upload" }) })
  ] }) });
}
function TrackingTimeline(props) {
  const { query } = useContext(ContainerConsignmentContext);
  return /* @__PURE__ */ jsx(
    ConsignmentTrackingHistory,
    __spreadProps$4(__spreadValues$4({}, props), {
      query
    })
  );
}
function ContainerConsignmentOrderDetails() {
  var _a, _b, _c, _d, _e, _f, _g;
  const { query } = useContext(ContainerConsignmentContext);
  const consignment = (_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data;
  const container = consignment == null ? void 0 : consignment.container;
  const gridRows = [];
  if (container) {
    gridRows.push({
      id: container.id,
      containerNumber: (_c = (_b = container.good.containerAsset) == null ? void 0 : _b.containerNumber) != null ? _c : EMPTY_STRING$g,
      fullOrMT: container.good.isEmpty ? "MT" : "FULL",
      movementType: consignment.movementType.name,
      type: (_d = container.good.type) == null ? void 0 : _d.name,
      commodity: (_e = container.good.commodity) == null ? void 0 : _e.name,
      size: (_f = container.good.size) == null ? void 0 : _f.name,
      weight: (_g = container.good.gross) == null ? void 0 : _g.measure
    });
  }
  return /* @__PURE__ */ jsx(ContainerConsignmentOrderDetails$1, { gridLoading: query.isFetching, gridRows });
}
function AdditionalDetails$1() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const theme = useTheme$2();
  const mobileBreakPoint = useMediaQuery(theme.breakpoints.down("md"));
  const fontSize = mobileBreakPoint ? "0.85rem" : "0.9rem";
  const { query } = useContext(ContainerConsignmentContext);
  const data = (_a = query.data) == null ? void 0 : _a.data;
  if (query.isFetching) {
    return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton, { height: "0.815rem", width: "80px" }),
        /* @__PURE__ */ jsx(Skeleton, { height: "0.9rem", width: "90px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton, { height: "0.9rem", width: "80px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton, { height: "0.815rem", width: "100px" }),
        /* @__PURE__ */ jsx(Skeleton, { height: "0.9rem", width: "85px" })
      ] }) }),
      /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 6, children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
        /* @__PURE__ */ jsx(Skeleton, { height: "0.815rem", width: "115px" }),
        /* @__PURE__ */ jsx(Skeleton, { height: "0.9rem", width: "75px" })
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsxs(Box$1, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: 12, children: [
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Vessel" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_d = (_c = (_b = data == null ? void 0 : data.vessel) == null ? void 0 : _b.transport) == null ? void 0 : _c.vesselName) != null ? _d : EMPTY_STRING$g })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Release Number" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_f = (_e = data == null ? void 0 : data.container.good.releaseNumber) == null ? void 0 : _e.reference) != null ? _f : EMPTY_STRING$g })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Seal" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: ((_g = data == null ? void 0 : data.container.good.sealNumber) != null ? _g : "").length > 0 ? data == null ? void 0 : data.container.good.sealNumber : "-" })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Box$1,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 6,
        paddingRight: mobileBreakPoint ? 2 : "inherit",
        children: /* @__PURE__ */ jsxs(Box$1, { display: "flex", flexDirection: "column", gap: 2, children: [
          /* @__PURE__ */ jsx(Typography$1, { fontSize: "small", lineHeight: 1, color: theme.palette.grey[700], children: "Pin" }),
          /* @__PURE__ */ jsx(Typography$1, { fontSize, lineHeight: "0.9rem", children: (_i = (_h = data == null ? void 0 : data.container.good.pin) == null ? void 0 : _h.note) != null ? _i : EMPTY_STRING$g })
        ] })
      }
    )
  ] });
}
function CommentsDetails() {
  var _a, _b;
  const { query } = useContext(ContainerConsignmentContext);
  if (query.isFetching) {
    return /* @__PURE__ */ jsx(CommentsDetailsLoading, {});
  }
  return /* @__PURE__ */ jsx(CommentsDetails$3, { comments: (_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.comments });
}
function deleteIds(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        deleteIds(obj[key]);
      } else if (key === "id") {
        delete obj[key];
      } else if (key === "objectID") {
        delete obj[key];
      }
    }
  }
}
function ContainerConsignmentBottomControls({ prepareDuplicateValue }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const theme = useTheme$2();
  const { query, currentUser, popup } = useContext(ContainerConsignmentContext);
  const [isOpenEnquiryDialog, setIsOpenEnquiryDialog] = useState(false);
  if (query.isFetching)
    return /* @__PURE__ */ jsx(Fragment, {});
  const enquiryOnClick = () => {
    setIsOpenEnquiryDialog(true);
  };
  const duplicateOnClick = () => {
    var _a2, _b2, _c2;
    if (!((_a2 = query.data) == null ? void 0 : _a2.data))
      return;
    const values = typeof prepareDuplicateValue === "function" ? prepareDuplicateValue((_b2 = query.data) == null ? void 0 : _b2.data) : (_c2 = query.data) == null ? void 0 : _c2.data;
    deleteIds(values);
    const newTab = window.open(`${window.location.origin}/#/ContainerBooking?duplicate=true`);
    if (newTab) {
      newTab.addEventListener("load", () => {
        const channel = new BroadcastChannel("ContainerBooking");
        channel.onmessage = function(event) {
          if (event.data.type === "connected" && event.data.payload === true) {
            channel.postMessage({ type: "duplicate", payload: values });
            channel.close();
          }
        };
      });
    }
  };
  const promptFeatureNotImplemented = () => {
    popup({
      message: "Feature is not implemented yet.",
      severity: "info"
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Box$1, { display: "flex", children: [
      /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: promptFeatureNotImplemented, children: "Print Consignment" }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: promptFeatureNotImplemented, children: "Print Labels" })
      ] }),
      /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, justifyContent: "flex-end", display: "flex", gap: 2, children: [
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: enquiryOnClick, children: "Enquiry" }),
        /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: duplicateOnClick, children: "Duplicate" })
      ] })
    ] }),
    isOpenEnquiryDialog && !query.isFetching && ((_b = (_a = query.data) == null ? void 0 : _a.data) == null ? void 0 : _b.reference) && /* @__PURE__ */ jsx(
      Enquiry,
      {
        setIsOpenEnquiryDialog,
        defaultValues: {
          jobReference: (_c = query.data) == null ? void 0 : _c.data.reference,
          name: (_e = (_d = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _d.fullName) != null ? _e : void 0,
          phone: (_g = (_f = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _f.phoneNumber) != null ? _g : void 0,
          email: (_i = (_h = currentUser == null ? void 0 : currentUser.data) == null ? void 0 : _h.email) != null ? _i : void 0
        }
      }
    )
  ] });
}
function ConsignmentChargeDetails({ gridFooter }) {
  var _a, _b, _c, _d;
  const { query, chargeQuery } = useContext(ContainerConsignmentContext);
  const rows = ((_b = (_a = chargeQuery == null ? void 0 : chargeQuery.data) == null ? void 0 : _a.data) == null ? void 0 : _b.rows) || [];
  return /* @__PURE__ */ jsx(
    ConsignmentChargeDetails$2,
    {
      gridLoading: chargeQuery.isFetching,
      gridRows: rows,
      estimatedCharge: (_d = (_c = query.data) == null ? void 0 : _c.data) == null ? void 0 : _d.estimatedCharge,
      gridFooter
    }
  );
}
function _ContainerConsignmentTracker({ id, children }) {
  const myAccountService = new MyAccountService();
  const query = useQuery$1(
    ["/ContainerConsignment", id],
    () => httpService$1.get(`ContainerConsignment/${id}`)
  );
  const { data: currentUser } = useQuery$1(["myDetail"], () => myAccountService.getMe());
  const [chargeQuery] = useGridQuery({
    systemName: "ConsignmentSummaryChargeGrid",
    parameters: {
      additionalFilter: {
        jobID: id
      }
    }
  });
  const popup = usePopupAlert();
  return /* @__PURE__ */ jsx(
    ContainerConsignmentContext.Provider,
    {
      value: {
        query,
        currentUser,
        chargeQuery,
        popup
      },
      children
    }
  );
}
const ContainerConsignment = Object.assign(_ContainerConsignmentTracker, {
  EventsProgress: () => {
    var _a, _b;
    const { query } = useContext(ContainerConsignmentContext);
    if (query.isFetching)
      return /* @__PURE__ */ jsx(SupplyChainTimelineLoading, { size: "sm" });
    if (!((_a = query.data) == null ? void 0 : _a.data.events))
      return /* @__PURE__ */ jsx(Fragment, {});
    return /* @__PURE__ */ jsx(ConsignmentSupplyChainTimeline, { events: (_b = query.data) == null ? void 0 : _b.data.events });
  },
  Map: Map$2,
  ContainerConsignmentTopControls,
  ConsignmentDetails,
  DocumentsDetails,
  ContainerConsignmentOrderDetails,
  TrackingTimeline,
  AdditionalDetails: AdditionalDetails$1,
  CommentsDetails,
  ContainerConsignmentBottomControls,
  ConsignmentChargeDetails
});
const ContainerConsignmentTrackerPage = Object.assign({
  EventsProgress: ConsignmentSupplyChainTimeline,
  EventsTimeline,
  ContainerConsignment
});
const useContainerConsignmentContext = () => {
  return useContext(ContainerConsignmentContext);
};

var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const baseValidationSchema = z$1.object({
  freightPayer: z$1.object(
    {
      fileAs: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.freightPayer")}`,
      required_error: `Please provide a ${getTerm("consignment.freightPayer")}`
    }
  ).passthrough()
});
const objectLocationSchema = z$1.object({
  locationID: z$1.number(),
  locationName: z$1.string()
}).passthrough();
const addressSchema = z$1.object({
  name: z$1.string()
}).passthrough();
const containerDraftValidationSchema = baseValidationSchema.extend({
  submitType: z$1.literal("draft")
}).passthrough();
const containerQuoteValidationSchema = baseValidationSchema.extend({
  submitType: z$1.literal("quote")
}).passthrough();
const containerSubmitValidationSchema = baseValidationSchema.extend({
  submitType: z$1.literal("submit"),
  orderReference: z$1.object(
    {
      reference: z$1.string()
    },
    {
      invalid_type_error: `Please provide an ${getTerm("consignment.orderReference")}`,
      required_error: `Please provide an ${getTerm("consignment.orderReference")}`
    }
  ).passthrough(),
  isDangerousGoods: z$1.boolean(),
  unNumber: z$1.object(
    {
      note: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.unNumber")}`,
      required_error: `Please provide a ${getTerm("consignment.unNumber")}`
    }
  ).passthrough().nullable().optional(),
  dgClass: z$1.object(
    {
      code: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.dgClass")}`,
      required_error: `Please provide a ${getTerm("consignment.dgClass")}`
    }
  ).passthrough().nullable().optional(),
  containerfullOrEmpty: z$1.object(
    {
      value: z$1.string(),
      label: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.container.fullOrEmpty")}`,
      required_error: `Please provide a ${getTerm("consignment.container.fullOrEmpty")}`
    }
  ).passthrough(),
  container: z$1.object({
    good: z$1.object({
      containerAsset: z$1.object({
        containerNumber: z$1.string({
          invalid_type_error: `Please provide a ${getTerm(
            "consignment.container.containerNumber"
          )}`,
          required_error: `Please provide a ${getTerm(
            "consignment.container.containerNumber"
          )}`
        })
      }).passthrough(),
      commodity: z$1.object(
        {
          code: z$1.string()
        },
        {
          invalid_type_error: `Please provide a ${getTerm(
            "consignment.container.commodity"
          )}`,
          required_error: `Please provide a ${getTerm("consignment.container.commodity")}`
        }
      ).passthrough(),
      doorDirection: z$1.object(
        {
          code: z$1.string()
        },
        {
          invalid_type_error: `Please provide a ${getTerm("consignment.container.doors")}`,
          required_error: `Please provide a ${getTerm("consignment.container.doors")}`
        }
      ).passthrough(),
      size: z$1.object(
        {
          code: z$1.string()
        },
        {
          invalid_type_error: `Please provide a ${getTerm("consignment.container.size")}`,
          required_error: `Please provide a ${getTerm("consignment.container.size")}`
        }
      ).passthrough()
    }).passthrough()
  }).passthrough(),
  movementType: z$1.object(
    {
      code: z$1.string()
    },
    {
      invalid_type_error: `Please provide a ${getTerm("consignment.container.movementType")}`,
      required_error: `Please provide a ${getTerm("consignment.container.movementType")}`
    }
  ).passthrough(),
  pickupLocation: objectLocationSchema.nullable().optional(),
  pickupAddress: addressSchema.nullable().optional(),
  deliveryLocation: objectLocationSchema.nullable().optional(),
  deliveryAddress: addressSchema.nullable().optional(),
  pack: objectLocationSchema.nullable().optional(),
  packAddress: addressSchema.nullable().optional(),
  unpack: objectLocationSchema.nullable().optional(),
  unpackAddress: addressSchema.nullable().optional()
}).passthrough();
const validationSchema = z$1.discriminatedUnion("submitType", [
  containerDraftValidationSchema,
  containerQuoteValidationSchema,
  containerSubmitValidationSchema
]);
const containerFormValidationSchema = validationSchema.superRefine((data, ctx) => __async$1(void 0, null, function* () {
  if (data.submitType === "submit") {
    if (data.isDangerousGoods) {
      if (!data.unNumber) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["unNumber"],
          message: `Please provide a ${getTerm("consignment.unNumber")}`
        });
      }
      if (!data.dgClass) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["dgClass"],
          message: `Please provide a ${getTerm("consignment.dgClass")}`
        });
      }
    }
    if (data.movementType.code === SystemName.MovementType.Import) {
      if (isEmpty$2(data.pickupLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupLocation"],
          message: "Pickup - Name is required for Import"
        });
      }
      if (isEmpty$2(data.pickupAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupAddress"],
          message: "Pickup Address is required for Import"
        });
      }
      if (isEmpty$2(data.deliveryLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryLocation"],
          message: "Dehire - Name is required for Import"
        });
      }
      if (!isEmpty$2(data.deliveryLocation) && data.deliveryLocation.locationID < 0 && isEmpty$2(data.newDeliveryLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newDeliveryLocation"],
          message: `Please provide a New Dehire - Name`
        });
      }
      if (isEmpty$2(data.deliveryAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryAddress"],
          message: "Dehire Address is required for Import"
        });
      }
      if (isEmpty$2(data.deliveryDate)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryDate"],
          message: "Dehire Date is required for Import"
        });
      }
      if (isEmpty$2(data.unpack)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["unpack"],
          message: "Unpack - Name is required for Import"
        });
      }
      if (!isEmpty$2(data.unpack) && data.unpack.locationID < 0 && isEmpty$2(data.newUnpackLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newUnpackLocation"],
          message: `Please provide a New Unpack - Name`
        });
      }
      if (isEmpty$2(data.unpackAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["unpackAddress"],
          message: "Unpack Address is required for Import"
        });
      }
    }
    if (data.movementType.code === SystemName.MovementType.Export) {
      if (isEmpty$2(data.pickupLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupLocation"],
          message: "Pickup - Name is required for Import"
        });
      }
      if (!isEmpty$2(data.pickupLocation) && data.pickupLocation.locationID < 0 && isEmpty$2(data.newPickupLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newPickupLocation"],
          message: `Please provide a New Pickup - Name`
        });
      }
      if (isEmpty$2(data.pickupAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupAddress"],
          message: "Pickup Address is required for Import"
        });
      }
      if (isEmpty$2(data.deliveryLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryLocation"],
          message: "Export - Name is required for Import"
        });
      }
      if (!isEmpty$2(data.deliveryLocation) && data.deliveryLocation.locationID < 0 && isEmpty$2(data.newDeliveryLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newDeliveryLocation"],
          message: `Please provide a New Export - Name`
        });
      }
      if (isEmpty$2(data.deliveryAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryAddress"],
          message: "Export Address is required for Import"
        });
      }
      if (isEmpty$2(data.pack)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pack"],
          message: "Pack - Name is required for Export"
        });
      }
      if (isEmpty$2(data.packAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["packAddress"],
          message: "Pack Address is required for Export"
        });
      }
      if (isEmpty$2(data.deliveryDate)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryDate"],
          message: "Export Date is required for Export"
        });
      }
    }
    if (data.movementType.code === SystemName.MovementType.Move) {
      if (isEmpty$2(data.pickupLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupLocation"],
          message: "Pickup - Name is required for Move"
        });
      }
      if (!isEmpty$2(data.pickupLocation) && data.pickupLocation.locationID < 0 && isEmpty$2(data.newPickupLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newPickupLocation"],
          message: `Please provide a New Pickup - Name`
        });
      }
      if (isEmpty$2(data.pickupAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["pickupAddress"],
          message: "Pickup Address is required for Move"
        });
      }
      if (!data.deliveryLocation) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryLocation"],
          message: "Dropoff - Name is required for Move"
        });
      }
      if (isEmpty$2(data.deliveryAddress)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryAddress"],
          message: "Dropoff Address is required for Move"
        });
      }
      if (!isEmpty$2(data.deliveryLocation) && data.deliveryLocation.locationID < 0 && isEmpty$2(data.newDeliveryLocation)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["newDeliveryLocation"],
          message: `Please provide a New Dropoff - Name`
        });
      }
      if (isEmpty$2(data.deliveryDate)) {
        ctx.addIssue({
          code: z$1.ZodIssueCode.custom,
          path: ["deliveryDate"],
          message: "Delivery Date is required for Move"
        });
      }
    }
  }
}));

var __defProp$3 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const Context$2 = createContext({});
const fullOrEmptyOptions = [
  {
    value: "Full",
    label: "Full"
  },
  {
    value: "Empty",
    label: "Empty"
  }
];
const formatObjectLocation = (propertyName, propertyNameLocationName, containerData, addressName) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const objectLocation = containerData[propertyName];
  const objectLocationName = containerData[propertyNameLocationName];
  if (!objectLocation) {
    return null;
  }
  const locationAddress = addressName ? containerData[addressName] : null;
  const addressFields = addressName && containerData[addressName] ? serializeAddress((_a = locationAddress == null ? void 0 : locationAddress.name) != null ? _a : "") : null;
  if (addressFields) {
    const { address1, address2, suburb, postcode } = addressFields;
    objectLocation.address1 = address1;
    objectLocation.address2 = address2;
    objectLocation.suburb = suburb;
    objectLocation.postcode = postcode;
  }
  if ((objectLocation == null ? void 0 : objectLocation.locationID) && objectLocation.locationID > 0) {
    return __spreadValues$3({}, objectLocation);
  }
  return __spreadProps$3(__spreadValues$3({}, objectLocation), {
    locationID: null,
    locationName: (_c = (_b = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _b.locationName) != null ? _c : objectLocationName == null ? void 0 : objectLocationName.name,
    latitude: (_f = (_d = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _d.latitude) != null ? _f : (_e = locationAddress == null ? void 0 : locationAddress.additionalData) == null ? void 0 : _e.latitude,
    longitude: (_i = (_g = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _g.longitude) != null ? _i : (_h = locationAddress == null ? void 0 : locationAddress.additionalData) == null ? void 0 : _h.longitude,
    combinedCode: (_j = objectLocationName == null ? void 0 : objectLocationName.additionalData) == null ? void 0 : _j.combinedCode
  });
};
const serializeContainerConsignment = (consignment) => {
  var _a, _b, _c;
  const consignmentData = __spreadValues$3({}, consignment);
  const container = (_a = consignmentData.container) != null ? _a : {};
  if (isLookupItem(consignmentData.vesselLookup)) {
    consignmentData.vessel = {
      transport: {
        vesselName: consignmentData.vesselLookup.name,
        vesselID: consignmentData.vesselLookup.id ? +consignmentData.vesselLookup.id : null,
        reference: (_c = (_b = consignmentData.vessel) == null ? void 0 : _b.transport) == null ? void 0 : _c.reference
      }
    };
  }
  if (consignmentData.containerfullOrEmpty) {
    container.good.isEmpty = consignmentData.containerfullOrEmpty.value === SystemName.GoodsLoad.Empty ? true : false;
  }
  if (consignmentData.pickupLocation) {
    consignmentData.pickupLocation = prepareObjectLocation(consignmentData.pickupLocation);
  }
  if (isObjectLocation(consignmentData.pickupLocation)) {
    consignmentData.pickupLocation = formatObjectLocation(
      "pickupLocation",
      "newPickupLocation",
      consignmentData,
      "pickupAddress"
    );
  }
  if (consignmentData.deliveryLocation) {
    consignmentData.deliveryLocation = prepareObjectLocation(consignmentData.deliveryLocation);
  }
  if (isObjectLocation(consignmentData.deliveryLocation)) {
    consignmentData.deliveryLocation = formatObjectLocation(
      "deliveryLocation",
      "newDeliveryLocation",
      consignmentData,
      "deliveryAddress"
    );
  }
  if (consignmentData.pack) {
    consignmentData.pack = prepareObjectLocation(consignmentData.pack);
  }
  if (isObjectLocation(consignmentData.pack)) {
    consignmentData.pack = formatObjectLocation(
      "pack",
      "newPackLocation",
      consignmentData,
      "packAddress"
    );
  }
  if (consignmentData.unpack) {
    consignmentData.unpack = prepareObjectLocation(consignmentData.unpack);
  }
  if (isObjectLocation(consignmentData.unpack)) {
    consignmentData.unpack = formatObjectLocation(
      "unpack",
      "newUnpackLocation",
      consignmentData,
      "unpackAddress"
    );
  }
  if (consignmentData.dehire) {
    consignmentData.dehire = prepareObjectLocation(consignmentData.dehire);
  }
  if (isObjectLocation(consignmentData.dehire)) {
    consignmentData.dehire = formatObjectLocation(
      "dehire",
      "newDehireLocation",
      consignmentData,
      "dehireAddress"
    );
  }
  if (consignmentData.container) {
    container.typeCode = "Container";
  }
  return __spreadProps$3(__spreadValues$3({}, consignmentData), {
    container
  });
};
function ConsignmentReferenceDetails() {
  const { form } = useContext(Context$2);
  return /* @__PURE__ */ jsx(ConsignmentReferences, { form });
}
const getCodeOptions = (codes, filterList) => {
  const filteredCodes = filterList ? codes.filter((code) => {
    var _a;
    return filterList.includes((_a = code.additionalData) == null ? void 0 : _a.code);
  }) : codes;
  const sortedCodes = filterList ? filteredCodes.sort(
    (a, b) => {
      var _a, _b;
      return filterList.indexOf((_a = a.additionalData) == null ? void 0 : _a.code) - filterList.indexOf((_b = b.additionalData) == null ? void 0 : _b.code);
    }
  ) : filteredCodes;
  const options = sortedCodes.map((code) => {
    var _a, _b;
    return {
      value: code.id,
      label: (_b = (_a = code.additionalData) == null ? void 0 : _a.codeName) != null ? _b : code.name,
      additionalData: code.additionalData
    };
  });
  return options;
};
const setFullOrEmpty = (value) => {
  let newValue = { value: null, disabled: false };
  switch (value) {
    case SystemName.MovementType.Import:
      newValue = { value: SystemName.GoodsLoad.Full, disabled: true };
      break;
    case SystemName.MovementType.Export:
      newValue = { value: SystemName.GoodsLoad.Empty, disabled: true };
      break;
    case SystemName.MovementType.Move:
      newValue = { value: null, disabled: false };
      break;
  }
  return newValue;
};
function ContainerDetails() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { form } = useContext(Context$2);
  const { watch, setValue, setError } = form;
  const [disableContainerGoodsLoad, setDisableContainerGoodsLoad] = useState(false);
  (_a = watch("freightPayer")) == null ? void 0 : _a.contactID;
  const [sizeDataOptions] = useLookupQuery({
    systemName: "Code",
    additionalFilter: {
      codeQualifier: "ContainerSize"
    }
  });
  const [movementTypeDataOptions] = useLookupQuery({
    systemName: "Code",
    additionalFilter: {
      codeQualifier: "MovementType"
    }
  });
  const [loadDataOptions] = useLookupQuery({
    systemName: "Code",
    additionalFilter: {
      codeQualifier: "TransportType"
    }
  });
  useEffect(() => {
    var _a2;
    if ((loadDataOptions == null ? void 0 : loadDataOptions.data) && !loadDataOptions.isFetching) {
      const standardLoad = loadDataOptions.data.data.results.find(
        (x) => {
          var _a3;
          return ((_a3 = x.additionalData) == null ? void 0 : _a3.code) === SystemName.ContainerTransportType.Standard;
        }
      );
      if (standardLoad) {
        setValue("container.good.transportType", {
          code: (_a2 = standardLoad.additionalData) == null ? void 0 : _a2.code,
          codeID: standardLoad.id,
          name: standardLoad.name
        });
      }
    }
  }, [loadDataOptions == null ? void 0 : loadDataOptions.data, loadDataOptions == null ? void 0 : loadDataOptions.isFetching]);
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "containerNumber", label: getTerm("consignment.container.containerNumber"), required: true }),
      /* @__PURE__ */ jsx(FormInput, { name: "container.good.containerAsset.containerNumber" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.good.owner", label: getTerm("consignment.container.containerOwner") }),
      /* @__PURE__ */ jsx(NoteInput, { name: "container.good.owner" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "movementType", label: getTerm("consignment.container.movementType"), required: true }),
      /* @__PURE__ */ jsx(
        ContainerToggleGroup,
        {
          name: "movementType",
          options: getCodeOptions((_d = (_c = (_b = movementTypeDataOptions.data) == null ? void 0 : _b.data) == null ? void 0 : _c.results) != null ? _d : []) || [],
          isLoading: movementTypeDataOptions.isLoading,
          onChange: (event, value) => {
            var _a2, _b2;
            const selectedMovementType = value;
            if (selectedMovementType) {
              const newValue = setFullOrEmpty((_b2 = (_a2 = selectedMovementType.additionalData) == null ? void 0 : _a2.code) != null ? _b2 : "");
              setValue("containerfullOrEmpty", {
                value: newValue.value,
                label: newValue.value
              });
              setDisableContainerGoodsLoad(newValue.disabled);
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "fullOrEmpty", label: getTerm("consignment.container.fullOrEmpty"), required: true }),
      /* @__PURE__ */ jsx(
        FormToggleGroup,
        {
          name: "containerfullOrEmpty",
          options: fullOrEmptyOptions,
          disabled: disableContainerGoodsLoad
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.good.gross", label: getTerm("consignment.container.weight") }),
      /* @__PURE__ */ jsx(MeasureInput, { name: "container.good.gross" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.size", label: getTerm("consignment.container.size"), required: true }),
      /* @__PURE__ */ jsx(
        ContainerToggleGroup,
        {
          name: "container.good.size",
          options: getCodeOptions((_g = (_f = (_e = sizeDataOptions.data) == null ? void 0 : _e.data) == null ? void 0 : _f.results) != null ? _g : [], ["10", "20", "40", "45"]) || [],
          isLoading: sizeDataOptions.isLoading
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "type", label: getTerm("consignment.container.type") }),
      /* @__PURE__ */ jsx(
        CodeLookup,
        {
          name: "container.good.type",
          params: {
            systemName: "Code",
            additionalFilter: {
              codeQualifier: "ContainerType"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(
        InputLabel,
        {
          name: "container.good.commodity",
          label: getTerm("consignment.container.commodity"),
          required: true
        }
      ),
      /* @__PURE__ */ jsx(
        CodeLookup,
        {
          name: "container.good.commodity",
          params: {
            systemName: "Code",
            additionalFilter: {
              codeQualifier: "Commodity"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "vessel", label: getTerm("consignment.container.vessel") }),
      /* @__PURE__ */ jsx(
        FormLookup,
        {
          name: "vesselLookup",
          params: {
            systemName: "Vessel"
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "voyage", label: getTerm("consignment.container.voyage") }),
      /* @__PURE__ */ jsx(FormInput, { name: "vessel.transport.reference" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 2, children: [
      /* @__PURE__ */ jsx(
        InputLabel,
        {
          name: "container.good.releaseNumber",
          label: getTerm("consignment.container.releaseNumber")
        }
      ),
      /* @__PURE__ */ jsx(ReferenceInput, { name: "container.good.releaseNumber" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 2, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.good.pin", label: getTerm("consignment.container.pin") }),
      /* @__PURE__ */ jsx(NoteInput, { name: "container.good.pin" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 2, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.good.sealNumber", label: getTerm("consignment.container.sealNumber") }),
      /* @__PURE__ */ jsx(FormInput, { name: "container.good.sealNumber" })
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "doors", label: getTerm("consignment.container.doors"), required: true }),
      /* @__PURE__ */ jsx(
        CodeLookup,
        {
          name: "container.good.doorDirection",
          params: {
            systemName: "Code",
            additionalFilter: {
              codeQualifier: "DoorDirection"
            }
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 3, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "container.good.transportType", label: getTerm("consignment.container.load") }),
      /* @__PURE__ */ jsx(
        ContainerToggleGroup,
        {
          name: "container.good.transportType",
          options: getCodeOptions((_j = (_i = (_h = loadDataOptions.data) == null ? void 0 : _h.data) == null ? void 0 : _i.results) != null ? _j : []) || [],
          isLoading: loadDataOptions.isLoading,
          sortOptions: (a, b) => {
            var _a2, _b2, _c2, _d2, _e2, _f2;
            const standardCodeName = "Standard";
            if (((_a2 = a.additionalData) == null ? void 0 : _a2.code) === standardCodeName)
              return -1;
            if (((_b2 = b.additionalData) == null ? void 0 : _b2.code) === standardCodeName)
              return 1;
            return ((_d2 = (_c2 = a.additionalData) == null ? void 0 : _c2.code) != null ? _d2 : "").localeCompare((_f2 = (_e2 = b.additionalData) == null ? void 0 : _e2.code) != null ? _f2 : "");
          }
        }
      )
    ] })
  ] });
}
function DangerousGoods() {
  const { form, isDropboxDocuments, mainDropboxDirectory } = useContext(Context$2);
  const { watch } = form;
  const reference = watch("reference");
  const folderPath = isDropboxDocuments ? mainDropboxDirectory + "/" + reference : mainDropboxDirectory;
  return /* @__PURE__ */ jsx(DangerousGoods$2, { form, isDropboxDocuments, folderPath });
}
function FromAndToDetails({
  placesAPIKey,
  autocompleteRequestOptions,
  placeDetailsRequestOptions
}) {
  var _a, _b;
  const { form } = useContext(Context$2);
  const movementType = (_b = (_a = form.watch("movementType")) == null ? void 0 : _a.code) != null ? _b : "";
  const renderedComponent = useMemo(() => {
    switch (movementType) {
      case SystemName.MovementType.Import:
        return /* @__PURE__ */ jsx(
          ImportMovementFromAndToDetails,
          {
            placesAPIKey,
            autocompleteRequestOptions,
            placeDetailsRequestOptions
          }
        );
      case SystemName.MovementType.Export:
        return /* @__PURE__ */ jsx(
          ExportMovementFromAndToDetails,
          {
            placesAPIKey,
            autocompleteRequestOptions,
            placeDetailsRequestOptions
          }
        );
      case SystemName.MovementType.Move:
        return /* @__PURE__ */ jsx(
          MoveMovementFromAndToDetails,
          {
            placesAPIKey,
            autocompleteRequestOptions,
            placeDetailsRequestOptions
          }
        );
      default:
        return /* @__PURE__ */ jsx(Box$1, { display: "flex", flexDirection: "column", gap: 4, children: /* @__PURE__ */ jsx(Alert$1, { severity: "info", children: "Select a Movement Type" }) });
    }
  }, [movementType]);
  return /* @__PURE__ */ jsx(Fragment, { children: renderedComponent });
}
function AdditionalDetails() {
  const { form, mainDropboxDirectory, isDropboxDocuments } = useContext(Context$2);
  const reference = form.watch("reference");
  const dropboxDirectory = reference ? mainDropboxDirectory + "/" + reference : "";
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
    /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "comments", label: getTerm("comments") }),
      /* @__PURE__ */ jsx(NoteInput, { name: "comments", multiline: true, minRows: 5 })
    ] }),
    isDropboxDocuments ? /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "documents", label: "Upload Documents" }),
      /* @__PURE__ */ jsx(
        DropboxDocuments,
        {
          folderDirectory: dropboxDirectory,
          filterDocuments: (documents) => !documents.name.startsWith("DG_"),
          control: form.control
        }
      )
    ] }) : /* @__PURE__ */ jsxs(Grid$3, { item: true, xs: 12, md: 6, children: [
      /* @__PURE__ */ jsx(InputLabel, { name: "documents", label: "Upload Documents" }),
      /* @__PURE__ */ jsx(Alert$1, { severity: "info", children: /* @__PURE__ */ jsx(Typography$1, { variant: "body2", children: "Feature to be implemented" }) })
    ] })
  ] });
}
function EstimateCharge() {
  return /* @__PURE__ */ jsx(EstimateCharge$2, {});
}
function ContainerBookingButtonControls({
  onSaveDraft,
  onSaveQuote,
  onCreateBooking
}) {
  const theme = useTheme$2();
  const popup = usePopupAlert();
  const navigate = useNavigate();
  const { checkFolderExists, createFolder, uploadFile, error: dropboxError } = useDropbox();
  const { form, mutation, mainDropboxDirectory, isDropboxDocuments } = useContext(Context$2);
  const { getValues, setValue, handleSubmit } = form;
  const [isDialogOpen, openDialog, closeDialog] = useToggle(false);
  const ConsignmentDashboardChannelName = "ConsignmentDashboard";
  const ConsignmentMessage = "refreshDashboard";
  const createNewChannel = () => {
    const channel = new BroadcastChannel(ConsignmentDashboardChannelName);
    channel.postMessage(ConsignmentMessage);
    channel.close();
  };
  const navigateToBooking = (id) => {
    navigate(`/ContainerBooking/${id}`);
  };
  const onConfirmDialog = () => {
    closeDialog();
    createBooking();
  };
  const handleSaveDropBoxDocument = (filePath, selectedFiles, filterType) => __async(this, null, function* () {
    if (!selectedFiles || selectedFiles.length === 0) {
      return;
    }
    const filteredSelectedFiles = selectedFiles.filter((file) => file.file);
    try {
      const isFolderExists = yield checkFolderExists(filePath);
      if (!isFolderExists) {
        yield createFolder.mutateAsync(filePath);
      }
      const uploadResults = yield Promise.allSettled(
        filteredSelectedFiles.map((file) => __async(this, null, function* () {
          const fileName = filterType ? `${filterType}_${file.file.name}` : file.file.name;
          return yield uploadFile.mutateAsync({ file: file.file, folderPath: filePath, fileName });
        }))
      );
      if (uploadResults.length > 0) {
        popup({
          message: "Documents have been saved successfully.",
          severity: "success"
        });
        setValue("dgDocuments", []);
        setValue("dropBoxDocuments", []);
      }
    } catch (error) {
      popup({
        message: "An error occurred while saving Documents.",
        severity: "error"
      });
    }
  });
  const getFullPath = (id) => __async(this, null, function* () {
    var _a, _b;
    const jobDetails = yield httpService$1.get(`ContainerConsignment/${id}`);
    const filePath = (_b = (_a = jobDetails == null ? void 0 : jobDetails.data) == null ? void 0 : _a.reference) != null ? _b : "";
    const fullPath = `${mainDropboxDirectory}/${filePath}`;
    return fullPath;
  });
  const createBooking = () => __async(this, null, function* () {
    var _a;
    const values = getValues();
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const submittedValues = __spreadProps$3(__spreadValues$3({}, values), {
      statusSystemName: SystemName.Status.Submitted,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Submitted)
    });
    try {
      const data = yield mutation.mutateAsync(submittedValues);
      popup({
        message: `Your booking has been ${getTerm("consignment.submitted")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigate(`/Container/${data == null ? void 0 : data.data}`);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while sending the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  const handleOnCreateBooking = () => {
    if (typeof onCreateBooking === "function") {
      onCreateBooking();
      return;
    }
    openDialog();
  };
  const handleOnSaveDraft = (values) => __async(this, null, function* () {
    var _a;
    if (typeof onSaveDraft === "function") {
      onSaveDraft();
      return;
    }
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const draftValues = __spreadProps$3(__spreadValues$3({}, values), {
      statusSystemName: SystemName.Status.Draft,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Draft)
    });
    try {
      const data = yield mutation.mutateAsync(draftValues);
      popup({
        message: `Your booking has been saved as ${getTerm("consignment.draft")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigateToBooking(data.data);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while saving the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  const handleOnSaveQuote = (values) => __async(this, null, function* () {
    var _a;
    if (typeof onSaveQuote === "function") {
      onSaveQuote();
      return;
    }
    const existingEvents = (_a = values == null ? void 0 : values.events) != null ? _a : [];
    const quoteValues = __spreadProps$3(__spreadValues$3({}, values), {
      statusSystemName: SystemName.Status.Quote,
      events: createConsignmentEvent(existingEvents, SystemName.Status.Quote)
    });
    try {
      const data = yield mutation.mutateAsync(quoteValues);
      popup({
        message: `Your booking has been saved as ${getTerm("consignment.quote")}!`,
        severity: "success"
      });
      if (data == null ? void 0 : data.data) {
        if (values.dropBoxDocuments && values.dropBoxDocuments.length > 0 || values.dgDocuments && values.dgDocuments.length > 0) {
          const fullPath = yield getFullPath(data.data);
          yield handleSaveDropBoxDocument(fullPath, values.dropBoxDocuments);
          yield handleSaveDropBoxDocument(fullPath, values.dgDocuments, "DG");
        }
        navigateToBooking(data.data);
      }
    } catch (e) {
      if (e instanceof Error) {
        popup({
          message: `An error has occurred while saving the booking!`,
          severity: "error"
        });
      }
    }
    createNewChannel();
  });
  const handleSubmitClick = (submitType) => {
    setValue("submitType", submitType);
    handleSubmitHandler();
  };
  const handleSubmitHandler = () => {
    handleSubmit((data) => {
      if (data.submitType === "quote") {
        handleOnSaveQuote(data);
        return;
      }
      if (data.submitType === "draft") {
        handleOnSaveDraft(data);
        return;
      }
      if (data.submitType === "submit") {
        handleOnCreateBooking();
        return;
      }
    })();
  };
  if (mutation.isLoading) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box$1, { display: "flex", children: /* @__PURE__ */ jsxs(Box$1, { flex: `1 0 calc(50% - ${theme.spacing(2)})`, justifyContent: "flex-end", display: "flex", gap: 2, children: [
      /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => handleSubmitClick("quote"), children: "Save as Quote" }),
      /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => handleSubmitClick("draft"), children: "Save as Draft" }),
      /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: () => handleSubmitClick("submit"), children: "Create Booking" })
    ] }) }),
    /* @__PURE__ */ jsx(
      DialogWrap,
      {
        fullWidth: true,
        open: isDialogOpen,
        onClose: closeDialog,
        title: "Confirm Booking",
        content: "You are now creating a live booking. Please confirm you wish to proceed",
        children: /* @__PURE__ */ jsxs(DialogActions$1, { children: [
          /* @__PURE__ */ jsx(Button, { onClick: closeDialog, autoFocus: true, children: "Cancel" }),
          /* @__PURE__ */ jsx(Button, { onClick: onConfirmDialog, autoFocus: true, children: "Confirm" })
        ] })
      }
    )
  ] });
}
const defaultValues = {
  pickupRequiredBy: {
    dateAndTime: dayjs().format("YYYY-MM-DD HH:mm:ss")
  }
};
function ContainerConsignmentBookingBase({ id, children, mainDropboxDirectory = "", isDropboxDocuments = false }) {
  useTheme$2();
  const [context, Form] = useForm({
    defaultValues: __spreadValues$3({}, defaultValues),
    validationSchema: containerFormValidationSchema
  });
  const {
    getValues,
    handleSubmit,
    reset,
    watch,
    formState: { isValid, errors }
  } = context;
  const [searchParams] = useSearchParams();
  const query = useQuery$1(
    ["/ContainerConsignment", id],
    () => httpService$1.get(`ContainerConsignment/${id}`),
    {
      enabled: !!id
    }
  );
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
    const isDuplicate = searchParams.get("duplicate") === "true";
    if ((_a = query == null ? void 0 : query.data) == null ? void 0 : _a.data) {
      reset(__spreadProps$3(__spreadValues$3({}, query.data.data), {
        isDangerousGoods: !isPropertyEmpty(query.data.data.dgClass, "code"),
        dgClass: !isPropertyEmpty(query.data.data.dgClass, "code") ? __spreadProps$3(__spreadValues$3({}, query.data.data.dgClass), {
          lookupDisplayText: query.data.data.dgClass.code + " - " + query.data.data.dgClass.name
        }) : null,
        containerfullOrEmpty: {
          value: ((_c = (_b = query.data.data.container) == null ? void 0 : _b.good) == null ? void 0 : _c.isEmpty) ? SystemName.GoodsLoad.Empty : SystemName.GoodsLoad.Full,
          label: ((_e = (_d = query.data.data.container) == null ? void 0 : _d.good) == null ? void 0 : _e.isEmpty) ? SystemName.GoodsLoad.Empty : SystemName.GoodsLoad.Full
        },
        pickupLocation: isEmpty$2((_f = query.data.data.pickupLocation) == null ? void 0 : _f.locationID) ? null : query.data.data.pickupLocation,
        deliveryLocation: isEmpty$2((_g = query.data.data.deliveryLocation) == null ? void 0 : _g.locationID) ? null : query.data.data.deliveryLocation,
        pickupAddress: !isPropertyEmpty(query.data.data.pickupLocation, "locationID") ? {
          id: (_j = (_h = query.data.data.pickupLocation) == null ? void 0 : _h.combinedCode) != null ? _j : (_i = query.data.data.pickupLocation) == null ? void 0 : _i.locationID,
          name: addAddress(query.data.data.pickupLocation)
        } : null,
        deliveryAddress: !isPropertyEmpty(query.data.data.deliveryLocation, "locationID") ? {
          id: (_m = (_k = query.data.data.deliveryLocation) == null ? void 0 : _k.combinedCode) != null ? _m : (_l = query.data.data.deliveryLocation) == null ? void 0 : _l.locationID,
          name: addAddress(query.data.data.deliveryLocation)
        } : null,
        packAddress: !isPropertyEmpty(query.data.data.pack, "locationID") ? {
          id: (_p = (_n = query.data.data.pack) == null ? void 0 : _n.combinedCode) != null ? _p : (_o = query.data.data.pack) == null ? void 0 : _o.locationID,
          name: addAddress(query.data.data.pack)
        } : null,
        unpackAddress: !isPropertyEmpty(query.data.data.unpack, "locationID") ? {
          id: (_s = (_q = query.data.data.unpack) == null ? void 0 : _q.combinedCode) != null ? _s : (_r = query.data.data.unpack) == null ? void 0 : _r.locationID,
          name: addAddress(query.data.data.unpack)
        } : null,
        dehireAddress: !isPropertyEmpty(query.data.data.deliveryLocation, "locationID") ? {
          id: (_v = (_t = query.data.data.deliveryLocation) == null ? void 0 : _t.combinedCode) != null ? _v : (_u = query.data.data.deliveryLocation) == null ? void 0 : _u.locationID,
          name: addAddress(query.data.data.deliveryLocation)
        } : null,
        vesselLookup: {
          id: (_z = (_y = (_x = (_w = query.data.data.vessel) == null ? void 0 : _w.transport) == null ? void 0 : _x.vesselID) == null ? void 0 : _y.toString()) != null ? _z : "",
          name: (_C = (_B = (_A = query.data.data.vessel) == null ? void 0 : _A.transport) == null ? void 0 : _B.vesselName) != null ? _C : ""
        }
      }));
    } else if (isDuplicate) {
      const channel = new BroadcastChannel("ContainerBooking");
      channel.postMessage({ type: "connected", payload: true });
      channel.onmessage = function(event) {
        var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2, _z2, _A2, _B2, _C2, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa;
        if (event.data.type === "duplicate") {
          reset(__spreadProps$3(__spreadValues$3({}, event.data.payload), {
            containerfullOrEmpty: {
              value: ((_d2 = (_c2 = (_b2 = (_a2 = event.data) == null ? void 0 : _a2.payload) == null ? void 0 : _b2.container) == null ? void 0 : _c2.good) == null ? void 0 : _d2.isEmpty) ? SystemName.GoodsLoad.Empty : SystemName.GoodsLoad.Full,
              label: ((_h2 = (_g2 = (_f2 = (_e2 = event.data) == null ? void 0 : _e2.payload) == null ? void 0 : _f2.container) == null ? void 0 : _g2.good) == null ? void 0 : _h2.isEmpty) ? SystemName.GoodsLoad.Empty : SystemName.GoodsLoad.Full
            },
            pickupLocation: isEmpty$2((_k2 = (_j2 = (_i2 = event.data) == null ? void 0 : _i2.payload) == null ? void 0 : _j2.pickupLocation) == null ? void 0 : _k2.locationID) ? null : (_m2 = (_l2 = event.data) == null ? void 0 : _l2.payload) == null ? void 0 : _m2.pickupLocation,
            deliveryLocation: isEmpty$2((_p2 = (_o2 = (_n2 = event.data) == null ? void 0 : _n2.payload) == null ? void 0 : _o2.deliveryLocation) == null ? void 0 : _p2.locationID) ? null : (_r2 = (_q2 = event.data) == null ? void 0 : _q2.payload) == null ? void 0 : _r2.deliveryLocation,
            pickupAddress: !isPropertyEmpty((_t2 = (_s2 = event.data) == null ? void 0 : _s2.payload) == null ? void 0 : _t2.pickupLocation, "locationID") ? {
              id: (_A2 = (_w2 = (_v2 = (_u2 = event.data) == null ? void 0 : _u2.payload) == null ? void 0 : _v2.pickupLocation) == null ? void 0 : _w2.combinedCode) != null ? _A2 : (_z2 = (_y2 = (_x2 = event.data) == null ? void 0 : _x2.payload) == null ? void 0 : _y2.pickupLocation) == null ? void 0 : _z2.locationID,
              name: addAddress((_C2 = (_B2 = event.data) == null ? void 0 : _B2.payload) == null ? void 0 : _C2.pickupLocation)
            } : null,
            deliveryAddress: !isPropertyEmpty((_E = (_D = event.data) == null ? void 0 : _D.payload) == null ? void 0 : _E.deliveryLocation, "locationID") ? {
              id: (_L = (_H = (_G = (_F = event.data) == null ? void 0 : _F.payload) == null ? void 0 : _G.deliveryLocation) == null ? void 0 : _H.combinedCode) != null ? _L : (_K = (_J = (_I = event.data) == null ? void 0 : _I.payload) == null ? void 0 : _J.deliveryLocation) == null ? void 0 : _K.locationID,
              name: addAddress((_N = (_M = event.data) == null ? void 0 : _M.payload) == null ? void 0 : _N.deliveryLocation)
            } : null,
            packAddress: !isPropertyEmpty((_P = (_O = event.data) == null ? void 0 : _O.payload) == null ? void 0 : _P.pack, "locationID") ? {
              id: (_W = (_S = (_R = (_Q = event.data) == null ? void 0 : _Q.payload) == null ? void 0 : _R.pack) == null ? void 0 : _S.combinedCode) != null ? _W : (_V = (_U = (_T = event.data) == null ? void 0 : _T.payload) == null ? void 0 : _U.pack) == null ? void 0 : _V.locationID,
              name: addAddress((_Y = (_X = event.data) == null ? void 0 : _X.payload) == null ? void 0 : _Y.pack)
            } : null,
            unpackAddress: !isPropertyEmpty((__ = (_Z = event.data) == null ? void 0 : _Z.payload) == null ? void 0 : __.unpack, "locationID") ? {
              id: (_fa = (_ba = (_aa = (_$ = event.data) == null ? void 0 : _$.payload) == null ? void 0 : _aa.unpack) == null ? void 0 : _ba.combinedCode) != null ? _fa : (_ea = (_da = (_ca = event.data) == null ? void 0 : _ca.payload) == null ? void 0 : _da.unpack) == null ? void 0 : _ea.locationID,
              name: addAddress((_ha = (_ga = event.data) == null ? void 0 : _ga.payload) == null ? void 0 : _ha.unpack)
            } : null,
            dehireAddress: !isPropertyEmpty((_ja = (_ia = event.data) == null ? void 0 : _ia.payload) == null ? void 0 : _ja.deliveryLocation, "locationID") ? {
              id: (_qa = (_ma = (_la = (_ka = event.data) == null ? void 0 : _ka.payload) == null ? void 0 : _la.deliveryLocation) == null ? void 0 : _ma.combinedCode) != null ? _qa : (_pa = (_oa = (_na = event.data) == null ? void 0 : _na.payload) == null ? void 0 : _oa.deliveryLocation) == null ? void 0 : _pa.locationID,
              name: addAddress((_sa = (_ra = event.data) == null ? void 0 : _ra.payload) == null ? void 0 : _sa.deliveryLocation)
            } : null
          }));
        }
      };
      return () => {
        channel.close();
      };
    }
  }, [query.data]);
  const mutation = useMutation$1({
    mutationKey: [`ContainerConsignment/Save`],
    mutationFn: (consignment) => httpService$1.post(`ContainerConsignment`, __spreadValues$3({}, serializeContainerConsignment(consignment)))
  });
  if (!isEmpty$2(id) && (query && query.isLoading || query.isFetching)) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(
    Context$2.Provider,
    {
      value: {
        form: context,
        mutation,
        query,
        isDropboxDocuments,
        mainDropboxDirectory
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const ContainerConsignmentBookingPage = Object.assign(ContainerConsignmentBookingBase, {
  ConsignmentReferenceDetails,
  ContainerDetails,
  DangerousGoods,
  FromAndToDetails,
  AdditionalDetails,
  EstimateCharge,
  ContainerBookingButtonControls
});
const useContainerConsignmentBookingPageContext = () => {
  return useContext(Context$2);
};

var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkboxIcon$1 = /* @__PURE__ */ jsx(CheckBoxOutlineBlank, { fontSize: "small" });
const checkboxCheckedIcon$1 = /* @__PURE__ */ jsx(CheckBox, { fontSize: "small" });
const Context$1 = createContext({});
const gridColumns$1 = (props) => {
  const queryClient = useQueryClient();
  const theme = useTheme$2();
  const href = defaultValue(props.hyperlinkRef, (jobTypeSystemName, id, _) => `/${jobTypeSystemName}/${id}`);
  const {
    watchlist: [state, dispatch],
    queryDashboardKey
  } = useConsignmentDashboardContext();
  const handleWindowClose = useCallback((newWindow) => {
    if (!newWindow) {
      return;
    }
    if (newWindow) {
      setTimeout(() => {
        newWindow.onpagehide = () => {
          queryClient.invalidateQueries([...queryDashboardKey]);
        };
      }, 1e3);
    }
  }, []);
  const handleClick = (row) => {
    const urlPath = href(row.jobTypeSystemName, row.id, row.statusSystemName);
    const newWindow = window.open(`${window.location.origin}/#${urlPath}`, "_blank");
    handleWindowClose(newWindow);
  };
  return [
    {
      field: "isWatchlisted",
      flex: 0,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      maxWidth: 50,
      type: "boolean",
      renderHeader: () => /* @__PURE__ */ jsx(Star, { sx: { color: theme.palette.common.white } }),
      renderCell: ({
        row
      }) => {
        var _a;
        return /* @__PURE__ */ jsx(
          WatchlistIcon,
          {
            objectID: row.id,
            objectType: "Job",
            isWatchlisted: (_a = state == null ? void 0 : state.edits[row.id]) != null ? _a : row.isWatchlisted,
            onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: row } })
          }
        );
      }
    },
    {
      field: "reference",
      flex: 1,
      headerName: "Consignment #",
      minWidth: 150,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: "", onClick: () => handleClick(row), children: value }) })
    },
    {
      field: "status",
      flex: 1,
      headerName: "Status",
      minWidth: 190,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(StatusCell, { systemName: row.statusSystemName, value }) })
    },
    {
      field: "edd",
      flex: 1,
      headerName: "EDD",
      minWidth: 100,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    },
    {
      field: "orderReference",
      flex: 1,
      headerName: "Order Ref",
      minWidth: 200
    },
    {
      field: "receiver",
      flex: 1,
      headerName: "Receiver",
      minWidth: 200
    },
    {
      field: "origin",
      flex: 1,
      headerName: "Origin",
      minWidth: 200
    },
    {
      field: "destination",
      flex: 1,
      headerName: "Destination",
      minWidth: 200
    },
    {
      field: "bookedDate",
      flex: 1,
      headerName: "Booked Date",
      minWidth: 100,
      type: "datetime",
      valueGetter: ({
        value
      }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    },
    {
      field: "containerNo",
      flex: 1,
      headerName: "Container #",
      minWidth: 150
    }
  ];
};
const initialWatchlistState$1 = {
  editCount: 0,
  edits: {}
};
const getWatchlistEdits$1 = (watchlist, data) => {
  var _a;
  let editCount = (_a = watchlist == null ? void 0 : watchlist.editCount) != null ? _a : 0;
  editCount += data.isWatchlisted ? 1 : -1;
  return { editCount, edits: __spreadProps$2(__spreadValues$2({}, watchlist == null ? void 0 : watchlist.edits), { [data.original.id]: data.isWatchlisted }) };
};
const watchlistReducer$1 = (state, action) => {
  switch (action.type) {
    case "WATCHLIST_RESET":
      return { editCount: 0, edits: {} };
    case "WATCHLIST_EDIT":
      return getWatchlistEdits$1(state, action.payload);
    default:
      return state;
  }
};
const initialFilters$1 = {
  jobType: [],
  status: [],
  bookedDateFrom: null,
  bookedDateTo: null,
  origin: [],
  destination: [],
  receiver: []
};
function Filters$1() {
  const { query, form, blockfilteredRows } = useContext(Context$1);
  const lookupRenderOption = (props, option, { selected }) => /* @__PURE__ */ createElement("li", __spreadProps$2(__spreadValues$2({}, props), { key: v4() }), /* @__PURE__ */ jsx(
    Checkbox$1,
    {
      icon: checkboxIcon$1,
      checkedIcon: checkboxCheckedIcon$1,
      style: { marginRight: 8 },
      checked: selected
    }
  ), /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.9rem", children: option.name }));
  const lookupSx = {
    ".MuiInputBase-root > input": {
      padding: "4px 8px !important"
    },
    ".MuiAutocomplete-input": {
      fontSize: "0.85rem"
    },
    ".MuiButtonBase-root.MuiChip-root": {
      height: "inherit",
      maxWidth: "calc(60% - 6px)",
      ".MuiSvgIcon-root": {
        margin: 0
      }
    }
  };
  const datePickerSlotProps = (placeholder) => ({
    textField: {
      size: "small",
      placeholder,
      inputProps: {
        sx: {
          padding: 0
        }
      },
      sx: {
        "& .MuiInputBase-root": { padding: "4px 8px", fontSize: "0.85rem" }
      }
    },
    openPickerButton: {
      size: "small",
      color: "primary",
      sx: { padding: 0, "& .MuiSvgIcon-root": { fontSize: "inherit" } }
    }
  });
  const datePickerTransform = {
    input: (value) => value ? removeTimezoneOffset(value) : null,
    output: (value) => value ? removeTimezoneOffset(value) : null
  };
  const bookedDateFrom = form.watch("bookedDateFrom");
  const bookedDateTo = form.watch("bookedDateTo");
  const handleClearAll = () => {
    form.reset(initialFilters$1);
  };
  const [originLookup, setOriginLookup] = useState([]);
  const [destinationLookup, setDestinationLookup] = useState([]);
  const [receiverLookup, setReceiverLookup] = useState([]);
  const statusOptionRecordCount = blockfilteredRows.reduce((acc, { statusID }) => {
    acc[statusID.toString()] = acc[statusID.toString()] || 0;
    acc[statusID.toString()] += 1;
    return acc;
  }, {});
  useEffect(() => {
    var _a;
    if (query.isFetched && ((_a = query.data) == null ? void 0 : _a.data.rows)) {
      const origins = query.data.data.rows.filter((row) => row.originID).reduce((acc, curr) => {
        if (!acc.find((a) => a.originID === curr.originID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.originID.toString(),
        name: row.origin
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setOriginLookup(origins);
      const destinations = query.data.data.rows.filter((row) => row.destinationID).reduce((acc, curr) => {
        if (!acc.find((a) => a.destinationID === curr.destinationID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.destinationID.toString(),
        name: row.destination
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setDestinationLookup(destinations);
      const receivers = query.data.data.rows.filter((row) => row.receiverID).reduce((acc, curr) => {
        if (!acc.find((a) => a.receiverID === curr.receiverID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.receiverID.toString(),
        name: row.receiver
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setReceiverLookup(receivers);
    }
  }, [query.isFetched]);
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontWeight: "bold", noWrap: true, children: "Filter By" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleClearAll, children: /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontSize: "small", noWrap: true, children: "Clear all" }) })
    ] }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.jobType"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        params: {
          systemName: "JobType",
          additionalFilter: "JobType.Consignment"
        },
        name: "jobType",
        renderOption: (option) => /* @__PURE__ */ jsx(Typography, { fontSize: "small", sx: { cursor: "pointer" }, children: option.name.replace(/ Consignment$/g, "") })
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.status"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        params: {
          systemName: "ConsignmentDashboardStatus"
        },
        name: "status",
        optionRecordCount: statusOptionRecordCount,
        estimateSize: 11
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.bookedDate"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "bookedDateFrom",
          maxDate: defaultValue(bookedDateTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "bookedDateTo",
          minDate: defaultValue(bookedDateFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.origin"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "origin",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: originLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.destination"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "destination",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: destinationLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.receiver"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "receiver",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: receiverLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) })
  ] });
}
function BlockFilters$1({ activeBGColor }) {
  const theme = useTheme$2();
  const {
    query,
    filteredRows,
    activeBlockFilter,
    setActiveBlockFilter
  } = useContext(Context$1);
  const filters = [
    {
      blockFilterType: "Active",
      title: "Active",
      value: defaultValue(applyBlockFilters$1(filteredRows, "Active").length, 0).toLocaleString(
        window.navigator.language
      ),
      loading: query.isFetching
    },
    {
      blockFilterType: "NotYetDeparted",
      title: "Not yet departed",
      value: defaultValue(applyBlockFilters$1(filteredRows, "NotYetDeparted").length, 0).toLocaleString(
        window.navigator.language
      ),
      loading: query.isFetching
    },
    {
      blockFilterType: "InTransit",
      title: "In transit",
      value: defaultValue(applyBlockFilters$1(filteredRows, "InTransit").length, 0).toLocaleString(
        window.navigator.language
      ),
      loading: query.isFetching
    },
    {
      blockFilterType: "ArrivingToday",
      title: "Arriving today",
      value: defaultValue(applyBlockFilters$1(filteredRows, "ArrivingToday").length, 0).toLocaleString(
        window.navigator.language
      ),
      loading: query.isFetching
    },
    {
      blockFilterType: "Watchlist",
      title: "Watchlist",
      value: defaultValue(applyBlockFilters$1(filteredRows, "Watchlist").length, 0).toLocaleString(
        window.navigator.language
      ),
      loading: query.isFetching
    }
  ];
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: filters.map((filter, i) => {
        const isActiveBlockFilter = activeBlockFilter === filter.blockFilterType;
        return /* @__PURE__ */ jsx(
          BlockFilter,
          {
            active: isActiveBlockFilter,
            title: filter.title,
            value: filter.value,
            loading: filter.loading,
            onClick: () => {
              setActiveBlockFilter(filter.blockFilterType);
            },
            sx: {
              borderRight: "1px solid",
              borderColor: i < filters.length - 1 ? theme.palette.grey[300] : "transparent"
            },
            activeBGColor
          },
          `${i}`
        );
      })
    }
  );
}
function VirtualizedList(_a) {
  var _b = _a, { gap = 4, sx, listItemProps } = _b, rest = __objRest$1(_b, ["gap", "sx", "listItemProps"]);
  const theme = useTheme$2();
  const { query, gridRows } = useContext(Context$1);
  const virtualizerRef = useRef(null);
  const virtualizer = useVirtualizer({
    count: gridRows.length,
    getScrollElement: () => virtualizerRef.current,
    estimateSize: () => 200
  });
  return /* @__PURE__ */ jsx(
    Box,
    __spreadProps$2(__spreadValues$2({
      ref: virtualizerRef,
      position: "relative",
      height: "0px",
      width: "100%"
    }, rest), {
      sx: __spreadValues$2({
        overflowY: "auto"
      }, sx),
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          height: `${virtualizer.getTotalSize()}px`,
          sx: {
            "& > div:not(:last-of-type)": {
              paddingBottom: theme.spacing(gap)
            }
          },
          children: [
            query.isFetching && /* @__PURE__ */ jsx(
              Loader,
              {
                sx: {
                  position: "absolute",
                  height: "100%",
                  top: 0 + virtualizer.scrollOffset
                }
              }
            ),
            virtualizer.getVirtualItems().map((item) => /* @__PURE__ */ jsx(
              Box,
              {
                "data-index": item.index,
                ref: virtualizer.measureElement,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                sx: {
                  transform: `translateY(${item.start}px)`
                },
                children: /* @__PURE__ */ jsx(
                  ListItem,
                  __spreadProps$2(__spreadValues$2({}, listItemProps), {
                    data: gridRows[item.index]
                  })
                )
              },
              item.key
            ))
          ]
        }
      )
    })
  );
}
function ListItem({ data, hyperlinkRef }) {
  var _a;
  const theme = useTheme$2();
  const {
    watchlist: [state, dispatch]
  } = useConsignmentDashboardContext();
  const href = defaultValue(hyperlinkRef, (jobTypeSystemName, id, _) => `/${jobTypeSystemName}/${id}`);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      bgcolor: theme.palette.common.white,
      border: 1,
      borderColor: theme.palette.grey[200],
      children: [
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", paddingX: 3, children: [
          /* @__PURE__ */ jsx(
            WatchlistIcon,
            {
              objectID: data.id,
              objectType: "Job",
              isWatchlisted: (_a = state == null ? void 0 : state.edits[data.id]) != null ? _a : data.isWatchlisted,
              onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: data } }),
              sx: { paddingLeft: 0 }
            }
          ),
          /* @__PURE__ */ jsx(StatusCell, { value: data.status })
        ] }),
        /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 4,
            rowGap: 2,
            borderColor: theme.palette.grey[300],
            children: /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 2, children: [
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Consignment #" }),
                /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(
                  Hyperlink,
                  {
                    to: href(data.jobTypeSystemName, data.id, data.statusSystemName),
                    sx: {
                      marginTop: theme.spacing(1),
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    },
                    target: "_blank",
                    children: data.reference
                  }
                ) })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "EDD" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, children: data.edd && dayjs(data.edd).format("DD/MM/YYYY") })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Order Ref" }),
                /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.orderReference }) })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Receiver" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, noWrap: true, children: data.receiver })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Origin" }),
                /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.origin }) })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, paddingBottom: 2, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Destination" }),
                /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", gap: 2, children: /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 1, children: data.destination }) })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Booked Date" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, noWrap: true, children: data.bookedDate && dayjs(data.bookedDate).format("DD/MM/YYYY") })
              ] }) }),
              /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 4, children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", fontWeight: "600", lineHeight: 1, color: "primary", children: "Container No" }),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.75rem", lineHeight: 2, noWrap: true, children: data.containerNo })
              ] }) })
            ] })
          }
        )
      ]
    }
  );
}
function Grid$1(_c) {
  var _d = _c, { hyperlinkRef, components } = _d, props = __objRest$1(_d, ["hyperlinkRef", "components"]);
  const theme = useTheme$2();
  const { query, gridRows } = useContext(Context$1);
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, () => /* @__PURE__ */ jsx(Fragment, {}));
  return /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ jsx(GridToolbar, {}),
    /* @__PURE__ */ jsx(
      DataGridPro,
      __spreadProps$2(__spreadValues$2({}, props), {
        columns: gridColumns$1({ hyperlinkRef }),
        rows: gridRows,
        loading: query.isFetching,
        getRowId: (row) => row.id,
        hideFooter: true,
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.common.black), 0.8)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.common.white,
            fontWeight: 600
          },
          "& .MuiDataGrid-sortIcon": {
            color: theme.palette.common.white
          },
          "& .MuiDataGrid-menuIconButton": {
            color: theme.palette.common.white
          },
          "& .MuiDataGrid-columnSeparator:hover": {
            color: darken(theme.palette.common.white, 0.3)
          },
          "& .MuiDataGrid-row": {
            backgroundColor: theme.palette.common.white
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "white"
          },
          "& .MuiDataGrid-virtualScrollerContent": {
            backgroundColor: "white",
            overflow: "auto",
            scrollbarGutter: "stable"
          }
        }
      })
    )
  ] });
}
const MapMarker = React__default$1.memo(() => /* @__PURE__ */ jsx(
  Avatar,
  {
    sx: {
      height: "24px",
      width: "24px",
      bgcolor: "primary.main",
      fontSize: "20px"
    },
    children: /* @__PURE__ */ jsx(Place, { fontSize: "inherit", color: "inherit" })
  }
));
function Map$1(_e) {
  var _f = _e, { onClusterClick, onMarkerClick, children } = _f, props = __objRest$1(_f, ["onClusterClick", "onMarkerClick", "children"]);
  var _a;
  const theme = useTheme$2();
  const { query, gridRows, activeBlockFilter } = useContext(Context$1);
  const menuAnchorEl = useRef(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [markerSource, setMarkerSource] = useState("shipperLatLon");
  const [filterKey, setFilterKey] = useState();
  const {
    organisations: { getOrganisations }
  } = usePortalApplicationContext();
  const organisationID = (_a = getOrganisations()[0]) == null ? void 0 : _a.id;
  const values = useWatch();
  useEffect(() => {
    setFilterKey(v4());
  }, [values]);
  const markerLiterals = !query.isLoading && query.isFetched ? gridRows.reduce(
    (accum, { id, [markerSource]: latlng, jobTypeSystemName }) => {
      if (!latlng) {
        return accum;
      }
      const parsed = JSON.parse(latlng);
      return [...accum, [id, { lat: parsed.latitude, lng: parsed.longitude }, jobTypeSystemName]];
    },
    []
  ) : [];
  const mapClusterClickHandler = useCallback(
    (event, cluster, map) => {
      if (onClusterClick) {
        return onClusterClick(markerLiterals)(event, cluster, map);
      }
    },
    [markerLiterals]
  );
  const mapMarkerClickHandler = useCallback(
    (literal) => (event, marker) => {
      if (onMarkerClick) {
        return onMarkerClick(literal)(event, marker);
      }
    },
    []
  );
  return /* @__PURE__ */ jsxs(Box, { position: "relative", width: "100%", height: "100%", children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: menuAnchorEl,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "0.5rem",
        right: "0.5rem",
        zIndex: theme.zIndex.modal,
        height: "2.5rem",
        width: "2.5rem",
        color: theme.palette.grey[700],
        bgcolor: alpha$1(hexToRgb(theme.palette.common.white), 0.3),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: `1px 1px 1px ${alpha$1(hexToRgb(theme.palette.grey[400]), 0.3)}`,
        sx: {
          cursor: "pointer",
          "&:hover": {
            color: theme.palette.grey[800]
          }
        },
        onClick: () => setSettingsOpen((x) => !x),
        children: /* @__PURE__ */ jsx(Settings, { fontSize: "large" })
      }
    ),
    /* @__PURE__ */ jsxs(
      Menu,
      {
        sx: {
          ".MuiList-root": {
            paddingTop: 0
          }
        },
        slotProps: {
          paper: {
            sx: { width: 320 }
          }
        },
        anchorEl: menuAnchorEl.current,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        open: settingsOpen,
        onClose: () => setSettingsOpen(false),
        children: [
          /* @__PURE__ */ jsx(
            ListItemText$1,
            {
              sx: {
                marginTop: 0,
                paddingX: theme.spacing(4),
                paddingY: theme.spacing(2),
                bgcolor: theme.palette.grey[100],
                color: theme.palette.grey[500]
              },
              children: "Markers"
            }
          ),
          /* @__PURE__ */ jsxs(MenuList$1, { children: [
            /* @__PURE__ */ jsx(MenuItem$1, { onClick: () => setMarkerSource("shipperLatLon"), children: /* @__PURE__ */ jsx(ListItemText$1, { inset: true, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
              "Pickup Location",
              markerSource === "shipperLatLon" && /* @__PURE__ */ jsx(Check, { color: "primary" })
            ] }) }) }),
            /* @__PURE__ */ jsx(MenuItem$1, { onClick: () => setMarkerSource("receiverLatLon"), children: /* @__PURE__ */ jsx(ListItemText$1, { inset: true, children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
              "Delivery Location",
              markerSource === "receiverLatLon" && /* @__PURE__ */ jsx(Check, { color: "primary" })
            ] }) }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(GoogleMap, __spreadProps$2(__spreadValues$2({}, props), { children: /* @__PURE__ */ jsxs(
      GoogleMap.MarkerClusterer,
      {
        onClusterClick: mapClusterClickHandler,
        children: [
          markerLiterals.map(([id, latlng, jobTypeSystemName]) => /* @__PURE__ */ jsx(
            GoogleMap.AdvancedMarker,
            {
              position: latlng,
              onClick: mapMarkerClickHandler([id, latlng, jobTypeSystemName]),
              children: /* @__PURE__ */ jsx(MapMarker, {})
            },
            `${id}_${markerSource}_${activeBlockFilter}`
          )),
          children
        ]
      },
      `${filterKey}_${markerSource}_${activeBlockFilter}_${organisationID}`
    ) }))
  ] });
}
function applyFormFilters$1(values, rows) {
  if (!rows)
    return [];
  let filteredRows = rows;
  if (values.jobType && values.jobType.length > 0) {
    filteredRows = filteredRows.filter((row) => values.jobType.includes(row.jobTypeID.toString()));
  }
  if (values.status && values.status.length > 0) {
    filteredRows = filteredRows.filter((row) => values.status.includes(row.statusID.toString()));
  }
  if (values.bookedDateFrom) {
    filteredRows = filteredRows.filter(
      (row) => row.bookedDate && new Date(row.bookedDate) >= new Date(values.bookedDateFrom)
    );
  }
  if (values.bookedDateTo) {
    let bookedDateTo = new Date(values.bookedDateTo);
    bookedDateTo.setDate(bookedDateTo.getDate() + 1);
    filteredRows = filteredRows.filter((row) => row.bookedDate && new Date(row.bookedDate) < bookedDateTo);
  }
  if (values.origin && values.origin.length > 0) {
    filteredRows = filteredRows.filter((row) => values.origin.find((c) => {
      var _a;
      return c.id === ((_a = row.originID) == null ? void 0 : _a.toString());
    }));
  }
  if (values.destination && values.destination.length > 0) {
    filteredRows = filteredRows.filter(
      (row) => values.destination.find((c) => {
        var _a;
        return c.id === ((_a = row.destinationID) == null ? void 0 : _a.toString());
      })
    );
  }
  if (values.receiver && values.receiver.length > 0) {
    filteredRows = filteredRows.filter((row) => values.receiver.find((c) => {
      var _a;
      return c.id === ((_a = row.receiverID) == null ? void 0 : _a.toString());
    }));
  }
  return filteredRows;
}
function applyBlockFilters$1(rows, blockFilter, watchlistEdits) {
  var _a;
  if (!watchlistEdits) {
    const { watchlist } = useContext(Context$1);
    watchlistEdits = (_a = watchlist && watchlist[0].edits) != null ? _a : {};
  }
  let gridRows = rows;
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  switch (blockFilter) {
    case "Active":
      gridRows = gridRows.filter((row) => {
        if (row.statusSystemName != "Delivered")
          return true;
        if (row.deliveredDate) {
          const deliveredDate = new Date(row.deliveredDate);
          deliveredDate.setHours(0, 0, 0, 0);
          if (today.getTime() === deliveredDate.getTime()) {
            return true;
          }
        }
        return false;
      });
      break;
    case "NotYetDeparted":
      const notYetDepartedStatusSystemNames = ["Quote", "Draft", "Submitted", "Booked"];
      gridRows = gridRows.filter((row) => notYetDepartedStatusSystemNames.includes(row.statusSystemName));
      break;
    case "InTransit":
      gridRows = gridRows.filter((row) => row.statusSystemName === "InTransit");
      break;
    case "ArrivingToday":
      gridRows = gridRows.filter((row) => {
        if (!row.deliveredDate && !row.outForDeliveryDate)
          return false;
        if (row.deliveredDate) {
          const deliveredDate = new Date(row.deliveredDate);
          deliveredDate.setHours(0, 0, 0, 0);
          if (today.getTime() === deliveredDate.getTime()) {
            return true;
          }
        }
        if (row.outForDeliveryDate) {
          const outForDeliveryDate = new Date(row.outForDeliveryDate);
          outForDeliveryDate.setHours(0, 0, 0, 0);
          if (today.getTime() === outForDeliveryDate.getTime()) {
            return true;
          }
        }
        return false;
      });
      break;
    case "Watchlist":
      gridRows = gridRows.filter(
        (row) => watchlistEdits === void 0 || watchlistEdits[row.id] === void 0 ? row.isWatchlisted : watchlistEdits[row.id]
      );
      break;
  }
  return gridRows;
}
function Base$1({ children }) {
  var _a, _b, _c, _d;
  const [context, Form] = useForm({
    defaultValues: initialFilters$1
  });
  const {
    organisations: { getOrganisations }
  } = usePortalApplicationContext();
  const organisationID = (_a = getOrganisations()[0]) == null ? void 0 : _a.id;
  const values = context.watch();
  const queryClient = useQueryClient();
  const [watchlistState, watchlistDispatch] = useReducer(watchlistReducer$1, initialWatchlistState$1);
  const [query, queryDashboardKey] = useGridQuery(
    {
      systemName: "ConsignmentDashboardGrid",
      parameters: {
        additionalFilter: {
          organisationID
        }
      }
    },
    { cacheTime: 0 }
  );
  const [activeBlockFilter, setActiveBlockFilter] = useState("Active");
  const filteredRows = applyFormFilters$1(values, (_b = query.data) == null ? void 0 : _b.data.rows);
  const blockfilteredRows = ((_c = query.data) == null ? void 0 : _c.data.rows) ? applyBlockFilters$1((_d = query.data) == null ? void 0 : _d.data.rows, activeBlockFilter, watchlistState.edits) : [];
  const gridRows = applyBlockFilters$1(filteredRows, activeBlockFilter, watchlistState.edits);
  useEffect(() => {
    const channel = new BroadcastChannel("ConsignmentDashboard");
    channel.onmessage = (event) => {
      if (event.data === "refreshDashboard") {
        queryClient.invalidateQueries([...queryDashboardKey]);
      }
    };
    return () => {
      channel.close();
    };
  }, [queryClient]);
  return /* @__PURE__ */ jsx(
    Context$1.Provider,
    {
      value: {
        form: context,
        query,
        queryDashboardKey,
        watchlist: [watchlistState, watchlistDispatch],
        filteredRows,
        blockfilteredRows,
        gridRows,
        activeBlockFilter,
        setActiveBlockFilter
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const ConsignmentDashboard = Object.assign(Base$1, {
  BlockFilters: BlockFilters$1,
  Filters: Filters$1,
  Grid: Grid$1,
  Map: Map$1,
  VirtualizedList
});
const useConsignmentDashboardContext = () => {
  return useContext(Context$1);
};

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkboxIcon = /* @__PURE__ */ jsx(CheckBoxOutlineBlank, { fontSize: "small" });
const checkboxCheckedIcon = /* @__PURE__ */ jsx(CheckBox, { fontSize: "small" });
const Context = createContext({});
const gridColumns = (props) => {
  const theme = useTheme$2();
  const href = defaultValue(props.hyperlinkRef, (jobTypeSystemName, id, _) => `/${jobTypeSystemName}/${id}`);
  const {
    watchlist: [state, dispatch]
  } = useConsignmentListContext();
  return [
    {
      field: "isWatchlisted",
      flex: 0,
      disableColumnMenu: true,
      resizable: false,
      sortable: false,
      disableExport: true,
      maxWidth: 50,
      type: "boolean",
      renderHeader: () => /* @__PURE__ */ jsx(Star, { sx: { color: theme.palette.common.white } }),
      renderCell: ({
        row
      }) => {
        var _a;
        return /* @__PURE__ */ jsx(
          WatchlistIcon,
          {
            objectID: row.id,
            objectType: "Job",
            isWatchlisted: (_a = state == null ? void 0 : state.edits[row.id]) != null ? _a : row.isWatchlisted,
            onComplete: (isWatchlisted) => dispatch({ type: "WATCHLIST_EDIT", payload: { isWatchlisted, original: row } })
          }
        );
      }
    },
    {
      field: "reference",
      flex: 1,
      headerName: "Consignment #",
      minWidth: 150,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(Hyperlink, { to: href(row.jobTypeSystemName, row.id, row.statusSystemName), target: "_blank", children: value }) })
    },
    {
      field: "status",
      flex: 1,
      headerName: "Status",
      minWidth: 190,
      renderCell: ({
        value,
        row
      }) => /* @__PURE__ */ jsx("div", { className: "MuiDataGrid-cellContent", children: /* @__PURE__ */ jsx(StatusCell, { systemName: row.statusSystemName, value }) })
    },
    {
      field: "edd",
      flex: 1,
      headerName: "EDD",
      minWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    },
    {
      field: "orderReference",
      flex: 1,
      headerName: "Order Ref",
      minWidth: 200
    },
    {
      field: "receiver",
      flex: 1,
      headerName: "Receiver",
      minWidth: 200
    },
    {
      field: "origin",
      flex: 1,
      headerName: "Origin",
      minWidth: 200
    },
    {
      field: "destination",
      flex: 1,
      headerName: "Destination",
      minWidth: 200
    },
    {
      field: "bookedDate",
      flex: 1,
      headerName: "Booked Date",
      minWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    },
    {
      field: "containerNo",
      flex: 1,
      headerName: "Container #",
      minWidth: 200
    },
    {
      field: "shipper",
      flex: 1,
      headerName: "Shipper",
      minWidth: 200
    },
    {
      field: "deliveryReference",
      flex: 1,
      headerName: "Delivery Ref",
      minWidth: 200
    },
    {
      field: "pickupReference",
      flex: 1,
      headerName: "Pickup Ref",
      minWidth: 200
    },
    {
      field: "pickupRequiredBy",
      flex: 1,
      headerName: "Required Pickup",
      minWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    },
    {
      field: "vessel",
      flex: 1,
      headerName: "Vessel",
      minWidth: 200
    },
    {
      field: "voyage",
      flex: 1,
      headerName: "Voyage",
      minWidth: 200
    },
    {
      field: "jobType",
      flex: 1,
      headerName: "Job Type",
      minWidth: 200
    },
    {
      field: "weight",
      flex: 1,
      headerName: "Weight",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "volume",
      flex: 1,
      headerName: "Cubic",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "charge",
      flex: 1,
      headerName: "Charge ($)",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "descriptionJSON",
      flex: 1,
      headerName: "Product Desc.",
      minWidth: 200,
      valueGetter: ({ value }) => {
        if (!value)
          return null;
        const descriptions = JSON.parse(value);
        const maxLineToShow = 2;
        let description = "";
        for (var i = 0; i < descriptions.length; i++) {
          if (i === maxLineToShow) {
            description += "...";
            break;
          }
          if (i > 0)
            description += ", ";
          description += descriptions[i].value;
        }
        return description;
      }
    },
    {
      field: "quantity",
      flex: 1,
      headerName: "Quantity",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "commodity",
      flex: 1,
      headerName: "Commodity",
      minWidth: 200,
      valueGetter: (params) => {
        if (params.row.jobTypeSystemName === "ContainerConsignment")
          return params.row.containerCommodity;
        let commodity = "";
        const maxLineToShow = 2;
        const jobLineCommodities = JSON.parse(params.row.jobLineCommodityJSON);
        if (jobLineCommodities) {
          for (var i = 0; i < jobLineCommodities.length; i++) {
            if (i === maxLineToShow) {
              commodity += "...";
              break;
            }
            if (i > 0)
              commodity += ", ";
            commodity += jobLineCommodities[i].shortName;
          }
        }
        return commodity;
      }
    },
    {
      field: "customer",
      flex: 1,
      headerName: "Customer",
      minWidth: 200
    },
    {
      field: "containerSize",
      flex: 1,
      headerName: "Container Size",
      minWidth: 200
    },
    {
      field: "containerReleaseNumber",
      flex: 1,
      headerName: "Container Release",
      minWidth: 200
    },
    {
      field: "containerIsEmpty",
      flex: 1,
      headerName: "Empty/Full",
      minWidth: 150,
      valueFormatter: ({ value }) => {
        if (value === null || value === void 0) {
          return null;
        }
        return value ? "Empty" : "Full";
      }
    },
    {
      field: "hirePallets",
      flex: 1,
      headerName: "Hire Pallets",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "nonHirePallets",
      flex: 1,
      headerName: "Non Hire Pallets",
      minWidth: 150,
      valueFormatter: ({ value }) => value ? formatNumber(value.toString()) : null
    },
    {
      field: "containerType",
      flex: 1,
      headerName: "Container Type",
      minWidth: 200
    },
    {
      field: "deliveryDate",
      flex: 1,
      headerName: "Delivery Date",
      minWidth: 150,
      type: "datetime",
      valueGetter: ({ value }) => value ? dayjs(value) : null,
      valueFormatter: ({ value }) => value ? value.format("DD/MM/YYYY") : null
    }
  ];
};
const initialWatchlistState = {
  editCount: 0,
  edits: {}
};
const getWatchlistEdits = (watchlist, data) => {
  var _a;
  let editCount = (_a = watchlist == null ? void 0 : watchlist.editCount) != null ? _a : 0;
  editCount += data.isWatchlisted ? 1 : -1;
  return { editCount, edits: __spreadProps$1(__spreadValues$1({}, watchlist == null ? void 0 : watchlist.edits), { [data.original.id]: data.isWatchlisted }) };
};
const watchlistReducer = (state, action) => {
  switch (action.type) {
    case "WATCHLIST_RESET":
      return { editCount: 0, edits: {} };
    case "WATCHLIST_EDIT":
      return getWatchlistEdits(state, action.payload);
    default:
      return state;
  }
};
function FormDelayFilterControl({
  name,
  label,
  delay = 3,
  shouldUnregister
}) {
  const theme = useTheme$2();
  const { control, watch } = useFormContext();
  const value = watch(name);
  const [checked, setChecked] = useState(value !== null);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value != null ? value : delay.toString());
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      shouldUnregister,
      name,
      render: ({ field: { onChange } }) => /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ jsx(
          Checkbox$1,
          {
            id: `${name}_checkbox`,
            name: `${name}_checkbox`,
            size: "small",
            sx: { padding: 0 },
            value: checked,
            onChange: (e) => {
              const value2 = e.target.checked;
              setChecked(value2);
              onChange(value2 ? inputValue : null);
            }
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ jsx(
            "label",
            {
              htmlFor: `${name}_checkbox`,
              style: { display: "flex", alignItems: "center", width: "calc(100% - 2rem)" },
              children: /* @__PURE__ */ jsx(
                Typography,
                {
                  noWrap: true,
                  fontSize: "small",
                  lineHeight: "1.1",
                  sx: { display: "inline-block", cursor: "pointer" },
                  children: label
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            NumberInput,
            {
              value: defaultValue(inputValue == null ? void 0 : inputValue.toString(), EMPTY_STRING$g),
              sx: {
                ".MuiInputBase-root": {
                  padding: "4px 8px !important",
                  fontSize: "0.85rem"
                }
              },
              placeholder: "All",
              onChange: (input) => {
                const value2 = input.trim();
                const output = value2 === EMPTY_STRING$g ? EMPTY_STRING$g : value2;
                setInputValue(output);
                if (checked) {
                  onChange(output);
                }
              },
              onKeyDown: (e) => {
                var _a, _b;
                if (e.key === "ArrowUp") {
                  e.preventDefault();
                  const len = defaultValue(inputValue == null ? void 0 : inputValue.toString().length, 0);
                  (_a = inputRef.current) == null ? void 0 : _a.setSelectionRange(len, len);
                  (_b = inputRef.current) == null ? void 0 : _b.focus();
                }
              },
              onKeyUp: (e) => {
                let output = inputValue;
                if (e.key === "ArrowUp") {
                  output = output ? (parseInt(output) + 1).toString() : "1";
                  setInputValue(output);
                  if (checked) {
                    onChange(output);
                  }
                }
                if (e.key === "ArrowDown") {
                  output = output ? Math.max(+output - 1, 0).toString() : "0";
                  setInputValue(output);
                  if (checked) {
                    onChange(output);
                  }
                }
              },
              InputProps: {
                inputRef,
                endAdornment: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
                  /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 0.5, children: [
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        display: "flex",
                        alignItems: "flex-start",
                        alignSelf: "stretch",
                        height: "8px",
                        sx: {
                          backgroundColor: theme.palette.grey[200],
                          borderRadius: "2px",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: theme.palette.grey[300]
                          }
                        },
                        onClick: (e) => {
                          e.preventDefault();
                          let output = inputValue;
                          output = output ? (parseInt(output) + 1).toString() : "1";
                          setInputValue(output);
                          if (checked) {
                            onChange(output);
                          }
                        },
                        children: /* @__PURE__ */ jsx(
                          "svg",
                          {
                            focusable: false,
                            "aria-hidden": "true",
                            height: "8px",
                            width: "20px",
                            viewBox: "0 0 16 16",
                            children: /* @__PURE__ */ jsx("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" })
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        display: "flex",
                        alignItems: "flex-end",
                        alignSelf: "stretch",
                        height: "8px",
                        sx: {
                          backgroundColor: theme.palette.grey[200],
                          borderRadius: "2px",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: theme.palette.grey[300]
                          }
                        },
                        onClick: (e) => {
                          e.preventDefault();
                          let output = inputValue;
                          output = output ? Math.max(parseInt(output) - 1, 0).toString() : "0";
                          setInputValue(output);
                          if (checked) {
                            onChange(output);
                          }
                        },
                        children: /* @__PURE__ */ jsx(
                          "svg",
                          {
                            focusable: false,
                            "aria-hidden": "true",
                            height: "8px",
                            width: "20px",
                            viewBox: "0 0 16 16",
                            style: { transform: "rotate(180deg)" },
                            children: /* @__PURE__ */ jsx("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" })
                          }
                        )
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      fontSize: "0.8rem",
                      lineHeight: "0.8rem",
                      color: theme.palette.grey[500],
                      sx: { minWidth: "4ch" },
                      children: inflect("Day", inputValue ? parseInt(inputValue) : 0)
                    }
                  )
                ] })
              }
            }
          )
        ] })
      ] })
    }
  );
}
const initialFilters = {
  showMode: "All",
  jobType: [],
  status: [],
  bookedDateFrom: null,
  bookedDateTo: null,
  deliveryDateFrom: null,
  deliveryDateTo: null,
  origin: [],
  destination: [],
  shipper: [],
  receiver: [],
  eddDelay: null
};
function Filters() {
  const theme = useTheme$2();
  const { query, form, blockfilteredRows } = useContext(Context);
  const [eddDelayKey, setEDDDelayKey] = useState(`edd_${v4()}`);
  const lookupRenderOption = (props, option, { selected }) => /* @__PURE__ */ createElement("li", __spreadProps$1(__spreadValues$1({}, props), { key: v4() }), /* @__PURE__ */ jsx(
    Checkbox$1,
    {
      icon: checkboxIcon,
      checkedIcon: checkboxCheckedIcon,
      style: { marginRight: 8 },
      checked: selected
    }
  ), /* @__PURE__ */ jsx(Typography, { fontSize: "0.85rem", lineHeight: "0.9rem", children: option.name }));
  const lookupSx = {
    ".MuiInputBase-root > input": {
      padding: "4px 8px !important"
    },
    ".MuiAutocomplete-input": {
      fontSize: "0.85rem"
    },
    ".MuiButtonBase-root.MuiChip-root": {
      height: "inherit",
      maxWidth: "calc(60% - 6px)",
      ".MuiSvgIcon-root": {
        margin: 0
      }
    }
  };
  const datePickerSlotProps = (placeholder) => ({
    textField: {
      size: "small",
      placeholder,
      inputProps: {
        sx: {
          padding: 0
        }
      },
      sx: {
        "& .MuiInputBase-root": { padding: "4px 8px", fontSize: "0.85rem" }
      }
    },
    openPickerButton: {
      size: "small",
      color: "primary",
      sx: { padding: 0, "& .MuiSvgIcon-root": { fontSize: "inherit" } }
    }
  });
  const datePickerTransform = {
    input: (value) => value ? removeTimezoneOffset(value) : null,
    output: (value) => value ? removeTimezoneOffset(value) : null
  };
  const bookedDateFrom = form.watch("bookedDateFrom");
  const bookedDateTo = form.watch("bookedDateTo");
  const deliveryDateFrom = form.watch("deliveryDateFrom");
  const deliveryDateTo = form.watch("deliveryDateTo");
  const handleClearAll = () => {
    const _a = initialFilters, resetState = __objRest(_a, ["showMode"]);
    form.reset(__spreadValues$1({ showMode: form.getValues("showMode") }, resetState));
    setEDDDelayKey(`edd_${v4()}`);
  };
  const [originLookup, setOriginLookup] = useState([]);
  const [destinationLookup, setDestinationLookup] = useState([]);
  const [shipperLookup, setShipperLookup] = useState([]);
  const [receiverLookup, setReceiverLookup] = useState([]);
  const statusOptionRecordCount = blockfilteredRows.reduce((acc, { statusID }) => {
    acc[statusID.toString()] = acc[statusID.toString()] || 0;
    acc[statusID.toString()] += 1;
    return acc;
  }, {});
  useEffect(() => {
    var _a;
    if (query.isFetched && ((_a = query.data) == null ? void 0 : _a.data.rows)) {
      const origins = query.data.data.rows.filter((row) => row.originID).reduce((acc, curr) => {
        if (!acc.find((a) => a.originID === curr.originID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.originID.toString(),
        name: row.origin
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setOriginLookup(origins);
      const destinations = query.data.data.rows.filter((row) => row.destinationID).reduce((acc, curr) => {
        if (!acc.find((a) => a.destinationID === curr.destinationID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.destinationID.toString(),
        name: row.destination
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setDestinationLookup(destinations);
      const shippers = query.data.data.rows.filter((row) => row.shipperID).reduce((acc, curr) => {
        if (!acc.find((a) => a.shipperID === curr.shipperID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.shipperID.toString(),
        name: row.shipper
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setShipperLookup(shippers);
      const receivers = query.data.data.rows.filter((row) => row.receiverID).reduce((acc, curr) => {
        if (!acc.find((a) => a.receiverID === curr.receiverID)) {
          acc.push(curr);
        }
        return acc;
      }, []).map((row) => ({
        id: row.receiverID.toString(),
        name: row.receiver
      })).sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      setReceiverLookup(receivers);
    }
  }, [query.isFetched]);
  return /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", gap: 4, children: [
    /* @__PURE__ */ jsx(
      Typography,
      {
        fontSize: "0.85rem",
        lineHeight: "0.9rem",
        fontWeight: "bold",
        children: "Show"
      }
    ),
    /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", gap: 3, children: /* @__PURE__ */ jsx(
      Controller,
      {
        control: form.control,
        name: "showMode",
        render: ({ field: { value, onChange } }) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(
            "label",
            {
              style: {
                display: "flex",
                alignItems: "center",
                columnGap: theme.spacing(1),
                cursor: "pointer"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Radio,
                  {
                    name: "showMode",
                    value: "All",
                    checked: value === "All",
                    size: "small",
                    sx: { padding: 0 },
                    onChange: () => onChange("All")
                  }
                ),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "All" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "label",
            {
              style: {
                display: "flex",
                alignItems: "center",
                columnGap: theme.spacing(1),
                cursor: "pointer"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Radio,
                  {
                    name: "showMode",
                    value: "Active",
                    checked: value === "Active",
                    size: "small",
                    sx: { padding: 0 },
                    onChange: () => onChange("Active")
                  }
                ),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Active" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "label",
            {
              style: {
                display: "flex",
                alignItems: "center",
                columnGap: theme.spacing(1),
                cursor: "pointer"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Radio,
                  {
                    name: "showMode",
                    value: "Delivered",
                    checked: value === "Delivered",
                    size: "small",
                    sx: { padding: 0 },
                    onChange: () => onChange("Delivered")
                  }
                ),
                /* @__PURE__ */ jsx(Typography, { fontSize: "0.8rem", lineHeight: "0.85rem", children: "Delivered" })
              ]
            }
          )
        ] })
      }
    ) }),
    /* @__PURE__ */ jsx(Divider$1, {}),
    /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontWeight: "bold", noWrap: true, children: "Filter By" }),
      /* @__PURE__ */ jsx(Button$1, { onClick: handleClearAll, children: /* @__PURE__ */ jsx(Typography, { textTransform: "uppercase", fontSize: "small", noWrap: true, children: "Clear all" }) })
    ] }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.jobType"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        params: {
          systemName: "JobType",
          additionalFilter: "JobType.Consignment"
        },
        name: "jobType",
        renderOption: (option) => /* @__PURE__ */ jsx(Typography, { fontSize: "small", sx: { cursor: "pointer" }, children: option.name.replace(/ Consignment$/g, "") })
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.status"), children: /* @__PURE__ */ jsx(
      FormLookupCheckboxGroup,
      {
        params: {
          systemName: "ConsignmentListStatus"
        },
        name: "status",
        optionRecordCount: statusOptionRecordCount,
        estimateSize: 11
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.bookedDate"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "bookedDateFrom",
          maxDate: defaultValue(bookedDateTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "bookedDateTo",
          minDate: defaultValue(bookedDateFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.deliveryDate"), children: /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "deliveryDateFrom",
          maxDate: defaultValue(deliveryDateTo, void 0),
          slotProps: datePickerSlotProps("From"),
          transform: datePickerTransform
        }
      ),
      /* @__PURE__ */ jsx(
        FormDateTimePicker,
        {
          name: "deliveryDateTo",
          minDate: defaultValue(deliveryDateFrom, void 0),
          slotProps: datePickerSlotProps("To"),
          transform: datePickerTransform
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.origin"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "origin",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: originLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.destination"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "destination",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: destinationLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.shipper"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "shipper",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: shipperLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.receiver"), children: /* @__PURE__ */ jsx(
      FormAutocompleteDropdown,
      {
        multiple: true,
        disableCloseOnSelect: true,
        blurOnSelect: false,
        limitTags: 1,
        name: "receiver",
        placeholder: "Search",
        renderOption: lookupRenderOption,
        sx: lookupSx,
        options: receiverLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id
      }
    ) }),
    /* @__PURE__ */ jsx(ExpandableSection, { title: getTerm("consignmentGrid.filters.eddDelay"), children: /* @__PURE__ */ jsx(Box, { display: "flex", flexDirection: "column", gap: 2, children: /* @__PURE__ */ jsx(
      FormDelayFilterControl,
      {
        name: "eddDelay",
        label: "EDD Delay"
      },
      eddDelayKey
    ) }) })
  ] });
}
function BlockFilters({ activeBGColor }) {
  const theme = useTheme$2();
  const {
    query,
    watchlist: [watchlistState],
    filteredRows,
    activeBlockFilter,
    setActiveBlockFilter
  } = useContext(Context);
  const filters = [
    {
      blockFilterType: "Active",
      title: "Active",
      value: defaultValue(applyBlockFilters(filteredRows, "Active").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    },
    {
      blockFilterType: "Booked",
      title: "Booked",
      value: defaultValue(applyBlockFilters(filteredRows, "Booked").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    },
    {
      blockFilterType: "InTransit",
      title: "In transit",
      value: defaultValue(applyBlockFilters(filteredRows, "InTransit").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    },
    {
      blockFilterType: "ArrivingToday",
      title: "Arriving today",
      value: defaultValue(applyBlockFilters(filteredRows, "ArrivingToday").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    },
    {
      blockFilterType: "Delivered",
      title: "Delivered",
      value: defaultValue(applyBlockFilters(filteredRows, "Delivered").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    },
    {
      blockFilterType: "Watchlist",
      title: "Watchlist",
      value: defaultValue(applyBlockFilters(filteredRows, "Watchlist").length, 0).toLocaleString(window.navigator.language),
      loading: query.isFetching
    }
  ];
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      border: 1,
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.common.white,
      sx: {
        boxShadow: `1px 2px 4px ${theme.palette.grey[300]}`
      },
      children: filters.map((filter, i) => {
        const isActiveBlockFilter = activeBlockFilter === filter.blockFilterType;
        return /* @__PURE__ */ jsx(
          BlockFilter,
          {
            active: isActiveBlockFilter,
            title: filter.title,
            value: filter.value,
            loading: filter.loading,
            onClick: () => {
              setActiveBlockFilter(filter.blockFilterType);
            },
            sx: {
              borderRight: "1px solid",
              borderColor: i < filters.length - 1 ? theme.palette.grey[300] : "transparent"
            },
            activeBGColor,
            boxFlex: `0 0 ${100 / filters.length}%`
          },
          `${i}`
        );
      })
    }
  );
}
function Grid(_a) {
  var _b = _a, { hyperlinkRef, components } = _b, props = __objRest(_b, ["hyperlinkRef", "components"]);
  const theme = useTheme$2();
  const { query, gridRows, dataGridApiRef } = useContext(Context);
  const columns = gridColumns({ hyperlinkRef });
  const initialColumns = [
    "isWatchlisted",
    "reference",
    "status",
    "edd",
    "orderReference",
    "receiver",
    "origin",
    "destination",
    "bookedDate",
    "containerNo",
    "shipper"
  ];
  const initialState = useMemo(() => ({
    columns: {
      orderedFields: columns.map((column) => column.field),
      columnVisibilityModel: columns.reduce((acc, column) => {
        acc[column.field] = initialColumns.includes(column.field);
        return acc;
      }, {})
    },
    sorting: {
      sortModel: []
    }
  }), [columns, query]);
  const { GridStateToolbar, state } = useDataGridPreferences({
    gridSystemName: "ConsignmentListGrid",
    initialData: initialState,
    apiRef: dataGridApiRef
  }, [query]);
  const GridToolbar = defaultValue(components == null ? void 0 : components.Toolbar, () => /* @__PURE__ */ jsx(Fragment, {}));
  return /* @__PURE__ */ jsxs(Box, { height: "inherit", display: "flex", flexDirection: "column", gap: 2, children: [
    /* @__PURE__ */ jsx(GridToolbar, {}),
    /* @__PURE__ */ jsx(
      DataGridPro,
      __spreadProps$1(__spreadValues$1({}, props), {
        columns,
        rows: gridRows,
        loading: query.isFetching,
        getRowId: (row) => row.id,
        hideFooter: true,
        apiRef: dataGridApiRef,
        slots: { toolbar: GridStateToolbar },
        initialState: state != null ? state : initialState,
        disableRowSelectionOnClick: true,
        sx: {
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: alpha$1(hexToRgb(theme.palette.common.black), 0.8)
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: theme.palette.common.white,
            fontWeight: 600
          },
          "& .MuiDataGrid-sortIcon": {
            color: theme.palette.common.white
          },
          "& .MuiDataGrid-menuIconButton": {
            color: theme.palette.common.white
          },
          "& .MuiDataGrid-columnSeparator:hover": {
            color: darken(theme.palette.common.white, 0.3)
          },
          "& .MuiDataGrid-row": {
            backgroundColor: theme.palette.common.white
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "white"
          },
          "& .MuiDataGrid-virtualScrollerContent": {
            backgroundColor: "white",
            overflow: "auto",
            scrollbarGutter: "stable"
          }
        }
      })
    )
  ] });
}
function applyFormFilters(values, rows) {
  if (!rows)
    return [];
  let filteredRows = rows;
  let daysAgo = /* @__PURE__ */ new Date();
  daysAgo.setDate(daysAgo.getDate() - 7);
  if (values.showMode === "All" && !values.bookedDateFrom && !values.bookedDateTo && !values.deliveryDateFrom && !values.deliveryDateTo) {
    filteredRows = filteredRows.filter(
      (row) => !row.bookedDate || new Date(row.bookedDate) >= new Date(daysAgo) || !row.deliveryDate || new Date(row.deliveryDate) >= new Date(daysAgo)
    );
  }
  if (values.showMode === "Active") {
    filteredRows = filteredRows.filter((row) => !row.deliveryDate);
  }
  if (values.showMode === "Delivered" && !values.deliveryDateFrom && !values.deliveryDateTo) {
    filteredRows = filteredRows.filter(
      (row) => row.deliveryDate && new Date(row.deliveryDate) >= new Date(daysAgo)
    );
  }
  if (values.jobType && values.jobType.length > 0) {
    filteredRows = filteredRows.filter((row) => values.jobType.includes(row.jobTypeID.toString()));
  }
  if (values.status && values.status.length > 0) {
    filteredRows = filteredRows.filter((row) => values.status.includes(row.statusID.toString()));
  }
  if (values.bookedDateFrom) {
    filteredRows = filteredRows.filter((row) => row.bookedDate && new Date(row.bookedDate) >= new Date(values.bookedDateFrom));
  }
  if (values.bookedDateTo) {
    let bookedDateTo = new Date(values.bookedDateTo);
    bookedDateTo.setDate(bookedDateTo.getDate() + 1);
    filteredRows = filteredRows.filter((row) => row.bookedDate && new Date(row.bookedDate) < bookedDateTo);
  }
  if (values.deliveryDateFrom) {
    filteredRows = filteredRows.filter((row) => row.deliveryDate && new Date(row.deliveryDate) >= new Date(values.deliveryDateFrom));
  }
  if (values.deliveryDateTo) {
    let deliveryDateTo = new Date(values.deliveryDateTo);
    deliveryDateTo.setDate(deliveryDateTo.getDate() + 1);
    filteredRows = filteredRows.filter((row) => row.deliveryDate && new Date(row.deliveryDate) < deliveryDateTo);
  }
  if (values.origin && values.origin.length > 0) {
    filteredRows = filteredRows.filter((row) => values.origin.find((c) => {
      var _a;
      return c.id === ((_a = row.originID) == null ? void 0 : _a.toString());
    }));
  }
  if (values.destination && values.destination.length > 0) {
    filteredRows = filteredRows.filter((row) => values.destination.find((c) => {
      var _a;
      return c.id === ((_a = row.destinationID) == null ? void 0 : _a.toString());
    }));
  }
  if (values.shipper && values.shipper.length > 0) {
    filteredRows = filteredRows.filter((row) => values.shipper.find((c) => {
      var _a;
      return c.id === ((_a = row.shipperID) == null ? void 0 : _a.toString());
    }));
  }
  if (values.receiver && values.receiver.length > 0) {
    filteredRows = filteredRows.filter((row) => values.receiver.find((c) => {
      var _a;
      return c.id === ((_a = row.receiverID) == null ? void 0 : _a.toString());
    }));
  }
  if (values.eddDelay !== null) {
    const eddDelayDay = values.eddDelay ? +values.eddDelay : 0;
    filteredRows = filteredRows.filter((row) => {
      if (!row.edd || row.statusSystemName === "Delivered") {
        return false;
      }
      let eddAfterDelay = new Date(row.edd);
      let daysAdded = 0;
      while (daysAdded < eddDelayDay) {
        eddAfterDelay.setDate(eddAfterDelay.getDate() + 1);
        const dayOfWeek = eddAfterDelay.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          daysAdded++;
        }
      }
      return eddAfterDelay < /* @__PURE__ */ new Date();
    });
  }
  return filteredRows;
}
function applyBlockFilters(rows, blockFilter, watchlistEdits) {
  var _a;
  if (!watchlistEdits) {
    const { watchlist } = useContext(Context);
    watchlistEdits = (_a = watchlist && watchlist[0].edits) != null ? _a : {};
  }
  let gridRows = rows;
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  switch (blockFilter) {
    case "Active":
      gridRows = gridRows.filter((row) => {
        if (row.statusSystemName != "Delivered")
          return true;
        if (row.deliveryDate) {
          const deliveryDate = new Date(row.deliveryDate);
          deliveryDate.setHours(0, 0, 0, 0);
          if (today.getTime() === deliveryDate.getTime()) {
            return true;
          }
        }
        return false;
      });
      break;
    case "Booked":
      gridRows = gridRows.filter((row) => row.statusSystemName === "Booked");
      break;
    case "InTransit":
      gridRows = gridRows.filter((row) => row.statusSystemName === "InTransit");
      break;
    case "ArrivingToday":
      gridRows = gridRows.filter((row) => {
        if (!row.deliveryDate && !row.outForDeliveryDate)
          return false;
        if (row.deliveryDate) {
          const deliveryDate = new Date(row.deliveryDate);
          deliveryDate.setHours(0, 0, 0, 0);
          if (today.getTime() === deliveryDate.getTime()) {
            return true;
          }
        }
        if (row.outForDeliveryDate) {
          const outForDeliveryDate = new Date(row.outForDeliveryDate);
          outForDeliveryDate.setHours(0, 0, 0, 0);
          if (today.getTime() === outForDeliveryDate.getTime()) {
            return true;
          }
        }
        return false;
      });
      break;
    case "Delivered":
      gridRows = gridRows.filter((row) => row.statusSystemName === "Delivered");
      break;
    case "Watchlist":
      gridRows = gridRows.filter(
        (row) => watchlistEdits === void 0 || watchlistEdits[row.id] === void 0 ? row.isWatchlisted : watchlistEdits[row.id]
      );
      break;
  }
  return gridRows;
}
function ExportGrid({ sx, logoURL }) {
  const theme = useTheme$2();
  const { dataGridApiRef, form } = useContext(Context);
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const popup = usePopupAlert();
  const values = form.getValues();
  const exportTypeLookup = [
    { id: "GridToExcel", name: "Export - Grid to Excel (.csv)" },
    { id: "GridToPDF", name: "Export - Job List (.pdf)" }
  ];
  const [exportType, setExportType] = useState(exportTypeLookup[0]);
  const onChangeHandler = (_e, value) => {
    if (value) {
      setExportType(value);
    }
  };
  const exportHandler = () => {
    var _a;
    const timeStamp = dayjs().format("DD-MMM-YYYY_HHmmss");
    const fileName = `Consignment_${timeStamp}`;
    if (exportType.id === "GridToExcel") {
      const option = {
        fileName
      };
      dataGridApiRef.current.exportDataAsCsv(option);
    } else if (exportType.id === "GridToPDF") {
      const columns = dataGridApiRef.current.getVisibleColumns().filter((col) => !col.disableExport);
      const rows = dataGridApiRef.current.getSortedRows();
      const maxColumnAllowed = 10;
      if (columns.length > maxColumnAllowed) {
        popup({ severity: "error", message: `Pdf report not available for more than ${maxColumnAllowed} columns. Please either reduce the number of columns selected in your grid to 10 or export via csv.` });
        return;
      }
      const organisationName = (_a = getOrganisations()[0]) == null ? void 0 : _a.name;
      const subheader = () => {
        let header = "";
        const dateFormat = "DD/MM/YY";
        if (values.bookedDateFrom || values.bookedDateTo) {
          header += `
						<p>
							Consignments booked between ${values.bookedDateFrom ? dayjs(values.bookedDateFrom).format(dateFormat) : dateFormat} - ${values.bookedDateTo ? dayjs(values.bookedDateTo).format(dateFormat) : dateFormat}
						</p>
					`;
        }
        if (values.deliveryDateFrom || values.deliveryDateTo) {
          header += `
						<p>
							Consignments delivered between ${values.deliveryDateFrom ? dayjs(values.deliveryDateFrom).format(dateFormat) : dateFormat} - ${values.deliveryDateTo ? dayjs(values.deliveryDateTo).format(dateFormat) : dateFormat}
						</p>
					`;
        }
        return header;
      };
      const printContent = `
				<html>
					<head>
						<title>${fileName}</title>
						<style>
							body {
								font-family: ${theme.typography.fontFamily};
							}
							header {
								display: flex;
								justify-content: space-between;
								align-items: center;
								margin-bottom: 20px;
							}
							header div {
								display: flex;
								flex-direction: column;
							}
							header h1, p {
								margin: 0;
							}
							header img {
								width: 100px;
								height: auto;
							}
							table {
								width: 100%;
								border-collapse: collapse;
							}
							tr:nth-child(even) {
								background-color: #f2f2f2;
							}
							th, td {
								border: 1px solid black;
								padding: 8px;
								text-align: left;
							}
							th {
								background-color: #f2f2f2;
								white-space: nowrap;
							}
							@media print {
								@page {
									size: landscape;
								}
								body {
									-webkit-print-color-adjust: exact;
									print-color-adjust: exact;
								}
							}
						</style>
					</head>
					<body>
						<header>
							<div>
								<h1>Consignment List${organisationName ? ` - ${organisationName}` : EMPTY_STRING$g}</h1>
								${subheader()}
							</div>
							${logoURL ? `<img src="${logoURL}" alt="Logo" />` : EMPTY_STRING$g}
						</header>
						<table>
							<thead>
								<tr>${columns.map((col) => `<th>${col.headerName}</th>`).join("")}</tr>
							</thead>
							<tbody>
								${rows.length > 0 ? rows.map((row) => {
        return `<tr>${columns.map((col) => {
          var _a2;
          const formattedValue = (_a2 = dataGridApiRef.current.getRowFormattedValue(row, col)) != null ? _a2 : EMPTY_STRING$g;
          return `<td>${formattedValue}</td>`;
        }).join("")}</tr>`;
      }).join("") : `<tr><td colspan="${columns.length}" style="text-align: center;">No rows</td></tr>`}
							</tbody>
						</table>
					</body>
				</html>
			`;
      const printIframe = document.createElement("iframe");
      document.body.appendChild(printIframe);
      if ((printIframe == null ? void 0 : printIframe.contentDocument) && (printIframe == null ? void 0 : printIframe.contentWindow)) {
        printIframe.contentDocument.open();
        printIframe.contentDocument.write(printContent);
        printIframe.contentDocument.close();
        printIframe.style.position = "absolute";
        printIframe.style.width = "0";
        printIframe.style.height = "0";
        printIframe.style.border = "none";
        printIframe.contentWindow.focus();
        printIframe.onload = () => {
          var _a2;
          (_a2 = printIframe.contentWindow) == null ? void 0 : _a2.print();
          document.body.removeChild(printIframe);
        };
      }
    }
  };
  return /* @__PURE__ */ jsxs(Grid$3, { container: true, spacing: 4, sx, children: [
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, children: /* @__PURE__ */ jsx(
      Typography,
      {
        fontSize: "0.85rem",
        lineHeight: "0.9rem",
        fontWeight: "bold",
        children: "Format"
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, children: /* @__PURE__ */ jsx(
      AutocompleteDropdown,
      {
        options: exportTypeLookup,
        isOptionEqualToValue: (option, val) => option.id === val.id,
        disableClearable: true,
        onChange: onChangeHandler,
        value: exportType
      }
    ) }),
    /* @__PURE__ */ jsx(Grid$3, { item: true, xs: 12, children: /* @__PURE__ */ jsx(Button$1, { variant: "contained", onClick: exportHandler, startIcon: /* @__PURE__ */ jsx(IosShare, {}), fullWidth: true, children: "Print/Export" }) })
  ] });
}
function Base({ children }) {
  var _a, _b, _c, _d;
  const [context, Form] = useForm({
    defaultValues: initialFilters
  });
  const { organisations: { getOrganisations } } = usePortalApplicationContext();
  const organisationID = (_a = getOrganisations()[0]) == null ? void 0 : _a.id;
  const dataGridApiRef = useGridApiRef();
  const values = context.watch();
  const [watchlistState, watchlistDispatch] = useReducer(watchlistReducer, initialWatchlistState);
  const [query] = useGridQuery(
    {
      systemName: "ConsignmentListGrid",
      parameters: {
        additionalFilter: {
          organisationID
        }
      }
    },
    { cacheTime: 0 }
  );
  const [activeBlockFilter, setActiveBlockFilter] = useState("Active");
  const filteredRows = applyFormFilters(values, (_b = query.data) == null ? void 0 : _b.data.rows);
  const blockfilteredRows = ((_c = query.data) == null ? void 0 : _c.data.rows) ? applyBlockFilters((_d = query.data) == null ? void 0 : _d.data.rows, activeBlockFilter, watchlistState.edits) : [];
  const gridRows = applyBlockFilters(filteredRows, activeBlockFilter, watchlistState.edits);
  return /* @__PURE__ */ jsx(
    Context.Provider,
    {
      value: {
        form: context,
        query,
        watchlist: [watchlistState, watchlistDispatch],
        filteredRows,
        blockfilteredRows,
        gridRows,
        activeBlockFilter,
        setActiveBlockFilter,
        dataGridApiRef
      },
      children: /* @__PURE__ */ jsx(Form, { style: { height: "100%", width: "100%" }, children })
    }
  );
}
const ConsignmentListPage = Object.assign(Base, {
  BlockFilters,
  Filters,
  Grid,
  ExportGrid
});
const useConsignmentListContext = () => {
  return useContext(Context);
};

function VerticalMenu({ items, collapsed, menuItemsStyles }) {
  const auth = useAuth();
  const theme = useTheme$2();
  const location = useLocation();
  useNavigate();
  return /* @__PURE__ */ jsx(
    List$1,
    {
      disablePadding: true,
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: 3
      },
      children: items.filter((x) => auth.userHasPermission(x.securityContext, x.securityContextPermission)).map((item) => {
        var _a, _b;
        const parts = item.path.split("?");
        const [path] = parts;
        const active = path === location.pathname;
        return /* @__PURE__ */ jsx(ListItem$2, { disablePadding: true, children: /* @__PURE__ */ jsxs(
          ListItemButton,
          {
            disableGutters: true,
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingX: theme.spacing(collapsed ? 0 : 6),
              borderRadius: theme.shape.borderRadius * 2,
              backgroundColor: active ? alpha$1(hexToRgb(theme.palette.primary.main), Number((_a = menuItemsStyles == null ? void 0 : menuItemsStyles.opacity) != null ? _a : 0.08)) : "initial",
              "&:hover": {
                backgroundColor: alpha$1(hexToRgb(theme.palette.primary.main), Number((_b = menuItemsStyles == null ? void 0 : menuItemsStyles.opacity) != null ? _b : 0.08))
              }
            },
            onClick: () => {
              const url = `${item.isExternalURL ? "" : "/#"}${item.path}`;
              item.openNewTab ? window.open(url) : window.location.href = url;
            },
            children: [
              item.icon && /* @__PURE__ */ jsx(
                ListItemIcon$1,
                {
                  title: item.label,
                  sx: {
                    minWidth: "initial",
                    fontSize: "1.35rem",
                    color: (menuItemsStyles == null ? void 0 : menuItemsStyles.color) || theme.palette.primary.main
                  },
                  children: item.icon
                }
              ),
              !collapsed && /* @__PURE__ */ jsx(
                ListItemText$1,
                {
                  primary: item.label,
                  sx: {
                    color: (menuItemsStyles == null ? void 0 : menuItemsStyles.color) || theme.palette.primary.main
                  },
                  primaryTypographyProps: {
                    fontSize: "1rem",
                    fontWeight: 500
                  }
                }
              )
            ]
          }
        ) }, item.path);
      })
    }
  );
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DefaultRender = (_props) => null;
function VerticalNavigation({
  width = { expanded: 275, collapsed: 75 },
  clientLogo,
  clientLogoStyle,
  components,
  MenuProps
}) {
  var _a, _b, _c;
  const auth = useAuth();
  const theme = useTheme$2();
  const storageKey = `${window.btoa(auth.user.userName)}_vertical-navigation`;
  const storedState = JSON.parse((_a = window.sessionStorage.getItem(storageKey)) != null ? _a : JSON.stringify({ collapsed: false }));
  const [collapsed, setCollapsed] = useState(storedState.collapsed);
  const _width = collapsed ? width.collapsed : width.expanded;
  const clientLogoCollapsedHeight = collapsed && ((_b = clientLogoStyle == null ? void 0 : clientLogoStyle.collapsed) == null ? void 0 : _b.height) ? clientLogoStyle.collapsed.height : "1.25rem";
  const clientLogoExpandedHeight = !collapsed && ((_c = clientLogoStyle == null ? void 0 : clientLogoStyle.expanded) == null ? void 0 : _c.height) ? clientLogoStyle.expanded.height : "1.25rem";
  useEffect(() => {
    window.sessionStorage.setItem(storageKey, JSON.stringify({ collapsed }));
  }, [collapsed]);
  const Header = defaultValue(components == null ? void 0 : components.Header, DefaultRender);
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      variant: "permanent",
      anchor: "left",
      sx: {
        width: _width,
        "& .MuiDrawer-paper": {
          width: _width,
          boxSizing: "border-box",
          backgroundColor: "inherit"
        }
      },
      children: /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            flexGrow: 0,
            display: "flex",
            flexDirection: collapsed ? "column" : "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingX: 6,
            paddingTop: 12,
            paddingBottom: collapsed ? 4 : 12,
            gap: 4,
            children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  src: collapsed ? clientLogo.collapsed : clientLogo.expanded,
                  style: {
                    height: collapsed ? clientLogoCollapsedHeight : clientLogoExpandedHeight
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  title: collapsed ? "Expand" : "Collapse",
                  sx: {
                    padding: 0,
                    marginRight: collapsed ? 0 : "-8px",
                    color: theme.palette.primary.main,
                    fontSize: "2rem"
                  },
                  onClick: () => setCollapsed((x) => !x),
                  children: collapsed ? /* @__PURE__ */ jsx(ChevronRight, { color: "inherit", fontSize: "inherit" }) : /* @__PURE__ */ jsx(ChevronLeft, { color: "inherit", fontSize: "inherit" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { flexGrow: 0, display: "flex", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsx(Header, { collapsed }) }),
        /* @__PURE__ */ jsx(
          Box,
          {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            paddingY: 6,
            paddingX: collapsed ? 4 : 6,
            sx: {
              overflowY: "auto"
            },
            children: /* @__PURE__ */ jsx(VerticalMenu, __spreadProps(__spreadValues({}, MenuProps), { collapsed }))
          }
        )
      ] })
    }
  );
}

const userHasSecurityContext = (auth, securityContext) => {
  var _a, _b;
  return Object.keys((_b = (_a = auth.user) == null ? void 0 : _a.permissions) != null ? _b : []).indexOf(securityContext) !== -1;
};

export { AccountService, AccountsPage, AddressFinder, AgentDetails$3 as AgentDetails, AgentDetailsLoading, AutocompleteDropdown, BlockFilter, BoatWithContainersIcon, CartonIcon, ChangePasswordForm, ChangePinForm, CleanUpPivotGrid, ClearSearchStateEvent, CodeLookup, Collapse, CommentsDetails$3 as CommentsDetails, CommentsDetailsLoading, ConfirmActionButton, ConsignmentChargeDetails$2 as ConsignmentChargeDetails, ConsignmentDashboard, ConsignmentDetails$2 as ConsignmentDetails, ConsignmentDetailsLoading, ConsignmentListPage, ConsignmentLocationField, ConsignmentMap, ConsignmentReferences, ConsignmentSupplyChainTimeline, ConsignmentTrackingHistory, ContactService, ContainerConsignmentBookingBase, ContainerConsignmentBookingPage, ContainerConsignmentOrderDetails$1 as ContainerConsignmentOrderDetails, ContainerConsignmentTrackerPage, ContainerDetails$4 as ContainerDetails, ContainerToggleGroup, ContainerTrackerPage, DangerousGoods$2 as DangerousGoods, DataGrid$1 as DataGrid, DateTimeInput, DateTimePicker, DialogWrap, DocumentsDetails$4 as DocumentsDetails, DropboxConnect, DropboxDocuments, Dropzone, Enquiry, EstimateBase, EstimateCharge$2 as EstimateCharge, EstimatePage, EventsTimeline, EventsTimelineLoading, ExpandableSection, ExportMovementFromAndToDetails, FilterListIcon, FormAddressLookup, FormAutocompleteDropdown, FormCheckbox, FormCheckboxGroup, FormDateTimePicker, FormElementWrap, FormInput, FormLocationAddressLookup, FormLookup, FormLookupCheckboxGroup, FormPhoneInput, FormPortLocationLookup, FormToggleGroup, FreightBookingBase, FreightBookingPage, FreightLineDetails$1 as FreightLineDetails, FreightTrackerPage, GeoCoordinateInformationBanner, GeoInformationRegionMapLayer, GoogleMap, GoogleMapAdvancedMarker, GoogleMapMarkerClusterer, GoogleMapOverlayView, GoogleMapPolyline, GridViewHyperlinkCell, GridViewLookupSelectCell, HttpService, Hyperlink, ImportMovementFromAndToDetails, InlineEditGrid, Input$2 as Input, InputLabel, Label, Loader, LoadingWrap, LocationLookup, Lookup, Map$8 as Map, MarkInput, MeasureInput, MimeTypes, MobileContainerConsignmentOrderDetails, MobileContainerDetails, MobileDocumentsDetails, MobileFreightLineDetails, MobileOrderDetails, MoveMovementFromAndToDetails, MyAccountService, NetworkHealthFilter, NetworkHealthGrid, NetworkHealthModal, NoteInput, NotificationConfigurationService, NumberInput, OrderBase, OrderCard, OrderDetails$5 as OrderDetails, OrderPage, OrderTrackerPage, OrdersDashboard, OrdersDashboardMenuItem, PackingLineDetails$1 as PackingLineDetails, PalletIcon, PartyLookup, PermissionForm, PhoneField, PortalApplicationContext, PortalFrameAccountService, PortalOrderSupplyChainTimeline, PortalShipmentSupplyChainTimeline, PreferenceForm, ProductLine, QueryClientProvider, RadioGroupField, RangeInput, RangeSlider, ReferenceInput, ReportActionButton, ReportScheduling, ReportSchedulingActionCell, ReportSchedulingAdd, ReportSchedulingForm, Reports, ScheduleJobService, SchedulesPage, SchedulesPageBase, Search, SearchEvent, Section, ShareService, ShareWithMagicLink, ShipmentDashboard, ShipmentDashboardMenuItem, ShipmentDetails$3 as ShipmentDetails, ShipmentDetailsLoading, ShipmentTrackerPage, StaffContacts$3 as StaffContacts, StaffContactsLoading, SubscriptionDialog, SubscriptionForm, SupplyChainTimeline, SupplyChainTimelineLoading, SwitchInput, Tab, ToggleGroup, ToggleGroupSkeleton, TrackPage, TrackPageBase, TrackerControls, TrackingDocuments, TrackingEvent, TrackingHistory, TrackingOrderCutLines, TrackingOrderDetails, TrackingOrderDetailsTotal, TrackingOrderSummary, TrackingOrderSummaryCard, TrackingPOD, TrackingPage, TrackingPalletTableOrdered, TrackingPalletTableSupplied, TransportBase, TransportGridColumns, TransportPage, UserFilter, UserForm, UserGrid, UserGroupForm, UserGroupService, UserOrganisationForm, UserOrganisationToggle, UserService, UserSettingService, VerticalMenu, VerticalNavigation, VoyageDetails$3 as VoyageDetails, VoyageDetailsLoading, WatchlistIcon, addTerms, additionalLookupItem, createContainerPayload, createOrderLinesPayload, formatDate$2 as formatDate, getTerm, getTermFromStore, hasOrdersDashboardPermission, hasTrackingDocumentsPermission, hasTrackingHistoryPermission, hasTrackingOrderDetailsPermission, hasTrackingPODPermission, hasTrackingPagePermission, httpService$1 as httpService, onEventAPI, onEventCoreAPI, orderPageValidation, persistOptions, portalFrameworkService, queryClient, removeDateTime, removeTimezoneOffset, serializeContainerConsignment, serializePortalOrder, shipmentModeIconMap, strictCustomEvent, useAccountsPage, useAttachmentDownload, useConfirmationDialog, useConsignmentDashboardContext, useConsignmentListContext, useContainerConsignmentBookingPageContext, useContainerConsignmentContext, useContainerContext, useContainerTrackerContext, useDataGridPreferences, useDropbox, useEstimatePageContext, useFavouriteReportSchedulingData, useForm, useFormConfigure, useFreightBookingPageContext, useFreightContext, useGoogleMapAdvancedMarkerContext, useGoogleMapContext, useGoogleMapMarkerClustererContext, useGridQuery, useIsMounted, useLoginRedirectPath, useLookupQuery, useMobileBreakpoint, useModal, useMutation, useMyAccount, useMyTimeZone, useOrderContext, useOrderPageContext, useOrderTrackerContext, useOrganisationLookupHelper, usePopupAlert, usePortalApplicationContext, usePreferences, useQuery, useSchedulesPage, useShipmentContext, useShipmentDashboardContext, useShipmentOptionLookup, useShipmentTrackerContext, useSortedTransportLegs, useSupplyChainEventList, useSupplyChainMemberList, useTabletBreakpoint, useToggle, useTrackPage, useTransportPageContext, useUserGroupHelper, useUserParentHelper, useUserPreferenceHelper, useUserSetting, useVesselMovementCoordinates, useVesselMovementLocations, userHasSecurityContext, zodValidator };
//# sourceMappingURL=index.mjs.map
